
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

var $92ef4069b018d725$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"6XAxV\",\"index.be4e51fe.js\",\"gmHlZ\",\"../../Nickainley-BuWKc7LA.3ba7586e.ttf\"]"));


var $hPtJY = parcelRequire("hPtJY");
(function() {
    const e = document.createElement("link").relList;
    if (e && e.supports && e.supports("modulepreload")) return;
    for (const i of document.querySelectorAll('link[rel="modulepreload"]'))n(i);
    new MutationObserver((i)=>{
        for (const r of i)if (r.type === "childList") for (const l of r.addedNodes)l.tagName === "LINK" && l.rel === "modulepreload" && n(l);
    }).observe(document, {
        childList: !0,
        subtree: !0
    });
    function t(i) {
        const r = {};
        return i.integrity && (r.integrity = i.integrity), i.referrerPolicy && (r.referrerPolicy = i.referrerPolicy), i.crossOrigin === "use-credentials" ? r.credentials = "include" : i.crossOrigin === "anonymous" ? r.credentials = "omit" : r.credentials = "same-origin", r;
    }
    function n(i) {
        if (i.ep) return;
        i.ep = !0;
        const r = t(i);
        fetch(i.href, r);
    }
})();
function $455d545b1dff00eb$var$Mb(a) {
    return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var $455d545b1dff00eb$var$S1 = {
    exports: {}
}, $455d545b1dff00eb$var$gm = {};
var $455d545b1dff00eb$var$x2;
function $455d545b1dff00eb$var$fC() {
    if ($455d545b1dff00eb$var$x2) return $455d545b1dff00eb$var$gm;
    $455d545b1dff00eb$var$x2 = 1;
    var a = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
    function t(n, i, r) {
        var l = null;
        if (r !== void 0 && (l = "" + r), i.key !== void 0 && (l = "" + i.key), "key" in i) {
            r = {};
            for(var c in i)c !== "key" && (r[c] = i[c]);
        } else r = i;
        return i = r.ref, {
            $$typeof: a,
            type: n,
            key: l,
            ref: i !== void 0 ? i : null,
            props: r
        };
    }
    return $455d545b1dff00eb$var$gm.Fragment = e, $455d545b1dff00eb$var$gm.jsx = t, $455d545b1dff00eb$var$gm.jsxs = t, $455d545b1dff00eb$var$gm;
}
var $455d545b1dff00eb$var$v2;
function $455d545b1dff00eb$var$hC() {
    return $455d545b1dff00eb$var$v2 || ($455d545b1dff00eb$var$v2 = 1, $455d545b1dff00eb$var$S1.exports = $455d545b1dff00eb$var$fC()), $455d545b1dff00eb$var$S1.exports;
}
var $455d545b1dff00eb$var$k = $455d545b1dff00eb$var$hC(), $455d545b1dff00eb$var$M1 = {
    exports: {}
}, $455d545b1dff00eb$var$$t = {};
var $455d545b1dff00eb$var$y2;
function $455d545b1dff00eb$var$dC() {
    if ($455d545b1dff00eb$var$y2) return $455d545b1dff00eb$var$$t;
    $455d545b1dff00eb$var$y2 = 1;
    var a = Symbol.for("react.transitional.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), r = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), x = Symbol.for("react.activity"), v = Symbol.iterator;
    function _(I) {
        return I === null || typeof I != "object" ? null : (I = v && I[v] || I["@@iterator"], typeof I == "function" ? I : null);
    }
    var S = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function() {},
        enqueueReplaceState: function() {},
        enqueueSetState: function() {}
    }, A = Object.assign, M = {};
    function b(I, Z, oe) {
        this.props = I, this.context = Z, this.refs = M, this.updater = oe || S;
    }
    b.prototype.isReactComponent = {}, b.prototype.setState = function(I, Z) {
        if (typeof I != "object" && typeof I != "function" && I != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, I, Z, "setState");
    }, b.prototype.forceUpdate = function(I) {
        this.updater.enqueueForceUpdate(this, I, "forceUpdate");
    };
    function C() {}
    C.prototype = b.prototype;
    function R(I, Z, oe) {
        this.props = I, this.context = Z, this.refs = M, this.updater = oe || S;
    }
    var N = R.prototype = new C;
    N.constructor = R, A(N, b.prototype), N.isPureReactComponent = !0;
    var z = Array.isArray;
    function L() {}
    var P = {
        H: null,
        A: null,
        T: null,
        S: null
    }, H = Object.prototype.hasOwnProperty;
    function O(I, Z, oe) {
        var ce = oe.ref;
        return {
            $$typeof: a,
            type: I,
            key: Z,
            ref: ce !== void 0 ? ce : null,
            props: oe
        };
    }
    function D(I, Z) {
        return O(I.type, Z, I.props);
    }
    function j(I) {
        return typeof I == "object" && I !== null && I.$$typeof === a;
    }
    function G(I) {
        var Z = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + I.replace(/[=:]/g, function(oe) {
            return Z[oe];
        });
    }
    var q = /\/+/g;
    function Y(I, Z) {
        return typeof I == "object" && I !== null && I.key != null ? G("" + I.key) : Z.toString(36);
    }
    function ae(I) {
        switch(I.status){
            case "fulfilled":
                return I.value;
            case "rejected":
                throw I.reason;
            default:
                switch(typeof I.status == "string" ? I.then(L, L) : (I.status = "pending", I.then(function(Z) {
                    I.status === "pending" && (I.status = "fulfilled", I.value = Z);
                }, function(Z) {
                    I.status === "pending" && (I.status = "rejected", I.reason = Z);
                })), I.status){
                    case "fulfilled":
                        return I.value;
                    case "rejected":
                        throw I.reason;
                }
        }
        throw I;
    }
    function F(I, Z, oe, ce, de) {
        var ue = typeof I;
        (ue === "undefined" || ue === "boolean") && (I = null);
        var le = !1;
        if (I === null) le = !0;
        else switch(ue){
            case "bigint":
            case "string":
            case "number":
                le = !0;
                break;
            case "object":
                switch(I.$$typeof){
                    case a:
                    case e:
                        le = !0;
                        break;
                    case m:
                        return le = I._init, F(le(I._payload), Z, oe, ce, de);
                }
        }
        if (le) return de = de(I), le = ce === "" ? "." + Y(I, 0) : ce, z(de) ? (oe = "", le != null && (oe = le.replace(q, "$&/") + "/"), F(de, Z, oe, "", function(Ue) {
            return Ue;
        })) : de != null && (j(de) && (de = D(de, oe + (de.key == null || I && I.key === de.key ? "" : ("" + de.key).replace(q, "$&/") + "/") + le)), Z.push(de)), 1;
        le = 0;
        var xe = ce === "" ? "." : ce + ":";
        if (z(I)) for(var Le = 0; Le < I.length; Le++)ce = I[Le], ue = xe + Y(ce, Le), le += F(ce, Z, oe, ue, de);
        else if (Le = _(I), typeof Le == "function") for(I = Le.call(I), Le = 0; !(ce = I.next()).done;)ce = ce.value, ue = xe + Y(ce, Le++), le += F(ce, Z, oe, ue, de);
        else if (ue === "object") {
            if (typeof I.then == "function") return F(ae(I), Z, oe, ce, de);
            throw Z = String(I), Error("Objects are not valid as a React child (found: " + (Z === "[object Object]" ? "object with keys {" + Object.keys(I).join(", ") + "}" : Z) + "). If you meant to render a collection of children, use an array instead.");
        }
        return le;
    }
    function Q(I, Z, oe) {
        if (I == null) return I;
        var ce = [], de = 0;
        return F(I, ce, "", "", function(ue) {
            return Z.call(oe, ue, de++);
        }), ce;
    }
    function K(I) {
        if (I._status === -1) {
            var Z = I._result;
            Z = Z(), Z.then(function(oe) {
                (I._status === 0 || I._status === -1) && (I._status = 1, I._result = oe);
            }, function(oe) {
                (I._status === 0 || I._status === -1) && (I._status = 2, I._result = oe);
            }), I._status === -1 && (I._status = 0, I._result = Z);
        }
        if (I._status === 1) return I._result.default;
        throw I._result;
    }
    var $ = typeof reportError == "function" ? reportError : function(I) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
            var Z = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: typeof I == "object" && I !== null && typeof I.message == "string" ? String(I.message) : String(I),
                error: I
            });
            if (!window.dispatchEvent(Z)) return;
        } else if (typeof $hPtJY == "object" && typeof $hPtJY.emit == "function") {
            $hPtJY.emit("uncaughtException", I);
            return;
        }
        console.error(I);
    }, ee = {
        map: Q,
        forEach: function(I, Z, oe) {
            Q(I, function() {
                Z.apply(this, arguments);
            }, oe);
        },
        count: function(I) {
            var Z = 0;
            return Q(I, function() {
                Z++;
            }), Z;
        },
        toArray: function(I) {
            return Q(I, function(Z) {
                return Z;
            }) || [];
        },
        only: function(I) {
            if (!j(I)) throw Error("React.Children.only expected to receive a single React element child.");
            return I;
        }
    };
    return $455d545b1dff00eb$var$$t.Activity = x, $455d545b1dff00eb$var$$t.Children = ee, $455d545b1dff00eb$var$$t.Component = b, $455d545b1dff00eb$var$$t.Fragment = t, $455d545b1dff00eb$var$$t.Profiler = i, $455d545b1dff00eb$var$$t.PureComponent = R, $455d545b1dff00eb$var$$t.StrictMode = n, $455d545b1dff00eb$var$$t.Suspense = f, $455d545b1dff00eb$var$$t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = P, $455d545b1dff00eb$var$$t.__COMPILER_RUNTIME = {
        __proto__: null,
        c: function(I) {
            return P.H.useMemoCache(I);
        }
    }, $455d545b1dff00eb$var$$t.cache = function(I) {
        return function() {
            return I.apply(null, arguments);
        };
    }, $455d545b1dff00eb$var$$t.cacheSignal = function() {
        return null;
    }, $455d545b1dff00eb$var$$t.cloneElement = function(I, Z, oe) {
        if (I == null) throw Error("The argument must be a React element, but you passed " + I + ".");
        var ce = A({}, I.props), de = I.key;
        if (Z != null) for(ue in Z.key !== void 0 && (de = "" + Z.key), Z)!H.call(Z, ue) || ue === "key" || ue === "__self" || ue === "__source" || ue === "ref" && Z.ref === void 0 || (ce[ue] = Z[ue]);
        var ue = arguments.length - 2;
        if (ue === 1) ce.children = oe;
        else if (1 < ue) {
            for(var le = Array(ue), xe = 0; xe < ue; xe++)le[xe] = arguments[xe + 2];
            ce.children = le;
        }
        return O(I.type, de, ce);
    }, $455d545b1dff00eb$var$$t.createContext = function(I) {
        return I = {
            $$typeof: l,
            _currentValue: I,
            _currentValue2: I,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        }, I.Provider = I, I.Consumer = {
            $$typeof: r,
            _context: I
        }, I;
    }, $455d545b1dff00eb$var$$t.createElement = function(I, Z, oe) {
        var ce, de = {}, ue = null;
        if (Z != null) for(ce in Z.key !== void 0 && (ue = "" + Z.key), Z)H.call(Z, ce) && ce !== "key" && ce !== "__self" && ce !== "__source" && (de[ce] = Z[ce]);
        var le = arguments.length - 2;
        if (le === 1) de.children = oe;
        else if (1 < le) {
            for(var xe = Array(le), Le = 0; Le < le; Le++)xe[Le] = arguments[Le + 2];
            de.children = xe;
        }
        if (I && I.defaultProps) for(ce in le = I.defaultProps, le)de[ce] === void 0 && (de[ce] = le[ce]);
        return O(I, ue, de);
    }, $455d545b1dff00eb$var$$t.createRef = function() {
        return {
            current: null
        };
    }, $455d545b1dff00eb$var$$t.forwardRef = function(I) {
        return {
            $$typeof: c,
            render: I
        };
    }, $455d545b1dff00eb$var$$t.isValidElement = j, $455d545b1dff00eb$var$$t.lazy = function(I) {
        return {
            $$typeof: m,
            _payload: {
                _status: -1,
                _result: I
            },
            _init: K
        };
    }, $455d545b1dff00eb$var$$t.memo = function(I, Z) {
        return {
            $$typeof: p,
            type: I,
            compare: Z === void 0 ? null : Z
        };
    }, $455d545b1dff00eb$var$$t.startTransition = function(I) {
        var Z = P.T, oe = {};
        P.T = oe;
        try {
            var ce = I(), de = P.S;
            de !== null && de(oe, ce), typeof ce == "object" && ce !== null && typeof ce.then == "function" && ce.then(L, $);
        } catch (ue) {
            $(ue);
        } finally{
            Z !== null && oe.types !== null && (Z.types = oe.types), P.T = Z;
        }
    }, $455d545b1dff00eb$var$$t.unstable_useCacheRefresh = function() {
        return P.H.useCacheRefresh();
    }, $455d545b1dff00eb$var$$t.use = function(I) {
        return P.H.use(I);
    }, $455d545b1dff00eb$var$$t.useActionState = function(I, Z, oe) {
        return P.H.useActionState(I, Z, oe);
    }, $455d545b1dff00eb$var$$t.useCallback = function(I, Z) {
        return P.H.useCallback(I, Z);
    }, $455d545b1dff00eb$var$$t.useContext = function(I) {
        return P.H.useContext(I);
    }, $455d545b1dff00eb$var$$t.useDebugValue = function() {}, $455d545b1dff00eb$var$$t.useDeferredValue = function(I, Z) {
        return P.H.useDeferredValue(I, Z);
    }, $455d545b1dff00eb$var$$t.useEffect = function(I, Z) {
        return P.H.useEffect(I, Z);
    }, $455d545b1dff00eb$var$$t.useEffectEvent = function(I) {
        return P.H.useEffectEvent(I);
    }, $455d545b1dff00eb$var$$t.useId = function() {
        return P.H.useId();
    }, $455d545b1dff00eb$var$$t.useImperativeHandle = function(I, Z, oe) {
        return P.H.useImperativeHandle(I, Z, oe);
    }, $455d545b1dff00eb$var$$t.useInsertionEffect = function(I, Z) {
        return P.H.useInsertionEffect(I, Z);
    }, $455d545b1dff00eb$var$$t.useLayoutEffect = function(I, Z) {
        return P.H.useLayoutEffect(I, Z);
    }, $455d545b1dff00eb$var$$t.useMemo = function(I, Z) {
        return P.H.useMemo(I, Z);
    }, $455d545b1dff00eb$var$$t.useOptimistic = function(I, Z) {
        return P.H.useOptimistic(I, Z);
    }, $455d545b1dff00eb$var$$t.useReducer = function(I, Z, oe) {
        return P.H.useReducer(I, Z, oe);
    }, $455d545b1dff00eb$var$$t.useRef = function(I) {
        return P.H.useRef(I);
    }, $455d545b1dff00eb$var$$t.useState = function(I) {
        return P.H.useState(I);
    }, $455d545b1dff00eb$var$$t.useSyncExternalStore = function(I, Z, oe) {
        return P.H.useSyncExternalStore(I, Z, oe);
    }, $455d545b1dff00eb$var$$t.useTransition = function() {
        return P.H.useTransition();
    }, $455d545b1dff00eb$var$$t.version = "19.2.0", $455d545b1dff00eb$var$$t;
}
var $455d545b1dff00eb$var$_2;
function $455d545b1dff00eb$var$jd() {
    return $455d545b1dff00eb$var$_2 || ($455d545b1dff00eb$var$_2 = 1, $455d545b1dff00eb$var$M1.exports = $455d545b1dff00eb$var$dC()), $455d545b1dff00eb$var$M1.exports;
}
var $455d545b1dff00eb$var$X = $455d545b1dff00eb$var$jd();
const $455d545b1dff00eb$var$hE = $455d545b1dff00eb$var$Mb($455d545b1dff00eb$var$X);
var $455d545b1dff00eb$var$E1 = {
    exports: {}
}, $455d545b1dff00eb$var$xm = {}, $455d545b1dff00eb$var$T1 = {
    exports: {}
}, $455d545b1dff00eb$var$A1 = {};
var $455d545b1dff00eb$var$b2;
function $455d545b1dff00eb$var$pC() {
    return $455d545b1dff00eb$var$b2 || ($455d545b1dff00eb$var$b2 = 1, function(a) {
        function e(F, Q) {
            var K = F.length;
            F.push(Q);
            e: for(; 0 < K;){
                var $ = K - 1 >>> 1, ee = F[$];
                if (0 < i(ee, Q)) F[$] = Q, F[K] = ee, K = $;
                else break e;
            }
        }
        function t(F) {
            return F.length === 0 ? null : F[0];
        }
        function n(F) {
            if (F.length === 0) return null;
            var Q = F[0], K = F.pop();
            if (K !== Q) {
                F[0] = K;
                e: for(var $ = 0, ee = F.length, I = ee >>> 1; $ < I;){
                    var Z = 2 * ($ + 1) - 1, oe = F[Z], ce = Z + 1, de = F[ce];
                    if (0 > i(oe, K)) ce < ee && 0 > i(de, oe) ? (F[$] = de, F[ce] = K, $ = ce) : (F[$] = oe, F[Z] = K, $ = Z);
                    else if (ce < ee && 0 > i(de, K)) F[$] = de, F[ce] = K, $ = ce;
                    else break e;
                }
            }
            return Q;
        }
        function i(F, Q) {
            var K = F.sortIndex - Q.sortIndex;
            return K !== 0 ? K : F.id - Q.id;
        }
        if (a.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
            var r = performance;
            a.unstable_now = function() {
                return r.now();
            };
        } else {
            var l = Date, c = l.now();
            a.unstable_now = function() {
                return l.now() - c;
            };
        }
        var f = [], p = [], m = 1, x = null, v = 3, _ = !1, S = !1, A = !1, M = !1, b = typeof setTimeout == "function" ? setTimeout : null, C = typeof clearTimeout == "function" ? clearTimeout : null, R = typeof setImmediate < "u" ? setImmediate : null;
        function N(F) {
            for(var Q = t(p); Q !== null;){
                if (Q.callback === null) n(p);
                else if (Q.startTime <= F) n(p), Q.sortIndex = Q.expirationTime, e(f, Q);
                else break;
                Q = t(p);
            }
        }
        function z(F) {
            if (A = !1, N(F), !S) {
                if (t(f) !== null) S = !0, L || (L = !0, G());
                else {
                    var Q = t(p);
                    Q !== null && ae(z, Q.startTime - F);
                }
            }
        }
        var L = !1, P = -1, H = 5, O = -1;
        function D() {
            return M ? !0 : !(a.unstable_now() - O < H);
        }
        function j() {
            if (M = !1, L) {
                var F = a.unstable_now();
                O = F;
                var Q = !0;
                try {
                    e: {
                        S = !1, A && (A = !1, C(P), P = -1), _ = !0;
                        var K = v;
                        try {
                            t: {
                                for(N(F), x = t(f); x !== null && !(x.expirationTime > F && D());){
                                    var $ = x.callback;
                                    if (typeof $ == "function") {
                                        x.callback = null, v = x.priorityLevel;
                                        var ee = $(x.expirationTime <= F);
                                        if (F = a.unstable_now(), typeof ee == "function") {
                                            x.callback = ee, N(F), Q = !0;
                                            break t;
                                        }
                                        x === t(f) && n(f), N(F);
                                    } else n(f);
                                    x = t(f);
                                }
                                if (x !== null) Q = !0;
                                else {
                                    var I = t(p);
                                    I !== null && ae(z, I.startTime - F), Q = !1;
                                }
                            }
                            break e;
                        } finally{
                            x = null, v = K, _ = !1;
                        }
                        Q = void 0;
                    }
                } finally{
                    Q ? G() : L = !1;
                }
            }
        }
        var G;
        if (typeof R == "function") G = function() {
            R(j);
        };
        else if (typeof MessageChannel < "u") {
            var q = new MessageChannel, Y = q.port2;
            q.port1.onmessage = j, G = function() {
                Y.postMessage(null);
            };
        } else G = function() {
            b(j, 0);
        };
        function ae(F, Q) {
            P = b(function() {
                F(a.unstable_now());
            }, Q);
        }
        a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(F) {
            F.callback = null;
        }, a.unstable_forceFrameRate = function(F) {
            0 > F || 125 < F ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : H = 0 < F ? Math.floor(1e3 / F) : 5;
        }, a.unstable_getCurrentPriorityLevel = function() {
            return v;
        }, a.unstable_next = function(F) {
            switch(v){
                case 1:
                case 2:
                case 3:
                    var Q = 3;
                    break;
                default:
                    Q = v;
            }
            var K = v;
            v = Q;
            try {
                return F();
            } finally{
                v = K;
            }
        }, a.unstable_requestPaint = function() {
            M = !0;
        }, a.unstable_runWithPriority = function(F, Q) {
            switch(F){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    F = 3;
            }
            var K = v;
            v = F;
            try {
                return Q();
            } finally{
                v = K;
            }
        }, a.unstable_scheduleCallback = function(F, Q, K) {
            var $ = a.unstable_now();
            switch(typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? $ + K : $) : K = $, F){
                case 1:
                    var ee = -1;
                    break;
                case 2:
                    ee = 250;
                    break;
                case 5:
                    ee = 1073741823;
                    break;
                case 4:
                    ee = 1e4;
                    break;
                default:
                    ee = 5e3;
            }
            return ee = K + ee, F = {
                id: m++,
                callback: Q,
                priorityLevel: F,
                startTime: K,
                expirationTime: ee,
                sortIndex: -1
            }, K > $ ? (F.sortIndex = K, e(p, F), t(f) === null && F === t(p) && (A ? (C(P), P = -1) : A = !0, ae(z, K - $))) : (F.sortIndex = ee, e(f, F), S || _ || (S = !0, L || (L = !0, G()))), F;
        }, a.unstable_shouldYield = D, a.unstable_wrapCallback = function(F) {
            var Q = v;
            return function() {
                var K = v;
                v = Q;
                try {
                    return F.apply(this, arguments);
                } finally{
                    v = K;
                }
            };
        };
    }($455d545b1dff00eb$var$A1)), $455d545b1dff00eb$var$A1;
}
var $455d545b1dff00eb$var$S2;
function $455d545b1dff00eb$var$mC() {
    return $455d545b1dff00eb$var$S2 || ($455d545b1dff00eb$var$S2 = 1, $455d545b1dff00eb$var$T1.exports = $455d545b1dff00eb$var$pC()), $455d545b1dff00eb$var$T1.exports;
}
var $455d545b1dff00eb$var$w1 = {
    exports: {}
}, $455d545b1dff00eb$var$Ja = {};
var $455d545b1dff00eb$var$M2;
function $455d545b1dff00eb$var$gC() {
    if ($455d545b1dff00eb$var$M2) return $455d545b1dff00eb$var$Ja;
    $455d545b1dff00eb$var$M2 = 1;
    var a = $455d545b1dff00eb$var$jd();
    function e(f) {
        var p = "https://react.dev/errors/" + f;
        if (1 < arguments.length) {
            p += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var m = 2; m < arguments.length; m++)p += "&args[]=" + encodeURIComponent(arguments[m]);
        }
        return "Minified React error #" + f + "; visit " + p + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function t() {}
    var n = {
        d: {
            f: t,
            r: function() {
                throw Error(e(522));
            },
            D: t,
            C: t,
            L: t,
            m: t,
            X: t,
            S: t,
            M: t
        },
        p: 0,
        findDOMNode: null
    }, i = Symbol.for("react.portal");
    function r(f, p, m) {
        var x = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
        return {
            $$typeof: i,
            key: x == null ? null : "" + x,
            children: f,
            containerInfo: p,
            implementation: m
        };
    }
    var l = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    function c(f, p) {
        if (f === "font") return "";
        if (typeof p == "string") return p === "use-credentials" ? p : "";
    }
    return $455d545b1dff00eb$var$Ja.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = n, $455d545b1dff00eb$var$Ja.createPortal = function(f, p) {
        var m = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
        if (!p || p.nodeType !== 1 && p.nodeType !== 9 && p.nodeType !== 11) throw Error(e(299));
        return r(f, p, null, m);
    }, $455d545b1dff00eb$var$Ja.flushSync = function(f) {
        var p = l.T, m = n.p;
        try {
            if (l.T = null, n.p = 2, f) return f();
        } finally{
            l.T = p, n.p = m, n.d.f();
        }
    }, $455d545b1dff00eb$var$Ja.preconnect = function(f, p) {
        typeof f == "string" && (p ? (p = p.crossOrigin, p = typeof p == "string" ? p === "use-credentials" ? p : "" : void 0) : p = null, n.d.C(f, p));
    }, $455d545b1dff00eb$var$Ja.prefetchDNS = function(f) {
        typeof f == "string" && n.d.D(f);
    }, $455d545b1dff00eb$var$Ja.preinit = function(f, p) {
        if (typeof f == "string" && p && typeof p.as == "string") {
            var m = p.as, x = c(m, p.crossOrigin), v = typeof p.integrity == "string" ? p.integrity : void 0, _ = typeof p.fetchPriority == "string" ? p.fetchPriority : void 0;
            m === "style" ? n.d.S(f, typeof p.precedence == "string" ? p.precedence : void 0, {
                crossOrigin: x,
                integrity: v,
                fetchPriority: _
            }) : m === "script" && n.d.X(f, {
                crossOrigin: x,
                integrity: v,
                fetchPriority: _,
                nonce: typeof p.nonce == "string" ? p.nonce : void 0
            });
        }
    }, $455d545b1dff00eb$var$Ja.preinitModule = function(f, p) {
        if (typeof f == "string") {
            if (typeof p == "object" && p !== null) {
                if (p.as == null || p.as === "script") {
                    var m = c(p.as, p.crossOrigin);
                    n.d.M(f, {
                        crossOrigin: m,
                        integrity: typeof p.integrity == "string" ? p.integrity : void 0,
                        nonce: typeof p.nonce == "string" ? p.nonce : void 0
                    });
                }
            } else p == null && n.d.M(f);
        }
    }, $455d545b1dff00eb$var$Ja.preload = function(f, p) {
        if (typeof f == "string" && typeof p == "object" && p !== null && typeof p.as == "string") {
            var m = p.as, x = c(m, p.crossOrigin);
            n.d.L(f, m, {
                crossOrigin: x,
                integrity: typeof p.integrity == "string" ? p.integrity : void 0,
                nonce: typeof p.nonce == "string" ? p.nonce : void 0,
                type: typeof p.type == "string" ? p.type : void 0,
                fetchPriority: typeof p.fetchPriority == "string" ? p.fetchPriority : void 0,
                referrerPolicy: typeof p.referrerPolicy == "string" ? p.referrerPolicy : void 0,
                imageSrcSet: typeof p.imageSrcSet == "string" ? p.imageSrcSet : void 0,
                imageSizes: typeof p.imageSizes == "string" ? p.imageSizes : void 0,
                media: typeof p.media == "string" ? p.media : void 0
            });
        }
    }, $455d545b1dff00eb$var$Ja.preloadModule = function(f, p) {
        if (typeof f == "string") {
            if (p) {
                var m = c(p.as, p.crossOrigin);
                n.d.m(f, {
                    as: typeof p.as == "string" && p.as !== "script" ? p.as : void 0,
                    crossOrigin: m,
                    integrity: typeof p.integrity == "string" ? p.integrity : void 0
                });
            } else n.d.m(f);
        }
    }, $455d545b1dff00eb$var$Ja.requestFormReset = function(f) {
        n.d.r(f);
    }, $455d545b1dff00eb$var$Ja.unstable_batchedUpdates = function(f, p) {
        return f(p);
    }, $455d545b1dff00eb$var$Ja.useFormState = function(f, p, m) {
        return l.H.useFormState(f, p, m);
    }, $455d545b1dff00eb$var$Ja.useFormStatus = function() {
        return l.H.useHostTransitionStatus();
    }, $455d545b1dff00eb$var$Ja.version = "19.2.0", $455d545b1dff00eb$var$Ja;
}
var $455d545b1dff00eb$var$E2;
function $455d545b1dff00eb$var$xC() {
    if ($455d545b1dff00eb$var$E2) return $455d545b1dff00eb$var$w1.exports;
    $455d545b1dff00eb$var$E2 = 1;
    function a() {
        if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
            __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
        } catch (e) {
            console.error(e);
        }
    }
    return a(), $455d545b1dff00eb$var$w1.exports = $455d545b1dff00eb$var$gC(), $455d545b1dff00eb$var$w1.exports;
}
var $455d545b1dff00eb$var$T2;
function $455d545b1dff00eb$var$vC() {
    if ($455d545b1dff00eb$var$T2) return $455d545b1dff00eb$var$xm;
    $455d545b1dff00eb$var$T2 = 1;
    var a = $455d545b1dff00eb$var$mC(), e = $455d545b1dff00eb$var$jd(), t = $455d545b1dff00eb$var$xC();
    function n(s) {
        var o = "https://react.dev/errors/" + s;
        if (1 < arguments.length) {
            o += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var d = 2; d < arguments.length; d++)o += "&args[]=" + encodeURIComponent(arguments[d]);
        }
        return "Minified React error #" + s + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function i(s) {
        return !(!s || s.nodeType !== 1 && s.nodeType !== 9 && s.nodeType !== 11);
    }
    function r(s) {
        var o = s, d = s;
        if (s.alternate) for(; o.return;)o = o.return;
        else {
            s = o;
            do o = s, (o.flags & 4098) !== 0 && (d = o.return), s = o.return;
            while (s);
        }
        return o.tag === 3 ? d : null;
    }
    function l(s) {
        if (s.tag === 13) {
            var o = s.memoizedState;
            if (o === null && (s = s.alternate, s !== null && (o = s.memoizedState)), o !== null) return o.dehydrated;
        }
        return null;
    }
    function c(s) {
        if (s.tag === 31) {
            var o = s.memoizedState;
            if (o === null && (s = s.alternate, s !== null && (o = s.memoizedState)), o !== null) return o.dehydrated;
        }
        return null;
    }
    function f(s) {
        if (r(s) !== s) throw Error(n(188));
    }
    function p(s) {
        var o = s.alternate;
        if (!o) {
            if (o = r(s), o === null) throw Error(n(188));
            return o !== s ? null : s;
        }
        for(var d = s, g = o;;){
            var E = d.return;
            if (E === null) break;
            var w = E.alternate;
            if (w === null) {
                if (g = E.return, g !== null) {
                    d = g;
                    continue;
                }
                break;
            }
            if (E.child === w.child) {
                for(w = E.child; w;){
                    if (w === d) return f(E), s;
                    if (w === g) return f(E), o;
                    w = w.sibling;
                }
                throw Error(n(188));
            }
            if (d.return !== g.return) d = E, g = w;
            else {
                for(var V = !1, re = E.child; re;){
                    if (re === d) {
                        V = !0, d = E, g = w;
                        break;
                    }
                    if (re === g) {
                        V = !0, g = E, d = w;
                        break;
                    }
                    re = re.sibling;
                }
                if (!V) {
                    for(re = w.child; re;){
                        if (re === d) {
                            V = !0, d = w, g = E;
                            break;
                        }
                        if (re === g) {
                            V = !0, g = w, d = E;
                            break;
                        }
                        re = re.sibling;
                    }
                    if (!V) throw Error(n(189));
                }
            }
            if (d.alternate !== g) throw Error(n(190));
        }
        if (d.tag !== 3) throw Error(n(188));
        return d.stateNode.current === d ? s : o;
    }
    function m(s) {
        var o = s.tag;
        if (o === 5 || o === 26 || o === 27 || o === 6) return s;
        for(s = s.child; s !== null;){
            if (o = m(s), o !== null) return o;
            s = s.sibling;
        }
        return null;
    }
    var x = Object.assign, v = Symbol.for("react.element"), _ = Symbol.for("react.transitional.element"), S = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), M = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), R = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), O = Symbol.for("react.activity"), D = Symbol.for("react.memo_cache_sentinel"), j = Symbol.iterator;
    function G(s) {
        return s === null || typeof s != "object" ? null : (s = j && s[j] || s["@@iterator"], typeof s == "function" ? s : null);
    }
    var q = Symbol.for("react.client.reference");
    function Y(s) {
        if (s == null) return null;
        if (typeof s == "function") return s.$$typeof === q ? null : s.displayName || s.name || null;
        if (typeof s == "string") return s;
        switch(s){
            case A:
                return "Fragment";
            case b:
                return "Profiler";
            case M:
                return "StrictMode";
            case z:
                return "Suspense";
            case L:
                return "SuspenseList";
            case O:
                return "Activity";
        }
        if (typeof s == "object") switch(s.$$typeof){
            case S:
                return "Portal";
            case R:
                return s.displayName || "Context";
            case C:
                return (s._context.displayName || "Context") + ".Consumer";
            case N:
                var o = s.render;
                return s = s.displayName, s || (s = o.displayName || o.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
            case P:
                return o = s.displayName || null, o !== null ? o : Y(s.type) || "Memo";
            case H:
                o = s._payload, s = s._init;
                try {
                    return Y(s(o));
                } catch  {}
        }
        return null;
    }
    var ae = Array.isArray, F = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Q = t.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = {
        pending: !1,
        data: null,
        method: null,
        action: null
    }, $ = [], ee = -1;
    function I(s) {
        return {
            current: s
        };
    }
    function Z(s) {
        0 > ee || (s.current = $[ee], $[ee] = null, ee--);
    }
    function oe(s, o) {
        ee++, $[ee] = s.current, s.current = o;
    }
    var ce = I(null), de = I(null), ue = I(null), le = I(null);
    function xe(s, o) {
        switch(oe(ue, o), oe(de, s), oe(ce, null), o.nodeType){
            case 9:
            case 11:
                s = (s = o.documentElement) && (s = s.namespaceURI) ? HS(s) : 0;
                break;
            default:
                if (s = o.tagName, o = o.namespaceURI) o = HS(o), s = VS(o, s);
                else switch(s){
                    case "svg":
                        s = 1;
                        break;
                    case "math":
                        s = 2;
                        break;
                    default:
                        s = 0;
                }
        }
        Z(ce), oe(ce, s);
    }
    function Le() {
        Z(ce), Z(de), Z(ue);
    }
    function Ue(s) {
        s.memoizedState !== null && oe(le, s);
        var o = ce.current, d = VS(o, s.type);
        o !== d && (oe(de, s), oe(ce, d));
    }
    function Ne(s) {
        de.current === s && (Z(ce), Z(de)), le.current === s && (Z(le), hm._currentValue = K);
    }
    var ke, nt;
    function Re(s) {
        if (ke === void 0) try {
            throw Error();
        } catch (d) {
            var o = d.stack.trim().match(/\n( *(at )?)/);
            ke = o && o[1] || "", nt = -1 < d.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < d.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return `
` + ke + s + nt;
    }
    var te = !1;
    function Oe(s, o) {
        if (!s || te) return "";
        te = !0;
        var d = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            var g = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (o) {
                            var ct = function() {
                                throw Error();
                            };
                            if (Object.defineProperty(ct.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            }), typeof Reflect == "object" && Reflect.construct) {
                                try {
                                    Reflect.construct(ct, []);
                                } catch (Qe) {
                                    var Xe = Qe;
                                }
                                Reflect.construct(s, [], ct);
                            } else {
                                try {
                                    ct.call();
                                } catch (Qe) {
                                    Xe = Qe;
                                }
                                s.call(ct.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (Qe) {
                                Xe = Qe;
                            }
                            (ct = s()) && typeof ct.catch == "function" && ct.catch(function() {});
                        }
                    } catch (Qe) {
                        if (Qe && Xe && typeof Qe.stack == "string") return [
                            Qe.stack,
                            Xe.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            g.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var E = Object.getOwnPropertyDescriptor(g.DetermineComponentFrameRoot, "name");
            E && E.configurable && Object.defineProperty(g.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var w = g.DetermineComponentFrameRoot(), V = w[0], re = w[1];
            if (V && re) {
                var ge = V.split(`
`), He = re.split(`
`);
                for(E = g = 0; g < ge.length && !ge[g].includes("DetermineComponentFrameRoot");)g++;
                for(; E < He.length && !He[E].includes("DetermineComponentFrameRoot");)E++;
                if (g === ge.length || E === He.length) for(g = ge.length - 1, E = He.length - 1; 1 <= g && 0 <= E && ge[g] !== He[E];)E--;
                for(; 1 <= g && 0 <= E; g--, E--)if (ge[g] !== He[E]) {
                    if (g !== 1 || E !== 1) do if (g--, E--, 0 > E || ge[g] !== He[E]) {
                        var et = `
` + ge[g].replace(" at new ", " at ");
                        return s.displayName && et.includes("<anonymous>") && (et = et.replace("<anonymous>", s.displayName)), et;
                    }
                    while (1 <= g && 0 <= E);
                    break;
                }
            }
        } finally{
            te = !1, Error.prepareStackTrace = d;
        }
        return (d = s ? s.displayName || s.name : "") ? Re(d) : "";
    }
    function Ie(s, o) {
        switch(s.tag){
            case 26:
            case 27:
            case 5:
                return Re(s.type);
            case 16:
                return Re("Lazy");
            case 13:
                return s.child !== o && o !== null ? Re("Suspense Fallback") : Re("Suspense");
            case 19:
                return Re("SuspenseList");
            case 0:
            case 15:
                return Oe(s.type, !1);
            case 11:
                return Oe(s.type.render, !1);
            case 1:
                return Oe(s.type, !0);
            case 31:
                return Re("Activity");
            default:
                return "";
        }
    }
    function Ae(s) {
        try {
            var o = "", d = null;
            do o += Ie(s, d), d = s, s = s.return;
            while (s);
            return o;
        } catch (g) {
            return `
Error generating stack: ` + g.message + `
` + g.stack;
        }
    }
    var ze = Object.prototype.hasOwnProperty, Ze = a.unstable_scheduleCallback, be = a.unstable_cancelCallback, rt = a.unstable_shouldYield, ne = a.unstable_requestPaint, W = a.unstable_now, pe = a.unstable_getCurrentPriorityLevel, Be = a.unstable_ImmediatePriority, Te = a.unstable_UserBlockingPriority, _e = a.unstable_NormalPriority, ot = a.unstable_LowPriority, tt = a.unstable_IdlePriority, gt = a.log, pt = a.unstable_setDisableYieldValue, Ge = null, Ye = null;
    function at(s) {
        if (typeof gt == "function" && pt(s), Ye && typeof Ye.setStrictMode == "function") try {
            Ye.setStrictMode(Ge, s);
        } catch  {}
    }
    var he = Math.clz32 ? Math.clz32 : fe, Ee = Math.log, lt = Math.LN2;
    function fe(s) {
        return s >>>= 0, s === 0 ? 32 : 31 - (Ee(s) / lt | 0) | 0;
    }
    var We = 256, Je = 262144, ut = 4194304;
    function Ke(s) {
        var o = s & 42;
        if (o !== 0) return o;
        switch(s & -s){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return s & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return s & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return s & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return s;
        }
    }
    function Ve(s, o, d) {
        var g = s.pendingLanes;
        if (g === 0) return 0;
        var E = 0, w = s.suspendedLanes, V = s.pingedLanes;
        s = s.warmLanes;
        var re = g & 134217727;
        return re !== 0 ? (g = re & ~w, g !== 0 ? E = Ke(g) : (V &= re, V !== 0 ? E = Ke(V) : d || (d = re & ~s, d !== 0 && (E = Ke(d))))) : (re = g & ~w, re !== 0 ? E = Ke(re) : V !== 0 ? E = Ke(V) : d || (d = g & ~s, d !== 0 && (E = Ke(d)))), E === 0 ? 0 : o !== 0 && o !== E && (o & w) === 0 && (w = E & -E, d = o & -o, w >= d || w === 32 && (d & 4194048) !== 0) ? o : E;
    }
    function ft(s, o) {
        return (s.pendingLanes & ~(s.suspendedLanes & ~s.pingedLanes) & o) === 0;
    }
    function vt(s, o) {
        switch(s){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return o + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return o + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yt() {
        var s = ut;
        return ut <<= 1, (ut & 62914560) === 0 && (ut = 4194304), s;
    }
    function Ct(s) {
        for(var o = [], d = 0; 31 > d; d++)o.push(s);
        return o;
    }
    function on(s, o) {
        s.pendingLanes |= o, o !== 268435456 && (s.suspendedLanes = 0, s.pingedLanes = 0, s.warmLanes = 0);
    }
    function gn(s, o, d, g, E, w) {
        var V = s.pendingLanes;
        s.pendingLanes = d, s.suspendedLanes = 0, s.pingedLanes = 0, s.warmLanes = 0, s.expiredLanes &= d, s.entangledLanes &= d, s.errorRecoveryDisabledLanes &= d, s.shellSuspendCounter = 0;
        var re = s.entanglements, ge = s.expirationTimes, He = s.hiddenUpdates;
        for(d = V & ~d; 0 < d;){
            var et = 31 - he(d), ct = 1 << et;
            re[et] = 0, ge[et] = -1;
            var Xe = He[et];
            if (Xe !== null) for(He[et] = null, et = 0; et < Xe.length; et++){
                var Qe = Xe[et];
                Qe !== null && (Qe.lane &= -536870913);
            }
            d &= ~ct;
        }
        g !== 0 && ni(s, g, 0), w !== 0 && E === 0 && s.tag !== 0 && (s.suspendedLanes |= w & ~(V & ~o));
    }
    function ni(s, o, d) {
        s.pendingLanes |= o, s.suspendedLanes &= ~o;
        var g = 31 - he(o);
        s.entangledLanes |= o, s.entanglements[g] = s.entanglements[g] | 1073741824 | d & 261930;
    }
    function Gi(s, o) {
        var d = s.entangledLanes |= o;
        for(s = s.entanglements; d;){
            var g = 31 - he(d), E = 1 << g;
            E & o | s[g] & o && (s[g] |= o), d &= ~E;
        }
    }
    function da(s, o) {
        var d = o & -o;
        return d = (d & 42) !== 0 ? 1 : jn(d), (d & (s.suspendedLanes | o)) !== 0 ? 0 : d;
    }
    function jn(s) {
        switch(s){
            case 2:
                s = 1;
                break;
            case 8:
                s = 4;
                break;
            case 32:
                s = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                s = 128;
                break;
            case 268435456:
                s = 134217728;
                break;
            default:
                s = 0;
        }
        return s;
    }
    function ea(s) {
        return s &= -s, 2 < s ? 8 < s ? (s & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
    }
    function Pi() {
        var s = Q.p;
        return s !== 0 ? s : (s = window.event, s === void 0 ? 32 : u2(s.type));
    }
    function hi(s, o) {
        var d = Q.p;
        try {
            return Q.p = s, o();
        } finally{
            Q.p = d;
        }
    }
    var Nn = Math.random().toString(36).slice(2), jt = "__reactFiber$" + Nn, ci = "__reactProps$" + Nn, Aa = "__reactContainer$" + Nn, Qs = "__reactEvents$" + Nn, Tl = "__reactListeners$" + Nn, zo = "__reactHandles$" + Nn, Ss = "__reactResources$" + Nn, es = "__reactMarker$" + Nn;
    function Ms(s) {
        delete s[jt], delete s[ci], delete s[Qs], delete s[Tl], delete s[zo];
    }
    function Qn(s) {
        var o = s[jt];
        if (o) return o;
        for(var d = s.parentNode; d;){
            if (o = d[Aa] || d[jt]) {
                if (d = o.alternate, o.child !== null || d !== null && d.child !== null) for(s = YS(s); s !== null;){
                    if (d = s[jt]) return d;
                    s = YS(s);
                }
                return o;
            }
            s = d, d = s.parentNode;
        }
        return null;
    }
    function ie(s) {
        if (s = s[jt] || s[Aa]) {
            var o = s.tag;
            if (o === 5 || o === 6 || o === 13 || o === 31 || o === 26 || o === 27 || o === 3) return s;
        }
        return null;
    }
    function Se(s) {
        var o = s.tag;
        if (o === 5 || o === 26 || o === 27 || o === 6) return s.stateNode;
        throw Error(n(33));
    }
    function ve(s) {
        var o = s[Ss];
        return o || (o = s[Ss] = {
            hoistableStyles: new Map,
            hoistableScripts: new Map
        }), o;
    }
    function Pe(s) {
        s[es] = !0;
    }
    var Me = new Set, dt = {};
    function xt(s, o) {
        Et(s, o), Et(s + "Capture", o);
    }
    function Et(s, o) {
        for(dt[s] = o, s = 0; s < o.length; s++)Me.add(o[s]);
    }
    var Tt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Ot = {}, Pt = {};
    function Ut(s) {
        return ze.call(Pt, s) ? !0 : ze.call(Ot, s) ? !1 : Tt.test(s) ? Pt[s] = !0 : (Ot[s] = !0, !1);
    }
    function qt(s, o, d) {
        if (Ut(o)) {
            if (d === null) s.removeAttribute(o);
            else {
                switch(typeof d){
                    case "undefined":
                    case "function":
                    case "symbol":
                        s.removeAttribute(o);
                        return;
                    case "boolean":
                        var g = o.toLowerCase().slice(0, 5);
                        if (g !== "data-" && g !== "aria-") {
                            s.removeAttribute(o);
                            return;
                        }
                }
                s.setAttribute(o, "" + d);
            }
        }
    }
    function mn(s, o, d) {
        if (d === null) s.removeAttribute(o);
        else {
            switch(typeof d){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    s.removeAttribute(o);
                    return;
            }
            s.setAttribute(o, "" + d);
        }
    }
    function fn(s, o, d, g) {
        if (g === null) s.removeAttribute(d);
        else {
            switch(typeof g){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    s.removeAttribute(d);
                    return;
            }
            s.setAttributeNS(o, d, "" + g);
        }
    }
    function ln(s) {
        switch(typeof s){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return s;
            case "object":
                return s;
            default:
                return "";
        }
    }
    function xn(s) {
        var o = s.type;
        return (s = s.nodeName) && s.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
    }
    function Lt(s, o, d) {
        var g = Object.getOwnPropertyDescriptor(s.constructor.prototype, o);
        if (!s.hasOwnProperty(o) && typeof g < "u" && typeof g.get == "function" && typeof g.set == "function") {
            var E = g.get, w = g.set;
            return Object.defineProperty(s, o, {
                configurable: !0,
                get: function() {
                    return E.call(this);
                },
                set: function(V) {
                    d = "" + V, w.call(this, V);
                }
            }), Object.defineProperty(s, o, {
                enumerable: g.enumerable
            }), {
                getValue: function() {
                    return d;
                },
                setValue: function(V) {
                    d = "" + V;
                },
                stopTracking: function() {
                    s._valueTracker = null, delete s[o];
                }
            };
        }
    }
    function _n(s) {
        if (!s._valueTracker) {
            var o = xn(s) ? "checked" : "value";
            s._valueTracker = Lt(s, o, "" + s[o]);
        }
    }
    function an(s) {
        if (!s) return !1;
        var o = s._valueTracker;
        if (!o) return !0;
        var d = o.getValue(), g = "";
        return s && (g = xn(s) ? s.checked ? "true" : "false" : s.value), s = g, s !== d ? (o.setValue(s), !0) : !1;
    }
    function ui(s) {
        if (s = s || (typeof document < "u" ? document : void 0), typeof s > "u") return null;
        try {
            return s.activeElement || s.body;
        } catch  {
            return s.body;
        }
    }
    var sr = /[\n"\\]/g;
    function hn(s) {
        return s.replace(sr, function(o) {
            return "\\" + o.charCodeAt(0).toString(16) + " ";
        });
    }
    function Or(s, o, d, g, E, w, V, re) {
        s.name = "", V != null && typeof V != "function" && typeof V != "symbol" && typeof V != "boolean" ? s.type = V : s.removeAttribute("type"), o != null ? V === "number" ? (o === 0 && s.value === "" || s.value != o) && (s.value = "" + ln(o)) : s.value !== "" + ln(o) && (s.value = "" + ln(o)) : V !== "submit" && V !== "reset" || s.removeAttribute("value"), o != null ? ii(s, V, ln(o)) : d != null ? ii(s, V, ln(d)) : g != null && s.removeAttribute("value"), E == null && w != null && (s.defaultChecked = !!w), E != null && (s.checked = E && typeof E != "function" && typeof E != "symbol"), re != null && typeof re != "function" && typeof re != "symbol" && typeof re != "boolean" ? s.name = "" + ln(re) : s.removeAttribute("name");
    }
    function On(s, o, d, g, E, w, V, re) {
        if (w != null && typeof w != "function" && typeof w != "symbol" && typeof w != "boolean" && (s.type = w), o != null || d != null) {
            if (!(w !== "submit" && w !== "reset" || o != null)) {
                _n(s);
                return;
            }
            d = d != null ? "" + ln(d) : "", o = o != null ? "" + ln(o) : d, re || o === s.value || (s.value = o), s.defaultValue = o;
        }
        g = g ?? E, g = typeof g != "function" && typeof g != "symbol" && !!g, s.checked = re ? s.checked : !!g, s.defaultChecked = !!g, V != null && typeof V != "function" && typeof V != "symbol" && typeof V != "boolean" && (s.name = V), _n(s);
    }
    function ii(s, o, d) {
        o === "number" && ui(s.ownerDocument) === s || s.defaultValue === "" + d || (s.defaultValue = "" + d);
    }
    function gi(s, o, d, g) {
        if (s = s.options, o) {
            o = {};
            for(var E = 0; E < d.length; E++)o["$" + d[E]] = !0;
            for(d = 0; d < s.length; d++)E = o.hasOwnProperty("$" + s[d].value), s[d].selected !== E && (s[d].selected = E), E && g && (s[d].defaultSelected = !0);
        } else {
            for(d = "" + ln(d), o = null, E = 0; E < s.length; E++){
                if (s[E].value === d) {
                    s[E].selected = !0, g && (s[E].defaultSelected = !0);
                    return;
                }
                o !== null || s[E].disabled || (o = s[E]);
            }
            o !== null && (o.selected = !0);
        }
    }
    function fi(s, o, d) {
        if (o != null && (o = "" + ln(o), o !== s.value && (s.value = o), d == null)) {
            s.defaultValue !== o && (s.defaultValue = o);
            return;
        }
        s.defaultValue = d != null ? "" + ln(d) : "";
    }
    function qn(s, o, d, g) {
        if (o == null) {
            if (g != null) {
                if (d != null) throw Error(n(92));
                if (ae(g)) {
                    if (1 < g.length) throw Error(n(93));
                    g = g[0];
                }
                d = g;
            }
            d == null && (d = ""), o = d;
        }
        d = ln(o), s.defaultValue = d, g = s.textContent, g === d && g !== "" && g !== null && (s.value = g), _n(s);
    }
    function wa(s, o) {
        if (o) {
            var d = s.firstChild;
            if (d && d === s.lastChild && d.nodeType === 3) {
                d.nodeValue = o;
                return;
            }
        }
        s.textContent = o;
    }
    var Ca = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
    function Po(s, o, d) {
        var g = o.indexOf("--") === 0;
        d == null || typeof d == "boolean" || d === "" ? g ? s.setProperty(o, "") : o === "float" ? s.cssFloat = "" : s[o] = "" : g ? s.setProperty(o, d) : typeof d != "number" || d === 0 || Ca.has(o) ? o === "float" ? s.cssFloat = d : s[o] = ("" + d).trim() : s[o] = d + "px";
    }
    function Al(s, o, d) {
        if (o != null && typeof o != "object") throw Error(n(62));
        if (s = s.style, d != null) {
            for(var g in d)!d.hasOwnProperty(g) || o != null && o.hasOwnProperty(g) || (g.indexOf("--") === 0 ? s.setProperty(g, "") : g === "float" ? s.cssFloat = "" : s[g] = "");
            for(var E in o)g = o[E], o.hasOwnProperty(E) && d[E] !== g && Po(s, E, g);
        } else for(var w in o)o.hasOwnProperty(w) && Po(s, w, o[w]);
    }
    function ts(s) {
        if (s.indexOf("-") === -1) return !1;
        switch(s){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    var Nu = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), wl = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
    function Lr(s) {
        return wl.test("" + s) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : s;
    }
    function ta() {}
    var ns = null;
    function Cl(s) {
        return s = s.target || s.srcElement || window, s.correspondingUseElement && (s = s.correspondingUseElement), s.nodeType === 3 ? s.parentNode : s;
    }
    var or = null, zr = null;
    function Rl(s) {
        var o = ie(s);
        if (o && (s = o.stateNode)) {
            var d = s[ci] || null;
            e: switch(s = o.stateNode, o.type){
                case "input":
                    if (Or(s, d.value, d.defaultValue, d.defaultValue, d.checked, d.defaultChecked, d.type, d.name), o = d.name, d.type === "radio" && o != null) {
                        for(d = s; d.parentNode;)d = d.parentNode;
                        for(d = d.querySelectorAll('input[name="' + hn("" + o) + '"][type="radio"]'), o = 0; o < d.length; o++){
                            var g = d[o];
                            if (g !== s && g.form === s.form) {
                                var E = g[ci] || null;
                                if (!E) throw Error(n(90));
                                Or(g, E.value, E.defaultValue, E.defaultValue, E.checked, E.defaultChecked, E.type, E.name);
                            }
                        }
                        for(o = 0; o < d.length; o++)g = d[o], g.form === s.form && an(g);
                    }
                    break e;
                case "textarea":
                    fi(s, d.value, d.defaultValue);
                    break e;
                case "select":
                    o = d.value, o != null && gi(s, !!d.multiple, o, !1);
            }
        }
    }
    var Dl = !1;
    function Bo(s, o, d) {
        if (Dl) return s(o, d);
        Dl = !0;
        try {
            var g = s(o);
            return g;
        } finally{
            if (Dl = !1, (or !== null || zr !== null) && (se(), or && (o = or, s = zr, zr = or = null, Rl(o), s))) for(o = 0; o < s.length; o++)Rl(s[o]);
        }
    }
    function is(s, o) {
        var d = s.stateNode;
        if (d === null) return null;
        var g = d[ci] || null;
        if (g === null) return null;
        d = g[o];
        e: switch(o){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (g = !g.disabled) || (s = s.type, g = !(s === "button" || s === "input" || s === "select" || s === "textarea")), s = !g;
                break e;
            default:
                s = !1;
        }
        if (s) return null;
        if (d && typeof d != "function") throw Error(n(231, o, typeof d));
        return d;
    }
    var lr = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), pa = !1;
    if (lr) try {
        var Ks = {};
        Object.defineProperty(Ks, "passive", {
            get: function() {
                pa = !0;
            }
        }), window.addEventListener("test", Ks, Ks), window.removeEventListener("test", Ks, Ks);
    } catch  {
        pa = !1;
    }
    var as = null, Ul = null, Pr = null;
    function Nl() {
        if (Pr) return Pr;
        var s, o = Ul, d = o.length, g, E = "value" in as ? as.value : as.textContent, w = E.length;
        for(s = 0; s < d && o[s] === E[s]; s++);
        var V = d - s;
        for(g = 1; g <= V && o[d - g] === E[w - g]; g++);
        return Pr = E.slice(s, 1 < g ? 1 - g : void 0);
    }
    function Es(s) {
        var o = s.keyCode;
        return "charCode" in s ? (s = s.charCode, s === 0 && o === 13 && (s = 13)) : s = o, s === 10 && (s = 13), 32 <= s || s === 13 ? s : 0;
    }
    function rs() {
        return !0;
    }
    function Js() {
        return !1;
    }
    function ai(s) {
        function o(d, g, E, w, V) {
            this._reactName = d, this._targetInst = E, this.type = g, this.nativeEvent = w, this.target = V, this.currentTarget = null;
            for(var re in s)s.hasOwnProperty(re) && (d = s[re], this[re] = d ? d(w) : w[re]);
            return this.isDefaultPrevented = (w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1) ? rs : Js, this.isPropagationStopped = Js, this;
        }
        return x(o.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var d = this.nativeEvent;
                d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = rs);
            },
            stopPropagation: function() {
                var d = this.nativeEvent;
                d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = rs);
            },
            persist: function() {},
            isPersistent: rs
        }), o;
    }
    var ss = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(s) {
            return s.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, $s = ai(ss), Ra = x({}, ss, {
        view: 0,
        detail: 0
    }), Ts = ai(Ra), Ol, os, As, ki = x({}, Ra, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: zu,
        button: 0,
        buttons: 0,
        relatedTarget: function(s) {
            return s.relatedTarget === void 0 ? s.fromElement === s.srcElement ? s.toElement : s.fromElement : s.relatedTarget;
        },
        movementX: function(s) {
            return "movementX" in s ? s.movementX : (s !== As && (As && s.type === "mousemove" ? (Ol = s.screenX - As.screenX, os = s.screenY - As.screenY) : os = Ol = 0, As = s), Ol);
        },
        movementY: function(s) {
            return "movementY" in s ? s.movementY : os;
        }
    }), eh = ai(ki), xi = x({}, ki, {
        dataTransfer: 0
    }), Ll = ai(xi), Ou = x({}, Ra, {
        relatedTarget: 0
    }), wc = ai(Ou), na = x({}, ss, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), Ha = ai(na), Bi = x({}, ss, {
        clipboardData: function(s) {
            return "clipboardData" in s ? s.clipboardData : window.clipboardData;
        }
    }), Br = ai(Bi), Lu = x({}, ss, {
        data: 0
    }), Kd = ai(Lu), L0 = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, Jd = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, $d = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    };
    function z0(s) {
        var o = this.nativeEvent;
        return o.getModifierState ? o.getModifierState(s) : (s = $d[s]) ? !!o[s] : !1;
    }
    function zu() {
        return z0;
    }
    var ep = x({}, Ra, {
        key: function(s) {
            if (s.key) {
                var o = L0[s.key] || s.key;
                if (o !== "Unidentified") return o;
            }
            return s.type === "keypress" ? (s = Es(s), s === 13 ? "Enter" : String.fromCharCode(s)) : s.type === "keydown" || s.type === "keyup" ? Jd[s.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: zu,
        charCode: function(s) {
            return s.type === "keypress" ? Es(s) : 0;
        },
        keyCode: function(s) {
            return s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
        },
        which: function(s) {
            return s.type === "keypress" ? Es(s) : s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
        }
    }), tp = ai(ep), P0 = x({}, ki, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), th = ai(P0), B0 = x({}, Ra, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: zu
    }), eo = ai(B0), np = x({}, ss, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), Vy = ai(np), I0 = x({}, ki, {
        deltaX: function(s) {
            return "deltaX" in s ? s.deltaX : "wheelDeltaX" in s ? -s.wheelDeltaX : 0;
        },
        deltaY: function(s) {
            return "deltaY" in s ? s.deltaY : "wheelDeltaY" in s ? -s.wheelDeltaY : "wheelDelta" in s ? -s.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), Io = ai(I0), to = x({}, ss, {
        newState: 0,
        oldState: 0
    }), ip = ai(to), ap = [
        9,
        13,
        27,
        32
    ], zl = lr && "CompositionEvent" in window, Fo = null;
    lr && "documentMode" in document && (Fo = document.documentMode);
    var Pl = lr && "TextEvent" in window && !Fo, ia = lr && (!zl || Fo && 8 < Fo && 11 >= Fo), Pu = " ", rp = !1;
    function nh(s, o) {
        switch(s){
            case "keyup":
                return ap.indexOf(o.keyCode) !== -1;
            case "keydown":
                return o.keyCode !== 229;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function Cc(s) {
        return s = s.detail, typeof s == "object" && "data" in s ? s.data : null;
    }
    var Ho = !1;
    function ih(s, o) {
        switch(s){
            case "compositionend":
                return Cc(o);
            case "keypress":
                return o.which !== 32 ? null : (rp = !0, Pu);
            case "textInput":
                return s = o.data, s === Pu && rp ? null : s;
            default:
                return null;
        }
    }
    function F0(s, o) {
        if (Ho) return s === "compositionend" || !zl && nh(s, o) ? (s = Nl(), Pr = Ul = as = null, Ho = !1, s) : null;
        switch(s){
            case "paste":
                return null;
            case "keypress":
                if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
                    if (o.char && 1 < o.char.length) return o.char;
                    if (o.which) return String.fromCharCode(o.which);
                }
                return null;
            case "compositionend":
                return ia && o.locale !== "ko" ? null : o.data;
            default:
                return null;
        }
    }
    var cr = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    };
    function sp(s) {
        var o = s && s.nodeName && s.nodeName.toLowerCase();
        return o === "input" ? !!cr[s.type] : o === "textarea";
    }
    function ah(s, o, d, g) {
        or ? zr ? zr.push(g) : zr = [
            g
        ] : or = g, o = Dg(o, "onChange"), 0 < o.length && (d = new $s("onChange", "change", null, d, g), s.push({
            event: d,
            listeners: o
        }));
    }
    var Rc = null, Dc = null;
    function op(s) {
        LS(s, 0);
    }
    function Uc(s) {
        var o = Se(s);
        if (an(o)) return s;
    }
    function lp(s, o) {
        if (s === "change") return o;
    }
    var Bu = !1;
    if (lr) {
        var Bl;
        if (lr) {
            var ri = "oninput" in document;
            if (!ri) {
                var H0 = document.createElement("div");
                H0.setAttribute("oninput", "return;"), ri = typeof H0.oninput == "function";
            }
            Bl = ri;
        } else Bl = !1;
        Bu = Bl && (!document.documentMode || 9 < document.documentMode);
    }
    function V0() {
        Rc && (Rc.detachEvent("onpropertychange", cp), Dc = Rc = null);
    }
    function cp(s) {
        if (s.propertyName === "value" && Uc(Dc)) {
            var o = [];
            ah(o, Dc, s, Cl(s)), Bo(op, o);
        }
    }
    function Iu(s, o, d) {
        s === "focusin" ? (V0(), Rc = o, Dc = d, Rc.attachEvent("onpropertychange", cp)) : s === "focusout" && V0();
    }
    function Vo(s) {
        if (s === "selectionchange" || s === "keyup" || s === "keydown") return Uc(Dc);
    }
    function G0(s, o) {
        if (s === "click") return Uc(o);
    }
    function k0(s, o) {
        if (s === "input" || s === "change") return Uc(o);
    }
    function Il(s, o) {
        return s === o && (s !== 0 || 1 / s === 1 / o) || s !== s && o !== o;
    }
    var si = typeof Object.is == "function" ? Object.is : Il;
    function Nc(s, o) {
        if (si(s, o)) return !0;
        if (typeof s != "object" || s === null || typeof o != "object" || o === null) return !1;
        var d = Object.keys(s), g = Object.keys(o);
        if (d.length !== g.length) return !1;
        for(g = 0; g < d.length; g++){
            var E = d[g];
            if (!ze.call(o, E) || !si(s[E], o[E])) return !1;
        }
        return !0;
    }
    function up(s) {
        for(; s && s.firstChild;)s = s.firstChild;
        return s;
    }
    function fp(s, o) {
        var d = up(s);
        s = 0;
        for(var g; d;){
            if (d.nodeType === 3) {
                if (g = s + d.textContent.length, s <= o && g >= o) return {
                    node: d,
                    offset: o - s
                };
                s = g;
            }
            e: {
                for(; d;){
                    if (d.nextSibling) {
                        d = d.nextSibling;
                        break e;
                    }
                    d = d.parentNode;
                }
                d = void 0;
            }
            d = up(d);
        }
    }
    function rh(s, o) {
        return s && o ? s === o ? !0 : s && s.nodeType === 3 ? !1 : o && o.nodeType === 3 ? rh(s, o.parentNode) : "contains" in s ? s.contains(o) : s.compareDocumentPosition ? !!(s.compareDocumentPosition(o) & 16) : !1 : !1;
    }
    function sh(s) {
        s = s != null && s.ownerDocument != null && s.ownerDocument.defaultView != null ? s.ownerDocument.defaultView : window;
        for(var o = ui(s.document); o instanceof s.HTMLIFrameElement;){
            try {
                var d = typeof o.contentWindow.location.href == "string";
            } catch  {
                d = !1;
            }
            if (d) s = o.contentWindow;
            else break;
            o = ui(s.document);
        }
        return o;
    }
    function Oc(s) {
        var o = s && s.nodeName && s.nodeName.toLowerCase();
        return o && (o === "input" && (s.type === "text" || s.type === "search" || s.type === "tel" || s.type === "url" || s.type === "password") || o === "textarea" || s.contentEditable === "true");
    }
    var j0 = lr && "documentMode" in document && 11 >= document.documentMode, Lc = null, oh = null, zc = null, ur = !1;
    function lh(s, o, d) {
        var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
        ur || Lc == null || Lc !== ui(g) || (g = Lc, "selectionStart" in g && Oc(g) ? g = {
            start: g.selectionStart,
            end: g.selectionEnd
        } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = {
            anchorNode: g.anchorNode,
            anchorOffset: g.anchorOffset,
            focusNode: g.focusNode,
            focusOffset: g.focusOffset
        }), zc && Nc(zc, g) || (zc = g, g = Dg(oh, "onSelect"), 0 < g.length && (o = new $s("onSelect", "select", null, o, d), s.push({
            event: o,
            listeners: g
        }), o.target = Lc)));
    }
    function Go(s, o) {
        var d = {};
        return d[s.toLowerCase()] = o.toLowerCase(), d["Webkit" + s] = "webkit" + o, d["Moz" + s] = "moz" + o, d;
    }
    var Pc = {
        animationend: Go("Animation", "AnimationEnd"),
        animationiteration: Go("Animation", "AnimationIteration"),
        animationstart: Go("Animation", "AnimationStart"),
        transitionrun: Go("Transition", "TransitionRun"),
        transitionstart: Go("Transition", "TransitionStart"),
        transitioncancel: Go("Transition", "TransitionCancel"),
        transitionend: Go("Transition", "TransitionEnd")
    }, Fu = {}, Da = {};
    lr && (Da = document.createElement("div").style, "AnimationEvent" in window || (delete Pc.animationend.animation, delete Pc.animationiteration.animation, delete Pc.animationstart.animation), "TransitionEvent" in window || delete Pc.transitionend.transition);
    function ko(s) {
        if (Fu[s]) return Fu[s];
        if (!Pc[s]) return s;
        var o = Pc[s], d;
        for(d in o)if (o.hasOwnProperty(d) && d in Da) return Fu[s] = o[d];
        return s;
    }
    var Va = ko("animationend"), hp = ko("animationiteration"), ws = ko("animationstart"), Bc = ko("transitionrun"), jo = ko("transitionstart"), dp = ko("transitioncancel"), ch = ko("transitionend"), no = new Map, uh = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    uh.push("scrollEnd");
    function ma(s, o) {
        no.set(s, o), xt(o, [
            s
        ]);
    }
    var Xo = typeof reportError == "function" ? reportError : function(s) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
            var o = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: typeof s == "object" && s !== null && typeof s.message == "string" ? String(s.message) : String(s),
                error: s
            });
            if (!window.dispatchEvent(o)) return;
        } else if (typeof $hPtJY == "object" && typeof $hPtJY.emit == "function") {
            $hPtJY.emit("uncaughtException", s);
            return;
        }
        console.error(s);
    }, Yi = [], Fl = 0, fh = 0;
    function Wo() {
        for(var s = Fl, o = fh = Fl = 0; o < s;){
            var d = Yi[o];
            Yi[o++] = null;
            var g = Yi[o];
            Yi[o++] = null;
            var E = Yi[o];
            Yi[o++] = null;
            var w = Yi[o];
            if (Yi[o++] = null, g !== null && E !== null) {
                var V = g.pending;
                V === null ? E.next = E : (E.next = V.next, V.next = E), g.pending = E;
            }
            w !== 0 && hh(d, E, w);
        }
    }
    function Hu(s, o, d, g) {
        Yi[Fl++] = s, Yi[Fl++] = o, Yi[Fl++] = d, Yi[Fl++] = g, fh |= g, s.lanes |= g, s = s.alternate, s !== null && (s.lanes |= g);
    }
    function Ic(s, o, d, g) {
        return Hu(s, o, d, g), Fc(s);
    }
    function qo(s, o) {
        return Hu(s, null, null, o), Fc(s);
    }
    function hh(s, o, d) {
        s.lanes |= d;
        var g = s.alternate;
        g !== null && (g.lanes |= d);
        for(var E = !1, w = s.return; w !== null;)w.childLanes |= d, g = w.alternate, g !== null && (g.childLanes |= d), w.tag === 22 && (s = w.stateNode, s === null || s._visibility & 1 || (E = !0)), s = w, w = w.return;
        return s.tag === 3 ? (w = s.stateNode, E && o !== null && (E = 31 - he(d), s = w.hiddenUpdates, g = s[E], g === null ? s[E] = [
            o
        ] : g.push(o), o.lane = d | 536870912), w) : null;
    }
    function Fc(s) {
        if (50 < nc) throw nc = 0, ic = null, Error(n(185));
        for(var o = s.return; o !== null;)s = o, o = s.return;
        return s.tag === 3 ? s.stateNode : null;
    }
    var Yo = {};
    function X0(s, o, d, g) {
        this.tag = s, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function Ua(s, o, d, g) {
        return new X0(s, o, d, g);
    }
    function Na(s) {
        return s = s.prototype, !(!s || !s.isReactComponent);
    }
    function Cs(s, o) {
        var d = s.alternate;
        return d === null ? (d = Ua(s.tag, o, s.key, s.mode), d.elementType = s.elementType, d.type = s.type, d.stateNode = s.stateNode, d.alternate = s, s.alternate = d) : (d.pendingProps = o, d.type = s.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = s.flags & 65011712, d.childLanes = s.childLanes, d.lanes = s.lanes, d.child = s.child, d.memoizedProps = s.memoizedProps, d.memoizedState = s.memoizedState, d.updateQueue = s.updateQueue, o = s.dependencies, d.dependencies = o === null ? null : {
            lanes: o.lanes,
            firstContext: o.firstContext
        }, d.sibling = s.sibling, d.index = s.index, d.ref = s.ref, d.refCleanup = s.refCleanup, d;
    }
    function ga(s, o) {
        s.flags &= 65011714;
        var d = s.alternate;
        return d === null ? (s.childLanes = 0, s.lanes = o, s.child = null, s.subtreeFlags = 0, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null) : (s.childLanes = d.childLanes, s.lanes = d.lanes, s.child = d.child, s.subtreeFlags = 0, s.deletions = null, s.memoizedProps = d.memoizedProps, s.memoizedState = d.memoizedState, s.updateQueue = d.updateQueue, s.type = d.type, o = d.dependencies, s.dependencies = o === null ? null : {
            lanes: o.lanes,
            firstContext: o.firstContext
        }), s;
    }
    function Vu(s, o, d, g, E, w) {
        var V = 0;
        if (g = s, typeof s == "function") Na(s) && (V = 1);
        else if (typeof s == "string") V = $w(s, d, ce.current) ? 26 : s === "html" || s === "head" || s === "body" ? 27 : 5;
        else e: switch(s){
            case O:
                return s = Ua(31, d, o, E), s.elementType = O, s.lanes = w, s;
            case A:
                return io(d.children, E, w, o);
            case M:
                V = 8, E |= 24;
                break;
            case b:
                return s = Ua(12, d, o, E | 2), s.elementType = b, s.lanes = w, s;
            case z:
                return s = Ua(13, d, o, E), s.elementType = z, s.lanes = w, s;
            case L:
                return s = Ua(19, d, o, E), s.elementType = L, s.lanes = w, s;
            default:
                if (typeof s == "object" && s !== null) switch(s.$$typeof){
                    case R:
                        V = 10;
                        break e;
                    case C:
                        V = 9;
                        break e;
                    case N:
                        V = 11;
                        break e;
                    case P:
                        V = 14;
                        break e;
                    case H:
                        V = 16, g = null;
                        break e;
                }
                V = 29, d = Error(n(130, s === null ? "null" : typeof s, "")), g = null;
        }
        return o = Ua(V, d, o, E), o.elementType = s, o.type = g, o.lanes = w, o;
    }
    function io(s, o, d, g) {
        return s = Ua(7, s, g, o), s.lanes = d, s;
    }
    function dh(s, o, d) {
        return s = Ua(6, s, null, o), s.lanes = d, s;
    }
    function W0(s) {
        var o = Ua(18, null, null, 0);
        return o.stateNode = s, o;
    }
    function ls(s, o, d) {
        return o = Ua(4, s.children !== null ? s.children : [], s.key, o), o.lanes = d, o.stateNode = {
            containerInfo: s.containerInfo,
            pendingChildren: null,
            implementation: s.implementation
        }, o;
    }
    var pp = new WeakMap;
    function Ga(s, o) {
        if (typeof s == "object" && s !== null) {
            var d = pp.get(s);
            return d !== void 0 ? d : (o = {
                value: s,
                source: o,
                stack: Ae(o)
            }, pp.set(s, o), o);
        }
        return {
            value: s,
            source: o,
            stack: Ae(o)
        };
    }
    var cs = [], Hl = 0, Gu = null, Hc = 0, fr = [], ka = 0, Rs = null, Ds = 1, Us = "";
    function ao(s, o) {
        cs[Hl++] = Hc, cs[Hl++] = Gu, Gu = s, Hc = o;
    }
    function mp(s, o, d) {
        fr[ka++] = Ds, fr[ka++] = Us, fr[ka++] = Rs, Rs = s;
        var g = Ds;
        s = Us;
        var E = 32 - he(g) - 1;
        g &= ~(1 << E), d += 1;
        var w = 32 - he(o) + E;
        if (30 < w) {
            var V = E - E % 5;
            w = (g & (1 << V) - 1).toString(32), g >>= V, E -= V, Ds = 1 << 32 - he(o) + E | d << E | g, Us = w + s;
        } else Ds = 1 << w | d << E | g, Us = s;
    }
    function ph(s) {
        s.return !== null && (ao(s, 1), mp(s, 1, 0));
    }
    function Zo(s) {
        for(; s === Gu;)Gu = cs[--Hl], cs[Hl] = null, Hc = cs[--Hl], cs[Hl] = null;
        for(; s === Rs;)Rs = fr[--ka], fr[ka] = null, Us = fr[--ka], fr[ka] = null, Ds = fr[--ka], fr[ka] = null;
    }
    function ku(s, o) {
        fr[ka++] = Ds, fr[ka++] = Us, fr[ka++] = Rs, Ds = o.id, Us = o.overflow, Rs = s;
    }
    var Zi = null, Kn = null, bn = !1, ro = null, Qi = !1, mh = Error(n(519));
    function vn(s) {
        var o = Error(n(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", ""));
        throw ju(Ga(o, s)), mh;
    }
    function gh(s) {
        var o = s.stateNode, d = s.type, g = s.memoizedProps;
        switch(o[jt] = s, o[ci] = g, d){
            case "dialog":
                Sn("cancel", o), Sn("close", o);
                break;
            case "iframe":
            case "object":
            case "embed":
                Sn("load", o);
                break;
            case "video":
            case "audio":
                for(d = 0; d < om.length; d++)Sn(om[d], o);
                break;
            case "source":
                Sn("error", o);
                break;
            case "img":
            case "image":
            case "link":
                Sn("error", o), Sn("load", o);
                break;
            case "details":
                Sn("toggle", o);
                break;
            case "input":
                Sn("invalid", o), On(o, g.value, g.defaultValue, g.checked, g.defaultChecked, g.type, g.name, !0);
                break;
            case "select":
                Sn("invalid", o);
                break;
            case "textarea":
                Sn("invalid", o), qn(o, g.value, g.defaultValue, g.children);
        }
        d = g.children, typeof d != "string" && typeof d != "number" && typeof d != "bigint" || o.textContent === "" + d || g.suppressHydrationWarning === !0 || IS(o.textContent, d) ? (g.popover != null && (Sn("beforetoggle", o), Sn("toggle", o)), g.onScroll != null && Sn("scroll", o), g.onScrollEnd != null && Sn("scrollend", o), g.onClick != null && (o.onclick = ta), o = !0) : o = !1, o || vn(s, !0);
    }
    function q0(s) {
        for(Zi = s.return; Zi;)switch(Zi.tag){
            case 5:
            case 31:
            case 13:
                Qi = !1;
                return;
            case 27:
            case 3:
                Qi = !0;
                return;
            default:
                Zi = Zi.return;
        }
    }
    function Vl(s) {
        if (s !== Zi) return !1;
        if (!bn) return q0(s), bn = !0, !1;
        var o = s.tag, d;
        if ((d = o !== 3 && o !== 27) && ((d = o === 5) && (d = s.type, d = !(d !== "form" && d !== "button") || o1(s.type, s.memoizedProps)), d = !d), d && Kn && vn(s), q0(s), o === 13) {
            if (s = s.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error(n(317));
            Kn = qS(s);
        } else if (o === 31) {
            if (s = s.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error(n(317));
            Kn = qS(s);
        } else o === 27 ? (o = Kn, ru(s.type) ? (s = h1, h1 = null, Kn = s) : Kn = o) : Kn = Zi ? Gs(s.stateNode.nextSibling) : null;
        return !0;
    }
    function Gl() {
        Kn = Zi = null, bn = !1;
    }
    function gp() {
        var s = ro;
        return s !== null && (Sa === null ? Sa = s : Sa.push.apply(Sa, s), ro = null), s;
    }
    function ju(s) {
        ro === null ? ro = [
            s
        ] : ro.push(s);
    }
    var xp = I(null), so = null, xa = null;
    function oo(s, o, d) {
        oe(xp, o._currentValue), o._currentValue = d;
    }
    function Ir(s) {
        s._currentValue = xp.current, Z(xp);
    }
    function lo(s, o, d) {
        for(; s !== null;){
            var g = s.alternate;
            if ((s.childLanes & o) !== o ? (s.childLanes |= o, g !== null && (g.childLanes |= o)) : g !== null && (g.childLanes & o) !== o && (g.childLanes |= o), s === d) break;
            s = s.return;
        }
    }
    function xh(s, o, d, g) {
        var E = s.child;
        for(E !== null && (E.return = s); E !== null;){
            var w = E.dependencies;
            if (w !== null) {
                var V = E.child;
                w = w.firstContext;
                e: for(; w !== null;){
                    var re = w;
                    w = E;
                    for(var ge = 0; ge < o.length; ge++)if (re.context === o[ge]) {
                        w.lanes |= d, re = w.alternate, re !== null && (re.lanes |= d), lo(w.return, d, s), g || (V = null);
                        break e;
                    }
                    w = re.next;
                }
            } else if (E.tag === 18) {
                if (V = E.return, V === null) throw Error(n(341));
                V.lanes |= d, w = V.alternate, w !== null && (w.lanes |= d), lo(V, d, s), V = null;
            } else V = E.child;
            if (V !== null) V.return = E;
            else for(V = E; V !== null;){
                if (V === s) {
                    V = null;
                    break;
                }
                if (E = V.sibling, E !== null) {
                    E.return = V.return, V = E;
                    break;
                }
                V = V.return;
            }
            E = V;
        }
    }
    function Qo(s, o, d, g) {
        s = null;
        for(var E = o, w = !1; E !== null;){
            if (!w) {
                if ((E.flags & 524288) !== 0) w = !0;
                else if ((E.flags & 262144) !== 0) break;
            }
            if (E.tag === 10) {
                var V = E.alternate;
                if (V === null) throw Error(n(387));
                if (V = V.memoizedProps, V !== null) {
                    var re = E.type;
                    si(E.pendingProps.value, V.value) || (s !== null ? s.push(re) : s = [
                        re
                    ]);
                }
            } else if (E === le.current) {
                if (V = E.alternate, V === null) throw Error(n(387));
                V.memoizedState.memoizedState !== E.memoizedState.memoizedState && (s !== null ? s.push(hm) : s = [
                    hm
                ]);
            }
            E = E.return;
        }
        s !== null && xh(o, s, d, g), o.flags |= 262144;
    }
    function Vc(s) {
        for(s = s.firstContext; s !== null;){
            if (!si(s.context._currentValue, s.memoizedValue)) return !0;
            s = s.next;
        }
        return !1;
    }
    function kl(s) {
        so = s, xa = null, s = s.dependencies, s !== null && (s.firstContext = null);
    }
    function Ki(s) {
        return vp(so, s);
    }
    function Xu(s, o) {
        return so === null && kl(s), vp(s, o);
    }
    function vp(s, o) {
        var d = o._currentValue;
        if (o = {
            context: o,
            memoizedValue: d,
            next: null
        }, xa === null) {
            if (s === null) throw Error(n(308));
            xa = o, s.dependencies = {
                lanes: 0,
                firstContext: o
            }, s.flags |= 524288;
        } else xa = xa.next = o;
        return d;
    }
    var Y0 = typeof AbortController < "u" ? AbortController : function() {
        var s = [], o = this.signal = {
            aborted: !1,
            addEventListener: function(d, g) {
                s.push(g);
            }
        };
        this.abort = function() {
            o.aborted = !0, s.forEach(function(d) {
                return d();
            });
        };
    }, Z0 = a.unstable_scheduleCallback, yp = a.unstable_NormalPriority, Bt = {
        $$typeof: R,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0
    };
    function _p() {
        return {
            controller: new Y0,
            data: new Map,
            refCount: 0
        };
    }
    function aa(s) {
        s.refCount--, s.refCount === 0 && Z0(yp, function() {
            s.controller.abort();
        });
    }
    var jl = null, bp = 0, co = 0, us = null;
    function Gc(s, o) {
        if (jl === null) {
            var d = jl = [];
            bp = 0, co = Jy(), us = {
                status: "pending",
                value: void 0,
                then: function(g) {
                    d.push(g);
                }
            };
        }
        return bp++, o.then(Sp, Sp), o;
    }
    function Sp() {
        if (--bp === 0 && jl !== null) {
            us !== null && (us.status = "fulfilled");
            var s = jl;
            jl = null, co = 0, us = null;
            for(var o = 0; o < s.length; o++)(0, s[o])();
        }
    }
    function Mp(s, o) {
        var d = [], g = {
            status: "pending",
            value: null,
            reason: null,
            then: function(E) {
                d.push(E);
            }
        };
        return s.then(function() {
            g.status = "fulfilled", g.value = o;
            for(var E = 0; E < d.length; E++)(0, d[E])(o);
        }, function(E) {
            for(g.status = "rejected", g.reason = E, E = 0; E < d.length; E++)(0, d[E])(void 0);
        }), g;
    }
    var Q0 = F.S;
    F.S = function(s, o) {
        nu = W(), typeof o == "object" && o !== null && typeof o.then == "function" && Gc(s, o), Q0 !== null && Q0(s, o);
    };
    var Ko = I(null);
    function Ns() {
        var s = Ko.current;
        return s !== null ? s : In.pooledCache;
    }
    function kc(s, o) {
        o === null ? oe(Ko, Ko.current) : oe(Ko, o.pool);
    }
    function vh() {
        var s = Ns();
        return s === null ? null : {
            parent: Bt._currentValue,
            pool: s
        };
    }
    var Jo = Error(n(460)), Wu = Error(n(474)), fs = Error(n(542)), qu = {
        then: function() {}
    };
    function K0(s) {
        return s = s.status, s === "fulfilled" || s === "rejected";
    }
    function Ep(s, o, d) {
        switch(d = s[d], d === void 0 ? s.push(o) : d !== o && (o.then(ta, ta), o = d), o.status){
            case "fulfilled":
                return o.value;
            case "rejected":
                throw s = o.reason, Tp(s), s;
            default:
                if (typeof o.status == "string") o.then(ta, ta);
                else {
                    if (s = In, s !== null && 100 < s.shellSuspendCounter) throw Error(n(482));
                    s = o, s.status = "pending", s.then(function(g) {
                        if (o.status === "pending") {
                            var E = o;
                            E.status = "fulfilled", E.value = g;
                        }
                    }, function(g) {
                        if (o.status === "pending") {
                            var E = o;
                            E.status = "rejected", E.reason = g;
                        }
                    });
                }
                switch(o.status){
                    case "fulfilled":
                        return o.value;
                    case "rejected":
                        throw s = o.reason, Tp(s), s;
                }
                throw Vt = o, Jo;
        }
    }
    function Xl(s) {
        try {
            var o = s._init;
            return o(s._payload);
        } catch (d) {
            throw d !== null && typeof d == "object" && typeof d.then == "function" ? (Vt = d, Jo) : d;
        }
    }
    var Vt = null;
    function yh() {
        if (Vt === null) throw Error(n(459));
        var s = Vt;
        return Vt = null, s;
    }
    function Tp(s) {
        if (s === Jo || s === fs) throw Error(n(483));
    }
    var $o = null, el = 0;
    function _h(s) {
        var o = el;
        return el += 1, $o === null && ($o = []), Ep($o, s, o);
    }
    function Yu(s, o) {
        o = o.props.ref, s.ref = o !== void 0 ? o : null;
    }
    function Zu(s, o) {
        throw o.$$typeof === v ? Error(n(525)) : (s = Object.prototype.toString.call(o), Error(n(31, s === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : s)));
    }
    function jc(s) {
        function o(Ce, ye) {
            if (s) {
                var Fe = Ce.deletions;
                Fe === null ? (Ce.deletions = [
                    ye
                ], Ce.flags |= 16) : Fe.push(ye);
            }
        }
        function d(Ce, ye) {
            if (!s) return null;
            for(; ye !== null;)o(Ce, ye), ye = ye.sibling;
            return null;
        }
        function g(Ce) {
            for(var ye = new Map; Ce !== null;)Ce.key !== null ? ye.set(Ce.key, Ce) : ye.set(Ce.index, Ce), Ce = Ce.sibling;
            return ye;
        }
        function E(Ce, ye) {
            return Ce = Cs(Ce, ye), Ce.index = 0, Ce.sibling = null, Ce;
        }
        function w(Ce, ye, Fe) {
            return Ce.index = Fe, s ? (Fe = Ce.alternate, Fe !== null ? (Fe = Fe.index, Fe < ye ? (Ce.flags |= 67108866, ye) : Fe) : (Ce.flags |= 67108866, ye)) : (Ce.flags |= 1048576, ye);
        }
        function V(Ce) {
            return s && Ce.alternate === null && (Ce.flags |= 67108866), Ce;
        }
        function re(Ce, ye, Fe, st) {
            return ye === null || ye.tag !== 6 ? (ye = dh(Fe, Ce.mode, st), ye.return = Ce, ye) : (ye = E(ye, Fe), ye.return = Ce, ye);
        }
        function ge(Ce, ye, Fe, st) {
            var Ht = Fe.type;
            return Ht === A ? et(Ce, ye, Fe.props.children, st, Fe.key) : ye !== null && (ye.elementType === Ht || typeof Ht == "object" && Ht !== null && Ht.$$typeof === H && Xl(Ht) === ye.type) ? (ye = E(ye, Fe.props), Yu(ye, Fe), ye.return = Ce, ye) : (ye = Vu(Fe.type, Fe.key, Fe.props, null, Ce.mode, st), Yu(ye, Fe), ye.return = Ce, ye);
        }
        function He(Ce, ye, Fe, st) {
            return ye === null || ye.tag !== 4 || ye.stateNode.containerInfo !== Fe.containerInfo || ye.stateNode.implementation !== Fe.implementation ? (ye = ls(Fe, Ce.mode, st), ye.return = Ce, ye) : (ye = E(ye, Fe.children || []), ye.return = Ce, ye);
        }
        function et(Ce, ye, Fe, st, Ht) {
            return ye === null || ye.tag !== 7 ? (ye = io(Fe, Ce.mode, st, Ht), ye.return = Ce, ye) : (ye = E(ye, Fe), ye.return = Ce, ye);
        }
        function ct(Ce, ye, Fe) {
            if (typeof ye == "string" && ye !== "" || typeof ye == "number" || typeof ye == "bigint") return ye = dh("" + ye, Ce.mode, Fe), ye.return = Ce, ye;
            if (typeof ye == "object" && ye !== null) {
                switch(ye.$$typeof){
                    case _:
                        return Fe = Vu(ye.type, ye.key, ye.props, null, Ce.mode, Fe), Yu(Fe, ye), Fe.return = Ce, Fe;
                    case S:
                        return ye = ls(ye, Ce.mode, Fe), ye.return = Ce, ye;
                    case H:
                        return ye = Xl(ye), ct(Ce, ye, Fe);
                }
                if (ae(ye) || G(ye)) return ye = io(ye, Ce.mode, Fe, null), ye.return = Ce, ye;
                if (typeof ye.then == "function") return ct(Ce, _h(ye), Fe);
                if (ye.$$typeof === R) return ct(Ce, Xu(Ce, ye), Fe);
                Zu(Ce, ye);
            }
            return null;
        }
        function Xe(Ce, ye, Fe, st) {
            var Ht = ye !== null ? ye.key : null;
            if (typeof Fe == "string" && Fe !== "" || typeof Fe == "number" || typeof Fe == "bigint") return Ht !== null ? null : re(Ce, ye, "" + Fe, st);
            if (typeof Fe == "object" && Fe !== null) {
                switch(Fe.$$typeof){
                    case _:
                        return Fe.key === Ht ? ge(Ce, ye, Fe, st) : null;
                    case S:
                        return Fe.key === Ht ? He(Ce, ye, Fe, st) : null;
                    case H:
                        return Fe = Xl(Fe), Xe(Ce, ye, Fe, st);
                }
                if (ae(Fe) || G(Fe)) return Ht !== null ? null : et(Ce, ye, Fe, st, null);
                if (typeof Fe.then == "function") return Xe(Ce, ye, _h(Fe), st);
                if (Fe.$$typeof === R) return Xe(Ce, ye, Xu(Ce, Fe), st);
                Zu(Ce, Fe);
            }
            return null;
        }
        function Qe(Ce, ye, Fe, st, Ht) {
            if (typeof st == "string" && st !== "" || typeof st == "number" || typeof st == "bigint") return Ce = Ce.get(Fe) || null, re(ye, Ce, "" + st, Ht);
            if (typeof st == "object" && st !== null) {
                switch(st.$$typeof){
                    case _:
                        return Ce = Ce.get(st.key === null ? Fe : st.key) || null, ge(ye, Ce, st, Ht);
                    case S:
                        return Ce = Ce.get(st.key === null ? Fe : st.key) || null, He(ye, Ce, st, Ht);
                    case H:
                        return st = Xl(st), Qe(Ce, ye, Fe, st, Ht);
                }
                if (ae(st) || G(st)) return Ce = Ce.get(Fe) || null, et(ye, Ce, st, Ht, null);
                if (typeof st.then == "function") return Qe(Ce, ye, Fe, _h(st), Ht);
                if (st.$$typeof === R) return Qe(Ce, ye, Fe, Xu(ye, st), Ht);
                Zu(ye, st);
            }
            return null;
        }
        function Rt(Ce, ye, Fe, st) {
            for(var Ht = null, Hn = null, Nt = ye, un = ye = 0, Tn = null; Nt !== null && un < Fe.length; un++){
                Nt.index > un ? (Tn = Nt, Nt = null) : Tn = Nt.sibling;
                var Vn = Xe(Ce, Nt, Fe[un], st);
                if (Vn === null) {
                    Nt === null && (Nt = Tn);
                    break;
                }
                s && Nt && Vn.alternate === null && o(Ce, Nt), ye = w(Vn, ye, un), Hn === null ? Ht = Vn : Hn.sibling = Vn, Hn = Vn, Nt = Tn;
            }
            if (un === Fe.length) return d(Ce, Nt), bn && ao(Ce, un), Ht;
            if (Nt === null) {
                for(; un < Fe.length; un++)Nt = ct(Ce, Fe[un], st), Nt !== null && (ye = w(Nt, ye, un), Hn === null ? Ht = Nt : Hn.sibling = Nt, Hn = Nt);
                return bn && ao(Ce, un), Ht;
            }
            for(Nt = g(Nt); un < Fe.length; un++)Tn = Qe(Nt, Ce, un, Fe[un], st), Tn !== null && (s && Tn.alternate !== null && Nt.delete(Tn.key === null ? un : Tn.key), ye = w(Tn, ye, un), Hn === null ? Ht = Tn : Hn.sibling = Tn, Hn = Tn);
            return s && Nt.forEach(function(uu) {
                return o(Ce, uu);
            }), bn && ao(Ce, un), Ht;
        }
        function kt(Ce, ye, Fe, st) {
            if (Fe == null) throw Error(n(151));
            for(var Ht = null, Hn = null, Nt = ye, un = ye = 0, Tn = null, Vn = Fe.next(); Nt !== null && !Vn.done; un++, Vn = Fe.next()){
                Nt.index > un ? (Tn = Nt, Nt = null) : Tn = Nt.sibling;
                var uu = Xe(Ce, Nt, Vn.value, st);
                if (uu === null) {
                    Nt === null && (Nt = Tn);
                    break;
                }
                s && Nt && uu.alternate === null && o(Ce, Nt), ye = w(uu, ye, un), Hn === null ? Ht = uu : Hn.sibling = uu, Hn = uu, Nt = Tn;
            }
            if (Vn.done) return d(Ce, Nt), bn && ao(Ce, un), Ht;
            if (Nt === null) {
                for(; !Vn.done; un++, Vn = Fe.next())Vn = ct(Ce, Vn.value, st), Vn !== null && (ye = w(Vn, ye, un), Hn === null ? Ht = Vn : Hn.sibling = Vn, Hn = Vn);
                return bn && ao(Ce, un), Ht;
            }
            for(Nt = g(Nt); !Vn.done; un++, Vn = Fe.next())Vn = Qe(Nt, Ce, un, Vn.value, st), Vn !== null && (s && Vn.alternate !== null && Nt.delete(Vn.key === null ? un : Vn.key), ye = w(Vn, ye, un), Hn === null ? Ht = Vn : Hn.sibling = Vn, Hn = Vn);
            return s && Nt.forEach(function(uC) {
                return o(Ce, uC);
            }), bn && ao(Ce, un), Ht;
        }
        function ei(Ce, ye, Fe, st) {
            if (typeof Fe == "object" && Fe !== null && Fe.type === A && Fe.key === null && (Fe = Fe.props.children), typeof Fe == "object" && Fe !== null) {
                switch(Fe.$$typeof){
                    case _:
                        e: {
                            for(var Ht = Fe.key; ye !== null;){
                                if (ye.key === Ht) {
                                    if (Ht = Fe.type, Ht === A) {
                                        if (ye.tag === 7) {
                                            d(Ce, ye.sibling), st = E(ye, Fe.props.children), st.return = Ce, Ce = st;
                                            break e;
                                        }
                                    } else if (ye.elementType === Ht || typeof Ht == "object" && Ht !== null && Ht.$$typeof === H && Xl(Ht) === ye.type) {
                                        d(Ce, ye.sibling), st = E(ye, Fe.props), Yu(st, Fe), st.return = Ce, Ce = st;
                                        break e;
                                    }
                                    d(Ce, ye);
                                    break;
                                } else o(Ce, ye);
                                ye = ye.sibling;
                            }
                            Fe.type === A ? (st = io(Fe.props.children, Ce.mode, st, Fe.key), st.return = Ce, Ce = st) : (st = Vu(Fe.type, Fe.key, Fe.props, null, Ce.mode, st), Yu(st, Fe), st.return = Ce, Ce = st);
                        }
                        return V(Ce);
                    case S:
                        e: {
                            for(Ht = Fe.key; ye !== null;){
                                if (ye.key === Ht) {
                                    if (ye.tag === 4 && ye.stateNode.containerInfo === Fe.containerInfo && ye.stateNode.implementation === Fe.implementation) {
                                        d(Ce, ye.sibling), st = E(ye, Fe.children || []), st.return = Ce, Ce = st;
                                        break e;
                                    } else {
                                        d(Ce, ye);
                                        break;
                                    }
                                } else o(Ce, ye);
                                ye = ye.sibling;
                            }
                            st = ls(Fe, Ce.mode, st), st.return = Ce, Ce = st;
                        }
                        return V(Ce);
                    case H:
                        return Fe = Xl(Fe), ei(Ce, ye, Fe, st);
                }
                if (ae(Fe)) return Rt(Ce, ye, Fe, st);
                if (G(Fe)) {
                    if (Ht = G(Fe), typeof Ht != "function") throw Error(n(150));
                    return Fe = Ht.call(Fe), kt(Ce, ye, Fe, st);
                }
                if (typeof Fe.then == "function") return ei(Ce, ye, _h(Fe), st);
                if (Fe.$$typeof === R) return ei(Ce, ye, Xu(Ce, Fe), st);
                Zu(Ce, Fe);
            }
            return typeof Fe == "string" && Fe !== "" || typeof Fe == "number" || typeof Fe == "bigint" ? (Fe = "" + Fe, ye !== null && ye.tag === 6 ? (d(Ce, ye.sibling), st = E(ye, Fe), st.return = Ce, Ce = st) : (d(Ce, ye), st = dh(Fe, Ce.mode, st), st.return = Ce, Ce = st), V(Ce)) : d(Ce, ye);
        }
        return function(Ce, ye, Fe, st) {
            try {
                el = 0;
                var Ht = ei(Ce, ye, Fe, st);
                return $o = null, Ht;
            } catch (Nt) {
                if (Nt === Jo || Nt === fs) throw Nt;
                var Hn = Ua(29, Nt, null, Ce.mode);
                return Hn.lanes = st, Hn.return = Ce, Hn;
            } finally{}
        };
    }
    var Wl = jc(!0), J0 = jc(!1), tl = !1;
    function Ap(s) {
        s.updateQueue = {
            baseState: s.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function wp(s, o) {
        s = s.updateQueue, o.updateQueue === s && (o.updateQueue = {
            baseState: s.baseState,
            firstBaseUpdate: s.firstBaseUpdate,
            lastBaseUpdate: s.lastBaseUpdate,
            shared: s.shared,
            callbacks: null
        });
    }
    function Os(s) {
        return {
            lane: s,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function uo(s, o, d) {
        var g = s.updateQueue;
        if (g === null) return null;
        if (g = g.shared, (Mn & 2) !== 0) {
            var E = g.pending;
            return E === null ? o.next = o : (o.next = E.next, E.next = o), g.pending = o, o = Fc(s), hh(s, null, d), o;
        }
        return Hu(s, g, o, d), Fc(s);
    }
    function nl(s, o, d) {
        if (o = o.updateQueue, o !== null && (o = o.shared, (d & 4194048) !== 0)) {
            var g = o.lanes;
            g &= s.pendingLanes, d |= g, o.lanes = d, Gi(s, d);
        }
    }
    function bh(s, o) {
        var d = s.updateQueue, g = s.alternate;
        if (g !== null && (g = g.updateQueue, d === g)) {
            var E = null, w = null;
            if (d = d.firstBaseUpdate, d !== null) {
                do {
                    var V = {
                        lane: d.lane,
                        tag: d.tag,
                        payload: d.payload,
                        callback: null,
                        next: null
                    };
                    w === null ? E = w = V : w = w.next = V, d = d.next;
                }while (d !== null);
                w === null ? E = w = o : w = w.next = o;
            } else E = w = o;
            d = {
                baseState: g.baseState,
                firstBaseUpdate: E,
                lastBaseUpdate: w,
                shared: g.shared,
                callbacks: g.callbacks
            }, s.updateQueue = d;
            return;
        }
        s = d.lastBaseUpdate, s === null ? d.firstBaseUpdate = o : s.next = o, d.lastBaseUpdate = o;
    }
    var Cp = !1;
    function Qu() {
        if (Cp) {
            var s = us;
            if (s !== null) throw s;
        }
    }
    function ql(s, o, d, g) {
        Cp = !1;
        var E = s.updateQueue;
        tl = !1;
        var w = E.firstBaseUpdate, V = E.lastBaseUpdate, re = E.shared.pending;
        if (re !== null) {
            E.shared.pending = null;
            var ge = re, He = ge.next;
            ge.next = null, V === null ? w = He : V.next = He, V = ge;
            var et = s.alternate;
            et !== null && (et = et.updateQueue, re = et.lastBaseUpdate, re !== V && (re === null ? et.firstBaseUpdate = He : re.next = He, et.lastBaseUpdate = ge));
        }
        if (w !== null) {
            var ct = E.baseState;
            V = 0, et = He = ge = null, re = w;
            do {
                var Xe = re.lane & -536870913, Qe = Xe !== re.lane;
                if (Qe ? (yn & Xe) === Xe : (g & Xe) === Xe) {
                    Xe !== 0 && Xe === co && (Cp = !0), et !== null && (et = et.next = {
                        lane: 0,
                        tag: re.tag,
                        payload: re.payload,
                        callback: null,
                        next: null
                    });
                    e: {
                        var Rt = s, kt = re;
                        Xe = o;
                        var ei = d;
                        switch(kt.tag){
                            case 1:
                                if (Rt = kt.payload, typeof Rt == "function") {
                                    ct = Rt.call(ei, ct, Xe);
                                    break e;
                                }
                                ct = Rt;
                                break e;
                            case 3:
                                Rt.flags = Rt.flags & -65537 | 128;
                            case 0:
                                if (Rt = kt.payload, Xe = typeof Rt == "function" ? Rt.call(ei, ct, Xe) : Rt, Xe == null) break e;
                                ct = x({}, ct, Xe);
                                break e;
                            case 2:
                                tl = !0;
                        }
                    }
                    Xe = re.callback, Xe !== null && (s.flags |= 64, Qe && (s.flags |= 8192), Qe = E.callbacks, Qe === null ? E.callbacks = [
                        Xe
                    ] : Qe.push(Xe));
                } else Qe = {
                    lane: Xe,
                    tag: re.tag,
                    payload: re.payload,
                    callback: re.callback,
                    next: null
                }, et === null ? (He = et = Qe, ge = ct) : et = et.next = Qe, V |= Xe;
                if (re = re.next, re === null) {
                    if (re = E.shared.pending, re === null) break;
                    Qe = re, re = Qe.next, Qe.next = null, E.lastBaseUpdate = Qe, E.shared.pending = null;
                }
            }while (!0);
            et === null && (ge = ct), E.baseState = ge, E.firstBaseUpdate = He, E.lastBaseUpdate = et, w === null && (E.shared.lanes = 0), Sr |= V, s.lanes = V, s.memoizedState = ct;
        }
    }
    function Ls(s, o) {
        if (typeof s != "function") throw Error(n(191, s));
        s.call(o);
    }
    function ra(s, o) {
        var d = s.callbacks;
        if (d !== null) for(s.callbacks = null, s = 0; s < d.length; s++)Ls(d[s], o);
    }
    var hr = I(null), Oa = I(0);
    function Rp(s, o) {
        s = Ri, oe(Oa, s), oe(hr, o), Ri = s | o.baseLanes;
    }
    function Dp() {
        oe(Oa, Ri), oe(hr, hr.current);
    }
    function va() {
        Ri = Oa.current, Z(hr), Z(Oa);
    }
    var ji = I(null), Fr = null;
    function il(s) {
        var o = s.alternate;
        oe(vi, vi.current & 1), oe(ji, s), Fr === null && (o === null || hr.current !== null || o.memoizedState !== null) && (Fr = s);
    }
    function Up(s) {
        oe(vi, vi.current), oe(ji, s), Fr === null && (Fr = s);
    }
    function $0(s) {
        s.tag === 22 ? (oe(vi, vi.current), oe(ji, s), Fr === null && (Fr = s)) : fo();
    }
    function fo() {
        oe(vi, vi.current), oe(ji, ji.current);
    }
    function dr(s) {
        Z(ji), Fr === s && (Fr = null), Z(vi);
    }
    var vi = I(0);
    function Sh(s) {
        for(var o = s; o !== null;){
            if (o.tag === 13) {
                var d = o.memoizedState;
                if (d !== null && (d = d.dehydrated, d === null || u1(d) || f1(d))) return o;
            } else if (o.tag === 19 && (o.memoizedProps.revealOrder === "forwards" || o.memoizedProps.revealOrder === "backwards" || o.memoizedProps.revealOrder === "unstable_legacy-backwards" || o.memoizedProps.revealOrder === "together")) {
                if ((o.flags & 128) !== 0) return o;
            } else if (o.child !== null) {
                o.child.return = o, o = o.child;
                continue;
            }
            if (o === s) break;
            for(; o.sibling === null;){
                if (o.return === null || o.return === s) return null;
                o = o.return;
            }
            o.sibling.return = o.return, o = o.sibling;
        }
        return null;
    }
    var ja = 0, Xt = null, Xn = null, Ii = null, Mh = !1, zs = !1, Yl = !1, Eh = 0, Ku = 0, Ps = null, Gy = 0;
    function yi() {
        throw Error(n(321));
    }
    function Np(s, o) {
        if (o === null) return !1;
        for(var d = 0; d < o.length && d < s.length; d++)if (!si(s[d], o[d])) return !1;
        return !0;
    }
    function Op(s, o, d, g, E, w) {
        return ja = w, Xt = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, F.H = s === null || s.memoizedState === null ? yg : qc, Yl = !1, w = d(g, E), Yl = !1, zs && (w = tg(o, d, g, E)), eg(s), w;
    }
    function eg(s) {
        F.H = nf;
        var o = Xn !== null && Xn.next !== null;
        if (ja = 0, Ii = Xn = Xt = null, Mh = !1, Ku = 0, Ps = null, o) throw Error(n(300));
        s === null || oi || (s = s.dependencies, s !== null && Vc(s) && (oi = !0));
    }
    function tg(s, o, d, g) {
        Xt = s;
        var E = 0;
        do {
            if (zs && (Ps = null), Ku = 0, zs = !1, 25 <= E) throw Error(n(301));
            if (E += 1, Ii = Xn = null, s.updateQueue != null) {
                var w = s.updateQueue;
                w.lastEffect = null, w.events = null, w.stores = null, w.memoCache != null && (w.memoCache.index = 0);
            }
            F.H = af, w = o(d, g);
        }while (zs);
        return w;
    }
    function ky() {
        var s = F.H, o = s.useState()[0];
        return o = typeof o.then == "function" ? $u(o) : o, s = s.useState()[0], (Xn !== null ? Xn.memoizedState : null) !== s && (Xt.flags |= 1024), o;
    }
    function Lp() {
        var s = Eh !== 0;
        return Eh = 0, s;
    }
    function zp(s, o, d) {
        o.updateQueue = s.updateQueue, o.flags &= -2053, s.lanes &= ~d;
    }
    function Pp(s) {
        if (Mh) {
            for(s = s.memoizedState; s !== null;){
                var o = s.queue;
                o !== null && (o.pending = null), s = s.next;
            }
            Mh = !1;
        }
        ja = 0, Ii = Xn = Xt = null, zs = !1, Ku = Eh = 0, Ps = null;
    }
    function La() {
        var s = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        return Ii === null ? Xt.memoizedState = Ii = s : Ii = Ii.next = s, Ii;
    }
    function Ti() {
        if (Xn === null) {
            var s = Xt.alternate;
            s = s !== null ? s.memoizedState : null;
        } else s = Xn.next;
        var o = Ii === null ? Xt.memoizedState : Ii.next;
        if (o !== null) Ii = o, Xn = s;
        else {
            if (s === null) throw Xt.alternate === null ? Error(n(467)) : Error(n(310));
            Xn = s, s = {
                memoizedState: Xn.memoizedState,
                baseState: Xn.baseState,
                baseQueue: Xn.baseQueue,
                queue: Xn.queue,
                next: null
            }, Ii === null ? Xt.memoizedState = Ii = s : Ii = Ii.next = s;
        }
        return Ii;
    }
    function Ju() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function $u(s) {
        var o = Ku;
        return Ku += 1, Ps === null && (Ps = []), s = Ep(Ps, s, o), o = Xt, (Ii === null ? o.memoizedState : Ii.next) === null && (o = o.alternate, F.H = o === null || o.memoizedState === null ? yg : qc), s;
    }
    function Th(s) {
        if (s !== null && typeof s == "object") {
            if (typeof s.then == "function") return $u(s);
            if (s.$$typeof === R) return Ki(s);
        }
        throw Error(n(438, String(s)));
    }
    function Bp(s) {
        var o = null, d = Xt.updateQueue;
        if (d !== null && (o = d.memoCache), o == null) {
            var g = Xt.alternate;
            g !== null && (g = g.updateQueue, g !== null && (g = g.memoCache, g != null && (o = {
                data: g.data.map(function(E) {
                    return E.slice();
                }),
                index: 0
            })));
        }
        if (o == null && (o = {
            data: [],
            index: 0
        }), d === null && (d = Ju(), Xt.updateQueue = d), d.memoCache = o, d = o.data[o.index], d === void 0) for(d = o.data[o.index] = Array(s), g = 0; g < s; g++)d[g] = D;
        return o.index++, d;
    }
    function ho(s, o) {
        return typeof o == "function" ? o(s) : o;
    }
    function Ah(s) {
        var o = Ti();
        return Ip(o, Xn, s);
    }
    function Ip(s, o, d) {
        var g = s.queue;
        if (g === null) throw Error(n(311));
        g.lastRenderedReducer = d;
        var E = s.baseQueue, w = g.pending;
        if (w !== null) {
            if (E !== null) {
                var V = E.next;
                E.next = w.next, w.next = V;
            }
            o.baseQueue = E = w, g.pending = null;
        }
        if (w = s.baseState, E === null) s.memoizedState = w;
        else {
            o = E.next;
            var re = V = null, ge = null, He = o, et = !1;
            do {
                var ct = He.lane & -536870913;
                if (ct !== He.lane ? (yn & ct) === ct : (ja & ct) === ct) {
                    var Xe = He.revertLane;
                    if (Xe === 0) ge !== null && (ge = ge.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: He.action,
                        hasEagerState: He.hasEagerState,
                        eagerState: He.eagerState,
                        next: null
                    }), ct === co && (et = !0);
                    else if ((ja & Xe) === Xe) {
                        He = He.next, Xe === co && (et = !0);
                        continue;
                    } else ct = {
                        lane: 0,
                        revertLane: He.revertLane,
                        gesture: null,
                        action: He.action,
                        hasEagerState: He.hasEagerState,
                        eagerState: He.eagerState,
                        next: null
                    }, ge === null ? (re = ge = ct, V = w) : ge = ge.next = ct, Xt.lanes |= Xe, Sr |= Xe;
                    ct = He.action, Yl && d(w, ct), w = He.hasEagerState ? He.eagerState : d(w, ct);
                } else Xe = {
                    lane: ct,
                    revertLane: He.revertLane,
                    gesture: He.gesture,
                    action: He.action,
                    hasEagerState: He.hasEagerState,
                    eagerState: He.eagerState,
                    next: null
                }, ge === null ? (re = ge = Xe, V = w) : ge = ge.next = Xe, Xt.lanes |= ct, Sr |= ct;
                He = He.next;
            }while (He !== null && He !== o);
            if (ge === null ? V = w : ge.next = re, !si(w, s.memoizedState) && (oi = !0, et && (d = us, d !== null))) throw d;
            s.memoizedState = w, s.baseState = V, s.baseQueue = ge, g.lastRenderedState = w;
        }
        return E === null && (g.lanes = 0), [
            s.memoizedState,
            g.dispatch
        ];
    }
    function wh(s) {
        var o = Ti(), d = o.queue;
        if (d === null) throw Error(n(311));
        d.lastRenderedReducer = s;
        var g = d.dispatch, E = d.pending, w = o.memoizedState;
        if (E !== null) {
            d.pending = null;
            var V = E = E.next;
            do w = s(w, V.action), V = V.next;
            while (V !== E);
            si(w, o.memoizedState) || (oi = !0), o.memoizedState = w, o.baseQueue === null && (o.baseState = w), d.lastRenderedState = w;
        }
        return [
            w,
            g
        ];
    }
    function Fp(s, o, d) {
        var g = Xt, E = Ti(), w = bn;
        if (w) {
            if (d === void 0) throw Error(n(407));
            d = d();
        } else d = o();
        var V = !si((Xn || E).memoizedState, d);
        if (V && (E.memoizedState = d, oi = !0), E = E.queue, jp(Vp.bind(null, g, E, s), [
            s
        ]), E.getSnapshot !== o || V || Ii !== null && Ii.memoizedState.tag & 1) {
            if (g.flags |= 2048, Xc(9, {
                destroy: void 0
            }, Hp.bind(null, g, E, d, o), null), In === null) throw Error(n(349));
            w || (ja & 127) !== 0 || ng(g, o, d);
        }
        return d;
    }
    function ng(s, o, d) {
        s.flags |= 16384, s = {
            getSnapshot: o,
            value: d
        }, o = Xt.updateQueue, o === null ? (o = Ju(), Xt.updateQueue = o, o.stores = [
            s
        ]) : (d = o.stores, d === null ? o.stores = [
            s
        ] : d.push(s));
    }
    function Hp(s, o, d, g) {
        o.value = d, o.getSnapshot = g, Gp(o) && Ch(s);
    }
    function Vp(s, o, d) {
        return d(function() {
            Gp(o) && Ch(s);
        });
    }
    function Gp(s) {
        var o = s.getSnapshot;
        s = s.value;
        try {
            var d = o();
            return !si(s, d);
        } catch  {
            return !0;
        }
    }
    function Ch(s) {
        var o = qo(s, 2);
        o !== null && h(o, s, 2);
    }
    function ef(s) {
        var o = La();
        if (typeof s == "function") {
            var d = s;
            if (s = d(), Yl) {
                at(!0);
                try {
                    d();
                } finally{
                    at(!1);
                }
            }
        }
        return o.memoizedState = o.baseState = s, o.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: ho,
            lastRenderedState: s
        }, o;
    }
    function ig(s, o, d, g) {
        return s.baseState = d, Ip(s, Xn, typeof g == "function" ? g : ho);
    }
    function jy(s, o, d, g, E) {
        if (po(s)) throw Error(n(485));
        if (s = o.action, s !== null) {
            var w = {
                payload: E,
                action: s,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(V) {
                    w.listeners.push(V);
                }
            };
            F.T !== null ? d(!0) : w.isTransition = !1, g(w), d = o.pending, d === null ? (w.next = o.pending = w, ag(o, w)) : (w.next = d.next, o.pending = d.next = w);
        }
    }
    function ag(s, o) {
        var d = o.action, g = o.payload, E = s.state;
        if (o.isTransition) {
            var w = F.T, V = {};
            F.T = V;
            try {
                var re = d(E, g), ge = F.S;
                ge !== null && ge(V, re), rg(s, o, re);
            } catch (He) {
                Rh(s, o, He);
            } finally{
                w !== null && V.types !== null && (w.types = V.types), F.T = w;
            }
        } else try {
            w = d(E, g), rg(s, o, w);
        } catch (He) {
            Rh(s, o, He);
        }
    }
    function rg(s, o, d) {
        d !== null && typeof d == "object" && typeof d.then == "function" ? d.then(function(g) {
            kp(s, o, g);
        }, function(g) {
            return Rh(s, o, g);
        }) : kp(s, o, d);
    }
    function kp(s, o, d) {
        o.status = "fulfilled", o.value = d, sg(o), s.state = d, o = s.pending, o !== null && (d = o.next, d === o ? s.pending = null : (d = d.next, o.next = d, ag(s, d)));
    }
    function Rh(s, o, d) {
        var g = s.pending;
        if (s.pending = null, g !== null) {
            g = g.next;
            do o.status = "rejected", o.reason = d, sg(o), o = o.next;
            while (o !== g);
        }
        s.action = null;
    }
    function sg(s) {
        s = s.listeners;
        for(var o = 0; o < s.length; o++)(0, s[o])();
    }
    function og(s, o) {
        return o;
    }
    function lg(s, o) {
        if (bn) {
            var d = In.formState;
            if (d !== null) {
                e: {
                    var g = Xt;
                    if (bn) {
                        if (Kn) {
                            t: {
                                for(var E = Kn, w = Qi; E.nodeType !== 8;){
                                    if (!w) {
                                        E = null;
                                        break t;
                                    }
                                    if (E = Gs(E.nextSibling), E === null) {
                                        E = null;
                                        break t;
                                    }
                                }
                                w = E.data, E = w === "F!" || w === "F" ? E : null;
                            }
                            if (E) {
                                Kn = Gs(E.nextSibling), g = E.data === "F!";
                                break e;
                            }
                        }
                        vn(g);
                    }
                    g = !1;
                }
                g && (o = d[0]);
            }
        }
        return d = La(), d.memoizedState = d.baseState = o, g = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: og,
            lastRenderedState: o
        }, d.queue = g, d = vg.bind(null, Xt, g), g.dispatch = d, g = ef(!1), w = tf.bind(null, Xt, !1, g.queue), g = La(), E = {
            state: o,
            dispatch: null,
            action: s,
            pending: null
        }, g.queue = E, d = jy.bind(null, Xt, E, w, d), E.dispatch = d, g.memoizedState = s, [
            o,
            d,
            !1
        ];
    }
    function cg(s) {
        var o = Ti();
        return ug(o, Xn, s);
    }
    function ug(s, o, d) {
        if (o = Ip(s, o, og)[0], s = Ah(ho)[0], typeof o == "object" && o !== null && typeof o.then == "function") try {
            var g = $u(o);
        } catch (V) {
            throw V === Jo ? fs : V;
        }
        else g = o;
        o = Ti();
        var E = o.queue, w = E.dispatch;
        return d !== o.memoizedState && (Xt.flags |= 2048, Xc(9, {
            destroy: void 0
        }, Xy.bind(null, E, d), null)), [
            g,
            w,
            s
        ];
    }
    function Xy(s, o) {
        s.action = o;
    }
    function fg(s) {
        var o = Ti(), d = Xn;
        if (d !== null) return ug(o, d, s);
        Ti(), o = o.memoizedState, d = Ti();
        var g = d.queue.dispatch;
        return d.memoizedState = s, [
            o,
            g,
            !1
        ];
    }
    function Xc(s, o, d, g) {
        return s = {
            tag: s,
            create: d,
            deps: g,
            inst: o,
            next: null
        }, o = Xt.updateQueue, o === null && (o = Ju(), Xt.updateQueue = o), d = o.lastEffect, d === null ? o.lastEffect = s.next = s : (g = d.next, d.next = s, s.next = g, o.lastEffect = s), s;
    }
    function hg() {
        return Ti().memoizedState;
    }
    function Dh(s, o, d, g) {
        var E = La();
        Xt.flags |= s, E.memoizedState = Xc(1 | o, {
            destroy: void 0
        }, d, g === void 0 ? null : g);
    }
    function Uh(s, o, d, g) {
        var E = Ti();
        g = g === void 0 ? null : g;
        var w = E.memoizedState.inst;
        Xn !== null && g !== null && Np(g, Xn.memoizedState.deps) ? E.memoizedState = Xc(o, w, d, g) : (Xt.flags |= s, E.memoizedState = Xc(1 | o, w, d, g));
    }
    function dg(s, o) {
        Dh(8390656, 8, s, o);
    }
    function jp(s, o) {
        Uh(2048, 8, s, o);
    }
    function pg(s) {
        Xt.flags |= 4;
        var o = Xt.updateQueue;
        if (o === null) o = Ju(), Xt.updateQueue = o, o.events = [
            s
        ];
        else {
            var d = o.events;
            d === null ? o.events = [
                s
            ] : d.push(s);
        }
    }
    function mg(s) {
        var o = Ti().memoizedState;
        return pg({
            ref: o,
            nextImpl: s
        }), function() {
            if ((Mn & 2) !== 0) throw Error(n(440));
            return o.impl.apply(void 0, arguments);
        };
    }
    function gg(s, o) {
        return Uh(4, 2, s, o);
    }
    function pr(s, o) {
        return Uh(4, 4, s, o);
    }
    function Xp(s, o) {
        if (typeof o == "function") {
            s = s();
            var d = o(s);
            return function() {
                typeof d == "function" ? d() : o(null);
            };
        }
        if (o != null) return s = s(), o.current = s, function() {
            o.current = null;
        };
    }
    function Nh(s, o, d) {
        d = d != null ? d.concat([
            s
        ]) : null, Uh(4, 4, Xp.bind(null, o, s), d);
    }
    function Oh() {}
    function Wp(s, o) {
        var d = Ti();
        o = o === void 0 ? null : o;
        var g = d.memoizedState;
        return o !== null && Np(o, g[1]) ? g[0] : (d.memoizedState = [
            s,
            o
        ], s);
    }
    function qp(s, o) {
        var d = Ti();
        o = o === void 0 ? null : o;
        var g = d.memoizedState;
        if (o !== null && Np(o, g[1])) return g[0];
        if (g = s(), Yl) {
            at(!0);
            try {
                s();
            } finally{
                at(!1);
            }
        }
        return d.memoizedState = [
            g,
            o
        ], g;
    }
    function Yp(s, o, d) {
        return d === void 0 || (ja & 1073741824) !== 0 && (yn & 261930) === 0 ? s.memoizedState = o : (s.memoizedState = d, s = u(), Xt.lanes |= s, Sr |= s, d);
    }
    function Zp(s, o, d, g) {
        return si(d, o) ? d : hr.current !== null ? (s = Yp(s, d, g), si(s, o) || (oi = !0), s) : (ja & 42) === 0 || (ja & 1073741824) !== 0 && (yn & 261930) === 0 ? (oi = !0, s.memoizedState = d) : (s = u(), Xt.lanes |= s, Sr |= s, o);
    }
    function Qp(s, o, d, g, E) {
        var w = Q.p;
        Q.p = w !== 0 && 8 > w ? w : 8;
        var V = F.T, re = {};
        F.T = re, tf(s, !1, o, d);
        try {
            var ge = E(), He = F.S;
            if (He !== null && He(re, ge), ge !== null && typeof ge == "object" && typeof ge.then == "function") {
                var et = Mp(ge, g);
                Wc(s, o, et, Pa(s));
            } else Wc(s, o, g, Pa(s));
        } catch (ct) {
            Wc(s, o, {
                then: function() {},
                status: "rejected",
                reason: ct
            }, Pa());
        } finally{
            Q.p = w, V !== null && re.types !== null && (V.types = re.types), F.T = V;
        }
    }
    function Wy() {}
    function Kp(s, o, d, g) {
        if (s.tag !== 5) throw Error(n(476));
        var E = xg(s).queue;
        Qp(s, E, o, K, d === null ? Wy : function() {
            return Jp(s), d(g);
        });
    }
    function xg(s) {
        var o = s.memoizedState;
        if (o !== null) return o;
        o = {
            memoizedState: K,
            baseState: K,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: ho,
                lastRenderedState: K
            },
            next: null
        };
        var d = {};
        return o.next = {
            memoizedState: d,
            baseState: d,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: ho,
                lastRenderedState: d
            },
            next: null
        }, s.memoizedState = o, s = s.alternate, s !== null && (s.memoizedState = o), o;
    }
    function Jp(s) {
        var o = xg(s);
        o.next === null && (o = s.alternate.memoizedState), Wc(s, o.next.queue, {}, Pa());
    }
    function $p() {
        return Ki(hm);
    }
    function sa() {
        return Ti().memoizedState;
    }
    function em() {
        return Ti().memoizedState;
    }
    function qy(s) {
        for(var o = s.return; o !== null;){
            switch(o.tag){
                case 24:
                case 3:
                    var d = Pa();
                    s = Os(d);
                    var g = uo(o, s, d);
                    g !== null && (h(g, o, d), nl(g, o, d)), o = {
                        cache: _p()
                    }, s.payload = o;
                    return;
            }
            o = o.return;
        }
    }
    function Yy(s, o, d) {
        var g = Pa();
        d = {
            lane: g,
            revertLane: 0,
            gesture: null,
            action: d,
            hasEagerState: !1,
            eagerState: null,
            next: null
        }, po(s) ? Zl(o, d) : (d = Ic(s, o, d, g), d !== null && (h(d, s, g), Xa(d, o, g)));
    }
    function vg(s, o, d) {
        var g = Pa();
        Wc(s, o, d, g);
    }
    function Wc(s, o, d, g) {
        var E = {
            lane: g,
            revertLane: 0,
            gesture: null,
            action: d,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (po(s)) Zl(o, E);
        else {
            var w = s.alternate;
            if (s.lanes === 0 && (w === null || w.lanes === 0) && (w = o.lastRenderedReducer, w !== null)) try {
                var V = o.lastRenderedState, re = w(V, d);
                if (E.hasEagerState = !0, E.eagerState = re, si(re, V)) return Hu(s, o, E, 0), In === null && Wo(), !1;
            } catch  {} finally{}
            if (d = Ic(s, o, E, g), d !== null) return h(d, s, g), Xa(d, o, g), !0;
        }
        return !1;
    }
    function tf(s, o, d, g) {
        if (g = {
            lane: 2,
            revertLane: Jy(),
            gesture: null,
            action: g,
            hasEagerState: !1,
            eagerState: null,
            next: null
        }, po(s)) {
            if (o) throw Error(n(479));
        } else o = Ic(s, d, g, 2), o !== null && h(o, s, 2);
    }
    function po(s) {
        var o = s.alternate;
        return s === Xt || o !== null && o === Xt;
    }
    function Zl(s, o) {
        zs = Mh = !0;
        var d = s.pending;
        d === null ? o.next = o : (o.next = d.next, d.next = o), s.pending = o;
    }
    function Xa(s, o, d) {
        if ((d & 4194048) !== 0) {
            var g = o.lanes;
            g &= s.pendingLanes, d |= g, o.lanes = d, Gi(s, d);
        }
    }
    var nf = {
        readContext: Ki,
        use: Th,
        useCallback: yi,
        useContext: yi,
        useEffect: yi,
        useImperativeHandle: yi,
        useLayoutEffect: yi,
        useInsertionEffect: yi,
        useMemo: yi,
        useReducer: yi,
        useRef: yi,
        useState: yi,
        useDebugValue: yi,
        useDeferredValue: yi,
        useTransition: yi,
        useSyncExternalStore: yi,
        useId: yi,
        useHostTransitionStatus: yi,
        useFormState: yi,
        useActionState: yi,
        useOptimistic: yi,
        useMemoCache: yi,
        useCacheRefresh: yi
    };
    nf.useEffectEvent = yi;
    var yg = {
        readContext: Ki,
        use: Th,
        useCallback: function(s, o) {
            return La().memoizedState = [
                s,
                o === void 0 ? null : o
            ], s;
        },
        useContext: Ki,
        useEffect: dg,
        useImperativeHandle: function(s, o, d) {
            d = d != null ? d.concat([
                s
            ]) : null, Dh(4194308, 4, Xp.bind(null, o, s), d);
        },
        useLayoutEffect: function(s, o) {
            return Dh(4194308, 4, s, o);
        },
        useInsertionEffect: function(s, o) {
            Dh(4, 2, s, o);
        },
        useMemo: function(s, o) {
            var d = La();
            o = o === void 0 ? null : o;
            var g = s();
            if (Yl) {
                at(!0);
                try {
                    s();
                } finally{
                    at(!1);
                }
            }
            return d.memoizedState = [
                g,
                o
            ], g;
        },
        useReducer: function(s, o, d) {
            var g = La();
            if (d !== void 0) {
                var E = d(o);
                if (Yl) {
                    at(!0);
                    try {
                        d(o);
                    } finally{
                        at(!1);
                    }
                }
            } else E = o;
            return g.memoizedState = g.baseState = E, s = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: s,
                lastRenderedState: E
            }, g.queue = s, s = s.dispatch = Yy.bind(null, Xt, s), [
                g.memoizedState,
                s
            ];
        },
        useRef: function(s) {
            var o = La();
            return s = {
                current: s
            }, o.memoizedState = s;
        },
        useState: function(s) {
            s = ef(s);
            var o = s.queue, d = vg.bind(null, Xt, o);
            return o.dispatch = d, [
                s.memoizedState,
                d
            ];
        },
        useDebugValue: Oh,
        useDeferredValue: function(s, o) {
            var d = La();
            return Yp(d, s, o);
        },
        useTransition: function() {
            var s = ef(!1);
            return s = Qp.bind(null, Xt, s.queue, !0, !1), La().memoizedState = s, [
                !1,
                s
            ];
        },
        useSyncExternalStore: function(s, o, d) {
            var g = Xt, E = La();
            if (bn) {
                if (d === void 0) throw Error(n(407));
                d = d();
            } else {
                if (d = o(), In === null) throw Error(n(349));
                (yn & 127) !== 0 || ng(g, o, d);
            }
            E.memoizedState = d;
            var w = {
                value: d,
                getSnapshot: o
            };
            return E.queue = w, dg(Vp.bind(null, g, w, s), [
                s
            ]), g.flags |= 2048, Xc(9, {
                destroy: void 0
            }, Hp.bind(null, g, w, d, o), null), d;
        },
        useId: function() {
            var s = La(), o = In.identifierPrefix;
            if (bn) {
                var d = Us, g = Ds;
                d = (g & ~(1 << 32 - he(g) - 1)).toString(32) + d, o = "_" + o + "R_" + d, d = Eh++, 0 < d && (o += "H" + d.toString(32)), o += "_";
            } else d = Gy++, o = "_" + o + "r_" + d.toString(32) + "_";
            return s.memoizedState = o;
        },
        useHostTransitionStatus: $p,
        useFormState: lg,
        useActionState: lg,
        useOptimistic: function(s) {
            var o = La();
            o.memoizedState = o.baseState = s;
            var d = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null
            };
            return o.queue = d, o = tf.bind(null, Xt, !0, d), d.dispatch = o, [
                s,
                o
            ];
        },
        useMemoCache: Bp,
        useCacheRefresh: function() {
            return La().memoizedState = qy.bind(null, Xt);
        },
        useEffectEvent: function(s) {
            var o = La(), d = {
                impl: s
            };
            return o.memoizedState = d, function() {
                if ((Mn & 2) !== 0) throw Error(n(440));
                return d.impl.apply(void 0, arguments);
            };
        }
    }, qc = {
        readContext: Ki,
        use: Th,
        useCallback: Wp,
        useContext: Ki,
        useEffect: jp,
        useImperativeHandle: Nh,
        useInsertionEffect: gg,
        useLayoutEffect: pr,
        useMemo: qp,
        useReducer: Ah,
        useRef: hg,
        useState: function() {
            return Ah(ho);
        },
        useDebugValue: Oh,
        useDeferredValue: function(s, o) {
            var d = Ti();
            return Zp(d, Xn.memoizedState, s, o);
        },
        useTransition: function() {
            var s = Ah(ho)[0], o = Ti().memoizedState;
            return [
                typeof s == "boolean" ? s : $u(s),
                o
            ];
        },
        useSyncExternalStore: Fp,
        useId: sa,
        useHostTransitionStatus: $p,
        useFormState: cg,
        useActionState: cg,
        useOptimistic: function(s, o) {
            var d = Ti();
            return ig(d, Xn, s, o);
        },
        useMemoCache: Bp,
        useCacheRefresh: em
    };
    qc.useEffectEvent = mg;
    var af = {
        readContext: Ki,
        use: Th,
        useCallback: Wp,
        useContext: Ki,
        useEffect: jp,
        useImperativeHandle: Nh,
        useInsertionEffect: gg,
        useLayoutEffect: pr,
        useMemo: qp,
        useReducer: wh,
        useRef: hg,
        useState: function() {
            return wh(ho);
        },
        useDebugValue: Oh,
        useDeferredValue: function(s, o) {
            var d = Ti();
            return Xn === null ? Yp(d, s, o) : Zp(d, Xn.memoizedState, s, o);
        },
        useTransition: function() {
            var s = wh(ho)[0], o = Ti().memoizedState;
            return [
                typeof s == "boolean" ? s : $u(s),
                o
            ];
        },
        useSyncExternalStore: Fp,
        useId: sa,
        useHostTransitionStatus: $p,
        useFormState: fg,
        useActionState: fg,
        useOptimistic: function(s, o) {
            var d = Ti();
            return Xn !== null ? ig(d, Xn, s, o) : (d.baseState = s, [
                s,
                d.queue.dispatch
            ]);
        },
        useMemoCache: Bp,
        useCacheRefresh: em
    };
    af.useEffectEvent = mg;
    function Yc(s, o, d, g) {
        o = s.memoizedState, d = d(g, o), d = d == null ? o : x({}, o, d), s.memoizedState = d, s.lanes === 0 && (s.updateQueue.baseState = d);
    }
    var rf = {
        enqueueSetState: function(s, o, d) {
            s = s._reactInternals;
            var g = Pa(), E = Os(g);
            E.payload = o, d != null && (E.callback = d), o = uo(s, E, g), o !== null && (h(o, s, g), nl(o, s, g));
        },
        enqueueReplaceState: function(s, o, d) {
            s = s._reactInternals;
            var g = Pa(), E = Os(g);
            E.tag = 1, E.payload = o, d != null && (E.callback = d), o = uo(s, E, g), o !== null && (h(o, s, g), nl(o, s, g));
        },
        enqueueForceUpdate: function(s, o) {
            s = s._reactInternals;
            var d = Pa(), g = Os(d);
            g.tag = 2, o != null && (g.callback = o), o = uo(s, g, d), o !== null && (h(o, s, d), nl(o, s, d));
        }
    };
    function _g(s, o, d, g, E, w, V) {
        return s = s.stateNode, typeof s.shouldComponentUpdate == "function" ? s.shouldComponentUpdate(g, w, V) : o.prototype && o.prototype.isPureReactComponent ? !Nc(d, g) || !Nc(E, w) : !0;
    }
    function bg(s, o, d, g) {
        s = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, g), o.state !== s && rf.enqueueReplaceState(o, o.state, null);
    }
    function oa(s, o) {
        var d = o;
        if ("ref" in o) {
            d = {};
            for(var g in o)g !== "ref" && (d[g] = o[g]);
        }
        if (s = s.defaultProps) {
            d === o && (d = x({}, d));
            for(var E in s)d[E] === void 0 && (d[E] = s[E]);
        }
        return d;
    }
    function tm(s) {
        Xo(s);
    }
    function Sg(s) {
        console.error(s);
    }
    function Lh(s) {
        Xo(s);
    }
    function zh(s, o) {
        try {
            var d = s.onUncaughtError;
            d(o.value, {
                componentStack: o.stack
            });
        } catch (g) {
            setTimeout(function() {
                throw g;
            });
        }
    }
    function Mg(s, o, d) {
        try {
            var g = s.onCaughtError;
            g(d.value, {
                componentStack: d.stack,
                errorBoundary: o.tag === 1 ? o.stateNode : null
            });
        } catch (E) {
            setTimeout(function() {
                throw E;
            });
        }
    }
    function nm(s, o, d) {
        return d = Os(d), d.tag = 3, d.payload = {
            element: null
        }, d.callback = function() {
            zh(s, o);
        }, d;
    }
    function Zc(s) {
        return s = Os(s), s.tag = 3, s;
    }
    function Wa(s, o, d, g) {
        var E = d.type.getDerivedStateFromError;
        if (typeof E == "function") {
            var w = g.value;
            s.payload = function() {
                return E(w);
            }, s.callback = function() {
                Mg(o, d, g);
            };
        }
        var V = d.stateNode;
        V !== null && typeof V.componentDidCatch == "function" && (s.callback = function() {
            Mg(o, d, g), typeof E != "function" && (Vs === null ? Vs = new Set([
                this
            ]) : Vs.add(this));
            var re = g.stack;
            this.componentDidCatch(g.value, {
                componentStack: re !== null ? re : ""
            });
        });
    }
    function mr(s, o, d, g, E) {
        if (d.flags |= 32768, g !== null && typeof g == "object" && typeof g.then == "function") {
            if (o = d.alternate, o !== null && Qo(o, d, E, !0), d = ji.current, d !== null) {
                switch(d.tag){
                    case 31:
                    case 13:
                        return Fr === null ? Zt() : d.alternate === null && Fn === 0 && (Fn = 3), d.flags &= -257, d.flags |= 65536, d.lanes = E, g === qu ? d.flags |= 16384 : (o = d.updateQueue, o === null ? d.updateQueue = new Set([
                            g
                        ]) : o.add(g), Zy(s, g, E)), !1;
                    case 22:
                        return d.flags |= 65536, g === qu ? d.flags |= 16384 : (o = d.updateQueue, o === null ? (o = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                g
                            ])
                        }, d.updateQueue = o) : (d = o.retryQueue, d === null ? o.retryQueue = new Set([
                            g
                        ]) : d.add(g)), Zy(s, g, E)), !1;
                }
                throw Error(n(435, d.tag));
            }
            return Zy(s, g, E), Zt(), !1;
        }
        if (bn) return o = ji.current, o !== null ? ((o.flags & 65536) === 0 && (o.flags |= 256), o.flags |= 65536, o.lanes = E, g !== mh && (s = Error(n(422), {
            cause: g
        }), ju(Ga(s, d)))) : (g !== mh && (o = Error(n(423), {
            cause: g
        }), ju(Ga(o, d))), s = s.current.alternate, s.flags |= 65536, E &= -E, s.lanes |= E, g = Ga(g, d), E = nm(s.stateNode, g, E), bh(s, E), Fn !== 4 && (Fn = 2)), !1;
        var w = Error(n(520), {
            cause: g
        });
        if (w = Ga(w, d), gs === null ? gs = [
            w
        ] : gs.push(w), Fn !== 4 && (Fn = 2), o === null) return !0;
        g = Ga(g, d), d = o;
        do {
            switch(d.tag){
                case 3:
                    return d.flags |= 65536, s = E & -E, d.lanes |= s, s = nm(d.stateNode, g, s), bh(d, s), !1;
                case 1:
                    if (o = d.type, w = d.stateNode, (d.flags & 128) === 0 && (typeof o.getDerivedStateFromError == "function" || w !== null && typeof w.componentDidCatch == "function" && (Vs === null || !Vs.has(w)))) return d.flags |= 65536, E &= -E, d.lanes |= E, E = Zc(E), Wa(E, s, d, g), bh(d, E), !1;
            }
            d = d.return;
        }while (d !== null);
        return !1;
    }
    var Ph = Error(n(461)), oi = !1;
    function _i(s, o, d, g) {
        o.child = s === null ? J0(o, null, d, g) : Wl(o, s.child, d, g);
    }
    function sf(s, o, d, g, E) {
        d = d.render;
        var w = o.ref;
        if ("ref" in g) {
            var V = {};
            for(var re in g)re !== "ref" && (V[re] = g[re]);
        } else V = g;
        return kl(o), g = Op(s, o, d, V, w, E), re = Lp(), s !== null && !oi ? (zp(s, o, E), ps(s, o, E)) : (bn && re && ph(o), o.flags |= 1, _i(s, o, g, E), o.child);
    }
    function of(s, o, d, g, E) {
        if (s === null) {
            var w = d.type;
            return typeof w == "function" && !Na(w) && w.defaultProps === void 0 && d.compare === null ? (o.tag = 15, o.type = w, gr(s, o, w, g, E)) : (s = Vu(d.type, null, g, o, o.mode, E), s.ref = o.ref, s.return = o, o.child = s);
        }
        if (w = s.child, !rl(s, E)) {
            var V = w.memoizedProps;
            if (d = d.compare, d = d !== null ? d : Nc, d(V, g) && s.ref === o.ref) return ps(s, o, E);
        }
        return o.flags |= 1, s = Cs(w, g), s.ref = o.ref, s.return = o, o.child = s;
    }
    function gr(s, o, d, g, E) {
        if (s !== null) {
            var w = s.memoizedProps;
            if (Nc(w, g) && s.ref === o.ref) {
                if (oi = !1, o.pendingProps = g = w, rl(s, E)) (s.flags & 131072) !== 0 && (oi = !0);
                else return o.lanes = s.lanes, ps(s, o, E);
            }
        }
        return Qc(s, o, d, g, E);
    }
    function xr(s, o, d, g) {
        var E = g.children, w = s !== null ? s.memoizedState : null;
        if (s === null && o.stateNode === null && (o.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        }), g.mode === "hidden") {
            if ((o.flags & 128) !== 0) {
                if (w = w !== null ? w.baseLanes | d : d, s !== null) {
                    for(g = o.child = s.child, E = 0; g !== null;)E = E | g.lanes | g.childLanes, g = g.sibling;
                    g = E & ~w;
                } else g = 0, o.child = null;
                return Bs(s, o, w, d, g);
            }
            if ((d & 536870912) !== 0) o.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, s !== null && kc(o, w !== null ? w.cachePool : null), w !== null ? Rp(o, w) : Dp(), $0(o);
            else return g = o.lanes = 536870912, Bs(s, o, w !== null ? w.baseLanes | d : d, d, g);
        } else w !== null ? (kc(o, w.cachePool), Rp(o, w), fo(), o.memoizedState = null) : (s !== null && kc(o, null), Dp(), fo());
        return _i(s, o, E, d), o.child;
    }
    function hs(s, o) {
        return s !== null && s.tag === 22 || o.stateNode !== null || (o.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        }), o.sibling;
    }
    function Bs(s, o, d, g, E) {
        var w = Ns();
        return w = w === null ? null : {
            parent: Bt._currentValue,
            pool: w
        }, o.memoizedState = {
            baseLanes: d,
            cachePool: w
        }, s !== null && kc(o, null), Dp(), $0(o), s !== null && Qo(s, o, g, !0), o.childLanes = E, null;
    }
    function Hr(s, o) {
        return o = Kc({
            mode: o.mode,
            children: o.children
        }, s.mode), o.ref = s.ref, s.child = o, o.return = s, o;
    }
    function Ji(s, o, d) {
        return Wl(o, s.child, null, d), s = Hr(o, o.pendingProps), s.flags |= 2, dr(o), o.memoizedState = null, s;
    }
    function lf(s, o, d) {
        var g = o.pendingProps, E = (o.flags & 128) !== 0;
        if (o.flags &= -129, s === null) {
            if (bn) {
                if (g.mode === "hidden") return s = Hr(o, g), o.lanes = 536870912, hs(null, s);
                if (Up(o), (s = Kn) ? (s = WS(s, Qi), s = s !== null && s.data === "&" ? s : null, s !== null && (o.memoizedState = {
                    dehydrated: s,
                    treeContext: Rs !== null ? {
                        id: Ds,
                        overflow: Us
                    } : null,
                    retryLane: 536870912,
                    hydrationErrors: null
                }, d = W0(s), d.return = o, o.child = d, Zi = o, Kn = null)) : s = null, s === null) throw vn(o);
                return o.lanes = 536870912, null;
            }
            return Hr(o, g);
        }
        var w = s.memoizedState;
        if (w !== null) {
            var V = w.dehydrated;
            if (Up(o), E) {
                if (o.flags & 256) o.flags &= -257, o = Ji(s, o, d);
                else if (o.memoizedState !== null) o.child = s.child, o.flags |= 128, o = null;
                else throw Error(n(558));
            } else if (oi || Qo(s, o, d, !1), E = (d & s.childLanes) !== 0, oi || E) {
                if (g = In, g !== null && (V = da(g, d), V !== 0 && V !== w.retryLane)) throw w.retryLane = V, qo(s, V), h(g, s, V), Ph;
                Zt(), o = Ji(s, o, d);
            } else s = w.treeContext, Kn = Gs(V.nextSibling), Zi = o, bn = !0, ro = null, Qi = !1, s !== null && ku(o, s), o = Hr(o, g), o.flags |= 4096;
            return o;
        }
        return s = Cs(s.child, {
            mode: g.mode,
            children: g.children
        }), s.ref = o.ref, o.child = s, s.return = o, s;
    }
    function ds(s, o) {
        var d = o.ref;
        if (d === null) s !== null && s.ref !== null && (o.flags |= 4194816);
        else {
            if (typeof d != "function" && typeof d != "object") throw Error(n(284));
            (s === null || s.ref !== d) && (o.flags |= 4194816);
        }
    }
    function Qc(s, o, d, g, E) {
        return kl(o), d = Op(s, o, d, g, void 0, E), g = Lp(), s !== null && !oi ? (zp(s, o, E), ps(s, o, E)) : (bn && g && ph(o), o.flags |= 1, _i(s, o, d, E), o.child);
    }
    function ya(s, o, d, g, E, w) {
        return kl(o), o.updateQueue = null, d = tg(o, g, d, E), eg(s), g = Lp(), s !== null && !oi ? (zp(s, o, w), ps(s, o, w)) : (bn && g && ph(o), o.flags |= 1, _i(s, o, d, w), o.child);
    }
    function la(s, o, d, g, E) {
        if (kl(o), o.stateNode === null) {
            var w = Yo, V = d.contextType;
            typeof V == "object" && V !== null && (w = Ki(V)), w = new d(g, w), o.memoizedState = w.state !== null && w.state !== void 0 ? w.state : null, w.updater = rf, o.stateNode = w, w._reactInternals = o, w = o.stateNode, w.props = g, w.state = o.memoizedState, w.refs = {}, Ap(o), V = d.contextType, w.context = typeof V == "object" && V !== null ? Ki(V) : Yo, w.state = o.memoizedState, V = d.getDerivedStateFromProps, typeof V == "function" && (Yc(o, d, V, g), w.state = o.memoizedState), typeof d.getDerivedStateFromProps == "function" || typeof w.getSnapshotBeforeUpdate == "function" || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (V = w.state, typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount(), V !== w.state && rf.enqueueReplaceState(w, w.state, null), ql(o, g, w, E), Qu(), w.state = o.memoizedState), typeof w.componentDidMount == "function" && (o.flags |= 4194308), g = !0;
        } else if (s === null) {
            w = o.stateNode;
            var re = o.memoizedProps, ge = oa(d, re);
            w.props = ge;
            var He = w.context, et = d.contextType;
            V = Yo, typeof et == "object" && et !== null && (V = Ki(et));
            var ct = d.getDerivedStateFromProps;
            et = typeof ct == "function" || typeof w.getSnapshotBeforeUpdate == "function", re = o.pendingProps !== re, et || typeof w.UNSAFE_componentWillReceiveProps != "function" && typeof w.componentWillReceiveProps != "function" || (re || He !== V) && bg(o, w, g, V), tl = !1;
            var Xe = o.memoizedState;
            w.state = Xe, ql(o, g, w, E), Qu(), He = o.memoizedState, re || Xe !== He || tl ? (typeof ct == "function" && (Yc(o, d, ct, g), He = o.memoizedState), (ge = tl || _g(o, d, ge, g, Xe, He, V)) ? (et || typeof w.UNSAFE_componentWillMount != "function" && typeof w.componentWillMount != "function" || (typeof w.componentWillMount == "function" && w.componentWillMount(), typeof w.UNSAFE_componentWillMount == "function" && w.UNSAFE_componentWillMount()), typeof w.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof w.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = g, o.memoizedState = He), w.props = g, w.state = He, w.context = V, g = ge) : (typeof w.componentDidMount == "function" && (o.flags |= 4194308), g = !1);
        } else {
            w = o.stateNode, wp(s, o), V = o.memoizedProps, et = oa(d, V), w.props = et, ct = o.pendingProps, Xe = w.context, He = d.contextType, ge = Yo, typeof He == "object" && He !== null && (ge = Ki(He)), re = d.getDerivedStateFromProps, (He = typeof re == "function" || typeof w.getSnapshotBeforeUpdate == "function") || typeof w.UNSAFE_componentWillReceiveProps != "function" && typeof w.componentWillReceiveProps != "function" || (V !== ct || Xe !== ge) && bg(o, w, g, ge), tl = !1, Xe = o.memoizedState, w.state = Xe, ql(o, g, w, E), Qu();
            var Qe = o.memoizedState;
            V !== ct || Xe !== Qe || tl || s !== null && s.dependencies !== null && Vc(s.dependencies) ? (typeof re == "function" && (Yc(o, d, re, g), Qe = o.memoizedState), (et = tl || _g(o, d, et, g, Xe, Qe, ge) || s !== null && s.dependencies !== null && Vc(s.dependencies)) ? (He || typeof w.UNSAFE_componentWillUpdate != "function" && typeof w.componentWillUpdate != "function" || (typeof w.componentWillUpdate == "function" && w.componentWillUpdate(g, Qe, ge), typeof w.UNSAFE_componentWillUpdate == "function" && w.UNSAFE_componentWillUpdate(g, Qe, ge)), typeof w.componentDidUpdate == "function" && (o.flags |= 4), typeof w.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof w.componentDidUpdate != "function" || V === s.memoizedProps && Xe === s.memoizedState || (o.flags |= 4), typeof w.getSnapshotBeforeUpdate != "function" || V === s.memoizedProps && Xe === s.memoizedState || (o.flags |= 1024), o.memoizedProps = g, o.memoizedState = Qe), w.props = g, w.state = Qe, w.context = ge, g = et) : (typeof w.componentDidUpdate != "function" || V === s.memoizedProps && Xe === s.memoizedState || (o.flags |= 4), typeof w.getSnapshotBeforeUpdate != "function" || V === s.memoizedProps && Xe === s.memoizedState || (o.flags |= 1024), g = !1);
        }
        return w = g, ds(s, o), g = (o.flags & 128) !== 0, w || g ? (w = o.stateNode, d = g && typeof d.getDerivedStateFromError != "function" ? null : w.render(), o.flags |= 1, s !== null && g ? (o.child = Wl(o, s.child, null, E), o.child = Wl(o, null, d, E)) : _i(s, o, d, E), o.memoizedState = w.state, s = o.child) : s = ps(s, o, E), s;
    }
    function An(s, o, d, g) {
        return Gl(), o.flags |= 256, _i(s, o, d, g), o.child;
    }
    var vr = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    };
    function Vr(s) {
        return {
            baseLanes: s,
            cachePool: vh()
        };
    }
    function cf(s, o, d) {
        return s = s !== null ? s.childLanes & ~d : 0, o && (s |= En), s;
    }
    function yr(s, o, d) {
        var g = o.pendingProps, E = !1, w = (o.flags & 128) !== 0, V;
        if ((V = w) || (V = s !== null && s.memoizedState === null ? !1 : (vi.current & 2) !== 0), V && (E = !0, o.flags &= -129), V = (o.flags & 32) !== 0, o.flags &= -33, s === null) {
            if (bn) {
                if (E ? il(o) : fo(), (s = Kn) ? (s = WS(s, Qi), s = s !== null && s.data !== "&" ? s : null, s !== null && (o.memoizedState = {
                    dehydrated: s,
                    treeContext: Rs !== null ? {
                        id: Ds,
                        overflow: Us
                    } : null,
                    retryLane: 536870912,
                    hydrationErrors: null
                }, d = W0(s), d.return = o, o.child = d, Zi = o, Kn = null)) : s = null, s === null) throw vn(o);
                return f1(s) ? o.lanes = 32 : o.lanes = 536870912, null;
            }
            var re = g.children;
            return g = g.fallback, E ? (fo(), E = o.mode, re = Kc({
                mode: "hidden",
                children: re
            }, E), g = io(g, E, d, null), re.return = o, g.return = o, re.sibling = g, o.child = re, g = o.child, g.memoizedState = Vr(d), g.childLanes = cf(s, V, d), o.memoizedState = vr, hs(null, g)) : (il(o), al(o, re));
        }
        var ge = s.memoizedState;
        if (ge !== null && (re = ge.dehydrated, re !== null)) {
            if (w) o.flags & 256 ? (il(o), o.flags &= -257, o = Jc(s, o, d)) : o.memoizedState !== null ? (fo(), o.child = s.child, o.flags |= 128, o = null) : (fo(), re = g.fallback, E = o.mode, g = Kc({
                mode: "visible",
                children: g.children
            }, E), re = io(re, E, d, null), re.flags |= 2, g.return = o, re.return = o, g.sibling = re, o.child = g, Wl(o, s.child, null, d), g = o.child, g.memoizedState = Vr(d), g.childLanes = cf(s, V, d), o.memoizedState = vr, o = hs(null, g));
            else if (il(o), f1(re)) {
                if (V = re.nextSibling && re.nextSibling.dataset, V) var He = V.dgst;
                V = He, g = Error(n(419)), g.stack = "", g.digest = V, ju({
                    value: g,
                    source: null,
                    stack: null
                }), o = Jc(s, o, d);
            } else if (oi || Qo(s, o, d, !1), V = (d & s.childLanes) !== 0, oi || V) {
                if (V = In, V !== null && (g = da(V, d), g !== 0 && g !== ge.retryLane)) throw ge.retryLane = g, qo(s, g), h(V, s, g), Ph;
                u1(re) || Zt(), o = Jc(s, o, d);
            } else u1(re) ? (o.flags |= 192, o.child = s.child, o = null) : (s = ge.treeContext, Kn = Gs(re.nextSibling), Zi = o, bn = !0, ro = null, Qi = !1, s !== null && ku(o, s), o = al(o, g.children), o.flags |= 4096);
            return o;
        }
        return E ? (fo(), re = g.fallback, E = o.mode, ge = s.child, He = ge.sibling, g = Cs(ge, {
            mode: "hidden",
            children: g.children
        }), g.subtreeFlags = ge.subtreeFlags & 65011712, He !== null ? re = Cs(He, re) : (re = io(re, E, d, null), re.flags |= 2), re.return = o, g.return = o, g.sibling = re, o.child = g, hs(null, g), g = o.child, re = s.child.memoizedState, re === null ? re = Vr(d) : (E = re.cachePool, E !== null ? (ge = Bt._currentValue, E = E.parent !== ge ? {
            parent: ge,
            pool: ge
        } : E) : E = vh(), re = {
            baseLanes: re.baseLanes | d,
            cachePool: E
        }), g.memoizedState = re, g.childLanes = cf(s, V, d), o.memoizedState = vr, hs(s.child, g)) : (il(o), d = s.child, s = d.sibling, d = Cs(d, {
            mode: "visible",
            children: g.children
        }), d.return = o, d.sibling = null, s !== null && (V = o.deletions, V === null ? (o.deletions = [
            s
        ], o.flags |= 16) : V.push(s)), o.child = d, o.memoizedState = null, d);
    }
    function al(s, o) {
        return o = Kc({
            mode: "visible",
            children: o
        }, s.mode), o.return = s, s.child = o;
    }
    function Kc(s, o) {
        return s = Ua(22, s, null, o), s.lanes = 0, s;
    }
    function Jc(s, o, d) {
        return Wl(o, s.child, null, d), s = al(o, o.pendingProps.children), s.flags |= 2, o.memoizedState = null, s;
    }
    function Ql(s, o, d) {
        s.lanes |= o;
        var g = s.alternate;
        g !== null && (g.lanes |= o), lo(s.return, o, d);
    }
    function uf(s, o, d, g, E, w) {
        var V = s.memoizedState;
        V === null ? s.memoizedState = {
            isBackwards: o,
            rendering: null,
            renderingStartTime: 0,
            last: g,
            tail: d,
            tailMode: E,
            treeForkCount: w
        } : (V.isBackwards = o, V.rendering = null, V.renderingStartTime = 0, V.last = g, V.tail = d, V.tailMode = E, V.treeForkCount = w);
    }
    function ff(s, o, d) {
        var g = o.pendingProps, E = g.revealOrder, w = g.tail;
        g = g.children;
        var V = vi.current, re = (V & 2) !== 0;
        if (re ? (V = V & 1 | 2, o.flags |= 128) : V &= 1, oe(vi, V), _i(s, o, g, d), g = bn ? Hc : 0, !re && s !== null && (s.flags & 128) !== 0) e: for(s = o.child; s !== null;){
            if (s.tag === 13) s.memoizedState !== null && Ql(s, d, o);
            else if (s.tag === 19) Ql(s, d, o);
            else if (s.child !== null) {
                s.child.return = s, s = s.child;
                continue;
            }
            if (s === o) break e;
            for(; s.sibling === null;){
                if (s.return === null || s.return === o) break e;
                s = s.return;
            }
            s.sibling.return = s.return, s = s.sibling;
        }
        switch(E){
            case "forwards":
                for(d = o.child, E = null; d !== null;)s = d.alternate, s !== null && Sh(s) === null && (E = d), d = d.sibling;
                d = E, d === null ? (E = o.child, o.child = null) : (E = d.sibling, d.sibling = null), uf(o, !1, E, d, w, g);
                break;
            case "backwards":
            case "unstable_legacy-backwards":
                for(d = null, E = o.child, o.child = null; E !== null;){
                    if (s = E.alternate, s !== null && Sh(s) === null) {
                        o.child = E;
                        break;
                    }
                    s = E.sibling, E.sibling = d, d = E, E = s;
                }
                uf(o, !0, d, null, w, g);
                break;
            case "together":
                uf(o, !1, null, null, void 0, g);
                break;
            default:
                o.memoizedState = null;
        }
        return o.child;
    }
    function ps(s, o, d) {
        if (s !== null && (o.dependencies = s.dependencies), Sr |= o.lanes, (d & o.childLanes) === 0) {
            if (s !== null) {
                if (Qo(s, o, d, !1), (d & o.childLanes) === 0) return null;
            } else return null;
        }
        if (s !== null && o.child !== s.child) throw Error(n(153));
        if (o.child !== null) {
            for(s = o.child, d = Cs(s, s.pendingProps), o.child = d, d.return = o; s.sibling !== null;)s = s.sibling, d = d.sibling = Cs(s, s.pendingProps), d.return = o;
            d.sibling = null;
        }
        return o.child;
    }
    function rl(s, o) {
        return (s.lanes & o) !== 0 ? !0 : (s = s.dependencies, !!(s !== null && Vc(s)));
    }
    function hf(s, o, d) {
        switch(o.tag){
            case 3:
                xe(o, o.stateNode.containerInfo), oo(o, Bt, s.memoizedState.cache), Gl();
                break;
            case 27:
            case 5:
                Ue(o);
                break;
            case 4:
                xe(o, o.stateNode.containerInfo);
                break;
            case 10:
                oo(o, o.type, o.memoizedProps.value);
                break;
            case 31:
                if (o.memoizedState !== null) return o.flags |= 128, Up(o), null;
                break;
            case 13:
                var g = o.memoizedState;
                if (g !== null) return g.dehydrated !== null ? (il(o), o.flags |= 128, null) : (d & o.child.childLanes) !== 0 ? yr(s, o, d) : (il(o), s = ps(s, o, d), s !== null ? s.sibling : null);
                il(o);
                break;
            case 19:
                var E = (s.flags & 128) !== 0;
                if (g = (d & o.childLanes) !== 0, g || (Qo(s, o, d, !1), g = (d & o.childLanes) !== 0), E) {
                    if (g) return ff(s, o, d);
                    o.flags |= 128;
                }
                if (E = o.memoizedState, E !== null && (E.rendering = null, E.tail = null, E.lastEffect = null), oe(vi, vi.current), g) break;
                return null;
            case 22:
                return o.lanes = 0, xr(s, o, d, o.pendingProps);
            case 24:
                oo(o, Bt, s.memoizedState.cache);
        }
        return ps(s, o, d);
    }
    function Bh(s, o, d) {
        if (s !== null) {
            if (s.memoizedProps !== o.pendingProps) oi = !0;
            else {
                if (!rl(s, d) && (o.flags & 128) === 0) return oi = !1, hf(s, o, d);
                oi = (s.flags & 131072) !== 0;
            }
        } else oi = !1, bn && (o.flags & 1048576) !== 0 && mp(o, Hc, o.index);
        switch(o.lanes = 0, o.tag){
            case 16:
                e: {
                    var g = o.pendingProps;
                    if (s = Xl(o.elementType), o.type = s, typeof s == "function") Na(s) ? (g = oa(s, g), o.tag = 1, o = la(null, o, s, g, d)) : (o.tag = 0, o = Qc(null, o, s, g, d));
                    else {
                        if (s != null) {
                            var E = s.$$typeof;
                            if (E === N) {
                                o.tag = 11, o = sf(null, o, s, g, d);
                                break e;
                            } else if (E === P) {
                                o.tag = 14, o = of(null, o, s, g, d);
                                break e;
                            }
                        }
                        throw o = Y(s) || s, Error(n(306, o, ""));
                    }
                }
                return o;
            case 0:
                return Qc(s, o, o.type, o.pendingProps, d);
            case 1:
                return g = o.type, E = oa(g, o.pendingProps), la(s, o, g, E, d);
            case 3:
                e: {
                    if (xe(o, o.stateNode.containerInfo), s === null) throw Error(n(387));
                    g = o.pendingProps;
                    var w = o.memoizedState;
                    E = w.element, wp(s, o), ql(o, g, null, d);
                    var V = o.memoizedState;
                    if (g = V.cache, oo(o, Bt, g), g !== w.cache && xh(o, [
                        Bt
                    ], d, !0), Qu(), g = V.element, w.isDehydrated) {
                        if (w = {
                            element: g,
                            isDehydrated: !1,
                            cache: V.cache
                        }, o.updateQueue.baseState = w, o.memoizedState = w, o.flags & 256) {
                            o = An(s, o, g, d);
                            break e;
                        } else if (g !== E) {
                            E = Ga(Error(n(424)), o), ju(E), o = An(s, o, g, d);
                            break e;
                        } else {
                            switch(s = o.stateNode.containerInfo, s.nodeType){
                                case 9:
                                    s = s.body;
                                    break;
                                default:
                                    s = s.nodeName === "HTML" ? s.ownerDocument.body : s;
                            }
                            for(Kn = Gs(s.firstChild), Zi = o, bn = !0, ro = null, Qi = !0, d = J0(o, null, g, d), o.child = d; d;)d.flags = d.flags & -3 | 4096, d = d.sibling;
                        }
                    } else {
                        if (Gl(), g === E) {
                            o = ps(s, o, d);
                            break e;
                        }
                        _i(s, o, g, d);
                    }
                    o = o.child;
                }
                return o;
            case 26:
                return ds(s, o), s === null ? (d = JS(o.type, null, o.pendingProps, null)) ? o.memoizedState = d : bn || (d = o.type, s = o.pendingProps, g = Ug(ue.current).createElement(d), g[jt] = o, g[ci] = s, Ba(g, d, s), Pe(g), o.stateNode = g) : o.memoizedState = JS(o.type, s.memoizedProps, o.pendingProps, s.memoizedState), null;
            case 27:
                return Ue(o), s === null && bn && (g = o.stateNode = ZS(o.type, o.pendingProps, ue.current), Zi = o, Qi = !0, E = Kn, ru(o.type) ? (h1 = E, Kn = Gs(g.firstChild)) : Kn = E), _i(s, o, o.pendingProps.children, d), ds(s, o), s === null && (o.flags |= 4194304), o.child;
            case 5:
                return s === null && bn && ((E = g = Kn) && (g = Hw(g, o.type, o.pendingProps, Qi), g !== null ? (o.stateNode = g, Zi = o, Kn = Gs(g.firstChild), Qi = !1, E = !0) : E = !1), E || vn(o)), Ue(o), E = o.type, w = o.pendingProps, V = s !== null ? s.memoizedProps : null, g = w.children, o1(E, w) ? g = null : V !== null && o1(E, V) && (o.flags |= 32), o.memoizedState !== null && (E = Op(s, o, ky, null, null, d), hm._currentValue = E), ds(s, o), _i(s, o, g, d), o.child;
            case 6:
                return s === null && bn && ((s = d = Kn) && (d = Vw(d, o.pendingProps, Qi), d !== null ? (o.stateNode = d, Zi = o, Kn = null, s = !0) : s = !1), s || vn(o)), null;
            case 13:
                return yr(s, o, d);
            case 4:
                return xe(o, o.stateNode.containerInfo), g = o.pendingProps, s === null ? o.child = Wl(o, null, g, d) : _i(s, o, g, d), o.child;
            case 11:
                return sf(s, o, o.type, o.pendingProps, d);
            case 7:
                return _i(s, o, o.pendingProps, d), o.child;
            case 8:
                return _i(s, o, o.pendingProps.children, d), o.child;
            case 12:
                return _i(s, o, o.pendingProps.children, d), o.child;
            case 10:
                return g = o.pendingProps, oo(o, o.type, g.value), _i(s, o, g.children, d), o.child;
            case 9:
                return E = o.type._context, g = o.pendingProps.children, kl(o), E = Ki(E), g = g(E), o.flags |= 1, _i(s, o, g, d), o.child;
            case 14:
                return of(s, o, o.type, o.pendingProps, d);
            case 15:
                return gr(s, o, o.type, o.pendingProps, d);
            case 19:
                return ff(s, o, d);
            case 31:
                return lf(s, o, d);
            case 22:
                return xr(s, o, d, o.pendingProps);
            case 24:
                return kl(o), g = Ki(Bt), s === null ? (E = Ns(), E === null && (E = In, w = _p(), E.pooledCache = w, w.refCount++, w !== null && (E.pooledCacheLanes |= d), E = w), o.memoizedState = {
                    parent: g,
                    cache: E
                }, Ap(o), oo(o, Bt, E)) : ((s.lanes & d) !== 0 && (wp(s, o), ql(o, null, null, d), Qu()), E = s.memoizedState, w = o.memoizedState, E.parent !== g ? (E = {
                    parent: g,
                    cache: g
                }, o.memoizedState = E, o.lanes === 0 && (o.memoizedState = o.updateQueue.baseState = E), oo(o, Bt, g)) : (g = w.cache, oo(o, Bt, g), g !== E.cache && xh(o, [
                    Bt
                ], d, !0))), _i(s, o, o.pendingProps.children, d), o.child;
            case 29:
                throw o.pendingProps;
        }
        throw Error(n(156, o.tag));
    }
    function qa(s) {
        s.flags |= 4;
    }
    function sl(s, o, d, g, E) {
        if ((o = (s.mode & 32) !== 0) && (o = !1), o) {
            if (s.flags |= 16777216, (E & 335544128) === E) {
                if (s.stateNode.complete) s.flags |= 8192;
                else if (mt()) s.flags |= 8192;
                else throw Vt = qu, Wu;
            }
        } else s.flags &= -16777217;
    }
    function mo(s, o) {
        if (o.type !== "stylesheet" || (o.state.loading & 4) !== 0) s.flags &= -16777217;
        else if (s.flags |= 16777216, !i2(o)) {
            if (mt()) s.flags |= 8192;
            else throw Vt = qu, Wu;
        }
    }
    function $c(s, o) {
        o !== null && (s.flags |= 4), s.flags & 16384 && (o = s.tag !== 22 ? yt() : 536870912, s.lanes |= o, Mr |= o);
    }
    function df(s, o) {
        if (!bn) switch(s.tailMode){
            case "hidden":
                o = s.tail;
                for(var d = null; o !== null;)o.alternate !== null && (d = o), o = o.sibling;
                d === null ? s.tail = null : d.sibling = null;
                break;
            case "collapsed":
                d = s.tail;
                for(var g = null; d !== null;)d.alternate !== null && (g = d), d = d.sibling;
                g === null ? o || s.tail === null ? s.tail = null : s.tail.sibling = null : g.sibling = null;
        }
    }
    function kn(s) {
        var o = s.alternate !== null && s.alternate.child === s.child, d = 0, g = 0;
        if (o) for(var E = s.child; E !== null;)d |= E.lanes | E.childLanes, g |= E.subtreeFlags & 65011712, g |= E.flags & 65011712, E.return = s, E = E.sibling;
        else for(E = s.child; E !== null;)d |= E.lanes | E.childLanes, g |= E.subtreeFlags, g |= E.flags, E.return = s, E = E.sibling;
        return s.subtreeFlags |= g, s.childLanes = d, o;
    }
    function im(s, o, d) {
        var g = o.pendingProps;
        switch(Zo(o), o.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return kn(o), null;
            case 1:
                return kn(o), null;
            case 3:
                return d = o.stateNode, g = null, s !== null && (g = s.memoizedState.cache), o.memoizedState.cache !== g && (o.flags |= 2048), Ir(Bt), Le(), d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null), (s === null || s.child === null) && (Vl(o) ? qa(o) : s === null || s.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, gp())), kn(o), null;
            case 26:
                var E = o.type, w = o.memoizedState;
                return s === null ? (qa(o), w !== null ? (kn(o), mo(o, w)) : (kn(o), sl(o, E, null, g, d))) : w ? w !== s.memoizedState ? (qa(o), kn(o), mo(o, w)) : (kn(o), o.flags &= -16777217) : (s = s.memoizedProps, s !== g && qa(o), kn(o), sl(o, E, s, g, d)), null;
            case 27:
                if (Ne(o), d = ue.current, E = o.type, s !== null && o.stateNode != null) s.memoizedProps !== g && qa(o);
                else {
                    if (!g) {
                        if (o.stateNode === null) throw Error(n(166));
                        return kn(o), null;
                    }
                    s = ce.current, Vl(o) ? gh(o) : (s = ZS(E, g, d), o.stateNode = s, qa(o));
                }
                return kn(o), null;
            case 5:
                if (Ne(o), E = o.type, s !== null && o.stateNode != null) s.memoizedProps !== g && qa(o);
                else {
                    if (!g) {
                        if (o.stateNode === null) throw Error(n(166));
                        return kn(o), null;
                    }
                    if (w = ce.current, Vl(o)) gh(o);
                    else {
                        var V = Ug(ue.current);
                        switch(w){
                            case 1:
                                w = V.createElementNS("http://www.w3.org/2000/svg", E);
                                break;
                            case 2:
                                w = V.createElementNS("http://www.w3.org/1998/Math/MathML", E);
                                break;
                            default:
                                switch(E){
                                    case "svg":
                                        w = V.createElementNS("http://www.w3.org/2000/svg", E);
                                        break;
                                    case "math":
                                        w = V.createElementNS("http://www.w3.org/1998/Math/MathML", E);
                                        break;
                                    case "script":
                                        w = V.createElement("div"), w.innerHTML = "<script><\/script>", w = w.removeChild(w.firstChild);
                                        break;
                                    case "select":
                                        w = typeof g.is == "string" ? V.createElement("select", {
                                            is: g.is
                                        }) : V.createElement("select"), g.multiple ? w.multiple = !0 : g.size && (w.size = g.size);
                                        break;
                                    default:
                                        w = typeof g.is == "string" ? V.createElement(E, {
                                            is: g.is
                                        }) : V.createElement(E);
                                }
                        }
                        w[jt] = o, w[ci] = g;
                        e: for(V = o.child; V !== null;){
                            if (V.tag === 5 || V.tag === 6) w.appendChild(V.stateNode);
                            else if (V.tag !== 4 && V.tag !== 27 && V.child !== null) {
                                V.child.return = V, V = V.child;
                                continue;
                            }
                            if (V === o) break e;
                            for(; V.sibling === null;){
                                if (V.return === null || V.return === o) break e;
                                V = V.return;
                            }
                            V.sibling.return = V.return, V = V.sibling;
                        }
                        o.stateNode = w;
                        e: switch(Ba(w, E, g), E){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                g = !!g.autoFocus;
                                break e;
                            case "img":
                                g = !0;
                                break e;
                            default:
                                g = !1;
                        }
                        g && qa(o);
                    }
                }
                return kn(o), sl(o, o.type, s === null ? null : s.memoizedProps, o.pendingProps, d), null;
            case 6:
                if (s && o.stateNode != null) s.memoizedProps !== g && qa(o);
                else {
                    if (typeof g != "string" && o.stateNode === null) throw Error(n(166));
                    if (s = ue.current, Vl(o)) {
                        if (s = o.stateNode, d = o.memoizedProps, g = null, E = Zi, E !== null) switch(E.tag){
                            case 27:
                            case 5:
                                g = E.memoizedProps;
                        }
                        s[jt] = o, s = !!(s.nodeValue === d || g !== null && g.suppressHydrationWarning === !0 || IS(s.nodeValue, d)), s || vn(o, !0);
                    } else s = Ug(s).createTextNode(g), s[jt] = o, o.stateNode = s;
                }
                return kn(o), null;
            case 31:
                if (d = o.memoizedState, s === null || s.memoizedState !== null) {
                    if (g = Vl(o), d !== null) {
                        if (s === null) {
                            if (!g) throw Error(n(318));
                            if (s = o.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error(n(557));
                            s[jt] = o;
                        } else Gl(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
                        kn(o), s = !1;
                    } else d = gp(), s !== null && s.memoizedState !== null && (s.memoizedState.hydrationErrors = d), s = !0;
                    if (!s) return o.flags & 256 ? (dr(o), o) : (dr(o), null);
                    if ((o.flags & 128) !== 0) throw Error(n(558));
                }
                return kn(o), null;
            case 13:
                if (g = o.memoizedState, s === null || s.memoizedState !== null && s.memoizedState.dehydrated !== null) {
                    if (E = Vl(o), g !== null && g.dehydrated !== null) {
                        if (s === null) {
                            if (!E) throw Error(n(318));
                            if (E = o.memoizedState, E = E !== null ? E.dehydrated : null, !E) throw Error(n(317));
                            E[jt] = o;
                        } else Gl(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
                        kn(o), E = !1;
                    } else E = gp(), s !== null && s.memoizedState !== null && (s.memoizedState.hydrationErrors = E), E = !0;
                    if (!E) return o.flags & 256 ? (dr(o), o) : (dr(o), null);
                }
                return dr(o), (o.flags & 128) !== 0 ? (o.lanes = d, o) : (d = g !== null, s = s !== null && s.memoizedState !== null, d && (g = o.child, E = null, g.alternate !== null && g.alternate.memoizedState !== null && g.alternate.memoizedState.cachePool !== null && (E = g.alternate.memoizedState.cachePool.pool), w = null, g.memoizedState !== null && g.memoizedState.cachePool !== null && (w = g.memoizedState.cachePool.pool), w !== E && (g.flags |= 2048)), d !== s && d && (o.child.flags |= 8192), $c(o, o.updateQueue), kn(o), null);
            case 4:
                return Le(), s === null && n1(o.stateNode.containerInfo), kn(o), null;
            case 10:
                return Ir(o.type), kn(o), null;
            case 19:
                if (Z(vi), g = o.memoizedState, g === null) return kn(o), null;
                if (E = (o.flags & 128) !== 0, w = g.rendering, w === null) {
                    if (E) df(g, !1);
                    else {
                        if (Fn !== 0 || s !== null && (s.flags & 128) !== 0) for(s = o.child; s !== null;){
                            if (w = Sh(s), w !== null) {
                                for(o.flags |= 128, df(g, !1), s = w.updateQueue, o.updateQueue = s, $c(o, s), o.subtreeFlags = 0, s = d, d = o.child; d !== null;)ga(d, s), d = d.sibling;
                                return oe(vi, vi.current & 1 | 2), bn && ao(o, g.treeForkCount), o.child;
                            }
                            s = s.sibling;
                        }
                        g.tail !== null && W() > Er && (o.flags |= 128, E = !0, df(g, !1), o.lanes = 4194304);
                    }
                } else {
                    if (!E) {
                        if (s = Sh(w), s !== null) {
                            if (o.flags |= 128, E = !0, s = s.updateQueue, o.updateQueue = s, $c(o, s), df(g, !0), g.tail === null && g.tailMode === "hidden" && !w.alternate && !bn) return kn(o), null;
                        } else 2 * W() - g.renderingStartTime > Er && d !== 536870912 && (o.flags |= 128, E = !0, df(g, !1), o.lanes = 4194304);
                    }
                    g.isBackwards ? (w.sibling = o.child, o.child = w) : (s = g.last, s !== null ? s.sibling = w : o.child = w, g.last = w);
                }
                return g.tail !== null ? (s = g.tail, g.rendering = s, g.tail = s.sibling, g.renderingStartTime = W(), s.sibling = null, d = vi.current, oe(vi, E ? d & 1 | 2 : d & 1), bn && ao(o, g.treeForkCount), s) : (kn(o), null);
            case 22:
            case 23:
                return dr(o), va(), g = o.memoizedState !== null, s !== null ? s.memoizedState !== null !== g && (o.flags |= 8192) : g && (o.flags |= 8192), g ? (d & 536870912) !== 0 && (o.flags & 128) === 0 && (kn(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : kn(o), d = o.updateQueue, d !== null && $c(o, d.retryQueue), d = null, s !== null && s.memoizedState !== null && s.memoizedState.cachePool !== null && (d = s.memoizedState.cachePool.pool), g = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (g = o.memoizedState.cachePool.pool), g !== d && (o.flags |= 2048), s !== null && Z(Ko), null;
            case 24:
                return d = null, s !== null && (d = s.memoizedState.cache), o.memoizedState.cache !== d && (o.flags |= 2048), Ir(Bt), kn(o), null;
            case 25:
                return null;
            case 30:
                return null;
        }
        throw Error(n(156, o.tag));
    }
    function Ih(s, o) {
        switch(Zo(o), o.tag){
            case 1:
                return s = o.flags, s & 65536 ? (o.flags = s & -65537 | 128, o) : null;
            case 3:
                return Ir(Bt), Le(), s = o.flags, (s & 65536) !== 0 && (s & 128) === 0 ? (o.flags = s & -65537 | 128, o) : null;
            case 26:
            case 27:
            case 5:
                return Ne(o), null;
            case 31:
                if (o.memoizedState !== null) {
                    if (dr(o), o.alternate === null) throw Error(n(340));
                    Gl();
                }
                return s = o.flags, s & 65536 ? (o.flags = s & -65537 | 128, o) : null;
            case 13:
                if (dr(o), s = o.memoizedState, s !== null && s.dehydrated !== null) {
                    if (o.alternate === null) throw Error(n(340));
                    Gl();
                }
                return s = o.flags, s & 65536 ? (o.flags = s & -65537 | 128, o) : null;
            case 19:
                return Z(vi), null;
            case 4:
                return Le(), null;
            case 10:
                return Ir(o.type), null;
            case 22:
            case 23:
                return dr(o), va(), s !== null && Z(Ko), s = o.flags, s & 65536 ? (o.flags = s & -65537 | 128, o) : null;
            case 24:
                return Ir(Bt), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function Kl(s, o) {
        switch(Zo(o), o.tag){
            case 3:
                Ir(Bt), Le();
                break;
            case 26:
            case 27:
            case 5:
                Ne(o);
                break;
            case 4:
                Le();
                break;
            case 31:
                o.memoizedState !== null && dr(o);
                break;
            case 13:
                dr(o);
                break;
            case 19:
                Z(vi);
                break;
            case 10:
                Ir(o.type);
                break;
            case 22:
            case 23:
                dr(o), va(), s !== null && Z(Ko);
                break;
            case 24:
                Ir(Bt);
        }
    }
    function Is(s, o) {
        try {
            var d = o.updateQueue, g = d !== null ? d.lastEffect : null;
            if (g !== null) {
                var E = g.next;
                d = E;
                do {
                    if ((d.tag & s) === s) {
                        g = void 0;
                        var w = d.create, V = d.inst;
                        g = w(), V.destroy = g;
                    }
                    d = d.next;
                }while (d !== E);
            }
        } catch (re) {
            Yn(o, o.return, re);
        }
    }
    function Gr(s, o, d) {
        try {
            var g = o.updateQueue, E = g !== null ? g.lastEffect : null;
            if (E !== null) {
                var w = E.next;
                g = w;
                do {
                    if ((g.tag & s) === s) {
                        var V = g.inst, re = V.destroy;
                        if (re !== void 0) {
                            V.destroy = void 0, E = o;
                            var ge = d, He = re;
                            try {
                                He();
                            } catch (et) {
                                Yn(E, ge, et);
                            }
                        }
                    }
                    g = g.next;
                }while (g !== w);
            }
        } catch (et) {
            Yn(o, o.return, et);
        }
    }
    function ol(s) {
        var o = s.updateQueue;
        if (o !== null) {
            var d = s.stateNode;
            try {
                ra(o, d);
            } catch (g) {
                Yn(s, s.return, g);
            }
        }
    }
    function am(s, o, d) {
        d.props = oa(s.type, s.memoizedProps), d.state = s.memoizedState;
        try {
            d.componentWillUnmount();
        } catch (g) {
            Yn(s, o, g);
        }
    }
    function Fs(s, o) {
        try {
            var d = s.ref;
            if (d !== null) {
                switch(s.tag){
                    case 26:
                    case 27:
                    case 5:
                        var g = s.stateNode;
                        break;
                    case 30:
                        g = s.stateNode;
                        break;
                    default:
                        g = s.stateNode;
                }
                typeof d == "function" ? s.refCleanup = d(g) : d.current = g;
            }
        } catch (E) {
            Yn(s, o, E);
        }
    }
    function _r(s, o) {
        var d = s.ref, g = s.refCleanup;
        if (d !== null) {
            if (typeof g == "function") try {
                g();
            } catch (E) {
                Yn(s, o, E);
            } finally{
                s.refCleanup = null, s = s.alternate, s != null && (s.refCleanup = null);
            }
            else if (typeof d == "function") try {
                d(null);
            } catch (E) {
                Yn(s, o, E);
            }
            else d.current = null;
        }
    }
    function br(s) {
        var o = s.type, d = s.memoizedProps, g = s.stateNode;
        try {
            e: switch(o){
                case "button":
                case "input":
                case "select":
                case "textarea":
                    d.autoFocus && g.focus();
                    break e;
                case "img":
                    d.src ? g.src = d.src : d.srcSet && (g.srcset = d.srcSet);
            }
        } catch (E) {
            Yn(s, s.return, E);
        }
    }
    function kr(s, o, d) {
        try {
            var g = s.stateNode;
            Lw(g, s.type, d, o), g[ci] = o;
        } catch (E) {
            Yn(s, s.return, E);
        }
    }
    function Fi(s) {
        return s.tag === 5 || s.tag === 3 || s.tag === 26 || s.tag === 27 && ru(s.type) || s.tag === 4;
    }
    function Hs(s) {
        e: for(;;){
            for(; s.sibling === null;){
                if (s.return === null || Fi(s.return)) return null;
                s = s.return;
            }
            for(s.sibling.return = s.return, s = s.sibling; s.tag !== 5 && s.tag !== 6 && s.tag !== 18;){
                if (s.tag === 27 && ru(s.type) || s.flags & 2 || s.child === null || s.tag === 4) continue e;
                s.child.return = s, s = s.child;
            }
            if (!(s.flags & 2)) return s.stateNode;
        }
    }
    function en(s, o, d) {
        var g = s.tag;
        if (g === 5 || g === 6) s = s.stateNode, o ? (d.nodeType === 9 ? d.body : d.nodeName === "HTML" ? d.ownerDocument.body : d).insertBefore(s, o) : (o = d.nodeType === 9 ? d.body : d.nodeName === "HTML" ? d.ownerDocument.body : d, o.appendChild(s), d = d._reactRootContainer, d != null || o.onclick !== null || (o.onclick = ta));
        else if (g !== 4 && (g === 27 && ru(s.type) && (d = s.stateNode, o = null), s = s.child, s !== null)) for(en(s, o, d), s = s.sibling; s !== null;)en(s, o, d), s = s.sibling;
    }
    function Ln(s, o, d) {
        var g = s.tag;
        if (g === 5 || g === 6) s = s.stateNode, o ? d.insertBefore(s, o) : d.appendChild(s);
        else if (g !== 4 && (g === 27 && ru(s.type) && (d = s.stateNode), s = s.child, s !== null)) for(Ln(s, o, d), s = s.sibling; s !== null;)Ln(s, o, d), s = s.sibling;
    }
    function Ai(s) {
        var o = s.stateNode, d = s.memoizedProps;
        try {
            for(var g = s.type, E = o.attributes; E.length;)o.removeAttributeNode(E[0]);
            Ba(o, g, d), o[jt] = s, o[ci] = d;
        } catch (w) {
            Yn(s, s.return, w);
        }
    }
    var jr = !1, li = !1, go = !1, pf = typeof WeakSet == "function" ? WeakSet : Set, bi = null;
    function eu(s, o) {
        if (s = s.containerInfo, r1 = Ig, s = sh(s), Oc(s)) {
            if ("selectionStart" in s) var d = {
                start: s.selectionStart,
                end: s.selectionEnd
            };
            else e: {
                d = (d = s.ownerDocument) && d.defaultView || window;
                var g = d.getSelection && d.getSelection();
                if (g && g.rangeCount !== 0) {
                    d = g.anchorNode;
                    var E = g.anchorOffset, w = g.focusNode;
                    g = g.focusOffset;
                    try {
                        d.nodeType, w.nodeType;
                    } catch  {
                        d = null;
                        break e;
                    }
                    var V = 0, re = -1, ge = -1, He = 0, et = 0, ct = s, Xe = null;
                    t: for(;;){
                        for(var Qe; ct !== d || E !== 0 && ct.nodeType !== 3 || (re = V + E), ct !== w || g !== 0 && ct.nodeType !== 3 || (ge = V + g), ct.nodeType === 3 && (V += ct.nodeValue.length), (Qe = ct.firstChild) !== null;)Xe = ct, ct = Qe;
                        for(;;){
                            if (ct === s) break t;
                            if (Xe === d && ++He === E && (re = V), Xe === w && ++et === g && (ge = V), (Qe = ct.nextSibling) !== null) break;
                            ct = Xe, Xe = ct.parentNode;
                        }
                        ct = Qe;
                    }
                    d = re === -1 || ge === -1 ? null : {
                        start: re,
                        end: ge
                    };
                } else d = null;
            }
            d = d || {
                start: 0,
                end: 0
            };
        } else d = null;
        for(s1 = {
            focusedElem: s,
            selectionRange: d
        }, Ig = !1, bi = o; bi !== null;)if (o = bi, s = o.child, (o.subtreeFlags & 1028) !== 0 && s !== null) s.return = o, bi = s;
        else for(; bi !== null;){
            switch(o = bi, w = o.alternate, s = o.flags, o.tag){
                case 0:
                    if ((s & 4) !== 0 && (s = o.updateQueue, s = s !== null ? s.events : null, s !== null)) for(d = 0; d < s.length; d++)E = s[d], E.ref.impl = E.nextImpl;
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    if ((s & 1024) !== 0 && w !== null) {
                        s = void 0, d = o, E = w.memoizedProps, w = w.memoizedState, g = d.stateNode;
                        try {
                            var Rt = oa(d.type, E);
                            s = g.getSnapshotBeforeUpdate(Rt, w), g.__reactInternalSnapshotBeforeUpdate = s;
                        } catch (kt) {
                            Yn(d, d.return, kt);
                        }
                    }
                    break;
                case 3:
                    if ((s & 1024) !== 0) {
                        if (s = o.stateNode.containerInfo, d = s.nodeType, d === 9) c1(s);
                        else if (d === 1) switch(s.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                c1(s);
                                break;
                            default:
                                s.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if ((s & 1024) !== 0) throw Error(n(163));
            }
            if (s = o.sibling, s !== null) {
                s.return = o.return, bi = s;
                break;
            }
            bi = o.return;
        }
    }
    function Eg(s, o, d) {
        var g = d.flags;
        switch(d.tag){
            case 0:
            case 11:
            case 15:
                xo(s, d), g & 4 && Is(5, d);
                break;
            case 1:
                if (xo(s, d), g & 4) {
                    if (s = d.stateNode, o === null) try {
                        s.componentDidMount();
                    } catch (V) {
                        Yn(d, d.return, V);
                    }
                    else {
                        var E = oa(d.type, o.memoizedProps);
                        o = o.memoizedState;
                        try {
                            s.componentDidUpdate(E, o, s.__reactInternalSnapshotBeforeUpdate);
                        } catch (V) {
                            Yn(d, d.return, V);
                        }
                    }
                }
                g & 64 && ol(d), g & 512 && Fs(d, d.return);
                break;
            case 3:
                if (xo(s, d), g & 64 && (s = d.updateQueue, s !== null)) {
                    if (o = null, d.child !== null) switch(d.child.tag){
                        case 27:
                        case 5:
                            o = d.child.stateNode;
                            break;
                        case 1:
                            o = d.child.stateNode;
                    }
                    try {
                        ra(s, o);
                    } catch (V) {
                        Yn(d, d.return, V);
                    }
                }
                break;
            case 27:
                o === null && g & 4 && Ai(d);
            case 26:
            case 5:
                xo(s, d), o === null && g & 4 && br(d), g & 512 && Fs(d, d.return);
                break;
            case 12:
                xo(s, d);
                break;
            case 31:
                xo(s, d), g & 4 && Hh(s, d);
                break;
            case 13:
                xo(s, d), g & 4 && rm(s, d), g & 64 && (s = d.memoizedState, s !== null && (s = s.dehydrated, s !== null && (d = Sw.bind(null, d), Gw(s, d))));
                break;
            case 22:
                if (g = d.memoizedState !== null || jr, !g) {
                    o = o !== null && o.memoizedState !== null || li, E = jr;
                    var w = li;
                    jr = g, (li = o) && !w ? Bn(s, d, (d.subtreeFlags & 8772) !== 0) : xo(s, d), jr = E, li = w;
                }
                break;
            case 30:
                break;
            default:
                xo(s, d);
        }
    }
    function Fh(s) {
        var o = s.alternate;
        o !== null && (s.alternate = null, Fh(o)), s.child = null, s.deletions = null, s.sibling = null, s.tag === 5 && (o = s.stateNode, o !== null && Ms(o)), s.stateNode = null, s.return = null, s.dependencies = null, s.memoizedProps = null, s.memoizedState = null, s.pendingProps = null, s.stateNode = null, s.updateQueue = null;
    }
    var wn = null, Hi = !1;
    function _a(s, o, d) {
        for(d = d.child; d !== null;)ll(s, o, d), d = d.sibling;
    }
    function ll(s, o, d) {
        if (Ye && typeof Ye.onCommitFiberUnmount == "function") try {
            Ye.onCommitFiberUnmount(Ge, d);
        } catch  {}
        switch(d.tag){
            case 26:
                li || _r(d, o), _a(s, o, d), d.memoizedState ? d.memoizedState.count-- : d.stateNode && (d = d.stateNode, d.parentNode.removeChild(d));
                break;
            case 27:
                li || _r(d, o);
                var g = wn, E = Hi;
                ru(d.type) && (wn = d.stateNode, Hi = !1), _a(s, o, d), cm(d.stateNode), wn = g, Hi = E;
                break;
            case 5:
                li || _r(d, o);
            case 6:
                if (g = wn, E = Hi, wn = null, _a(s, o, d), wn = g, Hi = E, wn !== null) {
                    if (Hi) try {
                        (wn.nodeType === 9 ? wn.body : wn.nodeName === "HTML" ? wn.ownerDocument.body : wn).removeChild(d.stateNode);
                    } catch (w) {
                        Yn(d, o, w);
                    }
                    else try {
                        wn.removeChild(d.stateNode);
                    } catch (w) {
                        Yn(d, o, w);
                    }
                }
                break;
            case 18:
                wn !== null && (Hi ? (s = wn, jS(s.nodeType === 9 ? s.body : s.nodeName === "HTML" ? s.ownerDocument.body : s, d.stateNode), Kh(s)) : jS(wn, d.stateNode));
                break;
            case 4:
                g = wn, E = Hi, wn = d.stateNode.containerInfo, Hi = !0, _a(s, o, d), wn = g, Hi = E;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                Gr(2, d, o), li || Gr(4, d, o), _a(s, o, d);
                break;
            case 1:
                li || (_r(d, o), g = d.stateNode, typeof g.componentWillUnmount == "function" && am(d, o, g)), _a(s, o, d);
                break;
            case 21:
                _a(s, o, d);
                break;
            case 22:
                li = (g = li) || d.memoizedState !== null, _a(s, o, d), li = g;
                break;
            default:
                _a(s, o, d);
        }
    }
    function Hh(s, o) {
        if (o.memoizedState === null && (s = o.alternate, s !== null && (s = s.memoizedState, s !== null))) {
            s = s.dehydrated;
            try {
                Kh(s);
            } catch (d) {
                Yn(o, o.return, d);
            }
        }
    }
    function rm(s, o) {
        if (o.memoizedState === null && (s = o.alternate, s !== null && (s = s.memoizedState, s !== null && (s = s.dehydrated, s !== null)))) try {
            Kh(s);
        } catch (d) {
            Yn(o, o.return, d);
        }
    }
    function Tg(s) {
        switch(s.tag){
            case 31:
            case 13:
            case 19:
                var o = s.stateNode;
                return o === null && (o = s.stateNode = new pf), o;
            case 22:
                return s = s.stateNode, o = s._retryCache, o === null && (o = s._retryCache = new pf), o;
            default:
                throw Error(n(435, s.tag));
        }
    }
    function wi(s, o) {
        var d = Tg(s);
        o.forEach(function(g) {
            if (!d.has(g)) {
                d.add(g);
                var E = Mw.bind(null, s, g);
                g.then(E, E);
            }
        });
    }
    function ba(s, o) {
        var d = o.deletions;
        if (d !== null) for(var g = 0; g < d.length; g++){
            var E = d[g], w = s, V = o, re = V;
            e: for(; re !== null;){
                switch(re.tag){
                    case 27:
                        if (ru(re.type)) {
                            wn = re.stateNode, Hi = !1;
                            break e;
                        }
                        break;
                    case 5:
                        wn = re.stateNode, Hi = !1;
                        break e;
                    case 3:
                    case 4:
                        wn = re.stateNode.containerInfo, Hi = !0;
                        break e;
                }
                re = re.return;
            }
            if (wn === null) throw Error(n(160));
            ll(w, V, E), wn = null, Hi = !1, w = E.alternate, w !== null && (w.return = null), E.return = null;
        }
        if (o.subtreeFlags & 13886) for(o = o.child; o !== null;)cl(o, s), o = o.sibling;
    }
    var Ya = null;
    function cl(s, o) {
        var d = s.alternate, g = s.flags;
        switch(s.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                ba(o, s), Si(s), g & 4 && (Gr(3, s, s.return), Is(3, s), Gr(5, s, s.return));
                break;
            case 1:
                ba(o, s), Si(s), g & 512 && (li || d === null || _r(d, d.return)), g & 64 && jr && (s = s.updateQueue, s !== null && (g = s.callbacks, g !== null && (d = s.shared.hiddenCallbacks, s.shared.hiddenCallbacks = d === null ? g : d.concat(g))));
                break;
            case 26:
                var E = Ya;
                if (ba(o, s), Si(s), g & 512 && (li || d === null || _r(d, d.return)), g & 4) {
                    var w = d !== null ? d.memoizedState : null;
                    if (g = s.memoizedState, d === null) {
                        if (g === null) {
                            if (s.stateNode === null) {
                                e: {
                                    g = s.type, d = s.memoizedProps, E = E.ownerDocument || E;
                                    t: switch(g){
                                        case "title":
                                            w = E.getElementsByTagName("title")[0], (!w || w[es] || w[jt] || w.namespaceURI === "http://www.w3.org/2000/svg" || w.hasAttribute("itemprop")) && (w = E.createElement(g), E.head.insertBefore(w, E.querySelector("head > title"))), Ba(w, g, d), w[jt] = s, Pe(w), g = w;
                                            break e;
                                        case "link":
                                            var V = t2("link", "href", E).get(g + (d.href || ""));
                                            if (V) {
                                                for(var re = 0; re < V.length; re++)if (w = V[re], w.getAttribute("href") === (d.href == null || d.href === "" ? null : d.href) && w.getAttribute("rel") === (d.rel == null ? null : d.rel) && w.getAttribute("title") === (d.title == null ? null : d.title) && w.getAttribute("crossorigin") === (d.crossOrigin == null ? null : d.crossOrigin)) {
                                                    V.splice(re, 1);
                                                    break t;
                                                }
                                            }
                                            w = E.createElement(g), Ba(w, g, d), E.head.appendChild(w);
                                            break;
                                        case "meta":
                                            if (V = t2("meta", "content", E).get(g + (d.content || ""))) {
                                                for(re = 0; re < V.length; re++)if (w = V[re], w.getAttribute("content") === (d.content == null ? null : "" + d.content) && w.getAttribute("name") === (d.name == null ? null : d.name) && w.getAttribute("property") === (d.property == null ? null : d.property) && w.getAttribute("http-equiv") === (d.httpEquiv == null ? null : d.httpEquiv) && w.getAttribute("charset") === (d.charSet == null ? null : d.charSet)) {
                                                    V.splice(re, 1);
                                                    break t;
                                                }
                                            }
                                            w = E.createElement(g), Ba(w, g, d), E.head.appendChild(w);
                                            break;
                                        default:
                                            throw Error(n(468, g));
                                    }
                                    w[jt] = s, Pe(w), g = w;
                                }
                                s.stateNode = g;
                            } else n2(E, s.type, s.stateNode);
                        } else s.stateNode = e2(E, g, s.memoizedProps);
                    } else w !== g ? (w === null ? d.stateNode !== null && (d = d.stateNode, d.parentNode.removeChild(d)) : w.count--, g === null ? n2(E, s.type, s.stateNode) : e2(E, g, s.memoizedProps)) : g === null && s.stateNode !== null && kr(s, s.memoizedProps, d.memoizedProps);
                }
                break;
            case 27:
                ba(o, s), Si(s), g & 512 && (li || d === null || _r(d, d.return)), d !== null && g & 4 && kr(s, s.memoizedProps, d.memoizedProps);
                break;
            case 5:
                if (ba(o, s), Si(s), g & 512 && (li || d === null || _r(d, d.return)), s.flags & 32) {
                    E = s.stateNode;
                    try {
                        wa(E, "");
                    } catch (Rt) {
                        Yn(s, s.return, Rt);
                    }
                }
                g & 4 && s.stateNode != null && (E = s.memoizedProps, kr(s, E, d !== null ? d.memoizedProps : E)), g & 1024 && (go = !0);
                break;
            case 6:
                if (ba(o, s), Si(s), g & 4) {
                    if (s.stateNode === null) throw Error(n(162));
                    g = s.memoizedProps, d = s.stateNode;
                    try {
                        d.nodeValue = g;
                    } catch (Rt) {
                        Yn(s, s.return, Rt);
                    }
                }
                break;
            case 3:
                if (Lg = null, E = Ya, Ya = Ng(o.containerInfo), ba(o, s), Ya = E, Si(s), g & 4 && d !== null && d.memoizedState.isDehydrated) try {
                    Kh(o.containerInfo);
                } catch (Rt) {
                    Yn(s, s.return, Rt);
                }
                go && (go = !1, Ag(s));
                break;
            case 4:
                g = Ya, Ya = Ng(s.stateNode.containerInfo), ba(o, s), Si(s), Ya = g;
                break;
            case 12:
                ba(o, s), Si(s);
                break;
            case 31:
                ba(o, s), Si(s), g & 4 && (g = s.updateQueue, g !== null && (s.updateQueue = null, wi(s, g)));
                break;
            case 13:
                ba(o, s), Si(s), s.child.flags & 8192 && s.memoizedState !== null != (d !== null && d.memoizedState !== null) && (_o = W()), g & 4 && (g = s.updateQueue, g !== null && (s.updateQueue = null, wi(s, g)));
                break;
            case 22:
                E = s.memoizedState !== null;
                var ge = d !== null && d.memoizedState !== null, He = jr, et = li;
                if (jr = He || E, li = et || ge, ba(o, s), li = et, jr = He, Si(s), g & 8192) e: for(o = s.stateNode, o._visibility = E ? o._visibility & -2 : o._visibility | 1, E && (d === null || ge || jr || li || Jl(s)), d = null, o = s;;){
                    if (o.tag === 5 || o.tag === 26) {
                        if (d === null) {
                            ge = d = o;
                            try {
                                if (w = ge.stateNode, E) V = w.style, typeof V.setProperty == "function" ? V.setProperty("display", "none", "important") : V.display = "none";
                                else {
                                    re = ge.stateNode;
                                    var ct = ge.memoizedProps.style, Xe = ct != null && ct.hasOwnProperty("display") ? ct.display : null;
                                    re.style.display = Xe == null || typeof Xe == "boolean" ? "" : ("" + Xe).trim();
                                }
                            } catch (Rt) {
                                Yn(ge, ge.return, Rt);
                            }
                        }
                    } else if (o.tag === 6) {
                        if (d === null) {
                            ge = o;
                            try {
                                ge.stateNode.nodeValue = E ? "" : ge.memoizedProps;
                            } catch (Rt) {
                                Yn(ge, ge.return, Rt);
                            }
                        }
                    } else if (o.tag === 18) {
                        if (d === null) {
                            ge = o;
                            try {
                                var Qe = ge.stateNode;
                                E ? XS(Qe, !0) : XS(ge.stateNode, !1);
                            } catch (Rt) {
                                Yn(ge, ge.return, Rt);
                            }
                        }
                    } else if ((o.tag !== 22 && o.tag !== 23 || o.memoizedState === null || o === s) && o.child !== null) {
                        o.child.return = o, o = o.child;
                        continue;
                    }
                    if (o === s) break e;
                    for(; o.sibling === null;){
                        if (o.return === null || o.return === s) break e;
                        d === o && (d = null), o = o.return;
                    }
                    d === o && (d = null), o.sibling.return = o.return, o = o.sibling;
                }
                g & 4 && (g = s.updateQueue, g !== null && (d = g.retryQueue, d !== null && (g.retryQueue = null, wi(s, d))));
                break;
            case 19:
                ba(o, s), Si(s), g & 4 && (g = s.updateQueue, g !== null && (s.updateQueue = null, wi(s, g)));
                break;
            case 30:
                break;
            case 21:
                break;
            default:
                ba(o, s), Si(s);
        }
    }
    function Si(s) {
        var o = s.flags;
        if (o & 2) {
            try {
                for(var d, g = s.return; g !== null;){
                    if (Fi(g)) {
                        d = g;
                        break;
                    }
                    g = g.return;
                }
                if (d == null) throw Error(n(160));
                switch(d.tag){
                    case 27:
                        var E = d.stateNode, w = Hs(s);
                        Ln(s, w, E);
                        break;
                    case 5:
                        var V = d.stateNode;
                        d.flags & 32 && (wa(V, ""), d.flags &= -33);
                        var re = Hs(s);
                        Ln(s, re, V);
                        break;
                    case 3:
                    case 4:
                        var ge = d.stateNode.containerInfo, He = Hs(s);
                        en(s, He, ge);
                        break;
                    default:
                        throw Error(n(161));
                }
            } catch (et) {
                Yn(s, s.return, et);
            }
            s.flags &= -3;
        }
        o & 4096 && (s.flags &= -4097);
    }
    function Ag(s) {
        if (s.subtreeFlags & 1024) for(s = s.child; s !== null;){
            var o = s;
            Ag(o), o.tag === 5 && o.flags & 1024 && o.stateNode.reset(), s = s.sibling;
        }
    }
    function xo(s, o) {
        if (o.subtreeFlags & 8772) for(o = o.child; o !== null;)Eg(s, o.alternate, o), o = o.sibling;
    }
    function Jl(s) {
        for(s = s.child; s !== null;){
            var o = s;
            switch(o.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Gr(4, o, o.return), Jl(o);
                    break;
                case 1:
                    _r(o, o.return);
                    var d = o.stateNode;
                    typeof d.componentWillUnmount == "function" && am(o, o.return, d), Jl(o);
                    break;
                case 27:
                    cm(o.stateNode);
                case 26:
                case 5:
                    _r(o, o.return), Jl(o);
                    break;
                case 22:
                    o.memoizedState === null && Jl(o);
                    break;
                case 30:
                    Jl(o);
                    break;
                default:
                    Jl(o);
            }
            s = s.sibling;
        }
    }
    function Bn(s, o, d) {
        for(d = d && (o.subtreeFlags & 8772) !== 0, o = o.child; o !== null;){
            var g = o.alternate, E = s, w = o, V = w.flags;
            switch(w.tag){
                case 0:
                case 11:
                case 15:
                    Bn(E, w, d), Is(4, w);
                    break;
                case 1:
                    if (Bn(E, w, d), g = w, E = g.stateNode, typeof E.componentDidMount == "function") try {
                        E.componentDidMount();
                    } catch (He) {
                        Yn(g, g.return, He);
                    }
                    if (g = w, E = g.updateQueue, E !== null) {
                        var re = g.stateNode;
                        try {
                            var ge = E.shared.hiddenCallbacks;
                            if (ge !== null) for(E.shared.hiddenCallbacks = null, E = 0; E < ge.length; E++)Ls(ge[E], re);
                        } catch (He) {
                            Yn(g, g.return, He);
                        }
                    }
                    d && V & 64 && ol(w), Fs(w, w.return);
                    break;
                case 27:
                    Ai(w);
                case 26:
                case 5:
                    Bn(E, w, d), d && g === null && V & 4 && br(w), Fs(w, w.return);
                    break;
                case 12:
                    Bn(E, w, d);
                    break;
                case 31:
                    Bn(E, w, d), d && V & 4 && Hh(E, w);
                    break;
                case 13:
                    Bn(E, w, d), d && V & 4 && rm(E, w);
                    break;
                case 22:
                    w.memoizedState === null && Bn(E, w, d), Fs(w, w.return);
                    break;
                case 30:
                    break;
                default:
                    Bn(E, w, d);
            }
            o = o.sibling;
        }
    }
    function Vh(s, o) {
        var d = null;
        s !== null && s.memoizedState !== null && s.memoizedState.cachePool !== null && (d = s.memoizedState.cachePool.pool), s = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (s = o.memoizedState.cachePool.pool), s !== d && (s != null && s.refCount++, d != null && aa(d));
    }
    function vo(s, o) {
        s = null, o.alternate !== null && (s = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== s && (o.refCount++, s != null && aa(s));
    }
    function Xi(s, o, d, g) {
        if (o.subtreeFlags & 10256) for(o = o.child; o !== null;)di(s, o, d, g), o = o.sibling;
    }
    function di(s, o, d, g) {
        var E = o.flags;
        switch(o.tag){
            case 0:
            case 11:
            case 15:
                Xi(s, o, d, g), E & 2048 && Is(9, o);
                break;
            case 1:
                Xi(s, o, d, g);
                break;
            case 3:
                Xi(s, o, d, g), E & 2048 && (s = null, o.alternate !== null && (s = o.alternate.memoizedState.cache), o = o.memoizedState.cache, o !== s && (o.refCount++, s != null && aa(s)));
                break;
            case 12:
                if (E & 2048) {
                    Xi(s, o, d, g), s = o.stateNode;
                    try {
                        var w = o.memoizedProps, V = w.id, re = w.onPostCommit;
                        typeof re == "function" && re(V, o.alternate === null ? "mount" : "update", s.passiveEffectDuration, -0);
                    } catch (ge) {
                        Yn(o, o.return, ge);
                    }
                } else Xi(s, o, d, g);
                break;
            case 31:
                Xi(s, o, d, g);
                break;
            case 13:
                Xi(s, o, d, g);
                break;
            case 23:
                break;
            case 22:
                w = o.stateNode, V = o.alternate, o.memoizedState !== null ? w._visibility & 2 ? Xi(s, o, d, g) : tu(s, o) : w._visibility & 2 ? Xi(s, o, d, g) : (w._visibility |= 2, ul(s, o, d, g, (o.subtreeFlags & 10256) !== 0 || !1)), E & 2048 && Vh(V, o);
                break;
            case 24:
                Xi(s, o, d, g), E & 2048 && vo(o.alternate, o);
                break;
            default:
                Xi(s, o, d, g);
        }
    }
    function ul(s, o, d, g, E) {
        for(E = E && ((o.subtreeFlags & 10256) !== 0 || !1), o = o.child; o !== null;){
            var w = s, V = o, re = d, ge = g, He = V.flags;
            switch(V.tag){
                case 0:
                case 11:
                case 15:
                    ul(w, V, re, ge, E), Is(8, V);
                    break;
                case 23:
                    break;
                case 22:
                    var et = V.stateNode;
                    V.memoizedState !== null ? et._visibility & 2 ? ul(w, V, re, ge, E) : tu(w, V) : (et._visibility |= 2, ul(w, V, re, ge, E)), E && He & 2048 && Vh(V.alternate, V);
                    break;
                case 24:
                    ul(w, V, re, ge, E), E && He & 2048 && vo(V.alternate, V);
                    break;
                default:
                    ul(w, V, re, ge, E);
            }
            o = o.sibling;
        }
    }
    function tu(s, o) {
        if (o.subtreeFlags & 10256) for(o = o.child; o !== null;){
            var d = s, g = o, E = g.flags;
            switch(g.tag){
                case 22:
                    tu(d, g), E & 2048 && Vh(g.alternate, g);
                    break;
                case 24:
                    tu(d, g), E & 2048 && vo(g.alternate, g);
                    break;
                default:
                    tu(d, g);
            }
            o = o.sibling;
        }
    }
    var Mi = 8192;
    function $l(s, o, d) {
        if (s.subtreeFlags & Mi) for(s = s.child; s !== null;)Ci(s, o, d), s = s.sibling;
    }
    function Ci(s, o, d) {
        switch(s.tag){
            case 26:
                $l(s, o, d), s.flags & Mi && s.memoizedState !== null && eC(d, Ya, s.memoizedState, s.memoizedProps);
                break;
            case 5:
                $l(s, o, d);
                break;
            case 3:
            case 4:
                var g = Ya;
                Ya = Ng(s.stateNode.containerInfo), $l(s, o, d), Ya = g;
                break;
            case 22:
                s.memoizedState === null && (g = s.alternate, g !== null && g.memoizedState !== null ? (g = Mi, Mi = 16777216, $l(s, o, d), Mi = g) : $l(s, o, d));
                break;
            default:
                $l(s, o, d);
        }
    }
    function Za(s) {
        var o = s.alternate;
        if (o !== null && (s = o.child, s !== null)) {
            o.child = null;
            do o = s.sibling, s.sibling = null, s = o;
            while (s !== null);
        }
    }
    function za(s) {
        var o = s.deletions;
        if ((s.flags & 16) !== 0) {
            if (o !== null) for(var d = 0; d < o.length; d++){
                var g = o[d];
                bi = g, mf(g, s);
            }
            Za(s);
        }
        if (s.subtreeFlags & 10256) for(s = s.child; s !== null;)ec(s), s = s.sibling;
    }
    function ec(s) {
        switch(s.tag){
            case 0:
            case 11:
            case 15:
                za(s), s.flags & 2048 && Gr(9, s, s.return);
                break;
            case 3:
                za(s);
                break;
            case 12:
                za(s);
                break;
            case 22:
                var o = s.stateNode;
                s.memoizedState !== null && o._visibility & 2 && (s.return === null || s.return.tag !== 13) ? (o._visibility &= -3, Gh(s)) : za(s);
                break;
            default:
                za(s);
        }
    }
    function Gh(s) {
        var o = s.deletions;
        if ((s.flags & 16) !== 0) {
            if (o !== null) for(var d = 0; d < o.length; d++){
                var g = o[d];
                bi = g, mf(g, s);
            }
            Za(s);
        }
        for(s = s.child; s !== null;){
            switch(o = s, o.tag){
                case 0:
                case 11:
                case 15:
                    Gr(8, o, o.return), Gh(o);
                    break;
                case 22:
                    d = o.stateNode, d._visibility & 2 && (d._visibility &= -3, Gh(o));
                    break;
                default:
                    Gh(o);
            }
            s = s.sibling;
        }
    }
    function mf(s, o) {
        for(; bi !== null;){
            var d = bi;
            switch(d.tag){
                case 0:
                case 11:
                case 15:
                    Gr(8, d, o);
                    break;
                case 23:
                case 22:
                    if (d.memoizedState !== null && d.memoizedState.cachePool !== null) {
                        var g = d.memoizedState.cachePool.pool;
                        g != null && g.refCount++;
                    }
                    break;
                case 24:
                    aa(d.memoizedState.cache);
            }
            if (g = d.child, g !== null) g.return = d, bi = g;
            else e: for(d = s; bi !== null;){
                g = bi;
                var E = g.sibling, w = g.return;
                if (Fh(g), g === d) {
                    bi = null;
                    break e;
                }
                if (E !== null) {
                    E.return = w, bi = E;
                    break e;
                }
                bi = w;
            }
        }
    }
    var kh = {
        getCacheForType: function(s) {
            var o = Ki(Bt), d = o.data.get(s);
            return d === void 0 && (d = s(), o.data.set(s, d)), d;
        },
        cacheSignal: function() {
            return Ki(Bt).controller.signal;
        }
    }, jh = typeof WeakMap == "function" ? WeakMap : Map, Mn = 0, In = null, tn = null, yn = 0, It = 0, dn = null, Kt = !1, cn = !1, Wn = !1, Ri = 0, Fn = 0, Sr = 0, yo = 0, ms = 0, En = 0, Mr = 0, gs = null, Sa = null, Qa = !1, _o = 0, nu = 0, Er = 1 / 0, iu = null, Vs = null, pi = 0, xs = null, Tr = null, Xr = 0, bo = 0, tc = null, Xh = null, nc = 0, ic = null;
    function Pa() {
        return (Mn & 2) !== 0 && yn !== 0 ? yn & -yn : F.T !== null ? Jy() : Pi();
    }
    function u() {
        if (En === 0) {
            if ((yn & 536870912) === 0 || bn) {
                var s = Je;
                Je <<= 1, (Je & 3932160) === 0 && (Je = 262144), En = s;
            } else En = 536870912;
        }
        return s = ji.current, s !== null && (s.flags |= 32), En;
    }
    function h(s, o, d) {
        (s === In && (It === 2 || It === 9) || s.cancelPendingCommit !== null) && (De(s, 0), B(s, yn, En, !1)), on(s, d), ((Mn & 2) === 0 || s !== In) && (s === In && ((Mn & 2) === 0 && (yo |= d), Fn === 4 && B(s, yn, En, !1)), fl(s));
    }
    function y(s, o, d) {
        if ((Mn & 6) !== 0) throw Error(n(327));
        var g = !d && (o & 127) === 0 && (o & s.expiredLanes) === 0 || ft(s, o), E = g ? ac(s, o) : Ka(s, o, !0), w = g;
        do {
            if (E === 0) {
                cn && !g && B(s, o, 0, !1);
                break;
            } else {
                if (d = s.current.alternate, w && !U(d)) {
                    E = Ka(s, o, !1), w = !1;
                    continue;
                }
                if (E === 2) {
                    if (w = o, s.errorRecoveryDisabledLanes & w) var V = 0;
                    else V = s.pendingLanes & -536870913, V = V !== 0 ? V : V & 536870912 ? 536870912 : 0;
                    if (V !== 0) {
                        o = V;
                        e: {
                            var re = s;
                            E = gs;
                            var ge = re.current.memoizedState.isDehydrated;
                            if (ge && (De(re, V).flags |= 256), V = Ka(re, V, !1), V !== 2) {
                                if (Wn && !ge) {
                                    re.errorRecoveryDisabledLanes |= w, yo |= w, E = 4;
                                    break e;
                                }
                                w = Sa, Sa = E, w !== null && (Sa === null ? Sa = w : Sa.push.apply(Sa, w));
                            }
                            E = V;
                        }
                        if (w = !1, E !== 2) continue;
                    }
                }
                if (E === 1) {
                    De(s, 0), B(s, o, 0, !0);
                    break;
                }
                e: {
                    switch(g = s, w = E, w){
                        case 0:
                        case 1:
                            throw Error(n(345));
                        case 4:
                            if ((o & 4194048) !== o) break;
                        case 6:
                            B(g, o, En, !Kt);
                            break e;
                        case 2:
                            Sa = null;
                            break;
                        case 3:
                        case 5:
                            break;
                        default:
                            throw Error(n(329));
                    }
                    if ((o & 62914560) === o && (E = _o + 300 - W(), 10 < E)) {
                        if (B(g, o, En, !Kt), Ve(g, 0, !0) !== 0) break e;
                        Xr = o, g.timeoutHandle = GS(T.bind(null, g, d, Sa, iu, Qa, o, En, yo, Mr, Kt, w, "Throttled", -0, 0), E);
                        break e;
                    }
                    T(g, d, Sa, iu, Qa, o, En, yo, Mr, Kt, w, null, -0, 0);
                }
            }
            break;
        }while (!0);
        fl(s);
    }
    function T(s, o, d, g, E, w, V, re, ge, He, et, ct, Xe, Qe) {
        if (s.timeoutHandle = -1, ct = o.subtreeFlags, ct & 8192 || (ct & 16785408) === 16785408) {
            ct = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: ta
            }, Ci(o, w, ct);
            var Rt = (w & 62914560) === w ? _o - W() : (w & 4194048) === w ? nu - W() : 0;
            if (Rt = tC(ct, Rt), Rt !== null) {
                Xr = w, s.cancelPendingCommit = Rt(Wt.bind(null, s, o, w, d, g, E, V, re, ge, et, ct, null, Xe, Qe)), B(s, w, V, !He);
                return;
            }
        }
        Wt(s, o, w, d, g, E, V, re, ge);
    }
    function U(s) {
        for(var o = s;;){
            var d = o.tag;
            if ((d === 0 || d === 11 || d === 15) && o.flags & 16384 && (d = o.updateQueue, d !== null && (d = d.stores, d !== null))) for(var g = 0; g < d.length; g++){
                var E = d[g], w = E.getSnapshot;
                E = E.value;
                try {
                    if (!si(w(), E)) return !1;
                } catch  {
                    return !1;
                }
            }
            if (d = o.child, o.subtreeFlags & 16384 && d !== null) d.return = o, o = d;
            else {
                if (o === s) break;
                for(; o.sibling === null;){
                    if (o.return === null || o.return === s) return !0;
                    o = o.return;
                }
                o.sibling.return = o.return, o = o.sibling;
            }
        }
        return !0;
    }
    function B(s, o, d, g) {
        o &= ~ms, o &= ~yo, s.suspendedLanes |= o, s.pingedLanes &= ~o, g && (s.warmLanes |= o), g = s.expirationTimes;
        for(var E = o; 0 < E;){
            var w = 31 - he(E), V = 1 << w;
            g[w] = -1, E &= ~V;
        }
        d !== 0 && ni(s, d, o);
    }
    function se() {
        return (Mn & 6) === 0 ? (sm(0), !1) : !0;
    }
    function me() {
        if (tn !== null) {
            if (It === 0) var s = tn.return;
            else s = tn, xa = so = null, Pp(s), $o = null, el = 0, s = tn;
            for(; s !== null;)Kl(s.alternate, s), s = s.return;
            tn = null;
        }
    }
    function De(s, o) {
        var d = s.timeoutHandle;
        d !== -1 && (s.timeoutHandle = -1, Bw(d)), d = s.cancelPendingCommit, d !== null && (s.cancelPendingCommit = null, d()), Xr = 0, me(), In = s, tn = d = Cs(s.current, null), yn = o, It = 0, dn = null, Kt = !1, cn = ft(s, o), Wn = !1, Mr = En = ms = yo = Sr = Fn = 0, Sa = gs = null, Qa = !1, (o & 8) !== 0 && (o |= o & 32);
        var g = s.entangledLanes;
        if (g !== 0) for(s = s.entanglements, g &= o; 0 < g;){
            var E = 31 - he(g), w = 1 << E;
            o |= s[E], g &= ~w;
        }
        return Ri = o, Wo(), d;
    }
    function it(s, o) {
        Xt = null, F.H = nf, o === Jo || o === fs ? (o = yh(), It = 3) : o === Wu ? (o = yh(), It = 4) : It = o === Ph ? 8 : o !== null && typeof o == "object" && typeof o.then == "function" ? 6 : 1, dn = o, tn === null && (Fn = 1, zh(s, Ga(o, s.current)));
    }
    function mt() {
        var s = ji.current;
        return s === null ? !0 : (yn & 4194048) === yn ? Fr === null : (yn & 62914560) === yn || (yn & 536870912) !== 0 ? s === Fr : !1;
    }
    function bt() {
        var s = F.H;
        return F.H = nf, s === null ? nf : s;
    }
    function At() {
        var s = F.A;
        return F.A = kh, s;
    }
    function Zt() {
        Fn = 4, Kt || (yn & 4194048) !== yn && ji.current !== null || (cn = !0), (Sr & 134217727) === 0 && (yo & 134217727) === 0 || In === null || B(In, yn, En, !1);
    }
    function Ka(s, o, d) {
        var g = Mn;
        Mn |= 2;
        var E = bt(), w = At();
        (In !== s || yn !== o) && (iu = null, De(s, o)), o = !1;
        var V = Fn;
        e: do try {
            if (It !== 0 && tn !== null) {
                var re = tn, ge = dn;
                switch(It){
                    case 8:
                        me(), V = 6;
                        break e;
                    case 3:
                    case 2:
                    case 9:
                    case 6:
                        ji.current === null && (o = !0);
                        var He = It;
                        if (It = 0, dn = null, ht(s, re, ge, He), d && cn) {
                            V = 0;
                            break e;
                        }
                        break;
                    default:
                        He = It, It = 0, dn = null, ht(s, re, ge, He);
                }
            }
            gf(), V = Fn;
            break;
        } catch (et) {
            it(s, et);
        }
        while (!0);
        return o && s.shellSuspendCounter++, xa = so = null, Mn = g, F.H = E, F.A = w, tn === null && (In = null, yn = 0, Wo()), V;
    }
    function gf() {
        for(; tn !== null;)we(tn);
    }
    function ac(s, o) {
        var d = Mn;
        Mn |= 2;
        var g = bt(), E = At();
        In !== s || yn !== o ? (iu = null, Er = W() + 500, De(s, o)) : cn = ft(s, o);
        e: do try {
            if (It !== 0 && tn !== null) {
                o = tn;
                var w = dn;
                t: switch(It){
                    case 1:
                        It = 0, dn = null, ht(s, o, w, 1);
                        break;
                    case 2:
                    case 9:
                        if (K0(w)) {
                            It = 0, dn = null, qe(o);
                            break;
                        }
                        o = function() {
                            It !== 2 && It !== 9 || In !== s || (It = 7), fl(s);
                        }, w.then(o, o);
                        break e;
                    case 3:
                        It = 7;
                        break e;
                    case 4:
                        It = 5;
                        break e;
                    case 7:
                        K0(w) ? (It = 0, dn = null, qe(o)) : (It = 0, dn = null, ht(s, o, w, 7));
                        break;
                    case 5:
                        var V = null;
                        switch(tn.tag){
                            case 26:
                                V = tn.memoizedState;
                            case 5:
                            case 27:
                                var re = tn;
                                if (V ? i2(V) : re.stateNode.complete) {
                                    It = 0, dn = null;
                                    var ge = re.sibling;
                                    if (ge !== null) tn = ge;
                                    else {
                                        var He = re.return;
                                        He !== null ? (tn = He, zt(He)) : tn = null;
                                    }
                                    break t;
                                }
                        }
                        It = 0, dn = null, ht(s, o, w, 5);
                        break;
                    case 6:
                        It = 0, dn = null, ht(s, o, w, 6);
                        break;
                    case 8:
                        me(), Fn = 6;
                        break e;
                    default:
                        throw Error(n(462));
                }
            }
            je();
            break;
        } catch (et) {
            it(s, et);
        }
        while (!0);
        return xa = so = null, F.H = g, F.A = E, Mn = d, tn !== null ? 0 : (In = null, yn = 0, Wo(), Fn);
    }
    function je() {
        for(; tn !== null && !rt();)we(tn);
    }
    function we(s) {
        var o = Bh(s.alternate, s, Ri);
        s.memoizedProps = s.pendingProps, o === null ? zt(s) : tn = o;
    }
    function qe(s) {
        var o = s, d = o.alternate;
        switch(o.tag){
            case 15:
            case 0:
                o = ya(d, o, o.pendingProps, o.type, void 0, yn);
                break;
            case 11:
                o = ya(d, o, o.pendingProps, o.type.render, o.ref, yn);
                break;
            case 5:
                Pp(o);
            default:
                Kl(d, o), o = tn = ga(o, Ri), o = Bh(d, o, Ri);
        }
        s.memoizedProps = s.pendingProps, o === null ? zt(s) : tn = o;
    }
    function ht(s, o, d, g) {
        xa = so = null, Pp(o), $o = null, el = 0;
        var E = o.return;
        try {
            if (mr(s, E, o, d, yn)) {
                Fn = 1, zh(s, Ga(d, s.current)), tn = null;
                return;
            }
        } catch (w) {
            if (E !== null) throw tn = E, w;
            Fn = 1, zh(s, Ga(d, s.current)), tn = null;
            return;
        }
        o.flags & 32768 ? (bn || g === 1 ? s = !0 : cn || (yn & 536870912) !== 0 ? s = !1 : (Kt = s = !0, (g === 2 || g === 9 || g === 3 || g === 6) && (g = ji.current, g !== null && g.tag === 13 && (g.flags |= 16384))), Jn(o, s)) : zt(o);
    }
    function zt(s) {
        var o = s;
        do {
            if ((o.flags & 32768) !== 0) {
                Jn(o, Kt);
                return;
            }
            s = o.return;
            var d = im(o.alternate, o, Ri);
            if (d !== null) {
                tn = d;
                return;
            }
            if (o = o.sibling, o !== null) {
                tn = o;
                return;
            }
            tn = o = s;
        }while (o !== null);
        Fn === 0 && (Fn = 5);
    }
    function Jn(s, o) {
        do {
            var d = Ih(s.alternate, s);
            if (d !== null) {
                d.flags &= 32767, tn = d;
                return;
            }
            if (d = s.return, d !== null && (d.flags |= 32768, d.subtreeFlags = 0, d.deletions = null), !o && (s = s.sibling, s !== null)) {
                tn = s;
                return;
            }
            tn = s = d;
        }while (s !== null);
        Fn = 6, tn = null;
    }
    function Wt(s, o, d, g, E, w, V, re, ge) {
        s.cancelPendingCommit = null;
        do Wh();
        while (pi !== 0);
        if ((Mn & 6) !== 0) throw Error(n(327));
        if (o !== null) {
            if (o === s.current) throw Error(n(177));
            if (w = o.lanes | o.childLanes, w |= fh, gn(s, d, w, V, re, ge), s === In && (tn = In = null, yn = 0), Tr = o, xs = s, Xr = d, bo = w, tc = E, Xh = g, (o.subtreeFlags & 10256) !== 0 || (o.flags & 10256) !== 0 ? (s.callbackNode = null, s.callbackPriority = 0, Ew(_e, function() {
                return TS(), null;
            })) : (s.callbackNode = null, s.callbackPriority = 0), g = (o.flags & 13878) !== 0, (o.subtreeFlags & 13878) !== 0 || g) {
                g = F.T, F.T = null, E = Q.p, Q.p = 2, V = Mn, Mn |= 4;
                try {
                    eu(s, o, d);
                } finally{
                    Mn = V, Q.p = E, F.T = g;
                }
            }
            pi = 1, Cn(), Wi(), Rn();
        }
    }
    function Cn() {
        if (pi === 1) {
            pi = 0;
            var s = xs, o = Tr, d = (o.flags & 13878) !== 0;
            if ((o.subtreeFlags & 13878) !== 0 || d) {
                d = F.T, F.T = null;
                var g = Q.p;
                Q.p = 2;
                var E = Mn;
                Mn |= 4;
                try {
                    cl(o, s);
                    var w = s1, V = sh(s.containerInfo), re = w.focusedElem, ge = w.selectionRange;
                    if (V !== re && re && re.ownerDocument && rh(re.ownerDocument.documentElement, re)) {
                        if (ge !== null && Oc(re)) {
                            var He = ge.start, et = ge.end;
                            if (et === void 0 && (et = He), "selectionStart" in re) re.selectionStart = He, re.selectionEnd = Math.min(et, re.value.length);
                            else {
                                var ct = re.ownerDocument || document, Xe = ct && ct.defaultView || window;
                                if (Xe.getSelection) {
                                    var Qe = Xe.getSelection(), Rt = re.textContent.length, kt = Math.min(ge.start, Rt), ei = ge.end === void 0 ? kt : Math.min(ge.end, Rt);
                                    !Qe.extend && kt > ei && (V = ei, ei = kt, kt = V);
                                    var Ce = fp(re, kt), ye = fp(re, ei);
                                    if (Ce && ye && (Qe.rangeCount !== 1 || Qe.anchorNode !== Ce.node || Qe.anchorOffset !== Ce.offset || Qe.focusNode !== ye.node || Qe.focusOffset !== ye.offset)) {
                                        var Fe = ct.createRange();
                                        Fe.setStart(Ce.node, Ce.offset), Qe.removeAllRanges(), kt > ei ? (Qe.addRange(Fe), Qe.extend(ye.node, ye.offset)) : (Fe.setEnd(ye.node, ye.offset), Qe.addRange(Fe));
                                    }
                                }
                            }
                        }
                        for(ct = [], Qe = re; Qe = Qe.parentNode;)Qe.nodeType === 1 && ct.push({
                            element: Qe,
                            left: Qe.scrollLeft,
                            top: Qe.scrollTop
                        });
                        for(typeof re.focus == "function" && re.focus(), re = 0; re < ct.length; re++){
                            var st = ct[re];
                            st.element.scrollLeft = st.left, st.element.scrollTop = st.top;
                        }
                    }
                    Ig = !!r1, s1 = r1 = null;
                } finally{
                    Mn = E, Q.p = g, F.T = d;
                }
            }
            s.current = o, pi = 2;
        }
    }
    function Wi() {
        if (pi === 2) {
            pi = 0;
            var s = xs, o = Tr, d = (o.flags & 8772) !== 0;
            if ((o.subtreeFlags & 8772) !== 0 || d) {
                d = F.T, F.T = null;
                var g = Q.p;
                Q.p = 2;
                var E = Mn;
                Mn |= 4;
                try {
                    Eg(s, o.alternate, o);
                } finally{
                    Mn = E, Q.p = g, F.T = d;
                }
            }
            pi = 3;
        }
    }
    function Rn() {
        if (pi === 4 || pi === 3) {
            pi = 0, ne();
            var s = xs, o = Tr, d = Xr, g = Xh;
            (o.subtreeFlags & 10256) !== 0 || (o.flags & 10256) !== 0 ? pi = 5 : (pi = 0, Tr = xs = null, So(s, s.pendingLanes));
            var E = s.pendingLanes;
            if (E === 0 && (Vs = null), ea(d), o = o.stateNode, Ye && typeof Ye.onCommitFiberRoot == "function") try {
                Ye.onCommitFiberRoot(Ge, o, void 0, (o.current.flags & 128) === 128);
            } catch  {}
            if (g !== null) {
                o = F.T, E = Q.p, Q.p = 2, F.T = null;
                try {
                    for(var w = s.onRecoverableError, V = 0; V < g.length; V++){
                        var re = g[V];
                        w(re.value, {
                            componentStack: re.stack
                        });
                    }
                } finally{
                    F.T = o, Q.p = E;
                }
            }
            (Xr & 3) !== 0 && Wh(), fl(s), E = s.pendingLanes, (d & 261930) !== 0 && (E & 42) !== 0 ? s === ic ? nc++ : (nc = 0, ic = s) : nc = 0, sm(0);
        }
    }
    function So(s, o) {
        (s.pooledCacheLanes &= o) === 0 && (o = s.pooledCache, o != null && (s.pooledCache = null, aa(o)));
    }
    function Wh() {
        return Cn(), Wi(), Rn(), TS();
    }
    function TS() {
        if (pi !== 5) return !1;
        var s = xs, o = bo;
        bo = 0;
        var d = ea(Xr), g = F.T, E = Q.p;
        try {
            Q.p = 32 > d ? 32 : d, F.T = null, d = tc, tc = null;
            var w = xs, V = Xr;
            if (pi = 0, Tr = xs = null, Xr = 0, (Mn & 6) !== 0) throw Error(n(331));
            var re = Mn;
            if (Mn |= 4, ec(w.current), di(w, w.current, V, d), Mn = re, sm(0, !1), Ye && typeof Ye.onPostCommitFiberRoot == "function") try {
                Ye.onPostCommitFiberRoot(Ge, w);
            } catch  {}
            return !0;
        } finally{
            Q.p = E, F.T = g, So(s, o);
        }
    }
    function AS(s, o, d) {
        o = Ga(d, o), o = nm(s.stateNode, o, 2), s = uo(s, o, 2), s !== null && (on(s, 2), fl(s));
    }
    function Yn(s, o, d) {
        if (s.tag === 3) AS(s, s, d);
        else for(; o !== null;){
            if (o.tag === 3) {
                AS(o, s, d);
                break;
            } else if (o.tag === 1) {
                var g = o.stateNode;
                if (typeof o.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (Vs === null || !Vs.has(g))) {
                    s = Ga(d, s), d = Zc(2), g = uo(o, d, 2), g !== null && (Wa(d, g, o, s), on(g, 2), fl(g));
                    break;
                }
            }
            o = o.return;
        }
    }
    function Zy(s, o, d) {
        var g = s.pingCache;
        if (g === null) {
            g = s.pingCache = new jh;
            var E = new Set;
            g.set(o, E);
        } else E = g.get(o), E === void 0 && (E = new Set, g.set(o, E));
        E.has(d) || (Wn = !0, E.add(d), s = bw.bind(null, s, o, d), o.then(s, s));
    }
    function bw(s, o, d) {
        var g = s.pingCache;
        g !== null && g.delete(o), s.pingedLanes |= s.suspendedLanes & d, s.warmLanes &= ~d, In === s && (yn & d) === d && (Fn === 4 || Fn === 3 && (yn & 62914560) === yn && 300 > W() - _o ? (Mn & 2) === 0 && De(s, 0) : ms |= d, Mr === yn && (Mr = 0)), fl(s);
    }
    function wS(s, o) {
        o === 0 && (o = yt()), s = qo(s, o), s !== null && (on(s, o), fl(s));
    }
    function Sw(s) {
        var o = s.memoizedState, d = 0;
        o !== null && (d = o.retryLane), wS(s, d);
    }
    function Mw(s, o) {
        var d = 0;
        switch(s.tag){
            case 31:
            case 13:
                var g = s.stateNode, E = s.memoizedState;
                E !== null && (d = E.retryLane);
                break;
            case 19:
                g = s.stateNode;
                break;
            case 22:
                g = s.stateNode._retryCache;
                break;
            default:
                throw Error(n(314));
        }
        g !== null && g.delete(o), wS(s, d);
    }
    function Ew(s, o) {
        return Ze(s, o);
    }
    var wg = null, qh = null, Qy = !1, Cg = !1, Ky = !1, au = 0;
    function fl(s) {
        s !== qh && s.next === null && (qh === null ? wg = qh = s : qh = qh.next = s), Cg = !0, Qy || (Qy = !0, Aw());
    }
    function sm(s, o) {
        if (!Ky && Cg) {
            Ky = !0;
            do for(var d = !1, g = wg; g !== null;){
                if (s !== 0) {
                    var E = g.pendingLanes;
                    if (E === 0) var w = 0;
                    else {
                        var V = g.suspendedLanes, re = g.pingedLanes;
                        w = (1 << 31 - he(42 | s) + 1) - 1, w &= E & ~(V & ~re), w = w & 201326741 ? w & 201326741 | 1 : w ? w | 2 : 0;
                    }
                    w !== 0 && (d = !0, US(g, w));
                } else w = yn, w = Ve(g, g === In ? w : 0, g.cancelPendingCommit !== null || g.timeoutHandle !== -1), (w & 3) === 0 || ft(g, w) || (d = !0, US(g, w));
                g = g.next;
            }
            while (d);
            Ky = !1;
        }
    }
    function Tw() {
        CS();
    }
    function CS() {
        Cg = Qy = !1;
        var s = 0;
        au !== 0 && Pw() && (s = au);
        for(var o = W(), d = null, g = wg; g !== null;){
            var E = g.next, w = RS(g, o);
            w === 0 ? (g.next = null, d === null ? wg = E : d.next = E, E === null && (qh = d)) : (d = g, (s !== 0 || (w & 3) !== 0) && (Cg = !0)), g = E;
        }
        pi !== 0 && pi !== 5 || sm(s), au !== 0 && (au = 0);
    }
    function RS(s, o) {
        for(var d = s.suspendedLanes, g = s.pingedLanes, E = s.expirationTimes, w = s.pendingLanes & -62914561; 0 < w;){
            var V = 31 - he(w), re = 1 << V, ge = E[V];
            ge === -1 ? ((re & d) === 0 || (re & g) !== 0) && (E[V] = vt(re, o)) : ge <= o && (s.expiredLanes |= re), w &= ~re;
        }
        if (o = In, d = yn, d = Ve(s, s === o ? d : 0, s.cancelPendingCommit !== null || s.timeoutHandle !== -1), g = s.callbackNode, d === 0 || s === o && (It === 2 || It === 9) || s.cancelPendingCommit !== null) return g !== null && g !== null && be(g), s.callbackNode = null, s.callbackPriority = 0;
        if ((d & 3) === 0 || ft(s, d)) {
            if (o = d & -d, o === s.callbackPriority) return o;
            switch(g !== null && be(g), ea(d)){
                case 2:
                case 8:
                    d = Te;
                    break;
                case 32:
                    d = _e;
                    break;
                case 268435456:
                    d = tt;
                    break;
                default:
                    d = _e;
            }
            return g = DS.bind(null, s), d = Ze(d, g), s.callbackPriority = o, s.callbackNode = d, o;
        }
        return g !== null && g !== null && be(g), s.callbackPriority = 2, s.callbackNode = null, 2;
    }
    function DS(s, o) {
        if (pi !== 0 && pi !== 5) return s.callbackNode = null, s.callbackPriority = 0, null;
        var d = s.callbackNode;
        if (Wh() && s.callbackNode !== d) return null;
        var g = yn;
        return g = Ve(s, s === In ? g : 0, s.cancelPendingCommit !== null || s.timeoutHandle !== -1), g === 0 ? null : (y(s, g, o), RS(s, W()), s.callbackNode != null && s.callbackNode === d ? DS.bind(null, s) : null);
    }
    function US(s, o) {
        if (Wh()) return null;
        y(s, o, !0);
    }
    function Aw() {
        Iw(function() {
            (Mn & 6) !== 0 ? Ze(Be, Tw) : CS();
        });
    }
    function Jy() {
        if (au === 0) {
            var s = co;
            s === 0 && (s = We, We <<= 1, (We & 261888) === 0 && (We = 256)), au = s;
        }
        return au;
    }
    function NS(s) {
        return s == null || typeof s == "symbol" || typeof s == "boolean" ? null : typeof s == "function" ? s : Lr("" + s);
    }
    function OS(s, o) {
        var d = o.ownerDocument.createElement("input");
        return d.name = o.name, d.value = o.value, s.id && d.setAttribute("form", s.id), o.parentNode.insertBefore(d, o), s = new FormData(s), d.parentNode.removeChild(d), s;
    }
    function ww(s, o, d, g, E) {
        if (o === "submit" && d && d.stateNode === E) {
            var w = NS((E[ci] || null).action), V = g.submitter;
            V && (o = (o = V[ci] || null) ? NS(o.formAction) : V.getAttribute("formAction"), o !== null && (w = o, V = null));
            var re = new $s("action", "action", null, g, E);
            s.push({
                event: re,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (g.defaultPrevented) {
                                if (au !== 0) {
                                    var ge = V ? OS(E, V) : new FormData(E);
                                    Kp(d, {
                                        pending: !0,
                                        data: ge,
                                        method: E.method,
                                        action: w
                                    }, null, ge);
                                }
                            } else typeof w == "function" && (re.preventDefault(), ge = V ? OS(E, V) : new FormData(E), Kp(d, {
                                pending: !0,
                                data: ge,
                                method: E.method,
                                action: w
                            }, w, ge));
                        },
                        currentTarget: E
                    }
                ]
            });
        }
    }
    for(var $y = 0; $y < uh.length; $y++){
        var e1 = uh[$y], Cw = e1.toLowerCase(), Rw = e1[0].toUpperCase() + e1.slice(1);
        ma(Cw, "on" + Rw);
    }
    ma(Va, "onAnimationEnd"), ma(hp, "onAnimationIteration"), ma(ws, "onAnimationStart"), ma("dblclick", "onDoubleClick"), ma("focusin", "onFocus"), ma("focusout", "onBlur"), ma(Bc, "onTransitionRun"), ma(jo, "onTransitionStart"), ma(dp, "onTransitionCancel"), ma(ch, "onTransitionEnd"), Et("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]), Et("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]), Et("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]), Et("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]), xt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), xt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), xt("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]), xt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var om = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Dw = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(om));
    function LS(s, o) {
        o = (o & 4) !== 0;
        for(var d = 0; d < s.length; d++){
            var g = s[d], E = g.event;
            g = g.listeners;
            e: {
                var w = void 0;
                if (o) for(var V = g.length - 1; 0 <= V; V--){
                    var re = g[V], ge = re.instance, He = re.currentTarget;
                    if (re = re.listener, ge !== w && E.isPropagationStopped()) break e;
                    w = re, E.currentTarget = He;
                    try {
                        w(E);
                    } catch (et) {
                        Xo(et);
                    }
                    E.currentTarget = null, w = ge;
                }
                else for(V = 0; V < g.length; V++){
                    if (re = g[V], ge = re.instance, He = re.currentTarget, re = re.listener, ge !== w && E.isPropagationStopped()) break e;
                    w = re, E.currentTarget = He;
                    try {
                        w(E);
                    } catch (et) {
                        Xo(et);
                    }
                    E.currentTarget = null, w = ge;
                }
            }
        }
    }
    function Sn(s, o) {
        var d = o[Qs];
        d === void 0 && (d = o[Qs] = new Set);
        var g = s + "__bubble";
        d.has(g) || (zS(o, s, 2, !1), d.add(g));
    }
    function t1(s, o, d) {
        var g = 0;
        o && (g |= 4), zS(d, s, g, o);
    }
    var Rg = "_reactListening" + Math.random().toString(36).slice(2);
    function n1(s) {
        if (!s[Rg]) {
            s[Rg] = !0, Me.forEach(function(d) {
                d !== "selectionchange" && (Dw.has(d) || t1(d, !1, s), t1(d, !0, s));
            });
            var o = s.nodeType === 9 ? s : s.ownerDocument;
            o === null || o[Rg] || (o[Rg] = !0, t1("selectionchange", !1, o));
        }
    }
    function zS(s, o, d, g) {
        switch(u2(o)){
            case 2:
                var E = aC;
                break;
            case 8:
                E = rC;
                break;
            default:
                E = x1;
        }
        d = E.bind(null, o, d, s), E = void 0, !pa || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (E = !0), g ? E !== void 0 ? s.addEventListener(o, d, {
            capture: !0,
            passive: E
        }) : s.addEventListener(o, d, !0) : E !== void 0 ? s.addEventListener(o, d, {
            passive: E
        }) : s.addEventListener(o, d, !1);
    }
    function i1(s, o, d, g, E) {
        var w = g;
        if ((o & 1) === 0 && (o & 2) === 0 && g !== null) e: for(;;){
            if (g === null) return;
            var V = g.tag;
            if (V === 3 || V === 4) {
                var re = g.stateNode.containerInfo;
                if (re === E) break;
                if (V === 4) for(V = g.return; V !== null;){
                    var ge = V.tag;
                    if ((ge === 3 || ge === 4) && V.stateNode.containerInfo === E) return;
                    V = V.return;
                }
                for(; re !== null;){
                    if (V = Qn(re), V === null) return;
                    if (ge = V.tag, ge === 5 || ge === 6 || ge === 26 || ge === 27) {
                        g = w = V;
                        continue e;
                    }
                    re = re.parentNode;
                }
            }
            g = g.return;
        }
        Bo(function() {
            var He = w, et = Cl(d), ct = [];
            e: {
                var Xe = no.get(s);
                if (Xe !== void 0) {
                    var Qe = $s, Rt = s;
                    switch(s){
                        case "keypress":
                            if (Es(d) === 0) break e;
                        case "keydown":
                        case "keyup":
                            Qe = tp;
                            break;
                        case "focusin":
                            Rt = "focus", Qe = wc;
                            break;
                        case "focusout":
                            Rt = "blur", Qe = wc;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            Qe = wc;
                            break;
                        case "click":
                            if (d.button === 2) break e;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            Qe = eh;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            Qe = Ll;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            Qe = eo;
                            break;
                        case Va:
                        case hp:
                        case ws:
                            Qe = Ha;
                            break;
                        case ch:
                            Qe = Vy;
                            break;
                        case "scroll":
                        case "scrollend":
                            Qe = Ts;
                            break;
                        case "wheel":
                            Qe = Io;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            Qe = Br;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            Qe = th;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            Qe = ip;
                    }
                    var kt = (o & 4) !== 0, ei = !kt && (s === "scroll" || s === "scrollend"), Ce = kt ? Xe !== null ? Xe + "Capture" : null : Xe;
                    kt = [];
                    for(var ye = He, Fe; ye !== null;){
                        var st = ye;
                        if (Fe = st.stateNode, st = st.tag, st !== 5 && st !== 26 && st !== 27 || Fe === null || Ce === null || (st = is(ye, Ce), st != null && kt.push(lm(ye, st, Fe))), ei) break;
                        ye = ye.return;
                    }
                    0 < kt.length && (Xe = new Qe(Xe, Rt, null, d, et), ct.push({
                        event: Xe,
                        listeners: kt
                    }));
                }
            }
            if ((o & 7) === 0) {
                e: {
                    if (Xe = s === "mouseover" || s === "pointerover", Qe = s === "mouseout" || s === "pointerout", Xe && d !== ns && (Rt = d.relatedTarget || d.fromElement) && (Qn(Rt) || Rt[Aa])) break e;
                    if ((Qe || Xe) && (Xe = et.window === et ? et : (Xe = et.ownerDocument) ? Xe.defaultView || Xe.parentWindow : window, Qe ? (Rt = d.relatedTarget || d.toElement, Qe = He, Rt = Rt ? Qn(Rt) : null, Rt !== null && (ei = r(Rt), kt = Rt.tag, Rt !== ei || kt !== 5 && kt !== 27 && kt !== 6) && (Rt = null)) : (Qe = null, Rt = He), Qe !== Rt)) {
                        if (kt = eh, st = "onMouseLeave", Ce = "onMouseEnter", ye = "mouse", (s === "pointerout" || s === "pointerover") && (kt = th, st = "onPointerLeave", Ce = "onPointerEnter", ye = "pointer"), ei = Qe == null ? Xe : Se(Qe), Fe = Rt == null ? Xe : Se(Rt), Xe = new kt(st, ye + "leave", Qe, d, et), Xe.target = ei, Xe.relatedTarget = Fe, st = null, Qn(et) === He && (kt = new kt(Ce, ye + "enter", Rt, d, et), kt.target = Fe, kt.relatedTarget = ei, st = kt), ei = st, Qe && Rt) t: {
                            for(kt = Uw, Ce = Qe, ye = Rt, Fe = 0, st = Ce; st; st = kt(st))Fe++;
                            st = 0;
                            for(var Ht = ye; Ht; Ht = kt(Ht))st++;
                            for(; 0 < Fe - st;)Ce = kt(Ce), Fe--;
                            for(; 0 < st - Fe;)ye = kt(ye), st--;
                            for(; Fe--;){
                                if (Ce === ye || ye !== null && Ce === ye.alternate) {
                                    kt = Ce;
                                    break t;
                                }
                                Ce = kt(Ce), ye = kt(ye);
                            }
                            kt = null;
                        }
                        else kt = null;
                        Qe !== null && PS(ct, Xe, Qe, kt, !1), Rt !== null && ei !== null && PS(ct, ei, Rt, kt, !0);
                    }
                }
                e: {
                    if (Xe = He ? Se(He) : window, Qe = Xe.nodeName && Xe.nodeName.toLowerCase(), Qe === "select" || Qe === "input" && Xe.type === "file") var Hn = lp;
                    else if (sp(Xe)) {
                        if (Bu) Hn = k0;
                        else {
                            Hn = Vo;
                            var Nt = Iu;
                        }
                    } else Qe = Xe.nodeName, !Qe || Qe.toLowerCase() !== "input" || Xe.type !== "checkbox" && Xe.type !== "radio" ? He && ts(He.elementType) && (Hn = lp) : Hn = G0;
                    if (Hn && (Hn = Hn(s, He))) {
                        ah(ct, Hn, d, et);
                        break e;
                    }
                    Nt && Nt(s, Xe, He), s === "focusout" && He && Xe.type === "number" && He.memoizedProps.value != null && ii(Xe, "number", Xe.value);
                }
                switch(Nt = He ? Se(He) : window, s){
                    case "focusin":
                        (sp(Nt) || Nt.contentEditable === "true") && (Lc = Nt, oh = He, zc = null);
                        break;
                    case "focusout":
                        zc = oh = Lc = null;
                        break;
                    case "mousedown":
                        ur = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        ur = !1, lh(ct, d, et);
                        break;
                    case "selectionchange":
                        if (j0) break;
                    case "keydown":
                    case "keyup":
                        lh(ct, d, et);
                }
                var un;
                if (zl) e: {
                    switch(s){
                        case "compositionstart":
                            var Tn = "onCompositionStart";
                            break e;
                        case "compositionend":
                            Tn = "onCompositionEnd";
                            break e;
                        case "compositionupdate":
                            Tn = "onCompositionUpdate";
                            break e;
                    }
                    Tn = void 0;
                }
                else Ho ? nh(s, d) && (Tn = "onCompositionEnd") : s === "keydown" && d.keyCode === 229 && (Tn = "onCompositionStart");
                Tn && (ia && d.locale !== "ko" && (Ho || Tn !== "onCompositionStart" ? Tn === "onCompositionEnd" && Ho && (un = Nl()) : (as = et, Ul = "value" in as ? as.value : as.textContent, Ho = !0)), Nt = Dg(He, Tn), 0 < Nt.length && (Tn = new Kd(Tn, s, null, d, et), ct.push({
                    event: Tn,
                    listeners: Nt
                }), un ? Tn.data = un : (un = Cc(d), un !== null && (Tn.data = un)))), (un = Pl ? ih(s, d) : F0(s, d)) && (Tn = Dg(He, "onBeforeInput"), 0 < Tn.length && (Nt = new Kd("onBeforeInput", "beforeinput", null, d, et), ct.push({
                    event: Nt,
                    listeners: Tn
                }), Nt.data = un)), ww(ct, s, He, d, et);
            }
            LS(ct, o);
        });
    }
    function lm(s, o, d) {
        return {
            instance: s,
            listener: o,
            currentTarget: d
        };
    }
    function Dg(s, o) {
        for(var d = o + "Capture", g = []; s !== null;){
            var E = s, w = E.stateNode;
            if (E = E.tag, E !== 5 && E !== 26 && E !== 27 || w === null || (E = is(s, d), E != null && g.unshift(lm(s, E, w)), E = is(s, o), E != null && g.push(lm(s, E, w))), s.tag === 3) return g;
            s = s.return;
        }
        return [];
    }
    function Uw(s) {
        if (s === null) return null;
        do s = s.return;
        while (s && s.tag !== 5 && s.tag !== 27);
        return s || null;
    }
    function PS(s, o, d, g, E) {
        for(var w = o._reactName, V = []; d !== null && d !== g;){
            var re = d, ge = re.alternate, He = re.stateNode;
            if (re = re.tag, ge !== null && ge === g) break;
            re !== 5 && re !== 26 && re !== 27 || He === null || (ge = He, E ? (He = is(d, w), He != null && V.unshift(lm(d, He, ge))) : E || (He = is(d, w), He != null && V.push(lm(d, He, ge)))), d = d.return;
        }
        V.length !== 0 && s.push({
            event: o,
            listeners: V
        });
    }
    var Nw = /\r\n?/g, Ow = /\u0000|\uFFFD/g;
    function BS(s) {
        return (typeof s == "string" ? s : "" + s).replace(Nw, `
`).replace(Ow, "");
    }
    function IS(s, o) {
        return o = BS(o), BS(s) === o;
    }
    function $n(s, o, d, g, E, w) {
        switch(d){
            case "children":
                typeof g == "string" ? o === "body" || o === "textarea" && g === "" || wa(s, g) : (typeof g == "number" || typeof g == "bigint") && o !== "body" && wa(s, "" + g);
                break;
            case "className":
                mn(s, "class", g);
                break;
            case "tabIndex":
                mn(s, "tabindex", g);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                mn(s, d, g);
                break;
            case "style":
                Al(s, g, w);
                break;
            case "data":
                if (o !== "object") {
                    mn(s, "data", g);
                    break;
                }
            case "src":
            case "href":
                if (g === "" && (o !== "a" || d !== "href")) {
                    s.removeAttribute(d);
                    break;
                }
                if (g == null || typeof g == "function" || typeof g == "symbol" || typeof g == "boolean") {
                    s.removeAttribute(d);
                    break;
                }
                g = Lr("" + g), s.setAttribute(d, g);
                break;
            case "action":
            case "formAction":
                if (typeof g == "function") {
                    s.setAttribute(d, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else typeof w == "function" && (d === "formAction" ? (o !== "input" && $n(s, o, "name", E.name, E, null), $n(s, o, "formEncType", E.formEncType, E, null), $n(s, o, "formMethod", E.formMethod, E, null), $n(s, o, "formTarget", E.formTarget, E, null)) : ($n(s, o, "encType", E.encType, E, null), $n(s, o, "method", E.method, E, null), $n(s, o, "target", E.target, E, null)));
                if (g == null || typeof g == "symbol" || typeof g == "boolean") {
                    s.removeAttribute(d);
                    break;
                }
                g = Lr("" + g), s.setAttribute(d, g);
                break;
            case "onClick":
                g != null && (s.onclick = ta);
                break;
            case "onScroll":
                g != null && Sn("scroll", s);
                break;
            case "onScrollEnd":
                g != null && Sn("scrollend", s);
                break;
            case "dangerouslySetInnerHTML":
                if (g != null) {
                    if (typeof g != "object" || !("__html" in g)) throw Error(n(61));
                    if (d = g.__html, d != null) {
                        if (E.children != null) throw Error(n(60));
                        s.innerHTML = d;
                    }
                }
                break;
            case "multiple":
                s.multiple = g && typeof g != "function" && typeof g != "symbol";
                break;
            case "muted":
                s.muted = g && typeof g != "function" && typeof g != "symbol";
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (g == null || typeof g == "function" || typeof g == "boolean" || typeof g == "symbol") {
                    s.removeAttribute("xlink:href");
                    break;
                }
                d = Lr("" + g), s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", d);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                g != null && typeof g != "function" && typeof g != "symbol" ? s.setAttribute(d, "" + g) : s.removeAttribute(d);
                break;
            case "inert":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                g && typeof g != "function" && typeof g != "symbol" ? s.setAttribute(d, "") : s.removeAttribute(d);
                break;
            case "capture":
            case "download":
                g === !0 ? s.setAttribute(d, "") : g !== !1 && g != null && typeof g != "function" && typeof g != "symbol" ? s.setAttribute(d, g) : s.removeAttribute(d);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                g != null && typeof g != "function" && typeof g != "symbol" && !isNaN(g) && 1 <= g ? s.setAttribute(d, g) : s.removeAttribute(d);
                break;
            case "rowSpan":
            case "start":
                g == null || typeof g == "function" || typeof g == "symbol" || isNaN(g) ? s.removeAttribute(d) : s.setAttribute(d, g);
                break;
            case "popover":
                Sn("beforetoggle", s), Sn("toggle", s), qt(s, "popover", g);
                break;
            case "xlinkActuate":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:actuate", g);
                break;
            case "xlinkArcrole":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:arcrole", g);
                break;
            case "xlinkRole":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:role", g);
                break;
            case "xlinkShow":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:show", g);
                break;
            case "xlinkTitle":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:title", g);
                break;
            case "xlinkType":
                fn(s, "http://www.w3.org/1999/xlink", "xlink:type", g);
                break;
            case "xmlBase":
                fn(s, "http://www.w3.org/XML/1998/namespace", "xml:base", g);
                break;
            case "xmlLang":
                fn(s, "http://www.w3.org/XML/1998/namespace", "xml:lang", g);
                break;
            case "xmlSpace":
                fn(s, "http://www.w3.org/XML/1998/namespace", "xml:space", g);
                break;
            case "is":
                qt(s, "is", g);
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                (!(2 < d.length) || d[0] !== "o" && d[0] !== "O" || d[1] !== "n" && d[1] !== "N") && (d = Nu.get(d) || d, qt(s, d, g));
        }
    }
    function a1(s, o, d, g, E, w) {
        switch(d){
            case "style":
                Al(s, g, w);
                break;
            case "dangerouslySetInnerHTML":
                if (g != null) {
                    if (typeof g != "object" || !("__html" in g)) throw Error(n(61));
                    if (d = g.__html, d != null) {
                        if (E.children != null) throw Error(n(60));
                        s.innerHTML = d;
                    }
                }
                break;
            case "children":
                typeof g == "string" ? wa(s, g) : (typeof g == "number" || typeof g == "bigint") && wa(s, "" + g);
                break;
            case "onScroll":
                g != null && Sn("scroll", s);
                break;
            case "onScrollEnd":
                g != null && Sn("scrollend", s);
                break;
            case "onClick":
                g != null && (s.onclick = ta);
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                break;
            case "innerText":
            case "textContent":
                break;
            default:
                if (!dt.hasOwnProperty(d)) e: {
                    if (d[0] === "o" && d[1] === "n" && (E = d.endsWith("Capture"), o = d.slice(2, E ? d.length - 7 : void 0), w = s[ci] || null, w = w != null ? w[d] : null, typeof w == "function" && s.removeEventListener(o, w, E), typeof g == "function")) {
                        typeof w != "function" && w !== null && (d in s ? s[d] = null : s.hasAttribute(d) && s.removeAttribute(d)), s.addEventListener(o, g, E);
                        break e;
                    }
                    d in s ? s[d] = g : g === !0 ? s.setAttribute(d, "") : qt(s, d, g);
                }
        }
    }
    function Ba(s, o, d) {
        switch(o){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                Sn("error", s), Sn("load", s);
                var g = !1, E = !1, w;
                for(w in d)if (d.hasOwnProperty(w)) {
                    var V = d[w];
                    if (V != null) switch(w){
                        case "src":
                            g = !0;
                            break;
                        case "srcSet":
                            E = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(n(137, o));
                        default:
                            $n(s, o, w, V, d, null);
                    }
                }
                E && $n(s, o, "srcSet", d.srcSet, d, null), g && $n(s, o, "src", d.src, d, null);
                return;
            case "input":
                Sn("invalid", s);
                var re = w = V = E = null, ge = null, He = null;
                for(g in d)if (d.hasOwnProperty(g)) {
                    var et = d[g];
                    if (et != null) switch(g){
                        case "name":
                            E = et;
                            break;
                        case "type":
                            V = et;
                            break;
                        case "checked":
                            ge = et;
                            break;
                        case "defaultChecked":
                            He = et;
                            break;
                        case "value":
                            w = et;
                            break;
                        case "defaultValue":
                            re = et;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (et != null) throw Error(n(137, o));
                            break;
                        default:
                            $n(s, o, g, et, d, null);
                    }
                }
                On(s, w, re, ge, He, V, E, !1);
                return;
            case "select":
                Sn("invalid", s), g = V = w = null;
                for(E in d)if (d.hasOwnProperty(E) && (re = d[E], re != null)) switch(E){
                    case "value":
                        w = re;
                        break;
                    case "defaultValue":
                        V = re;
                        break;
                    case "multiple":
                        g = re;
                    default:
                        $n(s, o, E, re, d, null);
                }
                o = w, d = V, s.multiple = !!g, o != null ? gi(s, !!g, o, !1) : d != null && gi(s, !!g, d, !0);
                return;
            case "textarea":
                Sn("invalid", s), w = E = g = null;
                for(V in d)if (d.hasOwnProperty(V) && (re = d[V], re != null)) switch(V){
                    case "value":
                        g = re;
                        break;
                    case "defaultValue":
                        E = re;
                        break;
                    case "children":
                        w = re;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (re != null) throw Error(n(91));
                        break;
                    default:
                        $n(s, o, V, re, d, null);
                }
                qn(s, g, E, w);
                return;
            case "option":
                for(ge in d)if (d.hasOwnProperty(ge) && (g = d[ge], g != null)) switch(ge){
                    case "selected":
                        s.selected = g && typeof g != "function" && typeof g != "symbol";
                        break;
                    default:
                        $n(s, o, ge, g, d, null);
                }
                return;
            case "dialog":
                Sn("beforetoggle", s), Sn("toggle", s), Sn("cancel", s), Sn("close", s);
                break;
            case "iframe":
            case "object":
                Sn("load", s);
                break;
            case "video":
            case "audio":
                for(g = 0; g < om.length; g++)Sn(om[g], s);
                break;
            case "image":
                Sn("error", s), Sn("load", s);
                break;
            case "details":
                Sn("toggle", s);
                break;
            case "embed":
            case "source":
            case "link":
                Sn("error", s), Sn("load", s);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(He in d)if (d.hasOwnProperty(He) && (g = d[He], g != null)) switch(He){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(n(137, o));
                    default:
                        $n(s, o, He, g, d, null);
                }
                return;
            default:
                if (ts(o)) {
                    for(et in d)d.hasOwnProperty(et) && (g = d[et], g !== void 0 && a1(s, o, et, g, d, void 0));
                    return;
                }
        }
        for(re in d)d.hasOwnProperty(re) && (g = d[re], g != null && $n(s, o, re, g, d, null));
    }
    function Lw(s, o, d, g) {
        switch(o){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var E = null, w = null, V = null, re = null, ge = null, He = null, et = null;
                for(Qe in d){
                    var ct = d[Qe];
                    if (d.hasOwnProperty(Qe) && ct != null) switch(Qe){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            ge = ct;
                        default:
                            g.hasOwnProperty(Qe) || $n(s, o, Qe, null, g, ct);
                    }
                }
                for(var Xe in g){
                    var Qe = g[Xe];
                    if (ct = d[Xe], g.hasOwnProperty(Xe) && (Qe != null || ct != null)) switch(Xe){
                        case "type":
                            w = Qe;
                            break;
                        case "name":
                            E = Qe;
                            break;
                        case "checked":
                            He = Qe;
                            break;
                        case "defaultChecked":
                            et = Qe;
                            break;
                        case "value":
                            V = Qe;
                            break;
                        case "defaultValue":
                            re = Qe;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (Qe != null) throw Error(n(137, o));
                            break;
                        default:
                            Qe !== ct && $n(s, o, Xe, Qe, g, ct);
                    }
                }
                Or(s, V, re, ge, He, et, w, E);
                return;
            case "select":
                Qe = V = re = Xe = null;
                for(w in d)if (ge = d[w], d.hasOwnProperty(w) && ge != null) switch(w){
                    case "value":
                        break;
                    case "multiple":
                        Qe = ge;
                    default:
                        g.hasOwnProperty(w) || $n(s, o, w, null, g, ge);
                }
                for(E in g)if (w = g[E], ge = d[E], g.hasOwnProperty(E) && (w != null || ge != null)) switch(E){
                    case "value":
                        Xe = w;
                        break;
                    case "defaultValue":
                        re = w;
                        break;
                    case "multiple":
                        V = w;
                    default:
                        w !== ge && $n(s, o, E, w, g, ge);
                }
                o = re, d = V, g = Qe, Xe != null ? gi(s, !!d, Xe, !1) : !!g != !!d && (o != null ? gi(s, !!d, o, !0) : gi(s, !!d, d ? [] : "", !1));
                return;
            case "textarea":
                Qe = Xe = null;
                for(re in d)if (E = d[re], d.hasOwnProperty(re) && E != null && !g.hasOwnProperty(re)) switch(re){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        $n(s, o, re, null, g, E);
                }
                for(V in g)if (E = g[V], w = d[V], g.hasOwnProperty(V) && (E != null || w != null)) switch(V){
                    case "value":
                        Xe = E;
                        break;
                    case "defaultValue":
                        Qe = E;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (E != null) throw Error(n(91));
                        break;
                    default:
                        E !== w && $n(s, o, V, E, g, w);
                }
                fi(s, Xe, Qe);
                return;
            case "option":
                for(var Rt in d)if (Xe = d[Rt], d.hasOwnProperty(Rt) && Xe != null && !g.hasOwnProperty(Rt)) switch(Rt){
                    case "selected":
                        s.selected = !1;
                        break;
                    default:
                        $n(s, o, Rt, null, g, Xe);
                }
                for(ge in g)if (Xe = g[ge], Qe = d[ge], g.hasOwnProperty(ge) && Xe !== Qe && (Xe != null || Qe != null)) switch(ge){
                    case "selected":
                        s.selected = Xe && typeof Xe != "function" && typeof Xe != "symbol";
                        break;
                    default:
                        $n(s, o, ge, Xe, g, Qe);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var kt in d)Xe = d[kt], d.hasOwnProperty(kt) && Xe != null && !g.hasOwnProperty(kt) && $n(s, o, kt, null, g, Xe);
                for(He in g)if (Xe = g[He], Qe = d[He], g.hasOwnProperty(He) && Xe !== Qe && (Xe != null || Qe != null)) switch(He){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (Xe != null) throw Error(n(137, o));
                        break;
                    default:
                        $n(s, o, He, Xe, g, Qe);
                }
                return;
            default:
                if (ts(o)) {
                    for(var ei in d)Xe = d[ei], d.hasOwnProperty(ei) && Xe !== void 0 && !g.hasOwnProperty(ei) && a1(s, o, ei, void 0, g, Xe);
                    for(et in g)Xe = g[et], Qe = d[et], !g.hasOwnProperty(et) || Xe === Qe || Xe === void 0 && Qe === void 0 || a1(s, o, et, Xe, g, Qe);
                    return;
                }
        }
        for(var Ce in d)Xe = d[Ce], d.hasOwnProperty(Ce) && Xe != null && !g.hasOwnProperty(Ce) && $n(s, o, Ce, null, g, Xe);
        for(ct in g)Xe = g[ct], Qe = d[ct], !g.hasOwnProperty(ct) || Xe === Qe || Xe == null && Qe == null || $n(s, o, ct, Xe, g, Qe);
    }
    function FS(s) {
        switch(s){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function zw() {
        if (typeof performance.getEntriesByType == "function") {
            for(var s = 0, o = 0, d = performance.getEntriesByType("resource"), g = 0; g < d.length; g++){
                var E = d[g], w = E.transferSize, V = E.initiatorType, re = E.duration;
                if (w && re && FS(V)) {
                    for(V = 0, re = E.responseEnd, g += 1; g < d.length; g++){
                        var ge = d[g], He = ge.startTime;
                        if (He > re) break;
                        var et = ge.transferSize, ct = ge.initiatorType;
                        et && FS(ct) && (ge = ge.responseEnd, V += et * (ge < re ? 1 : (re - He) / (ge - He)));
                    }
                    if (--g, o += 8 * (w + V) / (E.duration / 1e3), s++, 10 < s) break;
                }
            }
            if (0 < s) return o / s / 1e6;
        }
        return navigator.connection && (s = navigator.connection.downlink, typeof s == "number") ? s : 5;
    }
    var r1 = null, s1 = null;
    function Ug(s) {
        return s.nodeType === 9 ? s : s.ownerDocument;
    }
    function HS(s) {
        switch(s){
            case "http://www.w3.org/2000/svg":
                return 1;
            case "http://www.w3.org/1998/Math/MathML":
                return 2;
            default:
                return 0;
        }
    }
    function VS(s, o) {
        if (s === 0) switch(o){
            case "svg":
                return 1;
            case "math":
                return 2;
            default:
                return 0;
        }
        return s === 1 && o === "foreignObject" ? 0 : s;
    }
    function o1(s, o) {
        return s === "textarea" || s === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.children == "bigint" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
    }
    var l1 = null;
    function Pw() {
        var s = window.event;
        return s && s.type === "popstate" ? s === l1 ? !1 : (l1 = s, !0) : (l1 = null, !1);
    }
    var GS = typeof setTimeout == "function" ? setTimeout : void 0, Bw = typeof clearTimeout == "function" ? clearTimeout : void 0, kS = typeof Promise == "function" ? Promise : void 0, Iw = typeof queueMicrotask == "function" ? queueMicrotask : typeof kS < "u" ? function(s) {
        return kS.resolve(null).then(s).catch(Fw);
    } : GS;
    function Fw(s) {
        setTimeout(function() {
            throw s;
        });
    }
    function ru(s) {
        return s === "head";
    }
    function jS(s, o) {
        var d = o, g = 0;
        do {
            var E = d.nextSibling;
            if (s.removeChild(d), E && E.nodeType === 8) {
                if (d = E.data, d === "/$" || d === "/&") {
                    if (g === 0) {
                        s.removeChild(E), Kh(o);
                        return;
                    }
                    g--;
                } else if (d === "$" || d === "$?" || d === "$~" || d === "$!" || d === "&") g++;
                else if (d === "html") cm(s.ownerDocument.documentElement);
                else if (d === "head") {
                    d = s.ownerDocument.head, cm(d);
                    for(var w = d.firstChild; w;){
                        var V = w.nextSibling, re = w.nodeName;
                        w[es] || re === "SCRIPT" || re === "STYLE" || re === "LINK" && w.rel.toLowerCase() === "stylesheet" || d.removeChild(w), w = V;
                    }
                } else d === "body" && cm(s.ownerDocument.body);
            }
            d = E;
        }while (d);
        Kh(o);
    }
    function XS(s, o) {
        var d = s;
        s = 0;
        do {
            var g = d.nextSibling;
            if (d.nodeType === 1 ? o ? (d._stashedDisplay = d.style.display, d.style.display = "none") : (d.style.display = d._stashedDisplay || "", d.getAttribute("style") === "" && d.removeAttribute("style")) : d.nodeType === 3 && (o ? (d._stashedText = d.nodeValue, d.nodeValue = "") : d.nodeValue = d._stashedText || ""), g && g.nodeType === 8) {
                if (d = g.data, d === "/$") {
                    if (s === 0) break;
                    s--;
                } else d !== "$" && d !== "$?" && d !== "$~" && d !== "$!" || s++;
            }
            d = g;
        }while (d);
    }
    function c1(s) {
        var o = s.firstChild;
        for(o && o.nodeType === 10 && (o = o.nextSibling); o;){
            var d = o;
            switch(o = o.nextSibling, d.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    c1(d), Ms(d);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if (d.rel.toLowerCase() === "stylesheet") continue;
            }
            s.removeChild(d);
        }
    }
    function Hw(s, o, d, g) {
        for(; s.nodeType === 1;){
            var E = d;
            if (s.nodeName.toLowerCase() !== o.toLowerCase()) {
                if (!g && (s.nodeName !== "INPUT" || s.type !== "hidden")) break;
            } else if (g) {
                if (!s[es]) switch(o){
                    case "meta":
                        if (!s.hasAttribute("itemprop")) break;
                        return s;
                    case "link":
                        if (w = s.getAttribute("rel"), w === "stylesheet" && s.hasAttribute("data-precedence")) break;
                        if (w !== E.rel || s.getAttribute("href") !== (E.href == null || E.href === "" ? null : E.href) || s.getAttribute("crossorigin") !== (E.crossOrigin == null ? null : E.crossOrigin) || s.getAttribute("title") !== (E.title == null ? null : E.title)) break;
                        return s;
                    case "style":
                        if (s.hasAttribute("data-precedence")) break;
                        return s;
                    case "script":
                        if (w = s.getAttribute("src"), (w !== (E.src == null ? null : E.src) || s.getAttribute("type") !== (E.type == null ? null : E.type) || s.getAttribute("crossorigin") !== (E.crossOrigin == null ? null : E.crossOrigin)) && w && s.hasAttribute("async") && !s.hasAttribute("itemprop")) break;
                        return s;
                    default:
                        return s;
                }
            } else if (o === "input" && s.type === "hidden") {
                var w = E.name == null ? null : "" + E.name;
                if (E.type === "hidden" && s.getAttribute("name") === w) return s;
            } else return s;
            if (s = Gs(s.nextSibling), s === null) break;
        }
        return null;
    }
    function Vw(s, o, d) {
        if (o === "") return null;
        for(; s.nodeType !== 3;)if ((s.nodeType !== 1 || s.nodeName !== "INPUT" || s.type !== "hidden") && !d || (s = Gs(s.nextSibling), s === null)) return null;
        return s;
    }
    function WS(s, o) {
        for(; s.nodeType !== 8;)if ((s.nodeType !== 1 || s.nodeName !== "INPUT" || s.type !== "hidden") && !o || (s = Gs(s.nextSibling), s === null)) return null;
        return s;
    }
    function u1(s) {
        return s.data === "$?" || s.data === "$~";
    }
    function f1(s) {
        return s.data === "$!" || s.data === "$?" && s.ownerDocument.readyState !== "loading";
    }
    function Gw(s, o) {
        var d = s.ownerDocument;
        if (s.data === "$~") s._reactRetry = o;
        else if (s.data !== "$?" || d.readyState !== "loading") o();
        else {
            var g = function() {
                o(), d.removeEventListener("DOMContentLoaded", g);
            };
            d.addEventListener("DOMContentLoaded", g), s._reactRetry = g;
        }
    }
    function Gs(s) {
        for(; s != null; s = s.nextSibling){
            var o = s.nodeType;
            if (o === 1 || o === 3) break;
            if (o === 8) {
                if (o = s.data, o === "$" || o === "$!" || o === "$?" || o === "$~" || o === "&" || o === "F!" || o === "F") break;
                if (o === "/$" || o === "/&") return null;
            }
        }
        return s;
    }
    var h1 = null;
    function qS(s) {
        s = s.nextSibling;
        for(var o = 0; s;){
            if (s.nodeType === 8) {
                var d = s.data;
                if (d === "/$" || d === "/&") {
                    if (o === 0) return Gs(s.nextSibling);
                    o--;
                } else d !== "$" && d !== "$!" && d !== "$?" && d !== "$~" && d !== "&" || o++;
            }
            s = s.nextSibling;
        }
        return null;
    }
    function YS(s) {
        s = s.previousSibling;
        for(var o = 0; s;){
            if (s.nodeType === 8) {
                var d = s.data;
                if (d === "$" || d === "$!" || d === "$?" || d === "$~" || d === "&") {
                    if (o === 0) return s;
                    o--;
                } else d !== "/$" && d !== "/&" || o++;
            }
            s = s.previousSibling;
        }
        return null;
    }
    function ZS(s, o, d) {
        switch(o = Ug(d), s){
            case "html":
                if (s = o.documentElement, !s) throw Error(n(452));
                return s;
            case "head":
                if (s = o.head, !s) throw Error(n(453));
                return s;
            case "body":
                if (s = o.body, !s) throw Error(n(454));
                return s;
            default:
                throw Error(n(451));
        }
    }
    function cm(s) {
        for(var o = s.attributes; o.length;)s.removeAttributeNode(o[0]);
        Ms(s);
    }
    var ks = new Map, QS = new Set;
    function Ng(s) {
        return typeof s.getRootNode == "function" ? s.getRootNode() : s.nodeType === 9 ? s : s.ownerDocument;
    }
    var rc = Q.d;
    Q.d = {
        f: kw,
        r: jw,
        D: Xw,
        C: Ww,
        L: qw,
        m: Yw,
        X: Qw,
        S: Zw,
        M: Kw
    };
    function kw() {
        var s = rc.f(), o = se();
        return s || o;
    }
    function jw(s) {
        var o = ie(s);
        o !== null && o.tag === 5 && o.type === "form" ? Jp(o) : rc.r(s);
    }
    var Yh = typeof document > "u" ? null : document;
    function KS(s, o, d) {
        var g = Yh;
        if (g && typeof o == "string" && o) {
            var E = hn(o);
            E = 'link[rel="' + s + '"][href="' + E + '"]', typeof d == "string" && (E += '[crossorigin="' + d + '"]'), QS.has(E) || (QS.add(E), s = {
                rel: s,
                crossOrigin: d,
                href: o
            }, g.querySelector(E) === null && (o = g.createElement("link"), Ba(o, "link", s), Pe(o), g.head.appendChild(o)));
        }
    }
    function Xw(s) {
        rc.D(s), KS("dns-prefetch", s, null);
    }
    function Ww(s, o) {
        rc.C(s, o), KS("preconnect", s, o);
    }
    function qw(s, o, d) {
        rc.L(s, o, d);
        var g = Yh;
        if (g && s && o) {
            var E = 'link[rel="preload"][as="' + hn(o) + '"]';
            o === "image" && d && d.imageSrcSet ? (E += '[imagesrcset="' + hn(d.imageSrcSet) + '"]', typeof d.imageSizes == "string" && (E += '[imagesizes="' + hn(d.imageSizes) + '"]')) : E += '[href="' + hn(s) + '"]';
            var w = E;
            switch(o){
                case "style":
                    w = Zh(s);
                    break;
                case "script":
                    w = Qh(s);
            }
            ks.has(w) || (s = x({
                rel: "preload",
                href: o === "image" && d && d.imageSrcSet ? void 0 : s,
                as: o
            }, d), ks.set(w, s), g.querySelector(E) !== null || o === "style" && g.querySelector(um(w)) || o === "script" && g.querySelector(fm(w)) || (o = g.createElement("link"), Ba(o, "link", s), Pe(o), g.head.appendChild(o)));
        }
    }
    function Yw(s, o) {
        rc.m(s, o);
        var d = Yh;
        if (d && s) {
            var g = o && typeof o.as == "string" ? o.as : "script", E = 'link[rel="modulepreload"][as="' + hn(g) + '"][href="' + hn(s) + '"]', w = E;
            switch(g){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    w = Qh(s);
            }
            if (!ks.has(w) && (s = x({
                rel: "modulepreload",
                href: s
            }, o), ks.set(w, s), d.querySelector(E) === null)) {
                switch(g){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        if (d.querySelector(fm(w))) return;
                }
                g = d.createElement("link"), Ba(g, "link", s), Pe(g), d.head.appendChild(g);
            }
        }
    }
    function Zw(s, o, d) {
        rc.S(s, o, d);
        var g = Yh;
        if (g && s) {
            var E = ve(g).hoistableStyles, w = Zh(s);
            o = o || "default";
            var V = E.get(w);
            if (!V) {
                var re = {
                    loading: 0,
                    preload: null
                };
                if (V = g.querySelector(um(w))) re.loading = 5;
                else {
                    s = x({
                        rel: "stylesheet",
                        href: s,
                        "data-precedence": o
                    }, d), (d = ks.get(w)) && d1(s, d);
                    var ge = V = g.createElement("link");
                    Pe(ge), Ba(ge, "link", s), ge._p = new Promise(function(He, et) {
                        ge.onload = He, ge.onerror = et;
                    }), ge.addEventListener("load", function() {
                        re.loading |= 1;
                    }), ge.addEventListener("error", function() {
                        re.loading |= 2;
                    }), re.loading |= 4, Og(V, o, g);
                }
                V = {
                    type: "stylesheet",
                    instance: V,
                    count: 1,
                    state: re
                }, E.set(w, V);
            }
        }
    }
    function Qw(s, o) {
        rc.X(s, o);
        var d = Yh;
        if (d && s) {
            var g = ve(d).hoistableScripts, E = Qh(s), w = g.get(E);
            w || (w = d.querySelector(fm(E)), w || (s = x({
                src: s,
                async: !0
            }, o), (o = ks.get(E)) && p1(s, o), w = d.createElement("script"), Pe(w), Ba(w, "link", s), d.head.appendChild(w)), w = {
                type: "script",
                instance: w,
                count: 1,
                state: null
            }, g.set(E, w));
        }
    }
    function Kw(s, o) {
        rc.M(s, o);
        var d = Yh;
        if (d && s) {
            var g = ve(d).hoistableScripts, E = Qh(s), w = g.get(E);
            w || (w = d.querySelector(fm(E)), w || (s = x({
                src: s,
                async: !0,
                type: "module"
            }, o), (o = ks.get(E)) && p1(s, o), w = d.createElement("script"), Pe(w), Ba(w, "link", s), d.head.appendChild(w)), w = {
                type: "script",
                instance: w,
                count: 1,
                state: null
            }, g.set(E, w));
        }
    }
    function JS(s, o, d, g) {
        var E = (E = ue.current) ? Ng(E) : null;
        if (!E) throw Error(n(446));
        switch(s){
            case "meta":
            case "title":
                return null;
            case "style":
                return typeof d.precedence == "string" && typeof d.href == "string" ? (o = Zh(d.href), d = ve(E).hoistableStyles, g = d.get(o), g || (g = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, d.set(o, g)), g) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if (d.rel === "stylesheet" && typeof d.href == "string" && typeof d.precedence == "string") {
                    s = Zh(d.href);
                    var w = ve(E).hoistableStyles, V = w.get(s);
                    if (V || (E = E.ownerDocument || E, V = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: 0,
                            preload: null
                        }
                    }, w.set(s, V), (w = E.querySelector(um(s))) && !w._p && (V.instance = w, V.state.loading = 5), ks.has(s) || (d = {
                        rel: "preload",
                        as: "style",
                        href: d.href,
                        crossOrigin: d.crossOrigin,
                        integrity: d.integrity,
                        media: d.media,
                        hrefLang: d.hrefLang,
                        referrerPolicy: d.referrerPolicy
                    }, ks.set(s, d), w || Jw(E, s, d, V.state))), o && g === null) throw Error(n(528, ""));
                    return V;
                }
                if (o && g !== null) throw Error(n(529, ""));
                return null;
            case "script":
                return o = d.async, d = d.src, typeof d == "string" && o && typeof o != "function" && typeof o != "symbol" ? (o = Qh(d), d = ve(E).hoistableScripts, g = d.get(o), g || (g = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, d.set(o, g)), g) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error(n(444, s));
        }
    }
    function Zh(s) {
        return 'href="' + hn(s) + '"';
    }
    function um(s) {
        return 'link[rel="stylesheet"][' + s + "]";
    }
    function $S(s) {
        return x({}, s, {
            "data-precedence": s.precedence,
            precedence: null
        });
    }
    function Jw(s, o, d, g) {
        s.querySelector('link[rel="preload"][as="style"][' + o + "]") ? g.loading = 1 : (o = s.createElement("link"), g.preload = o, o.addEventListener("load", function() {
            return g.loading |= 1;
        }), o.addEventListener("error", function() {
            return g.loading |= 2;
        }), Ba(o, "link", d), Pe(o), s.head.appendChild(o));
    }
    function Qh(s) {
        return '[src="' + hn(s) + '"]';
    }
    function fm(s) {
        return "script[async]" + s;
    }
    function e2(s, o, d) {
        if (o.count++, o.instance === null) switch(o.type){
            case "style":
                var g = s.querySelector('style[data-href~="' + hn(d.href) + '"]');
                if (g) return o.instance = g, Pe(g), g;
                var E = x({}, d, {
                    "data-href": d.href,
                    "data-precedence": d.precedence,
                    href: null,
                    precedence: null
                });
                return g = (s.ownerDocument || s).createElement("style"), Pe(g), Ba(g, "style", E), Og(g, d.precedence, s), o.instance = g;
            case "stylesheet":
                E = Zh(d.href);
                var w = s.querySelector(um(E));
                if (w) return o.state.loading |= 4, o.instance = w, Pe(w), w;
                g = $S(d), (E = ks.get(E)) && d1(g, E), w = (s.ownerDocument || s).createElement("link"), Pe(w);
                var V = w;
                return V._p = new Promise(function(re, ge) {
                    V.onload = re, V.onerror = ge;
                }), Ba(w, "link", g), o.state.loading |= 4, Og(w, d.precedence, s), o.instance = w;
            case "script":
                return w = Qh(d.src), (E = s.querySelector(fm(w))) ? (o.instance = E, Pe(E), E) : (g = d, (E = ks.get(w)) && (g = x({}, d), p1(g, E)), s = s.ownerDocument || s, E = s.createElement("script"), Pe(E), Ba(E, "link", g), s.head.appendChild(E), o.instance = E);
            case "void":
                return null;
            default:
                throw Error(n(443, o.type));
        }
        else o.type === "stylesheet" && (o.state.loading & 4) === 0 && (g = o.instance, o.state.loading |= 4, Og(g, d.precedence, s));
        return o.instance;
    }
    function Og(s, o, d) {
        for(var g = d.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), E = g.length ? g[g.length - 1] : null, w = E, V = 0; V < g.length; V++){
            var re = g[V];
            if (re.dataset.precedence === o) w = re;
            else if (w !== E) break;
        }
        w ? w.parentNode.insertBefore(s, w.nextSibling) : (o = d.nodeType === 9 ? d.head : d, o.insertBefore(s, o.firstChild));
    }
    function d1(s, o) {
        s.crossOrigin == null && (s.crossOrigin = o.crossOrigin), s.referrerPolicy == null && (s.referrerPolicy = o.referrerPolicy), s.title == null && (s.title = o.title);
    }
    function p1(s, o) {
        s.crossOrigin == null && (s.crossOrigin = o.crossOrigin), s.referrerPolicy == null && (s.referrerPolicy = o.referrerPolicy), s.integrity == null && (s.integrity = o.integrity);
    }
    var Lg = null;
    function t2(s, o, d) {
        if (Lg === null) {
            var g = new Map, E = Lg = new Map;
            E.set(d, g);
        } else E = Lg, g = E.get(d), g || (g = new Map, E.set(d, g));
        if (g.has(s)) return g;
        for(g.set(s, null), d = d.getElementsByTagName(s), E = 0; E < d.length; E++){
            var w = d[E];
            if (!(w[es] || w[jt] || s === "link" && w.getAttribute("rel") === "stylesheet") && w.namespaceURI !== "http://www.w3.org/2000/svg") {
                var V = w.getAttribute(o) || "";
                V = s + V;
                var re = g.get(V);
                re ? re.push(w) : g.set(V, [
                    w
                ]);
            }
        }
        return g;
    }
    function n2(s, o, d) {
        s = s.ownerDocument || s, s.head.insertBefore(d, o === "title" ? s.querySelector("head > title") : null);
    }
    function $w(s, o, d) {
        if (d === 1 || o.itemProp != null) return !1;
        switch(s){
            case "meta":
            case "title":
                return !0;
            case "style":
                if (typeof o.precedence != "string" || typeof o.href != "string" || o.href === "") break;
                return !0;
            case "link":
                if (typeof o.rel != "string" || typeof o.href != "string" || o.href === "" || o.onLoad || o.onError) break;
                switch(o.rel){
                    case "stylesheet":
                        return s = o.disabled, typeof o.precedence == "string" && s == null;
                    default:
                        return !0;
                }
            case "script":
                if (o.async && typeof o.async != "function" && typeof o.async != "symbol" && !o.onLoad && !o.onError && o.src && typeof o.src == "string") return !0;
        }
        return !1;
    }
    function i2(s) {
        return !(s.type === "stylesheet" && (s.state.loading & 3) === 0);
    }
    function eC(s, o, d, g) {
        if (d.type === "stylesheet" && (typeof g.media != "string" || matchMedia(g.media).matches !== !1) && (d.state.loading & 4) === 0) {
            if (d.instance === null) {
                var E = Zh(g.href), w = o.querySelector(um(E));
                if (w) {
                    o = w._p, o !== null && typeof o == "object" && typeof o.then == "function" && (s.count++, s = zg.bind(s), o.then(s, s)), d.state.loading |= 4, d.instance = w, Pe(w);
                    return;
                }
                w = o.ownerDocument || o, g = $S(g), (E = ks.get(E)) && d1(g, E), w = w.createElement("link"), Pe(w);
                var V = w;
                V._p = new Promise(function(re, ge) {
                    V.onload = re, V.onerror = ge;
                }), Ba(w, "link", g), d.instance = w;
            }
            s.stylesheets === null && (s.stylesheets = new Map), s.stylesheets.set(d, o), (o = d.state.preload) && (d.state.loading & 3) === 0 && (s.count++, d = zg.bind(s), o.addEventListener("load", d), o.addEventListener("error", d));
        }
    }
    var m1 = 0;
    function tC(s, o) {
        return s.stylesheets && s.count === 0 && Bg(s, s.stylesheets), 0 < s.count || 0 < s.imgCount ? function(d) {
            var g = setTimeout(function() {
                if (s.stylesheets && Bg(s, s.stylesheets), s.unsuspend) {
                    var w = s.unsuspend;
                    s.unsuspend = null, w();
                }
            }, 6e4 + o);
            0 < s.imgBytes && m1 === 0 && (m1 = 62500 * zw());
            var E = setTimeout(function() {
                if (s.waitingForImages = !1, s.count === 0 && (s.stylesheets && Bg(s, s.stylesheets), s.unsuspend)) {
                    var w = s.unsuspend;
                    s.unsuspend = null, w();
                }
            }, (s.imgBytes > m1 ? 50 : 800) + o);
            return s.unsuspend = d, function() {
                s.unsuspend = null, clearTimeout(g), clearTimeout(E);
            };
        } : null;
    }
    function zg() {
        if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
            if (this.stylesheets) Bg(this, this.stylesheets);
            else if (this.unsuspend) {
                var s = this.unsuspend;
                this.unsuspend = null, s();
            }
        }
    }
    var Pg = null;
    function Bg(s, o) {
        s.stylesheets = null, s.unsuspend !== null && (s.count++, Pg = new Map, o.forEach(nC, s), Pg = null, zg.call(s));
    }
    function nC(s, o) {
        if (!(o.state.loading & 4)) {
            var d = Pg.get(s);
            if (d) var g = d.get(null);
            else {
                d = new Map, Pg.set(s, d);
                for(var E = s.querySelectorAll("link[data-precedence],style[data-precedence]"), w = 0; w < E.length; w++){
                    var V = E[w];
                    (V.nodeName === "LINK" || V.getAttribute("media") !== "not all") && (d.set(V.dataset.precedence, V), g = V);
                }
                g && d.set(null, g);
            }
            E = o.instance, V = E.getAttribute("data-precedence"), w = d.get(V) || g, w === g && d.set(null, E), d.set(V, E), this.count++, g = zg.bind(this), E.addEventListener("load", g), E.addEventListener("error", g), w ? w.parentNode.insertBefore(E, w.nextSibling) : (s = s.nodeType === 9 ? s.head : s, s.insertBefore(E, s.firstChild)), o.state.loading |= 4;
        }
    }
    var hm = {
        $$typeof: R,
        Provider: null,
        Consumer: null,
        _currentValue: K,
        _currentValue2: K,
        _threadCount: 0
    };
    function iC(s, o, d, g, E, w, V, re, ge) {
        this.tag = 1, this.containerInfo = s, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Ct(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ct(0), this.hiddenUpdates = Ct(null), this.identifierPrefix = g, this.onUncaughtError = E, this.onCaughtError = w, this.onRecoverableError = V, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = ge, this.incompleteTransitions = new Map;
    }
    function a2(s, o, d, g, E, w, V, re, ge, He, et, ct) {
        return s = new iC(s, o, d, V, ge, He, et, ct, re), o = 1, w === !0 && (o |= 24), w = Ua(3, null, null, o), s.current = w, w.stateNode = s, o = _p(), o.refCount++, s.pooledCache = o, o.refCount++, w.memoizedState = {
            element: g,
            isDehydrated: d,
            cache: o
        }, Ap(w), s;
    }
    function r2(s) {
        return s ? (s = Yo, s) : Yo;
    }
    function s2(s, o, d, g, E, w) {
        E = r2(E), g.context === null ? g.context = E : g.pendingContext = E, g = Os(o), g.payload = {
            element: d
        }, w = w === void 0 ? null : w, w !== null && (g.callback = w), d = uo(s, g, o), d !== null && (h(d, s, o), nl(d, s, o));
    }
    function o2(s, o) {
        if (s = s.memoizedState, s !== null && s.dehydrated !== null) {
            var d = s.retryLane;
            s.retryLane = d !== 0 && d < o ? d : o;
        }
    }
    function g1(s, o) {
        o2(s, o), (s = s.alternate) && o2(s, o);
    }
    function l2(s) {
        if (s.tag === 13 || s.tag === 31) {
            var o = qo(s, 67108864);
            o !== null && h(o, s, 67108864), g1(s, 67108864);
        }
    }
    function c2(s) {
        if (s.tag === 13 || s.tag === 31) {
            var o = Pa();
            o = jn(o);
            var d = qo(s, o);
            d !== null && h(d, s, o), g1(s, o);
        }
    }
    var Ig = !0;
    function aC(s, o, d, g) {
        var E = F.T;
        F.T = null;
        var w = Q.p;
        try {
            Q.p = 2, x1(s, o, d, g);
        } finally{
            Q.p = w, F.T = E;
        }
    }
    function rC(s, o, d, g) {
        var E = F.T;
        F.T = null;
        var w = Q.p;
        try {
            Q.p = 8, x1(s, o, d, g);
        } finally{
            Q.p = w, F.T = E;
        }
    }
    function x1(s, o, d, g) {
        if (Ig) {
            var E = v1(g);
            if (E === null) i1(s, o, g, Fg, d), f2(s, g);
            else if (oC(E, s, o, d, g)) g.stopPropagation();
            else if (f2(s, g), o & 4 && -1 < sC.indexOf(s)) {
                for(; E !== null;){
                    var w = ie(E);
                    if (w !== null) switch(w.tag){
                        case 3:
                            if (w = w.stateNode, w.current.memoizedState.isDehydrated) {
                                var V = Ke(w.pendingLanes);
                                if (V !== 0) {
                                    var re = w;
                                    for(re.pendingLanes |= 2, re.entangledLanes |= 2; V;){
                                        var ge = 1 << 31 - he(V);
                                        re.entanglements[1] |= ge, V &= ~ge;
                                    }
                                    fl(w), (Mn & 6) === 0 && (Er = W() + 500, sm(0));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            re = qo(w, 2), re !== null && h(re, w, 2), se(), g1(w, 2);
                    }
                    if (w = v1(g), w === null && i1(s, o, g, Fg, d), w === E) break;
                    E = w;
                }
                E !== null && g.stopPropagation();
            } else i1(s, o, g, null, d);
        }
    }
    function v1(s) {
        return s = Cl(s), y1(s);
    }
    var Fg = null;
    function y1(s) {
        if (Fg = null, s = Qn(s), s !== null) {
            var o = r(s);
            if (o === null) s = null;
            else {
                var d = o.tag;
                if (d === 13) {
                    if (s = l(o), s !== null) return s;
                    s = null;
                } else if (d === 31) {
                    if (s = c(o), s !== null) return s;
                    s = null;
                } else if (d === 3) {
                    if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
                    s = null;
                } else o !== s && (s = null);
            }
        }
        return Fg = s, null;
    }
    function u2(s) {
        switch(s){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return 2;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return 8;
            case "message":
                switch(pe()){
                    case Be:
                        return 2;
                    case Te:
                        return 8;
                    case _e:
                    case ot:
                        return 32;
                    case tt:
                        return 268435456;
                    default:
                        return 32;
                }
            default:
                return 32;
        }
    }
    var _1 = !1, su = null, ou = null, lu = null, dm = new Map, pm = new Map, cu = [], sC = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
    function f2(s, o) {
        switch(s){
            case "focusin":
            case "focusout":
                su = null;
                break;
            case "dragenter":
            case "dragleave":
                ou = null;
                break;
            case "mouseover":
            case "mouseout":
                lu = null;
                break;
            case "pointerover":
            case "pointerout":
                dm.delete(o.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                pm.delete(o.pointerId);
        }
    }
    function mm(s, o, d, g, E, w) {
        return s === null || s.nativeEvent !== w ? (s = {
            blockedOn: o,
            domEventName: d,
            eventSystemFlags: g,
            nativeEvent: w,
            targetContainers: [
                E
            ]
        }, o !== null && (o = ie(o), o !== null && l2(o)), s) : (s.eventSystemFlags |= g, o = s.targetContainers, E !== null && o.indexOf(E) === -1 && o.push(E), s);
    }
    function oC(s, o, d, g, E) {
        switch(o){
            case "focusin":
                return su = mm(su, s, o, d, g, E), !0;
            case "dragenter":
                return ou = mm(ou, s, o, d, g, E), !0;
            case "mouseover":
                return lu = mm(lu, s, o, d, g, E), !0;
            case "pointerover":
                var w = E.pointerId;
                return dm.set(w, mm(dm.get(w) || null, s, o, d, g, E)), !0;
            case "gotpointercapture":
                return w = E.pointerId, pm.set(w, mm(pm.get(w) || null, s, o, d, g, E)), !0;
        }
        return !1;
    }
    function h2(s) {
        var o = Qn(s.target);
        if (o !== null) {
            var d = r(o);
            if (d !== null) {
                if (o = d.tag, o === 13) {
                    if (o = l(d), o !== null) {
                        s.blockedOn = o, hi(s.priority, function() {
                            c2(d);
                        });
                        return;
                    }
                } else if (o === 31) {
                    if (o = c(d), o !== null) {
                        s.blockedOn = o, hi(s.priority, function() {
                            c2(d);
                        });
                        return;
                    }
                } else if (o === 3 && d.stateNode.current.memoizedState.isDehydrated) {
                    s.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        s.blockedOn = null;
    }
    function Hg(s) {
        if (s.blockedOn !== null) return !1;
        for(var o = s.targetContainers; 0 < o.length;){
            var d = v1(s.nativeEvent);
            if (d === null) {
                d = s.nativeEvent;
                var g = new d.constructor(d.type, d);
                ns = g, d.target.dispatchEvent(g), ns = null;
            } else return o = ie(d), o !== null && l2(o), s.blockedOn = d, !1;
            o.shift();
        }
        return !0;
    }
    function d2(s, o, d) {
        Hg(s) && d.delete(o);
    }
    function lC() {
        _1 = !1, su !== null && Hg(su) && (su = null), ou !== null && Hg(ou) && (ou = null), lu !== null && Hg(lu) && (lu = null), dm.forEach(d2), pm.forEach(d2);
    }
    function Vg(s, o) {
        s.blockedOn === o && (s.blockedOn = null, _1 || (_1 = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, lC)));
    }
    var Gg = null;
    function p2(s) {
        Gg !== s && (Gg = s, a.unstable_scheduleCallback(a.unstable_NormalPriority, function() {
            Gg === s && (Gg = null);
            for(var o = 0; o < s.length; o += 3){
                var d = s[o], g = s[o + 1], E = s[o + 2];
                if (typeof g != "function") {
                    if (y1(g || d) === null) continue;
                    break;
                }
                var w = ie(d);
                w !== null && (s.splice(o, 3), o -= 3, Kp(w, {
                    pending: !0,
                    data: E,
                    method: d.method,
                    action: g
                }, g, E));
            }
        }));
    }
    function Kh(s) {
        function o(ge) {
            return Vg(ge, s);
        }
        su !== null && Vg(su, s), ou !== null && Vg(ou, s), lu !== null && Vg(lu, s), dm.forEach(o), pm.forEach(o);
        for(var d = 0; d < cu.length; d++){
            var g = cu[d];
            g.blockedOn === s && (g.blockedOn = null);
        }
        for(; 0 < cu.length && (d = cu[0], d.blockedOn === null);)h2(d), d.blockedOn === null && cu.shift();
        if (d = (s.ownerDocument || s).$$reactFormReplay, d != null) for(g = 0; g < d.length; g += 3){
            var E = d[g], w = d[g + 1], V = E[ci] || null;
            if (typeof w == "function") V || p2(d);
            else if (V) {
                var re = null;
                if (w && w.hasAttribute("formAction")) {
                    if (E = w, V = w[ci] || null) re = V.formAction;
                    else if (y1(E) !== null) continue;
                } else re = V.action;
                typeof re == "function" ? d[g + 1] = re : (d.splice(g, 3), g -= 3), p2(d);
            }
        }
    }
    function m2() {
        function s(w) {
            w.canIntercept && w.info === "react-transition" && w.intercept({
                handler: function() {
                    return new Promise(function(V) {
                        return E = V;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function o() {
            E !== null && (E(), E = null), g || setTimeout(d, 20);
        }
        function d() {
            if (!g && !navigation.transition) {
                var w = navigation.currentEntry;
                w && w.url != null && navigation.navigate(w.url, {
                    state: w.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if (typeof navigation == "object") {
            var g = !1, E = null;
            return navigation.addEventListener("navigate", s), navigation.addEventListener("navigatesuccess", o), navigation.addEventListener("navigateerror", o), setTimeout(d, 100), function() {
                g = !0, navigation.removeEventListener("navigate", s), navigation.removeEventListener("navigatesuccess", o), navigation.removeEventListener("navigateerror", o), E !== null && (E(), E = null);
            };
        }
    }
    function b1(s) {
        this._internalRoot = s;
    }
    kg.prototype.render = b1.prototype.render = function(s) {
        var o = this._internalRoot;
        if (o === null) throw Error(n(409));
        var d = o.current, g = Pa();
        s2(d, g, s, o, null, null);
    }, kg.prototype.unmount = b1.prototype.unmount = function() {
        var s = this._internalRoot;
        if (s !== null) {
            this._internalRoot = null;
            var o = s.containerInfo;
            s2(s.current, 2, null, s, null, null), se(), o[Aa] = null;
        }
    };
    function kg(s) {
        this._internalRoot = s;
    }
    kg.prototype.unstable_scheduleHydration = function(s) {
        if (s) {
            var o = Pi();
            s = {
                blockedOn: null,
                target: s,
                priority: o
            };
            for(var d = 0; d < cu.length && o !== 0 && o < cu[d].priority; d++);
            cu.splice(d, 0, s), d === 0 && h2(s);
        }
    };
    var g2 = e.version;
    if (g2 !== "19.2.0") throw Error(n(527, g2, "19.2.0"));
    Q.findDOMNode = function(s) {
        var o = s._reactInternals;
        if (o === void 0) throw typeof s.render == "function" ? Error(n(188)) : (s = Object.keys(s).join(","), Error(n(268, s)));
        return s = p(o), s = s !== null ? m(s) : null, s = s === null ? null : s.stateNode, s;
    };
    var cC = {
        bundleType: 0,
        version: "19.2.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: F,
        reconcilerVersion: "19.2.0"
    };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
        var jg = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (!jg.isDisabled && jg.supportsFiber) try {
            Ge = jg.inject(cC), Ye = jg;
        } catch  {}
    }
    return $455d545b1dff00eb$var$xm.createRoot = function(s, o) {
        if (!i(s)) throw Error(n(299));
        var d = !1, g = "", E = tm, w = Sg, V = Lh;
        return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (g = o.identifierPrefix), o.onUncaughtError !== void 0 && (E = o.onUncaughtError), o.onCaughtError !== void 0 && (w = o.onCaughtError), o.onRecoverableError !== void 0 && (V = o.onRecoverableError)), o = a2(s, 1, !1, null, null, d, g, null, E, w, V, m2), s[Aa] = o.current, n1(s), new b1(o);
    }, $455d545b1dff00eb$var$xm.hydrateRoot = function(s, o, d) {
        if (!i(s)) throw Error(n(299));
        var g = !1, E = "", w = tm, V = Sg, re = Lh, ge = null;
        return d != null && (d.unstable_strictMode === !0 && (g = !0), d.identifierPrefix !== void 0 && (E = d.identifierPrefix), d.onUncaughtError !== void 0 && (w = d.onUncaughtError), d.onCaughtError !== void 0 && (V = d.onCaughtError), d.onRecoverableError !== void 0 && (re = d.onRecoverableError), d.formState !== void 0 && (ge = d.formState)), o = a2(s, 1, !0, o, d ?? null, g, E, ge, w, V, re, m2), o.context = r2(null), d = o.current, g = Pa(), g = jn(g), E = Os(g), E.callback = null, uo(d, E, g), d = g, o.current.lanes = d, on(o, d), fl(o), s[Aa] = o.current, n1(s), new kg(o);
    }, $455d545b1dff00eb$var$xm.version = "19.2.0", $455d545b1dff00eb$var$xm;
}
var $455d545b1dff00eb$var$A2;
function $455d545b1dff00eb$var$yC() {
    if ($455d545b1dff00eb$var$A2) return $455d545b1dff00eb$var$E1.exports;
    $455d545b1dff00eb$var$A2 = 1;
    function a() {
        if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
            __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
        } catch (e) {
            console.error(e);
        }
    }
    return a(), $455d545b1dff00eb$var$E1.exports = $455d545b1dff00eb$var$vC(), $455d545b1dff00eb$var$E1.exports;
}
var $455d545b1dff00eb$var$dE = $455d545b1dff00eb$var$yC();
var $455d545b1dff00eb$var$w2 = "popstate";
function $455d545b1dff00eb$var$_C(a = {}) {
    function e(i, r) {
        let { pathname: l = "/", search: c = "", hash: f = "" } = $455d545b1dff00eb$var$Qf(i.location.hash.substring(1));
        return !l.startsWith("/") && !l.startsWith(".") && (l = "/" + l), $455d545b1dff00eb$var$k_("", {
            pathname: l,
            search: c,
            hash: f
        }, r.state && r.state.usr || null, r.state && r.state.key || "default");
    }
    function t(i, r) {
        let l = i.document.querySelector("base"), c = "";
        if (l && l.getAttribute("href")) {
            let f = i.location.href, p = f.indexOf("#");
            c = p === -1 ? f : f.slice(0, p);
        }
        return c + "#" + (typeof r == "string" ? r : $455d545b1dff00eb$var$Km(r));
    }
    function n(i, r) {
        $455d545b1dff00eb$var$Uo(i.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(r)})`);
    }
    return $455d545b1dff00eb$var$SC(e, t, n, a);
}
function $455d545b1dff00eb$var$Oi(a, e) {
    if (a === !1 || a === null || typeof a > "u") throw new Error(e);
}
function $455d545b1dff00eb$var$Uo(a, e) {
    if (!a) {
        typeof console < "u" && console.warn(e);
        try {
            throw new Error(e);
        } catch  {}
    }
}
function $455d545b1dff00eb$var$bC() {
    return Math.random().toString(36).substring(2, 10);
}
function $455d545b1dff00eb$var$C2(a, e) {
    return {
        usr: a.state,
        key: a.key,
        idx: e
    };
}
function $455d545b1dff00eb$var$k_(a, e, t = null, n) {
    return {
        pathname: typeof a == "string" ? a : a.pathname,
        search: "",
        hash: "",
        ...typeof e == "string" ? $455d545b1dff00eb$var$Qf(e) : e,
        state: t,
        key: e && e.key || n || $455d545b1dff00eb$var$bC()
    };
}
function $455d545b1dff00eb$var$Km({ pathname: a = "/", search: e = "", hash: t = "" }) {
    return e && e !== "?" && (a += e.charAt(0) === "?" ? e : "?" + e), t && t !== "#" && (a += t.charAt(0) === "#" ? t : "#" + t), a;
}
function $455d545b1dff00eb$var$Qf(a) {
    let e = {};
    if (a) {
        let t = a.indexOf("#");
        t >= 0 && (e.hash = a.substring(t), a = a.substring(0, t));
        let n = a.indexOf("?");
        n >= 0 && (e.search = a.substring(n), a = a.substring(0, n)), a && (e.pathname = a);
    }
    return e;
}
function $455d545b1dff00eb$var$SC(a, e, t, n = {}) {
    let { window: i = document.defaultView, v5Compat: r = !1 } = n, l = i.history, c = "POP", f = null, p = m();
    p == null && (p = 0, l.replaceState({
        ...l.state,
        idx: p
    }, ""));
    function m() {
        return (l.state || {
            idx: null
        }).idx;
    }
    function x() {
        c = "POP";
        let M = m(), b = M == null ? null : M - p;
        p = M, f && f({
            action: c,
            location: A.location,
            delta: b
        });
    }
    function v(M, b) {
        c = "PUSH";
        let C = $455d545b1dff00eb$var$k_(A.location, M, b);
        t && t(C, M), p = m() + 1;
        let R = $455d545b1dff00eb$var$C2(C, p), N = A.createHref(C);
        try {
            l.pushState(R, "", N);
        } catch (z) {
            if (z instanceof DOMException && z.name === "DataCloneError") throw z;
            i.location.assign(N);
        }
        r && f && f({
            action: c,
            location: A.location,
            delta: 1
        });
    }
    function _(M, b) {
        c = "REPLACE";
        let C = $455d545b1dff00eb$var$k_(A.location, M, b);
        t && t(C, M), p = m();
        let R = $455d545b1dff00eb$var$C2(C, p), N = A.createHref(C);
        l.replaceState(R, "", N), r && f && f({
            action: c,
            location: A.location,
            delta: 0
        });
    }
    function S(M) {
        return $455d545b1dff00eb$var$MC(M);
    }
    let A = {
        get action () {
            return c;
        },
        get location () {
            return a(i, l);
        },
        listen (M) {
            if (f) throw new Error("A history only accepts one active listener");
            return i.addEventListener($455d545b1dff00eb$var$w2, x), f = M, ()=>{
                i.removeEventListener($455d545b1dff00eb$var$w2, x), f = null;
            };
        },
        createHref (M) {
            return e(i, M);
        },
        createURL: S,
        encodeLocation (M) {
            let b = S(M);
            return {
                pathname: b.pathname,
                search: b.search,
                hash: b.hash
            };
        },
        push: v,
        replace: _,
        go (M) {
            return l.go(M);
        }
    };
    return A;
}
function $455d545b1dff00eb$var$MC(a, e = !1) {
    let t = "http://localhost";
    typeof window < "u" && (t = window.location.origin !== "null" ? window.location.origin : window.location.href), $455d545b1dff00eb$var$Oi(t, "No window.location.(origin|href) available to create URL");
    let n = typeof a == "string" ? a : $455d545b1dff00eb$var$Km(a);
    return n = n.replace(/ $/, "%20"), !e && n.startsWith("//") && (n = t + n), new URL(n, t);
}
function $455d545b1dff00eb$var$pE(a, e, t = "/") {
    return $455d545b1dff00eb$var$EC(a, e, t, !1);
}
function $455d545b1dff00eb$var$EC(a, e, t, n) {
    let i = typeof e == "string" ? $455d545b1dff00eb$var$Qf(e) : e, r = $455d545b1dff00eb$var$_c(i.pathname || "/", t);
    if (r == null) return null;
    let l = $455d545b1dff00eb$var$mE(a);
    $455d545b1dff00eb$var$TC(l);
    let c = null;
    for(let f = 0; c == null && f < l.length; ++f){
        let p = $455d545b1dff00eb$var$PC(r);
        c = $455d545b1dff00eb$var$LC(l[f], p, n);
    }
    return c;
}
function $455d545b1dff00eb$var$mE(a, e = [], t = [], n = "", i = !1) {
    let r = (l, c, f = i, p)=>{
        let m = {
            relativePath: p === void 0 ? l.path || "" : p,
            caseSensitive: l.caseSensitive === !0,
            childrenIndex: c,
            route: l
        };
        if (m.relativePath.startsWith("/")) {
            if (!m.relativePath.startsWith(n) && f) return;
            $455d545b1dff00eb$var$Oi(m.relativePath.startsWith(n), `Absolute route path "${m.relativePath}" nested under path "${n}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`), m.relativePath = m.relativePath.slice(n.length);
        }
        let x = $455d545b1dff00eb$var$vc([
            n,
            m.relativePath
        ]), v = t.concat(m);
        l.children && l.children.length > 0 && ($455d545b1dff00eb$var$Oi(l.index !== !0, `Index routes must not have child routes. Please remove all child routes from route path "${x}".`), $455d545b1dff00eb$var$mE(l.children, e, v, x, f)), !(l.path == null && !l.index) && e.push({
            path: x,
            score: $455d545b1dff00eb$var$NC(x, l.index),
            routesMeta: v
        });
    };
    return a.forEach((l, c)=>{
        if (l.path === "" || !l.path?.includes("?")) r(l, c);
        else for (let f of $455d545b1dff00eb$var$gE(l.path))r(l, c, !0, f);
    }), e;
}
function $455d545b1dff00eb$var$gE(a) {
    let e = a.split("/");
    if (e.length === 0) return [];
    let [t, ...n] = e, i = t.endsWith("?"), r = t.replace(/\?$/, "");
    if (n.length === 0) return i ? [
        r,
        ""
    ] : [
        r
    ];
    let l = $455d545b1dff00eb$var$gE(n.join("/")), c = [];
    return c.push(...l.map((f)=>f === "" ? r : [
            r,
            f
        ].join("/"))), i && c.push(...l), c.map((f)=>a.startsWith("/") && f === "" ? "/" : f);
}
function $455d545b1dff00eb$var$TC(a) {
    a.sort((e, t)=>e.score !== t.score ? t.score - e.score : $455d545b1dff00eb$var$OC(e.routesMeta.map((n)=>n.childrenIndex), t.routesMeta.map((n)=>n.childrenIndex)));
}
var $455d545b1dff00eb$var$AC = /^:[\w-]+$/, $455d545b1dff00eb$var$wC = 3, $455d545b1dff00eb$var$CC = 2, $455d545b1dff00eb$var$RC = 1, $455d545b1dff00eb$var$DC = 10, $455d545b1dff00eb$var$UC = -2, $455d545b1dff00eb$var$R2 = (a)=>a === "*";
function $455d545b1dff00eb$var$NC(a, e) {
    let t = a.split("/"), n = t.length;
    return t.some($455d545b1dff00eb$var$R2) && (n += $455d545b1dff00eb$var$UC), e && (n += $455d545b1dff00eb$var$CC), t.filter((i)=>!$455d545b1dff00eb$var$R2(i)).reduce((i, r)=>i + ($455d545b1dff00eb$var$AC.test(r) ? $455d545b1dff00eb$var$wC : r === "" ? $455d545b1dff00eb$var$RC : $455d545b1dff00eb$var$DC), n);
}
function $455d545b1dff00eb$var$OC(a, e) {
    return a.length === e.length && a.slice(0, -1).every((n, i)=>n === e[i]) ? a[a.length - 1] - e[e.length - 1] : 0;
}
function $455d545b1dff00eb$var$LC(a, e, t = !1) {
    let { routesMeta: n } = a, i = {}, r = "/", l = [];
    for(let c = 0; c < n.length; ++c){
        let f = n[c], p = c === n.length - 1, m = r === "/" ? e : e.slice(r.length) || "/", x = $455d545b1dff00eb$var$ev({
            path: f.relativePath,
            caseSensitive: f.caseSensitive,
            end: p
        }, m), v = f.route;
        if (!x && p && t && !n[n.length - 1].route.index && (x = $455d545b1dff00eb$var$ev({
            path: f.relativePath,
            caseSensitive: f.caseSensitive,
            end: !1
        }, m)), !x) return null;
        Object.assign(i, x.params), l.push({
            params: i,
            pathname: $455d545b1dff00eb$var$vc([
                r,
                x.pathname
            ]),
            pathnameBase: $455d545b1dff00eb$var$HC($455d545b1dff00eb$var$vc([
                r,
                x.pathnameBase
            ])),
            route: v
        }), x.pathnameBase !== "/" && (r = $455d545b1dff00eb$var$vc([
            r,
            x.pathnameBase
        ]));
    }
    return l;
}
function $455d545b1dff00eb$var$ev(a, e) {
    typeof a == "string" && (a = {
        path: a,
        caseSensitive: !1,
        end: !0
    });
    let [t, n] = $455d545b1dff00eb$var$zC(a.path, a.caseSensitive, a.end), i = e.match(t);
    if (!i) return null;
    let r = i[0], l = r.replace(/(.)\/+$/, "$1"), c = i.slice(1);
    return {
        params: n.reduce((p, { paramName: m, isOptional: x }, v)=>{
            if (m === "*") {
                let S = c[v] || "";
                l = r.slice(0, r.length - S.length).replace(/(.)\/+$/, "$1");
            }
            const _ = c[v];
            return x && !_ ? p[m] = void 0 : p[m] = (_ || "").replace(/%2F/g, "/"), p;
        }, {}),
        pathname: r,
        pathnameBase: l,
        pattern: a
    };
}
function $455d545b1dff00eb$var$zC(a, e = !1, t = !0) {
    $455d545b1dff00eb$var$Uo(a === "*" || !a.endsWith("*") || a.endsWith("/*"), `Route path "${a}" will be treated as if it were "${a.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${a.replace(/\*$/, "/*")}".`);
    let n = [], i = "^" + a.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (l, c, f)=>(n.push({
            paramName: c,
            isOptional: f != null
        }), f ? "/?([^\\/]+)?" : "/([^\\/]+)")).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    return a.endsWith("*") ? (n.push({
        paramName: "*"
    }), i += a === "*" || a === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : t ? i += "\\/*$" : a !== "" && a !== "/" && (i += "(?:(?=\\/|$))"), [
        new RegExp(i, e ? void 0 : "i"),
        n
    ];
}
function $455d545b1dff00eb$var$PC(a) {
    try {
        return a.split("/").map((e)=>decodeURIComponent(e).replace(/\//g, "%2F")).join("/");
    } catch (e) {
        return $455d545b1dff00eb$var$Uo(!1, `The URL path "${a}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${e}).`), a;
    }
}
function $455d545b1dff00eb$var$_c(a, e) {
    if (e === "/") return a;
    if (!a.toLowerCase().startsWith(e.toLowerCase())) return null;
    let t = e.endsWith("/") ? e.length - 1 : e.length, n = a.charAt(t);
    return n && n !== "/" ? null : a.slice(t) || "/";
}
function $455d545b1dff00eb$var$BC(a, e = "/") {
    let { pathname: t, search: n = "", hash: i = "" } = typeof a == "string" ? $455d545b1dff00eb$var$Qf(a) : a;
    return {
        pathname: t ? t.startsWith("/") ? t : $455d545b1dff00eb$var$IC(t, e) : e,
        search: $455d545b1dff00eb$var$VC(n),
        hash: $455d545b1dff00eb$var$GC(i)
    };
}
function $455d545b1dff00eb$var$IC(a, e) {
    let t = e.replace(/\/+$/, "").split("/");
    return a.split("/").forEach((i)=>{
        i === ".." ? t.length > 1 && t.pop() : i !== "." && t.push(i);
    }), t.length > 1 ? t.join("/") : "/";
}
function $455d545b1dff00eb$var$C1(a, e, t, n) {
    return `Cannot include a '${a}' character in a manually specified \`to.${e}\` field [${JSON.stringify(n)}].  Please separate it out to the \`to.${t}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $455d545b1dff00eb$var$FC(a) {
    return a.filter((e, t)=>t === 0 || e.route.path && e.route.path.length > 0);
}
function $455d545b1dff00eb$var$xE(a) {
    let e = $455d545b1dff00eb$var$FC(a);
    return e.map((t, n)=>n === e.length - 1 ? t.pathname : t.pathnameBase);
}
function $455d545b1dff00eb$var$vE(a, e, t, n = !1) {
    let i;
    typeof a == "string" ? i = $455d545b1dff00eb$var$Qf(a) : (i = {
        ...a
    }, $455d545b1dff00eb$var$Oi(!i.pathname || !i.pathname.includes("?"), $455d545b1dff00eb$var$C1("?", "pathname", "search", i)), $455d545b1dff00eb$var$Oi(!i.pathname || !i.pathname.includes("#"), $455d545b1dff00eb$var$C1("#", "pathname", "hash", i)), $455d545b1dff00eb$var$Oi(!i.search || !i.search.includes("#"), $455d545b1dff00eb$var$C1("#", "search", "hash", i)));
    let r = a === "" || i.pathname === "", l = r ? "/" : i.pathname, c;
    if (l == null) c = t;
    else {
        let x = e.length - 1;
        if (!n && l.startsWith("..")) {
            let v = l.split("/");
            for(; v[0] === "..";)v.shift(), x -= 1;
            i.pathname = v.join("/");
        }
        c = x >= 0 ? e[x] : "/";
    }
    let f = $455d545b1dff00eb$var$BC(i, c), p = l && l !== "/" && l.endsWith("/"), m = (r || l === ".") && t.endsWith("/");
    return !f.pathname.endsWith("/") && (p || m) && (f.pathname += "/"), f;
}
var $455d545b1dff00eb$var$vc = (a)=>a.join("/").replace(/\/\/+/g, "/"), $455d545b1dff00eb$var$HC = (a)=>a.replace(/\/+$/, "").replace(/^\/*/, "/"), $455d545b1dff00eb$var$VC = (a)=>!a || a === "?" ? "" : a.startsWith("?") ? a : "?" + a, $455d545b1dff00eb$var$GC = (a)=>!a || a === "#" ? "" : a.startsWith("#") ? a : "#" + a;
function $455d545b1dff00eb$var$kC(a) {
    return a != null && typeof a.status == "number" && typeof a.statusText == "string" && typeof a.internal == "boolean" && "data" in a;
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
var $455d545b1dff00eb$var$yE = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
new Set($455d545b1dff00eb$var$yE);
var $455d545b1dff00eb$var$jC = [
    "GET",
    ...$455d545b1dff00eb$var$yE
];
new Set($455d545b1dff00eb$var$jC);
var $455d545b1dff00eb$var$Xd = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$Xd.displayName = "DataRouter";
var $455d545b1dff00eb$var$Qv = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$Qv.displayName = "DataRouterState";
$455d545b1dff00eb$var$X.createContext(!1);
var $455d545b1dff00eb$var$_E = $455d545b1dff00eb$var$X.createContext({
    isTransitioning: !1
});
$455d545b1dff00eb$var$_E.displayName = "ViewTransition";
var $455d545b1dff00eb$var$XC = $455d545b1dff00eb$var$X.createContext(new Map);
$455d545b1dff00eb$var$XC.displayName = "Fetchers";
var $455d545b1dff00eb$var$WC = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$WC.displayName = "Await";
var $455d545b1dff00eb$var$Sl = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$Sl.displayName = "Navigation";
var $455d545b1dff00eb$var$y0 = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$y0.displayName = "Location";
var $455d545b1dff00eb$var$Tc = $455d545b1dff00eb$var$X.createContext({
    outlet: null,
    matches: [],
    isDataRoute: !1
});
$455d545b1dff00eb$var$Tc.displayName = "Route";
var $455d545b1dff00eb$var$Eb = $455d545b1dff00eb$var$X.createContext(null);
$455d545b1dff00eb$var$Eb.displayName = "RouteError";
function $455d545b1dff00eb$var$qC(a, { relative: e } = {}) {
    $455d545b1dff00eb$var$Oi($455d545b1dff00eb$var$_0(), "useHref() may be used only in the context of a <Router> component.");
    let { basename: t, navigator: n } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), { hash: i, pathname: r, search: l } = $455d545b1dff00eb$var$b0(a, {
        relative: e
    }), c = r;
    return t !== "/" && (c = r === "/" ? t : $455d545b1dff00eb$var$vc([
        t,
        r
    ])), n.createHref({
        pathname: c,
        search: l,
        hash: i
    });
}
function $455d545b1dff00eb$var$_0() {
    return $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$y0) != null;
}
function $455d545b1dff00eb$var$Au() {
    return $455d545b1dff00eb$var$Oi($455d545b1dff00eb$var$_0(), "useLocation() may be used only in the context of a <Router> component."), $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$y0).location;
}
var $455d545b1dff00eb$var$bE = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function $455d545b1dff00eb$var$SE(a) {
    $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl).static || $455d545b1dff00eb$var$X.useLayoutEffect(a);
}
function $455d545b1dff00eb$var$YC() {
    let { isDataRoute: a } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc);
    return a ? $455d545b1dff00eb$var$oR() : $455d545b1dff00eb$var$ZC();
}
function $455d545b1dff00eb$var$ZC() {
    $455d545b1dff00eb$var$Oi($455d545b1dff00eb$var$_0(), "useNavigate() may be used only in the context of a <Router> component.");
    let a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Xd), { basename: e, navigator: t } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), { matches: n } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc), { pathname: i } = $455d545b1dff00eb$var$Au(), r = JSON.stringify($455d545b1dff00eb$var$xE(n)), l = $455d545b1dff00eb$var$X.useRef(!1);
    return $455d545b1dff00eb$var$SE(()=>{
        l.current = !0;
    }), $455d545b1dff00eb$var$X.useCallback((f, p = {})=>{
        if ($455d545b1dff00eb$var$Uo(l.current, $455d545b1dff00eb$var$bE), !l.current) return;
        if (typeof f == "number") {
            t.go(f);
            return;
        }
        let m = $455d545b1dff00eb$var$vE(f, JSON.parse(r), i, p.relative === "path");
        a == null && e !== "/" && (m.pathname = m.pathname === "/" ? e : $455d545b1dff00eb$var$vc([
            e,
            m.pathname
        ])), (p.replace ? t.replace : t.push)(m, p.state, p);
    }, [
        e,
        t,
        r,
        i,
        a
    ]);
}
$455d545b1dff00eb$var$X.createContext(null);
function $455d545b1dff00eb$var$b0(a, { relative: e } = {}) {
    let { matches: t } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc), { pathname: n } = $455d545b1dff00eb$var$Au(), i = JSON.stringify($455d545b1dff00eb$var$xE(t));
    return $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$vE(a, JSON.parse(i), n, e === "path"), [
        a,
        i,
        n,
        e
    ]);
}
function $455d545b1dff00eb$var$QC(a, e) {
    return $455d545b1dff00eb$var$ME(a, e);
}
function $455d545b1dff00eb$var$ME(a, e, t, n, i) {
    $455d545b1dff00eb$var$Oi($455d545b1dff00eb$var$_0(), "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: r } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), { matches: l } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc), c = l[l.length - 1], f = c ? c.params : {}, p = c ? c.pathname : "/", m = c ? c.pathnameBase : "/", x = c && c.route;
    {
        let C = x && x.path || "";
        $455d545b1dff00eb$var$EE(p, !x || C.endsWith("*") || C.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${p}" (under <Route path="${C}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${C}"> to <Route path="${C === "/" ? "*" : `${C}/*`}">.`);
    }
    let v = $455d545b1dff00eb$var$Au(), _;
    if (e) {
        let C = typeof e == "string" ? $455d545b1dff00eb$var$Qf(e) : e;
        $455d545b1dff00eb$var$Oi(m === "/" || C.pathname?.startsWith(m), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${m}" but pathname "${C.pathname}" was given in the \`location\` prop.`), _ = C;
    } else _ = v;
    let S = _.pathname || "/", A = S;
    if (m !== "/") {
        let C = m.replace(/^\//, "").split("/");
        A = "/" + S.replace(/^\//, "").split("/").slice(C.length).join("/");
    }
    let M = $455d545b1dff00eb$var$pE(a, {
        pathname: A
    });
    $455d545b1dff00eb$var$Uo(x || M != null, `No routes matched location "${_.pathname}${_.search}${_.hash}" `), $455d545b1dff00eb$var$Uo(M == null || M[M.length - 1].route.element !== void 0 || M[M.length - 1].route.Component !== void 0 || M[M.length - 1].route.lazy !== void 0, `Matched leaf route at location "${_.pathname}${_.search}${_.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    let b = $455d545b1dff00eb$var$tR(M && M.map((C)=>Object.assign({}, C, {
            params: Object.assign({}, f, C.params),
            pathname: $455d545b1dff00eb$var$vc([
                m,
                r.encodeLocation ? r.encodeLocation(C.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : C.pathname
            ]),
            pathnameBase: C.pathnameBase === "/" ? m : $455d545b1dff00eb$var$vc([
                m,
                r.encodeLocation ? r.encodeLocation(C.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : C.pathnameBase
            ])
        })), l, t, n, i);
    return e && b ? $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$y0.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ..._
            },
            navigationType: "POP"
        }
    }, b) : b;
}
function $455d545b1dff00eb$var$KC() {
    let a = $455d545b1dff00eb$var$sR(), e = $455d545b1dff00eb$var$kC(a) ? `${a.status} ${a.statusText}` : a instanceof Error ? a.message : JSON.stringify(a), t = a instanceof Error ? a.stack : null, n = "rgba(200,200,200, 0.5)", i = {
        padding: "0.5rem",
        backgroundColor: n
    }, r = {
        padding: "2px 4px",
        backgroundColor: n
    }, l = null;
    return console.error("Error handled by React Router default ErrorBoundary:", a), l = $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$X.Fragment, null, $455d545b1dff00eb$var$X.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), $455d545b1dff00eb$var$X.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", $455d545b1dff00eb$var$X.createElement("code", {
        style: r
    }, "ErrorBoundary"), " or", " ", $455d545b1dff00eb$var$X.createElement("code", {
        style: r
    }, "errorElement"), " prop on your route.")), $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$X.Fragment, null, $455d545b1dff00eb$var$X.createElement("h2", null, "Unexpected Application Error!"), $455d545b1dff00eb$var$X.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, e), t ? $455d545b1dff00eb$var$X.createElement("pre", {
        style: i
    }, t) : null, l);
}
var $455d545b1dff00eb$var$JC = $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$KC, null), $455d545b1dff00eb$var$$C = class extends $455d545b1dff00eb$var$X.Component {
    constructor(a){
        super(a), this.state = {
            location: a.location,
            revalidation: a.revalidation,
            error: a.error
        };
    }
    static getDerivedStateFromError(a) {
        return {
            error: a
        };
    }
    static getDerivedStateFromProps(a, e) {
        return e.location !== a.location || e.revalidation !== "idle" && a.revalidation === "idle" ? {
            error: a.error,
            location: a.location,
            revalidation: a.revalidation
        } : {
            error: a.error !== void 0 ? a.error : e.error,
            location: e.location,
            revalidation: a.revalidation || e.revalidation
        };
    }
    componentDidCatch(a, e) {
        this.props.unstable_onError ? this.props.unstable_onError(a, e) : console.error("React Router caught the following error during render", a);
    }
    render() {
        return this.state.error !== void 0 ? $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$Tc.Provider, {
            value: this.props.routeContext
        }, $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$Eb.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $455d545b1dff00eb$var$eR({ routeContext: a, match: e, children: t }) {
    let n = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Xd);
    return n && n.static && n.staticContext && (e.route.errorElement || e.route.ErrorBoundary) && (n.staticContext._deepestRenderedBoundaryId = e.route.id), $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$Tc.Provider, {
        value: a
    }, t);
}
function $455d545b1dff00eb$var$tR(a, e = [], t = null, n = null, i = null) {
    if (a == null) {
        if (!t) return null;
        if (t.errors) a = t.matches;
        else if (e.length === 0 && !t.initialized && t.matches.length > 0) a = t.matches;
        else return null;
    }
    let r = a, l = t?.errors;
    if (l != null) {
        let p = r.findIndex((m)=>m.route.id && l?.[m.route.id] !== void 0);
        $455d545b1dff00eb$var$Oi(p >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(l).join(",")}`), r = r.slice(0, Math.min(r.length, p + 1));
    }
    let c = !1, f = -1;
    if (t) for(let p = 0; p < r.length; p++){
        let m = r[p];
        if ((m.route.HydrateFallback || m.route.hydrateFallbackElement) && (f = p), m.route.id) {
            let { loaderData: x, errors: v } = t, _ = m.route.loader && !x.hasOwnProperty(m.route.id) && (!v || v[m.route.id] === void 0);
            if (m.route.lazy || _) {
                c = !0, f >= 0 ? r = r.slice(0, f + 1) : r = [
                    r[0]
                ];
                break;
            }
        }
    }
    return r.reduceRight((p, m, x)=>{
        let v, _ = !1, S = null, A = null;
        t && (v = l && m.route.id ? l[m.route.id] : void 0, S = m.route.errorElement || $455d545b1dff00eb$var$JC, c && (f < 0 && x === 0 ? ($455d545b1dff00eb$var$EE("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), _ = !0, A = null) : f === x && (_ = !0, A = m.route.hydrateFallbackElement || null)));
        let M = e.concat(r.slice(0, x + 1)), b = ()=>{
            let C;
            return v ? C = S : _ ? C = A : m.route.Component ? C = $455d545b1dff00eb$var$X.createElement(m.route.Component, null) : m.route.element ? C = m.route.element : C = p, $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$eR, {
                match: m,
                routeContext: {
                    outlet: p,
                    matches: M,
                    isDataRoute: t != null
                },
                children: C
            });
        };
        return t && (m.route.ErrorBoundary || m.route.errorElement || x === 0) ? $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$$C, {
            location: t.location,
            revalidation: t.revalidation,
            component: S,
            error: v,
            children: b(),
            routeContext: {
                outlet: null,
                matches: M,
                isDataRoute: !0
            },
            unstable_onError: n
        }) : b();
    }, null);
}
function $455d545b1dff00eb$var$Tb(a) {
    return `${a} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $455d545b1dff00eb$var$nR(a) {
    let e = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Xd);
    return $455d545b1dff00eb$var$Oi(e, $455d545b1dff00eb$var$Tb(a)), e;
}
function $455d545b1dff00eb$var$iR(a) {
    let e = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Qv);
    return $455d545b1dff00eb$var$Oi(e, $455d545b1dff00eb$var$Tb(a)), e;
}
function $455d545b1dff00eb$var$aR(a) {
    let e = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc);
    return $455d545b1dff00eb$var$Oi(e, $455d545b1dff00eb$var$Tb(a)), e;
}
function $455d545b1dff00eb$var$Ab(a) {
    let e = $455d545b1dff00eb$var$aR(a), t = e.matches[e.matches.length - 1];
    return $455d545b1dff00eb$var$Oi(t.route.id, `${a} can only be used on routes that contain a unique "id"`), t.route.id;
}
function $455d545b1dff00eb$var$rR() {
    return $455d545b1dff00eb$var$Ab("useRouteId");
}
function $455d545b1dff00eb$var$sR() {
    let a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Eb), e = $455d545b1dff00eb$var$iR("useRouteError"), t = $455d545b1dff00eb$var$Ab("useRouteError");
    return a !== void 0 ? a : e.errors?.[t];
}
function $455d545b1dff00eb$var$oR() {
    let { router: a } = $455d545b1dff00eb$var$nR("useNavigate"), e = $455d545b1dff00eb$var$Ab("useNavigate"), t = $455d545b1dff00eb$var$X.useRef(!1);
    return $455d545b1dff00eb$var$SE(()=>{
        t.current = !0;
    }), $455d545b1dff00eb$var$X.useCallback(async (i, r = {})=>{
        $455d545b1dff00eb$var$Uo(t.current, $455d545b1dff00eb$var$bE), t.current && (typeof i == "number" ? a.navigate(i) : await a.navigate(i, {
            fromRouteId: e,
            ...r
        }));
    }, [
        a,
        e
    ]);
}
var $455d545b1dff00eb$var$D2 = {};
function $455d545b1dff00eb$var$EE(a, e, t) {
    !e && !$455d545b1dff00eb$var$D2[a] && ($455d545b1dff00eb$var$D2[a] = !0, $455d545b1dff00eb$var$Uo(!1, t));
}
$455d545b1dff00eb$var$X.memo($455d545b1dff00eb$var$lR);
function $455d545b1dff00eb$var$lR({ routes: a, future: e, state: t, unstable_onError: n }) {
    return $455d545b1dff00eb$var$ME(a, void 0, t, n, e);
}
function $455d545b1dff00eb$var$Om(a) {
    $455d545b1dff00eb$var$Oi(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function $455d545b1dff00eb$var$cR({ basename: a = "/", children: e = null, location: t, navigationType: n = "POP", navigator: i, static: r = !1 }) {
    $455d545b1dff00eb$var$Oi(!$455d545b1dff00eb$var$_0(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let l = a.replace(/^\/*/, "/"), c = $455d545b1dff00eb$var$X.useMemo(()=>({
            basename: l,
            navigator: i,
            static: r,
            future: {}
        }), [
        l,
        i,
        r
    ]);
    typeof t == "string" && (t = $455d545b1dff00eb$var$Qf(t));
    let { pathname: f = "/", search: p = "", hash: m = "", state: x = null, key: v = "default" } = t, _ = $455d545b1dff00eb$var$X.useMemo(()=>{
        let S = $455d545b1dff00eb$var$_c(f, l);
        return S == null ? null : {
            location: {
                pathname: S,
                search: p,
                hash: m,
                state: x,
                key: v
            },
            navigationType: n
        };
    }, [
        l,
        f,
        p,
        m,
        x,
        v,
        n
    ]);
    return $455d545b1dff00eb$var$Uo(_ != null, `<Router basename="${l}"> is not able to match the URL "${f}${p}${m}" because it does not start with the basename, so the <Router> won't render anything.`), _ == null ? null : $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$Sl.Provider, {
        value: c
    }, $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$y0.Provider, {
        children: e,
        value: _
    }));
}
function $455d545b1dff00eb$var$uR({ children: a, location: e }) {
    return $455d545b1dff00eb$var$QC($455d545b1dff00eb$var$j_(a), e);
}
function $455d545b1dff00eb$var$j_(a, e = []) {
    let t = [];
    return $455d545b1dff00eb$var$X.Children.forEach(a, (n, i)=>{
        if (!$455d545b1dff00eb$var$X.isValidElement(n)) return;
        let r = [
            ...e,
            i
        ];
        if (n.type === $455d545b1dff00eb$var$X.Fragment) {
            t.push.apply(t, $455d545b1dff00eb$var$j_(n.props.children, r));
            return;
        }
        $455d545b1dff00eb$var$Oi(n.type === $455d545b1dff00eb$var$Om, `[${typeof n.type == "string" ? n.type : n.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`), $455d545b1dff00eb$var$Oi(!n.props.index || !n.props.children, "An index route cannot have child routes.");
        let l = {
            id: n.props.id || r.join("-"),
            caseSensitive: n.props.caseSensitive,
            element: n.props.element,
            Component: n.props.Component,
            index: n.props.index,
            path: n.props.path,
            middleware: n.props.middleware,
            loader: n.props.loader,
            action: n.props.action,
            hydrateFallbackElement: n.props.hydrateFallbackElement,
            HydrateFallback: n.props.HydrateFallback,
            errorElement: n.props.errorElement,
            ErrorBoundary: n.props.ErrorBoundary,
            hasErrorBoundary: n.props.hasErrorBoundary === !0 || n.props.ErrorBoundary != null || n.props.errorElement != null,
            shouldRevalidate: n.props.shouldRevalidate,
            handle: n.props.handle,
            lazy: n.props.lazy
        };
        n.props.children && (l.children = $455d545b1dff00eb$var$j_(n.props.children, r)), t.push(l);
    }), t;
}
var $455d545b1dff00eb$var$jx = "get", $455d545b1dff00eb$var$Xx = "application/x-www-form-urlencoded";
function $455d545b1dff00eb$var$Kv(a) {
    return a != null && typeof a.tagName == "string";
}
function $455d545b1dff00eb$var$fR(a) {
    return $455d545b1dff00eb$var$Kv(a) && a.tagName.toLowerCase() === "button";
}
function $455d545b1dff00eb$var$hR(a) {
    return $455d545b1dff00eb$var$Kv(a) && a.tagName.toLowerCase() === "form";
}
function $455d545b1dff00eb$var$dR(a) {
    return $455d545b1dff00eb$var$Kv(a) && a.tagName.toLowerCase() === "input";
}
function $455d545b1dff00eb$var$pR(a) {
    return !!(a.metaKey || a.altKey || a.ctrlKey || a.shiftKey);
}
function $455d545b1dff00eb$var$mR(a, e) {
    return a.button === 0 && (!e || e === "_self") && !$455d545b1dff00eb$var$pR(a);
}
var $455d545b1dff00eb$var$Xg = null;
function $455d545b1dff00eb$var$gR() {
    if ($455d545b1dff00eb$var$Xg === null) try {
        new FormData(document.createElement("form"), 0), $455d545b1dff00eb$var$Xg = !1;
    } catch  {
        $455d545b1dff00eb$var$Xg = !0;
    }
    return $455d545b1dff00eb$var$Xg;
}
var $455d545b1dff00eb$var$xR = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $455d545b1dff00eb$var$R1(a) {
    return a != null && !$455d545b1dff00eb$var$xR.has(a) ? ($455d545b1dff00eb$var$Uo(!1, `"${a}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$455d545b1dff00eb$var$Xx}"`), null) : a;
}
function $455d545b1dff00eb$var$vR(a, e) {
    let t, n, i, r, l;
    if ($455d545b1dff00eb$var$hR(a)) {
        let c = a.getAttribute("action");
        n = c ? $455d545b1dff00eb$var$_c(c, e) : null, t = a.getAttribute("method") || $455d545b1dff00eb$var$jx, i = $455d545b1dff00eb$var$R1(a.getAttribute("enctype")) || $455d545b1dff00eb$var$Xx, r = new FormData(a);
    } else if ($455d545b1dff00eb$var$fR(a) || $455d545b1dff00eb$var$dR(a) && (a.type === "submit" || a.type === "image")) {
        let c = a.form;
        if (c == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        let f = a.getAttribute("formaction") || c.getAttribute("action");
        if (n = f ? $455d545b1dff00eb$var$_c(f, e) : null, t = a.getAttribute("formmethod") || c.getAttribute("method") || $455d545b1dff00eb$var$jx, i = $455d545b1dff00eb$var$R1(a.getAttribute("formenctype")) || $455d545b1dff00eb$var$R1(c.getAttribute("enctype")) || $455d545b1dff00eb$var$Xx, r = new FormData(c, a), !$455d545b1dff00eb$var$gR()) {
            let { name: p, type: m, value: x } = a;
            if (m === "image") {
                let v = p ? `${p}.` : "";
                r.append(`${v}x`, "0"), r.append(`${v}y`, "0");
            } else p && r.append(p, x);
        }
    } else {
        if ($455d545b1dff00eb$var$Kv(a)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
        t = $455d545b1dff00eb$var$jx, n = null, i = $455d545b1dff00eb$var$Xx, l = a;
    }
    return r && i === "text/plain" && (l = r, r = void 0), {
        action: n,
        method: t.toLowerCase(),
        encType: i,
        formData: r,
        body: l
    };
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $455d545b1dff00eb$var$wb(a, e) {
    if (a === !1 || a === null || typeof a > "u") throw new Error(e);
}
function $455d545b1dff00eb$var$yR(a, e, t) {
    let n = typeof a == "string" ? new URL(a, typeof window > "u" ? "server://singlefetch/" : window.location.origin) : a;
    return n.pathname === "/" ? n.pathname = `_root.${t}` : e && $455d545b1dff00eb$var$_c(n.pathname, e) === "/" ? n.pathname = `${e.replace(/\/$/, "")}/_root.${t}` : n.pathname = `${n.pathname.replace(/\/$/, "")}.${t}`, n;
}
async function $455d545b1dff00eb$var$_R(a, e) {
    if (a.id in e) return e[a.id];
    try {
        let t = await import(a.module);
        return e[a.id] = t, t;
    } catch (t) {
        return console.error(`Error loading route module \`${a.module}\`, reloading page...`), console.error(t), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(()=>{});
    }
}
function $455d545b1dff00eb$var$bR(a) {
    return a == null ? !1 : a.href == null ? a.rel === "preload" && typeof a.imageSrcSet == "string" && typeof a.imageSizes == "string" : typeof a.rel == "string" && typeof a.href == "string";
}
async function $455d545b1dff00eb$var$SR(a, e, t) {
    let n = await Promise.all(a.map(async (i)=>{
        let r = e.routes[i.route.id];
        if (r) {
            let l = await $455d545b1dff00eb$var$_R(r, t);
            return l.links ? l.links() : [];
        }
        return [];
    }));
    return $455d545b1dff00eb$var$AR(n.flat(1).filter($455d545b1dff00eb$var$bR).filter((i)=>i.rel === "stylesheet" || i.rel === "preload").map((i)=>i.rel === "stylesheet" ? {
            ...i,
            rel: "prefetch",
            as: "style"
        } : {
            ...i,
            rel: "prefetch"
        }));
}
function $455d545b1dff00eb$var$U2(a, e, t, n, i, r) {
    let l = (f, p)=>t[p] ? f.route.id !== t[p].route.id : !0, c = (f, p)=>t[p].pathname !== f.pathname || t[p].route.path?.endsWith("*") && t[p].params["*"] !== f.params["*"];
    return r === "assets" ? e.filter((f, p)=>l(f, p) || c(f, p)) : r === "data" ? e.filter((f, p)=>{
        let m = n.routes[f.route.id];
        if (!m || !m.hasLoader) return !1;
        if (l(f, p) || c(f, p)) return !0;
        if (f.route.shouldRevalidate) {
            let x = f.route.shouldRevalidate({
                currentUrl: new URL(i.pathname + i.search + i.hash, window.origin),
                currentParams: t[0]?.params || {},
                nextUrl: new URL(a, window.origin),
                nextParams: f.params,
                defaultShouldRevalidate: !0
            });
            if (typeof x == "boolean") return x;
        }
        return !0;
    }) : [];
}
function $455d545b1dff00eb$var$MR(a, e, { includeHydrateFallback: t } = {}) {
    return $455d545b1dff00eb$var$ER(a.map((n)=>{
        let i = e.routes[n.route.id];
        if (!i) return [];
        let r = [
            i.module
        ];
        return i.clientActionModule && (r = r.concat(i.clientActionModule)), i.clientLoaderModule && (r = r.concat(i.clientLoaderModule)), t && i.hydrateFallbackModule && (r = r.concat(i.hydrateFallbackModule)), i.imports && (r = r.concat(i.imports)), r;
    }).flat(1));
}
function $455d545b1dff00eb$var$ER(a) {
    return [
        ...new Set(a)
    ];
}
function $455d545b1dff00eb$var$TR(a) {
    let e = {}, t = Object.keys(a).sort();
    for (let n of t)e[n] = a[n];
    return e;
}
function $455d545b1dff00eb$var$AR(a, e) {
    let t = new Set;
    return new Set(e), a.reduce((n, i)=>{
        let r = JSON.stringify($455d545b1dff00eb$var$TR(i));
        return t.has(r) || (t.add(r), n.push({
            key: r,
            link: i
        })), n;
    }, []);
}
function $455d545b1dff00eb$var$TE() {
    let a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Xd);
    return $455d545b1dff00eb$var$wb(a, "You must render this element inside a <DataRouterContext.Provider> element"), a;
}
function $455d545b1dff00eb$var$wR() {
    let a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Qv);
    return $455d545b1dff00eb$var$wb(a, "You must render this element inside a <DataRouterStateContext.Provider> element"), a;
}
var $455d545b1dff00eb$var$Cb = $455d545b1dff00eb$var$X.createContext(void 0);
$455d545b1dff00eb$var$Cb.displayName = "FrameworkContext";
function $455d545b1dff00eb$var$AE() {
    let a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Cb);
    return $455d545b1dff00eb$var$wb(a, "You must render this element inside a <HydratedRouter> element"), a;
}
function $455d545b1dff00eb$var$CR(a, e) {
    let t = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Cb), [n, i] = $455d545b1dff00eb$var$X.useState(!1), [r, l] = $455d545b1dff00eb$var$X.useState(!1), { onFocus: c, onBlur: f, onMouseEnter: p, onMouseLeave: m, onTouchStart: x } = e, v = $455d545b1dff00eb$var$X.useRef(null);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        if (a === "render" && l(!0), a === "viewport") {
            let A = (b)=>{
                b.forEach((C)=>{
                    l(C.isIntersecting);
                });
            }, M = new IntersectionObserver(A, {
                threshold: .5
            });
            return v.current && M.observe(v.current), ()=>{
                M.disconnect();
            };
        }
    }, [
        a
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (n) {
            let A = setTimeout(()=>{
                l(!0);
            }, 100);
            return ()=>{
                clearTimeout(A);
            };
        }
    }, [
        n
    ]);
    let _ = ()=>{
        i(!0);
    }, S = ()=>{
        i(!1), l(!1);
    };
    return t ? a !== "intent" ? [
        r,
        v,
        {}
    ] : [
        r,
        v,
        {
            onFocus: $455d545b1dff00eb$var$vm(c, _),
            onBlur: $455d545b1dff00eb$var$vm(f, S),
            onMouseEnter: $455d545b1dff00eb$var$vm(p, _),
            onMouseLeave: $455d545b1dff00eb$var$vm(m, S),
            onTouchStart: $455d545b1dff00eb$var$vm(x, _)
        }
    ] : [
        !1,
        v,
        {}
    ];
}
function $455d545b1dff00eb$var$vm(a, e) {
    return (t)=>{
        a && a(t), t.defaultPrevented || e(t);
    };
}
function $455d545b1dff00eb$var$RR({ page: a, ...e }) {
    let { router: t } = $455d545b1dff00eb$var$TE(), n = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$pE(t.routes, a, t.basename), [
        t.routes,
        a,
        t.basename
    ]);
    return n ? $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$UR, {
        page: a,
        matches: n,
        ...e
    }) : null;
}
function $455d545b1dff00eb$var$DR(a) {
    let { manifest: e, routeModules: t } = $455d545b1dff00eb$var$AE(), [n, i] = $455d545b1dff00eb$var$X.useState([]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        let r = !1;
        return $455d545b1dff00eb$var$SR(a, e, t).then((l)=>{
            r || i(l);
        }), ()=>{
            r = !0;
        };
    }, [
        a,
        e,
        t
    ]), n;
}
function $455d545b1dff00eb$var$UR({ page: a, matches: e, ...t }) {
    let n = $455d545b1dff00eb$var$Au(), { manifest: i, routeModules: r } = $455d545b1dff00eb$var$AE(), { basename: l } = $455d545b1dff00eb$var$TE(), { loaderData: c, matches: f } = $455d545b1dff00eb$var$wR(), p = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$U2(a, e, f, i, n, "data"), [
        a,
        e,
        f,
        i,
        n
    ]), m = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$U2(a, e, f, i, n, "assets"), [
        a,
        e,
        f,
        i,
        n
    ]), x = $455d545b1dff00eb$var$X.useMemo(()=>{
        if (a === n.pathname + n.search + n.hash) return [];
        let S = new Set, A = !1;
        if (e.forEach((b)=>{
            let C = i.routes[b.route.id];
            !C || !C.hasLoader || (!p.some((R)=>R.route.id === b.route.id) && b.route.id in c && r[b.route.id]?.shouldRevalidate || C.hasClientLoader ? A = !0 : S.add(b.route.id));
        }), S.size === 0) return [];
        let M = $455d545b1dff00eb$var$yR(a, l, "data");
        return A && S.size > 0 && M.searchParams.set("_routes", e.filter((b)=>S.has(b.route.id)).map((b)=>b.route.id).join(",")), [
            M.pathname + M.search
        ];
    }, [
        l,
        c,
        n,
        i,
        p,
        e,
        a,
        r
    ]), v = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$MR(m, i), [
        m,
        i
    ]), _ = $455d545b1dff00eb$var$DR(m);
    return $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$X.Fragment, null, x.map((S)=>$455d545b1dff00eb$var$X.createElement("link", {
            key: S,
            rel: "prefetch",
            as: "fetch",
            href: S,
            ...t
        })), v.map((S)=>$455d545b1dff00eb$var$X.createElement("link", {
            key: S,
            rel: "modulepreload",
            href: S,
            ...t
        })), _.map(({ key: S, link: A })=>$455d545b1dff00eb$var$X.createElement("link", {
            key: S,
            nonce: t.nonce,
            ...A
        })));
}
function $455d545b1dff00eb$var$NR(...a) {
    return (e)=>{
        a.forEach((t)=>{
            typeof t == "function" ? t(e) : t != null && (t.current = e);
        });
    };
}
var $455d545b1dff00eb$var$wE = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
    $455d545b1dff00eb$var$wE && (window.__reactRouterVersion = "7.9.5");
} catch  {}
function $455d545b1dff00eb$var$OR({ basename: a, children: e, window: t }) {
    let n = $455d545b1dff00eb$var$X.useRef();
    n.current == null && (n.current = $455d545b1dff00eb$var$_C({
        window: t,
        v5Compat: !0
    }));
    let i = n.current, [r, l] = $455d545b1dff00eb$var$X.useState({
        action: i.action,
        location: i.location
    }), c = $455d545b1dff00eb$var$X.useCallback((f)=>{
        $455d545b1dff00eb$var$X.startTransition(()=>l(f));
    }, [
        l
    ]);
    return $455d545b1dff00eb$var$X.useLayoutEffect(()=>i.listen(c), [
        i,
        c
    ]), $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$cR, {
        basename: a,
        children: e,
        location: r.location,
        navigationType: r.action,
        navigator: i
    });
}
var $455d545b1dff00eb$var$CE = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, $455d545b1dff00eb$var$Jv = $455d545b1dff00eb$var$X.forwardRef(function({ onClick: e, discover: t = "render", prefetch: n = "none", relative: i, reloadDocument: r, replace: l, state: c, target: f, to: p, preventScrollReset: m, viewTransition: x, ...v }, _) {
    let { basename: S } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), A = typeof p == "string" && $455d545b1dff00eb$var$CE.test(p), M, b = !1;
    if (typeof p == "string" && A && (M = p, $455d545b1dff00eb$var$wE)) try {
        let O = new URL(window.location.href), D = p.startsWith("//") ? new URL(O.protocol + p) : new URL(p), j = $455d545b1dff00eb$var$_c(D.pathname, S);
        D.origin === O.origin && j != null ? p = j + D.search + D.hash : b = !0;
    } catch  {
        $455d545b1dff00eb$var$Uo(!1, `<Link to="${p}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    let C = $455d545b1dff00eb$var$qC(p, {
        relative: i
    }), [R, N, z] = $455d545b1dff00eb$var$CR(n, v), L = $455d545b1dff00eb$var$BR(p, {
        replace: l,
        state: c,
        target: f,
        preventScrollReset: m,
        relative: i,
        viewTransition: x
    });
    function P(O) {
        e && e(O), O.defaultPrevented || L(O);
    }
    let H = $455d545b1dff00eb$var$X.createElement("a", {
        ...v,
        ...z,
        href: M || C,
        onClick: b || r ? e : P,
        ref: $455d545b1dff00eb$var$NR(_, N),
        target: f,
        "data-discover": !A && t === "render" ? "true" : void 0
    });
    return R && !A ? $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$X.Fragment, null, H, $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$RR, {
        page: C
    })) : H;
});
$455d545b1dff00eb$var$Jv.displayName = "Link";
var $455d545b1dff00eb$var$LR = $455d545b1dff00eb$var$X.forwardRef(function({ "aria-current": e = "page", caseSensitive: t = !1, className: n = "", end: i = !1, style: r, to: l, viewTransition: c, children: f, ...p }, m) {
    let x = $455d545b1dff00eb$var$b0(l, {
        relative: p.relative
    }), v = $455d545b1dff00eb$var$Au(), _ = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Qv), { navigator: S, basename: A } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), M = _ != null && $455d545b1dff00eb$var$GR(x) && c === !0, b = S.encodeLocation ? S.encodeLocation(x).pathname : x.pathname, C = v.pathname, R = _ && _.navigation && _.navigation.location ? _.navigation.location.pathname : null;
    t || (C = C.toLowerCase(), R = R ? R.toLowerCase() : null, b = b.toLowerCase()), R && A && (R = $455d545b1dff00eb$var$_c(R, A) || R);
    const N = b !== "/" && b.endsWith("/") ? b.length - 1 : b.length;
    let z = C === b || !i && C.startsWith(b) && C.charAt(N) === "/", L = R != null && (R === b || !i && R.startsWith(b) && R.charAt(b.length) === "/"), P = {
        isActive: z,
        isPending: L,
        isTransitioning: M
    }, H = z ? e : void 0, O;
    typeof n == "function" ? O = n(P) : O = [
        n,
        z ? "active" : null,
        L ? "pending" : null,
        M ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let D = typeof r == "function" ? r(P) : r;
    return $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$Jv, {
        ...p,
        "aria-current": H,
        className: O,
        ref: m,
        style: D,
        to: l,
        viewTransition: c
    }, typeof f == "function" ? f(P) : f);
});
$455d545b1dff00eb$var$LR.displayName = "NavLink";
var $455d545b1dff00eb$var$zR = $455d545b1dff00eb$var$X.forwardRef(({ discover: a = "render", fetcherKey: e, navigate: t, reloadDocument: n, replace: i, state: r, method: l = $455d545b1dff00eb$var$jx, action: c, onSubmit: f, relative: p, preventScrollReset: m, viewTransition: x, ...v }, _)=>{
    let S = $455d545b1dff00eb$var$HR(), A = $455d545b1dff00eb$var$VR(c, {
        relative: p
    }), M = l.toLowerCase() === "get" ? "get" : "post", b = typeof c == "string" && $455d545b1dff00eb$var$CE.test(c), C = (R)=>{
        if (f && f(R), R.defaultPrevented) return;
        R.preventDefault();
        let N = R.nativeEvent.submitter, z = N?.getAttribute("formmethod") || l;
        S(N || R.currentTarget, {
            fetcherKey: e,
            method: z,
            navigate: t,
            replace: i,
            state: r,
            relative: p,
            preventScrollReset: m,
            viewTransition: x
        });
    };
    return $455d545b1dff00eb$var$X.createElement("form", {
        ref: _,
        method: M,
        action: A,
        onSubmit: n ? f : C,
        ...v,
        "data-discover": !b && a === "render" ? "true" : void 0
    });
});
$455d545b1dff00eb$var$zR.displayName = "Form";
function $455d545b1dff00eb$var$PR(a) {
    return `${a} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $455d545b1dff00eb$var$RE(a) {
    let e = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Xd);
    return $455d545b1dff00eb$var$Oi(e, $455d545b1dff00eb$var$PR(a)), e;
}
function $455d545b1dff00eb$var$BR(a, { target: e, replace: t, state: n, preventScrollReset: i, relative: r, viewTransition: l } = {}) {
    let c = $455d545b1dff00eb$var$YC(), f = $455d545b1dff00eb$var$Au(), p = $455d545b1dff00eb$var$b0(a, {
        relative: r
    });
    return $455d545b1dff00eb$var$X.useCallback((m)=>{
        if ($455d545b1dff00eb$var$mR(m, e)) {
            m.preventDefault();
            let x = t !== void 0 ? t : $455d545b1dff00eb$var$Km(f) === $455d545b1dff00eb$var$Km(p);
            c(a, {
                replace: x,
                state: n,
                preventScrollReset: i,
                relative: r,
                viewTransition: l
            });
        }
    }, [
        f,
        c,
        p,
        t,
        n,
        e,
        a,
        i,
        r,
        l
    ]);
}
var $455d545b1dff00eb$var$IR = 0, $455d545b1dff00eb$var$FR = ()=>`__${String(++$455d545b1dff00eb$var$IR)}__`;
function $455d545b1dff00eb$var$HR() {
    let { router: a } = $455d545b1dff00eb$var$RE("useSubmit"), { basename: e } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), t = $455d545b1dff00eb$var$rR();
    return $455d545b1dff00eb$var$X.useCallback(async (n, i = {})=>{
        let { action: r, method: l, encType: c, formData: f, body: p } = $455d545b1dff00eb$var$vR(n, e);
        if (i.navigate === !1) {
            let m = i.fetcherKey || $455d545b1dff00eb$var$FR();
            await a.fetch(m, t, i.action || r, {
                preventScrollReset: i.preventScrollReset,
                formData: f,
                body: p,
                formMethod: i.method || l,
                formEncType: i.encType || c,
                flushSync: i.flushSync
            });
        } else await a.navigate(i.action || r, {
            preventScrollReset: i.preventScrollReset,
            formData: f,
            body: p,
            formMethod: i.method || l,
            formEncType: i.encType || c,
            replace: i.replace,
            state: i.state,
            fromRouteId: t,
            flushSync: i.flushSync,
            viewTransition: i.viewTransition
        });
    }, [
        a,
        e,
        t
    ]);
}
function $455d545b1dff00eb$var$VR(a, { relative: e } = {}) {
    let { basename: t } = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Sl), n = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$Tc);
    $455d545b1dff00eb$var$Oi(n, "useFormAction must be used inside a RouteContext");
    let [i] = n.matches.slice(-1), r = {
        ...$455d545b1dff00eb$var$b0(a || ".", {
            relative: e
        })
    }, l = $455d545b1dff00eb$var$Au();
    if (a == null) {
        r.search = l.search;
        let c = new URLSearchParams(r.search), f = c.getAll("index");
        if (f.some((m)=>m === "")) {
            c.delete("index"), f.filter((x)=>x).forEach((x)=>c.append("index", x));
            let m = c.toString();
            r.search = m ? `?${m}` : "";
        }
    }
    return (!a || a === ".") && i.route.index && (r.search = r.search ? r.search.replace(/^\?/, "?index&") : "?index"), t !== "/" && (r.pathname = r.pathname === "/" ? t : $455d545b1dff00eb$var$vc([
        t,
        r.pathname
    ])), $455d545b1dff00eb$var$Km(r);
}
function $455d545b1dff00eb$var$GR(a, { relative: e } = {}) {
    let t = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$_E);
    $455d545b1dff00eb$var$Oi(t != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: n } = $455d545b1dff00eb$var$RE("useViewTransitionState"), i = $455d545b1dff00eb$var$b0(a, {
        relative: e
    });
    if (!t.isTransitioning) return !1;
    let r = $455d545b1dff00eb$var$_c(t.currentLocation.pathname, n) || t.currentLocation.pathname, l = $455d545b1dff00eb$var$_c(t.nextLocation.pathname, n) || t.nextLocation.pathname;
    return $455d545b1dff00eb$var$ev(i.pathname, l) != null || $455d545b1dff00eb$var$ev(i.pathname, r) != null;
}
function $455d545b1dff00eb$var$kR() {
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "text-center mb-12",
        children: [
            $455d545b1dff00eb$var$k.jsx("h1", {
                className: "text-5xl font-bold text-black mb-4",
                children: "Interactive Learning"
            }),
            $455d545b1dff00eb$var$k.jsx("p", {
                className: "text-xl text-gray-600",
                children: "Explore Circle Theorems Through Interactive Exercises"
            })
        ]
    });
}
function $455d545b1dff00eb$var$jR({ theorem: a, hoveredCard: e, isPlaying: t, onMouseEnter: n, onMouseLeave: i }) {
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "bg-white border-2 border-gray-300 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow relative overflow-hidden",
        onMouseEnter: ()=>n(a.id),
        onMouseLeave: ()=>i(a.id),
        children: [
            $455d545b1dff00eb$var$k.jsx("h2", {
                className: "text-xl font-semibold text-black mb-2",
                children: a.number ? `Circle Theorem ${a.number}` : "Geometry Exercise"
            }),
            $455d545b1dff00eb$var$k.jsx("p", {
                className: "text-gray-700 mb-4 font-medium",
                children: a.name
            }),
            a.id === "cube-3d" && $455d545b1dff00eb$var$k.jsx("div", {
                className: "relative mb-4 rounded-lg overflow-hidden bg-gray-100 aspect-video",
                children: e === "cube-3d" && !t && $455d545b1dff00eb$var$k.jsx("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 transition-opacity",
                    children: $455d545b1dff00eb$var$k.jsx("div", {
                        className: "w-12 h-12 bg-white bg-opacity-90 rounded-full flex items-center justify-center shadow-lg",
                        children: $455d545b1dff00eb$var$k.jsx("svg", {
                            className: "w-6 h-6 text-indigo-600",
                            fill: "currentColor",
                            viewBox: "0 0 24 24",
                            children: $455d545b1dff00eb$var$k.jsx("path", {
                                d: "M6 4h4v16H6V4zm8 0h4v16h-4V4z"
                            })
                        })
                    })
                })
            }),
            $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$Jv, {
                to: `/${a.id}`,
                className: `block w-full px-6 py-3 ${a.color} text-white font-bold text-base rounded-lg transition-all duration-200 shadow-md hover:shadow-lg active:scale-95 text-center`,
                children: [
                    'Play with "',
                    a.fullName,
                    '"'
                ]
            }),
            $455d545b1dff00eb$var$k.jsx("p", {
                className: "mt-4 text-gray-500 text-sm",
                children: a.description
            })
        ]
    });
}
const $455d545b1dff00eb$var$XR = [
    {
        id: "angle-in-semicircle",
        number: 5,
        name: "Angle In A SemiCircle",
        fullName: "Circle Theorem 5 - Angle In A SemiCircle",
        description: "Discover how the angle in a semicircle is always 90\xb0",
        color: "bg-pink-500 hover:bg-pink-600"
    },
    {
        id: "cube-3d",
        number: null,
        name: "Cube Net Unfolding",
        fullName: "Cube Net Unfolding - 11 Distinct Nets",
        description: "Explore the 11 distinct ways to unfold a 3D cube into 2D nets",
        color: "bg-indigo-500 hover:bg-indigo-600"
    }
];
function $455d545b1dff00eb$var$WR() {
    const [a, e] = $455d545b1dff00eb$var$X.useState(null), [t, n] = $455d545b1dff00eb$var$X.useState(!1), i = $455d545b1dff00eb$var$X.useRef(null), r = (c)=>{
        c === "cube-3d" && (e(c), i.current && (i.current.pause(), n(!1)));
    }, l = (c)=>{
        c === "cube-3d" && (e(null), setTimeout(()=>{
            i.current && (i.current.play(), n(!0));
        }, 100));
    };
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        const c = setTimeout(()=>{
            i.current && !a && (i.current.play(), n(!0));
        }, 500);
        return ()=>clearTimeout(c);
    }, [
        a
    ]), $455d545b1dff00eb$var$k.jsx("div", {
        className: "min-h-screen bg-white p-6",
        children: $455d545b1dff00eb$var$k.jsxs("div", {
            className: "max-w-6xl mx-auto",
            children: [
                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$kR, {}),
                $455d545b1dff00eb$var$k.jsx("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6",
                    children: $455d545b1dff00eb$var$XR.map((c)=>$455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$jR, {
                            theorem: c,
                            hoveredCard: a,
                            isPlaying: t,
                            videoRef: i,
                            onMouseEnter: r,
                            onMouseLeave: l
                        }, c.id))
                })
            ]
        })
    });
}
function $455d545b1dff00eb$var$qR({ title: a, subtitle: e }) {
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "mb-4",
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Jv, {
                to: "/",
                className: "mb-4 inline-block px-4 py-2 bg-gray-200 hover:bg-gray-300 text-black font-medium rounded-lg transition-colors",
                children: "\u2190 Back to Home"
            }),
            $455d545b1dff00eb$var$k.jsx("p", {
                className: "text-sm text-pink-400 mb-1",
                children: "Interactive Learning"
            }),
            $455d545b1dff00eb$var$k.jsx("h1", {
                className: "text-4xl font-bold text-black mb-2",
                children: a
            }),
            $455d545b1dff00eb$var$k.jsx("p", {
                className: "text-red-600 italic",
                children: e
            })
        ]
    });
}
function $455d545b1dff00eb$var$YR({ tips: a, currentTip: e, onNext: t, onPrev: n }) {
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "bg-white border-2 border-black rounded-lg p-6 w-full max-w-md relative",
        children: [
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "flex items-center justify-between mb-4",
                children: [
                    $455d545b1dff00eb$var$k.jsx("button", {
                        type: "button",
                        onClick: n,
                        className: "text-2xl font-bold text-black hover:text-pink-500 transition-colors",
                        children: "\u2039"
                    }),
                    $455d545b1dff00eb$var$k.jsx("h2", {
                        className: "text-xl font-bold text-black",
                        children: "Don't Miss This Theorem"
                    }),
                    $455d545b1dff00eb$var$k.jsx("button", {
                        type: "button",
                        onClick: t,
                        className: "text-2xl font-bold text-black hover:text-pink-500 transition-colors",
                        children: "\u203A"
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "mb-4",
                children: $455d545b1dff00eb$var$k.jsx("p", {
                    className: "text-black leading-relaxed",
                    children: a[e].content
                })
            }),
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "flex justify-center gap-2 mt-4",
                children: a.map((i, r)=>$455d545b1dff00eb$var$k.jsx("div", {
                        className: `w-3 h-3 rounded-full transition-all ${r === e ? "bg-pink-500" : "bg-pink-200"}`
                    }, r))
            })
        ]
    });
}
function $455d545b1dff00eb$var$ZR({ circleState: a, onGenerateRandom: e, onDiameterChange: t, onCircumferenceChange: n, onRotateChange: i }) {
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "mt-6 flex flex-col gap-4",
        children: $455d545b1dff00eb$var$k.jsxs("div", {
            className: "flex items-center gap-4",
            children: [
                $455d545b1dff00eb$var$k.jsx("button", {
                    type: "button",
                    onClick: e,
                    className: "px-6 py-3 bg-gray-300 hover:bg-gray-400 text-black font-medium rounded-lg transition-colors",
                    children: "Generate Random Triangle"
                }),
                $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "flex-1 flex flex-col gap-3",
                    children: [
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex items-center gap-4",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-black w-32",
                                    children: "move diameter"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "1",
                                    step: "0.01",
                                    value: a.diameterOffset,
                                    onChange: (r)=>t(parseFloat(r.target.value)),
                                    className: "flex-1 h-2 bg-blue-200 rounded-lg appearance-none cursor-pointer slider-blue"
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex items-center gap-4",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-black w-32",
                                    children: "move circumference"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "1",
                                    step: "0.01",
                                    value: a.circumferenceOffset,
                                    onChange: (r)=>n(parseFloat(r.target.value)),
                                    className: "flex-1 h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer slider-purple"
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex items-center gap-4",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-black w-32",
                                    children: "rotate circle"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "1",
                                    step: "0.01",
                                    value: a.rotation / (2 * Math.PI) + .5,
                                    onChange: (r)=>i(parseFloat(r.target.value)),
                                    className: "flex-1 h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer slider-black"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $455d545b1dff00eb$var$Jh = 600, $455d545b1dff00eb$var$$h = 500, $455d545b1dff00eb$var$ed = 150, $455d545b1dff00eb$var$N2 = 8, $455d545b1dff00eb$var$O2 = {
    "angle-in-semicircle": {
        title: "Circle Theorem 5 - Angle In A SemiCircle",
        subtitle: "Drag the points on the circle",
        tips: [
            {
                title: "Introduction to the theorem",
                content: "The angle in a semicircle is always 90\xb0. This fundamental theorem states that any angle formed by drawing lines from the endpoints of a diameter to any point on the circumference will always be a right angle."
            },
            {
                title: "Why it's often overlooked",
                content: "It's the most unrecognized theorem yet easiest to spot. Many students miss this theorem because they don't recognize the pattern of a diameter forming a triangle with a point on the circumference."
            },
            {
                title: "How to spot it",
                content: "Look for a diameter and see if it forms a triangle. When you see a circle with a diameter drawn, check if there's a third point on the circumference that creates a triangle - if so, the angle at that point is 90\xb0."
            },
            {
                title: "Exam keywords requirement",
                content: "When explaining this theorem in an exam you must use the keywords: 'The angle in a semicircle is 90\xb0'. Examiners look for this specific phrasing to award marks."
            },
            {
                title: "Mathematical proof concept",
                content: "Based on the fact that the diameter subtends a right angle. The proof relies on the property that the angle at the center is twice the angle at the circumference, and since the diameter creates a 180\xb0 angle at the center, the angle at the circumference must be 90\xb0."
            },
            {
                title: "Real-world applications",
                content: "Used in construction, engineering, and navigation. This theorem helps in creating right angles without measuring tools, designing circular structures, and solving navigation problems involving circular paths."
            },
            {
                title: "Common mistakes to avoid",
                content: "Don't confuse with other circle theorems. Remember: this theorem specifically requires a diameter (not just any chord) and the angle must be at the circumference, not at the center."
            },
            {
                title: "Practice tips",
                content: "Always check for diameter first when solving circle problems. If you see a diameter in a circle problem, immediately check if it forms a triangle with a point on the circumference - this could be your key to solving the problem quickly."
            }
        ]
    },
    "angles-in-same-segment": {
        title: "Circle Theorem 1 - Angles In The Same Segment",
        subtitle: "Coming soon - Interactive exercise under development",
        tips: [
            {
                title: "Introduction",
                content: "Angles in the same segment are equal. This theorem states that angles subtended by the same arc at the circumference are equal."
            }
        ]
    },
    "angle-at-center": {
        title: "Circle Theorem 2 - Angle At The Center",
        subtitle: "Coming soon - Interactive exercise under development",
        tips: [
            {
                title: "Introduction",
                content: "The angle at the center is twice the angle at the circumference. This fundamental relationship connects central and inscribed angles."
            }
        ]
    },
    "opposite-angles-cyclic-quadrilateral": {
        title: "Circle Theorem 3 - Opposite Angles In Cyclic Quadrilateral",
        subtitle: "Coming soon - Interactive exercise under development",
        tips: [
            {
                title: "Introduction",
                content: "Opposite angles in a cyclic quadrilateral sum to 180\xb0. This theorem helps identify and work with quadrilaterals inscribed in circles."
            }
        ]
    },
    "tangent-and-radius": {
        title: "Circle Theorem 4 - Tangent And Radius",
        subtitle: "Coming soon - Interactive exercise under development",
        tips: [
            {
                title: "Introduction",
                content: "A tangent is perpendicular to the radius at the point of contact. This creates right angles in tangent problems."
            }
        ]
    },
    "alternate-segment-theorem": {
        title: "Circle Theorem 6 - Alternate Segment Theorem",
        subtitle: "Coming soon - Interactive exercise under development",
        tips: [
            {
                title: "Introduction",
                content: "The angle between a tangent and a chord equals the angle in the alternate segment. This theorem connects tangents and inscribed angles."
            }
        ]
    }
};
function $455d545b1dff00eb$var$L2() {
    const e = $455d545b1dff00eb$var$Au().pathname, t = e === "/exercise" ? "angle-in-semicircle" : e.substring(1) || "angle-in-semicircle", n = $455d545b1dff00eb$var$O2[t] || $455d545b1dff00eb$var$O2["angle-in-semicircle"], i = n.tips, r = $455d545b1dff00eb$var$X.useRef(null), [l, c] = $455d545b1dff00eb$var$X.useState(null), [f, p] = $455d545b1dff00eb$var$X.useState(0), [m, x] = $455d545b1dff00eb$var$X.useState({
        center: {
            x: $455d545b1dff00eb$var$Jh / 2,
            y: $455d545b1dff00eb$var$$h / 2
        },
        radius: $455d545b1dff00eb$var$ed,
        rotation: 0,
        pointA: {
            x: $455d545b1dff00eb$var$Jh / 2 - $455d545b1dff00eb$var$ed,
            y: $455d545b1dff00eb$var$$h / 2
        },
        pointB: {
            x: $455d545b1dff00eb$var$Jh / 2,
            y: $455d545b1dff00eb$var$$h / 2 - $455d545b1dff00eb$var$ed + $455d545b1dff00eb$var$ed + $455d545b1dff00eb$var$ed
        },
        pointC: {
            x: $455d545b1dff00eb$var$Jh / 2 + $455d545b1dff00eb$var$ed,
            y: $455d545b1dff00eb$var$$h / 2
        },
        diameterOffset: .5,
        circumferenceOffset: .5
    }), v = (O, D, j)=>({
            x: O.x + D * Math.cos(j),
            y: O.y + D * Math.sin(j)
        }), _ = (O, D, j)=>{
        const G = O.x - D.x, q = O.y - D.y;
        if (Math.sqrt(G * G + q * q) < .1) return v(D, j, 0);
        const ae = Math.atan2(q, G);
        return v(D, j, ae);
    }, S = (O, D, j, G, q, Y, ae)=>{
        const F = O.x - D.x, Q = O.y - D.y;
        if (Math.sqrt(F * F + Q * Q) < .1) {
            if (q) {
                const de = q.x - D.x, ue = q.y - D.y, le = Math.atan2(ue, de);
                return v(D, j, le);
            }
            return v(D, j, G + Math.PI / 2);
        }
        const $ = Math.atan2(Q, F), ee = G;
        let I = $ - ee;
        for(; I > Math.PI;)I -= 2 * Math.PI;
        for(; I < -Math.PI;)I += 2 * Math.PI;
        const Z = .15;
        I < Z ? I = Z : I > Math.PI - Z && (I = Math.PI - Z);
        const oe = ee + I, ce = v(D, j, oe);
        if (Y && ae) {
            const de = Math.atan2(Y.y - D.y, Y.x - D.x);
            let le = Math.atan2(ce.y - D.y, ce.x - D.x) - de;
            for(; le > Math.PI;)le -= 2 * Math.PI;
            for(; le < -Math.PI;)le += 2 * Math.PI;
            if (le > Math.PI - .2) return I = Math.PI - .2, v(D, j, ee + I);
        }
        return ce;
    }, A = ()=>{
        const O = r.current;
        if (!O) return;
        const D = O.getContext("2d");
        if (!D) return;
        D.clearRect(0, 0, $455d545b1dff00eb$var$Jh, $455d545b1dff00eb$var$$h);
        const { center: j, radius: G, rotation: q, pointA: Y, pointB: ae, pointC: F } = m;
        D.save(), D.translate(j.x, j.y), D.rotate(q), D.beginPath(), D.arc(0, 0, G, 0, Math.PI), D.strokeStyle = "#FFEB3B", D.lineWidth = 4, D.stroke(), D.restore(), D.beginPath(), D.arc(j.x, j.y, G, 0, 2 * Math.PI), D.strokeStyle = "#000000", D.lineWidth = 1, D.stroke(), D.beginPath(), D.moveTo(Y.x, Y.y), D.lineTo(F.x, F.y), D.strokeStyle = "#000000", D.lineWidth = 1, D.stroke(), D.beginPath(), D.moveTo(Y.x, Y.y), D.lineTo(ae.x, ae.y), D.lineTo(F.x, F.y), D.closePath(), D.strokeStyle = "#000000", D.lineWidth = 1.5, D.stroke();
        const Q = {
            x: Y.x - ae.x,
            y: Y.y - ae.y
        }, K = {
            x: F.x - ae.x,
            y: F.y - ae.y
        }, $ = Math.atan2(Q.y, Q.x), ee = Math.atan2(K.y, K.x), I = ($ + ee) / 2, Z = 12;
        D.save(), D.translate(ae.x, ae.y), D.rotate($), D.fillStyle = "#FF69B4", D.strokeStyle = "#FF69B4", D.lineWidth = 2, D.beginPath(), D.moveTo(0, 0), D.lineTo(Z, 0), D.lineTo(Z, Z), D.lineTo(0, Z), D.closePath(), D.fill(), D.stroke(), D.restore(), D.fillStyle = "#FF69B4", D.font = "bold 16px Arial";
        const oe = ae.x + Math.cos(I) * 25, ce = ae.y + Math.sin(I) * 25;
        D.fillText("90\xb0", oe, ce), D.fillStyle = "#000000", D.beginPath(), D.arc(j.x, j.y, 4, 0, 2 * Math.PI), D.fill(), D.fillStyle = "#000000", D.font = "14px Arial", D.fillText("O", j.x + 10, j.y - 10), [
            {
                point: Y,
                label: "A"
            },
            {
                point: ae,
                label: "B"
            },
            {
                point: F,
                label: "C"
            }
        ].forEach(({ point: ue, label: le })=>{
            D.fillStyle = "#DC2626", D.beginPath(), D.arc(ue.x, ue.y, $455d545b1dff00eb$var$N2, 0, 2 * Math.PI), D.fill(), D.strokeStyle = "#FFFFFF", D.lineWidth = 2, D.stroke(), D.fillStyle = "#000000", D.font = "bold 14px Arial";
            const xe = le === "B" ? -20 : le === "A" ? -15 : 15;
            D.fillText(le, ue.x + xe, ue.y - 10);
        });
    };
    $455d545b1dff00eb$var$X.useEffect(()=>{
        A();
    }, [
        m
    ]);
    const M = (O)=>{
        const D = r.current?.getBoundingClientRect();
        if (!D) return;
        const j = O.clientX - D.left, G = O.clientY - D.top, q = {
            x: j,
            y: G
        }, Y = $455d545b1dff00eb$var$N2 * 3, ae = Math.sqrt(Math.pow(q.x - m.pointB.x, 2) + Math.pow(q.y - m.pointB.y, 2)), F = Math.sqrt(Math.pow(q.x - m.pointA.x, 2) + Math.pow(q.y - m.pointA.y, 2)), Q = Math.sqrt(Math.pow(q.x - m.pointC.x, 2) + Math.pow(q.y - m.pointC.y, 2));
        ae < Y && ae <= F && ae <= Q ? c("B") : F < Y && F <= Q ? c("A") : Q < Y && c("C");
    }, b = (O)=>{
        if (!l) return;
        const D = r.current?.getBoundingClientRect();
        if (!D) return;
        const j = O.clientX - D.left, G = O.clientY - D.top, q = {
            x: j,
            y: G
        };
        x((Y)=>{
            const { center: ae, radius: F, rotation: Q } = Y, K = {
                ...Y
            };
            if (l === "A") {
                K.pointA = _(q, ae, F);
                const $ = Math.atan2(K.pointA.y - ae.y, K.pointA.x - ae.x);
                K.pointC = v(ae, F, $ + Math.PI), K.rotation = $;
                const I = Math.atan2(Y.pointB.y - ae.y, Y.pointB.x - ae.x) - Y.rotation;
                let oe = $ + I - $;
                for(; oe > Math.PI;)oe -= 2 * Math.PI;
                for(; oe < -Math.PI;)oe += 2 * Math.PI;
                oe < 0 && (oe = 0), oe > Math.PI && (oe = Math.PI), K.pointB = v(ae, F, $ + oe);
            } else if (l === "C") {
                K.pointC = _(q, ae, F);
                const $ = Math.atan2(K.pointC.y - ae.y, K.pointC.x - ae.x);
                K.pointA = v(ae, F, $ + Math.PI), K.rotation = $;
                const I = Math.atan2(Y.pointB.y - ae.y, Y.pointB.x - ae.x) - Y.rotation;
                let oe = $ + I - $;
                for(; oe > Math.PI;)oe -= 2 * Math.PI;
                for(; oe < -Math.PI;)oe += 2 * Math.PI;
                oe < 0 && (oe = 0), oe > Math.PI && (oe = Math.PI), K.pointB = v(ae, F, $ + oe);
            } else if (l === "B") {
                const $ = S(q, ae, F, Q, Y.pointB, Y.pointA, Y.pointC);
                K.pointB = $;
            }
            return K;
        });
    }, C = ()=>{
        c(null);
    }, R = ()=>{
        const { center: O, radius: D, rotation: j } = m, G = Math.random() * Math.PI, q = (Math.random() - .5) * .3, Y = j + q, ae = Y, F = Y + Math.PI, Q = Y + G;
        x((K)=>({
                ...K,
                rotation: Y,
                pointA: v(O, D, ae),
                pointB: v(O, D, Q),
                pointC: v(O, D, F)
            }));
    }, N = (O)=>{
        const D = (O - .5) * .5;
        x((j)=>{
            const { center: G, radius: q, rotation: Y } = j, ae = Y + D, F = ae, Q = ae + Math.PI;
            return {
                ...j,
                rotation: ae,
                diameterOffset: O,
                pointA: v(G, q, F),
                pointC: v(G, q, Q)
            };
        });
    }, z = (O)=>{
        x((D)=>{
            const { center: j, radius: G, rotation: q } = D, Y = q + O * Math.PI;
            return {
                ...D,
                circumferenceOffset: O,
                pointB: v(j, G, Y)
            };
        });
    }, L = (O)=>{
        const D = (O - .5) * 2 * Math.PI;
        x((j)=>{
            const { center: G, radius: q } = j, Y = D, ae = D + Math.PI, Q = Math.atan2(j.pointB.y - G.y, j.pointB.x - G.x) - j.rotation, K = D + Q;
            return {
                ...j,
                rotation: D,
                pointA: v(G, q, Y),
                pointB: v(G, q, K),
                pointC: v(G, q, ae)
            };
        });
    }, P = $455d545b1dff00eb$var$X.useCallback(()=>{
        p((O)=>(O + 1) % i.length);
    }, [
        i.length
    ]), H = $455d545b1dff00eb$var$X.useCallback(()=>{
        p((O)=>(O - 1 + i.length) % i.length);
    }, [
        i.length
    ]);
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "min-h-screen bg-white p-6",
        children: $455d545b1dff00eb$var$k.jsxs("div", {
            className: "max-w-7xl mx-auto",
            children: [
                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$qR, {
                    title: n.title,
                    subtitle: n.subtitle
                }),
                $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "flex flex-col lg:flex-row gap-6",
                    children: [
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: "flex-1",
                            children: $455d545b1dff00eb$var$k.jsx("canvas", {
                                ref: r,
                                width: $455d545b1dff00eb$var$Jh,
                                height: $455d545b1dff00eb$var$$h,
                                className: "border border-gray-300 rounded-lg cursor-move",
                                onMouseDown: M,
                                onMouseMove: b,
                                onMouseUp: C,
                                onMouseLeave: C
                            })
                        }),
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: "flex-1 flex flex-col items-center",
                            children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$YR, {
                                tips: i,
                                currentTip: f,
                                onNext: P,
                                onPrev: H
                            })
                        })
                    ]
                }),
                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$ZR, {
                    circleState: {
                        diameterOffset: m.diameterOffset,
                        circumferenceOffset: m.circumferenceOffset,
                        rotation: m.rotation
                    },
                    onGenerateRandom: R,
                    onDiameterChange: N,
                    onCircumferenceChange: z,
                    onRotateChange: L
                })
            ]
        })
    });
}
const $455d545b1dff00eb$var$$v = "181", $455d545b1dff00eb$var$Xs = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
}, $455d545b1dff00eb$var$Zr = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, $455d545b1dff00eb$var$DE = 0, $455d545b1dff00eb$var$X_ = 1, $455d545b1dff00eb$var$UE = 2, $455d545b1dff00eb$var$QR = 3, $455d545b1dff00eb$var$NE = 0, $455d545b1dff00eb$var$ey = 1, $455d545b1dff00eb$var$Im = 2, $455d545b1dff00eb$var$Ao = 3, $455d545b1dff00eb$var$bc = 0, $455d545b1dff00eb$var$Dr = 1, $455d545b1dff00eb$var$Ea = 2, $455d545b1dff00eb$var$yl = 0, $455d545b1dff00eb$var$Ff = 1, $455d545b1dff00eb$var$W_ = 2, $455d545b1dff00eb$var$q_ = 3, $455d545b1dff00eb$var$Y_ = 4, $455d545b1dff00eb$var$OE = 5, $455d545b1dff00eb$var$vu = 100, $455d545b1dff00eb$var$LE = 101, $455d545b1dff00eb$var$zE = 102, $455d545b1dff00eb$var$PE = 103, $455d545b1dff00eb$var$BE = 104, $455d545b1dff00eb$var$IE = 200, $455d545b1dff00eb$var$FE = 201, $455d545b1dff00eb$var$HE = 202, $455d545b1dff00eb$var$VE = 203, $455d545b1dff00eb$var$tv = 204, $455d545b1dff00eb$var$nv = 205, $455d545b1dff00eb$var$GE = 206, $455d545b1dff00eb$var$kE = 207, $455d545b1dff00eb$var$jE = 208, $455d545b1dff00eb$var$XE = 209, $455d545b1dff00eb$var$WE = 210, $455d545b1dff00eb$var$qE = 211, $455d545b1dff00eb$var$YE = 212, $455d545b1dff00eb$var$ZE = 213, $455d545b1dff00eb$var$QE = 214, $455d545b1dff00eb$var$iv = 0, $455d545b1dff00eb$var$av = 1, $455d545b1dff00eb$var$rv = 2, $455d545b1dff00eb$var$jf = 3, $455d545b1dff00eb$var$sv = 4, $455d545b1dff00eb$var$ov = 5, $455d545b1dff00eb$var$lv = 6, $455d545b1dff00eb$var$cv = 7, $455d545b1dff00eb$var$S0 = 0, $455d545b1dff00eb$var$KE = 1, $455d545b1dff00eb$var$JE = 2, $455d545b1dff00eb$var$_l = 0, $455d545b1dff00eb$var$$E = 1, $455d545b1dff00eb$var$eT = 2, $455d545b1dff00eb$var$tT = 3, $455d545b1dff00eb$var$Rb = 4, $455d545b1dff00eb$var$nT = 5, $455d545b1dff00eb$var$iT = 6, $455d545b1dff00eb$var$aT = 7, $455d545b1dff00eb$var$Z_ = "attached", $455d545b1dff00eb$var$rT = "detached", $455d545b1dff00eb$var$ty = 300, $455d545b1dff00eb$var$Sc = 301, $455d545b1dff00eb$var$Mu = 302, $455d545b1dff00eb$var$Jm = 303, $455d545b1dff00eb$var$$m = 304, $455d545b1dff00eb$var$Wd = 306, $455d545b1dff00eb$var$e0 = 1e3, $455d545b1dff00eb$var$Kr = 1001, $455d545b1dff00eb$var$t0 = 1002, $455d545b1dff00eb$var$Fa = 1003, $455d545b1dff00eb$var$Db = 1004, $455d545b1dff00eb$var$KR = 1004, $455d545b1dff00eb$var$Ad = 1005, $455d545b1dff00eb$var$JR = 1005, $455d545b1dff00eb$var$mi = 1006, $455d545b1dff00eb$var$Fm = 1007, $455d545b1dff00eb$var$$R = 1007, $455d545b1dff00eb$var$gl = 1008, $455d545b1dff00eb$var$eD = 1008, $455d545b1dff00eb$var$Ws = 1009, $455d545b1dff00eb$var$Ub = 1010, $455d545b1dff00eb$var$Nb = 1011, $455d545b1dff00eb$var$Od = 1012, $455d545b1dff00eb$var$ny = 1013, $455d545b1dff00eb$var$Mc = 1014, $455d545b1dff00eb$var$Rr = 1015, $455d545b1dff00eb$var$wu = 1016, $455d545b1dff00eb$var$iy = 1017, $455d545b1dff00eb$var$ay = 1018, $455d545b1dff00eb$var$Ld = 1020, $455d545b1dff00eb$var$Ob = 35902, $455d545b1dff00eb$var$Lb = 35899, $455d545b1dff00eb$var$zb = 1021, $455d545b1dff00eb$var$Pb = 1022, $455d545b1dff00eb$var$ar = 1023, $455d545b1dff00eb$var$zd = 1026, $455d545b1dff00eb$var$Pd = 1027, $455d545b1dff00eb$var$ry = 1028, $455d545b1dff00eb$var$M0 = 1029, $455d545b1dff00eb$var$sy = 1030, $455d545b1dff00eb$var$oy = 1031, $455d545b1dff00eb$var$tD = 1032, $455d545b1dff00eb$var$ly = 1033, $455d545b1dff00eb$var$Hm = 33776, $455d545b1dff00eb$var$Vm = 33777, $455d545b1dff00eb$var$Gm = 33778, $455d545b1dff00eb$var$km = 33779, $455d545b1dff00eb$var$uv = 35840, $455d545b1dff00eb$var$fv = 35841, $455d545b1dff00eb$var$hv = 35842, $455d545b1dff00eb$var$dv = 35843, $455d545b1dff00eb$var$pv = 36196, $455d545b1dff00eb$var$mv = 37492, $455d545b1dff00eb$var$gv = 37496, $455d545b1dff00eb$var$xv = 37808, $455d545b1dff00eb$var$vv = 37809, $455d545b1dff00eb$var$yv = 37810, $455d545b1dff00eb$var$_v = 37811, $455d545b1dff00eb$var$bv = 37812, $455d545b1dff00eb$var$Sv = 37813, $455d545b1dff00eb$var$Mv = 37814, $455d545b1dff00eb$var$Ev = 37815, $455d545b1dff00eb$var$Tv = 37816, $455d545b1dff00eb$var$Av = 37817, $455d545b1dff00eb$var$wv = 37818, $455d545b1dff00eb$var$Cv = 37819, $455d545b1dff00eb$var$Rv = 37820, $455d545b1dff00eb$var$Dv = 37821, $455d545b1dff00eb$var$Uv = 36492, $455d545b1dff00eb$var$Nv = 36494, $455d545b1dff00eb$var$Ov = 36495, $455d545b1dff00eb$var$Lv = 36283, $455d545b1dff00eb$var$zv = 36284, $455d545b1dff00eb$var$Pv = 36285, $455d545b1dff00eb$var$Bv = 36286, $455d545b1dff00eb$var$sT = 2200, $455d545b1dff00eb$var$oT = 2201, $455d545b1dff00eb$var$lT = 2202, $455d545b1dff00eb$var$n0 = 2300, $455d545b1dff00eb$var$Iv = 2301, $455d545b1dff00eb$var$Wx = 2302, $455d545b1dff00eb$var$zf = 2400, $455d545b1dff00eb$var$Pf = 2401, $455d545b1dff00eb$var$i0 = 2402, $455d545b1dff00eb$var$cy = 2500, $455d545b1dff00eb$var$Bb = 2501, $455d545b1dff00eb$var$nD = 0, $455d545b1dff00eb$var$iD = 1, $455d545b1dff00eb$var$aD = 2, $455d545b1dff00eb$var$cT = 3200, $455d545b1dff00eb$var$Ib = 3201, $455d545b1dff00eb$var$rD = 3202, $455d545b1dff00eb$var$sD = 3203, $455d545b1dff00eb$var$Cu = 0, $455d545b1dff00eb$var$uT = 1, $455d545b1dff00eb$var$pc = "", $455d545b1dff00eb$var$nr = "srgb", $455d545b1dff00eb$var$No = "srgb-linear", $455d545b1dff00eb$var$a0 = "linear", $455d545b1dff00eb$var$Zn = "srgb", $455d545b1dff00eb$var$oD = 0, $455d545b1dff00eb$var$Nf = 7680, $455d545b1dff00eb$var$lD = 7681, $455d545b1dff00eb$var$cD = 7682, $455d545b1dff00eb$var$uD = 7683, $455d545b1dff00eb$var$fD = 34055, $455d545b1dff00eb$var$hD = 34056, $455d545b1dff00eb$var$dD = 5386, $455d545b1dff00eb$var$pD = 512, $455d545b1dff00eb$var$mD = 513, $455d545b1dff00eb$var$gD = 514, $455d545b1dff00eb$var$xD = 515, $455d545b1dff00eb$var$vD = 516, $455d545b1dff00eb$var$yD = 517, $455d545b1dff00eb$var$_D = 518, $455d545b1dff00eb$var$Q_ = 519, $455d545b1dff00eb$var$fT = 512, $455d545b1dff00eb$var$hT = 513, $455d545b1dff00eb$var$dT = 514, $455d545b1dff00eb$var$Fb = 515, $455d545b1dff00eb$var$pT = 516, $455d545b1dff00eb$var$mT = 517, $455d545b1dff00eb$var$gT = 518, $455d545b1dff00eb$var$xT = 519, $455d545b1dff00eb$var$r0 = 35044, $455d545b1dff00eb$var$bD = 35048, $455d545b1dff00eb$var$SD = 35040, $455d545b1dff00eb$var$MD = 35045, $455d545b1dff00eb$var$ED = 35049, $455d545b1dff00eb$var$TD = 35041, $455d545b1dff00eb$var$AD = 35046, $455d545b1dff00eb$var$wD = 35050, $455d545b1dff00eb$var$CD = 35042, $455d545b1dff00eb$var$RD = "100", $455d545b1dff00eb$var$K_ = "300 es", $455d545b1dff00eb$var$_s = 2e3, $455d545b1dff00eb$var$Bd = 2001, $455d545b1dff00eb$var$DD = {
    COMPUTE: "compute",
    RENDER: "render"
}, $455d545b1dff00eb$var$UD = {
    PERSPECTIVE: "perspective",
    LINEAR: "linear",
    FLAT: "flat"
}, $455d545b1dff00eb$var$ND = {
    NORMAL: "normal",
    CENTROID: "centroid",
    SAMPLE: "sample",
    FIRST: "first",
    EITHER: "either"
};
function $455d545b1dff00eb$var$vT(a) {
    for(let e = a.length - 1; e >= 0; --e)if (a[e] >= 65535) return !0;
    return !1;
}
const $455d545b1dff00eb$var$OD = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $455d545b1dff00eb$var$wd(a, e) {
    return new $455d545b1dff00eb$var$OD[a](e);
}
function $455d545b1dff00eb$var$s0(a) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", a);
}
function $455d545b1dff00eb$var$yT() {
    const a = $455d545b1dff00eb$var$s0("canvas");
    return a.style.display = "block", a;
}
const $455d545b1dff00eb$var$z2 = {};
let $455d545b1dff00eb$var$Eu = null;
function $455d545b1dff00eb$var$LD(a) {
    $455d545b1dff00eb$var$Eu = a;
}
function $455d545b1dff00eb$var$zD() {
    return $455d545b1dff00eb$var$Eu;
}
function $455d545b1dff00eb$var$o0(...a) {
    const e = "THREE." + a.shift();
    $455d545b1dff00eb$var$Eu ? $455d545b1dff00eb$var$Eu("log", e, ...a) : console.log(e, ...a);
}
function $455d545b1dff00eb$var$Mt(...a) {
    const e = "THREE." + a.shift();
    $455d545b1dff00eb$var$Eu ? $455d545b1dff00eb$var$Eu("warn", e, ...a) : console.warn(e, ...a);
}
function $455d545b1dff00eb$var$Qt(...a) {
    const e = "THREE." + a.shift();
    $455d545b1dff00eb$var$Eu ? $455d545b1dff00eb$var$Eu("error", e, ...a) : console.error(e, ...a);
}
function $455d545b1dff00eb$var$Id(...a) {
    const e = a.join(" ");
    e in $455d545b1dff00eb$var$z2 || ($455d545b1dff00eb$var$z2[e] = !0, $455d545b1dff00eb$var$Mt(...a));
}
function $455d545b1dff00eb$var$PD(a, e, t) {
    return new Promise(function(n, i) {
        function r() {
            switch(a.clientWaitSync(e, a.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case a.WAIT_FAILED:
                    i();
                    break;
                case a.TIMEOUT_EXPIRED:
                    setTimeout(r, t);
                    break;
                default:
                    n();
            }
        }
        setTimeout(r, t);
    });
}
let $455d545b1dff00eb$var$Ml = class {
    addEventListener(e, t) {
        this._listeners === void 0 && (this._listeners = {});
        const n = this._listeners;
        n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
    }
    hasEventListener(e, t) {
        const n = this._listeners;
        return n === void 0 ? !1 : n[e] !== void 0 && n[e].indexOf(t) !== -1;
    }
    removeEventListener(e, t) {
        const n = this._listeners;
        if (n === void 0) return;
        const i = n[e];
        if (i !== void 0) {
            const r = i.indexOf(t);
            r !== -1 && i.splice(r, 1);
        }
    }
    dispatchEvent(e) {
        const t = this._listeners;
        if (t === void 0) return;
        const n = t[e.type];
        if (n !== void 0) {
            e.target = this;
            const i = n.slice(0);
            for(let r = 0, l = i.length; r < l; r++)i[r].call(this, e);
            e.target = null;
        }
    }
};
const $455d545b1dff00eb$var$$a = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $455d545b1dff00eb$var$P2 = 1234567;
const $455d545b1dff00eb$var$Hf = Math.PI / 180, $455d545b1dff00eb$var$Fd = 180 / Math.PI;
function $455d545b1dff00eb$var$bs() {
    const a = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
    return ($455d545b1dff00eb$var$$a[a & 255] + $455d545b1dff00eb$var$$a[a >> 8 & 255] + $455d545b1dff00eb$var$$a[a >> 16 & 255] + $455d545b1dff00eb$var$$a[a >> 24 & 255] + "-" + $455d545b1dff00eb$var$$a[e & 255] + $455d545b1dff00eb$var$$a[e >> 8 & 255] + "-" + $455d545b1dff00eb$var$$a[e >> 16 & 15 | 64] + $455d545b1dff00eb$var$$a[e >> 24 & 255] + "-" + $455d545b1dff00eb$var$$a[t & 63 | 128] + $455d545b1dff00eb$var$$a[t >> 8 & 255] + "-" + $455d545b1dff00eb$var$$a[t >> 16 & 255] + $455d545b1dff00eb$var$$a[t >> 24 & 255] + $455d545b1dff00eb$var$$a[n & 255] + $455d545b1dff00eb$var$$a[n >> 8 & 255] + $455d545b1dff00eb$var$$a[n >> 16 & 255] + $455d545b1dff00eb$var$$a[n >> 24 & 255]).toLowerCase();
}
function $455d545b1dff00eb$var$Yt(a, e, t) {
    return Math.max(e, Math.min(t, a));
}
function $455d545b1dff00eb$var$Hb(a, e) {
    return (a % e + e) % e;
}
function $455d545b1dff00eb$var$BD(a, e, t, n, i) {
    return n + (a - e) * (i - n) / (t - e);
}
function $455d545b1dff00eb$var$ID(a, e, t) {
    return a !== e ? (t - a) / (e - a) : 0;
}
function $455d545b1dff00eb$var$jm(a, e, t) {
    return (1 - t) * a + t * e;
}
function $455d545b1dff00eb$var$FD(a, e, t, n) {
    return $455d545b1dff00eb$var$jm(a, e, 1 - Math.exp(-t * n));
}
function $455d545b1dff00eb$var$HD(a, e = 1) {
    return e - Math.abs($455d545b1dff00eb$var$Hb(a, e * 2) - e);
}
function $455d545b1dff00eb$var$VD(a, e, t) {
    return a <= e ? 0 : a >= t ? 1 : (a = (a - e) / (t - e), a * a * (3 - 2 * a));
}
function $455d545b1dff00eb$var$GD(a, e, t) {
    return a <= e ? 0 : a >= t ? 1 : (a = (a - e) / (t - e), a * a * a * (a * (a * 6 - 15) + 10));
}
function $455d545b1dff00eb$var$kD(a, e) {
    return a + Math.floor(Math.random() * (e - a + 1));
}
function $455d545b1dff00eb$var$jD(a, e) {
    return a + Math.random() * (e - a);
}
function $455d545b1dff00eb$var$XD(a) {
    return a * (.5 - Math.random());
}
function $455d545b1dff00eb$var$WD(a) {
    a !== void 0 && ($455d545b1dff00eb$var$P2 = a);
    let e = $455d545b1dff00eb$var$P2 += 1831565813;
    return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function $455d545b1dff00eb$var$qD(a) {
    return a * $455d545b1dff00eb$var$Hf;
}
function $455d545b1dff00eb$var$YD(a) {
    return a * $455d545b1dff00eb$var$Fd;
}
function $455d545b1dff00eb$var$ZD(a) {
    return (a & a - 1) === 0 && a !== 0;
}
function $455d545b1dff00eb$var$QD(a) {
    return Math.pow(2, Math.ceil(Math.log(a) / Math.LN2));
}
function $455d545b1dff00eb$var$KD(a) {
    return Math.pow(2, Math.floor(Math.log(a) / Math.LN2));
}
function $455d545b1dff00eb$var$JD(a, e, t, n, i) {
    const r = Math.cos, l = Math.sin, c = r(t / 2), f = l(t / 2), p = r((e + n) / 2), m = l((e + n) / 2), x = r((e - n) / 2), v = l((e - n) / 2), _ = r((n - e) / 2), S = l((n - e) / 2);
    switch(i){
        case "XYX":
            a.set(c * m, f * x, f * v, c * p);
            break;
        case "YZY":
            a.set(f * v, c * m, f * x, c * p);
            break;
        case "ZXZ":
            a.set(f * x, f * v, c * m, c * p);
            break;
        case "XZX":
            a.set(c * m, f * S, f * _, c * p);
            break;
        case "YXY":
            a.set(f * _, c * m, f * S, c * p);
            break;
        case "ZYZ":
            a.set(f * S, f * _, c * m, c * p);
            break;
        default:
            $455d545b1dff00eb$var$Mt("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
    }
}
function $455d545b1dff00eb$var$Cr(a, e) {
    switch(e.constructor){
        case Float32Array:
            return a;
        case Uint32Array:
            return a / 4294967295;
        case Uint16Array:
            return a / 65535;
        case Uint8Array:
            return a / 255;
        case Int32Array:
            return Math.max(a / 2147483647, -1);
        case Int16Array:
            return Math.max(a / 32767, -1);
        case Int8Array:
            return Math.max(a / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $455d545b1dff00eb$var$sn(a, e) {
    switch(e.constructor){
        case Float32Array:
            return a;
        case Uint32Array:
            return Math.round(a * 4294967295);
        case Uint16Array:
            return Math.round(a * 65535);
        case Uint8Array:
            return Math.round(a * 255);
        case Int32Array:
            return Math.round(a * 2147483647);
        case Int16Array:
            return Math.round(a * 32767);
        case Int8Array:
            return Math.round(a * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
const $455d545b1dff00eb$var$Of = {
    DEG2RAD: $455d545b1dff00eb$var$Hf,
    RAD2DEG: $455d545b1dff00eb$var$Fd,
    generateUUID: $455d545b1dff00eb$var$bs,
    clamp: $455d545b1dff00eb$var$Yt,
    euclideanModulo: $455d545b1dff00eb$var$Hb,
    mapLinear: $455d545b1dff00eb$var$BD,
    inverseLerp: $455d545b1dff00eb$var$ID,
    lerp: $455d545b1dff00eb$var$jm,
    damp: $455d545b1dff00eb$var$FD,
    pingpong: $455d545b1dff00eb$var$HD,
    smoothstep: $455d545b1dff00eb$var$VD,
    smootherstep: $455d545b1dff00eb$var$GD,
    randInt: $455d545b1dff00eb$var$kD,
    randFloat: $455d545b1dff00eb$var$jD,
    randFloatSpread: $455d545b1dff00eb$var$XD,
    seededRandom: $455d545b1dff00eb$var$WD,
    degToRad: $455d545b1dff00eb$var$qD,
    radToDeg: $455d545b1dff00eb$var$YD,
    isPowerOfTwo: $455d545b1dff00eb$var$ZD,
    ceilPowerOfTwo: $455d545b1dff00eb$var$QD,
    floorPowerOfTwo: $455d545b1dff00eb$var$KD,
    setQuaternionFromProperEuler: $455d545b1dff00eb$var$JD,
    normalize: $455d545b1dff00eb$var$sn,
    denormalize: $455d545b1dff00eb$var$Cr
};
class $455d545b1dff00eb$var$$e {
    constructor(e = 0, t = 0){
        $455d545b1dff00eb$var$$e.prototype.isVector2 = !0, this.x = e, this.y = t;
    }
    get width() {
        return this.x;
    }
    set width(e) {
        this.x = e;
    }
    get height() {
        return this.y;
    }
    set height(e) {
        this.y = e;
    }
    set(e, t) {
        return this.x = e, this.y = t, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this;
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    applyMatrix3(e) {
        const t = this.x, n = this.y, i = e.elements;
        return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
    }
    clamp(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e.x, t.x), this.y = $455d545b1dff00eb$var$Yt(this.y, e.y, t.y), this;
    }
    clampScalar(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e, t), this.y = $455d545b1dff00eb$var$Yt(this.y, e, t), this;
    }
    clampLength(e, t) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar($455d545b1dff00eb$var$Yt(n, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    cross(e) {
        return this.x * e.y - this.y * e.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        const n = this.dot(e) / t;
        return Math.acos($455d545b1dff00eb$var$Yt(n, -1, 1));
    }
    distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
        const t = this.x - e.x, n = this.y - e.y;
        return t * t + n * n;
    }
    manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
    }
    lerpVectors(e, t, n) {
        return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this;
    }
    rotateAround(e, t) {
        const n = Math.cos(t), i = Math.sin(t), r = this.x - e.x, l = this.y - e.y;
        return this.x = r * n - l * i + e.x, this.y = r * i + l * n + e.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
class $455d545b1dff00eb$var$Gn {
    constructor(e = 0, t = 0, n = 0, i = 1){
        this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = i;
    }
    static slerpFlat(e, t, n, i, r, l, c) {
        let f = n[i + 0], p = n[i + 1], m = n[i + 2], x = n[i + 3], v = r[l + 0], _ = r[l + 1], S = r[l + 2], A = r[l + 3];
        if (c <= 0) {
            e[t + 0] = f, e[t + 1] = p, e[t + 2] = m, e[t + 3] = x;
            return;
        }
        if (c >= 1) {
            e[t + 0] = v, e[t + 1] = _, e[t + 2] = S, e[t + 3] = A;
            return;
        }
        if (x !== A || f !== v || p !== _ || m !== S) {
            let M = f * v + p * _ + m * S + x * A;
            M < 0 && (v = -v, _ = -_, S = -S, A = -A, M = -M);
            let b = 1 - c;
            if (M < .9995) {
                const C = Math.acos(M), R = Math.sin(C);
                b = Math.sin(b * C) / R, c = Math.sin(c * C) / R, f = f * b + v * c, p = p * b + _ * c, m = m * b + S * c, x = x * b + A * c;
            } else {
                f = f * b + v * c, p = p * b + _ * c, m = m * b + S * c, x = x * b + A * c;
                const C = 1 / Math.sqrt(f * f + p * p + m * m + x * x);
                f *= C, p *= C, m *= C, x *= C;
            }
        }
        e[t] = f, e[t + 1] = p, e[t + 2] = m, e[t + 3] = x;
    }
    static multiplyQuaternionsFlat(e, t, n, i, r, l) {
        const c = n[i], f = n[i + 1], p = n[i + 2], m = n[i + 3], x = r[l], v = r[l + 1], _ = r[l + 2], S = r[l + 3];
        return e[t] = c * S + m * x + f * _ - p * v, e[t + 1] = f * S + m * v + p * x - c * _, e[t + 2] = p * S + m * _ + c * v - f * x, e[t + 3] = m * S - c * x - f * v - p * _, e;
    }
    get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(e) {
        this._w = e, this._onChangeCallback();
    }
    set(e, t, n, i) {
        return this._x = e, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(e) {
        return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
    }
    setFromEuler(e, t = !0) {
        const n = e._x, i = e._y, r = e._z, l = e._order, c = Math.cos, f = Math.sin, p = c(n / 2), m = c(i / 2), x = c(r / 2), v = f(n / 2), _ = f(i / 2), S = f(r / 2);
        switch(l){
            case "XYZ":
                this._x = v * m * x + p * _ * S, this._y = p * _ * x - v * m * S, this._z = p * m * S + v * _ * x, this._w = p * m * x - v * _ * S;
                break;
            case "YXZ":
                this._x = v * m * x + p * _ * S, this._y = p * _ * x - v * m * S, this._z = p * m * S - v * _ * x, this._w = p * m * x + v * _ * S;
                break;
            case "ZXY":
                this._x = v * m * x - p * _ * S, this._y = p * _ * x + v * m * S, this._z = p * m * S + v * _ * x, this._w = p * m * x - v * _ * S;
                break;
            case "ZYX":
                this._x = v * m * x - p * _ * S, this._y = p * _ * x + v * m * S, this._z = p * m * S - v * _ * x, this._w = p * m * x + v * _ * S;
                break;
            case "YZX":
                this._x = v * m * x + p * _ * S, this._y = p * _ * x + v * m * S, this._z = p * m * S - v * _ * x, this._w = p * m * x - v * _ * S;
                break;
            case "XZY":
                this._x = v * m * x - p * _ * S, this._y = p * _ * x - v * m * S, this._z = p * m * S + v * _ * x, this._w = p * m * x + v * _ * S;
                break;
            default:
                $455d545b1dff00eb$var$Mt("Quaternion: .setFromEuler() encountered an unknown order: " + l);
        }
        return t === !0 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(e, t) {
        const n = t / 2, i = Math.sin(n);
        return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e) {
        const t = e.elements, n = t[0], i = t[4], r = t[8], l = t[1], c = t[5], f = t[9], p = t[2], m = t[6], x = t[10], v = n + c + x;
        if (v > 0) {
            const _ = .5 / Math.sqrt(v + 1);
            this._w = .25 / _, this._x = (m - f) * _, this._y = (r - p) * _, this._z = (l - i) * _;
        } else if (n > c && n > x) {
            const _ = 2 * Math.sqrt(1 + n - c - x);
            this._w = (m - f) / _, this._x = .25 * _, this._y = (i + l) / _, this._z = (r + p) / _;
        } else if (c > x) {
            const _ = 2 * Math.sqrt(1 + c - n - x);
            this._w = (r - p) / _, this._x = (i + l) / _, this._y = .25 * _, this._z = (f + m) / _;
        } else {
            const _ = 2 * Math.sqrt(1 + x - n - c);
            this._w = (l - i) / _, this._x = (r + p) / _, this._y = (f + m) / _, this._z = .25 * _;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(e, t) {
        let n = e.dot(t) + 1;
        return n < 1e-8 ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
    }
    angleTo(e) {
        return 2 * Math.acos(Math.abs($455d545b1dff00eb$var$Yt(this.dot(e), -1, 1)));
    }
    rotateTowards(e, t) {
        const n = this.angleTo(e);
        if (n === 0) return this;
        const i = Math.min(1, t / n);
        return this.slerp(e, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(e) {
        return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let e = this.length();
        return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
    }
    multiply(e) {
        return this.multiplyQuaternions(this, e);
    }
    premultiply(e) {
        return this.multiplyQuaternions(e, this);
    }
    multiplyQuaternions(e, t) {
        const n = e._x, i = e._y, r = e._z, l = e._w, c = t._x, f = t._y, p = t._z, m = t._w;
        return this._x = n * m + l * c + i * p - r * f, this._y = i * m + l * f + r * c - n * p, this._z = r * m + l * p + n * f - i * c, this._w = l * m - n * c - i * f - r * p, this._onChangeCallback(), this;
    }
    slerp(e, t) {
        if (t <= 0) return this;
        if (t >= 1) return this.copy(e);
        let n = e._x, i = e._y, r = e._z, l = e._w, c = this.dot(e);
        c < 0 && (n = -n, i = -i, r = -r, l = -l, c = -c);
        let f = 1 - t;
        if (c < .9995) {
            const p = Math.acos(c), m = Math.sin(p);
            f = Math.sin(f * p) / m, t = Math.sin(t * p) / m, this._x = this._x * f + n * t, this._y = this._y * f + i * t, this._z = this._z * f + r * t, this._w = this._w * f + l * t, this._onChangeCallback();
        } else this._x = this._x * f + n * t, this._y = this._y * f + i * t, this._z = this._z * f + r * t, this._w = this._w * f + l * t, this.normalize();
        return this;
    }
    slerpQuaternions(e, t, n) {
        return this.copy(e).slerp(t, n);
    }
    random() {
        const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), n = Math.random(), i = Math.sqrt(1 - n), r = Math.sqrt(n);
        return this.set(i * Math.sin(e), i * Math.cos(e), r * Math.sin(t), r * Math.cos(t));
    }
    equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
    }
    fromArray(e, t = 0) {
        return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
    }
    fromBufferAttribute(e, t) {
        return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}
class $455d545b1dff00eb$var$J {
    constructor(e = 0, t = 0, n = 0){
        $455d545b1dff00eb$var$J.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = n;
    }
    set(e, t, n) {
        return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setZ(e) {
        return this.z = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this;
    }
    multiplyVectors(e, t) {
        return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
    }
    applyEuler(e) {
        return this.applyQuaternion($455d545b1dff00eb$var$B2.setFromEuler(e));
    }
    applyAxisAngle(e, t) {
        return this.applyQuaternion($455d545b1dff00eb$var$B2.setFromAxisAngle(e, t));
    }
    applyMatrix3(e) {
        const t = this.x, n = this.y, i = this.z, r = e.elements;
        return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
    }
    applyNormalMatrix(e) {
        return this.applyMatrix3(e).normalize();
    }
    applyMatrix4(e) {
        const t = this.x, n = this.y, i = this.z, r = e.elements, l = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
        return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * l, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * l, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * l, this;
    }
    applyQuaternion(e) {
        const t = this.x, n = this.y, i = this.z, r = e.x, l = e.y, c = e.z, f = e.w, p = 2 * (l * i - c * n), m = 2 * (c * t - r * i), x = 2 * (r * n - l * t);
        return this.x = t + f * p + l * x - c * m, this.y = n + f * m + c * p - r * x, this.z = i + f * x + r * m - l * p, this;
    }
    project(e) {
        return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
    }
    unproject(e) {
        return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
    }
    transformDirection(e) {
        const t = this.x, n = this.y, i = this.z, r = e.elements;
        return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
    }
    clamp(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e.x, t.x), this.y = $455d545b1dff00eb$var$Yt(this.y, e.y, t.y), this.z = $455d545b1dff00eb$var$Yt(this.z, e.z, t.z), this;
    }
    clampScalar(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e, t), this.y = $455d545b1dff00eb$var$Yt(this.y, e, t), this.z = $455d545b1dff00eb$var$Yt(this.z, e, t), this;
    }
    clampLength(e, t) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar($455d545b1dff00eb$var$Yt(n, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
    }
    lerpVectors(e, t, n) {
        return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
    }
    cross(e) {
        return this.crossVectors(this, e);
    }
    crossVectors(e, t) {
        const n = e.x, i = e.y, r = e.z, l = t.x, c = t.y, f = t.z;
        return this.x = i * f - r * c, this.y = r * l - n * f, this.z = n * c - i * l, this;
    }
    projectOnVector(e) {
        const t = e.lengthSq();
        if (t === 0) return this.set(0, 0, 0);
        const n = e.dot(this) / t;
        return this.copy(e).multiplyScalar(n);
    }
    projectOnPlane(e) {
        return $455d545b1dff00eb$var$D1.copy(this).projectOnVector(e), this.sub($455d545b1dff00eb$var$D1);
    }
    reflect(e) {
        return this.sub($455d545b1dff00eb$var$D1.copy(e).multiplyScalar(2 * this.dot(e)));
    }
    angleTo(e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq());
        if (t === 0) return Math.PI / 2;
        const n = this.dot(e) / t;
        return Math.acos($455d545b1dff00eb$var$Yt(n, -1, 1));
    }
    distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
        const t = this.x - e.x, n = this.y - e.y, i = this.z - e.z;
        return t * t + n * n + i * i;
    }
    manhattanDistanceTo(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
    }
    setFromSpherical(e) {
        return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
    }
    setFromSphericalCoords(e, t, n) {
        const i = Math.sin(t) * e;
        return this.x = i * Math.sin(n), this.y = Math.cos(t) * e, this.z = i * Math.cos(n), this;
    }
    setFromCylindrical(e) {
        return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
    }
    setFromCylindricalCoords(e, t, n) {
        return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
    }
    setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this;
    }
    setFromMatrixScale(e) {
        const t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
        return this.x = t, this.y = n, this.z = i, this;
    }
    setFromMatrixColumn(e, t) {
        return this.fromArray(e.elements, t * 4);
    }
    setFromMatrix3Column(e, t) {
        return this.fromArray(e.elements, t * 3);
    }
    setFromEuler(e) {
        return this.x = e._x, this.y = e._y, this.z = e._z, this;
    }
    setFromColor(e) {
        return this.x = e.r, this.y = e.g, this.z = e.b, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, n = Math.sqrt(1 - t * t);
        return this.x = n * Math.cos(e), this.y = t, this.z = n * Math.sin(e), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
const $455d545b1dff00eb$var$D1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$B2 = new $455d545b1dff00eb$var$Gn;
class $455d545b1dff00eb$var$Jt {
    constructor(e, t, n, i, r, l, c, f, p){
        $455d545b1dff00eb$var$Jt.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, n, i, r, l, c, f, p);
    }
    set(e, t, n, i, r, l, c, f, p) {
        const m = this.elements;
        return m[0] = e, m[1] = i, m[2] = c, m[3] = t, m[4] = r, m[5] = f, m[6] = n, m[7] = l, m[8] = p, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(e) {
        const t = this.elements, n = e.elements;
        return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
    }
    extractBasis(e, t, n) {
        return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(e) {
        const t = e.elements;
        return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
    }
    multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
        const n = e.elements, i = t.elements, r = this.elements, l = n[0], c = n[3], f = n[6], p = n[1], m = n[4], x = n[7], v = n[2], _ = n[5], S = n[8], A = i[0], M = i[3], b = i[6], C = i[1], R = i[4], N = i[7], z = i[2], L = i[5], P = i[8];
        return r[0] = l * A + c * C + f * z, r[3] = l * M + c * R + f * L, r[6] = l * b + c * N + f * P, r[1] = p * A + m * C + x * z, r[4] = p * M + m * R + x * L, r[7] = p * b + m * N + x * P, r[2] = v * A + _ * C + S * z, r[5] = v * M + _ * R + S * L, r[8] = v * b + _ * N + S * P, this;
    }
    multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
    }
    determinant() {
        const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], l = e[4], c = e[5], f = e[6], p = e[7], m = e[8];
        return t * l * m - t * c * p - n * r * m + n * c * f + i * r * p - i * l * f;
    }
    invert() {
        const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], l = e[4], c = e[5], f = e[6], p = e[7], m = e[8], x = m * l - c * p, v = c * f - m * r, _ = p * r - l * f, S = t * x + n * v + i * _;
        if (S === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const A = 1 / S;
        return e[0] = x * A, e[1] = (i * p - m * n) * A, e[2] = (c * n - i * l) * A, e[3] = v * A, e[4] = (m * t - i * f) * A, e[5] = (i * r - c * t) * A, e[6] = _ * A, e[7] = (n * f - p * t) * A, e[8] = (l * t - n * r) * A, this;
    }
    transpose() {
        let e;
        const t = this.elements;
        return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
    }
    getNormalMatrix(e) {
        return this.setFromMatrix4(e).invert().transpose();
    }
    transposeIntoArray(e) {
        const t = this.elements;
        return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
    }
    setUvTransform(e, t, n, i, r, l, c) {
        const f = Math.cos(r), p = Math.sin(r);
        return this.set(n * f, n * p, -n * (f * l + p * c) + l + e, -i * p, i * f, -i * (-p * l + f * c) + c + t, 0, 0, 1), this;
    }
    scale(e, t) {
        return this.premultiply($455d545b1dff00eb$var$U1.makeScale(e, t)), this;
    }
    rotate(e) {
        return this.premultiply($455d545b1dff00eb$var$U1.makeRotation(-e)), this;
    }
    translate(e, t) {
        return this.premultiply($455d545b1dff00eb$var$U1.makeTranslation(e, t)), this;
    }
    makeTranslation(e, t) {
        return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
    }
    makeRotation(e) {
        const t = Math.cos(e), n = Math.sin(e);
        return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
    }
    makeScale(e, t) {
        return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
    }
    equals(e) {
        const t = this.elements, n = e.elements;
        for(let i = 0; i < 9; i++)if (t[i] !== n[i]) return !1;
        return !0;
    }
    fromArray(e, t = 0) {
        for(let n = 0; n < 9; n++)this.elements[n] = e[n + t];
        return this;
    }
    toArray(e = [], t = 0) {
        const n = this.elements;
        return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $455d545b1dff00eb$var$U1 = new $455d545b1dff00eb$var$Jt, $455d545b1dff00eb$var$I2 = new $455d545b1dff00eb$var$Jt().set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), $455d545b1dff00eb$var$F2 = new $455d545b1dff00eb$var$Jt().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
function $455d545b1dff00eb$var$$D() {
    const a = {
        enabled: !0,
        workingColorSpace: $455d545b1dff00eb$var$No,
        spaces: {},
        convert: function(i, r, l) {
            return this.enabled === !1 || r === l || !r || !l || (this.spaces[r].transfer === $455d545b1dff00eb$var$Zn && (i.r = $455d545b1dff00eb$var$yc(i.r), i.g = $455d545b1dff00eb$var$yc(i.g), i.b = $455d545b1dff00eb$var$yc(i.b)), this.spaces[r].primaries !== this.spaces[l].primaries && (i.applyMatrix3(this.spaces[r].toXYZ), i.applyMatrix3(this.spaces[l].fromXYZ)), this.spaces[l].transfer === $455d545b1dff00eb$var$Zn && (i.r = $455d545b1dff00eb$var$Rd(i.r), i.g = $455d545b1dff00eb$var$Rd(i.g), i.b = $455d545b1dff00eb$var$Rd(i.b))), i;
        },
        workingToColorSpace: function(i, r) {
            return this.convert(i, this.workingColorSpace, r);
        },
        colorSpaceToWorking: function(i, r) {
            return this.convert(i, r, this.workingColorSpace);
        },
        getPrimaries: function(i) {
            return this.spaces[i].primaries;
        },
        getTransfer: function(i) {
            return i === $455d545b1dff00eb$var$pc ? $455d545b1dff00eb$var$a0 : this.spaces[i].transfer;
        },
        getToneMappingMode: function(i) {
            return this.spaces[i].outputColorSpaceConfig.toneMappingMode || "standard";
        },
        getLuminanceCoefficients: function(i, r = this.workingColorSpace) {
            return i.fromArray(this.spaces[r].luminanceCoefficients);
        },
        define: function(i) {
            Object.assign(this.spaces, i);
        },
        _getMatrix: function(i, r, l) {
            return i.copy(this.spaces[r].toXYZ).multiply(this.spaces[l].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(i) {
            return this.spaces[i].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(i = this.workingColorSpace) {
            return this.spaces[i].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function(i, r) {
            return $455d545b1dff00eb$var$Id("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), a.workingToColorSpace(i, r);
        },
        toWorkingColorSpace: function(i, r) {
            return $455d545b1dff00eb$var$Id("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), a.colorSpaceToWorking(i, r);
        }
    }, e = [
        .64,
        .33,
        .3,
        .6,
        .15,
        .06
    ], t = [
        .2126,
        .7152,
        .0722
    ], n = [
        .3127,
        .329
    ];
    return a.define({
        [$455d545b1dff00eb$var$No]: {
            primaries: e,
            whitePoint: n,
            transfer: $455d545b1dff00eb$var$a0,
            toXYZ: $455d545b1dff00eb$var$I2,
            fromXYZ: $455d545b1dff00eb$var$F2,
            luminanceCoefficients: t,
            workingColorSpaceConfig: {
                unpackColorSpace: $455d545b1dff00eb$var$nr
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $455d545b1dff00eb$var$nr
            }
        },
        [$455d545b1dff00eb$var$nr]: {
            primaries: e,
            whitePoint: n,
            transfer: $455d545b1dff00eb$var$Zn,
            toXYZ: $455d545b1dff00eb$var$I2,
            fromXYZ: $455d545b1dff00eb$var$F2,
            luminanceCoefficients: t,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $455d545b1dff00eb$var$nr
            }
        }
    }), a;
}
const $455d545b1dff00eb$var$Dn = $455d545b1dff00eb$var$$D();
function $455d545b1dff00eb$var$yc(a) {
    return a < .04045 ? a * .0773993808 : Math.pow(a * .9478672986 + .0521327014, 2.4);
}
function $455d545b1dff00eb$var$Rd(a) {
    return a < .0031308 ? a * 12.92 : 1.055 * Math.pow(a, .41666) - .055;
}
let $455d545b1dff00eb$var$td;
class $455d545b1dff00eb$var$_T {
    static getDataURL(e, t = "image/png") {
        if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src;
        let n;
        if (e instanceof HTMLCanvasElement) n = e;
        else {
            $455d545b1dff00eb$var$td === void 0 && ($455d545b1dff00eb$var$td = $455d545b1dff00eb$var$s0("canvas")), $455d545b1dff00eb$var$td.width = e.width, $455d545b1dff00eb$var$td.height = e.height;
            const i = $455d545b1dff00eb$var$td.getContext("2d");
            e instanceof ImageData ? i.putImageData(e, 0, 0) : i.drawImage(e, 0, 0, e.width, e.height), n = $455d545b1dff00eb$var$td;
        }
        return n.toDataURL(t);
    }
    static sRGBToLinear(e) {
        if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
            const t = $455d545b1dff00eb$var$s0("canvas");
            t.width = e.width, t.height = e.height;
            const n = t.getContext("2d");
            n.drawImage(e, 0, 0, e.width, e.height);
            const i = n.getImageData(0, 0, e.width, e.height), r = i.data;
            for(let l = 0; l < r.length; l++)r[l] = $455d545b1dff00eb$var$yc(r[l] / 255) * 255;
            return n.putImageData(i, 0, 0), t;
        } else if (e.data) {
            const t = e.data.slice(0);
            for(let n = 0; n < t.length; n++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[n] = Math.floor($455d545b1dff00eb$var$yc(t[n] / 255) * 255) : t[n] = $455d545b1dff00eb$var$yc(t[n]);
            return {
                data: t,
                width: e.width,
                height: e.height
            };
        } else return $455d545b1dff00eb$var$Mt("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
    }
}
let $455d545b1dff00eb$var$eU = 0;
class $455d545b1dff00eb$var$_u {
    constructor(e = null){
        this.isSource = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$eU++
        }), this.uuid = $455d545b1dff00eb$var$bs(), this.data = e, this.dataReady = !0, this.version = 0;
    }
    getSize(e) {
        const t = this.data;
        return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : t instanceof VideoFrame ? e.set(t.displayHeight, t.displayWidth, 0) : t !== null ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
    }
    set needsUpdate(e) {
        e === !0 && this.version++;
    }
    toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
        const n = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (i !== null) {
            let r;
            if (Array.isArray(i)) {
                r = [];
                for(let l = 0, c = i.length; l < c; l++)i[l].isDataTexture ? r.push($455d545b1dff00eb$var$N1(i[l].image)) : r.push($455d545b1dff00eb$var$N1(i[l]));
            } else r = $455d545b1dff00eb$var$N1(i);
            n.url = r;
        }
        return t || (e.images[this.uuid] = n), n;
    }
}
function $455d545b1dff00eb$var$N1(a) {
    return typeof HTMLImageElement < "u" && a instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && a instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && a instanceof ImageBitmap ? $455d545b1dff00eb$var$_T.getDataURL(a) : a.data ? {
        data: Array.from(a.data),
        width: a.width,
        height: a.height,
        type: a.data.constructor.name
    } : ($455d545b1dff00eb$var$Mt("Texture: Unable to serialize Texture."), {});
}
let $455d545b1dff00eb$var$tU = 0;
const $455d545b1dff00eb$var$O1 = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$Li extends $455d545b1dff00eb$var$Ml {
    constructor(e = $455d545b1dff00eb$var$Li.DEFAULT_IMAGE, t = $455d545b1dff00eb$var$Li.DEFAULT_MAPPING, n = $455d545b1dff00eb$var$Kr, i = $455d545b1dff00eb$var$Kr, r = $455d545b1dff00eb$var$mi, l = $455d545b1dff00eb$var$gl, c = $455d545b1dff00eb$var$ar, f = $455d545b1dff00eb$var$Ws, p = $455d545b1dff00eb$var$Li.DEFAULT_ANISOTROPY, m = $455d545b1dff00eb$var$pc){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$tU++
        }), this.uuid = $455d545b1dff00eb$var$bs(), this.name = "", this.source = new $455d545b1dff00eb$var$_u(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = l, this.anisotropy = p, this.format = c, this.internalFormat = null, this.type = f, this.offset = new $455d545b1dff00eb$var$$e(0, 0), this.repeat = new $455d545b1dff00eb$var$$e(1, 1), this.center = new $455d545b1dff00eb$var$$e(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $455d545b1dff00eb$var$Jt, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = m, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0;
    }
    get width() {
        return this.source.getSize($455d545b1dff00eb$var$O1).x;
    }
    get height() {
        return this.source.getSize($455d545b1dff00eb$var$O1).y;
    }
    get depth() {
        return this.source.getSize($455d545b1dff00eb$var$O1).z;
    }
    get image() {
        return this.source.data;
    }
    set image(e = null) {
        this.source.data = e;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
    }
    setValues(e) {
        for(const t in e){
            const n = e[t];
            if (n === void 0) {
                $455d545b1dff00eb$var$Mt(`Texture.setValues(): parameter '${t}' has value of undefined.`);
                continue;
            }
            const i = this[t];
            if (i === void 0) {
                $455d545b1dff00eb$var$Mt(`Texture.setValues(): property '${t}' does not exist.`);
                continue;
            }
            i && n && i.isVector2 && n.isVector2 || i && n && i.isVector3 && n.isVector3 || i && n && i.isMatrix3 && n.isMatrix3 ? i.copy(n) : this[t] = n;
        }
    }
    toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid];
        const n = {
            metadata: {
                version: 4.7,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(e).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(e) {
        if (this.mapping !== $455d545b1dff00eb$var$ty) return e;
        if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1) switch(this.wrapS){
            case $455d545b1dff00eb$var$e0:
                e.x = e.x - Math.floor(e.x);
                break;
            case $455d545b1dff00eb$var$Kr:
                e.x = e.x < 0 ? 0 : 1;
                break;
            case $455d545b1dff00eb$var$t0:
                Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
                break;
        }
        if (e.y < 0 || e.y > 1) switch(this.wrapT){
            case $455d545b1dff00eb$var$e0:
                e.y = e.y - Math.floor(e.y);
                break;
            case $455d545b1dff00eb$var$Kr:
                e.y = e.y < 0 ? 0 : 1;
                break;
            case $455d545b1dff00eb$var$t0:
                Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
                break;
        }
        return this.flipY && (e.y = 1 - e.y), e;
    }
    set needsUpdate(e) {
        e === !0 && (this.version++, this.source.needsUpdate = !0);
    }
    set needsPMREMUpdate(e) {
        e === !0 && this.pmremVersion++;
    }
}
$455d545b1dff00eb$var$Li.DEFAULT_IMAGE = null;
$455d545b1dff00eb$var$Li.DEFAULT_MAPPING = $455d545b1dff00eb$var$ty;
$455d545b1dff00eb$var$Li.DEFAULT_ANISOTROPY = 1;
class $455d545b1dff00eb$var$Un {
    constructor(e = 0, t = 0, n = 0, i = 1){
        $455d545b1dff00eb$var$Un.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = n, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(e) {
        this.z = e;
    }
    get height() {
        return this.w;
    }
    set height(e) {
        this.w = e;
    }
    set(e, t, n, i) {
        return this.x = e, this.y = t, this.z = n, this.w = i, this;
    }
    setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this.w = e, this;
    }
    setX(e) {
        return this.x = e, this;
    }
    setY(e) {
        return this.y = e, this;
    }
    setZ(e) {
        return this.z = e, this;
    }
    setW(e) {
        return this.w = e, this;
    }
    setComponent(e, t) {
        switch(e){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            case 3:
                this.w = t;
                break;
            default:
                throw new Error("index is out of range: " + e);
        }
        return this;
    }
    getComponent(e) {
        switch(e){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + e);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
    }
    add(e) {
        return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
    }
    addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this.w += e, this;
    }
    addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
    }
    addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
    }
    sub(e) {
        return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
    }
    subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
    }
    subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
    }
    multiply(e) {
        return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
    }
    multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
    }
    applyMatrix4(e) {
        const t = this.x, n = this.y, i = this.z, r = this.w, l = e.elements;
        return this.x = l[0] * t + l[4] * n + l[8] * i + l[12] * r, this.y = l[1] * t + l[5] * n + l[9] * i + l[13] * r, this.z = l[2] * t + l[6] * n + l[10] * i + l[14] * r, this.w = l[3] * t + l[7] * n + l[11] * i + l[15] * r, this;
    }
    divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
    }
    divideScalar(e) {
        return this.multiplyScalar(1 / e);
    }
    setAxisAngleFromQuaternion(e) {
        this.w = 2 * Math.acos(e.w);
        const t = Math.sqrt(1 - e.w * e.w);
        return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
    }
    setAxisAngleFromRotationMatrix(e) {
        let t, n, i, r;
        const f = e.elements, p = f[0], m = f[4], x = f[8], v = f[1], _ = f[5], S = f[9], A = f[2], M = f[6], b = f[10];
        if (Math.abs(m - v) < .01 && Math.abs(x - A) < .01 && Math.abs(S - M) < .01) {
            if (Math.abs(m + v) < .1 && Math.abs(x + A) < .1 && Math.abs(S + M) < .1 && Math.abs(p + _ + b - 3) < .1) return this.set(1, 0, 0, 0), this;
            t = Math.PI;
            const R = (p + 1) / 2, N = (_ + 1) / 2, z = (b + 1) / 2, L = (m + v) / 4, P = (x + A) / 4, H = (S + M) / 4;
            return R > N && R > z ? R < .01 ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(R), i = L / n, r = P / n) : N > z ? N < .01 ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(N), n = L / i, r = H / i) : z < .01 ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(z), n = P / r, i = H / r), this.set(n, i, r, t), this;
        }
        let C = Math.sqrt((M - S) * (M - S) + (x - A) * (x - A) + (v - m) * (v - m));
        return Math.abs(C) < .001 && (C = 1), this.x = (M - S) / C, this.y = (x - A) / C, this.z = (v - m) / C, this.w = Math.acos((p + _ + b - 1) / 2), this;
    }
    setFromMatrixPosition(e) {
        const t = e.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
    }
    min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
    }
    max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
    }
    clamp(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e.x, t.x), this.y = $455d545b1dff00eb$var$Yt(this.y, e.y, t.y), this.z = $455d545b1dff00eb$var$Yt(this.z, e.z, t.z), this.w = $455d545b1dff00eb$var$Yt(this.w, e.w, t.w), this;
    }
    clampScalar(e, t) {
        return this.x = $455d545b1dff00eb$var$Yt(this.x, e, t), this.y = $455d545b1dff00eb$var$Yt(this.y, e, t), this.z = $455d545b1dff00eb$var$Yt(this.z, e, t), this.w = $455d545b1dff00eb$var$Yt(this.w, e, t), this;
    }
    clampLength(e, t) {
        const n = this.length();
        return this.divideScalar(n || 1).multiplyScalar($455d545b1dff00eb$var$Yt(n, e, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
        return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
    }
    lerpVectors(e, t, n) {
        return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
    }
    equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
    }
    fromArray(e, t = 0) {
        return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
    }
    fromBufferAttribute(e, t) {
        return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
class $455d545b1dff00eb$var$Vb extends $455d545b1dff00eb$var$Ml {
    constructor(e = 1, t = 1, n = {}){
        super(), n = Object.assign({
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: $455d545b1dff00eb$var$mi,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1
        }, n), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = n.depth, this.scissor = new $455d545b1dff00eb$var$Un(0, 0, e, t), this.scissorTest = !1, this.viewport = new $455d545b1dff00eb$var$Un(0, 0, e, t);
        const i = {
            width: e,
            height: t,
            depth: n.depth
        }, r = new $455d545b1dff00eb$var$Li(i);
        this.textures = [];
        const l = n.count;
        for(let c = 0; c < l; c++)this.textures[c] = r.clone(), this.textures[c].isRenderTargetTexture = !0, this.textures[c].renderTarget = this;
        this._setTextureOptions(n), this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = n.depthTexture, this.samples = n.samples, this.multiview = n.multiview;
    }
    _setTextureOptions(e = {}) {
        const t = {
            minFilter: $455d545b1dff00eb$var$mi,
            generateMipmaps: !1,
            flipY: !1,
            internalFormat: null
        };
        e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
        for(let n = 0; n < this.textures.length; n++)this.textures[n].setValues(t);
    }
    get texture() {
        return this.textures[0];
    }
    set texture(e) {
        this.textures[0] = e;
    }
    set depthTexture(e) {
        this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(e, t, n = 1) {
        if (this.width !== e || this.height !== t || this.depth !== n) {
            this.width = e, this.height = t, this.depth = n;
            for(let i = 0, r = this.textures.length; i < r; i++)this.textures[i].image.width = e, this.textures[i].image.height = t, this.textures[i].image.depth = n, this.textures[i].isData3DTexture !== !0 && (this.textures[i].isArrayTexture = this.textures[i].image.depth > 1);
            this.dispose();
        }
        this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
        for(let t = 0, n = e.textures.length; t < n; t++){
            this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
            const i = Object.assign({}, e.textures[t].image);
            this.textures[t].source = new $455d545b1dff00eb$var$_u(i);
        }
        return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $455d545b1dff00eb$var$Oo extends $455d545b1dff00eb$var$Vb {
    constructor(e = 1, t = 1, n = {}){
        super(e, t, n), this.isWebGLRenderTarget = !0;
    }
}
class $455d545b1dff00eb$var$uy extends $455d545b1dff00eb$var$Li {
    constructor(e = null, t = 1, n = 1, i = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: e,
            width: t,
            height: n,
            depth: i
        }, this.magFilter = $455d545b1dff00eb$var$Fa, this.minFilter = $455d545b1dff00eb$var$Fa, this.wrapR = $455d545b1dff00eb$var$Kr, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
    }
    addLayerUpdate(e) {
        this.layerUpdates.add(e);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $455d545b1dff00eb$var$nU extends $455d545b1dff00eb$var$Oo {
    constructor(e = 1, t = 1, n = 1, i = {}){
        super(e, t, i), this.isWebGLArrayRenderTarget = !0, this.depth = n, this.texture = new $455d545b1dff00eb$var$uy(null, e, t, n), this._setTextureOptions(i), this.texture.isRenderTargetTexture = !0;
    }
}
class $455d545b1dff00eb$var$fy extends $455d545b1dff00eb$var$Li {
    constructor(e = null, t = 1, n = 1, i = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: e,
            width: t,
            height: n,
            depth: i
        }, this.magFilter = $455d545b1dff00eb$var$Fa, this.minFilter = $455d545b1dff00eb$var$Fa, this.wrapR = $455d545b1dff00eb$var$Kr, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
class $455d545b1dff00eb$var$iU extends $455d545b1dff00eb$var$Oo {
    constructor(e = 1, t = 1, n = 1, i = {}){
        super(e, t, i), this.isWebGL3DRenderTarget = !0, this.depth = n, this.texture = new $455d545b1dff00eb$var$fy(null, e, t, n), this._setTextureOptions(i), this.texture.isRenderTargetTexture = !0;
    }
}
class $455d545b1dff00eb$var$ca {
    constructor(e = new $455d545b1dff00eb$var$J(1 / 0, 1 / 0, 1 / 0), t = new $455d545b1dff00eb$var$J(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = e, this.max = t;
    }
    set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
    }
    setFromArray(e) {
        this.makeEmpty();
        for(let t = 0, n = e.length; t < n; t += 3)this.expandByPoint($455d545b1dff00eb$var$Mo.fromArray(e, t));
        return this;
    }
    setFromBufferAttribute(e) {
        this.makeEmpty();
        for(let t = 0, n = e.count; t < n; t++)this.expandByPoint($455d545b1dff00eb$var$Mo.fromBufferAttribute(e, t));
        return this;
    }
    setFromPoints(e) {
        this.makeEmpty();
        for(let t = 0, n = e.length; t < n; t++)this.expandByPoint(e[t]);
        return this;
    }
    setFromCenterAndSize(e, t) {
        const n = $455d545b1dff00eb$var$Mo.copy(t).multiplyScalar(.5);
        return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
    }
    setFromObject(e, t = !1) {
        return this.makeEmpty(), this.expandByObject(e, t);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(e) {
        return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
    }
    expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
    }
    expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
    }
    expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
    }
    expandByObject(e, t = !1) {
        e.updateWorldMatrix(!1, !1);
        const n = e.geometry;
        if (n !== void 0) {
            const r = n.getAttribute("position");
            if (t === !0 && r !== void 0 && e.isInstancedMesh !== !0) for(let l = 0, c = r.count; l < c; l++)e.isMesh === !0 ? e.getVertexPosition(l, $455d545b1dff00eb$var$Mo) : $455d545b1dff00eb$var$Mo.fromBufferAttribute(r, l), $455d545b1dff00eb$var$Mo.applyMatrix4(e.matrixWorld), this.expandByPoint($455d545b1dff00eb$var$Mo);
            else e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), $455d545b1dff00eb$var$Wg.copy(e.boundingBox)) : (n.boundingBox === null && n.computeBoundingBox(), $455d545b1dff00eb$var$Wg.copy(n.boundingBox)), $455d545b1dff00eb$var$Wg.applyMatrix4(e.matrixWorld), this.union($455d545b1dff00eb$var$Wg);
        }
        const i = e.children;
        for(let r = 0, l = i.length; r < l; r++)this.expandByObject(i[r], t);
        return this;
    }
    containsPoint(e) {
        return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
    }
    containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
    }
    getParameter(e, t) {
        return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(e) {
        return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
    }
    intersectsSphere(e) {
        return this.clampPoint(e.center, $455d545b1dff00eb$var$Mo), $455d545b1dff00eb$var$Mo.distanceToSquared(e.center) <= e.radius * e.radius;
    }
    intersectsPlane(e) {
        let t, n;
        return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
    }
    intersectsTriangle(e) {
        if (this.isEmpty()) return !1;
        this.getCenter($455d545b1dff00eb$var$ym), $455d545b1dff00eb$var$qg.subVectors(this.max, $455d545b1dff00eb$var$ym), $455d545b1dff00eb$var$nd.subVectors(e.a, $455d545b1dff00eb$var$ym), $455d545b1dff00eb$var$id.subVectors(e.b, $455d545b1dff00eb$var$ym), $455d545b1dff00eb$var$ad.subVectors(e.c, $455d545b1dff00eb$var$ym), $455d545b1dff00eb$var$fu.subVectors($455d545b1dff00eb$var$id, $455d545b1dff00eb$var$nd), $455d545b1dff00eb$var$hu.subVectors($455d545b1dff00eb$var$ad, $455d545b1dff00eb$var$id), $455d545b1dff00eb$var$xf.subVectors($455d545b1dff00eb$var$nd, $455d545b1dff00eb$var$ad);
        let t = [
            0,
            -$455d545b1dff00eb$var$fu.z,
            $455d545b1dff00eb$var$fu.y,
            0,
            -$455d545b1dff00eb$var$hu.z,
            $455d545b1dff00eb$var$hu.y,
            0,
            -$455d545b1dff00eb$var$xf.z,
            $455d545b1dff00eb$var$xf.y,
            $455d545b1dff00eb$var$fu.z,
            0,
            -$455d545b1dff00eb$var$fu.x,
            $455d545b1dff00eb$var$hu.z,
            0,
            -$455d545b1dff00eb$var$hu.x,
            $455d545b1dff00eb$var$xf.z,
            0,
            -$455d545b1dff00eb$var$xf.x,
            -$455d545b1dff00eb$var$fu.y,
            $455d545b1dff00eb$var$fu.x,
            0,
            -$455d545b1dff00eb$var$hu.y,
            $455d545b1dff00eb$var$hu.x,
            0,
            -$455d545b1dff00eb$var$xf.y,
            $455d545b1dff00eb$var$xf.x,
            0
        ];
        return !$455d545b1dff00eb$var$L1(t, $455d545b1dff00eb$var$nd, $455d545b1dff00eb$var$id, $455d545b1dff00eb$var$ad, $455d545b1dff00eb$var$qg) || (t = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !$455d545b1dff00eb$var$L1(t, $455d545b1dff00eb$var$nd, $455d545b1dff00eb$var$id, $455d545b1dff00eb$var$ad, $455d545b1dff00eb$var$qg)) ? !1 : ($455d545b1dff00eb$var$Yg.crossVectors($455d545b1dff00eb$var$fu, $455d545b1dff00eb$var$hu), t = [
            $455d545b1dff00eb$var$Yg.x,
            $455d545b1dff00eb$var$Yg.y,
            $455d545b1dff00eb$var$Yg.z
        ], $455d545b1dff00eb$var$L1(t, $455d545b1dff00eb$var$nd, $455d545b1dff00eb$var$id, $455d545b1dff00eb$var$ad, $455d545b1dff00eb$var$qg));
    }
    clampPoint(e, t) {
        return t.copy(e).clamp(this.min, this.max);
    }
    distanceToPoint(e) {
        return this.clampPoint(e, $455d545b1dff00eb$var$Mo).distanceTo(e);
    }
    getBoundingSphere(e) {
        return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize($455d545b1dff00eb$var$Mo).length() * .5), e;
    }
    intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
    }
    applyMatrix4(e) {
        return this.isEmpty() ? this : ($455d545b1dff00eb$var$sc[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), $455d545b1dff00eb$var$sc[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints($455d545b1dff00eb$var$sc), this);
    }
    translate(e) {
        return this.min.add(e), this.max.add(e), this;
    }
    equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
    }
    toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    fromJSON(e) {
        return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
    }
}
const $455d545b1dff00eb$var$sc = [
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J,
    new $455d545b1dff00eb$var$J
], $455d545b1dff00eb$var$Mo = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Wg = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$nd = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$id = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ad = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$fu = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$hu = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$xf = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ym = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$qg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Yg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$vf = new $455d545b1dff00eb$var$J;
function $455d545b1dff00eb$var$L1(a, e, t, n, i) {
    for(let r = 0, l = a.length - 3; r <= l; r += 3){
        $455d545b1dff00eb$var$vf.fromArray(a, r);
        const c = i.x * Math.abs($455d545b1dff00eb$var$vf.x) + i.y * Math.abs($455d545b1dff00eb$var$vf.y) + i.z * Math.abs($455d545b1dff00eb$var$vf.z), f = e.dot($455d545b1dff00eb$var$vf), p = t.dot($455d545b1dff00eb$var$vf), m = n.dot($455d545b1dff00eb$var$vf);
        if (Math.max(-Math.max(f, p, m), Math.min(f, p, m)) > c) return !1;
    }
    return !0;
}
const $455d545b1dff00eb$var$aU = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$_m = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$z1 = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$Ta {
    constructor(e = new $455d545b1dff00eb$var$J, t = -1){
        this.isSphere = !0, this.center = e, this.radius = t;
    }
    set(e, t) {
        return this.center.copy(e), this.radius = t, this;
    }
    setFromPoints(e, t) {
        const n = this.center;
        t !== void 0 ? n.copy(t) : $455d545b1dff00eb$var$aU.setFromPoints(e).getCenter(n);
        let i = 0;
        for(let r = 0, l = e.length; r < l; r++)i = Math.max(i, n.distanceToSquared(e[r]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(e) {
        return this.center.copy(e.center), this.radius = e.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(e) {
        return e.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(e) {
        const t = this.radius + e.radius;
        return e.center.distanceToSquared(this.center) <= t * t;
    }
    intersectsBox(e) {
        return e.intersectsSphere(this);
    }
    intersectsPlane(e) {
        return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(e, t) {
        const n = this.center.distanceToSquared(e);
        return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
    }
    getBoundingBox(e) {
        return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
    }
    applyMatrix4(e) {
        return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
    }
    translate(e) {
        return this.center.add(e), this;
    }
    expandByPoint(e) {
        if (this.isEmpty()) return this.center.copy(e), this.radius = 0, this;
        $455d545b1dff00eb$var$_m.subVectors(e, this.center);
        const t = $455d545b1dff00eb$var$_m.lengthSq();
        if (t > this.radius * this.radius) {
            const n = Math.sqrt(t), i = (n - this.radius) * .5;
            this.center.addScaledVector($455d545b1dff00eb$var$_m, i / n), this.radius += i;
        }
        return this;
    }
    union(e) {
        return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : ($455d545b1dff00eb$var$z1.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint($455d545b1dff00eb$var$_m.copy(e.center).add($455d545b1dff00eb$var$z1)), this.expandByPoint($455d545b1dff00eb$var$_m.copy(e.center).sub($455d545b1dff00eb$var$z1))), this);
    }
    equals(e) {
        return e.center.equals(this.center) && e.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    fromJSON(e) {
        return this.radius = e.radius, this.center.fromArray(e.center), this;
    }
}
const $455d545b1dff00eb$var$oc = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$P1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Zg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$du = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$B1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Qg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$I1 = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$Kf {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J(0, 0, -1)){
        this.origin = e, this.direction = t;
    }
    set(e, t) {
        return this.origin.copy(e), this.direction.copy(t), this;
    }
    copy(e) {
        return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
    }
    at(e, t) {
        return t.copy(this.origin).addScaledVector(this.direction, e);
    }
    lookAt(e) {
        return this.direction.copy(e).sub(this.origin).normalize(), this;
    }
    recast(e) {
        return this.origin.copy(this.at(e, $455d545b1dff00eb$var$oc)), this;
    }
    closestPointToPoint(e, t) {
        t.subVectors(e, this.origin);
        const n = t.dot(this.direction);
        return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
    }
    distanceToPoint(e) {
        return Math.sqrt(this.distanceSqToPoint(e));
    }
    distanceSqToPoint(e) {
        const t = $455d545b1dff00eb$var$oc.subVectors(e, this.origin).dot(this.direction);
        return t < 0 ? this.origin.distanceToSquared(e) : ($455d545b1dff00eb$var$oc.copy(this.origin).addScaledVector(this.direction, t), $455d545b1dff00eb$var$oc.distanceToSquared(e));
    }
    distanceSqToSegment(e, t, n, i) {
        $455d545b1dff00eb$var$P1.copy(e).add(t).multiplyScalar(.5), $455d545b1dff00eb$var$Zg.copy(t).sub(e).normalize(), $455d545b1dff00eb$var$du.copy(this.origin).sub($455d545b1dff00eb$var$P1);
        const r = e.distanceTo(t) * .5, l = -this.direction.dot($455d545b1dff00eb$var$Zg), c = $455d545b1dff00eb$var$du.dot(this.direction), f = -$455d545b1dff00eb$var$du.dot($455d545b1dff00eb$var$Zg), p = $455d545b1dff00eb$var$du.lengthSq(), m = Math.abs(1 - l * l);
        let x, v, _, S;
        if (m > 0) {
            if (x = l * f - c, v = l * c - f, S = r * m, x >= 0) {
                if (v >= -S) {
                    if (v <= S) {
                        const A = 1 / m;
                        x *= A, v *= A, _ = x * (x + l * v + 2 * c) + v * (l * x + v + 2 * f) + p;
                    } else v = r, x = Math.max(0, -(l * v + c)), _ = -x * x + v * (v + 2 * f) + p;
                } else v = -r, x = Math.max(0, -(l * v + c)), _ = -x * x + v * (v + 2 * f) + p;
            } else v <= -S ? (x = Math.max(0, -(-l * r + c)), v = x > 0 ? -r : Math.min(Math.max(-r, -f), r), _ = -x * x + v * (v + 2 * f) + p) : v <= S ? (x = 0, v = Math.min(Math.max(-r, -f), r), _ = v * (v + 2 * f) + p) : (x = Math.max(0, -(l * r + c)), v = x > 0 ? r : Math.min(Math.max(-r, -f), r), _ = -x * x + v * (v + 2 * f) + p);
        } else v = l > 0 ? -r : r, x = Math.max(0, -(l * v + c)), _ = -x * x + v * (v + 2 * f) + p;
        return n && n.copy(this.origin).addScaledVector(this.direction, x), i && i.copy($455d545b1dff00eb$var$P1).addScaledVector($455d545b1dff00eb$var$Zg, v), _;
    }
    intersectSphere(e, t) {
        $455d545b1dff00eb$var$oc.subVectors(e.center, this.origin);
        const n = $455d545b1dff00eb$var$oc.dot(this.direction), i = $455d545b1dff00eb$var$oc.dot($455d545b1dff00eb$var$oc) - n * n, r = e.radius * e.radius;
        if (i > r) return null;
        const l = Math.sqrt(r - i), c = n - l, f = n + l;
        return f < 0 ? null : c < 0 ? this.at(f, t) : this.at(c, t);
    }
    intersectsSphere(e) {
        return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
    }
    distanceToPlane(e) {
        const t = e.normal.dot(this.direction);
        if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
        const n = -(this.origin.dot(e.normal) + e.constant) / t;
        return n >= 0 ? n : null;
    }
    intersectPlane(e, t) {
        const n = this.distanceToPlane(e);
        return n === null ? null : this.at(n, t);
    }
    intersectsPlane(e) {
        const t = e.distanceToPoint(this.origin);
        return t === 0 || e.normal.dot(this.direction) * t < 0;
    }
    intersectBox(e, t) {
        let n, i, r, l, c, f;
        const p = 1 / this.direction.x, m = 1 / this.direction.y, x = 1 / this.direction.z, v = this.origin;
        return p >= 0 ? (n = (e.min.x - v.x) * p, i = (e.max.x - v.x) * p) : (n = (e.max.x - v.x) * p, i = (e.min.x - v.x) * p), m >= 0 ? (r = (e.min.y - v.y) * m, l = (e.max.y - v.y) * m) : (r = (e.max.y - v.y) * m, l = (e.min.y - v.y) * m), n > l || r > i || ((r > n || isNaN(n)) && (n = r), (l < i || isNaN(i)) && (i = l), x >= 0 ? (c = (e.min.z - v.z) * x, f = (e.max.z - v.z) * x) : (c = (e.max.z - v.z) * x, f = (e.min.z - v.z) * x), n > f || c > i) || ((c > n || n !== n) && (n = c), (f < i || i !== i) && (i = f), i < 0) ? null : this.at(n >= 0 ? n : i, t);
    }
    intersectsBox(e) {
        return this.intersectBox(e, $455d545b1dff00eb$var$oc) !== null;
    }
    intersectTriangle(e, t, n, i, r) {
        $455d545b1dff00eb$var$B1.subVectors(t, e), $455d545b1dff00eb$var$Qg.subVectors(n, e), $455d545b1dff00eb$var$I1.crossVectors($455d545b1dff00eb$var$B1, $455d545b1dff00eb$var$Qg);
        let l = this.direction.dot($455d545b1dff00eb$var$I1), c;
        if (l > 0) {
            if (i) return null;
            c = 1;
        } else if (l < 0) c = -1, l = -l;
        else return null;
        $455d545b1dff00eb$var$du.subVectors(this.origin, e);
        const f = c * this.direction.dot($455d545b1dff00eb$var$Qg.crossVectors($455d545b1dff00eb$var$du, $455d545b1dff00eb$var$Qg));
        if (f < 0) return null;
        const p = c * this.direction.dot($455d545b1dff00eb$var$B1.cross($455d545b1dff00eb$var$du));
        if (p < 0 || f + p > l) return null;
        const m = -c * $455d545b1dff00eb$var$du.dot($455d545b1dff00eb$var$I1);
        return m < 0 ? null : this.at(m / l, r);
    }
    applyMatrix4(e) {
        return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
    }
    equals(e) {
        return e.origin.equals(this.origin) && e.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $455d545b1dff00eb$var$Ft {
    constructor(e, t, n, i, r, l, c, f, p, m, x, v, _, S, A, M){
        $455d545b1dff00eb$var$Ft.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, n, i, r, l, c, f, p, m, x, v, _, S, A, M);
    }
    set(e, t, n, i, r, l, c, f, p, m, x, v, _, S, A, M) {
        const b = this.elements;
        return b[0] = e, b[4] = t, b[8] = n, b[12] = i, b[1] = r, b[5] = l, b[9] = c, b[13] = f, b[2] = p, b[6] = m, b[10] = x, b[14] = v, b[3] = _, b[7] = S, b[11] = A, b[15] = M, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return new $455d545b1dff00eb$var$Ft().fromArray(this.elements);
    }
    copy(e) {
        const t = this.elements, n = e.elements;
        return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
    }
    copyPosition(e) {
        const t = this.elements, n = e.elements;
        return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
    }
    setFromMatrix3(e) {
        const t = e.elements;
        return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(e, t, n) {
        return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(e, t, n) {
        return this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(e) {
        const t = this.elements, n = e.elements, i = 1 / $455d545b1dff00eb$var$rd.setFromMatrixColumn(e, 0).length(), r = 1 / $455d545b1dff00eb$var$rd.setFromMatrixColumn(e, 1).length(), l = 1 / $455d545b1dff00eb$var$rd.setFromMatrixColumn(e, 2).length();
        return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * l, t[9] = n[9] * l, t[10] = n[10] * l, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromEuler(e) {
        const t = this.elements, n = e.x, i = e.y, r = e.z, l = Math.cos(n), c = Math.sin(n), f = Math.cos(i), p = Math.sin(i), m = Math.cos(r), x = Math.sin(r);
        if (e.order === "XYZ") {
            const v = l * m, _ = l * x, S = c * m, A = c * x;
            t[0] = f * m, t[4] = -f * x, t[8] = p, t[1] = _ + S * p, t[5] = v - A * p, t[9] = -c * f, t[2] = A - v * p, t[6] = S + _ * p, t[10] = l * f;
        } else if (e.order === "YXZ") {
            const v = f * m, _ = f * x, S = p * m, A = p * x;
            t[0] = v + A * c, t[4] = S * c - _, t[8] = l * p, t[1] = l * x, t[5] = l * m, t[9] = -c, t[2] = _ * c - S, t[6] = A + v * c, t[10] = l * f;
        } else if (e.order === "ZXY") {
            const v = f * m, _ = f * x, S = p * m, A = p * x;
            t[0] = v - A * c, t[4] = -l * x, t[8] = S + _ * c, t[1] = _ + S * c, t[5] = l * m, t[9] = A - v * c, t[2] = -l * p, t[6] = c, t[10] = l * f;
        } else if (e.order === "ZYX") {
            const v = l * m, _ = l * x, S = c * m, A = c * x;
            t[0] = f * m, t[4] = S * p - _, t[8] = v * p + A, t[1] = f * x, t[5] = A * p + v, t[9] = _ * p - S, t[2] = -p, t[6] = c * f, t[10] = l * f;
        } else if (e.order === "YZX") {
            const v = l * f, _ = l * p, S = c * f, A = c * p;
            t[0] = f * m, t[4] = A - v * x, t[8] = S * x + _, t[1] = x, t[5] = l * m, t[9] = -c * m, t[2] = -p * m, t[6] = _ * x + S, t[10] = v - A * x;
        } else if (e.order === "XZY") {
            const v = l * f, _ = l * p, S = c * f, A = c * p;
            t[0] = f * m, t[4] = -x, t[8] = p * m, t[1] = v * x + A, t[5] = l * m, t[9] = _ * x - S, t[2] = S * x - _, t[6] = c * m, t[10] = A * x + v;
        }
        return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromQuaternion(e) {
        return this.compose($455d545b1dff00eb$var$rU, e, $455d545b1dff00eb$var$sU);
    }
    lookAt(e, t, n) {
        const i = this.elements;
        return $455d545b1dff00eb$var$vs.subVectors(e, t), $455d545b1dff00eb$var$vs.lengthSq() === 0 && ($455d545b1dff00eb$var$vs.z = 1), $455d545b1dff00eb$var$vs.normalize(), $455d545b1dff00eb$var$pu.crossVectors(n, $455d545b1dff00eb$var$vs), $455d545b1dff00eb$var$pu.lengthSq() === 0 && (Math.abs(n.z) === 1 ? $455d545b1dff00eb$var$vs.x += 1e-4 : $455d545b1dff00eb$var$vs.z += 1e-4, $455d545b1dff00eb$var$vs.normalize(), $455d545b1dff00eb$var$pu.crossVectors(n, $455d545b1dff00eb$var$vs)), $455d545b1dff00eb$var$pu.normalize(), $455d545b1dff00eb$var$Kg.crossVectors($455d545b1dff00eb$var$vs, $455d545b1dff00eb$var$pu), i[0] = $455d545b1dff00eb$var$pu.x, i[4] = $455d545b1dff00eb$var$Kg.x, i[8] = $455d545b1dff00eb$var$vs.x, i[1] = $455d545b1dff00eb$var$pu.y, i[5] = $455d545b1dff00eb$var$Kg.y, i[9] = $455d545b1dff00eb$var$vs.y, i[2] = $455d545b1dff00eb$var$pu.z, i[6] = $455d545b1dff00eb$var$Kg.z, i[10] = $455d545b1dff00eb$var$vs.z, this;
    }
    multiply(e) {
        return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
        return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
        const n = e.elements, i = t.elements, r = this.elements, l = n[0], c = n[4], f = n[8], p = n[12], m = n[1], x = n[5], v = n[9], _ = n[13], S = n[2], A = n[6], M = n[10], b = n[14], C = n[3], R = n[7], N = n[11], z = n[15], L = i[0], P = i[4], H = i[8], O = i[12], D = i[1], j = i[5], G = i[9], q = i[13], Y = i[2], ae = i[6], F = i[10], Q = i[14], K = i[3], $ = i[7], ee = i[11], I = i[15];
        return r[0] = l * L + c * D + f * Y + p * K, r[4] = l * P + c * j + f * ae + p * $, r[8] = l * H + c * G + f * F + p * ee, r[12] = l * O + c * q + f * Q + p * I, r[1] = m * L + x * D + v * Y + _ * K, r[5] = m * P + x * j + v * ae + _ * $, r[9] = m * H + x * G + v * F + _ * ee, r[13] = m * O + x * q + v * Q + _ * I, r[2] = S * L + A * D + M * Y + b * K, r[6] = S * P + A * j + M * ae + b * $, r[10] = S * H + A * G + M * F + b * ee, r[14] = S * O + A * q + M * Q + b * I, r[3] = C * L + R * D + N * Y + z * K, r[7] = C * P + R * j + N * ae + z * $, r[11] = C * H + R * G + N * F + z * ee, r[15] = C * O + R * q + N * Q + z * I, this;
    }
    multiplyScalar(e) {
        const t = this.elements;
        return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
    }
    determinant() {
        const e = this.elements, t = e[0], n = e[4], i = e[8], r = e[12], l = e[1], c = e[5], f = e[9], p = e[13], m = e[2], x = e[6], v = e[10], _ = e[14], S = e[3], A = e[7], M = e[11], b = e[15];
        return S * (+r * f * x - i * p * x - r * c * v + n * p * v + i * c * _ - n * f * _) + A * (+t * f * _ - t * p * v + r * l * v - i * l * _ + i * p * m - r * f * m) + M * (+t * p * x - t * c * _ - r * l * x + n * l * _ + r * c * m - n * p * m) + b * (-i * c * m - t * f * x + t * c * v + i * l * x - n * l * v + n * f * m);
    }
    transpose() {
        const e = this.elements;
        let t;
        return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
    }
    setPosition(e, t, n) {
        const i = this.elements;
        return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = t, i[14] = n), this;
    }
    invert() {
        const e = this.elements, t = e[0], n = e[1], i = e[2], r = e[3], l = e[4], c = e[5], f = e[6], p = e[7], m = e[8], x = e[9], v = e[10], _ = e[11], S = e[12], A = e[13], M = e[14], b = e[15], C = x * M * p - A * v * p + A * f * _ - c * M * _ - x * f * b + c * v * b, R = S * v * p - m * M * p - S * f * _ + l * M * _ + m * f * b - l * v * b, N = m * A * p - S * x * p + S * c * _ - l * A * _ - m * c * b + l * x * b, z = S * x * f - m * A * f - S * c * v + l * A * v + m * c * M - l * x * M, L = t * C + n * R + i * N + r * z;
        if (L === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const P = 1 / L;
        return e[0] = C * P, e[1] = (A * v * r - x * M * r - A * i * _ + n * M * _ + x * i * b - n * v * b) * P, e[2] = (c * M * r - A * f * r + A * i * p - n * M * p - c * i * b + n * f * b) * P, e[3] = (x * f * r - c * v * r - x * i * p + n * v * p + c * i * _ - n * f * _) * P, e[4] = R * P, e[5] = (m * M * r - S * v * r + S * i * _ - t * M * _ - m * i * b + t * v * b) * P, e[6] = (S * f * r - l * M * r - S * i * p + t * M * p + l * i * b - t * f * b) * P, e[7] = (l * v * r - m * f * r + m * i * p - t * v * p - l * i * _ + t * f * _) * P, e[8] = N * P, e[9] = (S * x * r - m * A * r - S * n * _ + t * A * _ + m * n * b - t * x * b) * P, e[10] = (l * A * r - S * c * r + S * n * p - t * A * p - l * n * b + t * c * b) * P, e[11] = (m * c * r - l * x * r - m * n * p + t * x * p + l * n * _ - t * c * _) * P, e[12] = z * P, e[13] = (m * A * i - S * x * i + S * n * v - t * A * v - m * n * M + t * x * M) * P, e[14] = (S * c * i - l * A * i - S * n * f + t * A * f + l * n * M - t * c * M) * P, e[15] = (l * x * i - m * c * i + m * n * f - t * x * f - l * n * v + t * c * v) * P, this;
    }
    scale(e) {
        const t = this.elements, n = e.x, i = e.y, r = e.z;
        return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
    }
    getMaxScaleOnAxis() {
        const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
        return Math.sqrt(Math.max(t, n, i));
    }
    makeTranslation(e, t, n) {
        return e.isVector3 ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1) : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
    }
    makeRotationX(e) {
        const t = Math.cos(e), n = Math.sin(e);
        return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(e) {
        const t = Math.cos(e), n = Math.sin(e);
        return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(e) {
        const t = Math.cos(e), n = Math.sin(e);
        return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(e, t) {
        const n = Math.cos(t), i = Math.sin(t), r = 1 - n, l = e.x, c = e.y, f = e.z, p = r * l, m = r * c;
        return this.set(p * l + n, p * c - i * f, p * f + i * c, 0, p * c + i * f, m * c + n, m * f - i * l, 0, p * f - i * c, m * f + i * l, r * f * f + n, 0, 0, 0, 0, 1), this;
    }
    makeScale(e, t, n) {
        return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
    makeShear(e, t, n, i, r, l) {
        return this.set(1, n, r, 0, e, 1, l, 0, t, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(e, t, n) {
        const i = this.elements, r = t._x, l = t._y, c = t._z, f = t._w, p = r + r, m = l + l, x = c + c, v = r * p, _ = r * m, S = r * x, A = l * m, M = l * x, b = c * x, C = f * p, R = f * m, N = f * x, z = n.x, L = n.y, P = n.z;
        return i[0] = (1 - (A + b)) * z, i[1] = (_ + N) * z, i[2] = (S - R) * z, i[3] = 0, i[4] = (_ - N) * L, i[5] = (1 - (v + b)) * L, i[6] = (M + C) * L, i[7] = 0, i[8] = (S + R) * P, i[9] = (M - C) * P, i[10] = (1 - (v + A)) * P, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
    }
    decompose(e, t, n) {
        const i = this.elements;
        let r = $455d545b1dff00eb$var$rd.set(i[0], i[1], i[2]).length();
        const l = $455d545b1dff00eb$var$rd.set(i[4], i[5], i[6]).length(), c = $455d545b1dff00eb$var$rd.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (r = -r), e.x = i[12], e.y = i[13], e.z = i[14], $455d545b1dff00eb$var$Eo.copy(this);
        const p = 1 / r, m = 1 / l, x = 1 / c;
        return $455d545b1dff00eb$var$Eo.elements[0] *= p, $455d545b1dff00eb$var$Eo.elements[1] *= p, $455d545b1dff00eb$var$Eo.elements[2] *= p, $455d545b1dff00eb$var$Eo.elements[4] *= m, $455d545b1dff00eb$var$Eo.elements[5] *= m, $455d545b1dff00eb$var$Eo.elements[6] *= m, $455d545b1dff00eb$var$Eo.elements[8] *= x, $455d545b1dff00eb$var$Eo.elements[9] *= x, $455d545b1dff00eb$var$Eo.elements[10] *= x, t.setFromRotationMatrix($455d545b1dff00eb$var$Eo), n.x = r, n.y = l, n.z = c, this;
    }
    makePerspective(e, t, n, i, r, l, c = $455d545b1dff00eb$var$_s, f = !1) {
        const p = this.elements, m = 2 * r / (t - e), x = 2 * r / (n - i), v = (t + e) / (t - e), _ = (n + i) / (n - i);
        let S, A;
        if (f) S = r / (l - r), A = l * r / (l - r);
        else if (c === $455d545b1dff00eb$var$_s) S = -(l + r) / (l - r), A = -2 * l * r / (l - r);
        else if (c === $455d545b1dff00eb$var$Bd) S = -l / (l - r), A = -l * r / (l - r);
        else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + c);
        return p[0] = m, p[4] = 0, p[8] = v, p[12] = 0, p[1] = 0, p[5] = x, p[9] = _, p[13] = 0, p[2] = 0, p[6] = 0, p[10] = S, p[14] = A, p[3] = 0, p[7] = 0, p[11] = -1, p[15] = 0, this;
    }
    makeOrthographic(e, t, n, i, r, l, c = $455d545b1dff00eb$var$_s, f = !1) {
        const p = this.elements, m = 2 / (t - e), x = 2 / (n - i), v = -(t + e) / (t - e), _ = -(n + i) / (n - i);
        let S, A;
        if (f) S = 1 / (l - r), A = l / (l - r);
        else if (c === $455d545b1dff00eb$var$_s) S = -2 / (l - r), A = -(l + r) / (l - r);
        else if (c === $455d545b1dff00eb$var$Bd) S = -1 / (l - r), A = -r / (l - r);
        else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + c);
        return p[0] = m, p[4] = 0, p[8] = 0, p[12] = v, p[1] = 0, p[5] = x, p[9] = 0, p[13] = _, p[2] = 0, p[6] = 0, p[10] = S, p[14] = A, p[3] = 0, p[7] = 0, p[11] = 0, p[15] = 1, this;
    }
    equals(e) {
        const t = this.elements, n = e.elements;
        for(let i = 0; i < 16; i++)if (t[i] !== n[i]) return !1;
        return !0;
    }
    fromArray(e, t = 0) {
        for(let n = 0; n < 16; n++)this.elements[n] = e[n + t];
        return this;
    }
    toArray(e = [], t = 0) {
        const n = this.elements;
        return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
    }
}
const $455d545b1dff00eb$var$rd = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Eo = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$rU = new $455d545b1dff00eb$var$J(0, 0, 0), $455d545b1dff00eb$var$sU = new $455d545b1dff00eb$var$J(1, 1, 1), $455d545b1dff00eb$var$pu = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Kg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$vs = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$H2 = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$V2 = new $455d545b1dff00eb$var$Gn;
class $455d545b1dff00eb$var$ua {
    constructor(e = 0, t = 0, n = 0, i = $455d545b1dff00eb$var$ua.DEFAULT_ORDER){
        this.isEuler = !0, this._x = e, this._y = t, this._z = n, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(e) {
        this._x = e, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e) {
        this._y = e, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e) {
        this._z = e, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(e) {
        this._order = e, this._onChangeCallback();
    }
    set(e, t, n, i = this._order) {
        return this._x = e, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(e) {
        return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e, t = this._order, n = !0) {
        const i = e.elements, r = i[0], l = i[4], c = i[8], f = i[1], p = i[5], m = i[9], x = i[2], v = i[6], _ = i[10];
        switch(t){
            case "XYZ":
                this._y = Math.asin($455d545b1dff00eb$var$Yt(c, -1, 1)), Math.abs(c) < .9999999 ? (this._x = Math.atan2(-m, _), this._z = Math.atan2(-l, r)) : (this._x = Math.atan2(v, p), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$455d545b1dff00eb$var$Yt(m, -1, 1)), Math.abs(m) < .9999999 ? (this._y = Math.atan2(c, _), this._z = Math.atan2(f, p)) : (this._y = Math.atan2(-x, r), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($455d545b1dff00eb$var$Yt(v, -1, 1)), Math.abs(v) < .9999999 ? (this._y = Math.atan2(-x, _), this._z = Math.atan2(-l, p)) : (this._y = 0, this._z = Math.atan2(f, r));
                break;
            case "ZYX":
                this._y = Math.asin(-$455d545b1dff00eb$var$Yt(x, -1, 1)), Math.abs(x) < .9999999 ? (this._x = Math.atan2(v, _), this._z = Math.atan2(f, r)) : (this._x = 0, this._z = Math.atan2(-l, p));
                break;
            case "YZX":
                this._z = Math.asin($455d545b1dff00eb$var$Yt(f, -1, 1)), Math.abs(f) < .9999999 ? (this._x = Math.atan2(-m, p), this._y = Math.atan2(-x, r)) : (this._x = 0, this._y = Math.atan2(c, _));
                break;
            case "XZY":
                this._z = Math.asin(-$455d545b1dff00eb$var$Yt(l, -1, 1)), Math.abs(l) < .9999999 ? (this._x = Math.atan2(v, p), this._y = Math.atan2(c, r)) : (this._x = Math.atan2(-m, _), this._y = 0);
                break;
            default:
                $455d545b1dff00eb$var$Mt("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
        }
        return this._order = t, n === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(e, t, n) {
        return $455d545b1dff00eb$var$H2.makeRotationFromQuaternion(e), this.setFromRotationMatrix($455d545b1dff00eb$var$H2, t, n);
    }
    setFromVector3(e, t = this._order) {
        return this.set(e.x, e.y, e.z, t);
    }
    reorder(e) {
        return $455d545b1dff00eb$var$V2.setFromEuler(this), this.setFromQuaternion($455d545b1dff00eb$var$V2, e);
    }
    equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
    }
    fromArray(e) {
        return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
    }
    _onChange(e) {
        return this._onChangeCallback = e, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
}
$455d545b1dff00eb$var$ua.DEFAULT_ORDER = "XYZ";
class $455d545b1dff00eb$var$Hd {
    constructor(){
        this.mask = 1;
    }
    set(e) {
        this.mask = (1 << e | 0) >>> 0;
    }
    enable(e) {
        this.mask |= 1 << e | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(e) {
        this.mask ^= 1 << e | 0;
    }
    disable(e) {
        this.mask &= ~(1 << e | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(e) {
        return (this.mask & e.mask) !== 0;
    }
    isEnabled(e) {
        return (this.mask & (1 << e | 0)) !== 0;
    }
}
let $455d545b1dff00eb$var$oU = 0;
const $455d545b1dff00eb$var$G2 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$sd = new $455d545b1dff00eb$var$Gn, $455d545b1dff00eb$var$lc = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Jg = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$bm = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$lU = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$cU = new $455d545b1dff00eb$var$Gn, $455d545b1dff00eb$var$k2 = new $455d545b1dff00eb$var$J(1, 0, 0), $455d545b1dff00eb$var$j2 = new $455d545b1dff00eb$var$J(0, 1, 0), $455d545b1dff00eb$var$X2 = new $455d545b1dff00eb$var$J(0, 0, 1), $455d545b1dff00eb$var$W2 = {
    type: "added"
}, $455d545b1dff00eb$var$uU = {
    type: "removed"
}, $455d545b1dff00eb$var$od = {
    type: "childadded",
    child: null
}, $455d545b1dff00eb$var$F1 = {
    type: "childremoved",
    child: null
};
class $455d545b1dff00eb$var$Pn extends $455d545b1dff00eb$var$Ml {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$oU++
        }), this.uuid = $455d545b1dff00eb$var$bs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $455d545b1dff00eb$var$Pn.DEFAULT_UP.clone();
        const e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$ua, n = new $455d545b1dff00eb$var$Gn, i = new $455d545b1dff00eb$var$J(1, 1, 1);
        function r() {
            n.setFromEuler(t, !1);
        }
        function l() {
            t.setFromQuaternion(n, void 0, !1);
        }
        t._onChange(r), n._onChange(l), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new $455d545b1dff00eb$var$Ft
            },
            normalMatrix: {
                value: new $455d545b1dff00eb$var$Jt
            }
        }), this.matrix = new $455d545b1dff00eb$var$Ft, this.matrixWorld = new $455d545b1dff00eb$var$Ft, this.matrixAutoUpdate = $455d545b1dff00eb$var$Pn.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = $455d545b1dff00eb$var$Pn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new $455d545b1dff00eb$var$Hd, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(e) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(e) {
        return this.quaternion.premultiply(e), this;
    }
    setRotationFromAxisAngle(e, t) {
        this.quaternion.setFromAxisAngle(e, t);
    }
    setRotationFromEuler(e) {
        this.quaternion.setFromEuler(e, !0);
    }
    setRotationFromMatrix(e) {
        this.quaternion.setFromRotationMatrix(e);
    }
    setRotationFromQuaternion(e) {
        this.quaternion.copy(e);
    }
    rotateOnAxis(e, t) {
        return $455d545b1dff00eb$var$sd.setFromAxisAngle(e, t), this.quaternion.multiply($455d545b1dff00eb$var$sd), this;
    }
    rotateOnWorldAxis(e, t) {
        return $455d545b1dff00eb$var$sd.setFromAxisAngle(e, t), this.quaternion.premultiply($455d545b1dff00eb$var$sd), this;
    }
    rotateX(e) {
        return this.rotateOnAxis($455d545b1dff00eb$var$k2, e);
    }
    rotateY(e) {
        return this.rotateOnAxis($455d545b1dff00eb$var$j2, e);
    }
    rotateZ(e) {
        return this.rotateOnAxis($455d545b1dff00eb$var$X2, e);
    }
    translateOnAxis(e, t) {
        return $455d545b1dff00eb$var$G2.copy(e).applyQuaternion(this.quaternion), this.position.add($455d545b1dff00eb$var$G2.multiplyScalar(t)), this;
    }
    translateX(e) {
        return this.translateOnAxis($455d545b1dff00eb$var$k2, e);
    }
    translateY(e) {
        return this.translateOnAxis($455d545b1dff00eb$var$j2, e);
    }
    translateZ(e) {
        return this.translateOnAxis($455d545b1dff00eb$var$X2, e);
    }
    localToWorld(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(e) {
        return this.updateWorldMatrix(!0, !1), e.applyMatrix4($455d545b1dff00eb$var$lc.copy(this.matrixWorld).invert());
    }
    lookAt(e, t, n) {
        e.isVector3 ? $455d545b1dff00eb$var$Jg.copy(e) : $455d545b1dff00eb$var$Jg.set(e, t, n);
        const i = this.parent;
        this.updateWorldMatrix(!0, !1), $455d545b1dff00eb$var$bm.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $455d545b1dff00eb$var$lc.lookAt($455d545b1dff00eb$var$bm, $455d545b1dff00eb$var$Jg, this.up) : $455d545b1dff00eb$var$lc.lookAt($455d545b1dff00eb$var$Jg, $455d545b1dff00eb$var$bm, this.up), this.quaternion.setFromRotationMatrix($455d545b1dff00eb$var$lc), i && ($455d545b1dff00eb$var$lc.extractRotation(i.matrixWorld), $455d545b1dff00eb$var$sd.setFromRotationMatrix($455d545b1dff00eb$var$lc), this.quaternion.premultiply($455d545b1dff00eb$var$sd.invert()));
    }
    add(e) {
        if (arguments.length > 1) {
            for(let t = 0; t < arguments.length; t++)this.add(arguments[t]);
            return this;
        }
        return e === this ? ($455d545b1dff00eb$var$Qt("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent($455d545b1dff00eb$var$W2), $455d545b1dff00eb$var$od.child = e, this.dispatchEvent($455d545b1dff00eb$var$od), $455d545b1dff00eb$var$od.child = null) : $455d545b1dff00eb$var$Qt("Object3D.add: object not an instance of THREE.Object3D.", e), this);
    }
    remove(e) {
        if (arguments.length > 1) {
            for(let n = 0; n < arguments.length; n++)this.remove(arguments[n]);
            return this;
        }
        const t = this.children.indexOf(e);
        return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent($455d545b1dff00eb$var$uU), $455d545b1dff00eb$var$F1.child = e, this.dispatchEvent($455d545b1dff00eb$var$F1), $455d545b1dff00eb$var$F1.child = null), this;
    }
    removeFromParent() {
        const e = this.parent;
        return e !== null && e.remove(this), this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(e) {
        return this.updateWorldMatrix(!0, !1), $455d545b1dff00eb$var$lc.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), $455d545b1dff00eb$var$lc.multiply(e.parent.matrixWorld)), e.applyMatrix4($455d545b1dff00eb$var$lc), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent($455d545b1dff00eb$var$W2), $455d545b1dff00eb$var$od.child = e, this.dispatchEvent($455d545b1dff00eb$var$od), $455d545b1dff00eb$var$od.child = null, this;
    }
    getObjectById(e) {
        return this.getObjectByProperty("id", e);
    }
    getObjectByName(e) {
        return this.getObjectByProperty("name", e);
    }
    getObjectByProperty(e, t) {
        if (this[e] === t) return this;
        for(let n = 0, i = this.children.length; n < i; n++){
            const l = this.children[n].getObjectByProperty(e, t);
            if (l !== void 0) return l;
        }
    }
    getObjectsByProperty(e, t, n = []) {
        this[e] === t && n.push(this);
        const i = this.children;
        for(let r = 0, l = i.length; r < l; r++)i[r].getObjectsByProperty(e, t, n);
        return n;
    }
    getWorldPosition(e) {
        return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($455d545b1dff00eb$var$bm, e, $455d545b1dff00eb$var$lU), e;
    }
    getWorldScale(e) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($455d545b1dff00eb$var$bm, $455d545b1dff00eb$var$cU, e), e;
    }
    getWorldDirection(e) {
        this.updateWorldMatrix(!0, !1);
        const t = this.matrixWorld.elements;
        return e.set(t[8], t[9], t[10]).normalize();
    }
    raycast() {}
    traverse(e) {
        e(this);
        const t = this.children;
        for(let n = 0, i = t.length; n < i; n++)t[n].traverse(e);
    }
    traverseVisible(e) {
        if (this.visible === !1) return;
        e(this);
        const t = this.children;
        for(let n = 0, i = t.length; n < i; n++)t[n].traverseVisible(e);
    }
    traverseAncestors(e) {
        const t = this.parent;
        t !== null && (e(t), t.traverseAncestors(e));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(e) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
        const t = this.children;
        for(let n = 0, i = t.length; n < i; n++)t[n].updateMatrixWorld(e);
    }
    updateWorldMatrix(e, t) {
        const n = this.parent;
        if (e === !0 && n !== null && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), t === !0) {
            const i = this.children;
            for(let r = 0, l = i.length; r < l; r++)i[r].updateWorldMatrix(!1, !0);
        }
    }
    toJSON(e) {
        const t = e === void 0 || typeof e == "string", n = {};
        t && (e = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, n.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const i = {};
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (i.type = "BatchedMesh", i.perObjectFrustumCulled = this.perObjectFrustumCulled, i.sortObjects = this.sortObjects, i.drawRanges = this._drawRanges, i.reservedRanges = this._reservedRanges, i.geometryInfo = this._geometryInfo.map((c)=>({
                ...c,
                boundingBox: c.boundingBox ? c.boundingBox.toJSON() : void 0,
                boundingSphere: c.boundingSphere ? c.boundingSphere.toJSON() : void 0
            })), i.instanceInfo = this._instanceInfo.map((c)=>({
                ...c
            })), i.availableInstanceIds = this._availableInstanceIds.slice(), i.availableGeometryIds = this._availableGeometryIds.slice(), i.nextIndexStart = this._nextIndexStart, i.nextVertexStart = this._nextVertexStart, i.geometryCount = this._geometryCount, i.maxInstanceCount = this._maxInstanceCount, i.maxVertexCount = this._maxVertexCount, i.maxIndexCount = this._maxIndexCount, i.geometryInitialized = this._geometryInitialized, i.matricesTexture = this._matricesTexture.toJSON(e), i.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (i.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (i.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (i.boundingBox = this.boundingBox.toJSON()));
        function r(c, f) {
            return c[f.uuid] === void 0 && (c[f.uuid] = f.toJSON(e)), f.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = r(e.geometries, this.geometry);
            const c = this.geometry.parameters;
            if (c !== void 0 && c.shapes !== void 0) {
                const f = c.shapes;
                if (Array.isArray(f)) for(let p = 0, m = f.length; p < m; p++){
                    const x = f[p];
                    r(e.shapes, x);
                }
                else r(e.shapes, f);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (r(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                const c = [];
                for(let f = 0, p = this.material.length; f < p; f++)c.push(r(e.materials, this.material[f]));
                i.material = c;
            } else i.material = r(e.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let c = 0; c < this.children.length; c++)i.children.push(this.children[c].toJSON(e).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let c = 0; c < this.animations.length; c++){
                const f = this.animations[c];
                i.animations.push(r(e.animations, f));
            }
        }
        if (t) {
            const c = l(e.geometries), f = l(e.materials), p = l(e.textures), m = l(e.images), x = l(e.shapes), v = l(e.skeletons), _ = l(e.animations), S = l(e.nodes);
            c.length > 0 && (n.geometries = c), f.length > 0 && (n.materials = f), p.length > 0 && (n.textures = p), m.length > 0 && (n.images = m), x.length > 0 && (n.shapes = x), v.length > 0 && (n.skeletons = v), _.length > 0 && (n.animations = _), S.length > 0 && (n.nodes = S);
        }
        return n.object = i, n;
        function l(c) {
            const f = [];
            for(const p in c){
                const m = c[p];
                delete m.metadata, f.push(m);
            }
            return f;
        }
    }
    clone(e) {
        return new this.constructor().copy(this, e);
    }
    copy(e, t = !0) {
        if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0) for(let n = 0; n < e.children.length; n++){
            const i = e.children[n];
            this.add(i.clone());
        }
        return this;
    }
}
$455d545b1dff00eb$var$Pn.DEFAULT_UP = new $455d545b1dff00eb$var$J(0, 1, 0);
$455d545b1dff00eb$var$Pn.DEFAULT_MATRIX_AUTO_UPDATE = !0;
$455d545b1dff00eb$var$Pn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const $455d545b1dff00eb$var$To = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$cc = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$H1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$uc = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ld = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$cd = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$q2 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$V1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$G1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$k1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$j1 = new $455d545b1dff00eb$var$Un, $455d545b1dff00eb$var$X1 = new $455d545b1dff00eb$var$Un, $455d545b1dff00eb$var$W1 = new $455d545b1dff00eb$var$Un;
class $455d545b1dff00eb$var$Qr {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J, n = new $455d545b1dff00eb$var$J){
        this.a = e, this.b = t, this.c = n;
    }
    static getNormal(e, t, n, i) {
        i.subVectors(n, t), $455d545b1dff00eb$var$To.subVectors(e, t), i.cross($455d545b1dff00eb$var$To);
        const r = i.lengthSq();
        return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
    }
    static getBarycoord(e, t, n, i, r) {
        $455d545b1dff00eb$var$To.subVectors(i, t), $455d545b1dff00eb$var$cc.subVectors(n, t), $455d545b1dff00eb$var$H1.subVectors(e, t);
        const l = $455d545b1dff00eb$var$To.dot($455d545b1dff00eb$var$To), c = $455d545b1dff00eb$var$To.dot($455d545b1dff00eb$var$cc), f = $455d545b1dff00eb$var$To.dot($455d545b1dff00eb$var$H1), p = $455d545b1dff00eb$var$cc.dot($455d545b1dff00eb$var$cc), m = $455d545b1dff00eb$var$cc.dot($455d545b1dff00eb$var$H1), x = l * p - c * c;
        if (x === 0) return r.set(0, 0, 0), null;
        const v = 1 / x, _ = (p * f - c * m) * v, S = (l * m - c * f) * v;
        return r.set(1 - _ - S, S, _);
    }
    static containsPoint(e, t, n, i) {
        return this.getBarycoord(e, t, n, i, $455d545b1dff00eb$var$uc) === null ? !1 : $455d545b1dff00eb$var$uc.x >= 0 && $455d545b1dff00eb$var$uc.y >= 0 && $455d545b1dff00eb$var$uc.x + $455d545b1dff00eb$var$uc.y <= 1;
    }
    static getInterpolation(e, t, n, i, r, l, c, f) {
        return this.getBarycoord(e, t, n, i, $455d545b1dff00eb$var$uc) === null ? (f.x = 0, f.y = 0, "z" in f && (f.z = 0), "w" in f && (f.w = 0), null) : (f.setScalar(0), f.addScaledVector(r, $455d545b1dff00eb$var$uc.x), f.addScaledVector(l, $455d545b1dff00eb$var$uc.y), f.addScaledVector(c, $455d545b1dff00eb$var$uc.z), f);
    }
    static getInterpolatedAttribute(e, t, n, i, r, l) {
        return $455d545b1dff00eb$var$j1.setScalar(0), $455d545b1dff00eb$var$X1.setScalar(0), $455d545b1dff00eb$var$W1.setScalar(0), $455d545b1dff00eb$var$j1.fromBufferAttribute(e, t), $455d545b1dff00eb$var$X1.fromBufferAttribute(e, n), $455d545b1dff00eb$var$W1.fromBufferAttribute(e, i), l.setScalar(0), l.addScaledVector($455d545b1dff00eb$var$j1, r.x), l.addScaledVector($455d545b1dff00eb$var$X1, r.y), l.addScaledVector($455d545b1dff00eb$var$W1, r.z), l;
    }
    static isFrontFacing(e, t, n, i) {
        return $455d545b1dff00eb$var$To.subVectors(n, t), $455d545b1dff00eb$var$cc.subVectors(e, t), $455d545b1dff00eb$var$To.cross($455d545b1dff00eb$var$cc).dot(i) < 0;
    }
    set(e, t, n) {
        return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
    }
    setFromPointsAndIndices(e, t, n, i) {
        return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this;
    }
    setFromAttributeAndIndices(e, t, n, i) {
        return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, i), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
    }
    getArea() {
        return $455d545b1dff00eb$var$To.subVectors(this.c, this.b), $455d545b1dff00eb$var$cc.subVectors(this.a, this.b), $455d545b1dff00eb$var$To.cross($455d545b1dff00eb$var$cc).length() * .5;
    }
    getMidpoint(e) {
        return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(e) {
        return $455d545b1dff00eb$var$Qr.getNormal(this.a, this.b, this.c, e);
    }
    getPlane(e) {
        return e.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(e, t) {
        return $455d545b1dff00eb$var$Qr.getBarycoord(e, this.a, this.b, this.c, t);
    }
    getInterpolation(e, t, n, i, r) {
        return $455d545b1dff00eb$var$Qr.getInterpolation(e, this.a, this.b, this.c, t, n, i, r);
    }
    containsPoint(e) {
        return $455d545b1dff00eb$var$Qr.containsPoint(e, this.a, this.b, this.c);
    }
    isFrontFacing(e) {
        return $455d545b1dff00eb$var$Qr.isFrontFacing(this.a, this.b, this.c, e);
    }
    intersectsBox(e) {
        return e.intersectsTriangle(this);
    }
    closestPointToPoint(e, t) {
        const n = this.a, i = this.b, r = this.c;
        let l, c;
        $455d545b1dff00eb$var$ld.subVectors(i, n), $455d545b1dff00eb$var$cd.subVectors(r, n), $455d545b1dff00eb$var$V1.subVectors(e, n);
        const f = $455d545b1dff00eb$var$ld.dot($455d545b1dff00eb$var$V1), p = $455d545b1dff00eb$var$cd.dot($455d545b1dff00eb$var$V1);
        if (f <= 0 && p <= 0) return t.copy(n);
        $455d545b1dff00eb$var$G1.subVectors(e, i);
        const m = $455d545b1dff00eb$var$ld.dot($455d545b1dff00eb$var$G1), x = $455d545b1dff00eb$var$cd.dot($455d545b1dff00eb$var$G1);
        if (m >= 0 && x <= m) return t.copy(i);
        const v = f * x - m * p;
        if (v <= 0 && f >= 0 && m <= 0) return l = f / (f - m), t.copy(n).addScaledVector($455d545b1dff00eb$var$ld, l);
        $455d545b1dff00eb$var$k1.subVectors(e, r);
        const _ = $455d545b1dff00eb$var$ld.dot($455d545b1dff00eb$var$k1), S = $455d545b1dff00eb$var$cd.dot($455d545b1dff00eb$var$k1);
        if (S >= 0 && _ <= S) return t.copy(r);
        const A = _ * p - f * S;
        if (A <= 0 && p >= 0 && S <= 0) return c = p / (p - S), t.copy(n).addScaledVector($455d545b1dff00eb$var$cd, c);
        const M = m * S - _ * x;
        if (M <= 0 && x - m >= 0 && _ - S >= 0) return $455d545b1dff00eb$var$q2.subVectors(r, i), c = (x - m) / (x - m + (_ - S)), t.copy(i).addScaledVector($455d545b1dff00eb$var$q2, c);
        const b = 1 / (M + A + v);
        return l = A * b, c = v * b, t.copy(n).addScaledVector($455d545b1dff00eb$var$ld, l).addScaledVector($455d545b1dff00eb$var$cd, c);
    }
    equals(e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
    }
}
const $455d545b1dff00eb$var$bT = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $455d545b1dff00eb$var$mu = {
    h: 0,
    s: 0,
    l: 0
}, $455d545b1dff00eb$var$$g = {
    h: 0,
    s: 0,
    l: 0
};
function $455d545b1dff00eb$var$q1(a, e, t) {
    return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? a + (e - a) * 6 * t : t < 0.5 ? e : t < 2 / 3 ? a + (e - a) * 6 * (2 / 3 - t) : a;
}
class $455d545b1dff00eb$var$_t {
    constructor(e, t, n){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, n);
    }
    set(e, t, n) {
        if (t === void 0 && n === void 0) {
            const i = e;
            i && i.isColor ? this.copy(i) : typeof i == "number" ? this.setHex(i) : typeof i == "string" && this.setStyle(i);
        } else this.setRGB(e, t, n);
        return this;
    }
    setScalar(e) {
        return this.r = e, this.g = e, this.b = e, this;
    }
    setHex(e, t = $455d545b1dff00eb$var$nr) {
        return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, $455d545b1dff00eb$var$Dn.colorSpaceToWorking(this, t), this;
    }
    setRGB(e, t, n, i = $455d545b1dff00eb$var$Dn.workingColorSpace) {
        return this.r = e, this.g = t, this.b = n, $455d545b1dff00eb$var$Dn.colorSpaceToWorking(this, i), this;
    }
    setHSL(e, t, n, i = $455d545b1dff00eb$var$Dn.workingColorSpace) {
        if (e = $455d545b1dff00eb$var$Hb(e, 1), t = $455d545b1dff00eb$var$Yt(t, 0, 1), n = $455d545b1dff00eb$var$Yt(n, 0, 1), t === 0) this.r = this.g = this.b = n;
        else {
            const r = n <= .5 ? n * (1 + t) : n + t - n * t, l = 2 * n - r;
            this.r = $455d545b1dff00eb$var$q1(l, r, e + 1 / 3), this.g = $455d545b1dff00eb$var$q1(l, r, e), this.b = $455d545b1dff00eb$var$q1(l, r, e - 1 / 3);
        }
        return $455d545b1dff00eb$var$Dn.colorSpaceToWorking(this, i), this;
    }
    setStyle(e, t = $455d545b1dff00eb$var$nr) {
        function n(r) {
            r !== void 0 && parseFloat(r) < 1 && $455d545b1dff00eb$var$Mt("Color: Alpha component of " + e + " will be ignored.");
        }
        let i;
        if (i = /^(\w+)\(([^\)]*)\)/.exec(e)) {
            let r;
            const l = i[1], c = i[2];
            switch(l){
                case "rgb":
                case "rgba":
                    if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c)) return n(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, t);
                    if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c)) return n(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, t);
                    break;
                case "hsl":
                case "hsla":
                    if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c)) return n(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, t);
                    break;
                default:
                    $455d545b1dff00eb$var$Mt("Color: Unknown color model " + e);
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
            const r = i[1], l = r.length;
            if (l === 3) return this.setRGB(parseInt(r.charAt(0), 16) / 15, parseInt(r.charAt(1), 16) / 15, parseInt(r.charAt(2), 16) / 15, t);
            if (l === 6) return this.setHex(parseInt(r, 16), t);
            $455d545b1dff00eb$var$Mt("Color: Invalid hex color " + e);
        } else if (e && e.length > 0) return this.setColorName(e, t);
        return this;
    }
    setColorName(e, t = $455d545b1dff00eb$var$nr) {
        const n = $455d545b1dff00eb$var$bT[e.toLowerCase()];
        return n !== void 0 ? this.setHex(n, t) : $455d545b1dff00eb$var$Mt("Color: Unknown color " + e), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(e) {
        return this.r = e.r, this.g = e.g, this.b = e.b, this;
    }
    copySRGBToLinear(e) {
        return this.r = $455d545b1dff00eb$var$yc(e.r), this.g = $455d545b1dff00eb$var$yc(e.g), this.b = $455d545b1dff00eb$var$yc(e.b), this;
    }
    copyLinearToSRGB(e) {
        return this.r = $455d545b1dff00eb$var$Rd(e.r), this.g = $455d545b1dff00eb$var$Rd(e.g), this.b = $455d545b1dff00eb$var$Rd(e.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(e = $455d545b1dff00eb$var$nr) {
        return $455d545b1dff00eb$var$Dn.workingToColorSpace($455d545b1dff00eb$var$er.copy(this), e), Math.round($455d545b1dff00eb$var$Yt($455d545b1dff00eb$var$er.r * 255, 0, 255)) * 65536 + Math.round($455d545b1dff00eb$var$Yt($455d545b1dff00eb$var$er.g * 255, 0, 255)) * 256 + Math.round($455d545b1dff00eb$var$Yt($455d545b1dff00eb$var$er.b * 255, 0, 255));
    }
    getHexString(e = $455d545b1dff00eb$var$nr) {
        return ("000000" + this.getHex(e).toString(16)).slice(-6);
    }
    getHSL(e, t = $455d545b1dff00eb$var$Dn.workingColorSpace) {
        $455d545b1dff00eb$var$Dn.workingToColorSpace($455d545b1dff00eb$var$er.copy(this), t);
        const n = $455d545b1dff00eb$var$er.r, i = $455d545b1dff00eb$var$er.g, r = $455d545b1dff00eb$var$er.b, l = Math.max(n, i, r), c = Math.min(n, i, r);
        let f, p;
        const m = (c + l) / 2;
        if (c === l) f = 0, p = 0;
        else {
            const x = l - c;
            switch(p = m <= .5 ? x / (l + c) : x / (2 - l - c), l){
                case n:
                    f = (i - r) / x + (i < r ? 6 : 0);
                    break;
                case i:
                    f = (r - n) / x + 2;
                    break;
                case r:
                    f = (n - i) / x + 4;
                    break;
            }
            f /= 6;
        }
        return e.h = f, e.s = p, e.l = m, e;
    }
    getRGB(e, t = $455d545b1dff00eb$var$Dn.workingColorSpace) {
        return $455d545b1dff00eb$var$Dn.workingToColorSpace($455d545b1dff00eb$var$er.copy(this), t), e.r = $455d545b1dff00eb$var$er.r, e.g = $455d545b1dff00eb$var$er.g, e.b = $455d545b1dff00eb$var$er.b, e;
    }
    getStyle(e = $455d545b1dff00eb$var$nr) {
        $455d545b1dff00eb$var$Dn.workingToColorSpace($455d545b1dff00eb$var$er.copy(this), e);
        const t = $455d545b1dff00eb$var$er.r, n = $455d545b1dff00eb$var$er.g, i = $455d545b1dff00eb$var$er.b;
        return e !== $455d545b1dff00eb$var$nr ? `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(i * 255)})`;
    }
    offsetHSL(e, t, n) {
        return this.getHSL($455d545b1dff00eb$var$mu), this.setHSL($455d545b1dff00eb$var$mu.h + e, $455d545b1dff00eb$var$mu.s + t, $455d545b1dff00eb$var$mu.l + n);
    }
    add(e) {
        return this.r += e.r, this.g += e.g, this.b += e.b, this;
    }
    addColors(e, t) {
        return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
    }
    addScalar(e) {
        return this.r += e, this.g += e, this.b += e, this;
    }
    sub(e) {
        return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
    }
    multiply(e) {
        return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
    }
    multiplyScalar(e) {
        return this.r *= e, this.g *= e, this.b *= e, this;
    }
    lerp(e, t) {
        return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
    }
    lerpColors(e, t, n) {
        return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
    }
    lerpHSL(e, t) {
        this.getHSL($455d545b1dff00eb$var$mu), e.getHSL($455d545b1dff00eb$var$$g);
        const n = $455d545b1dff00eb$var$jm($455d545b1dff00eb$var$mu.h, $455d545b1dff00eb$var$$g.h, t), i = $455d545b1dff00eb$var$jm($455d545b1dff00eb$var$mu.s, $455d545b1dff00eb$var$$g.s, t), r = $455d545b1dff00eb$var$jm($455d545b1dff00eb$var$mu.l, $455d545b1dff00eb$var$$g.l, t);
        return this.setHSL(n, i, r), this;
    }
    setFromVector3(e) {
        return this.r = e.x, this.g = e.y, this.b = e.z, this;
    }
    applyMatrix3(e) {
        const t = this.r, n = this.g, i = this.b, r = e.elements;
        return this.r = r[0] * t + r[3] * n + r[6] * i, this.g = r[1] * t + r[4] * n + r[7] * i, this.b = r[2] * t + r[5] * n + r[8] * i, this;
    }
    equals(e) {
        return e.r === this.r && e.g === this.g && e.b === this.b;
    }
    fromArray(e, t = 0) {
        return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
    }
    toArray(e = [], t = 0) {
        return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
    }
    fromBufferAttribute(e, t) {
        return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
}
const $455d545b1dff00eb$var$er = new $455d545b1dff00eb$var$_t;
$455d545b1dff00eb$var$_t.NAMES = $455d545b1dff00eb$var$bT;
let $455d545b1dff00eb$var$fU = 0;
class $455d545b1dff00eb$var$rr extends $455d545b1dff00eb$var$Ml {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$fU++
        }), this.uuid = $455d545b1dff00eb$var$bs(), this.name = "", this.type = "Material", this.blending = $455d545b1dff00eb$var$Ff, this.side = $455d545b1dff00eb$var$bc, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = $455d545b1dff00eb$var$tv, this.blendDst = $455d545b1dff00eb$var$nv, this.blendEquation = $455d545b1dff00eb$var$vu, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new $455d545b1dff00eb$var$_t(0, 0, 0), this.blendAlpha = 0, this.depthFunc = $455d545b1dff00eb$var$jf, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = $455d545b1dff00eb$var$Q_, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $455d545b1dff00eb$var$Nf, this.stencilZFail = $455d545b1dff00eb$var$Nf, this.stencilZPass = $455d545b1dff00eb$var$Nf, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(e) {
        this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
    }
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(e) {
        if (e !== void 0) for(const t in e){
            const n = e[t];
            if (n === void 0) {
                $455d545b1dff00eb$var$Mt(`Material: parameter '${t}' has value of undefined.`);
                continue;
            }
            const i = this[t];
            if (i === void 0) {
                $455d545b1dff00eb$var$Mt(`Material: '${t}' is not a property of THREE.${this.type}.`);
                continue;
            }
            i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n;
        }
    }
    toJSON(e) {
        const t = e === void 0 || typeof e == "string";
        t && (e = {
            textures: {},
            images: {}
        });
        const n = {
            metadata: {
                version: 4.7,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (n.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (n.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== $455d545b1dff00eb$var$Ff && (n.blending = this.blending), this.side !== $455d545b1dff00eb$var$bc && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== $455d545b1dff00eb$var$tv && (n.blendSrc = this.blendSrc), this.blendDst !== $455d545b1dff00eb$var$nv && (n.blendDst = this.blendDst), this.blendEquation !== $455d545b1dff00eb$var$vu && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== $455d545b1dff00eb$var$jf && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== $455d545b1dff00eb$var$Q_ && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $455d545b1dff00eb$var$Nf && (n.stencilFail = this.stencilFail), this.stencilZFail !== $455d545b1dff00eb$var$Nf && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== $455d545b1dff00eb$var$Nf && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
        function i(r) {
            const l = [];
            for(const c in r){
                const f = r[c];
                delete f.metadata, l.push(f);
            }
            return l;
        }
        if (t) {
            const r = i(e.textures), l = i(e.images);
            r.length > 0 && (n.textures = r), l.length > 0 && (n.images = l);
        }
        return n;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
        const t = e.clippingPlanes;
        let n = null;
        if (t !== null) {
            const i = t.length;
            n = new Array(i);
            for(let r = 0; r !== i; ++r)n[r] = t[r].clone();
        }
        return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(e) {
        e === !0 && this.version++;
    }
}
class $455d545b1dff00eb$var$Ac extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $455d545b1dff00eb$var$ua, this.combine = $455d545b1dff00eb$var$S0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
    }
}
const $455d545b1dff00eb$var$mc = $455d545b1dff00eb$var$hU();
function $455d545b1dff00eb$var$hU() {
    const a = new ArrayBuffer(4), e = new Float32Array(a), t = new Uint32Array(a), n = new Uint32Array(512), i = new Uint32Array(512);
    for(let f = 0; f < 256; ++f){
        const p = f - 127;
        p < -27 ? (n[f] = 0, n[f | 256] = 32768, i[f] = 24, i[f | 256] = 24) : p < -14 ? (n[f] = 1024 >> -p - 14, n[f | 256] = 1024 >> -p - 14 | 32768, i[f] = -p - 1, i[f | 256] = -p - 1) : p <= 15 ? (n[f] = p + 15 << 10, n[f | 256] = p + 15 << 10 | 32768, i[f] = 13, i[f | 256] = 13) : p < 128 ? (n[f] = 31744, n[f | 256] = 64512, i[f] = 24, i[f | 256] = 24) : (n[f] = 31744, n[f | 256] = 64512, i[f] = 13, i[f | 256] = 13);
    }
    const r = new Uint32Array(2048), l = new Uint32Array(64), c = new Uint32Array(64);
    for(let f = 1; f < 1024; ++f){
        let p = f << 13, m = 0;
        for(; (p & 8388608) === 0;)p <<= 1, m -= 8388608;
        p &= -8388609, m += 947912704, r[f] = p | m;
    }
    for(let f = 1024; f < 2048; ++f)r[f] = 939524096 + (f - 1024 << 13);
    for(let f = 1; f < 31; ++f)l[f] = f << 23;
    l[31] = 1199570944, l[32] = 2147483648;
    for(let f = 33; f < 63; ++f)l[f] = 2147483648 + (f - 32 << 23);
    l[63] = 3347054592;
    for(let f = 1; f < 64; ++f)f !== 32 && (c[f] = 1024);
    return {
        floatView: e,
        uint32View: t,
        baseTable: n,
        shiftTable: i,
        mantissaTable: r,
        exponentTable: l,
        offsetTable: c
    };
}
function $455d545b1dff00eb$var$qr(a) {
    Math.abs(a) > 65504 && $455d545b1dff00eb$var$Mt("DataUtils.toHalfFloat(): Value out of range."), a = $455d545b1dff00eb$var$Yt(a, -65504, 65504), $455d545b1dff00eb$var$mc.floatView[0] = a;
    const e = $455d545b1dff00eb$var$mc.uint32View[0], t = e >> 23 & 511;
    return $455d545b1dff00eb$var$mc.baseTable[t] + ((e & 8388607) >> $455d545b1dff00eb$var$mc.shiftTable[t]);
}
function $455d545b1dff00eb$var$Lm(a) {
    const e = a >> 10;
    return $455d545b1dff00eb$var$mc.uint32View[0] = $455d545b1dff00eb$var$mc.mantissaTable[$455d545b1dff00eb$var$mc.offsetTable[e] + (a & 1023)] + $455d545b1dff00eb$var$mc.exponentTable[e], $455d545b1dff00eb$var$mc.floatView[0];
}
class $455d545b1dff00eb$var$dU {
    static toHalfFloat(e) {
        return $455d545b1dff00eb$var$qr(e);
    }
    static fromHalfFloat(e) {
        return $455d545b1dff00eb$var$Lm(e);
    }
}
const $455d545b1dff00eb$var$$i = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ex = new $455d545b1dff00eb$var$$e;
let $455d545b1dff00eb$var$pU = 0;
class $455d545b1dff00eb$var$ti {
    constructor(e, t, n = !1){
        if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$pU++
        }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = n, this.usage = $455d545b1dff00eb$var$r0, this.updateRanges = [], this.gpuType = $455d545b1dff00eb$var$Rr, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(e) {
        e === !0 && this.version++;
    }
    setUsage(e) {
        return this.usage = e, this;
    }
    addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(e) {
        return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
    }
    copyAt(e, t, n) {
        e *= this.itemSize, n *= t.itemSize;
        for(let i = 0, r = this.itemSize; i < r; i++)this.array[e + i] = t.array[n + i];
        return this;
    }
    copyArray(e) {
        return this.array.set(e), this;
    }
    applyMatrix3(e) {
        if (this.itemSize === 2) for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$ex.fromBufferAttribute(this, t), $455d545b1dff00eb$var$ex.applyMatrix3(e), this.setXY(t, $455d545b1dff00eb$var$ex.x, $455d545b1dff00eb$var$ex.y);
        else if (this.itemSize === 3) for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$$i.fromBufferAttribute(this, t), $455d545b1dff00eb$var$$i.applyMatrix3(e), this.setXYZ(t, $455d545b1dff00eb$var$$i.x, $455d545b1dff00eb$var$$i.y, $455d545b1dff00eb$var$$i.z);
        return this;
    }
    applyMatrix4(e) {
        for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$$i.fromBufferAttribute(this, t), $455d545b1dff00eb$var$$i.applyMatrix4(e), this.setXYZ(t, $455d545b1dff00eb$var$$i.x, $455d545b1dff00eb$var$$i.y, $455d545b1dff00eb$var$$i.z);
        return this;
    }
    applyNormalMatrix(e) {
        for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$$i.fromBufferAttribute(this, t), $455d545b1dff00eb$var$$i.applyNormalMatrix(e), this.setXYZ(t, $455d545b1dff00eb$var$$i.x, $455d545b1dff00eb$var$$i.y, $455d545b1dff00eb$var$$i.z);
        return this;
    }
    transformDirection(e) {
        for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$$i.fromBufferAttribute(this, t), $455d545b1dff00eb$var$$i.transformDirection(e), this.setXYZ(t, $455d545b1dff00eb$var$$i.x, $455d545b1dff00eb$var$$i.y, $455d545b1dff00eb$var$$i.z);
        return this;
    }
    set(e, t = 0) {
        return this.array.set(e, t), this;
    }
    getComponent(e, t) {
        let n = this.array[e * this.itemSize + t];
        return this.normalized && (n = $455d545b1dff00eb$var$Cr(n, this.array)), n;
    }
    setComponent(e, t, n) {
        return this.normalized && (n = $455d545b1dff00eb$var$sn(n, this.array)), this.array[e * this.itemSize + t] = n, this;
    }
    getX(e) {
        let t = this.array[e * this.itemSize];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setX(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize] = t, this;
    }
    getY(e) {
        let t = this.array[e * this.itemSize + 1];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setY(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
    }
    getZ(e) {
        let t = this.array[e * this.itemSize + 2];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setZ(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
    }
    getW(e) {
        let t = this.array[e * this.itemSize + 3];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setW(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
    }
    setXY(e, t, n) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
    }
    setXYZ(e, t, n, i) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this;
    }
    setXYZW(e, t, n, i, r) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array), r = $455d545b1dff00eb$var$sn(r, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this.array[e + 3] = r, this;
    }
    onUpload(e) {
        return this.onUploadCallback = e, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const e = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (e.name = this.name), this.usage !== $455d545b1dff00eb$var$r0 && (e.usage = this.usage), e;
    }
}
class $455d545b1dff00eb$var$mU extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Int8Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$gU extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Uint8Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$xU extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Uint8ClampedArray(e), t, n);
    }
}
class $455d545b1dff00eb$var$vU extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Int16Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$Gb extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Uint16Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$yU extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Int32Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$kb extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Uint32Array(e), t, n);
    }
}
class $455d545b1dff00eb$var$_U extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Uint16Array(e), t, n), this.isFloat16BufferAttribute = !0;
    }
    getX(e) {
        let t = $455d545b1dff00eb$var$Lm(this.array[e * this.itemSize]);
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setX(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize] = $455d545b1dff00eb$var$qr(t), this;
    }
    getY(e) {
        let t = $455d545b1dff00eb$var$Lm(this.array[e * this.itemSize + 1]);
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setY(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 1] = $455d545b1dff00eb$var$qr(t), this;
    }
    getZ(e) {
        let t = $455d545b1dff00eb$var$Lm(this.array[e * this.itemSize + 2]);
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setZ(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 2] = $455d545b1dff00eb$var$qr(t), this;
    }
    getW(e) {
        let t = $455d545b1dff00eb$var$Lm(this.array[e * this.itemSize + 3]);
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setW(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.array[e * this.itemSize + 3] = $455d545b1dff00eb$var$qr(t), this;
    }
    setXY(e, t, n) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array)), this.array[e + 0] = $455d545b1dff00eb$var$qr(t), this.array[e + 1] = $455d545b1dff00eb$var$qr(n), this;
    }
    setXYZ(e, t, n, i) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array)), this.array[e + 0] = $455d545b1dff00eb$var$qr(t), this.array[e + 1] = $455d545b1dff00eb$var$qr(n), this.array[e + 2] = $455d545b1dff00eb$var$qr(i), this;
    }
    setXYZW(e, t, n, i, r) {
        return e *= this.itemSize, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array), r = $455d545b1dff00eb$var$sn(r, this.array)), this.array[e + 0] = $455d545b1dff00eb$var$qr(t), this.array[e + 1] = $455d545b1dff00eb$var$qr(n), this.array[e + 2] = $455d545b1dff00eb$var$qr(i), this.array[e + 3] = $455d545b1dff00eb$var$qr(r), this;
    }
}
class $455d545b1dff00eb$var$Dt extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n){
        super(new Float32Array(e), t, n);
    }
}
let $455d545b1dff00eb$var$bU = 0;
const $455d545b1dff00eb$var$js = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Y1 = new $455d545b1dff00eb$var$Pn, $455d545b1dff00eb$var$ud = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ys = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$Sm = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$Ma = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$nn extends $455d545b1dff00eb$var$Ml {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$bU++
        }), this.uuid = $455d545b1dff00eb$var$bs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(e) {
        return Array.isArray(e) ? this.index = new ($455d545b1dff00eb$var$vT(e) ? $455d545b1dff00eb$var$kb : $455d545b1dff00eb$var$Gb)(e, 1) : this.index = e, this;
    }
    setIndirect(e) {
        return this.indirect = e, this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(e) {
        return this.attributes[e];
    }
    setAttribute(e, t) {
        return this.attributes[e] = t, this;
    }
    deleteAttribute(e) {
        return delete this.attributes[e], this;
    }
    hasAttribute(e) {
        return this.attributes[e] !== void 0;
    }
    addGroup(e, t, n = 0) {
        this.groups.push({
            start: e,
            count: t,
            materialIndex: n
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(e, t) {
        this.drawRange.start = e, this.drawRange.count = t;
    }
    applyMatrix4(e) {
        const t = this.attributes.position;
        t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
        const n = this.attributes.normal;
        if (n !== void 0) {
            const r = new $455d545b1dff00eb$var$Jt().getNormalMatrix(e);
            n.applyNormalMatrix(r), n.needsUpdate = !0;
        }
        const i = this.attributes.tangent;
        return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    applyQuaternion(e) {
        return $455d545b1dff00eb$var$js.makeRotationFromQuaternion(e), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    rotateX(e) {
        return $455d545b1dff00eb$var$js.makeRotationX(e), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    rotateY(e) {
        return $455d545b1dff00eb$var$js.makeRotationY(e), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    rotateZ(e) {
        return $455d545b1dff00eb$var$js.makeRotationZ(e), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    translate(e, t, n) {
        return $455d545b1dff00eb$var$js.makeTranslation(e, t, n), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    scale(e, t, n) {
        return $455d545b1dff00eb$var$js.makeScale(e, t, n), this.applyMatrix4($455d545b1dff00eb$var$js), this;
    }
    lookAt(e) {
        return $455d545b1dff00eb$var$Y1.lookAt(e), $455d545b1dff00eb$var$Y1.updateMatrix(), this.applyMatrix4($455d545b1dff00eb$var$Y1.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($455d545b1dff00eb$var$ud).negate(), this.translate($455d545b1dff00eb$var$ud.x, $455d545b1dff00eb$var$ud.y, $455d545b1dff00eb$var$ud.z), this;
    }
    setFromPoints(e) {
        const t = this.getAttribute("position");
        if (t === void 0) {
            const n = [];
            for(let i = 0, r = e.length; i < r; i++){
                const l = e[i];
                n.push(l.x, l.y, l.z || 0);
            }
            this.setAttribute("position", new $455d545b1dff00eb$var$Dt(n, 3));
        } else {
            const n = Math.min(e.length, t.count);
            for(let i = 0; i < n; i++){
                const r = e[i];
                t.setXYZ(i, r.x, r.y, r.z || 0);
            }
            e.length > t.count && $455d545b1dff00eb$var$Mt("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
        }
        return this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new $455d545b1dff00eb$var$ca);
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
            $455d545b1dff00eb$var$Qt("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(new $455d545b1dff00eb$var$J(-1 / 0, -1 / 0, -1 / 0), new $455d545b1dff00eb$var$J(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (e !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(e), t) for(let n = 0, i = t.length; n < i; n++){
                const r = t[n];
                $455d545b1dff00eb$var$ys.setFromBufferAttribute(r), this.morphTargetsRelative ? ($455d545b1dff00eb$var$Ma.addVectors(this.boundingBox.min, $455d545b1dff00eb$var$ys.min), this.boundingBox.expandByPoint($455d545b1dff00eb$var$Ma), $455d545b1dff00eb$var$Ma.addVectors(this.boundingBox.max, $455d545b1dff00eb$var$ys.max), this.boundingBox.expandByPoint($455d545b1dff00eb$var$Ma)) : (this.boundingBox.expandByPoint($455d545b1dff00eb$var$ys.min), this.boundingBox.expandByPoint($455d545b1dff00eb$var$ys.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && $455d545b1dff00eb$var$Qt('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new $455d545b1dff00eb$var$Ta);
        const e = this.attributes.position, t = this.morphAttributes.position;
        if (e && e.isGLBufferAttribute) {
            $455d545b1dff00eb$var$Qt("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new $455d545b1dff00eb$var$J, 1 / 0);
            return;
        }
        if (e) {
            const n = this.boundingSphere.center;
            if ($455d545b1dff00eb$var$ys.setFromBufferAttribute(e), t) for(let r = 0, l = t.length; r < l; r++){
                const c = t[r];
                $455d545b1dff00eb$var$Sm.setFromBufferAttribute(c), this.morphTargetsRelative ? ($455d545b1dff00eb$var$Ma.addVectors($455d545b1dff00eb$var$ys.min, $455d545b1dff00eb$var$Sm.min), $455d545b1dff00eb$var$ys.expandByPoint($455d545b1dff00eb$var$Ma), $455d545b1dff00eb$var$Ma.addVectors($455d545b1dff00eb$var$ys.max, $455d545b1dff00eb$var$Sm.max), $455d545b1dff00eb$var$ys.expandByPoint($455d545b1dff00eb$var$Ma)) : ($455d545b1dff00eb$var$ys.expandByPoint($455d545b1dff00eb$var$Sm.min), $455d545b1dff00eb$var$ys.expandByPoint($455d545b1dff00eb$var$Sm.max));
            }
            $455d545b1dff00eb$var$ys.getCenter(n);
            let i = 0;
            for(let r = 0, l = e.count; r < l; r++)$455d545b1dff00eb$var$Ma.fromBufferAttribute(e, r), i = Math.max(i, n.distanceToSquared($455d545b1dff00eb$var$Ma));
            if (t) for(let r = 0, l = t.length; r < l; r++){
                const c = t[r], f = this.morphTargetsRelative;
                for(let p = 0, m = c.count; p < m; p++)$455d545b1dff00eb$var$Ma.fromBufferAttribute(c, p), f && ($455d545b1dff00eb$var$ud.fromBufferAttribute(e, p), $455d545b1dff00eb$var$Ma.add($455d545b1dff00eb$var$ud)), i = Math.max(i, n.distanceToSquared($455d545b1dff00eb$var$Ma));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && $455d545b1dff00eb$var$Qt('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const e = this.index, t = this.attributes;
        if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
            $455d545b1dff00eb$var$Qt("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const n = t.position, i = t.normal, r = t.uv;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new $455d545b1dff00eb$var$ti(new Float32Array(4 * n.count), 4));
        const l = this.getAttribute("tangent"), c = [], f = [];
        for(let H = 0; H < n.count; H++)c[H] = new $455d545b1dff00eb$var$J, f[H] = new $455d545b1dff00eb$var$J;
        const p = new $455d545b1dff00eb$var$J, m = new $455d545b1dff00eb$var$J, x = new $455d545b1dff00eb$var$J, v = new $455d545b1dff00eb$var$$e, _ = new $455d545b1dff00eb$var$$e, S = new $455d545b1dff00eb$var$$e, A = new $455d545b1dff00eb$var$J, M = new $455d545b1dff00eb$var$J;
        function b(H, O, D) {
            p.fromBufferAttribute(n, H), m.fromBufferAttribute(n, O), x.fromBufferAttribute(n, D), v.fromBufferAttribute(r, H), _.fromBufferAttribute(r, O), S.fromBufferAttribute(r, D), m.sub(p), x.sub(p), _.sub(v), S.sub(v);
            const j = 1 / (_.x * S.y - S.x * _.y);
            isFinite(j) && (A.copy(m).multiplyScalar(S.y).addScaledVector(x, -_.y).multiplyScalar(j), M.copy(x).multiplyScalar(_.x).addScaledVector(m, -S.x).multiplyScalar(j), c[H].add(A), c[O].add(A), c[D].add(A), f[H].add(M), f[O].add(M), f[D].add(M));
        }
        let C = this.groups;
        C.length === 0 && (C = [
            {
                start: 0,
                count: e.count
            }
        ]);
        for(let H = 0, O = C.length; H < O; ++H){
            const D = C[H], j = D.start, G = D.count;
            for(let q = j, Y = j + G; q < Y; q += 3)b(e.getX(q + 0), e.getX(q + 1), e.getX(q + 2));
        }
        const R = new $455d545b1dff00eb$var$J, N = new $455d545b1dff00eb$var$J, z = new $455d545b1dff00eb$var$J, L = new $455d545b1dff00eb$var$J;
        function P(H) {
            z.fromBufferAttribute(i, H), L.copy(z);
            const O = c[H];
            R.copy(O), R.sub(z.multiplyScalar(z.dot(O))).normalize(), N.crossVectors(L, O);
            const j = N.dot(f[H]) < 0 ? -1 : 1;
            l.setXYZW(H, R.x, R.y, R.z, j);
        }
        for(let H = 0, O = C.length; H < O; ++H){
            const D = C[H], j = D.start, G = D.count;
            for(let q = j, Y = j + G; q < Y; q += 3)P(e.getX(q + 0)), P(e.getX(q + 1)), P(e.getX(q + 2));
        }
    }
    computeVertexNormals() {
        const e = this.index, t = this.getAttribute("position");
        if (t !== void 0) {
            let n = this.getAttribute("normal");
            if (n === void 0) n = new $455d545b1dff00eb$var$ti(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
            else for(let v = 0, _ = n.count; v < _; v++)n.setXYZ(v, 0, 0, 0);
            const i = new $455d545b1dff00eb$var$J, r = new $455d545b1dff00eb$var$J, l = new $455d545b1dff00eb$var$J, c = new $455d545b1dff00eb$var$J, f = new $455d545b1dff00eb$var$J, p = new $455d545b1dff00eb$var$J, m = new $455d545b1dff00eb$var$J, x = new $455d545b1dff00eb$var$J;
            if (e) for(let v = 0, _ = e.count; v < _; v += 3){
                const S = e.getX(v + 0), A = e.getX(v + 1), M = e.getX(v + 2);
                i.fromBufferAttribute(t, S), r.fromBufferAttribute(t, A), l.fromBufferAttribute(t, M), m.subVectors(l, r), x.subVectors(i, r), m.cross(x), c.fromBufferAttribute(n, S), f.fromBufferAttribute(n, A), p.fromBufferAttribute(n, M), c.add(m), f.add(m), p.add(m), n.setXYZ(S, c.x, c.y, c.z), n.setXYZ(A, f.x, f.y, f.z), n.setXYZ(M, p.x, p.y, p.z);
            }
            else for(let v = 0, _ = t.count; v < _; v += 3)i.fromBufferAttribute(t, v + 0), r.fromBufferAttribute(t, v + 1), l.fromBufferAttribute(t, v + 2), m.subVectors(l, r), x.subVectors(i, r), m.cross(x), n.setXYZ(v + 0, m.x, m.y, m.z), n.setXYZ(v + 1, m.x, m.y, m.z), n.setXYZ(v + 2, m.x, m.y, m.z);
            this.normalizeNormals(), n.needsUpdate = !0;
        }
    }
    normalizeNormals() {
        const e = this.attributes.normal;
        for(let t = 0, n = e.count; t < n; t++)$455d545b1dff00eb$var$Ma.fromBufferAttribute(e, t), $455d545b1dff00eb$var$Ma.normalize(), e.setXYZ(t, $455d545b1dff00eb$var$Ma.x, $455d545b1dff00eb$var$Ma.y, $455d545b1dff00eb$var$Ma.z);
    }
    toNonIndexed() {
        function e(c, f) {
            const p = c.array, m = c.itemSize, x = c.normalized, v = new p.constructor(f.length * m);
            let _ = 0, S = 0;
            for(let A = 0, M = f.length; A < M; A++){
                c.isInterleavedBufferAttribute ? _ = f[A] * c.data.stride + c.offset : _ = f[A] * m;
                for(let b = 0; b < m; b++)v[S++] = p[_++];
            }
            return new $455d545b1dff00eb$var$ti(v, m, x);
        }
        if (this.index === null) return $455d545b1dff00eb$var$Mt("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const t = new $455d545b1dff00eb$var$nn, n = this.index.array, i = this.attributes;
        for(const c in i){
            const f = i[c], p = e(f, n);
            t.setAttribute(c, p);
        }
        const r = this.morphAttributes;
        for(const c in r){
            const f = [], p = r[c];
            for(let m = 0, x = p.length; m < x; m++){
                const v = p[m], _ = e(v, n);
                f.push(_);
            }
            t.morphAttributes[c] = f;
        }
        t.morphTargetsRelative = this.morphTargetsRelative;
        const l = this.groups;
        for(let c = 0, f = l.length; c < f; c++){
            const p = l[c];
            t.addGroup(p.start, p.count, p.materialIndex);
        }
        return t;
    }
    toJSON() {
        const e = {
            metadata: {
                version: 4.7,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
            const f = this.parameters;
            for(const p in f)f[p] !== void 0 && (e[p] = f[p]);
            return e;
        }
        e.data = {
            attributes: {}
        };
        const t = this.index;
        t !== null && (e.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array)
        });
        const n = this.attributes;
        for(const f in n){
            const p = n[f];
            e.data.attributes[f] = p.toJSON(e.data);
        }
        const i = {};
        let r = !1;
        for(const f in this.morphAttributes){
            const p = this.morphAttributes[f], m = [];
            for(let x = 0, v = p.length; x < v; x++){
                const _ = p[x];
                m.push(_.toJSON(e.data));
            }
            m.length > 0 && (i[f] = m, r = !0);
        }
        r && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
        const l = this.groups;
        l.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(l)));
        const c = this.boundingSphere;
        return c !== null && (e.data.boundingSphere = c.toJSON()), e;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const t = {};
        this.name = e.name;
        const n = e.index;
        n !== null && this.setIndex(n.clone());
        const i = e.attributes;
        for(const p in i){
            const m = i[p];
            this.setAttribute(p, m.clone(t));
        }
        const r = e.morphAttributes;
        for(const p in r){
            const m = [], x = r[p];
            for(let v = 0, _ = x.length; v < _; v++)m.push(x[v].clone(t));
            this.morphAttributes[p] = m;
        }
        this.morphTargetsRelative = e.morphTargetsRelative;
        const l = e.groups;
        for(let p = 0, m = l.length; p < m; p++){
            const x = l[p];
            this.addGroup(x.start, x.count, x.materialIndex);
        }
        const c = e.boundingBox;
        c !== null && (this.boundingBox = c.clone());
        const f = e.boundingSphere;
        return f !== null && (this.boundingSphere = f.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $455d545b1dff00eb$var$Y2 = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$yf = new $455d545b1dff00eb$var$Kf, $455d545b1dff00eb$var$tx = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$Z2 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$nx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ix = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$ax = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Z1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$rx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Q2 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$sx = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$zi extends $455d545b1dff00eb$var$Pn {
    constructor(e = new $455d545b1dff00eb$var$nn, t = new $455d545b1dff00eb$var$Ac){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, n = Object.keys(t);
        if (n.length > 0) {
            const i = t[n[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let r = 0, l = i.length; r < l; r++){
                    const c = i[r].name || String(r);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = r;
                }
            }
        }
    }
    getVertexPosition(e, t) {
        const n = this.geometry, i = n.attributes.position, r = n.morphAttributes.position, l = n.morphTargetsRelative;
        t.fromBufferAttribute(i, e);
        const c = this.morphTargetInfluences;
        if (r && c) {
            $455d545b1dff00eb$var$rx.set(0, 0, 0);
            for(let f = 0, p = r.length; f < p; f++){
                const m = c[f], x = r[f];
                m !== 0 && ($455d545b1dff00eb$var$Z1.fromBufferAttribute(x, e), l ? $455d545b1dff00eb$var$rx.addScaledVector($455d545b1dff00eb$var$Z1, m) : $455d545b1dff00eb$var$rx.addScaledVector($455d545b1dff00eb$var$Z1.sub(t), m));
            }
            t.add($455d545b1dff00eb$var$rx);
        }
        return t;
    }
    raycast(e, t) {
        const n = this.geometry, i = this.material, r = this.matrixWorld;
        i !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), $455d545b1dff00eb$var$tx.copy(n.boundingSphere), $455d545b1dff00eb$var$tx.applyMatrix4(r), $455d545b1dff00eb$var$yf.copy(e.ray).recast(e.near), !($455d545b1dff00eb$var$tx.containsPoint($455d545b1dff00eb$var$yf.origin) === !1 && ($455d545b1dff00eb$var$yf.intersectSphere($455d545b1dff00eb$var$tx, $455d545b1dff00eb$var$Z2) === null || $455d545b1dff00eb$var$yf.origin.distanceToSquared($455d545b1dff00eb$var$Z2) > (e.far - e.near) ** 2)) && ($455d545b1dff00eb$var$Y2.copy(r).invert(), $455d545b1dff00eb$var$yf.copy(e.ray).applyMatrix4($455d545b1dff00eb$var$Y2), !(n.boundingBox !== null && $455d545b1dff00eb$var$yf.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, $455d545b1dff00eb$var$yf)));
    }
    _computeIntersections(e, t, n) {
        let i;
        const r = this.geometry, l = this.material, c = r.index, f = r.attributes.position, p = r.attributes.uv, m = r.attributes.uv1, x = r.attributes.normal, v = r.groups, _ = r.drawRange;
        if (c !== null) {
            if (Array.isArray(l)) for(let S = 0, A = v.length; S < A; S++){
                const M = v[S], b = l[M.materialIndex], C = Math.max(M.start, _.start), R = Math.min(c.count, Math.min(M.start + M.count, _.start + _.count));
                for(let N = C, z = R; N < z; N += 3){
                    const L = c.getX(N), P = c.getX(N + 1), H = c.getX(N + 2);
                    i = $455d545b1dff00eb$var$ox(this, b, e, n, p, m, x, L, P, H), i && (i.faceIndex = Math.floor(N / 3), i.face.materialIndex = M.materialIndex, t.push(i));
                }
            }
            else {
                const S = Math.max(0, _.start), A = Math.min(c.count, _.start + _.count);
                for(let M = S, b = A; M < b; M += 3){
                    const C = c.getX(M), R = c.getX(M + 1), N = c.getX(M + 2);
                    i = $455d545b1dff00eb$var$ox(this, l, e, n, p, m, x, C, R, N), i && (i.faceIndex = Math.floor(M / 3), t.push(i));
                }
            }
        } else if (f !== void 0) {
            if (Array.isArray(l)) for(let S = 0, A = v.length; S < A; S++){
                const M = v[S], b = l[M.materialIndex], C = Math.max(M.start, _.start), R = Math.min(f.count, Math.min(M.start + M.count, _.start + _.count));
                for(let N = C, z = R; N < z; N += 3){
                    const L = N, P = N + 1, H = N + 2;
                    i = $455d545b1dff00eb$var$ox(this, b, e, n, p, m, x, L, P, H), i && (i.faceIndex = Math.floor(N / 3), i.face.materialIndex = M.materialIndex, t.push(i));
                }
            }
            else {
                const S = Math.max(0, _.start), A = Math.min(f.count, _.start + _.count);
                for(let M = S, b = A; M < b; M += 3){
                    const C = M, R = M + 1, N = M + 2;
                    i = $455d545b1dff00eb$var$ox(this, l, e, n, p, m, x, C, R, N), i && (i.faceIndex = Math.floor(M / 3), t.push(i));
                }
            }
        }
    }
}
function $455d545b1dff00eb$var$SU(a, e, t, n, i, r, l, c) {
    let f;
    if (e.side === $455d545b1dff00eb$var$Dr ? f = n.intersectTriangle(l, r, i, !0, c) : f = n.intersectTriangle(i, r, l, e.side === $455d545b1dff00eb$var$bc, c), f === null) return null;
    $455d545b1dff00eb$var$sx.copy(c), $455d545b1dff00eb$var$sx.applyMatrix4(a.matrixWorld);
    const p = t.ray.origin.distanceTo($455d545b1dff00eb$var$sx);
    return p < t.near || p > t.far ? null : {
        distance: p,
        point: $455d545b1dff00eb$var$sx.clone(),
        object: a
    };
}
function $455d545b1dff00eb$var$ox(a, e, t, n, i, r, l, c, f, p) {
    a.getVertexPosition(c, $455d545b1dff00eb$var$nx), a.getVertexPosition(f, $455d545b1dff00eb$var$ix), a.getVertexPosition(p, $455d545b1dff00eb$var$ax);
    const m = $455d545b1dff00eb$var$SU(a, e, t, n, $455d545b1dff00eb$var$nx, $455d545b1dff00eb$var$ix, $455d545b1dff00eb$var$ax, $455d545b1dff00eb$var$Q2);
    if (m) {
        const x = new $455d545b1dff00eb$var$J;
        $455d545b1dff00eb$var$Qr.getBarycoord($455d545b1dff00eb$var$Q2, $455d545b1dff00eb$var$nx, $455d545b1dff00eb$var$ix, $455d545b1dff00eb$var$ax, x), i && (m.uv = $455d545b1dff00eb$var$Qr.getInterpolatedAttribute(i, c, f, p, x, new $455d545b1dff00eb$var$$e)), r && (m.uv1 = $455d545b1dff00eb$var$Qr.getInterpolatedAttribute(r, c, f, p, x, new $455d545b1dff00eb$var$$e)), l && (m.normal = $455d545b1dff00eb$var$Qr.getInterpolatedAttribute(l, c, f, p, x, new $455d545b1dff00eb$var$J), m.normal.dot(n.direction) > 0 && m.normal.multiplyScalar(-1));
        const v = {
            a: c,
            b: f,
            c: p,
            normal: new $455d545b1dff00eb$var$J,
            materialIndex: 0
        };
        $455d545b1dff00eb$var$Qr.getNormal($455d545b1dff00eb$var$nx, $455d545b1dff00eb$var$ix, $455d545b1dff00eb$var$ax, v.normal), m.face = v, m.barycoord = x;
    }
    return m;
}
class $455d545b1dff00eb$var$Ru extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 1, n = 1, i = 1, r = 1, l = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: e,
            height: t,
            depth: n,
            widthSegments: i,
            heightSegments: r,
            depthSegments: l
        };
        const c = this;
        i = Math.floor(i), r = Math.floor(r), l = Math.floor(l);
        const f = [], p = [], m = [], x = [];
        let v = 0, _ = 0;
        S("z", "y", "x", -1, -1, n, t, e, l, r, 0), S("z", "y", "x", 1, -1, n, t, -e, l, r, 1), S("x", "z", "y", 1, 1, e, n, t, i, l, 2), S("x", "z", "y", 1, -1, e, n, -t, i, l, 3), S("x", "y", "z", 1, -1, e, t, n, i, r, 4), S("x", "y", "z", -1, -1, e, t, -n, i, r, 5), this.setIndex(f), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(p, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(m, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(x, 2));
        function S(A, M, b, C, R, N, z, L, P, H, O) {
            const D = N / P, j = z / H, G = N / 2, q = z / 2, Y = L / 2, ae = P + 1, F = H + 1;
            let Q = 0, K = 0;
            const $ = new $455d545b1dff00eb$var$J;
            for(let ee = 0; ee < F; ee++){
                const I = ee * j - q;
                for(let Z = 0; Z < ae; Z++){
                    const oe = Z * D - G;
                    $[A] = oe * C, $[M] = I * R, $[b] = Y, p.push($.x, $.y, $.z), $[A] = 0, $[M] = 0, $[b] = L > 0 ? 1 : -1, m.push($.x, $.y, $.z), x.push(Z / P), x.push(1 - ee / H), Q += 1;
                }
            }
            for(let ee = 0; ee < H; ee++)for(let I = 0; I < P; I++){
                const Z = v + I + ae * ee, oe = v + I + ae * (ee + 1), ce = v + (I + 1) + ae * (ee + 1), de = v + (I + 1) + ae * ee;
                f.push(Z, oe, de), f.push(oe, ce, de), K += 6;
            }
            c.addGroup(_, K, O), _ += K, v += Q;
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Ru(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
    }
}
function $455d545b1dff00eb$var$Vd(a) {
    const e = {};
    for(const t in a){
        e[t] = {};
        for(const n in a[t]){
            const i = a[t][n];
            i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? i.isRenderTargetTexture ? ($455d545b1dff00eb$var$Mt("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[t][n] = null) : e[t][n] = i.clone() : Array.isArray(i) ? e[t][n] = i.slice() : e[t][n] = i;
        }
    }
    return e;
}
function $455d545b1dff00eb$var$wr(a) {
    const e = {};
    for(let t = 0; t < a.length; t++){
        const n = $455d545b1dff00eb$var$Vd(a[t]);
        for(const i in n)e[i] = n[i];
    }
    return e;
}
function $455d545b1dff00eb$var$MU(a) {
    const e = [];
    for(let t = 0; t < a.length; t++)e.push(a[t].clone());
    return e;
}
function $455d545b1dff00eb$var$ST(a) {
    const e = a.getRenderTarget();
    return e === null ? a.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : $455d545b1dff00eb$var$Dn.workingColorSpace;
}
const $455d545b1dff00eb$var$jb = {
    clone: $455d545b1dff00eb$var$Vd,
    merge: $455d545b1dff00eb$var$wr
};
var $455d545b1dff00eb$var$EU = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, $455d545b1dff00eb$var$TU = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class $455d545b1dff00eb$var$qs extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = $455d545b1dff00eb$var$EU, this.fragmentShader = $455d545b1dff00eb$var$TU, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
            clipCullDistance: !1,
            multiDraw: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = $455d545b1dff00eb$var$Vd(e.uniforms), this.uniformsGroups = $455d545b1dff00eb$var$MU(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        t.glslVersion = this.glslVersion, t.uniforms = {};
        for(const i in this.uniforms){
            const l = this.uniforms[i].value;
            l && l.isTexture ? t.uniforms[i] = {
                type: "t",
                value: l.toJSON(e).uuid
            } : l && l.isColor ? t.uniforms[i] = {
                type: "c",
                value: l.getHex()
            } : l && l.isVector2 ? t.uniforms[i] = {
                type: "v2",
                value: l.toArray()
            } : l && l.isVector3 ? t.uniforms[i] = {
                type: "v3",
                value: l.toArray()
            } : l && l.isVector4 ? t.uniforms[i] = {
                type: "v4",
                value: l.toArray()
            } : l && l.isMatrix3 ? t.uniforms[i] = {
                type: "m3",
                value: l.toArray()
            } : l && l.isMatrix4 ? t.uniforms[i] = {
                type: "m4",
                value: l.toArray()
            } : t.uniforms[i] = {
                value: l
            };
        }
        Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
        const n = {};
        for(const i in this.extensions)this.extensions[i] === !0 && (n[i] = !0);
        return Object.keys(n).length > 0 && (t.extensions = n), t;
    }
}
class $455d545b1dff00eb$var$hy extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $455d545b1dff00eb$var$Ft, this.projectionMatrix = new $455d545b1dff00eb$var$Ft, this.projectionMatrixInverse = new $455d545b1dff00eb$var$Ft, this.coordinateSystem = $455d545b1dff00eb$var$_s, this._reversedDepth = !1;
    }
    get reversedDepth() {
        return this._reversedDepth;
    }
    copy(e, t) {
        return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
    }
    getWorldDirection(e) {
        return super.getWorldDirection(e).negate();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, t) {
        super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $455d545b1dff00eb$var$gu = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$K2 = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$J2 = new $455d545b1dff00eb$var$$e;
let $455d545b1dff00eb$var$Ui = class extends $455d545b1dff00eb$var$hy {
    constructor(e = 50, t = 1, n = .1, i = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
    }
    setFocalLength(e) {
        const t = .5 * this.getFilmHeight() / e;
        this.fov = $455d545b1dff00eb$var$Fd * 2 * Math.atan(t), this.updateProjectionMatrix();
    }
    getFocalLength() {
        const e = Math.tan($455d545b1dff00eb$var$Hf * .5 * this.fov);
        return .5 * this.getFilmHeight() / e;
    }
    getEffectiveFOV() {
        return $455d545b1dff00eb$var$Fd * 2 * Math.atan(Math.tan($455d545b1dff00eb$var$Hf * .5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    getViewBounds(e, t, n) {
        $455d545b1dff00eb$var$gu.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), t.set($455d545b1dff00eb$var$gu.x, $455d545b1dff00eb$var$gu.y).multiplyScalar(-e / $455d545b1dff00eb$var$gu.z), $455d545b1dff00eb$var$gu.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), n.set($455d545b1dff00eb$var$gu.x, $455d545b1dff00eb$var$gu.y).multiplyScalar(-e / $455d545b1dff00eb$var$gu.z);
    }
    getViewSize(e, t) {
        return this.getViewBounds(e, $455d545b1dff00eb$var$K2, $455d545b1dff00eb$var$J2), t.subVectors($455d545b1dff00eb$var$J2, $455d545b1dff00eb$var$K2);
    }
    setViewOffset(e, t, n, i, r, l) {
        this.aspect = e / t, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = l, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e = this.near;
        let t = e * Math.tan($455d545b1dff00eb$var$Hf * .5 * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, r = -0.5 * i;
        const l = this.view;
        if (this.view !== null && this.view.enabled) {
            const f = l.fullWidth, p = l.fullHeight;
            r += l.offsetX * i / f, t -= l.offsetY * n / p, i *= l.width / f, n *= l.height / p;
        }
        const c = this.filmOffset;
        c !== 0 && (r += e * c / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, t, t - n, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
    }
};
const $455d545b1dff00eb$var$fd = -90, $455d545b1dff00eb$var$hd = 1;
class $455d545b1dff00eb$var$MT extends $455d545b1dff00eb$var$Pn {
    constructor(e, t, n){
        super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
        const i = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        i.layers = this.layers, this.add(i);
        const r = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        r.layers = this.layers, this.add(r);
        const l = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        l.layers = this.layers, this.add(l);
        const c = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        c.layers = this.layers, this.add(c);
        const f = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        f.layers = this.layers, this.add(f);
        const p = new $455d545b1dff00eb$var$Ui($455d545b1dff00eb$var$fd, $455d545b1dff00eb$var$hd, e, t);
        p.layers = this.layers, this.add(p);
    }
    updateCoordinateSystem() {
        const e = this.coordinateSystem, t = this.children.concat(), [n, i, r, l, c, f] = t;
        for (const p of t)this.remove(p);
        if (e === $455d545b1dff00eb$var$_s) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), l.up.set(0, 0, 1), l.lookAt(0, -1, 0), c.up.set(0, 1, 0), c.lookAt(0, 0, 1), f.up.set(0, 1, 0), f.lookAt(0, 0, -1);
        else if (e === $455d545b1dff00eb$var$Bd) n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), l.up.set(0, 0, -1), l.lookAt(0, -1, 0), c.up.set(0, -1, 0), c.lookAt(0, 0, 1), f.up.set(0, -1, 0), f.lookAt(0, 0, -1);
        else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
        for (const p of t)this.add(p), p.updateMatrixWorld();
    }
    update(e, t) {
        this.parent === null && this.updateMatrixWorld();
        const { renderTarget: n, activeMipmapLevel: i } = this;
        this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
        const [r, l, c, f, p, m] = this.children, x = e.getRenderTarget(), v = e.getActiveCubeFace(), _ = e.getActiveMipmapLevel(), S = e.xr.enabled;
        e.xr.enabled = !1;
        const A = n.texture.generateMipmaps;
        n.texture.generateMipmaps = !1, e.setRenderTarget(n, 0, i), e.render(t, r), e.setRenderTarget(n, 1, i), e.render(t, l), e.setRenderTarget(n, 2, i), e.render(t, c), e.setRenderTarget(n, 3, i), e.render(t, f), e.setRenderTarget(n, 4, i), e.render(t, p), n.texture.generateMipmaps = A, e.setRenderTarget(n, 5, i), e.render(t, m), e.setRenderTarget(x, v, _), e.xr.enabled = S, n.texture.needsPMREMUpdate = !0;
    }
}
class $455d545b1dff00eb$var$E0 extends $455d545b1dff00eb$var$Li {
    constructor(e = [], t = $455d545b1dff00eb$var$Sc, n, i, r, l, c, f, p, m){
        super(e, t, n, i, r, l, c, f, p, m), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(e) {
        this.image = e;
    }
}
class $455d545b1dff00eb$var$ET extends $455d545b1dff00eb$var$Oo {
    constructor(e = 1, t = {}){
        super(e, e, t), this.isWebGLCubeRenderTarget = !0;
        const n = {
            width: e,
            height: e,
            depth: 1
        }, i = [
            n,
            n,
            n,
            n,
            n,
            n
        ];
        this.texture = new $455d545b1dff00eb$var$E0(i), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
    }
    fromEquirectangularTexture(e, t) {
        this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
        const n = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, i = new $455d545b1dff00eb$var$Ru(5, 5, 5), r = new $455d545b1dff00eb$var$qs({
            name: "CubemapFromEquirect",
            uniforms: $455d545b1dff00eb$var$Vd(n.uniforms),
            vertexShader: n.vertexShader,
            fragmentShader: n.fragmentShader,
            side: $455d545b1dff00eb$var$Dr,
            blending: $455d545b1dff00eb$var$yl
        });
        r.uniforms.tEquirect.value = t;
        const l = new $455d545b1dff00eb$var$zi(i, r), c = t.minFilter;
        return t.minFilter === $455d545b1dff00eb$var$gl && (t.minFilter = $455d545b1dff00eb$var$mi), new $455d545b1dff00eb$var$MT(1, 10, this).update(e, l), t.minFilter = c, l.geometry.dispose(), l.material.dispose(), this;
    }
    clear(e, t = !0, n = !0, i = !0) {
        const r = e.getRenderTarget();
        for(let l = 0; l < 6; l++)e.setRenderTarget(this, l), e.clear(t, n, i);
        e.setRenderTarget(r);
    }
}
class $455d545b1dff00eb$var$Cd extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}
const $455d545b1dff00eb$var$AU = {
    type: "move"
};
class $455d545b1dff00eb$var$qx {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return this._hand === null && (this._hand = new $455d545b1dff00eb$var$Cd, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new $455d545b1dff00eb$var$Cd, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $455d545b1dff00eb$var$J, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $455d545b1dff00eb$var$J), this._targetRay;
    }
    getGripSpace() {
        return this._grip === null && (this._grip = new $455d545b1dff00eb$var$Cd, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $455d545b1dff00eb$var$J, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $455d545b1dff00eb$var$J), this._grip;
    }
    dispatchEvent(e) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
    }
    connect(e) {
        if (e && e.hand) {
            const t = this._hand;
            if (t) for (const n of e.hand.values())this._getHandJoint(t, n);
        }
        return this.dispatchEvent({
            type: "connected",
            data: e
        }), this;
    }
    disconnect(e) {
        return this.dispatchEvent({
            type: "disconnected",
            data: e
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    update(e, t, n) {
        let i = null, r = null, l = null;
        const c = this._targetRay, f = this._grip, p = this._hand;
        if (e && t.session.visibilityState !== "visible-blurred") {
            if (p && e.hand) {
                l = !0;
                for (const A of e.hand.values()){
                    const M = t.getJointPose(A, n), b = this._getHandJoint(p, A);
                    M !== null && (b.matrix.fromArray(M.transform.matrix), b.matrix.decompose(b.position, b.rotation, b.scale), b.matrixWorldNeedsUpdate = !0, b.jointRadius = M.radius), b.visible = M !== null;
                }
                const m = p.joints["index-finger-tip"], x = p.joints["thumb-tip"], v = m.position.distanceTo(x.position), _ = .02, S = .005;
                p.inputState.pinching && v > _ + S ? (p.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: e.handedness,
                    target: this
                })) : !p.inputState.pinching && v <= _ - S && (p.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: e.handedness,
                    target: this
                }));
            } else f !== null && e.gripSpace && (r = t.getPose(e.gripSpace, n), r !== null && (f.matrix.fromArray(r.transform.matrix), f.matrix.decompose(f.position, f.rotation, f.scale), f.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (f.hasLinearVelocity = !0, f.linearVelocity.copy(r.linearVelocity)) : f.hasLinearVelocity = !1, r.angularVelocity ? (f.hasAngularVelocity = !0, f.angularVelocity.copy(r.angularVelocity)) : f.hasAngularVelocity = !1));
            c !== null && (i = t.getPose(e.targetRaySpace, n), i === null && r !== null && (i = r), i !== null && (c.matrix.fromArray(i.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), c.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(i.linearVelocity)) : c.hasLinearVelocity = !1, i.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(i.angularVelocity)) : c.hasAngularVelocity = !1, this.dispatchEvent($455d545b1dff00eb$var$AU)));
        }
        return c !== null && (c.visible = i !== null), f !== null && (f.visible = r !== null), p !== null && (p.visible = l !== null), this;
    }
    _getHandJoint(e, t) {
        if (e.joints[t.jointName] === void 0) {
            const n = new $455d545b1dff00eb$var$Cd;
            n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
        }
        return e.joints[t.jointName];
    }
}
class $455d545b1dff00eb$var$dy {
    constructor(e, t = 25e-5){
        this.isFogExp2 = !0, this.name = "", this.color = new $455d545b1dff00eb$var$_t(e), this.density = t;
    }
    clone() {
        return new $455d545b1dff00eb$var$dy(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $455d545b1dff00eb$var$py {
    constructor(e, t = 1, n = 1e3){
        this.isFog = !0, this.name = "", this.color = new $455d545b1dff00eb$var$_t(e), this.near = t, this.far = n;
    }
    clone() {
        return new $455d545b1dff00eb$var$py(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $455d545b1dff00eb$var$Xb extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new $455d545b1dff00eb$var$ua, this.environmentIntensity = 1, this.environmentRotation = new $455d545b1dff00eb$var$ua, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(e, t) {
        return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
    }
}
class $455d545b1dff00eb$var$my {
    constructor(e, t){
        this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = $455d545b1dff00eb$var$r0, this.updateRanges = [], this.version = 0, this.uuid = $455d545b1dff00eb$var$bs();
    }
    onUploadCallback() {}
    set needsUpdate(e) {
        e === !0 && this.version++;
    }
    setUsage(e) {
        return this.usage = e, this;
    }
    addUpdateRange(e, t) {
        this.updateRanges.push({
            start: e,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(e) {
        return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
    }
    copyAt(e, t, n) {
        e *= this.stride, n *= t.stride;
        for(let i = 0, r = this.stride; i < r; i++)this.array[e + i] = t.array[n + i];
        return this;
    }
    set(e, t = 0) {
        return this.array.set(e, t), this;
    }
    clone(e) {
        e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = $455d545b1dff00eb$var$bs()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
        return n.setUsage(this.usage), n;
    }
    onUpload(e) {
        return this.onUploadCallback = e, this;
    }
    toJSON(e) {
        return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = $455d545b1dff00eb$var$bs()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $455d545b1dff00eb$var$Ar = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$Xf {
    constructor(e, t, n, i = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = n, this.normalized = i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(e) {
        this.data.needsUpdate = e;
    }
    applyMatrix4(e) {
        for(let t = 0, n = this.data.count; t < n; t++)$455d545b1dff00eb$var$Ar.fromBufferAttribute(this, t), $455d545b1dff00eb$var$Ar.applyMatrix4(e), this.setXYZ(t, $455d545b1dff00eb$var$Ar.x, $455d545b1dff00eb$var$Ar.y, $455d545b1dff00eb$var$Ar.z);
        return this;
    }
    applyNormalMatrix(e) {
        for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$Ar.fromBufferAttribute(this, t), $455d545b1dff00eb$var$Ar.applyNormalMatrix(e), this.setXYZ(t, $455d545b1dff00eb$var$Ar.x, $455d545b1dff00eb$var$Ar.y, $455d545b1dff00eb$var$Ar.z);
        return this;
    }
    transformDirection(e) {
        for(let t = 0, n = this.count; t < n; t++)$455d545b1dff00eb$var$Ar.fromBufferAttribute(this, t), $455d545b1dff00eb$var$Ar.transformDirection(e), this.setXYZ(t, $455d545b1dff00eb$var$Ar.x, $455d545b1dff00eb$var$Ar.y, $455d545b1dff00eb$var$Ar.z);
        return this;
    }
    getComponent(e, t) {
        let n = this.array[e * this.data.stride + this.offset + t];
        return this.normalized && (n = $455d545b1dff00eb$var$Cr(n, this.array)), n;
    }
    setComponent(e, t, n) {
        return this.normalized && (n = $455d545b1dff00eb$var$sn(n, this.array)), this.data.array[e * this.data.stride + this.offset + t] = n, this;
    }
    setX(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
    }
    setY(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
    }
    setZ(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
    }
    setW(e, t) {
        return this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
    }
    getX(e) {
        let t = this.data.array[e * this.data.stride + this.offset];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    getY(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 1];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    getZ(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 2];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    getW(e) {
        let t = this.data.array[e * this.data.stride + this.offset + 3];
        return this.normalized && (t = $455d545b1dff00eb$var$Cr(t, this.array)), t;
    }
    setXY(e, t, n) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
    }
    setXYZ(e, t, n, i) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this;
    }
    setXYZW(e, t, n, i, r) {
        return e = e * this.data.stride + this.offset, this.normalized && (t = $455d545b1dff00eb$var$sn(t, this.array), n = $455d545b1dff00eb$var$sn(n, this.array), i = $455d545b1dff00eb$var$sn(i, this.array), r = $455d545b1dff00eb$var$sn(r, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this.data.array[e + 3] = r, this;
    }
    clone(e) {
        if (e === void 0) {
            $455d545b1dff00eb$var$o0("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let n = 0; n < this.count; n++){
                const i = n * this.data.stride + this.offset;
                for(let r = 0; r < this.itemSize; r++)t.push(this.data.array[i + r]);
            }
            return new $455d545b1dff00eb$var$ti(new this.array.constructor(t), this.itemSize, this.normalized);
        } else return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new $455d545b1dff00eb$var$Xf(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(e) {
        if (e === void 0) {
            $455d545b1dff00eb$var$o0("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const t = [];
            for(let n = 0; n < this.count; n++){
                const i = n * this.data.stride + this.offset;
                for(let r = 0; r < this.itemSize; r++)t.push(this.data.array[i + r]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: t,
                normalized: this.normalized
            };
        } else return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
}
class $455d545b1dff00eb$var$Wb extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
    }
}
let $455d545b1dff00eb$var$dd;
const $455d545b1dff00eb$var$Mm = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$pd = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$md = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$gd = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$Em = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$TT = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$lx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Tm = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$cx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$$2 = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$Q1 = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$eM = new $455d545b1dff00eb$var$$e;
class $455d545b1dff00eb$var$AT extends $455d545b1dff00eb$var$Pn {
    constructor(e = new $455d545b1dff00eb$var$Wb){
        if (super(), this.isSprite = !0, this.type = "Sprite", $455d545b1dff00eb$var$dd === void 0) {
            $455d545b1dff00eb$var$dd = new $455d545b1dff00eb$var$nn;
            const t = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                .5,
                -0.5,
                0,
                1,
                0,
                .5,
                .5,
                0,
                1,
                1,
                -0.5,
                .5,
                0,
                0,
                1
            ]), n = new $455d545b1dff00eb$var$my(t, 5);
            $455d545b1dff00eb$var$dd.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]), $455d545b1dff00eb$var$dd.setAttribute("position", new $455d545b1dff00eb$var$Xf(n, 3, 0, !1)), $455d545b1dff00eb$var$dd.setAttribute("uv", new $455d545b1dff00eb$var$Xf(n, 2, 3, !1));
        }
        this.geometry = $455d545b1dff00eb$var$dd, this.material = e, this.center = new $455d545b1dff00eb$var$$e(.5, .5), this.count = 1;
    }
    raycast(e, t) {
        e.camera === null && $455d545b1dff00eb$var$Qt('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), $455d545b1dff00eb$var$pd.setFromMatrixScale(this.matrixWorld), $455d545b1dff00eb$var$TT.copy(e.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse, this.matrixWorld), $455d545b1dff00eb$var$md.setFromMatrixPosition(this.modelViewMatrix), e.camera.isPerspectiveCamera && this.material.sizeAttenuation === !1 && $455d545b1dff00eb$var$pd.multiplyScalar(-$455d545b1dff00eb$var$md.z);
        const n = this.material.rotation;
        let i, r;
        n !== 0 && (r = Math.cos(n), i = Math.sin(n));
        const l = this.center;
        $455d545b1dff00eb$var$ux($455d545b1dff00eb$var$lx.set(-0.5, -0.5, 0), $455d545b1dff00eb$var$md, l, $455d545b1dff00eb$var$pd, i, r), $455d545b1dff00eb$var$ux($455d545b1dff00eb$var$Tm.set(.5, -0.5, 0), $455d545b1dff00eb$var$md, l, $455d545b1dff00eb$var$pd, i, r), $455d545b1dff00eb$var$ux($455d545b1dff00eb$var$cx.set(.5, .5, 0), $455d545b1dff00eb$var$md, l, $455d545b1dff00eb$var$pd, i, r), $455d545b1dff00eb$var$$2.set(0, 0), $455d545b1dff00eb$var$Q1.set(1, 0), $455d545b1dff00eb$var$eM.set(1, 1);
        let c = e.ray.intersectTriangle($455d545b1dff00eb$var$lx, $455d545b1dff00eb$var$Tm, $455d545b1dff00eb$var$cx, !1, $455d545b1dff00eb$var$Mm);
        if (c === null && ($455d545b1dff00eb$var$ux($455d545b1dff00eb$var$Tm.set(-0.5, .5, 0), $455d545b1dff00eb$var$md, l, $455d545b1dff00eb$var$pd, i, r), $455d545b1dff00eb$var$Q1.set(0, 1), c = e.ray.intersectTriangle($455d545b1dff00eb$var$lx, $455d545b1dff00eb$var$cx, $455d545b1dff00eb$var$Tm, !1, $455d545b1dff00eb$var$Mm), c === null)) return;
        const f = e.ray.origin.distanceTo($455d545b1dff00eb$var$Mm);
        f < e.near || f > e.far || t.push({
            distance: f,
            point: $455d545b1dff00eb$var$Mm.clone(),
            uv: $455d545b1dff00eb$var$Qr.getInterpolation($455d545b1dff00eb$var$Mm, $455d545b1dff00eb$var$lx, $455d545b1dff00eb$var$Tm, $455d545b1dff00eb$var$cx, $455d545b1dff00eb$var$$2, $455d545b1dff00eb$var$Q1, $455d545b1dff00eb$var$eM, new $455d545b1dff00eb$var$$e),
            face: null,
            object: this
        });
    }
    copy(e, t) {
        return super.copy(e, t), e.center !== void 0 && this.center.copy(e.center), this.material = e.material, this;
    }
}
function $455d545b1dff00eb$var$ux(a, e, t, n, i, r) {
    $455d545b1dff00eb$var$gd.subVectors(a, t).addScalar(.5).multiply(n), i !== void 0 ? ($455d545b1dff00eb$var$Em.x = r * $455d545b1dff00eb$var$gd.x - i * $455d545b1dff00eb$var$gd.y, $455d545b1dff00eb$var$Em.y = i * $455d545b1dff00eb$var$gd.x + r * $455d545b1dff00eb$var$gd.y) : $455d545b1dff00eb$var$Em.copy($455d545b1dff00eb$var$gd), a.copy(e), a.x += $455d545b1dff00eb$var$Em.x, a.y += $455d545b1dff00eb$var$Em.y, a.applyMatrix4($455d545b1dff00eb$var$TT);
}
const $455d545b1dff00eb$var$fx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$tM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$wT extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.isLOD = !0, this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
            levels: {
                enumerable: !0,
                value: []
            }
        }), this.autoUpdate = !0;
    }
    copy(e) {
        super.copy(e, !1);
        const t = e.levels;
        for(let n = 0, i = t.length; n < i; n++){
            const r = t[n];
            this.addLevel(r.object.clone(), r.distance, r.hysteresis);
        }
        return this.autoUpdate = e.autoUpdate, this;
    }
    addLevel(e, t = 0, n = 0) {
        t = Math.abs(t);
        const i = this.levels;
        let r;
        for(r = 0; r < i.length && !(t < i[r].distance); r++);
        return i.splice(r, 0, {
            distance: t,
            hysteresis: n,
            object: e
        }), this.add(e), this;
    }
    removeLevel(e) {
        const t = this.levels;
        for(let n = 0; n < t.length; n++)if (t[n].distance === e) {
            const i = t.splice(n, 1);
            return this.remove(i[0].object), !0;
        }
        return !1;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(e) {
        const t = this.levels;
        if (t.length > 0) {
            let n, i;
            for(n = 1, i = t.length; n < i; n++){
                let r = t[n].distance;
                if (t[n].object.visible && (r -= r * t[n].hysteresis), e < r) break;
            }
            return t[n - 1].object;
        }
        return null;
    }
    raycast(e, t) {
        if (this.levels.length > 0) {
            $455d545b1dff00eb$var$fx.setFromMatrixPosition(this.matrixWorld);
            const i = e.ray.origin.distanceTo($455d545b1dff00eb$var$fx);
            this.getObjectForDistance(i).raycast(e, t);
        }
    }
    update(e) {
        const t = this.levels;
        if (t.length > 1) {
            $455d545b1dff00eb$var$fx.setFromMatrixPosition(e.matrixWorld), $455d545b1dff00eb$var$tM.setFromMatrixPosition(this.matrixWorld);
            const n = $455d545b1dff00eb$var$fx.distanceTo($455d545b1dff00eb$var$tM) / e.zoom;
            t[0].object.visible = !0;
            let i, r;
            for(i = 1, r = t.length; i < r; i++){
                let l = t[i].distance;
                if (t[i].object.visible && (l -= l * t[i].hysteresis), n >= l) t[i - 1].object.visible = !1, t[i].object.visible = !0;
                else break;
            }
            for(this._currentLevel = i - 1; i < r; i++)t[i].object.visible = !1;
        }
    }
    toJSON(e) {
        const t = super.toJSON(e);
        this.autoUpdate === !1 && (t.object.autoUpdate = !1), t.object.levels = [];
        const n = this.levels;
        for(let i = 0, r = n.length; i < r; i++){
            const l = n[i];
            t.object.levels.push({
                object: l.object.uuid,
                distance: l.distance,
                hysteresis: l.hysteresis
            });
        }
        return t;
    }
}
const $455d545b1dff00eb$var$nM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$iM = new $455d545b1dff00eb$var$Un, $455d545b1dff00eb$var$aM = new $455d545b1dff00eb$var$Un, $455d545b1dff00eb$var$wU = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$rM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$hx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$K1 = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$sM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$J1 = new $455d545b1dff00eb$var$Kf;
class $455d545b1dff00eb$var$CT extends $455d545b1dff00eb$var$zi {
    constructor(e, t){
        super(e, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = $455d545b1dff00eb$var$Z_, this.bindMatrix = new $455d545b1dff00eb$var$Ft, this.bindMatrixInverse = new $455d545b1dff00eb$var$Ft, this.boundingBox = null, this.boundingSphere = null;
    }
    computeBoundingBox() {
        const e = this.geometry;
        this.boundingBox === null && (this.boundingBox = new $455d545b1dff00eb$var$ca), this.boundingBox.makeEmpty();
        const t = e.getAttribute("position");
        for(let n = 0; n < t.count; n++)this.getVertexPosition(n, $455d545b1dff00eb$var$hx), this.boundingBox.expandByPoint($455d545b1dff00eb$var$hx);
    }
    computeBoundingSphere() {
        const e = this.geometry;
        this.boundingSphere === null && (this.boundingSphere = new $455d545b1dff00eb$var$Ta), this.boundingSphere.makeEmpty();
        const t = e.getAttribute("position");
        for(let n = 0; n < t.count; n++)this.getVertexPosition(n, $455d545b1dff00eb$var$hx), this.boundingSphere.expandByPoint($455d545b1dff00eb$var$hx);
    }
    copy(e, t) {
        return super.copy(e, t), this.bindMode = e.bindMode, this.bindMatrix.copy(e.bindMatrix), this.bindMatrixInverse.copy(e.bindMatrixInverse), this.skeleton = e.skeleton, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
    }
    raycast(e, t) {
        const n = this.material, i = this.matrixWorld;
        n !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), $455d545b1dff00eb$var$K1.copy(this.boundingSphere), $455d545b1dff00eb$var$K1.applyMatrix4(i), e.ray.intersectsSphere($455d545b1dff00eb$var$K1) !== !1 && ($455d545b1dff00eb$var$sM.copy(i).invert(), $455d545b1dff00eb$var$J1.copy(e.ray).applyMatrix4($455d545b1dff00eb$var$sM), !(this.boundingBox !== null && $455d545b1dff00eb$var$J1.intersectsBox(this.boundingBox) === !1) && this._computeIntersections(e, t, $455d545b1dff00eb$var$J1)));
    }
    getVertexPosition(e, t) {
        return super.getVertexPosition(e, t), this.applyBoneTransform(e, t), t;
    }
    bind(e, t) {
        this.skeleton = e, t === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const e = new $455d545b1dff00eb$var$Un, t = this.geometry.attributes.skinWeight;
        for(let n = 0, i = t.count; n < i; n++){
            e.fromBufferAttribute(t, n);
            const r = 1 / e.manhattanLength();
            r !== 1 / 0 ? e.multiplyScalar(r) : e.set(1, 0, 0, 0), t.setXYZW(n, e.x, e.y, e.z, e.w);
        }
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.bindMode === $455d545b1dff00eb$var$Z_ ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === $455d545b1dff00eb$var$rT ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : $455d545b1dff00eb$var$Mt("SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(e, t) {
        const n = this.skeleton, i = this.geometry;
        $455d545b1dff00eb$var$iM.fromBufferAttribute(i.attributes.skinIndex, e), $455d545b1dff00eb$var$aM.fromBufferAttribute(i.attributes.skinWeight, e), $455d545b1dff00eb$var$nM.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
        for(let r = 0; r < 4; r++){
            const l = $455d545b1dff00eb$var$aM.getComponent(r);
            if (l !== 0) {
                const c = $455d545b1dff00eb$var$iM.getComponent(r);
                $455d545b1dff00eb$var$rM.multiplyMatrices(n.bones[c].matrixWorld, n.boneInverses[c]), t.addScaledVector($455d545b1dff00eb$var$wU.copy($455d545b1dff00eb$var$nM).applyMatrix4($455d545b1dff00eb$var$rM), l);
            }
        }
        return t.applyMatrix4(this.bindMatrixInverse);
    }
}
class $455d545b1dff00eb$var$qb extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.isBone = !0, this.type = "Bone";
    }
}
class $455d545b1dff00eb$var$Ro extends $455d545b1dff00eb$var$Li {
    constructor(e = null, t = 1, n = 1, i, r, l, c, f, p = $455d545b1dff00eb$var$Fa, m = $455d545b1dff00eb$var$Fa, x, v){
        super(null, l, c, f, p, m, i, r, x, v), this.isDataTexture = !0, this.image = {
            data: e,
            width: t,
            height: n
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
const $455d545b1dff00eb$var$oM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$CU = new $455d545b1dff00eb$var$Ft;
class $455d545b1dff00eb$var$gy {
    constructor(e = [], t = []){
        this.uuid = $455d545b1dff00eb$var$bs(), this.bones = e.slice(0), this.boneInverses = t, this.boneMatrices = null, this.boneTexture = null, this.init();
    }
    init() {
        const e = this.bones, t = this.boneInverses;
        if (this.boneMatrices = new Float32Array(e.length * 16), t.length === 0) this.calculateInverses();
        else if (e.length !== t.length) {
            $455d545b1dff00eb$var$Mt("Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
            for(let n = 0, i = this.bones.length; n < i; n++)this.boneInverses.push(new $455d545b1dff00eb$var$Ft);
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let e = 0, t = this.bones.length; e < t; e++){
            const n = new $455d545b1dff00eb$var$Ft;
            this.bones[e] && n.copy(this.bones[e].matrixWorld).invert(), this.boneInverses.push(n);
        }
    }
    pose() {
        for(let e = 0, t = this.bones.length; e < t; e++){
            const n = this.bones[e];
            n && n.matrixWorld.copy(this.boneInverses[e]).invert();
        }
        for(let e = 0, t = this.bones.length; e < t; e++){
            const n = this.bones[e];
            n && (n.parent && n.parent.isBone ? (n.matrix.copy(n.parent.matrixWorld).invert(), n.matrix.multiply(n.matrixWorld)) : n.matrix.copy(n.matrixWorld), n.matrix.decompose(n.position, n.quaternion, n.scale));
        }
    }
    update() {
        const e = this.bones, t = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
        for(let r = 0, l = e.length; r < l; r++){
            const c = e[r] ? e[r].matrixWorld : $455d545b1dff00eb$var$CU;
            $455d545b1dff00eb$var$oM.multiplyMatrices(c, t[r]), $455d545b1dff00eb$var$oM.toArray(n, r * 16);
        }
        i !== null && (i.needsUpdate = !0);
    }
    clone() {
        return new $455d545b1dff00eb$var$gy(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        let e = Math.sqrt(this.bones.length * 4);
        e = Math.ceil(e / 4) * 4, e = Math.max(e, 4);
        const t = new Float32Array(e * e * 4);
        t.set(this.boneMatrices);
        const n = new $455d545b1dff00eb$var$Ro(t, e, e, $455d545b1dff00eb$var$ar, $455d545b1dff00eb$var$Rr);
        return n.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = n, this;
    }
    getBoneByName(e) {
        for(let t = 0, n = this.bones.length; t < n; t++){
            const i = this.bones[t];
            if (i.name === e) return i;
        }
    }
    dispose() {
        this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
    }
    fromJSON(e, t) {
        this.uuid = e.uuid;
        for(let n = 0, i = e.bones.length; n < i; n++){
            const r = e.bones[n];
            let l = t[r];
            l === void 0 && ($455d545b1dff00eb$var$Mt("Skeleton: No bone found with UUID:", r), l = new $455d545b1dff00eb$var$qb), this.bones.push(l), this.boneInverses.push(new $455d545b1dff00eb$var$Ft().fromArray(e.boneInverses[n]));
        }
        return this.init(), this;
    }
    toJSON() {
        const e = {
            metadata: {
                version: 4.7,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        e.uuid = this.uuid;
        const t = this.bones, n = this.boneInverses;
        for(let i = 0, r = t.length; i < r; i++){
            const l = t[i];
            e.bones.push(l.uuid);
            const c = n[i];
            e.boneInverses.push(c.toArray());
        }
        return e;
    }
}
class $455d545b1dff00eb$var$Wf extends $455d545b1dff00eb$var$ti {
    constructor(e, t, n, i = 1){
        super(e, t, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
    }
    copy(e) {
        return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
    }
}
const $455d545b1dff00eb$var$xd = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$lM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$dx = [], $455d545b1dff00eb$var$cM = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$RU = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Am = new $455d545b1dff00eb$var$zi, $455d545b1dff00eb$var$wm = new $455d545b1dff00eb$var$Ta;
class $455d545b1dff00eb$var$RT extends $455d545b1dff00eb$var$zi {
    constructor(e, t, n){
        super(e, t), this.isInstancedMesh = !0, this.instanceMatrix = new $455d545b1dff00eb$var$Wf(new Float32Array(n * 16), 16), this.instanceColor = null, this.morphTexture = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
        for(let i = 0; i < n; i++)this.setMatrixAt(i, $455d545b1dff00eb$var$RU);
    }
    computeBoundingBox() {
        const e = this.geometry, t = this.count;
        this.boundingBox === null && (this.boundingBox = new $455d545b1dff00eb$var$ca), e.boundingBox === null && e.computeBoundingBox(), this.boundingBox.makeEmpty();
        for(let n = 0; n < t; n++)this.getMatrixAt(n, $455d545b1dff00eb$var$xd), $455d545b1dff00eb$var$cM.copy(e.boundingBox).applyMatrix4($455d545b1dff00eb$var$xd), this.boundingBox.union($455d545b1dff00eb$var$cM);
    }
    computeBoundingSphere() {
        const e = this.geometry, t = this.count;
        this.boundingSphere === null && (this.boundingSphere = new $455d545b1dff00eb$var$Ta), e.boundingSphere === null && e.computeBoundingSphere(), this.boundingSphere.makeEmpty();
        for(let n = 0; n < t; n++)this.getMatrixAt(n, $455d545b1dff00eb$var$xd), $455d545b1dff00eb$var$wm.copy(e.boundingSphere).applyMatrix4($455d545b1dff00eb$var$xd), this.boundingSphere.union($455d545b1dff00eb$var$wm);
    }
    copy(e, t) {
        return super.copy(e, t), this.instanceMatrix.copy(e.instanceMatrix), e.morphTexture !== null && (this.morphTexture = e.morphTexture.clone()), e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()), this.count = e.count, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
    }
    getColorAt(e, t) {
        t.fromArray(this.instanceColor.array, e * 3);
    }
    getMatrixAt(e, t) {
        t.fromArray(this.instanceMatrix.array, e * 16);
    }
    getMorphAt(e, t) {
        const n = t.morphTargetInfluences, i = this.morphTexture.source.data.data, r = n.length + 1, l = e * r + 1;
        for(let c = 0; c < n.length; c++)n[c] = i[l + c];
    }
    raycast(e, t) {
        const n = this.matrixWorld, i = this.count;
        if ($455d545b1dff00eb$var$Am.geometry = this.geometry, $455d545b1dff00eb$var$Am.material = this.material, $455d545b1dff00eb$var$Am.material !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), $455d545b1dff00eb$var$wm.copy(this.boundingSphere), $455d545b1dff00eb$var$wm.applyMatrix4(n), e.ray.intersectsSphere($455d545b1dff00eb$var$wm) !== !1)) for(let r = 0; r < i; r++){
            this.getMatrixAt(r, $455d545b1dff00eb$var$xd), $455d545b1dff00eb$var$lM.multiplyMatrices(n, $455d545b1dff00eb$var$xd), $455d545b1dff00eb$var$Am.matrixWorld = $455d545b1dff00eb$var$lM, $455d545b1dff00eb$var$Am.raycast(e, $455d545b1dff00eb$var$dx);
            for(let l = 0, c = $455d545b1dff00eb$var$dx.length; l < c; l++){
                const f = $455d545b1dff00eb$var$dx[l];
                f.instanceId = r, f.object = this, t.push(f);
            }
            $455d545b1dff00eb$var$dx.length = 0;
        }
    }
    setColorAt(e, t) {
        this.instanceColor === null && (this.instanceColor = new $455d545b1dff00eb$var$Wf(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3)), t.toArray(this.instanceColor.array, e * 3);
    }
    setMatrixAt(e, t) {
        t.toArray(this.instanceMatrix.array, e * 16);
    }
    setMorphAt(e, t) {
        const n = t.morphTargetInfluences, i = n.length + 1;
        this.morphTexture === null && (this.morphTexture = new $455d545b1dff00eb$var$Ro(new Float32Array(i * this.count), i, this.count, $455d545b1dff00eb$var$ry, $455d545b1dff00eb$var$Rr));
        const r = this.morphTexture.source.data.data;
        let l = 0;
        for(let p = 0; p < n.length; p++)l += n[p];
        const c = this.geometry.morphTargetsRelative ? 1 : 1 - l, f = i * e;
        r[f] = c, r.set(n, f + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        }), this.morphTexture !== null && (this.morphTexture.dispose(), this.morphTexture = null);
    }
}
const $455d545b1dff00eb$var$$1 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$DU = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$UU = new $455d545b1dff00eb$var$Jt;
class $455d545b1dff00eb$var$ml {
    constructor(e = new $455d545b1dff00eb$var$J(1, 0, 0), t = 0){
        this.isPlane = !0, this.normal = e, this.constant = t;
    }
    set(e, t) {
        return this.normal.copy(e), this.constant = t, this;
    }
    setComponents(e, t, n, i) {
        return this.normal.set(e, t, n), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(e, t) {
        return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
    }
    setFromCoplanarPoints(e, t, n) {
        const i = $455d545b1dff00eb$var$$1.subVectors(n, t).cross($455d545b1dff00eb$var$DU.subVectors(e, t)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, e), this;
    }
    copy(e) {
        return this.normal.copy(e.normal), this.constant = e.constant, this;
    }
    normalize() {
        const e = 1 / this.normal.length();
        return this.normal.multiplyScalar(e), this.constant *= e, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(e) {
        return this.normal.dot(e) + this.constant;
    }
    distanceToSphere(e) {
        return this.distanceToPoint(e.center) - e.radius;
    }
    projectPoint(e, t) {
        return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
    }
    intersectLine(e, t) {
        const n = e.delta($455d545b1dff00eb$var$$1), i = this.normal.dot(n);
        if (i === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
        const r = -(e.start.dot(this.normal) + this.constant) / i;
        return r < 0 || r > 1 ? null : t.copy(e.start).addScaledVector(n, r);
    }
    intersectsLine(e) {
        const t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
        return t < 0 && n > 0 || n < 0 && t > 0;
    }
    intersectsBox(e) {
        return e.intersectsPlane(this);
    }
    intersectsSphere(e) {
        return e.intersectsPlane(this);
    }
    coplanarPoint(e) {
        return e.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(e, t) {
        const n = t || $455d545b1dff00eb$var$UU.getNormalMatrix(e), i = this.coplanarPoint($455d545b1dff00eb$var$$1).applyMatrix4(e), r = this.normal.applyMatrix3(n).normalize();
        return this.constant = -i.dot(r), this;
    }
    translate(e) {
        return this.constant -= e.dot(this.normal), this;
    }
    equals(e) {
        return e.normal.equals(this.normal) && e.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $455d545b1dff00eb$var$_f = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$NU = new $455d545b1dff00eb$var$$e(.5, .5), $455d545b1dff00eb$var$px = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$qd {
    constructor(e = new $455d545b1dff00eb$var$ml, t = new $455d545b1dff00eb$var$ml, n = new $455d545b1dff00eb$var$ml, i = new $455d545b1dff00eb$var$ml, r = new $455d545b1dff00eb$var$ml, l = new $455d545b1dff00eb$var$ml){
        this.planes = [
            e,
            t,
            n,
            i,
            r,
            l
        ];
    }
    set(e, t, n, i, r, l) {
        const c = this.planes;
        return c[0].copy(e), c[1].copy(t), c[2].copy(n), c[3].copy(i), c[4].copy(r), c[5].copy(l), this;
    }
    copy(e) {
        const t = this.planes;
        for(let n = 0; n < 6; n++)t[n].copy(e.planes[n]);
        return this;
    }
    setFromProjectionMatrix(e, t = $455d545b1dff00eb$var$_s, n = !1) {
        const i = this.planes, r = e.elements, l = r[0], c = r[1], f = r[2], p = r[3], m = r[4], x = r[5], v = r[6], _ = r[7], S = r[8], A = r[9], M = r[10], b = r[11], C = r[12], R = r[13], N = r[14], z = r[15];
        if (i[0].setComponents(p - l, _ - m, b - S, z - C).normalize(), i[1].setComponents(p + l, _ + m, b + S, z + C).normalize(), i[2].setComponents(p + c, _ + x, b + A, z + R).normalize(), i[3].setComponents(p - c, _ - x, b - A, z - R).normalize(), n) i[4].setComponents(f, v, M, N).normalize(), i[5].setComponents(p - f, _ - v, b - M, z - N).normalize();
        else if (i[4].setComponents(p - f, _ - v, b - M, z - N).normalize(), t === $455d545b1dff00eb$var$_s) i[5].setComponents(p + f, _ + v, b + M, z + N).normalize();
        else if (t === $455d545b1dff00eb$var$Bd) i[5].setComponents(f, v, M, N).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
        return this;
    }
    intersectsObject(e) {
        if (e.boundingSphere !== void 0) e.boundingSphere === null && e.computeBoundingSphere(), $455d545b1dff00eb$var$_f.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
        else {
            const t = e.geometry;
            t.boundingSphere === null && t.computeBoundingSphere(), $455d545b1dff00eb$var$_f.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
        }
        return this.intersectsSphere($455d545b1dff00eb$var$_f);
    }
    intersectsSprite(e) {
        $455d545b1dff00eb$var$_f.center.set(0, 0, 0);
        const t = $455d545b1dff00eb$var$NU.distanceTo(e.center);
        return $455d545b1dff00eb$var$_f.radius = .7071067811865476 + t, $455d545b1dff00eb$var$_f.applyMatrix4(e.matrixWorld), this.intersectsSphere($455d545b1dff00eb$var$_f);
    }
    intersectsSphere(e) {
        const t = this.planes, n = e.center, i = -e.radius;
        for(let r = 0; r < 6; r++)if (t[r].distanceToPoint(n) < i) return !1;
        return !0;
    }
    intersectsBox(e) {
        const t = this.planes;
        for(let n = 0; n < 6; n++){
            const i = t[n];
            if ($455d545b1dff00eb$var$px.x = i.normal.x > 0 ? e.max.x : e.min.x, $455d545b1dff00eb$var$px.y = i.normal.y > 0 ? e.max.y : e.min.y, $455d545b1dff00eb$var$px.z = i.normal.z > 0 ? e.max.z : e.min.z, i.distanceToPoint($455d545b1dff00eb$var$px) < 0) return !1;
        }
        return !0;
    }
    containsPoint(e) {
        const t = this.planes;
        for(let n = 0; n < 6; n++)if (t[n].distanceToPoint(e) < 0) return !1;
        return !0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $455d545b1dff00eb$var$hl = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$dl = new $455d545b1dff00eb$var$qd;
class $455d545b1dff00eb$var$xy {
    constructor(){
        this.coordinateSystem = $455d545b1dff00eb$var$_s;
    }
    intersectsObject(e, t) {
        if (!t.isArrayCamera || t.cameras.length === 0) return !1;
        for(let n = 0; n < t.cameras.length; n++){
            const i = t.cameras[n];
            if ($455d545b1dff00eb$var$hl.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), $455d545b1dff00eb$var$dl.setFromProjectionMatrix($455d545b1dff00eb$var$hl, i.coordinateSystem, i.reversedDepth), $455d545b1dff00eb$var$dl.intersectsObject(e)) return !0;
        }
        return !1;
    }
    intersectsSprite(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let n = 0; n < t.cameras.length; n++){
            const i = t.cameras[n];
            if ($455d545b1dff00eb$var$hl.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), $455d545b1dff00eb$var$dl.setFromProjectionMatrix($455d545b1dff00eb$var$hl, i.coordinateSystem, i.reversedDepth), $455d545b1dff00eb$var$dl.intersectsSprite(e)) return !0;
        }
        return !1;
    }
    intersectsSphere(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let n = 0; n < t.cameras.length; n++){
            const i = t.cameras[n];
            if ($455d545b1dff00eb$var$hl.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), $455d545b1dff00eb$var$dl.setFromProjectionMatrix($455d545b1dff00eb$var$hl, i.coordinateSystem, i.reversedDepth), $455d545b1dff00eb$var$dl.intersectsSphere(e)) return !0;
        }
        return !1;
    }
    intersectsBox(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let n = 0; n < t.cameras.length; n++){
            const i = t.cameras[n];
            if ($455d545b1dff00eb$var$hl.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), $455d545b1dff00eb$var$dl.setFromProjectionMatrix($455d545b1dff00eb$var$hl, i.coordinateSystem, i.reversedDepth), $455d545b1dff00eb$var$dl.intersectsBox(e)) return !0;
        }
        return !1;
    }
    containsPoint(e, t) {
        if (!t || !t.cameras || t.cameras.length === 0) return !1;
        for(let n = 0; n < t.cameras.length; n++){
            const i = t.cameras[n];
            if ($455d545b1dff00eb$var$hl.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), $455d545b1dff00eb$var$dl.setFromProjectionMatrix($455d545b1dff00eb$var$hl, i.coordinateSystem, i.reversedDepth), $455d545b1dff00eb$var$dl.containsPoint(e)) return !0;
        }
        return !1;
    }
    clone() {
        return new $455d545b1dff00eb$var$xy;
    }
}
function $455d545b1dff00eb$var$e_(a, e) {
    return a - e;
}
function $455d545b1dff00eb$var$OU(a, e) {
    return a.z - e.z;
}
function $455d545b1dff00eb$var$LU(a, e) {
    return e.z - a.z;
}
class $455d545b1dff00eb$var$zU {
    constructor(){
        this.index = 0, this.pool = [], this.list = [];
    }
    push(e, t, n, i) {
        const r = this.pool, l = this.list;
        this.index >= r.length && r.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const c = r[this.index];
        l.push(c), this.index++, c.start = e, c.count = t, c.z = n, c.index = i;
    }
    reset() {
        this.list.length = 0, this.index = 0;
    }
}
const $455d545b1dff00eb$var$Wr = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$PU = new $455d545b1dff00eb$var$_t(1, 1, 1), $455d545b1dff00eb$var$uM = new $455d545b1dff00eb$var$qd, $455d545b1dff00eb$var$BU = new $455d545b1dff00eb$var$xy, $455d545b1dff00eb$var$mx = new $455d545b1dff00eb$var$ca, $455d545b1dff00eb$var$bf = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$Cm = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$fM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$IU = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$t_ = new $455d545b1dff00eb$var$zU, $455d545b1dff00eb$var$tr = new $455d545b1dff00eb$var$zi, $455d545b1dff00eb$var$gx = [];
function $455d545b1dff00eb$var$FU(a, e, t = 0) {
    const n = e.itemSize;
    if (a.isInterleavedBufferAttribute || a.array.constructor !== e.array.constructor) {
        const i = a.count;
        for(let r = 0; r < i; r++)for(let l = 0; l < n; l++)e.setComponent(r + t, l, a.getComponent(r, l));
    } else e.array.set(a.array, t * n);
    e.needsUpdate = !0;
}
function $455d545b1dff00eb$var$Sf(a, e) {
    if (a.constructor !== e.constructor) {
        const t = Math.min(a.length, e.length);
        for(let n = 0; n < t; n++)e[n] = a[n];
    } else {
        const t = Math.min(a.length, e.length);
        e.set(new a.constructor(a.buffer, 0, t));
    }
}
class $455d545b1dff00eb$var$DT extends $455d545b1dff00eb$var$zi {
    constructor(e, t, n = t * 2, i){
        super(new $455d545b1dff00eb$var$nn, i), this.isBatchedMesh = !0, this.perObjectFrustumCulled = !0, this.sortObjects = !0, this.boundingBox = null, this.boundingSphere = null, this.customSort = null, this._instanceInfo = [], this._geometryInfo = [], this._availableInstanceIds = [], this._availableGeometryIds = [], this._nextIndexStart = 0, this._nextVertexStart = 0, this._geometryCount = 0, this._visibilityChanged = !0, this._geometryInitialized = !1, this._maxInstanceCount = e, this._maxVertexCount = t, this._maxIndexCount = n, this._multiDrawCounts = new Int32Array(e), this._multiDrawStarts = new Int32Array(e), this._multiDrawCount = 0, this._multiDrawInstances = null, this._matricesTexture = null, this._indirectTexture = null, this._colorsTexture = null, this._initMatricesTexture(), this._initIndirectTexture();
    }
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        let e = Math.sqrt(this._maxInstanceCount * 4);
        e = Math.ceil(e / 4) * 4, e = Math.max(e, 4);
        const t = new Float32Array(e * e * 4), n = new $455d545b1dff00eb$var$Ro(t, e, e, $455d545b1dff00eb$var$ar, $455d545b1dff00eb$var$Rr);
        this._matricesTexture = n;
    }
    _initIndirectTexture() {
        let e = Math.sqrt(this._maxInstanceCount);
        e = Math.ceil(e);
        const t = new Uint32Array(e * e), n = new $455d545b1dff00eb$var$Ro(t, e, e, $455d545b1dff00eb$var$M0, $455d545b1dff00eb$var$Mc);
        this._indirectTexture = n;
    }
    _initColorsTexture() {
        let e = Math.sqrt(this._maxInstanceCount);
        e = Math.ceil(e);
        const t = new Float32Array(e * e * 4).fill(1), n = new $455d545b1dff00eb$var$Ro(t, e, e, $455d545b1dff00eb$var$ar, $455d545b1dff00eb$var$Rr);
        n.colorSpace = $455d545b1dff00eb$var$Dn.workingColorSpace, this._colorsTexture = n;
    }
    _initializeGeometry(e) {
        const t = this.geometry, n = this._maxVertexCount, i = this._maxIndexCount;
        if (this._geometryInitialized === !1) {
            for(const r in e.attributes){
                const l = e.getAttribute(r), { array: c, itemSize: f, normalized: p } = l, m = new c.constructor(n * f), x = new $455d545b1dff00eb$var$ti(m, f, p);
                t.setAttribute(r, x);
            }
            if (e.getIndex() !== null) {
                const r = n > 65535 ? new Uint32Array(i) : new Uint16Array(i);
                t.setIndex(new $455d545b1dff00eb$var$ti(r, 1));
            }
            this._geometryInitialized = !0;
        }
    }
    _validateGeometry(e) {
        const t = this.geometry;
        if (!!e.getIndex() != !!t.getIndex()) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const n in t.attributes){
            if (!e.hasAttribute(n)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${n}". All geometries must have consistent attributes.`);
            const i = e.getAttribute(n), r = t.getAttribute(n);
            if (i.itemSize !== r.itemSize || i.normalized !== r.normalized) throw new Error("THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
        }
    }
    validateInstanceId(e) {
        const t = this._instanceInfo;
        if (e < 0 || e >= t.length || t[e].active === !1) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${e}. Instance is either out of range or has been deleted.`);
    }
    validateGeometryId(e) {
        const t = this._geometryInfo;
        if (e < 0 || e >= t.length || t[e].active === !1) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${e}. Geometry is either out of range or has been deleted.`);
    }
    setCustomSort(e) {
        return this.customSort = e, this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new $455d545b1dff00eb$var$ca);
        const e = this.boundingBox, t = this._instanceInfo;
        e.makeEmpty();
        for(let n = 0, i = t.length; n < i; n++){
            if (t[n].active === !1) continue;
            const r = t[n].geometryIndex;
            this.getMatrixAt(n, $455d545b1dff00eb$var$Wr), this.getBoundingBoxAt(r, $455d545b1dff00eb$var$mx).applyMatrix4($455d545b1dff00eb$var$Wr), e.union($455d545b1dff00eb$var$mx);
        }
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new $455d545b1dff00eb$var$Ta);
        const e = this.boundingSphere, t = this._instanceInfo;
        e.makeEmpty();
        for(let n = 0, i = t.length; n < i; n++){
            if (t[n].active === !1) continue;
            const r = t[n].geometryIndex;
            this.getMatrixAt(n, $455d545b1dff00eb$var$Wr), this.getBoundingSphereAt(r, $455d545b1dff00eb$var$bf).applyMatrix4($455d545b1dff00eb$var$Wr), e.union($455d545b1dff00eb$var$bf);
        }
    }
    addInstance(e) {
        if (this._instanceInfo.length >= this.maxInstanceCount && this._availableInstanceIds.length === 0) throw new Error("THREE.BatchedMesh: Maximum item count reached.");
        const n = {
            visible: !0,
            active: !0,
            geometryIndex: e
        };
        let i = null;
        this._availableInstanceIds.length > 0 ? (this._availableInstanceIds.sort($455d545b1dff00eb$var$e_), i = this._availableInstanceIds.shift(), this._instanceInfo[i] = n) : (i = this._instanceInfo.length, this._instanceInfo.push(n));
        const r = this._matricesTexture;
        $455d545b1dff00eb$var$Wr.identity().toArray(r.image.data, i * 16), r.needsUpdate = !0;
        const l = this._colorsTexture;
        return l && ($455d545b1dff00eb$var$PU.toArray(l.image.data, i * 4), l.needsUpdate = !0), this._visibilityChanged = !0, i;
    }
    addGeometry(e, t = -1, n = -1) {
        this._initializeGeometry(e), this._validateGeometry(e);
        const i = {
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            start: -1,
            count: -1,
            boundingBox: null,
            boundingSphere: null,
            active: !0
        }, r = this._geometryInfo;
        i.vertexStart = this._nextVertexStart, i.reservedVertexCount = t === -1 ? e.getAttribute("position").count : t;
        const l = e.getIndex();
        if (l !== null && (i.indexStart = this._nextIndexStart, i.reservedIndexCount = n === -1 ? l.count : n), i.indexStart !== -1 && i.indexStart + i.reservedIndexCount > this._maxIndexCount || i.vertexStart + i.reservedVertexCount > this._maxVertexCount) throw new Error("THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.");
        let f;
        return this._availableGeometryIds.length > 0 ? (this._availableGeometryIds.sort($455d545b1dff00eb$var$e_), f = this._availableGeometryIds.shift(), r[f] = i) : (f = this._geometryCount, this._geometryCount++, r.push(i)), this.setGeometryAt(f, e), this._nextIndexStart = i.indexStart + i.reservedIndexCount, this._nextVertexStart = i.vertexStart + i.reservedVertexCount, f;
    }
    setGeometryAt(e, t) {
        if (e >= this._geometryCount) throw new Error("THREE.BatchedMesh: Maximum geometry count reached.");
        this._validateGeometry(t);
        const n = this.geometry, i = n.getIndex() !== null, r = n.getIndex(), l = t.getIndex(), c = this._geometryInfo[e];
        if (i && l.count > c.reservedIndexCount || t.attributes.position.count > c.reservedVertexCount) throw new Error("THREE.BatchedMesh: Reserved space not large enough for provided geometry.");
        const f = c.vertexStart, p = c.reservedVertexCount;
        c.vertexCount = t.getAttribute("position").count;
        for(const m in n.attributes){
            const x = t.getAttribute(m), v = n.getAttribute(m);
            $455d545b1dff00eb$var$FU(x, v, f);
            const _ = x.itemSize;
            for(let S = x.count, A = p; S < A; S++){
                const M = f + S;
                for(let b = 0; b < _; b++)v.setComponent(M, b, 0);
            }
            v.needsUpdate = !0, v.addUpdateRange(f * _, p * _);
        }
        if (i) {
            const m = c.indexStart, x = c.reservedIndexCount;
            c.indexCount = t.getIndex().count;
            for(let v = 0; v < l.count; v++)r.setX(m + v, f + l.getX(v));
            for(let v = l.count, _ = x; v < _; v++)r.setX(m + v, f);
            r.needsUpdate = !0, r.addUpdateRange(m, c.reservedIndexCount);
        }
        return c.start = i ? c.indexStart : c.vertexStart, c.count = i ? c.indexCount : c.vertexCount, c.boundingBox = null, t.boundingBox !== null && (c.boundingBox = t.boundingBox.clone()), c.boundingSphere = null, t.boundingSphere !== null && (c.boundingSphere = t.boundingSphere.clone()), this._visibilityChanged = !0, e;
    }
    deleteGeometry(e) {
        const t = this._geometryInfo;
        if (e >= t.length || t[e].active === !1) return this;
        const n = this._instanceInfo;
        for(let i = 0, r = n.length; i < r; i++)n[i].active && n[i].geometryIndex === e && this.deleteInstance(i);
        return t[e].active = !1, this._availableGeometryIds.push(e), this._visibilityChanged = !0, this;
    }
    deleteInstance(e) {
        return this.validateInstanceId(e), this._instanceInfo[e].active = !1, this._availableInstanceIds.push(e), this._visibilityChanged = !0, this;
    }
    optimize() {
        let e = 0, t = 0;
        const n = this._geometryInfo, i = n.map((l, c)=>c).sort((l, c)=>n[l].vertexStart - n[c].vertexStart), r = this.geometry;
        for(let l = 0, c = n.length; l < c; l++){
            const f = i[l], p = n[f];
            if (p.active !== !1) {
                if (r.index !== null) {
                    if (p.indexStart !== t) {
                        const { indexStart: m, vertexStart: x, reservedIndexCount: v } = p, _ = r.index, S = _.array, A = e - x;
                        for(let M = m; M < m + v; M++)S[M] = S[M] + A;
                        _.array.copyWithin(t, m, m + v), _.addUpdateRange(t, v), p.indexStart = t;
                    }
                    t += p.reservedIndexCount;
                }
                if (p.vertexStart !== e) {
                    const { vertexStart: m, reservedVertexCount: x } = p, v = r.attributes;
                    for(const _ in v){
                        const S = v[_], { array: A, itemSize: M } = S;
                        A.copyWithin(e * M, m * M, (m + x) * M), S.addUpdateRange(e * M, x * M);
                    }
                    p.vertexStart = e;
                }
                e += p.reservedVertexCount, p.start = r.index ? p.indexStart : p.vertexStart, this._nextIndexStart = r.index ? p.indexStart + p.reservedIndexCount : 0, this._nextVertexStart = p.vertexStart + p.reservedVertexCount;
            }
        }
        return this;
    }
    getBoundingBoxAt(e, t) {
        if (e >= this._geometryCount) return null;
        const n = this.geometry, i = this._geometryInfo[e];
        if (i.boundingBox === null) {
            const r = new $455d545b1dff00eb$var$ca, l = n.index, c = n.attributes.position;
            for(let f = i.start, p = i.start + i.count; f < p; f++){
                let m = f;
                l && (m = l.getX(m)), r.expandByPoint($455d545b1dff00eb$var$Cm.fromBufferAttribute(c, m));
            }
            i.boundingBox = r;
        }
        return t.copy(i.boundingBox), t;
    }
    getBoundingSphereAt(e, t) {
        if (e >= this._geometryCount) return null;
        const n = this.geometry, i = this._geometryInfo[e];
        if (i.boundingSphere === null) {
            const r = new $455d545b1dff00eb$var$Ta;
            this.getBoundingBoxAt(e, $455d545b1dff00eb$var$mx), $455d545b1dff00eb$var$mx.getCenter(r.center);
            const l = n.index, c = n.attributes.position;
            let f = 0;
            for(let p = i.start, m = i.start + i.count; p < m; p++){
                let x = p;
                l && (x = l.getX(x)), $455d545b1dff00eb$var$Cm.fromBufferAttribute(c, x), f = Math.max(f, r.center.distanceToSquared($455d545b1dff00eb$var$Cm));
            }
            r.radius = Math.sqrt(f), i.boundingSphere = r;
        }
        return t.copy(i.boundingSphere), t;
    }
    setMatrixAt(e, t) {
        this.validateInstanceId(e);
        const n = this._matricesTexture, i = this._matricesTexture.image.data;
        return t.toArray(i, e * 16), n.needsUpdate = !0, this;
    }
    getMatrixAt(e, t) {
        return this.validateInstanceId(e), t.fromArray(this._matricesTexture.image.data, e * 16);
    }
    setColorAt(e, t) {
        return this.validateInstanceId(e), this._colorsTexture === null && this._initColorsTexture(), t.toArray(this._colorsTexture.image.data, e * 4), this._colorsTexture.needsUpdate = !0, this;
    }
    getColorAt(e, t) {
        return this.validateInstanceId(e), t.fromArray(this._colorsTexture.image.data, e * 4);
    }
    setVisibleAt(e, t) {
        return this.validateInstanceId(e), this._instanceInfo[e].visible === t ? this : (this._instanceInfo[e].visible = t, this._visibilityChanged = !0, this);
    }
    getVisibleAt(e) {
        return this.validateInstanceId(e), this._instanceInfo[e].visible;
    }
    setGeometryIdAt(e, t) {
        return this.validateInstanceId(e), this.validateGeometryId(t), this._instanceInfo[e].geometryIndex = t, this;
    }
    getGeometryIdAt(e) {
        return this.validateInstanceId(e), this._instanceInfo[e].geometryIndex;
    }
    getGeometryRangeAt(e, t = {}) {
        this.validateGeometryId(e);
        const n = this._geometryInfo[e];
        return t.vertexStart = n.vertexStart, t.vertexCount = n.vertexCount, t.reservedVertexCount = n.reservedVertexCount, t.indexStart = n.indexStart, t.indexCount = n.indexCount, t.reservedIndexCount = n.reservedIndexCount, t.start = n.start, t.count = n.count, t;
    }
    setInstanceCount(e) {
        const t = this._availableInstanceIds, n = this._instanceInfo;
        for(t.sort($455d545b1dff00eb$var$e_); t[t.length - 1] === n.length - 1;)n.pop(), t.pop();
        if (e < n.length) throw new Error(`BatchedMesh: Instance ids outside the range ${e} are being used. Cannot shrink instance count.`);
        const i = new Int32Array(e), r = new Int32Array(e);
        $455d545b1dff00eb$var$Sf(this._multiDrawCounts, i), $455d545b1dff00eb$var$Sf(this._multiDrawStarts, r), this._multiDrawCounts = i, this._multiDrawStarts = r, this._maxInstanceCount = e;
        const l = this._indirectTexture, c = this._matricesTexture, f = this._colorsTexture;
        l.dispose(), this._initIndirectTexture(), $455d545b1dff00eb$var$Sf(l.image.data, this._indirectTexture.image.data), c.dispose(), this._initMatricesTexture(), $455d545b1dff00eb$var$Sf(c.image.data, this._matricesTexture.image.data), f && (f.dispose(), this._initColorsTexture(), $455d545b1dff00eb$var$Sf(f.image.data, this._colorsTexture.image.data));
    }
    setGeometrySize(e, t) {
        const n = [
            ...this._geometryInfo
        ].filter((c)=>c.active);
        if (Math.max(...n.map((c)=>c.vertexStart + c.reservedVertexCount)) > e) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${t}. Cannot shrink further.`);
        if (this.geometry.index && Math.max(...n.map((f)=>f.indexStart + f.reservedIndexCount)) > t) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${t}. Cannot shrink further.`);
        const r = this.geometry;
        r.dispose(), this._maxVertexCount = e, this._maxIndexCount = t, this._geometryInitialized && (this._geometryInitialized = !1, this.geometry = new $455d545b1dff00eb$var$nn, this._initializeGeometry(r));
        const l = this.geometry;
        r.index && $455d545b1dff00eb$var$Sf(r.index.array, l.index.array);
        for(const c in r.attributes)$455d545b1dff00eb$var$Sf(r.attributes[c].array, l.attributes[c].array);
    }
    raycast(e, t) {
        const n = this._instanceInfo, i = this._geometryInfo, r = this.matrixWorld, l = this.geometry;
        $455d545b1dff00eb$var$tr.material = this.material, $455d545b1dff00eb$var$tr.geometry.index = l.index, $455d545b1dff00eb$var$tr.geometry.attributes = l.attributes, $455d545b1dff00eb$var$tr.geometry.boundingBox === null && ($455d545b1dff00eb$var$tr.geometry.boundingBox = new $455d545b1dff00eb$var$ca), $455d545b1dff00eb$var$tr.geometry.boundingSphere === null && ($455d545b1dff00eb$var$tr.geometry.boundingSphere = new $455d545b1dff00eb$var$Ta);
        for(let c = 0, f = n.length; c < f; c++){
            if (!n[c].visible || !n[c].active) continue;
            const p = n[c].geometryIndex, m = i[p];
            $455d545b1dff00eb$var$tr.geometry.setDrawRange(m.start, m.count), this.getMatrixAt(c, $455d545b1dff00eb$var$tr.matrixWorld).premultiply(r), this.getBoundingBoxAt(p, $455d545b1dff00eb$var$tr.geometry.boundingBox), this.getBoundingSphereAt(p, $455d545b1dff00eb$var$tr.geometry.boundingSphere), $455d545b1dff00eb$var$tr.raycast(e, $455d545b1dff00eb$var$gx);
            for(let x = 0, v = $455d545b1dff00eb$var$gx.length; x < v; x++){
                const _ = $455d545b1dff00eb$var$gx[x];
                _.object = this, _.batchId = c, t.push(_);
            }
            $455d545b1dff00eb$var$gx.length = 0;
        }
        $455d545b1dff00eb$var$tr.material = null, $455d545b1dff00eb$var$tr.geometry.index = null, $455d545b1dff00eb$var$tr.geometry.attributes = {}, $455d545b1dff00eb$var$tr.geometry.setDrawRange(0, 1 / 0);
    }
    copy(e) {
        return super.copy(e), this.geometry = e.geometry.clone(), this.perObjectFrustumCulled = e.perObjectFrustumCulled, this.sortObjects = e.sortObjects, this.boundingBox = e.boundingBox !== null ? e.boundingBox.clone() : null, this.boundingSphere = e.boundingSphere !== null ? e.boundingSphere.clone() : null, this._geometryInfo = e._geometryInfo.map((t)=>({
                ...t,
                boundingBox: t.boundingBox !== null ? t.boundingBox.clone() : null,
                boundingSphere: t.boundingSphere !== null ? t.boundingSphere.clone() : null
            })), this._instanceInfo = e._instanceInfo.map((t)=>({
                ...t
            })), this._availableInstanceIds = e._availableInstanceIds.slice(), this._availableGeometryIds = e._availableGeometryIds.slice(), this._nextIndexStart = e._nextIndexStart, this._nextVertexStart = e._nextVertexStart, this._geometryCount = e._geometryCount, this._maxInstanceCount = e._maxInstanceCount, this._maxVertexCount = e._maxVertexCount, this._maxIndexCount = e._maxIndexCount, this._geometryInitialized = e._geometryInitialized, this._multiDrawCounts = e._multiDrawCounts.slice(), this._multiDrawStarts = e._multiDrawStarts.slice(), this._indirectTexture = e._indirectTexture.clone(), this._indirectTexture.image.data = this._indirectTexture.image.data.slice(), this._matricesTexture = e._matricesTexture.clone(), this._matricesTexture.image.data = this._matricesTexture.image.data.slice(), this._colorsTexture !== null && (this._colorsTexture = e._colorsTexture.clone(), this._colorsTexture.image.data = this._colorsTexture.image.data.slice()), this;
    }
    dispose() {
        this.geometry.dispose(), this._matricesTexture.dispose(), this._matricesTexture = null, this._indirectTexture.dispose(), this._indirectTexture = null, this._colorsTexture !== null && (this._colorsTexture.dispose(), this._colorsTexture = null);
    }
    onBeforeRender(e, t, n, i, r) {
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        const l = i.getIndex(), c = l === null ? 1 : l.array.BYTES_PER_ELEMENT, f = this._instanceInfo, p = this._multiDrawStarts, m = this._multiDrawCounts, x = this._geometryInfo, v = this.perObjectFrustumCulled, _ = this._indirectTexture, S = _.image.data, A = n.isArrayCamera ? $455d545b1dff00eb$var$BU : $455d545b1dff00eb$var$uM;
        v && !n.isArrayCamera && ($455d545b1dff00eb$var$Wr.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse).multiply(this.matrixWorld), $455d545b1dff00eb$var$uM.setFromProjectionMatrix($455d545b1dff00eb$var$Wr, n.coordinateSystem, n.reversedDepth));
        let M = 0;
        if (this.sortObjects) {
            $455d545b1dff00eb$var$Wr.copy(this.matrixWorld).invert(), $455d545b1dff00eb$var$Cm.setFromMatrixPosition(n.matrixWorld).applyMatrix4($455d545b1dff00eb$var$Wr), $455d545b1dff00eb$var$fM.set(0, 0, -1).transformDirection(n.matrixWorld).transformDirection($455d545b1dff00eb$var$Wr);
            for(let R = 0, N = f.length; R < N; R++)if (f[R].visible && f[R].active) {
                const z = f[R].geometryIndex;
                this.getMatrixAt(R, $455d545b1dff00eb$var$Wr), this.getBoundingSphereAt(z, $455d545b1dff00eb$var$bf).applyMatrix4($455d545b1dff00eb$var$Wr);
                let L = !1;
                if (v && (L = !A.intersectsSphere($455d545b1dff00eb$var$bf, n)), !L) {
                    const P = x[z], H = $455d545b1dff00eb$var$IU.subVectors($455d545b1dff00eb$var$bf.center, $455d545b1dff00eb$var$Cm).dot($455d545b1dff00eb$var$fM);
                    $455d545b1dff00eb$var$t_.push(P.start, P.count, H, R);
                }
            }
            const b = $455d545b1dff00eb$var$t_.list, C = this.customSort;
            C === null ? b.sort(r.transparent ? $455d545b1dff00eb$var$LU : $455d545b1dff00eb$var$OU) : C.call(this, b, n);
            for(let R = 0, N = b.length; R < N; R++){
                const z = b[R];
                p[M] = z.start * c, m[M] = z.count, S[M] = z.index, M++;
            }
            $455d545b1dff00eb$var$t_.reset();
        } else for(let b = 0, C = f.length; b < C; b++)if (f[b].visible && f[b].active) {
            const R = f[b].geometryIndex;
            let N = !1;
            if (v && (this.getMatrixAt(b, $455d545b1dff00eb$var$Wr), this.getBoundingSphereAt(R, $455d545b1dff00eb$var$bf).applyMatrix4($455d545b1dff00eb$var$Wr), N = !A.intersectsSphere($455d545b1dff00eb$var$bf, n)), !N) {
                const z = x[R];
                p[M] = z.start * c, m[M] = z.count, S[M] = b, M++;
            }
        }
        _.needsUpdate = !0, this._multiDrawCount = M, this._visibilityChanged = !1;
    }
    onBeforeShadow(e, t, n, i, r, l) {
        this.onBeforeRender(e, null, i, r, l);
    }
}
class $455d545b1dff00eb$var$Nr extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
    }
}
const $455d545b1dff00eb$var$Fv = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Hv = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$hM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Rm = new $455d545b1dff00eb$var$Kf, $455d545b1dff00eb$var$xx = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$n_ = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$dM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$Tu extends $455d545b1dff00eb$var$Pn {
    constructor(e = new $455d545b1dff00eb$var$nn, t = new $455d545b1dff00eb$var$Nr){
        super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    computeLineDistances() {
        const e = this.geometry;
        if (e.index === null) {
            const t = e.attributes.position, n = [
                0
            ];
            for(let i = 1, r = t.count; i < r; i++)$455d545b1dff00eb$var$Fv.fromBufferAttribute(t, i - 1), $455d545b1dff00eb$var$Hv.fromBufferAttribute(t, i), n[i] = n[i - 1], n[i] += $455d545b1dff00eb$var$Fv.distanceTo($455d545b1dff00eb$var$Hv);
            e.setAttribute("lineDistance", new $455d545b1dff00eb$var$Dt(n, 1));
        } else $455d545b1dff00eb$var$Mt("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(e, t) {
        const n = this.geometry, i = this.matrixWorld, r = e.params.Line.threshold, l = n.drawRange;
        if (n.boundingSphere === null && n.computeBoundingSphere(), $455d545b1dff00eb$var$xx.copy(n.boundingSphere), $455d545b1dff00eb$var$xx.applyMatrix4(i), $455d545b1dff00eb$var$xx.radius += r, e.ray.intersectsSphere($455d545b1dff00eb$var$xx) === !1) return;
        $455d545b1dff00eb$var$hM.copy(i).invert(), $455d545b1dff00eb$var$Rm.copy(e.ray).applyMatrix4($455d545b1dff00eb$var$hM);
        const c = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), f = c * c, p = this.isLineSegments ? 2 : 1, m = n.index, v = n.attributes.position;
        if (m !== null) {
            const _ = Math.max(0, l.start), S = Math.min(m.count, l.start + l.count);
            for(let A = _, M = S - 1; A < M; A += p){
                const b = m.getX(A), C = m.getX(A + 1), R = $455d545b1dff00eb$var$vx(this, e, $455d545b1dff00eb$var$Rm, f, b, C, A);
                R && t.push(R);
            }
            if (this.isLineLoop) {
                const A = m.getX(S - 1), M = m.getX(_), b = $455d545b1dff00eb$var$vx(this, e, $455d545b1dff00eb$var$Rm, f, A, M, S - 1);
                b && t.push(b);
            }
        } else {
            const _ = Math.max(0, l.start), S = Math.min(v.count, l.start + l.count);
            for(let A = _, M = S - 1; A < M; A += p){
                const b = $455d545b1dff00eb$var$vx(this, e, $455d545b1dff00eb$var$Rm, f, A, A + 1, A);
                b && t.push(b);
            }
            if (this.isLineLoop) {
                const A = $455d545b1dff00eb$var$vx(this, e, $455d545b1dff00eb$var$Rm, f, S - 1, _, S - 1);
                A && t.push(A);
            }
        }
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, n = Object.keys(t);
        if (n.length > 0) {
            const i = t[n[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let r = 0, l = i.length; r < l; r++){
                    const c = i[r].name || String(r);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = r;
                }
            }
        }
    }
}
function $455d545b1dff00eb$var$vx(a, e, t, n, i, r, l) {
    const c = a.geometry.attributes.position;
    if ($455d545b1dff00eb$var$Fv.fromBufferAttribute(c, i), $455d545b1dff00eb$var$Hv.fromBufferAttribute(c, r), t.distanceSqToSegment($455d545b1dff00eb$var$Fv, $455d545b1dff00eb$var$Hv, $455d545b1dff00eb$var$n_, $455d545b1dff00eb$var$dM) > n) return;
    $455d545b1dff00eb$var$n_.applyMatrix4(a.matrixWorld);
    const p = e.ray.origin.distanceTo($455d545b1dff00eb$var$n_);
    if (!(p < e.near || p > e.far)) return {
        distance: p,
        point: $455d545b1dff00eb$var$dM.clone().applyMatrix4(a.matrixWorld),
        index: l,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: a
    };
}
const $455d545b1dff00eb$var$pM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$mM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$El extends $455d545b1dff00eb$var$Tu {
    constructor(e, t){
        super(e, t), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        const e = this.geometry;
        if (e.index === null) {
            const t = e.attributes.position, n = [];
            for(let i = 0, r = t.count; i < r; i += 2)$455d545b1dff00eb$var$pM.fromBufferAttribute(t, i), $455d545b1dff00eb$var$mM.fromBufferAttribute(t, i + 1), n[i] = i === 0 ? 0 : n[i - 1], n[i + 1] = n[i] + $455d545b1dff00eb$var$pM.distanceTo($455d545b1dff00eb$var$mM);
            e.setAttribute("lineDistance", new $455d545b1dff00eb$var$Dt(n, 1));
        } else $455d545b1dff00eb$var$Mt("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $455d545b1dff00eb$var$UT extends $455d545b1dff00eb$var$Tu {
    constructor(e, t){
        super(e, t), this.isLineLoop = !0, this.type = "LineLoop";
    }
}
class $455d545b1dff00eb$var$Yb extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
    }
}
const $455d545b1dff00eb$var$gM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$J_ = new $455d545b1dff00eb$var$Kf, $455d545b1dff00eb$var$yx = new $455d545b1dff00eb$var$Ta, $455d545b1dff00eb$var$_x = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$NT extends $455d545b1dff00eb$var$Pn {
    constructor(e = new $455d545b1dff00eb$var$nn, t = new $455d545b1dff00eb$var$Yb){
        super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(e, t) {
        return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
    }
    raycast(e, t) {
        const n = this.geometry, i = this.matrixWorld, r = e.params.Points.threshold, l = n.drawRange;
        if (n.boundingSphere === null && n.computeBoundingSphere(), $455d545b1dff00eb$var$yx.copy(n.boundingSphere), $455d545b1dff00eb$var$yx.applyMatrix4(i), $455d545b1dff00eb$var$yx.radius += r, e.ray.intersectsSphere($455d545b1dff00eb$var$yx) === !1) return;
        $455d545b1dff00eb$var$gM.copy(i).invert(), $455d545b1dff00eb$var$J_.copy(e.ray).applyMatrix4($455d545b1dff00eb$var$gM);
        const c = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), f = c * c, p = n.index, x = n.attributes.position;
        if (p !== null) {
            const v = Math.max(0, l.start), _ = Math.min(p.count, l.start + l.count);
            for(let S = v, A = _; S < A; S++){
                const M = p.getX(S);
                $455d545b1dff00eb$var$_x.fromBufferAttribute(x, M), $455d545b1dff00eb$var$xM($455d545b1dff00eb$var$_x, M, f, i, e, t, this);
            }
        } else {
            const v = Math.max(0, l.start), _ = Math.min(x.count, l.start + l.count);
            for(let S = v, A = _; S < A; S++)$455d545b1dff00eb$var$_x.fromBufferAttribute(x, S), $455d545b1dff00eb$var$xM($455d545b1dff00eb$var$_x, S, f, i, e, t, this);
        }
    }
    updateMorphTargets() {
        const t = this.geometry.morphAttributes, n = Object.keys(t);
        if (n.length > 0) {
            const i = t[n[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let r = 0, l = i.length; r < l; r++){
                    const c = i[r].name || String(r);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = r;
                }
            }
        }
    }
}
function $455d545b1dff00eb$var$xM(a, e, t, n, i, r, l) {
    const c = $455d545b1dff00eb$var$J_.distanceSqToPoint(a);
    if (c < t) {
        const f = new $455d545b1dff00eb$var$J;
        $455d545b1dff00eb$var$J_.closestPointToPoint(a, f), f.applyMatrix4(n);
        const p = i.ray.origin.distanceTo(f);
        if (p < i.near || p > i.far) return;
        r.push({
            distance: p,
            distanceToRay: Math.sqrt(c),
            point: f,
            index: e,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: l
        });
    }
}
class $455d545b1dff00eb$var$OT extends $455d545b1dff00eb$var$Li {
    constructor(e, t, n, i, r = $455d545b1dff00eb$var$mi, l = $455d545b1dff00eb$var$mi, c, f, p){
        super(e, t, n, i, r, l, c, f, p), this.isVideoTexture = !0, this.generateMipmaps = !1, this._requestVideoFrameCallbackId = 0;
        const m = this;
        function x() {
            m.needsUpdate = !0, m._requestVideoFrameCallbackId = e.requestVideoFrameCallback(x);
        }
        "requestVideoFrameCallback" in e && (this._requestVideoFrameCallbackId = e.requestVideoFrameCallback(x));
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const e = this.image;
        "requestVideoFrameCallback" in e === !1 && e.readyState >= e.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
    dispose() {
        this._requestVideoFrameCallbackId !== 0 && (this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId), this._requestVideoFrameCallbackId = 0), super.dispose();
    }
}
class $455d545b1dff00eb$var$HU extends $455d545b1dff00eb$var$OT {
    constructor(e, t, n, i, r, l, c, f){
        super({}, e, t, n, i, r, l, c, f), this.isVideoFrameTexture = !0;
    }
    update() {}
    clone() {
        return new this.constructor().copy(this);
    }
    setFrame(e) {
        this.image = e, this.needsUpdate = !0;
    }
}
class $455d545b1dff00eb$var$VU extends $455d545b1dff00eb$var$Li {
    constructor(e, t){
        super({
            width: e,
            height: t
        }), this.isFramebufferTexture = !0, this.magFilter = $455d545b1dff00eb$var$Fa, this.minFilter = $455d545b1dff00eb$var$Fa, this.generateMipmaps = !1, this.needsUpdate = !0;
    }
}
class $455d545b1dff00eb$var$vy extends $455d545b1dff00eb$var$Li {
    constructor(e, t, n, i, r, l, c, f, p, m, x, v){
        super(null, l, c, f, p, m, i, r, x, v), this.isCompressedTexture = !0, this.image = {
            width: t,
            height: n
        }, this.mipmaps = e, this.flipY = !1, this.generateMipmaps = !1;
    }
}
class $455d545b1dff00eb$var$GU extends $455d545b1dff00eb$var$vy {
    constructor(e, t, n, i, r, l){
        super(e, t, n, r, l), this.isCompressedArrayTexture = !0, this.image.depth = i, this.wrapR = $455d545b1dff00eb$var$Kr, this.layerUpdates = new Set;
    }
    addLayerUpdate(e) {
        this.layerUpdates.add(e);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $455d545b1dff00eb$var$kU extends $455d545b1dff00eb$var$vy {
    constructor(e, t, n){
        super(void 0, e[0].width, e[0].height, t, n, $455d545b1dff00eb$var$Sc), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = e;
    }
}
class $455d545b1dff00eb$var$jU extends $455d545b1dff00eb$var$Li {
    constructor(e, t, n, i, r, l, c, f, p){
        super(e, t, n, i, r, l, c, f, p), this.isCanvasTexture = !0, this.needsUpdate = !0;
    }
}
class $455d545b1dff00eb$var$yy extends $455d545b1dff00eb$var$Li {
    constructor(e, t, n = $455d545b1dff00eb$var$Mc, i, r, l, c = $455d545b1dff00eb$var$Fa, f = $455d545b1dff00eb$var$Fa, p, m = $455d545b1dff00eb$var$zd, x = 1){
        if (m !== $455d545b1dff00eb$var$zd && m !== $455d545b1dff00eb$var$Pd) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        const v = {
            width: e,
            height: t,
            depth: x
        };
        super(v, i, r, l, c, f, m, n, p), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
    }
    copy(e) {
        return super.copy(e), this.source = new $455d545b1dff00eb$var$_u(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
    }
}
class $455d545b1dff00eb$var$Zb extends $455d545b1dff00eb$var$Li {
    constructor(e = null){
        super(), this.sourceTexture = e, this.isExternalTexture = !0;
    }
    copy(e) {
        return super.copy(e), this.sourceTexture = e.sourceTexture, this;
    }
}
class $455d545b1dff00eb$var$_y extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 1, n = 4, i = 8, r = 1){
        super(), this.type = "CapsuleGeometry", this.parameters = {
            radius: e,
            height: t,
            capSegments: n,
            radialSegments: i,
            heightSegments: r
        }, t = Math.max(0, t), n = Math.max(1, Math.floor(n)), i = Math.max(3, Math.floor(i)), r = Math.max(1, Math.floor(r));
        const l = [], c = [], f = [], p = [], m = t / 2, x = Math.PI / 2 * e, v = t, _ = 2 * x + v, S = n * 2 + r, A = i + 1, M = new $455d545b1dff00eb$var$J, b = new $455d545b1dff00eb$var$J;
        for(let C = 0; C <= S; C++){
            let R = 0, N = 0, z = 0, L = 0;
            if (C <= n) {
                const O = C / n, D = O * Math.PI / 2;
                N = -m - e * Math.cos(D), z = e * Math.sin(D), L = -e * Math.cos(D), R = O * x;
            } else if (C <= n + r) {
                const O = (C - n) / r;
                N = -m + O * t, z = e, L = 0, R = x + O * v;
            } else {
                const O = (C - n - r) / n, D = O * Math.PI / 2;
                N = m + e * Math.sin(D), z = e * Math.cos(D), L = e * Math.sin(D), R = x + v + O * x;
            }
            const P = Math.max(0, Math.min(1, R / _));
            let H = 0;
            C === 0 ? H = .5 / i : C === S && (H = -0.5 / i);
            for(let O = 0; O <= i; O++){
                const D = O / i, j = D * Math.PI * 2, G = Math.sin(j), q = Math.cos(j);
                b.x = -z * q, b.y = N, b.z = z * G, c.push(b.x, b.y, b.z), M.set(-z * q, L, z * G), M.normalize(), f.push(M.x, M.y, M.z), p.push(D + H, P);
            }
            if (C > 0) {
                const O = (C - 1) * A;
                for(let D = 0; D < i; D++){
                    const j = O + D, G = O + D + 1, q = C * A + D, Y = C * A + D + 1;
                    l.push(j, G, q), l.push(G, Y, q);
                }
            }
        }
        this.setIndex(l), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(c, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(f, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(p, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$_y(e.radius, e.height, e.capSegments, e.radialSegments, e.heightSegments);
    }
}
class $455d545b1dff00eb$var$by extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 32, n = 0, i = Math.PI * 2){
        super(), this.type = "CircleGeometry", this.parameters = {
            radius: e,
            segments: t,
            thetaStart: n,
            thetaLength: i
        }, t = Math.max(3, t);
        const r = [], l = [], c = [], f = [], p = new $455d545b1dff00eb$var$J, m = new $455d545b1dff00eb$var$$e;
        l.push(0, 0, 0), c.push(0, 0, 1), f.push(.5, .5);
        for(let x = 0, v = 3; x <= t; x++, v += 3){
            const _ = n + x / t * i;
            p.x = e * Math.cos(_), p.y = e * Math.sin(_), l.push(p.x, p.y, p.z), c.push(0, 0, 1), m.x = (l[v] / e + 1) / 2, m.y = (l[v + 1] / e + 1) / 2, f.push(m.x, m.y);
        }
        for(let x = 1; x <= t; x++)r.push(x, x + 1, 0);
        this.setIndex(r), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(l, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(c, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(f, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$by(e.radius, e.segments, e.thetaStart, e.thetaLength);
    }
}
class $455d545b1dff00eb$var$T0 extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 1, n = 1, i = 32, r = 1, l = !1, c = 0, f = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: e,
            radiusBottom: t,
            height: n,
            radialSegments: i,
            heightSegments: r,
            openEnded: l,
            thetaStart: c,
            thetaLength: f
        };
        const p = this;
        i = Math.floor(i), r = Math.floor(r);
        const m = [], x = [], v = [], _ = [];
        let S = 0;
        const A = [], M = n / 2;
        let b = 0;
        C(), l === !1 && (e > 0 && R(!0), t > 0 && R(!1)), this.setIndex(m), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(x, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(v, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(_, 2));
        function C() {
            const N = new $455d545b1dff00eb$var$J, z = new $455d545b1dff00eb$var$J;
            let L = 0;
            const P = (t - e) / n;
            for(let H = 0; H <= r; H++){
                const O = [], D = H / r, j = D * (t - e) + e;
                for(let G = 0; G <= i; G++){
                    const q = G / i, Y = q * f + c, ae = Math.sin(Y), F = Math.cos(Y);
                    z.x = j * ae, z.y = -D * n + M, z.z = j * F, x.push(z.x, z.y, z.z), N.set(ae, P, F).normalize(), v.push(N.x, N.y, N.z), _.push(q, 1 - D), O.push(S++);
                }
                A.push(O);
            }
            for(let H = 0; H < i; H++)for(let O = 0; O < r; O++){
                const D = A[O][H], j = A[O + 1][H], G = A[O + 1][H + 1], q = A[O][H + 1];
                (e > 0 || O !== 0) && (m.push(D, j, q), L += 3), (t > 0 || O !== r - 1) && (m.push(j, G, q), L += 3);
            }
            p.addGroup(b, L, 0), b += L;
        }
        function R(N) {
            const z = S, L = new $455d545b1dff00eb$var$$e, P = new $455d545b1dff00eb$var$J;
            let H = 0;
            const O = N === !0 ? e : t, D = N === !0 ? 1 : -1;
            for(let G = 1; G <= i; G++)x.push(0, M * D, 0), v.push(0, D, 0), _.push(.5, .5), S++;
            const j = S;
            for(let G = 0; G <= i; G++){
                const Y = G / i * f + c, ae = Math.cos(Y), F = Math.sin(Y);
                P.x = O * F, P.y = M * D, P.z = O * ae, x.push(P.x, P.y, P.z), v.push(0, D, 0), L.x = ae * .5 + .5, L.y = F * .5 * D + .5, _.push(L.x, L.y), S++;
            }
            for(let G = 0; G < i; G++){
                const q = z + G, Y = j + G;
                N === !0 ? m.push(Y, Y + 1, q) : m.push(Y + 1, Y, q), H += 3;
            }
            p.addGroup(b, H, N === !0 ? 1 : 2), b += H;
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$T0(e.radiusTop, e.radiusBottom, e.height, e.radialSegments, e.heightSegments, e.openEnded, e.thetaStart, e.thetaLength);
    }
}
class $455d545b1dff00eb$var$A0 extends $455d545b1dff00eb$var$T0 {
    constructor(e = 1, t = 1, n = 32, i = 1, r = !1, l = 0, c = Math.PI * 2){
        super(0, e, t, n, i, r, l, c), this.type = "ConeGeometry", this.parameters = {
            radius: e,
            height: t,
            radialSegments: n,
            heightSegments: i,
            openEnded: r,
            thetaStart: l,
            thetaLength: c
        };
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$A0(e.radius, e.height, e.radialSegments, e.heightSegments, e.openEnded, e.thetaStart, e.thetaLength);
    }
}
class $455d545b1dff00eb$var$Du extends $455d545b1dff00eb$var$nn {
    constructor(e = [], t = [], n = 1, i = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: e,
            indices: t,
            radius: n,
            detail: i
        };
        const r = [], l = [];
        c(i), p(n), m(), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(r, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(r.slice(), 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(l, 2)), i === 0 ? this.computeVertexNormals() : this.normalizeNormals();
        function c(C) {
            const R = new $455d545b1dff00eb$var$J, N = new $455d545b1dff00eb$var$J, z = new $455d545b1dff00eb$var$J;
            for(let L = 0; L < t.length; L += 3)_(t[L + 0], R), _(t[L + 1], N), _(t[L + 2], z), f(R, N, z, C);
        }
        function f(C, R, N, z) {
            const L = z + 1, P = [];
            for(let H = 0; H <= L; H++){
                P[H] = [];
                const O = C.clone().lerp(N, H / L), D = R.clone().lerp(N, H / L), j = L - H;
                for(let G = 0; G <= j; G++)G === 0 && H === L ? P[H][G] = O : P[H][G] = O.clone().lerp(D, G / j);
            }
            for(let H = 0; H < L; H++)for(let O = 0; O < 2 * (L - H) - 1; O++){
                const D = Math.floor(O / 2);
                O % 2 === 0 ? (v(P[H][D + 1]), v(P[H + 1][D]), v(P[H][D])) : (v(P[H][D + 1]), v(P[H + 1][D + 1]), v(P[H + 1][D]));
            }
        }
        function p(C) {
            const R = new $455d545b1dff00eb$var$J;
            for(let N = 0; N < r.length; N += 3)R.x = r[N + 0], R.y = r[N + 1], R.z = r[N + 2], R.normalize().multiplyScalar(C), r[N + 0] = R.x, r[N + 1] = R.y, r[N + 2] = R.z;
        }
        function m() {
            const C = new $455d545b1dff00eb$var$J;
            for(let R = 0; R < r.length; R += 3){
                C.x = r[R + 0], C.y = r[R + 1], C.z = r[R + 2];
                const N = M(C) / 2 / Math.PI + .5, z = b(C) / Math.PI + .5;
                l.push(N, 1 - z);
            }
            S(), x();
        }
        function x() {
            for(let C = 0; C < l.length; C += 6){
                const R = l[C + 0], N = l[C + 2], z = l[C + 4], L = Math.max(R, N, z), P = Math.min(R, N, z);
                L > .9 && P < .1 && (R < .2 && (l[C + 0] += 1), N < .2 && (l[C + 2] += 1), z < .2 && (l[C + 4] += 1));
            }
        }
        function v(C) {
            r.push(C.x, C.y, C.z);
        }
        function _(C, R) {
            const N = C * 3;
            R.x = e[N + 0], R.y = e[N + 1], R.z = e[N + 2];
        }
        function S() {
            const C = new $455d545b1dff00eb$var$J, R = new $455d545b1dff00eb$var$J, N = new $455d545b1dff00eb$var$J, z = new $455d545b1dff00eb$var$J, L = new $455d545b1dff00eb$var$$e, P = new $455d545b1dff00eb$var$$e, H = new $455d545b1dff00eb$var$$e;
            for(let O = 0, D = 0; O < r.length; O += 9, D += 6){
                C.set(r[O + 0], r[O + 1], r[O + 2]), R.set(r[O + 3], r[O + 4], r[O + 5]), N.set(r[O + 6], r[O + 7], r[O + 8]), L.set(l[D + 0], l[D + 1]), P.set(l[D + 2], l[D + 3]), H.set(l[D + 4], l[D + 5]), z.copy(C).add(R).add(N).divideScalar(3);
                const j = M(z);
                A(L, D + 0, C, j), A(P, D + 2, R, j), A(H, D + 4, N, j);
            }
        }
        function A(C, R, N, z) {
            z < 0 && C.x === 1 && (l[R] = C.x - 1), N.x === 0 && N.z === 0 && (l[R] = z / 2 / Math.PI + .5);
        }
        function M(C) {
            return Math.atan2(C.z, -C.x);
        }
        function b(C) {
            return Math.atan2(-C.y, Math.sqrt(C.x * C.x + C.z * C.z));
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Du(e.vertices, e.indices, e.radius, e.details);
    }
}
class $455d545b1dff00eb$var$Sy extends $455d545b1dff00eb$var$Du {
    constructor(e = 1, t = 0){
        const n = (1 + Math.sqrt(5)) / 2, i = 1 / n, r = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            0,
            -n,
            0,
            -i,
            n,
            0,
            -i,
            -n,
            0,
            i,
            n,
            0,
            i
        ], l = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(r, l, e, t), this.type = "DodecahedronGeometry", this.parameters = {
            radius: e,
            detail: t
        };
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Sy(e.radius, e.detail);
    }
}
const $455d545b1dff00eb$var$bx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Sx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$i_ = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Mx = new $455d545b1dff00eb$var$Qr;
class $455d545b1dff00eb$var$LT extends $455d545b1dff00eb$var$nn {
    constructor(e = null, t = 1){
        if (super(), this.type = "EdgesGeometry", this.parameters = {
            geometry: e,
            thresholdAngle: t
        }, e !== null) {
            const i = Math.pow(10, 4), r = Math.cos($455d545b1dff00eb$var$Hf * t), l = e.getIndex(), c = e.getAttribute("position"), f = l ? l.count : c.count, p = [
                0,
                0,
                0
            ], m = [
                "a",
                "b",
                "c"
            ], x = new Array(3), v = {}, _ = [];
            for(let S = 0; S < f; S += 3){
                l ? (p[0] = l.getX(S), p[1] = l.getX(S + 1), p[2] = l.getX(S + 2)) : (p[0] = S, p[1] = S + 1, p[2] = S + 2);
                const { a: A, b: M, c: b } = $455d545b1dff00eb$var$Mx;
                if (A.fromBufferAttribute(c, p[0]), M.fromBufferAttribute(c, p[1]), b.fromBufferAttribute(c, p[2]), $455d545b1dff00eb$var$Mx.getNormal($455d545b1dff00eb$var$i_), x[0] = `${Math.round(A.x * i)},${Math.round(A.y * i)},${Math.round(A.z * i)}`, x[1] = `${Math.round(M.x * i)},${Math.round(M.y * i)},${Math.round(M.z * i)}`, x[2] = `${Math.round(b.x * i)},${Math.round(b.y * i)},${Math.round(b.z * i)}`, !(x[0] === x[1] || x[1] === x[2] || x[2] === x[0])) for(let C = 0; C < 3; C++){
                    const R = (C + 1) % 3, N = x[C], z = x[R], L = $455d545b1dff00eb$var$Mx[m[C]], P = $455d545b1dff00eb$var$Mx[m[R]], H = `${N}_${z}`, O = `${z}_${N}`;
                    O in v && v[O] ? ($455d545b1dff00eb$var$i_.dot(v[O].normal) <= r && (_.push(L.x, L.y, L.z), _.push(P.x, P.y, P.z)), v[O] = null) : H in v || (v[H] = {
                        index0: p[C],
                        index1: p[R],
                        normal: $455d545b1dff00eb$var$i_.clone()
                    });
                }
            }
            for(const S in v)if (v[S]) {
                const { index0: A, index1: M } = v[S];
                $455d545b1dff00eb$var$bx.fromBufferAttribute(c, A), $455d545b1dff00eb$var$Sx.fromBufferAttribute(c, M), _.push($455d545b1dff00eb$var$bx.x, $455d545b1dff00eb$var$bx.y, $455d545b1dff00eb$var$bx.z), _.push($455d545b1dff00eb$var$Sx.x, $455d545b1dff00eb$var$Sx.y, $455d545b1dff00eb$var$Sx.z);
            }
            this.setAttribute("position", new $455d545b1dff00eb$var$Dt(_, 3));
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
}
class $455d545b1dff00eb$var$Lo {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200, this.needsUpdate = !1, this.cacheArcLengths = null;
    }
    getPoint() {
        $455d545b1dff00eb$var$Mt("Curve: .getPoint() not implemented.");
    }
    getPointAt(e, t) {
        const n = this.getUtoTmapping(e);
        return this.getPoint(n, t);
    }
    getPoints(e = 5) {
        const t = [];
        for(let n = 0; n <= e; n++)t.push(this.getPoint(n / e));
        return t;
    }
    getSpacedPoints(e = 5) {
        const t = [];
        for(let n = 0; n <= e; n++)t.push(this.getPointAt(n / e));
        return t;
    }
    getLength() {
        const e = this.getLengths();
        return e[e.length - 1];
    }
    getLengths(e = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        const t = [];
        let n, i = this.getPoint(0), r = 0;
        t.push(0);
        for(let l = 1; l <= e; l++)n = this.getPoint(l / e), r += n.distanceTo(i), t.push(r), i = n;
        return this.cacheArcLengths = t, t;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(e, t = null) {
        const n = this.getLengths();
        let i = 0;
        const r = n.length;
        let l;
        t ? l = t : l = e * n[r - 1];
        let c = 0, f = r - 1, p;
        for(; c <= f;)if (i = Math.floor(c + (f - c) / 2), p = n[i] - l, p < 0) c = i + 1;
        else if (p > 0) f = i - 1;
        else {
            f = i;
            break;
        }
        if (i = f, n[i] === l) return i / (r - 1);
        const m = n[i], v = n[i + 1] - m, _ = (l - m) / v;
        return (i + _) / (r - 1);
    }
    getTangent(e, t) {
        let i = e - 1e-4, r = e + 1e-4;
        i < 0 && (i = 0), r > 1 && (r = 1);
        const l = this.getPoint(i), c = this.getPoint(r), f = t || (l.isVector2 ? new $455d545b1dff00eb$var$$e : new $455d545b1dff00eb$var$J);
        return f.copy(c).sub(l).normalize(), f;
    }
    getTangentAt(e, t) {
        const n = this.getUtoTmapping(e);
        return this.getTangent(n, t);
    }
    computeFrenetFrames(e, t = !1) {
        const n = new $455d545b1dff00eb$var$J, i = [], r = [], l = [], c = new $455d545b1dff00eb$var$J, f = new $455d545b1dff00eb$var$Ft;
        for(let _ = 0; _ <= e; _++){
            const S = _ / e;
            i[_] = this.getTangentAt(S, new $455d545b1dff00eb$var$J);
        }
        r[0] = new $455d545b1dff00eb$var$J, l[0] = new $455d545b1dff00eb$var$J;
        let p = Number.MAX_VALUE;
        const m = Math.abs(i[0].x), x = Math.abs(i[0].y), v = Math.abs(i[0].z);
        m <= p && (p = m, n.set(1, 0, 0)), x <= p && (p = x, n.set(0, 1, 0)), v <= p && n.set(0, 0, 1), c.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], c), l[0].crossVectors(i[0], r[0]);
        for(let _ = 1; _ <= e; _++){
            if (r[_] = r[_ - 1].clone(), l[_] = l[_ - 1].clone(), c.crossVectors(i[_ - 1], i[_]), c.length() > Number.EPSILON) {
                c.normalize();
                const S = Math.acos($455d545b1dff00eb$var$Yt(i[_ - 1].dot(i[_]), -1, 1));
                r[_].applyMatrix4(f.makeRotationAxis(c, S));
            }
            l[_].crossVectors(i[_], r[_]);
        }
        if (t === !0) {
            let _ = Math.acos($455d545b1dff00eb$var$Yt(r[0].dot(r[e]), -1, 1));
            _ /= e, i[0].dot(c.crossVectors(r[0], r[e])) > 0 && (_ = -_);
            for(let S = 1; S <= e; S++)r[S].applyMatrix4(f.makeRotationAxis(i[S], _ * S)), l[S].crossVectors(i[S], r[S]);
        }
        return {
            tangents: i,
            normals: r,
            binormals: l
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        return this.arcLengthDivisions = e.arcLengthDivisions, this;
    }
    toJSON() {
        const e = {
            metadata: {
                version: 4.7,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return e.arcLengthDivisions = this.arcLengthDivisions, e.type = this.type, e;
    }
    fromJSON(e) {
        return this.arcLengthDivisions = e.arcLengthDivisions, this;
    }
}
class $455d545b1dff00eb$var$My extends $455d545b1dff00eb$var$Lo {
    constructor(e = 0, t = 0, n = 1, i = 1, r = 0, l = Math.PI * 2, c = !1, f = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e, this.aY = t, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = l, this.aClockwise = c, this.aRotation = f;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$$e) {
        const n = t, i = Math.PI * 2;
        let r = this.aEndAngle - this.aStartAngle;
        const l = Math.abs(r) < Number.EPSILON;
        for(; r < 0;)r += i;
        for(; r > i;)r -= i;
        r < Number.EPSILON && (l ? r = 0 : r = i), this.aClockwise === !0 && !l && (r === i ? r = -i : r = r - i);
        const c = this.aStartAngle + e * r;
        let f = this.aX + this.xRadius * Math.cos(c), p = this.aY + this.yRadius * Math.sin(c);
        if (this.aRotation !== 0) {
            const m = Math.cos(this.aRotation), x = Math.sin(this.aRotation), v = f - this.aX, _ = p - this.aY;
            f = v * m - _ * x + this.aX, p = v * x + _ * m + this.aY;
        }
        return n.set(f, p);
    }
    copy(e) {
        return super.copy(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.aX = this.aX, e.aY = this.aY, e.xRadius = this.xRadius, e.yRadius = this.yRadius, e.aStartAngle = this.aStartAngle, e.aEndAngle = this.aEndAngle, e.aClockwise = this.aClockwise, e.aRotation = this.aRotation, e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
    }
}
class $455d545b1dff00eb$var$zT extends $455d545b1dff00eb$var$My {
    constructor(e, t, n, i, r, l){
        super(e, t, n, n, i, r, l), this.isArcCurve = !0, this.type = "ArcCurve";
    }
}
function $455d545b1dff00eb$var$Qb() {
    let a = 0, e = 0, t = 0, n = 0;
    function i(r, l, c, f) {
        a = r, e = c, t = -3 * r + 3 * l - 2 * c - f, n = 2 * r - 2 * l + c + f;
    }
    return {
        initCatmullRom: function(r, l, c, f, p) {
            i(l, c, p * (c - r), p * (f - l));
        },
        initNonuniformCatmullRom: function(r, l, c, f, p, m, x) {
            let v = (l - r) / p - (c - r) / (p + m) + (c - l) / m, _ = (c - l) / m - (f - l) / (m + x) + (f - c) / x;
            v *= m, _ *= m, i(l, c, v, _);
        },
        calc: function(r) {
            const l = r * r, c = l * r;
            return a + e * r + t * l + n * c;
        }
    };
}
const $455d545b1dff00eb$var$Ex = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$a_ = new $455d545b1dff00eb$var$Qb, $455d545b1dff00eb$var$r_ = new $455d545b1dff00eb$var$Qb, $455d545b1dff00eb$var$s_ = new $455d545b1dff00eb$var$Qb;
class $455d545b1dff00eb$var$PT extends $455d545b1dff00eb$var$Lo {
    constructor(e = [], t = !1, n = "centripetal", i = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = e, this.closed = t, this.curveType = n, this.tension = i;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$J) {
        const n = t, i = this.points, r = i.length, l = (r - (this.closed ? 0 : 1)) * e;
        let c = Math.floor(l), f = l - c;
        this.closed ? c += c > 0 ? 0 : (Math.floor(Math.abs(c) / r) + 1) * r : f === 0 && c === r - 1 && (c = r - 2, f = 1);
        let p, m;
        this.closed || c > 0 ? p = i[(c - 1) % r] : ($455d545b1dff00eb$var$Ex.subVectors(i[0], i[1]).add(i[0]), p = $455d545b1dff00eb$var$Ex);
        const x = i[c % r], v = i[(c + 1) % r];
        if (this.closed || c + 2 < r ? m = i[(c + 2) % r] : ($455d545b1dff00eb$var$Ex.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), m = $455d545b1dff00eb$var$Ex), this.curveType === "centripetal" || this.curveType === "chordal") {
            const _ = this.curveType === "chordal" ? .5 : .25;
            let S = Math.pow(p.distanceToSquared(x), _), A = Math.pow(x.distanceToSquared(v), _), M = Math.pow(v.distanceToSquared(m), _);
            A < 1e-4 && (A = 1), S < 1e-4 && (S = A), M < 1e-4 && (M = A), $455d545b1dff00eb$var$a_.initNonuniformCatmullRom(p.x, x.x, v.x, m.x, S, A, M), $455d545b1dff00eb$var$r_.initNonuniformCatmullRom(p.y, x.y, v.y, m.y, S, A, M), $455d545b1dff00eb$var$s_.initNonuniformCatmullRom(p.z, x.z, v.z, m.z, S, A, M);
        } else this.curveType === "catmullrom" && ($455d545b1dff00eb$var$a_.initCatmullRom(p.x, x.x, v.x, m.x, this.tension), $455d545b1dff00eb$var$r_.initCatmullRom(p.y, x.y, v.y, m.y, this.tension), $455d545b1dff00eb$var$s_.initCatmullRom(p.z, x.z, v.z, m.z, this.tension));
        return n.set($455d545b1dff00eb$var$a_.calc(f), $455d545b1dff00eb$var$r_.calc(f), $455d545b1dff00eb$var$s_.calc(f)), n;
    }
    copy(e) {
        super.copy(e), this.points = [];
        for(let t = 0, n = e.points.length; t < n; t++){
            const i = e.points[t];
            this.points.push(i.clone());
        }
        return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
    }
    toJSON() {
        const e = super.toJSON();
        e.points = [];
        for(let t = 0, n = this.points.length; t < n; t++){
            const i = this.points[t];
            e.points.push(i.toArray());
        }
        return e.closed = this.closed, e.curveType = this.curveType, e.tension = this.tension, e;
    }
    fromJSON(e) {
        super.fromJSON(e), this.points = [];
        for(let t = 0, n = e.points.length; t < n; t++){
            const i = e.points[t];
            this.points.push(new $455d545b1dff00eb$var$J().fromArray(i));
        }
        return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
    }
}
function $455d545b1dff00eb$var$vM(a, e, t, n, i) {
    const r = (n - e) * .5, l = (i - t) * .5, c = a * a, f = a * c;
    return (2 * t - 2 * n + r + l) * f + (-3 * t + 3 * n - 2 * r - l) * c + r * a + t;
}
function $455d545b1dff00eb$var$XU(a, e) {
    const t = 1 - a;
    return t * t * e;
}
function $455d545b1dff00eb$var$WU(a, e) {
    return 2 * (1 - a) * a * e;
}
function $455d545b1dff00eb$var$qU(a, e) {
    return a * a * e;
}
function $455d545b1dff00eb$var$Xm(a, e, t, n) {
    return $455d545b1dff00eb$var$XU(a, e) + $455d545b1dff00eb$var$WU(a, t) + $455d545b1dff00eb$var$qU(a, n);
}
function $455d545b1dff00eb$var$YU(a, e) {
    const t = 1 - a;
    return t * t * t * e;
}
function $455d545b1dff00eb$var$ZU(a, e) {
    const t = 1 - a;
    return 3 * t * t * a * e;
}
function $455d545b1dff00eb$var$QU(a, e) {
    return 3 * (1 - a) * a * a * e;
}
function $455d545b1dff00eb$var$KU(a, e) {
    return a * a * a * e;
}
function $455d545b1dff00eb$var$Wm(a, e, t, n, i) {
    return $455d545b1dff00eb$var$YU(a, e) + $455d545b1dff00eb$var$ZU(a, t) + $455d545b1dff00eb$var$QU(a, n) + $455d545b1dff00eb$var$KU(a, i);
}
class $455d545b1dff00eb$var$Kb extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$$e, t = new $455d545b1dff00eb$var$$e, n = new $455d545b1dff00eb$var$$e, i = new $455d545b1dff00eb$var$$e){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = e, this.v1 = t, this.v2 = n, this.v3 = i;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$$e) {
        const n = t, i = this.v0, r = this.v1, l = this.v2, c = this.v3;
        return n.set($455d545b1dff00eb$var$Wm(e, i.x, r.x, l.x, c.x), $455d545b1dff00eb$var$Wm(e, i.y, r.y, l.y, c.y)), n;
    }
    copy(e) {
        return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
    }
}
class $455d545b1dff00eb$var$BT extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J, n = new $455d545b1dff00eb$var$J, i = new $455d545b1dff00eb$var$J){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = e, this.v1 = t, this.v2 = n, this.v3 = i;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$J) {
        const n = t, i = this.v0, r = this.v1, l = this.v2, c = this.v3;
        return n.set($455d545b1dff00eb$var$Wm(e, i.x, r.x, l.x, c.x), $455d545b1dff00eb$var$Wm(e, i.y, r.y, l.y, c.y), $455d545b1dff00eb$var$Wm(e, i.z, r.z, l.z, c.z)), n;
    }
    copy(e) {
        return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
    }
}
class $455d545b1dff00eb$var$Jb extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$$e, t = new $455d545b1dff00eb$var$$e){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = e, this.v2 = t;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$$e) {
        const n = t;
        return e === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
    }
    getPointAt(e, t) {
        return this.getPoint(e, t);
    }
    getTangent(e, t = new $455d545b1dff00eb$var$$e) {
        return t.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(e, t) {
        return this.getTangent(e, t);
    }
    copy(e) {
        return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
    }
}
class $455d545b1dff00eb$var$IT extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = e, this.v2 = t;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$J) {
        const n = t;
        return e === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
    }
    getPointAt(e, t) {
        return this.getPoint(e, t);
    }
    getTangent(e, t = new $455d545b1dff00eb$var$J) {
        return t.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(e, t) {
        return this.getTangent(e, t);
    }
    copy(e) {
        return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
    }
}
class $455d545b1dff00eb$var$$b extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$$e, t = new $455d545b1dff00eb$var$$e, n = new $455d545b1dff00eb$var$$e){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = e, this.v1 = t, this.v2 = n;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$$e) {
        const n = t, i = this.v0, r = this.v1, l = this.v2;
        return n.set($455d545b1dff00eb$var$Xm(e, i.x, r.x, l.x), $455d545b1dff00eb$var$Xm(e, i.y, r.y, l.y)), n;
    }
    copy(e) {
        return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
    }
}
class $455d545b1dff00eb$var$eS extends $455d545b1dff00eb$var$Lo {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J, n = new $455d545b1dff00eb$var$J){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = e, this.v1 = t, this.v2 = n;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$J) {
        const n = t, i = this.v0, r = this.v1, l = this.v2;
        return n.set($455d545b1dff00eb$var$Xm(e, i.x, r.x, l.x), $455d545b1dff00eb$var$Xm(e, i.y, r.y, l.y), $455d545b1dff00eb$var$Xm(e, i.z, r.z, l.z)), n;
    }
    copy(e) {
        return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
    }
}
class $455d545b1dff00eb$var$tS extends $455d545b1dff00eb$var$Lo {
    constructor(e = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = e;
    }
    getPoint(e, t = new $455d545b1dff00eb$var$$e) {
        const n = t, i = this.points, r = (i.length - 1) * e, l = Math.floor(r), c = r - l, f = i[l === 0 ? l : l - 1], p = i[l], m = i[l > i.length - 2 ? i.length - 1 : l + 1], x = i[l > i.length - 3 ? i.length - 1 : l + 2];
        return n.set($455d545b1dff00eb$var$vM(c, f.x, p.x, m.x, x.x), $455d545b1dff00eb$var$vM(c, f.y, p.y, m.y, x.y)), n;
    }
    copy(e) {
        super.copy(e), this.points = [];
        for(let t = 0, n = e.points.length; t < n; t++){
            const i = e.points[t];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        const e = super.toJSON();
        e.points = [];
        for(let t = 0, n = this.points.length; t < n; t++){
            const i = this.points[t];
            e.points.push(i.toArray());
        }
        return e;
    }
    fromJSON(e) {
        super.fromJSON(e), this.points = [];
        for(let t = 0, n = e.points.length; t < n; t++){
            const i = e.points[t];
            this.points.push(new $455d545b1dff00eb$var$$e().fromArray(i));
        }
        return this;
    }
}
var $455d545b1dff00eb$var$Vv = Object.freeze({
    __proto__: null,
    ArcCurve: $455d545b1dff00eb$var$zT,
    CatmullRomCurve3: $455d545b1dff00eb$var$PT,
    CubicBezierCurve: $455d545b1dff00eb$var$Kb,
    CubicBezierCurve3: $455d545b1dff00eb$var$BT,
    EllipseCurve: $455d545b1dff00eb$var$My,
    LineCurve: $455d545b1dff00eb$var$Jb,
    LineCurve3: $455d545b1dff00eb$var$IT,
    QuadraticBezierCurve: $455d545b1dff00eb$var$$b,
    QuadraticBezierCurve3: $455d545b1dff00eb$var$eS,
    SplineCurve: $455d545b1dff00eb$var$tS
});
class $455d545b1dff00eb$var$FT extends $455d545b1dff00eb$var$Lo {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(e) {
        this.curves.push(e);
    }
    closePath() {
        const e = this.curves[0].getPoint(0), t = this.curves[this.curves.length - 1].getPoint(1);
        if (!e.equals(t)) {
            const n = e.isVector2 === !0 ? "LineCurve" : "LineCurve3";
            this.curves.push(new $455d545b1dff00eb$var$Vv[n](t, e));
        }
        return this;
    }
    getPoint(e, t) {
        const n = e * this.getLength(), i = this.getCurveLengths();
        let r = 0;
        for(; r < i.length;){
            if (i[r] >= n) {
                const l = i[r] - n, c = this.curves[r], f = c.getLength(), p = f === 0 ? 0 : 1 - l / f;
                return c.getPointAt(p, t);
            }
            r++;
        }
        return null;
    }
    getLength() {
        const e = this.getCurveLengths();
        return e[e.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        const e = [];
        let t = 0;
        for(let n = 0, i = this.curves.length; n < i; n++)t += this.curves[n].getLength(), e.push(t);
        return this.cacheLengths = e, e;
    }
    getSpacedPoints(e = 40) {
        const t = [];
        for(let n = 0; n <= e; n++)t.push(this.getPoint(n / e));
        return this.autoClose && t.push(t[0]), t;
    }
    getPoints(e = 12) {
        const t = [];
        let n;
        for(let i = 0, r = this.curves; i < r.length; i++){
            const l = r[i], c = l.isEllipseCurve ? e * 2 : l.isLineCurve || l.isLineCurve3 ? 1 : l.isSplineCurve ? e * l.points.length : e, f = l.getPoints(c);
            for(let p = 0; p < f.length; p++){
                const m = f[p];
                n && n.equals(m) || (t.push(m), n = m);
            }
        }
        return this.autoClose && t.length > 1 && !t[t.length - 1].equals(t[0]) && t.push(t[0]), t;
    }
    copy(e) {
        super.copy(e), this.curves = [];
        for(let t = 0, n = e.curves.length; t < n; t++){
            const i = e.curves[t];
            this.curves.push(i.clone());
        }
        return this.autoClose = e.autoClose, this;
    }
    toJSON() {
        const e = super.toJSON();
        e.autoClose = this.autoClose, e.curves = [];
        for(let t = 0, n = this.curves.length; t < n; t++){
            const i = this.curves[t];
            e.curves.push(i.toJSON());
        }
        return e;
    }
    fromJSON(e) {
        super.fromJSON(e), this.autoClose = e.autoClose, this.curves = [];
        for(let t = 0, n = e.curves.length; t < n; t++){
            const i = e.curves[t];
            this.curves.push(new $455d545b1dff00eb$var$Vv[i.type]().fromJSON(i));
        }
        return this;
    }
}
class $455d545b1dff00eb$var$Gv extends $455d545b1dff00eb$var$FT {
    constructor(e){
        super(), this.type = "Path", this.currentPoint = new $455d545b1dff00eb$var$$e, e && this.setFromPoints(e);
    }
    setFromPoints(e) {
        this.moveTo(e[0].x, e[0].y);
        for(let t = 1, n = e.length; t < n; t++)this.lineTo(e[t].x, e[t].y);
        return this;
    }
    moveTo(e, t) {
        return this.currentPoint.set(e, t), this;
    }
    lineTo(e, t) {
        const n = new $455d545b1dff00eb$var$Jb(this.currentPoint.clone(), new $455d545b1dff00eb$var$$e(e, t));
        return this.curves.push(n), this.currentPoint.set(e, t), this;
    }
    quadraticCurveTo(e, t, n, i) {
        const r = new $455d545b1dff00eb$var$$b(this.currentPoint.clone(), new $455d545b1dff00eb$var$$e(e, t), new $455d545b1dff00eb$var$$e(n, i));
        return this.curves.push(r), this.currentPoint.set(n, i), this;
    }
    bezierCurveTo(e, t, n, i, r, l) {
        const c = new $455d545b1dff00eb$var$Kb(this.currentPoint.clone(), new $455d545b1dff00eb$var$$e(e, t), new $455d545b1dff00eb$var$$e(n, i), new $455d545b1dff00eb$var$$e(r, l));
        return this.curves.push(c), this.currentPoint.set(r, l), this;
    }
    splineThru(e) {
        const t = [
            this.currentPoint.clone()
        ].concat(e), n = new $455d545b1dff00eb$var$tS(t);
        return this.curves.push(n), this.currentPoint.copy(e[e.length - 1]), this;
    }
    arc(e, t, n, i, r, l) {
        const c = this.currentPoint.x, f = this.currentPoint.y;
        return this.absarc(e + c, t + f, n, i, r, l), this;
    }
    absarc(e, t, n, i, r, l) {
        return this.absellipse(e, t, n, n, i, r, l), this;
    }
    ellipse(e, t, n, i, r, l, c, f) {
        const p = this.currentPoint.x, m = this.currentPoint.y;
        return this.absellipse(e + p, t + m, n, i, r, l, c, f), this;
    }
    absellipse(e, t, n, i, r, l, c, f) {
        const p = new $455d545b1dff00eb$var$My(e, t, n, i, r, l, c, f);
        if (this.curves.length > 0) {
            const x = p.getPoint(0);
            x.equals(this.currentPoint) || this.lineTo(x.x, x.y);
        }
        this.curves.push(p);
        const m = p.getPoint(1);
        return this.currentPoint.copy(m), this;
    }
    copy(e) {
        return super.copy(e), this.currentPoint.copy(e.currentPoint), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.currentPoint = this.currentPoint.toArray(), e;
    }
    fromJSON(e) {
        return super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this;
    }
}
class $455d545b1dff00eb$var$Vf extends $455d545b1dff00eb$var$Gv {
    constructor(e){
        super(e), this.uuid = $455d545b1dff00eb$var$bs(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(e) {
        const t = [];
        for(let n = 0, i = this.holes.length; n < i; n++)t[n] = this.holes[n].getPoints(e);
        return t;
    }
    extractPoints(e) {
        return {
            shape: this.getPoints(e),
            holes: this.getPointsHoles(e)
        };
    }
    copy(e) {
        super.copy(e), this.holes = [];
        for(let t = 0, n = e.holes.length; t < n; t++){
            const i = e.holes[t];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        const e = super.toJSON();
        e.uuid = this.uuid, e.holes = [];
        for(let t = 0, n = this.holes.length; t < n; t++){
            const i = this.holes[t];
            e.holes.push(i.toJSON());
        }
        return e;
    }
    fromJSON(e) {
        super.fromJSON(e), this.uuid = e.uuid, this.holes = [];
        for(let t = 0, n = e.holes.length; t < n; t++){
            const i = e.holes[t];
            this.holes.push(new $455d545b1dff00eb$var$Gv().fromJSON(i));
        }
        return this;
    }
}
function $455d545b1dff00eb$var$JU(a, e, t = 2) {
    const n = e && e.length, i = n ? e[0] * t : a.length;
    let r = $455d545b1dff00eb$var$HT(a, 0, i, t, !0);
    const l = [];
    if (!r || r.next === r.prev) return l;
    let c, f, p;
    if (n && (r = $455d545b1dff00eb$var$iN(a, e, r, t)), a.length > 80 * t) {
        c = a[0], f = a[1];
        let m = c, x = f;
        for(let v = t; v < i; v += t){
            const _ = a[v], S = a[v + 1];
            _ < c && (c = _), S < f && (f = S), _ > m && (m = _), S > x && (x = S);
        }
        p = Math.max(m - c, x - f), p = p !== 0 ? 32767 / p : 0;
    }
    return $455d545b1dff00eb$var$l0(r, l, t, c, f, p, 0), l;
}
function $455d545b1dff00eb$var$HT(a, e, t, n, i) {
    let r;
    if (i === $455d545b1dff00eb$var$pN(a, e, t, n) > 0) for(let l = e; l < t; l += n)r = $455d545b1dff00eb$var$yM(l / n | 0, a[l], a[l + 1], r);
    else for(let l = t - n; l >= e; l -= n)r = $455d545b1dff00eb$var$yM(l / n | 0, a[l], a[l + 1], r);
    return r && $455d545b1dff00eb$var$Gd(r, r.next) && ($455d545b1dff00eb$var$u0(r), r = r.next), r;
}
function $455d545b1dff00eb$var$qf(a, e) {
    if (!a) return a;
    e || (e = a);
    let t = a, n;
    do if (n = !1, !t.steiner && ($455d545b1dff00eb$var$Gd(t, t.next) || $455d545b1dff00eb$var$Ni(t.prev, t, t.next) === 0)) {
        if ($455d545b1dff00eb$var$u0(t), t = e = t.prev, t === t.next) break;
        n = !0;
    } else t = t.next;
    while (n || t !== e);
    return e;
}
function $455d545b1dff00eb$var$l0(a, e, t, n, i, r, l) {
    if (!a) return;
    !l && r && $455d545b1dff00eb$var$lN(a, n, i, r);
    let c = a;
    for(; a.prev !== a.next;){
        const f = a.prev, p = a.next;
        if (r ? $455d545b1dff00eb$var$eN(a, n, i, r) : $455d545b1dff00eb$var$$U(a)) {
            e.push(f.i, a.i, p.i), $455d545b1dff00eb$var$u0(a), a = p.next, c = p.next;
            continue;
        }
        if (a = p, a === c) {
            l ? l === 1 ? (a = $455d545b1dff00eb$var$tN($455d545b1dff00eb$var$qf(a), e), $455d545b1dff00eb$var$l0(a, e, t, n, i, r, 2)) : l === 2 && $455d545b1dff00eb$var$nN(a, e, t, n, i, r) : $455d545b1dff00eb$var$l0($455d545b1dff00eb$var$qf(a), e, t, n, i, r, 1);
            break;
        }
    }
}
function $455d545b1dff00eb$var$$U(a) {
    const e = a.prev, t = a, n = a.next;
    if ($455d545b1dff00eb$var$Ni(e, t, n) >= 0) return !1;
    const i = e.x, r = t.x, l = n.x, c = e.y, f = t.y, p = n.y, m = Math.min(i, r, l), x = Math.min(c, f, p), v = Math.max(i, r, l), _ = Math.max(c, f, p);
    let S = n.next;
    for(; S !== e;){
        if (S.x >= m && S.x <= v && S.y >= x && S.y <= _ && $455d545b1dff00eb$var$zm(i, c, r, f, l, p, S.x, S.y) && $455d545b1dff00eb$var$Ni(S.prev, S, S.next) >= 0) return !1;
        S = S.next;
    }
    return !0;
}
function $455d545b1dff00eb$var$eN(a, e, t, n) {
    const i = a.prev, r = a, l = a.next;
    if ($455d545b1dff00eb$var$Ni(i, r, l) >= 0) return !1;
    const c = i.x, f = r.x, p = l.x, m = i.y, x = r.y, v = l.y, _ = Math.min(c, f, p), S = Math.min(m, x, v), A = Math.max(c, f, p), M = Math.max(m, x, v), b = $455d545b1dff00eb$var$$_(_, S, e, t, n), C = $455d545b1dff00eb$var$$_(A, M, e, t, n);
    let R = a.prevZ, N = a.nextZ;
    for(; R && R.z >= b && N && N.z <= C;){
        if (R.x >= _ && R.x <= A && R.y >= S && R.y <= M && R !== i && R !== l && $455d545b1dff00eb$var$zm(c, m, f, x, p, v, R.x, R.y) && $455d545b1dff00eb$var$Ni(R.prev, R, R.next) >= 0 || (R = R.prevZ, N.x >= _ && N.x <= A && N.y >= S && N.y <= M && N !== i && N !== l && $455d545b1dff00eb$var$zm(c, m, f, x, p, v, N.x, N.y) && $455d545b1dff00eb$var$Ni(N.prev, N, N.next) >= 0)) return !1;
        N = N.nextZ;
    }
    for(; R && R.z >= b;){
        if (R.x >= _ && R.x <= A && R.y >= S && R.y <= M && R !== i && R !== l && $455d545b1dff00eb$var$zm(c, m, f, x, p, v, R.x, R.y) && $455d545b1dff00eb$var$Ni(R.prev, R, R.next) >= 0) return !1;
        R = R.prevZ;
    }
    for(; N && N.z <= C;){
        if (N.x >= _ && N.x <= A && N.y >= S && N.y <= M && N !== i && N !== l && $455d545b1dff00eb$var$zm(c, m, f, x, p, v, N.x, N.y) && $455d545b1dff00eb$var$Ni(N.prev, N, N.next) >= 0) return !1;
        N = N.nextZ;
    }
    return !0;
}
function $455d545b1dff00eb$var$tN(a, e) {
    let t = a;
    do {
        const n = t.prev, i = t.next.next;
        !$455d545b1dff00eb$var$Gd(n, i) && $455d545b1dff00eb$var$GT(n, t, t.next, i) && $455d545b1dff00eb$var$c0(n, i) && $455d545b1dff00eb$var$c0(i, n) && (e.push(n.i, t.i, i.i), $455d545b1dff00eb$var$u0(t), $455d545b1dff00eb$var$u0(t.next), t = a = i), t = t.next;
    }while (t !== a);
    return $455d545b1dff00eb$var$qf(t);
}
function $455d545b1dff00eb$var$nN(a, e, t, n, i, r) {
    let l = a;
    do {
        let c = l.next.next;
        for(; c !== l.prev;){
            if (l.i !== c.i && $455d545b1dff00eb$var$fN(l, c)) {
                let f = $455d545b1dff00eb$var$kT(l, c);
                l = $455d545b1dff00eb$var$qf(l, l.next), f = $455d545b1dff00eb$var$qf(f, f.next), $455d545b1dff00eb$var$l0(l, e, t, n, i, r, 0), $455d545b1dff00eb$var$l0(f, e, t, n, i, r, 0);
                return;
            }
            c = c.next;
        }
        l = l.next;
    }while (l !== a);
}
function $455d545b1dff00eb$var$iN(a, e, t, n) {
    const i = [];
    for(let r = 0, l = e.length; r < l; r++){
        const c = e[r] * n, f = r < l - 1 ? e[r + 1] * n : a.length, p = $455d545b1dff00eb$var$HT(a, c, f, n, !1);
        p === p.next && (p.steiner = !0), i.push($455d545b1dff00eb$var$uN(p));
    }
    i.sort($455d545b1dff00eb$var$aN);
    for(let r = 0; r < i.length; r++)t = $455d545b1dff00eb$var$rN(i[r], t);
    return t;
}
function $455d545b1dff00eb$var$aN(a, e) {
    let t = a.x - e.x;
    if (t === 0 && (t = a.y - e.y, t === 0)) {
        const n = (a.next.y - a.y) / (a.next.x - a.x), i = (e.next.y - e.y) / (e.next.x - e.x);
        t = n - i;
    }
    return t;
}
function $455d545b1dff00eb$var$rN(a, e) {
    const t = $455d545b1dff00eb$var$sN(a, e);
    if (!t) return e;
    const n = $455d545b1dff00eb$var$kT(t, a);
    return $455d545b1dff00eb$var$qf(n, n.next), $455d545b1dff00eb$var$qf(t, t.next);
}
function $455d545b1dff00eb$var$sN(a, e) {
    let t = e;
    const n = a.x, i = a.y;
    let r = -1 / 0, l;
    if ($455d545b1dff00eb$var$Gd(a, t)) return t;
    do {
        if ($455d545b1dff00eb$var$Gd(a, t.next)) return t.next;
        if (i <= t.y && i >= t.next.y && t.next.y !== t.y) {
            const x = t.x + (i - t.y) * (t.next.x - t.x) / (t.next.y - t.y);
            if (x <= n && x > r && (r = x, l = t.x < t.next.x ? t : t.next, x === n)) return l;
        }
        t = t.next;
    }while (t !== e);
    if (!l) return null;
    const c = l, f = l.x, p = l.y;
    let m = 1 / 0;
    t = l;
    do {
        if (n >= t.x && t.x >= f && n !== t.x && $455d545b1dff00eb$var$VT(i < p ? n : r, i, f, p, i < p ? r : n, i, t.x, t.y)) {
            const x = Math.abs(i - t.y) / (n - t.x);
            $455d545b1dff00eb$var$c0(t, a) && (x < m || x === m && (t.x > l.x || t.x === l.x && $455d545b1dff00eb$var$oN(l, t))) && (l = t, m = x);
        }
        t = t.next;
    }while (t !== c);
    return l;
}
function $455d545b1dff00eb$var$oN(a, e) {
    return $455d545b1dff00eb$var$Ni(a.prev, a, e.prev) < 0 && $455d545b1dff00eb$var$Ni(e.next, a, a.next) < 0;
}
function $455d545b1dff00eb$var$lN(a, e, t, n) {
    let i = a;
    do i.z === 0 && (i.z = $455d545b1dff00eb$var$$_(i.x, i.y, e, t, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
    while (i !== a);
    i.prevZ.nextZ = null, i.prevZ = null, $455d545b1dff00eb$var$cN(i);
}
function $455d545b1dff00eb$var$cN(a) {
    let e, t = 1;
    do {
        let n = a, i;
        a = null;
        let r = null;
        for(e = 0; n;){
            e++;
            let l = n, c = 0;
            for(let p = 0; p < t && (c++, l = l.nextZ, !!l); p++);
            let f = t;
            for(; c > 0 || f > 0 && l;)c !== 0 && (f === 0 || !l || n.z <= l.z) ? (i = n, n = n.nextZ, c--) : (i = l, l = l.nextZ, f--), r ? r.nextZ = i : a = i, i.prevZ = r, r = i;
            n = l;
        }
        r.nextZ = null, t *= 2;
    }while (e > 1);
    return a;
}
function $455d545b1dff00eb$var$$_(a, e, t, n, i) {
    return a = (a - t) * i | 0, e = (e - n) * i | 0, a = (a | a << 8) & 16711935, a = (a | a << 4) & 252645135, a = (a | a << 2) & 858993459, a = (a | a << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, a | e << 1;
}
function $455d545b1dff00eb$var$uN(a) {
    let e = a, t = a;
    do (e.x < t.x || e.x === t.x && e.y < t.y) && (t = e), e = e.next;
    while (e !== a);
    return t;
}
function $455d545b1dff00eb$var$VT(a, e, t, n, i, r, l, c) {
    return (i - l) * (e - c) >= (a - l) * (r - c) && (a - l) * (n - c) >= (t - l) * (e - c) && (t - l) * (r - c) >= (i - l) * (n - c);
}
function $455d545b1dff00eb$var$zm(a, e, t, n, i, r, l, c) {
    return !(a === l && e === c) && $455d545b1dff00eb$var$VT(a, e, t, n, i, r, l, c);
}
function $455d545b1dff00eb$var$fN(a, e) {
    return a.next.i !== e.i && a.prev.i !== e.i && !$455d545b1dff00eb$var$hN(a, e) && ($455d545b1dff00eb$var$c0(a, e) && $455d545b1dff00eb$var$c0(e, a) && $455d545b1dff00eb$var$dN(a, e) && ($455d545b1dff00eb$var$Ni(a.prev, a, e.prev) || $455d545b1dff00eb$var$Ni(a, e.prev, e)) || $455d545b1dff00eb$var$Gd(a, e) && $455d545b1dff00eb$var$Ni(a.prev, a, a.next) > 0 && $455d545b1dff00eb$var$Ni(e.prev, e, e.next) > 0);
}
function $455d545b1dff00eb$var$Ni(a, e, t) {
    return (e.y - a.y) * (t.x - e.x) - (e.x - a.x) * (t.y - e.y);
}
function $455d545b1dff00eb$var$Gd(a, e) {
    return a.x === e.x && a.y === e.y;
}
function $455d545b1dff00eb$var$GT(a, e, t, n) {
    const i = $455d545b1dff00eb$var$Ax($455d545b1dff00eb$var$Ni(a, e, t)), r = $455d545b1dff00eb$var$Ax($455d545b1dff00eb$var$Ni(a, e, n)), l = $455d545b1dff00eb$var$Ax($455d545b1dff00eb$var$Ni(t, n, a)), c = $455d545b1dff00eb$var$Ax($455d545b1dff00eb$var$Ni(t, n, e));
    return !!(i !== r && l !== c || i === 0 && $455d545b1dff00eb$var$Tx(a, t, e) || r === 0 && $455d545b1dff00eb$var$Tx(a, n, e) || l === 0 && $455d545b1dff00eb$var$Tx(t, a, n) || c === 0 && $455d545b1dff00eb$var$Tx(t, e, n));
}
function $455d545b1dff00eb$var$Tx(a, e, t) {
    return e.x <= Math.max(a.x, t.x) && e.x >= Math.min(a.x, t.x) && e.y <= Math.max(a.y, t.y) && e.y >= Math.min(a.y, t.y);
}
function $455d545b1dff00eb$var$Ax(a) {
    return a > 0 ? 1 : a < 0 ? -1 : 0;
}
function $455d545b1dff00eb$var$hN(a, e) {
    let t = a;
    do {
        if (t.i !== a.i && t.next.i !== a.i && t.i !== e.i && t.next.i !== e.i && $455d545b1dff00eb$var$GT(t, t.next, a, e)) return !0;
        t = t.next;
    }while (t !== a);
    return !1;
}
function $455d545b1dff00eb$var$c0(a, e) {
    return $455d545b1dff00eb$var$Ni(a.prev, a, a.next) < 0 ? $455d545b1dff00eb$var$Ni(a, e, a.next) >= 0 && $455d545b1dff00eb$var$Ni(a, a.prev, e) >= 0 : $455d545b1dff00eb$var$Ni(a, e, a.prev) < 0 || $455d545b1dff00eb$var$Ni(a, a.next, e) < 0;
}
function $455d545b1dff00eb$var$dN(a, e) {
    let t = a, n = !1;
    const i = (a.x + e.x) / 2, r = (a.y + e.y) / 2;
    do t.y > r != t.next.y > r && t.next.y !== t.y && i < (t.next.x - t.x) * (r - t.y) / (t.next.y - t.y) + t.x && (n = !n), t = t.next;
    while (t !== a);
    return n;
}
function $455d545b1dff00eb$var$kT(a, e) {
    const t = $455d545b1dff00eb$var$eb(a.i, a.x, a.y), n = $455d545b1dff00eb$var$eb(e.i, e.x, e.y), i = a.next, r = e.prev;
    return a.next = e, e.prev = a, t.next = i, i.prev = t, n.next = t, t.prev = n, r.next = n, n.prev = r, n;
}
function $455d545b1dff00eb$var$yM(a, e, t, n) {
    const i = $455d545b1dff00eb$var$eb(a, e, t);
    return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
}
function $455d545b1dff00eb$var$u0(a) {
    a.next.prev = a.prev, a.prev.next = a.next, a.prevZ && (a.prevZ.nextZ = a.nextZ), a.nextZ && (a.nextZ.prevZ = a.prevZ);
}
function $455d545b1dff00eb$var$eb(a, e, t) {
    return {
        i: a,
        x: e,
        y: t,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}
function $455d545b1dff00eb$var$pN(a, e, t, n) {
    let i = 0;
    for(let r = e, l = t - n; r < t; r += n)i += (a[l] - a[r]) * (a[r + 1] + a[l + 1]), l = r;
    return i;
}
class $455d545b1dff00eb$var$mN {
    static triangulate(e, t, n = 2) {
        return $455d545b1dff00eb$var$JU(e, t, n);
    }
}
class $455d545b1dff00eb$var$Co {
    static area(e) {
        const t = e.length;
        let n = 0;
        for(let i = t - 1, r = 0; r < t; i = r++)n += e[i].x * e[r].y - e[r].x * e[i].y;
        return n * .5;
    }
    static isClockWise(e) {
        return $455d545b1dff00eb$var$Co.area(e) < 0;
    }
    static triangulateShape(e, t) {
        const n = [], i = [], r = [];
        $455d545b1dff00eb$var$_M(e), $455d545b1dff00eb$var$bM(n, e);
        let l = e.length;
        t.forEach($455d545b1dff00eb$var$_M);
        for(let f = 0; f < t.length; f++)i.push(l), l += t[f].length, $455d545b1dff00eb$var$bM(n, t[f]);
        const c = $455d545b1dff00eb$var$mN.triangulate(n, i);
        for(let f = 0; f < c.length; f += 3)r.push(c.slice(f, f + 3));
        return r;
    }
}
function $455d545b1dff00eb$var$_M(a) {
    const e = a.length;
    e > 2 && a[e - 1].equals(a[0]) && a.pop();
}
function $455d545b1dff00eb$var$bM(a, e) {
    for(let t = 0; t < e.length; t++)a.push(e[t].x), a.push(e[t].y);
}
class $455d545b1dff00eb$var$Ey extends $455d545b1dff00eb$var$nn {
    constructor(e = new $455d545b1dff00eb$var$Vf([
        new $455d545b1dff00eb$var$$e(.5, .5),
        new $455d545b1dff00eb$var$$e(-0.5, .5),
        new $455d545b1dff00eb$var$$e(-0.5, -0.5),
        new $455d545b1dff00eb$var$$e(.5, -0.5)
    ]), t = {}){
        super(), this.type = "ExtrudeGeometry", this.parameters = {
            shapes: e,
            options: t
        }, e = Array.isArray(e) ? e : [
            e
        ];
        const n = this, i = [], r = [];
        for(let c = 0, f = e.length; c < f; c++){
            const p = e[c];
            l(p);
        }
        this.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(r, 2)), this.computeVertexNormals();
        function l(c) {
            const f = [], p = t.curveSegments !== void 0 ? t.curveSegments : 12, m = t.steps !== void 0 ? t.steps : 1, x = t.depth !== void 0 ? t.depth : 1;
            let v = t.bevelEnabled !== void 0 ? t.bevelEnabled : !0, _ = t.bevelThickness !== void 0 ? t.bevelThickness : .2, S = t.bevelSize !== void 0 ? t.bevelSize : _ - .1, A = t.bevelOffset !== void 0 ? t.bevelOffset : 0, M = t.bevelSegments !== void 0 ? t.bevelSegments : 3;
            const b = t.extrudePath, C = t.UVGenerator !== void 0 ? t.UVGenerator : $455d545b1dff00eb$var$gN;
            let R, N = !1, z, L, P, H;
            b && (R = b.getSpacedPoints(m), N = !0, v = !1, z = b.computeFrenetFrames(m, !1), L = new $455d545b1dff00eb$var$J, P = new $455d545b1dff00eb$var$J, H = new $455d545b1dff00eb$var$J), v || (M = 0, _ = 0, S = 0, A = 0);
            const O = c.extractPoints(p);
            let D = O.shape;
            const j = O.holes;
            if (!$455d545b1dff00eb$var$Co.isClockWise(D)) {
                D = D.reverse();
                for(let Re = 0, te = j.length; Re < te; Re++){
                    const Oe = j[Re];
                    $455d545b1dff00eb$var$Co.isClockWise(Oe) && (j[Re] = Oe.reverse());
                }
            }
            function q(Re) {
                const Oe = 10000000000000001e-36;
                let Ie = Re[0];
                for(let Ae = 1; Ae <= Re.length; Ae++){
                    const ze = Ae % Re.length, Ze = Re[ze], be = Ze.x - Ie.x, rt = Ze.y - Ie.y, ne = be * be + rt * rt, W = Math.max(Math.abs(Ze.x), Math.abs(Ze.y), Math.abs(Ie.x), Math.abs(Ie.y)), pe = Oe * W * W;
                    if (ne <= pe) {
                        Re.splice(ze, 1), Ae--;
                        continue;
                    }
                    Ie = Ze;
                }
            }
            q(D), j.forEach(q);
            const Y = j.length, ae = D;
            for(let Re = 0; Re < Y; Re++){
                const te = j[Re];
                D = D.concat(te);
            }
            function F(Re, te, Oe) {
                return te || $455d545b1dff00eb$var$Qt("ExtrudeGeometry: vec does not exist"), Re.clone().addScaledVector(te, Oe);
            }
            const Q = D.length;
            function K(Re, te, Oe) {
                let Ie, Ae, ze;
                const Ze = Re.x - te.x, be = Re.y - te.y, rt = Oe.x - Re.x, ne = Oe.y - Re.y, W = Ze * Ze + be * be, pe = Ze * ne - be * rt;
                if (Math.abs(pe) > Number.EPSILON) {
                    const Be = Math.sqrt(W), Te = Math.sqrt(rt * rt + ne * ne), _e = te.x - be / Be, ot = te.y + Ze / Be, tt = Oe.x - ne / Te, gt = Oe.y + rt / Te, pt = ((tt - _e) * ne - (gt - ot) * rt) / (Ze * ne - be * rt);
                    Ie = _e + Ze * pt - Re.x, Ae = ot + be * pt - Re.y;
                    const Ge = Ie * Ie + Ae * Ae;
                    if (Ge <= 2) return new $455d545b1dff00eb$var$$e(Ie, Ae);
                    ze = Math.sqrt(Ge / 2);
                } else {
                    let Be = !1;
                    Ze > Number.EPSILON ? rt > Number.EPSILON && (Be = !0) : Ze < -Number.EPSILON ? rt < -Number.EPSILON && (Be = !0) : Math.sign(be) === Math.sign(ne) && (Be = !0), Be ? (Ie = -be, Ae = Ze, ze = Math.sqrt(W)) : (Ie = Ze, Ae = be, ze = Math.sqrt(W / 2));
                }
                return new $455d545b1dff00eb$var$$e(Ie / ze, Ae / ze);
            }
            const $ = [];
            for(let Re = 0, te = ae.length, Oe = te - 1, Ie = Re + 1; Re < te; Re++, Oe++, Ie++)Oe === te && (Oe = 0), Ie === te && (Ie = 0), $[Re] = K(ae[Re], ae[Oe], ae[Ie]);
            const ee = [];
            let I, Z = $.concat();
            for(let Re = 0, te = Y; Re < te; Re++){
                const Oe = j[Re];
                I = [];
                for(let Ie = 0, Ae = Oe.length, ze = Ae - 1, Ze = Ie + 1; Ie < Ae; Ie++, ze++, Ze++)ze === Ae && (ze = 0), Ze === Ae && (Ze = 0), I[Ie] = K(Oe[Ie], Oe[ze], Oe[Ze]);
                ee.push(I), Z = Z.concat(I);
            }
            let oe;
            if (M === 0) oe = $455d545b1dff00eb$var$Co.triangulateShape(ae, j);
            else {
                const Re = [], te = [];
                for(let Oe = 0; Oe < M; Oe++){
                    const Ie = Oe / M, Ae = _ * Math.cos(Ie * Math.PI / 2), ze = S * Math.sin(Ie * Math.PI / 2) + A;
                    for(let Ze = 0, be = ae.length; Ze < be; Ze++){
                        const rt = F(ae[Ze], $[Ze], ze);
                        Le(rt.x, rt.y, -Ae), Ie === 0 && Re.push(rt);
                    }
                    for(let Ze = 0, be = Y; Ze < be; Ze++){
                        const rt = j[Ze];
                        I = ee[Ze];
                        const ne = [];
                        for(let W = 0, pe = rt.length; W < pe; W++){
                            const Be = F(rt[W], I[W], ze);
                            Le(Be.x, Be.y, -Ae), Ie === 0 && ne.push(Be);
                        }
                        Ie === 0 && te.push(ne);
                    }
                }
                oe = $455d545b1dff00eb$var$Co.triangulateShape(Re, te);
            }
            const ce = oe.length, de = S + A;
            for(let Re = 0; Re < Q; Re++){
                const te = v ? F(D[Re], Z[Re], de) : D[Re];
                N ? (P.copy(z.normals[0]).multiplyScalar(te.x), L.copy(z.binormals[0]).multiplyScalar(te.y), H.copy(R[0]).add(P).add(L), Le(H.x, H.y, H.z)) : Le(te.x, te.y, 0);
            }
            for(let Re = 1; Re <= m; Re++)for(let te = 0; te < Q; te++){
                const Oe = v ? F(D[te], Z[te], de) : D[te];
                N ? (P.copy(z.normals[Re]).multiplyScalar(Oe.x), L.copy(z.binormals[Re]).multiplyScalar(Oe.y), H.copy(R[Re]).add(P).add(L), Le(H.x, H.y, H.z)) : Le(Oe.x, Oe.y, x / m * Re);
            }
            for(let Re = M - 1; Re >= 0; Re--){
                const te = Re / M, Oe = _ * Math.cos(te * Math.PI / 2), Ie = S * Math.sin(te * Math.PI / 2) + A;
                for(let Ae = 0, ze = ae.length; Ae < ze; Ae++){
                    const Ze = F(ae[Ae], $[Ae], Ie);
                    Le(Ze.x, Ze.y, x + Oe);
                }
                for(let Ae = 0, ze = j.length; Ae < ze; Ae++){
                    const Ze = j[Ae];
                    I = ee[Ae];
                    for(let be = 0, rt = Ze.length; be < rt; be++){
                        const ne = F(Ze[be], I[be], Ie);
                        N ? Le(ne.x, ne.y + R[m - 1].y, R[m - 1].x + Oe) : Le(ne.x, ne.y, x + Oe);
                    }
                }
            }
            ue(), le();
            function ue() {
                const Re = i.length / 3;
                if (v) {
                    let te = 0, Oe = Q * te;
                    for(let Ie = 0; Ie < ce; Ie++){
                        const Ae = oe[Ie];
                        Ue(Ae[2] + Oe, Ae[1] + Oe, Ae[0] + Oe);
                    }
                    te = m + M * 2, Oe = Q * te;
                    for(let Ie = 0; Ie < ce; Ie++){
                        const Ae = oe[Ie];
                        Ue(Ae[0] + Oe, Ae[1] + Oe, Ae[2] + Oe);
                    }
                } else {
                    for(let te = 0; te < ce; te++){
                        const Oe = oe[te];
                        Ue(Oe[2], Oe[1], Oe[0]);
                    }
                    for(let te = 0; te < ce; te++){
                        const Oe = oe[te];
                        Ue(Oe[0] + Q * m, Oe[1] + Q * m, Oe[2] + Q * m);
                    }
                }
                n.addGroup(Re, i.length / 3 - Re, 0);
            }
            function le() {
                const Re = i.length / 3;
                let te = 0;
                xe(ae, te), te += ae.length;
                for(let Oe = 0, Ie = j.length; Oe < Ie; Oe++){
                    const Ae = j[Oe];
                    xe(Ae, te), te += Ae.length;
                }
                n.addGroup(Re, i.length / 3 - Re, 1);
            }
            function xe(Re, te) {
                let Oe = Re.length;
                for(; --Oe >= 0;){
                    const Ie = Oe;
                    let Ae = Oe - 1;
                    Ae < 0 && (Ae = Re.length - 1);
                    for(let ze = 0, Ze = m + M * 2; ze < Ze; ze++){
                        const be = Q * ze, rt = Q * (ze + 1), ne = te + Ie + be, W = te + Ae + be, pe = te + Ae + rt, Be = te + Ie + rt;
                        Ne(ne, W, pe, Be);
                    }
                }
            }
            function Le(Re, te, Oe) {
                f.push(Re), f.push(te), f.push(Oe);
            }
            function Ue(Re, te, Oe) {
                ke(Re), ke(te), ke(Oe);
                const Ie = i.length / 3, Ae = C.generateTopUV(n, i, Ie - 3, Ie - 2, Ie - 1);
                nt(Ae[0]), nt(Ae[1]), nt(Ae[2]);
            }
            function Ne(Re, te, Oe, Ie) {
                ke(Re), ke(te), ke(Ie), ke(te), ke(Oe), ke(Ie);
                const Ae = i.length / 3, ze = C.generateSideWallUV(n, i, Ae - 6, Ae - 3, Ae - 2, Ae - 1);
                nt(ze[0]), nt(ze[1]), nt(ze[3]), nt(ze[1]), nt(ze[2]), nt(ze[3]);
            }
            function ke(Re) {
                i.push(f[Re * 3 + 0]), i.push(f[Re * 3 + 1]), i.push(f[Re * 3 + 2]);
            }
            function nt(Re) {
                r.push(Re.x), r.push(Re.y);
            }
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    toJSON() {
        const e = super.toJSON(), t = this.parameters.shapes, n = this.parameters.options;
        return $455d545b1dff00eb$var$xN(t, n, e);
    }
    static fromJSON(e, t) {
        const n = [];
        for(let r = 0, l = e.shapes.length; r < l; r++){
            const c = t[e.shapes[r]];
            n.push(c);
        }
        const i = e.options.extrudePath;
        return i !== void 0 && (e.options.extrudePath = new $455d545b1dff00eb$var$Vv[i.type]().fromJSON(i)), new $455d545b1dff00eb$var$Ey(n, e.options);
    }
}
const $455d545b1dff00eb$var$gN = {
    generateTopUV: function(a, e, t, n, i) {
        const r = e[t * 3], l = e[t * 3 + 1], c = e[n * 3], f = e[n * 3 + 1], p = e[i * 3], m = e[i * 3 + 1];
        return [
            new $455d545b1dff00eb$var$$e(r, l),
            new $455d545b1dff00eb$var$$e(c, f),
            new $455d545b1dff00eb$var$$e(p, m)
        ];
    },
    generateSideWallUV: function(a, e, t, n, i, r) {
        const l = e[t * 3], c = e[t * 3 + 1], f = e[t * 3 + 2], p = e[n * 3], m = e[n * 3 + 1], x = e[n * 3 + 2], v = e[i * 3], _ = e[i * 3 + 1], S = e[i * 3 + 2], A = e[r * 3], M = e[r * 3 + 1], b = e[r * 3 + 2];
        return Math.abs(c - m) < Math.abs(l - p) ? [
            new $455d545b1dff00eb$var$$e(l, 1 - f),
            new $455d545b1dff00eb$var$$e(p, 1 - x),
            new $455d545b1dff00eb$var$$e(v, 1 - S),
            new $455d545b1dff00eb$var$$e(A, 1 - b)
        ] : [
            new $455d545b1dff00eb$var$$e(c, 1 - f),
            new $455d545b1dff00eb$var$$e(m, 1 - x),
            new $455d545b1dff00eb$var$$e(_, 1 - S),
            new $455d545b1dff00eb$var$$e(M, 1 - b)
        ];
    }
};
function $455d545b1dff00eb$var$xN(a, e, t) {
    if (t.shapes = [], Array.isArray(a)) for(let n = 0, i = a.length; n < i; n++){
        const r = a[n];
        t.shapes.push(r.uuid);
    }
    else t.shapes.push(a.uuid);
    return t.options = Object.assign({}, e), e.extrudePath !== void 0 && (t.options.extrudePath = e.extrudePath.toJSON()), t;
}
class $455d545b1dff00eb$var$Ty extends $455d545b1dff00eb$var$Du {
    constructor(e = 1, t = 0){
        const n = (1 + Math.sqrt(5)) / 2, i = [
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            0,
            0,
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            n,
            0,
            -1,
            n,
            0,
            1,
            -n,
            0,
            -1,
            -n,
            0,
            1
        ], r = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(i, r, e, t), this.type = "IcosahedronGeometry", this.parameters = {
            radius: e,
            detail: t
        };
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Ty(e.radius, e.detail);
    }
}
class $455d545b1dff00eb$var$Ay extends $455d545b1dff00eb$var$nn {
    constructor(e = [
        new $455d545b1dff00eb$var$$e(0, -0.5),
        new $455d545b1dff00eb$var$$e(.5, 0),
        new $455d545b1dff00eb$var$$e(0, .5)
    ], t = 12, n = 0, i = Math.PI * 2){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: e,
            segments: t,
            phiStart: n,
            phiLength: i
        }, t = Math.floor(t), i = $455d545b1dff00eb$var$Yt(i, 0, Math.PI * 2);
        const r = [], l = [], c = [], f = [], p = [], m = 1 / t, x = new $455d545b1dff00eb$var$J, v = new $455d545b1dff00eb$var$$e, _ = new $455d545b1dff00eb$var$J, S = new $455d545b1dff00eb$var$J, A = new $455d545b1dff00eb$var$J;
        let M = 0, b = 0;
        for(let C = 0; C <= e.length - 1; C++)switch(C){
            case 0:
                M = e[C + 1].x - e[C].x, b = e[C + 1].y - e[C].y, _.x = b * 1, _.y = -M, _.z = b * 0, A.copy(_), _.normalize(), f.push(_.x, _.y, _.z);
                break;
            case e.length - 1:
                f.push(A.x, A.y, A.z);
                break;
            default:
                M = e[C + 1].x - e[C].x, b = e[C + 1].y - e[C].y, _.x = b * 1, _.y = -M, _.z = b * 0, S.copy(_), _.x += A.x, _.y += A.y, _.z += A.z, _.normalize(), f.push(_.x, _.y, _.z), A.copy(S);
        }
        for(let C = 0; C <= t; C++){
            const R = n + C * m * i, N = Math.sin(R), z = Math.cos(R);
            for(let L = 0; L <= e.length - 1; L++){
                x.x = e[L].x * N, x.y = e[L].y, x.z = e[L].x * z, l.push(x.x, x.y, x.z), v.x = C / t, v.y = L / (e.length - 1), c.push(v.x, v.y);
                const P = f[3 * L + 0] * N, H = f[3 * L + 1], O = f[3 * L + 0] * z;
                p.push(P, H, O);
            }
        }
        for(let C = 0; C < t; C++)for(let R = 0; R < e.length - 1; R++){
            const N = R + C * e.length, z = N, L = N + e.length, P = N + e.length + 1, H = N + 1;
            r.push(z, L, H), r.push(P, H, L);
        }
        this.setIndex(r), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(l, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(c, 2)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(p, 3));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Ay(e.points, e.segments, e.phiStart, e.phiLength);
    }
}
class $455d545b1dff00eb$var$w0 extends $455d545b1dff00eb$var$Du {
    constructor(e = 1, t = 0){
        const n = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ], i = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(n, i, e, t), this.type = "OctahedronGeometry", this.parameters = {
            radius: e,
            detail: t
        };
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$w0(e.radius, e.detail);
    }
}
class $455d545b1dff00eb$var$Jr extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 1, n = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: e,
            height: t,
            widthSegments: n,
            heightSegments: i
        };
        const r = e / 2, l = t / 2, c = Math.floor(n), f = Math.floor(i), p = c + 1, m = f + 1, x = e / c, v = t / f, _ = [], S = [], A = [], M = [];
        for(let b = 0; b < m; b++){
            const C = b * v - l;
            for(let R = 0; R < p; R++){
                const N = R * x - r;
                S.push(N, -C, 0), A.push(0, 0, 1), M.push(R / c), M.push(1 - b / f);
            }
        }
        for(let b = 0; b < f; b++)for(let C = 0; C < c; C++){
            const R = C + p * b, N = C + p * (b + 1), z = C + 1 + p * (b + 1), L = C + 1 + p * b;
            _.push(R, N, L), _.push(N, z, L);
        }
        this.setIndex(_), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(S, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(A, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(M, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Jr(e.width, e.height, e.widthSegments, e.heightSegments);
    }
}
class $455d545b1dff00eb$var$wy extends $455d545b1dff00eb$var$nn {
    constructor(e = .5, t = 1, n = 32, i = 1, r = 0, l = Math.PI * 2){
        super(), this.type = "RingGeometry", this.parameters = {
            innerRadius: e,
            outerRadius: t,
            thetaSegments: n,
            phiSegments: i,
            thetaStart: r,
            thetaLength: l
        }, n = Math.max(3, n), i = Math.max(1, i);
        const c = [], f = [], p = [], m = [];
        let x = e;
        const v = (t - e) / i, _ = new $455d545b1dff00eb$var$J, S = new $455d545b1dff00eb$var$$e;
        for(let A = 0; A <= i; A++){
            for(let M = 0; M <= n; M++){
                const b = r + M / n * l;
                _.x = x * Math.cos(b), _.y = x * Math.sin(b), f.push(_.x, _.y, _.z), p.push(0, 0, 1), S.x = (_.x / t + 1) / 2, S.y = (_.y / t + 1) / 2, m.push(S.x, S.y);
            }
            x += v;
        }
        for(let A = 0; A < i; A++){
            const M = A * (n + 1);
            for(let b = 0; b < n; b++){
                const C = b + M, R = C, N = C + n + 1, z = C + n + 2, L = C + 1;
                c.push(R, N, L), c.push(N, z, L);
            }
        }
        this.setIndex(c), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(f, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(p, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(m, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$wy(e.innerRadius, e.outerRadius, e.thetaSegments, e.phiSegments, e.thetaStart, e.thetaLength);
    }
}
class $455d545b1dff00eb$var$Cy extends $455d545b1dff00eb$var$nn {
    constructor(e = new $455d545b1dff00eb$var$Vf([
        new $455d545b1dff00eb$var$$e(0, .5),
        new $455d545b1dff00eb$var$$e(-0.5, -0.5),
        new $455d545b1dff00eb$var$$e(.5, -0.5)
    ]), t = 12){
        super(), this.type = "ShapeGeometry", this.parameters = {
            shapes: e,
            curveSegments: t
        };
        const n = [], i = [], r = [], l = [];
        let c = 0, f = 0;
        if (Array.isArray(e) === !1) p(e);
        else for(let m = 0; m < e.length; m++)p(e[m]), this.addGroup(c, f, m), c += f, f = 0;
        this.setIndex(n), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(r, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(l, 2));
        function p(m) {
            const x = i.length / 3, v = m.extractPoints(t);
            let _ = v.shape;
            const S = v.holes;
            $455d545b1dff00eb$var$Co.isClockWise(_) === !1 && (_ = _.reverse());
            for(let M = 0, b = S.length; M < b; M++){
                const C = S[M];
                $455d545b1dff00eb$var$Co.isClockWise(C) === !0 && (S[M] = C.reverse());
            }
            const A = $455d545b1dff00eb$var$Co.triangulateShape(_, S);
            for(let M = 0, b = S.length; M < b; M++){
                const C = S[M];
                _ = _.concat(C);
            }
            for(let M = 0, b = _.length; M < b; M++){
                const C = _[M];
                i.push(C.x, C.y, 0), r.push(0, 0, 1), l.push(C.x, C.y);
            }
            for(let M = 0, b = A.length; M < b; M++){
                const C = A[M], R = C[0] + x, N = C[1] + x, z = C[2] + x;
                n.push(R, N, z), f += 3;
            }
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    toJSON() {
        const e = super.toJSON(), t = this.parameters.shapes;
        return $455d545b1dff00eb$var$vN(t, e);
    }
    static fromJSON(e, t) {
        const n = [];
        for(let i = 0, r = e.shapes.length; i < r; i++){
            const l = t[e.shapes[i]];
            n.push(l);
        }
        return new $455d545b1dff00eb$var$Cy(n, e.curveSegments);
    }
}
function $455d545b1dff00eb$var$vN(a, e) {
    if (e.shapes = [], Array.isArray(a)) for(let t = 0, n = a.length; t < n; t++){
        const i = a[t];
        e.shapes.push(i.uuid);
    }
    else e.shapes.push(a.uuid);
    return e;
}
class $455d545b1dff00eb$var$C0 extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = 32, n = 16, i = 0, r = Math.PI * 2, l = 0, c = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: e,
            widthSegments: t,
            heightSegments: n,
            phiStart: i,
            phiLength: r,
            thetaStart: l,
            thetaLength: c
        }, t = Math.max(3, Math.floor(t)), n = Math.max(2, Math.floor(n));
        const f = Math.min(l + c, Math.PI);
        let p = 0;
        const m = [], x = new $455d545b1dff00eb$var$J, v = new $455d545b1dff00eb$var$J, _ = [], S = [], A = [], M = [];
        for(let b = 0; b <= n; b++){
            const C = [], R = b / n;
            let N = 0;
            b === 0 && l === 0 ? N = .5 / t : b === n && f === Math.PI && (N = -0.5 / t);
            for(let z = 0; z <= t; z++){
                const L = z / t;
                x.x = -e * Math.cos(i + L * r) * Math.sin(l + R * c), x.y = e * Math.cos(l + R * c), x.z = e * Math.sin(i + L * r) * Math.sin(l + R * c), S.push(x.x, x.y, x.z), v.copy(x).normalize(), A.push(v.x, v.y, v.z), M.push(L + N, 1 - R), C.push(p++);
            }
            m.push(C);
        }
        for(let b = 0; b < n; b++)for(let C = 0; C < t; C++){
            const R = m[b][C + 1], N = m[b][C], z = m[b + 1][C], L = m[b + 1][C + 1];
            (b !== 0 || l > 0) && _.push(R, N, L), (b !== n - 1 || f < Math.PI) && _.push(N, z, L);
        }
        this.setIndex(_), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(S, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(A, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(M, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$C0(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
    }
}
class $455d545b1dff00eb$var$Ry extends $455d545b1dff00eb$var$Du {
    constructor(e = 1, t = 0){
        const n = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ], i = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(n, i, e, t), this.type = "TetrahedronGeometry", this.parameters = {
            radius: e,
            detail: t
        };
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Ry(e.radius, e.detail);
    }
}
class $455d545b1dff00eb$var$Dy extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = .4, n = 12, i = 48, r = Math.PI * 2){
        super(), this.type = "TorusGeometry", this.parameters = {
            radius: e,
            tube: t,
            radialSegments: n,
            tubularSegments: i,
            arc: r
        }, n = Math.floor(n), i = Math.floor(i);
        const l = [], c = [], f = [], p = [], m = new $455d545b1dff00eb$var$J, x = new $455d545b1dff00eb$var$J, v = new $455d545b1dff00eb$var$J;
        for(let _ = 0; _ <= n; _++)for(let S = 0; S <= i; S++){
            const A = S / i * r, M = _ / n * Math.PI * 2;
            x.x = (e + t * Math.cos(M)) * Math.cos(A), x.y = (e + t * Math.cos(M)) * Math.sin(A), x.z = t * Math.sin(M), c.push(x.x, x.y, x.z), m.x = e * Math.cos(A), m.y = e * Math.sin(A), v.subVectors(x, m).normalize(), f.push(v.x, v.y, v.z), p.push(S / i), p.push(_ / n);
        }
        for(let _ = 1; _ <= n; _++)for(let S = 1; S <= i; S++){
            const A = (i + 1) * _ + S - 1, M = (i + 1) * (_ - 1) + S - 1, b = (i + 1) * (_ - 1) + S, C = (i + 1) * _ + S;
            l.push(A, M, C), l.push(M, b, C);
        }
        this.setIndex(l), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(c, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(f, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(p, 2));
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Dy(e.radius, e.tube, e.radialSegments, e.tubularSegments, e.arc);
    }
}
class $455d545b1dff00eb$var$Uy extends $455d545b1dff00eb$var$nn {
    constructor(e = 1, t = .4, n = 64, i = 8, r = 2, l = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: e,
            tube: t,
            tubularSegments: n,
            radialSegments: i,
            p: r,
            q: l
        }, n = Math.floor(n), i = Math.floor(i);
        const c = [], f = [], p = [], m = [], x = new $455d545b1dff00eb$var$J, v = new $455d545b1dff00eb$var$J, _ = new $455d545b1dff00eb$var$J, S = new $455d545b1dff00eb$var$J, A = new $455d545b1dff00eb$var$J, M = new $455d545b1dff00eb$var$J, b = new $455d545b1dff00eb$var$J;
        for(let R = 0; R <= n; ++R){
            const N = R / n * r * Math.PI * 2;
            C(N, r, l, e, _), C(N + .01, r, l, e, S), M.subVectors(S, _), b.addVectors(S, _), A.crossVectors(M, b), b.crossVectors(A, M), A.normalize(), b.normalize();
            for(let z = 0; z <= i; ++z){
                const L = z / i * Math.PI * 2, P = -t * Math.cos(L), H = t * Math.sin(L);
                x.x = _.x + (P * b.x + H * A.x), x.y = _.y + (P * b.y + H * A.y), x.z = _.z + (P * b.z + H * A.z), f.push(x.x, x.y, x.z), v.subVectors(x, _).normalize(), p.push(v.x, v.y, v.z), m.push(R / n), m.push(z / i);
            }
        }
        for(let R = 1; R <= n; R++)for(let N = 1; N <= i; N++){
            const z = (i + 1) * (R - 1) + (N - 1), L = (i + 1) * R + (N - 1), P = (i + 1) * R + N, H = (i + 1) * (R - 1) + N;
            c.push(z, L, H), c.push(L, P, H);
        }
        this.setIndex(c), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(f, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(p, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(m, 2));
        function C(R, N, z, L, P) {
            const H = Math.cos(R), O = Math.sin(R), D = z / N * R, j = Math.cos(D);
            P.x = L * (2 + j) * .5 * H, P.y = L * (2 + j) * O * .5, P.z = L * Math.sin(D) * .5;
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Uy(e.radius, e.tube, e.tubularSegments, e.radialSegments, e.p, e.q);
    }
}
class $455d545b1dff00eb$var$Ny extends $455d545b1dff00eb$var$nn {
    constructor(e = new $455d545b1dff00eb$var$eS(new $455d545b1dff00eb$var$J(-1, -1, 0), new $455d545b1dff00eb$var$J(-1, 1, 0), new $455d545b1dff00eb$var$J(1, 1, 0)), t = 64, n = 1, i = 8, r = !1){
        super(), this.type = "TubeGeometry", this.parameters = {
            path: e,
            tubularSegments: t,
            radius: n,
            radialSegments: i,
            closed: r
        };
        const l = e.computeFrenetFrames(t, r);
        this.tangents = l.tangents, this.normals = l.normals, this.binormals = l.binormals;
        const c = new $455d545b1dff00eb$var$J, f = new $455d545b1dff00eb$var$J, p = new $455d545b1dff00eb$var$$e;
        let m = new $455d545b1dff00eb$var$J;
        const x = [], v = [], _ = [], S = [];
        A(), this.setIndex(S), this.setAttribute("position", new $455d545b1dff00eb$var$Dt(x, 3)), this.setAttribute("normal", new $455d545b1dff00eb$var$Dt(v, 3)), this.setAttribute("uv", new $455d545b1dff00eb$var$Dt(_, 2));
        function A() {
            for(let R = 0; R < t; R++)M(R);
            M(r === !1 ? t : 0), C(), b();
        }
        function M(R) {
            m = e.getPointAt(R / t, m);
            const N = l.normals[R], z = l.binormals[R];
            for(let L = 0; L <= i; L++){
                const P = L / i * Math.PI * 2, H = Math.sin(P), O = -Math.cos(P);
                f.x = O * N.x + H * z.x, f.y = O * N.y + H * z.y, f.z = O * N.z + H * z.z, f.normalize(), v.push(f.x, f.y, f.z), c.x = m.x + n * f.x, c.y = m.y + n * f.y, c.z = m.z + n * f.z, x.push(c.x, c.y, c.z);
            }
        }
        function b() {
            for(let R = 1; R <= t; R++)for(let N = 1; N <= i; N++){
                const z = (i + 1) * (R - 1) + (N - 1), L = (i + 1) * R + (N - 1), P = (i + 1) * R + N, H = (i + 1) * (R - 1) + N;
                S.push(z, L, H), S.push(L, P, H);
            }
        }
        function C() {
            for(let R = 0; R <= t; R++)for(let N = 0; N <= i; N++)p.x = R / t, p.y = N / i, _.push(p.x, p.y);
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.path = this.parameters.path.toJSON(), e;
    }
    static fromJSON(e) {
        return new $455d545b1dff00eb$var$Ny(new $455d545b1dff00eb$var$Vv[e.path.type]().fromJSON(e.path), e.tubularSegments, e.radius, e.radialSegments, e.closed);
    }
}
class $455d545b1dff00eb$var$jT extends $455d545b1dff00eb$var$nn {
    constructor(e = null){
        if (super(), this.type = "WireframeGeometry", this.parameters = {
            geometry: e
        }, e !== null) {
            const t = [], n = new Set, i = new $455d545b1dff00eb$var$J, r = new $455d545b1dff00eb$var$J;
            if (e.index !== null) {
                const l = e.attributes.position, c = e.index;
                let f = e.groups;
                f.length === 0 && (f = [
                    {
                        start: 0,
                        count: c.count,
                        materialIndex: 0
                    }
                ]);
                for(let p = 0, m = f.length; p < m; ++p){
                    const x = f[p], v = x.start, _ = x.count;
                    for(let S = v, A = v + _; S < A; S += 3)for(let M = 0; M < 3; M++){
                        const b = c.getX(S + M), C = c.getX(S + (M + 1) % 3);
                        i.fromBufferAttribute(l, b), r.fromBufferAttribute(l, C), $455d545b1dff00eb$var$SM(i, r, n) === !0 && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                    }
                }
            } else {
                const l = e.attributes.position;
                for(let c = 0, f = l.count / 3; c < f; c++)for(let p = 0; p < 3; p++){
                    const m = 3 * c + p, x = 3 * c + (p + 1) % 3;
                    i.fromBufferAttribute(l, m), r.fromBufferAttribute(l, x), $455d545b1dff00eb$var$SM(i, r, n) === !0 && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                }
            }
            this.setAttribute("position", new $455d545b1dff00eb$var$Dt(t, 3));
        }
    }
    copy(e) {
        return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
    }
}
function $455d545b1dff00eb$var$SM(a, e, t) {
    const n = `${a.x},${a.y},${a.z}-${e.x},${e.y},${e.z}`, i = `${e.x},${e.y},${e.z}-${a.x},${a.y},${a.z}`;
    return t.has(n) === !0 || t.has(i) === !0 ? !1 : (t.add(n), t.add(i), !0);
}
var $455d545b1dff00eb$var$MM = Object.freeze({
    __proto__: null,
    BoxGeometry: $455d545b1dff00eb$var$Ru,
    CapsuleGeometry: $455d545b1dff00eb$var$_y,
    CircleGeometry: $455d545b1dff00eb$var$by,
    ConeGeometry: $455d545b1dff00eb$var$A0,
    CylinderGeometry: $455d545b1dff00eb$var$T0,
    DodecahedronGeometry: $455d545b1dff00eb$var$Sy,
    EdgesGeometry: $455d545b1dff00eb$var$LT,
    ExtrudeGeometry: $455d545b1dff00eb$var$Ey,
    IcosahedronGeometry: $455d545b1dff00eb$var$Ty,
    LatheGeometry: $455d545b1dff00eb$var$Ay,
    OctahedronGeometry: $455d545b1dff00eb$var$w0,
    PlaneGeometry: $455d545b1dff00eb$var$Jr,
    PolyhedronGeometry: $455d545b1dff00eb$var$Du,
    RingGeometry: $455d545b1dff00eb$var$wy,
    ShapeGeometry: $455d545b1dff00eb$var$Cy,
    SphereGeometry: $455d545b1dff00eb$var$C0,
    TetrahedronGeometry: $455d545b1dff00eb$var$Ry,
    TorusGeometry: $455d545b1dff00eb$var$Dy,
    TorusKnotGeometry: $455d545b1dff00eb$var$Uy,
    TubeGeometry: $455d545b1dff00eb$var$Ny,
    WireframeGeometry: $455d545b1dff00eb$var$jT
});
class $455d545b1dff00eb$var$XT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new $455d545b1dff00eb$var$_t(0), this.transparent = !0, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$WT extends $455d545b1dff00eb$var$qs {
    constructor(e){
        super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
    }
}
class $455d545b1dff00eb$var$Oy extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshStandardMaterial = !0, this.type = "MeshStandardMaterial", this.defines = {
            STANDARD: ""
        }, this.color = new $455d545b1dff00eb$var$_t(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $455d545b1dff00eb$var$_t(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $455d545b1dff00eb$var$ua, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.defines = {
            STANDARD: ""
        }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$qT extends $455d545b1dff00eb$var$Oy {
    constructor(e){
        super(), this.isMeshPhysicalMaterial = !0, this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new $455d545b1dff00eb$var$$e(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $455d545b1dff00eb$var$Yt(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(t) {
                this.ior = (1 + .4 * t) / (1 - .4 * t);
            }
        }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
            100,
            400
        ], this.iridescenceThicknessMap = null, this.sheenColor = new $455d545b1dff00eb$var$_t(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new $455d545b1dff00eb$var$_t(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new $455d545b1dff00eb$var$_t(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._dispersion = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(e) {
        this._anisotropy > 0 != e > 0 && this.version++, this._anisotropy = e;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(e) {
        this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(e) {
        this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(e) {
        this._dispersion > 0 != e > 0 && this.version++, this._dispersion = e;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(e) {
        this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(e) {
        this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
    }
    copy(e) {
        return super.copy(e), this.defines = {
            STANDARD: "",
            PHYSICAL: ""
        }, this.anisotropy = e.anisotropy, this.anisotropyRotation = e.anisotropyRotation, this.anisotropyMap = e.anisotropyMap, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.dispersion = e.dispersion, this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [
            ...e.iridescenceThicknessRange
        ], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
    }
}
class $455d545b1dff00eb$var$YT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.specular = new $455d545b1dff00eb$var$_t(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $455d545b1dff00eb$var$_t(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $455d545b1dff00eb$var$ua, this.combine = $455d545b1dff00eb$var$S0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$ZT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshToonMaterial = !0, this.defines = {
            TOON: ""
        }, this.type = "MeshToonMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $455d545b1dff00eb$var$_t(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.gradientMap = e.gradientMap, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$QT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.flatShading = e.flatShading, this;
    }
}
class $455d545b1dff00eb$var$KT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new $455d545b1dff00eb$var$_t(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $455d545b1dff00eb$var$ua, this.combine = $455d545b1dff00eb$var$S0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$Ly extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = $455d545b1dff00eb$var$cT, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
    }
}
class $455d545b1dff00eb$var$zy extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
    }
}
class $455d545b1dff00eb$var$JT extends $455d545b1dff00eb$var$rr {
    constructor(e){
        super(), this.isMeshMatcapMaterial = !0, this.defines = {
            MATCAP: ""
        }, this.type = "MeshMatcapMaterial", this.color = new $455d545b1dff00eb$var$_t(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = $455d545b1dff00eb$var$Cu, this.normalScale = new $455d545b1dff00eb$var$$e(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.fog = !0, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.defines = {
            MATCAP: ""
        }, this.color.copy(e.color), this.matcap = e.matcap, this.map = e.map, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.flatShading = e.flatShading, this.fog = e.fog, this;
    }
}
class $455d545b1dff00eb$var$$T extends $455d545b1dff00eb$var$Nr {
    constructor(e){
        super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e);
    }
    copy(e) {
        return super.copy(e), this.scale = e.scale, this.dashSize = e.dashSize, this.gapSize = e.gapSize, this;
    }
}
function $455d545b1dff00eb$var$Bf(a, e) {
    return !a || a.constructor === e ? a : typeof e.BYTES_PER_ELEMENT == "number" ? new e(a) : Array.prototype.slice.call(a);
}
function $455d545b1dff00eb$var$eA(a) {
    return ArrayBuffer.isView(a) && !(a instanceof DataView);
}
function $455d545b1dff00eb$var$tA(a) {
    function e(i, r) {
        return a[i] - a[r];
    }
    const t = a.length, n = new Array(t);
    for(let i = 0; i !== t; ++i)n[i] = i;
    return n.sort(e), n;
}
function $455d545b1dff00eb$var$tb(a, e, t) {
    const n = a.length, i = new a.constructor(n);
    for(let r = 0, l = 0; l !== n; ++r){
        const c = t[r] * e;
        for(let f = 0; f !== e; ++f)i[l++] = a[c + f];
    }
    return i;
}
function $455d545b1dff00eb$var$nS(a, e, t, n) {
    let i = 1, r = a[0];
    for(; r !== void 0 && r[n] === void 0;)r = a[i++];
    if (r === void 0) return;
    let l = r[n];
    if (l !== void 0) {
        if (Array.isArray(l)) do l = r[n], l !== void 0 && (e.push(r.time), t.push(...l)), r = a[i++];
        while (r !== void 0);
        else if (l.toArray !== void 0) do l = r[n], l !== void 0 && (e.push(r.time), l.toArray(t, t.length)), r = a[i++];
        while (r !== void 0);
        else do l = r[n], l !== void 0 && (e.push(r.time), t.push(l)), r = a[i++];
        while (r !== void 0);
    }
}
function $455d545b1dff00eb$var$yN(a, e, t, n, i = 30) {
    const r = a.clone();
    r.name = e;
    const l = [];
    for(let f = 0; f < r.tracks.length; ++f){
        const p = r.tracks[f], m = p.getValueSize(), x = [], v = [];
        for(let _ = 0; _ < p.times.length; ++_){
            const S = p.times[_] * i;
            if (!(S < t || S >= n)) {
                x.push(p.times[_]);
                for(let A = 0; A < m; ++A)v.push(p.values[_ * m + A]);
            }
        }
        x.length !== 0 && (p.times = $455d545b1dff00eb$var$Bf(x, p.times.constructor), p.values = $455d545b1dff00eb$var$Bf(v, p.values.constructor), l.push(p));
    }
    r.tracks = l;
    let c = 1 / 0;
    for(let f = 0; f < r.tracks.length; ++f)c > r.tracks[f].times[0] && (c = r.tracks[f].times[0]);
    for(let f = 0; f < r.tracks.length; ++f)r.tracks[f].shift(-1 * c);
    return r.resetDuration(), r;
}
function $455d545b1dff00eb$var$_N(a, e = 0, t = a, n = 30) {
    n <= 0 && (n = 30);
    const i = t.tracks.length, r = e / n;
    for(let l = 0; l < i; ++l){
        const c = t.tracks[l], f = c.ValueTypeName;
        if (f === "bool" || f === "string") continue;
        const p = a.tracks.find(function(b) {
            return b.name === c.name && b.ValueTypeName === f;
        });
        if (p === void 0) continue;
        let m = 0;
        const x = c.getValueSize();
        c.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (m = x / 3);
        let v = 0;
        const _ = p.getValueSize();
        p.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (v = _ / 3);
        const S = c.times.length - 1;
        let A;
        if (r <= c.times[0]) {
            const b = m, C = x - m;
            A = c.values.slice(b, C);
        } else if (r >= c.times[S]) {
            const b = S * x + m, C = b + x - m;
            A = c.values.slice(b, C);
        } else {
            const b = c.createInterpolant(), C = m, R = x - m;
            b.evaluate(r), A = b.resultBuffer.slice(C, R);
        }
        f === "quaternion" && new $455d545b1dff00eb$var$Gn().fromArray(A).normalize().conjugate().toArray(A);
        const M = p.times.length;
        for(let b = 0; b < M; ++b){
            const C = b * _ + v;
            if (f === "quaternion") $455d545b1dff00eb$var$Gn.multiplyQuaternionsFlat(p.values, C, A, 0, p.values, C);
            else {
                const R = _ - v * 2;
                for(let N = 0; N < R; ++N)p.values[C + N] -= A[N];
            }
        }
    }
    return a.blendMode = $455d545b1dff00eb$var$Bb, a;
}
class $455d545b1dff00eb$var$bN {
    static convertArray(e, t) {
        return $455d545b1dff00eb$var$Bf(e, t);
    }
    static isTypedArray(e) {
        return $455d545b1dff00eb$var$eA(e);
    }
    static getKeyframeOrder(e) {
        return $455d545b1dff00eb$var$tA(e);
    }
    static sortedArray(e, t, n) {
        return $455d545b1dff00eb$var$tb(e, t, n);
    }
    static flattenJSON(e, t, n, i) {
        $455d545b1dff00eb$var$nS(e, t, n, i);
    }
    static subclip(e, t, n, i, r = 30) {
        return $455d545b1dff00eb$var$yN(e, t, n, i, r);
    }
    static makeClipAdditive(e, t = 0, n = e, i = 30) {
        return $455d545b1dff00eb$var$_N(e, t, n, i);
    }
}
class $455d545b1dff00eb$var$R0 {
    constructor(e, t, n, i){
        this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new t.constructor(n), this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(e) {
        const t = this.parameterPositions;
        let n = this._cachedIndex, i = t[n], r = t[n - 1];
        e: {
            t: {
                let l;
                n: {
                    i: if (!(e < i)) {
                        for(let c = n + 2;;){
                            if (i === void 0) {
                                if (e < r) break i;
                                return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                            }
                            if (n === c) break;
                            if (r = i, i = t[++n], e < i) break t;
                        }
                        l = t.length;
                        break n;
                    }
                    if (!(e >= r)) {
                        const c = t[1];
                        e < c && (n = 2, r = c);
                        for(let f = n - 2;;){
                            if (r === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (n === f) break;
                            if (i = r, r = t[--n - 1], e >= r) break t;
                        }
                        l = n, n = 0;
                        break n;
                    }
                    break e;
                }
                for(; n < l;){
                    const c = n + l >>> 1;
                    e < t[c] ? l = c : n = c + 1;
                }
                if (i = t[n], r = t[n - 1], r === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (i === void 0) return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
            }
            this._cachedIndex = n, this.intervalChanged_(n, r, i);
        }
        return this.interpolate_(n, r, e, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(e) {
        const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e * i;
        for(let l = 0; l !== i; ++l)t[l] = n[r + l];
        return t;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}
class $455d545b1dff00eb$var$nA extends $455d545b1dff00eb$var$R0 {
    constructor(e, t, n, i){
        super(e, t, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: $455d545b1dff00eb$var$zf,
            endingEnd: $455d545b1dff00eb$var$zf
        };
    }
    intervalChanged_(e, t, n) {
        const i = this.parameterPositions;
        let r = e - 2, l = e + 1, c = i[r], f = i[l];
        if (c === void 0) switch(this.getSettings_().endingStart){
            case $455d545b1dff00eb$var$Pf:
                r = e, c = 2 * t - n;
                break;
            case $455d545b1dff00eb$var$i0:
                r = i.length - 2, c = t + i[r] - i[r + 1];
                break;
            default:
                r = e, c = n;
        }
        if (f === void 0) switch(this.getSettings_().endingEnd){
            case $455d545b1dff00eb$var$Pf:
                l = e, f = 2 * n - t;
                break;
            case $455d545b1dff00eb$var$i0:
                l = 1, f = n + i[1] - i[0];
                break;
            default:
                l = e - 1, f = t;
        }
        const p = (n - t) * .5, m = this.valueSize;
        this._weightPrev = p / (t - c), this._weightNext = p / (f - n), this._offsetPrev = r * m, this._offsetNext = l * m;
    }
    interpolate_(e, t, n, i) {
        const r = this.resultBuffer, l = this.sampleValues, c = this.valueSize, f = e * c, p = f - c, m = this._offsetPrev, x = this._offsetNext, v = this._weightPrev, _ = this._weightNext, S = (n - t) / (i - t), A = S * S, M = A * S, b = -v * M + 2 * v * A - v * S, C = (1 + v) * M + (-1.5 - 2 * v) * A + (-0.5 + v) * S + 1, R = (-1 - _) * M + (1.5 + _) * A + .5 * S, N = _ * M - _ * A;
        for(let z = 0; z !== c; ++z)r[z] = b * l[m + z] + C * l[p + z] + R * l[f + z] + N * l[x + z];
        return r;
    }
}
class $455d545b1dff00eb$var$iS extends $455d545b1dff00eb$var$R0 {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
    interpolate_(e, t, n, i) {
        const r = this.resultBuffer, l = this.sampleValues, c = this.valueSize, f = e * c, p = f - c, m = (n - t) / (i - t), x = 1 - m;
        for(let v = 0; v !== c; ++v)r[v] = l[p + v] * x + l[f + v] * m;
        return r;
    }
}
class $455d545b1dff00eb$var$iA extends $455d545b1dff00eb$var$R0 {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
    interpolate_(e) {
        return this.copySampleValue_(e - 1);
    }
}
class $455d545b1dff00eb$var$Ys {
    constructor(e, t, n, i){
        if (e === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (t === void 0 || t.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
        this.name = e, this.times = $455d545b1dff00eb$var$Bf(t, this.TimeBufferType), this.values = $455d545b1dff00eb$var$Bf(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(e) {
        const t = e.constructor;
        let n;
        if (t.toJSON !== this.toJSON) n = t.toJSON(e);
        else {
            n = {
                name: e.name,
                times: $455d545b1dff00eb$var$Bf(e.times, Array),
                values: $455d545b1dff00eb$var$Bf(e.values, Array)
            };
            const i = e.getInterpolation();
            i !== e.DefaultInterpolation && (n.interpolation = i);
        }
        return n.type = e.ValueTypeName, n;
    }
    InterpolantFactoryMethodDiscrete(e) {
        return new $455d545b1dff00eb$var$iA(this.times, this.values, this.getValueSize(), e);
    }
    InterpolantFactoryMethodLinear(e) {
        return new $455d545b1dff00eb$var$iS(this.times, this.values, this.getValueSize(), e);
    }
    InterpolantFactoryMethodSmooth(e) {
        return new $455d545b1dff00eb$var$nA(this.times, this.values, this.getValueSize(), e);
    }
    setInterpolation(e) {
        let t;
        switch(e){
            case $455d545b1dff00eb$var$n0:
                t = this.InterpolantFactoryMethodDiscrete;
                break;
            case $455d545b1dff00eb$var$Iv:
                t = this.InterpolantFactoryMethodLinear;
                break;
            case $455d545b1dff00eb$var$Wx:
                t = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (t === void 0) {
            const n = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === void 0) {
                if (e !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(n);
            }
            return $455d545b1dff00eb$var$Mt("KeyframeTrack:", n), this;
        }
        return this.createInterpolant = t, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $455d545b1dff00eb$var$n0;
            case this.InterpolantFactoryMethodLinear:
                return $455d545b1dff00eb$var$Iv;
            case this.InterpolantFactoryMethodSmooth:
                return $455d545b1dff00eb$var$Wx;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(e) {
        if (e !== 0) {
            const t = this.times;
            for(let n = 0, i = t.length; n !== i; ++n)t[n] += e;
        }
        return this;
    }
    scale(e) {
        if (e !== 1) {
            const t = this.times;
            for(let n = 0, i = t.length; n !== i; ++n)t[n] *= e;
        }
        return this;
    }
    trim(e, t) {
        const n = this.times, i = n.length;
        let r = 0, l = i - 1;
        for(; r !== i && n[r] < e;)++r;
        for(; l !== -1 && n[l] > t;)--l;
        if (++l, r !== 0 || l !== i) {
            r >= l && (l = Math.max(l, 1), r = l - 1);
            const c = this.getValueSize();
            this.times = n.slice(r, l), this.values = this.values.slice(r * c, l * c);
        }
        return this;
    }
    validate() {
        let e = !0;
        const t = this.getValueSize();
        t - Math.floor(t) !== 0 && ($455d545b1dff00eb$var$Qt("KeyframeTrack: Invalid value size in track.", this), e = !1);
        const n = this.times, i = this.values, r = n.length;
        r === 0 && ($455d545b1dff00eb$var$Qt("KeyframeTrack: Track is empty.", this), e = !1);
        let l = null;
        for(let c = 0; c !== r; c++){
            const f = n[c];
            if (typeof f == "number" && isNaN(f)) {
                $455d545b1dff00eb$var$Qt("KeyframeTrack: Time is not a valid number.", this, c, f), e = !1;
                break;
            }
            if (l !== null && l > f) {
                $455d545b1dff00eb$var$Qt("KeyframeTrack: Out of order keys.", this, c, f, l), e = !1;
                break;
            }
            l = f;
        }
        if (i !== void 0 && $455d545b1dff00eb$var$eA(i)) for(let c = 0, f = i.length; c !== f; ++c){
            const p = i[c];
            if (isNaN(p)) {
                $455d545b1dff00eb$var$Qt("KeyframeTrack: Value is not a valid number.", this, c, p), e = !1;
                break;
            }
        }
        return e;
    }
    optimize() {
        const e = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), i = this.getInterpolation() === $455d545b1dff00eb$var$Wx, r = e.length - 1;
        let l = 1;
        for(let c = 1; c < r; ++c){
            let f = !1;
            const p = e[c], m = e[c + 1];
            if (p !== m && (c !== 1 || p !== e[0])) {
                if (i) f = !0;
                else {
                    const x = c * n, v = x - n, _ = x + n;
                    for(let S = 0; S !== n; ++S){
                        const A = t[x + S];
                        if (A !== t[v + S] || A !== t[_ + S]) {
                            f = !0;
                            break;
                        }
                    }
                }
            }
            if (f) {
                if (c !== l) {
                    e[l] = e[c];
                    const x = c * n, v = l * n;
                    for(let _ = 0; _ !== n; ++_)t[v + _] = t[x + _];
                }
                ++l;
            }
        }
        if (r > 0) {
            e[l] = e[r];
            for(let c = r * n, f = l * n, p = 0; p !== n; ++p)t[f + p] = t[c + p];
            ++l;
        }
        return l !== e.length ? (this.times = e.slice(0, l), this.values = t.slice(0, l * n)) : (this.times = e, this.values = t), this;
    }
    clone() {
        const e = this.times.slice(), t = this.values.slice(), n = this.constructor, i = new n(this.name, e, t);
        return i.createInterpolant = this.createInterpolant, i;
    }
}
$455d545b1dff00eb$var$Ys.prototype.ValueTypeName = "";
$455d545b1dff00eb$var$Ys.prototype.TimeBufferType = Float32Array;
$455d545b1dff00eb$var$Ys.prototype.ValueBufferType = Float32Array;
$455d545b1dff00eb$var$Ys.prototype.DefaultInterpolation = $455d545b1dff00eb$var$Iv;
class $455d545b1dff00eb$var$Jf extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n){
        super(e, t, n);
    }
}
$455d545b1dff00eb$var$Jf.prototype.ValueTypeName = "bool";
$455d545b1dff00eb$var$Jf.prototype.ValueBufferType = Array;
$455d545b1dff00eb$var$Jf.prototype.DefaultInterpolation = $455d545b1dff00eb$var$n0;
$455d545b1dff00eb$var$Jf.prototype.InterpolantFactoryMethodLinear = void 0;
$455d545b1dff00eb$var$Jf.prototype.InterpolantFactoryMethodSmooth = void 0;
class $455d545b1dff00eb$var$aS extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
}
$455d545b1dff00eb$var$aS.prototype.ValueTypeName = "color";
class $455d545b1dff00eb$var$f0 extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
}
$455d545b1dff00eb$var$f0.prototype.ValueTypeName = "number";
class $455d545b1dff00eb$var$aA extends $455d545b1dff00eb$var$R0 {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
    interpolate_(e, t, n, i) {
        const r = this.resultBuffer, l = this.sampleValues, c = this.valueSize, f = (n - t) / (i - t);
        let p = e * c;
        for(let m = p + c; p !== m; p += 4)$455d545b1dff00eb$var$Gn.slerpFlat(r, 0, l, p - c, l, p, f);
        return r;
    }
}
class $455d545b1dff00eb$var$D0 extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
    InterpolantFactoryMethodLinear(e) {
        return new $455d545b1dff00eb$var$aA(this.times, this.values, this.getValueSize(), e);
    }
}
$455d545b1dff00eb$var$D0.prototype.ValueTypeName = "quaternion";
$455d545b1dff00eb$var$D0.prototype.InterpolantFactoryMethodSmooth = void 0;
class $455d545b1dff00eb$var$$f extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n){
        super(e, t, n);
    }
}
$455d545b1dff00eb$var$$f.prototype.ValueTypeName = "string";
$455d545b1dff00eb$var$$f.prototype.ValueBufferType = Array;
$455d545b1dff00eb$var$$f.prototype.DefaultInterpolation = $455d545b1dff00eb$var$n0;
$455d545b1dff00eb$var$$f.prototype.InterpolantFactoryMethodLinear = void 0;
$455d545b1dff00eb$var$$f.prototype.InterpolantFactoryMethodSmooth = void 0;
class $455d545b1dff00eb$var$h0 extends $455d545b1dff00eb$var$Ys {
    constructor(e, t, n, i){
        super(e, t, n, i);
    }
}
$455d545b1dff00eb$var$h0.prototype.ValueTypeName = "vector";
class $455d545b1dff00eb$var$d0 {
    constructor(e = "", t = -1, n = [], i = $455d545b1dff00eb$var$cy){
        this.name = e, this.tracks = n, this.duration = t, this.blendMode = i, this.uuid = $455d545b1dff00eb$var$bs(), this.userData = {}, this.duration < 0 && this.resetDuration();
    }
    static parse(e) {
        const t = [], n = e.tracks, i = 1 / (e.fps || 1);
        for(let l = 0, c = n.length; l !== c; ++l)t.push($455d545b1dff00eb$var$MN(n[l]).scale(i));
        const r = new this(e.name, e.duration, t, e.blendMode);
        return r.uuid = e.uuid, r.userData = JSON.parse(e.userData || "{}"), r;
    }
    static toJSON(e) {
        const t = [], n = e.tracks, i = {
            name: e.name,
            duration: e.duration,
            tracks: t,
            uuid: e.uuid,
            blendMode: e.blendMode,
            userData: JSON.stringify(e.userData)
        };
        for(let r = 0, l = n.length; r !== l; ++r)t.push($455d545b1dff00eb$var$Ys.toJSON(n[r]));
        return i;
    }
    static CreateFromMorphTargetSequence(e, t, n, i) {
        const r = t.length, l = [];
        for(let c = 0; c < r; c++){
            let f = [], p = [];
            f.push((c + r - 1) % r, c, (c + 1) % r), p.push(0, 1, 0);
            const m = $455d545b1dff00eb$var$tA(f);
            f = $455d545b1dff00eb$var$tb(f, 1, m), p = $455d545b1dff00eb$var$tb(p, 1, m), !i && f[0] === 0 && (f.push(r), p.push(p[0])), l.push(new $455d545b1dff00eb$var$f0(".morphTargetInfluences[" + t[c].name + "]", f, p).scale(1 / n));
        }
        return new this(e, -1, l);
    }
    static findByName(e, t) {
        let n = e;
        if (!Array.isArray(e)) {
            const i = e;
            n = i.geometry && i.geometry.animations || i.animations;
        }
        for(let i = 0; i < n.length; i++)if (n[i].name === t) return n[i];
        return null;
    }
    static CreateClipsFromMorphTargetSequences(e, t, n) {
        const i = {}, r = /^([\w-]*?)([\d]+)$/;
        for(let c = 0, f = e.length; c < f; c++){
            const p = e[c], m = p.name.match(r);
            if (m && m.length > 1) {
                const x = m[1];
                let v = i[x];
                v || (i[x] = v = []), v.push(p);
            }
        }
        const l = [];
        for(const c in i)l.push(this.CreateFromMorphTargetSequence(c, i[c], t, n));
        return l;
    }
    static parseAnimation(e, t) {
        if ($455d545b1dff00eb$var$Mt("AnimationClip: parseAnimation() is deprecated and will be removed with r185"), !e) return $455d545b1dff00eb$var$Qt("AnimationClip: No animation in JSONLoader data."), null;
        const n = function(x, v, _, S, A) {
            if (_.length !== 0) {
                const M = [], b = [];
                $455d545b1dff00eb$var$nS(_, M, b, S), M.length !== 0 && A.push(new x(v, M, b));
            }
        }, i = [], r = e.name || "default", l = e.fps || 30, c = e.blendMode;
        let f = e.length || -1;
        const p = e.hierarchy || [];
        for(let x = 0; x < p.length; x++){
            const v = p[x].keys;
            if (!(!v || v.length === 0)) {
                if (v[0].morphTargets) {
                    const _ = {};
                    let S;
                    for(S = 0; S < v.length; S++)if (v[S].morphTargets) for(let A = 0; A < v[S].morphTargets.length; A++)_[v[S].morphTargets[A]] = -1;
                    for(const A in _){
                        const M = [], b = [];
                        for(let C = 0; C !== v[S].morphTargets.length; ++C){
                            const R = v[S];
                            M.push(R.time), b.push(R.morphTarget === A ? 1 : 0);
                        }
                        i.push(new $455d545b1dff00eb$var$f0(".morphTargetInfluence[" + A + "]", M, b));
                    }
                    f = _.length * l;
                } else {
                    const _ = ".bones[" + t[x].name + "]";
                    n($455d545b1dff00eb$var$h0, _ + ".position", v, "pos", i), n($455d545b1dff00eb$var$D0, _ + ".quaternion", v, "rot", i), n($455d545b1dff00eb$var$h0, _ + ".scale", v, "scl", i);
                }
            }
        }
        return i.length === 0 ? null : new this(r, f, i, c);
    }
    resetDuration() {
        const e = this.tracks;
        let t = 0;
        for(let n = 0, i = e.length; n !== i; ++n){
            const r = this.tracks[n];
            t = Math.max(t, r.times[r.times.length - 1]);
        }
        return this.duration = t, this;
    }
    trim() {
        for(let e = 0; e < this.tracks.length; e++)this.tracks[e].trim(0, this.duration);
        return this;
    }
    validate() {
        let e = !0;
        for(let t = 0; t < this.tracks.length; t++)e = e && this.tracks[t].validate();
        return e;
    }
    optimize() {
        for(let e = 0; e < this.tracks.length; e++)this.tracks[e].optimize();
        return this;
    }
    clone() {
        const e = [];
        for(let n = 0; n < this.tracks.length; n++)e.push(this.tracks[n].clone());
        const t = new this.constructor(this.name, this.duration, e, this.blendMode);
        return t.userData = JSON.parse(JSON.stringify(this.userData)), t;
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $455d545b1dff00eb$var$SN(a) {
    switch(a.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $455d545b1dff00eb$var$f0;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $455d545b1dff00eb$var$h0;
        case "color":
            return $455d545b1dff00eb$var$aS;
        case "quaternion":
            return $455d545b1dff00eb$var$D0;
        case "bool":
        case "boolean":
            return $455d545b1dff00eb$var$Jf;
        case "string":
            return $455d545b1dff00eb$var$$f;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + a);
}
function $455d545b1dff00eb$var$MN(a) {
    if (a.type === void 0) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const e = $455d545b1dff00eb$var$SN(a.type);
    if (a.times === void 0) {
        const t = [], n = [];
        $455d545b1dff00eb$var$nS(a.keys, t, n, "value"), a.times = t, a.values = n;
    }
    return e.parse !== void 0 ? e.parse(a) : new e(a.name, a.times, a.values, a.interpolation);
}
const $455d545b1dff00eb$var$xl = {
    enabled: !1,
    files: {},
    add: function(a, e) {
        this.enabled !== !1 && (this.files[a] = e);
    },
    get: function(a) {
        if (this.enabled !== !1) return this.files[a];
    },
    remove: function(a) {
        delete this.files[a];
    },
    clear: function() {
        this.files = {};
    }
};
class $455d545b1dff00eb$var$rS {
    constructor(e, t, n){
        const i = this;
        let r = !1, l = 0, c = 0, f;
        const p = [];
        this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this._abortController = null, this.itemStart = function(m) {
            c++, r === !1 && i.onStart !== void 0 && i.onStart(m, l, c), r = !0;
        }, this.itemEnd = function(m) {
            l++, i.onProgress !== void 0 && i.onProgress(m, l, c), l === c && (r = !1, i.onLoad !== void 0 && i.onLoad());
        }, this.itemError = function(m) {
            i.onError !== void 0 && i.onError(m);
        }, this.resolveURL = function(m) {
            return f ? f(m) : m;
        }, this.setURLModifier = function(m) {
            return f = m, this;
        }, this.addHandler = function(m, x) {
            return p.push(m, x), this;
        }, this.removeHandler = function(m) {
            const x = p.indexOf(m);
            return x !== -1 && p.splice(x, 2), this;
        }, this.getHandler = function(m) {
            for(let x = 0, v = p.length; x < v; x += 2){
                const _ = p[x], S = p[x + 1];
                if (_.global && (_.lastIndex = 0), _.test(m)) return S;
            }
            return null;
        }, this.abort = function() {
            return this.abortController.abort(), this._abortController = null, this;
        };
    }
    get abortController() {
        return this._abortController || (this._abortController = new AbortController), this._abortController;
    }
}
const $455d545b1dff00eb$var$rA = new $455d545b1dff00eb$var$rS;
class $455d545b1dff00eb$var$$r {
    constructor(e){
        this.manager = e !== void 0 ? e : $455d545b1dff00eb$var$rA, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(e, t) {
        const n = this;
        return new Promise(function(i, r) {
            n.load(e, i, t, r);
        });
    }
    parse() {}
    setCrossOrigin(e) {
        return this.crossOrigin = e, this;
    }
    setWithCredentials(e) {
        return this.withCredentials = e, this;
    }
    setPath(e) {
        return this.path = e, this;
    }
    setResourcePath(e) {
        return this.resourcePath = e, this;
    }
    setRequestHeader(e) {
        return this.requestHeader = e, this;
    }
    abort() {
        return this;
    }
}
$455d545b1dff00eb$var$$r.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $455d545b1dff00eb$var$fc = {};
class $455d545b1dff00eb$var$EN extends Error {
    constructor(e, t){
        super(e), this.response = t;
    }
}
class $455d545b1dff00eb$var$Ec extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e), this.mimeType = "", this.responseType = "", this._abortController = new AbortController;
    }
    load(e, t, n, i) {
        e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
        const r = $455d545b1dff00eb$var$xl.get(`file:${e}`);
        if (r !== void 0) return this.manager.itemStart(e), setTimeout(()=>{
            t && t(r), this.manager.itemEnd(e);
        }, 0), r;
        if ($455d545b1dff00eb$var$fc[e] !== void 0) {
            $455d545b1dff00eb$var$fc[e].push({
                onLoad: t,
                onProgress: n,
                onError: i
            });
            return;
        }
        $455d545b1dff00eb$var$fc[e] = [], $455d545b1dff00eb$var$fc[e].push({
            onLoad: t,
            onProgress: n,
            onError: i
        });
        const l = new Request(e, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin",
            signal: typeof AbortSignal.any == "function" ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        }), c = this.mimeType, f = this.responseType;
        fetch(l).then((p)=>{
            if (p.status === 200 || p.status === 0) {
                if (p.status === 0 && $455d545b1dff00eb$var$Mt("FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || p.body === void 0 || p.body.getReader === void 0) return p;
                const m = $455d545b1dff00eb$var$fc[e], x = p.body.getReader(), v = p.headers.get("X-File-Size") || p.headers.get("Content-Length"), _ = v ? parseInt(v) : 0, S = _ !== 0;
                let A = 0;
                const M = new ReadableStream({
                    start (b) {
                        C();
                        function C() {
                            x.read().then(({ done: R, value: N })=>{
                                if (R) b.close();
                                else {
                                    A += N.byteLength;
                                    const z = new ProgressEvent("progress", {
                                        lengthComputable: S,
                                        loaded: A,
                                        total: _
                                    });
                                    for(let L = 0, P = m.length; L < P; L++){
                                        const H = m[L];
                                        H.onProgress && H.onProgress(z);
                                    }
                                    b.enqueue(N), C();
                                }
                            }, (R)=>{
                                b.error(R);
                            });
                        }
                    }
                });
                return new Response(M);
            } else throw new $455d545b1dff00eb$var$EN(`fetch for "${p.url}" responded with ${p.status}: ${p.statusText}`, p);
        }).then((p)=>{
            switch(f){
                case "arraybuffer":
                    return p.arrayBuffer();
                case "blob":
                    return p.blob();
                case "document":
                    return p.text().then((m)=>new DOMParser().parseFromString(m, c));
                case "json":
                    return p.json();
                default:
                    if (c === "") return p.text();
                    {
                        const x = /charset="?([^;"\s]*)"?/i.exec(c), v = x && x[1] ? x[1].toLowerCase() : void 0, _ = new TextDecoder(v);
                        return p.arrayBuffer().then((S)=>_.decode(S));
                    }
            }
        }).then((p)=>{
            $455d545b1dff00eb$var$xl.add(`file:${e}`, p);
            const m = $455d545b1dff00eb$var$fc[e];
            delete $455d545b1dff00eb$var$fc[e];
            for(let x = 0, v = m.length; x < v; x++){
                const _ = m[x];
                _.onLoad && _.onLoad(p);
            }
        }).catch((p)=>{
            const m = $455d545b1dff00eb$var$fc[e];
            if (m === void 0) throw this.manager.itemError(e), p;
            delete $455d545b1dff00eb$var$fc[e];
            for(let x = 0, v = m.length; x < v; x++){
                const _ = m[x];
                _.onError && _.onError(p);
            }
            this.manager.itemError(e);
        }).finally(()=>{
            this.manager.itemEnd(e);
        }), this.manager.itemStart(e);
    }
    setResponseType(e) {
        return this.responseType = e, this;
    }
    setMimeType(e) {
        return this.mimeType = e, this;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
class $455d545b1dff00eb$var$TN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = new $455d545b1dff00eb$var$Ec(this.manager);
        l.setPath(this.path), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, function(c) {
            try {
                t(r.parse(JSON.parse(c)));
            } catch (f) {
                i ? i(f) : $455d545b1dff00eb$var$Qt(f), r.manager.itemError(e);
            }
        }, n, i);
    }
    parse(e) {
        const t = [];
        for(let n = 0; n < e.length; n++){
            const i = $455d545b1dff00eb$var$d0.parse(e[n]);
            t.push(i);
        }
        return t;
    }
}
class $455d545b1dff00eb$var$AN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = [], c = new $455d545b1dff00eb$var$vy, f = new $455d545b1dff00eb$var$Ec(this.manager);
        f.setPath(this.path), f.setResponseType("arraybuffer"), f.setRequestHeader(this.requestHeader), f.setWithCredentials(r.withCredentials);
        let p = 0;
        function m(x) {
            f.load(e[x], function(v) {
                const _ = r.parse(v, !0);
                l[x] = {
                    width: _.width,
                    height: _.height,
                    format: _.format,
                    mipmaps: _.mipmaps
                }, p += 1, p === 6 && (_.mipmapCount === 1 && (c.minFilter = $455d545b1dff00eb$var$mi), c.image = l, c.format = _.format, c.needsUpdate = !0, t && t(c));
            }, n, i);
        }
        if (Array.isArray(e)) for(let x = 0, v = e.length; x < v; ++x)m(x);
        else f.load(e, function(x) {
            const v = r.parse(x, !0);
            if (v.isCubemap) {
                const _ = v.mipmaps.length / v.mipmapCount;
                for(let S = 0; S < _; S++){
                    l[S] = {
                        mipmaps: []
                    };
                    for(let A = 0; A < v.mipmapCount; A++)l[S].mipmaps.push(v.mipmaps[S * v.mipmapCount + A]), l[S].format = v.format, l[S].width = v.width, l[S].height = v.height;
                }
                c.image = l;
            } else c.image.width = v.width, c.image.height = v.height, c.mipmaps = v.mipmaps;
            v.mipmapCount === 1 && (c.minFilter = $455d545b1dff00eb$var$mi), c.format = v.format, c.needsUpdate = !0, t && t(c);
        }, n, i);
        return c;
    }
}
const $455d545b1dff00eb$var$vd = new WeakMap;
class $455d545b1dff00eb$var$p0 extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
        const r = this, l = $455d545b1dff00eb$var$xl.get(`image:${e}`);
        if (l !== void 0) {
            if (l.complete === !0) r.manager.itemStart(e), setTimeout(function() {
                t && t(l), r.manager.itemEnd(e);
            }, 0);
            else {
                let x = $455d545b1dff00eb$var$vd.get(l);
                x === void 0 && (x = [], $455d545b1dff00eb$var$vd.set(l, x)), x.push({
                    onLoad: t,
                    onError: i
                });
            }
            return l;
        }
        const c = $455d545b1dff00eb$var$s0("img");
        function f() {
            m(), t && t(this);
            const x = $455d545b1dff00eb$var$vd.get(this) || [];
            for(let v = 0; v < x.length; v++){
                const _ = x[v];
                _.onLoad && _.onLoad(this);
            }
            $455d545b1dff00eb$var$vd.delete(this), r.manager.itemEnd(e);
        }
        function p(x) {
            m(), i && i(x), $455d545b1dff00eb$var$xl.remove(`image:${e}`);
            const v = $455d545b1dff00eb$var$vd.get(this) || [];
            for(let _ = 0; _ < v.length; _++){
                const S = v[_];
                S.onError && S.onError(x);
            }
            $455d545b1dff00eb$var$vd.delete(this), r.manager.itemError(e), r.manager.itemEnd(e);
        }
        function m() {
            c.removeEventListener("load", f, !1), c.removeEventListener("error", p, !1);
        }
        return c.addEventListener("load", f, !1), c.addEventListener("error", p, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (c.crossOrigin = this.crossOrigin), $455d545b1dff00eb$var$xl.add(`image:${e}`, c), r.manager.itemStart(e), c.src = e, c;
    }
}
class $455d545b1dff00eb$var$wN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = new $455d545b1dff00eb$var$E0;
        r.colorSpace = $455d545b1dff00eb$var$nr;
        const l = new $455d545b1dff00eb$var$p0(this.manager);
        l.setCrossOrigin(this.crossOrigin), l.setPath(this.path);
        let c = 0;
        function f(p) {
            l.load(e[p], function(m) {
                r.images[p] = m, c++, c === 6 && (r.needsUpdate = !0, t && t(r));
            }, void 0, i);
        }
        for(let p = 0; p < e.length; ++p)f(p);
        return r;
    }
}
class $455d545b1dff00eb$var$CN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = new $455d545b1dff00eb$var$Ro, c = new $455d545b1dff00eb$var$Ec(this.manager);
        return c.setResponseType("arraybuffer"), c.setRequestHeader(this.requestHeader), c.setPath(this.path), c.setWithCredentials(r.withCredentials), c.load(e, function(f) {
            let p;
            try {
                p = r.parse(f);
            } catch (m) {
                if (i !== void 0) i(m);
                else {
                    m(m);
                    return;
                }
            }
            p.image !== void 0 ? l.image = p.image : p.data !== void 0 && (l.image.width = p.width, l.image.height = p.height, l.image.data = p.data), l.wrapS = p.wrapS !== void 0 ? p.wrapS : $455d545b1dff00eb$var$Kr, l.wrapT = p.wrapT !== void 0 ? p.wrapT : $455d545b1dff00eb$var$Kr, l.magFilter = p.magFilter !== void 0 ? p.magFilter : $455d545b1dff00eb$var$mi, l.minFilter = p.minFilter !== void 0 ? p.minFilter : $455d545b1dff00eb$var$mi, l.anisotropy = p.anisotropy !== void 0 ? p.anisotropy : 1, p.colorSpace !== void 0 && (l.colorSpace = p.colorSpace), p.flipY !== void 0 && (l.flipY = p.flipY), p.format !== void 0 && (l.format = p.format), p.type !== void 0 && (l.type = p.type), p.mipmaps !== void 0 && (l.mipmaps = p.mipmaps, l.minFilter = $455d545b1dff00eb$var$gl), p.mipmapCount === 1 && (l.minFilter = $455d545b1dff00eb$var$mi), p.generateMipmaps !== void 0 && (l.generateMipmaps = p.generateMipmaps), l.needsUpdate = !0, t && t(l, p);
        }, n, i), l;
    }
}
class $455d545b1dff00eb$var$RN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = new $455d545b1dff00eb$var$Li, l = new $455d545b1dff00eb$var$p0(this.manager);
        return l.setCrossOrigin(this.crossOrigin), l.setPath(this.path), l.load(e, function(c) {
            r.image = c, r.needsUpdate = !0, t !== void 0 && t(r);
        }, n, i), r;
    }
}
class $455d545b1dff00eb$var$Uu extends $455d545b1dff00eb$var$Pn {
    constructor(e, t = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new $455d545b1dff00eb$var$_t(e), this.intensity = t;
    }
    dispose() {}
    copy(e, t) {
        return super.copy(e, t), this.color.copy(e.color), this.intensity = e.intensity, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, this.groundColor !== void 0 && (t.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (t.object.distance = this.distance), this.angle !== void 0 && (t.object.angle = this.angle), this.decay !== void 0 && (t.object.decay = this.decay), this.penumbra !== void 0 && (t.object.penumbra = this.penumbra), this.shadow !== void 0 && (t.object.shadow = this.shadow.toJSON()), this.target !== void 0 && (t.object.target = this.target.uuid), t;
    }
}
class $455d545b1dff00eb$var$sA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t, n){
        super(e, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy($455d545b1dff00eb$var$Pn.DEFAULT_UP), this.updateMatrix(), this.groundColor = new $455d545b1dff00eb$var$_t(t);
    }
    copy(e, t) {
        return super.copy(e, t), this.groundColor.copy(e.groundColor), this;
    }
}
const $455d545b1dff00eb$var$o_ = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$EM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$TM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$sS {
    constructor(e){
        this.camera = e, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new $455d545b1dff00eb$var$$e(512, 512), this.mapType = $455d545b1dff00eb$var$Ws, this.map = null, this.mapPass = null, this.matrix = new $455d545b1dff00eb$var$Ft, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new $455d545b1dff00eb$var$qd, this._frameExtents = new $455d545b1dff00eb$var$$e(1, 1), this._viewportCount = 1, this._viewports = [
            new $455d545b1dff00eb$var$Un(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(e) {
        const t = this.camera, n = this.matrix;
        $455d545b1dff00eb$var$EM.setFromMatrixPosition(e.matrixWorld), t.position.copy($455d545b1dff00eb$var$EM), $455d545b1dff00eb$var$TM.setFromMatrixPosition(e.target.matrixWorld), t.lookAt($455d545b1dff00eb$var$TM), t.updateMatrixWorld(), $455d545b1dff00eb$var$o_.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix($455d545b1dff00eb$var$o_, t.coordinateSystem, t.reversedDepth), t.reversedDepth ? n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, 1, 0, 0, 0, 0, 1) : n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply($455d545b1dff00eb$var$o_);
    }
    getViewport(e) {
        return this._viewports[e];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(e) {
        return this.camera = e.camera.clone(), this.intensity = e.intensity, this.bias = e.bias, this.radius = e.radius, this.autoUpdate = e.autoUpdate, this.needsUpdate = e.needsUpdate, this.normalBias = e.normalBias, this.blurSamples = e.blurSamples, this.mapSize.copy(e.mapSize), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const e = {};
        return this.intensity !== 1 && (e.intensity = this.intensity), this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
    }
}
class $455d545b1dff00eb$var$DN extends $455d545b1dff00eb$var$sS {
    constructor(){
        super(new $455d545b1dff00eb$var$Ui(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1, this.aspect = 1;
    }
    updateMatrices(e) {
        const t = this.camera, n = $455d545b1dff00eb$var$Fd * 2 * e.angle * this.focus, i = this.mapSize.width / this.mapSize.height * this.aspect, r = e.distance || t.far;
        (n !== t.fov || i !== t.aspect || r !== t.far) && (t.fov = n, t.aspect = i, t.far = r, t.updateProjectionMatrix()), super.updateMatrices(e);
    }
    copy(e) {
        return super.copy(e), this.focus = e.focus, this;
    }
}
class $455d545b1dff00eb$var$oA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t, n = 0, i = Math.PI / 3, r = 0, l = 2){
        super(e, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy($455d545b1dff00eb$var$Pn.DEFAULT_UP), this.updateMatrix(), this.target = new $455d545b1dff00eb$var$Pn, this.distance = n, this.angle = i, this.penumbra = r, this.decay = l, this.map = null, this.shadow = new $455d545b1dff00eb$var$DN;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(e) {
        this.intensity = e / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e, t) {
        return super.copy(e, t), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
    }
}
const $455d545b1dff00eb$var$AM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Dm = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$l_ = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$UN extends $455d545b1dff00eb$var$sS {
    constructor(){
        super(new $455d545b1dff00eb$var$Ui(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new $455d545b1dff00eb$var$$e(4, 2), this._viewportCount = 6, this._viewports = [
            new $455d545b1dff00eb$var$Un(2, 1, 1, 1),
            new $455d545b1dff00eb$var$Un(0, 1, 1, 1),
            new $455d545b1dff00eb$var$Un(3, 1, 1, 1),
            new $455d545b1dff00eb$var$Un(1, 1, 1, 1),
            new $455d545b1dff00eb$var$Un(3, 0, 1, 1),
            new $455d545b1dff00eb$var$Un(1, 0, 1, 1)
        ], this._cubeDirections = [
            new $455d545b1dff00eb$var$J(1, 0, 0),
            new $455d545b1dff00eb$var$J(-1, 0, 0),
            new $455d545b1dff00eb$var$J(0, 0, 1),
            new $455d545b1dff00eb$var$J(0, 0, -1),
            new $455d545b1dff00eb$var$J(0, 1, 0),
            new $455d545b1dff00eb$var$J(0, -1, 0)
        ], this._cubeUps = [
            new $455d545b1dff00eb$var$J(0, 1, 0),
            new $455d545b1dff00eb$var$J(0, 1, 0),
            new $455d545b1dff00eb$var$J(0, 1, 0),
            new $455d545b1dff00eb$var$J(0, 1, 0),
            new $455d545b1dff00eb$var$J(0, 0, 1),
            new $455d545b1dff00eb$var$J(0, 0, -1)
        ];
    }
    updateMatrices(e, t = 0) {
        const n = this.camera, i = this.matrix, r = e.distance || n.far;
        r !== n.far && (n.far = r, n.updateProjectionMatrix()), $455d545b1dff00eb$var$Dm.setFromMatrixPosition(e.matrixWorld), n.position.copy($455d545b1dff00eb$var$Dm), $455d545b1dff00eb$var$l_.copy(n.position), $455d545b1dff00eb$var$l_.add(this._cubeDirections[t]), n.up.copy(this._cubeUps[t]), n.lookAt($455d545b1dff00eb$var$l_), n.updateMatrixWorld(), i.makeTranslation(-$455d545b1dff00eb$var$Dm.x, -$455d545b1dff00eb$var$Dm.y, -$455d545b1dff00eb$var$Dm.z), $455d545b1dff00eb$var$AM.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix($455d545b1dff00eb$var$AM, n.coordinateSystem, n.reversedDepth);
    }
}
class $455d545b1dff00eb$var$lA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t, n = 0, i = 2){
        super(e, t), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new $455d545b1dff00eb$var$UN;
    }
    get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(e) {
        this.intensity = e / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e, t) {
        return super.copy(e, t), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
    }
}
class $455d545b1dff00eb$var$bl extends $455d545b1dff00eb$var$hy {
    constructor(e = -1, t = 1, n = 1, i = -1, r = .1, l = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = i, this.near = r, this.far = l, this.updateProjectionMatrix();
    }
    copy(e, t) {
        return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
    }
    setViewOffset(e, t, n, i, r, l) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = l, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
        let r = n - e, l = n + e, c = i + t, f = i - t;
        if (this.view !== null && this.view.enabled) {
            const p = (this.right - this.left) / this.view.fullWidth / this.zoom, m = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            r += p * this.view.offsetX, l = r + p * this.view.width, c -= m * this.view.offsetY, f = c - m * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(r, l, c, f, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
    }
}
class $455d545b1dff00eb$var$NN extends $455d545b1dff00eb$var$sS {
    constructor(){
        super(new $455d545b1dff00eb$var$bl(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}
class $455d545b1dff00eb$var$cA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t){
        super(e, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy($455d545b1dff00eb$var$Pn.DEFAULT_UP), this.updateMatrix(), this.target = new $455d545b1dff00eb$var$Pn, this.shadow = new $455d545b1dff00eb$var$NN;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(e) {
        return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
    }
}
class $455d545b1dff00eb$var$uA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t){
        super(e, t), this.isAmbientLight = !0, this.type = "AmbientLight";
    }
}
class $455d545b1dff00eb$var$fA extends $455d545b1dff00eb$var$Uu {
    constructor(e, t, n = 10, i = 10){
        super(e, t), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = n, this.height = i;
    }
    get power() {
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(e) {
        this.intensity = e / (this.width * this.height * Math.PI);
    }
    copy(e) {
        return super.copy(e), this.width = e.width, this.height = e.height, this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.width = this.width, t.object.height = this.height, t;
    }
}
class $455d545b1dff00eb$var$hA {
    constructor(){
        this.isSphericalHarmonics3 = !0, this.coefficients = [];
        for(let e = 0; e < 9; e++)this.coefficients.push(new $455d545b1dff00eb$var$J);
    }
    set(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].copy(e[t]);
        return this;
    }
    zero() {
        for(let e = 0; e < 9; e++)this.coefficients[e].set(0, 0, 0);
        return this;
    }
    getAt(e, t) {
        const n = e.x, i = e.y, r = e.z, l = this.coefficients;
        return t.copy(l[0]).multiplyScalar(.282095), t.addScaledVector(l[1], .488603 * i), t.addScaledVector(l[2], .488603 * r), t.addScaledVector(l[3], .488603 * n), t.addScaledVector(l[4], 1.092548 * (n * i)), t.addScaledVector(l[5], 1.092548 * (i * r)), t.addScaledVector(l[6], .315392 * (3 * r * r - 1)), t.addScaledVector(l[7], 1.092548 * (n * r)), t.addScaledVector(l[8], .546274 * (n * n - i * i)), t;
    }
    getIrradianceAt(e, t) {
        const n = e.x, i = e.y, r = e.z, l = this.coefficients;
        return t.copy(l[0]).multiplyScalar(.886227), t.addScaledVector(l[1], 1.023328 * i), t.addScaledVector(l[2], 1.023328 * r), t.addScaledVector(l[3], 1.023328 * n), t.addScaledVector(l[4], 0.858086 * n * i), t.addScaledVector(l[5], 0.858086 * i * r), t.addScaledVector(l[6], .743125 * r * r - .247708), t.addScaledVector(l[7], 0.858086 * n * r), t.addScaledVector(l[8], .429043 * (n * n - i * i)), t;
    }
    add(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].add(e.coefficients[t]);
        return this;
    }
    addScaledSH(e, t) {
        for(let n = 0; n < 9; n++)this.coefficients[n].addScaledVector(e.coefficients[n], t);
        return this;
    }
    scale(e) {
        for(let t = 0; t < 9; t++)this.coefficients[t].multiplyScalar(e);
        return this;
    }
    lerp(e, t) {
        for(let n = 0; n < 9; n++)this.coefficients[n].lerp(e.coefficients[n], t);
        return this;
    }
    equals(e) {
        for(let t = 0; t < 9; t++)if (!this.coefficients[t].equals(e.coefficients[t])) return !1;
        return !0;
    }
    copy(e) {
        return this.set(e.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(e, t = 0) {
        const n = this.coefficients;
        for(let i = 0; i < 9; i++)n[i].fromArray(e, t + i * 3);
        return this;
    }
    toArray(e = [], t = 0) {
        const n = this.coefficients;
        for(let i = 0; i < 9; i++)n[i].toArray(e, t + i * 3);
        return e;
    }
    static getBasisAt(e, t) {
        const n = e.x, i = e.y, r = e.z;
        t[0] = .282095, t[1] = .488603 * i, t[2] = .488603 * r, t[3] = .488603 * n, t[4] = 1.092548 * n * i, t[5] = 1.092548 * i * r, t[6] = .315392 * (3 * r * r - 1), t[7] = 1.092548 * n * r, t[8] = .546274 * (n * n - i * i);
    }
}
class $455d545b1dff00eb$var$dA extends $455d545b1dff00eb$var$Uu {
    constructor(e = new $455d545b1dff00eb$var$hA, t = 1){
        super(void 0, t), this.isLightProbe = !0, this.sh = e;
    }
    copy(e) {
        return super.copy(e), this.sh.copy(e.sh), this;
    }
    fromJSON(e) {
        return this.intensity = e.intensity, this.sh.fromArray(e.sh), this;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.object.sh = this.sh.toArray(), t;
    }
}
class $455d545b1dff00eb$var$Py extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e), this.textures = {};
    }
    load(e, t, n, i) {
        const r = this, l = new $455d545b1dff00eb$var$Ec(r.manager);
        l.setPath(r.path), l.setRequestHeader(r.requestHeader), l.setWithCredentials(r.withCredentials), l.load(e, function(c) {
            try {
                t(r.parse(JSON.parse(c)));
            } catch (f) {
                i ? i(f) : $455d545b1dff00eb$var$Qt(f), r.manager.itemError(e);
            }
        }, n, i);
    }
    parse(e) {
        const t = this.textures;
        function n(r) {
            return t[r] === void 0 && $455d545b1dff00eb$var$Mt("MaterialLoader: Undefined texture", r), t[r];
        }
        const i = this.createMaterialFromType(e.type);
        if (e.uuid !== void 0 && (i.uuid = e.uuid), e.name !== void 0 && (i.name = e.name), e.color !== void 0 && i.color !== void 0 && i.color.setHex(e.color), e.roughness !== void 0 && (i.roughness = e.roughness), e.metalness !== void 0 && (i.metalness = e.metalness), e.sheen !== void 0 && (i.sheen = e.sheen), e.sheenColor !== void 0 && (i.sheenColor = new $455d545b1dff00eb$var$_t().setHex(e.sheenColor)), e.sheenRoughness !== void 0 && (i.sheenRoughness = e.sheenRoughness), e.emissive !== void 0 && i.emissive !== void 0 && i.emissive.setHex(e.emissive), e.specular !== void 0 && i.specular !== void 0 && i.specular.setHex(e.specular), e.specularIntensity !== void 0 && (i.specularIntensity = e.specularIntensity), e.specularColor !== void 0 && i.specularColor !== void 0 && i.specularColor.setHex(e.specularColor), e.shininess !== void 0 && (i.shininess = e.shininess), e.clearcoat !== void 0 && (i.clearcoat = e.clearcoat), e.clearcoatRoughness !== void 0 && (i.clearcoatRoughness = e.clearcoatRoughness), e.dispersion !== void 0 && (i.dispersion = e.dispersion), e.iridescence !== void 0 && (i.iridescence = e.iridescence), e.iridescenceIOR !== void 0 && (i.iridescenceIOR = e.iridescenceIOR), e.iridescenceThicknessRange !== void 0 && (i.iridescenceThicknessRange = e.iridescenceThicknessRange), e.transmission !== void 0 && (i.transmission = e.transmission), e.thickness !== void 0 && (i.thickness = e.thickness), e.attenuationDistance !== void 0 && (i.attenuationDistance = e.attenuationDistance), e.attenuationColor !== void 0 && i.attenuationColor !== void 0 && i.attenuationColor.setHex(e.attenuationColor), e.anisotropy !== void 0 && (i.anisotropy = e.anisotropy), e.anisotropyRotation !== void 0 && (i.anisotropyRotation = e.anisotropyRotation), e.fog !== void 0 && (i.fog = e.fog), e.flatShading !== void 0 && (i.flatShading = e.flatShading), e.blending !== void 0 && (i.blending = e.blending), e.combine !== void 0 && (i.combine = e.combine), e.side !== void 0 && (i.side = e.side), e.shadowSide !== void 0 && (i.shadowSide = e.shadowSide), e.opacity !== void 0 && (i.opacity = e.opacity), e.transparent !== void 0 && (i.transparent = e.transparent), e.alphaTest !== void 0 && (i.alphaTest = e.alphaTest), e.alphaHash !== void 0 && (i.alphaHash = e.alphaHash), e.depthFunc !== void 0 && (i.depthFunc = e.depthFunc), e.depthTest !== void 0 && (i.depthTest = e.depthTest), e.depthWrite !== void 0 && (i.depthWrite = e.depthWrite), e.colorWrite !== void 0 && (i.colorWrite = e.colorWrite), e.blendSrc !== void 0 && (i.blendSrc = e.blendSrc), e.blendDst !== void 0 && (i.blendDst = e.blendDst), e.blendEquation !== void 0 && (i.blendEquation = e.blendEquation), e.blendSrcAlpha !== void 0 && (i.blendSrcAlpha = e.blendSrcAlpha), e.blendDstAlpha !== void 0 && (i.blendDstAlpha = e.blendDstAlpha), e.blendEquationAlpha !== void 0 && (i.blendEquationAlpha = e.blendEquationAlpha), e.blendColor !== void 0 && i.blendColor !== void 0 && i.blendColor.setHex(e.blendColor), e.blendAlpha !== void 0 && (i.blendAlpha = e.blendAlpha), e.stencilWriteMask !== void 0 && (i.stencilWriteMask = e.stencilWriteMask), e.stencilFunc !== void 0 && (i.stencilFunc = e.stencilFunc), e.stencilRef !== void 0 && (i.stencilRef = e.stencilRef), e.stencilFuncMask !== void 0 && (i.stencilFuncMask = e.stencilFuncMask), e.stencilFail !== void 0 && (i.stencilFail = e.stencilFail), e.stencilZFail !== void 0 && (i.stencilZFail = e.stencilZFail), e.stencilZPass !== void 0 && (i.stencilZPass = e.stencilZPass), e.stencilWrite !== void 0 && (i.stencilWrite = e.stencilWrite), e.wireframe !== void 0 && (i.wireframe = e.wireframe), e.wireframeLinewidth !== void 0 && (i.wireframeLinewidth = e.wireframeLinewidth), e.wireframeLinecap !== void 0 && (i.wireframeLinecap = e.wireframeLinecap), e.wireframeLinejoin !== void 0 && (i.wireframeLinejoin = e.wireframeLinejoin), e.rotation !== void 0 && (i.rotation = e.rotation), e.linewidth !== void 0 && (i.linewidth = e.linewidth), e.dashSize !== void 0 && (i.dashSize = e.dashSize), e.gapSize !== void 0 && (i.gapSize = e.gapSize), e.scale !== void 0 && (i.scale = e.scale), e.polygonOffset !== void 0 && (i.polygonOffset = e.polygonOffset), e.polygonOffsetFactor !== void 0 && (i.polygonOffsetFactor = e.polygonOffsetFactor), e.polygonOffsetUnits !== void 0 && (i.polygonOffsetUnits = e.polygonOffsetUnits), e.dithering !== void 0 && (i.dithering = e.dithering), e.alphaToCoverage !== void 0 && (i.alphaToCoverage = e.alphaToCoverage), e.premultipliedAlpha !== void 0 && (i.premultipliedAlpha = e.premultipliedAlpha), e.forceSinglePass !== void 0 && (i.forceSinglePass = e.forceSinglePass), e.visible !== void 0 && (i.visible = e.visible), e.toneMapped !== void 0 && (i.toneMapped = e.toneMapped), e.userData !== void 0 && (i.userData = e.userData), e.vertexColors !== void 0 && (typeof e.vertexColors == "number" ? i.vertexColors = e.vertexColors > 0 : i.vertexColors = e.vertexColors), e.uniforms !== void 0) for(const r in e.uniforms){
            const l = e.uniforms[r];
            switch(i.uniforms[r] = {}, l.type){
                case "t":
                    i.uniforms[r].value = n(l.value);
                    break;
                case "c":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$_t().setHex(l.value);
                    break;
                case "v2":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$$e().fromArray(l.value);
                    break;
                case "v3":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$J().fromArray(l.value);
                    break;
                case "v4":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$Un().fromArray(l.value);
                    break;
                case "m3":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$Jt().fromArray(l.value);
                    break;
                case "m4":
                    i.uniforms[r].value = new $455d545b1dff00eb$var$Ft().fromArray(l.value);
                    break;
                default:
                    i.uniforms[r].value = l.value;
            }
        }
        if (e.defines !== void 0 && (i.defines = e.defines), e.vertexShader !== void 0 && (i.vertexShader = e.vertexShader), e.fragmentShader !== void 0 && (i.fragmentShader = e.fragmentShader), e.glslVersion !== void 0 && (i.glslVersion = e.glslVersion), e.extensions !== void 0) for(const r in e.extensions)i.extensions[r] = e.extensions[r];
        if (e.lights !== void 0 && (i.lights = e.lights), e.clipping !== void 0 && (i.clipping = e.clipping), e.size !== void 0 && (i.size = e.size), e.sizeAttenuation !== void 0 && (i.sizeAttenuation = e.sizeAttenuation), e.map !== void 0 && (i.map = n(e.map)), e.matcap !== void 0 && (i.matcap = n(e.matcap)), e.alphaMap !== void 0 && (i.alphaMap = n(e.alphaMap)), e.bumpMap !== void 0 && (i.bumpMap = n(e.bumpMap)), e.bumpScale !== void 0 && (i.bumpScale = e.bumpScale), e.normalMap !== void 0 && (i.normalMap = n(e.normalMap)), e.normalMapType !== void 0 && (i.normalMapType = e.normalMapType), e.normalScale !== void 0) {
            let r = e.normalScale;
            Array.isArray(r) === !1 && (r = [
                r,
                r
            ]), i.normalScale = new $455d545b1dff00eb$var$$e().fromArray(r);
        }
        return e.displacementMap !== void 0 && (i.displacementMap = n(e.displacementMap)), e.displacementScale !== void 0 && (i.displacementScale = e.displacementScale), e.displacementBias !== void 0 && (i.displacementBias = e.displacementBias), e.roughnessMap !== void 0 && (i.roughnessMap = n(e.roughnessMap)), e.metalnessMap !== void 0 && (i.metalnessMap = n(e.metalnessMap)), e.emissiveMap !== void 0 && (i.emissiveMap = n(e.emissiveMap)), e.emissiveIntensity !== void 0 && (i.emissiveIntensity = e.emissiveIntensity), e.specularMap !== void 0 && (i.specularMap = n(e.specularMap)), e.specularIntensityMap !== void 0 && (i.specularIntensityMap = n(e.specularIntensityMap)), e.specularColorMap !== void 0 && (i.specularColorMap = n(e.specularColorMap)), e.envMap !== void 0 && (i.envMap = n(e.envMap)), e.envMapRotation !== void 0 && i.envMapRotation.fromArray(e.envMapRotation), e.envMapIntensity !== void 0 && (i.envMapIntensity = e.envMapIntensity), e.reflectivity !== void 0 && (i.reflectivity = e.reflectivity), e.refractionRatio !== void 0 && (i.refractionRatio = e.refractionRatio), e.lightMap !== void 0 && (i.lightMap = n(e.lightMap)), e.lightMapIntensity !== void 0 && (i.lightMapIntensity = e.lightMapIntensity), e.aoMap !== void 0 && (i.aoMap = n(e.aoMap)), e.aoMapIntensity !== void 0 && (i.aoMapIntensity = e.aoMapIntensity), e.gradientMap !== void 0 && (i.gradientMap = n(e.gradientMap)), e.clearcoatMap !== void 0 && (i.clearcoatMap = n(e.clearcoatMap)), e.clearcoatRoughnessMap !== void 0 && (i.clearcoatRoughnessMap = n(e.clearcoatRoughnessMap)), e.clearcoatNormalMap !== void 0 && (i.clearcoatNormalMap = n(e.clearcoatNormalMap)), e.clearcoatNormalScale !== void 0 && (i.clearcoatNormalScale = new $455d545b1dff00eb$var$$e().fromArray(e.clearcoatNormalScale)), e.iridescenceMap !== void 0 && (i.iridescenceMap = n(e.iridescenceMap)), e.iridescenceThicknessMap !== void 0 && (i.iridescenceThicknessMap = n(e.iridescenceThicknessMap)), e.transmissionMap !== void 0 && (i.transmissionMap = n(e.transmissionMap)), e.thicknessMap !== void 0 && (i.thicknessMap = n(e.thicknessMap)), e.anisotropyMap !== void 0 && (i.anisotropyMap = n(e.anisotropyMap)), e.sheenColorMap !== void 0 && (i.sheenColorMap = n(e.sheenColorMap)), e.sheenRoughnessMap !== void 0 && (i.sheenRoughnessMap = n(e.sheenRoughnessMap)), i;
    }
    setTextures(e) {
        return this.textures = e, this;
    }
    createMaterialFromType(e) {
        return $455d545b1dff00eb$var$Py.createMaterialFromType(e);
    }
    static createMaterialFromType(e) {
        const t = {
            ShadowMaterial: $455d545b1dff00eb$var$XT,
            SpriteMaterial: $455d545b1dff00eb$var$Wb,
            RawShaderMaterial: $455d545b1dff00eb$var$WT,
            ShaderMaterial: $455d545b1dff00eb$var$qs,
            PointsMaterial: $455d545b1dff00eb$var$Yb,
            MeshPhysicalMaterial: $455d545b1dff00eb$var$qT,
            MeshStandardMaterial: $455d545b1dff00eb$var$Oy,
            MeshPhongMaterial: $455d545b1dff00eb$var$YT,
            MeshToonMaterial: $455d545b1dff00eb$var$ZT,
            MeshNormalMaterial: $455d545b1dff00eb$var$QT,
            MeshLambertMaterial: $455d545b1dff00eb$var$KT,
            MeshDepthMaterial: $455d545b1dff00eb$var$Ly,
            MeshDistanceMaterial: $455d545b1dff00eb$var$zy,
            MeshBasicMaterial: $455d545b1dff00eb$var$Ac,
            MeshMatcapMaterial: $455d545b1dff00eb$var$JT,
            LineDashedMaterial: $455d545b1dff00eb$var$$T,
            LineBasicMaterial: $455d545b1dff00eb$var$Nr,
            Material: $455d545b1dff00eb$var$rr
        };
        return new t[e];
    }
}
class $455d545b1dff00eb$var$nb {
    static extractUrlBase(e) {
        const t = e.lastIndexOf("/");
        return t === -1 ? "./" : e.slice(0, t + 1);
    }
    static resolveURL(e, t) {
        return typeof e != "string" || e === "" ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e) ? e : t + e);
    }
}
class $455d545b1dff00eb$var$oS extends $455d545b1dff00eb$var$nn {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(e) {
        return super.copy(e), this.instanceCount = e.instanceCount, this;
    }
    toJSON() {
        const e = super.toJSON();
        return e.instanceCount = this.instanceCount, e.isInstancedBufferGeometry = !0, e;
    }
}
class $455d545b1dff00eb$var$pA extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = new $455d545b1dff00eb$var$Ec(r.manager);
        l.setPath(r.path), l.setRequestHeader(r.requestHeader), l.setWithCredentials(r.withCredentials), l.load(e, function(c) {
            try {
                t(r.parse(JSON.parse(c)));
            } catch (f) {
                i ? i(f) : $455d545b1dff00eb$var$Qt(f), r.manager.itemError(e);
            }
        }, n, i);
    }
    parse(e) {
        const t = {}, n = {};
        function i(_, S) {
            if (t[S] !== void 0) return t[S];
            const M = _.interleavedBuffers[S], b = r(_, M.buffer), C = $455d545b1dff00eb$var$wd(M.type, b), R = new $455d545b1dff00eb$var$my(C, M.stride);
            return R.uuid = M.uuid, t[S] = R, R;
        }
        function r(_, S) {
            if (n[S] !== void 0) return n[S];
            const M = _.arrayBuffers[S], b = new Uint32Array(M).buffer;
            return n[S] = b, b;
        }
        const l = e.isInstancedBufferGeometry ? new $455d545b1dff00eb$var$oS : new $455d545b1dff00eb$var$nn, c = e.data.index;
        if (c !== void 0) {
            const _ = $455d545b1dff00eb$var$wd(c.type, c.array);
            l.setIndex(new $455d545b1dff00eb$var$ti(_, 1));
        }
        const f = e.data.attributes;
        for(const _ in f){
            const S = f[_];
            let A;
            if (S.isInterleavedBufferAttribute) {
                const M = i(e.data, S.data);
                A = new $455d545b1dff00eb$var$Xf(M, S.itemSize, S.offset, S.normalized);
            } else {
                const M = $455d545b1dff00eb$var$wd(S.type, S.array), b = S.isInstancedBufferAttribute ? $455d545b1dff00eb$var$Wf : $455d545b1dff00eb$var$ti;
                A = new b(M, S.itemSize, S.normalized);
            }
            S.name !== void 0 && (A.name = S.name), S.usage !== void 0 && A.setUsage(S.usage), l.setAttribute(_, A);
        }
        const p = e.data.morphAttributes;
        if (p) for(const _ in p){
            const S = p[_], A = [];
            for(let M = 0, b = S.length; M < b; M++){
                const C = S[M];
                let R;
                if (C.isInterleavedBufferAttribute) {
                    const N = i(e.data, C.data);
                    R = new $455d545b1dff00eb$var$Xf(N, C.itemSize, C.offset, C.normalized);
                } else {
                    const N = $455d545b1dff00eb$var$wd(C.type, C.array);
                    R = new $455d545b1dff00eb$var$ti(N, C.itemSize, C.normalized);
                }
                C.name !== void 0 && (R.name = C.name), A.push(R);
            }
            l.morphAttributes[_] = A;
        }
        e.data.morphTargetsRelative && (l.morphTargetsRelative = !0);
        const x = e.data.groups || e.data.drawcalls || e.data.offsets;
        if (x !== void 0) for(let _ = 0, S = x.length; _ !== S; ++_){
            const A = x[_];
            l.addGroup(A.start, A.count, A.materialIndex);
        }
        const v = e.data.boundingSphere;
        return v !== void 0 && (l.boundingSphere = new $455d545b1dff00eb$var$Ta().fromJSON(v)), e.name && (l.name = e.name), e.userData && (l.userData = e.userData), l;
    }
}
class $455d545b1dff00eb$var$ON extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = this.path === "" ? $455d545b1dff00eb$var$nb.extractUrlBase(e) : this.path;
        this.resourcePath = this.resourcePath || l;
        const c = new $455d545b1dff00eb$var$Ec(this.manager);
        c.setPath(this.path), c.setRequestHeader(this.requestHeader), c.setWithCredentials(this.withCredentials), c.load(e, function(f) {
            let p = null;
            try {
                p = JSON.parse(f);
            } catch (x) {
                i !== void 0 && i(x), x("ObjectLoader: Can't parse " + e + ".", x.message);
                return;
            }
            const m = p.metadata;
            if (m === void 0 || m.type === void 0 || m.type.toLowerCase() === "geometry") {
                i !== void 0 && i(new Error("THREE.ObjectLoader: Can't load " + e)), $455d545b1dff00eb$var$Qt("ObjectLoader: Can't load " + e);
                return;
            }
            r.parse(p, t);
        }, n, i);
    }
    async loadAsync(e, t) {
        const n = this, i = this.path === "" ? $455d545b1dff00eb$var$nb.extractUrlBase(e) : this.path;
        this.resourcePath = this.resourcePath || i;
        const r = new $455d545b1dff00eb$var$Ec(this.manager);
        r.setPath(this.path), r.setRequestHeader(this.requestHeader), r.setWithCredentials(this.withCredentials);
        const l = await r.loadAsync(e, t), c = JSON.parse(l), f = c.metadata;
        if (f === void 0 || f.type === void 0 || f.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + e);
        return await n.parseAsync(c);
    }
    parse(e, t) {
        const n = this.parseAnimations(e.animations), i = this.parseShapes(e.shapes), r = this.parseGeometries(e.geometries, i), l = this.parseImages(e.images, function() {
            t !== void 0 && t(p);
        }), c = this.parseTextures(e.textures, l), f = this.parseMaterials(e.materials, c), p = this.parseObject(e.object, r, f, c, n), m = this.parseSkeletons(e.skeletons, p);
        if (this.bindSkeletons(p, m), this.bindLightTargets(p), t !== void 0) {
            let x = !1;
            for(const v in l)if (l[v].data instanceof HTMLImageElement) {
                x = !0;
                break;
            }
            x === !1 && t(p);
        }
        return p;
    }
    async parseAsync(e) {
        const t = this.parseAnimations(e.animations), n = this.parseShapes(e.shapes), i = this.parseGeometries(e.geometries, n), r = await this.parseImagesAsync(e.images), l = this.parseTextures(e.textures, r), c = this.parseMaterials(e.materials, l), f = this.parseObject(e.object, i, c, l, t), p = this.parseSkeletons(e.skeletons, f);
        return this.bindSkeletons(f, p), this.bindLightTargets(f), f;
    }
    parseShapes(e) {
        const t = {};
        if (e !== void 0) for(let n = 0, i = e.length; n < i; n++){
            const r = new $455d545b1dff00eb$var$Vf().fromJSON(e[n]);
            t[r.uuid] = r;
        }
        return t;
    }
    parseSkeletons(e, t) {
        const n = {}, i = {};
        if (t.traverse(function(r) {
            r.isBone && (i[r.uuid] = r);
        }), e !== void 0) for(let r = 0, l = e.length; r < l; r++){
            const c = new $455d545b1dff00eb$var$gy().fromJSON(e[r], i);
            n[c.uuid] = c;
        }
        return n;
    }
    parseGeometries(e, t) {
        const n = {};
        if (e !== void 0) {
            const i = new $455d545b1dff00eb$var$pA;
            for(let r = 0, l = e.length; r < l; r++){
                let c;
                const f = e[r];
                switch(f.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        c = i.parse(f);
                        break;
                    default:
                        f.type in $455d545b1dff00eb$var$MM ? c = $455d545b1dff00eb$var$MM[f.type].fromJSON(f, t) : $455d545b1dff00eb$var$Mt(`ObjectLoader: Unsupported geometry type "${f.type}"`);
                }
                c.uuid = f.uuid, f.name !== void 0 && (c.name = f.name), f.userData !== void 0 && (c.userData = f.userData), n[f.uuid] = c;
            }
        }
        return n;
    }
    parseMaterials(e, t) {
        const n = {}, i = {};
        if (e !== void 0) {
            const r = new $455d545b1dff00eb$var$Py;
            r.setTextures(t);
            for(let l = 0, c = e.length; l < c; l++){
                const f = e[l];
                n[f.uuid] === void 0 && (n[f.uuid] = r.parse(f)), i[f.uuid] = n[f.uuid];
            }
        }
        return i;
    }
    parseAnimations(e) {
        const t = {};
        if (e !== void 0) for(let n = 0; n < e.length; n++){
            const i = e[n], r = $455d545b1dff00eb$var$d0.parse(i);
            t[r.uuid] = r;
        }
        return t;
    }
    parseImages(e, t) {
        const n = this, i = {};
        let r;
        function l(f) {
            return n.manager.itemStart(f), r.load(f, function() {
                n.manager.itemEnd(f);
            }, void 0, function() {
                n.manager.itemError(f), n.manager.itemEnd(f);
            });
        }
        function c(f) {
            if (typeof f == "string") {
                const p = f, m = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(p) ? p : n.resourcePath + p;
                return l(m);
            } else return f.data ? {
                data: $455d545b1dff00eb$var$wd(f.type, f.data),
                width: f.width,
                height: f.height
            } : null;
        }
        if (e !== void 0 && e.length > 0) {
            const f = new $455d545b1dff00eb$var$rS(t);
            r = new $455d545b1dff00eb$var$p0(f), r.setCrossOrigin(this.crossOrigin);
            for(let p = 0, m = e.length; p < m; p++){
                const x = e[p], v = x.url;
                if (Array.isArray(v)) {
                    const _ = [];
                    for(let S = 0, A = v.length; S < A; S++){
                        const M = v[S], b = c(M);
                        b !== null && (b instanceof HTMLImageElement ? _.push(b) : _.push(new $455d545b1dff00eb$var$Ro(b.data, b.width, b.height)));
                    }
                    i[x.uuid] = new $455d545b1dff00eb$var$_u(_);
                } else {
                    const _ = c(x.url);
                    i[x.uuid] = new $455d545b1dff00eb$var$_u(_);
                }
            }
        }
        return i;
    }
    async parseImagesAsync(e) {
        const t = this, n = {};
        let i;
        async function r(l) {
            if (typeof l == "string") {
                const c = l, f = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(c) ? c : t.resourcePath + c;
                return await i.loadAsync(f);
            } else return l.data ? {
                data: $455d545b1dff00eb$var$wd(l.type, l.data),
                width: l.width,
                height: l.height
            } : null;
        }
        if (e !== void 0 && e.length > 0) {
            i = new $455d545b1dff00eb$var$p0(this.manager), i.setCrossOrigin(this.crossOrigin);
            for(let l = 0, c = e.length; l < c; l++){
                const f = e[l], p = f.url;
                if (Array.isArray(p)) {
                    const m = [];
                    for(let x = 0, v = p.length; x < v; x++){
                        const _ = p[x], S = await r(_);
                        S !== null && (S instanceof HTMLImageElement ? m.push(S) : m.push(new $455d545b1dff00eb$var$Ro(S.data, S.width, S.height)));
                    }
                    n[f.uuid] = new $455d545b1dff00eb$var$_u(m);
                } else {
                    const m = await r(f.url);
                    n[f.uuid] = new $455d545b1dff00eb$var$_u(m);
                }
            }
        }
        return n;
    }
    parseTextures(e, t) {
        function n(r, l) {
            return typeof r == "number" ? r : ($455d545b1dff00eb$var$Mt("ObjectLoader.parseTexture: Constant should be in numeric form.", r), l[r]);
        }
        const i = {};
        if (e !== void 0) for(let r = 0, l = e.length; r < l; r++){
            const c = e[r];
            c.image === void 0 && $455d545b1dff00eb$var$Mt('ObjectLoader: No "image" specified for', c.uuid), t[c.image] === void 0 && $455d545b1dff00eb$var$Mt("ObjectLoader: Undefined image", c.image);
            const f = t[c.image], p = f.data;
            let m;
            Array.isArray(p) ? (m = new $455d545b1dff00eb$var$E0, p.length === 6 && (m.needsUpdate = !0)) : (p && p.data ? m = new $455d545b1dff00eb$var$Ro : m = new $455d545b1dff00eb$var$Li, p && (m.needsUpdate = !0)), m.source = f, m.uuid = c.uuid, c.name !== void 0 && (m.name = c.name), c.mapping !== void 0 && (m.mapping = n(c.mapping, $455d545b1dff00eb$var$LN)), c.channel !== void 0 && (m.channel = c.channel), c.offset !== void 0 && m.offset.fromArray(c.offset), c.repeat !== void 0 && m.repeat.fromArray(c.repeat), c.center !== void 0 && m.center.fromArray(c.center), c.rotation !== void 0 && (m.rotation = c.rotation), c.wrap !== void 0 && (m.wrapS = n(c.wrap[0], $455d545b1dff00eb$var$wM), m.wrapT = n(c.wrap[1], $455d545b1dff00eb$var$wM)), c.format !== void 0 && (m.format = c.format), c.internalFormat !== void 0 && (m.internalFormat = c.internalFormat), c.type !== void 0 && (m.type = c.type), c.colorSpace !== void 0 && (m.colorSpace = c.colorSpace), c.minFilter !== void 0 && (m.minFilter = n(c.minFilter, $455d545b1dff00eb$var$CM)), c.magFilter !== void 0 && (m.magFilter = n(c.magFilter, $455d545b1dff00eb$var$CM)), c.anisotropy !== void 0 && (m.anisotropy = c.anisotropy), c.flipY !== void 0 && (m.flipY = c.flipY), c.generateMipmaps !== void 0 && (m.generateMipmaps = c.generateMipmaps), c.premultiplyAlpha !== void 0 && (m.premultiplyAlpha = c.premultiplyAlpha), c.unpackAlignment !== void 0 && (m.unpackAlignment = c.unpackAlignment), c.compareFunction !== void 0 && (m.compareFunction = c.compareFunction), c.userData !== void 0 && (m.userData = c.userData), i[c.uuid] = m;
        }
        return i;
    }
    parseObject(e, t, n, i, r) {
        let l;
        function c(v) {
            return t[v] === void 0 && $455d545b1dff00eb$var$Mt("ObjectLoader: Undefined geometry", v), t[v];
        }
        function f(v) {
            if (v !== void 0) {
                if (Array.isArray(v)) {
                    const _ = [];
                    for(let S = 0, A = v.length; S < A; S++){
                        const M = v[S];
                        n[M] === void 0 && $455d545b1dff00eb$var$Mt("ObjectLoader: Undefined material", M), _.push(n[M]);
                    }
                    return _;
                }
                return n[v] === void 0 && $455d545b1dff00eb$var$Mt("ObjectLoader: Undefined material", v), n[v];
            }
        }
        function p(v) {
            return i[v] === void 0 && $455d545b1dff00eb$var$Mt("ObjectLoader: Undefined texture", v), i[v];
        }
        let m, x;
        switch(e.type){
            case "Scene":
                l = new $455d545b1dff00eb$var$Xb, e.background !== void 0 && (Number.isInteger(e.background) ? l.background = new $455d545b1dff00eb$var$_t(e.background) : l.background = p(e.background)), e.environment !== void 0 && (l.environment = p(e.environment)), e.fog !== void 0 && (e.fog.type === "Fog" ? l.fog = new $455d545b1dff00eb$var$py(e.fog.color, e.fog.near, e.fog.far) : e.fog.type === "FogExp2" && (l.fog = new $455d545b1dff00eb$var$dy(e.fog.color, e.fog.density)), e.fog.name !== "" && (l.fog.name = e.fog.name)), e.backgroundBlurriness !== void 0 && (l.backgroundBlurriness = e.backgroundBlurriness), e.backgroundIntensity !== void 0 && (l.backgroundIntensity = e.backgroundIntensity), e.backgroundRotation !== void 0 && l.backgroundRotation.fromArray(e.backgroundRotation), e.environmentIntensity !== void 0 && (l.environmentIntensity = e.environmentIntensity), e.environmentRotation !== void 0 && l.environmentRotation.fromArray(e.environmentRotation);
                break;
            case "PerspectiveCamera":
                l = new $455d545b1dff00eb$var$Ui(e.fov, e.aspect, e.near, e.far), e.focus !== void 0 && (l.focus = e.focus), e.zoom !== void 0 && (l.zoom = e.zoom), e.filmGauge !== void 0 && (l.filmGauge = e.filmGauge), e.filmOffset !== void 0 && (l.filmOffset = e.filmOffset), e.view !== void 0 && (l.view = Object.assign({}, e.view));
                break;
            case "OrthographicCamera":
                l = new $455d545b1dff00eb$var$bl(e.left, e.right, e.top, e.bottom, e.near, e.far), e.zoom !== void 0 && (l.zoom = e.zoom), e.view !== void 0 && (l.view = Object.assign({}, e.view));
                break;
            case "AmbientLight":
                l = new $455d545b1dff00eb$var$uA(e.color, e.intensity);
                break;
            case "DirectionalLight":
                l = new $455d545b1dff00eb$var$cA(e.color, e.intensity), l.target = e.target || "";
                break;
            case "PointLight":
                l = new $455d545b1dff00eb$var$lA(e.color, e.intensity, e.distance, e.decay);
                break;
            case "RectAreaLight":
                l = new $455d545b1dff00eb$var$fA(e.color, e.intensity, e.width, e.height);
                break;
            case "SpotLight":
                l = new $455d545b1dff00eb$var$oA(e.color, e.intensity, e.distance, e.angle, e.penumbra, e.decay), l.target = e.target || "";
                break;
            case "HemisphereLight":
                l = new $455d545b1dff00eb$var$sA(e.color, e.groundColor, e.intensity);
                break;
            case "LightProbe":
                l = new $455d545b1dff00eb$var$dA().fromJSON(e);
                break;
            case "SkinnedMesh":
                m = c(e.geometry), x = f(e.material), l = new $455d545b1dff00eb$var$CT(m, x), e.bindMode !== void 0 && (l.bindMode = e.bindMode), e.bindMatrix !== void 0 && l.bindMatrix.fromArray(e.bindMatrix), e.skeleton !== void 0 && (l.skeleton = e.skeleton);
                break;
            case "Mesh":
                m = c(e.geometry), x = f(e.material), l = new $455d545b1dff00eb$var$zi(m, x);
                break;
            case "InstancedMesh":
                m = c(e.geometry), x = f(e.material);
                const v = e.count, _ = e.instanceMatrix, S = e.instanceColor;
                l = new $455d545b1dff00eb$var$RT(m, x, v), l.instanceMatrix = new $455d545b1dff00eb$var$Wf(new Float32Array(_.array), 16), S !== void 0 && (l.instanceColor = new $455d545b1dff00eb$var$Wf(new Float32Array(S.array), S.itemSize));
                break;
            case "BatchedMesh":
                m = c(e.geometry), x = f(e.material), l = new $455d545b1dff00eb$var$DT(e.maxInstanceCount, e.maxVertexCount, e.maxIndexCount, x), l.geometry = m, l.perObjectFrustumCulled = e.perObjectFrustumCulled, l.sortObjects = e.sortObjects, l._drawRanges = e.drawRanges, l._reservedRanges = e.reservedRanges, l._geometryInfo = e.geometryInfo.map((A)=>{
                    let M = null, b = null;
                    return A.boundingBox !== void 0 && (M = new $455d545b1dff00eb$var$ca().fromJSON(A.boundingBox)), A.boundingSphere !== void 0 && (b = new $455d545b1dff00eb$var$Ta().fromJSON(A.boundingSphere)), {
                        ...A,
                        boundingBox: M,
                        boundingSphere: b
                    };
                }), l._instanceInfo = e.instanceInfo, l._availableInstanceIds = e._availableInstanceIds, l._availableGeometryIds = e._availableGeometryIds, l._nextIndexStart = e.nextIndexStart, l._nextVertexStart = e.nextVertexStart, l._geometryCount = e.geometryCount, l._maxInstanceCount = e.maxInstanceCount, l._maxVertexCount = e.maxVertexCount, l._maxIndexCount = e.maxIndexCount, l._geometryInitialized = e.geometryInitialized, l._matricesTexture = p(e.matricesTexture.uuid), l._indirectTexture = p(e.indirectTexture.uuid), e.colorsTexture !== void 0 && (l._colorsTexture = p(e.colorsTexture.uuid)), e.boundingSphere !== void 0 && (l.boundingSphere = new $455d545b1dff00eb$var$Ta().fromJSON(e.boundingSphere)), e.boundingBox !== void 0 && (l.boundingBox = new $455d545b1dff00eb$var$ca().fromJSON(e.boundingBox));
                break;
            case "LOD":
                l = new $455d545b1dff00eb$var$wT;
                break;
            case "Line":
                l = new $455d545b1dff00eb$var$Tu(c(e.geometry), f(e.material));
                break;
            case "LineLoop":
                l = new $455d545b1dff00eb$var$UT(c(e.geometry), f(e.material));
                break;
            case "LineSegments":
                l = new $455d545b1dff00eb$var$El(c(e.geometry), f(e.material));
                break;
            case "PointCloud":
            case "Points":
                l = new $455d545b1dff00eb$var$NT(c(e.geometry), f(e.material));
                break;
            case "Sprite":
                l = new $455d545b1dff00eb$var$AT(f(e.material));
                break;
            case "Group":
                l = new $455d545b1dff00eb$var$Cd;
                break;
            case "Bone":
                l = new $455d545b1dff00eb$var$qb;
                break;
            default:
                l = new $455d545b1dff00eb$var$Pn;
        }
        if (l.uuid = e.uuid, e.name !== void 0 && (l.name = e.name), e.matrix !== void 0 ? (l.matrix.fromArray(e.matrix), e.matrixAutoUpdate !== void 0 && (l.matrixAutoUpdate = e.matrixAutoUpdate), l.matrixAutoUpdate && l.matrix.decompose(l.position, l.quaternion, l.scale)) : (e.position !== void 0 && l.position.fromArray(e.position), e.rotation !== void 0 && l.rotation.fromArray(e.rotation), e.quaternion !== void 0 && l.quaternion.fromArray(e.quaternion), e.scale !== void 0 && l.scale.fromArray(e.scale)), e.up !== void 0 && l.up.fromArray(e.up), e.castShadow !== void 0 && (l.castShadow = e.castShadow), e.receiveShadow !== void 0 && (l.receiveShadow = e.receiveShadow), e.shadow && (e.shadow.intensity !== void 0 && (l.shadow.intensity = e.shadow.intensity), e.shadow.bias !== void 0 && (l.shadow.bias = e.shadow.bias), e.shadow.normalBias !== void 0 && (l.shadow.normalBias = e.shadow.normalBias), e.shadow.radius !== void 0 && (l.shadow.radius = e.shadow.radius), e.shadow.mapSize !== void 0 && l.shadow.mapSize.fromArray(e.shadow.mapSize), e.shadow.camera !== void 0 && (l.shadow.camera = this.parseObject(e.shadow.camera))), e.visible !== void 0 && (l.visible = e.visible), e.frustumCulled !== void 0 && (l.frustumCulled = e.frustumCulled), e.renderOrder !== void 0 && (l.renderOrder = e.renderOrder), e.userData !== void 0 && (l.userData = e.userData), e.layers !== void 0 && (l.layers.mask = e.layers), e.children !== void 0) {
            const v = e.children;
            for(let _ = 0; _ < v.length; _++)l.add(this.parseObject(v[_], t, n, i, r));
        }
        if (e.animations !== void 0) {
            const v = e.animations;
            for(let _ = 0; _ < v.length; _++){
                const S = v[_];
                l.animations.push(r[S]);
            }
        }
        if (e.type === "LOD") {
            e.autoUpdate !== void 0 && (l.autoUpdate = e.autoUpdate);
            const v = e.levels;
            for(let _ = 0; _ < v.length; _++){
                const S = v[_], A = l.getObjectByProperty("uuid", S.object);
                A !== void 0 && l.addLevel(A, S.distance, S.hysteresis);
            }
        }
        return l;
    }
    bindSkeletons(e, t) {
        Object.keys(t).length !== 0 && e.traverse(function(n) {
            if (n.isSkinnedMesh === !0 && n.skeleton !== void 0) {
                const i = t[n.skeleton];
                i === void 0 ? $455d545b1dff00eb$var$Mt("ObjectLoader: No skeleton found with UUID:", n.skeleton) : n.bind(i, n.bindMatrix);
            }
        });
    }
    bindLightTargets(e) {
        e.traverse(function(t) {
            if (t.isDirectionalLight || t.isSpotLight) {
                const n = t.target, i = e.getObjectByProperty("uuid", n);
                i !== void 0 ? t.target = i : t.target = new $455d545b1dff00eb$var$Pn;
            }
        });
    }
}
const $455d545b1dff00eb$var$LN = {
    UVMapping: $455d545b1dff00eb$var$ty,
    CubeReflectionMapping: $455d545b1dff00eb$var$Sc,
    CubeRefractionMapping: $455d545b1dff00eb$var$Mu,
    EquirectangularReflectionMapping: $455d545b1dff00eb$var$Jm,
    EquirectangularRefractionMapping: $455d545b1dff00eb$var$$m,
    CubeUVReflectionMapping: $455d545b1dff00eb$var$Wd
}, $455d545b1dff00eb$var$wM = {
    RepeatWrapping: $455d545b1dff00eb$var$e0,
    ClampToEdgeWrapping: $455d545b1dff00eb$var$Kr,
    MirroredRepeatWrapping: $455d545b1dff00eb$var$t0
}, $455d545b1dff00eb$var$CM = {
    NearestFilter: $455d545b1dff00eb$var$Fa,
    NearestMipmapNearestFilter: $455d545b1dff00eb$var$Db,
    NearestMipmapLinearFilter: $455d545b1dff00eb$var$Ad,
    LinearFilter: $455d545b1dff00eb$var$mi,
    LinearMipmapNearestFilter: $455d545b1dff00eb$var$Fm,
    LinearMipmapLinearFilter: $455d545b1dff00eb$var$gl
}, $455d545b1dff00eb$var$c_ = new WeakMap;
class $455d545b1dff00eb$var$zN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e), this.isImageBitmapLoader = !0, typeof createImageBitmap > "u" && $455d545b1dff00eb$var$Mt("ImageBitmapLoader: createImageBitmap() not supported."), typeof fetch > "u" && $455d545b1dff00eb$var$Mt("ImageBitmapLoader: fetch() not supported."), this.options = {
            premultiplyAlpha: "none"
        }, this._abortController = new AbortController;
    }
    setOptions(e) {
        return this.options = e, this;
    }
    load(e, t, n, i) {
        e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
        const r = this, l = $455d545b1dff00eb$var$xl.get(`image-bitmap:${e}`);
        if (l !== void 0) {
            if (r.manager.itemStart(e), l.then) {
                l.then((p)=>{
                    if ($455d545b1dff00eb$var$c_.has(l) === !0) i && i($455d545b1dff00eb$var$c_.get(l)), r.manager.itemError(e), r.manager.itemEnd(e);
                    else return t && t(p), r.manager.itemEnd(e), p;
                });
                return;
            }
            return setTimeout(function() {
                t && t(l), r.manager.itemEnd(e);
            }, 0), l;
        }
        const c = {};
        c.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include", c.headers = this.requestHeader, c.signal = typeof AbortSignal.any == "function" ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const f = fetch(e, c).then(function(p) {
            return p.blob();
        }).then(function(p) {
            return createImageBitmap(p, Object.assign(r.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(p) {
            return $455d545b1dff00eb$var$xl.add(`image-bitmap:${e}`, p), t && t(p), r.manager.itemEnd(e), p;
        }).catch(function(p) {
            i && i(p), $455d545b1dff00eb$var$c_.set(f, p), $455d545b1dff00eb$var$xl.remove(`image-bitmap:${e}`), r.manager.itemError(e), r.manager.itemEnd(e);
        });
        $455d545b1dff00eb$var$xl.add(`image-bitmap:${e}`, f), r.manager.itemStart(e);
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
let $455d545b1dff00eb$var$wx;
class $455d545b1dff00eb$var$lS {
    static getContext() {
        return $455d545b1dff00eb$var$wx === void 0 && ($455d545b1dff00eb$var$wx = new (window.AudioContext || window.webkitAudioContext)), $455d545b1dff00eb$var$wx;
    }
    static setContext(e) {
        $455d545b1dff00eb$var$wx = e;
    }
}
class $455d545b1dff00eb$var$PN extends $455d545b1dff00eb$var$$r {
    constructor(e){
        super(e);
    }
    load(e, t, n, i) {
        const r = this, l = new $455d545b1dff00eb$var$Ec(this.manager);
        l.setResponseType("arraybuffer"), l.setPath(this.path), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, function(f) {
            try {
                const p = f.slice(0);
                $455d545b1dff00eb$var$lS.getContext().decodeAudioData(p, function(x) {
                    t(x);
                }).catch(c);
            } catch (p) {
                c(p);
            }
        }, n, i);
        function c(f) {
            i ? i(f) : $455d545b1dff00eb$var$Qt(f), r.manager.itemError(e);
        }
    }
}
const $455d545b1dff00eb$var$RM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$DM = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Mf = new $455d545b1dff00eb$var$Ft;
class $455d545b1dff00eb$var$BN {
    constructor(){
        this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new $455d545b1dff00eb$var$Ui, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new $455d545b1dff00eb$var$Ui, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(e) {
        const t = this._cache;
        if (t.focus !== e.focus || t.fov !== e.fov || t.aspect !== e.aspect * this.aspect || t.near !== e.near || t.far !== e.far || t.zoom !== e.zoom || t.eyeSep !== this.eyeSep) {
            t.focus = e.focus, t.fov = e.fov, t.aspect = e.aspect * this.aspect, t.near = e.near, t.far = e.far, t.zoom = e.zoom, t.eyeSep = this.eyeSep, $455d545b1dff00eb$var$Mf.copy(e.projectionMatrix);
            const i = t.eyeSep / 2, r = i * t.near / t.focus, l = t.near * Math.tan($455d545b1dff00eb$var$Hf * t.fov * .5) / t.zoom;
            let c, f;
            $455d545b1dff00eb$var$DM.elements[12] = -i, $455d545b1dff00eb$var$RM.elements[12] = i, c = -l * t.aspect + r, f = l * t.aspect + r, $455d545b1dff00eb$var$Mf.elements[0] = 2 * t.near / (f - c), $455d545b1dff00eb$var$Mf.elements[8] = (f + c) / (f - c), this.cameraL.projectionMatrix.copy($455d545b1dff00eb$var$Mf), c = -l * t.aspect - r, f = l * t.aspect - r, $455d545b1dff00eb$var$Mf.elements[0] = 2 * t.near / (f - c), $455d545b1dff00eb$var$Mf.elements[8] = (f + c) / (f - c), this.cameraR.projectionMatrix.copy($455d545b1dff00eb$var$Mf);
        }
        this.cameraL.matrixWorld.copy(e.matrixWorld).multiply($455d545b1dff00eb$var$DM), this.cameraR.matrixWorld.copy(e.matrixWorld).multiply($455d545b1dff00eb$var$RM);
    }
}
class $455d545b1dff00eb$var$mA extends $455d545b1dff00eb$var$Ui {
    constructor(e = []){
        super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
    }
}
class $455d545b1dff00eb$var$cS {
    constructor(e = !0){
        this.autoStart = e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = performance.now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let e = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const t = performance.now();
            e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
        }
        return e;
    }
}
const $455d545b1dff00eb$var$Ef = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$u_ = new $455d545b1dff00eb$var$Gn, $455d545b1dff00eb$var$IN = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Tf = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Af = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$FN extends $455d545b1dff00eb$var$Pn {
    constructor(){
        super(), this.type = "AudioListener", this.context = $455d545b1dff00eb$var$lS.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new $455d545b1dff00eb$var$cS;
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        return this.filter !== null && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(e) {
        return this.filter !== null ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = e, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(e) {
        return this.gain.gain.setTargetAtTime(e, this.context.currentTime, .01), this;
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e);
        const t = this.context.listener;
        if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose($455d545b1dff00eb$var$Ef, $455d545b1dff00eb$var$u_, $455d545b1dff00eb$var$IN), $455d545b1dff00eb$var$Tf.set(0, 0, -1).applyQuaternion($455d545b1dff00eb$var$u_), $455d545b1dff00eb$var$Af.set(0, 1, 0).applyQuaternion($455d545b1dff00eb$var$u_), t.positionX) {
            const n = this.context.currentTime + this.timeDelta;
            t.positionX.linearRampToValueAtTime($455d545b1dff00eb$var$Ef.x, n), t.positionY.linearRampToValueAtTime($455d545b1dff00eb$var$Ef.y, n), t.positionZ.linearRampToValueAtTime($455d545b1dff00eb$var$Ef.z, n), t.forwardX.linearRampToValueAtTime($455d545b1dff00eb$var$Tf.x, n), t.forwardY.linearRampToValueAtTime($455d545b1dff00eb$var$Tf.y, n), t.forwardZ.linearRampToValueAtTime($455d545b1dff00eb$var$Tf.z, n), t.upX.linearRampToValueAtTime($455d545b1dff00eb$var$Af.x, n), t.upY.linearRampToValueAtTime($455d545b1dff00eb$var$Af.y, n), t.upZ.linearRampToValueAtTime($455d545b1dff00eb$var$Af.z, n);
        } else t.setPosition($455d545b1dff00eb$var$Ef.x, $455d545b1dff00eb$var$Ef.y, $455d545b1dff00eb$var$Ef.z), t.setOrientation($455d545b1dff00eb$var$Tf.x, $455d545b1dff00eb$var$Tf.y, $455d545b1dff00eb$var$Tf.z, $455d545b1dff00eb$var$Af.x, $455d545b1dff00eb$var$Af.y, $455d545b1dff00eb$var$Af.z);
    }
}
class $455d545b1dff00eb$var$gA extends $455d545b1dff00eb$var$Pn {
    constructor(e){
        super(), this.type = "Audio", this.listener = e, this.context = e.context, this.gain = this.context.createGain(), this.gain.connect(e.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(e) {
        return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = e, this.connect(), this;
    }
    setMediaElementSource(e) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(e), this.connect(), this;
    }
    setMediaStreamSource(e) {
        return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(e), this.connect(), this;
    }
    setBuffer(e) {
        return this.buffer = e, this.sourceType = "buffer", this.autoplay && this.play(), this;
    }
    play(e = 0) {
        if (this.isPlaying === !0) {
            $455d545b1dff00eb$var$Mt("Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === !1) {
            $455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + e;
        const t = this.context.createBufferSource();
        return t.buffer = this.buffer, t.loop = this.loop, t.loopStart = this.loopStart, t.loopEnd = this.loopEnd, t.onended = this.onEnded.bind(this), t.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = t, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === !1) {
            $455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control.");
            return;
        }
        return this.isPlaying === !0 && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, this.loop === !0 && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
    }
    stop(e = 0) {
        if (this.hasPlaybackControl === !1) {
            $455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control.");
            return;
        }
        return this._progress = 0, this.source !== null && (this.source.stop(this.context.currentTime + e), this.source.onended = null), this.isPlaying = !1, this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let e = 1, t = this.filters.length; e < t; e++)this.filters[e - 1].connect(this.filters[e]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        return this._connected = !0, this;
    }
    disconnect() {
        if (this._connected !== !1) {
            if (this.filters.length > 0) {
                this.source.disconnect(this.filters[0]);
                for(let e = 1, t = this.filters.length; e < t; e++)this.filters[e - 1].disconnect(this.filters[e]);
                this.filters[this.filters.length - 1].disconnect(this.getOutput());
            } else this.source.disconnect(this.getOutput());
            return this._connected = !1, this;
        }
    }
    getFilters() {
        return this.filters;
    }
    setFilters(e) {
        return e || (e = []), this._connected === !0 ? (this.disconnect(), this.filters = e.slice(), this.connect()) : this.filters = e.slice(), this;
    }
    setDetune(e) {
        return this.detune = e, this.isPlaying === !0 && this.source.detune !== void 0 && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(e) {
        return this.setFilters(e ? [
            e
        ] : []);
    }
    setPlaybackRate(e) {
        if (this.hasPlaybackControl === !1) {
            $455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control.");
            return;
        }
        return this.playbackRate = e, this.isPlaying === !0 && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = !1, this._progress = 0;
    }
    getLoop() {
        return this.hasPlaybackControl === !1 ? ($455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control."), !1) : this.loop;
    }
    setLoop(e) {
        if (this.hasPlaybackControl === !1) {
            $455d545b1dff00eb$var$Mt("Audio: this Audio has no playback control.");
            return;
        }
        return this.loop = e, this.isPlaying === !0 && (this.source.loop = this.loop), this;
    }
    setLoopStart(e) {
        return this.loopStart = e, this;
    }
    setLoopEnd(e) {
        return this.loopEnd = e, this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(e) {
        return this.gain.gain.setTargetAtTime(e, this.context.currentTime, .01), this;
    }
    copy(e, t) {
        return super.copy(e, t), e.sourceType !== "buffer" ? ($455d545b1dff00eb$var$Mt("Audio: Audio source type cannot be copied."), this) : (this.autoplay = e.autoplay, this.buffer = e.buffer, this.detune = e.detune, this.loop = e.loop, this.loopStart = e.loopStart, this.loopEnd = e.loopEnd, this.offset = e.offset, this.duration = e.duration, this.playbackRate = e.playbackRate, this.hasPlaybackControl = e.hasPlaybackControl, this.sourceType = e.sourceType, this.filters = e.filters.slice(), this);
    }
    clone(e) {
        return new this.constructor(this.listener).copy(this, e);
    }
}
const $455d545b1dff00eb$var$wf = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$UM = new $455d545b1dff00eb$var$Gn, $455d545b1dff00eb$var$HN = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Cf = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$VN extends $455d545b1dff00eb$var$gA {
    constructor(e){
        super(e), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
    }
    connect() {
        return super.connect(), this.panner.connect(this.gain), this;
    }
    disconnect() {
        return super.disconnect(), this.panner.disconnect(this.gain), this;
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(e) {
        return this.panner.refDistance = e, this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(e) {
        return this.panner.rolloffFactor = e, this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(e) {
        return this.panner.distanceModel = e, this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(e) {
        return this.panner.maxDistance = e, this;
    }
    setDirectionalCone(e, t, n) {
        return this.panner.coneInnerAngle = e, this.panner.coneOuterAngle = t, this.panner.coneOuterGain = n, this;
    }
    updateMatrixWorld(e) {
        if (super.updateMatrixWorld(e), this.hasPlaybackControl === !0 && this.isPlaying === !1) return;
        this.matrixWorld.decompose($455d545b1dff00eb$var$wf, $455d545b1dff00eb$var$UM, $455d545b1dff00eb$var$HN), $455d545b1dff00eb$var$Cf.set(0, 0, 1).applyQuaternion($455d545b1dff00eb$var$UM);
        const t = this.panner;
        if (t.positionX) {
            const n = this.context.currentTime + this.listener.timeDelta;
            t.positionX.linearRampToValueAtTime($455d545b1dff00eb$var$wf.x, n), t.positionY.linearRampToValueAtTime($455d545b1dff00eb$var$wf.y, n), t.positionZ.linearRampToValueAtTime($455d545b1dff00eb$var$wf.z, n), t.orientationX.linearRampToValueAtTime($455d545b1dff00eb$var$Cf.x, n), t.orientationY.linearRampToValueAtTime($455d545b1dff00eb$var$Cf.y, n), t.orientationZ.linearRampToValueAtTime($455d545b1dff00eb$var$Cf.z, n);
        } else t.setPosition($455d545b1dff00eb$var$wf.x, $455d545b1dff00eb$var$wf.y, $455d545b1dff00eb$var$wf.z), t.setOrientation($455d545b1dff00eb$var$Cf.x, $455d545b1dff00eb$var$Cf.y, $455d545b1dff00eb$var$Cf.z);
    }
}
class $455d545b1dff00eb$var$GN {
    constructor(e, t = 2048){
        this.analyser = e.context.createAnalyser(), this.analyser.fftSize = t, this.data = new Uint8Array(this.analyser.frequencyBinCount), e.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        return this.analyser.getByteFrequencyData(this.data), this.data;
    }
    getAverageFrequency() {
        let e = 0;
        const t = this.getFrequencyData();
        for(let n = 0; n < t.length; n++)e += t[n];
        return e / t.length;
    }
}
class $455d545b1dff00eb$var$xA {
    constructor(e, t, n){
        this.binding = e, this.valueSize = n;
        let i, r, l;
        switch(t){
            case "quaternion":
                i = this._slerp, r = this._slerpAdditive, l = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(n * 6), this._workIndex = 5;
                break;
            case "string":
            case "bool":
                i = this._select, r = this._select, l = this._setAdditiveIdentityOther, this.buffer = new Array(n * 5);
                break;
            default:
                i = this._lerp, r = this._lerpAdditive, l = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(n * 5);
        }
        this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = l, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
    }
    accumulate(e, t) {
        const n = this.buffer, i = this.valueSize, r = e * i + i;
        let l = this.cumulativeWeight;
        if (l === 0) {
            for(let c = 0; c !== i; ++c)n[r + c] = n[c];
            l = t;
        } else {
            l += t;
            const c = t / l;
            this._mixBufferRegion(n, r, 0, c, i);
        }
        this.cumulativeWeight = l;
    }
    accumulateAdditive(e) {
        const t = this.buffer, n = this.valueSize, i = n * this._addIndex;
        this.cumulativeWeightAdditive === 0 && this._setIdentity(), this._mixBufferRegionAdditive(t, i, 0, e, n), this.cumulativeWeightAdditive += e;
    }
    apply(e) {
        const t = this.valueSize, n = this.buffer, i = e * t + t, r = this.cumulativeWeight, l = this.cumulativeWeightAdditive, c = this.binding;
        if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
            const f = t * this._origIndex;
            this._mixBufferRegion(n, i, f, 1 - r, t);
        }
        l > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t);
        for(let f = t, p = t + t; f !== p; ++f)if (n[f] !== n[f + t]) {
            c.setValue(n, i);
            break;
        }
    }
    saveOriginalState() {
        const e = this.binding, t = this.buffer, n = this.valueSize, i = n * this._origIndex;
        e.getValue(t, i);
        for(let r = n, l = i; r !== l; ++r)t[r] = t[i + r % n];
        this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
    }
    restoreOriginalState() {
        const e = this.valueSize * 3;
        this.binding.setValue(this.buffer, e);
    }
    _setAdditiveIdentityNumeric() {
        const e = this._addIndex * this.valueSize, t = e + this.valueSize;
        for(let n = e; n < t; n++)this.buffer[n] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const e = this._origIndex * this.valueSize, t = this._addIndex * this.valueSize;
        for(let n = 0; n < this.valueSize; n++)this.buffer[t + n] = this.buffer[e + n];
    }
    _select(e, t, n, i, r) {
        if (i >= .5) for(let l = 0; l !== r; ++l)e[t + l] = e[n + l];
    }
    _slerp(e, t, n, i) {
        $455d545b1dff00eb$var$Gn.slerpFlat(e, t, e, t, e, n, i);
    }
    _slerpAdditive(e, t, n, i, r) {
        const l = this._workIndex * r;
        $455d545b1dff00eb$var$Gn.multiplyQuaternionsFlat(e, l, e, t, e, n), $455d545b1dff00eb$var$Gn.slerpFlat(e, t, e, t, e, l, i);
    }
    _lerp(e, t, n, i, r) {
        const l = 1 - i;
        for(let c = 0; c !== r; ++c){
            const f = t + c;
            e[f] = e[f] * l + e[n + c] * i;
        }
    }
    _lerpAdditive(e, t, n, i, r) {
        for(let l = 0; l !== r; ++l){
            const c = t + l;
            e[c] = e[c] + e[n + l] * i;
        }
    }
}
const $455d545b1dff00eb$var$uS = "\\[\\]\\.:\\/", $455d545b1dff00eb$var$kN = new RegExp("[" + $455d545b1dff00eb$var$uS + "]", "g"), $455d545b1dff00eb$var$fS = "[^" + $455d545b1dff00eb$var$uS + "]", $455d545b1dff00eb$var$jN = "[^" + $455d545b1dff00eb$var$uS.replace("\\.", "") + "]", $455d545b1dff00eb$var$XN = /((?:WC+[\/:])*)/.source.replace("WC", $455d545b1dff00eb$var$fS), $455d545b1dff00eb$var$WN = /(WCOD+)?/.source.replace("WCOD", $455d545b1dff00eb$var$jN), $455d545b1dff00eb$var$qN = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $455d545b1dff00eb$var$fS), $455d545b1dff00eb$var$YN = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $455d545b1dff00eb$var$fS), $455d545b1dff00eb$var$ZN = new RegExp("^" + $455d545b1dff00eb$var$XN + $455d545b1dff00eb$var$WN + $455d545b1dff00eb$var$qN + $455d545b1dff00eb$var$YN + "$"), $455d545b1dff00eb$var$QN = [
    "material",
    "materials",
    "bones",
    "map"
];
class $455d545b1dff00eb$var$KN {
    constructor(e, t, n){
        const i = n || $455d545b1dff00eb$var$zn.parseTrackName(t);
        this._targetGroup = e, this._bindings = e.subscribe_(t, i);
    }
    getValue(e, t) {
        this.bind();
        const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
        i !== void 0 && i.getValue(e, t);
    }
    setValue(e, t) {
        const n = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)n[i].setValue(e, t);
    }
    bind() {
        const e = this._bindings;
        for(let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)e[t].bind();
    }
    unbind() {
        const e = this._bindings;
        for(let t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t)e[t].unbind();
    }
}
class $455d545b1dff00eb$var$zn {
    constructor(e, t, n){
        this.path = t, this.parsedPath = n || $455d545b1dff00eb$var$zn.parseTrackName(t), this.node = $455d545b1dff00eb$var$zn.findNode(e, this.parsedPath.nodeName), this.rootNode = e, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(e, t, n) {
        return e && e.isAnimationObjectGroup ? new $455d545b1dff00eb$var$zn.Composite(e, t, n) : new $455d545b1dff00eb$var$zn(e, t, n);
    }
    static sanitizeNodeName(e) {
        return e.replace(/\s/g, "_").replace($455d545b1dff00eb$var$kN, "");
    }
    static parseTrackName(e) {
        const t = $455d545b1dff00eb$var$ZN.exec(e);
        if (t === null) throw new Error("PropertyBinding: Cannot parse trackName: " + e);
        const n = {
            nodeName: t[2],
            objectName: t[3],
            objectIndex: t[4],
            propertyName: t[5],
            propertyIndex: t[6]
        }, i = n.nodeName && n.nodeName.lastIndexOf(".");
        if (i !== void 0 && i !== -1) {
            const r = n.nodeName.substring(i + 1);
            $455d545b1dff00eb$var$QN.indexOf(r) !== -1 && (n.nodeName = n.nodeName.substring(0, i), n.objectName = r);
        }
        if (n.propertyName === null || n.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
        return n;
    }
    static findNode(e, t) {
        if (t === void 0 || t === "" || t === "." || t === -1 || t === e.name || t === e.uuid) return e;
        if (e.skeleton) {
            const n = e.skeleton.getBoneByName(t);
            if (n !== void 0) return n;
        }
        if (e.children) {
            const n = function(r) {
                for(let l = 0; l < r.length; l++){
                    const c = r[l];
                    if (c.name === t || c.uuid === t) return c;
                    const f = n(c.children);
                    if (f) return f;
                }
                return null;
            }, i = n(e.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(e, t) {
        e[t] = this.targetObject[this.propertyName];
    }
    _getValue_array(e, t) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)e[t++] = n[i];
    }
    _getValue_arrayElement(e, t) {
        e[t] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(e, t) {
        this.resolvedProperty.toArray(e, t);
    }
    _setValue_direct(e, t) {
        this.targetObject[this.propertyName] = e[t];
    }
    _setValue_direct_setNeedsUpdate(e, t) {
        this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
        this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(e, t) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = e[t++];
    }
    _setValue_array_setNeedsUpdate(e, t) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = e[t++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
        const n = this.resolvedProperty;
        for(let i = 0, r = n.length; i !== r; ++i)n[i] = e[t++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t];
    }
    _setValue_arrayElement_setNeedsUpdate(e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(e, t) {
        this.resolvedProperty.fromArray(e, t);
    }
    _setValue_fromArray_setNeedsUpdate(e, t) {
        this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
        this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(e, t) {
        this.bind(), this.getValue(e, t);
    }
    _setValue_unbound(e, t) {
        this.bind(), this.setValue(e, t);
    }
    bind() {
        let e = this.node;
        const t = this.parsedPath, n = t.objectName, i = t.propertyName;
        let r = t.propertyIndex;
        if (e || (e = $455d545b1dff00eb$var$zn.findNode(this.rootNode, t.nodeName), this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) {
            $455d545b1dff00eb$var$Mt("PropertyBinding: No target node found for track: " + this.path + ".");
            return;
        }
        if (n) {
            let p = t.objectIndex;
            switch(n){
                case "materials":
                    if (!e.material) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!e.material.materials) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    e = e.material.materials;
                    break;
                case "bones":
                    if (!e.skeleton) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    e = e.skeleton.bones;
                    for(let m = 0; m < e.length; m++)if (e[m].name === p) {
                        p = m;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in e) {
                        e = e.map;
                        break;
                    }
                    if (!e.material) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!e.material.map) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    e = e.material.map;
                    break;
                default:
                    if (e[n] === void 0) {
                        $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    e = e[n];
            }
            if (p !== void 0) {
                if (e[p] === void 0) {
                    $455d545b1dff00eb$var$Qt("PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
                    return;
                }
                e = e[p];
            }
        }
        const l = e[i];
        if (l === void 0) {
            const p = t.nodeName;
            $455d545b1dff00eb$var$Qt("PropertyBinding: Trying to update property for track: " + p + "." + i + " but it wasn't found.", e);
            return;
        }
        let c = this.Versioning.None;
        this.targetObject = e, e.isMaterial === !0 ? c = this.Versioning.NeedsUpdate : e.isObject3D === !0 && (c = this.Versioning.MatrixWorldNeedsUpdate);
        let f = this.BindingType.Direct;
        if (r !== void 0) {
            if (i === "morphTargetInfluences") {
                if (!e.geometry) {
                    $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!e.geometry.morphAttributes) {
                    $455d545b1dff00eb$var$Qt("PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                e.morphTargetDictionary[r] !== void 0 && (r = e.morphTargetDictionary[r]);
            }
            f = this.BindingType.ArrayElement, this.resolvedProperty = l, this.propertyIndex = r;
        } else l.fromArray !== void 0 && l.toArray !== void 0 ? (f = this.BindingType.HasFromToArray, this.resolvedProperty = l) : Array.isArray(l) ? (f = this.BindingType.EntireArray, this.resolvedProperty = l) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[f], this.setValue = this.SetterByBindingTypeAndVersioning[f][c];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
}
$455d545b1dff00eb$var$zn.Composite = $455d545b1dff00eb$var$KN;
$455d545b1dff00eb$var$zn.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$455d545b1dff00eb$var$zn.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$455d545b1dff00eb$var$zn.prototype.GetterByBindingType = [
    $455d545b1dff00eb$var$zn.prototype._getValue_direct,
    $455d545b1dff00eb$var$zn.prototype._getValue_array,
    $455d545b1dff00eb$var$zn.prototype._getValue_arrayElement,
    $455d545b1dff00eb$var$zn.prototype._getValue_toArray
];
$455d545b1dff00eb$var$zn.prototype.SetterByBindingTypeAndVersioning = [
    [
        $455d545b1dff00eb$var$zn.prototype._setValue_direct,
        $455d545b1dff00eb$var$zn.prototype._setValue_direct_setNeedsUpdate,
        $455d545b1dff00eb$var$zn.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        $455d545b1dff00eb$var$zn.prototype._setValue_array,
        $455d545b1dff00eb$var$zn.prototype._setValue_array_setNeedsUpdate,
        $455d545b1dff00eb$var$zn.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        $455d545b1dff00eb$var$zn.prototype._setValue_arrayElement,
        $455d545b1dff00eb$var$zn.prototype._setValue_arrayElement_setNeedsUpdate,
        $455d545b1dff00eb$var$zn.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        $455d545b1dff00eb$var$zn.prototype._setValue_fromArray,
        $455d545b1dff00eb$var$zn.prototype._setValue_fromArray_setNeedsUpdate,
        $455d545b1dff00eb$var$zn.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
class $455d545b1dff00eb$var$JN {
    constructor(){
        this.isAnimationObjectGroup = !0, this.uuid = $455d545b1dff00eb$var$bs(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
        const e = {};
        this._indicesByUUID = e;
        for(let n = 0, i = arguments.length; n !== i; ++n)e[arguments[n].uuid] = n;
        this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
        const t = this;
        this.stats = {
            objects: {
                get total () {
                    return t._objects.length;
                },
                get inUse () {
                    return this.total - t.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return t._bindings.length;
            }
        };
    }
    add() {
        const e = this._objects, t = this._indicesByUUID, n = this._paths, i = this._parsedPaths, r = this._bindings, l = r.length;
        let c, f = e.length, p = this.nCachedObjects_;
        for(let m = 0, x = arguments.length; m !== x; ++m){
            const v = arguments[m], _ = v.uuid;
            let S = t[_];
            if (S === void 0) {
                S = f++, t[_] = S, e.push(v);
                for(let A = 0, M = l; A !== M; ++A)r[A].push(new $455d545b1dff00eb$var$zn(v, n[A], i[A]));
            } else if (S < p) {
                c = e[S];
                const A = --p, M = e[A];
                t[M.uuid] = S, e[S] = M, t[_] = A, e[A] = v;
                for(let b = 0, C = l; b !== C; ++b){
                    const R = r[b], N = R[A];
                    let z = R[S];
                    R[S] = N, z === void 0 && (z = new $455d545b1dff00eb$var$zn(v, n[b], i[b])), R[A] = z;
                }
            } else e[S] !== c && $455d545b1dff00eb$var$Qt("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
        }
        this.nCachedObjects_ = p;
    }
    remove() {
        const e = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
        let r = this.nCachedObjects_;
        for(let l = 0, c = arguments.length; l !== c; ++l){
            const f = arguments[l], p = f.uuid, m = t[p];
            if (m !== void 0 && m >= r) {
                const x = r++, v = e[x];
                t[v.uuid] = m, e[m] = v, t[p] = x, e[x] = f;
                for(let _ = 0, S = i; _ !== S; ++_){
                    const A = n[_], M = A[x], b = A[m];
                    A[m] = M, A[x] = b;
                }
            }
        }
        this.nCachedObjects_ = r;
    }
    uncache() {
        const e = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
        let r = this.nCachedObjects_, l = e.length;
        for(let c = 0, f = arguments.length; c !== f; ++c){
            const p = arguments[c], m = p.uuid, x = t[m];
            if (x !== void 0) {
                if (delete t[m], x < r) {
                    const v = --r, _ = e[v], S = --l, A = e[S];
                    t[_.uuid] = x, e[x] = _, t[A.uuid] = v, e[v] = A, e.pop();
                    for(let M = 0, b = i; M !== b; ++M){
                        const C = n[M], R = C[v], N = C[S];
                        C[x] = R, C[v] = N, C.pop();
                    }
                } else {
                    const v = --l, _ = e[v];
                    v > 0 && (t[_.uuid] = x), e[x] = _, e.pop();
                    for(let S = 0, A = i; S !== A; ++S){
                        const M = n[S];
                        M[x] = M[v], M.pop();
                    }
                }
            }
        }
        this.nCachedObjects_ = r;
    }
    subscribe_(e, t) {
        const n = this._bindingsIndicesByPath;
        let i = n[e];
        const r = this._bindings;
        if (i !== void 0) return r[i];
        const l = this._paths, c = this._parsedPaths, f = this._objects, p = f.length, m = this.nCachedObjects_, x = new Array(p);
        i = r.length, n[e] = i, l.push(e), c.push(t), r.push(x);
        for(let v = m, _ = f.length; v !== _; ++v){
            const S = f[v];
            x[v] = new $455d545b1dff00eb$var$zn(S, e, t);
        }
        return x;
    }
    unsubscribe_(e) {
        const t = this._bindingsIndicesByPath, n = t[e];
        if (n !== void 0) {
            const i = this._paths, r = this._parsedPaths, l = this._bindings, c = l.length - 1, f = l[c], p = e[c];
            t[p] = n, l[n] = f, l.pop(), r[n] = r[c], r.pop(), i[n] = i[c], i.pop();
        }
    }
}
class $455d545b1dff00eb$var$vA {
    constructor(e, t, n = null, i = t.blendMode){
        this._mixer = e, this._clip = t, this._localRoot = n, this.blendMode = i;
        const r = t.tracks, l = r.length, c = new Array(l), f = {
            endingStart: $455d545b1dff00eb$var$zf,
            endingEnd: $455d545b1dff00eb$var$zf
        };
        for(let p = 0; p !== l; ++p){
            const m = r[p].createInterpolant(null);
            c[p] = m, m.settings = f;
        }
        this._interpolantSettings = f, this._interpolants = c, this._propertyBindings = new Array(l), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = $455d545b1dff00eb$var$oT, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    play() {
        return this._mixer._activateAction(this), this;
    }
    stop() {
        return this._mixer._deactivateAction(this), this.reset();
    }
    reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(e) {
        return this._startTime = e, this;
    }
    setLoop(e, t) {
        return this.loop = e, this.repetitions = t, this;
    }
    setEffectiveWeight(e) {
        return this.weight = e, this._effectiveWeight = this.enabled ? e : 0, this.stopFading();
    }
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(e) {
        return this._scheduleFading(e, 0, 1);
    }
    fadeOut(e) {
        return this._scheduleFading(e, 1, 0);
    }
    crossFadeFrom(e, t, n = !1) {
        if (e.fadeOut(t), this.fadeIn(t), n === !0) {
            const i = this._clip.duration, r = e._clip.duration, l = r / i, c = i / r;
            e.warp(1, l, t), this.warp(c, 1, t);
        }
        return this;
    }
    crossFadeTo(e, t, n = !1) {
        return e.crossFadeFrom(this, t, n);
    }
    stopFading() {
        const e = this._weightInterpolant;
        return e !== null && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
    }
    setEffectiveTimeScale(e) {
        return this.timeScale = e, this._effectiveTimeScale = this.paused ? 0 : e, this.stopWarping();
    }
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(e) {
        return this.timeScale = this._clip.duration / e, this.stopWarping();
    }
    syncWith(e) {
        return this.time = e.time, this.timeScale = e.timeScale, this.stopWarping();
    }
    halt(e) {
        return this.warp(this._effectiveTimeScale, 0, e);
    }
    warp(e, t, n) {
        const i = this._mixer, r = i.time, l = this.timeScale;
        let c = this._timeScaleInterpolant;
        c === null && (c = i._lendControlInterpolant(), this._timeScaleInterpolant = c);
        const f = c.parameterPositions, p = c.sampleValues;
        return f[0] = r, f[1] = r + n, p[0] = e / l, p[1] = t / l, this;
    }
    stopWarping() {
        const e = this._timeScaleInterpolant;
        return e !== null && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
    }
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    _update(e, t, n, i) {
        if (!this.enabled) {
            this._updateWeight(e);
            return;
        }
        const r = this._startTime;
        if (r !== null) {
            const f = (e - r) * n;
            f < 0 || n === 0 ? t = 0 : (this._startTime = null, t = n * f);
        }
        t *= this._updateTimeScale(e);
        const l = this._updateTime(t), c = this._updateWeight(e);
        if (c > 0) {
            const f = this._interpolants, p = this._propertyBindings;
            switch(this.blendMode){
                case $455d545b1dff00eb$var$Bb:
                    for(let m = 0, x = f.length; m !== x; ++m)f[m].evaluate(l), p[m].accumulateAdditive(c);
                    break;
                case $455d545b1dff00eb$var$cy:
                default:
                    for(let m = 0, x = f.length; m !== x; ++m)f[m].evaluate(l), p[m].accumulate(i, c);
            }
        }
    }
    _updateWeight(e) {
        let t = 0;
        if (this.enabled) {
            t = this.weight;
            const n = this._weightInterpolant;
            if (n !== null) {
                const i = n.evaluate(e)[0];
                t *= i, e > n.parameterPositions[1] && (this.stopFading(), i === 0 && (this.enabled = !1));
            }
        }
        return this._effectiveWeight = t, t;
    }
    _updateTimeScale(e) {
        let t = 0;
        if (!this.paused) {
            t = this.timeScale;
            const n = this._timeScaleInterpolant;
            if (n !== null) {
                const i = n.evaluate(e)[0];
                t *= i, e > n.parameterPositions[1] && (this.stopWarping(), t === 0 ? this.paused = !0 : this.timeScale = t);
            }
        }
        return this._effectiveTimeScale = t, t;
    }
    _updateTime(e) {
        const t = this._clip.duration, n = this.loop;
        let i = this.time + e, r = this._loopCount;
        const l = n === $455d545b1dff00eb$var$lT;
        if (e === 0) return r === -1 ? i : l && (r & 1) === 1 ? t - i : i;
        if (n === $455d545b1dff00eb$var$sT) {
            r === -1 && (this._loopCount = 0, this._setEndings(!0, !0, !1));
            e: {
                if (i >= t) i = t;
                else if (i < 0) i = 0;
                else {
                    this.time = i;
                    break e;
                }
                this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: e < 0 ? -1 : 1
                });
            }
        } else {
            if (r === -1 && (e >= 0 ? (r = 0, this._setEndings(!0, this.repetitions === 0, l)) : this._setEndings(this.repetitions === 0, !0, l)), i >= t || i < 0) {
                const c = Math.floor(i / t);
                i -= t * c, r += Math.abs(c);
                const f = this.repetitions - r;
                if (f <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = e > 0 ? t : 0, this.time = i, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: e > 0 ? 1 : -1
                });
                else {
                    if (f === 1) {
                        const p = e < 0;
                        this._setEndings(p, !p, l);
                    } else this._setEndings(!1, !1, l);
                    this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: c
                    });
                }
            } else this.time = i;
            if (l && (r & 1) === 1) return t - i;
        }
        return i;
    }
    _setEndings(e, t, n) {
        const i = this._interpolantSettings;
        n ? (i.endingStart = $455d545b1dff00eb$var$Pf, i.endingEnd = $455d545b1dff00eb$var$Pf) : (e ? i.endingStart = this.zeroSlopeAtStart ? $455d545b1dff00eb$var$Pf : $455d545b1dff00eb$var$zf : i.endingStart = $455d545b1dff00eb$var$i0, t ? i.endingEnd = this.zeroSlopeAtEnd ? $455d545b1dff00eb$var$Pf : $455d545b1dff00eb$var$zf : i.endingEnd = $455d545b1dff00eb$var$i0);
    }
    _scheduleFading(e, t, n) {
        const i = this._mixer, r = i.time;
        let l = this._weightInterpolant;
        l === null && (l = i._lendControlInterpolant(), this._weightInterpolant = l);
        const c = l.parameterPositions, f = l.sampleValues;
        return c[0] = r, f[0] = t, c[1] = r + e, f[1] = n, this;
    }
}
const $455d545b1dff00eb$var$$N = new Float32Array(1);
class $455d545b1dff00eb$var$e4 extends $455d545b1dff00eb$var$Ml {
    constructor(e){
        super(), this._root = e, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    _bindAction(e, t) {
        const n = e._localRoot || this._root, i = e._clip.tracks, r = i.length, l = e._propertyBindings, c = e._interpolants, f = n.uuid, p = this._bindingsByRootAndName;
        let m = p[f];
        m === void 0 && (m = {}, p[f] = m);
        for(let x = 0; x !== r; ++x){
            const v = i[x], _ = v.name;
            let S = m[_];
            if (S !== void 0) ++S.referenceCount, l[x] = S;
            else {
                if (S = l[x], S !== void 0) {
                    S._cacheIndex === null && (++S.referenceCount, this._addInactiveBinding(S, f, _));
                    continue;
                }
                const A = t && t._propertyBindings[x].binding.parsedPath;
                S = new $455d545b1dff00eb$var$xA($455d545b1dff00eb$var$zn.create(n, _, A), v.ValueTypeName, v.getValueSize()), ++S.referenceCount, this._addInactiveBinding(S, f, _), l[x] = S;
            }
            c[x].resultBuffer = S.buffer;
        }
    }
    _activateAction(e) {
        if (!this._isActiveAction(e)) {
            if (e._cacheIndex === null) {
                const n = (e._localRoot || this._root).uuid, i = e._clip.uuid, r = this._actionsByClip[i];
                this._bindAction(e, r && r.knownActions[0]), this._addInactiveAction(e, i, n);
            }
            const t = e._propertyBindings;
            for(let n = 0, i = t.length; n !== i; ++n){
                const r = t[n];
                r.useCount++ === 0 && (this._lendBinding(r), r.saveOriginalState());
            }
            this._lendAction(e);
        }
    }
    _deactivateAction(e) {
        if (this._isActiveAction(e)) {
            const t = e._propertyBindings;
            for(let n = 0, i = t.length; n !== i; ++n){
                const r = t[n];
                --r.useCount === 0 && (r.restoreOriginalState(), this._takeBackBinding(r));
            }
            this._takeBackAction(e);
        }
    }
    _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        const e = this;
        this.stats = {
            actions: {
                get total () {
                    return e._actions.length;
                },
                get inUse () {
                    return e._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return e._bindings.length;
                },
                get inUse () {
                    return e._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return e._controlInterpolants.length;
                },
                get inUse () {
                    return e._nActiveControlInterpolants;
                }
            }
        };
    }
    _isActiveAction(e) {
        const t = e._cacheIndex;
        return t !== null && t < this._nActiveActions;
    }
    _addInactiveAction(e, t, n) {
        const i = this._actions, r = this._actionsByClip;
        let l = r[t];
        if (l === void 0) l = {
            knownActions: [
                e
            ],
            actionByRoot: {}
        }, e._byClipCacheIndex = 0, r[t] = l;
        else {
            const c = l.knownActions;
            e._byClipCacheIndex = c.length, c.push(e);
        }
        e._cacheIndex = i.length, i.push(e), l.actionByRoot[n] = e;
    }
    _removeInactiveAction(e) {
        const t = this._actions, n = t[t.length - 1], i = e._cacheIndex;
        n._cacheIndex = i, t[i] = n, t.pop(), e._cacheIndex = null;
        const r = e._clip.uuid, l = this._actionsByClip, c = l[r], f = c.knownActions, p = f[f.length - 1], m = e._byClipCacheIndex;
        p._byClipCacheIndex = m, f[m] = p, f.pop(), e._byClipCacheIndex = null;
        const x = c.actionByRoot, v = (e._localRoot || this._root).uuid;
        delete x[v], f.length === 0 && delete l[r], this._removeInactiveBindingsForAction(e);
    }
    _removeInactiveBindingsForAction(e) {
        const t = e._propertyBindings;
        for(let n = 0, i = t.length; n !== i; ++n){
            const r = t[n];
            --r.referenceCount === 0 && this._removeInactiveBinding(r);
        }
    }
    _lendAction(e) {
        const t = this._actions, n = e._cacheIndex, i = this._nActiveActions++, r = t[i];
        e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
    }
    _takeBackAction(e) {
        const t = this._actions, n = e._cacheIndex, i = --this._nActiveActions, r = t[i];
        e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
    }
    _addInactiveBinding(e, t, n) {
        const i = this._bindingsByRootAndName, r = this._bindings;
        let l = i[t];
        l === void 0 && (l = {}, i[t] = l), l[n] = e, e._cacheIndex = r.length, r.push(e);
    }
    _removeInactiveBinding(e) {
        const t = this._bindings, n = e.binding, i = n.rootNode.uuid, r = n.path, l = this._bindingsByRootAndName, c = l[i], f = t[t.length - 1], p = e._cacheIndex;
        f._cacheIndex = p, t[p] = f, t.pop(), delete c[r], Object.keys(c).length === 0 && delete l[i];
    }
    _lendBinding(e) {
        const t = this._bindings, n = e._cacheIndex, i = this._nActiveBindings++, r = t[i];
        e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
    }
    _takeBackBinding(e) {
        const t = this._bindings, n = e._cacheIndex, i = --this._nActiveBindings, r = t[i];
        e._cacheIndex = i, t[i] = e, r._cacheIndex = n, t[n] = r;
    }
    _lendControlInterpolant() {
        const e = this._controlInterpolants, t = this._nActiveControlInterpolants++;
        let n = e[t];
        return n === void 0 && (n = new $455d545b1dff00eb$var$iS(new Float32Array(2), new Float32Array(2), 1, $455d545b1dff00eb$var$$N), n.__cacheIndex = t, e[t] = n), n;
    }
    _takeBackControlInterpolant(e) {
        const t = this._controlInterpolants, n = e.__cacheIndex, i = --this._nActiveControlInterpolants, r = t[i];
        e.__cacheIndex = i, t[i] = e, r.__cacheIndex = n, t[n] = r;
    }
    clipAction(e, t, n) {
        const i = t || this._root, r = i.uuid;
        let l = typeof e == "string" ? $455d545b1dff00eb$var$d0.findByName(i, e) : e;
        const c = l !== null ? l.uuid : e, f = this._actionsByClip[c];
        let p = null;
        if (n === void 0 && (l !== null ? n = l.blendMode : n = $455d545b1dff00eb$var$cy), f !== void 0) {
            const x = f.actionByRoot[r];
            if (x !== void 0 && x.blendMode === n) return x;
            p = f.knownActions[0], l === null && (l = p._clip);
        }
        if (l === null) return null;
        const m = new $455d545b1dff00eb$var$vA(this, l, t, n);
        return this._bindAction(m, p), this._addInactiveAction(m, c, r), m;
    }
    existingAction(e, t) {
        const n = t || this._root, i = n.uuid, r = typeof e == "string" ? $455d545b1dff00eb$var$d0.findByName(n, e) : e, l = r ? r.uuid : e, c = this._actionsByClip[l];
        return c !== void 0 && c.actionByRoot[i] || null;
    }
    stopAllAction() {
        const e = this._actions, t = this._nActiveActions;
        for(let n = t - 1; n >= 0; --n)e[n].stop();
        return this;
    }
    update(e) {
        e *= this.timeScale;
        const t = this._actions, n = this._nActiveActions, i = this.time += e, r = Math.sign(e), l = this._accuIndex ^= 1;
        for(let p = 0; p !== n; ++p)t[p]._update(i, e, r, l);
        const c = this._bindings, f = this._nActiveBindings;
        for(let p = 0; p !== f; ++p)c[p].apply(l);
        return this;
    }
    setTime(e) {
        this.time = 0;
        for(let t = 0; t < this._actions.length; t++)this._actions[t].time = 0;
        return this.update(e);
    }
    getRoot() {
        return this._root;
    }
    uncacheClip(e) {
        const t = this._actions, n = e.uuid, i = this._actionsByClip, r = i[n];
        if (r !== void 0) {
            const l = r.knownActions;
            for(let c = 0, f = l.length; c !== f; ++c){
                const p = l[c];
                this._deactivateAction(p);
                const m = p._cacheIndex, x = t[t.length - 1];
                p._cacheIndex = null, p._byClipCacheIndex = null, x._cacheIndex = m, t[m] = x, t.pop(), this._removeInactiveBindingsForAction(p);
            }
            delete i[n];
        }
    }
    uncacheRoot(e) {
        const t = e.uuid, n = this._actionsByClip;
        for(const l in n){
            const c = n[l].actionByRoot, f = c[t];
            f !== void 0 && (this._deactivateAction(f), this._removeInactiveAction(f));
        }
        const i = this._bindingsByRootAndName, r = i[t];
        if (r !== void 0) for(const l in r){
            const c = r[l];
            c.restoreOriginalState(), this._removeInactiveBinding(c);
        }
    }
    uncacheAction(e, t) {
        const n = this.existingAction(e, t);
        n !== null && (this._deactivateAction(n), this._removeInactiveAction(n));
    }
}
class $455d545b1dff00eb$var$t4 extends $455d545b1dff00eb$var$Vb {
    constructor(e = 1, t = 1, n = 1, i = {}){
        super(e, t, i), this.isRenderTarget3D = !0, this.depth = n, this.texture = new $455d545b1dff00eb$var$fy(null, e, t, n), this._setTextureOptions(i), this.texture.isRenderTargetTexture = !0;
    }
}
class $455d545b1dff00eb$var$hS {
    constructor(e){
        this.value = e;
    }
    clone() {
        return new $455d545b1dff00eb$var$hS(this.value.clone === void 0 ? this.value : this.value.clone());
    }
}
let $455d545b1dff00eb$var$n4 = 0;
class $455d545b1dff00eb$var$i4 extends $455d545b1dff00eb$var$Ml {
    constructor(){
        super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
            value: $455d545b1dff00eb$var$n4++
        }), this.name = "", this.usage = $455d545b1dff00eb$var$r0, this.uniforms = [];
    }
    add(e) {
        return this.uniforms.push(e), this;
    }
    remove(e) {
        const t = this.uniforms.indexOf(e);
        return t !== -1 && this.uniforms.splice(t, 1), this;
    }
    setName(e) {
        return this.name = e, this;
    }
    setUsage(e) {
        return this.usage = e, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    copy(e) {
        this.name = e.name, this.usage = e.usage;
        const t = e.uniforms;
        this.uniforms.length = 0;
        for(let n = 0, i = t.length; n < i; n++){
            const r = Array.isArray(t[n]) ? t[n] : [
                t[n]
            ];
            for(let l = 0; l < r.length; l++)this.uniforms.push(r[l].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $455d545b1dff00eb$var$a4 extends $455d545b1dff00eb$var$my {
    constructor(e, t, n = 1){
        super(e, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
    }
    copy(e) {
        return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
    }
    clone(e) {
        const t = super.clone(e);
        return t.meshPerAttribute = this.meshPerAttribute, t;
    }
    toJSON(e) {
        const t = super.toJSON(e);
        return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
    }
}
class $455d545b1dff00eb$var$r4 {
    constructor(e, t, n, i, r, l = !1){
        this.isGLBufferAttribute = !0, this.name = "", this.buffer = e, this.type = t, this.itemSize = n, this.elementSize = i, this.count = r, this.normalized = l, this.version = 0;
    }
    set needsUpdate(e) {
        e === !0 && this.version++;
    }
    setBuffer(e) {
        return this.buffer = e, this;
    }
    setType(e, t) {
        return this.type = e, this.elementSize = t, this;
    }
    setItemSize(e) {
        return this.itemSize = e, this;
    }
    setCount(e) {
        return this.count = e, this;
    }
}
const $455d545b1dff00eb$var$NM = new $455d545b1dff00eb$var$Ft;
class $455d545b1dff00eb$var$dS {
    constructor(e, t, n = 0, i = 1 / 0){
        this.ray = new $455d545b1dff00eb$var$Kf(e, t), this.near = n, this.far = i, this.camera = null, this.layers = new $455d545b1dff00eb$var$Hd, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(e, t) {
        this.ray.set(e, t);
    }
    setFromCamera(e, t) {
        t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e.x, e.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, (t.near + t.far) / (t.near - t.far)).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : $455d545b1dff00eb$var$Qt("Raycaster: Unsupported camera type: " + t.type);
    }
    setFromXRController(e) {
        return $455d545b1dff00eb$var$NM.identity().extractRotation(e.matrixWorld), this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4($455d545b1dff00eb$var$NM), this;
    }
    intersectObject(e, t = !0, n = []) {
        return $455d545b1dff00eb$var$ib(e, this, n, t), n.sort($455d545b1dff00eb$var$OM), n;
    }
    intersectObjects(e, t = !0, n = []) {
        for(let i = 0, r = e.length; i < r; i++)$455d545b1dff00eb$var$ib(e[i], this, n, t);
        return n.sort($455d545b1dff00eb$var$OM), n;
    }
}
function $455d545b1dff00eb$var$OM(a, e) {
    return a.distance - e.distance;
}
function $455d545b1dff00eb$var$ib(a, e, t, n) {
    let i = !0;
    if (a.layers.test(e.layers) && a.raycast(e, t) === !1 && (i = !1), i === !0 && n === !0) {
        const r = a.children;
        for(let l = 0, c = r.length; l < c; l++)$455d545b1dff00eb$var$ib(r[l], e, t, !0);
    }
}
class $455d545b1dff00eb$var$s4 {
    constructor(){
        this._previousTime = 0, this._currentTime = 0, this._startTime = performance.now(), this._delta = 0, this._elapsed = 0, this._timescale = 1, this._document = null, this._pageVisibilityHandler = null;
    }
    connect(e) {
        this._document = e, e.hidden !== void 0 && (this._pageVisibilityHandler = $455d545b1dff00eb$var$o4.bind(this), e.addEventListener("visibilitychange", this._pageVisibilityHandler, !1));
    }
    disconnect() {
        this._pageVisibilityHandler !== null && (this._document.removeEventListener("visibilitychange", this._pageVisibilityHandler), this._pageVisibilityHandler = null), this._document = null;
    }
    getDelta() {
        return this._delta / 1e3;
    }
    getElapsed() {
        return this._elapsed / 1e3;
    }
    getTimescale() {
        return this._timescale;
    }
    setTimescale(e) {
        return this._timescale = e, this;
    }
    reset() {
        return this._currentTime = performance.now() - this._startTime, this;
    }
    dispose() {
        this.disconnect();
    }
    update(e) {
        return this._pageVisibilityHandler !== null && this._document.hidden === !0 ? this._delta = 0 : (this._previousTime = this._currentTime, this._currentTime = (e !== void 0 ? e : performance.now()) - this._startTime, this._delta = (this._currentTime - this._previousTime) * this._timescale, this._elapsed += this._delta), this;
    }
}
function $455d545b1dff00eb$var$o4() {
    this._document.hidden === !1 && this.reset();
}
class $455d545b1dff00eb$var$ab {
    constructor(e = 1, t = 0, n = 0){
        this.radius = e, this.phi = t, this.theta = n;
    }
    set(e, t, n) {
        return this.radius = e, this.phi = t, this.theta = n, this;
    }
    copy(e) {
        return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
    }
    makeSafe() {
        return this.phi = $455d545b1dff00eb$var$Yt(this.phi, 1e-6, Math.PI - 1e-6), this;
    }
    setFromVector3(e) {
        return this.setFromCartesianCoords(e.x, e.y, e.z);
    }
    setFromCartesianCoords(e, t, n) {
        return this.radius = Math.sqrt(e * e + t * t + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e, n), this.phi = Math.acos($455d545b1dff00eb$var$Yt(t / this.radius, -1, 1))), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $455d545b1dff00eb$var$l4 {
    constructor(e = 1, t = 0, n = 0){
        this.radius = e, this.theta = t, this.y = n;
    }
    set(e, t, n) {
        return this.radius = e, this.theta = t, this.y = n, this;
    }
    copy(e) {
        return this.radius = e.radius, this.theta = e.theta, this.y = e.y, this;
    }
    setFromVector3(e) {
        return this.setFromCartesianCoords(e.x, e.y, e.z);
    }
    setFromCartesianCoords(e, t, n) {
        return this.radius = Math.sqrt(e * e + n * n), this.theta = Math.atan2(e, n), this.y = t, this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $455d545b1dff00eb$var$pS {
    constructor(e, t, n, i){
        $455d545b1dff00eb$var$pS.prototype.isMatrix2 = !0, this.elements = [
            1,
            0,
            0,
            1
        ], e !== void 0 && this.set(e, t, n, i);
    }
    identity() {
        return this.set(1, 0, 0, 1), this;
    }
    fromArray(e, t = 0) {
        for(let n = 0; n < 4; n++)this.elements[n] = e[n + t];
        return this;
    }
    set(e, t, n, i) {
        const r = this.elements;
        return r[0] = e, r[2] = t, r[1] = n, r[3] = i, this;
    }
}
const $455d545b1dff00eb$var$LM = new $455d545b1dff00eb$var$$e;
class $455d545b1dff00eb$var$c4 {
    constructor(e = new $455d545b1dff00eb$var$$e(1 / 0, 1 / 0), t = new $455d545b1dff00eb$var$$e(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = e, this.max = t;
    }
    set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
    }
    setFromPoints(e) {
        this.makeEmpty();
        for(let t = 0, n = e.length; t < n; t++)this.expandByPoint(e[t]);
        return this;
    }
    setFromCenterAndSize(e, t) {
        const n = $455d545b1dff00eb$var$LM.copy(t).multiplyScalar(.5);
        return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(e) {
        return this.isEmpty() ? e.set(0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(e) {
        return this.isEmpty() ? e.set(0, 0) : e.subVectors(this.max, this.min);
    }
    expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
    }
    expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
    }
    expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
    }
    containsPoint(e) {
        return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y;
    }
    containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y;
    }
    getParameter(e, t) {
        return t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(e) {
        return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y;
    }
    clampPoint(e, t) {
        return t.copy(e).clamp(this.min, this.max);
    }
    distanceToPoint(e) {
        return this.clampPoint(e, $455d545b1dff00eb$var$LM).distanceTo(e);
    }
    intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
    }
    translate(e) {
        return this.min.add(e), this.max.add(e), this;
    }
    equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
    }
}
const $455d545b1dff00eb$var$zM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Cx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$yd = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$_d = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$f_ = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$u4 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$f4 = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$h4 {
    constructor(e = new $455d545b1dff00eb$var$J, t = new $455d545b1dff00eb$var$J){
        this.start = e, this.end = t;
    }
    set(e, t) {
        return this.start.copy(e), this.end.copy(t), this;
    }
    copy(e) {
        return this.start.copy(e.start), this.end.copy(e.end), this;
    }
    getCenter(e) {
        return e.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(e) {
        return e.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(e, t) {
        return this.delta(t).multiplyScalar(e).add(this.start);
    }
    closestPointToPointParameter(e, t) {
        $455d545b1dff00eb$var$zM.subVectors(e, this.start), $455d545b1dff00eb$var$Cx.subVectors(this.end, this.start);
        const n = $455d545b1dff00eb$var$Cx.dot($455d545b1dff00eb$var$Cx);
        let r = $455d545b1dff00eb$var$Cx.dot($455d545b1dff00eb$var$zM) / n;
        return t && (r = $455d545b1dff00eb$var$Yt(r, 0, 1)), r;
    }
    closestPointToPoint(e, t, n) {
        const i = this.closestPointToPointParameter(e, t);
        return this.delta(n).multiplyScalar(i).add(this.start);
    }
    distanceSqToLine3(e, t = $455d545b1dff00eb$var$u4, n = $455d545b1dff00eb$var$f4) {
        const i = 10000000000000001e-32;
        let r, l;
        const c = this.start, f = e.start, p = this.end, m = e.end;
        $455d545b1dff00eb$var$yd.subVectors(p, c), $455d545b1dff00eb$var$_d.subVectors(m, f), $455d545b1dff00eb$var$f_.subVectors(c, f);
        const x = $455d545b1dff00eb$var$yd.dot($455d545b1dff00eb$var$yd), v = $455d545b1dff00eb$var$_d.dot($455d545b1dff00eb$var$_d), _ = $455d545b1dff00eb$var$_d.dot($455d545b1dff00eb$var$f_);
        if (x <= i && v <= i) return t.copy(c), n.copy(f), t.sub(n), t.dot(t);
        if (x <= i) r = 0, l = _ / v, l = $455d545b1dff00eb$var$Yt(l, 0, 1);
        else {
            const S = $455d545b1dff00eb$var$yd.dot($455d545b1dff00eb$var$f_);
            if (v <= i) l = 0, r = $455d545b1dff00eb$var$Yt(-S / x, 0, 1);
            else {
                const A = $455d545b1dff00eb$var$yd.dot($455d545b1dff00eb$var$_d), M = x * v - A * A;
                M !== 0 ? r = $455d545b1dff00eb$var$Yt((A * _ - S * v) / M, 0, 1) : r = 0, l = (A * r + _) / v, l < 0 ? (l = 0, r = $455d545b1dff00eb$var$Yt(-S / x, 0, 1)) : l > 1 && (l = 1, r = $455d545b1dff00eb$var$Yt((A - S) / x, 0, 1));
            }
        }
        return t.copy(c).add($455d545b1dff00eb$var$yd.multiplyScalar(r)), n.copy(f).add($455d545b1dff00eb$var$_d.multiplyScalar(l)), t.sub(n), t.dot(t);
    }
    applyMatrix4(e) {
        return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this;
    }
    equals(e) {
        return e.start.equals(this.start) && e.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $455d545b1dff00eb$var$PM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$d4 extends $455d545b1dff00eb$var$Pn {
    constructor(e, t){
        super(), this.light = e, this.matrixAutoUpdate = !1, this.color = t, this.type = "SpotLightHelper";
        const n = new $455d545b1dff00eb$var$nn, i = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let l = 0, c = 1, f = 32; l < f; l++, c++){
            const p = l / f * Math.PI * 2, m = c / f * Math.PI * 2;
            i.push(Math.cos(p), Math.sin(p), 1, Math.cos(m), Math.sin(m), 1);
        }
        n.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3));
        const r = new $455d545b1dff00eb$var$Nr({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new $455d545b1dff00eb$var$El(n, r), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), this.parent ? (this.parent.updateWorldMatrix(!0), this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld)) : this.matrix.copy(this.light.matrixWorld), this.matrixWorld.copy(this.light.matrixWorld);
        const e = this.light.distance ? this.light.distance : 1e3, t = e * Math.tan(this.light.angle);
        this.cone.scale.set(t, t, e), $455d545b1dff00eb$var$PM.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt($455d545b1dff00eb$var$PM), this.color !== void 0 ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
}
const $455d545b1dff00eb$var$xu = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Rx = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$h_ = new $455d545b1dff00eb$var$Ft;
class $455d545b1dff00eb$var$p4 extends $455d545b1dff00eb$var$El {
    constructor(e){
        const t = $455d545b1dff00eb$var$yA(e), n = new $455d545b1dff00eb$var$nn, i = [], r = [];
        for(let p = 0; p < t.length; p++){
            const m = t[p];
            m.parent && m.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(0, 0, 0), r.push(0, 0, 0));
        }
        n.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3)), n.setAttribute("color", new $455d545b1dff00eb$var$Dt(r, 3));
        const l = new $455d545b1dff00eb$var$Nr({
            vertexColors: !0,
            depthTest: !1,
            depthWrite: !1,
            toneMapped: !1,
            transparent: !0
        });
        super(n, l), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = e, this.bones = t, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
        const c = new $455d545b1dff00eb$var$_t(255), f = new $455d545b1dff00eb$var$_t(65280);
        this.setColors(c, f);
    }
    updateMatrixWorld(e) {
        const t = this.bones, n = this.geometry, i = n.getAttribute("position");
        $455d545b1dff00eb$var$h_.copy(this.root.matrixWorld).invert();
        for(let r = 0, l = 0; r < t.length; r++){
            const c = t[r];
            c.parent && c.parent.isBone && ($455d545b1dff00eb$var$Rx.multiplyMatrices($455d545b1dff00eb$var$h_, c.matrixWorld), $455d545b1dff00eb$var$xu.setFromMatrixPosition($455d545b1dff00eb$var$Rx), i.setXYZ(l, $455d545b1dff00eb$var$xu.x, $455d545b1dff00eb$var$xu.y, $455d545b1dff00eb$var$xu.z), $455d545b1dff00eb$var$Rx.multiplyMatrices($455d545b1dff00eb$var$h_, c.parent.matrixWorld), $455d545b1dff00eb$var$xu.setFromMatrixPosition($455d545b1dff00eb$var$Rx), i.setXYZ(l + 1, $455d545b1dff00eb$var$xu.x, $455d545b1dff00eb$var$xu.y, $455d545b1dff00eb$var$xu.z), l += 2);
        }
        n.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(e);
    }
    setColors(e, t) {
        const i = this.geometry.getAttribute("color");
        for(let r = 0; r < i.count; r += 2)i.setXYZ(r, e.r, e.g, e.b), i.setXYZ(r + 1, t.r, t.g, t.b);
        return i.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
function $455d545b1dff00eb$var$yA(a) {
    const e = [];
    a.isBone === !0 && e.push(a);
    for(let t = 0; t < a.children.length; t++)e.push(...$455d545b1dff00eb$var$yA(a.children[t]));
    return e;
}
class $455d545b1dff00eb$var$m4 extends $455d545b1dff00eb$var$zi {
    constructor(e, t, n){
        const i = new $455d545b1dff00eb$var$C0(t, 4, 2), r = new $455d545b1dff00eb$var$Ac({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        });
        super(i, r), this.light = e, this.color = n, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.color !== void 0 ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
}
const $455d545b1dff00eb$var$g4 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$BM = new $455d545b1dff00eb$var$_t, $455d545b1dff00eb$var$IM = new $455d545b1dff00eb$var$_t;
class $455d545b1dff00eb$var$x4 extends $455d545b1dff00eb$var$Pn {
    constructor(e, t, n){
        super(), this.light = e, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "HemisphereLightHelper";
        const i = new $455d545b1dff00eb$var$w0(t);
        i.rotateY(Math.PI * .5), this.material = new $455d545b1dff00eb$var$Ac({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        }), this.color === void 0 && (this.material.vertexColors = !0);
        const r = i.getAttribute("position"), l = new Float32Array(r.count * 3);
        i.setAttribute("color", new $455d545b1dff00eb$var$ti(l, 3)), this.add(new $455d545b1dff00eb$var$zi(i, this.material)), this.update();
    }
    dispose() {
        this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }
    update() {
        const e = this.children[0];
        if (this.color !== void 0) this.material.color.set(this.color);
        else {
            const t = e.geometry.getAttribute("color");
            $455d545b1dff00eb$var$BM.copy(this.light.color), $455d545b1dff00eb$var$IM.copy(this.light.groundColor);
            for(let n = 0, i = t.count; n < i; n++){
                const r = n < i / 2 ? $455d545b1dff00eb$var$BM : $455d545b1dff00eb$var$IM;
                t.setXYZ(n, r.r, r.g, r.b);
            }
            t.needsUpdate = !0;
        }
        this.light.updateWorldMatrix(!0, !1), e.lookAt($455d545b1dff00eb$var$g4.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $455d545b1dff00eb$var$v4 extends $455d545b1dff00eb$var$El {
    constructor(e = 10, t = 10, n = 4473924, i = 8947848){
        n = new $455d545b1dff00eb$var$_t(n), i = new $455d545b1dff00eb$var$_t(i);
        const r = t / 2, l = e / t, c = e / 2, f = [], p = [];
        for(let v = 0, _ = 0, S = -c; v <= t; v++, S += l){
            f.push(-c, 0, S, c, 0, S), f.push(S, 0, -c, S, 0, c);
            const A = v === r ? n : i;
            A.toArray(p, _), _ += 3, A.toArray(p, _), _ += 3, A.toArray(p, _), _ += 3, A.toArray(p, _), _ += 3;
        }
        const m = new $455d545b1dff00eb$var$nn;
        m.setAttribute("position", new $455d545b1dff00eb$var$Dt(f, 3)), m.setAttribute("color", new $455d545b1dff00eb$var$Dt(p, 3));
        const x = new $455d545b1dff00eb$var$Nr({
            vertexColors: !0,
            toneMapped: !1
        });
        super(m, x), this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $455d545b1dff00eb$var$y4 extends $455d545b1dff00eb$var$El {
    constructor(e = 10, t = 16, n = 8, i = 64, r = 4473924, l = 8947848){
        r = new $455d545b1dff00eb$var$_t(r), l = new $455d545b1dff00eb$var$_t(l);
        const c = [], f = [];
        if (t > 1) for(let x = 0; x < t; x++){
            const v = x / t * (Math.PI * 2), _ = Math.sin(v) * e, S = Math.cos(v) * e;
            c.push(0, 0, 0), c.push(_, 0, S);
            const A = x & 1 ? r : l;
            f.push(A.r, A.g, A.b), f.push(A.r, A.g, A.b);
        }
        for(let x = 0; x < n; x++){
            const v = x & 1 ? r : l, _ = e - e / n * x;
            for(let S = 0; S < i; S++){
                let A = S / i * (Math.PI * 2), M = Math.sin(A) * _, b = Math.cos(A) * _;
                c.push(M, 0, b), f.push(v.r, v.g, v.b), A = (S + 1) / i * (Math.PI * 2), M = Math.sin(A) * _, b = Math.cos(A) * _, c.push(M, 0, b), f.push(v.r, v.g, v.b);
            }
        }
        const p = new $455d545b1dff00eb$var$nn;
        p.setAttribute("position", new $455d545b1dff00eb$var$Dt(c, 3)), p.setAttribute("color", new $455d545b1dff00eb$var$Dt(f, 3));
        const m = new $455d545b1dff00eb$var$Nr({
            vertexColors: !0,
            toneMapped: !1
        });
        super(p, m), this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
const $455d545b1dff00eb$var$FM = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Dx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$HM = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$_4 extends $455d545b1dff00eb$var$Pn {
    constructor(e, t, n){
        super(), this.light = e, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "DirectionalLightHelper", t === void 0 && (t = 1);
        let i = new $455d545b1dff00eb$var$nn;
        i.setAttribute("position", new $455d545b1dff00eb$var$Dt([
            -t,
            t,
            0,
            t,
            t,
            0,
            t,
            -t,
            0,
            -t,
            -t,
            0,
            -t,
            t,
            0
        ], 3));
        const r = new $455d545b1dff00eb$var$Nr({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new $455d545b1dff00eb$var$Tu(i, r), this.add(this.lightPlane), i = new $455d545b1dff00eb$var$nn, i.setAttribute("position", new $455d545b1dff00eb$var$Dt([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new $455d545b1dff00eb$var$Tu(i, r), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), $455d545b1dff00eb$var$FM.setFromMatrixPosition(this.light.matrixWorld), $455d545b1dff00eb$var$Dx.setFromMatrixPosition(this.light.target.matrixWorld), $455d545b1dff00eb$var$HM.subVectors($455d545b1dff00eb$var$Dx, $455d545b1dff00eb$var$FM), this.lightPlane.lookAt($455d545b1dff00eb$var$Dx), this.color !== void 0 ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt($455d545b1dff00eb$var$Dx), this.targetLine.scale.z = $455d545b1dff00eb$var$HM.length();
    }
}
const $455d545b1dff00eb$var$Ux = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Vi = new $455d545b1dff00eb$var$hy;
class $455d545b1dff00eb$var$b4 extends $455d545b1dff00eb$var$El {
    constructor(e){
        const t = new $455d545b1dff00eb$var$nn, n = new $455d545b1dff00eb$var$Nr({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), i = [], r = [], l = {};
        c("n1", "n2"), c("n2", "n4"), c("n4", "n3"), c("n3", "n1"), c("f1", "f2"), c("f2", "f4"), c("f4", "f3"), c("f3", "f1"), c("n1", "f1"), c("n2", "f2"), c("n3", "f3"), c("n4", "f4"), c("p", "n1"), c("p", "n2"), c("p", "n3"), c("p", "n4"), c("u1", "u2"), c("u2", "u3"), c("u3", "u1"), c("c", "t"), c("p", "c"), c("cn1", "cn2"), c("cn3", "cn4"), c("cf1", "cf2"), c("cf3", "cf4");
        function c(S, A) {
            f(S), f(A);
        }
        function f(S) {
            i.push(0, 0, 0), r.push(0, 0, 0), l[S] === void 0 && (l[S] = []), l[S].push(i.length / 3 - 1);
        }
        t.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3)), t.setAttribute("color", new $455d545b1dff00eb$var$Dt(r, 3)), super(t, n), this.type = "CameraHelper", this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = l, this.update();
        const p = new $455d545b1dff00eb$var$_t(16755200), m = new $455d545b1dff00eb$var$_t(16711680), x = new $455d545b1dff00eb$var$_t(43775), v = new $455d545b1dff00eb$var$_t(16777215), _ = new $455d545b1dff00eb$var$_t(3355443);
        this.setColors(p, m, x, v, _);
    }
    setColors(e, t, n, i, r) {
        const c = this.geometry.getAttribute("color");
        return c.setXYZ(0, e.r, e.g, e.b), c.setXYZ(1, e.r, e.g, e.b), c.setXYZ(2, e.r, e.g, e.b), c.setXYZ(3, e.r, e.g, e.b), c.setXYZ(4, e.r, e.g, e.b), c.setXYZ(5, e.r, e.g, e.b), c.setXYZ(6, e.r, e.g, e.b), c.setXYZ(7, e.r, e.g, e.b), c.setXYZ(8, e.r, e.g, e.b), c.setXYZ(9, e.r, e.g, e.b), c.setXYZ(10, e.r, e.g, e.b), c.setXYZ(11, e.r, e.g, e.b), c.setXYZ(12, e.r, e.g, e.b), c.setXYZ(13, e.r, e.g, e.b), c.setXYZ(14, e.r, e.g, e.b), c.setXYZ(15, e.r, e.g, e.b), c.setXYZ(16, e.r, e.g, e.b), c.setXYZ(17, e.r, e.g, e.b), c.setXYZ(18, e.r, e.g, e.b), c.setXYZ(19, e.r, e.g, e.b), c.setXYZ(20, e.r, e.g, e.b), c.setXYZ(21, e.r, e.g, e.b), c.setXYZ(22, e.r, e.g, e.b), c.setXYZ(23, e.r, e.g, e.b), c.setXYZ(24, t.r, t.g, t.b), c.setXYZ(25, t.r, t.g, t.b), c.setXYZ(26, t.r, t.g, t.b), c.setXYZ(27, t.r, t.g, t.b), c.setXYZ(28, t.r, t.g, t.b), c.setXYZ(29, t.r, t.g, t.b), c.setXYZ(30, t.r, t.g, t.b), c.setXYZ(31, t.r, t.g, t.b), c.setXYZ(32, n.r, n.g, n.b), c.setXYZ(33, n.r, n.g, n.b), c.setXYZ(34, n.r, n.g, n.b), c.setXYZ(35, n.r, n.g, n.b), c.setXYZ(36, n.r, n.g, n.b), c.setXYZ(37, n.r, n.g, n.b), c.setXYZ(38, i.r, i.g, i.b), c.setXYZ(39, i.r, i.g, i.b), c.setXYZ(40, r.r, r.g, r.b), c.setXYZ(41, r.r, r.g, r.b), c.setXYZ(42, r.r, r.g, r.b), c.setXYZ(43, r.r, r.g, r.b), c.setXYZ(44, r.r, r.g, r.b), c.setXYZ(45, r.r, r.g, r.b), c.setXYZ(46, r.r, r.g, r.b), c.setXYZ(47, r.r, r.g, r.b), c.setXYZ(48, r.r, r.g, r.b), c.setXYZ(49, r.r, r.g, r.b), c.needsUpdate = !0, this;
    }
    update() {
        const e = this.geometry, t = this.pointMap, n = 1, i = 1;
        let r, l;
        if ($455d545b1dff00eb$var$Vi.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), this.camera.reversedDepth === !0) r = 1, l = 0;
        else if (this.camera.coordinateSystem === $455d545b1dff00eb$var$_s) r = -1, l = 1;
        else if (this.camera.coordinateSystem === $455d545b1dff00eb$var$Bd) r = 0, l = 1;
        else throw new Error("THREE.CameraHelper.update(): Invalid coordinate system: " + this.camera.coordinateSystem);
        $455d545b1dff00eb$var$qi("c", t, e, $455d545b1dff00eb$var$Vi, 0, 0, r), $455d545b1dff00eb$var$qi("t", t, e, $455d545b1dff00eb$var$Vi, 0, 0, l), $455d545b1dff00eb$var$qi("n1", t, e, $455d545b1dff00eb$var$Vi, -n, -i, r), $455d545b1dff00eb$var$qi("n2", t, e, $455d545b1dff00eb$var$Vi, n, -i, r), $455d545b1dff00eb$var$qi("n3", t, e, $455d545b1dff00eb$var$Vi, -n, i, r), $455d545b1dff00eb$var$qi("n4", t, e, $455d545b1dff00eb$var$Vi, n, i, r), $455d545b1dff00eb$var$qi("f1", t, e, $455d545b1dff00eb$var$Vi, -n, -i, l), $455d545b1dff00eb$var$qi("f2", t, e, $455d545b1dff00eb$var$Vi, n, -i, l), $455d545b1dff00eb$var$qi("f3", t, e, $455d545b1dff00eb$var$Vi, -n, i, l), $455d545b1dff00eb$var$qi("f4", t, e, $455d545b1dff00eb$var$Vi, n, i, l), $455d545b1dff00eb$var$qi("u1", t, e, $455d545b1dff00eb$var$Vi, n * .7, i * 1.1, r), $455d545b1dff00eb$var$qi("u2", t, e, $455d545b1dff00eb$var$Vi, -n * .7, i * 1.1, r), $455d545b1dff00eb$var$qi("u3", t, e, $455d545b1dff00eb$var$Vi, 0, i * 2, r), $455d545b1dff00eb$var$qi("cf1", t, e, $455d545b1dff00eb$var$Vi, -n, 0, l), $455d545b1dff00eb$var$qi("cf2", t, e, $455d545b1dff00eb$var$Vi, n, 0, l), $455d545b1dff00eb$var$qi("cf3", t, e, $455d545b1dff00eb$var$Vi, 0, -i, l), $455d545b1dff00eb$var$qi("cf4", t, e, $455d545b1dff00eb$var$Vi, 0, i, l), $455d545b1dff00eb$var$qi("cn1", t, e, $455d545b1dff00eb$var$Vi, -n, 0, r), $455d545b1dff00eb$var$qi("cn2", t, e, $455d545b1dff00eb$var$Vi, n, 0, r), $455d545b1dff00eb$var$qi("cn3", t, e, $455d545b1dff00eb$var$Vi, 0, -i, r), $455d545b1dff00eb$var$qi("cn4", t, e, $455d545b1dff00eb$var$Vi, 0, i, r), e.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
function $455d545b1dff00eb$var$qi(a, e, t, n, i, r, l) {
    $455d545b1dff00eb$var$Ux.set(i, r, l).unproject(n);
    const c = e[a];
    if (c !== void 0) {
        const f = t.getAttribute("position");
        for(let p = 0, m = c.length; p < m; p++)f.setXYZ(c[p], $455d545b1dff00eb$var$Ux.x, $455d545b1dff00eb$var$Ux.y, $455d545b1dff00eb$var$Ux.z);
    }
}
const $455d545b1dff00eb$var$Nx = new $455d545b1dff00eb$var$ca;
class $455d545b1dff00eb$var$S4 extends $455d545b1dff00eb$var$El {
    constructor(e, t = 16776960){
        const n = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = new Float32Array(24), r = new $455d545b1dff00eb$var$nn;
        r.setIndex(new $455d545b1dff00eb$var$ti(n, 1)), r.setAttribute("position", new $455d545b1dff00eb$var$ti(i, 3)), super(r, new $455d545b1dff00eb$var$Nr({
            color: t,
            toneMapped: !1
        })), this.object = e, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
    }
    update() {
        if (this.object !== void 0 && $455d545b1dff00eb$var$Nx.setFromObject(this.object), $455d545b1dff00eb$var$Nx.isEmpty()) return;
        const e = $455d545b1dff00eb$var$Nx.min, t = $455d545b1dff00eb$var$Nx.max, n = this.geometry.attributes.position, i = n.array;
        i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = e.x, i[4] = t.y, i[5] = t.z, i[6] = e.x, i[7] = e.y, i[8] = t.z, i[9] = t.x, i[10] = e.y, i[11] = t.z, i[12] = t.x, i[13] = t.y, i[14] = e.z, i[15] = e.x, i[16] = t.y, i[17] = e.z, i[18] = e.x, i[19] = e.y, i[20] = e.z, i[21] = t.x, i[22] = e.y, i[23] = e.z, n.needsUpdate = !0, this.geometry.computeBoundingSphere();
    }
    setFromObject(e) {
        return this.object = e, this.update(), this;
    }
    copy(e, t) {
        return super.copy(e, t), this.object = e.object, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $455d545b1dff00eb$var$M4 extends $455d545b1dff00eb$var$El {
    constructor(e, t = 16776960){
        const n = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], r = new $455d545b1dff00eb$var$nn;
        r.setIndex(new $455d545b1dff00eb$var$ti(n, 1)), r.setAttribute("position", new $455d545b1dff00eb$var$Dt(i, 3)), super(r, new $455d545b1dff00eb$var$Nr({
            color: t,
            toneMapped: !1
        })), this.box = e, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(e) {
        const t = this.box;
        t.isEmpty() || (t.getCenter(this.position), t.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(e));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $455d545b1dff00eb$var$E4 extends $455d545b1dff00eb$var$Tu {
    constructor(e, t = 1, n = 16776960){
        const i = n, r = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ], l = new $455d545b1dff00eb$var$nn;
        l.setAttribute("position", new $455d545b1dff00eb$var$Dt(r, 3)), l.computeBoundingSphere(), super(l, new $455d545b1dff00eb$var$Nr({
            color: i,
            toneMapped: !1
        })), this.type = "PlaneHelper", this.plane = e, this.size = t;
        const c = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ], f = new $455d545b1dff00eb$var$nn;
        f.setAttribute("position", new $455d545b1dff00eb$var$Dt(c, 3)), f.computeBoundingSphere(), this.add(new $455d545b1dff00eb$var$zi(f, new $455d545b1dff00eb$var$Ac({
            color: i,
            opacity: .2,
            transparent: !0,
            depthWrite: !1,
            toneMapped: !1
        })));
    }
    updateMatrixWorld(e) {
        this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(e);
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }
}
const $455d545b1dff00eb$var$VM = new $455d545b1dff00eb$var$J;
let $455d545b1dff00eb$var$Ox, $455d545b1dff00eb$var$d_;
class $455d545b1dff00eb$var$T4 extends $455d545b1dff00eb$var$Pn {
    constructor(e = new $455d545b1dff00eb$var$J(0, 0, 1), t = new $455d545b1dff00eb$var$J(0, 0, 0), n = 1, i = 16776960, r = n * .2, l = r * .2){
        super(), this.type = "ArrowHelper", $455d545b1dff00eb$var$Ox === void 0 && ($455d545b1dff00eb$var$Ox = new $455d545b1dff00eb$var$nn, $455d545b1dff00eb$var$Ox.setAttribute("position", new $455d545b1dff00eb$var$Dt([
            0,
            0,
            0,
            0,
            1,
            0
        ], 3)), $455d545b1dff00eb$var$d_ = new $455d545b1dff00eb$var$A0(.5, 1, 5, 1), $455d545b1dff00eb$var$d_.translate(0, -0.5, 0)), this.position.copy(t), this.line = new $455d545b1dff00eb$var$Tu($455d545b1dff00eb$var$Ox, new $455d545b1dff00eb$var$Nr({
            color: i,
            toneMapped: !1
        })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new $455d545b1dff00eb$var$zi($455d545b1dff00eb$var$d_, new $455d545b1dff00eb$var$Ac({
            color: i,
            toneMapped: !1
        })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(e), this.setLength(n, r, l);
    }
    setDirection(e) {
        if (e.y > .99999) this.quaternion.set(0, 0, 0, 1);
        else if (e.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $455d545b1dff00eb$var$VM.set(e.z, 0, -e.x).normalize();
            const t = Math.acos(e.y);
            this.quaternion.setFromAxisAngle($455d545b1dff00eb$var$VM, t);
        }
    }
    setLength(e, t = e * .2, n = t * .2) {
        this.line.scale.set(1, Math.max(1e-4, e - t), 1), this.line.updateMatrix(), this.cone.scale.set(n, t, n), this.cone.position.y = e, this.cone.updateMatrix();
    }
    setColor(e) {
        this.line.material.color.set(e), this.cone.material.color.set(e);
    }
    copy(e) {
        return super.copy(e, !1), this.line.copy(e.line), this.cone.copy(e.cone), this;
    }
    dispose() {
        this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
    }
}
class $455d545b1dff00eb$var$A4 extends $455d545b1dff00eb$var$El {
    constructor(e = 1){
        const t = [
            0,
            0,
            0,
            e,
            0,
            0,
            0,
            0,
            0,
            0,
            e,
            0,
            0,
            0,
            0,
            0,
            0,
            e
        ], n = [
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], i = new $455d545b1dff00eb$var$nn;
        i.setAttribute("position", new $455d545b1dff00eb$var$Dt(t, 3)), i.setAttribute("color", new $455d545b1dff00eb$var$Dt(n, 3));
        const r = new $455d545b1dff00eb$var$Nr({
            vertexColors: !0,
            toneMapped: !1
        });
        super(i, r), this.type = "AxesHelper";
    }
    setColors(e, t, n) {
        const i = new $455d545b1dff00eb$var$_t, r = this.geometry.attributes.color.array;
        return i.set(e), i.toArray(r, 0), i.toArray(r, 3), i.set(t), i.toArray(r, 6), i.toArray(r, 9), i.set(n), i.toArray(r, 12), i.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
}
class $455d545b1dff00eb$var$w4 {
    constructor(){
        this.type = "ShapePath", this.color = new $455d545b1dff00eb$var$_t, this.subPaths = [], this.currentPath = null;
    }
    moveTo(e, t) {
        return this.currentPath = new $455d545b1dff00eb$var$Gv, this.subPaths.push(this.currentPath), this.currentPath.moveTo(e, t), this;
    }
    lineTo(e, t) {
        return this.currentPath.lineTo(e, t), this;
    }
    quadraticCurveTo(e, t, n, i) {
        return this.currentPath.quadraticCurveTo(e, t, n, i), this;
    }
    bezierCurveTo(e, t, n, i, r, l) {
        return this.currentPath.bezierCurveTo(e, t, n, i, r, l), this;
    }
    splineThru(e) {
        return this.currentPath.splineThru(e), this;
    }
    toShapes(e) {
        function t(b) {
            const C = [];
            for(let R = 0, N = b.length; R < N; R++){
                const z = b[R], L = new $455d545b1dff00eb$var$Vf;
                L.curves = z.curves, C.push(L);
            }
            return C;
        }
        function n(b, C) {
            const R = C.length;
            let N = !1;
            for(let z = R - 1, L = 0; L < R; z = L++){
                let P = C[z], H = C[L], O = H.x - P.x, D = H.y - P.y;
                if (Math.abs(D) > Number.EPSILON) {
                    if (D < 0 && (P = C[L], O = -O, H = C[z], D = -D), b.y < P.y || b.y > H.y) continue;
                    if (b.y === P.y) {
                        if (b.x === P.x) return !0;
                    } else {
                        const j = D * (b.x - P.x) - O * (b.y - P.y);
                        if (j === 0) return !0;
                        if (j < 0) continue;
                        N = !N;
                    }
                } else {
                    if (b.y !== P.y) continue;
                    if (H.x <= b.x && b.x <= P.x || P.x <= b.x && b.x <= H.x) return !0;
                }
            }
            return N;
        }
        const i = $455d545b1dff00eb$var$Co.isClockWise, r = this.subPaths;
        if (r.length === 0) return [];
        let l, c, f;
        const p = [];
        if (r.length === 1) return c = r[0], f = new $455d545b1dff00eb$var$Vf, f.curves = c.curves, p.push(f), p;
        let m = !i(r[0].getPoints());
        m = e ? !m : m;
        const x = [], v = [];
        let _ = [], S = 0, A;
        v[S] = void 0, _[S] = [];
        for(let b = 0, C = r.length; b < C; b++)c = r[b], A = c.getPoints(), l = i(A), l = e ? !l : l, l ? (!m && v[S] && S++, v[S] = {
            s: new $455d545b1dff00eb$var$Vf,
            p: A
        }, v[S].s.curves = c.curves, m && S++, _[S] = []) : _[S].push({
            h: c,
            p: A[0]
        });
        if (!v[0]) return t(r);
        if (v.length > 1) {
            let b = !1, C = 0;
            for(let R = 0, N = v.length; R < N; R++)x[R] = [];
            for(let R = 0, N = v.length; R < N; R++){
                const z = _[R];
                for(let L = 0; L < z.length; L++){
                    const P = z[L];
                    let H = !0;
                    for(let O = 0; O < v.length; O++)n(P.p, v[O].p) && (R !== O && C++, H ? (H = !1, x[O].push(P)) : b = !0);
                    H && x[R].push(P);
                }
            }
            C > 0 && b === !1 && (_ = x);
        }
        let M;
        for(let b = 0, C = v.length; b < C; b++){
            f = v[b].s, p.push(f), M = _[b];
            for(let R = 0, N = M.length; R < N; R++)f.holes.push(M[R].h);
        }
        return p;
    }
}
class $455d545b1dff00eb$var$_A extends $455d545b1dff00eb$var$Ml {
    constructor(e, t = null){
        super(), this.object = e, this.domElement = t, this.enabled = !0, this.state = -1, this.keys = {}, this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        }, this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect(e) {
        if (e === void 0) {
            $455d545b1dff00eb$var$Mt("Controls: connect() now requires an element.");
            return;
        }
        this.domElement !== null && this.disconnect(), this.domElement = e;
    }
    disconnect() {}
    dispose() {}
    update() {}
}
function $455d545b1dff00eb$var$C4(a, e) {
    const t = a.image && a.image.width ? a.image.width / a.image.height : 1;
    return t > e ? (a.repeat.x = 1, a.repeat.y = t / e, a.offset.x = 0, a.offset.y = (1 - a.repeat.y) / 2) : (a.repeat.x = e / t, a.repeat.y = 1, a.offset.x = (1 - a.repeat.x) / 2, a.offset.y = 0), a;
}
function $455d545b1dff00eb$var$R4(a, e) {
    const t = a.image && a.image.width ? a.image.width / a.image.height : 1;
    return t > e ? (a.repeat.x = e / t, a.repeat.y = 1, a.offset.x = (1 - a.repeat.x) / 2, a.offset.y = 0) : (a.repeat.x = 1, a.repeat.y = t / e, a.offset.x = 0, a.offset.y = (1 - a.repeat.y) / 2), a;
}
function $455d545b1dff00eb$var$D4(a) {
    return a.repeat.x = 1, a.repeat.y = 1, a.offset.x = 0, a.offset.y = 0, a;
}
function $455d545b1dff00eb$var$rb(a, e, t, n) {
    const i = $455d545b1dff00eb$var$U4(n);
    switch(t){
        case $455d545b1dff00eb$var$zb:
            return a * e;
        case $455d545b1dff00eb$var$ry:
            return a * e / i.components * i.byteLength;
        case $455d545b1dff00eb$var$M0:
            return a * e / i.components * i.byteLength;
        case $455d545b1dff00eb$var$sy:
            return a * e * 2 / i.components * i.byteLength;
        case $455d545b1dff00eb$var$oy:
            return a * e * 2 / i.components * i.byteLength;
        case $455d545b1dff00eb$var$Pb:
            return a * e * 3 / i.components * i.byteLength;
        case $455d545b1dff00eb$var$ar:
            return a * e * 4 / i.components * i.byteLength;
        case $455d545b1dff00eb$var$ly:
            return a * e * 4 / i.components * i.byteLength;
        case $455d545b1dff00eb$var$Hm:
        case $455d545b1dff00eb$var$Vm:
            return Math.floor((a + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case $455d545b1dff00eb$var$Gm:
        case $455d545b1dff00eb$var$km:
            return Math.floor((a + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $455d545b1dff00eb$var$fv:
        case $455d545b1dff00eb$var$dv:
            return Math.max(a, 16) * Math.max(e, 8) / 4;
        case $455d545b1dff00eb$var$uv:
        case $455d545b1dff00eb$var$hv:
            return Math.max(a, 8) * Math.max(e, 8) / 2;
        case $455d545b1dff00eb$var$pv:
        case $455d545b1dff00eb$var$mv:
            return Math.floor((a + 3) / 4) * Math.floor((e + 3) / 4) * 8;
        case $455d545b1dff00eb$var$gv:
            return Math.floor((a + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $455d545b1dff00eb$var$xv:
            return Math.floor((a + 3) / 4) * Math.floor((e + 3) / 4) * 16;
        case $455d545b1dff00eb$var$vv:
            return Math.floor((a + 4) / 5) * Math.floor((e + 3) / 4) * 16;
        case $455d545b1dff00eb$var$yv:
            return Math.floor((a + 4) / 5) * Math.floor((e + 4) / 5) * 16;
        case $455d545b1dff00eb$var$_v:
            return Math.floor((a + 5) / 6) * Math.floor((e + 4) / 5) * 16;
        case $455d545b1dff00eb$var$bv:
            return Math.floor((a + 5) / 6) * Math.floor((e + 5) / 6) * 16;
        case $455d545b1dff00eb$var$Sv:
            return Math.floor((a + 7) / 8) * Math.floor((e + 4) / 5) * 16;
        case $455d545b1dff00eb$var$Mv:
            return Math.floor((a + 7) / 8) * Math.floor((e + 5) / 6) * 16;
        case $455d545b1dff00eb$var$Ev:
            return Math.floor((a + 7) / 8) * Math.floor((e + 7) / 8) * 16;
        case $455d545b1dff00eb$var$Tv:
            return Math.floor((a + 9) / 10) * Math.floor((e + 4) / 5) * 16;
        case $455d545b1dff00eb$var$Av:
            return Math.floor((a + 9) / 10) * Math.floor((e + 5) / 6) * 16;
        case $455d545b1dff00eb$var$wv:
            return Math.floor((a + 9) / 10) * Math.floor((e + 7) / 8) * 16;
        case $455d545b1dff00eb$var$Cv:
            return Math.floor((a + 9) / 10) * Math.floor((e + 9) / 10) * 16;
        case $455d545b1dff00eb$var$Rv:
            return Math.floor((a + 11) / 12) * Math.floor((e + 9) / 10) * 16;
        case $455d545b1dff00eb$var$Dv:
            return Math.floor((a + 11) / 12) * Math.floor((e + 11) / 12) * 16;
        case $455d545b1dff00eb$var$Uv:
        case $455d545b1dff00eb$var$Nv:
        case $455d545b1dff00eb$var$Ov:
            return Math.ceil(a / 4) * Math.ceil(e / 4) * 16;
        case $455d545b1dff00eb$var$Lv:
        case $455d545b1dff00eb$var$zv:
            return Math.ceil(a / 4) * Math.ceil(e / 4) * 8;
        case $455d545b1dff00eb$var$Pv:
        case $455d545b1dff00eb$var$Bv:
            return Math.ceil(a / 4) * Math.ceil(e / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${t} format.`);
}
function $455d545b1dff00eb$var$U4(a) {
    switch(a){
        case $455d545b1dff00eb$var$Ws:
        case $455d545b1dff00eb$var$Ub:
            return {
                byteLength: 1,
                components: 1
            };
        case $455d545b1dff00eb$var$Od:
        case $455d545b1dff00eb$var$Nb:
        case $455d545b1dff00eb$var$wu:
            return {
                byteLength: 2,
                components: 1
            };
        case $455d545b1dff00eb$var$iy:
        case $455d545b1dff00eb$var$ay:
            return {
                byteLength: 2,
                components: 4
            };
        case $455d545b1dff00eb$var$Mc:
        case $455d545b1dff00eb$var$ny:
        case $455d545b1dff00eb$var$Rr:
            return {
                byteLength: 4,
                components: 1
            };
        case $455d545b1dff00eb$var$Ob:
        case $455d545b1dff00eb$var$Lb:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${a}.`);
}
class $455d545b1dff00eb$var$N4 {
    static contain(e, t) {
        return $455d545b1dff00eb$var$C4(e, t);
    }
    static cover(e, t) {
        return $455d545b1dff00eb$var$R4(e, t);
    }
    static fill(e) {
        return $455d545b1dff00eb$var$D4(e);
    }
    static getByteLength(e, t, n, i) {
        return $455d545b1dff00eb$var$rb(e, t, n, i);
    }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $455d545b1dff00eb$var$$v
    }
}));
typeof window < "u" && (window.__THREE__ ? $455d545b1dff00eb$var$Mt("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $455d545b1dff00eb$var$$v);
function $455d545b1dff00eb$var$bA() {
    let a = null, e = !1, t = null, n = null;
    function i(r, l) {
        t(r, l), n = a.requestAnimationFrame(i);
    }
    return {
        start: function() {
            e !== !0 && t !== null && (n = a.requestAnimationFrame(i), e = !0);
        },
        stop: function() {
            a.cancelAnimationFrame(n), e = !1;
        },
        setAnimationLoop: function(r) {
            t = r;
        },
        setContext: function(r) {
            a = r;
        }
    };
}
function $455d545b1dff00eb$var$O4(a) {
    const e = new WeakMap;
    function t(c, f) {
        const p = c.array, m = c.usage, x = p.byteLength, v = a.createBuffer();
        a.bindBuffer(f, v), a.bufferData(f, p, m), c.onUploadCallback();
        let _;
        if (p instanceof Float32Array) _ = a.FLOAT;
        else if (typeof Float16Array < "u" && p instanceof Float16Array) _ = a.HALF_FLOAT;
        else if (p instanceof Uint16Array) c.isFloat16BufferAttribute ? _ = a.HALF_FLOAT : _ = a.UNSIGNED_SHORT;
        else if (p instanceof Int16Array) _ = a.SHORT;
        else if (p instanceof Uint32Array) _ = a.UNSIGNED_INT;
        else if (p instanceof Int32Array) _ = a.INT;
        else if (p instanceof Int8Array) _ = a.BYTE;
        else if (p instanceof Uint8Array) _ = a.UNSIGNED_BYTE;
        else if (p instanceof Uint8ClampedArray) _ = a.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + p);
        return {
            buffer: v,
            type: _,
            bytesPerElement: p.BYTES_PER_ELEMENT,
            version: c.version,
            size: x
        };
    }
    function n(c, f, p) {
        const m = f.array, x = f.updateRanges;
        if (a.bindBuffer(p, c), x.length === 0) a.bufferSubData(p, 0, m);
        else {
            x.sort((_, S)=>_.start - S.start);
            let v = 0;
            for(let _ = 1; _ < x.length; _++){
                const S = x[v], A = x[_];
                A.start <= S.start + S.count + 1 ? S.count = Math.max(S.count, A.start + A.count - S.start) : (++v, x[v] = A);
            }
            x.length = v + 1;
            for(let _ = 0, S = x.length; _ < S; _++){
                const A = x[_];
                a.bufferSubData(p, A.start * m.BYTES_PER_ELEMENT, m, A.start, A.count);
            }
            f.clearUpdateRanges();
        }
        f.onUploadCallback();
    }
    function i(c) {
        return c.isInterleavedBufferAttribute && (c = c.data), e.get(c);
    }
    function r(c) {
        c.isInterleavedBufferAttribute && (c = c.data);
        const f = e.get(c);
        f && (a.deleteBuffer(f.buffer), e.delete(c));
    }
    function l(c, f) {
        if (c.isInterleavedBufferAttribute && (c = c.data), c.isGLBufferAttribute) {
            const m = e.get(c);
            (!m || m.version < c.version) && e.set(c, {
                buffer: c.buffer,
                type: c.type,
                bytesPerElement: c.elementSize,
                version: c.version
            });
            return;
        }
        const p = e.get(c);
        if (p === void 0) e.set(c, t(c, f));
        else if (p.version < c.version) {
            if (p.size !== c.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
            n(p.buffer, c, f), p.version = c.version;
        }
    }
    return {
        get: i,
        remove: r,
        update: l
    };
}
var $455d545b1dff00eb$var$L4 = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, $455d545b1dff00eb$var$z4 = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, $455d545b1dff00eb$var$P4 = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, $455d545b1dff00eb$var$B4 = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, $455d545b1dff00eb$var$I4 = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, $455d545b1dff00eb$var$F4 = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, $455d545b1dff00eb$var$H4 = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, $455d545b1dff00eb$var$V4 = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, $455d545b1dff00eb$var$G4 = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, $455d545b1dff00eb$var$k4 = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, $455d545b1dff00eb$var$j4 = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, $455d545b1dff00eb$var$X4 = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, $455d545b1dff00eb$var$W4 = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, $455d545b1dff00eb$var$q4 = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, $455d545b1dff00eb$var$Y4 = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, $455d545b1dff00eb$var$Z4 = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, $455d545b1dff00eb$var$Q4 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, $455d545b1dff00eb$var$K4 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, $455d545b1dff00eb$var$J4 = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, $455d545b1dff00eb$var$$4 = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, $455d545b1dff00eb$var$eO = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, $455d545b1dff00eb$var$tO = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, $455d545b1dff00eb$var$nO = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, $455d545b1dff00eb$var$iO = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, $455d545b1dff00eb$var$aO = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, $455d545b1dff00eb$var$rO = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, $455d545b1dff00eb$var$sO = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, $455d545b1dff00eb$var$oO = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, $455d545b1dff00eb$var$lO = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, $455d545b1dff00eb$var$cO = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, $455d545b1dff00eb$var$uO = "gl_FragColor = linearToOutputTexel( gl_FragColor );", $455d545b1dff00eb$var$fO = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, $455d545b1dff00eb$var$hO = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, $455d545b1dff00eb$var$dO = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
#endif`, $455d545b1dff00eb$var$pO = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, $455d545b1dff00eb$var$mO = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, $455d545b1dff00eb$var$gO = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, $455d545b1dff00eb$var$xO = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, $455d545b1dff00eb$var$vO = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, $455d545b1dff00eb$var$yO = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, $455d545b1dff00eb$var$_O = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, $455d545b1dff00eb$var$bO = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, $455d545b1dff00eb$var$SO = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, $455d545b1dff00eb$var$MO = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, $455d545b1dff00eb$var$EO = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, $455d545b1dff00eb$var$TO = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, $455d545b1dff00eb$var$AO = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, $455d545b1dff00eb$var$wO = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, $455d545b1dff00eb$var$CO = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, $455d545b1dff00eb$var$RO = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, $455d545b1dff00eb$var$DO = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, $455d545b1dff00eb$var$UO = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, $455d545b1dff00eb$var$NO = `uniform sampler2D dfgLUT;
struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 uv = vec2( roughness, dotNV );
	return texture2D( dfgLUT, uv ).rg;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
vec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 dfgV = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNV * dotNV), 0.0, dotNV), material.roughness );
	vec2 dfgL = DFGApprox( vec3(0.0, 0.0, 1.0), vec3(sqrt(1.0 - dotNL * dotNL), 0.0, dotNL), material.roughness );
	vec3 FssEss_V = material.specularColor * dfgV.x + material.specularF90 * dfgV.y;
	vec3 FssEss_L = material.specularColor * dfgL.x + material.specularF90 * dfgL.y;
	float Ess_V = dfgV.x + dfgV.y;
	float Ess_L = dfgL.x + dfgL.y;
	float Ems_V = 1.0 - Ess_V;
	float Ems_L = 1.0 - Ess_L;
	vec3 Favg = material.specularColor + ( 1.0 - material.specularColor ) * 0.047619;
	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg * Favg + EPSILON );
	float compensationFactor = Ems_V * Ems_L;
	vec3 multiScatter = Fms * compensationFactor;
	return singleScatter + multiScatter;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, $455d545b1dff00eb$var$OO = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, $455d545b1dff00eb$var$LO = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, $455d545b1dff00eb$var$zO = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, $455d545b1dff00eb$var$PO = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, $455d545b1dff00eb$var$BO = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, $455d545b1dff00eb$var$IO = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, $455d545b1dff00eb$var$FO = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, $455d545b1dff00eb$var$HO = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, $455d545b1dff00eb$var$VO = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, $455d545b1dff00eb$var$GO = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, $455d545b1dff00eb$var$kO = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, $455d545b1dff00eb$var$jO = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, $455d545b1dff00eb$var$XO = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, $455d545b1dff00eb$var$WO = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, $455d545b1dff00eb$var$qO = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, $455d545b1dff00eb$var$YO = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, $455d545b1dff00eb$var$ZO = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, $455d545b1dff00eb$var$QO = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, $455d545b1dff00eb$var$KO = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, $455d545b1dff00eb$var$JO = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, $455d545b1dff00eb$var$$O = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, $455d545b1dff00eb$var$eL = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, $455d545b1dff00eb$var$tL = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, $455d545b1dff00eb$var$nL = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, $455d545b1dff00eb$var$iL = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, $455d545b1dff00eb$var$aL = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, $455d545b1dff00eb$var$rL = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, $455d545b1dff00eb$var$sL = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, $455d545b1dff00eb$var$oL = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, $455d545b1dff00eb$var$lL = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, $455d545b1dff00eb$var$cL = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, $455d545b1dff00eb$var$uL = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, $455d545b1dff00eb$var$fL = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, $455d545b1dff00eb$var$hL = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, $455d545b1dff00eb$var$dL = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, $455d545b1dff00eb$var$pL = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, $455d545b1dff00eb$var$mL = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		float depth = unpackRGBAToDepth( texture2D( depths, uv ) );
		#ifdef USE_REVERSED_DEPTH_BUFFER
			return step( depth, compare );
		#else
			return step( compare, depth );
		#endif
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow( sampler2D shadow, vec2 uv, float compare ) {
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		#ifdef USE_REVERSED_DEPTH_BUFFER
			float hard_shadow = step( distribution.x, compare );
		#else
			float hard_shadow = step( compare, distribution.x );
		#endif
		if ( hard_shadow != 1.0 ) {
			float distance = compare - distribution.x;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`, $455d545b1dff00eb$var$gL = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, $455d545b1dff00eb$var$xL = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, $455d545b1dff00eb$var$vL = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, $455d545b1dff00eb$var$yL = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, $455d545b1dff00eb$var$_L = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, $455d545b1dff00eb$var$bL = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, $455d545b1dff00eb$var$SL = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, $455d545b1dff00eb$var$ML = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, $455d545b1dff00eb$var$EL = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, $455d545b1dff00eb$var$TL = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, $455d545b1dff00eb$var$AL = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, $455d545b1dff00eb$var$wL = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, $455d545b1dff00eb$var$CL = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, $455d545b1dff00eb$var$RL = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, $455d545b1dff00eb$var$DL = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, $455d545b1dff00eb$var$UL = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, $455d545b1dff00eb$var$NL = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const $455d545b1dff00eb$var$OL = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, $455d545b1dff00eb$var$LL = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, $455d545b1dff00eb$var$zL = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, $455d545b1dff00eb$var$PL = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, $455d545b1dff00eb$var$BL = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, $455d545b1dff00eb$var$IL = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, $455d545b1dff00eb$var$FL = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, $455d545b1dff00eb$var$HL = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSED_DEPTH_BUFFER
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, $455d545b1dff00eb$var$VL = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, $455d545b1dff00eb$var$GL = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, $455d545b1dff00eb$var$kL = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, $455d545b1dff00eb$var$jL = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, $455d545b1dff00eb$var$XL = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$WL = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, $455d545b1dff00eb$var$qL = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$YL = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$ZL = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$QL = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$KL = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, $455d545b1dff00eb$var$JL = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$$L = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, $455d545b1dff00eb$var$e5 = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, $455d545b1dff00eb$var$t5 = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$n5 = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$i5 = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, $455d545b1dff00eb$var$a5 = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$r5 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$s5 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, $455d545b1dff00eb$var$o5 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$l5 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, $455d545b1dff00eb$var$c5 = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$u5 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, $455d545b1dff00eb$var$f5 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, $455d545b1dff00eb$var$h5 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, $455d545b1dff00eb$var$rn = {
    alphahash_fragment: $455d545b1dff00eb$var$L4,
    alphahash_pars_fragment: $455d545b1dff00eb$var$z4,
    alphamap_fragment: $455d545b1dff00eb$var$P4,
    alphamap_pars_fragment: $455d545b1dff00eb$var$B4,
    alphatest_fragment: $455d545b1dff00eb$var$I4,
    alphatest_pars_fragment: $455d545b1dff00eb$var$F4,
    aomap_fragment: $455d545b1dff00eb$var$H4,
    aomap_pars_fragment: $455d545b1dff00eb$var$V4,
    batching_pars_vertex: $455d545b1dff00eb$var$G4,
    batching_vertex: $455d545b1dff00eb$var$k4,
    begin_vertex: $455d545b1dff00eb$var$j4,
    beginnormal_vertex: $455d545b1dff00eb$var$X4,
    bsdfs: $455d545b1dff00eb$var$W4,
    iridescence_fragment: $455d545b1dff00eb$var$q4,
    bumpmap_pars_fragment: $455d545b1dff00eb$var$Y4,
    clipping_planes_fragment: $455d545b1dff00eb$var$Z4,
    clipping_planes_pars_fragment: $455d545b1dff00eb$var$Q4,
    clipping_planes_pars_vertex: $455d545b1dff00eb$var$K4,
    clipping_planes_vertex: $455d545b1dff00eb$var$J4,
    color_fragment: $455d545b1dff00eb$var$$4,
    color_pars_fragment: $455d545b1dff00eb$var$eO,
    color_pars_vertex: $455d545b1dff00eb$var$tO,
    color_vertex: $455d545b1dff00eb$var$nO,
    common: $455d545b1dff00eb$var$iO,
    cube_uv_reflection_fragment: $455d545b1dff00eb$var$aO,
    defaultnormal_vertex: $455d545b1dff00eb$var$rO,
    displacementmap_pars_vertex: $455d545b1dff00eb$var$sO,
    displacementmap_vertex: $455d545b1dff00eb$var$oO,
    emissivemap_fragment: $455d545b1dff00eb$var$lO,
    emissivemap_pars_fragment: $455d545b1dff00eb$var$cO,
    colorspace_fragment: $455d545b1dff00eb$var$uO,
    colorspace_pars_fragment: $455d545b1dff00eb$var$fO,
    envmap_fragment: $455d545b1dff00eb$var$hO,
    envmap_common_pars_fragment: $455d545b1dff00eb$var$dO,
    envmap_pars_fragment: $455d545b1dff00eb$var$pO,
    envmap_pars_vertex: $455d545b1dff00eb$var$mO,
    envmap_physical_pars_fragment: $455d545b1dff00eb$var$AO,
    envmap_vertex: $455d545b1dff00eb$var$gO,
    fog_vertex: $455d545b1dff00eb$var$xO,
    fog_pars_vertex: $455d545b1dff00eb$var$vO,
    fog_fragment: $455d545b1dff00eb$var$yO,
    fog_pars_fragment: $455d545b1dff00eb$var$_O,
    gradientmap_pars_fragment: $455d545b1dff00eb$var$bO,
    lightmap_pars_fragment: $455d545b1dff00eb$var$SO,
    lights_lambert_fragment: $455d545b1dff00eb$var$MO,
    lights_lambert_pars_fragment: $455d545b1dff00eb$var$EO,
    lights_pars_begin: $455d545b1dff00eb$var$TO,
    lights_toon_fragment: $455d545b1dff00eb$var$wO,
    lights_toon_pars_fragment: $455d545b1dff00eb$var$CO,
    lights_phong_fragment: $455d545b1dff00eb$var$RO,
    lights_phong_pars_fragment: $455d545b1dff00eb$var$DO,
    lights_physical_fragment: $455d545b1dff00eb$var$UO,
    lights_physical_pars_fragment: $455d545b1dff00eb$var$NO,
    lights_fragment_begin: $455d545b1dff00eb$var$OO,
    lights_fragment_maps: $455d545b1dff00eb$var$LO,
    lights_fragment_end: $455d545b1dff00eb$var$zO,
    logdepthbuf_fragment: $455d545b1dff00eb$var$PO,
    logdepthbuf_pars_fragment: $455d545b1dff00eb$var$BO,
    logdepthbuf_pars_vertex: $455d545b1dff00eb$var$IO,
    logdepthbuf_vertex: $455d545b1dff00eb$var$FO,
    map_fragment: $455d545b1dff00eb$var$HO,
    map_pars_fragment: $455d545b1dff00eb$var$VO,
    map_particle_fragment: $455d545b1dff00eb$var$GO,
    map_particle_pars_fragment: $455d545b1dff00eb$var$kO,
    metalnessmap_fragment: $455d545b1dff00eb$var$jO,
    metalnessmap_pars_fragment: $455d545b1dff00eb$var$XO,
    morphinstance_vertex: $455d545b1dff00eb$var$WO,
    morphcolor_vertex: $455d545b1dff00eb$var$qO,
    morphnormal_vertex: $455d545b1dff00eb$var$YO,
    morphtarget_pars_vertex: $455d545b1dff00eb$var$ZO,
    morphtarget_vertex: $455d545b1dff00eb$var$QO,
    normal_fragment_begin: $455d545b1dff00eb$var$KO,
    normal_fragment_maps: $455d545b1dff00eb$var$JO,
    normal_pars_fragment: $455d545b1dff00eb$var$$O,
    normal_pars_vertex: $455d545b1dff00eb$var$eL,
    normal_vertex: $455d545b1dff00eb$var$tL,
    normalmap_pars_fragment: $455d545b1dff00eb$var$nL,
    clearcoat_normal_fragment_begin: $455d545b1dff00eb$var$iL,
    clearcoat_normal_fragment_maps: $455d545b1dff00eb$var$aL,
    clearcoat_pars_fragment: $455d545b1dff00eb$var$rL,
    iridescence_pars_fragment: $455d545b1dff00eb$var$sL,
    opaque_fragment: $455d545b1dff00eb$var$oL,
    packing: $455d545b1dff00eb$var$lL,
    premultiplied_alpha_fragment: $455d545b1dff00eb$var$cL,
    project_vertex: $455d545b1dff00eb$var$uL,
    dithering_fragment: $455d545b1dff00eb$var$fL,
    dithering_pars_fragment: $455d545b1dff00eb$var$hL,
    roughnessmap_fragment: $455d545b1dff00eb$var$dL,
    roughnessmap_pars_fragment: $455d545b1dff00eb$var$pL,
    shadowmap_pars_fragment: $455d545b1dff00eb$var$mL,
    shadowmap_pars_vertex: $455d545b1dff00eb$var$gL,
    shadowmap_vertex: $455d545b1dff00eb$var$xL,
    shadowmask_pars_fragment: $455d545b1dff00eb$var$vL,
    skinbase_vertex: $455d545b1dff00eb$var$yL,
    skinning_pars_vertex: $455d545b1dff00eb$var$_L,
    skinning_vertex: $455d545b1dff00eb$var$bL,
    skinnormal_vertex: $455d545b1dff00eb$var$SL,
    specularmap_fragment: $455d545b1dff00eb$var$ML,
    specularmap_pars_fragment: $455d545b1dff00eb$var$EL,
    tonemapping_fragment: $455d545b1dff00eb$var$TL,
    tonemapping_pars_fragment: $455d545b1dff00eb$var$AL,
    transmission_fragment: $455d545b1dff00eb$var$wL,
    transmission_pars_fragment: $455d545b1dff00eb$var$CL,
    uv_pars_fragment: $455d545b1dff00eb$var$RL,
    uv_pars_vertex: $455d545b1dff00eb$var$DL,
    uv_vertex: $455d545b1dff00eb$var$UL,
    worldpos_vertex: $455d545b1dff00eb$var$NL,
    background_vert: $455d545b1dff00eb$var$OL,
    background_frag: $455d545b1dff00eb$var$LL,
    backgroundCube_vert: $455d545b1dff00eb$var$zL,
    backgroundCube_frag: $455d545b1dff00eb$var$PL,
    cube_vert: $455d545b1dff00eb$var$BL,
    cube_frag: $455d545b1dff00eb$var$IL,
    depth_vert: $455d545b1dff00eb$var$FL,
    depth_frag: $455d545b1dff00eb$var$HL,
    distanceRGBA_vert: $455d545b1dff00eb$var$VL,
    distanceRGBA_frag: $455d545b1dff00eb$var$GL,
    equirect_vert: $455d545b1dff00eb$var$kL,
    equirect_frag: $455d545b1dff00eb$var$jL,
    linedashed_vert: $455d545b1dff00eb$var$XL,
    linedashed_frag: $455d545b1dff00eb$var$WL,
    meshbasic_vert: $455d545b1dff00eb$var$qL,
    meshbasic_frag: $455d545b1dff00eb$var$YL,
    meshlambert_vert: $455d545b1dff00eb$var$ZL,
    meshlambert_frag: $455d545b1dff00eb$var$QL,
    meshmatcap_vert: $455d545b1dff00eb$var$KL,
    meshmatcap_frag: $455d545b1dff00eb$var$JL,
    meshnormal_vert: $455d545b1dff00eb$var$$L,
    meshnormal_frag: $455d545b1dff00eb$var$e5,
    meshphong_vert: $455d545b1dff00eb$var$t5,
    meshphong_frag: $455d545b1dff00eb$var$n5,
    meshphysical_vert: $455d545b1dff00eb$var$i5,
    meshphysical_frag: $455d545b1dff00eb$var$a5,
    meshtoon_vert: $455d545b1dff00eb$var$r5,
    meshtoon_frag: $455d545b1dff00eb$var$s5,
    points_vert: $455d545b1dff00eb$var$o5,
    points_frag: $455d545b1dff00eb$var$l5,
    shadow_vert: $455d545b1dff00eb$var$c5,
    shadow_frag: $455d545b1dff00eb$var$u5,
    sprite_vert: $455d545b1dff00eb$var$f5,
    sprite_frag: $455d545b1dff00eb$var$h5
}, $455d545b1dff00eb$var$St = {
    common: {
        diffuse: {
            value: new $455d545b1dff00eb$var$_t(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: new $455d545b1dff00eb$var$Jt
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        },
        dfgLUT: {
            value: null
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        normalScale: {
            value: new $455d545b1dff00eb$var$$e(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new $455d545b1dff00eb$var$_t(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $455d545b1dff00eb$var$_t(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $455d545b1dff00eb$var$Jt
        }
    },
    sprite: {
        diffuse: {
            value: new $455d545b1dff00eb$var$_t(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new $455d545b1dff00eb$var$$e(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $455d545b1dff00eb$var$Jt
        },
        alphaTest: {
            value: 0
        }
    }
}, $455d545b1dff00eb$var$wo = {
    basic: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.specularmap,
            $455d545b1dff00eb$var$St.envmap,
            $455d545b1dff00eb$var$St.aomap,
            $455d545b1dff00eb$var$St.lightmap,
            $455d545b1dff00eb$var$St.fog
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshbasic_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshbasic_frag
    },
    lambert: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.specularmap,
            $455d545b1dff00eb$var$St.envmap,
            $455d545b1dff00eb$var$St.aomap,
            $455d545b1dff00eb$var$St.lightmap,
            $455d545b1dff00eb$var$St.emissivemap,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            $455d545b1dff00eb$var$St.fog,
            $455d545b1dff00eb$var$St.lights,
            {
                emissive: {
                    value: new $455d545b1dff00eb$var$_t(0)
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshlambert_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshlambert_frag
    },
    phong: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.specularmap,
            $455d545b1dff00eb$var$St.envmap,
            $455d545b1dff00eb$var$St.aomap,
            $455d545b1dff00eb$var$St.lightmap,
            $455d545b1dff00eb$var$St.emissivemap,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            $455d545b1dff00eb$var$St.fog,
            $455d545b1dff00eb$var$St.lights,
            {
                emissive: {
                    value: new $455d545b1dff00eb$var$_t(0)
                },
                specular: {
                    value: new $455d545b1dff00eb$var$_t(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshphong_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshphong_frag
    },
    standard: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.envmap,
            $455d545b1dff00eb$var$St.aomap,
            $455d545b1dff00eb$var$St.lightmap,
            $455d545b1dff00eb$var$St.emissivemap,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            $455d545b1dff00eb$var$St.roughnessmap,
            $455d545b1dff00eb$var$St.metalnessmap,
            $455d545b1dff00eb$var$St.fog,
            $455d545b1dff00eb$var$St.lights,
            {
                emissive: {
                    value: new $455d545b1dff00eb$var$_t(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshphysical_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshphysical_frag
    },
    toon: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.aomap,
            $455d545b1dff00eb$var$St.lightmap,
            $455d545b1dff00eb$var$St.emissivemap,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            $455d545b1dff00eb$var$St.gradientmap,
            $455d545b1dff00eb$var$St.fog,
            $455d545b1dff00eb$var$St.lights,
            {
                emissive: {
                    value: new $455d545b1dff00eb$var$_t(0)
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshtoon_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshtoon_frag
    },
    matcap: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            $455d545b1dff00eb$var$St.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshmatcap_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshmatcap_frag
    },
    points: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.points,
            $455d545b1dff00eb$var$St.fog
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.points_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.points_frag
    },
    dashed: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.linedashed_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.linedashed_frag
    },
    depth: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.displacementmap
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.depth_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.depth_frag
    },
    normal: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.bumpmap,
            $455d545b1dff00eb$var$St.normalmap,
            $455d545b1dff00eb$var$St.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.meshnormal_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.meshnormal_frag
    },
    sprite: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.sprite,
            $455d545b1dff00eb$var$St.fog
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.sprite_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $455d545b1dff00eb$var$rn.background_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: new $455d545b1dff00eb$var$Jt
            }
        },
        vertexShader: $455d545b1dff00eb$var$rn.backgroundCube_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: $455d545b1dff00eb$var$rn.cube_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $455d545b1dff00eb$var$rn.equirect_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.equirect_frag
    },
    distanceRGBA: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.common,
            $455d545b1dff00eb$var$St.displacementmap,
            {
                referencePosition: {
                    value: new $455d545b1dff00eb$var$J
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.distanceRGBA_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.distanceRGBA_frag
    },
    shadow: {
        uniforms: $455d545b1dff00eb$var$wr([
            $455d545b1dff00eb$var$St.lights,
            $455d545b1dff00eb$var$St.fog,
            {
                color: {
                    value: new $455d545b1dff00eb$var$_t(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $455d545b1dff00eb$var$rn.shadow_vert,
        fragmentShader: $455d545b1dff00eb$var$rn.shadow_frag
    }
};
$455d545b1dff00eb$var$wo.physical = {
    uniforms: $455d545b1dff00eb$var$wr([
        $455d545b1dff00eb$var$wo.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            clearcoatNormalScale: {
                value: new $455d545b1dff00eb$var$$e(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $455d545b1dff00eb$var$_t(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            transmissionSamplerSize: {
                value: new $455d545b1dff00eb$var$$e
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $455d545b1dff00eb$var$_t(0)
            },
            specularColor: {
                value: new $455d545b1dff00eb$var$_t(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            },
            anisotropyVector: {
                value: new $455d545b1dff00eb$var$$e
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: new $455d545b1dff00eb$var$Jt
            }
        }
    ]),
    vertexShader: $455d545b1dff00eb$var$rn.meshphysical_vert,
    fragmentShader: $455d545b1dff00eb$var$rn.meshphysical_frag
};
const $455d545b1dff00eb$var$Lx = {
    r: 0,
    b: 0,
    g: 0
}, $455d545b1dff00eb$var$Rf = new $455d545b1dff00eb$var$ua, $455d545b1dff00eb$var$d5 = new $455d545b1dff00eb$var$Ft;
function $455d545b1dff00eb$var$p5(a, e, t, n, i, r, l) {
    const c = new $455d545b1dff00eb$var$_t(0);
    let f = r === !0 ? 0 : 1, p, m, x = null, v = 0, _ = null;
    function S(R) {
        let N = R.isScene === !0 ? R.background : null;
        return N && N.isTexture && (N = (R.backgroundBlurriness > 0 ? t : e).get(N)), N;
    }
    function A(R) {
        let N = !1;
        const z = S(R);
        z === null ? b(c, f) : z && z.isColor && (b(z, 1), N = !0);
        const L = a.xr.getEnvironmentBlendMode();
        L === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, l) : L === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, l), (a.autoClear || N) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), a.clear(a.autoClearColor, a.autoClearDepth, a.autoClearStencil));
    }
    function M(R, N) {
        const z = S(N);
        z && (z.isCubeTexture || z.mapping === $455d545b1dff00eb$var$Wd) ? (m === void 0 && (m = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Ru(1, 1, 1), new $455d545b1dff00eb$var$qs({
            name: "BackgroundCubeMaterial",
            uniforms: $455d545b1dff00eb$var$Vd($455d545b1dff00eb$var$wo.backgroundCube.uniforms),
            vertexShader: $455d545b1dff00eb$var$wo.backgroundCube.vertexShader,
            fragmentShader: $455d545b1dff00eb$var$wo.backgroundCube.fragmentShader,
            side: $455d545b1dff00eb$var$Dr,
            depthTest: !1,
            depthWrite: !1,
            fog: !1,
            allowOverride: !1
        })), m.geometry.deleteAttribute("normal"), m.geometry.deleteAttribute("uv"), m.onBeforeRender = function(L, P, H) {
            this.matrixWorld.copyPosition(H.matrixWorld);
        }, Object.defineProperty(m.material, "envMap", {
            get: function() {
                return this.uniforms.envMap.value;
            }
        }), i.update(m)), $455d545b1dff00eb$var$Rf.copy(N.backgroundRotation), $455d545b1dff00eb$var$Rf.x *= -1, $455d545b1dff00eb$var$Rf.y *= -1, $455d545b1dff00eb$var$Rf.z *= -1, z.isCubeTexture && z.isRenderTargetTexture === !1 && ($455d545b1dff00eb$var$Rf.y *= -1, $455d545b1dff00eb$var$Rf.z *= -1), m.material.uniforms.envMap.value = z, m.material.uniforms.flipEnvMap.value = z.isCubeTexture && z.isRenderTargetTexture === !1 ? -1 : 1, m.material.uniforms.backgroundBlurriness.value = N.backgroundBlurriness, m.material.uniforms.backgroundIntensity.value = N.backgroundIntensity, m.material.uniforms.backgroundRotation.value.setFromMatrix4($455d545b1dff00eb$var$d5.makeRotationFromEuler($455d545b1dff00eb$var$Rf)), m.material.toneMapped = $455d545b1dff00eb$var$Dn.getTransfer(z.colorSpace) !== $455d545b1dff00eb$var$Zn, (x !== z || v !== z.version || _ !== a.toneMapping) && (m.material.needsUpdate = !0, x = z, v = z.version, _ = a.toneMapping), m.layers.enableAll(), R.unshift(m, m.geometry, m.material, 0, 0, null)) : z && z.isTexture && (p === void 0 && (p = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Jr(2, 2), new $455d545b1dff00eb$var$qs({
            name: "BackgroundMaterial",
            uniforms: $455d545b1dff00eb$var$Vd($455d545b1dff00eb$var$wo.background.uniforms),
            vertexShader: $455d545b1dff00eb$var$wo.background.vertexShader,
            fragmentShader: $455d545b1dff00eb$var$wo.background.fragmentShader,
            side: $455d545b1dff00eb$var$bc,
            depthTest: !1,
            depthWrite: !1,
            fog: !1,
            allowOverride: !1
        })), p.geometry.deleteAttribute("normal"), Object.defineProperty(p.material, "map", {
            get: function() {
                return this.uniforms.t2D.value;
            }
        }), i.update(p)), p.material.uniforms.t2D.value = z, p.material.uniforms.backgroundIntensity.value = N.backgroundIntensity, p.material.toneMapped = $455d545b1dff00eb$var$Dn.getTransfer(z.colorSpace) !== $455d545b1dff00eb$var$Zn, z.matrixAutoUpdate === !0 && z.updateMatrix(), p.material.uniforms.uvTransform.value.copy(z.matrix), (x !== z || v !== z.version || _ !== a.toneMapping) && (p.material.needsUpdate = !0, x = z, v = z.version, _ = a.toneMapping), p.layers.enableAll(), R.unshift(p, p.geometry, p.material, 0, 0, null));
    }
    function b(R, N) {
        R.getRGB($455d545b1dff00eb$var$Lx, $455d545b1dff00eb$var$ST(a)), n.buffers.color.setClear($455d545b1dff00eb$var$Lx.r, $455d545b1dff00eb$var$Lx.g, $455d545b1dff00eb$var$Lx.b, N, l);
    }
    function C() {
        m !== void 0 && (m.geometry.dispose(), m.material.dispose(), m = void 0), p !== void 0 && (p.geometry.dispose(), p.material.dispose(), p = void 0);
    }
    return {
        getClearColor: function() {
            return c;
        },
        setClearColor: function(R, N = 1) {
            c.set(R), f = N, b(c, f);
        },
        getClearAlpha: function() {
            return f;
        },
        setClearAlpha: function(R) {
            f = R, b(c, f);
        },
        render: A,
        addToRenderList: M,
        dispose: C
    };
}
function $455d545b1dff00eb$var$m5(a, e) {
    const t = a.getParameter(a.MAX_VERTEX_ATTRIBS), n = {}, i = v(null);
    let r = i, l = !1;
    function c(D, j, G, q, Y) {
        let ae = !1;
        const F = x(q, G, j);
        r !== F && (r = F, p(r.object)), ae = _(D, q, G, Y), ae && S(D, q, G, Y), Y !== null && e.update(Y, a.ELEMENT_ARRAY_BUFFER), (ae || l) && (l = !1, N(D, j, G, q), Y !== null && a.bindBuffer(a.ELEMENT_ARRAY_BUFFER, e.get(Y).buffer));
    }
    function f() {
        return a.createVertexArray();
    }
    function p(D) {
        return a.bindVertexArray(D);
    }
    function m(D) {
        return a.deleteVertexArray(D);
    }
    function x(D, j, G) {
        const q = G.wireframe === !0;
        let Y = n[D.id];
        Y === void 0 && (Y = {}, n[D.id] = Y);
        let ae = Y[j.id];
        ae === void 0 && (ae = {}, Y[j.id] = ae);
        let F = ae[q];
        return F === void 0 && (F = v(f()), ae[q] = F), F;
    }
    function v(D) {
        const j = [], G = [], q = [];
        for(let Y = 0; Y < t; Y++)j[Y] = 0, G[Y] = 0, q[Y] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: j,
            enabledAttributes: G,
            attributeDivisors: q,
            object: D,
            attributes: {},
            index: null
        };
    }
    function _(D, j, G, q) {
        const Y = r.attributes, ae = j.attributes;
        let F = 0;
        const Q = G.getAttributes();
        for(const K in Q)if (Q[K].location >= 0) {
            const ee = Y[K];
            let I = ae[K];
            if (I === void 0 && (K === "instanceMatrix" && D.instanceMatrix && (I = D.instanceMatrix), K === "instanceColor" && D.instanceColor && (I = D.instanceColor)), ee === void 0 || ee.attribute !== I || I && ee.data !== I.data) return !0;
            F++;
        }
        return r.attributesNum !== F || r.index !== q;
    }
    function S(D, j, G, q) {
        const Y = {}, ae = j.attributes;
        let F = 0;
        const Q = G.getAttributes();
        for(const K in Q)if (Q[K].location >= 0) {
            let ee = ae[K];
            ee === void 0 && (K === "instanceMatrix" && D.instanceMatrix && (ee = D.instanceMatrix), K === "instanceColor" && D.instanceColor && (ee = D.instanceColor));
            const I = {};
            I.attribute = ee, ee && ee.data && (I.data = ee.data), Y[K] = I, F++;
        }
        r.attributes = Y, r.attributesNum = F, r.index = q;
    }
    function A() {
        const D = r.newAttributes;
        for(let j = 0, G = D.length; j < G; j++)D[j] = 0;
    }
    function M(D) {
        b(D, 0);
    }
    function b(D, j) {
        const G = r.newAttributes, q = r.enabledAttributes, Y = r.attributeDivisors;
        G[D] = 1, q[D] === 0 && (a.enableVertexAttribArray(D), q[D] = 1), Y[D] !== j && (a.vertexAttribDivisor(D, j), Y[D] = j);
    }
    function C() {
        const D = r.newAttributes, j = r.enabledAttributes;
        for(let G = 0, q = j.length; G < q; G++)j[G] !== D[G] && (a.disableVertexAttribArray(G), j[G] = 0);
    }
    function R(D, j, G, q, Y, ae, F) {
        F === !0 ? a.vertexAttribIPointer(D, j, G, Y, ae) : a.vertexAttribPointer(D, j, G, q, Y, ae);
    }
    function N(D, j, G, q) {
        A();
        const Y = q.attributes, ae = G.getAttributes(), F = j.defaultAttributeValues;
        for(const Q in ae){
            const K = ae[Q];
            if (K.location >= 0) {
                let $ = Y[Q];
                if ($ === void 0 && (Q === "instanceMatrix" && D.instanceMatrix && ($ = D.instanceMatrix), Q === "instanceColor" && D.instanceColor && ($ = D.instanceColor)), $ !== void 0) {
                    const ee = $.normalized, I = $.itemSize, Z = e.get($);
                    if (Z === void 0) continue;
                    const oe = Z.buffer, ce = Z.type, de = Z.bytesPerElement, ue = ce === a.INT || ce === a.UNSIGNED_INT || $.gpuType === $455d545b1dff00eb$var$ny;
                    if ($.isInterleavedBufferAttribute) {
                        const le = $.data, xe = le.stride, Le = $.offset;
                        if (le.isInstancedInterleavedBuffer) {
                            for(let Ue = 0; Ue < K.locationSize; Ue++)b(K.location + Ue, le.meshPerAttribute);
                            D.isInstancedMesh !== !0 && q._maxInstanceCount === void 0 && (q._maxInstanceCount = le.meshPerAttribute * le.count);
                        } else for(let Ue = 0; Ue < K.locationSize; Ue++)M(K.location + Ue);
                        a.bindBuffer(a.ARRAY_BUFFER, oe);
                        for(let Ue = 0; Ue < K.locationSize; Ue++)R(K.location + Ue, I / K.locationSize, ce, ee, xe * de, (Le + I / K.locationSize * Ue) * de, ue);
                    } else {
                        if ($.isInstancedBufferAttribute) {
                            for(let le = 0; le < K.locationSize; le++)b(K.location + le, $.meshPerAttribute);
                            D.isInstancedMesh !== !0 && q._maxInstanceCount === void 0 && (q._maxInstanceCount = $.meshPerAttribute * $.count);
                        } else for(let le = 0; le < K.locationSize; le++)M(K.location + le);
                        a.bindBuffer(a.ARRAY_BUFFER, oe);
                        for(let le = 0; le < K.locationSize; le++)R(K.location + le, I / K.locationSize, ce, ee, I * de, I / K.locationSize * le * de, ue);
                    }
                } else if (F !== void 0) {
                    const ee = F[Q];
                    if (ee !== void 0) switch(ee.length){
                        case 2:
                            a.vertexAttrib2fv(K.location, ee);
                            break;
                        case 3:
                            a.vertexAttrib3fv(K.location, ee);
                            break;
                        case 4:
                            a.vertexAttrib4fv(K.location, ee);
                            break;
                        default:
                            a.vertexAttrib1fv(K.location, ee);
                    }
                }
            }
        }
        C();
    }
    function z() {
        H();
        for(const D in n){
            const j = n[D];
            for(const G in j){
                const q = j[G];
                for(const Y in q)m(q[Y].object), delete q[Y];
                delete j[G];
            }
            delete n[D];
        }
    }
    function L(D) {
        if (n[D.id] === void 0) return;
        const j = n[D.id];
        for(const G in j){
            const q = j[G];
            for(const Y in q)m(q[Y].object), delete q[Y];
            delete j[G];
        }
        delete n[D.id];
    }
    function P(D) {
        for(const j in n){
            const G = n[j];
            if (G[D.id] === void 0) continue;
            const q = G[D.id];
            for(const Y in q)m(q[Y].object), delete q[Y];
            delete G[D.id];
        }
    }
    function H() {
        O(), l = !0, r !== i && (r = i, p(r.object));
    }
    function O() {
        i.geometry = null, i.program = null, i.wireframe = !1;
    }
    return {
        setup: c,
        reset: H,
        resetDefaultState: O,
        dispose: z,
        releaseStatesOfGeometry: L,
        releaseStatesOfProgram: P,
        initAttributes: A,
        enableAttribute: M,
        disableUnusedAttributes: C
    };
}
function $455d545b1dff00eb$var$g5(a, e, t) {
    let n;
    function i(p) {
        n = p;
    }
    function r(p, m) {
        a.drawArrays(n, p, m), t.update(m, n, 1);
    }
    function l(p, m, x) {
        x !== 0 && (a.drawArraysInstanced(n, p, m, x), t.update(m, n, x));
    }
    function c(p, m, x) {
        if (x === 0) return;
        e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, p, 0, m, 0, x);
        let _ = 0;
        for(let S = 0; S < x; S++)_ += m[S];
        t.update(_, n, 1);
    }
    function f(p, m, x, v) {
        if (x === 0) return;
        const _ = e.get("WEBGL_multi_draw");
        if (_ === null) for(let S = 0; S < p.length; S++)l(p[S], m[S], v[S]);
        else {
            _.multiDrawArraysInstancedWEBGL(n, p, 0, m, 0, v, 0, x);
            let S = 0;
            for(let A = 0; A < x; A++)S += m[A] * v[A];
            t.update(S, n, 1);
        }
    }
    this.setMode = i, this.render = r, this.renderInstances = l, this.renderMultiDraw = c, this.renderMultiDrawInstances = f;
}
function $455d545b1dff00eb$var$x5(a, e, t, n) {
    let i;
    function r() {
        if (i !== void 0) return i;
        if (e.has("EXT_texture_filter_anisotropic") === !0) {
            const P = e.get("EXT_texture_filter_anisotropic");
            i = a.getParameter(P.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else i = 0;
        return i;
    }
    function l(P) {
        return !(P !== $455d545b1dff00eb$var$ar && n.convert(P) !== a.getParameter(a.IMPLEMENTATION_COLOR_READ_FORMAT));
    }
    function c(P) {
        const H = P === $455d545b1dff00eb$var$wu && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
        return !(P !== $455d545b1dff00eb$var$Ws && n.convert(P) !== a.getParameter(a.IMPLEMENTATION_COLOR_READ_TYPE) && P !== $455d545b1dff00eb$var$Rr && !H);
    }
    function f(P) {
        if (P === "highp") {
            if (a.getShaderPrecisionFormat(a.VERTEX_SHADER, a.HIGH_FLOAT).precision > 0 && a.getShaderPrecisionFormat(a.FRAGMENT_SHADER, a.HIGH_FLOAT).precision > 0) return "highp";
            P = "mediump";
        }
        return P === "mediump" && a.getShaderPrecisionFormat(a.VERTEX_SHADER, a.MEDIUM_FLOAT).precision > 0 && a.getShaderPrecisionFormat(a.FRAGMENT_SHADER, a.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
    }
    let p = t.precision !== void 0 ? t.precision : "highp";
    const m = f(p);
    m !== p && ($455d545b1dff00eb$var$Mt("WebGLRenderer:", p, "not supported, using", m, "instead."), p = m);
    const x = t.logarithmicDepthBuffer === !0, v = t.reversedDepthBuffer === !0 && e.has("EXT_clip_control"), _ = a.getParameter(a.MAX_TEXTURE_IMAGE_UNITS), S = a.getParameter(a.MAX_VERTEX_TEXTURE_IMAGE_UNITS), A = a.getParameter(a.MAX_TEXTURE_SIZE), M = a.getParameter(a.MAX_CUBE_MAP_TEXTURE_SIZE), b = a.getParameter(a.MAX_VERTEX_ATTRIBS), C = a.getParameter(a.MAX_VERTEX_UNIFORM_VECTORS), R = a.getParameter(a.MAX_VARYING_VECTORS), N = a.getParameter(a.MAX_FRAGMENT_UNIFORM_VECTORS), z = S > 0, L = a.getParameter(a.MAX_SAMPLES);
    return {
        isWebGL2: !0,
        getMaxAnisotropy: r,
        getMaxPrecision: f,
        textureFormatReadable: l,
        textureTypeReadable: c,
        precision: p,
        logarithmicDepthBuffer: x,
        reversedDepthBuffer: v,
        maxTextures: _,
        maxVertexTextures: S,
        maxTextureSize: A,
        maxCubemapSize: M,
        maxAttributes: b,
        maxVertexUniforms: C,
        maxVaryings: R,
        maxFragmentUniforms: N,
        vertexTextures: z,
        maxSamples: L
    };
}
function $455d545b1dff00eb$var$v5(a) {
    const e = this;
    let t = null, n = 0, i = !1, r = !1;
    const l = new $455d545b1dff00eb$var$ml, c = new $455d545b1dff00eb$var$Jt, f = {
        value: null,
        needsUpdate: !1
    };
    this.uniform = f, this.numPlanes = 0, this.numIntersection = 0, this.init = function(x, v) {
        const _ = x.length !== 0 || v || n !== 0 || i;
        return i = v, n = x.length, _;
    }, this.beginShadows = function() {
        r = !0, m(null);
    }, this.endShadows = function() {
        r = !1;
    }, this.setGlobalState = function(x, v) {
        t = m(x, v, 0);
    }, this.setState = function(x, v, _) {
        const S = x.clippingPlanes, A = x.clipIntersection, M = x.clipShadows, b = a.get(x);
        if (!i || S === null || S.length === 0 || r && !M) r ? m(null) : p();
        else {
            const C = r ? 0 : n, R = C * 4;
            let N = b.clippingState || null;
            f.value = N, N = m(S, v, R, _);
            for(let z = 0; z !== R; ++z)N[z] = t[z];
            b.clippingState = N, this.numIntersection = A ? this.numPlanes : 0, this.numPlanes += C;
        }
    };
    function p() {
        f.value !== t && (f.value = t, f.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0;
    }
    function m(x, v, _, S) {
        const A = x !== null ? x.length : 0;
        let M = null;
        if (A !== 0) {
            if (M = f.value, S !== !0 || M === null) {
                const b = _ + A * 4, C = v.matrixWorldInverse;
                c.getNormalMatrix(C), (M === null || M.length < b) && (M = new Float32Array(b));
                for(let R = 0, N = _; R !== A; ++R, N += 4)l.copy(x[R]).applyMatrix4(C, c), l.normal.toArray(M, N), M[N + 3] = l.constant;
            }
            f.value = M, f.needsUpdate = !0;
        }
        return e.numPlanes = A, e.numIntersection = 0, M;
    }
}
function $455d545b1dff00eb$var$y5(a) {
    let e = new WeakMap;
    function t(l, c) {
        return c === $455d545b1dff00eb$var$Jm ? l.mapping = $455d545b1dff00eb$var$Sc : c === $455d545b1dff00eb$var$$m && (l.mapping = $455d545b1dff00eb$var$Mu), l;
    }
    function n(l) {
        if (l && l.isTexture) {
            const c = l.mapping;
            if (c === $455d545b1dff00eb$var$Jm || c === $455d545b1dff00eb$var$$m) {
                if (e.has(l)) {
                    const f = e.get(l).texture;
                    return t(f, l.mapping);
                } else {
                    const f = l.image;
                    if (f && f.height > 0) {
                        const p = new $455d545b1dff00eb$var$ET(f.height);
                        return p.fromEquirectangularTexture(a, l), e.set(l, p), l.addEventListener("dispose", i), t(p.texture, l.mapping);
                    } else return null;
                }
            }
        }
        return l;
    }
    function i(l) {
        const c = l.target;
        c.removeEventListener("dispose", i);
        const f = e.get(c);
        f !== void 0 && (e.delete(c), f.dispose());
    }
    function r() {
        e = new WeakMap;
    }
    return {
        get: n,
        dispose: r
    };
}
const $455d545b1dff00eb$var$bu = 4, $455d545b1dff00eb$var$GM = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], $455d545b1dff00eb$var$Lf = 20, $455d545b1dff00eb$var$_5 = 256, $455d545b1dff00eb$var$Um = new $455d545b1dff00eb$var$bl, $455d545b1dff00eb$var$kM = new $455d545b1dff00eb$var$_t;
let $455d545b1dff00eb$var$p_ = null, $455d545b1dff00eb$var$m_ = 0, $455d545b1dff00eb$var$g_ = 0, $455d545b1dff00eb$var$x_ = !1;
const $455d545b1dff00eb$var$b5 = new $455d545b1dff00eb$var$J;
class $455d545b1dff00eb$var$sb {
    constructor(e){
        this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
    }
    fromScene(e, t = 0, n = .1, i = 100, r = {}) {
        const { size: l = 256, position: c = $455d545b1dff00eb$var$b5 } = r;
        $455d545b1dff00eb$var$p_ = this._renderer.getRenderTarget(), $455d545b1dff00eb$var$m_ = this._renderer.getActiveCubeFace(), $455d545b1dff00eb$var$g_ = this._renderer.getActiveMipmapLevel(), $455d545b1dff00eb$var$x_ = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(l);
        const f = this._allocateTargets();
        return f.depthBuffer = !0, this._sceneToCubeUV(e, n, i, f, c), t > 0 && this._blur(f, 0, 0, t), this._applyPMREM(f), this._cleanup(f), f;
    }
    fromEquirectangular(e, t = null) {
        return this._fromTexture(e, t);
    }
    fromCubemap(e, t = null) {
        return this._fromTexture(e, t);
    }
    compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = $455d545b1dff00eb$var$WM(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = $455d545b1dff00eb$var$XM(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
    }
    _setSize(e) {
        this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let e = 0; e < this._lodMeshes.length; e++)this._lodMeshes[e].geometry.dispose();
    }
    _cleanup(e) {
        this._renderer.setRenderTarget($455d545b1dff00eb$var$p_, $455d545b1dff00eb$var$m_, $455d545b1dff00eb$var$g_), this._renderer.xr.enabled = $455d545b1dff00eb$var$x_, e.scissorTest = !1, $455d545b1dff00eb$var$bd(e, 0, 0, e.width, e.height);
    }
    _fromTexture(e, t) {
        e.mapping === $455d545b1dff00eb$var$Sc || e.mapping === $455d545b1dff00eb$var$Mu ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), $455d545b1dff00eb$var$p_ = this._renderer.getRenderTarget(), $455d545b1dff00eb$var$m_ = this._renderer.getActiveCubeFace(), $455d545b1dff00eb$var$g_ = this._renderer.getActiveMipmapLevel(), $455d545b1dff00eb$var$x_ = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
        const n = t || this._allocateTargets();
        return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
        const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
            magFilter: $455d545b1dff00eb$var$mi,
            minFilter: $455d545b1dff00eb$var$mi,
            generateMipmaps: !1,
            type: $455d545b1dff00eb$var$wu,
            format: $455d545b1dff00eb$var$ar,
            colorSpace: $455d545b1dff00eb$var$No,
            depthBuffer: !1
        }, i = $455d545b1dff00eb$var$jM(e, t, n);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = $455d545b1dff00eb$var$jM(e, t, n);
            const { _lodMax: r } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $455d545b1dff00eb$var$S5(r)), this._blurMaterial = $455d545b1dff00eb$var$E5(r, e, t), this._ggxMaterial = $455d545b1dff00eb$var$M5(r, e, t);
        }
        return i;
    }
    _compileMaterial(e) {
        const t = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$nn, e);
        this._renderer.compile(t, $455d545b1dff00eb$var$Um);
    }
    _sceneToCubeUV(e, t, n, i, r) {
        const f = new $455d545b1dff00eb$var$Ui(90, 1, t, n), p = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], m = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], x = this._renderer, v = x.autoClear, _ = x.toneMapping;
        x.getClearColor($455d545b1dff00eb$var$kM), x.toneMapping = $455d545b1dff00eb$var$_l, x.autoClear = !1, x.state.buffers.depth.getReversed() && (x.setRenderTarget(i), x.clearDepth(), x.setRenderTarget(null)), this._backgroundBox === null && (this._backgroundBox = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Ru, new $455d545b1dff00eb$var$Ac({
            name: "PMREM.Background",
            side: $455d545b1dff00eb$var$Dr,
            depthWrite: !1,
            depthTest: !1
        })));
        const A = this._backgroundBox, M = A.material;
        let b = !1;
        const C = e.background;
        C ? C.isColor && (M.color.copy(C), e.background = null, b = !0) : (M.color.copy($455d545b1dff00eb$var$kM), b = !0);
        for(let R = 0; R < 6; R++){
            const N = R % 3;
            N === 0 ? (f.up.set(0, p[R], 0), f.position.set(r.x, r.y, r.z), f.lookAt(r.x + m[R], r.y, r.z)) : N === 1 ? (f.up.set(0, 0, p[R]), f.position.set(r.x, r.y, r.z), f.lookAt(r.x, r.y + m[R], r.z)) : (f.up.set(0, p[R], 0), f.position.set(r.x, r.y, r.z), f.lookAt(r.x, r.y, r.z + m[R]));
            const z = this._cubeSize;
            $455d545b1dff00eb$var$bd(i, N * z, R > 2 ? z : 0, z, z), x.setRenderTarget(i), b && x.render(A, f), x.render(e, f);
        }
        x.toneMapping = _, x.autoClear = v, e.background = C;
    }
    _textureToCubeUV(e, t) {
        const n = this._renderer, i = e.mapping === $455d545b1dff00eb$var$Sc || e.mapping === $455d545b1dff00eb$var$Mu;
        i ? (this._cubemapMaterial === null && (this._cubemapMaterial = $455d545b1dff00eb$var$WM()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = $455d545b1dff00eb$var$XM());
        const r = i ? this._cubemapMaterial : this._equirectMaterial, l = this._lodMeshes[0];
        l.material = r;
        const c = r.uniforms;
        c.envMap.value = e;
        const f = this._cubeSize;
        $455d545b1dff00eb$var$bd(t, 0, 0, 3 * f, 2 * f), n.setRenderTarget(t), n.render(l, $455d545b1dff00eb$var$Um);
    }
    _applyPMREM(e) {
        const t = this._renderer, n = t.autoClear;
        t.autoClear = !1;
        const i = this._lodMeshes.length;
        for(let r = 1; r < i; r++)this._applyGGXFilter(e, r - 1, r);
        t.autoClear = n;
    }
    _applyGGXFilter(e, t, n) {
        const i = this._renderer, r = this._pingPongRenderTarget, l = this._ggxMaterial, c = this._lodMeshes[n];
        c.material = l;
        const f = l.uniforms, p = n / (this._lodMeshes.length - 1), m = t / (this._lodMeshes.length - 1), x = Math.sqrt(p * p - m * m), v = .05 + p * .95, _ = x * v, { _lodMax: S } = this, A = this._sizeLods[n], M = 3 * A * (n > S - $455d545b1dff00eb$var$bu ? n - S + $455d545b1dff00eb$var$bu : 0), b = 4 * (this._cubeSize - A);
        f.envMap.value = e.texture, f.roughness.value = _, f.mipInt.value = S - t, $455d545b1dff00eb$var$bd(r, M, b, 3 * A, 2 * A), i.setRenderTarget(r), i.render(c, $455d545b1dff00eb$var$Um), f.envMap.value = r.texture, f.roughness.value = 0, f.mipInt.value = S - n, $455d545b1dff00eb$var$bd(e, M, b, 3 * A, 2 * A), i.setRenderTarget(e), i.render(c, $455d545b1dff00eb$var$Um);
    }
    _blur(e, t, n, i, r) {
        const l = this._pingPongRenderTarget;
        this._halfBlur(e, l, t, n, i, "latitudinal", r), this._halfBlur(l, e, n, n, i, "longitudinal", r);
    }
    _halfBlur(e, t, n, i, r, l, c) {
        const f = this._renderer, p = this._blurMaterial;
        l !== "latitudinal" && l !== "longitudinal" && $455d545b1dff00eb$var$Qt("blur direction must be either latitudinal or longitudinal!");
        const m = 3, x = this._lodMeshes[i];
        x.material = p;
        const v = p.uniforms, _ = this._sizeLods[n] - 1, S = isFinite(r) ? Math.PI / (2 * _) : 2 * Math.PI / (2 * $455d545b1dff00eb$var$Lf - 1), A = r / S, M = isFinite(r) ? 1 + Math.floor(m * A) : $455d545b1dff00eb$var$Lf;
        M > $455d545b1dff00eb$var$Lf && $455d545b1dff00eb$var$Mt(`sigmaRadians, ${r}, is too large and will clip, as it requested ${M} samples when the maximum is set to ${$455d545b1dff00eb$var$Lf}`);
        const b = [];
        let C = 0;
        for(let P = 0; P < $455d545b1dff00eb$var$Lf; ++P){
            const H = P / A, O = Math.exp(-H * H / 2);
            b.push(O), P === 0 ? C += O : P < M && (C += 2 * O);
        }
        for(let P = 0; P < b.length; P++)b[P] = b[P] / C;
        v.envMap.value = e.texture, v.samples.value = M, v.weights.value = b, v.latitudinal.value = l === "latitudinal", c && (v.poleAxis.value = c);
        const { _lodMax: R } = this;
        v.dTheta.value = S, v.mipInt.value = R - n;
        const N = this._sizeLods[i], z = 3 * N * (i > R - $455d545b1dff00eb$var$bu ? i - R + $455d545b1dff00eb$var$bu : 0), L = 4 * (this._cubeSize - N);
        $455d545b1dff00eb$var$bd(t, z, L, 3 * N, 2 * N), f.setRenderTarget(t), f.render(x, $455d545b1dff00eb$var$Um);
    }
}
function $455d545b1dff00eb$var$S5(a) {
    const e = [], t = [], n = [];
    let i = a;
    const r = a - $455d545b1dff00eb$var$bu + 1 + $455d545b1dff00eb$var$GM.length;
    for(let l = 0; l < r; l++){
        const c = Math.pow(2, i);
        e.push(c);
        let f = 1 / c;
        l > a - $455d545b1dff00eb$var$bu ? f = $455d545b1dff00eb$var$GM[l - a + $455d545b1dff00eb$var$bu - 1] : l === 0 && (f = 0), t.push(f);
        const p = 1 / (c - 2), m = -p, x = 1 + p, v = [
            m,
            m,
            x,
            m,
            x,
            x,
            m,
            m,
            x,
            x,
            m,
            x
        ], _ = 6, S = 6, A = 3, M = 2, b = 1, C = new Float32Array(A * S * _), R = new Float32Array(M * S * _), N = new Float32Array(b * S * _);
        for(let L = 0; L < _; L++){
            const P = L % 3 * 2 / 3 - 1, H = L > 2 ? 0 : -1, O = [
                P,
                H,
                0,
                P + 2 / 3,
                H,
                0,
                P + 2 / 3,
                H + 1,
                0,
                P,
                H,
                0,
                P + 2 / 3,
                H + 1,
                0,
                P,
                H + 1,
                0
            ];
            C.set(O, A * S * L), R.set(v, M * S * L);
            const D = [
                L,
                L,
                L,
                L,
                L,
                L
            ];
            N.set(D, b * S * L);
        }
        const z = new $455d545b1dff00eb$var$nn;
        z.setAttribute("position", new $455d545b1dff00eb$var$ti(C, A)), z.setAttribute("uv", new $455d545b1dff00eb$var$ti(R, M)), z.setAttribute("faceIndex", new $455d545b1dff00eb$var$ti(N, b)), n.push(new $455d545b1dff00eb$var$zi(z, null)), i > $455d545b1dff00eb$var$bu && i--;
    }
    return {
        lodMeshes: n,
        sizeLods: e,
        sigmas: t
    };
}
function $455d545b1dff00eb$var$jM(a, e, t) {
    const n = new $455d545b1dff00eb$var$Oo(a, e, t);
    return n.texture.mapping = $455d545b1dff00eb$var$Wd, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function $455d545b1dff00eb$var$bd(a, e, t, n, i) {
    a.viewport.set(e, t, n, i), a.scissor.set(e, t, n, i);
}
function $455d545b1dff00eb$var$M5(a, e, t) {
    return new $455d545b1dff00eb$var$qs({
        name: "PMREMGGXConvolution",
        defines: {
            GGX_SAMPLES: $455d545b1dff00eb$var$_5,
            CUBEUV_TEXEL_WIDTH: 1 / e,
            CUBEUV_TEXEL_HEIGHT: 1 / t,
            CUBEUV_MAX_MIP: `${a}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            roughness: {
                value: 0
            },
            mipInt: {
                value: 0
            }
        },
        vertexShader: $455d545b1dff00eb$var$By(),
        fragmentShader: `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: $455d545b1dff00eb$var$yl,
        depthTest: !1,
        depthWrite: !1
    });
}
function $455d545b1dff00eb$var$E5(a, e, t) {
    const n = new Float32Array($455d545b1dff00eb$var$Lf), i = new $455d545b1dff00eb$var$J(0, 1, 0);
    return new $455d545b1dff00eb$var$qs({
        name: "SphericalGaussianBlur",
        defines: {
            n: $455d545b1dff00eb$var$Lf,
            CUBEUV_TEXEL_WIDTH: 1 / e,
            CUBEUV_TEXEL_HEIGHT: 1 / t,
            CUBEUV_MAX_MIP: `${a}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: n
            },
            latitudinal: {
                value: !1
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: i
            }
        },
        vertexShader: $455d545b1dff00eb$var$By(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $455d545b1dff00eb$var$yl,
        depthTest: !1,
        depthWrite: !1
    });
}
function $455d545b1dff00eb$var$XM() {
    return new $455d545b1dff00eb$var$qs({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $455d545b1dff00eb$var$By(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $455d545b1dff00eb$var$yl,
        depthTest: !1,
        depthWrite: !1
    });
}
function $455d545b1dff00eb$var$WM() {
    return new $455d545b1dff00eb$var$qs({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $455d545b1dff00eb$var$By(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $455d545b1dff00eb$var$yl,
        depthTest: !1,
        depthWrite: !1
    });
}
function $455d545b1dff00eb$var$By() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $455d545b1dff00eb$var$T5(a) {
    let e = new WeakMap, t = null;
    function n(c) {
        if (c && c.isTexture) {
            const f = c.mapping, p = f === $455d545b1dff00eb$var$Jm || f === $455d545b1dff00eb$var$$m, m = f === $455d545b1dff00eb$var$Sc || f === $455d545b1dff00eb$var$Mu;
            if (p || m) {
                let x = e.get(c);
                const v = x !== void 0 ? x.texture.pmremVersion : 0;
                if (c.isRenderTargetTexture && c.pmremVersion !== v) return t === null && (t = new $455d545b1dff00eb$var$sb(a)), x = p ? t.fromEquirectangular(c, x) : t.fromCubemap(c, x), x.texture.pmremVersion = c.pmremVersion, e.set(c, x), x.texture;
                if (x !== void 0) return x.texture;
                {
                    const _ = c.image;
                    return p && _ && _.height > 0 || m && _ && i(_) ? (t === null && (t = new $455d545b1dff00eb$var$sb(a)), x = p ? t.fromEquirectangular(c) : t.fromCubemap(c), x.texture.pmremVersion = c.pmremVersion, e.set(c, x), c.addEventListener("dispose", r), x.texture) : null;
                }
            }
        }
        return c;
    }
    function i(c) {
        let f = 0;
        const p = 6;
        for(let m = 0; m < p; m++)c[m] !== void 0 && f++;
        return f === p;
    }
    function r(c) {
        const f = c.target;
        f.removeEventListener("dispose", r);
        const p = e.get(f);
        p !== void 0 && (e.delete(f), p.dispose());
    }
    function l() {
        e = new WeakMap, t !== null && (t.dispose(), t = null);
    }
    return {
        get: n,
        dispose: l
    };
}
function $455d545b1dff00eb$var$A5(a) {
    const e = {};
    function t(n) {
        if (e[n] !== void 0) return e[n];
        const i = a.getExtension(n);
        return e[n] = i, i;
    }
    return {
        has: function(n) {
            return t(n) !== null;
        },
        init: function() {
            t("EXT_color_buffer_float"), t("WEBGL_clip_cull_distance"), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture"), t("WEBGL_render_shared_exponent");
        },
        get: function(n) {
            const i = t(n);
            return i === null && $455d545b1dff00eb$var$Id("WebGLRenderer: " + n + " extension not supported."), i;
        }
    };
}
function $455d545b1dff00eb$var$w5(a, e, t, n) {
    const i = {}, r = new WeakMap;
    function l(x) {
        const v = x.target;
        v.index !== null && e.remove(v.index);
        for(const S in v.attributes)e.remove(v.attributes[S]);
        v.removeEventListener("dispose", l), delete i[v.id];
        const _ = r.get(v);
        _ && (e.remove(_), r.delete(v)), n.releaseStatesOfGeometry(v), v.isInstancedBufferGeometry === !0 && delete v._maxInstanceCount, t.memory.geometries--;
    }
    function c(x, v) {
        return i[v.id] === !0 || (v.addEventListener("dispose", l), i[v.id] = !0, t.memory.geometries++), v;
    }
    function f(x) {
        const v = x.attributes;
        for(const _ in v)e.update(v[_], a.ARRAY_BUFFER);
    }
    function p(x) {
        const v = [], _ = x.index, S = x.attributes.position;
        let A = 0;
        if (_ !== null) {
            const C = _.array;
            A = _.version;
            for(let R = 0, N = C.length; R < N; R += 3){
                const z = C[R + 0], L = C[R + 1], P = C[R + 2];
                v.push(z, L, L, P, P, z);
            }
        } else if (S !== void 0) {
            const C = S.array;
            A = S.version;
            for(let R = 0, N = C.length / 3 - 1; R < N; R += 3){
                const z = R + 0, L = R + 1, P = R + 2;
                v.push(z, L, L, P, P, z);
            }
        } else return;
        const M = new ($455d545b1dff00eb$var$vT(v) ? $455d545b1dff00eb$var$kb : $455d545b1dff00eb$var$Gb)(v, 1);
        M.version = A;
        const b = r.get(x);
        b && e.remove(b), r.set(x, M);
    }
    function m(x) {
        const v = r.get(x);
        if (v) {
            const _ = x.index;
            _ !== null && v.version < _.version && p(x);
        } else p(x);
        return r.get(x);
    }
    return {
        get: c,
        update: f,
        getWireframeAttribute: m
    };
}
function $455d545b1dff00eb$var$C5(a, e, t) {
    let n;
    function i(v) {
        n = v;
    }
    let r, l;
    function c(v) {
        r = v.type, l = v.bytesPerElement;
    }
    function f(v, _) {
        a.drawElements(n, _, r, v * l), t.update(_, n, 1);
    }
    function p(v, _, S) {
        S !== 0 && (a.drawElementsInstanced(n, _, r, v * l, S), t.update(_, n, S));
    }
    function m(v, _, S) {
        if (S === 0) return;
        e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, _, 0, r, v, 0, S);
        let M = 0;
        for(let b = 0; b < S; b++)M += _[b];
        t.update(M, n, 1);
    }
    function x(v, _, S, A) {
        if (S === 0) return;
        const M = e.get("WEBGL_multi_draw");
        if (M === null) for(let b = 0; b < v.length; b++)p(v[b] / l, _[b], A[b]);
        else {
            M.multiDrawElementsInstancedWEBGL(n, _, 0, r, v, 0, A, 0, S);
            let b = 0;
            for(let C = 0; C < S; C++)b += _[C] * A[C];
            t.update(b, n, 1);
        }
    }
    this.setMode = i, this.setIndex = c, this.render = f, this.renderInstances = p, this.renderMultiDraw = m, this.renderMultiDrawInstances = x;
}
function $455d545b1dff00eb$var$R5(a) {
    const e = {
        geometries: 0,
        textures: 0
    }, t = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function n(r, l, c) {
        switch(t.calls++, l){
            case a.TRIANGLES:
                t.triangles += c * (r / 3);
                break;
            case a.LINES:
                t.lines += c * (r / 2);
                break;
            case a.LINE_STRIP:
                t.lines += c * (r - 1);
                break;
            case a.LINE_LOOP:
                t.lines += c * r;
                break;
            case a.POINTS:
                t.points += c * r;
                break;
            default:
                $455d545b1dff00eb$var$Qt("WebGLInfo: Unknown draw mode:", l);
                break;
        }
    }
    function i() {
        t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
    }
    return {
        memory: e,
        render: t,
        programs: null,
        autoReset: !0,
        reset: i,
        update: n
    };
}
function $455d545b1dff00eb$var$D5(a, e, t) {
    const n = new WeakMap, i = new $455d545b1dff00eb$var$Un;
    function r(l, c, f) {
        const p = l.morphTargetInfluences, m = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, x = m !== void 0 ? m.length : 0;
        let v = n.get(c);
        if (v === void 0 || v.count !== x) {
            let O = function() {
                P.dispose(), n.delete(c), c.removeEventListener("dispose", O);
            };
            v !== void 0 && v.texture.dispose();
            const _ = c.morphAttributes.position !== void 0, S = c.morphAttributes.normal !== void 0, A = c.morphAttributes.color !== void 0, M = c.morphAttributes.position || [], b = c.morphAttributes.normal || [], C = c.morphAttributes.color || [];
            let R = 0;
            _ === !0 && (R = 1), S === !0 && (R = 2), A === !0 && (R = 3);
            let N = c.attributes.position.count * R, z = 1;
            N > e.maxTextureSize && (z = Math.ceil(N / e.maxTextureSize), N = e.maxTextureSize);
            const L = new Float32Array(N * z * 4 * x), P = new $455d545b1dff00eb$var$uy(L, N, z, x);
            P.type = $455d545b1dff00eb$var$Rr, P.needsUpdate = !0;
            const H = R * 4;
            for(let D = 0; D < x; D++){
                const j = M[D], G = b[D], q = C[D], Y = N * z * 4 * D;
                for(let ae = 0; ae < j.count; ae++){
                    const F = ae * H;
                    _ === !0 && (i.fromBufferAttribute(j, ae), L[Y + F + 0] = i.x, L[Y + F + 1] = i.y, L[Y + F + 2] = i.z, L[Y + F + 3] = 0), S === !0 && (i.fromBufferAttribute(G, ae), L[Y + F + 4] = i.x, L[Y + F + 5] = i.y, L[Y + F + 6] = i.z, L[Y + F + 7] = 0), A === !0 && (i.fromBufferAttribute(q, ae), L[Y + F + 8] = i.x, L[Y + F + 9] = i.y, L[Y + F + 10] = i.z, L[Y + F + 11] = q.itemSize === 4 ? i.w : 1);
                }
            }
            v = {
                count: x,
                texture: P,
                size: new $455d545b1dff00eb$var$$e(N, z)
            }, n.set(c, v), c.addEventListener("dispose", O);
        }
        if (l.isInstancedMesh === !0 && l.morphTexture !== null) f.getUniforms().setValue(a, "morphTexture", l.morphTexture, t);
        else {
            let _ = 0;
            for(let A = 0; A < p.length; A++)_ += p[A];
            const S = c.morphTargetsRelative ? 1 : 1 - _;
            f.getUniforms().setValue(a, "morphTargetBaseInfluence", S), f.getUniforms().setValue(a, "morphTargetInfluences", p);
        }
        f.getUniforms().setValue(a, "morphTargetsTexture", v.texture, t), f.getUniforms().setValue(a, "morphTargetsTextureSize", v.size);
    }
    return {
        update: r
    };
}
function $455d545b1dff00eb$var$U5(a, e, t, n) {
    let i = new WeakMap;
    function r(f) {
        const p = n.render.frame, m = f.geometry, x = e.get(f, m);
        if (i.get(x) !== p && (e.update(x), i.set(x, p)), f.isInstancedMesh && (f.hasEventListener("dispose", c) === !1 && f.addEventListener("dispose", c), i.get(f) !== p && (t.update(f.instanceMatrix, a.ARRAY_BUFFER), f.instanceColor !== null && t.update(f.instanceColor, a.ARRAY_BUFFER), i.set(f, p))), f.isSkinnedMesh) {
            const v = f.skeleton;
            i.get(v) !== p && (v.update(), i.set(v, p));
        }
        return x;
    }
    function l() {
        i = new WeakMap;
    }
    function c(f) {
        const p = f.target;
        p.removeEventListener("dispose", c), t.remove(p.instanceMatrix), p.instanceColor !== null && t.remove(p.instanceColor);
    }
    return {
        update: r,
        dispose: l
    };
}
const $455d545b1dff00eb$var$SA = new $455d545b1dff00eb$var$Li, $455d545b1dff00eb$var$qM = new $455d545b1dff00eb$var$yy(1, 1), $455d545b1dff00eb$var$MA = new $455d545b1dff00eb$var$uy, $455d545b1dff00eb$var$EA = new $455d545b1dff00eb$var$fy, $455d545b1dff00eb$var$TA = new $455d545b1dff00eb$var$E0, $455d545b1dff00eb$var$YM = [], $455d545b1dff00eb$var$ZM = [], $455d545b1dff00eb$var$QM = new Float32Array(16), $455d545b1dff00eb$var$KM = new Float32Array(9), $455d545b1dff00eb$var$JM = new Float32Array(4);
function $455d545b1dff00eb$var$Yd(a, e, t) {
    const n = a[0];
    if (n <= 0 || n > 0) return a;
    const i = e * t;
    let r = $455d545b1dff00eb$var$YM[i];
    if (r === void 0 && (r = new Float32Array(i), $455d545b1dff00eb$var$YM[i] = r), e !== 0) {
        n.toArray(r, 0);
        for(let l = 1, c = 0; l !== e; ++l)c += t, a[l].toArray(r, c);
    }
    return r;
}
function $455d545b1dff00eb$var$fa(a, e) {
    if (a.length !== e.length) return !1;
    for(let t = 0, n = a.length; t < n; t++)if (a[t] !== e[t]) return !1;
    return !0;
}
function $455d545b1dff00eb$var$ha(a, e) {
    for(let t = 0, n = e.length; t < n; t++)a[t] = e[t];
}
function $455d545b1dff00eb$var$Iy(a, e) {
    let t = $455d545b1dff00eb$var$ZM[e];
    t === void 0 && (t = new Int32Array(e), $455d545b1dff00eb$var$ZM[e] = t);
    for(let n = 0; n !== e; ++n)t[n] = a.allocateTextureUnit();
    return t;
}
function $455d545b1dff00eb$var$N5(a, e) {
    const t = this.cache;
    t[0] !== e && (a.uniform1f(this.addr, e), t[0] = e);
}
function $455d545b1dff00eb$var$O5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y) && (a.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform2fv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$L5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (a.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
    else if (e.r !== void 0) (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (a.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform3fv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$z5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (a.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform4fv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$P5(a, e) {
    const t = this.cache, n = e.elements;
    if (n === void 0) {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniformMatrix2fv(this.addr, !1, e), $455d545b1dff00eb$var$ha(t, e);
    } else {
        if ($455d545b1dff00eb$var$fa(t, n)) return;
        $455d545b1dff00eb$var$JM.set(n), a.uniformMatrix2fv(this.addr, !1, $455d545b1dff00eb$var$JM), $455d545b1dff00eb$var$ha(t, n);
    }
}
function $455d545b1dff00eb$var$B5(a, e) {
    const t = this.cache, n = e.elements;
    if (n === void 0) {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniformMatrix3fv(this.addr, !1, e), $455d545b1dff00eb$var$ha(t, e);
    } else {
        if ($455d545b1dff00eb$var$fa(t, n)) return;
        $455d545b1dff00eb$var$KM.set(n), a.uniformMatrix3fv(this.addr, !1, $455d545b1dff00eb$var$KM), $455d545b1dff00eb$var$ha(t, n);
    }
}
function $455d545b1dff00eb$var$I5(a, e) {
    const t = this.cache, n = e.elements;
    if (n === void 0) {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniformMatrix4fv(this.addr, !1, e), $455d545b1dff00eb$var$ha(t, e);
    } else {
        if ($455d545b1dff00eb$var$fa(t, n)) return;
        $455d545b1dff00eb$var$QM.set(n), a.uniformMatrix4fv(this.addr, !1, $455d545b1dff00eb$var$QM), $455d545b1dff00eb$var$ha(t, n);
    }
}
function $455d545b1dff00eb$var$F5(a, e) {
    const t = this.cache;
    t[0] !== e && (a.uniform1i(this.addr, e), t[0] = e);
}
function $455d545b1dff00eb$var$H5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y) && (a.uniform2i(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform2iv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$V5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (a.uniform3i(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform3iv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$G5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (a.uniform4i(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform4iv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$k5(a, e) {
    const t = this.cache;
    t[0] !== e && (a.uniform1ui(this.addr, e), t[0] = e);
}
function $455d545b1dff00eb$var$j5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y) && (a.uniform2ui(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform2uiv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$X5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (a.uniform3ui(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform3uiv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$W5(a, e) {
    const t = this.cache;
    if (e.x !== void 0) (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (a.uniform4ui(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
    else {
        if ($455d545b1dff00eb$var$fa(t, e)) return;
        a.uniform4uiv(this.addr, e), $455d545b1dff00eb$var$ha(t, e);
    }
}
function $455d545b1dff00eb$var$q5(a, e, t) {
    const n = this.cache, i = t.allocateTextureUnit();
    n[0] !== i && (a.uniform1i(this.addr, i), n[0] = i);
    let r;
    this.type === a.SAMPLER_2D_SHADOW ? ($455d545b1dff00eb$var$qM.compareFunction = $455d545b1dff00eb$var$Fb, r = $455d545b1dff00eb$var$qM) : r = $455d545b1dff00eb$var$SA, t.setTexture2D(e || r, i);
}
function $455d545b1dff00eb$var$Y5(a, e, t) {
    const n = this.cache, i = t.allocateTextureUnit();
    n[0] !== i && (a.uniform1i(this.addr, i), n[0] = i), t.setTexture3D(e || $455d545b1dff00eb$var$EA, i);
}
function $455d545b1dff00eb$var$Z5(a, e, t) {
    const n = this.cache, i = t.allocateTextureUnit();
    n[0] !== i && (a.uniform1i(this.addr, i), n[0] = i), t.setTextureCube(e || $455d545b1dff00eb$var$TA, i);
}
function $455d545b1dff00eb$var$Q5(a, e, t) {
    const n = this.cache, i = t.allocateTextureUnit();
    n[0] !== i && (a.uniform1i(this.addr, i), n[0] = i), t.setTexture2DArray(e || $455d545b1dff00eb$var$MA, i);
}
function $455d545b1dff00eb$var$K5(a) {
    switch(a){
        case 5126:
            return $455d545b1dff00eb$var$N5;
        case 35664:
            return $455d545b1dff00eb$var$O5;
        case 35665:
            return $455d545b1dff00eb$var$L5;
        case 35666:
            return $455d545b1dff00eb$var$z5;
        case 35674:
            return $455d545b1dff00eb$var$P5;
        case 35675:
            return $455d545b1dff00eb$var$B5;
        case 35676:
            return $455d545b1dff00eb$var$I5;
        case 5124:
        case 35670:
            return $455d545b1dff00eb$var$F5;
        case 35667:
        case 35671:
            return $455d545b1dff00eb$var$H5;
        case 35668:
        case 35672:
            return $455d545b1dff00eb$var$V5;
        case 35669:
        case 35673:
            return $455d545b1dff00eb$var$G5;
        case 5125:
            return $455d545b1dff00eb$var$k5;
        case 36294:
            return $455d545b1dff00eb$var$j5;
        case 36295:
            return $455d545b1dff00eb$var$X5;
        case 36296:
            return $455d545b1dff00eb$var$W5;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return $455d545b1dff00eb$var$q5;
        case 35679:
        case 36299:
        case 36307:
            return $455d545b1dff00eb$var$Y5;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return $455d545b1dff00eb$var$Z5;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return $455d545b1dff00eb$var$Q5;
    }
}
function $455d545b1dff00eb$var$J5(a, e) {
    a.uniform1fv(this.addr, e);
}
function $455d545b1dff00eb$var$$5(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 2);
    a.uniform2fv(this.addr, t);
}
function $455d545b1dff00eb$var$ez(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 3);
    a.uniform3fv(this.addr, t);
}
function $455d545b1dff00eb$var$tz(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 4);
    a.uniform4fv(this.addr, t);
}
function $455d545b1dff00eb$var$nz(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 4);
    a.uniformMatrix2fv(this.addr, !1, t);
}
function $455d545b1dff00eb$var$iz(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 9);
    a.uniformMatrix3fv(this.addr, !1, t);
}
function $455d545b1dff00eb$var$az(a, e) {
    const t = $455d545b1dff00eb$var$Yd(e, this.size, 16);
    a.uniformMatrix4fv(this.addr, !1, t);
}
function $455d545b1dff00eb$var$rz(a, e) {
    a.uniform1iv(this.addr, e);
}
function $455d545b1dff00eb$var$sz(a, e) {
    a.uniform2iv(this.addr, e);
}
function $455d545b1dff00eb$var$oz(a, e) {
    a.uniform3iv(this.addr, e);
}
function $455d545b1dff00eb$var$lz(a, e) {
    a.uniform4iv(this.addr, e);
}
function $455d545b1dff00eb$var$cz(a, e) {
    a.uniform1uiv(this.addr, e);
}
function $455d545b1dff00eb$var$uz(a, e) {
    a.uniform2uiv(this.addr, e);
}
function $455d545b1dff00eb$var$fz(a, e) {
    a.uniform3uiv(this.addr, e);
}
function $455d545b1dff00eb$var$hz(a, e) {
    a.uniform4uiv(this.addr, e);
}
function $455d545b1dff00eb$var$dz(a, e, t) {
    const n = this.cache, i = e.length, r = $455d545b1dff00eb$var$Iy(t, i);
    $455d545b1dff00eb$var$fa(n, r) || (a.uniform1iv(this.addr, r), $455d545b1dff00eb$var$ha(n, r));
    for(let l = 0; l !== i; ++l)t.setTexture2D(e[l] || $455d545b1dff00eb$var$SA, r[l]);
}
function $455d545b1dff00eb$var$pz(a, e, t) {
    const n = this.cache, i = e.length, r = $455d545b1dff00eb$var$Iy(t, i);
    $455d545b1dff00eb$var$fa(n, r) || (a.uniform1iv(this.addr, r), $455d545b1dff00eb$var$ha(n, r));
    for(let l = 0; l !== i; ++l)t.setTexture3D(e[l] || $455d545b1dff00eb$var$EA, r[l]);
}
function $455d545b1dff00eb$var$mz(a, e, t) {
    const n = this.cache, i = e.length, r = $455d545b1dff00eb$var$Iy(t, i);
    $455d545b1dff00eb$var$fa(n, r) || (a.uniform1iv(this.addr, r), $455d545b1dff00eb$var$ha(n, r));
    for(let l = 0; l !== i; ++l)t.setTextureCube(e[l] || $455d545b1dff00eb$var$TA, r[l]);
}
function $455d545b1dff00eb$var$gz(a, e, t) {
    const n = this.cache, i = e.length, r = $455d545b1dff00eb$var$Iy(t, i);
    $455d545b1dff00eb$var$fa(n, r) || (a.uniform1iv(this.addr, r), $455d545b1dff00eb$var$ha(n, r));
    for(let l = 0; l !== i; ++l)t.setTexture2DArray(e[l] || $455d545b1dff00eb$var$MA, r[l]);
}
function $455d545b1dff00eb$var$xz(a) {
    switch(a){
        case 5126:
            return $455d545b1dff00eb$var$J5;
        case 35664:
            return $455d545b1dff00eb$var$$5;
        case 35665:
            return $455d545b1dff00eb$var$ez;
        case 35666:
            return $455d545b1dff00eb$var$tz;
        case 35674:
            return $455d545b1dff00eb$var$nz;
        case 35675:
            return $455d545b1dff00eb$var$iz;
        case 35676:
            return $455d545b1dff00eb$var$az;
        case 5124:
        case 35670:
            return $455d545b1dff00eb$var$rz;
        case 35667:
        case 35671:
            return $455d545b1dff00eb$var$sz;
        case 35668:
        case 35672:
            return $455d545b1dff00eb$var$oz;
        case 35669:
        case 35673:
            return $455d545b1dff00eb$var$lz;
        case 5125:
            return $455d545b1dff00eb$var$cz;
        case 36294:
            return $455d545b1dff00eb$var$uz;
        case 36295:
            return $455d545b1dff00eb$var$fz;
        case 36296:
            return $455d545b1dff00eb$var$hz;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return $455d545b1dff00eb$var$dz;
        case 35679:
        case 36299:
        case 36307:
            return $455d545b1dff00eb$var$pz;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return $455d545b1dff00eb$var$mz;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return $455d545b1dff00eb$var$gz;
    }
}
class $455d545b1dff00eb$var$vz {
    constructor(e, t, n){
        this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = $455d545b1dff00eb$var$K5(t.type);
    }
}
class $455d545b1dff00eb$var$yz {
    constructor(e, t, n){
        this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = $455d545b1dff00eb$var$xz(t.type);
    }
}
class $455d545b1dff00eb$var$_z {
    constructor(e){
        this.id = e, this.seq = [], this.map = {};
    }
    setValue(e, t, n) {
        const i = this.seq;
        for(let r = 0, l = i.length; r !== l; ++r){
            const c = i[r];
            c.setValue(e, t[c.id], n);
        }
    }
}
const $455d545b1dff00eb$var$v_ = /(\w+)(\])?(\[|\.)?/g;
function $455d545b1dff00eb$var$$M(a, e) {
    a.seq.push(e), a.map[e.id] = e;
}
function $455d545b1dff00eb$var$bz(a, e, t) {
    const n = a.name, i = n.length;
    for($455d545b1dff00eb$var$v_.lastIndex = 0;;){
        const r = $455d545b1dff00eb$var$v_.exec(n), l = $455d545b1dff00eb$var$v_.lastIndex;
        let c = r[1];
        const f = r[2] === "]", p = r[3];
        if (f && (c = c | 0), p === void 0 || p === "[" && l + 2 === i) {
            $455d545b1dff00eb$var$$M(t, p === void 0 ? new $455d545b1dff00eb$var$vz(c, a, e) : new $455d545b1dff00eb$var$yz(c, a, e));
            break;
        } else {
            let x = t.map[c];
            x === void 0 && (x = new $455d545b1dff00eb$var$_z(c), $455d545b1dff00eb$var$$M(t, x)), t = x;
        }
    }
}
class $455d545b1dff00eb$var$Yx {
    constructor(e, t){
        this.seq = [], this.map = {};
        const n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const r = e.getActiveUniform(t, i), l = e.getUniformLocation(t, r.name);
            $455d545b1dff00eb$var$bz(r, l, this);
        }
    }
    setValue(e, t, n, i) {
        const r = this.map[t];
        r !== void 0 && r.setValue(e, n, i);
    }
    setOptional(e, t, n) {
        const i = t[n];
        i !== void 0 && this.setValue(e, n, i);
    }
    static upload(e, t, n, i) {
        for(let r = 0, l = t.length; r !== l; ++r){
            const c = t[r], f = n[c.id];
            f.needsUpdate !== !1 && c.setValue(e, f.value, i);
        }
    }
    static seqWithValue(e, t) {
        const n = [];
        for(let i = 0, r = e.length; i !== r; ++i){
            const l = e[i];
            l.id in t && n.push(l);
        }
        return n;
    }
}
function $455d545b1dff00eb$var$e3(a, e, t) {
    const n = a.createShader(e);
    return a.shaderSource(n, t), a.compileShader(n), n;
}
const $455d545b1dff00eb$var$Sz = 37297;
let $455d545b1dff00eb$var$Mz = 0;
function $455d545b1dff00eb$var$Ez(a, e) {
    const t = a.split(`
`), n = [], i = Math.max(e - 6, 0), r = Math.min(e + 6, t.length);
    for(let l = i; l < r; l++){
        const c = l + 1;
        n.push(`${c === e ? ">" : " "} ${c}: ${t[l]}`);
    }
    return n.join(`
`);
}
const $455d545b1dff00eb$var$t3 = new $455d545b1dff00eb$var$Jt;
function $455d545b1dff00eb$var$Tz(a) {
    $455d545b1dff00eb$var$Dn._getMatrix($455d545b1dff00eb$var$t3, $455d545b1dff00eb$var$Dn.workingColorSpace, a);
    const e = `mat3( ${$455d545b1dff00eb$var$t3.elements.map((t)=>t.toFixed(4))} )`;
    switch($455d545b1dff00eb$var$Dn.getTransfer(a)){
        case $455d545b1dff00eb$var$a0:
            return [
                e,
                "LinearTransferOETF"
            ];
        case $455d545b1dff00eb$var$Zn:
            return [
                e,
                "sRGBTransferOETF"
            ];
        default:
            return $455d545b1dff00eb$var$Mt("WebGLProgram: Unsupported color space: ", a), [
                e,
                "LinearTransferOETF"
            ];
    }
}
function $455d545b1dff00eb$var$n3(a, e, t) {
    const n = a.getShaderParameter(e, a.COMPILE_STATUS), r = (a.getShaderInfoLog(e) || "").trim();
    if (n && r === "") return "";
    const l = /ERROR: 0:(\d+)/.exec(r);
    if (l) {
        const c = parseInt(l[1]);
        return t.toUpperCase() + `

` + r + `

` + $455d545b1dff00eb$var$Ez(a.getShaderSource(e), c);
    } else return r;
}
function $455d545b1dff00eb$var$Az(a, e) {
    const t = $455d545b1dff00eb$var$Tz(e);
    return [
        `vec4 ${a}( vec4 value ) {`,
        `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
        "}"
    ].join(`
`);
}
function $455d545b1dff00eb$var$wz(a, e) {
    let t;
    switch(e){
        case $455d545b1dff00eb$var$$E:
            t = "Linear";
            break;
        case $455d545b1dff00eb$var$eT:
            t = "Reinhard";
            break;
        case $455d545b1dff00eb$var$tT:
            t = "Cineon";
            break;
        case $455d545b1dff00eb$var$Rb:
            t = "ACESFilmic";
            break;
        case $455d545b1dff00eb$var$iT:
            t = "AgX";
            break;
        case $455d545b1dff00eb$var$aT:
            t = "Neutral";
            break;
        case $455d545b1dff00eb$var$nT:
            t = "Custom";
            break;
        default:
            $455d545b1dff00eb$var$Mt("WebGLProgram: Unsupported toneMapping:", e), t = "Linear";
    }
    return "vec3 " + a + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
const $455d545b1dff00eb$var$zx = new $455d545b1dff00eb$var$J;
function $455d545b1dff00eb$var$Cz() {
    $455d545b1dff00eb$var$Dn.getLuminanceCoefficients($455d545b1dff00eb$var$zx);
    const a = $455d545b1dff00eb$var$zx.x.toFixed(4), e = $455d545b1dff00eb$var$zx.y.toFixed(4), t = $455d545b1dff00eb$var$zx.z.toFixed(4);
    return [
        "float luminance( const in vec3 rgb ) {",
        `	const vec3 weights = vec3( ${a}, ${e}, ${t} );`,
        "	return dot( weights, rgb );",
        "}"
    ].join(`
`);
}
function $455d545b1dff00eb$var$Rz(a) {
    return [
        a.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
        a.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
    ].filter($455d545b1dff00eb$var$Pm).join(`
`);
}
function $455d545b1dff00eb$var$Dz(a) {
    const e = [];
    for(const t in a){
        const n = a[t];
        n !== !1 && e.push("#define " + t + " " + n);
    }
    return e.join(`
`);
}
function $455d545b1dff00eb$var$Uz(a, e) {
    const t = {}, n = a.getProgramParameter(e, a.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const r = a.getActiveAttrib(e, i), l = r.name;
        let c = 1;
        r.type === a.FLOAT_MAT2 && (c = 2), r.type === a.FLOAT_MAT3 && (c = 3), r.type === a.FLOAT_MAT4 && (c = 4), t[l] = {
            type: r.type,
            location: a.getAttribLocation(e, l),
            locationSize: c
        };
    }
    return t;
}
function $455d545b1dff00eb$var$Pm(a) {
    return a !== "";
}
function $455d545b1dff00eb$var$i3(a, e) {
    const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
    return a.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, t).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function $455d545b1dff00eb$var$a3(a, e) {
    return a.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const $455d545b1dff00eb$var$Nz = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $455d545b1dff00eb$var$ob(a) {
    return a.replace($455d545b1dff00eb$var$Nz, $455d545b1dff00eb$var$Lz);
}
const $455d545b1dff00eb$var$Oz = new Map;
function $455d545b1dff00eb$var$Lz(a, e) {
    let t = $455d545b1dff00eb$var$rn[e];
    if (t === void 0) {
        const n = $455d545b1dff00eb$var$Oz.get(e);
        if (n !== void 0) t = $455d545b1dff00eb$var$rn[n], $455d545b1dff00eb$var$Mt('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, n);
        else throw new Error("Can not resolve #include <" + e + ">");
    }
    return $455d545b1dff00eb$var$ob(t);
}
const $455d545b1dff00eb$var$zz = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $455d545b1dff00eb$var$r3(a) {
    return a.replace($455d545b1dff00eb$var$zz, $455d545b1dff00eb$var$Pz);
}
function $455d545b1dff00eb$var$Pz(a, e, t, n) {
    let i = "";
    for(let r = parseInt(e); r < parseInt(t); r++)i += n.replace(/\[\s*i\s*\]/g, "[ " + r + " ]").replace(/UNROLLED_LOOP_INDEX/g, r);
    return i;
}
function $455d545b1dff00eb$var$s3(a) {
    let e = `precision ${a.precision} float;
	precision ${a.precision} int;
	precision ${a.precision} sampler2D;
	precision ${a.precision} samplerCube;
	precision ${a.precision} sampler3D;
	precision ${a.precision} sampler2DArray;
	precision ${a.precision} sampler2DShadow;
	precision ${a.precision} samplerCubeShadow;
	precision ${a.precision} sampler2DArrayShadow;
	precision ${a.precision} isampler2D;
	precision ${a.precision} isampler3D;
	precision ${a.precision} isamplerCube;
	precision ${a.precision} isampler2DArray;
	precision ${a.precision} usampler2D;
	precision ${a.precision} usampler3D;
	precision ${a.precision} usamplerCube;
	precision ${a.precision} usampler2DArray;
	`;
    return a.precision === "highp" ? e += `
#define HIGH_PRECISION` : a.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : a.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function $455d545b1dff00eb$var$Bz(a) {
    let e = "SHADOWMAP_TYPE_BASIC";
    return a.shadowMapType === $455d545b1dff00eb$var$ey ? e = "SHADOWMAP_TYPE_PCF" : a.shadowMapType === $455d545b1dff00eb$var$Im ? e = "SHADOWMAP_TYPE_PCF_SOFT" : a.shadowMapType === $455d545b1dff00eb$var$Ao && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function $455d545b1dff00eb$var$Iz(a) {
    let e = "ENVMAP_TYPE_CUBE";
    if (a.envMap) switch(a.envMapMode){
        case $455d545b1dff00eb$var$Sc:
        case $455d545b1dff00eb$var$Mu:
            e = "ENVMAP_TYPE_CUBE";
            break;
        case $455d545b1dff00eb$var$Wd:
            e = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return e;
}
function $455d545b1dff00eb$var$Fz(a) {
    let e = "ENVMAP_MODE_REFLECTION";
    if (a.envMap) switch(a.envMapMode){
        case $455d545b1dff00eb$var$Mu:
            e = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return e;
}
function $455d545b1dff00eb$var$Hz(a) {
    let e = "ENVMAP_BLENDING_NONE";
    if (a.envMap) switch(a.combine){
        case $455d545b1dff00eb$var$S0:
            e = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $455d545b1dff00eb$var$KE:
            e = "ENVMAP_BLENDING_MIX";
            break;
        case $455d545b1dff00eb$var$JE:
            e = "ENVMAP_BLENDING_ADD";
            break;
    }
    return e;
}
function $455d545b1dff00eb$var$Vz(a) {
    const e = a.envMapCubeUVHeight;
    if (e === null) return null;
    const t = Math.log2(e) - 2, n = 1 / e;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)),
        texelHeight: n,
        maxMip: t
    };
}
function $455d545b1dff00eb$var$Gz(a, e, t, n) {
    const i = a.getContext(), r = t.defines;
    let l = t.vertexShader, c = t.fragmentShader;
    const f = $455d545b1dff00eb$var$Bz(t), p = $455d545b1dff00eb$var$Iz(t), m = $455d545b1dff00eb$var$Fz(t), x = $455d545b1dff00eb$var$Hz(t), v = $455d545b1dff00eb$var$Vz(t), _ = $455d545b1dff00eb$var$Rz(t), S = $455d545b1dff00eb$var$Dz(r), A = i.createProgram();
    let M, b, C = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
    t.isRawShaderMaterial ? (M = [
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        S
    ].filter($455d545b1dff00eb$var$Pm).join(`
`), M.length > 0 && (M += `
`), b = [
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        S
    ].filter($455d545b1dff00eb$var$Pm).join(`
`), b.length > 0 && (b += `
`)) : (M = [
        $455d545b1dff00eb$var$s3(t),
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        S,
        t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        t.batching ? "#define USE_BATCHING" : "",
        t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        t.instancing ? "#define USE_INSTANCING" : "",
        t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        t.useFog && t.fog ? "#define USE_FOG" : "",
        t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
        t.map ? "#define USE_MAP" : "",
        t.envMap ? "#define USE_ENVMAP" : "",
        t.envMap ? "#define " + m : "",
        t.lightMap ? "#define USE_LIGHTMAP" : "",
        t.aoMap ? "#define USE_AOMAP" : "",
        t.bumpMap ? "#define USE_BUMPMAP" : "",
        t.normalMap ? "#define USE_NORMALMAP" : "",
        t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        t.anisotropy ? "#define USE_ANISOTROPY" : "",
        t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        t.specularMap ? "#define USE_SPECULARMAP" : "",
        t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        t.metalnessMap ? "#define USE_METALNESSMAP" : "",
        t.alphaMap ? "#define USE_ALPHAMAP" : "",
        t.alphaHash ? "#define USE_ALPHAHASH" : "",
        t.transmission ? "#define USE_TRANSMISSION" : "",
        t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        t.mapUv ? "#define MAP_UV " + t.mapUv : "",
        t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
        t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
        t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
        t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
        t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
        t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
        t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
        t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
        t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
        t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
        t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
        t.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv : "",
        t.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv : "",
        t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
        t.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv : "",
        t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
        t.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv : "",
        t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
        t.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv : "",
        t.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv : "",
        t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
        t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
        t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
        t.vertexColors ? "#define USE_COLOR" : "",
        t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        t.vertexUv1s ? "#define USE_UV1" : "",
        t.vertexUv2s ? "#define USE_UV2" : "",
        t.vertexUv3s ? "#define USE_UV3" : "",
        t.pointsUvs ? "#define USE_POINTS_UV" : "",
        t.flatShading ? "#define FLAT_SHADED" : "",
        t.skinning ? "#define USE_SKINNING" : "",
        t.morphTargets ? "#define USE_MORPHTARGETS" : "",
        t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        t.morphColors ? "#define USE_MORPHCOLORS" : "",
        t.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
        t.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
        t.doubleSided ? "#define DOUBLE_SIDED" : "",
        t.flipSided ? "#define FLIP_SIDED" : "",
        t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        t.shadowMapEnabled ? "#define " + f : "",
        t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "	uniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "	attribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "	attribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "	attribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`
    ].filter($455d545b1dff00eb$var$Pm).join(`
`), b = [
        $455d545b1dff00eb$var$s3(t),
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        S,
        t.useFog && t.fog ? "#define USE_FOG" : "",
        t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
        t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        t.map ? "#define USE_MAP" : "",
        t.matcap ? "#define USE_MATCAP" : "",
        t.envMap ? "#define USE_ENVMAP" : "",
        t.envMap ? "#define " + p : "",
        t.envMap ? "#define " + m : "",
        t.envMap ? "#define " + x : "",
        v ? "#define CUBEUV_TEXEL_WIDTH " + v.texelWidth : "",
        v ? "#define CUBEUV_TEXEL_HEIGHT " + v.texelHeight : "",
        v ? "#define CUBEUV_MAX_MIP " + v.maxMip + ".0" : "",
        t.lightMap ? "#define USE_LIGHTMAP" : "",
        t.aoMap ? "#define USE_AOMAP" : "",
        t.bumpMap ? "#define USE_BUMPMAP" : "",
        t.normalMap ? "#define USE_NORMALMAP" : "",
        t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        t.anisotropy ? "#define USE_ANISOTROPY" : "",
        t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        t.clearcoat ? "#define USE_CLEARCOAT" : "",
        t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        t.dispersion ? "#define USE_DISPERSION" : "",
        t.iridescence ? "#define USE_IRIDESCENCE" : "",
        t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        t.specularMap ? "#define USE_SPECULARMAP" : "",
        t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        t.metalnessMap ? "#define USE_METALNESSMAP" : "",
        t.alphaMap ? "#define USE_ALPHAMAP" : "",
        t.alphaTest ? "#define USE_ALPHATEST" : "",
        t.alphaHash ? "#define USE_ALPHAHASH" : "",
        t.sheen ? "#define USE_SHEEN" : "",
        t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        t.transmission ? "#define USE_TRANSMISSION" : "",
        t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
        t.vertexColors || t.instancingColor || t.batchingColor ? "#define USE_COLOR" : "",
        t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        t.vertexUv1s ? "#define USE_UV1" : "",
        t.vertexUv2s ? "#define USE_UV2" : "",
        t.vertexUv3s ? "#define USE_UV3" : "",
        t.pointsUvs ? "#define USE_POINTS_UV" : "",
        t.gradientMap ? "#define USE_GRADIENTMAP" : "",
        t.flatShading ? "#define FLAT_SHADED" : "",
        t.doubleSided ? "#define DOUBLE_SIDED" : "",
        t.flipSided ? "#define FLIP_SIDED" : "",
        t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        t.shadowMapEnabled ? "#define " + f : "",
        t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        t.toneMapping !== $455d545b1dff00eb$var$_l ? "#define TONE_MAPPING" : "",
        t.toneMapping !== $455d545b1dff00eb$var$_l ? $455d545b1dff00eb$var$rn.tonemapping_pars_fragment : "",
        t.toneMapping !== $455d545b1dff00eb$var$_l ? $455d545b1dff00eb$var$wz("toneMapping", t.toneMapping) : "",
        t.dithering ? "#define DITHERING" : "",
        t.opaque ? "#define OPAQUE" : "",
        $455d545b1dff00eb$var$rn.colorspace_pars_fragment,
        $455d545b1dff00eb$var$Az("linearToOutputTexel", t.outputColorSpace),
        $455d545b1dff00eb$var$Cz(),
        t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
        `
`
    ].filter($455d545b1dff00eb$var$Pm).join(`
`)), l = $455d545b1dff00eb$var$ob(l), l = $455d545b1dff00eb$var$i3(l, t), l = $455d545b1dff00eb$var$a3(l, t), c = $455d545b1dff00eb$var$ob(c), c = $455d545b1dff00eb$var$i3(c, t), c = $455d545b1dff00eb$var$a3(c, t), l = $455d545b1dff00eb$var$r3(l), c = $455d545b1dff00eb$var$r3(c), t.isRawShaderMaterial !== !0 && (C = `#version 300 es
`, M = [
        _,
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join(`
`) + `
` + M, b = [
        "#define varying in",
        t.glslVersion === $455d545b1dff00eb$var$K_ ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        t.glslVersion === $455d545b1dff00eb$var$K_ ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join(`
`) + `
` + b);
    const R = C + M + l, N = C + b + c, z = $455d545b1dff00eb$var$e3(i, i.VERTEX_SHADER, R), L = $455d545b1dff00eb$var$e3(i, i.FRAGMENT_SHADER, N);
    i.attachShader(A, z), i.attachShader(A, L), t.index0AttributeName !== void 0 ? i.bindAttribLocation(A, 0, t.index0AttributeName) : t.morphTargets === !0 && i.bindAttribLocation(A, 0, "position"), i.linkProgram(A);
    function P(j) {
        if (a.debug.checkShaderErrors) {
            const G = i.getProgramInfoLog(A) || "", q = i.getShaderInfoLog(z) || "", Y = i.getShaderInfoLog(L) || "", ae = G.trim(), F = q.trim(), Q = Y.trim();
            let K = !0, $ = !0;
            if (i.getProgramParameter(A, i.LINK_STATUS) === !1) {
                if (K = !1, typeof a.debug.onShaderError == "function") a.debug.onShaderError(i, A, z, L);
                else {
                    const ee = $455d545b1dff00eb$var$n3(i, z, "vertex"), I = $455d545b1dff00eb$var$n3(i, L, "fragment");
                    $455d545b1dff00eb$var$Qt("THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(A, i.VALIDATE_STATUS) + `

Material Name: ` + j.name + `
Material Type: ` + j.type + `

Program Info Log: ` + ae + `
` + ee + `
` + I);
                }
            } else ae !== "" ? $455d545b1dff00eb$var$Mt("WebGLProgram: Program Info Log:", ae) : (F === "" || Q === "") && ($ = !1);
            $ && (j.diagnostics = {
                runnable: K,
                programLog: ae,
                vertexShader: {
                    log: F,
                    prefix: M
                },
                fragmentShader: {
                    log: Q,
                    prefix: b
                }
            });
        }
        i.deleteShader(z), i.deleteShader(L), H = new $455d545b1dff00eb$var$Yx(i, A), O = $455d545b1dff00eb$var$Uz(i, A);
    }
    let H;
    this.getUniforms = function() {
        return H === void 0 && P(this), H;
    };
    let O;
    this.getAttributes = function() {
        return O === void 0 && P(this), O;
    };
    let D = t.rendererExtensionParallelShaderCompile === !1;
    return this.isReady = function() {
        return D === !1 && (D = i.getProgramParameter(A, $455d545b1dff00eb$var$Sz)), D;
    }, this.destroy = function() {
        n.releaseStatesOfProgram(this), i.deleteProgram(A), this.program = void 0;
    }, this.type = t.shaderType, this.name = t.shaderName, this.id = $455d545b1dff00eb$var$Mz++, this.cacheKey = e, this.usedTimes = 1, this.program = A, this.vertexShader = z, this.fragmentShader = L, this;
}
let $455d545b1dff00eb$var$kz = 0;
class $455d545b1dff00eb$var$jz {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(e) {
        const t = e.vertexShader, n = e.fragmentShader, i = this._getShaderStage(t), r = this._getShaderStage(n), l = this._getShaderCacheForMaterial(e);
        return l.has(i) === !1 && (l.add(i), i.usedTimes++), l.has(r) === !1 && (l.add(r), r.usedTimes++), this;
    }
    remove(e) {
        const t = this.materialCache.get(e);
        for (const n of t)n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
        return this.materialCache.delete(e), this;
    }
    getVertexShaderID(e) {
        return this._getShaderStage(e.vertexShader).id;
    }
    getFragmentShaderID(e) {
        return this._getShaderStage(e.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(e) {
        const t = this.materialCache;
        let n = t.get(e);
        return n === void 0 && (n = new Set, t.set(e, n)), n;
    }
    _getShaderStage(e) {
        const t = this.shaderCache;
        let n = t.get(e);
        return n === void 0 && (n = new $455d545b1dff00eb$var$Xz(e), t.set(e, n)), n;
    }
}
class $455d545b1dff00eb$var$Xz {
    constructor(e){
        this.id = $455d545b1dff00eb$var$kz++, this.code = e, this.usedTimes = 0;
    }
}
function $455d545b1dff00eb$var$Wz(a, e, t, n, i, r, l) {
    const c = new $455d545b1dff00eb$var$Hd, f = new $455d545b1dff00eb$var$jz, p = new Set, m = [], x = i.logarithmicDepthBuffer, v = i.vertexTextures;
    let _ = i.precision;
    const S = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function A(O) {
        return p.add(O), O === 0 ? "uv" : `uv${O}`;
    }
    function M(O, D, j, G, q) {
        const Y = G.fog, ae = q.geometry, F = O.isMeshStandardMaterial ? G.environment : null, Q = (O.isMeshStandardMaterial ? t : e).get(O.envMap || F), K = Q && Q.mapping === $455d545b1dff00eb$var$Wd ? Q.image.height : null, $ = S[O.type];
        O.precision !== null && (_ = i.getMaxPrecision(O.precision), _ !== O.precision && $455d545b1dff00eb$var$Mt("WebGLProgram.getParameters:", O.precision, "not supported, using", _, "instead."));
        const ee = ae.morphAttributes.position || ae.morphAttributes.normal || ae.morphAttributes.color, I = ee !== void 0 ? ee.length : 0;
        let Z = 0;
        ae.morphAttributes.position !== void 0 && (Z = 1), ae.morphAttributes.normal !== void 0 && (Z = 2), ae.morphAttributes.color !== void 0 && (Z = 3);
        let oe, ce, de, ue;
        if ($) {
            const Ct = $455d545b1dff00eb$var$wo[$];
            oe = Ct.vertexShader, ce = Ct.fragmentShader;
        } else oe = O.vertexShader, ce = O.fragmentShader, f.update(O), de = f.getVertexShaderID(O), ue = f.getFragmentShaderID(O);
        const le = a.getRenderTarget(), xe = a.state.buffers.depth.getReversed(), Le = q.isInstancedMesh === !0, Ue = q.isBatchedMesh === !0, Ne = !!O.map, ke = !!O.matcap, nt = !!Q, Re = !!O.aoMap, te = !!O.lightMap, Oe = !!O.bumpMap, Ie = !!O.normalMap, Ae = !!O.displacementMap, ze = !!O.emissiveMap, Ze = !!O.metalnessMap, be = !!O.roughnessMap, rt = O.anisotropy > 0, ne = O.clearcoat > 0, W = O.dispersion > 0, pe = O.iridescence > 0, Be = O.sheen > 0, Te = O.transmission > 0, _e = rt && !!O.anisotropyMap, ot = ne && !!O.clearcoatMap, tt = ne && !!O.clearcoatNormalMap, gt = ne && !!O.clearcoatRoughnessMap, pt = pe && !!O.iridescenceMap, Ge = pe && !!O.iridescenceThicknessMap, Ye = Be && !!O.sheenColorMap, at = Be && !!O.sheenRoughnessMap, he = !!O.specularMap, Ee = !!O.specularColorMap, lt = !!O.specularIntensityMap, fe = Te && !!O.transmissionMap, We = Te && !!O.thicknessMap, Je = !!O.gradientMap, ut = !!O.alphaMap, Ke = O.alphaTest > 0, Ve = !!O.alphaHash, ft = !!O.extensions;
        let vt = $455d545b1dff00eb$var$_l;
        O.toneMapped && (le === null || le.isXRRenderTarget === !0) && (vt = a.toneMapping);
        const yt = {
            shaderID: $,
            shaderType: O.type,
            shaderName: O.name,
            vertexShader: oe,
            fragmentShader: ce,
            defines: O.defines,
            customVertexShaderID: de,
            customFragmentShaderID: ue,
            isRawShaderMaterial: O.isRawShaderMaterial === !0,
            glslVersion: O.glslVersion,
            precision: _,
            batching: Ue,
            batchingColor: Ue && q._colorsTexture !== null,
            instancing: Le,
            instancingColor: Le && q.instanceColor !== null,
            instancingMorph: Le && q.morphTexture !== null,
            supportsVertexTextures: v,
            outputColorSpace: le === null ? a.outputColorSpace : le.isXRRenderTarget === !0 ? le.texture.colorSpace : $455d545b1dff00eb$var$No,
            alphaToCoverage: !!O.alphaToCoverage,
            map: Ne,
            matcap: ke,
            envMap: nt,
            envMapMode: nt && Q.mapping,
            envMapCubeUVHeight: K,
            aoMap: Re,
            lightMap: te,
            bumpMap: Oe,
            normalMap: Ie,
            displacementMap: v && Ae,
            emissiveMap: ze,
            normalMapObjectSpace: Ie && O.normalMapType === $455d545b1dff00eb$var$uT,
            normalMapTangentSpace: Ie && O.normalMapType === $455d545b1dff00eb$var$Cu,
            metalnessMap: Ze,
            roughnessMap: be,
            anisotropy: rt,
            anisotropyMap: _e,
            clearcoat: ne,
            clearcoatMap: ot,
            clearcoatNormalMap: tt,
            clearcoatRoughnessMap: gt,
            dispersion: W,
            iridescence: pe,
            iridescenceMap: pt,
            iridescenceThicknessMap: Ge,
            sheen: Be,
            sheenColorMap: Ye,
            sheenRoughnessMap: at,
            specularMap: he,
            specularColorMap: Ee,
            specularIntensityMap: lt,
            transmission: Te,
            transmissionMap: fe,
            thicknessMap: We,
            gradientMap: Je,
            opaque: O.transparent === !1 && O.blending === $455d545b1dff00eb$var$Ff && O.alphaToCoverage === !1,
            alphaMap: ut,
            alphaTest: Ke,
            alphaHash: Ve,
            combine: O.combine,
            mapUv: Ne && A(O.map.channel),
            aoMapUv: Re && A(O.aoMap.channel),
            lightMapUv: te && A(O.lightMap.channel),
            bumpMapUv: Oe && A(O.bumpMap.channel),
            normalMapUv: Ie && A(O.normalMap.channel),
            displacementMapUv: Ae && A(O.displacementMap.channel),
            emissiveMapUv: ze && A(O.emissiveMap.channel),
            metalnessMapUv: Ze && A(O.metalnessMap.channel),
            roughnessMapUv: be && A(O.roughnessMap.channel),
            anisotropyMapUv: _e && A(O.anisotropyMap.channel),
            clearcoatMapUv: ot && A(O.clearcoatMap.channel),
            clearcoatNormalMapUv: tt && A(O.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: gt && A(O.clearcoatRoughnessMap.channel),
            iridescenceMapUv: pt && A(O.iridescenceMap.channel),
            iridescenceThicknessMapUv: Ge && A(O.iridescenceThicknessMap.channel),
            sheenColorMapUv: Ye && A(O.sheenColorMap.channel),
            sheenRoughnessMapUv: at && A(O.sheenRoughnessMap.channel),
            specularMapUv: he && A(O.specularMap.channel),
            specularColorMapUv: Ee && A(O.specularColorMap.channel),
            specularIntensityMapUv: lt && A(O.specularIntensityMap.channel),
            transmissionMapUv: fe && A(O.transmissionMap.channel),
            thicknessMapUv: We && A(O.thicknessMap.channel),
            alphaMapUv: ut && A(O.alphaMap.channel),
            vertexTangents: !!ae.attributes.tangent && (Ie || rt),
            vertexColors: O.vertexColors,
            vertexAlphas: O.vertexColors === !0 && !!ae.attributes.color && ae.attributes.color.itemSize === 4,
            pointsUvs: q.isPoints === !0 && !!ae.attributes.uv && (Ne || ut),
            fog: !!Y,
            useFog: O.fog === !0,
            fogExp2: !!Y && Y.isFogExp2,
            flatShading: O.flatShading === !0 && O.wireframe === !1,
            sizeAttenuation: O.sizeAttenuation === !0,
            logarithmicDepthBuffer: x,
            reversedDepthBuffer: xe,
            skinning: q.isSkinnedMesh === !0,
            morphTargets: ae.morphAttributes.position !== void 0,
            morphNormals: ae.morphAttributes.normal !== void 0,
            morphColors: ae.morphAttributes.color !== void 0,
            morphTargetsCount: I,
            morphTextureStride: Z,
            numDirLights: D.directional.length,
            numPointLights: D.point.length,
            numSpotLights: D.spot.length,
            numSpotLightMaps: D.spotLightMap.length,
            numRectAreaLights: D.rectArea.length,
            numHemiLights: D.hemi.length,
            numDirLightShadows: D.directionalShadowMap.length,
            numPointLightShadows: D.pointShadowMap.length,
            numSpotLightShadows: D.spotShadowMap.length,
            numSpotLightShadowsWithMaps: D.numSpotLightShadowsWithMaps,
            numLightProbes: D.numLightProbes,
            numClippingPlanes: l.numPlanes,
            numClipIntersection: l.numIntersection,
            dithering: O.dithering,
            shadowMapEnabled: a.shadowMap.enabled && j.length > 0,
            shadowMapType: a.shadowMap.type,
            toneMapping: vt,
            decodeVideoTexture: Ne && O.map.isVideoTexture === !0 && $455d545b1dff00eb$var$Dn.getTransfer(O.map.colorSpace) === $455d545b1dff00eb$var$Zn,
            decodeVideoTextureEmissive: ze && O.emissiveMap.isVideoTexture === !0 && $455d545b1dff00eb$var$Dn.getTransfer(O.emissiveMap.colorSpace) === $455d545b1dff00eb$var$Zn,
            premultipliedAlpha: O.premultipliedAlpha,
            doubleSided: O.side === $455d545b1dff00eb$var$Ea,
            flipSided: O.side === $455d545b1dff00eb$var$Dr,
            useDepthPacking: O.depthPacking >= 0,
            depthPacking: O.depthPacking || 0,
            index0AttributeName: O.index0AttributeName,
            extensionClipCullDistance: ft && O.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
            extensionMultiDraw: (ft && O.extensions.multiDraw === !0 || Ue) && n.has("WEBGL_multi_draw"),
            rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
            customProgramCacheKey: O.customProgramCacheKey()
        };
        return yt.vertexUv1s = p.has(1), yt.vertexUv2s = p.has(2), yt.vertexUv3s = p.has(3), p.clear(), yt;
    }
    function b(O) {
        const D = [];
        if (O.shaderID ? D.push(O.shaderID) : (D.push(O.customVertexShaderID), D.push(O.customFragmentShaderID)), O.defines !== void 0) for(const j in O.defines)D.push(j), D.push(O.defines[j]);
        return O.isRawShaderMaterial === !1 && (C(D, O), R(D, O), D.push(a.outputColorSpace)), D.push(O.customProgramCacheKey), D.join();
    }
    function C(O, D) {
        O.push(D.precision), O.push(D.outputColorSpace), O.push(D.envMapMode), O.push(D.envMapCubeUVHeight), O.push(D.mapUv), O.push(D.alphaMapUv), O.push(D.lightMapUv), O.push(D.aoMapUv), O.push(D.bumpMapUv), O.push(D.normalMapUv), O.push(D.displacementMapUv), O.push(D.emissiveMapUv), O.push(D.metalnessMapUv), O.push(D.roughnessMapUv), O.push(D.anisotropyMapUv), O.push(D.clearcoatMapUv), O.push(D.clearcoatNormalMapUv), O.push(D.clearcoatRoughnessMapUv), O.push(D.iridescenceMapUv), O.push(D.iridescenceThicknessMapUv), O.push(D.sheenColorMapUv), O.push(D.sheenRoughnessMapUv), O.push(D.specularMapUv), O.push(D.specularColorMapUv), O.push(D.specularIntensityMapUv), O.push(D.transmissionMapUv), O.push(D.thicknessMapUv), O.push(D.combine), O.push(D.fogExp2), O.push(D.sizeAttenuation), O.push(D.morphTargetsCount), O.push(D.morphAttributeCount), O.push(D.numDirLights), O.push(D.numPointLights), O.push(D.numSpotLights), O.push(D.numSpotLightMaps), O.push(D.numHemiLights), O.push(D.numRectAreaLights), O.push(D.numDirLightShadows), O.push(D.numPointLightShadows), O.push(D.numSpotLightShadows), O.push(D.numSpotLightShadowsWithMaps), O.push(D.numLightProbes), O.push(D.shadowMapType), O.push(D.toneMapping), O.push(D.numClippingPlanes), O.push(D.numClipIntersection), O.push(D.depthPacking);
    }
    function R(O, D) {
        c.disableAll(), D.supportsVertexTextures && c.enable(0), D.instancing && c.enable(1), D.instancingColor && c.enable(2), D.instancingMorph && c.enable(3), D.matcap && c.enable(4), D.envMap && c.enable(5), D.normalMapObjectSpace && c.enable(6), D.normalMapTangentSpace && c.enable(7), D.clearcoat && c.enable(8), D.iridescence && c.enable(9), D.alphaTest && c.enable(10), D.vertexColors && c.enable(11), D.vertexAlphas && c.enable(12), D.vertexUv1s && c.enable(13), D.vertexUv2s && c.enable(14), D.vertexUv3s && c.enable(15), D.vertexTangents && c.enable(16), D.anisotropy && c.enable(17), D.alphaHash && c.enable(18), D.batching && c.enable(19), D.dispersion && c.enable(20), D.batchingColor && c.enable(21), D.gradientMap && c.enable(22), O.push(c.mask), c.disableAll(), D.fog && c.enable(0), D.useFog && c.enable(1), D.flatShading && c.enable(2), D.logarithmicDepthBuffer && c.enable(3), D.reversedDepthBuffer && c.enable(4), D.skinning && c.enable(5), D.morphTargets && c.enable(6), D.morphNormals && c.enable(7), D.morphColors && c.enable(8), D.premultipliedAlpha && c.enable(9), D.shadowMapEnabled && c.enable(10), D.doubleSided && c.enable(11), D.flipSided && c.enable(12), D.useDepthPacking && c.enable(13), D.dithering && c.enable(14), D.transmission && c.enable(15), D.sheen && c.enable(16), D.opaque && c.enable(17), D.pointsUvs && c.enable(18), D.decodeVideoTexture && c.enable(19), D.decodeVideoTextureEmissive && c.enable(20), D.alphaToCoverage && c.enable(21), O.push(c.mask);
    }
    function N(O) {
        const D = S[O.type];
        let j;
        if (D) {
            const G = $455d545b1dff00eb$var$wo[D];
            j = $455d545b1dff00eb$var$jb.clone(G.uniforms);
        } else j = O.uniforms;
        return j;
    }
    function z(O, D) {
        let j;
        for(let G = 0, q = m.length; G < q; G++){
            const Y = m[G];
            if (Y.cacheKey === D) {
                j = Y, ++j.usedTimes;
                break;
            }
        }
        return j === void 0 && (j = new $455d545b1dff00eb$var$Gz(a, D, O, r), m.push(j)), j;
    }
    function L(O) {
        if (--O.usedTimes === 0) {
            const D = m.indexOf(O);
            m[D] = m[m.length - 1], m.pop(), O.destroy();
        }
    }
    function P(O) {
        f.remove(O);
    }
    function H() {
        f.dispose();
    }
    return {
        getParameters: M,
        getProgramCacheKey: b,
        getUniforms: N,
        acquireProgram: z,
        releaseProgram: L,
        releaseShaderCache: P,
        programs: m,
        dispose: H
    };
}
function $455d545b1dff00eb$var$qz() {
    let a = new WeakMap;
    function e(l) {
        return a.has(l);
    }
    function t(l) {
        let c = a.get(l);
        return c === void 0 && (c = {}, a.set(l, c)), c;
    }
    function n(l) {
        a.delete(l);
    }
    function i(l, c, f) {
        a.get(l)[c] = f;
    }
    function r() {
        a = new WeakMap;
    }
    return {
        has: e,
        get: t,
        remove: n,
        update: i,
        dispose: r
    };
}
function $455d545b1dff00eb$var$Yz(a, e) {
    return a.groupOrder !== e.groupOrder ? a.groupOrder - e.groupOrder : a.renderOrder !== e.renderOrder ? a.renderOrder - e.renderOrder : a.material.id !== e.material.id ? a.material.id - e.material.id : a.z !== e.z ? a.z - e.z : a.id - e.id;
}
function $455d545b1dff00eb$var$o3(a, e) {
    return a.groupOrder !== e.groupOrder ? a.groupOrder - e.groupOrder : a.renderOrder !== e.renderOrder ? a.renderOrder - e.renderOrder : a.z !== e.z ? e.z - a.z : a.id - e.id;
}
function $455d545b1dff00eb$var$l3() {
    const a = [];
    let e = 0;
    const t = [], n = [], i = [];
    function r() {
        e = 0, t.length = 0, n.length = 0, i.length = 0;
    }
    function l(x, v, _, S, A, M) {
        let b = a[e];
        return b === void 0 ? (b = {
            id: x.id,
            object: x,
            geometry: v,
            material: _,
            groupOrder: S,
            renderOrder: x.renderOrder,
            z: A,
            group: M
        }, a[e] = b) : (b.id = x.id, b.object = x, b.geometry = v, b.material = _, b.groupOrder = S, b.renderOrder = x.renderOrder, b.z = A, b.group = M), e++, b;
    }
    function c(x, v, _, S, A, M) {
        const b = l(x, v, _, S, A, M);
        _.transmission > 0 ? n.push(b) : _.transparent === !0 ? i.push(b) : t.push(b);
    }
    function f(x, v, _, S, A, M) {
        const b = l(x, v, _, S, A, M);
        _.transmission > 0 ? n.unshift(b) : _.transparent === !0 ? i.unshift(b) : t.unshift(b);
    }
    function p(x, v) {
        t.length > 1 && t.sort(x || $455d545b1dff00eb$var$Yz), n.length > 1 && n.sort(v || $455d545b1dff00eb$var$o3), i.length > 1 && i.sort(v || $455d545b1dff00eb$var$o3);
    }
    function m() {
        for(let x = e, v = a.length; x < v; x++){
            const _ = a[x];
            if (_.id === null) break;
            _.id = null, _.object = null, _.geometry = null, _.material = null, _.group = null;
        }
    }
    return {
        opaque: t,
        transmissive: n,
        transparent: i,
        init: r,
        push: c,
        unshift: f,
        finish: m,
        sort: p
    };
}
function $455d545b1dff00eb$var$Zz() {
    let a = new WeakMap;
    function e(n, i) {
        const r = a.get(n);
        let l;
        return r === void 0 ? (l = new $455d545b1dff00eb$var$l3, a.set(n, [
            l
        ])) : i >= r.length ? (l = new $455d545b1dff00eb$var$l3, r.push(l)) : l = r[i], l;
    }
    function t() {
        a = new WeakMap;
    }
    return {
        get: e,
        dispose: t
    };
}
function $455d545b1dff00eb$var$Qz() {
    const a = {};
    return {
        get: function(e) {
            if (a[e.id] !== void 0) return a[e.id];
            let t;
            switch(e.type){
                case "DirectionalLight":
                    t = {
                        direction: new $455d545b1dff00eb$var$J,
                        color: new $455d545b1dff00eb$var$_t
                    };
                    break;
                case "SpotLight":
                    t = {
                        position: new $455d545b1dff00eb$var$J,
                        direction: new $455d545b1dff00eb$var$J,
                        color: new $455d545b1dff00eb$var$_t,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    t = {
                        position: new $455d545b1dff00eb$var$J,
                        color: new $455d545b1dff00eb$var$_t,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    t = {
                        direction: new $455d545b1dff00eb$var$J,
                        skyColor: new $455d545b1dff00eb$var$_t,
                        groundColor: new $455d545b1dff00eb$var$_t
                    };
                    break;
                case "RectAreaLight":
                    t = {
                        color: new $455d545b1dff00eb$var$_t,
                        position: new $455d545b1dff00eb$var$J,
                        halfWidth: new $455d545b1dff00eb$var$J,
                        halfHeight: new $455d545b1dff00eb$var$J
                    };
                    break;
            }
            return a[e.id] = t, t;
        }
    };
}
function $455d545b1dff00eb$var$Kz() {
    const a = {};
    return {
        get: function(e) {
            if (a[e.id] !== void 0) return a[e.id];
            let t;
            switch(e.type){
                case "DirectionalLight":
                    t = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $455d545b1dff00eb$var$$e
                    };
                    break;
                case "SpotLight":
                    t = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $455d545b1dff00eb$var$$e
                    };
                    break;
                case "PointLight":
                    t = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $455d545b1dff00eb$var$$e,
                        shadowCameraNear: 1,
                        shadowCameraFar: 1e3
                    };
                    break;
            }
            return a[e.id] = t, t;
        }
    };
}
let $455d545b1dff00eb$var$Jz = 0;
function $455d545b1dff00eb$var$$z(a, e) {
    return (e.castShadow ? 2 : 0) - (a.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (a.map ? 1 : 0);
}
function $455d545b1dff00eb$var$eP(a) {
    const e = new $455d545b1dff00eb$var$Qz, t = $455d545b1dff00eb$var$Kz(), n = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let p = 0; p < 9; p++)n.probe.push(new $455d545b1dff00eb$var$J);
    const i = new $455d545b1dff00eb$var$J, r = new $455d545b1dff00eb$var$Ft, l = new $455d545b1dff00eb$var$Ft;
    function c(p) {
        let m = 0, x = 0, v = 0;
        for(let O = 0; O < 9; O++)n.probe[O].set(0, 0, 0);
        let _ = 0, S = 0, A = 0, M = 0, b = 0, C = 0, R = 0, N = 0, z = 0, L = 0, P = 0;
        p.sort($455d545b1dff00eb$var$$z);
        for(let O = 0, D = p.length; O < D; O++){
            const j = p[O], G = j.color, q = j.intensity, Y = j.distance, ae = j.shadow && j.shadow.map ? j.shadow.map.texture : null;
            if (j.isAmbientLight) m += G.r * q, x += G.g * q, v += G.b * q;
            else if (j.isLightProbe) {
                for(let F = 0; F < 9; F++)n.probe[F].addScaledVector(j.sh.coefficients[F], q);
                P++;
            } else if (j.isDirectionalLight) {
                const F = e.get(j);
                if (F.color.copy(j.color).multiplyScalar(j.intensity), j.castShadow) {
                    const Q = j.shadow, K = t.get(j);
                    K.shadowIntensity = Q.intensity, K.shadowBias = Q.bias, K.shadowNormalBias = Q.normalBias, K.shadowRadius = Q.radius, K.shadowMapSize = Q.mapSize, n.directionalShadow[_] = K, n.directionalShadowMap[_] = ae, n.directionalShadowMatrix[_] = j.shadow.matrix, C++;
                }
                n.directional[_] = F, _++;
            } else if (j.isSpotLight) {
                const F = e.get(j);
                F.position.setFromMatrixPosition(j.matrixWorld), F.color.copy(G).multiplyScalar(q), F.distance = Y, F.coneCos = Math.cos(j.angle), F.penumbraCos = Math.cos(j.angle * (1 - j.penumbra)), F.decay = j.decay, n.spot[A] = F;
                const Q = j.shadow;
                if (j.map && (n.spotLightMap[z] = j.map, z++, Q.updateMatrices(j), j.castShadow && L++), n.spotLightMatrix[A] = Q.matrix, j.castShadow) {
                    const K = t.get(j);
                    K.shadowIntensity = Q.intensity, K.shadowBias = Q.bias, K.shadowNormalBias = Q.normalBias, K.shadowRadius = Q.radius, K.shadowMapSize = Q.mapSize, n.spotShadow[A] = K, n.spotShadowMap[A] = ae, N++;
                }
                A++;
            } else if (j.isRectAreaLight) {
                const F = e.get(j);
                F.color.copy(G).multiplyScalar(q), F.halfWidth.set(j.width * .5, 0, 0), F.halfHeight.set(0, j.height * .5, 0), n.rectArea[M] = F, M++;
            } else if (j.isPointLight) {
                const F = e.get(j);
                if (F.color.copy(j.color).multiplyScalar(j.intensity), F.distance = j.distance, F.decay = j.decay, j.castShadow) {
                    const Q = j.shadow, K = t.get(j);
                    K.shadowIntensity = Q.intensity, K.shadowBias = Q.bias, K.shadowNormalBias = Q.normalBias, K.shadowRadius = Q.radius, K.shadowMapSize = Q.mapSize, K.shadowCameraNear = Q.camera.near, K.shadowCameraFar = Q.camera.far, n.pointShadow[S] = K, n.pointShadowMap[S] = ae, n.pointShadowMatrix[S] = j.shadow.matrix, R++;
                }
                n.point[S] = F, S++;
            } else if (j.isHemisphereLight) {
                const F = e.get(j);
                F.skyColor.copy(j.color).multiplyScalar(q), F.groundColor.copy(j.groundColor).multiplyScalar(q), n.hemi[b] = F, b++;
            }
        }
        M > 0 && (a.has("OES_texture_float_linear") === !0 ? (n.rectAreaLTC1 = $455d545b1dff00eb$var$St.LTC_FLOAT_1, n.rectAreaLTC2 = $455d545b1dff00eb$var$St.LTC_FLOAT_2) : (n.rectAreaLTC1 = $455d545b1dff00eb$var$St.LTC_HALF_1, n.rectAreaLTC2 = $455d545b1dff00eb$var$St.LTC_HALF_2)), n.ambient[0] = m, n.ambient[1] = x, n.ambient[2] = v;
        const H = n.hash;
        (H.directionalLength !== _ || H.pointLength !== S || H.spotLength !== A || H.rectAreaLength !== M || H.hemiLength !== b || H.numDirectionalShadows !== C || H.numPointShadows !== R || H.numSpotShadows !== N || H.numSpotMaps !== z || H.numLightProbes !== P) && (n.directional.length = _, n.spot.length = A, n.rectArea.length = M, n.point.length = S, n.hemi.length = b, n.directionalShadow.length = C, n.directionalShadowMap.length = C, n.pointShadow.length = R, n.pointShadowMap.length = R, n.spotShadow.length = N, n.spotShadowMap.length = N, n.directionalShadowMatrix.length = C, n.pointShadowMatrix.length = R, n.spotLightMatrix.length = N + z - L, n.spotLightMap.length = z, n.numSpotLightShadowsWithMaps = L, n.numLightProbes = P, H.directionalLength = _, H.pointLength = S, H.spotLength = A, H.rectAreaLength = M, H.hemiLength = b, H.numDirectionalShadows = C, H.numPointShadows = R, H.numSpotShadows = N, H.numSpotMaps = z, H.numLightProbes = P, n.version = $455d545b1dff00eb$var$Jz++);
    }
    function f(p, m) {
        let x = 0, v = 0, _ = 0, S = 0, A = 0;
        const M = m.matrixWorldInverse;
        for(let b = 0, C = p.length; b < C; b++){
            const R = p[b];
            if (R.isDirectionalLight) {
                const N = n.directional[x];
                N.direction.setFromMatrixPosition(R.matrixWorld), i.setFromMatrixPosition(R.target.matrixWorld), N.direction.sub(i), N.direction.transformDirection(M), x++;
            } else if (R.isSpotLight) {
                const N = n.spot[_];
                N.position.setFromMatrixPosition(R.matrixWorld), N.position.applyMatrix4(M), N.direction.setFromMatrixPosition(R.matrixWorld), i.setFromMatrixPosition(R.target.matrixWorld), N.direction.sub(i), N.direction.transformDirection(M), _++;
            } else if (R.isRectAreaLight) {
                const N = n.rectArea[S];
                N.position.setFromMatrixPosition(R.matrixWorld), N.position.applyMatrix4(M), l.identity(), r.copy(R.matrixWorld), r.premultiply(M), l.extractRotation(r), N.halfWidth.set(R.width * .5, 0, 0), N.halfHeight.set(0, R.height * .5, 0), N.halfWidth.applyMatrix4(l), N.halfHeight.applyMatrix4(l), S++;
            } else if (R.isPointLight) {
                const N = n.point[v];
                N.position.setFromMatrixPosition(R.matrixWorld), N.position.applyMatrix4(M), v++;
            } else if (R.isHemisphereLight) {
                const N = n.hemi[A];
                N.direction.setFromMatrixPosition(R.matrixWorld), N.direction.transformDirection(M), A++;
            }
        }
    }
    return {
        setup: c,
        setupView: f,
        state: n
    };
}
function $455d545b1dff00eb$var$c3(a) {
    const e = new $455d545b1dff00eb$var$eP(a), t = [], n = [];
    function i(m) {
        p.camera = m, t.length = 0, n.length = 0;
    }
    function r(m) {
        t.push(m);
    }
    function l(m) {
        n.push(m);
    }
    function c() {
        e.setup(t);
    }
    function f(m) {
        e.setupView(t, m);
    }
    const p = {
        lightsArray: t,
        shadowsArray: n,
        camera: null,
        lights: e,
        transmissionRenderTarget: {}
    };
    return {
        init: i,
        state: p,
        setupLights: c,
        setupLightsView: f,
        pushLight: r,
        pushShadow: l
    };
}
function $455d545b1dff00eb$var$tP(a) {
    let e = new WeakMap;
    function t(i, r = 0) {
        const l = e.get(i);
        let c;
        return l === void 0 ? (c = new $455d545b1dff00eb$var$c3(a), e.set(i, [
            c
        ])) : r >= l.length ? (c = new $455d545b1dff00eb$var$c3(a), l.push(c)) : c = l[r], c;
    }
    function n() {
        e = new WeakMap;
    }
    return {
        get: t,
        dispose: n
    };
}
const $455d545b1dff00eb$var$nP = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, $455d545b1dff00eb$var$iP = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function $455d545b1dff00eb$var$aP(a, e, t) {
    let n = new $455d545b1dff00eb$var$qd;
    const i = new $455d545b1dff00eb$var$$e, r = new $455d545b1dff00eb$var$$e, l = new $455d545b1dff00eb$var$Un, c = new $455d545b1dff00eb$var$Ly({
        depthPacking: $455d545b1dff00eb$var$Ib
    }), f = new $455d545b1dff00eb$var$zy, p = {}, m = t.maxTextureSize, x = {
        [$455d545b1dff00eb$var$bc]: $455d545b1dff00eb$var$Dr,
        [$455d545b1dff00eb$var$Dr]: $455d545b1dff00eb$var$bc,
        [$455d545b1dff00eb$var$Ea]: $455d545b1dff00eb$var$Ea
    }, v = new $455d545b1dff00eb$var$qs({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $455d545b1dff00eb$var$$e
            },
            radius: {
                value: 4
            }
        },
        vertexShader: $455d545b1dff00eb$var$nP,
        fragmentShader: $455d545b1dff00eb$var$iP
    }), _ = v.clone();
    _.defines.HORIZONTAL_PASS = 1;
    const S = new $455d545b1dff00eb$var$nn;
    S.setAttribute("position", new $455d545b1dff00eb$var$ti(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    const A = new $455d545b1dff00eb$var$zi(S, v), M = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = $455d545b1dff00eb$var$ey;
    let b = this.type;
    this.render = function(L, P, H) {
        if (M.enabled === !1 || M.autoUpdate === !1 && M.needsUpdate === !1 || L.length === 0) return;
        const O = a.getRenderTarget(), D = a.getActiveCubeFace(), j = a.getActiveMipmapLevel(), G = a.state;
        G.setBlending($455d545b1dff00eb$var$yl), G.buffers.depth.getReversed() === !0 ? G.buffers.color.setClear(0, 0, 0, 0) : G.buffers.color.setClear(1, 1, 1, 1), G.buffers.depth.setTest(!0), G.setScissorTest(!1);
        const q = b !== $455d545b1dff00eb$var$Ao && this.type === $455d545b1dff00eb$var$Ao, Y = b === $455d545b1dff00eb$var$Ao && this.type !== $455d545b1dff00eb$var$Ao;
        for(let ae = 0, F = L.length; ae < F; ae++){
            const Q = L[ae], K = Q.shadow;
            if (K === void 0) {
                $455d545b1dff00eb$var$Mt("WebGLShadowMap:", Q, "has no shadow.");
                continue;
            }
            if (K.autoUpdate === !1 && K.needsUpdate === !1) continue;
            i.copy(K.mapSize);
            const $ = K.getFrameExtents();
            if (i.multiply($), r.copy(K.mapSize), (i.x > m || i.y > m) && (i.x > m && (r.x = Math.floor(m / $.x), i.x = r.x * $.x, K.mapSize.x = r.x), i.y > m && (r.y = Math.floor(m / $.y), i.y = r.y * $.y, K.mapSize.y = r.y)), K.map === null || q === !0 || Y === !0) {
                const I = this.type !== $455d545b1dff00eb$var$Ao ? {
                    minFilter: $455d545b1dff00eb$var$Fa,
                    magFilter: $455d545b1dff00eb$var$Fa
                } : {};
                K.map !== null && K.map.dispose(), K.map = new $455d545b1dff00eb$var$Oo(i.x, i.y, I), K.map.texture.name = Q.name + ".shadowMap", K.camera.updateProjectionMatrix();
            }
            a.setRenderTarget(K.map), a.clear();
            const ee = K.getViewportCount();
            for(let I = 0; I < ee; I++){
                const Z = K.getViewport(I);
                l.set(r.x * Z.x, r.y * Z.y, r.x * Z.z, r.y * Z.w), G.viewport(l), K.updateMatrices(Q, I), n = K.getFrustum(), N(P, H, K.camera, Q, this.type);
            }
            K.isPointLightShadow !== !0 && this.type === $455d545b1dff00eb$var$Ao && C(K, H), K.needsUpdate = !1;
        }
        b = this.type, M.needsUpdate = !1, a.setRenderTarget(O, D, j);
    };
    function C(L, P) {
        const H = e.update(A);
        v.defines.VSM_SAMPLES !== L.blurSamples && (v.defines.VSM_SAMPLES = L.blurSamples, _.defines.VSM_SAMPLES = L.blurSamples, v.needsUpdate = !0, _.needsUpdate = !0), L.mapPass === null && (L.mapPass = new $455d545b1dff00eb$var$Oo(i.x, i.y)), v.uniforms.shadow_pass.value = L.map.texture, v.uniforms.resolution.value = L.mapSize, v.uniforms.radius.value = L.radius, a.setRenderTarget(L.mapPass), a.clear(), a.renderBufferDirect(P, null, H, v, A, null), _.uniforms.shadow_pass.value = L.mapPass.texture, _.uniforms.resolution.value = L.mapSize, _.uniforms.radius.value = L.radius, a.setRenderTarget(L.map), a.clear(), a.renderBufferDirect(P, null, H, _, A, null);
    }
    function R(L, P, H, O) {
        let D = null;
        const j = H.isPointLight === !0 ? L.customDistanceMaterial : L.customDepthMaterial;
        if (j !== void 0) D = j;
        else if (D = H.isPointLight === !0 ? f : c, a.localClippingEnabled && P.clipShadows === !0 && Array.isArray(P.clippingPlanes) && P.clippingPlanes.length !== 0 || P.displacementMap && P.displacementScale !== 0 || P.alphaMap && P.alphaTest > 0 || P.map && P.alphaTest > 0 || P.alphaToCoverage === !0) {
            const G = D.uuid, q = P.uuid;
            let Y = p[G];
            Y === void 0 && (Y = {}, p[G] = Y);
            let ae = Y[q];
            ae === void 0 && (ae = D.clone(), Y[q] = ae, P.addEventListener("dispose", z)), D = ae;
        }
        if (D.visible = P.visible, D.wireframe = P.wireframe, O === $455d545b1dff00eb$var$Ao ? D.side = P.shadowSide !== null ? P.shadowSide : P.side : D.side = P.shadowSide !== null ? P.shadowSide : x[P.side], D.alphaMap = P.alphaMap, D.alphaTest = P.alphaToCoverage === !0 ? .5 : P.alphaTest, D.map = P.map, D.clipShadows = P.clipShadows, D.clippingPlanes = P.clippingPlanes, D.clipIntersection = P.clipIntersection, D.displacementMap = P.displacementMap, D.displacementScale = P.displacementScale, D.displacementBias = P.displacementBias, D.wireframeLinewidth = P.wireframeLinewidth, D.linewidth = P.linewidth, H.isPointLight === !0 && D.isMeshDistanceMaterial === !0) {
            const G = a.properties.get(D);
            G.light = H;
        }
        return D;
    }
    function N(L, P, H, O, D) {
        if (L.visible === !1) return;
        if (L.layers.test(P.layers) && (L.isMesh || L.isLine || L.isPoints) && (L.castShadow || L.receiveShadow && D === $455d545b1dff00eb$var$Ao) && (!L.frustumCulled || n.intersectsObject(L))) {
            L.modelViewMatrix.multiplyMatrices(H.matrixWorldInverse, L.matrixWorld);
            const q = e.update(L), Y = L.material;
            if (Array.isArray(Y)) {
                const ae = q.groups;
                for(let F = 0, Q = ae.length; F < Q; F++){
                    const K = ae[F], $ = Y[K.materialIndex];
                    if ($ && $.visible) {
                        const ee = R(L, $, O, D);
                        L.onBeforeShadow(a, L, P, H, q, ee, K), a.renderBufferDirect(H, null, q, ee, L, K), L.onAfterShadow(a, L, P, H, q, ee, K);
                    }
                }
            } else if (Y.visible) {
                const ae = R(L, Y, O, D);
                L.onBeforeShadow(a, L, P, H, q, ae, null), a.renderBufferDirect(H, null, q, ae, L, null), L.onAfterShadow(a, L, P, H, q, ae, null);
            }
        }
        const G = L.children;
        for(let q = 0, Y = G.length; q < Y; q++)N(G[q], P, H, O, D);
    }
    function z(L) {
        L.target.removeEventListener("dispose", z);
        for(const H in p){
            const O = p[H], D = L.target.uuid;
            D in O && (O[D].dispose(), delete O[D]);
        }
    }
}
const $455d545b1dff00eb$var$rP = {
    [$455d545b1dff00eb$var$iv]: $455d545b1dff00eb$var$av,
    [$455d545b1dff00eb$var$rv]: $455d545b1dff00eb$var$lv,
    [$455d545b1dff00eb$var$sv]: $455d545b1dff00eb$var$cv,
    [$455d545b1dff00eb$var$jf]: $455d545b1dff00eb$var$ov,
    [$455d545b1dff00eb$var$av]: $455d545b1dff00eb$var$iv,
    [$455d545b1dff00eb$var$lv]: $455d545b1dff00eb$var$rv,
    [$455d545b1dff00eb$var$cv]: $455d545b1dff00eb$var$sv,
    [$455d545b1dff00eb$var$ov]: $455d545b1dff00eb$var$jf
};
function $455d545b1dff00eb$var$sP(a, e) {
    function t() {
        let fe = !1;
        const We = new $455d545b1dff00eb$var$Un;
        let Je = null;
        const ut = new $455d545b1dff00eb$var$Un(0, 0, 0, 0);
        return {
            setMask: function(Ke) {
                Je !== Ke && !fe && (a.colorMask(Ke, Ke, Ke, Ke), Je = Ke);
            },
            setLocked: function(Ke) {
                fe = Ke;
            },
            setClear: function(Ke, Ve, ft, vt, yt) {
                yt === !0 && (Ke *= vt, Ve *= vt, ft *= vt), We.set(Ke, Ve, ft, vt), ut.equals(We) === !1 && (a.clearColor(Ke, Ve, ft, vt), ut.copy(We));
            },
            reset: function() {
                fe = !1, Je = null, ut.set(-1, 0, 0, 0);
            }
        };
    }
    function n() {
        let fe = !1, We = !1, Je = null, ut = null, Ke = null;
        return {
            setReversed: function(Ve) {
                if (We !== Ve) {
                    const ft = e.get("EXT_clip_control");
                    Ve ? ft.clipControlEXT(ft.LOWER_LEFT_EXT, ft.ZERO_TO_ONE_EXT) : ft.clipControlEXT(ft.LOWER_LEFT_EXT, ft.NEGATIVE_ONE_TO_ONE_EXT), We = Ve;
                    const vt = Ke;
                    Ke = null, this.setClear(vt);
                }
            },
            getReversed: function() {
                return We;
            },
            setTest: function(Ve) {
                Ve ? le(a.DEPTH_TEST) : xe(a.DEPTH_TEST);
            },
            setMask: function(Ve) {
                Je !== Ve && !fe && (a.depthMask(Ve), Je = Ve);
            },
            setFunc: function(Ve) {
                if (We && (Ve = $455d545b1dff00eb$var$rP[Ve]), ut !== Ve) {
                    switch(Ve){
                        case $455d545b1dff00eb$var$iv:
                            a.depthFunc(a.NEVER);
                            break;
                        case $455d545b1dff00eb$var$av:
                            a.depthFunc(a.ALWAYS);
                            break;
                        case $455d545b1dff00eb$var$rv:
                            a.depthFunc(a.LESS);
                            break;
                        case $455d545b1dff00eb$var$jf:
                            a.depthFunc(a.LEQUAL);
                            break;
                        case $455d545b1dff00eb$var$sv:
                            a.depthFunc(a.EQUAL);
                            break;
                        case $455d545b1dff00eb$var$ov:
                            a.depthFunc(a.GEQUAL);
                            break;
                        case $455d545b1dff00eb$var$lv:
                            a.depthFunc(a.GREATER);
                            break;
                        case $455d545b1dff00eb$var$cv:
                            a.depthFunc(a.NOTEQUAL);
                            break;
                        default:
                            a.depthFunc(a.LEQUAL);
                    }
                    ut = Ve;
                }
            },
            setLocked: function(Ve) {
                fe = Ve;
            },
            setClear: function(Ve) {
                Ke !== Ve && (We && (Ve = 1 - Ve), a.clearDepth(Ve), Ke = Ve);
            },
            reset: function() {
                fe = !1, Je = null, ut = null, Ke = null, We = !1;
            }
        };
    }
    function i() {
        let fe = !1, We = null, Je = null, ut = null, Ke = null, Ve = null, ft = null, vt = null, yt = null;
        return {
            setTest: function(Ct) {
                fe || (Ct ? le(a.STENCIL_TEST) : xe(a.STENCIL_TEST));
            },
            setMask: function(Ct) {
                We !== Ct && !fe && (a.stencilMask(Ct), We = Ct);
            },
            setFunc: function(Ct, on, gn) {
                (Je !== Ct || ut !== on || Ke !== gn) && (a.stencilFunc(Ct, on, gn), Je = Ct, ut = on, Ke = gn);
            },
            setOp: function(Ct, on, gn) {
                (Ve !== Ct || ft !== on || vt !== gn) && (a.stencilOp(Ct, on, gn), Ve = Ct, ft = on, vt = gn);
            },
            setLocked: function(Ct) {
                fe = Ct;
            },
            setClear: function(Ct) {
                yt !== Ct && (a.clearStencil(Ct), yt = Ct);
            },
            reset: function() {
                fe = !1, We = null, Je = null, ut = null, Ke = null, Ve = null, ft = null, vt = null, yt = null;
            }
        };
    }
    const r = new t, l = new n, c = new i, f = new WeakMap, p = new WeakMap;
    let m = {}, x = {}, v = new WeakMap, _ = [], S = null, A = !1, M = null, b = null, C = null, R = null, N = null, z = null, L = null, P = new $455d545b1dff00eb$var$_t(0, 0, 0), H = 0, O = !1, D = null, j = null, G = null, q = null, Y = null;
    const ae = a.getParameter(a.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let F = !1, Q = 0;
    const K = a.getParameter(a.VERSION);
    K.indexOf("WebGL") !== -1 ? (Q = parseFloat(/^WebGL (\d)/.exec(K)[1]), F = Q >= 1) : K.indexOf("OpenGL ES") !== -1 && (Q = parseFloat(/^OpenGL ES (\d)/.exec(K)[1]), F = Q >= 2);
    let $ = null, ee = {};
    const I = a.getParameter(a.SCISSOR_BOX), Z = a.getParameter(a.VIEWPORT), oe = new $455d545b1dff00eb$var$Un().fromArray(I), ce = new $455d545b1dff00eb$var$Un().fromArray(Z);
    function de(fe, We, Je, ut) {
        const Ke = new Uint8Array(4), Ve = a.createTexture();
        a.bindTexture(fe, Ve), a.texParameteri(fe, a.TEXTURE_MIN_FILTER, a.NEAREST), a.texParameteri(fe, a.TEXTURE_MAG_FILTER, a.NEAREST);
        for(let ft = 0; ft < Je; ft++)fe === a.TEXTURE_3D || fe === a.TEXTURE_2D_ARRAY ? a.texImage3D(We, 0, a.RGBA, 1, 1, ut, 0, a.RGBA, a.UNSIGNED_BYTE, Ke) : a.texImage2D(We + ft, 0, a.RGBA, 1, 1, 0, a.RGBA, a.UNSIGNED_BYTE, Ke);
        return Ve;
    }
    const ue = {};
    ue[a.TEXTURE_2D] = de(a.TEXTURE_2D, a.TEXTURE_2D, 1), ue[a.TEXTURE_CUBE_MAP] = de(a.TEXTURE_CUBE_MAP, a.TEXTURE_CUBE_MAP_POSITIVE_X, 6), ue[a.TEXTURE_2D_ARRAY] = de(a.TEXTURE_2D_ARRAY, a.TEXTURE_2D_ARRAY, 1, 1), ue[a.TEXTURE_3D] = de(a.TEXTURE_3D, a.TEXTURE_3D, 1, 1), r.setClear(0, 0, 0, 1), l.setClear(1), c.setClear(0), le(a.DEPTH_TEST), l.setFunc($455d545b1dff00eb$var$jf), Oe(!1), Ie($455d545b1dff00eb$var$X_), le(a.CULL_FACE), Re($455d545b1dff00eb$var$yl);
    function le(fe) {
        m[fe] !== !0 && (a.enable(fe), m[fe] = !0);
    }
    function xe(fe) {
        m[fe] !== !1 && (a.disable(fe), m[fe] = !1);
    }
    function Le(fe, We) {
        return x[fe] !== We ? (a.bindFramebuffer(fe, We), x[fe] = We, fe === a.DRAW_FRAMEBUFFER && (x[a.FRAMEBUFFER] = We), fe === a.FRAMEBUFFER && (x[a.DRAW_FRAMEBUFFER] = We), !0) : !1;
    }
    function Ue(fe, We) {
        let Je = _, ut = !1;
        if (fe) {
            Je = v.get(We), Je === void 0 && (Je = [], v.set(We, Je));
            const Ke = fe.textures;
            if (Je.length !== Ke.length || Je[0] !== a.COLOR_ATTACHMENT0) {
                for(let Ve = 0, ft = Ke.length; Ve < ft; Ve++)Je[Ve] = a.COLOR_ATTACHMENT0 + Ve;
                Je.length = Ke.length, ut = !0;
            }
        } else Je[0] !== a.BACK && (Je[0] = a.BACK, ut = !0);
        ut && a.drawBuffers(Je);
    }
    function Ne(fe) {
        return S !== fe ? (a.useProgram(fe), S = fe, !0) : !1;
    }
    const ke = {
        [$455d545b1dff00eb$var$vu]: a.FUNC_ADD,
        [$455d545b1dff00eb$var$LE]: a.FUNC_SUBTRACT,
        [$455d545b1dff00eb$var$zE]: a.FUNC_REVERSE_SUBTRACT
    };
    ke[$455d545b1dff00eb$var$PE] = a.MIN, ke[$455d545b1dff00eb$var$BE] = a.MAX;
    const nt = {
        [$455d545b1dff00eb$var$IE]: a.ZERO,
        [$455d545b1dff00eb$var$FE]: a.ONE,
        [$455d545b1dff00eb$var$HE]: a.SRC_COLOR,
        [$455d545b1dff00eb$var$tv]: a.SRC_ALPHA,
        [$455d545b1dff00eb$var$WE]: a.SRC_ALPHA_SATURATE,
        [$455d545b1dff00eb$var$jE]: a.DST_COLOR,
        [$455d545b1dff00eb$var$GE]: a.DST_ALPHA,
        [$455d545b1dff00eb$var$VE]: a.ONE_MINUS_SRC_COLOR,
        [$455d545b1dff00eb$var$nv]: a.ONE_MINUS_SRC_ALPHA,
        [$455d545b1dff00eb$var$XE]: a.ONE_MINUS_DST_COLOR,
        [$455d545b1dff00eb$var$kE]: a.ONE_MINUS_DST_ALPHA,
        [$455d545b1dff00eb$var$qE]: a.CONSTANT_COLOR,
        [$455d545b1dff00eb$var$YE]: a.ONE_MINUS_CONSTANT_COLOR,
        [$455d545b1dff00eb$var$ZE]: a.CONSTANT_ALPHA,
        [$455d545b1dff00eb$var$QE]: a.ONE_MINUS_CONSTANT_ALPHA
    };
    function Re(fe, We, Je, ut, Ke, Ve, ft, vt, yt, Ct) {
        if (fe === $455d545b1dff00eb$var$yl) {
            A === !0 && (xe(a.BLEND), A = !1);
            return;
        }
        if (A === !1 && (le(a.BLEND), A = !0), fe !== $455d545b1dff00eb$var$OE) {
            if (fe !== M || Ct !== O) {
                if ((b !== $455d545b1dff00eb$var$vu || N !== $455d545b1dff00eb$var$vu) && (a.blendEquation(a.FUNC_ADD), b = $455d545b1dff00eb$var$vu, N = $455d545b1dff00eb$var$vu), Ct) switch(fe){
                    case $455d545b1dff00eb$var$Ff:
                        a.blendFuncSeparate(a.ONE, a.ONE_MINUS_SRC_ALPHA, a.ONE, a.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $455d545b1dff00eb$var$W_:
                        a.blendFunc(a.ONE, a.ONE);
                        break;
                    case $455d545b1dff00eb$var$q_:
                        a.blendFuncSeparate(a.ZERO, a.ONE_MINUS_SRC_COLOR, a.ZERO, a.ONE);
                        break;
                    case $455d545b1dff00eb$var$Y_:
                        a.blendFuncSeparate(a.DST_COLOR, a.ONE_MINUS_SRC_ALPHA, a.ZERO, a.ONE);
                        break;
                    default:
                        $455d545b1dff00eb$var$Qt("WebGLState: Invalid blending: ", fe);
                        break;
                }
                else switch(fe){
                    case $455d545b1dff00eb$var$Ff:
                        a.blendFuncSeparate(a.SRC_ALPHA, a.ONE_MINUS_SRC_ALPHA, a.ONE, a.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $455d545b1dff00eb$var$W_:
                        a.blendFuncSeparate(a.SRC_ALPHA, a.ONE, a.ONE, a.ONE);
                        break;
                    case $455d545b1dff00eb$var$q_:
                        $455d545b1dff00eb$var$Qt("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                        break;
                    case $455d545b1dff00eb$var$Y_:
                        $455d545b1dff00eb$var$Qt("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                        break;
                    default:
                        $455d545b1dff00eb$var$Qt("WebGLState: Invalid blending: ", fe);
                        break;
                }
                C = null, R = null, z = null, L = null, P.set(0, 0, 0), H = 0, M = fe, O = Ct;
            }
            return;
        }
        Ke = Ke || We, Ve = Ve || Je, ft = ft || ut, (We !== b || Ke !== N) && (a.blendEquationSeparate(ke[We], ke[Ke]), b = We, N = Ke), (Je !== C || ut !== R || Ve !== z || ft !== L) && (a.blendFuncSeparate(nt[Je], nt[ut], nt[Ve], nt[ft]), C = Je, R = ut, z = Ve, L = ft), (vt.equals(P) === !1 || yt !== H) && (a.blendColor(vt.r, vt.g, vt.b, yt), P.copy(vt), H = yt), M = fe, O = !1;
    }
    function te(fe, We) {
        fe.side === $455d545b1dff00eb$var$Ea ? xe(a.CULL_FACE) : le(a.CULL_FACE);
        let Je = fe.side === $455d545b1dff00eb$var$Dr;
        We && (Je = !Je), Oe(Je), fe.blending === $455d545b1dff00eb$var$Ff && fe.transparent === !1 ? Re($455d545b1dff00eb$var$yl) : Re(fe.blending, fe.blendEquation, fe.blendSrc, fe.blendDst, fe.blendEquationAlpha, fe.blendSrcAlpha, fe.blendDstAlpha, fe.blendColor, fe.blendAlpha, fe.premultipliedAlpha), l.setFunc(fe.depthFunc), l.setTest(fe.depthTest), l.setMask(fe.depthWrite), r.setMask(fe.colorWrite);
        const ut = fe.stencilWrite;
        c.setTest(ut), ut && (c.setMask(fe.stencilWriteMask), c.setFunc(fe.stencilFunc, fe.stencilRef, fe.stencilFuncMask), c.setOp(fe.stencilFail, fe.stencilZFail, fe.stencilZPass)), ze(fe.polygonOffset, fe.polygonOffsetFactor, fe.polygonOffsetUnits), fe.alphaToCoverage === !0 ? le(a.SAMPLE_ALPHA_TO_COVERAGE) : xe(a.SAMPLE_ALPHA_TO_COVERAGE);
    }
    function Oe(fe) {
        D !== fe && (fe ? a.frontFace(a.CW) : a.frontFace(a.CCW), D = fe);
    }
    function Ie(fe) {
        fe !== $455d545b1dff00eb$var$DE ? (le(a.CULL_FACE), fe !== j && (fe === $455d545b1dff00eb$var$X_ ? a.cullFace(a.BACK) : fe === $455d545b1dff00eb$var$UE ? a.cullFace(a.FRONT) : a.cullFace(a.FRONT_AND_BACK))) : xe(a.CULL_FACE), j = fe;
    }
    function Ae(fe) {
        fe !== G && (F && a.lineWidth(fe), G = fe);
    }
    function ze(fe, We, Je) {
        fe ? (le(a.POLYGON_OFFSET_FILL), (q !== We || Y !== Je) && (a.polygonOffset(We, Je), q = We, Y = Je)) : xe(a.POLYGON_OFFSET_FILL);
    }
    function Ze(fe) {
        fe ? le(a.SCISSOR_TEST) : xe(a.SCISSOR_TEST);
    }
    function be(fe) {
        fe === void 0 && (fe = a.TEXTURE0 + ae - 1), $ !== fe && (a.activeTexture(fe), $ = fe);
    }
    function rt(fe, We, Je) {
        Je === void 0 && ($ === null ? Je = a.TEXTURE0 + ae - 1 : Je = $);
        let ut = ee[Je];
        ut === void 0 && (ut = {
            type: void 0,
            texture: void 0
        }, ee[Je] = ut), (ut.type !== fe || ut.texture !== We) && ($ !== Je && (a.activeTexture(Je), $ = Je), a.bindTexture(fe, We || ue[fe]), ut.type = fe, ut.texture = We);
    }
    function ne() {
        const fe = ee[$];
        fe !== void 0 && fe.type !== void 0 && (a.bindTexture(fe.type, null), fe.type = void 0, fe.texture = void 0);
    }
    function W() {
        try {
            a.compressedTexImage2D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function pe() {
        try {
            a.compressedTexImage3D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function Be() {
        try {
            a.texSubImage2D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function Te() {
        try {
            a.texSubImage3D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function _e() {
        try {
            a.compressedTexSubImage2D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function ot() {
        try {
            a.compressedTexSubImage3D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function tt() {
        try {
            a.texStorage2D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function gt() {
        try {
            a.texStorage3D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function pt() {
        try {
            a.texImage2D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function Ge() {
        try {
            a.texImage3D(...arguments);
        } catch (fe) {
            fe("WebGLState:", fe);
        }
    }
    function Ye(fe) {
        oe.equals(fe) === !1 && (a.scissor(fe.x, fe.y, fe.z, fe.w), oe.copy(fe));
    }
    function at(fe) {
        ce.equals(fe) === !1 && (a.viewport(fe.x, fe.y, fe.z, fe.w), ce.copy(fe));
    }
    function he(fe, We) {
        let Je = p.get(We);
        Je === void 0 && (Je = new WeakMap, p.set(We, Je));
        let ut = Je.get(fe);
        ut === void 0 && (ut = a.getUniformBlockIndex(We, fe.name), Je.set(fe, ut));
    }
    function Ee(fe, We) {
        const ut = p.get(We).get(fe);
        f.get(We) !== ut && (a.uniformBlockBinding(We, ut, fe.__bindingPointIndex), f.set(We, ut));
    }
    function lt() {
        a.disable(a.BLEND), a.disable(a.CULL_FACE), a.disable(a.DEPTH_TEST), a.disable(a.POLYGON_OFFSET_FILL), a.disable(a.SCISSOR_TEST), a.disable(a.STENCIL_TEST), a.disable(a.SAMPLE_ALPHA_TO_COVERAGE), a.blendEquation(a.FUNC_ADD), a.blendFunc(a.ONE, a.ZERO), a.blendFuncSeparate(a.ONE, a.ZERO, a.ONE, a.ZERO), a.blendColor(0, 0, 0, 0), a.colorMask(!0, !0, !0, !0), a.clearColor(0, 0, 0, 0), a.depthMask(!0), a.depthFunc(a.LESS), l.setReversed(!1), a.clearDepth(1), a.stencilMask(4294967295), a.stencilFunc(a.ALWAYS, 0, 4294967295), a.stencilOp(a.KEEP, a.KEEP, a.KEEP), a.clearStencil(0), a.cullFace(a.BACK), a.frontFace(a.CCW), a.polygonOffset(0, 0), a.activeTexture(a.TEXTURE0), a.bindFramebuffer(a.FRAMEBUFFER, null), a.bindFramebuffer(a.DRAW_FRAMEBUFFER, null), a.bindFramebuffer(a.READ_FRAMEBUFFER, null), a.useProgram(null), a.lineWidth(1), a.scissor(0, 0, a.canvas.width, a.canvas.height), a.viewport(0, 0, a.canvas.width, a.canvas.height), m = {}, $ = null, ee = {}, x = {}, v = new WeakMap, _ = [], S = null, A = !1, M = null, b = null, C = null, R = null, N = null, z = null, L = null, P = new $455d545b1dff00eb$var$_t(0, 0, 0), H = 0, O = !1, D = null, j = null, G = null, q = null, Y = null, oe.set(0, 0, a.canvas.width, a.canvas.height), ce.set(0, 0, a.canvas.width, a.canvas.height), r.reset(), l.reset(), c.reset();
    }
    return {
        buffers: {
            color: r,
            depth: l,
            stencil: c
        },
        enable: le,
        disable: xe,
        bindFramebuffer: Le,
        drawBuffers: Ue,
        useProgram: Ne,
        setBlending: Re,
        setMaterial: te,
        setFlipSided: Oe,
        setCullFace: Ie,
        setLineWidth: Ae,
        setPolygonOffset: ze,
        setScissorTest: Ze,
        activeTexture: be,
        bindTexture: rt,
        unbindTexture: ne,
        compressedTexImage2D: W,
        compressedTexImage3D: pe,
        texImage2D: pt,
        texImage3D: Ge,
        updateUBOMapping: he,
        uniformBlockBinding: Ee,
        texStorage2D: tt,
        texStorage3D: gt,
        texSubImage2D: Be,
        texSubImage3D: Te,
        compressedTexSubImage2D: _e,
        compressedTexSubImage3D: ot,
        scissor: Ye,
        viewport: at,
        reset: lt
    };
}
function $455d545b1dff00eb$var$oP(a, e, t, n, i, r, l) {
    const c = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, f = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), p = new $455d545b1dff00eb$var$$e, m = new WeakMap;
    let x;
    const v = new WeakMap;
    let _ = !1;
    try {
        _ = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch  {}
    function S(ne, W) {
        return _ ? new OffscreenCanvas(ne, W) : $455d545b1dff00eb$var$s0("canvas");
    }
    function A(ne, W, pe) {
        let Be = 1;
        const Te = rt(ne);
        if ((Te.width > pe || Te.height > pe) && (Be = pe / Math.max(Te.width, Te.height)), Be < 1) {
            if (typeof HTMLImageElement < "u" && ne instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && ne instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && ne instanceof ImageBitmap || typeof VideoFrame < "u" && ne instanceof VideoFrame) {
                const _e = Math.floor(Be * Te.width), ot = Math.floor(Be * Te.height);
                x === void 0 && (x = S(_e, ot));
                const tt = W ? S(_e, ot) : x;
                return tt.width = _e, tt.height = ot, tt.getContext("2d").drawImage(ne, 0, 0, _e, ot), $455d545b1dff00eb$var$Mt("WebGLRenderer: Texture has been resized from (" + Te.width + "x" + Te.height + ") to (" + _e + "x" + ot + ")."), tt;
            } else return "data" in ne && $455d545b1dff00eb$var$Mt("WebGLRenderer: Image in DataTexture is too big (" + Te.width + "x" + Te.height + ")."), ne;
        }
        return ne;
    }
    function M(ne) {
        return ne.generateMipmaps;
    }
    function b(ne) {
        a.generateMipmap(ne);
    }
    function C(ne) {
        return ne.isWebGLCubeRenderTarget ? a.TEXTURE_CUBE_MAP : ne.isWebGL3DRenderTarget ? a.TEXTURE_3D : ne.isWebGLArrayRenderTarget || ne.isCompressedArrayTexture ? a.TEXTURE_2D_ARRAY : a.TEXTURE_2D;
    }
    function R(ne, W, pe, Be, Te = !1) {
        if (ne !== null) {
            if (a[ne] !== void 0) return a[ne];
            $455d545b1dff00eb$var$Mt("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + ne + "'");
        }
        let _e = W;
        if (W === a.RED && (pe === a.FLOAT && (_e = a.R32F), pe === a.HALF_FLOAT && (_e = a.R16F), pe === a.UNSIGNED_BYTE && (_e = a.R8)), W === a.RED_INTEGER && (pe === a.UNSIGNED_BYTE && (_e = a.R8UI), pe === a.UNSIGNED_SHORT && (_e = a.R16UI), pe === a.UNSIGNED_INT && (_e = a.R32UI), pe === a.BYTE && (_e = a.R8I), pe === a.SHORT && (_e = a.R16I), pe === a.INT && (_e = a.R32I)), W === a.RG && (pe === a.FLOAT && (_e = a.RG32F), pe === a.HALF_FLOAT && (_e = a.RG16F), pe === a.UNSIGNED_BYTE && (_e = a.RG8)), W === a.RG_INTEGER && (pe === a.UNSIGNED_BYTE && (_e = a.RG8UI), pe === a.UNSIGNED_SHORT && (_e = a.RG16UI), pe === a.UNSIGNED_INT && (_e = a.RG32UI), pe === a.BYTE && (_e = a.RG8I), pe === a.SHORT && (_e = a.RG16I), pe === a.INT && (_e = a.RG32I)), W === a.RGB_INTEGER && (pe === a.UNSIGNED_BYTE && (_e = a.RGB8UI), pe === a.UNSIGNED_SHORT && (_e = a.RGB16UI), pe === a.UNSIGNED_INT && (_e = a.RGB32UI), pe === a.BYTE && (_e = a.RGB8I), pe === a.SHORT && (_e = a.RGB16I), pe === a.INT && (_e = a.RGB32I)), W === a.RGBA_INTEGER && (pe === a.UNSIGNED_BYTE && (_e = a.RGBA8UI), pe === a.UNSIGNED_SHORT && (_e = a.RGBA16UI), pe === a.UNSIGNED_INT && (_e = a.RGBA32UI), pe === a.BYTE && (_e = a.RGBA8I), pe === a.SHORT && (_e = a.RGBA16I), pe === a.INT && (_e = a.RGBA32I)), W === a.RGB && (pe === a.UNSIGNED_INT_5_9_9_9_REV && (_e = a.RGB9_E5), pe === a.UNSIGNED_INT_10F_11F_11F_REV && (_e = a.R11F_G11F_B10F)), W === a.RGBA) {
            const ot = Te ? $455d545b1dff00eb$var$a0 : $455d545b1dff00eb$var$Dn.getTransfer(Be);
            pe === a.FLOAT && (_e = a.RGBA32F), pe === a.HALF_FLOAT && (_e = a.RGBA16F), pe === a.UNSIGNED_BYTE && (_e = ot === $455d545b1dff00eb$var$Zn ? a.SRGB8_ALPHA8 : a.RGBA8), pe === a.UNSIGNED_SHORT_4_4_4_4 && (_e = a.RGBA4), pe === a.UNSIGNED_SHORT_5_5_5_1 && (_e = a.RGB5_A1);
        }
        return (_e === a.R16F || _e === a.R32F || _e === a.RG16F || _e === a.RG32F || _e === a.RGBA16F || _e === a.RGBA32F) && e.get("EXT_color_buffer_float"), _e;
    }
    function N(ne, W) {
        let pe;
        return ne ? W === null || W === $455d545b1dff00eb$var$Mc || W === $455d545b1dff00eb$var$Ld ? pe = a.DEPTH24_STENCIL8 : W === $455d545b1dff00eb$var$Rr ? pe = a.DEPTH32F_STENCIL8 : W === $455d545b1dff00eb$var$Od && (pe = a.DEPTH24_STENCIL8, $455d545b1dff00eb$var$Mt("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : W === null || W === $455d545b1dff00eb$var$Mc || W === $455d545b1dff00eb$var$Ld ? pe = a.DEPTH_COMPONENT24 : W === $455d545b1dff00eb$var$Rr ? pe = a.DEPTH_COMPONENT32F : W === $455d545b1dff00eb$var$Od && (pe = a.DEPTH_COMPONENT16), pe;
    }
    function z(ne, W) {
        return M(ne) === !0 || ne.isFramebufferTexture && ne.minFilter !== $455d545b1dff00eb$var$Fa && ne.minFilter !== $455d545b1dff00eb$var$mi ? Math.log2(Math.max(W.width, W.height)) + 1 : ne.mipmaps !== void 0 && ne.mipmaps.length > 0 ? ne.mipmaps.length : ne.isCompressedTexture && Array.isArray(ne.image) ? W.mipmaps.length : 1;
    }
    function L(ne) {
        const W = ne.target;
        W.removeEventListener("dispose", L), H(W), W.isVideoTexture && m.delete(W);
    }
    function P(ne) {
        const W = ne.target;
        W.removeEventListener("dispose", P), D(W);
    }
    function H(ne) {
        const W = n.get(ne);
        if (W.__webglInit === void 0) return;
        const pe = ne.source, Be = v.get(pe);
        if (Be) {
            const Te = Be[W.__cacheKey];
            Te.usedTimes--, Te.usedTimes === 0 && O(ne), Object.keys(Be).length === 0 && v.delete(pe);
        }
        n.remove(ne);
    }
    function O(ne) {
        const W = n.get(ne);
        a.deleteTexture(W.__webglTexture);
        const pe = ne.source, Be = v.get(pe);
        delete Be[W.__cacheKey], l.memory.textures--;
    }
    function D(ne) {
        const W = n.get(ne);
        if (ne.depthTexture && (ne.depthTexture.dispose(), n.remove(ne.depthTexture)), ne.isWebGLCubeRenderTarget) for(let Be = 0; Be < 6; Be++){
            if (Array.isArray(W.__webglFramebuffer[Be])) for(let Te = 0; Te < W.__webglFramebuffer[Be].length; Te++)a.deleteFramebuffer(W.__webglFramebuffer[Be][Te]);
            else a.deleteFramebuffer(W.__webglFramebuffer[Be]);
            W.__webglDepthbuffer && a.deleteRenderbuffer(W.__webglDepthbuffer[Be]);
        }
        else {
            if (Array.isArray(W.__webglFramebuffer)) for(let Be = 0; Be < W.__webglFramebuffer.length; Be++)a.deleteFramebuffer(W.__webglFramebuffer[Be]);
            else a.deleteFramebuffer(W.__webglFramebuffer);
            if (W.__webglDepthbuffer && a.deleteRenderbuffer(W.__webglDepthbuffer), W.__webglMultisampledFramebuffer && a.deleteFramebuffer(W.__webglMultisampledFramebuffer), W.__webglColorRenderbuffer) for(let Be = 0; Be < W.__webglColorRenderbuffer.length; Be++)W.__webglColorRenderbuffer[Be] && a.deleteRenderbuffer(W.__webglColorRenderbuffer[Be]);
            W.__webglDepthRenderbuffer && a.deleteRenderbuffer(W.__webglDepthRenderbuffer);
        }
        const pe = ne.textures;
        for(let Be = 0, Te = pe.length; Be < Te; Be++){
            const _e = n.get(pe[Be]);
            _e.__webglTexture && (a.deleteTexture(_e.__webglTexture), l.memory.textures--), n.remove(pe[Be]);
        }
        n.remove(ne);
    }
    let j = 0;
    function G() {
        j = 0;
    }
    function q() {
        const ne = j;
        return ne >= i.maxTextures && $455d545b1dff00eb$var$Mt("WebGLTextures: Trying to use " + ne + " texture units while this GPU supports only " + i.maxTextures), j += 1, ne;
    }
    function Y(ne) {
        const W = [];
        return W.push(ne.wrapS), W.push(ne.wrapT), W.push(ne.wrapR || 0), W.push(ne.magFilter), W.push(ne.minFilter), W.push(ne.anisotropy), W.push(ne.internalFormat), W.push(ne.format), W.push(ne.type), W.push(ne.generateMipmaps), W.push(ne.premultiplyAlpha), W.push(ne.flipY), W.push(ne.unpackAlignment), W.push(ne.colorSpace), W.join();
    }
    function ae(ne, W) {
        const pe = n.get(ne);
        if (ne.isVideoTexture && Ze(ne), ne.isRenderTargetTexture === !1 && ne.isExternalTexture !== !0 && ne.version > 0 && pe.__version !== ne.version) {
            const Be = ne.image;
            if (Be === null) $455d545b1dff00eb$var$Mt("WebGLRenderer: Texture marked for update but no image data found.");
            else if (Be.complete === !1) $455d545b1dff00eb$var$Mt("WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                ue(pe, ne, W);
                return;
            }
        } else ne.isExternalTexture && (pe.__webglTexture = ne.sourceTexture ? ne.sourceTexture : null);
        t.bindTexture(a.TEXTURE_2D, pe.__webglTexture, a.TEXTURE0 + W);
    }
    function F(ne, W) {
        const pe = n.get(ne);
        if (ne.isRenderTargetTexture === !1 && ne.version > 0 && pe.__version !== ne.version) {
            ue(pe, ne, W);
            return;
        } else ne.isExternalTexture && (pe.__webglTexture = ne.sourceTexture ? ne.sourceTexture : null);
        t.bindTexture(a.TEXTURE_2D_ARRAY, pe.__webglTexture, a.TEXTURE0 + W);
    }
    function Q(ne, W) {
        const pe = n.get(ne);
        if (ne.isRenderTargetTexture === !1 && ne.version > 0 && pe.__version !== ne.version) {
            ue(pe, ne, W);
            return;
        }
        t.bindTexture(a.TEXTURE_3D, pe.__webglTexture, a.TEXTURE0 + W);
    }
    function K(ne, W) {
        const pe = n.get(ne);
        if (ne.version > 0 && pe.__version !== ne.version) {
            le(pe, ne, W);
            return;
        }
        t.bindTexture(a.TEXTURE_CUBE_MAP, pe.__webglTexture, a.TEXTURE0 + W);
    }
    const $ = {
        [$455d545b1dff00eb$var$e0]: a.REPEAT,
        [$455d545b1dff00eb$var$Kr]: a.CLAMP_TO_EDGE,
        [$455d545b1dff00eb$var$t0]: a.MIRRORED_REPEAT
    }, ee = {
        [$455d545b1dff00eb$var$Fa]: a.NEAREST,
        [$455d545b1dff00eb$var$Db]: a.NEAREST_MIPMAP_NEAREST,
        [$455d545b1dff00eb$var$Ad]: a.NEAREST_MIPMAP_LINEAR,
        [$455d545b1dff00eb$var$mi]: a.LINEAR,
        [$455d545b1dff00eb$var$Fm]: a.LINEAR_MIPMAP_NEAREST,
        [$455d545b1dff00eb$var$gl]: a.LINEAR_MIPMAP_LINEAR
    }, I = {
        [$455d545b1dff00eb$var$fT]: a.NEVER,
        [$455d545b1dff00eb$var$xT]: a.ALWAYS,
        [$455d545b1dff00eb$var$hT]: a.LESS,
        [$455d545b1dff00eb$var$Fb]: a.LEQUAL,
        [$455d545b1dff00eb$var$dT]: a.EQUAL,
        [$455d545b1dff00eb$var$gT]: a.GEQUAL,
        [$455d545b1dff00eb$var$pT]: a.GREATER,
        [$455d545b1dff00eb$var$mT]: a.NOTEQUAL
    };
    function Z(ne, W) {
        if (W.type === $455d545b1dff00eb$var$Rr && e.has("OES_texture_float_linear") === !1 && (W.magFilter === $455d545b1dff00eb$var$mi || W.magFilter === $455d545b1dff00eb$var$Fm || W.magFilter === $455d545b1dff00eb$var$Ad || W.magFilter === $455d545b1dff00eb$var$gl || W.minFilter === $455d545b1dff00eb$var$mi || W.minFilter === $455d545b1dff00eb$var$Fm || W.minFilter === $455d545b1dff00eb$var$Ad || W.minFilter === $455d545b1dff00eb$var$gl) && $455d545b1dff00eb$var$Mt("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), a.texParameteri(ne, a.TEXTURE_WRAP_S, $[W.wrapS]), a.texParameteri(ne, a.TEXTURE_WRAP_T, $[W.wrapT]), (ne === a.TEXTURE_3D || ne === a.TEXTURE_2D_ARRAY) && a.texParameteri(ne, a.TEXTURE_WRAP_R, $[W.wrapR]), a.texParameteri(ne, a.TEXTURE_MAG_FILTER, ee[W.magFilter]), a.texParameteri(ne, a.TEXTURE_MIN_FILTER, ee[W.minFilter]), W.compareFunction && (a.texParameteri(ne, a.TEXTURE_COMPARE_MODE, a.COMPARE_REF_TO_TEXTURE), a.texParameteri(ne, a.TEXTURE_COMPARE_FUNC, I[W.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
            if (W.magFilter === $455d545b1dff00eb$var$Fa || W.minFilter !== $455d545b1dff00eb$var$Ad && W.minFilter !== $455d545b1dff00eb$var$gl || W.type === $455d545b1dff00eb$var$Rr && e.has("OES_texture_float_linear") === !1) return;
            if (W.anisotropy > 1 || n.get(W).__currentAnisotropy) {
                const pe = e.get("EXT_texture_filter_anisotropic");
                a.texParameterf(ne, pe.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(W.anisotropy, i.getMaxAnisotropy())), n.get(W).__currentAnisotropy = W.anisotropy;
            }
        }
    }
    function oe(ne, W) {
        let pe = !1;
        ne.__webglInit === void 0 && (ne.__webglInit = !0, W.addEventListener("dispose", L));
        const Be = W.source;
        let Te = v.get(Be);
        Te === void 0 && (Te = {}, v.set(Be, Te));
        const _e = Y(W);
        if (_e !== ne.__cacheKey) {
            Te[_e] === void 0 && (Te[_e] = {
                texture: a.createTexture(),
                usedTimes: 0
            }, l.memory.textures++, pe = !0), Te[_e].usedTimes++;
            const ot = Te[ne.__cacheKey];
            ot !== void 0 && (Te[ne.__cacheKey].usedTimes--, ot.usedTimes === 0 && O(W)), ne.__cacheKey = _e, ne.__webglTexture = Te[_e].texture;
        }
        return pe;
    }
    function ce(ne, W, pe) {
        return Math.floor(Math.floor(ne / pe) / W);
    }
    function de(ne, W, pe, Be) {
        const _e = ne.updateRanges;
        if (_e.length === 0) t.texSubImage2D(a.TEXTURE_2D, 0, 0, 0, W.width, W.height, pe, Be, W.data);
        else {
            _e.sort((Ge, Ye)=>Ge.start - Ye.start);
            let ot = 0;
            for(let Ge = 1; Ge < _e.length; Ge++){
                const Ye = _e[ot], at = _e[Ge], he = Ye.start + Ye.count, Ee = ce(at.start, W.width, 4), lt = ce(Ye.start, W.width, 4);
                at.start <= he + 1 && Ee === lt && ce(at.start + at.count - 1, W.width, 4) === Ee ? Ye.count = Math.max(Ye.count, at.start + at.count - Ye.start) : (++ot, _e[ot] = at);
            }
            _e.length = ot + 1;
            const tt = a.getParameter(a.UNPACK_ROW_LENGTH), gt = a.getParameter(a.UNPACK_SKIP_PIXELS), pt = a.getParameter(a.UNPACK_SKIP_ROWS);
            a.pixelStorei(a.UNPACK_ROW_LENGTH, W.width);
            for(let Ge = 0, Ye = _e.length; Ge < Ye; Ge++){
                const at = _e[Ge], he = Math.floor(at.start / 4), Ee = Math.ceil(at.count / 4), lt = he % W.width, fe = Math.floor(he / W.width), We = Ee, Je = 1;
                a.pixelStorei(a.UNPACK_SKIP_PIXELS, lt), a.pixelStorei(a.UNPACK_SKIP_ROWS, fe), t.texSubImage2D(a.TEXTURE_2D, 0, lt, fe, We, Je, pe, Be, W.data);
            }
            ne.clearUpdateRanges(), a.pixelStorei(a.UNPACK_ROW_LENGTH, tt), a.pixelStorei(a.UNPACK_SKIP_PIXELS, gt), a.pixelStorei(a.UNPACK_SKIP_ROWS, pt);
        }
    }
    function ue(ne, W, pe) {
        let Be = a.TEXTURE_2D;
        (W.isDataArrayTexture || W.isCompressedArrayTexture) && (Be = a.TEXTURE_2D_ARRAY), W.isData3DTexture && (Be = a.TEXTURE_3D);
        const Te = oe(ne, W), _e = W.source;
        t.bindTexture(Be, ne.__webglTexture, a.TEXTURE0 + pe);
        const ot = n.get(_e);
        if (_e.version !== ot.__version || Te === !0) {
            t.activeTexture(a.TEXTURE0 + pe);
            const tt = $455d545b1dff00eb$var$Dn.getPrimaries($455d545b1dff00eb$var$Dn.workingColorSpace), gt = W.colorSpace === $455d545b1dff00eb$var$pc ? null : $455d545b1dff00eb$var$Dn.getPrimaries(W.colorSpace), pt = W.colorSpace === $455d545b1dff00eb$var$pc || tt === gt ? a.NONE : a.BROWSER_DEFAULT_WEBGL;
            a.pixelStorei(a.UNPACK_FLIP_Y_WEBGL, W.flipY), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, W.premultiplyAlpha), a.pixelStorei(a.UNPACK_ALIGNMENT, W.unpackAlignment), a.pixelStorei(a.UNPACK_COLORSPACE_CONVERSION_WEBGL, pt);
            let Ge = A(W.image, !1, i.maxTextureSize);
            Ge = be(W, Ge);
            const Ye = r.convert(W.format, W.colorSpace), at = r.convert(W.type);
            let he = R(W.internalFormat, Ye, at, W.colorSpace, W.isVideoTexture);
            Z(Be, W);
            let Ee;
            const lt = W.mipmaps, fe = W.isVideoTexture !== !0, We = ot.__version === void 0 || Te === !0, Je = _e.dataReady, ut = z(W, Ge);
            if (W.isDepthTexture) he = N(W.format === $455d545b1dff00eb$var$Pd, W.type), We && (fe ? t.texStorage2D(a.TEXTURE_2D, 1, he, Ge.width, Ge.height) : t.texImage2D(a.TEXTURE_2D, 0, he, Ge.width, Ge.height, 0, Ye, at, null));
            else if (W.isDataTexture) {
                if (lt.length > 0) {
                    fe && We && t.texStorage2D(a.TEXTURE_2D, ut, he, lt[0].width, lt[0].height);
                    for(let Ke = 0, Ve = lt.length; Ke < Ve; Ke++)Ee = lt[Ke], fe ? Je && t.texSubImage2D(a.TEXTURE_2D, Ke, 0, 0, Ee.width, Ee.height, Ye, at, Ee.data) : t.texImage2D(a.TEXTURE_2D, Ke, he, Ee.width, Ee.height, 0, Ye, at, Ee.data);
                    W.generateMipmaps = !1;
                } else fe ? (We && t.texStorage2D(a.TEXTURE_2D, ut, he, Ge.width, Ge.height), Je && de(W, Ge, Ye, at)) : t.texImage2D(a.TEXTURE_2D, 0, he, Ge.width, Ge.height, 0, Ye, at, Ge.data);
            } else if (W.isCompressedTexture) {
                if (W.isCompressedArrayTexture) {
                    fe && We && t.texStorage3D(a.TEXTURE_2D_ARRAY, ut, he, lt[0].width, lt[0].height, Ge.depth);
                    for(let Ke = 0, Ve = lt.length; Ke < Ve; Ke++)if (Ee = lt[Ke], W.format !== $455d545b1dff00eb$var$ar) {
                        if (Ye !== null) {
                            if (fe) {
                                if (Je) {
                                    if (W.layerUpdates.size > 0) {
                                        const ft = $455d545b1dff00eb$var$rb(Ee.width, Ee.height, W.format, W.type);
                                        for (const vt of W.layerUpdates){
                                            const yt = Ee.data.subarray(vt * ft / Ee.data.BYTES_PER_ELEMENT, (vt + 1) * ft / Ee.data.BYTES_PER_ELEMENT);
                                            t.compressedTexSubImage3D(a.TEXTURE_2D_ARRAY, Ke, 0, 0, vt, Ee.width, Ee.height, 1, Ye, yt);
                                        }
                                        W.clearLayerUpdates();
                                    } else t.compressedTexSubImage3D(a.TEXTURE_2D_ARRAY, Ke, 0, 0, 0, Ee.width, Ee.height, Ge.depth, Ye, Ee.data);
                                }
                            } else t.compressedTexImage3D(a.TEXTURE_2D_ARRAY, Ke, he, Ee.width, Ee.height, Ge.depth, 0, Ee.data, 0, 0);
                        } else $455d545b1dff00eb$var$Mt("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                    } else fe ? Je && t.texSubImage3D(a.TEXTURE_2D_ARRAY, Ke, 0, 0, 0, Ee.width, Ee.height, Ge.depth, Ye, at, Ee.data) : t.texImage3D(a.TEXTURE_2D_ARRAY, Ke, he, Ee.width, Ee.height, Ge.depth, 0, Ye, at, Ee.data);
                } else {
                    fe && We && t.texStorage2D(a.TEXTURE_2D, ut, he, lt[0].width, lt[0].height);
                    for(let Ke = 0, Ve = lt.length; Ke < Ve; Ke++)Ee = lt[Ke], W.format !== $455d545b1dff00eb$var$ar ? Ye !== null ? fe ? Je && t.compressedTexSubImage2D(a.TEXTURE_2D, Ke, 0, 0, Ee.width, Ee.height, Ye, Ee.data) : t.compressedTexImage2D(a.TEXTURE_2D, Ke, he, Ee.width, Ee.height, 0, Ee.data) : $455d545b1dff00eb$var$Mt("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : fe ? Je && t.texSubImage2D(a.TEXTURE_2D, Ke, 0, 0, Ee.width, Ee.height, Ye, at, Ee.data) : t.texImage2D(a.TEXTURE_2D, Ke, he, Ee.width, Ee.height, 0, Ye, at, Ee.data);
                }
            } else if (W.isDataArrayTexture) {
                if (fe) {
                    if (We && t.texStorage3D(a.TEXTURE_2D_ARRAY, ut, he, Ge.width, Ge.height, Ge.depth), Je) {
                        if (W.layerUpdates.size > 0) {
                            const Ke = $455d545b1dff00eb$var$rb(Ge.width, Ge.height, W.format, W.type);
                            for (const Ve of W.layerUpdates){
                                const ft = Ge.data.subarray(Ve * Ke / Ge.data.BYTES_PER_ELEMENT, (Ve + 1) * Ke / Ge.data.BYTES_PER_ELEMENT);
                                t.texSubImage3D(a.TEXTURE_2D_ARRAY, 0, 0, 0, Ve, Ge.width, Ge.height, 1, Ye, at, ft);
                            }
                            W.clearLayerUpdates();
                        } else t.texSubImage3D(a.TEXTURE_2D_ARRAY, 0, 0, 0, 0, Ge.width, Ge.height, Ge.depth, Ye, at, Ge.data);
                    }
                } else t.texImage3D(a.TEXTURE_2D_ARRAY, 0, he, Ge.width, Ge.height, Ge.depth, 0, Ye, at, Ge.data);
            } else if (W.isData3DTexture) fe ? (We && t.texStorage3D(a.TEXTURE_3D, ut, he, Ge.width, Ge.height, Ge.depth), Je && t.texSubImage3D(a.TEXTURE_3D, 0, 0, 0, 0, Ge.width, Ge.height, Ge.depth, Ye, at, Ge.data)) : t.texImage3D(a.TEXTURE_3D, 0, he, Ge.width, Ge.height, Ge.depth, 0, Ye, at, Ge.data);
            else if (W.isFramebufferTexture) {
                if (We) {
                    if (fe) t.texStorage2D(a.TEXTURE_2D, ut, he, Ge.width, Ge.height);
                    else {
                        let Ke = Ge.width, Ve = Ge.height;
                        for(let ft = 0; ft < ut; ft++)t.texImage2D(a.TEXTURE_2D, ft, he, Ke, Ve, 0, Ye, at, null), Ke >>= 1, Ve >>= 1;
                    }
                }
            } else if (lt.length > 0) {
                if (fe && We) {
                    const Ke = rt(lt[0]);
                    t.texStorage2D(a.TEXTURE_2D, ut, he, Ke.width, Ke.height);
                }
                for(let Ke = 0, Ve = lt.length; Ke < Ve; Ke++)Ee = lt[Ke], fe ? Je && t.texSubImage2D(a.TEXTURE_2D, Ke, 0, 0, Ye, at, Ee) : t.texImage2D(a.TEXTURE_2D, Ke, he, Ye, at, Ee);
                W.generateMipmaps = !1;
            } else if (fe) {
                if (We) {
                    const Ke = rt(Ge);
                    t.texStorage2D(a.TEXTURE_2D, ut, he, Ke.width, Ke.height);
                }
                Je && t.texSubImage2D(a.TEXTURE_2D, 0, 0, 0, Ye, at, Ge);
            } else t.texImage2D(a.TEXTURE_2D, 0, he, Ye, at, Ge);
            M(W) && b(Be), ot.__version = _e.version, W.onUpdate && W.onUpdate(W);
        }
        ne.__version = W.version;
    }
    function le(ne, W, pe) {
        if (W.image.length !== 6) return;
        const Be = oe(ne, W), Te = W.source;
        t.bindTexture(a.TEXTURE_CUBE_MAP, ne.__webglTexture, a.TEXTURE0 + pe);
        const _e = n.get(Te);
        if (Te.version !== _e.__version || Be === !0) {
            t.activeTexture(a.TEXTURE0 + pe);
            const ot = $455d545b1dff00eb$var$Dn.getPrimaries($455d545b1dff00eb$var$Dn.workingColorSpace), tt = W.colorSpace === $455d545b1dff00eb$var$pc ? null : $455d545b1dff00eb$var$Dn.getPrimaries(W.colorSpace), gt = W.colorSpace === $455d545b1dff00eb$var$pc || ot === tt ? a.NONE : a.BROWSER_DEFAULT_WEBGL;
            a.pixelStorei(a.UNPACK_FLIP_Y_WEBGL, W.flipY), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, W.premultiplyAlpha), a.pixelStorei(a.UNPACK_ALIGNMENT, W.unpackAlignment), a.pixelStorei(a.UNPACK_COLORSPACE_CONVERSION_WEBGL, gt);
            const pt = W.isCompressedTexture || W.image[0].isCompressedTexture, Ge = W.image[0] && W.image[0].isDataTexture, Ye = [];
            for(let Ve = 0; Ve < 6; Ve++)!pt && !Ge ? Ye[Ve] = A(W.image[Ve], !0, i.maxCubemapSize) : Ye[Ve] = Ge ? W.image[Ve].image : W.image[Ve], Ye[Ve] = be(W, Ye[Ve]);
            const at = Ye[0], he = r.convert(W.format, W.colorSpace), Ee = r.convert(W.type), lt = R(W.internalFormat, he, Ee, W.colorSpace), fe = W.isVideoTexture !== !0, We = _e.__version === void 0 || Be === !0, Je = Te.dataReady;
            let ut = z(W, at);
            Z(a.TEXTURE_CUBE_MAP, W);
            let Ke;
            if (pt) {
                fe && We && t.texStorage2D(a.TEXTURE_CUBE_MAP, ut, lt, at.width, at.height);
                for(let Ve = 0; Ve < 6; Ve++){
                    Ke = Ye[Ve].mipmaps;
                    for(let ft = 0; ft < Ke.length; ft++){
                        const vt = Ke[ft];
                        W.format !== $455d545b1dff00eb$var$ar ? he !== null ? fe ? Je && t.compressedTexSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft, 0, 0, vt.width, vt.height, he, vt.data) : t.compressedTexImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft, lt, vt.width, vt.height, 0, vt.data) : $455d545b1dff00eb$var$Mt("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : fe ? Je && t.texSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft, 0, 0, vt.width, vt.height, he, Ee, vt.data) : t.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft, lt, vt.width, vt.height, 0, he, Ee, vt.data);
                    }
                }
            } else {
                if (Ke = W.mipmaps, fe && We) {
                    Ke.length > 0 && ut++;
                    const Ve = rt(Ye[0]);
                    t.texStorage2D(a.TEXTURE_CUBE_MAP, ut, lt, Ve.width, Ve.height);
                }
                for(let Ve = 0; Ve < 6; Ve++)if (Ge) {
                    fe ? Je && t.texSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, 0, 0, 0, Ye[Ve].width, Ye[Ve].height, he, Ee, Ye[Ve].data) : t.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, 0, lt, Ye[Ve].width, Ye[Ve].height, 0, he, Ee, Ye[Ve].data);
                    for(let ft = 0; ft < Ke.length; ft++){
                        const yt = Ke[ft].image[Ve].image;
                        fe ? Je && t.texSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft + 1, 0, 0, yt.width, yt.height, he, Ee, yt.data) : t.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft + 1, lt, yt.width, yt.height, 0, he, Ee, yt.data);
                    }
                } else {
                    fe ? Je && t.texSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, 0, 0, 0, he, Ee, Ye[Ve]) : t.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, 0, lt, he, Ee, Ye[Ve]);
                    for(let ft = 0; ft < Ke.length; ft++){
                        const vt = Ke[ft];
                        fe ? Je && t.texSubImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft + 1, 0, 0, he, Ee, vt.image[Ve]) : t.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, ft + 1, lt, he, Ee, vt.image[Ve]);
                    }
                }
            }
            M(W) && b(a.TEXTURE_CUBE_MAP), _e.__version = Te.version, W.onUpdate && W.onUpdate(W);
        }
        ne.__version = W.version;
    }
    function xe(ne, W, pe, Be, Te, _e) {
        const ot = r.convert(pe.format, pe.colorSpace), tt = r.convert(pe.type), gt = R(pe.internalFormat, ot, tt, pe.colorSpace), pt = n.get(W), Ge = n.get(pe);
        if (Ge.__renderTarget = W, !pt.__hasExternalTextures) {
            const Ye = Math.max(1, W.width >> _e), at = Math.max(1, W.height >> _e);
            Te === a.TEXTURE_3D || Te === a.TEXTURE_2D_ARRAY ? t.texImage3D(Te, _e, gt, Ye, at, W.depth, 0, ot, tt, null) : t.texImage2D(Te, _e, gt, Ye, at, 0, ot, tt, null);
        }
        t.bindFramebuffer(a.FRAMEBUFFER, ne), ze(W) ? c.framebufferTexture2DMultisampleEXT(a.FRAMEBUFFER, Be, Te, Ge.__webglTexture, 0, Ae(W)) : (Te === a.TEXTURE_2D || Te >= a.TEXTURE_CUBE_MAP_POSITIVE_X && Te <= a.TEXTURE_CUBE_MAP_NEGATIVE_Z) && a.framebufferTexture2D(a.FRAMEBUFFER, Be, Te, Ge.__webglTexture, _e), t.bindFramebuffer(a.FRAMEBUFFER, null);
    }
    function Le(ne, W, pe) {
        if (a.bindRenderbuffer(a.RENDERBUFFER, ne), W.depthBuffer) {
            const Be = W.depthTexture, Te = Be && Be.isDepthTexture ? Be.type : null, _e = N(W.stencilBuffer, Te), ot = W.stencilBuffer ? a.DEPTH_STENCIL_ATTACHMENT : a.DEPTH_ATTACHMENT, tt = Ae(W);
            ze(W) ? c.renderbufferStorageMultisampleEXT(a.RENDERBUFFER, tt, _e, W.width, W.height) : pe ? a.renderbufferStorageMultisample(a.RENDERBUFFER, tt, _e, W.width, W.height) : a.renderbufferStorage(a.RENDERBUFFER, _e, W.width, W.height), a.framebufferRenderbuffer(a.FRAMEBUFFER, ot, a.RENDERBUFFER, ne);
        } else {
            const Be = W.textures;
            for(let Te = 0; Te < Be.length; Te++){
                const _e = Be[Te], ot = r.convert(_e.format, _e.colorSpace), tt = r.convert(_e.type), gt = R(_e.internalFormat, ot, tt, _e.colorSpace), pt = Ae(W);
                pe && ze(W) === !1 ? a.renderbufferStorageMultisample(a.RENDERBUFFER, pt, gt, W.width, W.height) : ze(W) ? c.renderbufferStorageMultisampleEXT(a.RENDERBUFFER, pt, gt, W.width, W.height) : a.renderbufferStorage(a.RENDERBUFFER, gt, W.width, W.height);
            }
        }
        a.bindRenderbuffer(a.RENDERBUFFER, null);
    }
    function Ue(ne, W) {
        if (W && W.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (t.bindFramebuffer(a.FRAMEBUFFER, ne), !(W.depthTexture && W.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        const Be = n.get(W.depthTexture);
        Be.__renderTarget = W, (!Be.__webglTexture || W.depthTexture.image.width !== W.width || W.depthTexture.image.height !== W.height) && (W.depthTexture.image.width = W.width, W.depthTexture.image.height = W.height, W.depthTexture.needsUpdate = !0), ae(W.depthTexture, 0);
        const Te = Be.__webglTexture, _e = Ae(W);
        if (W.depthTexture.format === $455d545b1dff00eb$var$zd) ze(W) ? c.framebufferTexture2DMultisampleEXT(a.FRAMEBUFFER, a.DEPTH_ATTACHMENT, a.TEXTURE_2D, Te, 0, _e) : a.framebufferTexture2D(a.FRAMEBUFFER, a.DEPTH_ATTACHMENT, a.TEXTURE_2D, Te, 0);
        else if (W.depthTexture.format === $455d545b1dff00eb$var$Pd) ze(W) ? c.framebufferTexture2DMultisampleEXT(a.FRAMEBUFFER, a.DEPTH_STENCIL_ATTACHMENT, a.TEXTURE_2D, Te, 0, _e) : a.framebufferTexture2D(a.FRAMEBUFFER, a.DEPTH_STENCIL_ATTACHMENT, a.TEXTURE_2D, Te, 0);
        else throw new Error("Unknown depthTexture format");
    }
    function Ne(ne) {
        const W = n.get(ne), pe = ne.isWebGLCubeRenderTarget === !0;
        if (W.__boundDepthTexture !== ne.depthTexture) {
            const Be = ne.depthTexture;
            if (W.__depthDisposeCallback && W.__depthDisposeCallback(), Be) {
                const Te = ()=>{
                    delete W.__boundDepthTexture, delete W.__depthDisposeCallback, Be.removeEventListener("dispose", Te);
                };
                Be.addEventListener("dispose", Te), W.__depthDisposeCallback = Te;
            }
            W.__boundDepthTexture = Be;
        }
        if (ne.depthTexture && !W.__autoAllocateDepthBuffer) {
            if (pe) throw new Error("target.depthTexture not supported in Cube render targets");
            const Be = ne.texture.mipmaps;
            Be && Be.length > 0 ? Ue(W.__webglFramebuffer[0], ne) : Ue(W.__webglFramebuffer, ne);
        } else if (pe) {
            W.__webglDepthbuffer = [];
            for(let Be = 0; Be < 6; Be++)if (t.bindFramebuffer(a.FRAMEBUFFER, W.__webglFramebuffer[Be]), W.__webglDepthbuffer[Be] === void 0) W.__webglDepthbuffer[Be] = a.createRenderbuffer(), Le(W.__webglDepthbuffer[Be], ne, !1);
            else {
                const Te = ne.stencilBuffer ? a.DEPTH_STENCIL_ATTACHMENT : a.DEPTH_ATTACHMENT, _e = W.__webglDepthbuffer[Be];
                a.bindRenderbuffer(a.RENDERBUFFER, _e), a.framebufferRenderbuffer(a.FRAMEBUFFER, Te, a.RENDERBUFFER, _e);
            }
        } else {
            const Be = ne.texture.mipmaps;
            if (Be && Be.length > 0 ? t.bindFramebuffer(a.FRAMEBUFFER, W.__webglFramebuffer[0]) : t.bindFramebuffer(a.FRAMEBUFFER, W.__webglFramebuffer), W.__webglDepthbuffer === void 0) W.__webglDepthbuffer = a.createRenderbuffer(), Le(W.__webglDepthbuffer, ne, !1);
            else {
                const Te = ne.stencilBuffer ? a.DEPTH_STENCIL_ATTACHMENT : a.DEPTH_ATTACHMENT, _e = W.__webglDepthbuffer;
                a.bindRenderbuffer(a.RENDERBUFFER, _e), a.framebufferRenderbuffer(a.FRAMEBUFFER, Te, a.RENDERBUFFER, _e);
            }
        }
        t.bindFramebuffer(a.FRAMEBUFFER, null);
    }
    function ke(ne, W, pe) {
        const Be = n.get(ne);
        W !== void 0 && xe(Be.__webglFramebuffer, ne, ne.texture, a.COLOR_ATTACHMENT0, a.TEXTURE_2D, 0), pe !== void 0 && Ne(ne);
    }
    function nt(ne) {
        const W = ne.texture, pe = n.get(ne), Be = n.get(W);
        ne.addEventListener("dispose", P);
        const Te = ne.textures, _e = ne.isWebGLCubeRenderTarget === !0, ot = Te.length > 1;
        if (ot || (Be.__webglTexture === void 0 && (Be.__webglTexture = a.createTexture()), Be.__version = W.version, l.memory.textures++), _e) {
            pe.__webglFramebuffer = [];
            for(let tt = 0; tt < 6; tt++)if (W.mipmaps && W.mipmaps.length > 0) {
                pe.__webglFramebuffer[tt] = [];
                for(let gt = 0; gt < W.mipmaps.length; gt++)pe.__webglFramebuffer[tt][gt] = a.createFramebuffer();
            } else pe.__webglFramebuffer[tt] = a.createFramebuffer();
        } else {
            if (W.mipmaps && W.mipmaps.length > 0) {
                pe.__webglFramebuffer = [];
                for(let tt = 0; tt < W.mipmaps.length; tt++)pe.__webglFramebuffer[tt] = a.createFramebuffer();
            } else pe.__webglFramebuffer = a.createFramebuffer();
            if (ot) for(let tt = 0, gt = Te.length; tt < gt; tt++){
                const pt = n.get(Te[tt]);
                pt.__webglTexture === void 0 && (pt.__webglTexture = a.createTexture(), l.memory.textures++);
            }
            if (ne.samples > 0 && ze(ne) === !1) {
                pe.__webglMultisampledFramebuffer = a.createFramebuffer(), pe.__webglColorRenderbuffer = [], t.bindFramebuffer(a.FRAMEBUFFER, pe.__webglMultisampledFramebuffer);
                for(let tt = 0; tt < Te.length; tt++){
                    const gt = Te[tt];
                    pe.__webglColorRenderbuffer[tt] = a.createRenderbuffer(), a.bindRenderbuffer(a.RENDERBUFFER, pe.__webglColorRenderbuffer[tt]);
                    const pt = r.convert(gt.format, gt.colorSpace), Ge = r.convert(gt.type), Ye = R(gt.internalFormat, pt, Ge, gt.colorSpace, ne.isXRRenderTarget === !0), at = Ae(ne);
                    a.renderbufferStorageMultisample(a.RENDERBUFFER, at, Ye, ne.width, ne.height), a.framebufferRenderbuffer(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0 + tt, a.RENDERBUFFER, pe.__webglColorRenderbuffer[tt]);
                }
                a.bindRenderbuffer(a.RENDERBUFFER, null), ne.depthBuffer && (pe.__webglDepthRenderbuffer = a.createRenderbuffer(), Le(pe.__webglDepthRenderbuffer, ne, !0)), t.bindFramebuffer(a.FRAMEBUFFER, null);
            }
        }
        if (_e) {
            t.bindTexture(a.TEXTURE_CUBE_MAP, Be.__webglTexture), Z(a.TEXTURE_CUBE_MAP, W);
            for(let tt = 0; tt < 6; tt++)if (W.mipmaps && W.mipmaps.length > 0) for(let gt = 0; gt < W.mipmaps.length; gt++)xe(pe.__webglFramebuffer[tt][gt], ne, W, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + tt, gt);
            else xe(pe.__webglFramebuffer[tt], ne, W, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + tt, 0);
            M(W) && b(a.TEXTURE_CUBE_MAP), t.unbindTexture();
        } else if (ot) {
            for(let tt = 0, gt = Te.length; tt < gt; tt++){
                const pt = Te[tt], Ge = n.get(pt);
                let Ye = a.TEXTURE_2D;
                (ne.isWebGL3DRenderTarget || ne.isWebGLArrayRenderTarget) && (Ye = ne.isWebGL3DRenderTarget ? a.TEXTURE_3D : a.TEXTURE_2D_ARRAY), t.bindTexture(Ye, Ge.__webglTexture), Z(Ye, pt), xe(pe.__webglFramebuffer, ne, pt, a.COLOR_ATTACHMENT0 + tt, Ye, 0), M(pt) && b(Ye);
            }
            t.unbindTexture();
        } else {
            let tt = a.TEXTURE_2D;
            if ((ne.isWebGL3DRenderTarget || ne.isWebGLArrayRenderTarget) && (tt = ne.isWebGL3DRenderTarget ? a.TEXTURE_3D : a.TEXTURE_2D_ARRAY), t.bindTexture(tt, Be.__webglTexture), Z(tt, W), W.mipmaps && W.mipmaps.length > 0) for(let gt = 0; gt < W.mipmaps.length; gt++)xe(pe.__webglFramebuffer[gt], ne, W, a.COLOR_ATTACHMENT0, tt, gt);
            else xe(pe.__webglFramebuffer, ne, W, a.COLOR_ATTACHMENT0, tt, 0);
            M(W) && b(tt), t.unbindTexture();
        }
        ne.depthBuffer && Ne(ne);
    }
    function Re(ne) {
        const W = ne.textures;
        for(let pe = 0, Be = W.length; pe < Be; pe++){
            const Te = W[pe];
            if (M(Te)) {
                const _e = C(ne), ot = n.get(Te).__webglTexture;
                t.bindTexture(_e, ot), b(_e), t.unbindTexture();
            }
        }
    }
    const te = [], Oe = [];
    function Ie(ne) {
        if (ne.samples > 0) {
            if (ze(ne) === !1) {
                const W = ne.textures, pe = ne.width, Be = ne.height;
                let Te = a.COLOR_BUFFER_BIT;
                const _e = ne.stencilBuffer ? a.DEPTH_STENCIL_ATTACHMENT : a.DEPTH_ATTACHMENT, ot = n.get(ne), tt = W.length > 1;
                if (tt) for(let pt = 0; pt < W.length; pt++)t.bindFramebuffer(a.FRAMEBUFFER, ot.__webglMultisampledFramebuffer), a.framebufferRenderbuffer(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0 + pt, a.RENDERBUFFER, null), t.bindFramebuffer(a.FRAMEBUFFER, ot.__webglFramebuffer), a.framebufferTexture2D(a.DRAW_FRAMEBUFFER, a.COLOR_ATTACHMENT0 + pt, a.TEXTURE_2D, null, 0);
                t.bindFramebuffer(a.READ_FRAMEBUFFER, ot.__webglMultisampledFramebuffer);
                const gt = ne.texture.mipmaps;
                gt && gt.length > 0 ? t.bindFramebuffer(a.DRAW_FRAMEBUFFER, ot.__webglFramebuffer[0]) : t.bindFramebuffer(a.DRAW_FRAMEBUFFER, ot.__webglFramebuffer);
                for(let pt = 0; pt < W.length; pt++){
                    if (ne.resolveDepthBuffer && (ne.depthBuffer && (Te |= a.DEPTH_BUFFER_BIT), ne.stencilBuffer && ne.resolveStencilBuffer && (Te |= a.STENCIL_BUFFER_BIT)), tt) {
                        a.framebufferRenderbuffer(a.READ_FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.RENDERBUFFER, ot.__webglColorRenderbuffer[pt]);
                        const Ge = n.get(W[pt]).__webglTexture;
                        a.framebufferTexture2D(a.DRAW_FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_2D, Ge, 0);
                    }
                    a.blitFramebuffer(0, 0, pe, Be, 0, 0, pe, Be, Te, a.NEAREST), f === !0 && (te.length = 0, Oe.length = 0, te.push(a.COLOR_ATTACHMENT0 + pt), ne.depthBuffer && ne.resolveDepthBuffer === !1 && (te.push(_e), Oe.push(_e), a.invalidateFramebuffer(a.DRAW_FRAMEBUFFER, Oe)), a.invalidateFramebuffer(a.READ_FRAMEBUFFER, te));
                }
                if (t.bindFramebuffer(a.READ_FRAMEBUFFER, null), t.bindFramebuffer(a.DRAW_FRAMEBUFFER, null), tt) for(let pt = 0; pt < W.length; pt++){
                    t.bindFramebuffer(a.FRAMEBUFFER, ot.__webglMultisampledFramebuffer), a.framebufferRenderbuffer(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0 + pt, a.RENDERBUFFER, ot.__webglColorRenderbuffer[pt]);
                    const Ge = n.get(W[pt]).__webglTexture;
                    t.bindFramebuffer(a.FRAMEBUFFER, ot.__webglFramebuffer), a.framebufferTexture2D(a.DRAW_FRAMEBUFFER, a.COLOR_ATTACHMENT0 + pt, a.TEXTURE_2D, Ge, 0);
                }
                t.bindFramebuffer(a.DRAW_FRAMEBUFFER, ot.__webglMultisampledFramebuffer);
            } else if (ne.depthBuffer && ne.resolveDepthBuffer === !1 && f) {
                const W = ne.stencilBuffer ? a.DEPTH_STENCIL_ATTACHMENT : a.DEPTH_ATTACHMENT;
                a.invalidateFramebuffer(a.DRAW_FRAMEBUFFER, [
                    W
                ]);
            }
        }
    }
    function Ae(ne) {
        return Math.min(i.maxSamples, ne.samples);
    }
    function ze(ne) {
        const W = n.get(ne);
        return ne.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && W.__useRenderToTexture !== !1;
    }
    function Ze(ne) {
        const W = l.render.frame;
        m.get(ne) !== W && (m.set(ne, W), ne.update());
    }
    function be(ne, W) {
        const pe = ne.colorSpace, Be = ne.format, Te = ne.type;
        return ne.isCompressedTexture === !0 || ne.isVideoTexture === !0 || pe !== $455d545b1dff00eb$var$No && pe !== $455d545b1dff00eb$var$pc && ($455d545b1dff00eb$var$Dn.getTransfer(pe) === $455d545b1dff00eb$var$Zn ? (Be !== $455d545b1dff00eb$var$ar || Te !== $455d545b1dff00eb$var$Ws) && $455d545b1dff00eb$var$Mt("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : $455d545b1dff00eb$var$Qt("WebGLTextures: Unsupported texture color space:", pe)), W;
    }
    function rt(ne) {
        return typeof HTMLImageElement < "u" && ne instanceof HTMLImageElement ? (p.width = ne.naturalWidth || ne.width, p.height = ne.naturalHeight || ne.height) : typeof VideoFrame < "u" && ne instanceof VideoFrame ? (p.width = ne.displayWidth, p.height = ne.displayHeight) : (p.width = ne.width, p.height = ne.height), p;
    }
    this.allocateTextureUnit = q, this.resetTextureUnits = G, this.setTexture2D = ae, this.setTexture2DArray = F, this.setTexture3D = Q, this.setTextureCube = K, this.rebindTextures = ke, this.setupRenderTarget = nt, this.updateRenderTargetMipmap = Re, this.updateMultisampleRenderTarget = Ie, this.setupDepthRenderbuffer = Ne, this.setupFrameBufferTexture = xe, this.useMultisampledRTT = ze;
}
function $455d545b1dff00eb$var$AA(a, e) {
    function t(n, i = $455d545b1dff00eb$var$pc) {
        let r;
        const l = $455d545b1dff00eb$var$Dn.getTransfer(i);
        if (n === $455d545b1dff00eb$var$Ws) return a.UNSIGNED_BYTE;
        if (n === $455d545b1dff00eb$var$iy) return a.UNSIGNED_SHORT_4_4_4_4;
        if (n === $455d545b1dff00eb$var$ay) return a.UNSIGNED_SHORT_5_5_5_1;
        if (n === $455d545b1dff00eb$var$Ob) return a.UNSIGNED_INT_5_9_9_9_REV;
        if (n === $455d545b1dff00eb$var$Lb) return a.UNSIGNED_INT_10F_11F_11F_REV;
        if (n === $455d545b1dff00eb$var$Ub) return a.BYTE;
        if (n === $455d545b1dff00eb$var$Nb) return a.SHORT;
        if (n === $455d545b1dff00eb$var$Od) return a.UNSIGNED_SHORT;
        if (n === $455d545b1dff00eb$var$ny) return a.INT;
        if (n === $455d545b1dff00eb$var$Mc) return a.UNSIGNED_INT;
        if (n === $455d545b1dff00eb$var$Rr) return a.FLOAT;
        if (n === $455d545b1dff00eb$var$wu) return a.HALF_FLOAT;
        if (n === $455d545b1dff00eb$var$zb) return a.ALPHA;
        if (n === $455d545b1dff00eb$var$Pb) return a.RGB;
        if (n === $455d545b1dff00eb$var$ar) return a.RGBA;
        if (n === $455d545b1dff00eb$var$zd) return a.DEPTH_COMPONENT;
        if (n === $455d545b1dff00eb$var$Pd) return a.DEPTH_STENCIL;
        if (n === $455d545b1dff00eb$var$ry) return a.RED;
        if (n === $455d545b1dff00eb$var$M0) return a.RED_INTEGER;
        if (n === $455d545b1dff00eb$var$sy) return a.RG;
        if (n === $455d545b1dff00eb$var$oy) return a.RG_INTEGER;
        if (n === $455d545b1dff00eb$var$ly) return a.RGBA_INTEGER;
        if (n === $455d545b1dff00eb$var$Hm || n === $455d545b1dff00eb$var$Vm || n === $455d545b1dff00eb$var$Gm || n === $455d545b1dff00eb$var$km) {
            if (l === $455d545b1dff00eb$var$Zn) {
                if (r = e.get("WEBGL_compressed_texture_s3tc_srgb"), r !== null) {
                    if (n === $455d545b1dff00eb$var$Hm) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (n === $455d545b1dff00eb$var$Vm) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (n === $455d545b1dff00eb$var$Gm) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (n === $455d545b1dff00eb$var$km) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (r = e.get("WEBGL_compressed_texture_s3tc"), r !== null) {
                if (n === $455d545b1dff00eb$var$Hm) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (n === $455d545b1dff00eb$var$Vm) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (n === $455d545b1dff00eb$var$Gm) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (n === $455d545b1dff00eb$var$km) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (n === $455d545b1dff00eb$var$uv || n === $455d545b1dff00eb$var$fv || n === $455d545b1dff00eb$var$hv || n === $455d545b1dff00eb$var$dv) {
            if (r = e.get("WEBGL_compressed_texture_pvrtc"), r !== null) {
                if (n === $455d545b1dff00eb$var$uv) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (n === $455d545b1dff00eb$var$fv) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (n === $455d545b1dff00eb$var$hv) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (n === $455d545b1dff00eb$var$dv) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (n === $455d545b1dff00eb$var$pv || n === $455d545b1dff00eb$var$mv || n === $455d545b1dff00eb$var$gv) {
            if (r = e.get("WEBGL_compressed_texture_etc"), r !== null) {
                if (n === $455d545b1dff00eb$var$pv || n === $455d545b1dff00eb$var$mv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
                if (n === $455d545b1dff00eb$var$gv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (n === $455d545b1dff00eb$var$xv || n === $455d545b1dff00eb$var$vv || n === $455d545b1dff00eb$var$yv || n === $455d545b1dff00eb$var$_v || n === $455d545b1dff00eb$var$bv || n === $455d545b1dff00eb$var$Sv || n === $455d545b1dff00eb$var$Mv || n === $455d545b1dff00eb$var$Ev || n === $455d545b1dff00eb$var$Tv || n === $455d545b1dff00eb$var$Av || n === $455d545b1dff00eb$var$wv || n === $455d545b1dff00eb$var$Cv || n === $455d545b1dff00eb$var$Rv || n === $455d545b1dff00eb$var$Dv) {
            if (r = e.get("WEBGL_compressed_texture_astc"), r !== null) {
                if (n === $455d545b1dff00eb$var$xv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (n === $455d545b1dff00eb$var$vv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (n === $455d545b1dff00eb$var$yv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (n === $455d545b1dff00eb$var$_v) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (n === $455d545b1dff00eb$var$bv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (n === $455d545b1dff00eb$var$Sv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (n === $455d545b1dff00eb$var$Mv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (n === $455d545b1dff00eb$var$Ev) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (n === $455d545b1dff00eb$var$Tv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (n === $455d545b1dff00eb$var$Av) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (n === $455d545b1dff00eb$var$wv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (n === $455d545b1dff00eb$var$Cv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (n === $455d545b1dff00eb$var$Rv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (n === $455d545b1dff00eb$var$Dv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (n === $455d545b1dff00eb$var$Uv || n === $455d545b1dff00eb$var$Nv || n === $455d545b1dff00eb$var$Ov) {
            if (r = e.get("EXT_texture_compression_bptc"), r !== null) {
                if (n === $455d545b1dff00eb$var$Uv) return l === $455d545b1dff00eb$var$Zn ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (n === $455d545b1dff00eb$var$Nv) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (n === $455d545b1dff00eb$var$Ov) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        if (n === $455d545b1dff00eb$var$Lv || n === $455d545b1dff00eb$var$zv || n === $455d545b1dff00eb$var$Pv || n === $455d545b1dff00eb$var$Bv) {
            if (r = e.get("EXT_texture_compression_rgtc"), r !== null) {
                if (n === $455d545b1dff00eb$var$Lv) return r.COMPRESSED_RED_RGTC1_EXT;
                if (n === $455d545b1dff00eb$var$zv) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (n === $455d545b1dff00eb$var$Pv) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (n === $455d545b1dff00eb$var$Bv) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return n === $455d545b1dff00eb$var$Ld ? a.UNSIGNED_INT_24_8 : a[n] !== void 0 ? a[n] : null;
    }
    return {
        convert: t
    };
}
const $455d545b1dff00eb$var$lP = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, $455d545b1dff00eb$var$cP = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $455d545b1dff00eb$var$uP {
    constructor(){
        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
    }
    init(e, t) {
        if (this.texture === null) {
            const n = new $455d545b1dff00eb$var$Zb(e.texture);
            (e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) && (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = n;
        }
    }
    getMesh(e) {
        if (this.texture !== null && this.mesh === null) {
            const t = e.cameras[0].viewport, n = new $455d545b1dff00eb$var$qs({
                vertexShader: $455d545b1dff00eb$var$lP,
                fragmentShader: $455d545b1dff00eb$var$cP,
                uniforms: {
                    depthColor: {
                        value: this.texture
                    },
                    depthWidth: {
                        value: t.z
                    },
                    depthHeight: {
                        value: t.w
                    }
                }
            });
            this.mesh = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Jr(20, 20), n);
        }
        return this.mesh;
    }
    reset() {
        this.texture = null, this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $455d545b1dff00eb$var$fP extends $455d545b1dff00eb$var$Ml {
    constructor(e, t){
        super();
        const n = this;
        let i = null, r = 1, l = null, c = "local-floor", f = 1, p = null, m = null, x = null, v = null, _ = null, S = null;
        const A = typeof XRWebGLBinding < "u", M = new $455d545b1dff00eb$var$uP, b = {}, C = t.getContextAttributes();
        let R = null, N = null;
        const z = [], L = [], P = new $455d545b1dff00eb$var$$e;
        let H = null;
        const O = new $455d545b1dff00eb$var$Ui;
        O.viewport = new $455d545b1dff00eb$var$Un;
        const D = new $455d545b1dff00eb$var$Ui;
        D.viewport = new $455d545b1dff00eb$var$Un;
        const j = [
            O,
            D
        ], G = new $455d545b1dff00eb$var$mA;
        let q = null, Y = null;
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(ue) {
            let le = z[ue];
            return le === void 0 && (le = new $455d545b1dff00eb$var$qx, z[ue] = le), le.getTargetRaySpace();
        }, this.getControllerGrip = function(ue) {
            let le = z[ue];
            return le === void 0 && (le = new $455d545b1dff00eb$var$qx, z[ue] = le), le.getGripSpace();
        }, this.getHand = function(ue) {
            let le = z[ue];
            return le === void 0 && (le = new $455d545b1dff00eb$var$qx, z[ue] = le), le.getHandSpace();
        };
        function ae(ue) {
            const le = L.indexOf(ue.inputSource);
            if (le === -1) return;
            const xe = z[le];
            xe !== void 0 && (xe.update(ue.inputSource, ue.frame, p || l), xe.dispatchEvent({
                type: ue.type,
                data: ue.inputSource
            }));
        }
        function F() {
            i.removeEventListener("select", ae), i.removeEventListener("selectstart", ae), i.removeEventListener("selectend", ae), i.removeEventListener("squeeze", ae), i.removeEventListener("squeezestart", ae), i.removeEventListener("squeezeend", ae), i.removeEventListener("end", F), i.removeEventListener("inputsourceschange", Q);
            for(let ue = 0; ue < z.length; ue++){
                const le = L[ue];
                le !== null && (L[ue] = null, z[ue].disconnect(le));
            }
            q = null, Y = null, M.reset();
            for(const ue in b)delete b[ue];
            e.setRenderTarget(R), _ = null, v = null, x = null, i = null, N = null, de.stop(), n.isPresenting = !1, e.setPixelRatio(H), e.setSize(P.width, P.height, !1), n.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(ue) {
            r = ue, n.isPresenting === !0 && $455d545b1dff00eb$var$Mt("WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(ue) {
            c = ue, n.isPresenting === !0 && $455d545b1dff00eb$var$Mt("WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return p || l;
        }, this.setReferenceSpace = function(ue) {
            p = ue;
        }, this.getBaseLayer = function() {
            return v !== null ? v : _;
        }, this.getBinding = function() {
            return x === null && A && (x = new XRWebGLBinding(i, t)), x;
        }, this.getFrame = function() {
            return S;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(ue) {
            if (i = ue, i !== null) {
                if (R = e.getRenderTarget(), i.addEventListener("select", ae), i.addEventListener("selectstart", ae), i.addEventListener("selectend", ae), i.addEventListener("squeeze", ae), i.addEventListener("squeezestart", ae), i.addEventListener("squeezeend", ae), i.addEventListener("end", F), i.addEventListener("inputsourceschange", Q), C.xrCompatible !== !0 && await t.makeXRCompatible(), H = e.getPixelRatio(), e.getSize(P), A && "createProjectionLayer" in XRWebGLBinding.prototype) {
                    let xe = null, Le = null, Ue = null;
                    C.depth && (Ue = C.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, xe = C.stencil ? $455d545b1dff00eb$var$Pd : $455d545b1dff00eb$var$zd, Le = C.stencil ? $455d545b1dff00eb$var$Ld : $455d545b1dff00eb$var$Mc);
                    const Ne = {
                        colorFormat: t.RGBA8,
                        depthFormat: Ue,
                        scaleFactor: r
                    };
                    x = this.getBinding(), v = x.createProjectionLayer(Ne), i.updateRenderState({
                        layers: [
                            v
                        ]
                    }), e.setPixelRatio(1), e.setSize(v.textureWidth, v.textureHeight, !1), N = new $455d545b1dff00eb$var$Oo(v.textureWidth, v.textureHeight, {
                        format: $455d545b1dff00eb$var$ar,
                        type: $455d545b1dff00eb$var$Ws,
                        depthTexture: new $455d545b1dff00eb$var$yy(v.textureWidth, v.textureHeight, Le, void 0, void 0, void 0, void 0, void 0, void 0, xe),
                        stencilBuffer: C.stencil,
                        colorSpace: e.outputColorSpace,
                        samples: C.antialias ? 4 : 0,
                        resolveDepthBuffer: v.ignoreDepthValues === !1,
                        resolveStencilBuffer: v.ignoreDepthValues === !1
                    });
                } else {
                    const xe = {
                        antialias: C.antialias,
                        alpha: !0,
                        depth: C.depth,
                        stencil: C.stencil,
                        framebufferScaleFactor: r
                    };
                    _ = new XRWebGLLayer(i, t, xe), i.updateRenderState({
                        baseLayer: _
                    }), e.setPixelRatio(1), e.setSize(_.framebufferWidth, _.framebufferHeight, !1), N = new $455d545b1dff00eb$var$Oo(_.framebufferWidth, _.framebufferHeight, {
                        format: $455d545b1dff00eb$var$ar,
                        type: $455d545b1dff00eb$var$Ws,
                        colorSpace: e.outputColorSpace,
                        stencilBuffer: C.stencil,
                        resolveDepthBuffer: _.ignoreDepthValues === !1,
                        resolveStencilBuffer: _.ignoreDepthValues === !1
                    });
                }
                N.isXRRenderTarget = !0, this.setFoveation(f), p = null, l = await i.requestReferenceSpace(c), de.setContext(i), de.start(), n.isPresenting = !0, n.dispatchEvent({
                    type: "sessionstart"
                });
            }
        }, this.getEnvironmentBlendMode = function() {
            if (i !== null) return i.environmentBlendMode;
        }, this.getDepthTexture = function() {
            return M.getDepthTexture();
        };
        function Q(ue) {
            for(let le = 0; le < ue.removed.length; le++){
                const xe = ue.removed[le], Le = L.indexOf(xe);
                Le >= 0 && (L[Le] = null, z[Le].disconnect(xe));
            }
            for(let le = 0; le < ue.added.length; le++){
                const xe = ue.added[le];
                let Le = L.indexOf(xe);
                if (Le === -1) {
                    for(let Ne = 0; Ne < z.length; Ne++)if (Ne >= L.length) {
                        L.push(xe), Le = Ne;
                        break;
                    } else if (L[Ne] === null) {
                        L[Ne] = xe, Le = Ne;
                        break;
                    }
                    if (Le === -1) break;
                }
                const Ue = z[Le];
                Ue && Ue.connect(xe);
            }
        }
        const K = new $455d545b1dff00eb$var$J, $ = new $455d545b1dff00eb$var$J;
        function ee(ue, le, xe) {
            K.setFromMatrixPosition(le.matrixWorld), $.setFromMatrixPosition(xe.matrixWorld);
            const Le = K.distanceTo($), Ue = le.projectionMatrix.elements, Ne = xe.projectionMatrix.elements, ke = Ue[14] / (Ue[10] - 1), nt = Ue[14] / (Ue[10] + 1), Re = (Ue[9] + 1) / Ue[5], te = (Ue[9] - 1) / Ue[5], Oe = (Ue[8] - 1) / Ue[0], Ie = (Ne[8] + 1) / Ne[0], Ae = ke * Oe, ze = ke * Ie, Ze = Le / (-Oe + Ie), be = Ze * -Oe;
            if (le.matrixWorld.decompose(ue.position, ue.quaternion, ue.scale), ue.translateX(be), ue.translateZ(Ze), ue.matrixWorld.compose(ue.position, ue.quaternion, ue.scale), ue.matrixWorldInverse.copy(ue.matrixWorld).invert(), Ue[10] === -1) ue.projectionMatrix.copy(le.projectionMatrix), ue.projectionMatrixInverse.copy(le.projectionMatrixInverse);
            else {
                const rt = ke + Ze, ne = nt + Ze, W = Ae - be, pe = ze + (Le - be), Be = Re * nt / ne * rt, Te = te * nt / ne * rt;
                ue.projectionMatrix.makePerspective(W, pe, Be, Te, rt, ne), ue.projectionMatrixInverse.copy(ue.projectionMatrix).invert();
            }
        }
        function I(ue, le) {
            le === null ? ue.matrixWorld.copy(ue.matrix) : ue.matrixWorld.multiplyMatrices(le.matrixWorld, ue.matrix), ue.matrixWorldInverse.copy(ue.matrixWorld).invert();
        }
        this.updateCamera = function(ue) {
            if (i === null) return;
            let le = ue.near, xe = ue.far;
            M.texture !== null && (M.depthNear > 0 && (le = M.depthNear), M.depthFar > 0 && (xe = M.depthFar)), G.near = D.near = O.near = le, G.far = D.far = O.far = xe, (q !== G.near || Y !== G.far) && (i.updateRenderState({
                depthNear: G.near,
                depthFar: G.far
            }), q = G.near, Y = G.far), G.layers.mask = ue.layers.mask | 6, O.layers.mask = G.layers.mask & 3, D.layers.mask = G.layers.mask & 5;
            const Le = ue.parent, Ue = G.cameras;
            I(G, Le);
            for(let Ne = 0; Ne < Ue.length; Ne++)I(Ue[Ne], Le);
            Ue.length === 2 ? ee(G, O, D) : G.projectionMatrix.copy(O.projectionMatrix), Z(ue, G, Le);
        };
        function Z(ue, le, xe) {
            xe === null ? ue.matrix.copy(le.matrixWorld) : (ue.matrix.copy(xe.matrixWorld), ue.matrix.invert(), ue.matrix.multiply(le.matrixWorld)), ue.matrix.decompose(ue.position, ue.quaternion, ue.scale), ue.updateMatrixWorld(!0), ue.projectionMatrix.copy(le.projectionMatrix), ue.projectionMatrixInverse.copy(le.projectionMatrixInverse), ue.isPerspectiveCamera && (ue.fov = $455d545b1dff00eb$var$Fd * 2 * Math.atan(1 / ue.projectionMatrix.elements[5]), ue.zoom = 1);
        }
        this.getCamera = function() {
            return G;
        }, this.getFoveation = function() {
            if (!(v === null && _ === null)) return f;
        }, this.setFoveation = function(ue) {
            f = ue, v !== null && (v.fixedFoveation = ue), _ !== null && _.fixedFoveation !== void 0 && (_.fixedFoveation = ue);
        }, this.hasDepthSensing = function() {
            return M.texture !== null;
        }, this.getDepthSensingMesh = function() {
            return M.getMesh(G);
        }, this.getCameraTexture = function(ue) {
            return b[ue];
        };
        let oe = null;
        function ce(ue, le) {
            if (m = le.getViewerPose(p || l), S = le, m !== null) {
                const xe = m.views;
                _ !== null && (e.setRenderTargetFramebuffer(N, _.framebuffer), e.setRenderTarget(N));
                let Le = !1;
                xe.length !== G.cameras.length && (G.cameras.length = 0, Le = !0);
                for(let nt = 0; nt < xe.length; nt++){
                    const Re = xe[nt];
                    let te = null;
                    if (_ !== null) te = _.getViewport(Re);
                    else {
                        const Ie = x.getViewSubImage(v, Re);
                        te = Ie.viewport, nt === 0 && (e.setRenderTargetTextures(N, Ie.colorTexture, Ie.depthStencilTexture), e.setRenderTarget(N));
                    }
                    let Oe = j[nt];
                    Oe === void 0 && (Oe = new $455d545b1dff00eb$var$Ui, Oe.layers.enable(nt), Oe.viewport = new $455d545b1dff00eb$var$Un, j[nt] = Oe), Oe.matrix.fromArray(Re.transform.matrix), Oe.matrix.decompose(Oe.position, Oe.quaternion, Oe.scale), Oe.projectionMatrix.fromArray(Re.projectionMatrix), Oe.projectionMatrixInverse.copy(Oe.projectionMatrix).invert(), Oe.viewport.set(te.x, te.y, te.width, te.height), nt === 0 && (G.matrix.copy(Oe.matrix), G.matrix.decompose(G.position, G.quaternion, G.scale)), Le === !0 && G.cameras.push(Oe);
                }
                const Ue = i.enabledFeatures;
                if (Ue && Ue.includes("depth-sensing") && i.depthUsage == "gpu-optimized" && A) {
                    x = n.getBinding();
                    const nt = x.getDepthInformation(xe[0]);
                    nt && nt.isValid && nt.texture && M.init(nt, i.renderState);
                }
                if (Ue && Ue.includes("camera-access") && A) {
                    e.state.unbindTexture(), x = n.getBinding();
                    for(let nt = 0; nt < xe.length; nt++){
                        const Re = xe[nt].camera;
                        if (Re) {
                            let te = b[Re];
                            te || (te = new $455d545b1dff00eb$var$Zb, b[Re] = te);
                            const Oe = x.getCameraImage(Re);
                            te.sourceTexture = Oe;
                        }
                    }
                }
            }
            for(let xe = 0; xe < z.length; xe++){
                const Le = L[xe], Ue = z[xe];
                Le !== null && Ue !== void 0 && Ue.update(Le, le, p || l);
            }
            oe && oe(ue, le), le.detectedPlanes && n.dispatchEvent({
                type: "planesdetected",
                data: le
            }), S = null;
        }
        const de = new $455d545b1dff00eb$var$bA;
        de.setAnimationLoop(ce), this.setAnimationLoop = function(ue) {
            oe = ue;
        }, this.dispose = function() {};
    }
}
const $455d545b1dff00eb$var$Df = new $455d545b1dff00eb$var$ua, $455d545b1dff00eb$var$hP = new $455d545b1dff00eb$var$Ft;
function $455d545b1dff00eb$var$dP(a, e) {
    function t(M, b) {
        M.matrixAutoUpdate === !0 && M.updateMatrix(), b.value.copy(M.matrix);
    }
    function n(M, b) {
        b.color.getRGB(M.fogColor.value, $455d545b1dff00eb$var$ST(a)), b.isFog ? (M.fogNear.value = b.near, M.fogFar.value = b.far) : b.isFogExp2 && (M.fogDensity.value = b.density);
    }
    function i(M, b, C, R, N) {
        b.isMeshBasicMaterial || b.isMeshLambertMaterial ? r(M, b) : b.isMeshToonMaterial ? (r(M, b), x(M, b)) : b.isMeshPhongMaterial ? (r(M, b), m(M, b)) : b.isMeshStandardMaterial ? (r(M, b), v(M, b), b.isMeshPhysicalMaterial && _(M, b, N)) : b.isMeshMatcapMaterial ? (r(M, b), S(M, b)) : b.isMeshDepthMaterial ? r(M, b) : b.isMeshDistanceMaterial ? (r(M, b), A(M, b)) : b.isMeshNormalMaterial ? r(M, b) : b.isLineBasicMaterial ? (l(M, b), b.isLineDashedMaterial && c(M, b)) : b.isPointsMaterial ? f(M, b, C, R) : b.isSpriteMaterial ? p(M, b) : b.isShadowMaterial ? (M.color.value.copy(b.color), M.opacity.value = b.opacity) : b.isShaderMaterial && (b.uniformsNeedUpdate = !1);
    }
    function r(M, b) {
        M.opacity.value = b.opacity, b.color && M.diffuse.value.copy(b.color), b.emissive && M.emissive.value.copy(b.emissive).multiplyScalar(b.emissiveIntensity), b.map && (M.map.value = b.map, t(b.map, M.mapTransform)), b.alphaMap && (M.alphaMap.value = b.alphaMap, t(b.alphaMap, M.alphaMapTransform)), b.bumpMap && (M.bumpMap.value = b.bumpMap, t(b.bumpMap, M.bumpMapTransform), M.bumpScale.value = b.bumpScale, b.side === $455d545b1dff00eb$var$Dr && (M.bumpScale.value *= -1)), b.normalMap && (M.normalMap.value = b.normalMap, t(b.normalMap, M.normalMapTransform), M.normalScale.value.copy(b.normalScale), b.side === $455d545b1dff00eb$var$Dr && M.normalScale.value.negate()), b.displacementMap && (M.displacementMap.value = b.displacementMap, t(b.displacementMap, M.displacementMapTransform), M.displacementScale.value = b.displacementScale, M.displacementBias.value = b.displacementBias), b.emissiveMap && (M.emissiveMap.value = b.emissiveMap, t(b.emissiveMap, M.emissiveMapTransform)), b.specularMap && (M.specularMap.value = b.specularMap, t(b.specularMap, M.specularMapTransform)), b.alphaTest > 0 && (M.alphaTest.value = b.alphaTest);
        const C = e.get(b), R = C.envMap, N = C.envMapRotation;
        R && (M.envMap.value = R, $455d545b1dff00eb$var$Df.copy(N), $455d545b1dff00eb$var$Df.x *= -1, $455d545b1dff00eb$var$Df.y *= -1, $455d545b1dff00eb$var$Df.z *= -1, R.isCubeTexture && R.isRenderTargetTexture === !1 && ($455d545b1dff00eb$var$Df.y *= -1, $455d545b1dff00eb$var$Df.z *= -1), M.envMapRotation.value.setFromMatrix4($455d545b1dff00eb$var$hP.makeRotationFromEuler($455d545b1dff00eb$var$Df)), M.flipEnvMap.value = R.isCubeTexture && R.isRenderTargetTexture === !1 ? -1 : 1, M.reflectivity.value = b.reflectivity, M.ior.value = b.ior, M.refractionRatio.value = b.refractionRatio), b.lightMap && (M.lightMap.value = b.lightMap, M.lightMapIntensity.value = b.lightMapIntensity, t(b.lightMap, M.lightMapTransform)), b.aoMap && (M.aoMap.value = b.aoMap, M.aoMapIntensity.value = b.aoMapIntensity, t(b.aoMap, M.aoMapTransform));
    }
    function l(M, b) {
        M.diffuse.value.copy(b.color), M.opacity.value = b.opacity, b.map && (M.map.value = b.map, t(b.map, M.mapTransform));
    }
    function c(M, b) {
        M.dashSize.value = b.dashSize, M.totalSize.value = b.dashSize + b.gapSize, M.scale.value = b.scale;
    }
    function f(M, b, C, R) {
        M.diffuse.value.copy(b.color), M.opacity.value = b.opacity, M.size.value = b.size * C, M.scale.value = R * .5, b.map && (M.map.value = b.map, t(b.map, M.uvTransform)), b.alphaMap && (M.alphaMap.value = b.alphaMap, t(b.alphaMap, M.alphaMapTransform)), b.alphaTest > 0 && (M.alphaTest.value = b.alphaTest);
    }
    function p(M, b) {
        M.diffuse.value.copy(b.color), M.opacity.value = b.opacity, M.rotation.value = b.rotation, b.map && (M.map.value = b.map, t(b.map, M.mapTransform)), b.alphaMap && (M.alphaMap.value = b.alphaMap, t(b.alphaMap, M.alphaMapTransform)), b.alphaTest > 0 && (M.alphaTest.value = b.alphaTest);
    }
    function m(M, b) {
        M.specular.value.copy(b.specular), M.shininess.value = Math.max(b.shininess, 1e-4);
    }
    function x(M, b) {
        b.gradientMap && (M.gradientMap.value = b.gradientMap);
    }
    function v(M, b) {
        M.metalness.value = b.metalness, b.metalnessMap && (M.metalnessMap.value = b.metalnessMap, t(b.metalnessMap, M.metalnessMapTransform)), M.roughness.value = b.roughness, b.roughnessMap && (M.roughnessMap.value = b.roughnessMap, t(b.roughnessMap, M.roughnessMapTransform)), b.envMap && (M.envMapIntensity.value = b.envMapIntensity);
    }
    function _(M, b, C) {
        M.ior.value = b.ior, b.sheen > 0 && (M.sheenColor.value.copy(b.sheenColor).multiplyScalar(b.sheen), M.sheenRoughness.value = b.sheenRoughness, b.sheenColorMap && (M.sheenColorMap.value = b.sheenColorMap, t(b.sheenColorMap, M.sheenColorMapTransform)), b.sheenRoughnessMap && (M.sheenRoughnessMap.value = b.sheenRoughnessMap, t(b.sheenRoughnessMap, M.sheenRoughnessMapTransform))), b.clearcoat > 0 && (M.clearcoat.value = b.clearcoat, M.clearcoatRoughness.value = b.clearcoatRoughness, b.clearcoatMap && (M.clearcoatMap.value = b.clearcoatMap, t(b.clearcoatMap, M.clearcoatMapTransform)), b.clearcoatRoughnessMap && (M.clearcoatRoughnessMap.value = b.clearcoatRoughnessMap, t(b.clearcoatRoughnessMap, M.clearcoatRoughnessMapTransform)), b.clearcoatNormalMap && (M.clearcoatNormalMap.value = b.clearcoatNormalMap, t(b.clearcoatNormalMap, M.clearcoatNormalMapTransform), M.clearcoatNormalScale.value.copy(b.clearcoatNormalScale), b.side === $455d545b1dff00eb$var$Dr && M.clearcoatNormalScale.value.negate())), b.dispersion > 0 && (M.dispersion.value = b.dispersion), b.iridescence > 0 && (M.iridescence.value = b.iridescence, M.iridescenceIOR.value = b.iridescenceIOR, M.iridescenceThicknessMinimum.value = b.iridescenceThicknessRange[0], M.iridescenceThicknessMaximum.value = b.iridescenceThicknessRange[1], b.iridescenceMap && (M.iridescenceMap.value = b.iridescenceMap, t(b.iridescenceMap, M.iridescenceMapTransform)), b.iridescenceThicknessMap && (M.iridescenceThicknessMap.value = b.iridescenceThicknessMap, t(b.iridescenceThicknessMap, M.iridescenceThicknessMapTransform))), b.transmission > 0 && (M.transmission.value = b.transmission, M.transmissionSamplerMap.value = C.texture, M.transmissionSamplerSize.value.set(C.width, C.height), b.transmissionMap && (M.transmissionMap.value = b.transmissionMap, t(b.transmissionMap, M.transmissionMapTransform)), M.thickness.value = b.thickness, b.thicknessMap && (M.thicknessMap.value = b.thicknessMap, t(b.thicknessMap, M.thicknessMapTransform)), M.attenuationDistance.value = b.attenuationDistance, M.attenuationColor.value.copy(b.attenuationColor)), b.anisotropy > 0 && (M.anisotropyVector.value.set(b.anisotropy * Math.cos(b.anisotropyRotation), b.anisotropy * Math.sin(b.anisotropyRotation)), b.anisotropyMap && (M.anisotropyMap.value = b.anisotropyMap, t(b.anisotropyMap, M.anisotropyMapTransform))), M.specularIntensity.value = b.specularIntensity, M.specularColor.value.copy(b.specularColor), b.specularColorMap && (M.specularColorMap.value = b.specularColorMap, t(b.specularColorMap, M.specularColorMapTransform)), b.specularIntensityMap && (M.specularIntensityMap.value = b.specularIntensityMap, t(b.specularIntensityMap, M.specularIntensityMapTransform));
    }
    function S(M, b) {
        b.matcap && (M.matcap.value = b.matcap);
    }
    function A(M, b) {
        const C = e.get(b).light;
        M.referencePosition.value.setFromMatrixPosition(C.matrixWorld), M.nearDistance.value = C.shadow.camera.near, M.farDistance.value = C.shadow.camera.far;
    }
    return {
        refreshFogUniforms: n,
        refreshMaterialUniforms: i
    };
}
function $455d545b1dff00eb$var$pP(a, e, t, n) {
    let i = {}, r = {}, l = [];
    const c = a.getParameter(a.MAX_UNIFORM_BUFFER_BINDINGS);
    function f(C, R) {
        const N = R.program;
        n.uniformBlockBinding(C, N);
    }
    function p(C, R) {
        let N = i[C.id];
        N === void 0 && (S(C), N = m(C), i[C.id] = N, C.addEventListener("dispose", M));
        const z = R.program;
        n.updateUBOMapping(C, z);
        const L = e.render.frame;
        r[C.id] !== L && (v(C), r[C.id] = L);
    }
    function m(C) {
        const R = x();
        C.__bindingPointIndex = R;
        const N = a.createBuffer(), z = C.__size, L = C.usage;
        return a.bindBuffer(a.UNIFORM_BUFFER, N), a.bufferData(a.UNIFORM_BUFFER, z, L), a.bindBuffer(a.UNIFORM_BUFFER, null), a.bindBufferBase(a.UNIFORM_BUFFER, R, N), N;
    }
    function x() {
        for(let C = 0; C < c; C++)if (l.indexOf(C) === -1) return l.push(C), C;
        return $455d545b1dff00eb$var$Qt("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function v(C) {
        const R = i[C.id], N = C.uniforms, z = C.__cache;
        a.bindBuffer(a.UNIFORM_BUFFER, R);
        for(let L = 0, P = N.length; L < P; L++){
            const H = Array.isArray(N[L]) ? N[L] : [
                N[L]
            ];
            for(let O = 0, D = H.length; O < D; O++){
                const j = H[O];
                if (_(j, L, O, z) === !0) {
                    const G = j.__offset, q = Array.isArray(j.value) ? j.value : [
                        j.value
                    ];
                    let Y = 0;
                    for(let ae = 0; ae < q.length; ae++){
                        const F = q[ae], Q = A(F);
                        typeof F == "number" || typeof F == "boolean" ? (j.__data[0] = F, a.bufferSubData(a.UNIFORM_BUFFER, G + Y, j.__data)) : F.isMatrix3 ? (j.__data[0] = F.elements[0], j.__data[1] = F.elements[1], j.__data[2] = F.elements[2], j.__data[3] = 0, j.__data[4] = F.elements[3], j.__data[5] = F.elements[4], j.__data[6] = F.elements[5], j.__data[7] = 0, j.__data[8] = F.elements[6], j.__data[9] = F.elements[7], j.__data[10] = F.elements[8], j.__data[11] = 0) : (F.toArray(j.__data, Y), Y += Q.storage / Float32Array.BYTES_PER_ELEMENT);
                    }
                    a.bufferSubData(a.UNIFORM_BUFFER, G, j.__data);
                }
            }
        }
        a.bindBuffer(a.UNIFORM_BUFFER, null);
    }
    function _(C, R, N, z) {
        const L = C.value, P = R + "_" + N;
        if (z[P] === void 0) return typeof L == "number" || typeof L == "boolean" ? z[P] = L : z[P] = L.clone(), !0;
        {
            const H = z[P];
            if (typeof L == "number" || typeof L == "boolean") {
                if (H !== L) return z[P] = L, !0;
            } else if (H.equals(L) === !1) return H.copy(L), !0;
        }
        return !1;
    }
    function S(C) {
        const R = C.uniforms;
        let N = 0;
        const z = 16;
        for(let P = 0, H = R.length; P < H; P++){
            const O = Array.isArray(R[P]) ? R[P] : [
                R[P]
            ];
            for(let D = 0, j = O.length; D < j; D++){
                const G = O[D], q = Array.isArray(G.value) ? G.value : [
                    G.value
                ];
                for(let Y = 0, ae = q.length; Y < ae; Y++){
                    const F = q[Y], Q = A(F), K = N % z, $ = K % Q.boundary, ee = K + $;
                    N += $, ee !== 0 && z - ee < Q.storage && (N += z - ee), G.__data = new Float32Array(Q.storage / Float32Array.BYTES_PER_ELEMENT), G.__offset = N, N += Q.storage;
                }
            }
        }
        const L = N % z;
        return L > 0 && (N += z - L), C.__size = N, C.__cache = {}, this;
    }
    function A(C) {
        const R = {
            boundary: 0,
            storage: 0
        };
        return typeof C == "number" || typeof C == "boolean" ? (R.boundary = 4, R.storage = 4) : C.isVector2 ? (R.boundary = 8, R.storage = 8) : C.isVector3 || C.isColor ? (R.boundary = 16, R.storage = 12) : C.isVector4 ? (R.boundary = 16, R.storage = 16) : C.isMatrix3 ? (R.boundary = 48, R.storage = 48) : C.isMatrix4 ? (R.boundary = 64, R.storage = 64) : C.isTexture ? $455d545b1dff00eb$var$Mt("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : $455d545b1dff00eb$var$Mt("WebGLRenderer: Unsupported uniform value type.", C), R;
    }
    function M(C) {
        const R = C.target;
        R.removeEventListener("dispose", M);
        const N = l.indexOf(R.__bindingPointIndex);
        l.splice(N, 1), a.deleteBuffer(i[R.id]), delete i[R.id], delete r[R.id];
    }
    function b() {
        for(const C in i)a.deleteBuffer(i[C]);
        l = [], i = {}, r = {};
    }
    return {
        bind: f,
        update: p,
        dispose: b
    };
}
const $455d545b1dff00eb$var$mP = new Uint16Array([
    11481,
    15204,
    11534,
    15171,
    11808,
    15015,
    12385,
    14843,
    12894,
    14716,
    13396,
    14600,
    13693,
    14483,
    13976,
    14366,
    14237,
    14171,
    14405,
    13961,
    14511,
    13770,
    14605,
    13598,
    14687,
    13444,
    14760,
    13305,
    14822,
    13066,
    14876,
    12857,
    14923,
    12675,
    14963,
    12517,
    14997,
    12379,
    15025,
    12230,
    15049,
    12023,
    15070,
    11843,
    15086,
    11687,
    15100,
    11551,
    15111,
    11433,
    15120,
    11330,
    15127,
    11217,
    15132,
    11060,
    15135,
    10922,
    15138,
    10801,
    15139,
    10695,
    15139,
    10600,
    13012,
    14923,
    13020,
    14917,
    13064,
    14886,
    13176,
    14800,
    13349,
    14666,
    13513,
    14526,
    13724,
    14398,
    13960,
    14230,
    14200,
    14020,
    14383,
    13827,
    14488,
    13651,
    14583,
    13491,
    14667,
    13348,
    14740,
    13132,
    14803,
    12908,
    14856,
    12713,
    14901,
    12542,
    14938,
    12394,
    14968,
    12241,
    14992,
    12017,
    15010,
    11822,
    15024,
    11654,
    15034,
    11507,
    15041,
    11380,
    15044,
    11269,
    15044,
    11081,
    15042,
    10913,
    15037,
    10764,
    15031,
    10635,
    15023,
    10520,
    15014,
    10419,
    15003,
    10330,
    13657,
    14676,
    13658,
    14673,
    13670,
    14660,
    13698,
    14622,
    13750,
    14547,
    13834,
    14442,
    13956,
    14317,
    14112,
    14093,
    14291,
    13889,
    14407,
    13704,
    14499,
    13538,
    14586,
    13389,
    14664,
    13201,
    14733,
    12966,
    14792,
    12758,
    14842,
    12577,
    14882,
    12418,
    14915,
    12272,
    14940,
    12033,
    14959,
    11826,
    14972,
    11646,
    14980,
    11490,
    14983,
    11355,
    14983,
    11212,
    14979,
    11008,
    14971,
    10830,
    14961,
    10675,
    14950,
    10540,
    14936,
    10420,
    14923,
    10315,
    14909,
    10204,
    14894,
    10041,
    14089,
    14460,
    14090,
    14459,
    14096,
    14452,
    14112,
    14431,
    14141,
    14388,
    14186,
    14305,
    14252,
    14130,
    14341,
    13941,
    14399,
    13756,
    14467,
    13585,
    14539,
    13430,
    14610,
    13272,
    14677,
    13026,
    14737,
    12808,
    14790,
    12617,
    14833,
    12449,
    14869,
    12303,
    14896,
    12065,
    14916,
    11845,
    14929,
    11655,
    14937,
    11490,
    14939,
    11347,
    14936,
    11184,
    14930,
    10970,
    14921,
    10783,
    14912,
    10621,
    14900,
    10480,
    14885,
    10356,
    14867,
    10247,
    14848,
    10062,
    14827,
    9894,
    14805,
    9745,
    14400,
    14208,
    14400,
    14206,
    14402,
    14198,
    14406,
    14174,
    14415,
    14122,
    14427,
    14035,
    14444,
    13913,
    14469,
    13767,
    14504,
    13613,
    14548,
    13463,
    14598,
    13324,
    14651,
    13082,
    14704,
    12858,
    14752,
    12658,
    14795,
    12483,
    14831,
    12330,
    14860,
    12106,
    14881,
    11875,
    14895,
    11675,
    14903,
    11501,
    14905,
    11351,
    14903,
    11178,
    14900,
    10953,
    14892,
    10757,
    14880,
    10589,
    14865,
    10442,
    14847,
    10313,
    14827,
    10162,
    14805,
    9965,
    14782,
    9792,
    14757,
    9642,
    14731,
    9507,
    14562,
    13883,
    14562,
    13883,
    14563,
    13877,
    14566,
    13862,
    14570,
    13830,
    14576,
    13773,
    14584,
    13689,
    14595,
    13582,
    14613,
    13461,
    14637,
    13336,
    14668,
    13120,
    14704,
    12897,
    14741,
    12695,
    14776,
    12516,
    14808,
    12358,
    14835,
    12150,
    14856,
    11910,
    14870,
    11701,
    14878,
    11519,
    14882,
    11361,
    14884,
    11187,
    14880,
    10951,
    14871,
    10748,
    14858,
    10572,
    14842,
    10418,
    14823,
    10286,
    14801,
    10099,
    14777,
    9897,
    14751,
    9722,
    14725,
    9567,
    14696,
    9430,
    14666,
    9309,
    14702,
    13604,
    14702,
    13604,
    14702,
    13600,
    14703,
    13591,
    14705,
    13570,
    14707,
    13533,
    14709,
    13477,
    14712,
    13400,
    14718,
    13305,
    14727,
    13106,
    14743,
    12907,
    14762,
    12716,
    14784,
    12539,
    14807,
    12380,
    14827,
    12190,
    14844,
    11943,
    14855,
    11727,
    14863,
    11539,
    14870,
    11376,
    14871,
    11204,
    14868,
    10960,
    14858,
    10748,
    14845,
    10565,
    14829,
    10406,
    14809,
    10269,
    14786,
    10058,
    14761,
    9852,
    14734,
    9671,
    14705,
    9512,
    14674,
    9374,
    14641,
    9253,
    14608,
    9076,
    14821,
    13366,
    14821,
    13365,
    14821,
    13364,
    14821,
    13358,
    14821,
    13344,
    14821,
    13320,
    14819,
    13252,
    14817,
    13145,
    14815,
    13011,
    14814,
    12858,
    14817,
    12698,
    14823,
    12539,
    14832,
    12389,
    14841,
    12214,
    14850,
    11968,
    14856,
    11750,
    14861,
    11558,
    14866,
    11390,
    14867,
    11226,
    14862,
    10972,
    14853,
    10754,
    14840,
    10565,
    14823,
    10401,
    14803,
    10259,
    14780,
    10032,
    14754,
    9820,
    14725,
    9635,
    14694,
    9473,
    14661,
    9333,
    14627,
    9203,
    14593,
    8988,
    14557,
    8798,
    14923,
    13014,
    14922,
    13014,
    14922,
    13012,
    14922,
    13004,
    14920,
    12987,
    14919,
    12957,
    14915,
    12907,
    14909,
    12834,
    14902,
    12738,
    14894,
    12623,
    14888,
    12498,
    14883,
    12370,
    14880,
    12203,
    14878,
    11970,
    14875,
    11759,
    14873,
    11569,
    14874,
    11401,
    14872,
    11243,
    14865,
    10986,
    14855,
    10762,
    14842,
    10568,
    14825,
    10401,
    14804,
    10255,
    14781,
    10017,
    14754,
    9799,
    14725,
    9611,
    14692,
    9445,
    14658,
    9301,
    14623,
    9139,
    14587,
    8920,
    14548,
    8729,
    14509,
    8562,
    15008,
    12672,
    15008,
    12672,
    15008,
    12671,
    15007,
    12667,
    15005,
    12656,
    15001,
    12637,
    14997,
    12605,
    14989,
    12556,
    14978,
    12490,
    14966,
    12407,
    14953,
    12313,
    14940,
    12136,
    14927,
    11934,
    14914,
    11742,
    14903,
    11563,
    14896,
    11401,
    14889,
    11247,
    14879,
    10992,
    14866,
    10767,
    14851,
    10570,
    14833,
    10400,
    14812,
    10252,
    14789,
    10007,
    14761,
    9784,
    14731,
    9592,
    14698,
    9424,
    14663,
    9279,
    14627,
    9088,
    14588,
    8868,
    14548,
    8676,
    14508,
    8508,
    14467,
    8360,
    15080,
    12386,
    15080,
    12386,
    15079,
    12385,
    15078,
    12383,
    15076,
    12378,
    15072,
    12367,
    15066,
    12347,
    15057,
    12315,
    15045,
    12253,
    15030,
    12138,
    15012,
    11998,
    14993,
    11845,
    14972,
    11685,
    14951,
    11530,
    14935,
    11383,
    14920,
    11228,
    14904,
    10981,
    14887,
    10762,
    14870,
    10567,
    14850,
    10397,
    14827,
    10248,
    14803,
    9997,
    14774,
    9771,
    14743,
    9578,
    14710,
    9407,
    14674,
    9259,
    14637,
    9048,
    14596,
    8826,
    14555,
    8632,
    14514,
    8464,
    14471,
    8317,
    14427,
    8182,
    15139,
    12008,
    15139,
    12008,
    15138,
    12008,
    15137,
    12007,
    15135,
    12003,
    15130,
    11990,
    15124,
    11969,
    15115,
    11929,
    15102,
    11872,
    15086,
    11794,
    15064,
    11693,
    15041,
    11581,
    15013,
    11459,
    14987,
    11336,
    14966,
    11170,
    14944,
    10944,
    14921,
    10738,
    14898,
    10552,
    14875,
    10387,
    14850,
    10239,
    14824,
    9983,
    14794,
    9758,
    14762,
    9563,
    14728,
    9392,
    14692,
    9244,
    14653,
    9014,
    14611,
    8791,
    14569,
    8597,
    14526,
    8427,
    14481,
    8281,
    14436,
    8110,
    14391,
    7885,
    15188,
    11617,
    15188,
    11617,
    15187,
    11617,
    15186,
    11618,
    15183,
    11617,
    15179,
    11612,
    15173,
    11601,
    15163,
    11581,
    15150,
    11546,
    15133,
    11495,
    15110,
    11427,
    15083,
    11346,
    15051,
    11246,
    15024,
    11057,
    14996,
    10868,
    14967,
    10687,
    14938,
    10517,
    14911,
    10362,
    14882,
    10206,
    14853,
    9956,
    14821,
    9737,
    14787,
    9543,
    14752,
    9375,
    14715,
    9228,
    14675,
    8980,
    14632,
    8760,
    14589,
    8565,
    14544,
    8395,
    14498,
    8248,
    14451,
    8049,
    14404,
    7824,
    14357,
    7630,
    15228,
    11298,
    15228,
    11298,
    15227,
    11299,
    15226,
    11301,
    15223,
    11303,
    15219,
    11302,
    15213,
    11299,
    15204,
    11290,
    15191,
    11271,
    15174,
    11217,
    15150,
    11129,
    15119,
    11015,
    15087,
    10886,
    15057,
    10744,
    15024,
    10599,
    14990,
    10455,
    14957,
    10318,
    14924,
    10143,
    14891,
    9911,
    14856,
    9701,
    14820,
    9516,
    14782,
    9352,
    14744,
    9200,
    14703,
    8946,
    14659,
    8725,
    14615,
    8533,
    14568,
    8366,
    14521,
    8220,
    14472,
    7992,
    14423,
    7770,
    14374,
    7578,
    14315,
    7408,
    15260,
    10819,
    15260,
    10819,
    15259,
    10822,
    15258,
    10826,
    15256,
    10832,
    15251,
    10836,
    15246,
    10841,
    15237,
    10838,
    15225,
    10821,
    15207,
    10788,
    15183,
    10734,
    15151,
    10660,
    15120,
    10571,
    15087,
    10469,
    15049,
    10359,
    15012,
    10249,
    14974,
    10041,
    14937,
    9837,
    14900,
    9647,
    14860,
    9475,
    14820,
    9320,
    14779,
    9147,
    14736,
    8902,
    14691,
    8688,
    14646,
    8499,
    14598,
    8335,
    14549,
    8189,
    14499,
    7940,
    14448,
    7720,
    14397,
    7529,
    14347,
    7363,
    14256,
    7218,
    15285,
    10410,
    15285,
    10411,
    15285,
    10413,
    15284,
    10418,
    15282,
    10425,
    15278,
    10434,
    15272,
    10442,
    15264,
    10449,
    15252,
    10445,
    15235,
    10433,
    15210,
    10403,
    15179,
    10358,
    15149,
    10301,
    15113,
    10218,
    15073,
    10059,
    15033,
    9894,
    14991,
    9726,
    14951,
    9565,
    14909,
    9413,
    14865,
    9273,
    14822,
    9073,
    14777,
    8845,
    14730,
    8641,
    14682,
    8459,
    14633,
    8300,
    14583,
    8129,
    14531,
    7883,
    14479,
    7670,
    14426,
    7482,
    14373,
    7321,
    14305,
    7176,
    14201,
    6939,
    15305,
    9939,
    15305,
    9940,
    15305,
    9945,
    15304,
    9955,
    15302,
    9967,
    15298,
    9989,
    15293,
    10010,
    15286,
    10033,
    15274,
    10044,
    15258,
    10045,
    15233,
    10022,
    15205,
    9975,
    15174,
    9903,
    15136,
    9808,
    15095,
    9697,
    15053,
    9578,
    15009,
    9451,
    14965,
    9327,
    14918,
    9198,
    14871,
    8973,
    14825,
    8766,
    14775,
    8579,
    14725,
    8408,
    14675,
    8259,
    14622,
    8058,
    14569,
    7821,
    14515,
    7615,
    14460,
    7435,
    14405,
    7276,
    14350,
    7108,
    14256,
    6866,
    14149,
    6653,
    15321,
    9444,
    15321,
    9445,
    15321,
    9448,
    15320,
    9458,
    15317,
    9470,
    15314,
    9490,
    15310,
    9515,
    15302,
    9540,
    15292,
    9562,
    15276,
    9579,
    15251,
    9577,
    15226,
    9559,
    15195,
    9519,
    15156,
    9463,
    15116,
    9389,
    15071,
    9304,
    15025,
    9208,
    14978,
    9023,
    14927,
    8838,
    14878,
    8661,
    14827,
    8496,
    14774,
    8344,
    14722,
    8206,
    14667,
    7973,
    14612,
    7749,
    14556,
    7555,
    14499,
    7382,
    14443,
    7229,
    14385,
    7025,
    14322,
    6791,
    14210,
    6588,
    14100,
    6409,
    15333,
    8920,
    15333,
    8921,
    15332,
    8927,
    15332,
    8943,
    15329,
    8965,
    15326,
    9002,
    15322,
    9048,
    15316,
    9106,
    15307,
    9162,
    15291,
    9204,
    15267,
    9221,
    15244,
    9221,
    15212,
    9196,
    15175,
    9134,
    15133,
    9043,
    15088,
    8930,
    15040,
    8801,
    14990,
    8665,
    14938,
    8526,
    14886,
    8391,
    14830,
    8261,
    14775,
    8087,
    14719,
    7866,
    14661,
    7664,
    14603,
    7482,
    14544,
    7322,
    14485,
    7178,
    14426,
    6936,
    14367,
    6713,
    14281,
    6517,
    14166,
    6348,
    14054,
    6198,
    15341,
    8360,
    15341,
    8361,
    15341,
    8366,
    15341,
    8379,
    15339,
    8399,
    15336,
    8431,
    15332,
    8473,
    15326,
    8527,
    15318,
    8585,
    15302,
    8632,
    15281,
    8670,
    15258,
    8690,
    15227,
    8690,
    15191,
    8664,
    15149,
    8612,
    15104,
    8543,
    15055,
    8456,
    15001,
    8360,
    14948,
    8259,
    14892,
    8122,
    14834,
    7923,
    14776,
    7734,
    14716,
    7558,
    14656,
    7397,
    14595,
    7250,
    14534,
    7070,
    14472,
    6835,
    14410,
    6628,
    14350,
    6443,
    14243,
    6283,
    14125,
    6135,
    14010,
    5889,
    15348,
    7715,
    15348,
    7717,
    15348,
    7725,
    15347,
    7745,
    15345,
    7780,
    15343,
    7836,
    15339,
    7905,
    15334,
    8e3,
    15326,
    8103,
    15310,
    8193,
    15293,
    8239,
    15270,
    8270,
    15240,
    8287,
    15204,
    8283,
    15163,
    8260,
    15118,
    8223,
    15067,
    8143,
    15014,
    8014,
    14958,
    7873,
    14899,
    7723,
    14839,
    7573,
    14778,
    7430,
    14715,
    7293,
    14652,
    7164,
    14588,
    6931,
    14524,
    6720,
    14460,
    6531,
    14396,
    6362,
    14330,
    6210,
    14207,
    6015,
    14086,
    5781,
    13969,
    5576,
    15352,
    7114,
    15352,
    7116,
    15352,
    7128,
    15352,
    7159,
    15350,
    7195,
    15348,
    7237,
    15345,
    7299,
    15340,
    7374,
    15332,
    7457,
    15317,
    7544,
    15301,
    7633,
    15280,
    7703,
    15251,
    7754,
    15216,
    7775,
    15176,
    7767,
    15131,
    7733,
    15079,
    7670,
    15026,
    7588,
    14967,
    7492,
    14906,
    7387,
    14844,
    7278,
    14779,
    7171,
    14714,
    6965,
    14648,
    6770,
    14581,
    6587,
    14515,
    6420,
    14448,
    6269,
    14382,
    6123,
    14299,
    5881,
    14172,
    5665,
    14049,
    5477,
    13929,
    5310,
    15355,
    6329,
    15355,
    6330,
    15355,
    6339,
    15355,
    6362,
    15353,
    6410,
    15351,
    6472,
    15349,
    6572,
    15344,
    6688,
    15337,
    6835,
    15323,
    6985,
    15309,
    7142,
    15287,
    7220,
    15260,
    7277,
    15226,
    7310,
    15188,
    7326,
    15142,
    7318,
    15090,
    7285,
    15036,
    7239,
    14976,
    7177,
    14914,
    7045,
    14849,
    6892,
    14782,
    6736,
    14714,
    6581,
    14645,
    6433,
    14576,
    6293,
    14506,
    6164,
    14438,
    5946,
    14369,
    5733,
    14270,
    5540,
    14140,
    5369,
    14014,
    5216,
    13892,
    5043,
    15357,
    5483,
    15357,
    5484,
    15357,
    5496,
    15357,
    5528,
    15356,
    5597,
    15354,
    5692,
    15351,
    5835,
    15347,
    6011,
    15339,
    6195,
    15328,
    6317,
    15314,
    6446,
    15293,
    6566,
    15268,
    6668,
    15235,
    6746,
    15197,
    6796,
    15152,
    6811,
    15101,
    6790,
    15046,
    6748,
    14985,
    6673,
    14921,
    6583,
    14854,
    6479,
    14785,
    6371,
    14714,
    6259,
    14643,
    6149,
    14571,
    5946,
    14499,
    5750,
    14428,
    5567,
    14358,
    5401,
    14242,
    5250,
    14109,
    5111,
    13980,
    4870,
    13856,
    4657,
    15359,
    4555,
    15359,
    4557,
    15358,
    4573,
    15358,
    4633,
    15357,
    4715,
    15355,
    4841,
    15353,
    5061,
    15349,
    5216,
    15342,
    5391,
    15331,
    5577,
    15318,
    5770,
    15299,
    5967,
    15274,
    6150,
    15243,
    6223,
    15206,
    6280,
    15161,
    6310,
    15111,
    6317,
    15055,
    6300,
    14994,
    6262,
    14928,
    6208,
    14860,
    6141,
    14788,
    5994,
    14715,
    5838,
    14641,
    5684,
    14566,
    5529,
    14492,
    5384,
    14418,
    5247,
    14346,
    5121,
    14216,
    4892,
    14079,
    4682,
    13948,
    4496,
    13822,
    4330,
    15359,
    3498,
    15359,
    3501,
    15359,
    3520,
    15359,
    3598,
    15358,
    3719,
    15356,
    3860,
    15355,
    4137,
    15351,
    4305,
    15344,
    4563,
    15334,
    4809,
    15321,
    5116,
    15303,
    5273,
    15280,
    5418,
    15250,
    5547,
    15214,
    5653,
    15170,
    5722,
    15120,
    5761,
    15064,
    5763,
    15002,
    5733,
    14935,
    5673,
    14865,
    5597,
    14792,
    5504,
    14716,
    5400,
    14640,
    5294,
    14563,
    5185,
    14486,
    5041,
    14410,
    4841,
    14335,
    4655,
    14191,
    4482,
    14051,
    4325,
    13918,
    4183,
    13790,
    4012,
    15360,
    2282,
    15360,
    2285,
    15360,
    2306,
    15360,
    2401,
    15359,
    2547,
    15357,
    2748,
    15355,
    3103,
    15352,
    3349,
    15345,
    3675,
    15336,
    4020,
    15324,
    4272,
    15307,
    4496,
    15285,
    4716,
    15255,
    4908,
    15220,
    5086,
    15178,
    5170,
    15128,
    5214,
    15072,
    5234,
    15010,
    5231,
    14943,
    5206,
    14871,
    5166,
    14796,
    5102,
    14718,
    4971,
    14639,
    4833,
    14559,
    4687,
    14480,
    4541,
    14402,
    4401,
    14315,
    4268,
    14167,
    4142,
    14025,
    3958,
    13888,
    3747,
    13759,
    3556,
    15360,
    923,
    15360,
    925,
    15360,
    946,
    15360,
    1052,
    15359,
    1214,
    15357,
    1494,
    15356,
    1892,
    15352,
    2274,
    15346,
    2663,
    15338,
    3099,
    15326,
    3393,
    15309,
    3679,
    15288,
    3980,
    15260,
    4183,
    15226,
    4325,
    15185,
    4437,
    15136,
    4517,
    15080,
    4570,
    15018,
    4591,
    14950,
    4581,
    14877,
    4545,
    14800,
    4485,
    14720,
    4411,
    14638,
    4325,
    14556,
    4231,
    14475,
    4136,
    14395,
    3988,
    14297,
    3803,
    14145,
    3628,
    13999,
    3465,
    13861,
    3314,
    13729,
    3177,
    15360,
    263,
    15360,
    264,
    15360,
    272,
    15360,
    325,
    15359,
    407,
    15358,
    548,
    15356,
    780,
    15352,
    1144,
    15347,
    1580,
    15339,
    2099,
    15328,
    2425,
    15312,
    2795,
    15292,
    3133,
    15264,
    3329,
    15232,
    3517,
    15191,
    3689,
    15143,
    3819,
    15088,
    3923,
    15025,
    3978,
    14956,
    3999,
    14882,
    3979,
    14804,
    3931,
    14722,
    3855,
    14639,
    3756,
    14554,
    3645,
    14470,
    3529,
    14388,
    3409,
    14279,
    3289,
    14124,
    3173,
    13975,
    3055,
    13834,
    2848,
    13701,
    2658,
    15360,
    49,
    15360,
    49,
    15360,
    52,
    15360,
    75,
    15359,
    111,
    15358,
    201,
    15356,
    283,
    15353,
    519,
    15348,
    726,
    15340,
    1045,
    15329,
    1415,
    15314,
    1795,
    15295,
    2173,
    15269,
    2410,
    15237,
    2649,
    15197,
    2866,
    15150,
    3054,
    15095,
    3140,
    15032,
    3196,
    14963,
    3228,
    14888,
    3236,
    14808,
    3224,
    14725,
    3191,
    14639,
    3146,
    14553,
    3088,
    14466,
    2976,
    14382,
    2836,
    14262,
    2692,
    14103,
    2549,
    13952,
    2409,
    13808,
    2278,
    13674,
    2154,
    15360,
    4,
    15360,
    4,
    15360,
    4,
    15360,
    13,
    15359,
    33,
    15358,
    59,
    15357,
    112,
    15353,
    199,
    15348,
    302,
    15341,
    456,
    15331,
    628,
    15316,
    827,
    15297,
    1082,
    15272,
    1332,
    15241,
    1601,
    15202,
    1851,
    15156,
    2069,
    15101,
    2172,
    15039,
    2256,
    14970,
    2314,
    14894,
    2348,
    14813,
    2358,
    14728,
    2344,
    14640,
    2311,
    14551,
    2263,
    14463,
    2203,
    14376,
    2133,
    14247,
    2059,
    14084,
    1915,
    13930,
    1761,
    13784,
    1609,
    13648,
    1464,
    15360,
    0,
    15360,
    0,
    15360,
    0,
    15360,
    3,
    15359,
    18,
    15358,
    26,
    15357,
    53,
    15354,
    80,
    15348,
    97,
    15341,
    165,
    15332,
    238,
    15318,
    326,
    15299,
    427,
    15275,
    529,
    15245,
    654,
    15207,
    771,
    15161,
    885,
    15108,
    994,
    15046,
    1089,
    14976,
    1170,
    14900,
    1229,
    14817,
    1266,
    14731,
    1284,
    14641,
    1282,
    14550,
    1260,
    14460,
    1223,
    14370,
    1174,
    14232,
    1116,
    14066,
    1050,
    13909,
    981,
    13761,
    910,
    13623,
    839
]);
let $455d545b1dff00eb$var$hc = null;
function $455d545b1dff00eb$var$gP() {
    return $455d545b1dff00eb$var$hc === null && ($455d545b1dff00eb$var$hc = new $455d545b1dff00eb$var$Ro($455d545b1dff00eb$var$mP, 32, 32, $455d545b1dff00eb$var$sy, $455d545b1dff00eb$var$wu), $455d545b1dff00eb$var$hc.minFilter = $455d545b1dff00eb$var$mi, $455d545b1dff00eb$var$hc.magFilter = $455d545b1dff00eb$var$mi, $455d545b1dff00eb$var$hc.wrapS = $455d545b1dff00eb$var$Kr, $455d545b1dff00eb$var$hc.wrapT = $455d545b1dff00eb$var$Kr, $455d545b1dff00eb$var$hc.generateMipmaps = !1, $455d545b1dff00eb$var$hc.needsUpdate = !0), $455d545b1dff00eb$var$hc;
}
class $455d545b1dff00eb$var$wA {
    constructor(e = {}){
        const { canvas: t = $455d545b1dff00eb$var$yT(), context: n = null, depth: i = !0, stencil: r = !1, alpha: l = !1, antialias: c = !1, premultipliedAlpha: f = !0, preserveDrawingBuffer: p = !1, powerPreference: m = "default", failIfMajorPerformanceCaveat: x = !1, reversedDepthBuffer: v = !1 } = e;
        this.isWebGLRenderer = !0;
        let _;
        if (n !== null) {
            if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            _ = n.getContextAttributes().alpha;
        } else _ = l;
        const S = new Set([
            $455d545b1dff00eb$var$ly,
            $455d545b1dff00eb$var$oy,
            $455d545b1dff00eb$var$M0
        ]), A = new Set([
            $455d545b1dff00eb$var$Ws,
            $455d545b1dff00eb$var$Mc,
            $455d545b1dff00eb$var$Od,
            $455d545b1dff00eb$var$Ld,
            $455d545b1dff00eb$var$iy,
            $455d545b1dff00eb$var$ay
        ]), M = new Uint32Array(4), b = new Int32Array(4);
        let C = null, R = null;
        const N = [], z = [];
        this.domElement = t, this.debug = {
            checkShaderErrors: !0,
            onShaderError: null
        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = $455d545b1dff00eb$var$_l, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
        const L = this;
        let P = !1;
        this._outputColorSpace = $455d545b1dff00eb$var$nr;
        let H = 0, O = 0, D = null, j = -1, G = null;
        const q = new $455d545b1dff00eb$var$Un, Y = new $455d545b1dff00eb$var$Un;
        let ae = null;
        const F = new $455d545b1dff00eb$var$_t(0);
        let Q = 0, K = t.width, $ = t.height, ee = 1, I = null, Z = null;
        const oe = new $455d545b1dff00eb$var$Un(0, 0, K, $), ce = new $455d545b1dff00eb$var$Un(0, 0, K, $);
        let de = !1;
        const ue = new $455d545b1dff00eb$var$qd;
        let le = !1, xe = !1;
        const Le = new $455d545b1dff00eb$var$Ft, Ue = new $455d545b1dff00eb$var$J, Ne = new $455d545b1dff00eb$var$Un, ke = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: !0
        };
        let nt = !1;
        function Re() {
            return D === null ? ee : 1;
        }
        let te = n;
        function Oe(ie, Se) {
            return t.getContext(ie, Se);
        }
        try {
            const ie = {
                alpha: !0,
                depth: i,
                stencil: r,
                antialias: c,
                premultipliedAlpha: f,
                preserveDrawingBuffer: p,
                powerPreference: m,
                failIfMajorPerformanceCaveat: x
            };
            if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${$455d545b1dff00eb$var$$v}`), t.addEventListener("webglcontextlost", Ke, !1), t.addEventListener("webglcontextrestored", Ve, !1), t.addEventListener("webglcontextcreationerror", ft, !1), te === null) {
                const Se = "webgl2";
                if (te = Oe(Se, ie), te === null) throw Oe(Se) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
            }
        } catch (ie) {
            throw ie("WebGLRenderer: " + ie.message), ie;
        }
        let Ie, Ae, ze, Ze, be, rt, ne, W, pe, Be, Te, _e, ot, tt, gt, pt, Ge, Ye, at, he, Ee, lt, fe, We;
        function Je() {
            Ie = new $455d545b1dff00eb$var$A5(te), Ie.init(), lt = new $455d545b1dff00eb$var$AA(te, Ie), Ae = new $455d545b1dff00eb$var$x5(te, Ie, e, lt), ze = new $455d545b1dff00eb$var$sP(te, Ie), Ae.reversedDepthBuffer && v && ze.buffers.depth.setReversed(!0), Ze = new $455d545b1dff00eb$var$R5(te), be = new $455d545b1dff00eb$var$qz, rt = new $455d545b1dff00eb$var$oP(te, Ie, ze, be, Ae, lt, Ze), ne = new $455d545b1dff00eb$var$y5(L), W = new $455d545b1dff00eb$var$T5(L), pe = new $455d545b1dff00eb$var$O4(te), fe = new $455d545b1dff00eb$var$m5(te, pe), Be = new $455d545b1dff00eb$var$w5(te, pe, Ze, fe), Te = new $455d545b1dff00eb$var$U5(te, Be, pe, Ze), at = new $455d545b1dff00eb$var$D5(te, Ae, rt), pt = new $455d545b1dff00eb$var$v5(be), _e = new $455d545b1dff00eb$var$Wz(L, ne, W, Ie, Ae, fe, pt), ot = new $455d545b1dff00eb$var$dP(L, be), tt = new $455d545b1dff00eb$var$Zz, gt = new $455d545b1dff00eb$var$tP(Ie), Ye = new $455d545b1dff00eb$var$p5(L, ne, W, ze, Te, _, f), Ge = new $455d545b1dff00eb$var$aP(L, Te, Ae), We = new $455d545b1dff00eb$var$pP(te, Ze, Ae, ze), he = new $455d545b1dff00eb$var$g5(te, Ie, Ze), Ee = new $455d545b1dff00eb$var$C5(te, Ie, Ze), Ze.programs = _e.programs, L.capabilities = Ae, L.extensions = Ie, L.properties = be, L.renderLists = tt, L.shadowMap = Ge, L.state = ze, L.info = Ze;
        }
        Je();
        const ut = new $455d545b1dff00eb$var$fP(L, te);
        this.xr = ut, this.getContext = function() {
            return te;
        }, this.getContextAttributes = function() {
            return te.getContextAttributes();
        }, this.forceContextLoss = function() {
            const ie = Ie.get("WEBGL_lose_context");
            ie && ie.loseContext();
        }, this.forceContextRestore = function() {
            const ie = Ie.get("WEBGL_lose_context");
            ie && ie.restoreContext();
        }, this.getPixelRatio = function() {
            return ee;
        }, this.setPixelRatio = function(ie) {
            ie !== void 0 && (ee = ie, this.setSize(K, $, !1));
        }, this.getSize = function(ie) {
            return ie.set(K, $);
        }, this.setSize = function(ie, Se, ve = !0) {
            if (ut.isPresenting) {
                $455d545b1dff00eb$var$Mt("WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            K = ie, $ = Se, t.width = Math.floor(ie * ee), t.height = Math.floor(Se * ee), ve === !0 && (t.style.width = ie + "px", t.style.height = Se + "px"), this.setViewport(0, 0, ie, Se);
        }, this.getDrawingBufferSize = function(ie) {
            return ie.set(K * ee, $ * ee).floor();
        }, this.setDrawingBufferSize = function(ie, Se, ve) {
            K = ie, $ = Se, ee = ve, t.width = Math.floor(ie * ve), t.height = Math.floor(Se * ve), this.setViewport(0, 0, ie, Se);
        }, this.getCurrentViewport = function(ie) {
            return ie.copy(q);
        }, this.getViewport = function(ie) {
            return ie.copy(oe);
        }, this.setViewport = function(ie, Se, ve, Pe) {
            ie.isVector4 ? oe.set(ie.x, ie.y, ie.z, ie.w) : oe.set(ie, Se, ve, Pe), ze.viewport(q.copy(oe).multiplyScalar(ee).round());
        }, this.getScissor = function(ie) {
            return ie.copy(ce);
        }, this.setScissor = function(ie, Se, ve, Pe) {
            ie.isVector4 ? ce.set(ie.x, ie.y, ie.z, ie.w) : ce.set(ie, Se, ve, Pe), ze.scissor(Y.copy(ce).multiplyScalar(ee).round());
        }, this.getScissorTest = function() {
            return de;
        }, this.setScissorTest = function(ie) {
            ze.setScissorTest(de = ie);
        }, this.setOpaqueSort = function(ie) {
            I = ie;
        }, this.setTransparentSort = function(ie) {
            Z = ie;
        }, this.getClearColor = function(ie) {
            return ie.copy(Ye.getClearColor());
        }, this.setClearColor = function() {
            Ye.setClearColor(...arguments);
        }, this.getClearAlpha = function() {
            return Ye.getClearAlpha();
        }, this.setClearAlpha = function() {
            Ye.setClearAlpha(...arguments);
        }, this.clear = function(ie = !0, Se = !0, ve = !0) {
            let Pe = 0;
            if (ie) {
                let Me = !1;
                if (D !== null) {
                    const dt = D.texture.format;
                    Me = S.has(dt);
                }
                if (Me) {
                    const dt = D.texture.type, xt = A.has(dt), Et = Ye.getClearColor(), Tt = Ye.getClearAlpha(), Ot = Et.r, Pt = Et.g, Ut = Et.b;
                    xt ? (M[0] = Ot, M[1] = Pt, M[2] = Ut, M[3] = Tt, te.clearBufferuiv(te.COLOR, 0, M)) : (b[0] = Ot, b[1] = Pt, b[2] = Ut, b[3] = Tt, te.clearBufferiv(te.COLOR, 0, b));
                } else Pe |= te.COLOR_BUFFER_BIT;
            }
            Se && (Pe |= te.DEPTH_BUFFER_BIT), ve && (Pe |= te.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), te.clear(Pe);
        }, this.clearColor = function() {
            this.clear(!0, !1, !1);
        }, this.clearDepth = function() {
            this.clear(!1, !0, !1);
        }, this.clearStencil = function() {
            this.clear(!1, !1, !0);
        }, this.dispose = function() {
            t.removeEventListener("webglcontextlost", Ke, !1), t.removeEventListener("webglcontextrestored", Ve, !1), t.removeEventListener("webglcontextcreationerror", ft, !1), Ye.dispose(), tt.dispose(), gt.dispose(), be.dispose(), ne.dispose(), W.dispose(), Te.dispose(), fe.dispose(), We.dispose(), _e.dispose(), ut.dispose(), ut.removeEventListener("sessionstart", Gi), ut.removeEventListener("sessionend", da), jn.stop();
        };
        function Ke(ie) {
            ie.preventDefault(), $455d545b1dff00eb$var$o0("WebGLRenderer: Context Lost."), P = !0;
        }
        function Ve() {
            $455d545b1dff00eb$var$o0("WebGLRenderer: Context Restored."), P = !1;
            const ie = Ze.autoReset, Se = Ge.enabled, ve = Ge.autoUpdate, Pe = Ge.needsUpdate, Me = Ge.type;
            Je(), Ze.autoReset = ie, Ge.enabled = Se, Ge.autoUpdate = ve, Ge.needsUpdate = Pe, Ge.type = Me;
        }
        function ft(ie) {
            $455d545b1dff00eb$var$Qt("WebGLRenderer: A WebGL context could not be created. Reason: ", ie.statusMessage);
        }
        function vt(ie) {
            const Se = ie.target;
            Se.removeEventListener("dispose", vt), yt(Se);
        }
        function yt(ie) {
            Ct(ie), be.remove(ie);
        }
        function Ct(ie) {
            const Se = be.get(ie).programs;
            Se !== void 0 && (Se.forEach(function(ve) {
                _e.releaseProgram(ve);
            }), ie.isShaderMaterial && _e.releaseShaderCache(ie));
        }
        this.renderBufferDirect = function(ie, Se, ve, Pe, Me, dt) {
            Se === null && (Se = ke);
            const xt = Me.isMesh && Me.matrixWorld.determinant() < 0, Et = Tl(ie, Se, ve, Pe, Me);
            ze.setMaterial(Pe, xt);
            let Tt = ve.index, Ot = 1;
            if (Pe.wireframe === !0) {
                if (Tt = Be.getWireframeAttribute(ve), Tt === void 0) return;
                Ot = 2;
            }
            const Pt = ve.drawRange, Ut = ve.attributes.position;
            let qt = Pt.start * Ot, mn = (Pt.start + Pt.count) * Ot;
            dt !== null && (qt = Math.max(qt, dt.start * Ot), mn = Math.min(mn, (dt.start + dt.count) * Ot)), Tt !== null ? (qt = Math.max(qt, 0), mn = Math.min(mn, Tt.count)) : Ut != null && (qt = Math.max(qt, 0), mn = Math.min(mn, Ut.count));
            const fn = mn - qt;
            if (fn < 0 || fn === 1 / 0) return;
            fe.setup(Me, Pe, Et, ve, Tt);
            let ln, xn = he;
            if (Tt !== null && (ln = pe.get(Tt), xn = Ee, xn.setIndex(ln)), Me.isMesh) Pe.wireframe === !0 ? (ze.setLineWidth(Pe.wireframeLinewidth * Re()), xn.setMode(te.LINES)) : xn.setMode(te.TRIANGLES);
            else if (Me.isLine) {
                let Lt = Pe.linewidth;
                Lt === void 0 && (Lt = 1), ze.setLineWidth(Lt * Re()), Me.isLineSegments ? xn.setMode(te.LINES) : Me.isLineLoop ? xn.setMode(te.LINE_LOOP) : xn.setMode(te.LINE_STRIP);
            } else Me.isPoints ? xn.setMode(te.POINTS) : Me.isSprite && xn.setMode(te.TRIANGLES);
            if (Me.isBatchedMesh) {
                if (Me._multiDrawInstances !== null) $455d545b1dff00eb$var$Id("WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), xn.renderMultiDrawInstances(Me._multiDrawStarts, Me._multiDrawCounts, Me._multiDrawCount, Me._multiDrawInstances);
                else if (Ie.get("WEBGL_multi_draw")) xn.renderMultiDraw(Me._multiDrawStarts, Me._multiDrawCounts, Me._multiDrawCount);
                else {
                    const Lt = Me._multiDrawStarts, _n = Me._multiDrawCounts, an = Me._multiDrawCount, ui = Tt ? pe.get(Tt).bytesPerElement : 1, sr = be.get(Pe).currentProgram.getUniforms();
                    for(let hn = 0; hn < an; hn++)sr.setValue(te, "_gl_DrawID", hn), xn.render(Lt[hn] / ui, _n[hn]);
                }
            } else if (Me.isInstancedMesh) xn.renderInstances(qt, fn, Me.count);
            else if (ve.isInstancedBufferGeometry) {
                const Lt = ve._maxInstanceCount !== void 0 ? ve._maxInstanceCount : 1 / 0, _n = Math.min(ve.instanceCount, Lt);
                xn.renderInstances(qt, fn, _n);
            } else xn.render(qt, fn);
        };
        function on(ie, Se, ve) {
            ie.transparent === !0 && ie.side === $455d545b1dff00eb$var$Ea && ie.forceSinglePass === !1 ? (ie.side = $455d545b1dff00eb$var$Dr, ie.needsUpdate = !0, ci(ie, Se, ve), ie.side = $455d545b1dff00eb$var$bc, ie.needsUpdate = !0, ci(ie, Se, ve), ie.side = $455d545b1dff00eb$var$Ea) : ci(ie, Se, ve);
        }
        this.compile = function(ie, Se, ve = null) {
            ve === null && (ve = ie), R = gt.get(ve), R.init(Se), z.push(R), ve.traverseVisible(function(Me) {
                Me.isLight && Me.layers.test(Se.layers) && (R.pushLight(Me), Me.castShadow && R.pushShadow(Me));
            }), ie !== ve && ie.traverseVisible(function(Me) {
                Me.isLight && Me.layers.test(Se.layers) && (R.pushLight(Me), Me.castShadow && R.pushShadow(Me));
            }), R.setupLights();
            const Pe = new Set;
            return ie.traverse(function(Me) {
                if (!(Me.isMesh || Me.isPoints || Me.isLine || Me.isSprite)) return;
                const dt = Me.material;
                if (dt) {
                    if (Array.isArray(dt)) for(let xt = 0; xt < dt.length; xt++){
                        const Et = dt[xt];
                        on(Et, ve, Me), Pe.add(Et);
                    }
                    else on(dt, ve, Me), Pe.add(dt);
                }
            }), R = z.pop(), Pe;
        }, this.compileAsync = function(ie, Se, ve = null) {
            const Pe = this.compile(ie, Se, ve);
            return new Promise((Me)=>{
                function dt() {
                    if (Pe.forEach(function(xt) {
                        be.get(xt).currentProgram.isReady() && Pe.delete(xt);
                    }), Pe.size === 0) {
                        Me(ie);
                        return;
                    }
                    setTimeout(dt, 10);
                }
                Ie.get("KHR_parallel_shader_compile") !== null ? dt() : setTimeout(dt, 10);
            });
        };
        let gn = null;
        function ni(ie) {
            gn && gn(ie);
        }
        function Gi() {
            jn.stop();
        }
        function da() {
            jn.start();
        }
        const jn = new $455d545b1dff00eb$var$bA;
        jn.setAnimationLoop(ni), typeof self < "u" && jn.setContext(self), this.setAnimationLoop = function(ie) {
            gn = ie, ut.setAnimationLoop(ie), ie === null ? jn.stop() : jn.start();
        }, ut.addEventListener("sessionstart", Gi), ut.addEventListener("sessionend", da), this.render = function(ie, Se) {
            if (Se !== void 0 && Se.isCamera !== !0) {
                $455d545b1dff00eb$var$Qt("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (P === !0) return;
            if (ie.matrixWorldAutoUpdate === !0 && ie.updateMatrixWorld(), Se.parent === null && Se.matrixWorldAutoUpdate === !0 && Se.updateMatrixWorld(), ut.enabled === !0 && ut.isPresenting === !0 && (ut.cameraAutoUpdate === !0 && ut.updateCamera(Se), Se = ut.getCamera()), ie.isScene === !0 && ie.onBeforeRender(L, ie, Se, D), R = gt.get(ie, z.length), R.init(Se), z.push(R), Le.multiplyMatrices(Se.projectionMatrix, Se.matrixWorldInverse), ue.setFromProjectionMatrix(Le, $455d545b1dff00eb$var$_s, Se.reversedDepth), xe = this.localClippingEnabled, le = pt.init(this.clippingPlanes, xe), C = tt.get(ie, N.length), C.init(), N.push(C), ut.enabled === !0 && ut.isPresenting === !0) {
                const dt = L.xr.getDepthSensingMesh();
                dt !== null && ea(dt, Se, -1 / 0, L.sortObjects);
            }
            ea(ie, Se, 0, L.sortObjects), C.finish(), L.sortObjects === !0 && C.sort(I, Z), nt = ut.enabled === !1 || ut.isPresenting === !1 || ut.hasDepthSensing() === !1, nt && Ye.addToRenderList(C, ie), this.info.render.frame++, le === !0 && pt.beginShadows();
            const ve = R.state.shadowsArray;
            Ge.render(ve, ie, Se), le === !0 && pt.endShadows(), this.info.autoReset === !0 && this.info.reset();
            const Pe = C.opaque, Me = C.transmissive;
            if (R.setupLights(), Se.isArrayCamera) {
                const dt = Se.cameras;
                if (Me.length > 0) for(let xt = 0, Et = dt.length; xt < Et; xt++){
                    const Tt = dt[xt];
                    hi(Pe, Me, ie, Tt);
                }
                nt && Ye.render(ie);
                for(let xt = 0, Et = dt.length; xt < Et; xt++){
                    const Tt = dt[xt];
                    Pi(C, ie, Tt, Tt.viewport);
                }
            } else Me.length > 0 && hi(Pe, Me, ie, Se), nt && Ye.render(ie), Pi(C, ie, Se);
            D !== null && O === 0 && (rt.updateMultisampleRenderTarget(D), rt.updateRenderTargetMipmap(D)), ie.isScene === !0 && ie.onAfterRender(L, ie, Se), fe.resetDefaultState(), j = -1, G = null, z.pop(), z.length > 0 ? (R = z[z.length - 1], le === !0 && pt.setGlobalState(L.clippingPlanes, R.state.camera)) : R = null, N.pop(), N.length > 0 ? C = N[N.length - 1] : C = null;
        };
        function ea(ie, Se, ve, Pe) {
            if (ie.visible === !1) return;
            if (ie.layers.test(Se.layers)) {
                if (ie.isGroup) ve = ie.renderOrder;
                else if (ie.isLOD) ie.autoUpdate === !0 && ie.update(Se);
                else if (ie.isLight) R.pushLight(ie), ie.castShadow && R.pushShadow(ie);
                else if (ie.isSprite) {
                    if (!ie.frustumCulled || ue.intersectsSprite(ie)) {
                        Pe && Ne.setFromMatrixPosition(ie.matrixWorld).applyMatrix4(Le);
                        const xt = Te.update(ie), Et = ie.material;
                        Et.visible && C.push(ie, xt, Et, ve, Ne.z, null);
                    }
                } else if ((ie.isMesh || ie.isLine || ie.isPoints) && (!ie.frustumCulled || ue.intersectsObject(ie))) {
                    const xt = Te.update(ie), Et = ie.material;
                    if (Pe && (ie.boundingSphere !== void 0 ? (ie.boundingSphere === null && ie.computeBoundingSphere(), Ne.copy(ie.boundingSphere.center)) : (xt.boundingSphere === null && xt.computeBoundingSphere(), Ne.copy(xt.boundingSphere.center)), Ne.applyMatrix4(ie.matrixWorld).applyMatrix4(Le)), Array.isArray(Et)) {
                        const Tt = xt.groups;
                        for(let Ot = 0, Pt = Tt.length; Ot < Pt; Ot++){
                            const Ut = Tt[Ot], qt = Et[Ut.materialIndex];
                            qt && qt.visible && C.push(ie, xt, qt, ve, Ne.z, Ut);
                        }
                    } else Et.visible && C.push(ie, xt, Et, ve, Ne.z, null);
                }
            }
            const dt = ie.children;
            for(let xt = 0, Et = dt.length; xt < Et; xt++)ea(dt[xt], Se, ve, Pe);
        }
        function Pi(ie, Se, ve, Pe) {
            const { opaque: Me, transmissive: dt, transparent: xt } = ie;
            R.setupLightsView(ve), le === !0 && pt.setGlobalState(L.clippingPlanes, ve), Pe && ze.viewport(q.copy(Pe)), Me.length > 0 && Nn(Me, Se, ve), dt.length > 0 && Nn(dt, Se, ve), xt.length > 0 && Nn(xt, Se, ve), ze.buffers.depth.setTest(!0), ze.buffers.depth.setMask(!0), ze.buffers.color.setMask(!0), ze.setPolygonOffset(!1);
        }
        function hi(ie, Se, ve, Pe) {
            if ((ve.isScene === !0 ? ve.overrideMaterial : null) !== null) return;
            R.state.transmissionRenderTarget[Pe.id] === void 0 && (R.state.transmissionRenderTarget[Pe.id] = new $455d545b1dff00eb$var$Oo(1, 1, {
                generateMipmaps: !0,
                type: Ie.has("EXT_color_buffer_half_float") || Ie.has("EXT_color_buffer_float") ? $455d545b1dff00eb$var$wu : $455d545b1dff00eb$var$Ws,
                minFilter: $455d545b1dff00eb$var$gl,
                samples: 4,
                stencilBuffer: r,
                resolveDepthBuffer: !1,
                resolveStencilBuffer: !1,
                colorSpace: $455d545b1dff00eb$var$Dn.workingColorSpace
            }));
            const dt = R.state.transmissionRenderTarget[Pe.id], xt = Pe.viewport || q;
            dt.setSize(xt.z * L.transmissionResolutionScale, xt.w * L.transmissionResolutionScale);
            const Et = L.getRenderTarget(), Tt = L.getActiveCubeFace(), Ot = L.getActiveMipmapLevel();
            L.setRenderTarget(dt), L.getClearColor(F), Q = L.getClearAlpha(), Q < 1 && L.setClearColor(16777215, .5), L.clear(), nt && Ye.render(ve);
            const Pt = L.toneMapping;
            L.toneMapping = $455d545b1dff00eb$var$_l;
            const Ut = Pe.viewport;
            if (Pe.viewport !== void 0 && (Pe.viewport = void 0), R.setupLightsView(Pe), le === !0 && pt.setGlobalState(L.clippingPlanes, Pe), Nn(ie, ve, Pe), rt.updateMultisampleRenderTarget(dt), rt.updateRenderTargetMipmap(dt), Ie.has("WEBGL_multisampled_render_to_texture") === !1) {
                let qt = !1;
                for(let mn = 0, fn = Se.length; mn < fn; mn++){
                    const ln = Se[mn], { object: xn, geometry: Lt, material: _n, group: an } = ln;
                    if (_n.side === $455d545b1dff00eb$var$Ea && xn.layers.test(Pe.layers)) {
                        const ui = _n.side;
                        _n.side = $455d545b1dff00eb$var$Dr, _n.needsUpdate = !0, jt(xn, ve, Pe, Lt, _n, an), _n.side = ui, _n.needsUpdate = !0, qt = !0;
                    }
                }
                qt === !0 && (rt.updateMultisampleRenderTarget(dt), rt.updateRenderTargetMipmap(dt));
            }
            L.setRenderTarget(Et, Tt, Ot), L.setClearColor(F, Q), Ut !== void 0 && (Pe.viewport = Ut), L.toneMapping = Pt;
        }
        function Nn(ie, Se, ve) {
            const Pe = Se.isScene === !0 ? Se.overrideMaterial : null;
            for(let Me = 0, dt = ie.length; Me < dt; Me++){
                const xt = ie[Me], { object: Et, geometry: Tt, group: Ot } = xt;
                let Pt = xt.material;
                Pt.allowOverride === !0 && Pe !== null && (Pt = Pe), Et.layers.test(ve.layers) && jt(Et, Se, ve, Tt, Pt, Ot);
            }
        }
        function jt(ie, Se, ve, Pe, Me, dt) {
            ie.onBeforeRender(L, Se, ve, Pe, Me, dt), ie.modelViewMatrix.multiplyMatrices(ve.matrixWorldInverse, ie.matrixWorld), ie.normalMatrix.getNormalMatrix(ie.modelViewMatrix), Me.onBeforeRender(L, Se, ve, Pe, ie, dt), Me.transparent === !0 && Me.side === $455d545b1dff00eb$var$Ea && Me.forceSinglePass === !1 ? (Me.side = $455d545b1dff00eb$var$Dr, Me.needsUpdate = !0, L.renderBufferDirect(ve, Se, Pe, Me, ie, dt), Me.side = $455d545b1dff00eb$var$bc, Me.needsUpdate = !0, L.renderBufferDirect(ve, Se, Pe, Me, ie, dt), Me.side = $455d545b1dff00eb$var$Ea) : L.renderBufferDirect(ve, Se, Pe, Me, ie, dt), ie.onAfterRender(L, Se, ve, Pe, Me, dt);
        }
        function ci(ie, Se, ve) {
            Se.isScene !== !0 && (Se = ke);
            const Pe = be.get(ie), Me = R.state.lights, dt = R.state.shadowsArray, xt = Me.state.version, Et = _e.getParameters(ie, Me.state, dt, Se, ve), Tt = _e.getProgramCacheKey(Et);
            let Ot = Pe.programs;
            Pe.environment = ie.isMeshStandardMaterial ? Se.environment : null, Pe.fog = Se.fog, Pe.envMap = (ie.isMeshStandardMaterial ? W : ne).get(ie.envMap || Pe.environment), Pe.envMapRotation = Pe.environment !== null && ie.envMap === null ? Se.environmentRotation : ie.envMapRotation, Ot === void 0 && (ie.addEventListener("dispose", vt), Ot = new Map, Pe.programs = Ot);
            let Pt = Ot.get(Tt);
            if (Pt !== void 0) {
                if (Pe.currentProgram === Pt && Pe.lightsStateVersion === xt) return Qs(ie, Et), Pt;
            } else Et.uniforms = _e.getUniforms(ie), ie.onBeforeCompile(Et, L), Pt = _e.acquireProgram(Et, Tt), Ot.set(Tt, Pt), Pe.uniforms = Et.uniforms;
            const Ut = Pe.uniforms;
            return (!ie.isShaderMaterial && !ie.isRawShaderMaterial || ie.clipping === !0) && (Ut.clippingPlanes = pt.uniform), Qs(ie, Et), Pe.needsLights = Ss(ie), Pe.lightsStateVersion = xt, Pe.needsLights && (Ut.ambientLightColor.value = Me.state.ambient, Ut.lightProbe.value = Me.state.probe, Ut.directionalLights.value = Me.state.directional, Ut.directionalLightShadows.value = Me.state.directionalShadow, Ut.spotLights.value = Me.state.spot, Ut.spotLightShadows.value = Me.state.spotShadow, Ut.rectAreaLights.value = Me.state.rectArea, Ut.ltc_1.value = Me.state.rectAreaLTC1, Ut.ltc_2.value = Me.state.rectAreaLTC2, Ut.pointLights.value = Me.state.point, Ut.pointLightShadows.value = Me.state.pointShadow, Ut.hemisphereLights.value = Me.state.hemi, Ut.directionalShadowMap.value = Me.state.directionalShadowMap, Ut.directionalShadowMatrix.value = Me.state.directionalShadowMatrix, Ut.spotShadowMap.value = Me.state.spotShadowMap, Ut.spotLightMatrix.value = Me.state.spotLightMatrix, Ut.spotLightMap.value = Me.state.spotLightMap, Ut.pointShadowMap.value = Me.state.pointShadowMap, Ut.pointShadowMatrix.value = Me.state.pointShadowMatrix), Pe.currentProgram = Pt, Pe.uniformsList = null, Pt;
        }
        function Aa(ie) {
            if (ie.uniformsList === null) {
                const Se = ie.currentProgram.getUniforms();
                ie.uniformsList = $455d545b1dff00eb$var$Yx.seqWithValue(Se.seq, ie.uniforms);
            }
            return ie.uniformsList;
        }
        function Qs(ie, Se) {
            const ve = be.get(ie);
            ve.outputColorSpace = Se.outputColorSpace, ve.batching = Se.batching, ve.batchingColor = Se.batchingColor, ve.instancing = Se.instancing, ve.instancingColor = Se.instancingColor, ve.instancingMorph = Se.instancingMorph, ve.skinning = Se.skinning, ve.morphTargets = Se.morphTargets, ve.morphNormals = Se.morphNormals, ve.morphColors = Se.morphColors, ve.morphTargetsCount = Se.morphTargetsCount, ve.numClippingPlanes = Se.numClippingPlanes, ve.numIntersection = Se.numClipIntersection, ve.vertexAlphas = Se.vertexAlphas, ve.vertexTangents = Se.vertexTangents, ve.toneMapping = Se.toneMapping;
        }
        function Tl(ie, Se, ve, Pe, Me) {
            Se.isScene !== !0 && (Se = ke), rt.resetTextureUnits();
            const dt = Se.fog, xt = Pe.isMeshStandardMaterial ? Se.environment : null, Et = D === null ? L.outputColorSpace : D.isXRRenderTarget === !0 ? D.texture.colorSpace : $455d545b1dff00eb$var$No, Tt = (Pe.isMeshStandardMaterial ? W : ne).get(Pe.envMap || xt), Ot = Pe.vertexColors === !0 && !!ve.attributes.color && ve.attributes.color.itemSize === 4, Pt = !!ve.attributes.tangent && (!!Pe.normalMap || Pe.anisotropy > 0), Ut = !!ve.morphAttributes.position, qt = !!ve.morphAttributes.normal, mn = !!ve.morphAttributes.color;
            let fn = $455d545b1dff00eb$var$_l;
            Pe.toneMapped && (D === null || D.isXRRenderTarget === !0) && (fn = L.toneMapping);
            const ln = ve.morphAttributes.position || ve.morphAttributes.normal || ve.morphAttributes.color, xn = ln !== void 0 ? ln.length : 0, Lt = be.get(Pe), _n = R.state.lights;
            if (le === !0 && (xe === !0 || ie !== G)) {
                const fi = ie === G && Pe.id === j;
                pt.setState(Pe, ie, fi);
            }
            let an = !1;
            Pe.version === Lt.__version ? (Lt.needsLights && Lt.lightsStateVersion !== _n.state.version || Lt.outputColorSpace !== Et || Me.isBatchedMesh && Lt.batching === !1 || !Me.isBatchedMesh && Lt.batching === !0 || Me.isBatchedMesh && Lt.batchingColor === !0 && Me.colorTexture === null || Me.isBatchedMesh && Lt.batchingColor === !1 && Me.colorTexture !== null || Me.isInstancedMesh && Lt.instancing === !1 || !Me.isInstancedMesh && Lt.instancing === !0 || Me.isSkinnedMesh && Lt.skinning === !1 || !Me.isSkinnedMesh && Lt.skinning === !0 || Me.isInstancedMesh && Lt.instancingColor === !0 && Me.instanceColor === null || Me.isInstancedMesh && Lt.instancingColor === !1 && Me.instanceColor !== null || Me.isInstancedMesh && Lt.instancingMorph === !0 && Me.morphTexture === null || Me.isInstancedMesh && Lt.instancingMorph === !1 && Me.morphTexture !== null || Lt.envMap !== Tt || Pe.fog === !0 && Lt.fog !== dt || Lt.numClippingPlanes !== void 0 && (Lt.numClippingPlanes !== pt.numPlanes || Lt.numIntersection !== pt.numIntersection) || Lt.vertexAlphas !== Ot || Lt.vertexTangents !== Pt || Lt.morphTargets !== Ut || Lt.morphNormals !== qt || Lt.morphColors !== mn || Lt.toneMapping !== fn || Lt.morphTargetsCount !== xn) && (an = !0) : (an = !0, Lt.__version = Pe.version);
            let ui = Lt.currentProgram;
            an === !0 && (ui = ci(Pe, Se, Me));
            let sr = !1, hn = !1, Or = !1;
            const On = ui.getUniforms(), ii = Lt.uniforms;
            if (ze.useProgram(ui.program) && (sr = !0, hn = !0, Or = !0), Pe.id !== j && (j = Pe.id, hn = !0), sr || G !== ie) {
                ze.buffers.depth.getReversed() && ie.reversedDepth !== !0 && (ie._reversedDepth = !0, ie.updateProjectionMatrix()), On.setValue(te, "projectionMatrix", ie.projectionMatrix), On.setValue(te, "viewMatrix", ie.matrixWorldInverse);
                const qn = On.map.cameraPosition;
                qn !== void 0 && qn.setValue(te, Ue.setFromMatrixPosition(ie.matrixWorld)), Ae.logarithmicDepthBuffer && On.setValue(te, "logDepthBufFC", 2 / (Math.log(ie.far + 1) / Math.LN2)), (Pe.isMeshPhongMaterial || Pe.isMeshToonMaterial || Pe.isMeshLambertMaterial || Pe.isMeshBasicMaterial || Pe.isMeshStandardMaterial || Pe.isShaderMaterial) && On.setValue(te, "isOrthographic", ie.isOrthographicCamera === !0), G !== ie && (G = ie, hn = !0, Or = !0);
            }
            if (Me.isSkinnedMesh) {
                On.setOptional(te, Me, "bindMatrix"), On.setOptional(te, Me, "bindMatrixInverse");
                const fi = Me.skeleton;
                fi && (fi.boneTexture === null && fi.computeBoneTexture(), On.setValue(te, "boneTexture", fi.boneTexture, rt));
            }
            Me.isBatchedMesh && (On.setOptional(te, Me, "batchingTexture"), On.setValue(te, "batchingTexture", Me._matricesTexture, rt), On.setOptional(te, Me, "batchingIdTexture"), On.setValue(te, "batchingIdTexture", Me._indirectTexture, rt), On.setOptional(te, Me, "batchingColorTexture"), Me._colorsTexture !== null && On.setValue(te, "batchingColorTexture", Me._colorsTexture, rt));
            const gi = ve.morphAttributes;
            if ((gi.position !== void 0 || gi.normal !== void 0 || gi.color !== void 0) && at.update(Me, ve, ui), (hn || Lt.receiveShadow !== Me.receiveShadow) && (Lt.receiveShadow = Me.receiveShadow, On.setValue(te, "receiveShadow", Me.receiveShadow)), Pe.isMeshGouraudMaterial && Pe.envMap !== null && (ii.envMap.value = Tt, ii.flipEnvMap.value = Tt.isCubeTexture && Tt.isRenderTargetTexture === !1 ? -1 : 1), Pe.isMeshStandardMaterial && Pe.envMap === null && Se.environment !== null && (ii.envMapIntensity.value = Se.environmentIntensity), ii.dfgLUT !== void 0 && (ii.dfgLUT.value = $455d545b1dff00eb$var$gP()), hn && (On.setValue(te, "toneMappingExposure", L.toneMappingExposure), Lt.needsLights && zo(ii, Or), dt && Pe.fog === !0 && ot.refreshFogUniforms(ii, dt), ot.refreshMaterialUniforms(ii, Pe, ee, $, R.state.transmissionRenderTarget[ie.id]), $455d545b1dff00eb$var$Yx.upload(te, Aa(Lt), ii, rt)), Pe.isShaderMaterial && Pe.uniformsNeedUpdate === !0 && ($455d545b1dff00eb$var$Yx.upload(te, Aa(Lt), ii, rt), Pe.uniformsNeedUpdate = !1), Pe.isSpriteMaterial && On.setValue(te, "center", Me.center), On.setValue(te, "modelViewMatrix", Me.modelViewMatrix), On.setValue(te, "normalMatrix", Me.normalMatrix), On.setValue(te, "modelMatrix", Me.matrixWorld), Pe.isShaderMaterial || Pe.isRawShaderMaterial) {
                const fi = Pe.uniformsGroups;
                for(let qn = 0, wa = fi.length; qn < wa; qn++){
                    const Ca = fi[qn];
                    We.update(Ca, ui), We.bind(Ca, ui);
                }
            }
            return ui;
        }
        function zo(ie, Se) {
            ie.ambientLightColor.needsUpdate = Se, ie.lightProbe.needsUpdate = Se, ie.directionalLights.needsUpdate = Se, ie.directionalLightShadows.needsUpdate = Se, ie.pointLights.needsUpdate = Se, ie.pointLightShadows.needsUpdate = Se, ie.spotLights.needsUpdate = Se, ie.spotLightShadows.needsUpdate = Se, ie.rectAreaLights.needsUpdate = Se, ie.hemisphereLights.needsUpdate = Se;
        }
        function Ss(ie) {
            return ie.isMeshLambertMaterial || ie.isMeshToonMaterial || ie.isMeshPhongMaterial || ie.isMeshStandardMaterial || ie.isShadowMaterial || ie.isShaderMaterial && ie.lights === !0;
        }
        this.getActiveCubeFace = function() {
            return H;
        }, this.getActiveMipmapLevel = function() {
            return O;
        }, this.getRenderTarget = function() {
            return D;
        }, this.setRenderTargetTextures = function(ie, Se, ve) {
            const Pe = be.get(ie);
            Pe.__autoAllocateDepthBuffer = ie.resolveDepthBuffer === !1, Pe.__autoAllocateDepthBuffer === !1 && (Pe.__useRenderToTexture = !1), be.get(ie.texture).__webglTexture = Se, be.get(ie.depthTexture).__webglTexture = Pe.__autoAllocateDepthBuffer ? void 0 : ve, Pe.__hasExternalTextures = !0;
        }, this.setRenderTargetFramebuffer = function(ie, Se) {
            const ve = be.get(ie);
            ve.__webglFramebuffer = Se, ve.__useDefaultFramebuffer = Se === void 0;
        };
        const es = te.createFramebuffer();
        this.setRenderTarget = function(ie, Se = 0, ve = 0) {
            D = ie, H = Se, O = ve;
            let Pe = !0, Me = null, dt = !1, xt = !1;
            if (ie) {
                const Tt = be.get(ie);
                if (Tt.__useDefaultFramebuffer !== void 0) ze.bindFramebuffer(te.FRAMEBUFFER, null), Pe = !1;
                else if (Tt.__webglFramebuffer === void 0) rt.setupRenderTarget(ie);
                else if (Tt.__hasExternalTextures) rt.rebindTextures(ie, be.get(ie.texture).__webglTexture, be.get(ie.depthTexture).__webglTexture);
                else if (ie.depthBuffer) {
                    const Ut = ie.depthTexture;
                    if (Tt.__boundDepthTexture !== Ut) {
                        if (Ut !== null && be.has(Ut) && (ie.width !== Ut.image.width || ie.height !== Ut.image.height)) throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                        rt.setupDepthRenderbuffer(ie);
                    }
                }
                const Ot = ie.texture;
                (Ot.isData3DTexture || Ot.isDataArrayTexture || Ot.isCompressedArrayTexture) && (xt = !0);
                const Pt = be.get(ie).__webglFramebuffer;
                ie.isWebGLCubeRenderTarget ? (Array.isArray(Pt[Se]) ? Me = Pt[Se][ve] : Me = Pt[Se], dt = !0) : ie.samples > 0 && rt.useMultisampledRTT(ie) === !1 ? Me = be.get(ie).__webglMultisampledFramebuffer : Array.isArray(Pt) ? Me = Pt[ve] : Me = Pt, q.copy(ie.viewport), Y.copy(ie.scissor), ae = ie.scissorTest;
            } else q.copy(oe).multiplyScalar(ee).floor(), Y.copy(ce).multiplyScalar(ee).floor(), ae = de;
            if (ve !== 0 && (Me = es), ze.bindFramebuffer(te.FRAMEBUFFER, Me) && Pe && ze.drawBuffers(ie, Me), ze.viewport(q), ze.scissor(Y), ze.setScissorTest(ae), dt) {
                const Tt = be.get(ie.texture);
                te.framebufferTexture2D(te.FRAMEBUFFER, te.COLOR_ATTACHMENT0, te.TEXTURE_CUBE_MAP_POSITIVE_X + Se, Tt.__webglTexture, ve);
            } else if (xt) {
                const Tt = Se;
                for(let Ot = 0; Ot < ie.textures.length; Ot++){
                    const Pt = be.get(ie.textures[Ot]);
                    te.framebufferTextureLayer(te.FRAMEBUFFER, te.COLOR_ATTACHMENT0 + Ot, Pt.__webglTexture, ve, Tt);
                }
            } else if (ie !== null && ve !== 0) {
                const Tt = be.get(ie.texture);
                te.framebufferTexture2D(te.FRAMEBUFFER, te.COLOR_ATTACHMENT0, te.TEXTURE_2D, Tt.__webglTexture, ve);
            }
            j = -1;
        }, this.readRenderTargetPixels = function(ie, Se, ve, Pe, Me, dt, xt, Et = 0) {
            if (!(ie && ie.isWebGLRenderTarget)) {
                $455d545b1dff00eb$var$Qt("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let Tt = be.get(ie).__webglFramebuffer;
            if (ie.isWebGLCubeRenderTarget && xt !== void 0 && (Tt = Tt[xt]), Tt) {
                ze.bindFramebuffer(te.FRAMEBUFFER, Tt);
                try {
                    const Ot = ie.textures[Et], Pt = Ot.format, Ut = Ot.type;
                    if (!Ae.textureFormatReadable(Pt)) {
                        $455d545b1dff00eb$var$Qt("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    if (!Ae.textureTypeReadable(Ut)) {
                        $455d545b1dff00eb$var$Qt("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    Se >= 0 && Se <= ie.width - Pe && ve >= 0 && ve <= ie.height - Me && (ie.textures.length > 1 && te.readBuffer(te.COLOR_ATTACHMENT0 + Et), te.readPixels(Se, ve, Pe, Me, lt.convert(Pt), lt.convert(Ut), dt));
                } finally{
                    const Ot = D !== null ? be.get(D).__webglFramebuffer : null;
                    ze.bindFramebuffer(te.FRAMEBUFFER, Ot);
                }
            }
        }, this.readRenderTargetPixelsAsync = async function(ie, Se, ve, Pe, Me, dt, xt, Et = 0) {
            if (!(ie && ie.isWebGLRenderTarget)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let Tt = be.get(ie).__webglFramebuffer;
            if (ie.isWebGLCubeRenderTarget && xt !== void 0 && (Tt = Tt[xt]), Tt) {
                if (Se >= 0 && Se <= ie.width - Pe && ve >= 0 && ve <= ie.height - Me) {
                    ze.bindFramebuffer(te.FRAMEBUFFER, Tt);
                    const Ot = ie.textures[Et], Pt = Ot.format, Ut = Ot.type;
                    if (!Ae.textureFormatReadable(Pt)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                    if (!Ae.textureTypeReadable(Ut)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                    const qt = te.createBuffer();
                    te.bindBuffer(te.PIXEL_PACK_BUFFER, qt), te.bufferData(te.PIXEL_PACK_BUFFER, dt.byteLength, te.STREAM_READ), ie.textures.length > 1 && te.readBuffer(te.COLOR_ATTACHMENT0 + Et), te.readPixels(Se, ve, Pe, Me, lt.convert(Pt), lt.convert(Ut), 0);
                    const mn = D !== null ? be.get(D).__webglFramebuffer : null;
                    ze.bindFramebuffer(te.FRAMEBUFFER, mn);
                    const fn = te.fenceSync(te.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    return te.flush(), await $455d545b1dff00eb$var$PD(te, fn, 4), te.bindBuffer(te.PIXEL_PACK_BUFFER, qt), te.getBufferSubData(te.PIXEL_PACK_BUFFER, 0, dt), te.deleteBuffer(qt), te.deleteSync(fn), dt;
                } else throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
        }, this.copyFramebufferToTexture = function(ie, Se = null, ve = 0) {
            const Pe = Math.pow(2, -ve), Me = Math.floor(ie.image.width * Pe), dt = Math.floor(ie.image.height * Pe), xt = Se !== null ? Se.x : 0, Et = Se !== null ? Se.y : 0;
            rt.setTexture2D(ie, 0), te.copyTexSubImage2D(te.TEXTURE_2D, ve, 0, 0, xt, Et, Me, dt), ze.unbindTexture();
        };
        const Ms = te.createFramebuffer(), Qn = te.createFramebuffer();
        this.copyTextureToTexture = function(ie, Se, ve = null, Pe = null, Me = 0, dt = null) {
            dt === null && (Me !== 0 ? ($455d545b1dff00eb$var$Id("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), dt = Me, Me = 0) : dt = 0);
            let xt, Et, Tt, Ot, Pt, Ut, qt, mn, fn;
            const ln = ie.isCompressedTexture ? ie.mipmaps[dt] : ie.image;
            if (ve !== null) xt = ve.max.x - ve.min.x, Et = ve.max.y - ve.min.y, Tt = ve.isBox3 ? ve.max.z - ve.min.z : 1, Ot = ve.min.x, Pt = ve.min.y, Ut = ve.isBox3 ? ve.min.z : 0;
            else {
                const gi = Math.pow(2, -Me);
                xt = Math.floor(ln.width * gi), Et = Math.floor(ln.height * gi), ie.isDataArrayTexture ? Tt = ln.depth : ie.isData3DTexture ? Tt = Math.floor(ln.depth * gi) : Tt = 1, Ot = 0, Pt = 0, Ut = 0;
            }
            Pe !== null ? (qt = Pe.x, mn = Pe.y, fn = Pe.z) : (qt = 0, mn = 0, fn = 0);
            const xn = lt.convert(Se.format), Lt = lt.convert(Se.type);
            let _n;
            Se.isData3DTexture ? (rt.setTexture3D(Se, 0), _n = te.TEXTURE_3D) : Se.isDataArrayTexture || Se.isCompressedArrayTexture ? (rt.setTexture2DArray(Se, 0), _n = te.TEXTURE_2D_ARRAY) : (rt.setTexture2D(Se, 0), _n = te.TEXTURE_2D), te.pixelStorei(te.UNPACK_FLIP_Y_WEBGL, Se.flipY), te.pixelStorei(te.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Se.premultiplyAlpha), te.pixelStorei(te.UNPACK_ALIGNMENT, Se.unpackAlignment);
            const an = te.getParameter(te.UNPACK_ROW_LENGTH), ui = te.getParameter(te.UNPACK_IMAGE_HEIGHT), sr = te.getParameter(te.UNPACK_SKIP_PIXELS), hn = te.getParameter(te.UNPACK_SKIP_ROWS), Or = te.getParameter(te.UNPACK_SKIP_IMAGES);
            te.pixelStorei(te.UNPACK_ROW_LENGTH, ln.width), te.pixelStorei(te.UNPACK_IMAGE_HEIGHT, ln.height), te.pixelStorei(te.UNPACK_SKIP_PIXELS, Ot), te.pixelStorei(te.UNPACK_SKIP_ROWS, Pt), te.pixelStorei(te.UNPACK_SKIP_IMAGES, Ut);
            const On = ie.isDataArrayTexture || ie.isData3DTexture, ii = Se.isDataArrayTexture || Se.isData3DTexture;
            if (ie.isDepthTexture) {
                const gi = be.get(ie), fi = be.get(Se), qn = be.get(gi.__renderTarget), wa = be.get(fi.__renderTarget);
                ze.bindFramebuffer(te.READ_FRAMEBUFFER, qn.__webglFramebuffer), ze.bindFramebuffer(te.DRAW_FRAMEBUFFER, wa.__webglFramebuffer);
                for(let Ca = 0; Ca < Tt; Ca++)On && (te.framebufferTextureLayer(te.READ_FRAMEBUFFER, te.COLOR_ATTACHMENT0, be.get(ie).__webglTexture, Me, Ut + Ca), te.framebufferTextureLayer(te.DRAW_FRAMEBUFFER, te.COLOR_ATTACHMENT0, be.get(Se).__webglTexture, dt, fn + Ca)), te.blitFramebuffer(Ot, Pt, xt, Et, qt, mn, xt, Et, te.DEPTH_BUFFER_BIT, te.NEAREST);
                ze.bindFramebuffer(te.READ_FRAMEBUFFER, null), ze.bindFramebuffer(te.DRAW_FRAMEBUFFER, null);
            } else if (Me !== 0 || ie.isRenderTargetTexture || be.has(ie)) {
                const gi = be.get(ie), fi = be.get(Se);
                ze.bindFramebuffer(te.READ_FRAMEBUFFER, Ms), ze.bindFramebuffer(te.DRAW_FRAMEBUFFER, Qn);
                for(let qn = 0; qn < Tt; qn++)On ? te.framebufferTextureLayer(te.READ_FRAMEBUFFER, te.COLOR_ATTACHMENT0, gi.__webglTexture, Me, Ut + qn) : te.framebufferTexture2D(te.READ_FRAMEBUFFER, te.COLOR_ATTACHMENT0, te.TEXTURE_2D, gi.__webglTexture, Me), ii ? te.framebufferTextureLayer(te.DRAW_FRAMEBUFFER, te.COLOR_ATTACHMENT0, fi.__webglTexture, dt, fn + qn) : te.framebufferTexture2D(te.DRAW_FRAMEBUFFER, te.COLOR_ATTACHMENT0, te.TEXTURE_2D, fi.__webglTexture, dt), Me !== 0 ? te.blitFramebuffer(Ot, Pt, xt, Et, qt, mn, xt, Et, te.COLOR_BUFFER_BIT, te.NEAREST) : ii ? te.copyTexSubImage3D(_n, dt, qt, mn, fn + qn, Ot, Pt, xt, Et) : te.copyTexSubImage2D(_n, dt, qt, mn, Ot, Pt, xt, Et);
                ze.bindFramebuffer(te.READ_FRAMEBUFFER, null), ze.bindFramebuffer(te.DRAW_FRAMEBUFFER, null);
            } else ii ? ie.isDataTexture || ie.isData3DTexture ? te.texSubImage3D(_n, dt, qt, mn, fn, xt, Et, Tt, xn, Lt, ln.data) : Se.isCompressedArrayTexture ? te.compressedTexSubImage3D(_n, dt, qt, mn, fn, xt, Et, Tt, xn, ln.data) : te.texSubImage3D(_n, dt, qt, mn, fn, xt, Et, Tt, xn, Lt, ln) : ie.isDataTexture ? te.texSubImage2D(te.TEXTURE_2D, dt, qt, mn, xt, Et, xn, Lt, ln.data) : ie.isCompressedTexture ? te.compressedTexSubImage2D(te.TEXTURE_2D, dt, qt, mn, ln.width, ln.height, xn, ln.data) : te.texSubImage2D(te.TEXTURE_2D, dt, qt, mn, xt, Et, xn, Lt, ln);
            te.pixelStorei(te.UNPACK_ROW_LENGTH, an), te.pixelStorei(te.UNPACK_IMAGE_HEIGHT, ui), te.pixelStorei(te.UNPACK_SKIP_PIXELS, sr), te.pixelStorei(te.UNPACK_SKIP_ROWS, hn), te.pixelStorei(te.UNPACK_SKIP_IMAGES, Or), dt === 0 && Se.generateMipmaps && te.generateMipmap(_n), ze.unbindTexture();
        }, this.initRenderTarget = function(ie) {
            be.get(ie).__webglFramebuffer === void 0 && rt.setupRenderTarget(ie);
        }, this.initTexture = function(ie) {
            ie.isCubeTexture ? rt.setTextureCube(ie, 0) : ie.isData3DTexture ? rt.setTexture3D(ie, 0) : ie.isDataArrayTexture || ie.isCompressedArrayTexture ? rt.setTexture2DArray(ie, 0) : rt.setTexture2D(ie, 0), ze.unbindTexture();
        }, this.resetState = function() {
            H = 0, O = 0, D = null, ze.reset(), fe.reset();
        }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $455d545b1dff00eb$var$_s;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(e) {
        this._outputColorSpace = e;
        const t = this.getContext();
        t.drawingBufferColorSpace = $455d545b1dff00eb$var$Dn._getDrawingBufferColorSpace(e), t.unpackColorSpace = $455d545b1dff00eb$var$Dn._getUnpackColorSpace();
    }
}
const $455d545b1dff00eb$var$xP = Object.freeze(Object.defineProperty({
    __proto__: null,
    ACESFilmicToneMapping: $455d545b1dff00eb$var$Rb,
    AddEquation: $455d545b1dff00eb$var$vu,
    AddOperation: $455d545b1dff00eb$var$JE,
    AdditiveAnimationBlendMode: $455d545b1dff00eb$var$Bb,
    AdditiveBlending: $455d545b1dff00eb$var$W_,
    AgXToneMapping: $455d545b1dff00eb$var$iT,
    AlphaFormat: $455d545b1dff00eb$var$zb,
    AlwaysCompare: $455d545b1dff00eb$var$xT,
    AlwaysDepth: $455d545b1dff00eb$var$av,
    AlwaysStencilFunc: $455d545b1dff00eb$var$Q_,
    AmbientLight: $455d545b1dff00eb$var$uA,
    AnimationAction: $455d545b1dff00eb$var$vA,
    AnimationClip: $455d545b1dff00eb$var$d0,
    AnimationLoader: $455d545b1dff00eb$var$TN,
    AnimationMixer: $455d545b1dff00eb$var$e4,
    AnimationObjectGroup: $455d545b1dff00eb$var$JN,
    AnimationUtils: $455d545b1dff00eb$var$bN,
    ArcCurve: $455d545b1dff00eb$var$zT,
    ArrayCamera: $455d545b1dff00eb$var$mA,
    ArrowHelper: $455d545b1dff00eb$var$T4,
    AttachedBindMode: $455d545b1dff00eb$var$Z_,
    Audio: $455d545b1dff00eb$var$gA,
    AudioAnalyser: $455d545b1dff00eb$var$GN,
    AudioContext: $455d545b1dff00eb$var$lS,
    AudioListener: $455d545b1dff00eb$var$FN,
    AudioLoader: $455d545b1dff00eb$var$PN,
    AxesHelper: $455d545b1dff00eb$var$A4,
    BackSide: $455d545b1dff00eb$var$Dr,
    BasicDepthPacking: $455d545b1dff00eb$var$cT,
    BasicShadowMap: $455d545b1dff00eb$var$NE,
    BatchedMesh: $455d545b1dff00eb$var$DT,
    Bone: $455d545b1dff00eb$var$qb,
    BooleanKeyframeTrack: $455d545b1dff00eb$var$Jf,
    Box2: $455d545b1dff00eb$var$c4,
    Box3: $455d545b1dff00eb$var$ca,
    Box3Helper: $455d545b1dff00eb$var$M4,
    BoxGeometry: $455d545b1dff00eb$var$Ru,
    BoxHelper: $455d545b1dff00eb$var$S4,
    BufferAttribute: $455d545b1dff00eb$var$ti,
    BufferGeometry: $455d545b1dff00eb$var$nn,
    BufferGeometryLoader: $455d545b1dff00eb$var$pA,
    ByteType: $455d545b1dff00eb$var$Ub,
    Cache: $455d545b1dff00eb$var$xl,
    Camera: $455d545b1dff00eb$var$hy,
    CameraHelper: $455d545b1dff00eb$var$b4,
    CanvasTexture: $455d545b1dff00eb$var$jU,
    CapsuleGeometry: $455d545b1dff00eb$var$_y,
    CatmullRomCurve3: $455d545b1dff00eb$var$PT,
    CineonToneMapping: $455d545b1dff00eb$var$tT,
    CircleGeometry: $455d545b1dff00eb$var$by,
    ClampToEdgeWrapping: $455d545b1dff00eb$var$Kr,
    Clock: $455d545b1dff00eb$var$cS,
    Color: $455d545b1dff00eb$var$_t,
    ColorKeyframeTrack: $455d545b1dff00eb$var$aS,
    ColorManagement: $455d545b1dff00eb$var$Dn,
    CompressedArrayTexture: $455d545b1dff00eb$var$GU,
    CompressedCubeTexture: $455d545b1dff00eb$var$kU,
    CompressedTexture: $455d545b1dff00eb$var$vy,
    CompressedTextureLoader: $455d545b1dff00eb$var$AN,
    ConeGeometry: $455d545b1dff00eb$var$A0,
    ConstantAlphaFactor: $455d545b1dff00eb$var$ZE,
    ConstantColorFactor: $455d545b1dff00eb$var$qE,
    Controls: $455d545b1dff00eb$var$_A,
    CubeCamera: $455d545b1dff00eb$var$MT,
    CubeReflectionMapping: $455d545b1dff00eb$var$Sc,
    CubeRefractionMapping: $455d545b1dff00eb$var$Mu,
    CubeTexture: $455d545b1dff00eb$var$E0,
    CubeTextureLoader: $455d545b1dff00eb$var$wN,
    CubeUVReflectionMapping: $455d545b1dff00eb$var$Wd,
    CubicBezierCurve: $455d545b1dff00eb$var$Kb,
    CubicBezierCurve3: $455d545b1dff00eb$var$BT,
    CubicInterpolant: $455d545b1dff00eb$var$nA,
    CullFaceBack: $455d545b1dff00eb$var$X_,
    CullFaceFront: $455d545b1dff00eb$var$UE,
    CullFaceFrontBack: $455d545b1dff00eb$var$QR,
    CullFaceNone: $455d545b1dff00eb$var$DE,
    Curve: $455d545b1dff00eb$var$Lo,
    CurvePath: $455d545b1dff00eb$var$FT,
    CustomBlending: $455d545b1dff00eb$var$OE,
    CustomToneMapping: $455d545b1dff00eb$var$nT,
    CylinderGeometry: $455d545b1dff00eb$var$T0,
    Cylindrical: $455d545b1dff00eb$var$l4,
    Data3DTexture: $455d545b1dff00eb$var$fy,
    DataArrayTexture: $455d545b1dff00eb$var$uy,
    DataTexture: $455d545b1dff00eb$var$Ro,
    DataTextureLoader: $455d545b1dff00eb$var$CN,
    DataUtils: $455d545b1dff00eb$var$dU,
    DecrementStencilOp: $455d545b1dff00eb$var$uD,
    DecrementWrapStencilOp: $455d545b1dff00eb$var$hD,
    DefaultLoadingManager: $455d545b1dff00eb$var$rA,
    DepthFormat: $455d545b1dff00eb$var$zd,
    DepthStencilFormat: $455d545b1dff00eb$var$Pd,
    DepthTexture: $455d545b1dff00eb$var$yy,
    DetachedBindMode: $455d545b1dff00eb$var$rT,
    DirectionalLight: $455d545b1dff00eb$var$cA,
    DirectionalLightHelper: $455d545b1dff00eb$var$_4,
    DiscreteInterpolant: $455d545b1dff00eb$var$iA,
    DodecahedronGeometry: $455d545b1dff00eb$var$Sy,
    DoubleSide: $455d545b1dff00eb$var$Ea,
    DstAlphaFactor: $455d545b1dff00eb$var$GE,
    DstColorFactor: $455d545b1dff00eb$var$jE,
    DynamicCopyUsage: $455d545b1dff00eb$var$wD,
    DynamicDrawUsage: $455d545b1dff00eb$var$bD,
    DynamicReadUsage: $455d545b1dff00eb$var$ED,
    EdgesGeometry: $455d545b1dff00eb$var$LT,
    EllipseCurve: $455d545b1dff00eb$var$My,
    EqualCompare: $455d545b1dff00eb$var$dT,
    EqualDepth: $455d545b1dff00eb$var$sv,
    EqualStencilFunc: $455d545b1dff00eb$var$gD,
    EquirectangularReflectionMapping: $455d545b1dff00eb$var$Jm,
    EquirectangularRefractionMapping: $455d545b1dff00eb$var$$m,
    Euler: $455d545b1dff00eb$var$ua,
    EventDispatcher: $455d545b1dff00eb$var$Ml,
    ExternalTexture: $455d545b1dff00eb$var$Zb,
    ExtrudeGeometry: $455d545b1dff00eb$var$Ey,
    FileLoader: $455d545b1dff00eb$var$Ec,
    Float16BufferAttribute: $455d545b1dff00eb$var$_U,
    Float32BufferAttribute: $455d545b1dff00eb$var$Dt,
    FloatType: $455d545b1dff00eb$var$Rr,
    Fog: $455d545b1dff00eb$var$py,
    FogExp2: $455d545b1dff00eb$var$dy,
    FramebufferTexture: $455d545b1dff00eb$var$VU,
    FrontSide: $455d545b1dff00eb$var$bc,
    Frustum: $455d545b1dff00eb$var$qd,
    FrustumArray: $455d545b1dff00eb$var$xy,
    GLBufferAttribute: $455d545b1dff00eb$var$r4,
    GLSL1: $455d545b1dff00eb$var$RD,
    GLSL3: $455d545b1dff00eb$var$K_,
    GreaterCompare: $455d545b1dff00eb$var$pT,
    GreaterDepth: $455d545b1dff00eb$var$lv,
    GreaterEqualCompare: $455d545b1dff00eb$var$gT,
    GreaterEqualDepth: $455d545b1dff00eb$var$ov,
    GreaterEqualStencilFunc: $455d545b1dff00eb$var$_D,
    GreaterStencilFunc: $455d545b1dff00eb$var$vD,
    GridHelper: $455d545b1dff00eb$var$v4,
    Group: $455d545b1dff00eb$var$Cd,
    HalfFloatType: $455d545b1dff00eb$var$wu,
    HemisphereLight: $455d545b1dff00eb$var$sA,
    HemisphereLightHelper: $455d545b1dff00eb$var$x4,
    IcosahedronGeometry: $455d545b1dff00eb$var$Ty,
    ImageBitmapLoader: $455d545b1dff00eb$var$zN,
    ImageLoader: $455d545b1dff00eb$var$p0,
    ImageUtils: $455d545b1dff00eb$var$_T,
    IncrementStencilOp: $455d545b1dff00eb$var$cD,
    IncrementWrapStencilOp: $455d545b1dff00eb$var$fD,
    InstancedBufferAttribute: $455d545b1dff00eb$var$Wf,
    InstancedBufferGeometry: $455d545b1dff00eb$var$oS,
    InstancedInterleavedBuffer: $455d545b1dff00eb$var$a4,
    InstancedMesh: $455d545b1dff00eb$var$RT,
    Int16BufferAttribute: $455d545b1dff00eb$var$vU,
    Int32BufferAttribute: $455d545b1dff00eb$var$yU,
    Int8BufferAttribute: $455d545b1dff00eb$var$mU,
    IntType: $455d545b1dff00eb$var$ny,
    InterleavedBuffer: $455d545b1dff00eb$var$my,
    InterleavedBufferAttribute: $455d545b1dff00eb$var$Xf,
    Interpolant: $455d545b1dff00eb$var$R0,
    InterpolateDiscrete: $455d545b1dff00eb$var$n0,
    InterpolateLinear: $455d545b1dff00eb$var$Iv,
    InterpolateSmooth: $455d545b1dff00eb$var$Wx,
    InterpolationSamplingMode: $455d545b1dff00eb$var$ND,
    InterpolationSamplingType: $455d545b1dff00eb$var$UD,
    InvertStencilOp: $455d545b1dff00eb$var$dD,
    KeepStencilOp: $455d545b1dff00eb$var$Nf,
    KeyframeTrack: $455d545b1dff00eb$var$Ys,
    LOD: $455d545b1dff00eb$var$wT,
    LatheGeometry: $455d545b1dff00eb$var$Ay,
    Layers: $455d545b1dff00eb$var$Hd,
    LessCompare: $455d545b1dff00eb$var$hT,
    LessDepth: $455d545b1dff00eb$var$rv,
    LessEqualCompare: $455d545b1dff00eb$var$Fb,
    LessEqualDepth: $455d545b1dff00eb$var$jf,
    LessEqualStencilFunc: $455d545b1dff00eb$var$xD,
    LessStencilFunc: $455d545b1dff00eb$var$mD,
    Light: $455d545b1dff00eb$var$Uu,
    LightProbe: $455d545b1dff00eb$var$dA,
    Line: $455d545b1dff00eb$var$Tu,
    Line3: $455d545b1dff00eb$var$h4,
    LineBasicMaterial: $455d545b1dff00eb$var$Nr,
    LineCurve: $455d545b1dff00eb$var$Jb,
    LineCurve3: $455d545b1dff00eb$var$IT,
    LineDashedMaterial: $455d545b1dff00eb$var$$T,
    LineLoop: $455d545b1dff00eb$var$UT,
    LineSegments: $455d545b1dff00eb$var$El,
    LinearFilter: $455d545b1dff00eb$var$mi,
    LinearInterpolant: $455d545b1dff00eb$var$iS,
    LinearMipMapLinearFilter: $455d545b1dff00eb$var$eD,
    LinearMipMapNearestFilter: $455d545b1dff00eb$var$$R,
    LinearMipmapLinearFilter: $455d545b1dff00eb$var$gl,
    LinearMipmapNearestFilter: $455d545b1dff00eb$var$Fm,
    LinearSRGBColorSpace: $455d545b1dff00eb$var$No,
    LinearToneMapping: $455d545b1dff00eb$var$$E,
    LinearTransfer: $455d545b1dff00eb$var$a0,
    Loader: $455d545b1dff00eb$var$$r,
    LoaderUtils: $455d545b1dff00eb$var$nb,
    LoadingManager: $455d545b1dff00eb$var$rS,
    LoopOnce: $455d545b1dff00eb$var$sT,
    LoopPingPong: $455d545b1dff00eb$var$lT,
    LoopRepeat: $455d545b1dff00eb$var$oT,
    MOUSE: $455d545b1dff00eb$var$Xs,
    Material: $455d545b1dff00eb$var$rr,
    MaterialLoader: $455d545b1dff00eb$var$Py,
    MathUtils: $455d545b1dff00eb$var$Of,
    Matrix2: $455d545b1dff00eb$var$pS,
    Matrix3: $455d545b1dff00eb$var$Jt,
    Matrix4: $455d545b1dff00eb$var$Ft,
    MaxEquation: $455d545b1dff00eb$var$BE,
    Mesh: $455d545b1dff00eb$var$zi,
    MeshBasicMaterial: $455d545b1dff00eb$var$Ac,
    MeshDepthMaterial: $455d545b1dff00eb$var$Ly,
    MeshDistanceMaterial: $455d545b1dff00eb$var$zy,
    MeshLambertMaterial: $455d545b1dff00eb$var$KT,
    MeshMatcapMaterial: $455d545b1dff00eb$var$JT,
    MeshNormalMaterial: $455d545b1dff00eb$var$QT,
    MeshPhongMaterial: $455d545b1dff00eb$var$YT,
    MeshPhysicalMaterial: $455d545b1dff00eb$var$qT,
    MeshStandardMaterial: $455d545b1dff00eb$var$Oy,
    MeshToonMaterial: $455d545b1dff00eb$var$ZT,
    MinEquation: $455d545b1dff00eb$var$PE,
    MirroredRepeatWrapping: $455d545b1dff00eb$var$t0,
    MixOperation: $455d545b1dff00eb$var$KE,
    MultiplyBlending: $455d545b1dff00eb$var$Y_,
    MultiplyOperation: $455d545b1dff00eb$var$S0,
    NearestFilter: $455d545b1dff00eb$var$Fa,
    NearestMipMapLinearFilter: $455d545b1dff00eb$var$JR,
    NearestMipMapNearestFilter: $455d545b1dff00eb$var$KR,
    NearestMipmapLinearFilter: $455d545b1dff00eb$var$Ad,
    NearestMipmapNearestFilter: $455d545b1dff00eb$var$Db,
    NeutralToneMapping: $455d545b1dff00eb$var$aT,
    NeverCompare: $455d545b1dff00eb$var$fT,
    NeverDepth: $455d545b1dff00eb$var$iv,
    NeverStencilFunc: $455d545b1dff00eb$var$pD,
    NoBlending: $455d545b1dff00eb$var$yl,
    NoColorSpace: $455d545b1dff00eb$var$pc,
    NoToneMapping: $455d545b1dff00eb$var$_l,
    NormalAnimationBlendMode: $455d545b1dff00eb$var$cy,
    NormalBlending: $455d545b1dff00eb$var$Ff,
    NotEqualCompare: $455d545b1dff00eb$var$mT,
    NotEqualDepth: $455d545b1dff00eb$var$cv,
    NotEqualStencilFunc: $455d545b1dff00eb$var$yD,
    NumberKeyframeTrack: $455d545b1dff00eb$var$f0,
    Object3D: $455d545b1dff00eb$var$Pn,
    ObjectLoader: $455d545b1dff00eb$var$ON,
    ObjectSpaceNormalMap: $455d545b1dff00eb$var$uT,
    OctahedronGeometry: $455d545b1dff00eb$var$w0,
    OneFactor: $455d545b1dff00eb$var$FE,
    OneMinusConstantAlphaFactor: $455d545b1dff00eb$var$QE,
    OneMinusConstantColorFactor: $455d545b1dff00eb$var$YE,
    OneMinusDstAlphaFactor: $455d545b1dff00eb$var$kE,
    OneMinusDstColorFactor: $455d545b1dff00eb$var$XE,
    OneMinusSrcAlphaFactor: $455d545b1dff00eb$var$nv,
    OneMinusSrcColorFactor: $455d545b1dff00eb$var$VE,
    OrthographicCamera: $455d545b1dff00eb$var$bl,
    PCFShadowMap: $455d545b1dff00eb$var$ey,
    PCFSoftShadowMap: $455d545b1dff00eb$var$Im,
    PMREMGenerator: $455d545b1dff00eb$var$sb,
    Path: $455d545b1dff00eb$var$Gv,
    PerspectiveCamera: $455d545b1dff00eb$var$Ui,
    Plane: $455d545b1dff00eb$var$ml,
    PlaneGeometry: $455d545b1dff00eb$var$Jr,
    PlaneHelper: $455d545b1dff00eb$var$E4,
    PointLight: $455d545b1dff00eb$var$lA,
    PointLightHelper: $455d545b1dff00eb$var$m4,
    Points: $455d545b1dff00eb$var$NT,
    PointsMaterial: $455d545b1dff00eb$var$Yb,
    PolarGridHelper: $455d545b1dff00eb$var$y4,
    PolyhedronGeometry: $455d545b1dff00eb$var$Du,
    PositionalAudio: $455d545b1dff00eb$var$VN,
    PropertyBinding: $455d545b1dff00eb$var$zn,
    PropertyMixer: $455d545b1dff00eb$var$xA,
    QuadraticBezierCurve: $455d545b1dff00eb$var$$b,
    QuadraticBezierCurve3: $455d545b1dff00eb$var$eS,
    Quaternion: $455d545b1dff00eb$var$Gn,
    QuaternionKeyframeTrack: $455d545b1dff00eb$var$D0,
    QuaternionLinearInterpolant: $455d545b1dff00eb$var$aA,
    RED_GREEN_RGTC2_Format: $455d545b1dff00eb$var$Pv,
    RED_RGTC1_Format: $455d545b1dff00eb$var$Lv,
    REVISION: $455d545b1dff00eb$var$$v,
    RGBADepthPacking: $455d545b1dff00eb$var$Ib,
    RGBAFormat: $455d545b1dff00eb$var$ar,
    RGBAIntegerFormat: $455d545b1dff00eb$var$ly,
    RGBA_ASTC_10x10_Format: $455d545b1dff00eb$var$Cv,
    RGBA_ASTC_10x5_Format: $455d545b1dff00eb$var$Tv,
    RGBA_ASTC_10x6_Format: $455d545b1dff00eb$var$Av,
    RGBA_ASTC_10x8_Format: $455d545b1dff00eb$var$wv,
    RGBA_ASTC_12x10_Format: $455d545b1dff00eb$var$Rv,
    RGBA_ASTC_12x12_Format: $455d545b1dff00eb$var$Dv,
    RGBA_ASTC_4x4_Format: $455d545b1dff00eb$var$xv,
    RGBA_ASTC_5x4_Format: $455d545b1dff00eb$var$vv,
    RGBA_ASTC_5x5_Format: $455d545b1dff00eb$var$yv,
    RGBA_ASTC_6x5_Format: $455d545b1dff00eb$var$_v,
    RGBA_ASTC_6x6_Format: $455d545b1dff00eb$var$bv,
    RGBA_ASTC_8x5_Format: $455d545b1dff00eb$var$Sv,
    RGBA_ASTC_8x6_Format: $455d545b1dff00eb$var$Mv,
    RGBA_ASTC_8x8_Format: $455d545b1dff00eb$var$Ev,
    RGBA_BPTC_Format: $455d545b1dff00eb$var$Uv,
    RGBA_ETC2_EAC_Format: $455d545b1dff00eb$var$gv,
    RGBA_PVRTC_2BPPV1_Format: $455d545b1dff00eb$var$dv,
    RGBA_PVRTC_4BPPV1_Format: $455d545b1dff00eb$var$hv,
    RGBA_S3TC_DXT1_Format: $455d545b1dff00eb$var$Vm,
    RGBA_S3TC_DXT3_Format: $455d545b1dff00eb$var$Gm,
    RGBA_S3TC_DXT5_Format: $455d545b1dff00eb$var$km,
    RGBDepthPacking: $455d545b1dff00eb$var$rD,
    RGBFormat: $455d545b1dff00eb$var$Pb,
    RGBIntegerFormat: $455d545b1dff00eb$var$tD,
    RGB_BPTC_SIGNED_Format: $455d545b1dff00eb$var$Nv,
    RGB_BPTC_UNSIGNED_Format: $455d545b1dff00eb$var$Ov,
    RGB_ETC1_Format: $455d545b1dff00eb$var$pv,
    RGB_ETC2_Format: $455d545b1dff00eb$var$mv,
    RGB_PVRTC_2BPPV1_Format: $455d545b1dff00eb$var$fv,
    RGB_PVRTC_4BPPV1_Format: $455d545b1dff00eb$var$uv,
    RGB_S3TC_DXT1_Format: $455d545b1dff00eb$var$Hm,
    RGDepthPacking: $455d545b1dff00eb$var$sD,
    RGFormat: $455d545b1dff00eb$var$sy,
    RGIntegerFormat: $455d545b1dff00eb$var$oy,
    RawShaderMaterial: $455d545b1dff00eb$var$WT,
    Ray: $455d545b1dff00eb$var$Kf,
    Raycaster: $455d545b1dff00eb$var$dS,
    RectAreaLight: $455d545b1dff00eb$var$fA,
    RedFormat: $455d545b1dff00eb$var$ry,
    RedIntegerFormat: $455d545b1dff00eb$var$M0,
    ReinhardToneMapping: $455d545b1dff00eb$var$eT,
    RenderTarget: $455d545b1dff00eb$var$Vb,
    RenderTarget3D: $455d545b1dff00eb$var$t4,
    RepeatWrapping: $455d545b1dff00eb$var$e0,
    ReplaceStencilOp: $455d545b1dff00eb$var$lD,
    ReverseSubtractEquation: $455d545b1dff00eb$var$zE,
    RingGeometry: $455d545b1dff00eb$var$wy,
    SIGNED_RED_GREEN_RGTC2_Format: $455d545b1dff00eb$var$Bv,
    SIGNED_RED_RGTC1_Format: $455d545b1dff00eb$var$zv,
    SRGBColorSpace: $455d545b1dff00eb$var$nr,
    SRGBTransfer: $455d545b1dff00eb$var$Zn,
    Scene: $455d545b1dff00eb$var$Xb,
    ShaderChunk: $455d545b1dff00eb$var$rn,
    ShaderLib: $455d545b1dff00eb$var$wo,
    ShaderMaterial: $455d545b1dff00eb$var$qs,
    ShadowMaterial: $455d545b1dff00eb$var$XT,
    Shape: $455d545b1dff00eb$var$Vf,
    ShapeGeometry: $455d545b1dff00eb$var$Cy,
    ShapePath: $455d545b1dff00eb$var$w4,
    ShapeUtils: $455d545b1dff00eb$var$Co,
    ShortType: $455d545b1dff00eb$var$Nb,
    Skeleton: $455d545b1dff00eb$var$gy,
    SkeletonHelper: $455d545b1dff00eb$var$p4,
    SkinnedMesh: $455d545b1dff00eb$var$CT,
    Source: $455d545b1dff00eb$var$_u,
    Sphere: $455d545b1dff00eb$var$Ta,
    SphereGeometry: $455d545b1dff00eb$var$C0,
    Spherical: $455d545b1dff00eb$var$ab,
    SphericalHarmonics3: $455d545b1dff00eb$var$hA,
    SplineCurve: $455d545b1dff00eb$var$tS,
    SpotLight: $455d545b1dff00eb$var$oA,
    SpotLightHelper: $455d545b1dff00eb$var$d4,
    Sprite: $455d545b1dff00eb$var$AT,
    SpriteMaterial: $455d545b1dff00eb$var$Wb,
    SrcAlphaFactor: $455d545b1dff00eb$var$tv,
    SrcAlphaSaturateFactor: $455d545b1dff00eb$var$WE,
    SrcColorFactor: $455d545b1dff00eb$var$HE,
    StaticCopyUsage: $455d545b1dff00eb$var$AD,
    StaticDrawUsage: $455d545b1dff00eb$var$r0,
    StaticReadUsage: $455d545b1dff00eb$var$MD,
    StereoCamera: $455d545b1dff00eb$var$BN,
    StreamCopyUsage: $455d545b1dff00eb$var$CD,
    StreamDrawUsage: $455d545b1dff00eb$var$SD,
    StreamReadUsage: $455d545b1dff00eb$var$TD,
    StringKeyframeTrack: $455d545b1dff00eb$var$$f,
    SubtractEquation: $455d545b1dff00eb$var$LE,
    SubtractiveBlending: $455d545b1dff00eb$var$q_,
    TOUCH: $455d545b1dff00eb$var$Zr,
    TangentSpaceNormalMap: $455d545b1dff00eb$var$Cu,
    TetrahedronGeometry: $455d545b1dff00eb$var$Ry,
    Texture: $455d545b1dff00eb$var$Li,
    TextureLoader: $455d545b1dff00eb$var$RN,
    TextureUtils: $455d545b1dff00eb$var$N4,
    Timer: $455d545b1dff00eb$var$s4,
    TimestampQuery: $455d545b1dff00eb$var$DD,
    TorusGeometry: $455d545b1dff00eb$var$Dy,
    TorusKnotGeometry: $455d545b1dff00eb$var$Uy,
    Triangle: $455d545b1dff00eb$var$Qr,
    TriangleFanDrawMode: $455d545b1dff00eb$var$aD,
    TriangleStripDrawMode: $455d545b1dff00eb$var$iD,
    TrianglesDrawMode: $455d545b1dff00eb$var$nD,
    TubeGeometry: $455d545b1dff00eb$var$Ny,
    UVMapping: $455d545b1dff00eb$var$ty,
    Uint16BufferAttribute: $455d545b1dff00eb$var$Gb,
    Uint32BufferAttribute: $455d545b1dff00eb$var$kb,
    Uint8BufferAttribute: $455d545b1dff00eb$var$gU,
    Uint8ClampedBufferAttribute: $455d545b1dff00eb$var$xU,
    Uniform: $455d545b1dff00eb$var$hS,
    UniformsGroup: $455d545b1dff00eb$var$i4,
    UniformsLib: $455d545b1dff00eb$var$St,
    UniformsUtils: $455d545b1dff00eb$var$jb,
    UnsignedByteType: $455d545b1dff00eb$var$Ws,
    UnsignedInt101111Type: $455d545b1dff00eb$var$Lb,
    UnsignedInt248Type: $455d545b1dff00eb$var$Ld,
    UnsignedInt5999Type: $455d545b1dff00eb$var$Ob,
    UnsignedIntType: $455d545b1dff00eb$var$Mc,
    UnsignedShort4444Type: $455d545b1dff00eb$var$iy,
    UnsignedShort5551Type: $455d545b1dff00eb$var$ay,
    UnsignedShortType: $455d545b1dff00eb$var$Od,
    VSMShadowMap: $455d545b1dff00eb$var$Ao,
    Vector2: $455d545b1dff00eb$var$$e,
    Vector3: $455d545b1dff00eb$var$J,
    Vector4: $455d545b1dff00eb$var$Un,
    VectorKeyframeTrack: $455d545b1dff00eb$var$h0,
    VideoFrameTexture: $455d545b1dff00eb$var$HU,
    VideoTexture: $455d545b1dff00eb$var$OT,
    WebGL3DRenderTarget: $455d545b1dff00eb$var$iU,
    WebGLArrayRenderTarget: $455d545b1dff00eb$var$nU,
    WebGLCoordinateSystem: $455d545b1dff00eb$var$_s,
    WebGLCubeRenderTarget: $455d545b1dff00eb$var$ET,
    WebGLRenderTarget: $455d545b1dff00eb$var$Oo,
    WebGLRenderer: $455d545b1dff00eb$var$wA,
    WebGLUtils: $455d545b1dff00eb$var$AA,
    WebGPUCoordinateSystem: $455d545b1dff00eb$var$Bd,
    WebXRController: $455d545b1dff00eb$var$qx,
    WireframeGeometry: $455d545b1dff00eb$var$jT,
    WrapAroundEnding: $455d545b1dff00eb$var$i0,
    ZeroCurvatureEnding: $455d545b1dff00eb$var$zf,
    ZeroFactor: $455d545b1dff00eb$var$IE,
    ZeroSlopeEnding: $455d545b1dff00eb$var$Pf,
    ZeroStencilOp: $455d545b1dff00eb$var$oD,
    createCanvasElement: $455d545b1dff00eb$var$yT,
    error: $455d545b1dff00eb$var$Qt,
    getConsoleFunction: $455d545b1dff00eb$var$zD,
    log: $455d545b1dff00eb$var$o0,
    setConsoleFunction: $455d545b1dff00eb$var$LD,
    warn: $455d545b1dff00eb$var$Mt,
    warnOnce: $455d545b1dff00eb$var$Id
}, Symbol.toStringTag, {
    value: "Module"
}));
var $455d545b1dff00eb$var$vP = Object.defineProperty, $455d545b1dff00eb$var$yP = (a, e, t)=>e in a ? $455d545b1dff00eb$var$vP(a, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : a[e] = t, $455d545b1dff00eb$var$_P = (a, e, t)=>($455d545b1dff00eb$var$yP(a, e + "", t), t);
class $455d545b1dff00eb$var$bP {
    constructor(){
        $455d545b1dff00eb$var$_P(this, "_listeners");
    }
    addEventListener(e, t) {
        this._listeners === void 0 && (this._listeners = {});
        const n = this._listeners;
        n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
    }
    hasEventListener(e, t) {
        if (this._listeners === void 0) return !1;
        const n = this._listeners;
        return n[e] !== void 0 && n[e].indexOf(t) !== -1;
    }
    removeEventListener(e, t) {
        if (this._listeners === void 0) return;
        const i = this._listeners[e];
        if (i !== void 0) {
            const r = i.indexOf(t);
            r !== -1 && i.splice(r, 1);
        }
    }
    dispatchEvent(e) {
        if (this._listeners === void 0) return;
        const n = this._listeners[e.type];
        if (n !== void 0) {
            e.target = this;
            const i = n.slice(0);
            for(let r = 0, l = i.length; r < l; r++)i[r].call(this, e);
            e.target = null;
        }
    }
}
var $455d545b1dff00eb$var$SP = Object.defineProperty, $455d545b1dff00eb$var$MP = (a, e, t)=>e in a ? $455d545b1dff00eb$var$SP(a, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : a[e] = t, $455d545b1dff00eb$var$Gt = (a, e, t)=>($455d545b1dff00eb$var$MP(a, typeof e != "symbol" ? e + "" : e, t), t);
const $455d545b1dff00eb$var$Px = new $455d545b1dff00eb$var$Kf, $455d545b1dff00eb$var$u3 = new $455d545b1dff00eb$var$ml, $455d545b1dff00eb$var$EP = Math.cos(70 * (Math.PI / 180)), $455d545b1dff00eb$var$f3 = (a, e)=>(a % e + e) % e;
let $455d545b1dff00eb$var$TP = class extends $455d545b1dff00eb$var$bP {
    constructor(e, t){
        super(), $455d545b1dff00eb$var$Gt(this, "object"), $455d545b1dff00eb$var$Gt(this, "domElement"), $455d545b1dff00eb$var$Gt(this, "enabled", !0), $455d545b1dff00eb$var$Gt(this, "target", new $455d545b1dff00eb$var$J), $455d545b1dff00eb$var$Gt(this, "minDistance", 0), $455d545b1dff00eb$var$Gt(this, "maxDistance", 1 / 0), $455d545b1dff00eb$var$Gt(this, "minZoom", 0), $455d545b1dff00eb$var$Gt(this, "maxZoom", 1 / 0), $455d545b1dff00eb$var$Gt(this, "minPolarAngle", 0), $455d545b1dff00eb$var$Gt(this, "maxPolarAngle", Math.PI), $455d545b1dff00eb$var$Gt(this, "minAzimuthAngle", -1 / 0), $455d545b1dff00eb$var$Gt(this, "maxAzimuthAngle", 1 / 0), $455d545b1dff00eb$var$Gt(this, "enableDamping", !1), $455d545b1dff00eb$var$Gt(this, "dampingFactor", .05), $455d545b1dff00eb$var$Gt(this, "enableZoom", !0), $455d545b1dff00eb$var$Gt(this, "zoomSpeed", 1), $455d545b1dff00eb$var$Gt(this, "enableRotate", !0), $455d545b1dff00eb$var$Gt(this, "rotateSpeed", 1), $455d545b1dff00eb$var$Gt(this, "enablePan", !0), $455d545b1dff00eb$var$Gt(this, "panSpeed", 1), $455d545b1dff00eb$var$Gt(this, "screenSpacePanning", !0), $455d545b1dff00eb$var$Gt(this, "keyPanSpeed", 7), $455d545b1dff00eb$var$Gt(this, "zoomToCursor", !1), $455d545b1dff00eb$var$Gt(this, "autoRotate", !1), $455d545b1dff00eb$var$Gt(this, "autoRotateSpeed", 2), $455d545b1dff00eb$var$Gt(this, "reverseOrbit", !1), $455d545b1dff00eb$var$Gt(this, "reverseHorizontalOrbit", !1), $455d545b1dff00eb$var$Gt(this, "reverseVerticalOrbit", !1), $455d545b1dff00eb$var$Gt(this, "keys", {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        }), $455d545b1dff00eb$var$Gt(this, "mouseButtons", {
            LEFT: $455d545b1dff00eb$var$Xs.ROTATE,
            MIDDLE: $455d545b1dff00eb$var$Xs.DOLLY,
            RIGHT: $455d545b1dff00eb$var$Xs.PAN
        }), $455d545b1dff00eb$var$Gt(this, "touches", {
            ONE: $455d545b1dff00eb$var$Zr.ROTATE,
            TWO: $455d545b1dff00eb$var$Zr.DOLLY_PAN
        }), $455d545b1dff00eb$var$Gt(this, "target0"), $455d545b1dff00eb$var$Gt(this, "position0"), $455d545b1dff00eb$var$Gt(this, "zoom0"), $455d545b1dff00eb$var$Gt(this, "_domElementKeyEvents", null), $455d545b1dff00eb$var$Gt(this, "getPolarAngle"), $455d545b1dff00eb$var$Gt(this, "getAzimuthalAngle"), $455d545b1dff00eb$var$Gt(this, "setPolarAngle"), $455d545b1dff00eb$var$Gt(this, "setAzimuthalAngle"), $455d545b1dff00eb$var$Gt(this, "getDistance"), $455d545b1dff00eb$var$Gt(this, "getZoomScale"), $455d545b1dff00eb$var$Gt(this, "listenToKeyEvents"), $455d545b1dff00eb$var$Gt(this, "stopListenToKeyEvents"), $455d545b1dff00eb$var$Gt(this, "saveState"), $455d545b1dff00eb$var$Gt(this, "reset"), $455d545b1dff00eb$var$Gt(this, "update"), $455d545b1dff00eb$var$Gt(this, "connect"), $455d545b1dff00eb$var$Gt(this, "dispose"), $455d545b1dff00eb$var$Gt(this, "dollyIn"), $455d545b1dff00eb$var$Gt(this, "dollyOut"), $455d545b1dff00eb$var$Gt(this, "getScale"), $455d545b1dff00eb$var$Gt(this, "setScale"), this.object = e, this.domElement = t, this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this.getPolarAngle = ()=>m.phi, this.getAzimuthalAngle = ()=>m.theta, this.setPolarAngle = (he)=>{
            let Ee = $455d545b1dff00eb$var$f3(he, 2 * Math.PI), lt = m.phi;
            lt < 0 && (lt += 2 * Math.PI), Ee < 0 && (Ee += 2 * Math.PI);
            let fe = Math.abs(Ee - lt);
            2 * Math.PI - fe < fe && (Ee < lt ? Ee += 2 * Math.PI : lt += 2 * Math.PI), x.phi = Ee - lt, n.update();
        }, this.setAzimuthalAngle = (he)=>{
            let Ee = $455d545b1dff00eb$var$f3(he, 2 * Math.PI), lt = m.theta;
            lt < 0 && (lt += 2 * Math.PI), Ee < 0 && (Ee += 2 * Math.PI);
            let fe = Math.abs(Ee - lt);
            2 * Math.PI - fe < fe && (Ee < lt ? Ee += 2 * Math.PI : lt += 2 * Math.PI), x.theta = Ee - lt, n.update();
        }, this.getDistance = ()=>n.object.position.distanceTo(n.target), this.listenToKeyEvents = (he)=>{
            he.addEventListener("keydown", _e), this._domElementKeyEvents = he;
        }, this.stopListenToKeyEvents = ()=>{
            this._domElementKeyEvents.removeEventListener("keydown", _e), this._domElementKeyEvents = null;
        }, this.saveState = ()=>{
            n.target0.copy(n.target), n.position0.copy(n.object.position), n.zoom0 = n.object.zoom;
        }, this.reset = ()=>{
            n.target.copy(n.target0), n.object.position.copy(n.position0), n.object.zoom = n.zoom0, n.object.updateProjectionMatrix(), n.dispatchEvent(i), n.update(), f = c.NONE;
        }, this.update = (()=>{
            const he = new $455d545b1dff00eb$var$J, Ee = new $455d545b1dff00eb$var$J(0, 1, 0), lt = new $455d545b1dff00eb$var$Gn().setFromUnitVectors(e.up, Ee), fe = lt.clone().invert(), We = new $455d545b1dff00eb$var$J, Je = new $455d545b1dff00eb$var$Gn, ut = 2 * Math.PI;
            return function() {
                const Ve = n.object.position;
                lt.setFromUnitVectors(e.up, Ee), fe.copy(lt).invert(), he.copy(Ve).sub(n.target), he.applyQuaternion(lt), m.setFromVector3(he), n.autoRotate && f === c.NONE && Y(G()), n.enableDamping ? (m.theta += x.theta * n.dampingFactor, m.phi += x.phi * n.dampingFactor) : (m.theta += x.theta, m.phi += x.phi);
                let ft = n.minAzimuthAngle, vt = n.maxAzimuthAngle;
                isFinite(ft) && isFinite(vt) && (ft < -Math.PI ? ft += ut : ft > Math.PI && (ft -= ut), vt < -Math.PI ? vt += ut : vt > Math.PI && (vt -= ut), ft <= vt ? m.theta = Math.max(ft, Math.min(vt, m.theta)) : m.theta = m.theta > (ft + vt) / 2 ? Math.max(ft, m.theta) : Math.min(vt, m.theta)), m.phi = Math.max(n.minPolarAngle, Math.min(n.maxPolarAngle, m.phi)), m.makeSafe(), n.enableDamping === !0 ? n.target.addScaledVector(_, n.dampingFactor) : n.target.add(_), n.zoomToCursor && O || n.object.isOrthographicCamera ? m.radius = oe(m.radius) : m.radius = oe(m.radius * v), he.setFromSpherical(m), he.applyQuaternion(fe), Ve.copy(n.target).add(he), n.object.matrixAutoUpdate || n.object.updateMatrix(), n.object.lookAt(n.target), n.enableDamping === !0 ? (x.theta *= 1 - n.dampingFactor, x.phi *= 1 - n.dampingFactor, _.multiplyScalar(1 - n.dampingFactor)) : (x.set(0, 0, 0), _.set(0, 0, 0));
                let yt = !1;
                if (n.zoomToCursor && O) {
                    let Ct = null;
                    if (n.object instanceof $455d545b1dff00eb$var$Ui && n.object.isPerspectiveCamera) {
                        const on = he.length();
                        Ct = oe(on * v);
                        const gn = on - Ct;
                        n.object.position.addScaledVector(P, gn), n.object.updateMatrixWorld();
                    } else if (n.object.isOrthographicCamera) {
                        const on = new $455d545b1dff00eb$var$J(H.x, H.y, 0);
                        on.unproject(n.object), n.object.zoom = Math.max(n.minZoom, Math.min(n.maxZoom, n.object.zoom / v)), n.object.updateProjectionMatrix(), yt = !0;
                        const gn = new $455d545b1dff00eb$var$J(H.x, H.y, 0);
                        gn.unproject(n.object), n.object.position.sub(gn).add(on), n.object.updateMatrixWorld(), Ct = he.length();
                    } else console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled."), n.zoomToCursor = !1;
                    Ct !== null && (n.screenSpacePanning ? n.target.set(0, 0, -1).transformDirection(n.object.matrix).multiplyScalar(Ct).add(n.object.position) : ($455d545b1dff00eb$var$Px.origin.copy(n.object.position), $455d545b1dff00eb$var$Px.direction.set(0, 0, -1).transformDirection(n.object.matrix), Math.abs(n.object.up.dot($455d545b1dff00eb$var$Px.direction)) < $455d545b1dff00eb$var$EP ? e.lookAt(n.target) : ($455d545b1dff00eb$var$u3.setFromNormalAndCoplanarPoint(n.object.up, n.target), $455d545b1dff00eb$var$Px.intersectPlane($455d545b1dff00eb$var$u3, n.target))));
                } else n.object instanceof $455d545b1dff00eb$var$bl && n.object.isOrthographicCamera && (yt = v !== 1, yt && (n.object.zoom = Math.max(n.minZoom, Math.min(n.maxZoom, n.object.zoom / v)), n.object.updateProjectionMatrix()));
                return v = 1, O = !1, yt || We.distanceToSquared(n.object.position) > p || 8 * (1 - Je.dot(n.object.quaternion)) > p ? (n.dispatchEvent(i), We.copy(n.object.position), Je.copy(n.object.quaternion), yt = !1, !0) : !1;
            };
        })(), this.connect = (he)=>{
            n.domElement = he, n.domElement.style.touchAction = "none", n.domElement.addEventListener("contextmenu", gt), n.domElement.addEventListener("pointerdown", rt), n.domElement.addEventListener("pointercancel", W), n.domElement.addEventListener("wheel", Te);
        }, this.dispose = ()=>{
            var he, Ee, lt, fe, We, Je;
            n.domElement && (n.domElement.style.touchAction = "auto"), (he = n.domElement) == null || he.removeEventListener("contextmenu", gt), (Ee = n.domElement) == null || Ee.removeEventListener("pointerdown", rt), (lt = n.domElement) == null || lt.removeEventListener("pointercancel", W), (fe = n.domElement) == null || fe.removeEventListener("wheel", Te), (We = n.domElement) == null || We.ownerDocument.removeEventListener("pointermove", ne), (Je = n.domElement) == null || Je.ownerDocument.removeEventListener("pointerup", W), n._domElementKeyEvents !== null && n._domElementKeyEvents.removeEventListener("keydown", _e);
        };
        const n = this, i = {
            type: "change"
        }, r = {
            type: "start"
        }, l = {
            type: "end"
        }, c = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        let f = c.NONE;
        const p = 1e-6, m = new $455d545b1dff00eb$var$ab, x = new $455d545b1dff00eb$var$ab;
        let v = 1;
        const _ = new $455d545b1dff00eb$var$J, S = new $455d545b1dff00eb$var$$e, A = new $455d545b1dff00eb$var$$e, M = new $455d545b1dff00eb$var$$e, b = new $455d545b1dff00eb$var$$e, C = new $455d545b1dff00eb$var$$e, R = new $455d545b1dff00eb$var$$e, N = new $455d545b1dff00eb$var$$e, z = new $455d545b1dff00eb$var$$e, L = new $455d545b1dff00eb$var$$e, P = new $455d545b1dff00eb$var$J, H = new $455d545b1dff00eb$var$$e;
        let O = !1;
        const D = [], j = {};
        function G() {
            return 2 * Math.PI / 60 / 60 * n.autoRotateSpeed;
        }
        function q() {
            return Math.pow(.95, n.zoomSpeed);
        }
        function Y(he) {
            n.reverseOrbit || n.reverseHorizontalOrbit ? x.theta += he : x.theta -= he;
        }
        function ae(he) {
            n.reverseOrbit || n.reverseVerticalOrbit ? x.phi += he : x.phi -= he;
        }
        const F = (()=>{
            const he = new $455d545b1dff00eb$var$J;
            return function(lt, fe) {
                he.setFromMatrixColumn(fe, 0), he.multiplyScalar(-lt), _.add(he);
            };
        })(), Q = (()=>{
            const he = new $455d545b1dff00eb$var$J;
            return function(lt, fe) {
                n.screenSpacePanning === !0 ? he.setFromMatrixColumn(fe, 1) : (he.setFromMatrixColumn(fe, 0), he.crossVectors(n.object.up, he)), he.multiplyScalar(lt), _.add(he);
            };
        })(), K = (()=>{
            const he = new $455d545b1dff00eb$var$J;
            return function(lt, fe) {
                const We = n.domElement;
                if (We && n.object instanceof $455d545b1dff00eb$var$Ui && n.object.isPerspectiveCamera) {
                    const Je = n.object.position;
                    he.copy(Je).sub(n.target);
                    let ut = he.length();
                    ut *= Math.tan(n.object.fov / 2 * Math.PI / 180), F(2 * lt * ut / We.clientHeight, n.object.matrix), Q(2 * fe * ut / We.clientHeight, n.object.matrix);
                } else We && n.object instanceof $455d545b1dff00eb$var$bl && n.object.isOrthographicCamera ? (F(lt * (n.object.right - n.object.left) / n.object.zoom / We.clientWidth, n.object.matrix), Q(fe * (n.object.top - n.object.bottom) / n.object.zoom / We.clientHeight, n.object.matrix)) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."), n.enablePan = !1);
            };
        })();
        function $(he) {
            n.object instanceof $455d545b1dff00eb$var$Ui && n.object.isPerspectiveCamera || n.object instanceof $455d545b1dff00eb$var$bl && n.object.isOrthographicCamera ? v = he : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), n.enableZoom = !1);
        }
        function ee(he) {
            $(v / he);
        }
        function I(he) {
            $(v * he);
        }
        function Z(he) {
            if (!n.zoomToCursor || !n.domElement) return;
            O = !0;
            const Ee = n.domElement.getBoundingClientRect(), lt = he.clientX - Ee.left, fe = he.clientY - Ee.top, We = Ee.width, Je = Ee.height;
            H.x = lt / We * 2 - 1, H.y = -(fe / Je) * 2 + 1, P.set(H.x, H.y, 1).unproject(n.object).sub(n.object.position).normalize();
        }
        function oe(he) {
            return Math.max(n.minDistance, Math.min(n.maxDistance, he));
        }
        function ce(he) {
            S.set(he.clientX, he.clientY);
        }
        function de(he) {
            Z(he), N.set(he.clientX, he.clientY);
        }
        function ue(he) {
            b.set(he.clientX, he.clientY);
        }
        function le(he) {
            A.set(he.clientX, he.clientY), M.subVectors(A, S).multiplyScalar(n.rotateSpeed);
            const Ee = n.domElement;
            Ee && (Y(2 * Math.PI * M.x / Ee.clientHeight), ae(2 * Math.PI * M.y / Ee.clientHeight)), S.copy(A), n.update();
        }
        function xe(he) {
            z.set(he.clientX, he.clientY), L.subVectors(z, N), L.y > 0 ? ee(q()) : L.y < 0 && I(q()), N.copy(z), n.update();
        }
        function Le(he) {
            C.set(he.clientX, he.clientY), R.subVectors(C, b).multiplyScalar(n.panSpeed), K(R.x, R.y), b.copy(C), n.update();
        }
        function Ue(he) {
            Z(he), he.deltaY < 0 ? I(q()) : he.deltaY > 0 && ee(q()), n.update();
        }
        function Ne(he) {
            let Ee = !1;
            switch(he.code){
                case n.keys.UP:
                    K(0, n.keyPanSpeed), Ee = !0;
                    break;
                case n.keys.BOTTOM:
                    K(0, -n.keyPanSpeed), Ee = !0;
                    break;
                case n.keys.LEFT:
                    K(n.keyPanSpeed, 0), Ee = !0;
                    break;
                case n.keys.RIGHT:
                    K(-n.keyPanSpeed, 0), Ee = !0;
                    break;
            }
            Ee && (he.preventDefault(), n.update());
        }
        function ke() {
            if (D.length == 1) S.set(D[0].pageX, D[0].pageY);
            else {
                const he = .5 * (D[0].pageX + D[1].pageX), Ee = .5 * (D[0].pageY + D[1].pageY);
                S.set(he, Ee);
            }
        }
        function nt() {
            if (D.length == 1) b.set(D[0].pageX, D[0].pageY);
            else {
                const he = .5 * (D[0].pageX + D[1].pageX), Ee = .5 * (D[0].pageY + D[1].pageY);
                b.set(he, Ee);
            }
        }
        function Re() {
            const he = D[0].pageX - D[1].pageX, Ee = D[0].pageY - D[1].pageY, lt = Math.sqrt(he * he + Ee * Ee);
            N.set(0, lt);
        }
        function te() {
            n.enableZoom && Re(), n.enablePan && nt();
        }
        function Oe() {
            n.enableZoom && Re(), n.enableRotate && ke();
        }
        function Ie(he) {
            if (D.length == 1) A.set(he.pageX, he.pageY);
            else {
                const lt = at(he), fe = .5 * (he.pageX + lt.x), We = .5 * (he.pageY + lt.y);
                A.set(fe, We);
            }
            M.subVectors(A, S).multiplyScalar(n.rotateSpeed);
            const Ee = n.domElement;
            Ee && (Y(2 * Math.PI * M.x / Ee.clientHeight), ae(2 * Math.PI * M.y / Ee.clientHeight)), S.copy(A);
        }
        function Ae(he) {
            if (D.length == 1) C.set(he.pageX, he.pageY);
            else {
                const Ee = at(he), lt = .5 * (he.pageX + Ee.x), fe = .5 * (he.pageY + Ee.y);
                C.set(lt, fe);
            }
            R.subVectors(C, b).multiplyScalar(n.panSpeed), K(R.x, R.y), b.copy(C);
        }
        function ze(he) {
            const Ee = at(he), lt = he.pageX - Ee.x, fe = he.pageY - Ee.y, We = Math.sqrt(lt * lt + fe * fe);
            z.set(0, We), L.set(0, Math.pow(z.y / N.y, n.zoomSpeed)), ee(L.y), N.copy(z);
        }
        function Ze(he) {
            n.enableZoom && ze(he), n.enablePan && Ae(he);
        }
        function be(he) {
            n.enableZoom && ze(he), n.enableRotate && Ie(he);
        }
        function rt(he) {
            var Ee, lt;
            n.enabled !== !1 && (D.length === 0 && ((Ee = n.domElement) == null || Ee.ownerDocument.addEventListener("pointermove", ne), (lt = n.domElement) == null || lt.ownerDocument.addEventListener("pointerup", W)), pt(he), he.pointerType === "touch" ? ot(he) : pe(he));
        }
        function ne(he) {
            n.enabled !== !1 && (he.pointerType === "touch" ? tt(he) : Be(he));
        }
        function W(he) {
            var Ee, lt, fe;
            Ge(he), D.length === 0 && ((Ee = n.domElement) == null || Ee.releasePointerCapture(he.pointerId), (lt = n.domElement) == null || lt.ownerDocument.removeEventListener("pointermove", ne), (fe = n.domElement) == null || fe.ownerDocument.removeEventListener("pointerup", W)), n.dispatchEvent(l), f = c.NONE;
        }
        function pe(he) {
            let Ee;
            switch(he.button){
                case 0:
                    Ee = n.mouseButtons.LEFT;
                    break;
                case 1:
                    Ee = n.mouseButtons.MIDDLE;
                    break;
                case 2:
                    Ee = n.mouseButtons.RIGHT;
                    break;
                default:
                    Ee = -1;
            }
            switch(Ee){
                case $455d545b1dff00eb$var$Xs.DOLLY:
                    if (n.enableZoom === !1) return;
                    de(he), f = c.DOLLY;
                    break;
                case $455d545b1dff00eb$var$Xs.ROTATE:
                    if (he.ctrlKey || he.metaKey || he.shiftKey) {
                        if (n.enablePan === !1) return;
                        ue(he), f = c.PAN;
                    } else {
                        if (n.enableRotate === !1) return;
                        ce(he), f = c.ROTATE;
                    }
                    break;
                case $455d545b1dff00eb$var$Xs.PAN:
                    if (he.ctrlKey || he.metaKey || he.shiftKey) {
                        if (n.enableRotate === !1) return;
                        ce(he), f = c.ROTATE;
                    } else {
                        if (n.enablePan === !1) return;
                        ue(he), f = c.PAN;
                    }
                    break;
                default:
                    f = c.NONE;
            }
            f !== c.NONE && n.dispatchEvent(r);
        }
        function Be(he) {
            if (n.enabled !== !1) switch(f){
                case c.ROTATE:
                    if (n.enableRotate === !1) return;
                    le(he);
                    break;
                case c.DOLLY:
                    if (n.enableZoom === !1) return;
                    xe(he);
                    break;
                case c.PAN:
                    if (n.enablePan === !1) return;
                    Le(he);
                    break;
            }
        }
        function Te(he) {
            n.enabled === !1 || n.enableZoom === !1 || f !== c.NONE && f !== c.ROTATE || (he.preventDefault(), n.dispatchEvent(r), Ue(he), n.dispatchEvent(l));
        }
        function _e(he) {
            n.enabled === !1 || n.enablePan === !1 || Ne(he);
        }
        function ot(he) {
            switch(Ye(he), D.length){
                case 1:
                    switch(n.touches.ONE){
                        case $455d545b1dff00eb$var$Zr.ROTATE:
                            if (n.enableRotate === !1) return;
                            ke(), f = c.TOUCH_ROTATE;
                            break;
                        case $455d545b1dff00eb$var$Zr.PAN:
                            if (n.enablePan === !1) return;
                            nt(), f = c.TOUCH_PAN;
                            break;
                        default:
                            f = c.NONE;
                    }
                    break;
                case 2:
                    switch(n.touches.TWO){
                        case $455d545b1dff00eb$var$Zr.DOLLY_PAN:
                            if (n.enableZoom === !1 && n.enablePan === !1) return;
                            te(), f = c.TOUCH_DOLLY_PAN;
                            break;
                        case $455d545b1dff00eb$var$Zr.DOLLY_ROTATE:
                            if (n.enableZoom === !1 && n.enableRotate === !1) return;
                            Oe(), f = c.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            f = c.NONE;
                    }
                    break;
                default:
                    f = c.NONE;
            }
            f !== c.NONE && n.dispatchEvent(r);
        }
        function tt(he) {
            switch(Ye(he), f){
                case c.TOUCH_ROTATE:
                    if (n.enableRotate === !1) return;
                    Ie(he), n.update();
                    break;
                case c.TOUCH_PAN:
                    if (n.enablePan === !1) return;
                    Ae(he), n.update();
                    break;
                case c.TOUCH_DOLLY_PAN:
                    if (n.enableZoom === !1 && n.enablePan === !1) return;
                    Ze(he), n.update();
                    break;
                case c.TOUCH_DOLLY_ROTATE:
                    if (n.enableZoom === !1 && n.enableRotate === !1) return;
                    be(he), n.update();
                    break;
                default:
                    f = c.NONE;
            }
        }
        function gt(he) {
            n.enabled !== !1 && he.preventDefault();
        }
        function pt(he) {
            D.push(he);
        }
        function Ge(he) {
            delete j[he.pointerId];
            for(let Ee = 0; Ee < D.length; Ee++)if (D[Ee].pointerId == he.pointerId) {
                D.splice(Ee, 1);
                return;
            }
        }
        function Ye(he) {
            let Ee = j[he.pointerId];
            Ee === void 0 && (Ee = new $455d545b1dff00eb$var$$e, j[he.pointerId] = Ee), Ee.set(he.pageX, he.pageY);
        }
        function at(he) {
            const Ee = he.pointerId === D[0].pointerId ? D[1] : D[0];
            return j[Ee.pointerId];
        }
        this.dollyIn = (he = q())=>{
            I(he), n.update();
        }, this.dollyOut = (he = q())=>{
            ee(he), n.update();
        }, this.getScale = ()=>v, this.setScale = (he)=>{
            $(he), n.update();
        }, this.getZoomScale = ()=>q(), t !== void 0 && this.connect(t), this.update();
    }
};
const $455d545b1dff00eb$var$Ur = [
    "#F7DDB3",
    "#F6D1E8",
    "#A8E4FA",
    "#B5E59C",
    "#FCFFA4",
    "#E89A88"
], $455d545b1dff00eb$var$mS = [
    "#f6d7a6",
    "#f4c9e4",
    "#99dff9",
    "#a8e08b",
    "#fbff94",
    "#e48873"
], $455d545b1dff00eb$var$lb = [
    "Front",
    "Back",
    "Top",
    "Bottom",
    "Right",
    "Left"
], $455d545b1dff00eb$var$wt = {
    blushPink: "#fd99c5",
    petalPink: "#feb8d7",
    aquaBlue: "#33d0fb",
    electricBlue: "#23d4ff",
    coralGlow: "#fb67a7",
    sunshineYellow: "#ffd966",
    energyRed: "#cf2a0e"
}, $455d545b1dff00eb$var$pn = 1.3, $455d545b1dff00eb$var$Do = $455d545b1dff00eb$var$Ur.length, $455d545b1dff00eb$var$AP = $455d545b1dff00eb$var$pn / 2, $455d545b1dff00eb$var$gS = [
    "UP",
    "DOWN",
    "LEFT",
    "RIGHT"
], $455d545b1dff00eb$var$wP = [
    {
        pos: [
            0,
            0,
            $455d545b1dff00eb$var$pn / 2
        ],
        rot: [
            0,
            0,
            0
        ]
    },
    {
        pos: [
            0,
            0,
            -$455d545b1dff00eb$var$pn / 2
        ],
        rot: [
            0,
            Math.PI,
            0
        ]
    },
    {
        pos: [
            0,
            $455d545b1dff00eb$var$pn / 2,
            0
        ],
        rot: [
            -Math.PI / 2,
            0,
            0
        ]
    },
    {
        pos: [
            0,
            -$455d545b1dff00eb$var$pn / 2,
            0
        ],
        rot: [
            Math.PI / 2,
            0,
            0
        ]
    },
    {
        pos: [
            $455d545b1dff00eb$var$pn / 2,
            0,
            0
        ],
        rot: [
            0,
            Math.PI / 2,
            0
        ]
    },
    {
        pos: [
            -$455d545b1dff00eb$var$pn / 2,
            0,
            0
        ],
        rot: [
            0,
            -Math.PI / 2,
            0
        ]
    }
], $455d545b1dff00eb$var$CP = {
    0: [
        2,
        3,
        4,
        5
    ],
    1: [
        2,
        3,
        4,
        5
    ],
    2: [
        0,
        1,
        4,
        5
    ],
    3: [
        0,
        1,
        4,
        5
    ],
    4: [
        0,
        1,
        2,
        3
    ],
    5: [
        0,
        1,
        2,
        3
    ]
}, $455d545b1dff00eb$var$h3 = [
    [
        0,
        "UP"
    ],
    [
        2,
        "UP"
    ],
    [
        0,
        "RIGHT"
    ],
    [
        0,
        "DOWN"
    ],
    [
        0,
        "LEFT"
    ]
], $455d545b1dff00eb$var$RP = new Set([
    "0,0;0,1;0,2;0,3;1,0;2,0",
    "0,0;0,1;0,2;1,0;1,2;2,1",
    "0,0;0,1;0,2;1,1;2,1;3,1",
    "0,0;0,1;0,2;1,2;1,3;2,3",
    "0,0;0,1;1,0;1,1;1,2;2,2",
    "0,0;0,1;1,1;1,2;1,3;2,2",
    "0,0;0,1;1,1;1,2;1,3;2,3",
    "0,0;0,1;1,1;1,2;2,2;2,3",
    "0,1;1,0;1,1;1,2;1,3;2,1",
    "0,0;0,1;0,2;1,0;2,0;2,1",
    "0,0;0,1;1,1;2,0;2,1;2,2"
]), $455d545b1dff00eb$var$DP = [
    {
        0: [
            2,
            0
        ],
        2: [
            2,
            3
        ],
        4: [
            3,
            0
        ],
        1: [
            2,
            2
        ],
        3: [
            2,
            1
        ],
        5: [
            1,
            0
        ]
    },
    {
        4: [
            1,
            0
        ],
        0: [
            1,
            1
        ],
        5: [
            0,
            2
        ],
        2: [
            1,
            2
        ],
        3: [
            0,
            3
        ],
        1: [
            1,
            3
        ]
    },
    {
        5: [
            0,
            0
        ],
        2: [
            1,
            0
        ],
        0: [
            1,
            1
        ],
        3: [
            1,
            2
        ],
        4: [
            2,
            2
        ],
        1: [
            1,
            3
        ]
    },
    {
        0: [
            0,
            2
        ],
        1: [
            0,
            0
        ],
        2: [
            0,
            1
        ],
        3: [
            1,
            0
        ],
        4: [
            2,
            0
        ],
        5: [
            0,
            3
        ]
    },
    {
        2: [
            0,
            0
        ],
        5: [
            0,
            1
        ],
        0: [
            1,
            1
        ],
        4: [
            2,
            1
        ],
        3: [
            1,
            2
        ],
        1: [
            1,
            3
        ]
    },
    {
        2: [
            0,
            0
        ],
        5: [
            0,
            1
        ],
        0: [
            1,
            1
        ],
        3: [
            1,
            2
        ],
        4: [
            2,
            2
        ],
        1: [
            1,
            3
        ]
    },
    {
        2: [
            0,
            0
        ],
        5: [
            1,
            0
        ],
        0: [
            1,
            1
        ],
        3: [
            1,
            2
        ],
        1: [
            1,
            3
        ],
        4: [
            2,
            3
        ]
    },
    {
        2: [
            0,
            0
        ],
        5: [
            1,
            0
        ],
        0: [
            1,
            1
        ],
        3: [
            1,
            2
        ],
        4: [
            2,
            2
        ],
        1: [
            2,
            3
        ]
    },
    {
        2: [
            1,
            0
        ],
        5: [
            0,
            1
        ],
        0: [
            1,
            1
        ],
        4: [
            2,
            1
        ],
        3: [
            1,
            2
        ],
        1: [
            1,
            3
        ]
    },
    {
        2: [
            1,
            0
        ],
        5: [
            0,
            1
        ],
        0: [
            1,
            1
        ],
        4: [
            2,
            2
        ],
        3: [
            1,
            2
        ],
        1: [
            1,
            3
        ]
    },
    {
        0: [
            0,
            2
        ],
        1: [
            2,
            2
        ],
        2: [
            1,
            2
        ],
        3: [
            3,
            1
        ],
        4: [
            2,
            1
        ],
        5: [
            3,
            0
        ]
    }
], $455d545b1dff00eb$var$UP = [
    {
        title: "Understanding Cube Nets",
        content: "A cube net is a 2D arrangement of 6 squares that can be folded into a 3D cube. There are exactly 11 unique ways to arrange these squares.",
        highlights: [
            "cube net",
            "6 squares",
            "11 unique ways"
        ],
        icon: "\uD83E\uDDE9",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.blushPink,
            $455d545b1dff00eb$var$wt.petalPink
        ]
    },
    {
        title: "Area Formula",
        content: "Surface area equals the sum of 6 faces. If each face has area x\xb2, then the total area equals 6x\xb2 for the complete cube.",
        highlights: [
            "surface area",
            "6 faces",
            "6x\xb2"
        ],
        icon: "\uD83E\uDDEE",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.aquaBlue,
            $455d545b1dff00eb$var$wt.electricBlue
        ]
    },
    {
        title: "Why 11 Unique Nets?",
        content: "There are exactly 11 distinct cube nets possible. Some arrangements look different but are the same when rotated or reflected.",
        highlights: [
            "11 distinct",
            "rotated",
            "reflected"
        ],
        icon: "\uD83D\uDD0D",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.electricBlue,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Valid vs Invalid Nets",
        content: "Valid nets must have all 6 faces connected edge-to-edge, no opposite faces adjacent, and form a single connected shape.",
        highlights: [
            "6 faces",
            "connected",
            "no opposites"
        ],
        icon: "\u2705",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.sunshineYellow,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Real-World Applications",
        content: "Cube nets are used in packaging design, architecture, and 3D modeling to create boxes and structures from flat materials.",
        highlights: [
            "packaging",
            "architecture",
            "3D modeling"
        ],
        icon: "\uD83C\uDFD7\uFE0F",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.aquaBlue,
            $455d545b1dff00eb$var$wt.sunshineYellow
        ]
    },
    {
        title: "Spatial Reasoning",
        content: "Building cube nets develops spatial reasoning by visualizing how 2D shapes transform into 3D objects through folding techniques.",
        highlights: [
            "spatial reasoning",
            "2D to 3D",
            "visualization"
        ],
        icon: "\uD83E\uDDE0",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.coralGlow,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Area Calculation",
        content: "Each face area equals x\xb2 where x is the side length. With 6 faces total, the complete surface area equals 6x\xb2.",
        highlights: [
            "x\xb2",
            "6 faces",
            "6x\xb2"
        ],
        icon: "\uD83D\uDCCF",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.electricBlue,
            $455d545b1dff00eb$var$wt.coralGlow
        ]
    },
    {
        title: "Folding Strategy",
        content: "Start with one face and build outward systematically. Each new face must be adjacent to an existing face on the actual cube.",
        highlights: [
            "start with one",
            "adjacent faces",
            "build outward"
        ],
        icon: "\uD83E\uDDED",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.energyRed,
            $455d545b1dff00eb$var$wt.sunshineYellow
        ]
    }
], $455d545b1dff00eb$var$NP = [
    {
        title: "Understanding Surface Area",
        content: "Surface area is the total area of all faces of a 3D shape. For a cube, we calculate the area of each face and add them together.",
        highlights: [
            "surface area",
            "all faces",
            "add together"
        ],
        icon: "\uD83D\uDCD0",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.blushPink,
            $455d545b1dff00eb$var$wt.petalPink
        ]
    },
    {
        title: "Area of One Face",
        content: "Each face of a cube is a square. If the side length is x, then the area of one face is x \xd7 x = x\xb2.",
        highlights: [
            "square",
            "x \xd7 x",
            "x\xb2"
        ],
        icon: "\uD83D\uDD32",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.aquaBlue,
            $455d545b1dff00eb$var$wt.electricBlue
        ]
    },
    {
        title: "Total Surface Area",
        content: "A cube has 6 faces, all with the same area. So the total surface area is 6 \xd7 x\xb2 = 6x\xb2.",
        highlights: [
            "6 faces",
            "6 \xd7 x\xb2",
            "6x\xb2"
        ],
        icon: "\uD83E\uDDEE",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.electricBlue,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Visualizing the Net",
        content: "When you unfold a cube into a net, you can see all 6 faces laid out flat. This helps visualize why we multiply by 6.",
        highlights: [
            "unfold",
            "6 faces",
            "multiply by 6"
        ],
        icon: "\uD83D\uDCE6",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.sunshineYellow,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Drag and Drop Learning",
        content: "Drag the faces to the drop zone to see how length \xd7 width becomes area. Each square face has area x\xb2.",
        highlights: [
            "drag and drop",
            "length \xd7 width",
            "x\xb2"
        ],
        icon: "\uD83D\uDDB1\uFE0F",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.aquaBlue,
            $455d545b1dff00eb$var$wt.sunshineYellow
        ]
    },
    {
        title: "Adding All Faces",
        content: "To find total surface area, add the area of all 6 faces: x\xb2 + x\xb2 + x\xb2 + x\xb2 + x\xb2 + x\xb2 = 6x\xb2.",
        highlights: [
            "add",
            "6 faces",
            "6x\xb2"
        ],
        icon: "\u2795",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.coralGlow,
            $455d545b1dff00eb$var$wt.blushPink
        ]
    },
    {
        title: "Why x\xb2?",
        content: "When you multiply length (x) by width (x), you get x \xd7 x = x\xb2. This is the area formula for a square.",
        highlights: [
            "x \xd7 x",
            "x\xb2",
            "area formula"
        ],
        icon: "\u2753",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.electricBlue,
            $455d545b1dff00eb$var$wt.coralGlow
        ]
    },
    {
        title: "Real-World Example",
        content: "If a cube has side length 5 cm, each face has area 5\xb2 = 25 cm\xb2. Total surface area = 6 \xd7 25 = 150 cm\xb2.",
        highlights: [
            "5 cm",
            "25 cm\xb2",
            "150 cm\xb2"
        ],
        icon: "\uD83C\uDF0D",
        tagline: "",
        accent: [
            $455d545b1dff00eb$var$wt.energyRed,
            $455d545b1dff00eb$var$wt.sunshineYellow
        ]
    }
];
function $455d545b1dff00eb$var$OP() {
    return $455d545b1dff00eb$var$wP.map(({ pos: a, rot: e })=>{
        const t = new $455d545b1dff00eb$var$Gn().setFromEuler(new $455d545b1dff00eb$var$ua(e[0], e[1], e[2])), n = new $455d545b1dff00eb$var$J(a[0], a[1], a[2]), i = new $455d545b1dff00eb$var$J(0, 0, 1).applyQuaternion(t).normalize(), r = new $455d545b1dff00eb$var$J(0, 1, 0).applyQuaternion(t).normalize(), l = new $455d545b1dff00eb$var$J(1, 0, 0).applyQuaternion(t).normalize();
        return {
            center: n,
            normal: i,
            up: r,
            right: l,
            quaternion: t
        };
    });
}
function $455d545b1dff00eb$var$LP({ isAnimating: a, isPaused: e, isCompleted: t, onPlayPause: n, onPlayClick: i, onReset: r }) {
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "absolute top-2 right-2 z-10 flex items-center gap-2",
        children: [
            a ? $455d545b1dff00eb$var$k.jsx("button", {
                onClick: n,
                className: "p-2 bg-white/90 hover:bg-white rounded-full shadow-md border border-gray-200 transition-all",
                "aria-label": e ? "Resume animation" : "Pause animation",
                children: e ? $455d545b1dff00eb$var$k.jsx("svg", {
                    className: "w-4 h-4 text-gray-700",
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    children: $455d545b1dff00eb$var$k.jsx("path", {
                        d: "M8 5v14l11-7z"
                    })
                }) : $455d545b1dff00eb$var$k.jsx("svg", {
                    className: "w-4 h-4 text-gray-700",
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    children: $455d545b1dff00eb$var$k.jsx("path", {
                        d: "M6 4h4v16H6V4zm8 0h4v16h-4V4z"
                    })
                })
            }) : $455d545b1dff00eb$var$k.jsx("button", {
                onClick: i,
                className: "p-2 bg-[#FD99C5] hover:bg-[#db2777] rounded-full shadow-md transition-all",
                "aria-label": t ? "Fold cube back" : "Play animation",
                children: $455d545b1dff00eb$var$k.jsx("svg", {
                    className: "w-4 h-4 text-white",
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    children: $455d545b1dff00eb$var$k.jsx("path", {
                        d: "M8 5v14l11-7z"
                    })
                })
            }),
            $455d545b1dff00eb$var$k.jsx("button", {
                onClick: r,
                className: "p-2 bg-white/90 hover:bg-white rounded-full shadow-md border border-gray-200 transition-all",
                "aria-label": "Reset animation",
                children: $455d545b1dff00eb$var$k.jsx("svg", {
                    className: "w-4 h-4 text-gray-700",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: $455d545b1dff00eb$var$k.jsx("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    })
                })
            })
        ]
    });
}
var $455d545b1dff00eb$var$y_ = {
    exports: {}
}, $455d545b1dff00eb$var$dc = {};
var $455d545b1dff00eb$var$d3;
function $455d545b1dff00eb$var$zP() {
    return $455d545b1dff00eb$var$d3 || ($455d545b1dff00eb$var$d3 = 1, $455d545b1dff00eb$var$dc.ConcurrentRoot = 1, $455d545b1dff00eb$var$dc.ContinuousEventPriority = 8, $455d545b1dff00eb$var$dc.DefaultEventPriority = 32, $455d545b1dff00eb$var$dc.DiscreteEventPriority = 2, $455d545b1dff00eb$var$dc.IdleEventPriority = 268435456, $455d545b1dff00eb$var$dc.LegacyRoot = 0, $455d545b1dff00eb$var$dc.NoEventPriority = 0), $455d545b1dff00eb$var$dc;
}
var $455d545b1dff00eb$var$p3;
function $455d545b1dff00eb$var$PP() {
    return $455d545b1dff00eb$var$p3 || ($455d545b1dff00eb$var$p3 = 1, $455d545b1dff00eb$var$y_.exports = $455d545b1dff00eb$var$zP()), $455d545b1dff00eb$var$y_.exports;
}
var $455d545b1dff00eb$var$Zx = $455d545b1dff00eb$var$PP(), $455d545b1dff00eb$var$__ = {
    exports: {}
}, $455d545b1dff00eb$var$b_ = {}, $455d545b1dff00eb$var$S_ = {
    exports: {}
}, $455d545b1dff00eb$var$M_ = {};
var $455d545b1dff00eb$var$m3;
function $455d545b1dff00eb$var$BP() {
    if ($455d545b1dff00eb$var$m3) return $455d545b1dff00eb$var$M_;
    $455d545b1dff00eb$var$m3 = 1;
    var a = $455d545b1dff00eb$var$jd();
    function e(x, v) {
        return x === v && (x !== 0 || 1 / x === 1 / v) || x !== x && v !== v;
    }
    var t = typeof Object.is == "function" ? Object.is : e, n = a.useState, i = a.useEffect, r = a.useLayoutEffect, l = a.useDebugValue;
    function c(x, v) {
        var _ = v(), S = n({
            inst: {
                value: _,
                getSnapshot: v
            }
        }), A = S[0].inst, M = S[1];
        return r(function() {
            A.value = _, A.getSnapshot = v, f(A) && M({
                inst: A
            });
        }, [
            x,
            _,
            v
        ]), i(function() {
            return f(A) && M({
                inst: A
            }), x(function() {
                f(A) && M({
                    inst: A
                });
            });
        }, [
            x
        ]), l(_), _;
    }
    function f(x) {
        var v = x.getSnapshot;
        x = x.value;
        try {
            var _ = v();
            return !t(x, _);
        } catch  {
            return !0;
        }
    }
    function p(x, v) {
        return v();
    }
    var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : c;
    return $455d545b1dff00eb$var$M_.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : m, $455d545b1dff00eb$var$M_;
}
var $455d545b1dff00eb$var$g3;
function $455d545b1dff00eb$var$IP() {
    return $455d545b1dff00eb$var$g3 || ($455d545b1dff00eb$var$g3 = 1, $455d545b1dff00eb$var$S_.exports = $455d545b1dff00eb$var$BP()), $455d545b1dff00eb$var$S_.exports;
}
var $455d545b1dff00eb$var$x3;
function $455d545b1dff00eb$var$FP() {
    if ($455d545b1dff00eb$var$x3) return $455d545b1dff00eb$var$b_;
    $455d545b1dff00eb$var$x3 = 1;
    var a = $455d545b1dff00eb$var$jd(), e = $455d545b1dff00eb$var$IP();
    function t(p, m) {
        return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    var n = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, r = a.useRef, l = a.useEffect, c = a.useMemo, f = a.useDebugValue;
    return $455d545b1dff00eb$var$b_.useSyncExternalStoreWithSelector = function(p, m, x, v, _) {
        var S = r(null);
        if (S.current === null) {
            var A = {
                hasValue: !1,
                value: null
            };
            S.current = A;
        } else A = S.current;
        S = c(function() {
            function b(L) {
                if (!C) {
                    if (C = !0, R = L, L = v(L), _ !== void 0 && A.hasValue) {
                        var P = A.value;
                        if (_(P, L)) return N = P;
                    }
                    return N = L;
                }
                if (P = N, n(R, L)) return P;
                var H = v(L);
                return _ !== void 0 && _(P, H) ? (R = L, P) : (R = L, N = H);
            }
            var C = !1, R, N, z = x === void 0 ? null : x;
            return [
                function() {
                    return b(m());
                },
                z === null ? void 0 : function() {
                    return b(z());
                }
            ];
        }, [
            m,
            x,
            v,
            _
        ]);
        var M = i(p, S[0], S[1]);
        return l(function() {
            A.hasValue = !0, A.value = M;
        }, [
            M
        ]), f(M), M;
    }, $455d545b1dff00eb$var$b_;
}
var $455d545b1dff00eb$var$v3;
function $455d545b1dff00eb$var$HP() {
    return $455d545b1dff00eb$var$v3 || ($455d545b1dff00eb$var$v3 = 1, $455d545b1dff00eb$var$__.exports = $455d545b1dff00eb$var$FP()), $455d545b1dff00eb$var$__.exports;
}
var $455d545b1dff00eb$var$VP = $455d545b1dff00eb$var$HP();
const $455d545b1dff00eb$var$GP = $455d545b1dff00eb$var$Mb($455d545b1dff00eb$var$VP), $455d545b1dff00eb$var$y3 = (a)=>{
    let e;
    const t = new Set, n = (p, m)=>{
        const x = typeof p == "function" ? p(e) : p;
        if (!Object.is(x, e)) {
            const v = e;
            e = m ?? (typeof x != "object" || x === null) ? x : Object.assign({}, e, x), t.forEach((_)=>_(e, v));
        }
    }, i = ()=>e, c = {
        setState: n,
        getState: i,
        getInitialState: ()=>f,
        subscribe: (p)=>(t.add(p), ()=>t.delete(p))
    }, f = e = a(n, i, c);
    return c;
}, $455d545b1dff00eb$var$kP = (a)=>a ? $455d545b1dff00eb$var$y3(a) : $455d545b1dff00eb$var$y3, { useSyncExternalStoreWithSelector: $455d545b1dff00eb$var$jP } = $455d545b1dff00eb$var$GP, $455d545b1dff00eb$var$XP = (a)=>a;
function $455d545b1dff00eb$var$WP(a, e = $455d545b1dff00eb$var$XP, t) {
    const n = $455d545b1dff00eb$var$jP(a.subscribe, a.getState, a.getInitialState, e, t);
    return $455d545b1dff00eb$var$hE.useDebugValue(n), n;
}
const $455d545b1dff00eb$var$_3 = (a, e)=>{
    const t = $455d545b1dff00eb$var$kP(a), n = (i, r = e)=>$455d545b1dff00eb$var$WP(t, i, r);
    return Object.assign(n, t), n;
}, $455d545b1dff00eb$var$qP = (a, e)=>a ? $455d545b1dff00eb$var$_3(a, e) : $455d545b1dff00eb$var$_3, $455d545b1dff00eb$var$YP = (a)=>typeof a == "object" && typeof a.then == "function", $455d545b1dff00eb$var$Bx = [];
function $455d545b1dff00eb$var$ZP(a, e, t = (n, i)=>n === i) {
    if (a === e) return !0;
    if (!a || !e) return !1;
    const n = a.length;
    if (e.length !== n) return !1;
    for(let i = 0; i < n; i++)if (!t(a[i], e[i])) return !1;
    return !0;
}
function $455d545b1dff00eb$var$QP(a, e = null, t = !1, n = {}) {
    e === null && (e = [
        a
    ]);
    for (const r of $455d545b1dff00eb$var$Bx)if ($455d545b1dff00eb$var$ZP(e, r.keys, r.equal)) {
        if (t) return;
        if (Object.prototype.hasOwnProperty.call(r, "error")) throw r.error;
        if (Object.prototype.hasOwnProperty.call(r, "response")) return n.lifespan && n.lifespan > 0 && (r.timeout && clearTimeout(r.timeout), r.timeout = setTimeout(r.remove, n.lifespan)), r.response;
        if (!t) throw r.promise;
    }
    const i = {
        keys: e,
        equal: n.equal,
        remove: ()=>{
            const r = $455d545b1dff00eb$var$Bx.indexOf(i);
            r !== -1 && $455d545b1dff00eb$var$Bx.splice(r, 1);
        },
        promise: ($455d545b1dff00eb$var$YP(a) ? a : a(...e)).then((r)=>{
            i.response = r, n.lifespan && n.lifespan > 0 && (i.timeout = setTimeout(i.remove, n.lifespan));
        }).catch((r)=>i.error = r)
    };
    if ($455d545b1dff00eb$var$Bx.push(i), !t) throw i.promise;
}
const $455d545b1dff00eb$var$KP = (a, e, t)=>$455d545b1dff00eb$var$QP(a, e, !1, t);
var $455d545b1dff00eb$var$E_ = {
    exports: {}
}, $455d545b1dff00eb$var$T_ = {
    exports: {}
}, $455d545b1dff00eb$var$A_ = {
    exports: {}
}, $455d545b1dff00eb$var$w_ = {};
var $455d545b1dff00eb$var$b3;
function $455d545b1dff00eb$var$JP() {
    return $455d545b1dff00eb$var$b3 || ($455d545b1dff00eb$var$b3 = 1, function(a) {
        function e(F, Q) {
            var K = F.length;
            F.push(Q);
            e: for(; 0 < K;){
                var $ = K - 1 >>> 1, ee = F[$];
                if (0 < i(ee, Q)) F[$] = Q, F[K] = ee, K = $;
                else break e;
            }
        }
        function t(F) {
            return F.length === 0 ? null : F[0];
        }
        function n(F) {
            if (F.length === 0) return null;
            var Q = F[0], K = F.pop();
            if (K !== Q) {
                F[0] = K;
                e: for(var $ = 0, ee = F.length, I = ee >>> 1; $ < I;){
                    var Z = 2 * ($ + 1) - 1, oe = F[Z], ce = Z + 1, de = F[ce];
                    if (0 > i(oe, K)) ce < ee && 0 > i(de, oe) ? (F[$] = de, F[ce] = K, $ = ce) : (F[$] = oe, F[Z] = K, $ = Z);
                    else if (ce < ee && 0 > i(de, K)) F[$] = de, F[ce] = K, $ = ce;
                    else break e;
                }
            }
            return Q;
        }
        function i(F, Q) {
            var K = F.sortIndex - Q.sortIndex;
            return K !== 0 ? K : F.id - Q.id;
        }
        if (a.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
            var r = performance;
            a.unstable_now = function() {
                return r.now();
            };
        } else {
            var l = Date, c = l.now();
            a.unstable_now = function() {
                return l.now() - c;
            };
        }
        var f = [], p = [], m = 1, x = null, v = 3, _ = !1, S = !1, A = !1, M = typeof setTimeout == "function" ? setTimeout : null, b = typeof clearTimeout == "function" ? clearTimeout : null, C = typeof setImmediate < "u" ? setImmediate : null;
        function R(F) {
            for(var Q = t(p); Q !== null;){
                if (Q.callback === null) n(p);
                else if (Q.startTime <= F) n(p), Q.sortIndex = Q.expirationTime, e(f, Q);
                else break;
                Q = t(p);
            }
        }
        function N(F) {
            if (A = !1, R(F), !S) {
                if (t(f) !== null) S = !0, Y();
                else {
                    var Q = t(p);
                    Q !== null && ae(N, Q.startTime - F);
                }
            }
        }
        var z = !1, L = -1, P = 5, H = -1;
        function O() {
            return !(a.unstable_now() - H < P);
        }
        function D() {
            if (z) {
                var F = a.unstable_now();
                H = F;
                var Q = !0;
                try {
                    e: {
                        S = !1, A && (A = !1, b(L), L = -1), _ = !0;
                        var K = v;
                        try {
                            t: {
                                for(R(F), x = t(f); x !== null && !(x.expirationTime > F && O());){
                                    var $ = x.callback;
                                    if (typeof $ == "function") {
                                        x.callback = null, v = x.priorityLevel;
                                        var ee = $(x.expirationTime <= F);
                                        if (F = a.unstable_now(), typeof ee == "function") {
                                            x.callback = ee, R(F), Q = !0;
                                            break t;
                                        }
                                        x === t(f) && n(f), R(F);
                                    } else n(f);
                                    x = t(f);
                                }
                                if (x !== null) Q = !0;
                                else {
                                    var I = t(p);
                                    I !== null && ae(N, I.startTime - F), Q = !1;
                                }
                            }
                            break e;
                        } finally{
                            x = null, v = K, _ = !1;
                        }
                        Q = void 0;
                    }
                } finally{
                    Q ? j() : z = !1;
                }
            }
        }
        var j;
        if (typeof C == "function") j = function() {
            C(D);
        };
        else if (typeof MessageChannel < "u") {
            var G = new MessageChannel, q = G.port2;
            G.port1.onmessage = D, j = function() {
                q.postMessage(null);
            };
        } else j = function() {
            M(D, 0);
        };
        function Y() {
            z || (z = !0, j());
        }
        function ae(F, Q) {
            L = M(function() {
                F(a.unstable_now());
            }, Q);
        }
        a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(F) {
            F.callback = null;
        }, a.unstable_continueExecution = function() {
            S || _ || (S = !0, Y());
        }, a.unstable_forceFrameRate = function(F) {
            0 > F || 125 < F ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < F ? Math.floor(1e3 / F) : 5;
        }, a.unstable_getCurrentPriorityLevel = function() {
            return v;
        }, a.unstable_getFirstCallbackNode = function() {
            return t(f);
        }, a.unstable_next = function(F) {
            switch(v){
                case 1:
                case 2:
                case 3:
                    var Q = 3;
                    break;
                default:
                    Q = v;
            }
            var K = v;
            v = Q;
            try {
                return F();
            } finally{
                v = K;
            }
        }, a.unstable_pauseExecution = function() {}, a.unstable_requestPaint = function() {}, a.unstable_runWithPriority = function(F, Q) {
            switch(F){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    F = 3;
            }
            var K = v;
            v = F;
            try {
                return Q();
            } finally{
                v = K;
            }
        }, a.unstable_scheduleCallback = function(F, Q, K) {
            var $ = a.unstable_now();
            switch(typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? $ + K : $) : K = $, F){
                case 1:
                    var ee = -1;
                    break;
                case 2:
                    ee = 250;
                    break;
                case 5:
                    ee = 1073741823;
                    break;
                case 4:
                    ee = 1e4;
                    break;
                default:
                    ee = 5e3;
            }
            return ee = K + ee, F = {
                id: m++,
                callback: Q,
                priorityLevel: F,
                startTime: K,
                expirationTime: ee,
                sortIndex: -1
            }, K > $ ? (F.sortIndex = K, e(p, F), t(f) === null && F === t(p) && (A ? (b(L), L = -1) : A = !0, ae(N, K - $))) : (F.sortIndex = ee, e(f, F), S || _ || (S = !0, Y())), F;
        }, a.unstable_shouldYield = O, a.unstable_wrapCallback = function(F) {
            var Q = v;
            return function() {
                var K = v;
                v = Q;
                try {
                    return F.apply(this, arguments);
                } finally{
                    v = K;
                }
            };
        };
    }($455d545b1dff00eb$var$w_)), $455d545b1dff00eb$var$w_;
}
var $455d545b1dff00eb$var$S3;
function $455d545b1dff00eb$var$$P() {
    return $455d545b1dff00eb$var$S3 || ($455d545b1dff00eb$var$S3 = 1, $455d545b1dff00eb$var$A_.exports = $455d545b1dff00eb$var$JP()), $455d545b1dff00eb$var$A_.exports;
}
var $455d545b1dff00eb$var$M3;
function $455d545b1dff00eb$var$eB() {
    return $455d545b1dff00eb$var$M3 || ($455d545b1dff00eb$var$M3 = 1, function(a) {
        a.exports = function(e) {
            function t(u, h, y, T) {
                return new xp(u, h, y, T);
            }
            function n() {}
            function i(u) {
                var h = "https://react.dev/errors/" + u;
                if (1 < arguments.length) {
                    h += "?args[]=" + encodeURIComponent(arguments[1]);
                    for(var y = 2; y < arguments.length; y++)h += "&args[]=" + encodeURIComponent(arguments[y]);
                }
                return "Minified React error #" + u + "; visit " + h + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            function r(u) {
                return u === null || typeof u != "object" ? null : (u = Ep && u[Ep] || u["@@iterator"], typeof u == "function" ? u : null);
            }
            function l(u) {
                if (u == null) return null;
                if (typeof u == "function") return u.$$typeof === Xl ? null : u.displayName || u.name || null;
                if (typeof u == "string") return u;
                switch(u){
                    case Gc:
                        return "Fragment";
                    case us:
                        return "Portal";
                    case Mp:
                        return "Profiler";
                    case Sp:
                        return "StrictMode";
                    case vh:
                        return "Suspense";
                    case Jo:
                        return "SuspenseList";
                }
                if (typeof u == "object") switch(u.$$typeof){
                    case Ns:
                        return (u.displayName || "Context") + ".Provider";
                    case Ko:
                        return (u._context.displayName || "Context") + ".Consumer";
                    case kc:
                        var h = u.render;
                        return u = u.displayName, u || (u = h.displayName || h.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
                    case Wu:
                        return h = u.displayName || null, h !== null ? h : l(u.type) || "Memo";
                    case fs:
                        h = u._payload, u = u._init;
                        try {
                            return l(u(h));
                        } catch  {}
                }
                return null;
            }
            function c(u) {
                if (yh === void 0) try {
                    throw Error();
                } catch (y) {
                    var h = y.stack.trim().match(/\n( *(at )?)/);
                    yh = h && h[1] || "", Tp = -1 < y.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < y.stack.indexOf("@") ? "@unknown:0:0" : "";
                }
                return `
` + yh + u + Tp;
            }
            function f(u, h) {
                if (!u || $o) return "";
                $o = !0;
                var y = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    var T = {
                        DetermineComponentFrameRoot: function() {
                            try {
                                if (h) {
                                    var bt = function() {
                                        throw Error();
                                    };
                                    if (Object.defineProperty(bt.prototype, "props", {
                                        set: function() {
                                            throw Error();
                                        }
                                    }), typeof Reflect == "object" && Reflect.construct) {
                                        try {
                                            Reflect.construct(bt, []);
                                        } catch (Zt) {
                                            var At = Zt;
                                        }
                                        Reflect.construct(u, [], bt);
                                    } else {
                                        try {
                                            bt.call();
                                        } catch (Zt) {
                                            At = Zt;
                                        }
                                        u.call(bt.prototype);
                                    }
                                } else {
                                    try {
                                        throw Error();
                                    } catch (Zt) {
                                        At = Zt;
                                    }
                                    (bt = u()) && typeof bt.catch == "function" && bt.catch(function() {});
                                }
                            } catch (Zt) {
                                if (Zt && At && typeof Zt.stack == "string") return [
                                    Zt.stack,
                                    At.stack
                                ];
                            }
                            return [
                                null,
                                null
                            ];
                        }
                    };
                    T.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
                    var U = Object.getOwnPropertyDescriptor(T.DetermineComponentFrameRoot, "name");
                    U && U.configurable && Object.defineProperty(T.DetermineComponentFrameRoot, "name", {
                        value: "DetermineComponentFrameRoot"
                    });
                    var B = T.DetermineComponentFrameRoot(), se = B[0], me = B[1];
                    if (se && me) {
                        var De = se.split(`
`), it = me.split(`
`);
                        for(U = T = 0; T < De.length && !De[T].includes("DetermineComponentFrameRoot");)T++;
                        for(; U < it.length && !it[U].includes("DetermineComponentFrameRoot");)U++;
                        if (T === De.length || U === it.length) for(T = De.length - 1, U = it.length - 1; 1 <= T && 0 <= U && De[T] !== it[U];)U--;
                        for(; 1 <= T && 0 <= U; T--, U--)if (De[T] !== it[U]) {
                            if (T !== 1 || U !== 1) do if (T--, U--, 0 > U || De[T] !== it[U]) {
                                var mt = `
` + De[T].replace(" at new ", " at ");
                                return u.displayName && mt.includes("<anonymous>") && (mt = mt.replace("<anonymous>", u.displayName)), mt;
                            }
                            while (1 <= T && 0 <= U);
                            break;
                        }
                    }
                } finally{
                    $o = !1, Error.prepareStackTrace = y;
                }
                return (y = u ? u.displayName || u.name : "") ? c(y) : "";
            }
            function p(u) {
                switch(u.tag){
                    case 26:
                    case 27:
                    case 5:
                        return c(u.type);
                    case 16:
                        return c("Lazy");
                    case 13:
                        return c("Suspense");
                    case 19:
                        return c("SuspenseList");
                    case 0:
                    case 15:
                        return u = f(u.type, !1), u;
                    case 11:
                        return u = f(u.type.render, !1), u;
                    case 1:
                        return u = f(u.type, !0), u;
                    default:
                        return "";
                }
            }
            function m(u) {
                try {
                    var h = "";
                    do h += p(u), u = u.return;
                    while (u);
                    return h;
                } catch (y) {
                    return `
Error generating stack: ` + y.message + `
` + y.stack;
                }
            }
            function x(u) {
                var h = u, y = u;
                if (u.alternate) for(; h.return;)h = h.return;
                else {
                    u = h;
                    do h = u, (h.flags & 4098) !== 0 && (y = h.return), u = h.return;
                    while (u);
                }
                return h.tag === 3 ? y : null;
            }
            function v(u) {
                if (x(u) !== u) throw Error(i(188));
            }
            function _(u) {
                var h = u.alternate;
                if (!h) {
                    if (h = x(u), h === null) throw Error(i(188));
                    return h !== u ? null : u;
                }
                for(var y = u, T = h;;){
                    var U = y.return;
                    if (U === null) break;
                    var B = U.alternate;
                    if (B === null) {
                        if (T = U.return, T !== null) {
                            y = T;
                            continue;
                        }
                        break;
                    }
                    if (U.child === B.child) {
                        for(B = U.child; B;){
                            if (B === y) return v(U), u;
                            if (B === T) return v(U), h;
                            B = B.sibling;
                        }
                        throw Error(i(188));
                    }
                    if (y.return !== T.return) y = U, T = B;
                    else {
                        for(var se = !1, me = U.child; me;){
                            if (me === y) {
                                se = !0, y = U, T = B;
                                break;
                            }
                            if (me === T) {
                                se = !0, T = U, y = B;
                                break;
                            }
                            me = me.sibling;
                        }
                        if (!se) {
                            for(me = B.child; me;){
                                if (me === y) {
                                    se = !0, y = B, T = U;
                                    break;
                                }
                                if (me === T) {
                                    se = !0, T = B, y = U;
                                    break;
                                }
                                me = me.sibling;
                            }
                            if (!se) throw Error(i(189));
                        }
                    }
                    if (y.alternate !== T) throw Error(i(190));
                }
                if (y.tag !== 3) throw Error(i(188));
                return y.stateNode.current === y ? u : h;
            }
            function S(u) {
                var h = u.tag;
                if (h === 5 || h === 26 || h === 27 || h === 6) return u;
                for(u = u.child; u !== null;){
                    if (h = S(u), h !== null) return h;
                    u = u.sibling;
                }
                return null;
            }
            function A(u) {
                var h = u.tag;
                if (h === 5 || h === 26 || h === 27 || h === 6) return u;
                for(u = u.child; u !== null;){
                    if (u.tag !== 4 && (h = A(u), h !== null)) return h;
                    u = u.sibling;
                }
                return null;
            }
            function M(u) {
                return {
                    current: u
                };
            }
            function b(u) {
                0 > po || (u.current = tf[po], tf[po] = null, po--);
            }
            function C(u, h) {
                po++, tf[po] = u.current, u.current = h;
            }
            function R(u) {
                return u >>>= 0, u === 0 ? 32 : 31 - (nf(u) / yg | 0) | 0;
            }
            function N(u) {
                var h = u & 42;
                if (h !== 0) return h;
                switch(u & -u){
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    case 4:
                        return 4;
                    case 8:
                        return 8;
                    case 16:
                        return 16;
                    case 32:
                        return 32;
                    case 64:
                        return 64;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return u & 4194176;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        return u & 62914560;
                    case 67108864:
                        return 67108864;
                    case 134217728:
                        return 134217728;
                    case 268435456:
                        return 268435456;
                    case 536870912:
                        return 536870912;
                    case 1073741824:
                        return 0;
                    default:
                        return u;
                }
            }
            function z(u, h) {
                var y = u.pendingLanes;
                if (y === 0) return 0;
                var T = 0, U = u.suspendedLanes, B = u.pingedLanes, se = u.warmLanes;
                u = u.finishedLanes !== 0;
                var me = y & 134217727;
                return me !== 0 ? (y = me & ~U, y !== 0 ? T = N(y) : (B &= me, B !== 0 ? T = N(B) : u || (se = me & ~se, se !== 0 && (T = N(se))))) : (me = y & ~U, me !== 0 ? T = N(me) : B !== 0 ? T = N(B) : u || (se = y & ~se, se !== 0 && (T = N(se)))), T === 0 ? 0 : h !== 0 && h !== T && (h & U) === 0 && (U = T & -T, se = h & -h, U >= se || U === 32 && (se & 4194176) !== 0) ? h : T;
            }
            function L(u, h) {
                return (u.pendingLanes & ~(u.suspendedLanes & ~u.pingedLanes) & h) === 0;
            }
            function P(u, h) {
                switch(u){
                    case 1:
                    case 2:
                    case 4:
                    case 8:
                        return h + 250;
                    case 16:
                    case 32:
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return h + 5e3;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        return -1;
                    case 67108864:
                    case 134217728:
                    case 268435456:
                    case 536870912:
                    case 1073741824:
                        return -1;
                    default:
                        return -1;
                }
            }
            function H() {
                var u = qc;
                return qc <<= 1, (qc & 4194176) === 0 && (qc = 128), u;
            }
            function O() {
                var u = af;
                return af <<= 1, (af & 62914560) === 0 && (af = 4194304), u;
            }
            function D(u) {
                for(var h = [], y = 0; 31 > y; y++)h.push(u);
                return h;
            }
            function j(u, h) {
                u.pendingLanes |= h, h !== 268435456 && (u.suspendedLanes = 0, u.pingedLanes = 0, u.warmLanes = 0);
            }
            function G(u, h, y, T, U, B) {
                var se = u.pendingLanes;
                u.pendingLanes = y, u.suspendedLanes = 0, u.pingedLanes = 0, u.warmLanes = 0, u.expiredLanes &= y, u.entangledLanes &= y, u.errorRecoveryDisabledLanes &= y, u.shellSuspendCounter = 0;
                var me = u.entanglements, De = u.expirationTimes, it = u.hiddenUpdates;
                for(y = se & ~y; 0 < y;){
                    var mt = 31 - Xa(y), bt = 1 << mt;
                    me[mt] = 0, De[mt] = -1;
                    var At = it[mt];
                    if (At !== null) for(it[mt] = null, mt = 0; mt < At.length; mt++){
                        var Zt = At[mt];
                        Zt !== null && (Zt.lane &= -536870913);
                    }
                    y &= ~bt;
                }
                T !== 0 && q(u, T, 0), B !== 0 && U === 0 && u.tag !== 0 && (u.suspendedLanes |= B & ~(se & ~h));
            }
            function q(u, h, y) {
                u.pendingLanes |= h, u.suspendedLanes &= ~h;
                var T = 31 - Xa(h);
                u.entangledLanes |= h, u.entanglements[T] = u.entanglements[T] | 1073741824 | y & 4194218;
            }
            function Y(u, h) {
                var y = u.entangledLanes |= h;
                for(u = u.entanglements; y;){
                    var T = 31 - Xa(y), U = 1 << T;
                    U & h | u[T] & h && (u[T] |= h), y &= ~U;
                }
            }
            function ae(u) {
                return u &= -u, 2 < u ? 8 < u ? (u & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
            }
            function F(u) {
                if (Wa && typeof Wa.onCommitFiberRoot == "function") try {
                    Wa.onCommitFiberRoot(Zc, u, void 0, (u.current.flags & 128) === 128);
                } catch  {}
            }
            function Q(u) {
                if (typeof Mg == "function" && nm(u), Wa && typeof Wa.setStrictMode == "function") try {
                    Wa.setStrictMode(Zc, u);
                } catch  {}
            }
            function K(u, h) {
                return u === h && (u !== 0 || 1 / u === 1 / h) || u !== u && h !== h;
            }
            function $(u, h) {
                if (typeof u == "object" && u !== null) {
                    var y = Ph.get(u);
                    return y !== void 0 ? y : (h = {
                        value: u,
                        source: h,
                        stack: m(h)
                    }, Ph.set(u, h), h);
                }
                return {
                    value: u,
                    source: h,
                    stack: m(h)
                };
            }
            function ee(u, h) {
                oi[_i++] = of, oi[_i++] = sf, sf = u, of = h;
            }
            function I(u, h, y) {
                gr[xr++] = Bs, gr[xr++] = Hr, gr[xr++] = hs, hs = u;
                var T = Bs;
                u = Hr;
                var U = 32 - Xa(T) - 1;
                T &= ~(1 << U), y += 1;
                var B = 32 - Xa(h) + U;
                if (30 < B) {
                    var se = U - U % 5;
                    B = (T & (1 << se) - 1).toString(32), T >>= se, U -= se, Bs = 1 << 32 - Xa(h) + U | y << U | T, Hr = B + u;
                } else Bs = 1 << B | y << U | T, Hr = u;
            }
            function Z(u) {
                u.return !== null && (ee(u, 1), I(u, 1, 0));
            }
            function oe(u) {
                for(; u === sf;)sf = oi[--_i], oi[_i] = null, of = oi[--_i], oi[_i] = null;
                for(; u === hs;)hs = gr[--xr], gr[xr] = null, Hr = gr[--xr], gr[xr] = null, Bs = gr[--xr], gr[xr] = null;
            }
            function ce(u, h) {
                C(ds, h), C(lf, u), C(Ji, null), u = Wl(h), b(Ji), C(Ji, u);
            }
            function de() {
                b(Ji), b(lf), b(ds);
            }
            function ue(u) {
                u.memoizedState !== null && C(Qc, u);
                var h = Ji.current, y = J0(h, u.type);
                h !== y && (C(lf, u), C(Ji, y));
            }
            function le(u) {
                lf.current === u && (b(Ji), b(lf)), Qc.current === u && (b(Qc), Ls ? Xt._currentValue = ja : Xt._currentValue2 = ja);
            }
            function xe(u) {
                var h = Error(i(418, ""));
                throw nt($(h, u)), cf;
            }
            function Le(u, h) {
                if (!Oa) throw Error(i(175));
                Xy(u.stateNode, u.type, u.memoizedProps, h, u) || xe(u);
            }
            function Ue(u) {
                for(ya = u.return; ya;)switch(ya.tag){
                    case 3:
                    case 27:
                        Vr = !0;
                        return;
                    case 5:
                    case 13:
                        Vr = !1;
                        return;
                    default:
                        ya = ya.return;
                }
            }
            function Ne(u) {
                if (!Oa || u !== ya) return !1;
                if (!An) return Ue(u), An = !0, !1;
                var h = !1;
                if (sa ? u.tag !== 3 && u.tag !== 27 && (u.tag !== 5 || pg(u.type) && !nl(u.type, u.memoizedProps)) && (h = !0) : u.tag !== 3 && (u.tag !== 5 || pg(u.type) && !nl(u.type, u.memoizedProps)) && (h = !0), h && la && xe(u), Ue(u), u.tag === 13) {
                    if (!Oa) throw Error(i(316));
                    if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(i(317));
                    la = hg(u);
                } else la = ya ? kp(u.stateNode) : null;
                return !0;
            }
            function ke() {
                Oa && (la = ya = null, An = !1);
            }
            function nt(u) {
                vr === null ? vr = [
                    u
                ] : vr.push(u);
            }
            function Re() {
                for(var u = al, h = Kc = al = 0; h < u;){
                    var y = yr[h];
                    yr[h++] = null;
                    var T = yr[h];
                    yr[h++] = null;
                    var U = yr[h];
                    yr[h++] = null;
                    var B = yr[h];
                    if (yr[h++] = null, T !== null && U !== null) {
                        var se = T.pending;
                        se === null ? U.next = U : (U.next = se.next, se.next = U), T.pending = U;
                    }
                    B !== 0 && Ae(y, U, B);
                }
            }
            function te(u, h, y, T) {
                yr[al++] = u, yr[al++] = h, yr[al++] = y, yr[al++] = T, Kc |= T, u.lanes |= T, u = u.alternate, u !== null && (u.lanes |= T);
            }
            function Oe(u, h, y, T) {
                return te(u, h, y, T), ze(u);
            }
            function Ie(u, h) {
                return te(u, null, null, h), ze(u);
            }
            function Ae(u, h, y) {
                u.lanes |= y;
                var T = u.alternate;
                T !== null && (T.lanes |= y);
                for(var U = !1, B = u.return; B !== null;)B.childLanes |= y, T = B.alternate, T !== null && (T.childLanes |= y), B.tag === 22 && (u = B.stateNode, u === null || u._visibility & 1 || (U = !0)), u = B, B = B.return;
                U && h !== null && u.tag === 3 && (B = u.stateNode, U = 31 - Xa(y), B = B.hiddenUpdates, u = B[U], u === null ? B[U] = [
                    h
                ] : u.push(h), h.lane = y | 536870912);
            }
            function ze(u) {
                if (50 < ic) throw ic = 0, Pa = null, Error(i(185));
                for(var h = u.return; h !== null;)u = h, h = u.return;
                return u.tag === 3 ? u.stateNode : null;
            }
            function Ze(u) {
                u !== Ql && u.next === null && (Ql === null ? Jc = Ql = u : Ql = Ql.next = u), ff = !0, uf || (uf = !0, Be(rt));
            }
            function be(u, h) {
                if (!ps && ff) {
                    ps = !0;
                    do for(var y = !1, T = Jc; T !== null;){
                        if (u !== 0) {
                            var U = T.pendingLanes;
                            if (U === 0) var B = 0;
                            else {
                                var se = T.suspendedLanes, me = T.pingedLanes;
                                B = (1 << 31 - Xa(42 | u) + 1) - 1, B &= U & ~(se & ~me), B = B & 201326677 ? B & 201326677 | 1 : B ? B | 2 : 0;
                            }
                            B !== 0 && (y = !0, pe(T, B));
                        } else B = cn, B = z(T, T === dn ? B : 0), (B & 3) === 0 || L(T, B) || (y = !0, pe(T, B));
                        T = T.next;
                    }
                    while (y);
                    ps = !1;
                }
            }
            function rt() {
                ff = uf = !1;
                var u = 0;
                rl !== 0 && (il() && (u = rl), rl = 0);
                for(var h = oa(), y = null, T = Jc; T !== null;){
                    var U = T.next, B = ne(T, h);
                    B === 0 ? (T.next = null, y === null ? Jc = U : y.next = U, U === null && (Ql = y)) : (y = T, (u !== 0 || (B & 3) !== 0) && (ff = !0)), T = U;
                }
                be(u);
            }
            function ne(u, h) {
                for(var y = u.suspendedLanes, T = u.pingedLanes, U = u.expirationTimes, B = u.pendingLanes & -62914561; 0 < B;){
                    var se = 31 - Xa(B), me = 1 << se, De = U[se];
                    De === -1 ? ((me & y) === 0 || (me & T) !== 0) && (U[se] = P(me, h)) : De <= h && (u.expiredLanes |= me), B &= ~me;
                }
                if (h = dn, y = cn, y = z(u, u === h ? y : 0), T = u.callbackNode, y === 0 || u === h && Wn === 2 || u.cancelPendingCommit !== null) return T !== null && T !== null && rf(T), u.callbackNode = null, u.callbackPriority = 0;
                if ((y & 3) === 0 || L(u, y)) {
                    if (h = y & -y, h === u.callbackPriority) return h;
                    switch(T !== null && rf(T), ae(y)){
                        case 2:
                        case 8:
                            y = Sg;
                            break;
                        case 32:
                            y = Lh;
                            break;
                        case 268435456:
                            y = zh;
                            break;
                        default:
                            y = Lh;
                    }
                    return T = W.bind(null, u), y = Yc(y, T), u.callbackPriority = h, u.callbackNode = y, h;
                }
                return T !== null && T !== null && rf(T), u.callbackPriority = 2, u.callbackNode = null, 2;
            }
            function W(u, h) {
                var y = u.callbackNode;
                if (Qi() && u.callbackNode !== y) return null;
                var T = cn;
                return T = z(u, u === dn ? T : 0), T === 0 ? null : (Vu(u, T, h), ne(u, oa()), u.callbackNode != null && u.callbackNode === y ? W.bind(null, u) : null);
            }
            function pe(u, h) {
                if (Qi()) return null;
                Vu(u, h, !0);
            }
            function Be(u) {
                Ii ? Mh(function() {
                    (It & 6) !== 0 ? Yc(tm, u) : u();
                }) : Yc(tm, u);
            }
            function Te() {
                return rl === 0 && (rl = H()), rl;
            }
            function _e(u, h) {
                if (hf === null) {
                    var y = hf = [];
                    Bh = 0, qa = Te(), sl = {
                        status: "pending",
                        value: void 0,
                        then: function(T) {
                            y.push(T);
                        }
                    };
                }
                return Bh++, h.then(ot, ot), h;
            }
            function ot() {
                if (--Bh === 0 && hf !== null) {
                    sl !== null && (sl.status = "fulfilled");
                    var u = hf;
                    hf = null, qa = 0, sl = null;
                    for(var h = 0; h < u.length; h++)(0, u[h])();
                }
            }
            function tt(u, h) {
                var y = [], T = {
                    status: "pending",
                    value: null,
                    reason: null,
                    then: function(U) {
                        y.push(U);
                    }
                };
                return u.then(function() {
                    T.status = "fulfilled", T.value = h;
                    for(var U = 0; U < y.length; U++)(0, y[U])(h);
                }, function(U) {
                    for(T.status = "rejected", T.reason = U, U = 0; U < y.length; U++)(0, y[U])(void 0);
                }), T;
            }
            function gt(u) {
                u.updateQueue = {
                    baseState: u.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null,
                        lanes: 0,
                        hiddenCallbacks: null
                    },
                    callbacks: null
                };
            }
            function pt(u, h) {
                u = u.updateQueue, h.updateQueue === u && (h.updateQueue = {
                    baseState: u.baseState,
                    firstBaseUpdate: u.firstBaseUpdate,
                    lastBaseUpdate: u.lastBaseUpdate,
                    shared: u.shared,
                    callbacks: null
                });
            }
            function Ge(u) {
                return {
                    lane: u,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function Ye(u, h, y) {
                var T = u.updateQueue;
                if (T === null) return null;
                if (T = T.shared, (It & 2) !== 0) {
                    var U = T.pending;
                    return U === null ? h.next = h : (h.next = U.next, U.next = h), T.pending = h, h = ze(u), Ae(u, null, y), h;
                }
                return te(u, T, h, y), ze(u);
            }
            function at(u, h, y) {
                if (h = h.updateQueue, h !== null && (h = h.shared, (y & 4194176) !== 0)) {
                    var T = h.lanes;
                    T &= u.pendingLanes, y |= T, h.lanes = y, Y(u, y);
                }
            }
            function he(u, h) {
                var y = u.updateQueue, T = u.alternate;
                if (T !== null && (T = T.updateQueue, y === T)) {
                    var U = null, B = null;
                    if (y = y.firstBaseUpdate, y !== null) {
                        do {
                            var se = {
                                lane: y.lane,
                                tag: y.tag,
                                payload: y.payload,
                                callback: null,
                                next: null
                            };
                            B === null ? U = B = se : B = B.next = se, y = y.next;
                        }while (y !== null);
                        B === null ? U = B = h : B = B.next = h;
                    } else U = B = h;
                    y = {
                        baseState: T.baseState,
                        firstBaseUpdate: U,
                        lastBaseUpdate: B,
                        shared: T.shared,
                        callbacks: T.callbacks
                    }, u.updateQueue = y;
                    return;
                }
                u = y.lastBaseUpdate, u === null ? y.firstBaseUpdate = h : u.next = h, y.lastBaseUpdate = h;
            }
            function Ee() {
                if ($c) {
                    var u = sl;
                    if (u !== null) throw u;
                }
            }
            function lt(u, h, y, T) {
                $c = !1;
                var U = u.updateQueue;
                mo = !1;
                var B = U.firstBaseUpdate, se = U.lastBaseUpdate, me = U.shared.pending;
                if (me !== null) {
                    U.shared.pending = null;
                    var De = me, it = De.next;
                    De.next = null, se === null ? B = it : se.next = it, se = De;
                    var mt = u.alternate;
                    mt !== null && (mt = mt.updateQueue, me = mt.lastBaseUpdate, me !== se && (me === null ? mt.firstBaseUpdate = it : me.next = it, mt.lastBaseUpdate = De));
                }
                if (B !== null) {
                    var bt = U.baseState;
                    se = 0, mt = it = De = null, me = B;
                    do {
                        var At = me.lane & -536870913, Zt = At !== me.lane;
                        if (Zt ? (cn & At) === At : (T & At) === At) {
                            At !== 0 && At === qa && ($c = !0), mt !== null && (mt = mt.next = {
                                lane: 0,
                                tag: me.tag,
                                payload: me.payload,
                                callback: null,
                                next: null
                            });
                            e: {
                                var Ka = u, gf = me;
                                At = h;
                                var ac = y;
                                switch(gf.tag){
                                    case 1:
                                        if (Ka = gf.payload, typeof Ka == "function") {
                                            bt = Ka.call(ac, bt, At);
                                            break e;
                                        }
                                        bt = Ka;
                                        break e;
                                    case 3:
                                        Ka.flags = Ka.flags & -65537 | 128;
                                    case 0:
                                        if (Ka = gf.payload, At = typeof Ka == "function" ? Ka.call(ac, bt, At) : Ka, At == null) break e;
                                        bt = jl({}, bt, At);
                                        break e;
                                    case 2:
                                        mo = !0;
                                }
                            }
                            At = me.callback, At !== null && (u.flags |= 64, Zt && (u.flags |= 8192), Zt = U.callbacks, Zt === null ? U.callbacks = [
                                At
                            ] : Zt.push(At));
                        } else Zt = {
                            lane: At,
                            tag: me.tag,
                            payload: me.payload,
                            callback: me.callback,
                            next: null
                        }, mt === null ? (it = mt = Zt, De = bt) : mt = mt.next = Zt, se |= At;
                        if (me = me.next, me === null) {
                            if (me = U.shared.pending, me === null) break;
                            Zt = me, me = Zt.next, Zt.next = null, U.lastBaseUpdate = Zt, U.shared.pending = null;
                        }
                    }while (!0);
                    mt === null && (De = bt), U.baseState = De, U.firstBaseUpdate = it, U.lastBaseUpdate = mt, B === null && (U.shared.lanes = 0), Mr |= se, u.lanes = se, u.memoizedState = bt;
                }
            }
            function fe(u, h) {
                if (typeof u != "function") throw Error(i(191, u));
                u.call(h);
            }
            function We(u, h) {
                var y = u.callbacks;
                if (y !== null) for(u.callbacks = null, u = 0; u < y.length; u++)fe(y[u], h);
            }
            function Je(u, h) {
                if (mr(u, h)) return !0;
                if (typeof u != "object" || u === null || typeof h != "object" || h === null) return !1;
                var y = Object.keys(u), T = Object.keys(h);
                if (y.length !== T.length) return !1;
                for(T = 0; T < y.length; T++){
                    var U = y[T];
                    if (!df.call(h, U) || !mr(u[U], h[U])) return !1;
                }
                return !0;
            }
            function ut(u) {
                return u = u.status, u === "fulfilled" || u === "rejected";
            }
            function Ke() {}
            function Ve(u, h, y) {
                switch(y = u[y], y === void 0 ? u.push(h) : y !== h && (h.then(Ke, Ke), h = y), h.status){
                    case "fulfilled":
                        return h.value;
                    case "rejected":
                        throw u = h.reason, u === kn ? Error(i(483)) : u;
                    default:
                        if (typeof h.status == "string") h.then(Ke, Ke);
                        else {
                            if (u = dn, u !== null && 100 < u.shellSuspendCounter) throw Error(i(482));
                            u = h, u.status = "pending", u.then(function(T) {
                                if (h.status === "pending") {
                                    var U = h;
                                    U.status = "fulfilled", U.value = T;
                                }
                            }, function(T) {
                                if (h.status === "pending") {
                                    var U = h;
                                    U.status = "rejected", U.reason = T;
                                }
                            });
                        }
                        switch(h.status){
                            case "fulfilled":
                                return h.value;
                            case "rejected":
                                throw u = h.reason, u === kn ? Error(i(483)) : u;
                        }
                        throw Kl = h, kn;
                }
            }
            function ft() {
                if (Kl === null) throw Error(i(459));
                var u = Kl;
                return Kl = null, u;
            }
            function vt(u) {
                var h = Gr;
                return Gr += 1, Is === null && (Is = []), Ve(Is, u, h);
            }
            function yt(u, h) {
                h = h.props.ref, u.ref = h !== void 0 ? h : null;
            }
            function Ct(u, h) {
                throw h.$$typeof === bp ? Error(i(525)) : (u = Object.prototype.toString.call(h), Error(i(31, u === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : u)));
            }
            function on(u) {
                var h = u._init;
                return h(u._payload);
            }
            function gn(u) {
                function h(je, we) {
                    if (u) {
                        var qe = je.deletions;
                        qe === null ? (je.deletions = [
                            we
                        ], je.flags |= 16) : qe.push(we);
                    }
                }
                function y(je, we) {
                    if (!u) return null;
                    for(; we !== null;)h(je, we), we = we.sibling;
                    return null;
                }
                function T(je) {
                    for(var we = new Map; je !== null;)je.key !== null ? we.set(je.key, je) : we.set(je.index, je), je = je.sibling;
                    return we;
                }
                function U(je, we) {
                    return je = xa(je, we), je.index = 0, je.sibling = null, je;
                }
                function B(je, we, qe) {
                    return je.index = qe, u ? (qe = je.alternate, qe !== null ? (qe = qe.index, qe < we ? (je.flags |= 33554434, we) : qe) : (je.flags |= 33554434, we)) : (je.flags |= 1048576, we);
                }
                function se(je) {
                    return u && je.alternate === null && (je.flags |= 33554434), je;
                }
                function me(je, we, qe, ht) {
                    return we === null || we.tag !== 6 ? (we = Qo(qe, je.mode, ht), we.return = je, we) : (we = U(we, qe), we.return = je, we);
                }
                function De(je, we, qe, ht) {
                    var zt = qe.type;
                    return zt === Gc ? mt(je, we, qe.props.children, ht, qe.key) : we !== null && (we.elementType === zt || typeof zt == "object" && zt !== null && zt.$$typeof === fs && on(zt) === we.type) ? (we = U(we, qe.props), yt(we, qe), we.return = je, we) : (we = Ir(qe.type, qe.key, qe.props, null, je.mode, ht), yt(we, qe), we.return = je, we);
                }
                function it(je, we, qe, ht) {
                    return we === null || we.tag !== 4 || we.stateNode.containerInfo !== qe.containerInfo || we.stateNode.implementation !== qe.implementation ? (we = Vc(qe, je.mode, ht), we.return = je, we) : (we = U(we, qe.children || []), we.return = je, we);
                }
                function mt(je, we, qe, ht, zt) {
                    return we === null || we.tag !== 7 ? (we = lo(qe, je.mode, ht, zt), we.return = je, we) : (we = U(we, qe), we.return = je, we);
                }
                function bt(je, we, qe) {
                    if (typeof we == "string" && we !== "" || typeof we == "number" || typeof we == "bigint") return we = Qo("" + we, je.mode, qe), we.return = je, we;
                    if (typeof we == "object" && we !== null) {
                        switch(we.$$typeof){
                            case co:
                                return qe = Ir(we.type, we.key, we.props, null, je.mode, qe), yt(qe, we), qe.return = je, qe;
                            case us:
                                return we = Vc(we, je.mode, qe), we.return = je, we;
                            case fs:
                                var ht = we._init;
                                return we = ht(we._payload), bt(je, we, qe);
                        }
                        if (el(we) || r(we)) return we = lo(we, je.mode, qe, null), we.return = je, we;
                        if (typeof we.then == "function") return bt(je, vt(we), qe);
                        if (we.$$typeof === Ns) return bt(je, Pu(je, we), qe);
                        Ct(je, we);
                    }
                    return null;
                }
                function At(je, we, qe, ht) {
                    var zt = we !== null ? we.key : null;
                    if (typeof qe == "string" && qe !== "" || typeof qe == "number" || typeof qe == "bigint") return zt !== null ? null : me(je, we, "" + qe, ht);
                    if (typeof qe == "object" && qe !== null) {
                        switch(qe.$$typeof){
                            case co:
                                return qe.key === zt ? De(je, we, qe, ht) : null;
                            case us:
                                return qe.key === zt ? it(je, we, qe, ht) : null;
                            case fs:
                                return zt = qe._init, qe = zt(qe._payload), At(je, we, qe, ht);
                        }
                        if (el(qe) || r(qe)) return zt !== null ? null : mt(je, we, qe, ht, null);
                        if (typeof qe.then == "function") return At(je, we, vt(qe), ht);
                        if (qe.$$typeof === Ns) return At(je, we, Pu(je, qe), ht);
                        Ct(je, qe);
                    }
                    return null;
                }
                function Zt(je, we, qe, ht, zt) {
                    if (typeof ht == "string" && ht !== "" || typeof ht == "number" || typeof ht == "bigint") return je = je.get(qe) || null, me(we, je, "" + ht, zt);
                    if (typeof ht == "object" && ht !== null) {
                        switch(ht.$$typeof){
                            case co:
                                return je = je.get(ht.key === null ? qe : ht.key) || null, De(we, je, ht, zt);
                            case us:
                                return je = je.get(ht.key === null ? qe : ht.key) || null, it(we, je, ht, zt);
                            case fs:
                                var Jn = ht._init;
                                return ht = Jn(ht._payload), Zt(je, we, qe, ht, zt);
                        }
                        if (el(ht) || r(ht)) return je = je.get(qe) || null, mt(we, je, ht, zt, null);
                        if (typeof ht.then == "function") return Zt(je, we, qe, vt(ht), zt);
                        if (ht.$$typeof === Ns) return Zt(je, we, qe, Pu(we, ht), zt);
                        Ct(we, ht);
                    }
                    return null;
                }
                function Ka(je, we, qe, ht) {
                    for(var zt = null, Jn = null, Wt = we, Cn = we = 0, Wi = null; Wt !== null && Cn < qe.length; Cn++){
                        Wt.index > Cn ? (Wi = Wt, Wt = null) : Wi = Wt.sibling;
                        var Rn = At(je, Wt, qe[Cn], ht);
                        if (Rn === null) {
                            Wt === null && (Wt = Wi);
                            break;
                        }
                        u && Wt && Rn.alternate === null && h(je, Wt), we = B(Rn, we, Cn), Jn === null ? zt = Rn : Jn.sibling = Rn, Jn = Rn, Wt = Wi;
                    }
                    if (Cn === qe.length) return y(je, Wt), An && ee(je, Cn), zt;
                    if (Wt === null) {
                        for(; Cn < qe.length; Cn++)Wt = bt(je, qe[Cn], ht), Wt !== null && (we = B(Wt, we, Cn), Jn === null ? zt = Wt : Jn.sibling = Wt, Jn = Wt);
                        return An && ee(je, Cn), zt;
                    }
                    for(Wt = T(Wt); Cn < qe.length; Cn++)Wi = Zt(Wt, je, Cn, qe[Cn], ht), Wi !== null && (u && Wi.alternate !== null && Wt.delete(Wi.key === null ? Cn : Wi.key), we = B(Wi, we, Cn), Jn === null ? zt = Wi : Jn.sibling = Wi, Jn = Wi);
                    return u && Wt.forEach(function(So) {
                        return h(je, So);
                    }), An && ee(je, Cn), zt;
                }
                function gf(je, we, qe, ht) {
                    if (qe == null) throw Error(i(151));
                    for(var zt = null, Jn = null, Wt = we, Cn = we = 0, Wi = null, Rn = qe.next(); Wt !== null && !Rn.done; Cn++, Rn = qe.next()){
                        Wt.index > Cn ? (Wi = Wt, Wt = null) : Wi = Wt.sibling;
                        var So = At(je, Wt, Rn.value, ht);
                        if (So === null) {
                            Wt === null && (Wt = Wi);
                            break;
                        }
                        u && Wt && So.alternate === null && h(je, Wt), we = B(So, we, Cn), Jn === null ? zt = So : Jn.sibling = So, Jn = So, Wt = Wi;
                    }
                    if (Rn.done) return y(je, Wt), An && ee(je, Cn), zt;
                    if (Wt === null) {
                        for(; !Rn.done; Cn++, Rn = qe.next())Rn = bt(je, Rn.value, ht), Rn !== null && (we = B(Rn, we, Cn), Jn === null ? zt = Rn : Jn.sibling = Rn, Jn = Rn);
                        return An && ee(je, Cn), zt;
                    }
                    for(Wt = T(Wt); !Rn.done; Cn++, Rn = qe.next())Rn = Zt(Wt, je, Cn, Rn.value, ht), Rn !== null && (u && Rn.alternate !== null && Wt.delete(Rn.key === null ? Cn : Rn.key), we = B(Rn, we, Cn), Jn === null ? zt = Rn : Jn.sibling = Rn, Jn = Rn);
                    return u && Wt.forEach(function(Wh) {
                        return h(je, Wh);
                    }), An && ee(je, Cn), zt;
                }
                function ac(je, we, qe, ht) {
                    if (typeof qe == "object" && qe !== null && qe.type === Gc && qe.key === null && (qe = qe.props.children), typeof qe == "object" && qe !== null) {
                        switch(qe.$$typeof){
                            case co:
                                e: {
                                    for(var zt = qe.key; we !== null;){
                                        if (we.key === zt) {
                                            if (zt = qe.type, zt === Gc) {
                                                if (we.tag === 7) {
                                                    y(je, we.sibling), ht = U(we, qe.props.children), ht.return = je, je = ht;
                                                    break e;
                                                }
                                            } else if (we.elementType === zt || typeof zt == "object" && zt !== null && zt.$$typeof === fs && on(zt) === we.type) {
                                                y(je, we.sibling), ht = U(we, qe.props), yt(ht, qe), ht.return = je, je = ht;
                                                break e;
                                            }
                                            y(je, we);
                                            break;
                                        } else h(je, we);
                                        we = we.sibling;
                                    }
                                    qe.type === Gc ? (ht = lo(qe.props.children, je.mode, ht, qe.key), ht.return = je, je = ht) : (ht = Ir(qe.type, qe.key, qe.props, null, je.mode, ht), yt(ht, qe), ht.return = je, je = ht);
                                }
                                return se(je);
                            case us:
                                e: {
                                    for(zt = qe.key; we !== null;){
                                        if (we.key === zt) {
                                            if (we.tag === 4 && we.stateNode.containerInfo === qe.containerInfo && we.stateNode.implementation === qe.implementation) {
                                                y(je, we.sibling), ht = U(we, qe.children || []), ht.return = je, je = ht;
                                                break e;
                                            } else {
                                                y(je, we);
                                                break;
                                            }
                                        } else h(je, we);
                                        we = we.sibling;
                                    }
                                    ht = Vc(qe, je.mode, ht), ht.return = je, je = ht;
                                }
                                return se(je);
                            case fs:
                                return zt = qe._init, qe = zt(qe._payload), ac(je, we, qe, ht);
                        }
                        if (el(qe)) return Ka(je, we, qe, ht);
                        if (r(qe)) {
                            if (zt = r(qe), typeof zt != "function") throw Error(i(150));
                            return qe = zt.call(qe), gf(je, we, qe, ht);
                        }
                        if (typeof qe.then == "function") return ac(je, we, vt(qe), ht);
                        if (qe.$$typeof === Ns) return ac(je, we, Pu(je, qe), ht);
                        Ct(je, qe);
                    }
                    return typeof qe == "string" && qe !== "" || typeof qe == "number" || typeof qe == "bigint" ? (qe = "" + qe, we !== null && we.tag === 6 ? (y(je, we.sibling), ht = U(we, qe), ht.return = je, je = ht) : (y(je, we), ht = Qo(qe, je.mode, ht), ht.return = je, je = ht), se(je)) : y(je, we);
                }
                return function(je, we, qe, ht) {
                    try {
                        Gr = 0;
                        var zt = ac(je, we, qe, ht);
                        return Is = null, zt;
                    } catch (Wt) {
                        if (Wt === kn) throw Wt;
                        var Jn = t(29, Wt, null, je.mode);
                        return Jn.lanes = ht, Jn.return = je, Jn;
                    } finally{}
                };
            }
            function ni(u, h) {
                u = ms, C(_r, u), C(Fs, h), ms = u | h.baseLanes;
            }
            function Gi() {
                C(_r, ms), C(Fs, Fs.current);
            }
            function da() {
                ms = _r.current, b(Fs), b(_r);
            }
            function jn(u) {
                var h = u.alternate;
                C(Fi, Fi.current & 1), C(br, u), kr === null && (h === null || Fs.current !== null || h.memoizedState !== null) && (kr = u);
            }
            function ea(u) {
                if (u.tag === 22) {
                    if (C(Fi, Fi.current), C(br, u), kr === null) {
                        var h = u.alternate;
                        h !== null && h.memoizedState !== null && (kr = u);
                    }
                } else Pi();
            }
            function Pi() {
                C(Fi, Fi.current), C(br, br.current);
            }
            function hi(u) {
                b(br), kr === u && (kr = null), b(Fi);
            }
            function Nn(u) {
                for(var h = u; h !== null;){
                    if (h.tag === 13) {
                        var y = h.memoizedState;
                        if (y !== null && (y = y.dehydrated, y === null || Ch(y) || ef(y))) return h;
                    } else if (h.tag === 19 && h.memoizedProps.revealOrder !== void 0) {
                        if ((h.flags & 128) !== 0) return h;
                    } else if (h.child !== null) {
                        h.child.return = h, h = h.child;
                        continue;
                    }
                    if (h === u) break;
                    for(; h.sibling === null;){
                        if (h.return === null || h.return === u) return null;
                        h = h.return;
                    }
                    h.sibling.return = h.return, h = h.sibling;
                }
                return null;
            }
            function jt() {
                throw Error(i(321));
            }
            function ci(u, h) {
                if (h === null) return !1;
                for(var y = 0; y < h.length && y < u.length; y++)if (!mr(u[y], h[y])) return !1;
                return !0;
            }
            function Aa(u, h, y, T, U, B) {
                return Hs = B, en = h, h.memoizedState = null, h.updateQueue = null, h.lanes = 0, Vt.H = u === null || u.memoizedState === null ? Hi : _a, go = !1, B = y(T, U), go = !1, li && (B = Tl(h, y, T, U)), Qs(u), B;
            }
            function Qs(u) {
                Vt.H = wn;
                var h = Ln !== null && Ln.next !== null;
                if (Hs = 0, Ai = Ln = en = null, jr = !1, bi = 0, eu = null, h) throw Error(i(300));
                u === null || wi || (u = u.dependencies, u !== null && Fo(u) && (wi = !0));
            }
            function Tl(u, h, y, T) {
                en = u;
                var U = 0;
                do {
                    if (li && (eu = null), bi = 0, li = !1, 25 <= U) throw Error(i(301));
                    if (U += 1, Ai = Ln = null, u.updateQueue != null) {
                        var B = u.updateQueue;
                        B.lastEffect = null, B.events = null, B.stores = null, B.memoCache != null && (B.memoCache.index = 0);
                    }
                    Vt.H = ll, B = h(y, T);
                }while (li);
                return B;
            }
            function zo() {
                var u = Vt.H, h = u.useState()[0];
                return h = typeof h.then == "function" ? Se(h) : h, u = u.useState()[0], (Ln !== null ? Ln.memoizedState : null) !== u && (en.flags |= 1024), h;
            }
            function Ss() {
                var u = pf !== 0;
                return pf = 0, u;
            }
            function es(u, h, y) {
                h.updateQueue = u.updateQueue, h.flags &= -2053, u.lanes &= ~y;
            }
            function Ms(u) {
                if (jr) {
                    for(u = u.memoizedState; u !== null;){
                        var h = u.queue;
                        h !== null && (h.pending = null), u = u.next;
                    }
                    jr = !1;
                }
                Hs = 0, Ai = Ln = en = null, li = !1, bi = pf = 0, eu = null;
            }
            function Qn() {
                var u = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return Ai === null ? en.memoizedState = Ai = u : Ai = Ai.next = u, Ai;
            }
            function ie() {
                if (Ln === null) {
                    var u = en.alternate;
                    u = u !== null ? u.memoizedState : null;
                } else u = Ln.next;
                var h = Ai === null ? en.memoizedState : Ai.next;
                if (h !== null) Ai = h, Ln = u;
                else {
                    if (u === null) throw en.alternate === null ? Error(i(467)) : Error(i(310));
                    Ln = u, u = {
                        memoizedState: Ln.memoizedState,
                        baseState: Ln.baseState,
                        baseQueue: Ln.baseQueue,
                        queue: Ln.queue,
                        next: null
                    }, Ai === null ? en.memoizedState = Ai = u : Ai = Ai.next = u;
                }
                return Ai;
            }
            function Se(u) {
                var h = bi;
                return bi += 1, eu === null && (eu = []), u = Ve(eu, u, h), h = en, (Ai === null ? h.memoizedState : Ai.next) === null && (h = h.alternate, Vt.H = h === null || h.memoizedState === null ? Hi : _a), u;
            }
            function ve(u) {
                if (u !== null && typeof u == "object") {
                    if (typeof u.then == "function") return Se(u);
                    if (u.$$typeof === Ns) return ia(u);
                }
                throw Error(i(438, String(u)));
            }
            function Pe(u) {
                var h = null, y = en.updateQueue;
                if (y !== null && (h = y.memoCache), h == null) {
                    var T = en.alternate;
                    T !== null && (T = T.updateQueue, T !== null && (T = T.memoCache, T != null && (h = {
                        data: T.data.map(function(U) {
                            return U.slice();
                        }),
                        index: 0
                    })));
                }
                if (h == null && (h = {
                    data: [],
                    index: 0
                }), y === null && (y = Fh(), en.updateQueue = y), y.memoCache = h, y = h.data[h.index], y === void 0) for(y = h.data[h.index] = Array(u), T = 0; T < u; T++)y[T] = K0;
                return h.index++, y;
            }
            function Me(u, h) {
                return typeof h == "function" ? h(u) : h;
            }
            function dt(u) {
                var h = ie();
                return xt(h, Ln, u);
            }
            function xt(u, h, y) {
                var T = u.queue;
                if (T === null) throw Error(i(311));
                T.lastRenderedReducer = y;
                var U = u.baseQueue, B = T.pending;
                if (B !== null) {
                    if (U !== null) {
                        var se = U.next;
                        U.next = B.next, B.next = se;
                    }
                    h.baseQueue = U = B, T.pending = null;
                }
                if (B = u.baseState, U === null) u.memoizedState = B;
                else {
                    h = U.next;
                    var me = se = null, De = null, it = h, mt = !1;
                    do {
                        var bt = it.lane & -536870913;
                        if (bt !== it.lane ? (cn & bt) === bt : (Hs & bt) === bt) {
                            var At = it.revertLane;
                            if (At === 0) De !== null && (De = De.next = {
                                lane: 0,
                                revertLane: 0,
                                action: it.action,
                                hasEagerState: it.hasEagerState,
                                eagerState: it.eagerState,
                                next: null
                            }), bt === qa && (mt = !0);
                            else if ((Hs & At) === At) {
                                it = it.next, At === qa && (mt = !0);
                                continue;
                            } else bt = {
                                lane: 0,
                                revertLane: it.revertLane,
                                action: it.action,
                                hasEagerState: it.hasEagerState,
                                eagerState: it.eagerState,
                                next: null
                            }, De === null ? (me = De = bt, se = B) : De = De.next = bt, en.lanes |= At, Mr |= At;
                            bt = it.action, go && y(B, bt), B = it.hasEagerState ? it.eagerState : y(B, bt);
                        } else At = {
                            lane: bt,
                            revertLane: it.revertLane,
                            action: it.action,
                            hasEagerState: it.hasEagerState,
                            eagerState: it.eagerState,
                            next: null
                        }, De === null ? (me = De = At, se = B) : De = De.next = At, en.lanes |= bt, Mr |= bt;
                        it = it.next;
                    }while (it !== null && it !== h);
                    if (De === null ? se = B : De.next = me, !mr(B, u.memoizedState) && (wi = !0, mt && (y = sl, y !== null))) throw y;
                    u.memoizedState = B, u.baseState = se, u.baseQueue = De, T.lastRenderedState = B;
                }
                return U === null && (T.lanes = 0), [
                    u.memoizedState,
                    T.dispatch
                ];
            }
            function Et(u) {
                var h = ie(), y = h.queue;
                if (y === null) throw Error(i(311));
                y.lastRenderedReducer = u;
                var T = y.dispatch, U = y.pending, B = h.memoizedState;
                if (U !== null) {
                    y.pending = null;
                    var se = U = U.next;
                    do B = u(B, se.action), se = se.next;
                    while (se !== U);
                    mr(B, h.memoizedState) || (wi = !0), h.memoizedState = B, h.baseQueue === null && (h.baseState = B), y.lastRenderedState = B;
                }
                return [
                    B,
                    T
                ];
            }
            function Tt(u, h, y) {
                var T = en, U = ie(), B = An;
                if (B) {
                    if (y === void 0) throw Error(i(407));
                    y = y();
                } else y = h();
                var se = !mr((Ln || U).memoizedState, y);
                if (se && (U.memoizedState = y, wi = !0), U = U.queue, ts(Ut.bind(null, T, U, u), [
                    u
                ]), U.getSnapshot !== h || se || Ai !== null && Ai.memoizedState.tag & 1) {
                    if (T.flags |= 2048, qn(9, Pt.bind(null, T, U, y, h), {
                        destroy: void 0
                    }, null), dn === null) throw Error(i(349));
                    B || (Hs & 60) !== 0 || Ot(T, h, y);
                }
                return y;
            }
            function Ot(u, h, y) {
                u.flags |= 16384, u = {
                    getSnapshot: h,
                    value: y
                }, h = en.updateQueue, h === null ? (h = Fh(), en.updateQueue = h, h.stores = [
                    u
                ]) : (y = h.stores, y === null ? h.stores = [
                    u
                ] : y.push(u));
            }
            function Pt(u, h, y, T) {
                h.value = y, h.getSnapshot = T, qt(h) && mn(u);
            }
            function Ut(u, h, y) {
                return y(function() {
                    qt(h) && mn(u);
                });
            }
            function qt(u) {
                var h = u.getSnapshot;
                u = u.value;
                try {
                    var y = h();
                    return !mr(u, y);
                } catch  {
                    return !0;
                }
            }
            function mn(u) {
                var h = Ie(u, 2);
                h !== null && ga(h, u, 2);
            }
            function fn(u) {
                var h = Qn();
                if (typeof u == "function") {
                    var y = u;
                    if (u = y(), go) {
                        Q(!0);
                        try {
                            y();
                        } finally{
                            Q(!1);
                        }
                    }
                }
                return h.memoizedState = h.baseState = u, h.queue = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: Me,
                    lastRenderedState: u
                }, h;
            }
            function ln(u, h, y, T) {
                return u.baseState = y, xt(u, Ln, typeof T == "function" ? T : Me);
            }
            function xn(u, h, y, T, U) {
                if (Es(u)) throw Error(i(485));
                if (u = h.action, u !== null) {
                    var B = {
                        payload: U,
                        action: u,
                        next: null,
                        isTransition: !0,
                        status: "pending",
                        value: null,
                        reason: null,
                        listeners: [],
                        then: function(se) {
                            B.listeners.push(se);
                        }
                    };
                    Vt.T !== null ? y(!0) : B.isTransition = !1, T(B), y = h.pending, y === null ? (B.next = h.pending = B, Lt(h, B)) : (B.next = y.next, h.pending = y.next = B);
                }
            }
            function Lt(u, h) {
                var y = h.action, T = h.payload, U = u.state;
                if (h.isTransition) {
                    var B = Vt.T, se = {};
                    Vt.T = se;
                    try {
                        var me = y(U, T), De = Vt.S;
                        De !== null && De(se, me), _n(u, h, me);
                    } catch (it) {
                        ui(u, h, it);
                    } finally{
                        Vt.T = B;
                    }
                } else try {
                    B = y(U, T), _n(u, h, B);
                } catch (it) {
                    ui(u, h, it);
                }
            }
            function _n(u, h, y) {
                y !== null && typeof y == "object" && typeof y.then == "function" ? y.then(function(T) {
                    an(u, h, T);
                }, function(T) {
                    return ui(u, h, T);
                }) : an(u, h, y);
            }
            function an(u, h, y) {
                h.status = "fulfilled", h.value = y, sr(h), u.state = y, h = u.pending, h !== null && (y = h.next, y === h ? u.pending = null : (y = y.next, h.next = y, Lt(u, y)));
            }
            function ui(u, h, y) {
                var T = u.pending;
                if (u.pending = null, T !== null) {
                    T = T.next;
                    do h.status = "rejected", h.reason = y, sr(h), h = h.next;
                    while (h !== T);
                }
                u.action = null;
            }
            function sr(u) {
                u = u.listeners;
                for(var h = 0; h < u.length; h++)(0, u[h])();
            }
            function hn(u, h) {
                return h;
            }
            function Or(u, h) {
                if (An) {
                    var y = dn.formState;
                    if (y !== null) {
                        e: {
                            var T = en;
                            if (An) {
                                if (la) {
                                    var U = ag(la, Vr);
                                    if (U) {
                                        la = kp(U), T = rg(U);
                                        break e;
                                    }
                                }
                                xe(T);
                            }
                            T = !1;
                        }
                        T && (h = y[0]);
                    }
                }
                y = Qn(), y.memoizedState = y.baseState = h, T = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: hn,
                    lastRenderedState: h
                }, y.queue = T, y = Ul.bind(null, en, T), T.dispatch = y, T = fn(!1);
                var B = Nl.bind(null, en, !1, T.queue);
                return T = Qn(), U = {
                    state: h,
                    dispatch: null,
                    action: u,
                    pending: null
                }, T.queue = U, y = xn.bind(null, en, U, B, y), U.dispatch = y, T.memoizedState = u, [
                    h,
                    y,
                    !1
                ];
            }
            function On(u) {
                var h = ie();
                return ii(h, Ln, u);
            }
            function ii(u, h, y) {
                h = xt(u, h, hn)[0], u = dt(Me)[0], h = typeof h == "object" && h !== null && typeof h.then == "function" ? Se(h) : h;
                var T = ie(), U = T.queue, B = U.dispatch;
                return y !== T.memoizedState && (en.flags |= 2048, qn(9, gi.bind(null, U, y), {
                    destroy: void 0
                }, null)), [
                    h,
                    B,
                    u
                ];
            }
            function gi(u, h) {
                u.action = h;
            }
            function fi(u) {
                var h = ie(), y = Ln;
                if (y !== null) return ii(h, y, u);
                ie(), h = h.memoizedState, y = ie();
                var T = y.queue.dispatch;
                return y.memoizedState = u, [
                    h,
                    T,
                    !1
                ];
            }
            function qn(u, h, y, T) {
                return u = {
                    tag: u,
                    create: h,
                    inst: y,
                    deps: T,
                    next: null
                }, h = en.updateQueue, h === null && (h = Fh(), en.updateQueue = h), y = h.lastEffect, y === null ? h.lastEffect = u.next = u : (T = y.next, y.next = u, u.next = T, h.lastEffect = u), u;
            }
            function wa() {
                return ie().memoizedState;
            }
            function Ca(u, h, y, T) {
                var U = Qn();
                en.flags |= u, U.memoizedState = qn(1 | h, y, {
                    destroy: void 0
                }, T === void 0 ? null : T);
            }
            function Po(u, h, y, T) {
                var U = ie();
                T = T === void 0 ? null : T;
                var B = U.memoizedState.inst;
                Ln !== null && T !== null && ci(T, Ln.memoizedState.deps) ? U.memoizedState = qn(h, y, B, T) : (en.flags |= u, U.memoizedState = qn(1 | h, y, B, T));
            }
            function Al(u, h) {
                Ca(8390656, 8, u, h);
            }
            function ts(u, h) {
                Po(2048, 8, u, h);
            }
            function Nu(u, h) {
                return Po(4, 2, u, h);
            }
            function wl(u, h) {
                return Po(4, 4, u, h);
            }
            function Lr(u, h) {
                if (typeof h == "function") {
                    u = u();
                    var y = h(u);
                    return function() {
                        typeof y == "function" ? y() : h(null);
                    };
                }
                if (h != null) return u = u(), h.current = u, function() {
                    h.current = null;
                };
            }
            function ta(u, h, y) {
                y = y != null ? y.concat([
                    u
                ]) : null, Po(4, 4, Lr.bind(null, h, u), y);
            }
            function ns() {}
            function Cl(u, h) {
                var y = ie();
                h = h === void 0 ? null : h;
                var T = y.memoizedState;
                return h !== null && ci(h, T[1]) ? T[0] : (y.memoizedState = [
                    u,
                    h
                ], u);
            }
            function or(u, h) {
                var y = ie();
                h = h === void 0 ? null : h;
                var T = y.memoizedState;
                if (h !== null && ci(h, T[1])) return T[0];
                if (T = u(), go) {
                    Q(!0);
                    try {
                        u();
                    } finally{
                        Q(!1);
                    }
                }
                return y.memoizedState = [
                    T,
                    h
                ], T;
            }
            function zr(u, h, y) {
                return y === void 0 || (Hs & 1073741824) !== 0 ? u.memoizedState = h : (u.memoizedState = y, u = Cs(), en.lanes |= u, Mr |= u, y);
            }
            function Rl(u, h, y, T) {
                return mr(y, h) ? y : Fs.current !== null ? (u = zr(u, y, T), mr(u, h) || (wi = !0), u) : (Hs & 42) === 0 ? (wi = !0, u.memoizedState = y) : (u = Cs(), en.lanes |= u, Mr |= u, h);
            }
            function Dl(u, h, y, T, U) {
                var B = ji();
                va(B !== 0 && 8 > B ? B : 8);
                var se = Vt.T, me = {};
                Vt.T = me, Nl(u, !1, h, y);
                try {
                    var De = U(), it = Vt.S;
                    if (it !== null && it(me, De), De !== null && typeof De == "object" && typeof De.then == "function") {
                        var mt = tt(De, T);
                        Pr(u, h, mt, Na(u));
                    } else Pr(u, h, T, Na(u));
                } catch (bt) {
                    Pr(u, h, {
                        then: function() {},
                        status: "rejected",
                        reason: bt
                    }, Na());
                } finally{
                    va(B), Vt.T = se;
                }
            }
            function Bo(u) {
                var h = u.memoizedState;
                if (h !== null) return h;
                h = {
                    memoizedState: ja,
                    baseState: ja,
                    baseQueue: null,
                    queue: {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Me,
                        lastRenderedState: ja
                    },
                    next: null
                };
                var y = {};
                return h.next = {
                    memoizedState: y,
                    baseState: y,
                    baseQueue: null,
                    queue: {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Me,
                        lastRenderedState: y
                    },
                    next: null
                }, u.memoizedState = h, u = u.alternate, u !== null && (u.memoizedState = h), h;
            }
            function is() {
                return ia(Xt);
            }
            function lr() {
                return ie().memoizedState;
            }
            function pa() {
                return ie().memoizedState;
            }
            function Ks(u) {
                for(var h = u.return; h !== null;){
                    switch(h.tag){
                        case 24:
                        case 3:
                            var y = Na();
                            u = Ge(y);
                            var T = Ye(h, u, y);
                            T !== null && (ga(T, h, y), at(T, h, y)), h = {
                                cache: nh()
                            }, u.payload = h;
                            return;
                    }
                    h = h.return;
                }
            }
            function as(u, h, y) {
                var T = Na();
                y = {
                    lane: T,
                    revertLane: 0,
                    action: y,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                }, Es(u) ? rs(h, y) : (y = Oe(u, h, y, T), y !== null && (ga(y, u, T), Js(y, h, T)));
            }
            function Ul(u, h, y) {
                var T = Na();
                Pr(u, h, y, T);
            }
            function Pr(u, h, y, T) {
                var U = {
                    lane: T,
                    revertLane: 0,
                    action: y,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                };
                if (Es(u)) rs(h, U);
                else {
                    var B = u.alternate;
                    if (u.lanes === 0 && (B === null || B.lanes === 0) && (B = h.lastRenderedReducer, B !== null)) try {
                        var se = h.lastRenderedState, me = B(se, y);
                        if (U.hasEagerState = !0, U.eagerState = me, mr(me, se)) return te(u, h, U, 0), dn === null && Re(), !1;
                    } catch  {} finally{}
                    if (y = Oe(u, h, U, T), y !== null) return ga(y, u, T), Js(y, h, T), !0;
                }
                return !1;
            }
            function Nl(u, h, y, T) {
                if (T = {
                    lane: 2,
                    revertLane: Te(),
                    action: T,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                }, Es(u)) {
                    if (h) throw Error(i(479));
                } else h = Oe(u, y, T, 2), h !== null && ga(h, u, 2);
            }
            function Es(u) {
                var h = u.alternate;
                return u === en || h !== null && h === en;
            }
            function rs(u, h) {
                li = jr = !0;
                var y = u.pending;
                y === null ? h.next = h : (h.next = y.next, y.next = h), u.pending = h;
            }
            function Js(u, h, y) {
                if ((y & 4194176) !== 0) {
                    var T = h.lanes;
                    T &= u.pendingLanes, y |= T, h.lanes = y, Y(u, y);
                }
            }
            function ai(u, h, y, T) {
                h = u.memoizedState, y = y(T, h), y = y == null ? h : jl({}, h, y), u.memoizedState = y, u.lanes === 0 && (u.updateQueue.baseState = y);
            }
            function ss(u, h, y, T, U, B, se) {
                return u = u.stateNode, typeof u.shouldComponentUpdate == "function" ? u.shouldComponentUpdate(T, B, se) : h.prototype && h.prototype.isPureReactComponent ? !Je(y, T) || !Je(U, B) : !0;
            }
            function $s(u, h, y, T) {
                u = h.state, typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps(y, T), typeof h.UNSAFE_componentWillReceiveProps == "function" && h.UNSAFE_componentWillReceiveProps(y, T), h.state !== u && Hh.enqueueReplaceState(h, h.state, null);
            }
            function Ra(u, h) {
                var y = h;
                if ("ref" in h) {
                    y = {};
                    for(var T in h)T !== "ref" && (y[T] = h[T]);
                }
                if (u = u.defaultProps) {
                    y === h && (y = jl({}, y));
                    for(var U in u)y[U] === void 0 && (y[U] = u[U]);
                }
                return y;
            }
            function Ts(u, h) {
                try {
                    var y = u.onUncaughtError;
                    y(h.value, {
                        componentStack: h.stack
                    });
                } catch (T) {
                    setTimeout(function() {
                        throw T;
                    });
                }
            }
            function Ol(u, h, y) {
                try {
                    var T = u.onCaughtError;
                    T(y.value, {
                        componentStack: y.stack,
                        errorBoundary: h.tag === 1 ? h.stateNode : null
                    });
                } catch (U) {
                    setTimeout(function() {
                        throw U;
                    });
                }
            }
            function os(u, h, y) {
                return y = Ge(y), y.tag = 3, y.payload = {
                    element: null
                }, y.callback = function() {
                    Ts(u, h);
                }, y;
            }
            function As(u) {
                return u = Ge(u), u.tag = 3, u;
            }
            function ki(u, h, y, T) {
                var U = y.type.getDerivedStateFromError;
                if (typeof U == "function") {
                    var B = T.value;
                    u.payload = function() {
                        return U(B);
                    }, u.callback = function() {
                        Ol(h, y, T);
                    };
                }
                var se = y.stateNode;
                se !== null && typeof se.componentDidCatch == "function" && (u.callback = function() {
                    Ol(h, y, T), typeof U != "function" && (Tr === null ? Tr = new Set([
                        this
                    ]) : Tr.add(this));
                    var me = T.stack;
                    this.componentDidCatch(T.value, {
                        componentStack: me !== null ? me : ""
                    });
                });
            }
            function eh(u, h, y, T, U) {
                if (y.flags |= 32768, T !== null && typeof T == "object" && typeof T.then == "function") {
                    if (h = y.alternate, h !== null && zl(h, y, U, !0), y = br.current, y !== null) {
                        switch(y.tag){
                            case 13:
                                return kr === null ? ka() : y.alternate === null && En === 0 && (En = 3), y.flags &= -257, y.flags |= 65536, y.lanes = U, T === Ih ? y.flags |= 16384 : (h = y.updateQueue, h === null ? y.updateQueue = new Set([
                                    T
                                ]) : h.add(T), gh(u, T, U)), !1;
                            case 22:
                                return y.flags |= 65536, T === Ih ? y.flags |= 16384 : (h = y.updateQueue, h === null ? (h = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([
                                        T
                                    ])
                                }, y.updateQueue = h) : (y = h.retryQueue, y === null ? h.retryQueue = new Set([
                                    T
                                ]) : y.add(T)), gh(u, T, U)), !1;
                        }
                        throw Error(i(435, y.tag));
                    }
                    return gh(u, T, U), ka(), !1;
                }
                if (An) return h = br.current, h !== null ? ((h.flags & 65536) === 0 && (h.flags |= 256), h.flags |= 65536, h.lanes = U, T !== cf && (u = Error(i(422), {
                    cause: T
                }), nt($(u, y)))) : (T !== cf && (h = Error(i(423), {
                    cause: T
                }), nt($(h, y))), u = u.current.alternate, u.flags |= 65536, U &= -U, u.lanes |= U, T = $(T, y), U = os(u.stateNode, T, U), he(u, U), En !== 4 && (En = 2)), !1;
                var B = Error(i(520), {
                    cause: T
                });
                if (B = $(B, y), nu === null ? nu = [
                    B
                ] : nu.push(B), En !== 4 && (En = 2), h === null) return !0;
                T = $(T, y), y = h;
                do {
                    switch(y.tag){
                        case 3:
                            return y.flags |= 65536, u = U & -U, y.lanes |= u, u = os(y.stateNode, T, u), he(y, u), !1;
                        case 1:
                            if (h = y.type, B = y.stateNode, (y.flags & 128) === 0 && (typeof h.getDerivedStateFromError == "function" || B !== null && typeof B.componentDidCatch == "function" && (Tr === null || !Tr.has(B)))) return y.flags |= 65536, U &= -U, y.lanes |= U, U = As(U), ki(U, u, y, T), he(y, U), !1;
                    }
                    y = y.return;
                }while (y !== null);
                return !1;
            }
            function xi(u, h, y, T) {
                h.child = u === null ? am(h, null, y, T) : ol(h, u.child, y, T);
            }
            function Ll(u, h, y, T, U) {
                y = y.render;
                var B = h.ref;
                if ("ref" in T) {
                    var se = {};
                    for(var me in T)me !== "ref" && (se[me] = T[me]);
                } else se = T;
                return Pl(h), T = Aa(u, h, y, se, B, U), me = Ss(), u !== null && !wi ? (es(u, h, U), eo(u, h, U)) : (An && me && Z(h), h.flags |= 1, xi(u, h, T, U), h.child);
            }
            function Ou(u, h, y, T, U) {
                if (u === null) {
                    var B = y.type;
                    return typeof B == "function" && !so(B) && B.defaultProps === void 0 && y.compare === null ? (h.tag = 15, h.type = B, wc(u, h, B, T, U)) : (u = Ir(y.type, null, T, h, h.mode, U), u.ref = h.ref, u.return = h, h.child = u);
                }
                if (B = u.child, !np(u, U)) {
                    var se = B.memoizedProps;
                    if (y = y.compare, y = y !== null ? y : Je, y(se, T) && u.ref === h.ref) return eo(u, h, U);
                }
                return h.flags |= 1, u = xa(B, T), u.ref = h.ref, u.return = h, h.child = u;
            }
            function wc(u, h, y, T, U) {
                if (u !== null) {
                    var B = u.memoizedProps;
                    if (Je(B, T) && u.ref === h.ref) {
                        if (wi = !1, h.pendingProps = T = B, np(u, U)) (u.flags & 131072) !== 0 && (wi = !0);
                        else return h.lanes = u.lanes, eo(u, h, U);
                    }
                }
                return Br(u, h, y, T, U);
            }
            function na(u, h, y) {
                var T = h.pendingProps, U = T.children, B = (h.stateNode._pendingVisibility & 2) !== 0, se = u !== null ? u.memoizedState : null;
                if (Bi(u, h), T.mode === "hidden" || B) {
                    if ((h.flags & 128) !== 0) {
                        if (T = se !== null ? se.baseLanes | y : y, u !== null) {
                            for(U = h.child = u.child, B = 0; U !== null;)B = B | U.lanes | U.childLanes, U = U.sibling;
                            h.childLanes = B & ~T;
                        } else h.childLanes = 0, h.child = null;
                        return Ha(u, h, T, y);
                    }
                    if ((y & 536870912) !== 0) h.memoizedState = {
                        baseLanes: 0,
                        cachePool: null
                    }, u !== null && ih(h, se !== null ? se.cachePool : null), se !== null ? ni(h, se) : Gi(), ea(h);
                    else return h.lanes = h.childLanes = 536870912, Ha(u, h, se !== null ? se.baseLanes | y : y, y);
                } else se !== null ? (ih(h, se.cachePool), ni(h, se), Pi(), h.memoizedState = null) : (u !== null && ih(h, null), Gi(), Pi());
                return xi(u, h, U, y), h.child;
            }
            function Ha(u, h, y, T) {
                var U = Ho();
                return U = U === null ? null : {
                    parent: Ls ? Bn._currentValue : Bn._currentValue2,
                    pool: U
                }, h.memoizedState = {
                    baseLanes: y,
                    cachePool: U
                }, u !== null && ih(h, null), Gi(), ea(h), u !== null && zl(u, h, T, !0), null;
            }
            function Bi(u, h) {
                var y = h.ref;
                if (y === null) u !== null && u.ref !== null && (h.flags |= 2097664);
                else {
                    if (typeof y != "function" && typeof y != "object") throw Error(i(284));
                    (u === null || u.ref !== y) && (h.flags |= 2097664);
                }
            }
            function Br(u, h, y, T, U) {
                return Pl(h), y = Aa(u, h, y, T, void 0, U), T = Ss(), u !== null && !wi ? (es(u, h, U), eo(u, h, U)) : (An && T && Z(h), h.flags |= 1, xi(u, h, y, U), h.child);
            }
            function Lu(u, h, y, T, U, B) {
                return Pl(h), h.updateQueue = null, y = Tl(h, T, y, U), Qs(u), T = Ss(), u !== null && !wi ? (es(u, h, B), eo(u, h, B)) : (An && T && Z(h), h.flags |= 1, xi(u, h, y, B), h.child);
            }
            function Kd(u, h, y, T, U) {
                if (Pl(h), h.stateNode === null) {
                    var B = Zl, se = y.contextType;
                    typeof se == "object" && se !== null && (B = ia(se)), B = new y(T, B), h.memoizedState = B.state !== null && B.state !== void 0 ? B.state : null, B.updater = Hh, h.stateNode = B, B._reactInternals = h, B = h.stateNode, B.props = T, B.state = h.memoizedState, B.refs = {}, gt(h), se = y.contextType, B.context = typeof se == "object" && se !== null ? ia(se) : Zl, B.state = h.memoizedState, se = y.getDerivedStateFromProps, typeof se == "function" && (ai(h, y, se, T), B.state = h.memoizedState), typeof y.getDerivedStateFromProps == "function" || typeof B.getSnapshotBeforeUpdate == "function" || typeof B.UNSAFE_componentWillMount != "function" && typeof B.componentWillMount != "function" || (se = B.state, typeof B.componentWillMount == "function" && B.componentWillMount(), typeof B.UNSAFE_componentWillMount == "function" && B.UNSAFE_componentWillMount(), se !== B.state && Hh.enqueueReplaceState(B, B.state, null), lt(h, T, B, U), Ee(), B.state = h.memoizedState), typeof B.componentDidMount == "function" && (h.flags |= 4194308), T = !0;
                } else if (u === null) {
                    B = h.stateNode;
                    var me = h.memoizedProps, De = Ra(y, me);
                    B.props = De;
                    var it = B.context, mt = y.contextType;
                    se = Zl, typeof mt == "object" && mt !== null && (se = ia(mt));
                    var bt = y.getDerivedStateFromProps;
                    mt = typeof bt == "function" || typeof B.getSnapshotBeforeUpdate == "function", me = h.pendingProps !== me, mt || typeof B.UNSAFE_componentWillReceiveProps != "function" && typeof B.componentWillReceiveProps != "function" || (me || it !== se) && $s(h, B, T, se), mo = !1;
                    var At = h.memoizedState;
                    B.state = At, lt(h, T, B, U), Ee(), it = h.memoizedState, me || At !== it || mo ? (typeof bt == "function" && (ai(h, y, bt, T), it = h.memoizedState), (De = mo || ss(h, y, De, T, At, it, se)) ? (mt || typeof B.UNSAFE_componentWillMount != "function" && typeof B.componentWillMount != "function" || (typeof B.componentWillMount == "function" && B.componentWillMount(), typeof B.UNSAFE_componentWillMount == "function" && B.UNSAFE_componentWillMount()), typeof B.componentDidMount == "function" && (h.flags |= 4194308)) : (typeof B.componentDidMount == "function" && (h.flags |= 4194308), h.memoizedProps = T, h.memoizedState = it), B.props = T, B.state = it, B.context = se, T = De) : (typeof B.componentDidMount == "function" && (h.flags |= 4194308), T = !1);
                } else {
                    B = h.stateNode, pt(u, h), se = h.memoizedProps, mt = Ra(y, se), B.props = mt, bt = h.pendingProps, At = B.context, it = y.contextType, De = Zl, typeof it == "object" && it !== null && (De = ia(it)), me = y.getDerivedStateFromProps, (it = typeof me == "function" || typeof B.getSnapshotBeforeUpdate == "function") || typeof B.UNSAFE_componentWillReceiveProps != "function" && typeof B.componentWillReceiveProps != "function" || (se !== bt || At !== De) && $s(h, B, T, De), mo = !1, At = h.memoizedState, B.state = At, lt(h, T, B, U), Ee();
                    var Zt = h.memoizedState;
                    se !== bt || At !== Zt || mo || u !== null && u.dependencies !== null && Fo(u.dependencies) ? (typeof me == "function" && (ai(h, y, me, T), Zt = h.memoizedState), (mt = mo || ss(h, y, mt, T, At, Zt, De) || u !== null && u.dependencies !== null && Fo(u.dependencies)) ? (it || typeof B.UNSAFE_componentWillUpdate != "function" && typeof B.componentWillUpdate != "function" || (typeof B.componentWillUpdate == "function" && B.componentWillUpdate(T, Zt, De), typeof B.UNSAFE_componentWillUpdate == "function" && B.UNSAFE_componentWillUpdate(T, Zt, De)), typeof B.componentDidUpdate == "function" && (h.flags |= 4), typeof B.getSnapshotBeforeUpdate == "function" && (h.flags |= 1024)) : (typeof B.componentDidUpdate != "function" || se === u.memoizedProps && At === u.memoizedState || (h.flags |= 4), typeof B.getSnapshotBeforeUpdate != "function" || se === u.memoizedProps && At === u.memoizedState || (h.flags |= 1024), h.memoizedProps = T, h.memoizedState = Zt), B.props = T, B.state = Zt, B.context = De, T = mt) : (typeof B.componentDidUpdate != "function" || se === u.memoizedProps && At === u.memoizedState || (h.flags |= 4), typeof B.getSnapshotBeforeUpdate != "function" || se === u.memoizedProps && At === u.memoizedState || (h.flags |= 1024), T = !1);
                }
                return B = T, Bi(u, h), T = (h.flags & 128) !== 0, B || T ? (B = h.stateNode, y = T && typeof y.getDerivedStateFromError != "function" ? null : B.render(), h.flags |= 1, u !== null && T ? (h.child = ol(h, u.child, null, U), h.child = ol(h, null, y, U)) : xi(u, h, y, U), h.memoizedState = B.state, u = h.child) : u = eo(u, h, U), u;
            }
            function L0(u, h, y, T) {
                return ke(), h.flags |= 256, xi(u, h, y, T), h.child;
            }
            function Jd(u) {
                return {
                    baseLanes: u,
                    cachePool: F0()
                };
            }
            function $d(u, h, y) {
                return u = u !== null ? u.childLanes & ~y : 0, h && (u |= Qa), u;
            }
            function z0(u, h, y) {
                var T = h.pendingProps, U = !1, B = (h.flags & 128) !== 0, se;
                if ((se = B) || (se = u !== null && u.memoizedState === null ? !1 : (Fi.current & 2) !== 0), se && (U = !0, h.flags &= -129), se = (h.flags & 32) !== 0, h.flags &= -33, u === null) {
                    if (An) {
                        if (U ? jn(h) : Pi(), An) {
                            var me = la, De;
                            (De = me) && (me = ug(me, Vr), me !== null ? (h.memoizedState = {
                                dehydrated: me,
                                treeContext: hs !== null ? {
                                    id: Bs,
                                    overflow: Hr
                                } : null,
                                retryLane: 536870912
                            }, De = t(18, null, null, 0), De.stateNode = me, De.return = h, h.child = De, ya = h, la = null, De = !0) : De = !1), De || xe(h);
                        }
                        if (me = h.memoizedState, me !== null && (me = me.dehydrated, me !== null)) return ef(me) ? h.lanes = 16 : h.lanes = 536870912, null;
                        hi(h);
                    }
                    return me = T.children, T = T.fallback, U ? (Pi(), U = h.mode, me = ep({
                        mode: "hidden",
                        children: me
                    }, U), T = lo(T, U, y, null), me.return = h, T.return = h, me.sibling = T, h.child = me, U = h.child, U.memoizedState = Jd(y), U.childLanes = $d(u, se, y), h.memoizedState = ba, T) : (jn(h), zu(h, me));
                }
                if (De = u.memoizedState, De !== null && (me = De.dehydrated, me !== null)) {
                    if (B) h.flags & 256 ? (jn(h), h.flags &= -257, h = tp(u, h, y)) : h.memoizedState !== null ? (Pi(), h.child = u.child, h.flags |= 128, h = null) : (Pi(), U = T.fallback, me = h.mode, T = ep({
                        mode: "visible",
                        children: T.children
                    }, me), U = lo(U, me, y, null), U.flags |= 2, T.return = h, U.return = h, T.sibling = U, h.child = T, ol(h, u.child, null, y), T = h.child, T.memoizedState = Jd(y), T.childLanes = $d(u, se, y), h.memoizedState = ba, h = U);
                    else if (jn(h), ef(me)) se = ig(me).digest, T = Error(i(419)), T.stack = "", T.digest = se, nt({
                        value: T,
                        source: null,
                        stack: null
                    }), h = tp(u, h, y);
                    else if (wi || zl(u, h, y, !1), se = (y & u.childLanes) !== 0, wi || se) {
                        if (se = dn, se !== null) {
                            if (T = y & -y, (T & 42) !== 0) T = 1;
                            else switch(T){
                                case 2:
                                    T = 1;
                                    break;
                                case 8:
                                    T = 4;
                                    break;
                                case 32:
                                    T = 16;
                                    break;
                                case 128:
                                case 256:
                                case 512:
                                case 1024:
                                case 2048:
                                case 4096:
                                case 8192:
                                case 16384:
                                case 32768:
                                case 65536:
                                case 131072:
                                case 262144:
                                case 524288:
                                case 1048576:
                                case 2097152:
                                case 4194304:
                                case 8388608:
                                case 16777216:
                                case 33554432:
                                    T = 64;
                                    break;
                                case 268435456:
                                    T = 134217728;
                                    break;
                                default:
                                    T = 0;
                            }
                            if (T = (T & (se.suspendedLanes | y)) !== 0 ? 0 : T, T !== 0 && T !== De.retryLane) throw De.retryLane = T, Ie(u, T), ga(se, u, T), Tg;
                        }
                        Ch(me) || ka(), h = tp(u, h, y);
                    } else Ch(me) ? (h.flags |= 128, h.child = u.child, h = Gl.bind(null, u), jy(me, h), h = null) : (u = De.treeContext, Oa && (la = og(me), ya = h, An = !0, vr = null, Vr = !1, u !== null && (gr[xr++] = Bs, gr[xr++] = Hr, gr[xr++] = hs, Bs = u.id, Hr = u.overflow, hs = h)), h = zu(h, T.children), h.flags |= 4096);
                    return h;
                }
                return U ? (Pi(), U = T.fallback, me = h.mode, De = u.child, B = De.sibling, T = xa(De, {
                    mode: "hidden",
                    children: T.children
                }), T.subtreeFlags = De.subtreeFlags & 31457280, B !== null ? U = xa(B, U) : (U = lo(U, me, y, null), U.flags |= 2), U.return = h, T.return = h, T.sibling = U, h.child = T, T = U, U = h.child, me = u.child.memoizedState, me === null ? me = Jd(y) : (De = me.cachePool, De !== null ? (B = Ls ? Bn._currentValue : Bn._currentValue2, De = De.parent !== B ? {
                    parent: B,
                    pool: B
                } : De) : De = F0(), me = {
                    baseLanes: me.baseLanes | y,
                    cachePool: De
                }), U.memoizedState = me, U.childLanes = $d(u, se, y), h.memoizedState = ba, T) : (jn(h), y = u.child, u = y.sibling, y = xa(y, {
                    mode: "visible",
                    children: T.children
                }), y.return = h, y.sibling = null, u !== null && (se = h.deletions, se === null ? (h.deletions = [
                    u
                ], h.flags |= 16) : se.push(u)), h.child = y, h.memoizedState = null, y);
            }
            function zu(u, h) {
                return h = ep({
                    mode: "visible",
                    children: h
                }, u.mode), h.return = u, u.child = h;
            }
            function ep(u, h) {
                return xh(u, h, 0, null);
            }
            function tp(u, h, y) {
                return ol(h, u.child, null, y), u = zu(h, h.pendingProps.children), u.flags |= 2, h.memoizedState = null, u;
            }
            function P0(u, h, y) {
                u.lanes |= h;
                var T = u.alternate;
                T !== null && (T.lanes |= h), ip(u.return, h, y);
            }
            function th(u, h, y, T, U) {
                var B = u.memoizedState;
                B === null ? u.memoizedState = {
                    isBackwards: h,
                    rendering: null,
                    renderingStartTime: 0,
                    last: T,
                    tail: y,
                    tailMode: U
                } : (B.isBackwards = h, B.rendering = null, B.renderingStartTime = 0, B.last = T, B.tail = y, B.tailMode = U);
            }
            function B0(u, h, y) {
                var T = h.pendingProps, U = T.revealOrder, B = T.tail;
                if (xi(u, h, T.children, y), T = Fi.current, (T & 2) !== 0) T = T & 1 | 2, h.flags |= 128;
                else {
                    if (u !== null && (u.flags & 128) !== 0) e: for(u = h.child; u !== null;){
                        if (u.tag === 13) u.memoizedState !== null && P0(u, y, h);
                        else if (u.tag === 19) P0(u, y, h);
                        else if (u.child !== null) {
                            u.child.return = u, u = u.child;
                            continue;
                        }
                        if (u === h) break e;
                        for(; u.sibling === null;){
                            if (u.return === null || u.return === h) break e;
                            u = u.return;
                        }
                        u.sibling.return = u.return, u = u.sibling;
                    }
                    T &= 1;
                }
                switch(C(Fi, T), U){
                    case "forwards":
                        for(y = h.child, U = null; y !== null;)u = y.alternate, u !== null && Nn(u) === null && (U = y), y = y.sibling;
                        y = U, y === null ? (U = h.child, h.child = null) : (U = y.sibling, y.sibling = null), th(h, !1, U, y, B);
                        break;
                    case "backwards":
                        for(y = null, U = h.child, h.child = null; U !== null;){
                            if (u = U.alternate, u !== null && Nn(u) === null) {
                                h.child = U;
                                break;
                            }
                            u = U.sibling, U.sibling = y, y = U, U = u;
                        }
                        th(h, !0, y, null, B);
                        break;
                    case "together":
                        th(h, !1, null, null, void 0);
                        break;
                    default:
                        h.memoizedState = null;
                }
                return h.child;
            }
            function eo(u, h, y) {
                if (u !== null && (h.dependencies = u.dependencies), Mr |= h.lanes, (y & h.childLanes) === 0) {
                    if (u !== null) {
                        if (zl(u, h, y, !1), (y & h.childLanes) === 0) return null;
                    } else return null;
                }
                if (u !== null && h.child !== u.child) throw Error(i(153));
                if (h.child !== null) {
                    for(u = h.child, y = xa(u, u.pendingProps), h.child = y, y.return = h; u.sibling !== null;)u = u.sibling, y = y.sibling = xa(u, u.pendingProps), y.return = h;
                    y.sibling = null;
                }
                return h.child;
            }
            function np(u, h) {
                return (u.lanes & h) !== 0 ? !0 : (u = u.dependencies, !!(u !== null && Fo(u)));
            }
            function Vy(u, h, y) {
                switch(h.tag){
                    case 3:
                        ce(h, h.stateNode.containerInfo), Io(h, Bn, u.memoizedState.cache), ke();
                        break;
                    case 27:
                    case 5:
                        ue(h);
                        break;
                    case 4:
                        ce(h, h.stateNode.containerInfo);
                        break;
                    case 10:
                        Io(h, h.type, h.memoizedProps.value);
                        break;
                    case 13:
                        var T = h.memoizedState;
                        if (T !== null) return T.dehydrated !== null ? (jn(h), h.flags |= 128, null) : (y & h.child.childLanes) !== 0 ? z0(u, h, y) : (jn(h), u = eo(u, h, y), u !== null ? u.sibling : null);
                        jn(h);
                        break;
                    case 19:
                        var U = (u.flags & 128) !== 0;
                        if (T = (y & h.childLanes) !== 0, T || (zl(u, h, y, !1), T = (y & h.childLanes) !== 0), U) {
                            if (T) return B0(u, h, y);
                            h.flags |= 128;
                        }
                        if (U = h.memoizedState, U !== null && (U.rendering = null, U.tail = null, U.lastEffect = null), C(Fi, Fi.current), T) break;
                        return null;
                    case 22:
                    case 23:
                        return h.lanes = 0, na(u, h, y);
                    case 24:
                        Io(h, Bn, u.memoizedState.cache);
                }
                return eo(u, h, y);
            }
            function I0(u, h, y) {
                if (u !== null) {
                    if (u.memoizedProps !== h.pendingProps) wi = !0;
                    else {
                        if (!np(u, y) && (h.flags & 128) === 0) return wi = !1, Vy(u, h, y);
                        wi = (u.flags & 131072) !== 0;
                    }
                } else wi = !1, An && (h.flags & 1048576) !== 0 && I(h, of, h.index);
                switch(h.lanes = 0, h.tag){
                    case 16:
                        e: {
                            u = h.pendingProps;
                            var T = h.elementType, U = T._init;
                            if (T = U(T._payload), h.type = T, typeof T == "function") so(T) ? (u = Ra(T, u), h.tag = 1, h = Kd(null, h, T, u, y)) : (h.tag = 0, h = Br(null, h, T, u, y));
                            else {
                                if (T != null) {
                                    if (U = T.$$typeof, U === kc) {
                                        h.tag = 11, h = Ll(null, h, T, u, y);
                                        break e;
                                    } else if (U === Wu) {
                                        h.tag = 14, h = Ou(null, h, T, u, y);
                                        break e;
                                    }
                                }
                                throw h = l(T) || T, Error(i(306, h, ""));
                            }
                        }
                        return h;
                    case 0:
                        return Br(u, h, h.type, h.pendingProps, y);
                    case 1:
                        return T = h.type, U = Ra(T, h.pendingProps), Kd(u, h, T, U, y);
                    case 3:
                        e: {
                            if (ce(h, h.stateNode.containerInfo), u === null) throw Error(i(387));
                            var B = h.pendingProps;
                            U = h.memoizedState, T = U.element, pt(u, h), lt(h, B, null, y);
                            var se = h.memoizedState;
                            if (B = se.cache, Io(h, Bn, B), B !== U.cache && ap(h, [
                                Bn
                            ], y, !0), Ee(), B = se.element, Oa && U.isDehydrated) {
                                if (U = {
                                    element: B,
                                    isDehydrated: !1,
                                    cache: se.cache
                                }, h.updateQueue.baseState = U, h.memoizedState = U, h.flags & 256) {
                                    h = L0(u, h, B, y);
                                    break e;
                                } else if (B !== T) {
                                    T = $(Error(i(424)), h), nt(T), h = L0(u, h, B, y);
                                    break e;
                                } else for(Oa && (la = sg(h.stateNode.containerInfo), ya = h, An = !0, vr = null, Vr = !0), y = am(h, null, B, y), h.child = y; y;)y.flags = y.flags & -3 | 4096, y = y.sibling;
                            } else {
                                if (ke(), B === T) {
                                    h = eo(u, h, y);
                                    break e;
                                }
                                xi(u, h, B, y);
                            }
                            h = h.child;
                        }
                        return h;
                    case 26:
                        if (pr) return Bi(u, h), u === null ? (y = Oh(h.type, null, h.pendingProps, null)) ? h.memoizedState = y : An || (h.stateNode = Wy(h.type, h.pendingProps, ds.current, h)) : h.memoizedState = Oh(h.type, u.memoizedProps, h.pendingProps, u.memoizedState), null;
                    case 27:
                        if (sa) return ue(h), u === null && sa && An && (T = h.stateNode = em(h.type, h.pendingProps, ds.current, Ji.current, !1), ya = h, Vr = !0, la = Rh(T)), T = h.pendingProps.children, u !== null || An ? xi(u, h, T, y) : h.child = ol(h, null, T, y), Bi(u, h), h.child;
                    case 5:
                        return u === null && An && (mg(h.type, h.pendingProps, Ji.current), (U = T = la) && (T = lg(T, h.type, h.pendingProps, Vr), T !== null ? (h.stateNode = T, ya = h, la = Rh(T), Vr = !1, U = !0) : U = !1), U || xe(h)), ue(h), U = h.type, B = h.pendingProps, se = u !== null ? u.memoizedProps : null, T = B.children, nl(U, B) ? T = null : se !== null && nl(U, se) && (h.flags |= 32), h.memoizedState !== null && (U = Aa(u, h, zo, null, null, y), Ls ? Xt._currentValue = U : Xt._currentValue2 = U), Bi(u, h), xi(u, h, T, y), h.child;
                    case 6:
                        return u === null && An && (gg(h.pendingProps, Ji.current), (u = y = la) && (y = cg(y, h.pendingProps, Vr), y !== null ? (h.stateNode = y, ya = h, la = null, u = !0) : u = !1), u || xe(h)), null;
                    case 13:
                        return z0(u, h, y);
                    case 4:
                        return ce(h, h.stateNode.containerInfo), T = h.pendingProps, u === null ? h.child = ol(h, null, T, y) : xi(u, h, T, y), h.child;
                    case 11:
                        return Ll(u, h, h.type, h.pendingProps, y);
                    case 7:
                        return xi(u, h, h.pendingProps, y), h.child;
                    case 8:
                        return xi(u, h, h.pendingProps.children, y), h.child;
                    case 12:
                        return xi(u, h, h.pendingProps.children, y), h.child;
                    case 10:
                        return T = h.pendingProps, Io(h, h.type, T.value), xi(u, h, T.children, y), h.child;
                    case 9:
                        return U = h.type._context, T = h.pendingProps.children, Pl(h), U = ia(U), T = T(U), h.flags |= 1, xi(u, h, T, y), h.child;
                    case 14:
                        return Ou(u, h, h.type, h.pendingProps, y);
                    case 15:
                        return wc(u, h, h.type, h.pendingProps, y);
                    case 19:
                        return B0(u, h, y);
                    case 22:
                        return na(u, h, y);
                    case 24:
                        return Pl(h), T = ia(Bn), u === null ? (U = Ho(), U === null && (U = dn, B = nh(), U.pooledCache = B, B.refCount++, B !== null && (U.pooledCacheLanes |= y), U = B), h.memoizedState = {
                            parent: T,
                            cache: U
                        }, gt(h), Io(h, Bn, U)) : ((u.lanes & y) !== 0 && (pt(u, h), lt(h, null, null, y), Ee()), U = u.memoizedState, B = h.memoizedState, U.parent !== T ? (U = {
                            parent: T,
                            cache: T
                        }, h.memoizedState = U, h.lanes === 0 && (h.memoizedState = h.updateQueue.baseState = U), Io(h, Bn, T)) : (T = B.cache, Io(h, Bn, T), T !== U.cache && ap(h, [
                            Bn
                        ], y, !0))), xi(u, h, h.pendingProps.children, y), h.child;
                    case 29:
                        throw h.pendingProps;
                }
                throw Error(i(156, h.tag));
            }
            function Io(u, h, y) {
                Ls ? (C(Ya, h._currentValue), h._currentValue = y) : (C(Ya, h._currentValue2), h._currentValue2 = y);
            }
            function to(u) {
                var h = Ya.current;
                Ls ? u._currentValue = h : u._currentValue2 = h, b(Ya);
            }
            function ip(u, h, y) {
                for(; u !== null;){
                    var T = u.alternate;
                    if ((u.childLanes & h) !== h ? (u.childLanes |= h, T !== null && (T.childLanes |= h)) : T !== null && (T.childLanes & h) !== h && (T.childLanes |= h), u === y) break;
                    u = u.return;
                }
            }
            function ap(u, h, y, T) {
                var U = u.child;
                for(U !== null && (U.return = u); U !== null;){
                    var B = U.dependencies;
                    if (B !== null) {
                        var se = U.child;
                        B = B.firstContext;
                        e: for(; B !== null;){
                            var me = B;
                            B = U;
                            for(var De = 0; De < h.length; De++)if (me.context === h[De]) {
                                B.lanes |= y, me = B.alternate, me !== null && (me.lanes |= y), ip(B.return, y, u), T || (se = null);
                                break e;
                            }
                            B = me.next;
                        }
                    } else if (U.tag === 18) {
                        if (se = U.return, se === null) throw Error(i(341));
                        se.lanes |= y, B = se.alternate, B !== null && (B.lanes |= y), ip(se, y, u), se = null;
                    } else se = U.child;
                    if (se !== null) se.return = U;
                    else for(se = U; se !== null;){
                        if (se === u) {
                            se = null;
                            break;
                        }
                        if (U = se.sibling, U !== null) {
                            U.return = se.return, se = U;
                            break;
                        }
                        se = se.return;
                    }
                    U = se;
                }
            }
            function zl(u, h, y, T) {
                u = null;
                for(var U = h, B = !1; U !== null;){
                    if (!B) {
                        if ((U.flags & 524288) !== 0) B = !0;
                        else if ((U.flags & 262144) !== 0) break;
                    }
                    if (U.tag === 10) {
                        var se = U.alternate;
                        if (se === null) throw Error(i(387));
                        if (se = se.memoizedProps, se !== null) {
                            var me = U.type;
                            mr(U.pendingProps.value, se.value) || (u !== null ? u.push(me) : u = [
                                me
                            ]);
                        }
                    } else if (U === Qc.current) {
                        if (se = U.alternate, se === null) throw Error(i(387));
                        se.memoizedState.memoizedState !== U.memoizedState.memoizedState && (u !== null ? u.push(Xt) : u = [
                            Xt
                        ]);
                    }
                    U = U.return;
                }
                u !== null && ap(h, u, y, T), h.flags |= 262144;
            }
            function Fo(u) {
                for(u = u.firstContext; u !== null;){
                    var h = u.context;
                    if (!mr(Ls ? h._currentValue : h._currentValue2, u.memoizedValue)) return !0;
                    u = u.next;
                }
                return !1;
            }
            function Pl(u) {
                cl = u, Si = null, u = u.dependencies, u !== null && (u.firstContext = null);
            }
            function ia(u) {
                return rp(cl, u);
            }
            function Pu(u, h) {
                return cl === null && Pl(u), rp(u, h);
            }
            function rp(u, h) {
                var y = Ls ? h._currentValue : h._currentValue2;
                if (h = {
                    context: h,
                    memoizedValue: y,
                    next: null
                }, Si === null) {
                    if (u === null) throw Error(i(308));
                    Si = h, u.dependencies = {
                        lanes: 0,
                        firstContext: h
                    }, u.flags |= 524288;
                } else Si = Si.next = h;
                return y;
            }
            function nh() {
                return {
                    controller: new Ag,
                    data: new Map,
                    refCount: 0
                };
            }
            function Cc(u) {
                u.refCount--, u.refCount === 0 && xo(Jl, function() {
                    u.controller.abort();
                });
            }
            function Ho() {
                var u = vo.current;
                return u !== null ? u : dn.pooledCache;
            }
            function ih(u, h) {
                h === null ? C(vo, vo.current) : C(vo, h.pool);
            }
            function F0() {
                var u = Ho();
                return u === null ? null : {
                    parent: Ls ? Bn._currentValue : Bn._currentValue2,
                    pool: u
                };
            }
            function cr(u) {
                u.flags |= 4;
            }
            function sp(u, h) {
                if (u !== null && u.child === h.child) return !1;
                if ((h.flags & 16) !== 0) return !0;
                for(u = h.child; u !== null;){
                    if ((u.flags & 13878) !== 0 || (u.subtreeFlags & 13878) !== 0) return !0;
                    u = u.sibling;
                }
                return !1;
            }
            function ah(u, h, y, T) {
                if (ra) for(y = h.child; y !== null;){
                    if (y.tag === 5 || y.tag === 6) Os(u, y.stateNode);
                    else if (!(y.tag === 4 || sa && y.tag === 27) && y.child !== null) {
                        y.child.return = y, y = y.child;
                        continue;
                    }
                    if (y === h) break;
                    for(; y.sibling === null;){
                        if (y.return === null || y.return === h) return;
                        y = y.return;
                    }
                    y.sibling.return = y.return, y = y.sibling;
                }
                else if (hr) for(var U = h.child; U !== null;){
                    if (U.tag === 5) {
                        var B = U.stateNode;
                        y && T && (B = Vp(B, U.type, U.memoizedProps)), Os(u, B);
                    } else if (U.tag === 6) B = U.stateNode, y && T && (B = Gp(B, U.memoizedProps)), Os(u, B);
                    else if (U.tag !== 4) {
                        if (U.tag === 22 && U.memoizedState !== null) B = U.child, B !== null && (B.return = U), ah(u, U, !0, !0);
                        else if (U.child !== null) {
                            U.child.return = U, U = U.child;
                            continue;
                        }
                    }
                    if (U === h) break;
                    for(; U.sibling === null;){
                        if (U.return === null || U.return === h) return;
                        U = U.return;
                    }
                    U.sibling.return = U.return, U = U.sibling;
                }
            }
            function Rc(u, h, y, T) {
                if (hr) for(var U = h.child; U !== null;){
                    if (U.tag === 5) {
                        var B = U.stateNode;
                        y && T && (B = Vp(B, U.type, U.memoizedProps)), Fp(u, B);
                    } else if (U.tag === 6) B = U.stateNode, y && T && (B = Gp(B, U.memoizedProps)), Fp(u, B);
                    else if (U.tag !== 4) {
                        if (U.tag === 22 && U.memoizedState !== null) B = U.child, B !== null && (B.return = U), Rc(u, U, !(U.memoizedProps !== null && U.memoizedProps.mode === "manual"), !0);
                        else if (U.child !== null) {
                            U.child.return = U, U = U.child;
                            continue;
                        }
                    }
                    if (U === h) break;
                    for(; U.sibling === null;){
                        if (U.return === null || U.return === h) return;
                        U = U.return;
                    }
                    U.sibling.return = U.return, U = U.sibling;
                }
            }
            function Dc(u, h) {
                if (hr && sp(u, h)) {
                    u = h.stateNode;
                    var y = u.containerInfo, T = wh();
                    Rc(T, h, !1, !1), u.pendingChildren = T, cr(h), ng(y, T);
                }
            }
            function op(u, h, y, T) {
                if (ra) u.memoizedProps !== T && cr(h);
                else if (hr) {
                    var U = u.stateNode, B = u.memoizedProps;
                    if ((u = sp(u, h)) || B !== T) {
                        var se = Ji.current;
                        B = Ip(U, y, B, T, !u, null), B === U ? h.stateNode = U : (uo(B, y, T, se) && cr(h), h.stateNode = B, u ? ah(B, h, !1, !1) : cr(h));
                    } else h.stateNode = U;
                }
            }
            function Uc(u, h, y) {
                if ($0(h, y)) {
                    if (u.flags |= 16777216, !fo(h, y)) {
                        if (Gu()) u.flags |= 8192;
                        else throw Kl = Ih, im;
                    }
                } else u.flags &= -16777217;
            }
            function lp(u, h) {
                if (xg(h)) {
                    if (u.flags |= 16777216, !Jp(h)) {
                        if (Gu()) u.flags |= 8192;
                        else throw Kl = Ih, im;
                    }
                } else u.flags &= -16777217;
            }
            function Bu(u, h) {
                h !== null && (u.flags |= 4), u.flags & 16384 && (h = u.tag !== 22 ? O() : 536870912, u.lanes |= h, _o |= h);
            }
            function Bl(u, h) {
                if (!An) switch(u.tailMode){
                    case "hidden":
                        h = u.tail;
                        for(var y = null; h !== null;)h.alternate !== null && (y = h), h = h.sibling;
                        y === null ? u.tail = null : y.sibling = null;
                        break;
                    case "collapsed":
                        y = u.tail;
                        for(var T = null; y !== null;)y.alternate !== null && (T = y), y = y.sibling;
                        T === null ? h || u.tail === null ? u.tail = null : u.tail.sibling = null : T.sibling = null;
                }
            }
            function ri(u) {
                var h = u.alternate !== null && u.alternate.child === u.child, y = 0, T = 0;
                if (h) for(var U = u.child; U !== null;)y |= U.lanes | U.childLanes, T |= U.subtreeFlags & 31457280, T |= U.flags & 31457280, U.return = u, U = U.sibling;
                else for(U = u.child; U !== null;)y |= U.lanes | U.childLanes, T |= U.subtreeFlags, T |= U.flags, U.return = u, U = U.sibling;
                return u.subtreeFlags |= T, u.childLanes = y, h;
            }
            function H0(u, h, y) {
                var T = h.pendingProps;
                switch(oe(h), h.tag){
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return ri(h), null;
                    case 1:
                        return ri(h), null;
                    case 3:
                        return y = h.stateNode, T = null, u !== null && (T = u.memoizedState.cache), h.memoizedState.cache !== T && (h.flags |= 2048), to(Bn), de(), y.pendingContext && (y.context = y.pendingContext, y.pendingContext = null), (u === null || u.child === null) && (Ne(h) ? cr(h) : u === null || u.memoizedState.isDehydrated && (h.flags & 256) === 0 || (h.flags |= 1024, vr !== null && (io(vr), vr = null))), Dc(u, h), ri(h), null;
                    case 26:
                        if (pr) {
                            y = h.type;
                            var U = h.memoizedState;
                            return u === null ? (cr(h), U !== null ? (ri(h), lp(h, U)) : (ri(h), Uc(h, y, T))) : U ? U !== u.memoizedState ? (cr(h), ri(h), lp(h, U)) : (ri(h), h.flags &= -16777217) : (ra ? u.memoizedProps !== T && cr(h) : op(u, h, y, T), ri(h), Uc(h, y, T)), null;
                        }
                    case 27:
                        if (sa) {
                            if (le(h), y = ds.current, U = h.type, u !== null && h.stateNode != null) ra ? u.memoizedProps !== T && cr(h) : op(u, h, U, T);
                            else {
                                if (!T) {
                                    if (h.stateNode === null) throw Error(i(166));
                                    return ri(h), null;
                                }
                                u = Ji.current, Ne(h) ? Le(h, u) : (u = em(U, T, y, u, !0), h.stateNode = u, cr(h));
                            }
                            return ri(h), null;
                        }
                    case 5:
                        if (le(h), y = h.type, u !== null && h.stateNode != null) op(u, h, y, T);
                        else {
                            if (!T) {
                                if (h.stateNode === null) throw Error(i(166));
                                return ri(h), null;
                            }
                            u = Ji.current, Ne(h) ? Le(h, u) : (U = wp(y, T, ds.current, u, h), ah(U, h, !1, !1), h.stateNode = U, uo(U, y, T, u) && cr(h));
                        }
                        return ri(h), Uc(h, h.type, h.pendingProps), null;
                    case 6:
                        if (u && h.stateNode != null) y = u.memoizedProps, ra ? y !== T && cr(h) : hr && (y !== T ? (h.stateNode = bh(T, ds.current, Ji.current, h), cr(h)) : h.stateNode = u.stateNode);
                        else {
                            if (typeof T != "string" && h.stateNode === null) throw Error(i(166));
                            if (u = ds.current, y = Ji.current, Ne(h)) {
                                if (!Oa) throw Error(i(176));
                                if (u = h.stateNode, y = h.memoizedProps, T = null, U = ya, U !== null) switch(U.tag){
                                    case 27:
                                    case 5:
                                        T = U.memoizedProps;
                                }
                                fg(u, y, h, T) || xe(h);
                            } else h.stateNode = bh(T, u, y, h);
                        }
                        return ri(h), null;
                    case 13:
                        if (T = h.memoizedState, u === null || u.memoizedState !== null && u.memoizedState.dehydrated !== null) {
                            if (U = Ne(h), T !== null && T.dehydrated !== null) {
                                if (u === null) {
                                    if (!U) throw Error(i(318));
                                    if (!Oa) throw Error(i(344));
                                    if (U = h.memoizedState, U = U !== null ? U.dehydrated : null, !U) throw Error(i(317));
                                    Xc(U, h);
                                } else ke(), (h.flags & 128) === 0 && (h.memoizedState = null), h.flags |= 4;
                                ri(h), U = !1;
                            } else vr !== null && (io(vr), vr = null), U = !0;
                            if (!U) return h.flags & 256 ? (hi(h), h) : (hi(h), null);
                        }
                        if (hi(h), (h.flags & 128) !== 0) return h.lanes = y, h;
                        if (y = T !== null, u = u !== null && u.memoizedState !== null, y) {
                            T = h.child, U = null, T.alternate !== null && T.alternate.memoizedState !== null && T.alternate.memoizedState.cachePool !== null && (U = T.alternate.memoizedState.cachePool.pool);
                            var B = null;
                            T.memoizedState !== null && T.memoizedState.cachePool !== null && (B = T.memoizedState.cachePool.pool), B !== U && (T.flags |= 2048);
                        }
                        return y !== u && y && (h.child.flags |= 8192), Bu(h, h.updateQueue), ri(h), null;
                    case 4:
                        return de(), Dc(u, h), u === null && Dp(h.stateNode.containerInfo), ri(h), null;
                    case 10:
                        return to(h.type), ri(h), null;
                    case 19:
                        if (b(Fi), U = h.memoizedState, U === null) return ri(h), null;
                        if (T = (h.flags & 128) !== 0, B = U.rendering, B === null) {
                            if (T) Bl(U, !1);
                            else {
                                if (En !== 0 || u !== null && (u.flags & 128) !== 0) for(u = h.child; u !== null;){
                                    if (B = Nn(u), B !== null) {
                                        for(h.flags |= 128, Bl(U, !1), u = B.updateQueue, h.updateQueue = u, Bu(h, u), h.subtreeFlags = 0, u = y, y = h.child; y !== null;)oo(y, u), y = y.sibling;
                                        return C(Fi, Fi.current & 1 | 2), h.child;
                                    }
                                    u = u.sibling;
                                }
                                U.tail !== null && oa() > pi && (h.flags |= 128, T = !0, Bl(U, !1), h.lanes = 4194304);
                            }
                        } else {
                            if (!T) {
                                if (u = Nn(B), u !== null) {
                                    if (h.flags |= 128, T = !0, u = u.updateQueue, h.updateQueue = u, Bu(h, u), Bl(U, !0), U.tail === null && U.tailMode === "hidden" && !B.alternate && !An) return ri(h), null;
                                } else 2 * oa() - U.renderingStartTime > pi && y !== 536870912 && (h.flags |= 128, T = !0, Bl(U, !1), h.lanes = 4194304);
                            }
                            U.isBackwards ? (B.sibling = h.child, h.child = B) : (u = U.last, u !== null ? u.sibling = B : h.child = B, U.last = B);
                        }
                        return U.tail !== null ? (h = U.tail, U.rendering = h, U.tail = h.sibling, U.renderingStartTime = oa(), h.sibling = null, u = Fi.current, C(Fi, T ? u & 1 | 2 : u & 1), h) : (ri(h), null);
                    case 22:
                    case 23:
                        return hi(h), da(), T = h.memoizedState !== null, u !== null ? u.memoizedState !== null !== T && (h.flags |= 8192) : T && (h.flags |= 8192), T ? (y & 536870912) !== 0 && (h.flags & 128) === 0 && (ri(h), h.subtreeFlags & 6 && (h.flags |= 8192)) : ri(h), y = h.updateQueue, y !== null && Bu(h, y.retryQueue), y = null, u !== null && u.memoizedState !== null && u.memoizedState.cachePool !== null && (y = u.memoizedState.cachePool.pool), T = null, h.memoizedState !== null && h.memoizedState.cachePool !== null && (T = h.memoizedState.cachePool.pool), T !== y && (h.flags |= 2048), u !== null && b(vo), null;
                    case 24:
                        return y = null, u !== null && (y = u.memoizedState.cache), h.memoizedState.cache !== y && (h.flags |= 2048), to(Bn), ri(h), null;
                    case 25:
                        return null;
                }
                throw Error(i(156, h.tag));
            }
            function V0(u, h) {
                switch(oe(h), h.tag){
                    case 1:
                        return u = h.flags, u & 65536 ? (h.flags = u & -65537 | 128, h) : null;
                    case 3:
                        return to(Bn), de(), u = h.flags, (u & 65536) !== 0 && (u & 128) === 0 ? (h.flags = u & -65537 | 128, h) : null;
                    case 26:
                    case 27:
                    case 5:
                        return le(h), null;
                    case 13:
                        if (hi(h), u = h.memoizedState, u !== null && u.dehydrated !== null) {
                            if (h.alternate === null) throw Error(i(340));
                            ke();
                        }
                        return u = h.flags, u & 65536 ? (h.flags = u & -65537 | 128, h) : null;
                    case 19:
                        return b(Fi), null;
                    case 4:
                        return de(), null;
                    case 10:
                        return to(h.type), null;
                    case 22:
                    case 23:
                        return hi(h), da(), u !== null && b(vo), u = h.flags, u & 65536 ? (h.flags = u & -65537 | 128, h) : null;
                    case 24:
                        return to(Bn), null;
                    case 25:
                        return null;
                    default:
                        return null;
                }
            }
            function cp(u, h) {
                switch(oe(h), h.tag){
                    case 3:
                        to(Bn), de();
                        break;
                    case 26:
                    case 27:
                    case 5:
                        le(h);
                        break;
                    case 4:
                        de();
                        break;
                    case 13:
                        hi(h);
                        break;
                    case 19:
                        b(Fi);
                        break;
                    case 10:
                        to(h.type);
                        break;
                    case 22:
                    case 23:
                        hi(h), da(), u !== null && b(vo);
                        break;
                    case 24:
                        to(Bn);
                }
            }
            function Iu(u, h) {
                try {
                    var y = h.updateQueue, T = y !== null ? y.lastEffect : null;
                    if (T !== null) {
                        var U = T.next;
                        y = U;
                        do {
                            if ((y.tag & u) === u) {
                                T = void 0;
                                var B = y.create, se = y.inst;
                                T = B(), se.destroy = T;
                            }
                            y = y.next;
                        }while (y !== U);
                    }
                } catch (me) {
                    vn(h, h.return, me);
                }
            }
            function Vo(u, h, y) {
                try {
                    var T = h.updateQueue, U = T !== null ? T.lastEffect : null;
                    if (U !== null) {
                        var B = U.next;
                        T = B;
                        do {
                            if ((T.tag & u) === u) {
                                var se = T.inst, me = se.destroy;
                                if (me !== void 0) {
                                    se.destroy = void 0, U = h;
                                    var De = y;
                                    try {
                                        me();
                                    } catch (it) {
                                        vn(U, De, it);
                                    }
                                }
                            }
                            T = T.next;
                        }while (T !== B);
                    }
                } catch (it) {
                    vn(h, h.return, it);
                }
            }
            function G0(u) {
                var h = u.updateQueue;
                if (h !== null) {
                    var y = u.stateNode;
                    try {
                        We(h, y);
                    } catch (T) {
                        vn(u, u.return, T);
                    }
                }
            }
            function k0(u, h, y) {
                y.props = Ra(u.type, u.memoizedProps), y.state = u.memoizedState;
                try {
                    y.componentWillUnmount();
                } catch (T) {
                    vn(u, h, T);
                }
            }
            function Il(u, h) {
                try {
                    var y = u.ref;
                    if (y !== null) {
                        var T = u.stateNode;
                        switch(u.tag){
                            case 26:
                            case 27:
                            case 5:
                                var U = jc(T);
                                break;
                            default:
                                U = T;
                        }
                        typeof y == "function" ? u.refCleanup = y(U) : y.current = U;
                    }
                } catch (B) {
                    vn(u, h, B);
                }
            }
            function si(u, h) {
                var y = u.ref, T = u.refCleanup;
                if (y !== null) {
                    if (typeof T == "function") try {
                        T();
                    } catch (U) {
                        vn(u, h, U);
                    } finally{
                        u.refCleanup = null, u = u.alternate, u != null && (u.refCleanup = null);
                    }
                    else if (typeof y == "function") try {
                        y(null);
                    } catch (U) {
                        vn(u, h, U);
                    }
                    else y.current = null;
                }
            }
            function Nc(u) {
                var h = u.type, y = u.memoizedProps, T = u.stateNode;
                try {
                    ky(T, h, y, u);
                } catch (U) {
                    vn(u, u.return, U);
                }
            }
            function up(u, h, y) {
                try {
                    Lp(u.stateNode, u.type, y, h, u);
                } catch (T) {
                    vn(u, u.return, T);
                }
            }
            function fp(u) {
                return u.tag === 5 || u.tag === 3 || (pr ? u.tag === 26 : !1) || (sa ? u.tag === 27 : !1) || u.tag === 4;
            }
            function rh(u) {
                e: for(;;){
                    for(; u.sibling === null;){
                        if (u.return === null || fp(u.return)) return null;
                        u = u.return;
                    }
                    for(u.sibling.return = u.return, u = u.sibling; u.tag !== 5 && u.tag !== 6 && (!sa || u.tag !== 27) && u.tag !== 18;){
                        if (u.flags & 2 || u.child === null || u.tag === 4) continue e;
                        u.child.return = u, u = u.child;
                    }
                    if (!(u.flags & 2)) return u.stateNode;
                }
            }
            function sh(u, h, y) {
                var T = u.tag;
                if (T === 5 || T === 6) u = u.stateNode, h ? Pp(y, u, h) : eg(y, u);
                else if (!(T === 4 || sa && T === 27) && (u = u.child, u !== null)) for(sh(u, h, y), u = u.sibling; u !== null;)sh(u, h, y), u = u.sibling;
            }
            function Oc(u, h, y) {
                var T = u.tag;
                if (T === 5 || T === 6) u = u.stateNode, h ? zp(y, u, h) : Op(y, u);
                else if (!(T === 4 || sa && T === 27) && (u = u.child, u !== null)) for(Oc(u, h, y), u = u.sibling; u !== null;)Oc(u, h, y), u = u.sibling;
            }
            function j0(u, h, y) {
                u = u.containerInfo;
                try {
                    Hp(u, y);
                } catch (T) {
                    vn(h, h.return, T);
                }
            }
            function Lc(u, h) {
                for(tl(u.containerInfo), Mi = h; Mi !== null;)if (u = Mi, h = u.child, (u.subtreeFlags & 1028) !== 0 && h !== null) h.return = u, Mi = h;
                else for(; Mi !== null;){
                    u = Mi;
                    var y = u.alternate;
                    switch(h = u.flags, u.tag){
                        case 0:
                            break;
                        case 11:
                        case 15:
                            break;
                        case 1:
                            if ((h & 1024) !== 0 && y !== null) {
                                h = void 0;
                                var T = u, U = y.memoizedProps;
                                y = y.memoizedState;
                                var B = T.stateNode;
                                try {
                                    var se = Ra(T.type, U, T.elementType === T.type);
                                    h = B.getSnapshotBeforeUpdate(se, y), B.__reactInternalSnapshotBeforeUpdate = h;
                                } catch (me) {
                                    vn(T, T.return, me);
                                }
                            }
                            break;
                        case 3:
                            (h & 1024) !== 0 && ra && Ah(u.stateNode.containerInfo);
                            break;
                        case 5:
                        case 26:
                        case 27:
                        case 6:
                        case 4:
                        case 17:
                            break;
                        default:
                            if ((h & 1024) !== 0) throw Error(i(163));
                    }
                    if (h = u.sibling, h !== null) {
                        h.return = u.return, Mi = h;
                        break;
                    }
                    Mi = u.return;
                }
                return se = $l, $l = !1, se;
            }
            function oh(u, h, y) {
                var T = y.flags;
                switch(y.tag){
                    case 0:
                    case 11:
                    case 15:
                        ws(u, y), T & 4 && Iu(5, y);
                        break;
                    case 1:
                        if (ws(u, y), T & 4) {
                            if (u = y.stateNode, h === null) try {
                                u.componentDidMount();
                            } catch (me) {
                                vn(y, y.return, me);
                            }
                            else {
                                var U = Ra(y.type, h.memoizedProps);
                                h = h.memoizedState;
                                try {
                                    u.componentDidUpdate(U, h, u.__reactInternalSnapshotBeforeUpdate);
                                } catch (me) {
                                    vn(y, y.return, me);
                                }
                            }
                        }
                        T & 64 && G0(y), T & 512 && Il(y, y.return);
                        break;
                    case 3:
                        if (ws(u, y), T & 64 && (T = y.updateQueue, T !== null)) {
                            if (u = null, y.child !== null) switch(y.child.tag){
                                case 27:
                                case 5:
                                    u = jc(y.child.stateNode);
                                    break;
                                case 1:
                                    u = y.child.stateNode;
                            }
                            try {
                                We(T, u);
                            } catch (me) {
                                vn(y, y.return, me);
                            }
                        }
                        break;
                    case 26:
                        if (pr) {
                            ws(u, y), T & 512 && Il(y, y.return);
                            break;
                        }
                    case 27:
                    case 5:
                        ws(u, y), h === null && T & 4 && Nc(y), T & 512 && Il(y, y.return);
                        break;
                    case 12:
                        ws(u, y);
                        break;
                    case 13:
                        ws(u, y), T & 4 && Go(u, y);
                        break;
                    case 22:
                        if (U = y.memoizedState !== null || Xi, !U) {
                            h = h !== null && h.memoizedState !== null || di;
                            var B = Xi, se = di;
                            Xi = U, (di = h) && !se ? jo(u, y, (y.subtreeFlags & 8772) !== 0) : ws(u, y), Xi = B, di = se;
                        }
                        T & 512 && (y.memoizedProps.mode === "manual" ? Il(y, y.return) : si(y, y.return));
                        break;
                    default:
                        ws(u, y);
                }
            }
            function zc(u) {
                var h = u.alternate;
                h !== null && (u.alternate = null, zc(h)), u.child = null, u.deletions = null, u.sibling = null, u.tag === 5 && (h = u.stateNode, h !== null && Up(h)), u.stateNode = null, u.return = null, u.dependencies = null, u.memoizedProps = null, u.memoizedState = null, u.pendingProps = null, u.stateNode = null, u.updateQueue = null;
            }
            function ur(u, h, y) {
                for(y = y.child; y !== null;)lh(u, h, y), y = y.sibling;
            }
            function lh(u, h, y) {
                if (Wa && typeof Wa.onCommitFiberUnmount == "function") try {
                    Wa.onCommitFiberUnmount(Zc, y);
                } catch  {}
                switch(y.tag){
                    case 26:
                        if (pr) {
                            di || si(y, h), ur(u, h, y), y.memoizedState ? qp(y.memoizedState) : y.stateNode && Qp(y.stateNode);
                            break;
                        }
                    case 27:
                        if (sa) {
                            di || si(y, h);
                            var T = Ci, U = Za;
                            Ci = y.stateNode, ur(u, h, y), vg(y.stateNode), Ci = T, Za = U;
                            break;
                        }
                    case 5:
                        di || si(y, h);
                    case 6:
                        if (ra) {
                            if (T = Ci, U = Za, Ci = null, ur(u, h, y), Ci = T, Za = U, Ci !== null) {
                                if (Za) try {
                                    Ti(Ci, y.stateNode);
                                } catch (B) {
                                    vn(y, h, B);
                                }
                                else try {
                                    La(Ci, y.stateNode);
                                } catch (B) {
                                    vn(y, h, B);
                                }
                            }
                        } else ur(u, h, y);
                        break;
                    case 18:
                        ra && Ci !== null && (Za ? jp(Ci, y.stateNode) : dg(Ci, y.stateNode));
                        break;
                    case 4:
                        ra ? (T = Ci, U = Za, Ci = y.stateNode.containerInfo, Za = !0, ur(u, h, y), Ci = T, Za = U) : (hr && j0(y.stateNode, y, wh()), ur(u, h, y));
                        break;
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        di || Vo(2, y, h), di || Vo(4, y, h), ur(u, h, y);
                        break;
                    case 1:
                        di || (si(y, h), T = y.stateNode, typeof T.componentWillUnmount == "function" && k0(y, h, T)), ur(u, h, y);
                        break;
                    case 21:
                        ur(u, h, y);
                        break;
                    case 22:
                        di || si(y, h), di = (T = di) || y.memoizedState !== null, ur(u, h, y), di = T;
                        break;
                    default:
                        ur(u, h, y);
                }
            }
            function Go(u, h) {
                if (Oa && h.memoizedState === null && (u = h.alternate, u !== null && (u = u.memoizedState, u !== null && (u = u.dehydrated, u !== null)))) try {
                    Uh(u);
                } catch (y) {
                    vn(h, h.return, y);
                }
            }
            function Pc(u) {
                switch(u.tag){
                    case 13:
                    case 19:
                        var h = u.stateNode;
                        return h === null && (h = u.stateNode = new tu), h;
                    case 22:
                        return u = u.stateNode, h = u._retryCache, h === null && (h = u._retryCache = new tu), h;
                    default:
                        throw Error(i(435, u.tag));
                }
            }
            function Fu(u, h) {
                var y = Pc(u);
                h.forEach(function(T) {
                    var U = gp.bind(null, u, T);
                    y.has(T) || (y.add(T), T.then(U, U));
                });
            }
            function Da(u, h) {
                var y = h.deletions;
                if (y !== null) for(var T = 0; T < y.length; T++){
                    var U = y[T], B = u, se = h;
                    if (ra) {
                        var me = se;
                        e: for(; me !== null;){
                            switch(me.tag){
                                case 27:
                                case 5:
                                    Ci = me.stateNode, Za = !1;
                                    break e;
                                case 3:
                                    Ci = me.stateNode.containerInfo, Za = !0;
                                    break e;
                                case 4:
                                    Ci = me.stateNode.containerInfo, Za = !0;
                                    break e;
                            }
                            me = me.return;
                        }
                        if (Ci === null) throw Error(i(160));
                        lh(B, se, U), Ci = null, Za = !1;
                    } else lh(B, se, U);
                    B = U.alternate, B !== null && (B.return = null), U.return = null;
                }
                if (h.subtreeFlags & 13878) for(h = h.child; h !== null;)ko(h, u), h = h.sibling;
            }
            function ko(u, h) {
                var y = u.alternate, T = u.flags;
                switch(u.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Da(h, u), Va(u), T & 4 && (Vo(3, u, u.return), Iu(3, u), Vo(5, u, u.return));
                        break;
                    case 1:
                        Da(h, u), Va(u), T & 512 && (di || y === null || si(y, y.return)), T & 64 && Xi && (u = u.updateQueue, u !== null && (T = u.callbacks, T !== null && (y = u.shared.hiddenCallbacks, u.shared.hiddenCallbacks = y === null ? T : y.concat(T))));
                        break;
                    case 26:
                        if (pr) {
                            var U = za;
                            Da(h, u), Va(u), T & 512 && (di || y === null || si(y, y.return)), T & 4 && (T = y !== null ? y.memoizedState : null, h = u.memoizedState, y === null ? h === null ? u.stateNode === null ? u.stateNode = Yp(U, u.type, u.memoizedProps, u) : Zp(U, u.type, u.stateNode) : u.stateNode = Wp(U, h, u.memoizedProps) : T !== h ? (T === null ? y.stateNode !== null && Qp(y.stateNode) : qp(T), h === null ? Zp(U, u.type, u.stateNode) : Wp(U, h, u.memoizedProps)) : h === null && u.stateNode !== null && up(u, u.memoizedProps, y.memoizedProps));
                            break;
                        }
                    case 27:
                        if (sa && T & 4 && u.alternate === null) {
                            U = u.stateNode;
                            var B = u.memoizedProps;
                            try {
                                qy(U), Yy(u.type, B, U, u);
                            } catch (mt) {
                                vn(u, u.return, mt);
                            }
                        }
                    case 5:
                        if (Da(h, u), Va(u), T & 512 && (di || y === null || si(y, y.return)), ra) {
                            if (u.flags & 32) {
                                h = u.stateNode;
                                try {
                                    Ju(h);
                                } catch (mt) {
                                    vn(u, u.return, mt);
                                }
                            }
                            T & 4 && u.stateNode != null && (h = u.memoizedProps, up(u, h, y !== null ? y.memoizedProps : h)), T & 1024 && (ul = !0);
                        }
                        break;
                    case 6:
                        if (Da(h, u), Va(u), T & 4 && ra) {
                            if (u.stateNode === null) throw Error(i(162));
                            T = u.memoizedProps, y = y !== null ? y.memoizedProps : T, h = u.stateNode;
                            try {
                                tg(h, y, T);
                            } catch (mt) {
                                vn(u, u.return, mt);
                            }
                        }
                        break;
                    case 3:
                        if (pr ? (Kp(), U = za, za = Nh(h.containerInfo), Da(h, u), za = U) : Da(h, u), Va(u), T & 4) {
                            if (ra && Oa && y !== null && y.memoizedState.isDehydrated) try {
                                Dh(h.containerInfo);
                            } catch (mt) {
                                vn(u, u.return, mt);
                            }
                            if (hr) {
                                T = h.containerInfo, y = h.pendingChildren;
                                try {
                                    Hp(T, y);
                                } catch (mt) {
                                    vn(u, u.return, mt);
                                }
                            }
                        }
                        ul && (ul = !1, hp(u));
                        break;
                    case 4:
                        pr ? (y = za, za = Nh(u.stateNode.containerInfo), Da(h, u), Va(u), za = y) : (Da(h, u), Va(u)), T & 4 && hr && j0(u.stateNode, u, u.stateNode.pendingChildren);
                        break;
                    case 12:
                        Da(h, u), Va(u);
                        break;
                    case 13:
                        Da(h, u), Va(u), u.child.flags & 8192 && u.memoizedState !== null != (y !== null && y.memoizedState !== null) && (Vs = oa()), T & 4 && (T = u.updateQueue, T !== null && (u.updateQueue = null, Fu(u, T)));
                        break;
                    case 22:
                        T & 512 && (di || y === null || si(y, y.return)), U = u.memoizedState !== null;
                        var se = y !== null && y.memoizedState !== null, me = Xi, De = di;
                        if (Xi = me || U, di = De || se, Da(h, u), di = De, Xi = me, Va(u), h = u.stateNode, h._current = u, h._visibility &= -3, h._visibility |= h._pendingVisibility & 2, T & 8192 && (h._visibility = U ? h._visibility & -2 : h._visibility | 1, U && (h = Xi || di, y === null || se || h || Bc(u)), ra && (u.memoizedProps === null || u.memoizedProps.mode !== "manual"))) {
                            e: if (y = null, ra) for(h = u;;){
                                if (h.tag === 5 || pr && h.tag === 26 || sa && h.tag === 27) {
                                    if (y === null) {
                                        se = y = h;
                                        try {
                                            B = se.stateNode, U ? $u(B) : Bp(se.stateNode, se.memoizedProps);
                                        } catch (mt) {
                                            vn(se, se.return, mt);
                                        }
                                    }
                                } else if (h.tag === 6) {
                                    if (y === null) {
                                        se = h;
                                        try {
                                            var it = se.stateNode;
                                            U ? Th(it) : ho(it, se.memoizedProps);
                                        } catch (mt) {
                                            vn(se, se.return, mt);
                                        }
                                    }
                                } else if ((h.tag !== 22 && h.tag !== 23 || h.memoizedState === null || h === u) && h.child !== null) {
                                    h.child.return = h, h = h.child;
                                    continue;
                                }
                                if (h === u) break e;
                                for(; h.sibling === null;){
                                    if (h.return === null || h.return === u) break e;
                                    y === h && (y = null), h = h.return;
                                }
                                y === h && (y = null), h.sibling.return = h.return, h = h.sibling;
                            }
                        }
                        T & 4 && (T = u.updateQueue, T !== null && (y = T.retryQueue, y !== null && (T.retryQueue = null, Fu(u, y))));
                        break;
                    case 19:
                        Da(h, u), Va(u), T & 4 && (T = u.updateQueue, T !== null && (u.updateQueue = null, Fu(u, T)));
                        break;
                    case 21:
                        break;
                    default:
                        Da(h, u), Va(u);
                }
            }
            function Va(u) {
                var h = u.flags;
                if (h & 2) {
                    try {
                        if (ra && (!sa || u.tag !== 27)) {
                            e: {
                                for(var y = u.return; y !== null;){
                                    if (fp(y)) {
                                        var T = y;
                                        break e;
                                    }
                                    y = y.return;
                                }
                                throw Error(i(160));
                            }
                            switch(T.tag){
                                case 27:
                                    if (sa) {
                                        var U = T.stateNode, B = rh(u);
                                        Oc(u, B, U);
                                        break;
                                    }
                                case 5:
                                    var se = T.stateNode;
                                    T.flags & 32 && (Ju(se), T.flags &= -33);
                                    var me = rh(u);
                                    Oc(u, me, se);
                                    break;
                                case 3:
                                case 4:
                                    var De = T.stateNode.containerInfo, it = rh(u);
                                    sh(u, it, De);
                                    break;
                                default:
                                    throw Error(i(161));
                            }
                        }
                    } catch (mt) {
                        vn(u, u.return, mt);
                    }
                    u.flags &= -3;
                }
                h & 4096 && (u.flags &= -4097);
            }
            function hp(u) {
                if (u.subtreeFlags & 1024) for(u = u.child; u !== null;){
                    var h = u;
                    hp(h), h.tag === 5 && h.flags & 1024 && Xn(h.stateNode), u = u.sibling;
                }
            }
            function ws(u, h) {
                if (h.subtreeFlags & 8772) for(h = h.child; h !== null;)oh(u, h.alternate, h), h = h.sibling;
            }
            function Bc(u) {
                for(u = u.child; u !== null;){
                    var h = u;
                    switch(h.tag){
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            Vo(4, h, h.return), Bc(h);
                            break;
                        case 1:
                            si(h, h.return);
                            var y = h.stateNode;
                            typeof y.componentWillUnmount == "function" && k0(h, h.return, y), Bc(h);
                            break;
                        case 26:
                        case 27:
                        case 5:
                            si(h, h.return), Bc(h);
                            break;
                        case 22:
                            si(h, h.return), h.memoizedState === null && Bc(h);
                            break;
                        default:
                            Bc(h);
                    }
                    u = u.sibling;
                }
            }
            function jo(u, h, y) {
                for(y = y && (h.subtreeFlags & 8772) !== 0, h = h.child; h !== null;){
                    var T = h.alternate, U = u, B = h, se = B.flags;
                    switch(B.tag){
                        case 0:
                        case 11:
                        case 15:
                            jo(U, B, y), Iu(4, B);
                            break;
                        case 1:
                            if (jo(U, B, y), T = B, U = T.stateNode, typeof U.componentDidMount == "function") try {
                                U.componentDidMount();
                            } catch (it) {
                                vn(T, T.return, it);
                            }
                            if (T = B, U = T.updateQueue, U !== null) {
                                var me = T.stateNode;
                                try {
                                    var De = U.shared.hiddenCallbacks;
                                    if (De !== null) for(U.shared.hiddenCallbacks = null, U = 0; U < De.length; U++)fe(De[U], me);
                                } catch (it) {
                                    vn(T, T.return, it);
                                }
                            }
                            y && se & 64 && G0(B), Il(B, B.return);
                            break;
                        case 26:
                        case 27:
                        case 5:
                            jo(U, B, y), y && T === null && se & 4 && Nc(B), Il(B, B.return);
                            break;
                        case 12:
                            jo(U, B, y);
                            break;
                        case 13:
                            jo(U, B, y), y && se & 4 && Go(U, B);
                            break;
                        case 22:
                            B.memoizedState === null && jo(U, B, y), Il(B, B.return);
                            break;
                        default:
                            jo(U, B, y);
                    }
                    h = h.sibling;
                }
            }
            function dp(u, h) {
                var y = null;
                u !== null && u.memoizedState !== null && u.memoizedState.cachePool !== null && (y = u.memoizedState.cachePool.pool), u = null, h.memoizedState !== null && h.memoizedState.cachePool !== null && (u = h.memoizedState.cachePool.pool), u !== y && (u != null && u.refCount++, y != null && Cc(y));
            }
            function ch(u, h) {
                u = null, h.alternate !== null && (u = h.alternate.memoizedState.cache), h = h.memoizedState.cache, h !== u && (h.refCount++, u != null && Cc(u));
            }
            function no(u, h, y, T) {
                if (h.subtreeFlags & 10256) for(h = h.child; h !== null;)uh(u, h, y, T), h = h.sibling;
            }
            function uh(u, h, y, T) {
                var U = h.flags;
                switch(h.tag){
                    case 0:
                    case 11:
                    case 15:
                        no(u, h, y, T), U & 2048 && Iu(9, h);
                        break;
                    case 3:
                        no(u, h, y, T), U & 2048 && (u = null, h.alternate !== null && (u = h.alternate.memoizedState.cache), h = h.memoizedState.cache, h !== u && (h.refCount++, u != null && Cc(u)));
                        break;
                    case 12:
                        if (U & 2048) {
                            no(u, h, y, T), u = h.stateNode;
                            try {
                                var B = h.memoizedProps, se = B.id, me = B.onPostCommit;
                                typeof me == "function" && me(se, h.alternate === null ? "mount" : "update", u.passiveEffectDuration, -0);
                            } catch (De) {
                                vn(h, h.return, De);
                            }
                        } else no(u, h, y, T);
                        break;
                    case 23:
                        break;
                    case 22:
                        B = h.stateNode, h.memoizedState !== null ? B._visibility & 4 ? no(u, h, y, T) : Xo(u, h) : B._visibility & 4 ? no(u, h, y, T) : (B._visibility |= 4, ma(u, h, y, T, (h.subtreeFlags & 10256) !== 0)), U & 2048 && dp(h.alternate, h);
                        break;
                    case 24:
                        no(u, h, y, T), U & 2048 && ch(h.alternate, h);
                        break;
                    default:
                        no(u, h, y, T);
                }
            }
            function ma(u, h, y, T, U) {
                for(U = U && (h.subtreeFlags & 10256) !== 0, h = h.child; h !== null;){
                    var B = u, se = h, me = y, De = T, it = se.flags;
                    switch(se.tag){
                        case 0:
                        case 11:
                        case 15:
                            ma(B, se, me, De, U), Iu(8, se);
                            break;
                        case 23:
                            break;
                        case 22:
                            var mt = se.stateNode;
                            se.memoizedState !== null ? mt._visibility & 4 ? ma(B, se, me, De, U) : Xo(B, se) : (mt._visibility |= 4, ma(B, se, me, De, U)), U && it & 2048 && dp(se.alternate, se);
                            break;
                        case 24:
                            ma(B, se, me, De, U), U && it & 2048 && ch(se.alternate, se);
                            break;
                        default:
                            ma(B, se, me, De, U);
                    }
                    h = h.sibling;
                }
            }
            function Xo(u, h) {
                if (h.subtreeFlags & 10256) for(h = h.child; h !== null;){
                    var y = u, T = h, U = T.flags;
                    switch(T.tag){
                        case 22:
                            Xo(y, T), U & 2048 && dp(T.alternate, T);
                            break;
                        case 24:
                            Xo(y, T), U & 2048 && ch(T.alternate, T);
                            break;
                        default:
                            Xo(y, T);
                    }
                    h = h.sibling;
                }
            }
            function Yi(u) {
                if (u.subtreeFlags & ec) for(u = u.child; u !== null;)Fl(u), u = u.sibling;
            }
            function Fl(u) {
                switch(u.tag){
                    case 26:
                        Yi(u), u.flags & ec && (u.memoizedState !== null ? $p(za, u.memoizedState, u.memoizedProps) : vi(u.type, u.memoizedProps));
                        break;
                    case 5:
                        Yi(u), u.flags & ec && vi(u.type, u.memoizedProps);
                        break;
                    case 3:
                    case 4:
                        if (pr) {
                            var h = za;
                            za = Nh(u.stateNode.containerInfo), Yi(u), za = h;
                        } else Yi(u);
                        break;
                    case 22:
                        u.memoizedState === null && (h = u.alternate, h !== null && h.memoizedState !== null ? (h = ec, ec = 16777216, Yi(u), ec = h) : Yi(u));
                        break;
                    default:
                        Yi(u);
                }
            }
            function fh(u) {
                var h = u.alternate;
                if (h !== null && (u = h.child, u !== null)) {
                    h.child = null;
                    do h = u.sibling, u.sibling = null, u = h;
                    while (u !== null);
                }
            }
            function Wo(u) {
                var h = u.deletions;
                if ((u.flags & 16) !== 0) {
                    if (h !== null) for(var y = 0; y < h.length; y++){
                        var T = h[y];
                        Mi = T, qo(T, u);
                    }
                    fh(u);
                }
                if (u.subtreeFlags & 10256) for(u = u.child; u !== null;)Hu(u), u = u.sibling;
            }
            function Hu(u) {
                switch(u.tag){
                    case 0:
                    case 11:
                    case 15:
                        Wo(u), u.flags & 2048 && Vo(9, u, u.return);
                        break;
                    case 3:
                        Wo(u);
                        break;
                    case 12:
                        Wo(u);
                        break;
                    case 22:
                        var h = u.stateNode;
                        u.memoizedState !== null && h._visibility & 4 && (u.return === null || u.return.tag !== 13) ? (h._visibility &= -5, Ic(u)) : Wo(u);
                        break;
                    default:
                        Wo(u);
                }
            }
            function Ic(u) {
                var h = u.deletions;
                if ((u.flags & 16) !== 0) {
                    if (h !== null) for(var y = 0; y < h.length; y++){
                        var T = h[y];
                        Mi = T, qo(T, u);
                    }
                    fh(u);
                }
                for(u = u.child; u !== null;){
                    switch(h = u, h.tag){
                        case 0:
                        case 11:
                        case 15:
                            Vo(8, h, h.return), Ic(h);
                            break;
                        case 22:
                            y = h.stateNode, y._visibility & 4 && (y._visibility &= -5, Ic(h));
                            break;
                        default:
                            Ic(h);
                    }
                    u = u.sibling;
                }
            }
            function qo(u, h) {
                for(; Mi !== null;){
                    var y = Mi;
                    switch(y.tag){
                        case 0:
                        case 11:
                        case 15:
                            Vo(8, y, h);
                            break;
                        case 23:
                        case 22:
                            if (y.memoizedState !== null && y.memoizedState.cachePool !== null) {
                                var T = y.memoizedState.cachePool.pool;
                                T != null && T.refCount++;
                            }
                            break;
                        case 24:
                            Cc(y.memoizedState.cache);
                    }
                    if (T = y.child, T !== null) T.return = y, Mi = T;
                    else e: for(y = u; Mi !== null;){
                        T = Mi;
                        var U = T.sibling, B = T.return;
                        if (zc(T), T === y) {
                            Mi = null;
                            break e;
                        }
                        if (U !== null) {
                            U.return = B, Mi = U;
                            break e;
                        }
                        Mi = B;
                    }
                }
            }
            function hh(u) {
                var h = Rp(u);
                if (h != null) {
                    if (typeof h.memoizedProps["data-testname"] != "string") throw Error(i(364));
                    return h;
                }
                if (u = Yl(u), u === null) throw Error(i(362));
                return u.stateNode.current;
            }
            function Fc(u, h) {
                var y = u.tag;
                switch(h.$$typeof){
                    case mf:
                        if (u.type === h.value) return !0;
                        break;
                    case kh:
                        e: {
                            for(h = h.value, u = [
                                u,
                                0
                            ], y = 0; y < u.length;){
                                var T = u[y++], U = T.tag, B = u[y++], se = h[B];
                                if (U !== 5 && U !== 26 && U !== 27 || !Ps(T)) {
                                    for(; se != null && Fc(T, se);)B++, se = h[B];
                                    if (B === h.length) {
                                        h = !0;
                                        break e;
                                    } else for(T = T.child; T !== null;)u.push(T, B), T = T.sibling;
                                }
                            }
                            h = !1;
                        }
                        return h;
                    case jh:
                        if ((y === 5 || y === 26 || y === 27) && Gy(u.stateNode, h.value)) return !0;
                        break;
                    case In:
                        if ((y === 5 || y === 6 || y === 26 || y === 27) && (u = Ku(u), u !== null && 0 <= u.indexOf(h.value))) return !0;
                        break;
                    case Mn:
                        if ((y === 5 || y === 26 || y === 27) && (u = u.memoizedProps["data-testname"], typeof u == "string" && u.toLowerCase() === h.value.toLowerCase())) return !0;
                        break;
                    default:
                        throw Error(i(365));
                }
                return !1;
            }
            function Yo(u) {
                switch(u.$$typeof){
                    case mf:
                        return "<" + (l(u.value) || "Unknown") + ">";
                    case kh:
                        return ":has(" + (Yo(u) || "") + ")";
                    case jh:
                        return '[role="' + u.value + '"]';
                    case In:
                        return '"' + u.value + '"';
                    case Mn:
                        return '[data-testname="' + u.value + '"]';
                    default:
                        throw Error(i(365));
                }
            }
            function X0(u, h) {
                var y = [];
                u = [
                    u,
                    0
                ];
                for(var T = 0; T < u.length;){
                    var U = u[T++], B = U.tag, se = u[T++], me = h[se];
                    if (B !== 5 && B !== 26 && B !== 27 || !Ps(U)) {
                        for(; me != null && Fc(U, me);)se++, me = h[se];
                        if (se === h.length) y.push(U);
                        else for(U = U.child; U !== null;)u.push(U, se), U = U.sibling;
                    }
                }
                return y;
            }
            function Ua(u, h) {
                if (!zs) throw Error(i(363));
                u = hh(u), u = X0(u, h), h = [], u = Array.from(u);
                for(var y = 0; y < u.length;){
                    var T = u[y++], U = T.tag;
                    if (U === 5 || U === 26 || U === 27) Ps(T) || h.push(T.stateNode);
                    else for(T = T.child; T !== null;)u.push(T), T = T.sibling;
                }
                return h;
            }
            function Na() {
                if ((It & 2) !== 0 && cn !== 0) return cn & -cn;
                if (Vt.T !== null) {
                    var u = qa;
                    return u !== 0 ? u : Te();
                }
                return Fr();
            }
            function Cs() {
                Qa === 0 && (Qa = (cn & 536870912) === 0 || An ? H() : 536870912);
                var u = br.current;
                return u !== null && (u.flags |= 32), Qa;
            }
            function ga(u, h, y) {
                (u === dn && Wn === 2 || u.cancelPendingCommit !== null) && (cs(u, 0), ls(u, cn, Qa, !1)), j(u, y), ((It & 2) === 0 || u !== dn) && (u === dn && ((It & 2) === 0 && (gs |= y), En === 4 && ls(u, cn, Qa, !1)), Ze(u));
            }
            function Vu(u, h, y) {
                if ((It & 6) !== 0) throw Error(i(327));
                var T = !y && (h & 60) === 0 && (h & u.expiredLanes) === 0 || L(u, h), U = T ? Us(u, h) : Rs(u, h, !0), B = T;
                do {
                    if (U === 0) {
                        Sr && !T && ls(u, h, 0, !1);
                        break;
                    } else if (U === 6) ls(u, h, 0, !Fn);
                    else {
                        if (y = u.current.alternate, B && !W0(y)) {
                            U = Rs(u, h, !1), B = !1;
                            continue;
                        }
                        if (U === 2) {
                            if (B = h, u.errorRecoveryDisabledLanes & B) var se = 0;
                            else se = u.pendingLanes & -536870913, se = se !== 0 ? se : se & 536870912 ? 536870912 : 0;
                            if (se !== 0) {
                                h = se;
                                e: {
                                    var me = u;
                                    U = nu;
                                    var De = Oa && me.current.memoizedState.isDehydrated;
                                    if (De && (cs(me, se).flags |= 256), se = Rs(me, se, !1), se !== 2) {
                                        if (yo && !De) {
                                            me.errorRecoveryDisabledLanes |= B, gs |= B, U = 4;
                                            break e;
                                        }
                                        B = Er, Er = U, B !== null && io(B);
                                    }
                                    U = se;
                                }
                                if (B = !1, U !== 2) continue;
                            }
                        }
                        if (U === 1) {
                            cs(u, 0), ls(u, h, 0, !0);
                            break;
                        }
                        e: {
                            switch(T = u, U){
                                case 0:
                                case 1:
                                    throw Error(i(345));
                                case 4:
                                    if ((h & 4194176) === h) {
                                        ls(T, h, Qa, !Fn);
                                        break e;
                                    }
                                    break;
                                case 2:
                                    Er = null;
                                    break;
                                case 3:
                                case 5:
                                    break;
                                default:
                                    throw Error(i(329));
                            }
                            if (T.finishedWork = y, T.finishedLanes = h, (h & 62914560) === h && (B = Vs + 300 - oa(), 10 < B)) {
                                if (ls(T, h, Qa, !Fn), z(T, 0) !== 0) break e;
                                T.timeoutHandle = Cp(dh.bind(null, T, y, Er, xs, iu, h, Qa, gs, _o, Fn, 2, -0, 0), B);
                                break e;
                            }
                            dh(T, y, Er, xs, iu, h, Qa, gs, _o, Fn, 0, -0, 0);
                        }
                    }
                    break;
                }while (!0);
                Ze(u);
            }
            function io(u) {
                Er === null ? Er = u : Er.push.apply(Er, u);
            }
            function dh(u, h, y, T, U, B, se, me, De, it, mt, bt, At) {
                var Zt = h.subtreeFlags;
                if ((Zt & 8192 || (Zt & 16785408) === 16785408) && (dr(), Fl(h), h = Sh(), h !== null)) {
                    u.cancelPendingCommit = h(Kn.bind(null, u, y, T, U, se, me, De, 1, bt, At)), ls(u, B, se, !it);
                    return;
                }
                Kn(u, y, T, U, se, me, De, mt, bt, At);
            }
            function W0(u) {
                for(var h = u;;){
                    var y = h.tag;
                    if ((y === 0 || y === 11 || y === 15) && h.flags & 16384 && (y = h.updateQueue, y !== null && (y = y.stores, y !== null))) for(var T = 0; T < y.length; T++){
                        var U = y[T], B = U.getSnapshot;
                        U = U.value;
                        try {
                            if (!mr(B(), U)) return !1;
                        } catch  {
                            return !1;
                        }
                    }
                    if (y = h.child, h.subtreeFlags & 16384 && y !== null) y.return = h, h = y;
                    else {
                        if (h === u) break;
                        for(; h.sibling === null;){
                            if (h.return === null || h.return === u) return !0;
                            h = h.return;
                        }
                        h.sibling.return = h.return, h = h.sibling;
                    }
                }
                return !0;
            }
            function ls(u, h, y, T) {
                h &= ~Sa, h &= ~gs, u.suspendedLanes |= h, u.pingedLanes &= ~h, T && (u.warmLanes |= h), T = u.expirationTimes;
                for(var U = h; 0 < U;){
                    var B = 31 - Xa(U), se = 1 << B;
                    T[B] = -1, U &= ~se;
                }
                y !== 0 && q(u, y, h);
            }
            function pp() {
                return (It & 6) === 0 ? (be(0), !1) : !0;
            }
            function Ga() {
                if (Kt !== null) {
                    if (Wn === 0) var u = Kt.return;
                    else u = Kt, Si = cl = null, Ms(u), Is = null, Gr = 0, u = Kt;
                    for(; u !== null;)cp(u.alternate, u), u = u.return;
                    Kt = null;
                }
            }
            function cs(u, h) {
                u.finishedWork = null, u.finishedLanes = 0;
                var y = u.timeoutHandle;
                y !== ql && (u.timeoutHandle = ql, Qu(y)), y = u.cancelPendingCommit, y !== null && (u.cancelPendingCommit = null, y()), Ga(), dn = u, Kt = y = xa(u.current, null), cn = h, Wn = 0, Ri = null, Fn = !1, Sr = L(u, h), yo = !1, _o = Qa = Sa = gs = Mr = En = 0, Er = nu = null, iu = !1, (h & 8) !== 0 && (h |= h & 32);
                var T = u.entangledLanes;
                if (T !== 0) for(u = u.entanglements, T &= h; 0 < T;){
                    var U = 31 - Xa(T), B = 1 << U;
                    h |= u[U], T &= ~B;
                }
                return ms = h, Re(), y;
            }
            function Hl(u, h) {
                en = null, Vt.H = wn, h === kn ? (h = ft(), Wn = 3) : h === im ? (h = ft(), Wn = 4) : Wn = h === Tg ? 8 : h !== null && typeof h == "object" && typeof h.then == "function" ? 6 : 1, Ri = h, Kt === null && (En = 1, Ts(u, $(h, u.current)));
            }
            function Gu() {
                var u = br.current;
                return u === null ? !0 : (cn & 4194176) === cn ? kr === null : (cn & 62914560) === cn || (cn & 536870912) !== 0 ? u === kr : !1;
            }
            function Hc() {
                var u = Vt.H;
                return Vt.H = wn, u === null ? wn : u;
            }
            function fr() {
                var u = Vt.A;
                return Vt.A = Gh, u;
            }
            function ka() {
                En = 4, Fn || (cn & 4194176) !== cn && br.current !== null || (Sr = !0), (Mr & 134217727) === 0 && (gs & 134217727) === 0 || dn === null || ls(dn, cn, Qa, !1);
            }
            function Rs(u, h, y) {
                var T = It;
                It |= 2;
                var U = Hc(), B = fr();
                (dn !== u || cn !== h) && (xs = null, cs(u, h)), h = !1;
                var se = En;
                e: do try {
                    if (Wn !== 0 && Kt !== null) {
                        var me = Kt, De = Ri;
                        switch(Wn){
                            case 8:
                                Ga(), se = 6;
                                break e;
                            case 3:
                            case 2:
                            case 6:
                                br.current === null && (h = !0);
                                var it = Wn;
                                if (Wn = 0, Ri = null, Zo(u, me, De, it), y && Sr) {
                                    se = 0;
                                    break e;
                                }
                                break;
                            default:
                                it = Wn, Wn = 0, Ri = null, Zo(u, me, De, it);
                        }
                    }
                    Ds(), se = En;
                    break;
                } catch (mt) {
                    Hl(u, mt);
                }
                while (!0);
                return h && u.shellSuspendCounter++, Si = cl = null, It = T, Vt.H = U, Vt.A = B, Kt === null && (dn = null, cn = 0, Re()), se;
            }
            function Ds() {
                for(; Kt !== null;)mp(Kt);
            }
            function Us(u, h) {
                var y = It;
                It |= 2;
                var T = Hc(), U = fr();
                dn !== u || cn !== h ? (xs = null, pi = oa() + 500, cs(u, h)) : Sr = L(u, h);
                e: do try {
                    if (Wn !== 0 && Kt !== null) {
                        h = Kt;
                        var B = Ri;
                        t: switch(Wn){
                            case 1:
                                Wn = 0, Ri = null, Zo(u, h, B, 1);
                                break;
                            case 2:
                                if (ut(B)) {
                                    Wn = 0, Ri = null, ph(h);
                                    break;
                                }
                                h = function() {
                                    Wn === 2 && dn === u && (Wn = 7), Ze(u);
                                }, B.then(h, h);
                                break e;
                            case 3:
                                Wn = 7;
                                break e;
                            case 4:
                                Wn = 5;
                                break e;
                            case 7:
                                ut(B) ? (Wn = 0, Ri = null, ph(h)) : (Wn = 0, Ri = null, Zo(u, h, B, 7));
                                break;
                            case 5:
                                var se = null;
                                switch(Kt.tag){
                                    case 26:
                                        se = Kt.memoizedState;
                                    case 5:
                                    case 27:
                                        var me = Kt, De = me.type, it = me.pendingProps;
                                        if (se ? Jp(se) : fo(De, it)) {
                                            Wn = 0, Ri = null;
                                            var mt = me.sibling;
                                            if (mt !== null) Kt = mt;
                                            else {
                                                var bt = me.return;
                                                bt !== null ? (Kt = bt, ku(bt)) : Kt = null;
                                            }
                                            break t;
                                        }
                                }
                                Wn = 0, Ri = null, Zo(u, h, B, 5);
                                break;
                            case 6:
                                Wn = 0, Ri = null, Zo(u, h, B, 6);
                                break;
                            case 8:
                                Ga(), En = 6;
                                break e;
                            default:
                                throw Error(i(462));
                        }
                    }
                    ao();
                    break;
                } catch (At) {
                    Hl(u, At);
                }
                while (!0);
                return Si = cl = null, Vt.H = T, Vt.A = U, It = y, Kt !== null ? 0 : (dn = null, cn = 0, Re(), En);
            }
            function ao() {
                for(; Kt !== null && !_g();)mp(Kt);
            }
            function mp(u) {
                var h = I0(u.alternate, u, ms);
                u.memoizedProps = u.pendingProps, h === null ? ku(u) : Kt = h;
            }
            function ph(u) {
                var h = u, y = h.alternate;
                switch(h.tag){
                    case 15:
                    case 0:
                        h = Lu(y, h, h.pendingProps, h.type, void 0, cn);
                        break;
                    case 11:
                        h = Lu(y, h, h.pendingProps, h.type.render, h.ref, cn);
                        break;
                    case 5:
                        Ms(h);
                    default:
                        cp(y, h), h = Kt = oo(h, ms), h = I0(y, h, ms);
                }
                u.memoizedProps = u.pendingProps, h === null ? ku(u) : Kt = h;
            }
            function Zo(u, h, y, T) {
                Si = cl = null, Ms(h), Is = null, Gr = 0;
                var U = h.return;
                try {
                    if (eh(u, U, h, y, cn)) {
                        En = 1, Ts(u, $(y, u.current)), Kt = null;
                        return;
                    }
                } catch (B) {
                    if (U !== null) throw Kt = U, B;
                    En = 1, Ts(u, $(y, u.current)), Kt = null;
                    return;
                }
                h.flags & 32768 ? (An || T === 1 ? u = !0 : Sr || (cn & 536870912) !== 0 ? u = !1 : (Fn = u = !0, (T === 2 || T === 3 || T === 6) && (T = br.current, T !== null && T.tag === 13 && (T.flags |= 16384))), Zi(h, u)) : ku(h);
            }
            function ku(u) {
                var h = u;
                do {
                    if ((h.flags & 32768) !== 0) {
                        Zi(h, Fn);
                        return;
                    }
                    u = h.return;
                    var y = H0(h.alternate, h, ms);
                    if (y !== null) {
                        Kt = y;
                        return;
                    }
                    if (h = h.sibling, h !== null) {
                        Kt = h;
                        return;
                    }
                    Kt = h = u;
                }while (h !== null);
                En === 0 && (En = 5);
            }
            function Zi(u, h) {
                do {
                    var y = V0(u.alternate, u);
                    if (y !== null) {
                        y.flags &= 32767, Kt = y;
                        return;
                    }
                    if (y = u.return, y !== null && (y.flags |= 32768, y.subtreeFlags = 0, y.deletions = null), !h && (u = u.sibling, u !== null)) {
                        Kt = u;
                        return;
                    }
                    Kt = u = y;
                }while (u !== null);
                En = 6, Kt = null;
            }
            function Kn(u, h, y, T, U, B, se, me, De, it) {
                var mt = Vt.T, bt = ji();
                try {
                    va(2), Vt.T = null, bn(u, h, y, T, bt, U, B, se, me, De, it);
                } finally{
                    Vt.T = mt, va(bt);
                }
            }
            function bn(u, h, y, T, U, B, se, me) {
                do Qi();
                while (bo !== null);
                if ((It & 6) !== 0) throw Error(i(327));
                var De = u.finishedWork;
                if (T = u.finishedLanes, De === null) return null;
                if (u.finishedWork = null, u.finishedLanes = 0, De === u.current) throw Error(i(177));
                u.callbackNode = null, u.callbackPriority = 0, u.cancelPendingCommit = null;
                var it = De.lanes | De.childLanes;
                if (it |= Kc, G(u, T, it, B, se, me), u === dn && (Kt = dn = null, cn = 0), (De.subtreeFlags & 10256) === 0 && (De.flags & 10256) === 0 || Xr || (Xr = !0, Xh = it, nc = y, ju(Lh, function() {
                    return Qi(), null;
                })), y = (De.flags & 15990) !== 0, (De.subtreeFlags & 15990) !== 0 || y ? (y = Vt.T, Vt.T = null, B = ji(), va(2), se = It, It |= 4, Lc(u, De), ko(De, u), Ap(u.containerInfo), u.current = De, oh(u, De.alternate, De), bg(), It = se, va(B), Vt.T = y) : u.current = De, Xr ? (Xr = !1, bo = u, tc = T) : ro(u, it), it = u.pendingLanes, it === 0 && (Tr = null), F(De.stateNode), Ze(u), h !== null) for(U = u.onRecoverableError, De = 0; De < h.length; De++)it = h[De], U(it.value, {
                    componentStack: it.stack
                });
                return (tc & 3) !== 0 && Qi(), it = u.pendingLanes, (T & 4194218) !== 0 && (it & 42) !== 0 ? u === Pa ? ic++ : (ic = 0, Pa = u) : ic = 0, be(0), null;
            }
            function ro(u, h) {
                (u.pooledCacheLanes &= h) === 0 && (h = u.pooledCache, h != null && (u.pooledCache = null, Cc(h)));
            }
            function Qi() {
                if (bo !== null) {
                    var u = bo, h = Xh;
                    Xh = 0;
                    var y = ae(tc), T = 32 > y ? 32 : y;
                    y = Vt.T;
                    var U = ji();
                    try {
                        if (va(T), Vt.T = null, bo === null) var B = !1;
                        else {
                            T = nc, nc = null;
                            var se = bo, me = tc;
                            if (bo = null, tc = 0, (It & 6) !== 0) throw Error(i(331));
                            var De = It;
                            if (It |= 4, Hu(se.current), uh(se, se.current, me, T), It = De, be(0, !1), Wa && typeof Wa.onPostCommitFiberRoot == "function") try {
                                Wa.onPostCommitFiberRoot(Zc, se);
                            } catch  {}
                            B = !0;
                        }
                        return B;
                    } finally{
                        va(U), Vt.T = y, ro(u, h);
                    }
                }
                return !1;
            }
            function mh(u, h, y) {
                h = $(y, h), h = os(u.stateNode, h, 2), u = Ye(u, h, 2), u !== null && (j(u, 2), Ze(u));
            }
            function vn(u, h, y) {
                if (u.tag === 3) mh(u, u, y);
                else for(; h !== null;){
                    if (h.tag === 3) {
                        mh(h, u, y);
                        break;
                    } else if (h.tag === 1) {
                        var T = h.stateNode;
                        if (typeof h.type.getDerivedStateFromError == "function" || typeof T.componentDidCatch == "function" && (Tr === null || !Tr.has(T))) {
                            u = $(y, u), y = As(2), T = Ye(h, y, 2), T !== null && (ki(y, T, h, u), j(T, 2), Ze(T));
                            break;
                        }
                    }
                    h = h.return;
                }
            }
            function gh(u, h, y) {
                var T = u.pingCache;
                if (T === null) {
                    T = u.pingCache = new yn;
                    var U = new Set;
                    T.set(h, U);
                } else U = T.get(h), U === void 0 && (U = new Set, T.set(h, U));
                U.has(y) || (yo = !0, U.add(y), u = q0.bind(null, u, h, y), h.then(u, u));
            }
            function q0(u, h, y) {
                var T = u.pingCache;
                T !== null && T.delete(h), u.pingedLanes |= u.suspendedLanes & y, u.warmLanes &= ~y, dn === u && (cn & y) === y && (En === 4 || En === 3 && (cn & 62914560) === cn && 300 > oa() - Vs ? (It & 2) === 0 && cs(u, 0) : Sa |= y, _o === cn && (_o = 0)), Ze(u);
            }
            function Vl(u, h) {
                h === 0 && (h = O()), u = Ie(u, h), u !== null && (j(u, h), Ze(u));
            }
            function Gl(u) {
                var h = u.memoizedState, y = 0;
                h !== null && (y = h.retryLane), Vl(u, y);
            }
            function gp(u, h) {
                var y = 0;
                switch(u.tag){
                    case 13:
                        var T = u.stateNode, U = u.memoizedState;
                        U !== null && (y = U.retryLane);
                        break;
                    case 19:
                        T = u.stateNode;
                        break;
                    case 22:
                        T = u.stateNode._retryCache;
                        break;
                    default:
                        throw Error(i(314));
                }
                T !== null && T.delete(h), Vl(u, y);
            }
            function ju(u, h) {
                return Yc(u, h);
            }
            function xp(u, h, y, T) {
                this.tag = u, this.key = y, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = h, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = T, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function so(u) {
                return u = u.prototype, !(!u || !u.isReactComponent);
            }
            function xa(u, h) {
                var y = u.alternate;
                return y === null ? (y = t(u.tag, h, u.key, u.mode), y.elementType = u.elementType, y.type = u.type, y.stateNode = u.stateNode, y.alternate = u, u.alternate = y) : (y.pendingProps = h, y.type = u.type, y.flags = 0, y.subtreeFlags = 0, y.deletions = null), y.flags = u.flags & 31457280, y.childLanes = u.childLanes, y.lanes = u.lanes, y.child = u.child, y.memoizedProps = u.memoizedProps, y.memoizedState = u.memoizedState, y.updateQueue = u.updateQueue, h = u.dependencies, y.dependencies = h === null ? null : {
                    lanes: h.lanes,
                    firstContext: h.firstContext
                }, y.sibling = u.sibling, y.index = u.index, y.ref = u.ref, y.refCleanup = u.refCleanup, y;
            }
            function oo(u, h) {
                u.flags &= 31457282;
                var y = u.alternate;
                return y === null ? (u.childLanes = 0, u.lanes = h, u.child = null, u.subtreeFlags = 0, u.memoizedProps = null, u.memoizedState = null, u.updateQueue = null, u.dependencies = null, u.stateNode = null) : (u.childLanes = y.childLanes, u.lanes = y.lanes, u.child = y.child, u.subtreeFlags = 0, u.deletions = null, u.memoizedProps = y.memoizedProps, u.memoizedState = y.memoizedState, u.updateQueue = y.updateQueue, u.type = y.type, h = y.dependencies, u.dependencies = h === null ? null : {
                    lanes: h.lanes,
                    firstContext: h.firstContext
                }), u;
            }
            function Ir(u, h, y, T, U, B) {
                var se = 0;
                if (T = u, typeof u == "function") so(u) && (se = 1);
                else if (typeof u == "string") se = pr && sa ? Xp(u, y, Ji.current) ? 26 : Wc(u) ? 27 : 5 : pr ? Xp(u, y, Ji.current) ? 26 : 5 : sa && Wc(u) ? 27 : 5;
                else e: switch(u){
                    case Gc:
                        return lo(y.children, U, B, h);
                    case Sp:
                        se = 8, U |= 24;
                        break;
                    case Mp:
                        return u = t(12, y, h, U | 2), u.elementType = Mp, u.lanes = B, u;
                    case vh:
                        return u = t(13, y, h, U), u.elementType = vh, u.lanes = B, u;
                    case Jo:
                        return u = t(19, y, h, U), u.elementType = Jo, u.lanes = B, u;
                    case qu:
                        return xh(y, U, B, h);
                    default:
                        if (typeof u == "object" && u !== null) switch(u.$$typeof){
                            case Q0:
                            case Ns:
                                se = 10;
                                break e;
                            case Ko:
                                se = 9;
                                break e;
                            case kc:
                                se = 11;
                                break e;
                            case Wu:
                                se = 14;
                                break e;
                            case fs:
                                se = 16, T = null;
                                break e;
                        }
                        se = 29, y = Error(i(130, u === null ? "null" : typeof u, "")), T = null;
                }
                return h = t(se, y, h, U), h.elementType = u, h.type = T, h.lanes = B, h;
            }
            function lo(u, h, y, T) {
                return u = t(7, u, T, h), u.lanes = y, u;
            }
            function xh(u, h, y, T) {
                u = t(22, u, T, h), u.elementType = qu, u.lanes = y;
                var U = {
                    _visibility: 1,
                    _pendingVisibility: 1,
                    _pendingMarkers: null,
                    _retryCache: null,
                    _transitions: null,
                    _current: null,
                    detach: function() {
                        var B = U._current;
                        if (B === null) throw Error(i(456));
                        if ((U._pendingVisibility & 2) === 0) {
                            var se = Ie(B, 2);
                            se !== null && (U._pendingVisibility |= 2, ga(se, B, 2));
                        }
                    },
                    attach: function() {
                        var B = U._current;
                        if (B === null) throw Error(i(456));
                        if ((U._pendingVisibility & 2) !== 0) {
                            var se = Ie(B, 2);
                            se !== null && (U._pendingVisibility &= -3, ga(se, B, 2));
                        }
                    }
                };
                return u.stateNode = U, u;
            }
            function Qo(u, h, y) {
                return u = t(6, u, null, h), u.lanes = y, u;
            }
            function Vc(u, h, y) {
                return h = t(4, u.children !== null ? u.children : [], u.key, h), h.lanes = y, h.stateNode = {
                    containerInfo: u.containerInfo,
                    pendingChildren: null,
                    implementation: u.implementation
                }, h;
            }
            function kl(u, h, y, T, U, B, se, me) {
                this.tag = 1, this.containerInfo = u, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = ql, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = D(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = D(0), this.hiddenUpdates = D(null), this.identifierPrefix = T, this.onUncaughtError = U, this.onCaughtError = B, this.onRecoverableError = se, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = me, this.incompleteTransitions = new Map;
            }
            function Ki(u, h, y, T, U, B, se, me, De, it, mt, bt) {
                return u = new kl(u, h, y, se, me, De, it, bt), h = 1, B === !0 && (h |= 24), B = t(3, null, null, h), u.current = B, B.stateNode = u, h = nh(), h.refCount++, u.pooledCache = h, h.refCount++, B.memoizedState = {
                    element: T,
                    isDehydrated: y,
                    cache: h
                }, gt(B), u;
            }
            function Xu(u) {
                return u ? (u = Zl, u) : Zl;
            }
            function vp(u) {
                var h = u._reactInternals;
                if (h === void 0) throw typeof u.render == "function" ? Error(i(188)) : (u = Object.keys(u).join(","), Error(i(268, u)));
                return u = _(h), u = u !== null ? S(u) : null, u === null ? null : jc(u.stateNode);
            }
            function Y0(u, h, y, T, U, B) {
                U = Xu(U), T.context === null ? T.context = U : T.pendingContext = U, T = Ge(h), T.payload = {
                    element: y
                }, B = B === void 0 ? null : B, B !== null && (T.callback = B), y = Ye(u, T, h), y !== null && (ga(y, u, h), at(y, u, h));
            }
            function Z0(u, h) {
                if (u = u.memoizedState, u !== null && u.dehydrated !== null) {
                    var y = u.retryLane;
                    u.retryLane = y !== 0 && y < h ? y : h;
                }
            }
            function yp(u, h) {
                Z0(u, h), (u = u.alternate) && Z0(u, h);
            }
            var Bt = {}, _p = $455d545b1dff00eb$var$jd(), aa = $455d545b1dff00eb$var$$P(), jl = Object.assign, bp = Symbol.for("react.element"), co = Symbol.for("react.transitional.element"), us = Symbol.for("react.portal"), Gc = Symbol.for("react.fragment"), Sp = Symbol.for("react.strict_mode"), Mp = Symbol.for("react.profiler"), Q0 = Symbol.for("react.provider"), Ko = Symbol.for("react.consumer"), Ns = Symbol.for("react.context"), kc = Symbol.for("react.forward_ref"), vh = Symbol.for("react.suspense"), Jo = Symbol.for("react.suspense_list"), Wu = Symbol.for("react.memo"), fs = Symbol.for("react.lazy"), qu = Symbol.for("react.offscreen"), K0 = Symbol.for("react.memo_cache_sentinel"), Ep = Symbol.iterator, Xl = Symbol.for("react.client.reference"), Vt = _p.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, yh, Tp, $o = !1, el = Array.isArray, _h = e.rendererVersion, Yu = e.rendererPackageName, Zu = e.extraDevToolsConfig, jc = e.getPublicInstance, Wl = e.getRootHostContext, J0 = e.getChildHostContext, tl = e.prepareForCommit, Ap = e.resetAfterCommit, wp = e.createInstance, Os = e.appendInitialChild, uo = e.finalizeInitialChildren, nl = e.shouldSetTextContent, bh = e.createTextInstance, Cp = e.scheduleTimeout, Qu = e.cancelTimeout, ql = e.noTimeout, Ls = e.isPrimaryRenderer;
            e.warnsIfNotActing;
            var ra = e.supportsMutation, hr = e.supportsPersistence, Oa = e.supportsHydration, Rp = e.getInstanceFromNode;
            e.beforeActiveInstanceBlur, e.afterActiveInstanceBlur;
            var Dp = e.preparePortalMount;
            e.prepareScopeUpdate, e.getInstanceFromScope;
            var va = e.setCurrentUpdatePriority, ji = e.getCurrentUpdatePriority, Fr = e.resolveUpdatePriority;
            e.resolveEventType, e.resolveEventTimeStamp;
            var il = e.shouldAttemptEagerTransition, Up = e.detachDeletedInstance;
            e.requestPostPaintCallback;
            var $0 = e.maySuspendCommit, fo = e.preloadInstance, dr = e.startSuspendingCommit, vi = e.suspendInstance, Sh = e.waitForCommitToBeReady, ja = e.NotPendingTransition, Xt = e.HostTransitionContext, Xn = e.resetFormInstance;
            e.bindToConsole;
            var Ii = e.supportsMicrotasks, Mh = e.scheduleMicrotask, zs = e.supportsTestSelectors, Yl = e.findFiberRoot, Eh = e.getBoundingRect, Ku = e.getTextContent, Ps = e.isHiddenSubtree, Gy = e.matchAccessibilityRole, yi = e.setFocusIfFocusable, Np = e.setupIntersectionObserver, Op = e.appendChild, eg = e.appendChildToContainer, tg = e.commitTextUpdate, ky = e.commitMount, Lp = e.commitUpdate, zp = e.insertBefore, Pp = e.insertInContainerBefore, La = e.removeChild, Ti = e.removeChildFromContainer, Ju = e.resetTextContent, $u = e.hideInstance, Th = e.hideTextInstance, Bp = e.unhideInstance, ho = e.unhideTextInstance, Ah = e.clearContainer, Ip = e.cloneInstance, wh = e.createContainerChildSet, Fp = e.appendChildToContainerChildSet, ng = e.finalizeContainerChildren, Hp = e.replaceContainerChildren, Vp = e.cloneHiddenInstance, Gp = e.cloneHiddenTextInstance, Ch = e.isSuspenseInstancePending, ef = e.isSuspenseInstanceFallback, ig = e.getSuspenseInstanceFallbackErrorDetails, jy = e.registerSuspenseInstanceRetry, ag = e.canHydrateFormStateMarker, rg = e.isFormStateMarkerMatching, kp = e.getNextHydratableSibling, Rh = e.getFirstHydratableChild, sg = e.getFirstHydratableChildWithinContainer, og = e.getFirstHydratableChildWithinSuspenseInstance, lg = e.canHydrateInstance, cg = e.canHydrateTextInstance, ug = e.canHydrateSuspenseInstance, Xy = e.hydrateInstance, fg = e.hydrateTextInstance, Xc = e.hydrateSuspenseInstance, hg = e.getNextHydratableInstanceAfterSuspenseInstance, Dh = e.commitHydratedContainer, Uh = e.commitHydratedSuspenseInstance, dg = e.clearSuspenseBoundary, jp = e.clearSuspenseBoundaryFromContainer, pg = e.shouldDeleteUnhydratedTailInstances;
            e.diffHydratedPropsForDevWarnings, e.diffHydratedTextForDevWarnings, e.describeHydratableInstanceForDevWarnings;
            var mg = e.validateHydratableInstance, gg = e.validateHydratableTextInstance, pr = e.supportsResources, Xp = e.isHostHoistableType, Nh = e.getHoistableRoot, Oh = e.getResource, Wp = e.acquireResource, qp = e.releaseResource, Yp = e.hydrateHoistable, Zp = e.mountHoistable, Qp = e.unmountHoistable, Wy = e.createHoistableInstance, Kp = e.prepareToCommitHoistables, xg = e.mayResourceSuspendCommit, Jp = e.preloadResource, $p = e.suspendResource, sa = e.supportsSingletons, em = e.resolveSingletonInstance, qy = e.clearSingleton, Yy = e.acquireSingletonInstance, vg = e.releaseSingletonInstance, Wc = e.isHostSingletonType, tf = [], po = -1, Zl = {}, Xa = Math.clz32 ? Math.clz32 : R, nf = Math.log, yg = Math.LN2, qc = 128, af = 4194304, Yc = aa.unstable_scheduleCallback, rf = aa.unstable_cancelCallback, _g = aa.unstable_shouldYield, bg = aa.unstable_requestPaint, oa = aa.unstable_now, tm = aa.unstable_ImmediatePriority, Sg = aa.unstable_UserBlockingPriority, Lh = aa.unstable_NormalPriority, zh = aa.unstable_IdlePriority, Mg = aa.log, nm = aa.unstable_setDisableYieldValue, Zc = null, Wa = null, mr = typeof Object.is == "function" ? Object.is : K, Ph = new WeakMap, oi = [], _i = 0, sf = null, of = 0, gr = [], xr = 0, hs = null, Bs = 1, Hr = "", Ji = M(null), lf = M(null), ds = M(null), Qc = M(null), ya = null, la = null, An = !1, vr = null, Vr = !1, cf = Error(i(519)), yr = [], al = 0, Kc = 0, Jc = null, Ql = null, uf = !1, ff = !1, ps = !1, rl = 0, hf = null, Bh = 0, qa = 0, sl = null, mo = !1, $c = !1, df = Object.prototype.hasOwnProperty, kn = Error(i(460)), im = Error(i(474)), Ih = {
                then: function() {}
            }, Kl = null, Is = null, Gr = 0, ol = gn(!0), am = gn(!1), Fs = M(null), _r = M(0), br = M(null), kr = null, Fi = M(0), Hs = 0, en = null, Ln = null, Ai = null, jr = !1, li = !1, go = !1, pf = 0, bi = 0, eu = null, Eg = 0, Fh = function() {
                return {
                    lastEffect: null,
                    events: null,
                    stores: null,
                    memoCache: null
                };
            }, wn = {
                readContext: ia,
                use: ve,
                useCallback: jt,
                useContext: jt,
                useEffect: jt,
                useImperativeHandle: jt,
                useLayoutEffect: jt,
                useInsertionEffect: jt,
                useMemo: jt,
                useReducer: jt,
                useRef: jt,
                useState: jt,
                useDebugValue: jt,
                useDeferredValue: jt,
                useTransition: jt,
                useSyncExternalStore: jt,
                useId: jt
            };
            wn.useCacheRefresh = jt, wn.useMemoCache = jt, wn.useHostTransitionStatus = jt, wn.useFormState = jt, wn.useActionState = jt, wn.useOptimistic = jt;
            var Hi = {
                readContext: ia,
                use: ve,
                useCallback: function(u, h) {
                    return Qn().memoizedState = [
                        u,
                        h === void 0 ? null : h
                    ], u;
                },
                useContext: ia,
                useEffect: Al,
                useImperativeHandle: function(u, h, y) {
                    y = y != null ? y.concat([
                        u
                    ]) : null, Ca(4194308, 4, Lr.bind(null, h, u), y);
                },
                useLayoutEffect: function(u, h) {
                    return Ca(4194308, 4, u, h);
                },
                useInsertionEffect: function(u, h) {
                    Ca(4, 2, u, h);
                },
                useMemo: function(u, h) {
                    var y = Qn();
                    h = h === void 0 ? null : h;
                    var T = u();
                    if (go) {
                        Q(!0);
                        try {
                            u();
                        } finally{
                            Q(!1);
                        }
                    }
                    return y.memoizedState = [
                        T,
                        h
                    ], T;
                },
                useReducer: function(u, h, y) {
                    var T = Qn();
                    if (y !== void 0) {
                        var U = y(h);
                        if (go) {
                            Q(!0);
                            try {
                                y(h);
                            } finally{
                                Q(!1);
                            }
                        }
                    } else U = h;
                    return T.memoizedState = T.baseState = U, u = {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: u,
                        lastRenderedState: U
                    }, T.queue = u, u = u.dispatch = as.bind(null, en, u), [
                        T.memoizedState,
                        u
                    ];
                },
                useRef: function(u) {
                    var h = Qn();
                    return u = {
                        current: u
                    }, h.memoizedState = u;
                },
                useState: function(u) {
                    u = fn(u);
                    var h = u.queue, y = Ul.bind(null, en, h);
                    return h.dispatch = y, [
                        u.memoizedState,
                        y
                    ];
                },
                useDebugValue: ns,
                useDeferredValue: function(u, h) {
                    var y = Qn();
                    return zr(y, u, h);
                },
                useTransition: function() {
                    var u = fn(!1);
                    return u = Dl.bind(null, en, u.queue, !0, !1), Qn().memoizedState = u, [
                        !1,
                        u
                    ];
                },
                useSyncExternalStore: function(u, h, y) {
                    var T = en, U = Qn();
                    if (An) {
                        if (y === void 0) throw Error(i(407));
                        y = y();
                    } else {
                        if (y = h(), dn === null) throw Error(i(349));
                        (cn & 60) !== 0 || Ot(T, h, y);
                    }
                    U.memoizedState = y;
                    var B = {
                        value: y,
                        getSnapshot: h
                    };
                    return U.queue = B, Al(Ut.bind(null, T, B, u), [
                        u
                    ]), T.flags |= 2048, qn(9, Pt.bind(null, T, B, y, h), {
                        destroy: void 0
                    }, null), y;
                },
                useId: function() {
                    var u = Qn(), h = dn.identifierPrefix;
                    if (An) {
                        var y = Hr, T = Bs;
                        y = (T & ~(1 << 32 - Xa(T) - 1)).toString(32) + y, h = ":" + h + "R" + y, y = pf++, 0 < y && (h += "H" + y.toString(32)), h += ":";
                    } else y = Eg++, h = ":" + h + "r" + y.toString(32) + ":";
                    return u.memoizedState = h;
                },
                useCacheRefresh: function() {
                    return Qn().memoizedState = Ks.bind(null, en);
                }
            };
            Hi.useMemoCache = Pe, Hi.useHostTransitionStatus = is, Hi.useFormState = Or, Hi.useActionState = Or, Hi.useOptimistic = function(u) {
                var h = Qn();
                h.memoizedState = h.baseState = u;
                var y = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: null,
                    lastRenderedState: null
                };
                return h.queue = y, h = Nl.bind(null, en, !0, y), y.dispatch = h, [
                    u,
                    h
                ];
            };
            var _a = {
                readContext: ia,
                use: ve,
                useCallback: Cl,
                useContext: ia,
                useEffect: ts,
                useImperativeHandle: ta,
                useInsertionEffect: Nu,
                useLayoutEffect: wl,
                useMemo: or,
                useReducer: dt,
                useRef: wa,
                useState: function() {
                    return dt(Me);
                },
                useDebugValue: ns,
                useDeferredValue: function(u, h) {
                    var y = ie();
                    return Rl(y, Ln.memoizedState, u, h);
                },
                useTransition: function() {
                    var u = dt(Me)[0], h = ie().memoizedState;
                    return [
                        typeof u == "boolean" ? u : Se(u),
                        h
                    ];
                },
                useSyncExternalStore: Tt,
                useId: lr
            };
            _a.useCacheRefresh = pa, _a.useMemoCache = Pe, _a.useHostTransitionStatus = is, _a.useFormState = On, _a.useActionState = On, _a.useOptimistic = function(u, h) {
                var y = ie();
                return ln(y, Ln, u, h);
            };
            var ll = {
                readContext: ia,
                use: ve,
                useCallback: Cl,
                useContext: ia,
                useEffect: ts,
                useImperativeHandle: ta,
                useInsertionEffect: Nu,
                useLayoutEffect: wl,
                useMemo: or,
                useReducer: Et,
                useRef: wa,
                useState: function() {
                    return Et(Me);
                },
                useDebugValue: ns,
                useDeferredValue: function(u, h) {
                    var y = ie();
                    return Ln === null ? zr(y, u, h) : Rl(y, Ln.memoizedState, u, h);
                },
                useTransition: function() {
                    var u = Et(Me)[0], h = ie().memoizedState;
                    return [
                        typeof u == "boolean" ? u : Se(u),
                        h
                    ];
                },
                useSyncExternalStore: Tt,
                useId: lr
            };
            ll.useCacheRefresh = pa, ll.useMemoCache = Pe, ll.useHostTransitionStatus = is, ll.useFormState = fi, ll.useActionState = fi, ll.useOptimistic = function(u, h) {
                var y = ie();
                return Ln !== null ? ln(y, Ln, u, h) : (y.baseState = u, [
                    u,
                    y.queue.dispatch
                ]);
            };
            var Hh = {
                isMounted: function(u) {
                    return (u = u._reactInternals) ? x(u) === u : !1;
                },
                enqueueSetState: function(u, h, y) {
                    u = u._reactInternals;
                    var T = Na(), U = Ge(T);
                    U.payload = h, y != null && (U.callback = y), h = Ye(u, U, T), h !== null && (ga(h, u, T), at(h, u, T));
                },
                enqueueReplaceState: function(u, h, y) {
                    u = u._reactInternals;
                    var T = Na(), U = Ge(T);
                    U.tag = 1, U.payload = h, y != null && (U.callback = y), h = Ye(u, U, T), h !== null && (ga(h, u, T), at(h, u, T));
                },
                enqueueForceUpdate: function(u, h) {
                    u = u._reactInternals;
                    var y = Na(), T = Ge(y);
                    T.tag = 2, h != null && (T.callback = h), h = Ye(u, T, y), h !== null && (ga(h, u, y), at(h, u, y));
                }
            }, rm = typeof reportError == "function" ? reportError : function(u) {
                if (typeof window == "object" && typeof window.ErrorEvent == "function") {
                    var h = new window.ErrorEvent("error", {
                        bubbles: !0,
                        cancelable: !0,
                        message: typeof u == "object" && u !== null && typeof u.message == "string" ? String(u.message) : String(u),
                        error: u
                    });
                    if (!window.dispatchEvent(h)) return;
                } else if (typeof $hPtJY == "object" && typeof $hPtJY.emit == "function") {
                    $hPtJY.emit("uncaughtException", u);
                    return;
                }
                console.error(u);
            }, Tg = Error(i(461)), wi = !1, ba = {
                dehydrated: null,
                treeContext: null,
                retryLane: 0
            }, Ya = M(null), cl = null, Si = null, Ag = typeof AbortController < "u" ? AbortController : function() {
                var u = [], h = this.signal = {
                    aborted: !1,
                    addEventListener: function(y, T) {
                        u.push(T);
                    }
                };
                this.abort = function() {
                    h.aborted = !0, u.forEach(function(y) {
                        return y();
                    });
                };
            }, xo = aa.unstable_scheduleCallback, Jl = aa.unstable_NormalPriority, Bn = {
                $$typeof: Ns,
                Consumer: null,
                Provider: null,
                _currentValue: null,
                _currentValue2: null,
                _threadCount: 0
            }, Vh = Vt.S;
            Vt.S = function(u, h) {
                typeof h == "object" && h !== null && typeof h.then == "function" && _e(u, h), Vh !== null && Vh(u, h);
            };
            var vo = M(null), Xi = !1, di = !1, ul = !1, tu = typeof WeakSet == "function" ? WeakSet : Set, Mi = null, $l = !1, Ci = null, Za = !1, za = null, ec = 8192, Gh = {
                getCacheForType: function(u) {
                    var h = ia(Bn), y = h.data.get(u);
                    return y === void 0 && (y = u(), h.data.set(u, y)), y;
                }
            }, mf = 0, kh = 1, jh = 2, Mn = 3, In = 4;
            if (typeof Symbol == "function" && Symbol.for) {
                var tn = Symbol.for;
                mf = tn("selector.component"), kh = tn("selector.has_pseudo_class"), jh = tn("selector.role"), Mn = tn("selector.test_id"), In = tn("selector.text");
            }
            var yn = typeof WeakMap == "function" ? WeakMap : Map, It = 0, dn = null, Kt = null, cn = 0, Wn = 0, Ri = null, Fn = !1, Sr = !1, yo = !1, ms = 0, En = 0, Mr = 0, gs = 0, Sa = 0, Qa = 0, _o = 0, nu = null, Er = null, iu = !1, Vs = 0, pi = 1 / 0, xs = null, Tr = null, Xr = !1, bo = null, tc = 0, Xh = 0, nc = null, ic = 0, Pa = null;
            return Bt.attemptContinuousHydration = function(u) {
                if (u.tag === 13) {
                    var h = Ie(u, 67108864);
                    h !== null && ga(h, u, 67108864), yp(u, 67108864);
                }
            }, Bt.attemptHydrationAtCurrentPriority = function(u) {
                if (u.tag === 13) {
                    var h = Na(), y = Ie(u, h);
                    y !== null && ga(y, u, h), yp(u, h);
                }
            }, Bt.attemptSynchronousHydration = function(u) {
                switch(u.tag){
                    case 3:
                        if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                            var h = N(u.pendingLanes);
                            if (h !== 0) {
                                for(u.pendingLanes |= 2, u.entangledLanes |= 2; h;){
                                    var y = 1 << 31 - Xa(h);
                                    u.entanglements[1] |= y, h &= ~y;
                                }
                                Ze(u), (It & 6) === 0 && (pi = oa() + 500, be(0));
                            }
                        }
                        break;
                    case 13:
                        h = Ie(u, 2), h !== null && ga(h, u, 2), pp(), yp(u, 2);
                }
            }, Bt.batchedUpdates = function(u, h) {
                return u(h);
            }, Bt.createComponentSelector = function(u) {
                return {
                    $$typeof: mf,
                    value: u
                };
            }, Bt.createContainer = function(u, h, y, T, U, B, se, me, De, it) {
                return Ki(u, h, !1, null, y, T, B, se, me, De, it, null);
            }, Bt.createHasPseudoClassSelector = function(u) {
                return {
                    $$typeof: kh,
                    value: u
                };
            }, Bt.createHydrationContainer = function(u, h, y, T, U, B, se, me, De, it, mt, bt, At) {
                return u = Ki(y, T, !0, u, U, B, me, De, it, mt, bt, At), u.context = Xu(null), y = u.current, T = Na(), U = Ge(T), U.callback = h ?? null, Ye(y, U, T), u.current.lanes = T, j(u, T), Ze(u), u;
            }, Bt.createPortal = function(u, h, y) {
                var T = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
                return {
                    $$typeof: us,
                    key: T == null ? null : "" + T,
                    children: u,
                    containerInfo: h,
                    implementation: y
                };
            }, Bt.createRoleSelector = function(u) {
                return {
                    $$typeof: jh,
                    value: u
                };
            }, Bt.createTestNameSelector = function(u) {
                return {
                    $$typeof: Mn,
                    value: u
                };
            }, Bt.createTextSelector = function(u) {
                return {
                    $$typeof: In,
                    value: u
                };
            }, Bt.defaultOnCaughtError = function(u) {
                console.error(u);
            }, Bt.defaultOnRecoverableError = function(u) {
                rm(u);
            }, Bt.defaultOnUncaughtError = function(u) {
                rm(u);
            }, Bt.deferredUpdates = function(u) {
                var h = Vt.T, y = ji();
                try {
                    return va(32), Vt.T = null, u();
                } finally{
                    va(y), Vt.T = h;
                }
            }, Bt.discreteUpdates = function(u, h, y, T, U) {
                var B = Vt.T, se = ji();
                try {
                    return va(2), Vt.T = null, u(h, y, T, U);
                } finally{
                    va(se), Vt.T = B, It === 0 && (pi = oa() + 500);
                }
            }, Bt.findAllNodes = Ua, Bt.findBoundingRects = function(u, h) {
                if (!zs) throw Error(i(363));
                h = Ua(u, h), u = [];
                for(var y = 0; y < h.length; y++)u.push(Eh(h[y]));
                for(h = u.length - 1; 0 < h; h--){
                    y = u[h];
                    for(var T = y.x, U = T + y.width, B = y.y, se = B + y.height, me = h - 1; 0 <= me; me--)if (h !== me) {
                        var De = u[me], it = De.x, mt = it + De.width, bt = De.y, At = bt + De.height;
                        if (T >= it && B >= bt && U <= mt && se <= At) {
                            u.splice(h, 1);
                            break;
                        } else if (T !== it || y.width !== De.width || At < B || bt > se) {
                            if (!(B !== bt || y.height !== De.height || mt < T || it > U)) {
                                it > T && (De.width += it - T, De.x = T), mt < U && (De.width = U - it), u.splice(h, 1);
                                break;
                            }
                        } else {
                            bt > B && (De.height += bt - B, De.y = B), At < se && (De.height = se - bt), u.splice(h, 1);
                            break;
                        }
                    }
                }
                return u;
            }, Bt.findHostInstance = vp, Bt.findHostInstanceWithNoPortals = function(u) {
                return u = _(u), u = u !== null ? A(u) : null, u === null ? null : jc(u.stateNode);
            }, Bt.findHostInstanceWithWarning = function(u) {
                return vp(u);
            }, Bt.flushPassiveEffects = Qi, Bt.flushSyncFromReconciler = function(u) {
                var h = It;
                It |= 1;
                var y = Vt.T, T = ji();
                try {
                    if (va(2), Vt.T = null, u) return u();
                } finally{
                    va(T), Vt.T = y, It = h, (It & 6) === 0 && be(0);
                }
            }, Bt.flushSyncWork = pp, Bt.focusWithin = function(u, h) {
                if (!zs) throw Error(i(363));
                for(u = hh(u), h = X0(u, h), h = Array.from(h), u = 0; u < h.length;){
                    var y = h[u++], T = y.tag;
                    if (!Ps(y)) {
                        if ((T === 5 || T === 26 || T === 27) && yi(y.stateNode)) return !0;
                        for(y = y.child; y !== null;)h.push(y), y = y.sibling;
                    }
                }
                return !1;
            }, Bt.getFindAllNodesFailureDescription = function(u, h) {
                if (!zs) throw Error(i(363));
                var y = 0, T = [];
                u = [
                    hh(u),
                    0
                ];
                for(var U = 0; U < u.length;){
                    var B = u[U++], se = B.tag, me = u[U++], De = h[me];
                    if ((se !== 5 && se !== 26 && se !== 27 || !Ps(B)) && (Fc(B, De) && (T.push(Yo(De)), me++, me > y && (y = me)), me < h.length)) for(B = B.child; B !== null;)u.push(B, me), B = B.sibling;
                }
                if (y < h.length) {
                    for(u = []; y < h.length; y++)u.push(Yo(h[y]));
                    return `findAllNodes was able to match part of the selector:
  ` + (T.join(" > ") + `

No matching component was found for:
  `) + u.join(" > ");
                }
                return null;
            }, Bt.getPublicRootInstance = function(u) {
                if (u = u.current, !u.child) return null;
                switch(u.child.tag){
                    case 27:
                    case 5:
                        return jc(u.child.stateNode);
                    default:
                        return u.child.stateNode;
                }
            }, Bt.injectIntoDevTools = function() {
                var u = {
                    bundleType: 0,
                    version: _h,
                    rendererPackageName: Yu,
                    currentDispatcherRef: Vt,
                    findFiberByHostInstance: Rp,
                    reconcilerVersion: "19.0.0"
                };
                if (Zu !== null && (u.rendererConfig = Zu), typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") u = !1;
                else {
                    var h = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (h.isDisabled || !h.supportsFiber) u = !0;
                    else {
                        try {
                            Zc = h.inject(u), Wa = h;
                        } catch  {}
                        u = !!h.checkDCE;
                    }
                }
                return u;
            }, Bt.isAlreadyRendering = function() {
                return !1;
            }, Bt.observeVisibleRects = function(u, h, y, T) {
                if (!zs) throw Error(i(363));
                u = Ua(u, h);
                var U = Np(u, y, T).disconnect;
                return {
                    disconnect: function() {
                        U();
                    }
                };
            }, Bt.shouldError = function() {
                return null;
            }, Bt.shouldSuspend = function() {
                return !1;
            }, Bt.startHostTransition = function(u, h, y, T) {
                if (u.tag !== 5) throw Error(i(476));
                var U = Bo(u).queue;
                Dl(u, U, h, ja, y === null ? n : function() {
                    var B = Bo(u).next.queue;
                    return Pr(u, B, {}, Na()), y(T);
                });
            }, Bt.updateContainer = function(u, h, y, T) {
                var U = h.current, B = Na();
                return Y0(U, B, u, h, y, T), B;
            }, Bt.updateContainerSync = function(u, h, y, T) {
                return h.tag === 0 && Qi(), Y0(h.current, 2, u, h, y, T), 2;
            }, Bt;
        }, a.exports.default = a.exports, Object.defineProperty(a.exports, "__esModule", {
            value: !0
        });
    }($455d545b1dff00eb$var$T_)), $455d545b1dff00eb$var$T_.exports;
}
var $455d545b1dff00eb$var$E3;
function $455d545b1dff00eb$var$tB() {
    return $455d545b1dff00eb$var$E3 || ($455d545b1dff00eb$var$E3 = 1, $455d545b1dff00eb$var$E_.exports = $455d545b1dff00eb$var$eB()), $455d545b1dff00eb$var$E_.exports;
}
var $455d545b1dff00eb$var$nB = $455d545b1dff00eb$var$tB();
const $455d545b1dff00eb$var$iB = $455d545b1dff00eb$var$Mb($455d545b1dff00eb$var$nB);
var $455d545b1dff00eb$var$C_ = {
    exports: {}
}, $455d545b1dff00eb$var$R_ = {};
var $455d545b1dff00eb$var$T3;
function $455d545b1dff00eb$var$aB() {
    return $455d545b1dff00eb$var$T3 || ($455d545b1dff00eb$var$T3 = 1, function(a) {
        function e(F, Q) {
            var K = F.length;
            F.push(Q);
            e: for(; 0 < K;){
                var $ = K - 1 >>> 1, ee = F[$];
                if (0 < i(ee, Q)) F[$] = Q, F[K] = ee, K = $;
                else break e;
            }
        }
        function t(F) {
            return F.length === 0 ? null : F[0];
        }
        function n(F) {
            if (F.length === 0) return null;
            var Q = F[0], K = F.pop();
            if (K !== Q) {
                F[0] = K;
                e: for(var $ = 0, ee = F.length, I = ee >>> 1; $ < I;){
                    var Z = 2 * ($ + 1) - 1, oe = F[Z], ce = Z + 1, de = F[ce];
                    if (0 > i(oe, K)) ce < ee && 0 > i(de, oe) ? (F[$] = de, F[ce] = K, $ = ce) : (F[$] = oe, F[Z] = K, $ = Z);
                    else if (ce < ee && 0 > i(de, K)) F[$] = de, F[ce] = K, $ = ce;
                    else break e;
                }
            }
            return Q;
        }
        function i(F, Q) {
            var K = F.sortIndex - Q.sortIndex;
            return K !== 0 ? K : F.id - Q.id;
        }
        if (a.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
            var r = performance;
            a.unstable_now = function() {
                return r.now();
            };
        } else {
            var l = Date, c = l.now();
            a.unstable_now = function() {
                return l.now() - c;
            };
        }
        var f = [], p = [], m = 1, x = null, v = 3, _ = !1, S = !1, A = !1, M = typeof setTimeout == "function" ? setTimeout : null, b = typeof clearTimeout == "function" ? clearTimeout : null, C = typeof setImmediate < "u" ? setImmediate : null;
        function R(F) {
            for(var Q = t(p); Q !== null;){
                if (Q.callback === null) n(p);
                else if (Q.startTime <= F) n(p), Q.sortIndex = Q.expirationTime, e(f, Q);
                else break;
                Q = t(p);
            }
        }
        function N(F) {
            if (A = !1, R(F), !S) {
                if (t(f) !== null) S = !0, Y();
                else {
                    var Q = t(p);
                    Q !== null && ae(N, Q.startTime - F);
                }
            }
        }
        var z = !1, L = -1, P = 5, H = -1;
        function O() {
            return !(a.unstable_now() - H < P);
        }
        function D() {
            if (z) {
                var F = a.unstable_now();
                H = F;
                var Q = !0;
                try {
                    e: {
                        S = !1, A && (A = !1, b(L), L = -1), _ = !0;
                        var K = v;
                        try {
                            t: {
                                for(R(F), x = t(f); x !== null && !(x.expirationTime > F && O());){
                                    var $ = x.callback;
                                    if (typeof $ == "function") {
                                        x.callback = null, v = x.priorityLevel;
                                        var ee = $(x.expirationTime <= F);
                                        if (F = a.unstable_now(), typeof ee == "function") {
                                            x.callback = ee, R(F), Q = !0;
                                            break t;
                                        }
                                        x === t(f) && n(f), R(F);
                                    } else n(f);
                                    x = t(f);
                                }
                                if (x !== null) Q = !0;
                                else {
                                    var I = t(p);
                                    I !== null && ae(N, I.startTime - F), Q = !1;
                                }
                            }
                            break e;
                        } finally{
                            x = null, v = K, _ = !1;
                        }
                        Q = void 0;
                    }
                } finally{
                    Q ? j() : z = !1;
                }
            }
        }
        var j;
        if (typeof C == "function") j = function() {
            C(D);
        };
        else if (typeof MessageChannel < "u") {
            var G = new MessageChannel, q = G.port2;
            G.port1.onmessage = D, j = function() {
                q.postMessage(null);
            };
        } else j = function() {
            M(D, 0);
        };
        function Y() {
            z || (z = !0, j());
        }
        function ae(F, Q) {
            L = M(function() {
                F(a.unstable_now());
            }, Q);
        }
        a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(F) {
            F.callback = null;
        }, a.unstable_continueExecution = function() {
            S || _ || (S = !0, Y());
        }, a.unstable_forceFrameRate = function(F) {
            0 > F || 125 < F ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < F ? Math.floor(1e3 / F) : 5;
        }, a.unstable_getCurrentPriorityLevel = function() {
            return v;
        }, a.unstable_getFirstCallbackNode = function() {
            return t(f);
        }, a.unstable_next = function(F) {
            switch(v){
                case 1:
                case 2:
                case 3:
                    var Q = 3;
                    break;
                default:
                    Q = v;
            }
            var K = v;
            v = Q;
            try {
                return F();
            } finally{
                v = K;
            }
        }, a.unstable_pauseExecution = function() {}, a.unstable_requestPaint = function() {}, a.unstable_runWithPriority = function(F, Q) {
            switch(F){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    F = 3;
            }
            var K = v;
            v = F;
            try {
                return Q();
            } finally{
                v = K;
            }
        }, a.unstable_scheduleCallback = function(F, Q, K) {
            var $ = a.unstable_now();
            switch(typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? $ + K : $) : K = $, F){
                case 1:
                    var ee = -1;
                    break;
                case 2:
                    ee = 250;
                    break;
                case 5:
                    ee = 1073741823;
                    break;
                case 4:
                    ee = 1e4;
                    break;
                default:
                    ee = 5e3;
            }
            return ee = K + ee, F = {
                id: m++,
                callback: Q,
                priorityLevel: F,
                startTime: K,
                expirationTime: ee,
                sortIndex: -1
            }, K > $ ? (F.sortIndex = K, e(p, F), t(f) === null && F === t(p) && (A ? (b(L), L = -1) : A = !0, ae(N, K - $))) : (F.sortIndex = ee, e(f, F), S || _ || (S = !0, Y())), F;
        }, a.unstable_shouldYield = O, a.unstable_wrapCallback = function(F) {
            var Q = v;
            return function() {
                var K = v;
                v = Q;
                try {
                    return F.apply(this, arguments);
                } finally{
                    v = K;
                }
            };
        };
    }($455d545b1dff00eb$var$R_)), $455d545b1dff00eb$var$R_;
}
var $455d545b1dff00eb$var$A3;
function $455d545b1dff00eb$var$rB() {
    return $455d545b1dff00eb$var$A3 || ($455d545b1dff00eb$var$A3 = 1, $455d545b1dff00eb$var$C_.exports = $455d545b1dff00eb$var$aB()), $455d545b1dff00eb$var$C_.exports;
}
var $455d545b1dff00eb$var$w3 = $455d545b1dff00eb$var$rB();
function $455d545b1dff00eb$var$xS(a, e, t) {
    if (!a) return;
    if (t(a) === !0) return a;
    let n = e ? a.return : a.child;
    for(; n;){
        const i = $455d545b1dff00eb$var$xS(n, e, t);
        if (i) return i;
        n = e ? null : n.sibling;
    }
}
function $455d545b1dff00eb$var$CA(a) {
    try {
        return Object.defineProperties(a, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch  {
        return a;
    }
}
const $455d545b1dff00eb$var$vS = $455d545b1dff00eb$var$CA($455d545b1dff00eb$var$X.createContext(null));
class $455d545b1dff00eb$var$RA extends $455d545b1dff00eb$var$X.Component {
    render() {
        return $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$vS.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $455d545b1dff00eb$var$DA() {
    const a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$vS);
    if (a === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const e = $455d545b1dff00eb$var$X.useId();
    return $455d545b1dff00eb$var$X.useMemo(()=>{
        for (const t of [
            a,
            a?.alternate
        ]){
            if (!t) continue;
            const n = $455d545b1dff00eb$var$xS(t, !1, (i)=>{
                let r = i.memoizedState;
                for(; r;){
                    if (r.memoizedState === e) return !0;
                    r = r.next;
                }
            });
            if (n) return n;
        }
    }, [
        a,
        e
    ]);
}
const $455d545b1dff00eb$var$sB = Symbol.for("react.context"), $455d545b1dff00eb$var$oB = (a)=>a !== null && typeof a == "object" && "$$typeof" in a && a.$$typeof === $455d545b1dff00eb$var$sB;
function $455d545b1dff00eb$var$lB() {
    const a = $455d545b1dff00eb$var$DA(), [e] = $455d545b1dff00eb$var$X.useState(()=>new Map);
    e.clear();
    let t = a;
    for(; t;){
        const n = t.type;
        $455d545b1dff00eb$var$oB(n) && n !== $455d545b1dff00eb$var$vS && !e.has(n) && e.set(n, $455d545b1dff00eb$var$X.use($455d545b1dff00eb$var$CA(n))), t = t.return;
    }
    return e;
}
function $455d545b1dff00eb$var$cB() {
    const a = $455d545b1dff00eb$var$lB();
    return $455d545b1dff00eb$var$X.useMemo(()=>Array.from(a.keys()).reduce((e, t)=>(n)=>$455d545b1dff00eb$var$X.createElement(e, null, $455d545b1dff00eb$var$X.createElement(t.Provider, {
                    ...n,
                    value: a.get(t)
                })), (e)=>$455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$RA, {
                ...e
            })), [
        a
    ]);
}
function $455d545b1dff00eb$var$UA(a) {
    let e = a.root;
    for(; e.getState().previousRoot;)e = e.getState().previousRoot;
    return e;
}
const $455d545b1dff00eb$var$NA = (a)=>a && a.isOrthographicCamera, $455d545b1dff00eb$var$uB = (a)=>a && a.hasOwnProperty("current"), $455d545b1dff00eb$var$fB = (a)=>a != null && (typeof a == "string" || typeof a == "number" || a.isColor), $455d545b1dff00eb$var$U0 = ((a, e)=>typeof window < "u" && (((a = window.document) == null ? void 0 : a.createElement) || ((e = window.navigator) == null ? void 0 : e.product) === "ReactNative"))() ? $455d545b1dff00eb$var$X.useLayoutEffect : $455d545b1dff00eb$var$X.useEffect;
function $455d545b1dff00eb$var$OA(a) {
    const e = $455d545b1dff00eb$var$X.useRef(a);
    return $455d545b1dff00eb$var$U0(()=>void (e.current = a), [
        a
    ]), e;
}
function $455d545b1dff00eb$var$hB() {
    const a = $455d545b1dff00eb$var$DA(), e = $455d545b1dff00eb$var$cB();
    return $455d545b1dff00eb$var$X.useMemo(()=>({ children: t })=>{
            const i = !!$455d545b1dff00eb$var$xS(a, !0, (r)=>r.type === $455d545b1dff00eb$var$X.StrictMode) ? $455d545b1dff00eb$var$X.StrictMode : $455d545b1dff00eb$var$X.Fragment;
            return $455d545b1dff00eb$var$k.jsx(i, {
                children: $455d545b1dff00eb$var$k.jsx(e, {
                    children: t
                })
            });
        }, [
        a,
        e
    ]);
}
function $455d545b1dff00eb$var$dB({ set: a }) {
    return $455d545b1dff00eb$var$U0(()=>(a(new Promise(()=>null)), ()=>a(!1)), [
        a
    ]), null;
}
const $455d545b1dff00eb$var$pB = ((a)=>(a = class extends $455d545b1dff00eb$var$X.Component {
        constructor(...t){
            super(...t), this.state = {
                error: !1
            };
        }
        componentDidCatch(t) {
            this.props.set(t);
        }
        render() {
            return this.state.error ? null : this.props.children;
        }
    }, a.getDerivedStateFromError = ()=>({
            error: !0
        }), a))();
function $455d545b1dff00eb$var$LA(a) {
    var e;
    const t = typeof window < "u" ? (e = window.devicePixelRatio) != null ? e : 2 : 1;
    return Array.isArray(a) ? Math.min(Math.max(a[0], t), a[1]) : a;
}
function $455d545b1dff00eb$var$Sd(a) {
    var e;
    return (e = a.__r3f) == null ? void 0 : e.root.getState();
}
const $455d545b1dff00eb$var$Di = {
    obj: (a)=>a === Object(a) && !$455d545b1dff00eb$var$Di.arr(a) && typeof a != "function",
    fun: (a)=>typeof a == "function",
    str: (a)=>typeof a == "string",
    num: (a)=>typeof a == "number",
    boo: (a)=>typeof a == "boolean",
    und: (a)=>a === void 0,
    nul: (a)=>a === null,
    arr: (a)=>Array.isArray(a),
    equ (a, e, { arrays: t = "shallow", objects: n = "reference", strict: i = !0 } = {}) {
        if (typeof a != typeof e || !!a != !!e) return !1;
        if ($455d545b1dff00eb$var$Di.str(a) || $455d545b1dff00eb$var$Di.num(a) || $455d545b1dff00eb$var$Di.boo(a)) return a === e;
        const r = $455d545b1dff00eb$var$Di.obj(a);
        if (r && n === "reference") return a === e;
        const l = $455d545b1dff00eb$var$Di.arr(a);
        if (l && t === "reference") return a === e;
        if ((l || r) && a === e) return !0;
        let c;
        for(c in a)if (!(c in e)) return !1;
        if (r && t === "shallow" && n === "shallow") {
            for(c in i ? e : a)if (!$455d545b1dff00eb$var$Di.equ(a[c], e[c], {
                strict: i,
                objects: "reference"
            })) return !1;
        } else for(c in i ? e : a)if (a[c] !== e[c]) return !1;
        if ($455d545b1dff00eb$var$Di.und(c)) {
            if (l && a.length === 0 && e.length === 0 || r && Object.keys(a).length === 0 && Object.keys(e).length === 0) return !0;
            if (a !== e) return !1;
        }
        return !0;
    }
};
function $455d545b1dff00eb$var$mB(a) {
    a.type !== "Scene" && (a.dispose == null || a.dispose());
    for(const e in a){
        const t = a[e];
        t?.type !== "Scene" && (t == null || t.dispose == null || t.dispose());
    }
}
const $455d545b1dff00eb$var$zA = [
    "children",
    "key",
    "ref"
];
function $455d545b1dff00eb$var$gB(a) {
    const e = {};
    for(const t in a)$455d545b1dff00eb$var$zA.includes(t) || (e[t] = a[t]);
    return e;
}
function $455d545b1dff00eb$var$kv(a, e, t, n) {
    const i = a;
    let r = i?.__r3f;
    return r || (r = {
        root: e,
        type: t,
        parent: null,
        children: [],
        props: $455d545b1dff00eb$var$gB(n),
        object: i,
        eventCount: 0,
        handlers: {},
        isHidden: !1
    }, i && (i.__r3f = r)), r;
}
function $455d545b1dff00eb$var$m0(a, e) {
    if (!e.includes("-")) return {
        root: a,
        key: e,
        target: a[e]
    };
    if (e in a) return {
        root: a,
        key: e,
        target: a[e]
    };
    let t = a;
    const n = e.split("-");
    for (const i of n){
        if (typeof t != "object" || t === null) {
            if (t !== void 0) {
                const r = n.slice(n.indexOf(i)).join("-");
                return {
                    root: t,
                    key: r,
                    target: void 0
                };
            }
            return {
                root: a,
                key: e,
                target: void 0
            };
        }
        e = i, a = t, t = t[e];
    }
    return {
        root: a,
        key: e,
        target: t
    };
}
const $455d545b1dff00eb$var$C3 = /-\d+$/;
function $455d545b1dff00eb$var$jv(a, e) {
    if ($455d545b1dff00eb$var$Di.str(e.props.attach)) {
        if ($455d545b1dff00eb$var$C3.test(e.props.attach)) {
            const i = e.props.attach.replace($455d545b1dff00eb$var$C3, ""), { root: r, key: l } = $455d545b1dff00eb$var$m0(a.object, i);
            Array.isArray(r[l]) || (r[l] = []);
        }
        const { root: t, key: n } = $455d545b1dff00eb$var$m0(a.object, e.props.attach);
        e.previousAttach = t[n], t[n] = e.object;
    } else $455d545b1dff00eb$var$Di.fun(e.props.attach) && (e.previousAttach = e.props.attach(a.object, e.object));
}
function $455d545b1dff00eb$var$Xv(a, e) {
    if ($455d545b1dff00eb$var$Di.str(e.props.attach)) {
        const { root: t, key: n } = $455d545b1dff00eb$var$m0(a.object, e.props.attach), i = e.previousAttach;
        i === void 0 ? delete t[n] : t[n] = i;
    } else e.previousAttach == null || e.previousAttach(a.object, e.object);
    delete e.previousAttach;
}
const $455d545b1dff00eb$var$cb = [
    ...$455d545b1dff00eb$var$zA,
    "args",
    "dispose",
    "attach",
    "object",
    "onUpdate",
    "dispose"
], $455d545b1dff00eb$var$R3 = new Map;
function $455d545b1dff00eb$var$xB(a) {
    let e = $455d545b1dff00eb$var$R3.get(a.constructor);
    try {
        e || (e = new a.constructor, $455d545b1dff00eb$var$R3.set(a.constructor, e));
    } catch  {}
    return e;
}
function $455d545b1dff00eb$var$vB(a, e) {
    const t = {};
    for(const n in e)if (!$455d545b1dff00eb$var$cb.includes(n) && !$455d545b1dff00eb$var$Di.equ(e[n], a.props[n])) {
        t[n] = e[n];
        for(const i in e)i.startsWith(`${n}-`) && (t[i] = e[i]);
    }
    for(const n in a.props){
        if ($455d545b1dff00eb$var$cb.includes(n) || e.hasOwnProperty(n)) continue;
        const { root: i, key: r } = $455d545b1dff00eb$var$m0(a.object, n);
        if (i.constructor && i.constructor.length === 0) {
            const l = $455d545b1dff00eb$var$xB(i);
            $455d545b1dff00eb$var$Di.und(l) || (t[r] = l[r]);
        } else t[r] = 0;
    }
    return t;
}
const $455d545b1dff00eb$var$yB = [
    "map",
    "emissiveMap",
    "sheenColorMap",
    "specularColorMap",
    "envMap"
], $455d545b1dff00eb$var$_B = /^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/;
function $455d545b1dff00eb$var$yu(a, e) {
    var t;
    const n = a.__r3f, i = n && $455d545b1dff00eb$var$UA(n).getState(), r = n?.eventCount;
    for(const c in e){
        let f = e[c];
        if ($455d545b1dff00eb$var$cb.includes(c)) continue;
        if (n && $455d545b1dff00eb$var$_B.test(c)) {
            typeof f == "function" ? n.handlers[c] = f : delete n.handlers[c], n.eventCount = Object.keys(n.handlers).length;
            continue;
        }
        if (f === void 0) continue;
        let { root: p, key: m, target: x } = $455d545b1dff00eb$var$m0(a, c);
        if (x === void 0 && (typeof p != "object" || p === null)) throw Error(`R3F: Cannot set "${c}". Ensure it is an object before setting "${m}".`);
        if (x instanceof $455d545b1dff00eb$var$Hd && f instanceof $455d545b1dff00eb$var$Hd) x.mask = f.mask;
        else if (x instanceof $455d545b1dff00eb$var$_t && $455d545b1dff00eb$var$fB(f)) x.set(f);
        else if (x !== null && typeof x == "object" && typeof x.set == "function" && typeof x.copy == "function" && f != null && f.constructor && x.constructor === f.constructor) x.copy(f);
        else if (x !== null && typeof x == "object" && typeof x.set == "function" && Array.isArray(f)) typeof x.fromArray == "function" ? x.fromArray(f) : x.set(...f);
        else if (x !== null && typeof x == "object" && typeof x.set == "function" && typeof f == "number") typeof x.setScalar == "function" ? x.setScalar(f) : x.set(f);
        else {
            var l;
            p[m] = f, i && !i.linear && $455d545b1dff00eb$var$yB.includes(m) && (l = p[m]) != null && l.isTexture && p[m].format === $455d545b1dff00eb$var$ar && p[m].type === $455d545b1dff00eb$var$Ws && (p[m].colorSpace = $455d545b1dff00eb$var$nr);
        }
    }
    if (n != null && n.parent && i != null && i.internal && (t = n.object) != null && t.isObject3D && r !== n.eventCount) {
        const c = n.object, f = i.internal.interaction.indexOf(c);
        f > -1 && i.internal.interaction.splice(f, 1), n.eventCount && c.raycast !== null && i.internal.interaction.push(c);
    }
    return n && n.props.attach === void 0 && (n.object.isBufferGeometry ? n.props.attach = "geometry" : n.object.isMaterial && (n.props.attach = "material")), n && $455d545b1dff00eb$var$Zd(n), a;
}
function $455d545b1dff00eb$var$Zd(a) {
    var e;
    if (!a.parent) return;
    a.props.onUpdate == null || a.props.onUpdate(a.object);
    const t = (e = a.root) == null || e.getState == null ? void 0 : e.getState();
    t && t.internal.frames === 0 && t.invalidate();
}
function $455d545b1dff00eb$var$bB(a, e) {
    a.manual || ($455d545b1dff00eb$var$NA(a) ? (a.left = e.width / -2, a.right = e.width / 2, a.top = e.height / 2, a.bottom = e.height / -2) : a.aspect = e.width / e.height, a.updateProjectionMatrix());
}
const $455d545b1dff00eb$var$Yr = (a)=>a?.isObject3D;
function $455d545b1dff00eb$var$Ix(a) {
    return (a.eventObject || a.object).uuid + "/" + a.index + a.instanceId;
}
function $455d545b1dff00eb$var$PA(a, e, t, n) {
    const i = t.get(e);
    i && (t.delete(e), t.size === 0 && (a.delete(n), i.target.releasePointerCapture(n)));
}
function $455d545b1dff00eb$var$SB(a, e) {
    const { internal: t } = a.getState();
    t.interaction = t.interaction.filter((n)=>n !== e), t.initialHits = t.initialHits.filter((n)=>n !== e), t.hovered.forEach((n, i)=>{
        (n.eventObject === e || n.object === e) && t.hovered.delete(i);
    }), t.capturedMap.forEach((n, i)=>{
        $455d545b1dff00eb$var$PA(t.capturedMap, e, n, i);
    });
}
function $455d545b1dff00eb$var$MB(a) {
    function e(f) {
        const { internal: p } = a.getState(), m = f.offsetX - p.initialClick[0], x = f.offsetY - p.initialClick[1];
        return Math.round(Math.sqrt(m * m + x * x));
    }
    function t(f) {
        return f.filter((p)=>[
                "Move",
                "Over",
                "Enter",
                "Out",
                "Leave"
            ].some((m)=>{
                var x;
                return (x = p.__r3f) == null ? void 0 : x.handlers["onPointer" + m];
            }));
    }
    function n(f, p) {
        const m = a.getState(), x = new Set, v = [], _ = p ? p(m.internal.interaction) : m.internal.interaction;
        for(let b = 0; b < _.length; b++){
            const C = $455d545b1dff00eb$var$Sd(_[b]);
            C && (C.raycaster.camera = void 0);
        }
        m.previousRoot || m.events.compute == null || m.events.compute(f, m);
        function S(b) {
            const C = $455d545b1dff00eb$var$Sd(b);
            if (!C || !C.events.enabled || C.raycaster.camera === null) return [];
            if (C.raycaster.camera === void 0) {
                var R;
                C.events.compute == null || C.events.compute(f, C, (R = C.previousRoot) == null ? void 0 : R.getState()), C.raycaster.camera === void 0 && (C.raycaster.camera = null);
            }
            return C.raycaster.camera ? C.raycaster.intersectObject(b, !0) : [];
        }
        let A = _.flatMap(S).sort((b, C)=>{
            const R = $455d545b1dff00eb$var$Sd(b.object), N = $455d545b1dff00eb$var$Sd(C.object);
            return !R || !N ? b.distance - C.distance : N.events.priority - R.events.priority || b.distance - C.distance;
        }).filter((b)=>{
            const C = $455d545b1dff00eb$var$Ix(b);
            return x.has(C) ? !1 : (x.add(C), !0);
        });
        m.events.filter && (A = m.events.filter(A, m));
        for (const b of A){
            let C = b.object;
            for(; C;){
                var M;
                (M = C.__r3f) != null && M.eventCount && v.push({
                    ...b,
                    eventObject: C
                }), C = C.parent;
            }
        }
        if ("pointerId" in f && m.internal.capturedMap.has(f.pointerId)) for (let b of m.internal.capturedMap.get(f.pointerId).values())x.has($455d545b1dff00eb$var$Ix(b.intersection)) || v.push(b.intersection);
        return v;
    }
    function i(f, p, m, x) {
        if (f.length) {
            const v = {
                stopped: !1
            };
            for (const _ of f){
                let S = $455d545b1dff00eb$var$Sd(_.object);
                if (S || _.object.traverseAncestors((A)=>{
                    const M = $455d545b1dff00eb$var$Sd(A);
                    if (M) return S = M, !1;
                }), S) {
                    const { raycaster: A, pointer: M, camera: b, internal: C } = S, R = new $455d545b1dff00eb$var$J(M.x, M.y, 0).unproject(b), N = (O)=>{
                        var D, j;
                        return (D = (j = C.capturedMap.get(O)) == null ? void 0 : j.has(_.eventObject)) != null ? D : !1;
                    }, z = (O)=>{
                        const D = {
                            intersection: _,
                            target: p.target
                        };
                        C.capturedMap.has(O) ? C.capturedMap.get(O).set(_.eventObject, D) : C.capturedMap.set(O, new Map([
                            [
                                _.eventObject,
                                D
                            ]
                        ])), p.target.setPointerCapture(O);
                    }, L = (O)=>{
                        const D = C.capturedMap.get(O);
                        D && $455d545b1dff00eb$var$PA(C.capturedMap, _.eventObject, D, O);
                    };
                    let P = {};
                    for(let O in p){
                        let D = p[O];
                        typeof D != "function" && (P[O] = D);
                    }
                    let H = {
                        ..._,
                        ...P,
                        pointer: M,
                        intersections: f,
                        stopped: v.stopped,
                        delta: m,
                        unprojectedPoint: R,
                        ray: A.ray,
                        camera: b,
                        stopPropagation () {
                            const O = "pointerId" in p && C.capturedMap.get(p.pointerId);
                            if ((!O || O.has(_.eventObject)) && (H.stopped = v.stopped = !0, C.hovered.size && Array.from(C.hovered.values()).find((D)=>D.eventObject === _.eventObject))) {
                                const D = f.slice(0, f.indexOf(_));
                                r([
                                    ...D,
                                    _
                                ]);
                            }
                        },
                        target: {
                            hasPointerCapture: N,
                            setPointerCapture: z,
                            releasePointerCapture: L
                        },
                        currentTarget: {
                            hasPointerCapture: N,
                            setPointerCapture: z,
                            releasePointerCapture: L
                        },
                        nativeEvent: p
                    };
                    if (x(H), v.stopped === !0) break;
                }
            }
        }
        return f;
    }
    function r(f) {
        const { internal: p } = a.getState();
        for (const m of p.hovered.values())if (!f.length || !f.find((x)=>x.object === m.object && x.index === m.index && x.instanceId === m.instanceId)) {
            const v = m.eventObject.__r3f;
            if (p.hovered.delete($455d545b1dff00eb$var$Ix(m)), v != null && v.eventCount) {
                const _ = v.handlers, S = {
                    ...m,
                    intersections: f
                };
                _.onPointerOut == null || _.onPointerOut(S), _.onPointerLeave == null || _.onPointerLeave(S);
            }
        }
    }
    function l(f, p) {
        for(let m = 0; m < p.length; m++){
            const x = p[m].__r3f;
            x == null || x.handlers.onPointerMissed == null || x.handlers.onPointerMissed(f);
        }
    }
    function c(f) {
        switch(f){
            case "onPointerLeave":
            case "onPointerCancel":
                return ()=>r([]);
            case "onLostPointerCapture":
                return (p)=>{
                    const { internal: m } = a.getState();
                    "pointerId" in p && m.capturedMap.has(p.pointerId) && requestAnimationFrame(()=>{
                        m.capturedMap.has(p.pointerId) && (m.capturedMap.delete(p.pointerId), r([]));
                    });
                };
        }
        return function(m) {
            const { onPointerMissed: x, internal: v } = a.getState();
            v.lastEvent.current = m;
            const _ = f === "onPointerMove", S = f === "onClick" || f === "onContextMenu" || f === "onDoubleClick", M = n(m, _ ? t : void 0), b = S ? e(m) : 0;
            f === "onPointerDown" && (v.initialClick = [
                m.offsetX,
                m.offsetY
            ], v.initialHits = M.map((R)=>R.eventObject)), S && !M.length && b <= 2 && (l(m, v.interaction), x && x(m)), _ && r(M);
            function C(R) {
                const N = R.eventObject, z = N.__r3f;
                if (!(z != null && z.eventCount)) return;
                const L = z.handlers;
                if (_) {
                    if (L.onPointerOver || L.onPointerEnter || L.onPointerOut || L.onPointerLeave) {
                        const P = $455d545b1dff00eb$var$Ix(R), H = v.hovered.get(P);
                        H ? H.stopped && R.stopPropagation() : (v.hovered.set(P, R), L.onPointerOver == null || L.onPointerOver(R), L.onPointerEnter == null || L.onPointerEnter(R));
                    }
                    L.onPointerMove == null || L.onPointerMove(R);
                } else {
                    const P = L[f];
                    P ? (!S || v.initialHits.includes(N)) && (l(m, v.interaction.filter((H)=>!v.initialHits.includes(H))), P(R)) : S && v.initialHits.includes(N) && l(m, v.interaction.filter((H)=>!v.initialHits.includes(H)));
                }
            }
            i(M, m, b, C);
        };
    }
    return {
        handlePointer: c
    };
}
const $455d545b1dff00eb$var$D3 = (a)=>!!(a != null && a.render), $455d545b1dff00eb$var$BA = $455d545b1dff00eb$var$X.createContext(null), $455d545b1dff00eb$var$EB = (a, e)=>{
    const t = $455d545b1dff00eb$var$qP((c, f)=>{
        const p = new $455d545b1dff00eb$var$J, m = new $455d545b1dff00eb$var$J, x = new $455d545b1dff00eb$var$J;
        function v(b = f().camera, C = m, R = f().size) {
            const { width: N, height: z, top: L, left: P } = R, H = N / z;
            C.isVector3 ? x.copy(C) : x.set(...C);
            const O = b.getWorldPosition(p).distanceTo(x);
            if ($455d545b1dff00eb$var$NA(b)) return {
                width: N / b.zoom,
                height: z / b.zoom,
                top: L,
                left: P,
                factor: 1,
                distance: O,
                aspect: H
            };
            {
                const D = b.fov * Math.PI / 180, j = 2 * Math.tan(D / 2) * O, G = j * (N / z);
                return {
                    width: G,
                    height: j,
                    top: L,
                    left: P,
                    factor: N / G,
                    distance: O,
                    aspect: H
                };
            }
        }
        let _;
        const S = (b)=>c((C)=>({
                    performance: {
                        ...C.performance,
                        current: b
                    }
                })), A = new $455d545b1dff00eb$var$$e;
        return {
            set: c,
            get: f,
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: !0,
                connected: !1
            },
            scene: null,
            xr: null,
            invalidate: (b = 1)=>a(f(), b),
            advance: (b, C)=>e(b, C, f()),
            legacy: !1,
            linear: !1,
            flat: !1,
            controls: null,
            clock: new $455d545b1dff00eb$var$cS,
            pointer: A,
            mouse: A,
            frameloop: "always",
            onPointerMissed: void 0,
            performance: {
                current: 1,
                min: .5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const b = f();
                    _ && clearTimeout(_), b.performance.current !== b.performance.min && S(b.performance.min), _ = setTimeout(()=>S(f().performance.max), b.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: v
            },
            setEvents: (b)=>c((C)=>({
                        ...C,
                        events: {
                            ...C.events,
                            ...b
                        }
                    })),
            setSize: (b, C, R = 0, N = 0)=>{
                const z = f().camera, L = {
                    width: b,
                    height: C,
                    top: R,
                    left: N
                };
                c((P)=>({
                        size: L,
                        viewport: {
                            ...P.viewport,
                            ...v(z, m, L)
                        }
                    }));
            },
            setDpr: (b)=>c((C)=>{
                    const R = $455d545b1dff00eb$var$LA(b);
                    return {
                        viewport: {
                            ...C.viewport,
                            dpr: R,
                            initialDpr: C.viewport.initialDpr || R
                        }
                    };
                }),
            setFrameloop: (b = "always")=>{
                const C = f().clock;
                C.stop(), C.elapsedTime = 0, b !== "never" && (C.start(), C.elapsedTime = 0), c(()=>({
                        frameloop: b
                    }));
            },
            previousRoot: void 0,
            internal: {
                interaction: [],
                hovered: new Map,
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map,
                lastEvent: $455d545b1dff00eb$var$X.createRef(),
                active: !1,
                frames: 0,
                priority: 0,
                subscribe: (b, C, R)=>{
                    const N = f().internal;
                    return N.priority = N.priority + (C > 0 ? 1 : 0), N.subscribers.push({
                        ref: b,
                        priority: C,
                        store: R
                    }), N.subscribers = N.subscribers.sort((z, L)=>z.priority - L.priority), ()=>{
                        const z = f().internal;
                        z != null && z.subscribers && (z.priority = z.priority - (C > 0 ? 1 : 0), z.subscribers = z.subscribers.filter((L)=>L.ref !== b));
                    };
                }
            }
        };
    }), n = t.getState();
    let i = n.size, r = n.viewport.dpr, l = n.camera;
    return t.subscribe(()=>{
        const { camera: c, size: f, viewport: p, gl: m, set: x } = t.getState();
        if (f.width !== i.width || f.height !== i.height || p.dpr !== r) {
            i = f, r = p.dpr, $455d545b1dff00eb$var$bB(c, f), p.dpr > 0 && m.setPixelRatio(p.dpr);
            const v = typeof HTMLCanvasElement < "u" && m.domElement instanceof HTMLCanvasElement;
            m.setSize(f.width, f.height, v);
        }
        c !== l && (l = c, x((v)=>({
                viewport: {
                    ...v.viewport,
                    ...v.viewport.getCurrentViewport(c)
                }
            })));
    }), t.subscribe((c)=>a(c)), t;
};
function $455d545b1dff00eb$var$IA() {
    const a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$BA);
    if (!a) throw new Error("R3F: Hooks can only be used within the Canvas component!");
    return a;
}
function $455d545b1dff00eb$var$Ei(a = (t)=>t, e) {
    return $455d545b1dff00eb$var$IA()(a, e);
}
function $455d545b1dff00eb$var$Zs(a, e = 0) {
    const t = $455d545b1dff00eb$var$IA(), n = t.getState().internal.subscribe, i = $455d545b1dff00eb$var$OA(a);
    return $455d545b1dff00eb$var$U0(()=>n(i, e, t), [
        e,
        n,
        t
    ]), null;
}
function $455d545b1dff00eb$var$TB(a) {
    const e = $455d545b1dff00eb$var$iB(a);
    return e.injectIntoDevTools({
        bundleType: 0,
        rendererPackageName: "@react-three/fiber",
        version: $455d545b1dff00eb$var$X.version
    }), e;
}
const $455d545b1dff00eb$var$FA = 0, $455d545b1dff00eb$var$kd = {}, $455d545b1dff00eb$var$AB = /^three(?=[A-Z])/, $455d545b1dff00eb$var$Fy = (a)=>`${a[0].toUpperCase()}${a.slice(1)}`;
let $455d545b1dff00eb$var$wB = 0;
const $455d545b1dff00eb$var$CB = (a)=>typeof a == "function";
function $455d545b1dff00eb$var$RB(a) {
    if ($455d545b1dff00eb$var$CB(a)) {
        const e = `${$455d545b1dff00eb$var$wB++}`;
        return $455d545b1dff00eb$var$kd[e] = a, e;
    } else Object.assign($455d545b1dff00eb$var$kd, a);
}
function $455d545b1dff00eb$var$HA(a, e) {
    const t = $455d545b1dff00eb$var$Fy(a), n = $455d545b1dff00eb$var$kd[t];
    if (a !== "primitive" && !n) throw new Error(`R3F: ${t} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
    if (a === "primitive" && !e.object) throw new Error("R3F: Primitives without 'object' are invalid!");
    if (e.args !== void 0 && !Array.isArray(e.args)) throw new Error("R3F: The args prop must be an array!");
}
function $455d545b1dff00eb$var$DB(a, e, t) {
    var n;
    return a = $455d545b1dff00eb$var$Fy(a) in $455d545b1dff00eb$var$kd ? a : a.replace($455d545b1dff00eb$var$AB, ""), $455d545b1dff00eb$var$HA(a, e), a === "primitive" && (n = e.object) != null && n.__r3f && delete e.object.__r3f, $455d545b1dff00eb$var$kv(e.object, t, a, e);
}
function $455d545b1dff00eb$var$UB(a) {
    if (!a.isHidden) {
        var e;
        a.props.attach && (e = a.parent) != null && e.object ? $455d545b1dff00eb$var$Xv(a.parent, a) : $455d545b1dff00eb$var$Yr(a.object) && (a.object.visible = !1), a.isHidden = !0, $455d545b1dff00eb$var$Zd(a);
    }
}
function $455d545b1dff00eb$var$VA(a) {
    if (a.isHidden) {
        var e;
        a.props.attach && (e = a.parent) != null && e.object ? $455d545b1dff00eb$var$jv(a.parent, a) : $455d545b1dff00eb$var$Yr(a.object) && a.props.visible !== !1 && (a.object.visible = !0), a.isHidden = !1, $455d545b1dff00eb$var$Zd(a);
    }
}
function $455d545b1dff00eb$var$yS(a, e, t) {
    const n = e.root.getState();
    if (!(!a.parent && a.object !== n.scene)) {
        if (!e.object) {
            var i, r;
            const l = $455d545b1dff00eb$var$kd[$455d545b1dff00eb$var$Fy(e.type)];
            e.object = (i = e.props.object) != null ? i : new l(...(r = e.props.args) != null ? r : []), e.object.__r3f = e;
        }
        if ($455d545b1dff00eb$var$yu(e.object, e.props), e.props.attach) $455d545b1dff00eb$var$jv(a, e);
        else if ($455d545b1dff00eb$var$Yr(e.object) && $455d545b1dff00eb$var$Yr(a.object)) {
            const l = a.object.children.indexOf(t?.object);
            if (t && l !== -1) {
                const c = a.object.children.indexOf(e.object);
                if (c !== -1) {
                    a.object.children.splice(c, 1);
                    const f = c < l ? l - 1 : l;
                    a.object.children.splice(f, 0, e.object);
                } else e.object.parent = a.object, a.object.children.splice(l, 0, e.object), e.object.dispatchEvent({
                    type: "added"
                }), a.object.dispatchEvent({
                    type: "childadded",
                    child: e.object
                });
            } else a.object.add(e.object);
        }
        for (const l of e.children)$455d545b1dff00eb$var$yS(e, l);
        $455d545b1dff00eb$var$Zd(e);
    }
}
function $455d545b1dff00eb$var$D_(a, e) {
    e && (e.parent = a, a.children.push(e), $455d545b1dff00eb$var$yS(a, e));
}
function $455d545b1dff00eb$var$U3(a, e, t) {
    if (!e || !t) return;
    e.parent = a;
    const n = a.children.indexOf(t);
    n !== -1 ? a.children.splice(n, 0, e) : a.children.push(e), $455d545b1dff00eb$var$yS(a, e, t);
}
function $455d545b1dff00eb$var$GA(a) {
    if (typeof a.dispose == "function") {
        const e = ()=>{
            try {
                a.dispose();
            } catch  {}
        };
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? e() : $455d545b1dff00eb$var$w3.unstable_scheduleCallback($455d545b1dff00eb$var$w3.unstable_IdlePriority, e);
    }
}
function $455d545b1dff00eb$var$ub(a, e, t) {
    if (!e) return;
    e.parent = null;
    const n = a.children.indexOf(e);
    n !== -1 && a.children.splice(n, 1), e.props.attach ? $455d545b1dff00eb$var$Xv(a, e) : $455d545b1dff00eb$var$Yr(e.object) && $455d545b1dff00eb$var$Yr(a.object) && (a.object.remove(e.object), $455d545b1dff00eb$var$SB($455d545b1dff00eb$var$UA(e), e.object));
    const i = e.props.dispose !== null && t !== !1;
    for(let r = e.children.length - 1; r >= 0; r--){
        const l = e.children[r];
        $455d545b1dff00eb$var$ub(e, l, i);
    }
    e.children.length = 0, delete e.object.__r3f, i && e.type !== "primitive" && e.object.type !== "Scene" && $455d545b1dff00eb$var$GA(e.object), t === void 0 && $455d545b1dff00eb$var$Zd(e);
}
function $455d545b1dff00eb$var$NB(a, e) {
    for (const t of [
        a,
        a.alternate
    ])if (t !== null) {
        if (typeof t.ref == "function") {
            t.refCleanup == null || t.refCleanup();
            const n = t.ref(e);
            typeof n == "function" && (t.refCleanup = n);
        } else t.ref && (t.ref.current = e);
    }
}
const $455d545b1dff00eb$var$Qx = [];
function $455d545b1dff00eb$var$OB() {
    for (const [t] of $455d545b1dff00eb$var$Qx){
        const n = t.parent;
        if (n) {
            t.props.attach ? $455d545b1dff00eb$var$Xv(n, t) : $455d545b1dff00eb$var$Yr(t.object) && $455d545b1dff00eb$var$Yr(n.object) && n.object.remove(t.object);
            for (const i of t.children)i.props.attach ? $455d545b1dff00eb$var$Xv(t, i) : $455d545b1dff00eb$var$Yr(i.object) && $455d545b1dff00eb$var$Yr(t.object) && t.object.remove(i.object);
        }
        t.isHidden && $455d545b1dff00eb$var$VA(t), t.object.__r3f && delete t.object.__r3f, t.type !== "primitive" && $455d545b1dff00eb$var$GA(t.object);
    }
    for (const [t, n, i] of $455d545b1dff00eb$var$Qx){
        t.props = n;
        const r = t.parent;
        if (r) {
            var a, e;
            const l = $455d545b1dff00eb$var$kd[$455d545b1dff00eb$var$Fy(t.type)];
            t.object = (a = t.props.object) != null ? a : new l(...(e = t.props.args) != null ? e : []), t.object.__r3f = t, $455d545b1dff00eb$var$NB(i, t.object), $455d545b1dff00eb$var$yu(t.object, t.props), t.props.attach ? $455d545b1dff00eb$var$jv(r, t) : $455d545b1dff00eb$var$Yr(t.object) && $455d545b1dff00eb$var$Yr(r.object) && r.object.add(t.object);
            for (const c of t.children)c.props.attach ? $455d545b1dff00eb$var$jv(t, c) : $455d545b1dff00eb$var$Yr(c.object) && $455d545b1dff00eb$var$Yr(t.object) && t.object.add(c.object);
            $455d545b1dff00eb$var$Zd(t);
        }
    }
    $455d545b1dff00eb$var$Qx.length = 0;
}
const $455d545b1dff00eb$var$U_ = ()=>{}, $455d545b1dff00eb$var$N3 = {};
let $455d545b1dff00eb$var$Fx = $455d545b1dff00eb$var$FA;
const $455d545b1dff00eb$var$LB = 0, $455d545b1dff00eb$var$zB = 4, $455d545b1dff00eb$var$fb = $455d545b1dff00eb$var$TB({
    isPrimaryRenderer: !1,
    warnsIfNotActing: !1,
    supportsMutation: !0,
    supportsPersistence: !1,
    supportsHydration: !1,
    createInstance: $455d545b1dff00eb$var$DB,
    removeChild: $455d545b1dff00eb$var$ub,
    appendChild: $455d545b1dff00eb$var$D_,
    appendInitialChild: $455d545b1dff00eb$var$D_,
    insertBefore: $455d545b1dff00eb$var$U3,
    appendChildToContainer (a, e) {
        const t = a.getState().scene.__r3f;
        !e || !t || $455d545b1dff00eb$var$D_(t, e);
    },
    removeChildFromContainer (a, e) {
        const t = a.getState().scene.__r3f;
        !e || !t || $455d545b1dff00eb$var$ub(t, e);
    },
    insertInContainerBefore (a, e, t) {
        const n = a.getState().scene.__r3f;
        !e || !t || !n || $455d545b1dff00eb$var$U3(n, e, t);
    },
    getRootHostContext: ()=>$455d545b1dff00eb$var$N3,
    getChildHostContext: ()=>$455d545b1dff00eb$var$N3,
    commitUpdate (a, e, t, n, i) {
        var r, l, c;
        $455d545b1dff00eb$var$HA(e, n);
        let f = !1;
        if ((a.type === "primitive" && t.object !== n.object || ((r = n.args) == null ? void 0 : r.length) !== ((l = t.args) == null ? void 0 : l.length) || (c = n.args) != null && c.some((m, x)=>{
            var v;
            return m !== ((v = t.args) == null ? void 0 : v[x]);
        })) && (f = !0), f) $455d545b1dff00eb$var$Qx.push([
            a,
            {
                ...n
            },
            i
        ]);
        else {
            const m = $455d545b1dff00eb$var$vB(a, n);
            Object.keys(m).length && (Object.assign(a.props, m), $455d545b1dff00eb$var$yu(a.object, m));
        }
        (i.sibling === null || (i.flags & $455d545b1dff00eb$var$zB) === $455d545b1dff00eb$var$LB) && $455d545b1dff00eb$var$OB();
    },
    finalizeInitialChildren: ()=>!1,
    commitMount () {},
    getPublicInstance: (a)=>a?.object,
    prepareForCommit: ()=>null,
    preparePortalMount: (a)=>$455d545b1dff00eb$var$kv(a.getState().scene, a, "", {}),
    resetAfterCommit: ()=>{},
    shouldSetTextContent: ()=>!1,
    clearContainer: ()=>!1,
    hideInstance: $455d545b1dff00eb$var$UB,
    unhideInstance: $455d545b1dff00eb$var$VA,
    createTextInstance: $455d545b1dff00eb$var$U_,
    hideTextInstance: $455d545b1dff00eb$var$U_,
    unhideTextInstance: $455d545b1dff00eb$var$U_,
    scheduleTimeout: typeof setTimeout == "function" ? setTimeout : void 0,
    cancelTimeout: typeof clearTimeout == "function" ? clearTimeout : void 0,
    noTimeout: -1,
    getInstanceFromNode: ()=>null,
    beforeActiveInstanceBlur () {},
    afterActiveInstanceBlur () {},
    detachDeletedInstance () {},
    prepareScopeUpdate () {},
    getInstanceFromScope: ()=>null,
    shouldAttemptEagerTransition: ()=>!1,
    trackSchedulerEvent: ()=>{},
    resolveEventType: ()=>null,
    resolveEventTimeStamp: ()=>-1.1,
    requestPostPaintCallback () {},
    maySuspendCommit: ()=>!1,
    preloadInstance: ()=>!0,
    startSuspendingCommit () {},
    suspendInstance () {},
    waitForCommitToBeReady: ()=>null,
    NotPendingTransition: null,
    HostTransitionContext: $455d545b1dff00eb$var$X.createContext(null),
    setCurrentUpdatePriority (a) {
        $455d545b1dff00eb$var$Fx = a;
    },
    getCurrentUpdatePriority () {
        return $455d545b1dff00eb$var$Fx;
    },
    resolveUpdatePriority () {
        var a;
        if ($455d545b1dff00eb$var$Fx !== $455d545b1dff00eb$var$FA) return $455d545b1dff00eb$var$Fx;
        switch(typeof window < "u" && ((a = window.event) == null ? void 0 : a.type)){
            case "click":
            case "contextmenu":
            case "dblclick":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
                return $455d545b1dff00eb$var$Zx.DiscreteEventPriority;
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerenter":
            case "pointerleave":
            case "wheel":
                return $455d545b1dff00eb$var$Zx.ContinuousEventPriority;
            default:
                return $455d545b1dff00eb$var$Zx.DefaultEventPriority;
        }
    },
    resetFormInstance () {}
}), $455d545b1dff00eb$var$Yf = new Map, $455d545b1dff00eb$var$Md = {
    objects: "shallow",
    strict: !1
};
function $455d545b1dff00eb$var$PB(a, e) {
    if (!e && typeof HTMLCanvasElement < "u" && a instanceof HTMLCanvasElement && a.parentElement) {
        const { width: t, height: n, top: i, left: r } = a.parentElement.getBoundingClientRect();
        return {
            width: t,
            height: n,
            top: i,
            left: r
        };
    } else if (!e && typeof OffscreenCanvas < "u" && a instanceof OffscreenCanvas) return {
        width: a.width,
        height: a.height,
        top: 0,
        left: 0
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        ...e
    };
}
function $455d545b1dff00eb$var$BB(a) {
    const e = $455d545b1dff00eb$var$Yf.get(a), t = e?.fiber, n = e?.store;
    e && console.warn("R3F.createRoot should only be called once!");
    const i = typeof reportError == "function" ? reportError : console.error, r = n || $455d545b1dff00eb$var$EB($455d545b1dff00eb$var$pb, $455d545b1dff00eb$var$L3), l = t || $455d545b1dff00eb$var$fb.createContainer(r, $455d545b1dff00eb$var$Zx.ConcurrentRoot, null, !1, null, "", i, i, i, null);
    e || $455d545b1dff00eb$var$Yf.set(a, {
        fiber: l,
        store: r
    });
    let c, f, p = !1, m = null;
    return {
        async configure (x = {}) {
            let v;
            m = new Promise((I)=>v = I);
            let { gl: _, size: S, scene: A, events: M, onCreated: b, shadows: C = !1, linear: R = !1, flat: N = !1, legacy: z = !1, orthographic: L = !1, frameloop: P = "always", dpr: H = [
                1,
                2
            ], performance: O, raycaster: D, camera: j, onPointerMissed: G } = x, q = r.getState(), Y = q.gl;
            if (!q.gl) {
                const I = {
                    canvas: a,
                    powerPreference: "high-performance",
                    antialias: !0,
                    alpha: !0
                }, Z = typeof _ == "function" ? await _(I) : _;
                $455d545b1dff00eb$var$D3(Z) ? Y = Z : Y = new $455d545b1dff00eb$var$wA({
                    ...I,
                    ..._
                }), q.set({
                    gl: Y
                });
            }
            let ae = q.raycaster;
            ae || q.set({
                raycaster: ae = new $455d545b1dff00eb$var$dS
            });
            const { params: F, ...Q } = D || {};
            if ($455d545b1dff00eb$var$Di.equ(Q, ae, $455d545b1dff00eb$var$Md) || $455d545b1dff00eb$var$yu(ae, {
                ...Q
            }), $455d545b1dff00eb$var$Di.equ(F, ae.params, $455d545b1dff00eb$var$Md) || $455d545b1dff00eb$var$yu(ae, {
                params: {
                    ...ae.params,
                    ...F
                }
            }), !q.camera || q.camera === f && !$455d545b1dff00eb$var$Di.equ(f, j, $455d545b1dff00eb$var$Md)) {
                f = j;
                const I = j?.isCamera, Z = I ? j : L ? new $455d545b1dff00eb$var$bl(0, 0, 0, 0, .1, 1e3) : new $455d545b1dff00eb$var$Ui(75, 0, .1, 1e3);
                I || (Z.position.z = 5, j && ($455d545b1dff00eb$var$yu(Z, j), Z.manual || ("aspect" in j || "left" in j || "right" in j || "bottom" in j || "top" in j) && (Z.manual = !0, Z.updateProjectionMatrix())), !q.camera && !(j != null && j.rotation) && Z.lookAt(0, 0, 0)), q.set({
                    camera: Z
                }), ae.camera = Z;
            }
            if (!q.scene) {
                let I;
                A != null && A.isScene ? (I = A, $455d545b1dff00eb$var$kv(I, r, "", {})) : (I = new $455d545b1dff00eb$var$Xb, $455d545b1dff00eb$var$kv(I, r, "", {}), A && $455d545b1dff00eb$var$yu(I, A)), q.set({
                    scene: I
                });
            }
            M && !q.events.handlers && q.set({
                events: M(r)
            });
            const K = $455d545b1dff00eb$var$PB(a, S);
            if ($455d545b1dff00eb$var$Di.equ(K, q.size, $455d545b1dff00eb$var$Md) || q.setSize(K.width, K.height, K.top, K.left), H && q.viewport.dpr !== $455d545b1dff00eb$var$LA(H) && q.setDpr(H), q.frameloop !== P && q.setFrameloop(P), q.onPointerMissed || q.set({
                onPointerMissed: G
            }), O && !$455d545b1dff00eb$var$Di.equ(O, q.performance, $455d545b1dff00eb$var$Md) && q.set((I)=>({
                    performance: {
                        ...I.performance,
                        ...O
                    }
                })), !q.xr) {
                var $;
                const I = (ce, de)=>{
                    const ue = r.getState();
                    ue.frameloop !== "never" && $455d545b1dff00eb$var$L3(ce, !0, ue, de);
                }, Z = ()=>{
                    const ce = r.getState();
                    ce.gl.xr.enabled = ce.gl.xr.isPresenting, ce.gl.xr.setAnimationLoop(ce.gl.xr.isPresenting ? I : null), ce.gl.xr.isPresenting || $455d545b1dff00eb$var$pb(ce);
                }, oe = {
                    connect () {
                        const ce = r.getState().gl;
                        ce.xr.addEventListener("sessionstart", Z), ce.xr.addEventListener("sessionend", Z);
                    },
                    disconnect () {
                        const ce = r.getState().gl;
                        ce.xr.removeEventListener("sessionstart", Z), ce.xr.removeEventListener("sessionend", Z);
                    }
                };
                typeof (($ = Y.xr) == null ? void 0 : $.addEventListener) == "function" && oe.connect(), q.set({
                    xr: oe
                });
            }
            if (Y.shadowMap) {
                const I = Y.shadowMap.enabled, Z = Y.shadowMap.type;
                if (Y.shadowMap.enabled = !!C, $455d545b1dff00eb$var$Di.boo(C)) Y.shadowMap.type = $455d545b1dff00eb$var$Im;
                else if ($455d545b1dff00eb$var$Di.str(C)) {
                    var ee;
                    const oe = {
                        basic: $455d545b1dff00eb$var$NE,
                        percentage: $455d545b1dff00eb$var$ey,
                        soft: $455d545b1dff00eb$var$Im,
                        variance: $455d545b1dff00eb$var$Ao
                    };
                    Y.shadowMap.type = (ee = oe[C]) != null ? ee : $455d545b1dff00eb$var$Im;
                } else $455d545b1dff00eb$var$Di.obj(C) && Object.assign(Y.shadowMap, C);
                (I !== Y.shadowMap.enabled || Z !== Y.shadowMap.type) && (Y.shadowMap.needsUpdate = !0);
            }
            return $455d545b1dff00eb$var$Dn.enabled = !z, p || (Y.outputColorSpace = R ? $455d545b1dff00eb$var$No : $455d545b1dff00eb$var$nr, Y.toneMapping = N ? $455d545b1dff00eb$var$_l : $455d545b1dff00eb$var$Rb), q.legacy !== z && q.set(()=>({
                    legacy: z
                })), q.linear !== R && q.set(()=>({
                    linear: R
                })), q.flat !== N && q.set(()=>({
                    flat: N
                })), _ && !$455d545b1dff00eb$var$Di.fun(_) && !$455d545b1dff00eb$var$D3(_) && !$455d545b1dff00eb$var$Di.equ(_, Y, $455d545b1dff00eb$var$Md) && $455d545b1dff00eb$var$yu(Y, _), c = b, p = !0, v(), this;
        },
        render (x) {
            return !p && !m && this.configure(), m.then(()=>{
                $455d545b1dff00eb$var$fb.updateContainer($455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$IB, {
                    store: r,
                    children: x,
                    onCreated: c,
                    rootElement: a
                }), l, null, ()=>{});
            }), r;
        },
        unmount () {
            $455d545b1dff00eb$var$kA(a);
        }
    };
}
function $455d545b1dff00eb$var$IB({ store: a, children: e, onCreated: t, rootElement: n }) {
    return $455d545b1dff00eb$var$U0(()=>{
        const i = a.getState();
        i.set((r)=>({
                internal: {
                    ...r.internal,
                    active: !0
                }
            })), t && t(i), a.getState().events.connected || i.events.connect == null || i.events.connect(n);
    }, []), $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$BA.Provider, {
        value: a,
        children: e
    });
}
function $455d545b1dff00eb$var$kA(a, e) {
    const t = $455d545b1dff00eb$var$Yf.get(a), n = t?.fiber;
    if (n) {
        const i = t?.store.getState();
        i && (i.internal.active = !1), $455d545b1dff00eb$var$fb.updateContainer(null, n, null, ()=>{
            i && setTimeout(()=>{
                try {
                    var r, l, c, f;
                    i.events.disconnect == null || i.events.disconnect(), (r = i.gl) == null || (l = r.renderLists) == null || l.dispose == null || l.dispose(), (c = i.gl) == null || c.forceContextLoss == null || c.forceContextLoss(), (f = i.gl) != null && f.xr && i.xr.disconnect(), $455d545b1dff00eb$var$mB(i.scene), $455d545b1dff00eb$var$Yf.delete(a);
                } catch  {}
            }, 500);
        });
    }
}
const $455d545b1dff00eb$var$FB = new Set, $455d545b1dff00eb$var$HB = new Set, $455d545b1dff00eb$var$VB = new Set;
function $455d545b1dff00eb$var$N_(a, e) {
    if (a.size) for (const { callback: t } of a.values())t(e);
}
function $455d545b1dff00eb$var$qm(a, e) {
    switch(a){
        case "before":
            return $455d545b1dff00eb$var$N_($455d545b1dff00eb$var$FB, e);
        case "after":
            return $455d545b1dff00eb$var$N_($455d545b1dff00eb$var$HB, e);
        case "tail":
            return $455d545b1dff00eb$var$N_($455d545b1dff00eb$var$VB, e);
    }
}
let $455d545b1dff00eb$var$O_, $455d545b1dff00eb$var$L_;
function $455d545b1dff00eb$var$hb(a, e, t) {
    let n = e.clock.getDelta();
    e.frameloop === "never" && typeof a == "number" && (n = a - e.clock.elapsedTime, e.clock.oldTime = e.clock.elapsedTime, e.clock.elapsedTime = a), $455d545b1dff00eb$var$O_ = e.internal.subscribers;
    for(let i = 0; i < $455d545b1dff00eb$var$O_.length; i++)$455d545b1dff00eb$var$L_ = $455d545b1dff00eb$var$O_[i], $455d545b1dff00eb$var$L_.ref.current($455d545b1dff00eb$var$L_.store.getState(), n, t);
    return !e.internal.priority && e.gl.render && e.gl.render(e.scene, e.camera), e.internal.frames = Math.max(0, e.internal.frames - 1), e.frameloop === "always" ? 1 : e.internal.frames;
}
let $455d545b1dff00eb$var$Wv = !1, $455d545b1dff00eb$var$db = !1, $455d545b1dff00eb$var$z_, $455d545b1dff00eb$var$O3, $455d545b1dff00eb$var$Ed;
function $455d545b1dff00eb$var$jA(a) {
    $455d545b1dff00eb$var$O3 = requestAnimationFrame($455d545b1dff00eb$var$jA), $455d545b1dff00eb$var$Wv = !0, $455d545b1dff00eb$var$z_ = 0, $455d545b1dff00eb$var$qm("before", a), $455d545b1dff00eb$var$db = !0;
    for (const t of $455d545b1dff00eb$var$Yf.values()){
        var e;
        $455d545b1dff00eb$var$Ed = t.store.getState(), $455d545b1dff00eb$var$Ed.internal.active && ($455d545b1dff00eb$var$Ed.frameloop === "always" || $455d545b1dff00eb$var$Ed.internal.frames > 0) && !((e = $455d545b1dff00eb$var$Ed.gl.xr) != null && e.isPresenting) && ($455d545b1dff00eb$var$z_ += $455d545b1dff00eb$var$hb(a, $455d545b1dff00eb$var$Ed));
    }
    if ($455d545b1dff00eb$var$db = !1, $455d545b1dff00eb$var$qm("after", a), $455d545b1dff00eb$var$z_ === 0) return $455d545b1dff00eb$var$qm("tail", a), $455d545b1dff00eb$var$Wv = !1, cancelAnimationFrame($455d545b1dff00eb$var$O3);
}
function $455d545b1dff00eb$var$pb(a, e = 1) {
    var t;
    if (!a) return $455d545b1dff00eb$var$Yf.forEach((n)=>$455d545b1dff00eb$var$pb(n.store.getState(), e));
    (t = a.gl.xr) != null && t.isPresenting || !a.internal.active || a.frameloop === "never" || (e > 1 ? a.internal.frames = Math.min(60, a.internal.frames + e) : $455d545b1dff00eb$var$db ? a.internal.frames = 2 : a.internal.frames = 1, $455d545b1dff00eb$var$Wv || ($455d545b1dff00eb$var$Wv = !0, requestAnimationFrame($455d545b1dff00eb$var$jA)));
}
function $455d545b1dff00eb$var$L3(a, e = !0, t, n) {
    if (e && $455d545b1dff00eb$var$qm("before", a), t) $455d545b1dff00eb$var$hb(a, t, n);
    else for (const i of $455d545b1dff00eb$var$Yf.values())$455d545b1dff00eb$var$hb(a, i.store.getState());
    e && $455d545b1dff00eb$var$qm("after", a);
}
const $455d545b1dff00eb$var$P_ = {
    onClick: [
        "click",
        !1
    ],
    onContextMenu: [
        "contextmenu",
        !1
    ],
    onDoubleClick: [
        "dblclick",
        !1
    ],
    onWheel: [
        "wheel",
        !0
    ],
    onPointerDown: [
        "pointerdown",
        !0
    ],
    onPointerUp: [
        "pointerup",
        !0
    ],
    onPointerLeave: [
        "pointerleave",
        !0
    ],
    onPointerMove: [
        "pointermove",
        !0
    ],
    onPointerCancel: [
        "pointercancel",
        !0
    ],
    onLostPointerCapture: [
        "lostpointercapture",
        !0
    ]
};
function $455d545b1dff00eb$var$GB(a) {
    const { handlePointer: e } = $455d545b1dff00eb$var$MB(a);
    return {
        priority: 1,
        enabled: !0,
        compute (t, n, i) {
            n.pointer.set(t.offsetX / n.size.width * 2 - 1, -(t.offsetY / n.size.height) * 2 + 1), n.raycaster.setFromCamera(n.pointer, n.camera);
        },
        connected: void 0,
        handlers: Object.keys($455d545b1dff00eb$var$P_).reduce((t, n)=>({
                ...t,
                [n]: e(n)
            }), {}),
        update: ()=>{
            var t;
            const { events: n, internal: i } = a.getState();
            (t = i.lastEvent) != null && t.current && n.handlers && n.handlers.onPointerMove(i.lastEvent.current);
        },
        connect: (t)=>{
            const { set: n, events: i } = a.getState();
            if (i.disconnect == null || i.disconnect(), n((r)=>({
                    events: {
                        ...r.events,
                        connected: t
                    }
                })), i.handlers) for(const r in i.handlers){
                const l = i.handlers[r], [c, f] = $455d545b1dff00eb$var$P_[r];
                t.addEventListener(c, l, {
                    passive: f
                });
            }
        },
        disconnect: ()=>{
            const { set: t, events: n } = a.getState();
            if (n.connected) {
                if (n.handlers) for(const i in n.handlers){
                    const r = n.handlers[i], [l] = $455d545b1dff00eb$var$P_[i];
                    n.connected.removeEventListener(l, r);
                }
                t((i)=>({
                        events: {
                            ...i.events,
                            connected: void 0
                        }
                    }));
            }
        }
    };
}
function $455d545b1dff00eb$var$z3(a, e) {
    let t;
    return (...n)=>{
        window.clearTimeout(t), t = window.setTimeout(()=>a(...n), e);
    };
}
function $455d545b1dff00eb$var$kB({ debounce: a, scroll: e, polyfill: t, offsetSize: n } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const i = t || (typeof window > "u" ? class {
    } : window.ResizeObserver);
    if (!i) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [r, l] = $455d545b1dff00eb$var$X.useState({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), c = $455d545b1dff00eb$var$X.useRef({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: r,
        orientationHandler: null
    }), f = a ? typeof a == "number" ? a : a.scroll : null, p = a ? typeof a == "number" ? a : a.resize : null, m = $455d545b1dff00eb$var$X.useRef(!1);
    $455d545b1dff00eb$var$X.useEffect(()=>(m.current = !0, ()=>void (m.current = !1)));
    const [x, v, _] = $455d545b1dff00eb$var$X.useMemo(()=>{
        const b = ()=>{
            if (!c.current.element) return;
            const { left: C, top: R, width: N, height: z, bottom: L, right: P, x: H, y: O } = c.current.element.getBoundingClientRect(), D = {
                left: C,
                top: R,
                width: N,
                height: z,
                bottom: L,
                right: P,
                x: H,
                y: O
            };
            c.current.element instanceof HTMLElement && n && (D.height = c.current.element.offsetHeight, D.width = c.current.element.offsetWidth), Object.freeze(D), m.current && !$455d545b1dff00eb$var$qB(c.current.lastBounds, D) && l(c.current.lastBounds = D);
        };
        return [
            b,
            p ? $455d545b1dff00eb$var$z3(b, p) : b,
            f ? $455d545b1dff00eb$var$z3(b, f) : b
        ];
    }, [
        l,
        n,
        f,
        p
    ]);
    function S() {
        c.current.scrollContainers && (c.current.scrollContainers.forEach((b)=>b.removeEventListener("scroll", _, !0)), c.current.scrollContainers = null), c.current.resizeObserver && (c.current.resizeObserver.disconnect(), c.current.resizeObserver = null), c.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", c.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", c.current.orientationHandler));
    }
    function A() {
        c.current.element && (c.current.resizeObserver = new i(_), c.current.resizeObserver.observe(c.current.element), e && c.current.scrollContainers && c.current.scrollContainers.forEach((b)=>b.addEventListener("scroll", _, {
                capture: !0,
                passive: !0
            })), c.current.orientationHandler = ()=>{
            _();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", c.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", c.current.orientationHandler));
    }
    const M = (b)=>{
        !b || b === c.current.element || (S(), c.current.element = b, c.current.scrollContainers = $455d545b1dff00eb$var$XA(b), A());
    };
    return $455d545b1dff00eb$var$XB(_, !!e), $455d545b1dff00eb$var$jB(v), $455d545b1dff00eb$var$X.useEffect(()=>{
        S(), A();
    }, [
        e,
        _,
        v
    ]), $455d545b1dff00eb$var$X.useEffect(()=>S, []), [
        M,
        r,
        x
    ];
}
function $455d545b1dff00eb$var$jB(a) {
    $455d545b1dff00eb$var$X.useEffect(()=>{
        const e = a;
        return window.addEventListener("resize", e), ()=>void window.removeEventListener("resize", e);
    }, [
        a
    ]);
}
function $455d545b1dff00eb$var$XB(a, e) {
    $455d545b1dff00eb$var$X.useEffect(()=>{
        if (e) {
            const t = a;
            return window.addEventListener("scroll", t, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", t, !0);
        }
    }, [
        a,
        e
    ]);
}
function $455d545b1dff00eb$var$XA(a) {
    const e = [];
    if (!a || a === document.body) return e;
    const { overflow: t, overflowX: n, overflowY: i } = window.getComputedStyle(a);
    return [
        t,
        n,
        i
    ].some((r)=>r === "auto" || r === "scroll") && e.push(a), [
        ...e,
        ...$455d545b1dff00eb$var$XA(a.parentElement)
    ];
}
const $455d545b1dff00eb$var$WB = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $455d545b1dff00eb$var$qB = (a, e)=>$455d545b1dff00eb$var$WB.every((t)=>a[t] === e[t]);
function $455d545b1dff00eb$var$YB({ ref: a, children: e, fallback: t, resize: n, style: i, gl: r, events: l = $455d545b1dff00eb$var$GB, eventSource: c, eventPrefix: f, shadows: p, linear: m, flat: x, legacy: v, orthographic: _, frameloop: S, dpr: A, performance: M, raycaster: b, camera: C, scene: R, onPointerMissed: N, onCreated: z, ...L }) {
    $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$RB($455d545b1dff00eb$var$xP), []);
    const P = $455d545b1dff00eb$var$hB(), [H, O] = $455d545b1dff00eb$var$kB({
        scroll: !0,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...n
    }), D = $455d545b1dff00eb$var$X.useRef(null), j = $455d545b1dff00eb$var$X.useRef(null);
    $455d545b1dff00eb$var$X.useImperativeHandle(a, ()=>D.current);
    const G = $455d545b1dff00eb$var$OA(N), [q, Y] = $455d545b1dff00eb$var$X.useState(!1), [ae, F] = $455d545b1dff00eb$var$X.useState(!1);
    if (q) throw q;
    if (ae) throw ae;
    const Q = $455d545b1dff00eb$var$X.useRef(null);
    $455d545b1dff00eb$var$U0(()=>{
        const $ = D.current;
        if (O.width > 0 && O.height > 0 && $) {
            Q.current || (Q.current = $455d545b1dff00eb$var$BB($));
            async function ee() {
                await Q.current.configure({
                    gl: r,
                    scene: R,
                    events: l,
                    shadows: p,
                    linear: m,
                    flat: x,
                    legacy: v,
                    orthographic: _,
                    frameloop: S,
                    dpr: A,
                    performance: M,
                    raycaster: b,
                    camera: C,
                    size: O,
                    onPointerMissed: (...I)=>G.current == null ? void 0 : G.current(...I),
                    onCreated: (I)=>{
                        I.events.connect == null || I.events.connect(c ? $455d545b1dff00eb$var$uB(c) ? c.current : c : j.current), f && I.setEvents({
                            compute: (Z, oe)=>{
                                const ce = Z[f + "X"], de = Z[f + "Y"];
                                oe.pointer.set(ce / oe.size.width * 2 - 1, -(de / oe.size.height) * 2 + 1), oe.raycaster.setFromCamera(oe.pointer, oe.camera);
                            }
                        }), z?.(I);
                    }
                }), Q.current.render($455d545b1dff00eb$var$k.jsx(P, {
                    children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$pB, {
                        set: F,
                        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$X.Suspense, {
                            fallback: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$dB, {
                                set: Y
                            }),
                            children: e ?? null
                        })
                    })
                }));
            }
            ee();
        }
    }), $455d545b1dff00eb$var$X.useEffect(()=>{
        const $ = D.current;
        if ($) return ()=>$455d545b1dff00eb$var$kA($);
    }, []);
    const K = c ? "none" : "auto";
    return $455d545b1dff00eb$var$k.jsx("div", {
        ref: j,
        style: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: K,
            ...i
        },
        ...L,
        children: $455d545b1dff00eb$var$k.jsx("div", {
            ref: H,
            style: {
                width: "100%",
                height: "100%"
            },
            children: $455d545b1dff00eb$var$k.jsx("canvas", {
                ref: D,
                style: {
                    display: "block"
                },
                children: t
            })
        })
    });
}
function $455d545b1dff00eb$var$_S(a) {
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$RA, {
        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$YB, {
            ...a
        })
    });
}
const $455d545b1dff00eb$var$If = (a)=>`${Math.round(a.x)},${Math.round(a.y)},${Math.round(a.z)}`;
function $455d545b1dff00eb$var$ZB(a) {
    const e = {};
    return a.forEach((t, n)=>{
        e[$455d545b1dff00eb$var$If(t.normal)] = n;
    }), e;
}
const $455d545b1dff00eb$var$QB = (a)=>new $455d545b1dff00eb$var$Ft().copy(a).invert(), $455d545b1dff00eb$var$WA = (a)=>{
    const e = new $455d545b1dff00eb$var$Jt;
    return e.setFromMatrix4(a), e;
}, $455d545b1dff00eb$var$Ym = (a, e)=>{
    switch(e){
        case "UP":
            return a.up.clone();
        case "DOWN":
            return a.up.clone().negate();
        case "LEFT":
            return a.right.clone().negate();
        case "RIGHT":
        default:
            return a.right.clone();
    }
}, $455d545b1dff00eb$var$KB = (a, e)=>{
    switch(e){
        case "UP":
        case "DOWN":
            return a.right.clone();
        case "LEFT":
        case "RIGHT":
        default:
            return a.up.clone();
    }
};
function $455d545b1dff00eb$var$JB(a, e, t) {
    return a.map((n, i)=>{
        const r = {};
        return $455d545b1dff00eb$var$gS.forEach((l)=>{
            const c = $455d545b1dff00eb$var$Ym(n, l), f = t[$455d545b1dff00eb$var$If(c)];
            if (f === void 0) return;
            const p = e[f], m = $455d545b1dff00eb$var$QB(p), x = $455d545b1dff00eb$var$WA(m), _ = n.center.clone().add(c.clone().setLength($455d545b1dff00eb$var$AP)).clone().applyMatrix4(m), A = $455d545b1dff00eb$var$KB(n, l).clone().applyMatrix3(x).normalize(), M = m.clone().multiply(e[i]), b = n.normal.clone().applyMatrix3(x).normalize();
            r[l] = {
                parentFaceIndex: f,
                pivot: _,
                axis: A,
                connection: M,
                childNormal: b
            };
        }), r;
    });
}
function $455d545b1dff00eb$var$$B(a) {
    return a.map((e)=>{
        const t = new $455d545b1dff00eb$var$Ft;
        return t.compose(e.center.clone(), e.quaternion.clone(), new $455d545b1dff00eb$var$J(1, 1, 1)), t;
    });
}
const $455d545b1dff00eb$var$P3 = new $455d545b1dff00eb$var$J(0, 0, 1);
function $455d545b1dff00eb$var$B3(a, e, t) {
    const n = new $455d545b1dff00eb$var$Gn().setFromAxisAngle(a.axis, t * e), i = new $455d545b1dff00eb$var$Ft().makeRotationFromQuaternion(n), r = new $455d545b1dff00eb$var$Ft().makeTranslation(a.pivot.x, a.pivot.y, a.pivot.z), l = new $455d545b1dff00eb$var$Ft().makeTranslation(-a.pivot.x, -a.pivot.y, -a.pivot.z), f = r.clone().multiply(i).multiply(l).clone().multiply(a.connection), p = a.childNormal.clone().applyMatrix3($455d545b1dff00eb$var$WA(i)).normalize();
    return {
        childMatrix: f,
        rotatedNormal: p
    };
}
const $455d545b1dff00eb$var$eI = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$qv = new $455d545b1dff00eb$var$Jt;
function $455d545b1dff00eb$var$bS(a) {
    return $455d545b1dff00eb$var$qv.setFromMatrix4(a), $455d545b1dff00eb$var$eI.set(0, 0, 1).applyMatrix3($455d545b1dff00eb$var$qv).normalize().clone();
}
function $455d545b1dff00eb$var$qA(a) {
    const e = $455d545b1dff00eb$var$bS(a);
    $455d545b1dff00eb$var$qv.setFromMatrix4(a);
    const t = new $455d545b1dff00eb$var$J(1, 0, 0).applyMatrix3($455d545b1dff00eb$var$qv), n = t.sub(e.clone().multiplyScalar(t.dot(e))), i = n.lengthSq() < 1e-6 ? new $455d545b1dff00eb$var$J(0, 1, 0).cross(e).normalize() : n.normalize(), r = new $455d545b1dff00eb$var$J().crossVectors(e, i).normalize();
    return {
        normal: e,
        right: i,
        up: r
    };
}
function $455d545b1dff00eb$var$YA(a, e, t, n, i, r = 0) {
    if (t[a]) return t[a];
    const l = e[a];
    let c;
    if (!l.unfolded || l.parentFace === null || !l.direction) c = n[a].clone(), r !== 0 && (c = new $455d545b1dff00eb$var$Ft().makeRotationY(r).multiply(c));
    else {
        const f = i[a]?.[l.direction];
        if (!f) c = n[a].clone();
        else {
            const p = $455d545b1dff00eb$var$YA(f.parentFaceIndex, e, t, n, i, r).clone(), m = Math.PI / 2 * l.animProgress, x = $455d545b1dff00eb$var$B3(f, m, 1), v = $455d545b1dff00eb$var$B3(f, m, -1), _ = x.rotatedNormal.dot($455d545b1dff00eb$var$P3) >= v.rotatedNormal.dot($455d545b1dff00eb$var$P3) ? x : v;
            c = p.multiply(_.childMatrix);
        }
    }
    return t[a] = c, c;
}
function $455d545b1dff00eb$var$ZA(a, e, t, n = 0) {
    const i = new Array($455d545b1dff00eb$var$Do).fill(null);
    return a.map((r, l)=>$455d545b1dff00eb$var$YA(l, a, i, e, t, n).clone());
}
function $455d545b1dff00eb$var$tI({ target: a, position: e }) {
    const { camera: t } = $455d545b1dff00eb$var$Ei(), n = $455d545b1dff00eb$var$X.useRef(new $455d545b1dff00eb$var$J(...e)), i = $455d545b1dff00eb$var$X.useRef(new $455d545b1dff00eb$var$J(...a)), r = $455d545b1dff00eb$var$X.useRef(t.position.clone()), l = $455d545b1dff00eb$var$X.useRef(new $455d545b1dff00eb$var$J);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        n.current.set(...e), i.current.set(...a);
    }, [
        a,
        e
    ]), $455d545b1dff00eb$var$Zs(()=>{
        r.current.lerp(n.current, .05), t.position.copy(r.current), l.current.lerp(i.current, .05), t.lookAt(l.current);
    }), null;
}
function $455d545b1dff00eb$var$nI({ color: a, worldMatrix: e }) {
    const t = $455d545b1dff00eb$var$X.useRef(null), n = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J, []), i = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$Gn, []), r = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J(1, 1, 1), []);
    return $455d545b1dff00eb$var$Zs(()=>{
        t.current && (e.decompose(n, i, r), t.current.position.copy(n), t.current.quaternion.copy(i));
    }), $455d545b1dff00eb$var$k.jsxs("group", {
        ref: t,
        children: [
            $455d545b1dff00eb$var$k.jsxs("mesh", {
                children: [
                    $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                        args: [
                            $455d545b1dff00eb$var$pn,
                            $455d545b1dff00eb$var$pn
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                        color: a,
                        transparent: !0,
                        opacity: .85,
                        side: $455d545b1dff00eb$var$Ea
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("lineSegments", {
                children: [
                    $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                        args: [
                            new $455d545b1dff00eb$var$Jr($455d545b1dff00eb$var$pn, $455d545b1dff00eb$var$pn)
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                        color: "#000000",
                        opacity: 1,
                        transparent: !1,
                        linewidth: 2
                    })
                ]
            })
        ]
    });
}
function $455d545b1dff00eb$var$g0(a) {
    return a < .5 ? 2 * a * a : 1 - Math.pow(-2 * a + 2, 2) / 2;
}
function $455d545b1dff00eb$var$iI(a) {
    return a < .5 ? 4 * a * a * a : 1 - Math.pow(-2 * a + 2, 3) / 2;
}
const $455d545b1dff00eb$var$I3 = 5e3, $455d545b1dff00eb$var$Hx = $455d545b1dff00eb$var$Ur.map((a)=>({
        unfolded: !1,
        animProgress: 0,
        direction: null,
        gridX: 0,
        gridY: 0,
        parentFace: null,
        color: a
    }));
function $455d545b1dff00eb$var$aI({ coordinates: a, isAnimating: e, isPaused: t, isFolding: n, resetTrigger: i, onResetComplete: r, onAnimationComplete: l, faceBaseInfo: c, getDirectionVector: f, vectorKey: p, hingeConfig: m }) {
    const [x, v] = $455d545b1dff00eb$var$X.useState($455d545b1dff00eb$var$Hx), [_, S] = $455d545b1dff00eb$var$X.useState(!1), A = $455d545b1dff00eb$var$X.useRef(!1), M = $455d545b1dff00eb$var$X.useRef(!1), b = $455d545b1dff00eb$var$X.useRef(null), C = $455d545b1dff00eb$var$X.useRef(!1), R = $455d545b1dff00eb$var$X.useRef(!1), N = $455d545b1dff00eb$var$X.useRef(!1);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        M.current = t;
    }, [
        t
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        i && !C.current && (b.current !== null && (cancelAnimationFrame(b.current), b.current = null), $455d545b1dff00eb$var$X.startTransition(()=>{
            v($455d545b1dff00eb$var$Hx), S(!1);
        }), A.current = !1, M.current = !1, R.current = !1, r()), C.current = i;
    }, [
        i,
        r
    ]);
    const z = $455d545b1dff00eb$var$X.useCallback(async ()=>{
        if (A.current && e && !t) return;
        A.current = !0, S(!1), v($455d545b1dff00eb$var$Hx), M.current = !1, await new Promise((G)=>setTimeout(G, 100));
        const P = $455d545b1dff00eb$var$Ur.map((G, q)=>({
                unfolded: !0,
                animProgress: 0,
                direction: null,
                gridX: a[q]?.[0] || 0,
                gridY: a[q]?.[1] || 0,
                parentFace: null,
                color: G
            }));
        P[0].parentFace = null, P[0].direction = null;
        const H = new Set([
            0
        ]), O = [
            {
                faceIndex: 0,
                parentIndex: null
            }
        ];
        for(; O.length > 0;){
            const G = O.shift(), q = a[G.faceIndex], Y = [
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ],
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ]
            ];
            for (const ae of Y){
                const F = [
                    q[0] + ae[0],
                    q[1] + ae[1]
                ];
                for(let Q = 0; Q < 6; Q++){
                    if (H.has(Q)) continue;
                    const K = a[Q];
                    if (K[0] === F[0] && K[1] === F[1]) {
                        let $ = null;
                        for (const ee of [
                            "UP",
                            "DOWN",
                            "LEFT",
                            "RIGHT"
                        ]){
                            const I = m[Q]?.[ee];
                            if (I && I.parentFaceIndex === G.faceIndex) {
                                $ = ee;
                                break;
                            }
                        }
                        if (!$) {
                            const ee = c[G.faceIndex], I = c[Q];
                            for (const Z of [
                                "UP",
                                "DOWN",
                                "LEFT",
                                "RIGHT"
                            ]){
                                const oe = f(I, Z);
                                if (p(oe) === p(ee.normal)) {
                                    $ = Z;
                                    break;
                                }
                            }
                        }
                        $ && (P[Q].parentFace = G.faceIndex, P[Q].direction = $, H.add(Q), O.push({
                            faceIndex: Q,
                            parentIndex: G.faceIndex
                        }));
                        break;
                    }
                }
            }
        }
        v(P), await new Promise((G)=>setTimeout(G, 200));
        const D = Array.from({
            length: 6
        }, (G, q)=>q).filter((G)=>G !== 0 && P[G].parentFace !== null && P[G].direction !== null), j = (G)=>new Promise((q)=>{
                const Y = Date.now();
                let ae = 0, F = 0;
                const Q = ()=>{
                    if (M.current) {
                        F === 0 && (F = Date.now()), b.current = requestAnimationFrame(Q);
                        return;
                    }
                    F > 0 && (ae += Date.now() - F, F = 0);
                    const K = Date.now() - Y - ae, $ = Math.min(K / $455d545b1dff00eb$var$I3, 1), ee = $455d545b1dff00eb$var$g0($);
                    v((I)=>{
                        const Z = [
                            ...I
                        ];
                        return Z[G] && (Z[G] = {
                            ...Z[G],
                            animProgress: ee
                        }), Z;
                    }), $ < 1 ? b.current = requestAnimationFrame(Q) : (v((I)=>{
                        const Z = [
                            ...I
                        ];
                        return Z[G] && (Z[G] = {
                            ...Z[G],
                            animProgress: 1
                        }), Z;
                    }), q());
                };
                b.current = requestAnimationFrame(Q);
            });
        await Promise.all(D.map(j)), S(!0), l();
    }, [
        a,
        e,
        t,
        c,
        f,
        p,
        m,
        l
    ]), L = $455d545b1dff00eb$var$X.useCallback(async ()=>{
        S(!1), M.current = !1;
        const P = Array.from({
            length: 6
        }, (O, D)=>D).filter((O)=>O !== 0 && x[O].animProgress > 0);
        if (P.length === 0) {
            l();
            return;
        }
        const H = (O)=>new Promise((D)=>{
                const j = Date.now(), G = x[O].animProgress;
                let q = 0, Y = 0;
                const ae = ()=>{
                    if (M.current) {
                        Y === 0 && (Y = Date.now()), b.current = requestAnimationFrame(ae);
                        return;
                    }
                    Y > 0 && (q += Date.now() - Y, Y = 0);
                    const F = Date.now() - j - q, Q = Math.min(F / $455d545b1dff00eb$var$I3, 1), K = $455d545b1dff00eb$var$g0(Q), $ = G * (1 - K);
                    v((ee)=>{
                        const I = [
                            ...ee
                        ];
                        return I[O] && (I[O] = {
                            ...I[O],
                            animProgress: $
                        }), I;
                    }), Q < 1 ? b.current = requestAnimationFrame(ae) : (v((ee)=>{
                        const I = [
                            ...ee
                        ];
                        return I[O] && (I[O] = {
                            ...I[O],
                            animProgress: 0
                        }), I;
                    }), D());
                };
                b.current = requestAnimationFrame(ae);
            });
        await Promise.all(P.map(H)), v($455d545b1dff00eb$var$Hx), A.current = !1, R.current = !1, l();
    }, [
        x,
        l
    ]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        n && !N.current && e ? (N.current = !0, $455d545b1dff00eb$var$X.startTransition(()=>void L())) : n || (N.current = !1), e && !t && !n && !R.current ? (R.current = !0, $455d545b1dff00eb$var$X.startTransition(()=>void z())) : e || (R.current = !1);
    }, [
        e,
        t,
        n,
        z,
        L
    ]), $455d545b1dff00eb$var$X.useEffect(()=>()=>{
            b.current !== null && cancelAnimationFrame(b.current);
        }, []), {
        faceStates: x,
        isAnimationComplete: _
    };
}
function $455d545b1dff00eb$var$rI(a, e, t) {
    return $455d545b1dff00eb$var$X.useMemo(()=>{
        const n = [], i = new $455d545b1dff00eb$var$J, r = new $455d545b1dff00eb$var$Gn, l = new $455d545b1dff00eb$var$J;
        for(let P = 0; P < a.length; P++)a[P].decompose(i, r, l), n.push(i.clone());
        if (n.length === 0) return {
            center: [
                0,
                0,
                0
            ],
            cameraPosition: [
                0,
                0,
                12
            ]
        };
        const c = n.map((P)=>P.x), f = n.map((P)=>P.y), p = n.map((P)=>P.z), m = Math.min(...c), x = Math.max(...c), v = Math.min(...f), _ = Math.max(...f), S = Math.min(...p), A = Math.max(...p), M = [
            (m + x) / 2,
            (v + _) / 2,
            (S + A) / 2
        ], b = x - m + $455d545b1dff00eb$var$pn, C = _ - v + $455d545b1dff00eb$var$pn, R = A - S + $455d545b1dff00eb$var$pn, N = Math.max(b, C, R), z = Math.max(N * 1.8, 6);
        let L;
        if (e) {
            const P = x - m, H = _ - v, O = A - S, D = Math.min(P, H, O), j = Math.max(N * 1.5, 9);
            D === O ? L = [
                M[0],
                M[1],
                M[2] + j
            ] : D === H ? L = [
                M[0],
                M[1] + j,
                M[2]
            ] : L = [
                M[0] + j,
                M[1],
                M[2]
            ];
        } else L = [
            M[0] + z * .75,
            M[1] + z * .75,
            M[2] + z * .75
        ];
        return {
            center: M,
            cameraPosition: L
        };
    }, [
        a,
        e,
        t
    ]);
}
function $455d545b1dff00eb$var$sI({ netId: a, coordinates: e, isAnimating: t, isPaused: n, isFolding: i, resetTrigger: r, onResetComplete: l, onAnimationComplete: c, faceBaseInfo: f, getDirectionVector: p, vectorKey: m, hingeConfig: x, baseMatrices: v }) {
    const { faceStates: _, isAnimationComplete: S } = $455d545b1dff00eb$var$aI({
        coordinates: e,
        isAnimating: t,
        isPaused: n,
        isFolding: i,
        resetTrigger: r,
        onResetComplete: l,
        onAnimationComplete: c,
        faceBaseInfo: f,
        getDirectionVector: p,
        vectorKey: m,
        hingeConfig: x
    }), A = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$ZA(_, v, x), [
        _,
        v,
        x
    ]), { center: M, cameraPosition: b } = $455d545b1dff00eb$var$rI(A, S, a);
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "w-full h-full relative",
        children: [
            $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$_S, {
                flat: !0,
                gl: {
                    outputColorSpace: $455d545b1dff00eb$var$No
                },
                camera: {
                    position: b,
                    fov: 55
                },
                children: [
                    $455d545b1dff00eb$var$k.jsx("ambientLight", {
                        intensity: .8
                    }),
                    $455d545b1dff00eb$var$k.jsx("directionalLight", {
                        position: [
                            5,
                            5,
                            5
                        ],
                        intensity: 1
                    }),
                    $455d545b1dff00eb$var$k.jsx("directionalLight", {
                        position: [
                            -5,
                            -5,
                            -5
                        ],
                        intensity: .5
                    }),
                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$tI, {
                        target: M,
                        position: b
                    }),
                    $455d545b1dff00eb$var$Ur.map((C, R)=>{
                        const N = A[R], L = _[R]?.color || $455d545b1dff00eb$var$Ur[R];
                        return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$nI, {
                            color: L,
                            worldMatrix: N
                        }, R);
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "absolute top-3 left-3 text-xs font-medium text-gray-600 tracking-wide pointer-events-none select-none",
                children: [
                    "Net ",
                    a
                ]
            })
        ]
    });
}
function $455d545b1dff00eb$var$oI({ netId: a, coordinates: e, isAnimating: t, isPaused: n, isCompleted: i, isFolding: r, resetTrigger: l, onAnimate: c, onFoldBack: f, onPlayPause: p, onReset: m, onResetComplete: x, onAnimationComplete: v, faceBaseInfo: _, getDirectionVector: S, vectorKey: A, hingeConfig: M, baseMatrices: b }) {
    const C = ()=>{
        i ? f() : c();
    };
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "w-full h-[450px] relative border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm",
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$LP, {
                isAnimating: t,
                isPaused: n,
                isCompleted: i,
                onPlayPause: p,
                onPlayClick: C,
                onReset: m
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$sI, {
                netId: a,
                coordinates: e,
                isAnimating: t,
                isPaused: n,
                isFolding: r,
                resetTrigger: l,
                onResetComplete: x,
                onAnimationComplete: v,
                faceBaseInfo: _,
                getDirectionVector: S,
                vectorKey: A,
                hingeConfig: M,
                baseMatrices: b
            })
        ]
    });
}
function $455d545b1dff00eb$var$lI({ isOpen: a, onClose: e, faceBaseInfo: t, getDirectionVector: n, vectorKey: i, hingeConfig: r, baseMatrices: l }) {
    const [c, f] = $455d545b1dff00eb$var$X.useState(new Array(11).fill(!1)), [p, m] = $455d545b1dff00eb$var$X.useState(new Array(11).fill(!1)), [x, v] = $455d545b1dff00eb$var$X.useState(new Array(11).fill(!1)), [_, S] = $455d545b1dff00eb$var$X.useState(new Array(11).fill(!1)), [A, M] = $455d545b1dff00eb$var$X.useState([]), [b, C] = $455d545b1dff00eb$var$X.useState(null), R = $455d545b1dff00eb$var$X.useRef(new Array(11).fill(null));
    $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!a && b !== null) {
            const O = setTimeout(()=>{
                C(null);
            }, 0);
            return ()=>clearTimeout(O);
        }
    }, [
        a,
        b
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (b !== null && R.current[b]) {
            const O = R.current[b];
            O && O.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, [
        b
    ]);
    const N = $455d545b1dff00eb$var$X.useCallback((O)=>{
        const D = O - 1;
        f((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !0, G;
        }), m((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), v((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        });
    }, []), z = $455d545b1dff00eb$var$X.useCallback((O)=>{
        const D = O - 1;
        S((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !0, G;
        }), v((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), f((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !0, G;
        }), m((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        });
    }, []), L = $455d545b1dff00eb$var$X.useCallback((O)=>{
        const D = O - 1;
        m((j)=>{
            const G = [
                ...j
            ], q = G[D];
            return G[D] = !q, G;
        });
    }, []), P = $455d545b1dff00eb$var$X.useCallback((O)=>{
        const D = O - 1;
        f((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), m((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), v((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), S((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), M((j)=>[
                ...j.filter((q)=>q !== O),
                O
            ]);
    }, []), H = $455d545b1dff00eb$var$X.useCallback((O)=>{
        const D = O - 1;
        f((j)=>{
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        }), S((j)=>{
            j[D] || v((q)=>{
                const Y = [
                    ...q
                ];
                return Y[D] = !0, Y;
            });
            const G = [
                ...j
            ];
            return G[D] = !1, G;
        });
    }, []);
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("div", {
                className: `fixed top-0 right-0 h-full bg-white shadow-2xl z-50 transition-transform duration-300 ease-in-out ${a ? "translate-x-0" : "translate-x-full"}`,
                style: {
                    width: "min(95vw, 1000px)",
                    zIndex: 1e13
                },
                children: $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "h-full flex flex-col",
                    children: [
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex items-center gap-3 p-4 border-b border-gray-200 bg-gray-50",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: e,
                                    className: "p-2 hover:bg-gray-200 rounded-lg transition-colors flex-shrink-0",
                                    "aria-label": "Close drawer",
                                    children: $455d545b1dff00eb$var$k.jsx("svg", {
                                        className: "w-6 h-6",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: $455d545b1dff00eb$var$k.jsx("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                }),
                                $455d545b1dff00eb$var$k.jsx("h2", {
                                    className: "text-lg font-bold text-gray-900",
                                    children: "All 11 Valid Cube Nets"
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: "flex-1 overflow-y-auto p-2",
                            children: $455d545b1dff00eb$var$k.jsx("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-2",
                                children: $455d545b1dff00eb$var$DP.map((O, D)=>$455d545b1dff00eb$var$k.jsx("div", {
                                        ref: (j)=>{
                                            R.current[D] = j;
                                        },
                                        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$oI, {
                                            netId: D + 1,
                                            coordinates: O,
                                            isAnimating: c[D],
                                            isPaused: p[D],
                                            isCompleted: x[D],
                                            isFolding: _[D],
                                            resetTrigger: A.includes(D + 1),
                                            onAnimate: ()=>N(D + 1),
                                            onFoldBack: ()=>z(D + 1),
                                            onPlayPause: ()=>L(D + 1),
                                            onReset: ()=>P(D + 1),
                                            onResetComplete: ()=>{
                                                M((j)=>j.filter((G)=>G !== D + 1));
                                            },
                                            onAnimationComplete: ()=>H(D + 1),
                                            faceBaseInfo: t,
                                            getDirectionVector: n,
                                            vectorKey: i,
                                            hingeConfig: r,
                                            baseMatrices: l
                                        })
                                    }, D))
                            })
                        })
                    ]
                })
            }),
            a && $455d545b1dff00eb$var$k.jsx("div", {
                style: {
                    zIndex: 1e9
                },
                className: "fixed inset-0 bg-black bg-opacity-50  transition-opacity",
                onClick: e
            })
        ]
    });
}
function $455d545b1dff00eb$var$cI({ isOpen: a, onClose: e, videoUrl: t, title: n = "Maths Video Playlist" }) {
    const [i, r] = $455d545b1dff00eb$var$X.useState({
        x: 100,
        y: 100
    }), [l, c] = $455d545b1dff00eb$var$X.useState({
        width: 560,
        height: 315
    }), [f, p] = $455d545b1dff00eb$var$X.useState(!1), [m, x] = $455d545b1dff00eb$var$X.useState(!1), [v, _] = $455d545b1dff00eb$var$X.useState({
        x: 0,
        y: 0
    }), [S, A] = $455d545b1dff00eb$var$X.useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }), M = $455d545b1dff00eb$var$X.useRef(null), b = $455d545b1dff00eb$var$X.useRef(null), R = ((P)=>{
        const H = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/, O = P.match(H);
        return O && O[2].length === 11 ? O[2] : null;
    })(t), N = R ? `https://www.youtube.com/embed/${R}` : "", z = $455d545b1dff00eb$var$X.useCallback((P)=>{
        const H = P.target;
        H.closest("button") || b.current?.contains(H) && (p(!0), _({
            x: P.clientX - i.x,
            y: P.clientY - i.y
        }));
    }, [
        i
    ]), L = $455d545b1dff00eb$var$X.useCallback((P)=>{
        P.stopPropagation(), x(!0), A({
            x: P.clientX,
            y: P.clientY,
            width: l.width,
            height: l.height
        });
    }, [
        l
    ]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        const P = (O)=>{
            if (f) r({
                x: O.clientX - v.x,
                y: O.clientY - v.y
            });
            else if (m) {
                const D = O.clientX - S.x, j = O.clientY - S.y;
                c({
                    width: Math.max(400, S.width + D),
                    height: Math.max(225, S.height + j)
                });
            }
        }, H = ()=>{
            p(!1), x(!1);
        };
        if (f || m) return document.addEventListener("mousemove", P), document.addEventListener("mouseup", H), ()=>{
            document.removeEventListener("mousemove", P), document.removeEventListener("mouseup", H);
        };
    }, [
        f,
        m,
        v,
        S
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (M.current) {
            const P = M.current.getBoundingClientRect(), H = window.innerWidth - P.width, O = window.innerHeight - P.height;
            r((D)=>({
                    x: Math.max(0, Math.min(D.x, H)),
                    y: Math.max(0, Math.min(D.y, O))
                }));
        }
    }, [
        l,
        a
    ]), a ? $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("div", {
                style: {
                    zIndex: 1e9
                },
                className: "fixed inset-0 bg-black bg-opacity-30",
                onClick: e
            }),
            $455d545b1dff00eb$var$k.jsxs("div", {
                ref: M,
                className: "fixed bg-white rounded-lg shadow-2xl overflow-hidden border border-pink-200",
                style: {
                    left: `${i.x}px`,
                    top: `${i.y}px`,
                    width: `${l.width}px`,
                    height: `${l.height}px`,
                    cursor: f ? "grabbing" : "default",
                    zIndex: 1000000001
                },
                children: [
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        ref: b,
                        onMouseDown: z,
                        className: "bg-gradient-to-r from-pink-500 to-pink-600 px-4 py-3 flex items-center justify-between cursor-grab active:cursor-grabbing select-none",
                        children: [
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("svg", {
                                        className: "w-5 h-5 text-white",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24",
                                        children: $455d545b1dff00eb$var$k.jsx("path", {
                                            d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                        })
                                    }),
                                    $455d545b1dff00eb$var$k.jsx("h3", {
                                        className: "text-white font-semibold text-sm",
                                        children: n
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("button", {
                                onClick: e,
                                className: "text-white hover:bg-pink-700 rounded-full p-1 transition-colors",
                                "aria-label": "Close",
                                children: $455d545b1dff00eb$var$k.jsx("svg", {
                                    className: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: $455d545b1dff00eb$var$k.jsx("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            })
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: "w-full h-[calc(100%-49px)] bg-gray-50",
                        children: N ? $455d545b1dff00eb$var$k.jsx("iframe", {
                            width: "100%",
                            height: "100%",
                            src: N,
                            title: n,
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: !0,
                            className: "w-full h-full"
                        }) : $455d545b1dff00eb$var$k.jsx("div", {
                            className: "flex items-center justify-center h-full text-gray-500",
                            children: "Invalid video URL"
                        })
                    }),
                    $455d545b1dff00eb$var$k.jsx("div", {
                        onMouseDown: L,
                        className: "absolute bottom-0 right-0 w-6 h-6 cursor-nwse-resize bg-pink-500 opacity-0 hover:opacity-100 transition-opacity",
                        style: {
                            clipPath: "polygon(100% 0, 0 100%, 100% 100%)"
                        },
                        children: $455d545b1dff00eb$var$k.jsx("div", {
                            className: "absolute bottom-1 right-1 w-3 h-3 border-r-2 border-b-2 border-white"
                        })
                    })
                ]
            })
        ]
    }) : null;
}
function $455d545b1dff00eb$var$uI({ value: a, onChange: e, options: t }) {
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "flex items-center gap-1 bg-white rounded-lg shadow-lg border border-gray-200 p-1 w-fit",
        children: t.map(({ value: n, label: i })=>$455d545b1dff00eb$var$k.jsx("button", {
                type: "button",
                onClick: ()=>e(n),
                className: `px-3 md:px-4 py-2 rounded-md text-xs md:text-sm font-medium transition-all whitespace-nowrap ${a === n ? "bg-[#FD99C5] text-white shadow-md" : "text-gray-600 hover:bg-gray-100"}`,
                children: i
            }, n))
    });
}
function $455d545b1dff00eb$var$Zf() {
    return $455d545b1dff00eb$var$Zf = Object.assign ? Object.assign.bind() : function(a) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var n in t)({}).hasOwnProperty.call(t, n) && (a[n] = t[n]);
        }
        return a;
    }, $455d545b1dff00eb$var$Zf.apply(null, arguments);
}
const $455d545b1dff00eb$var$N0 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$SS = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$fI = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$F3 = new $455d545b1dff00eb$var$$e;
function $455d545b1dff00eb$var$hI(a, e, t) {
    const n = $455d545b1dff00eb$var$N0.setFromMatrixPosition(a.matrixWorld);
    n.project(e);
    const i = t.width / 2, r = t.height / 2;
    return [
        n.x * i + i,
        -(n.y * r) + r
    ];
}
function $455d545b1dff00eb$var$dI(a, e) {
    const t = $455d545b1dff00eb$var$N0.setFromMatrixPosition(a.matrixWorld), n = $455d545b1dff00eb$var$SS.setFromMatrixPosition(e.matrixWorld), i = t.sub(n), r = e.getWorldDirection($455d545b1dff00eb$var$fI);
    return i.angleTo(r) > Math.PI / 2;
}
function $455d545b1dff00eb$var$pI(a, e, t, n) {
    const i = $455d545b1dff00eb$var$N0.setFromMatrixPosition(a.matrixWorld), r = i.clone();
    r.project(e), $455d545b1dff00eb$var$F3.set(r.x, r.y), t.setFromCamera($455d545b1dff00eb$var$F3, e);
    const l = t.intersectObjects(n, !0);
    if (l.length) {
        const c = l[0].distance;
        return i.distanceTo(t.ray.origin) < c;
    }
    return !0;
}
function $455d545b1dff00eb$var$mI(a, e) {
    if (e instanceof $455d545b1dff00eb$var$bl) return e.zoom;
    if (e instanceof $455d545b1dff00eb$var$Ui) {
        const t = $455d545b1dff00eb$var$N0.setFromMatrixPosition(a.matrixWorld), n = $455d545b1dff00eb$var$SS.setFromMatrixPosition(e.matrixWorld), i = e.fov * Math.PI / 180, r = t.distanceTo(n);
        return 1 / (2 * Math.tan(i / 2) * r);
    } else return 1;
}
function $455d545b1dff00eb$var$gI(a, e, t) {
    if (e instanceof $455d545b1dff00eb$var$Ui || e instanceof $455d545b1dff00eb$var$bl) {
        const n = $455d545b1dff00eb$var$N0.setFromMatrixPosition(a.matrixWorld), i = $455d545b1dff00eb$var$SS.setFromMatrixPosition(e.matrixWorld), r = n.distanceTo(i), l = (t[1] - t[0]) / (e.far - e.near), c = t[1] - l * e.far;
        return Math.round(l * r + c);
    }
}
const $455d545b1dff00eb$var$mb = (a)=>Math.abs(a) < 1e-10 ? 0 : a;
function $455d545b1dff00eb$var$QA(a, e, t = "") {
    let n = "matrix3d(";
    for(let i = 0; i !== 16; i++)n += $455d545b1dff00eb$var$mb(e[i] * a.elements[i]) + (i !== 15 ? "," : ")");
    return t + n;
}
const $455d545b1dff00eb$var$xI = ((a)=>(e)=>$455d545b1dff00eb$var$QA(e, a))([
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1
]), $455d545b1dff00eb$var$vI = ((a)=>(e, t)=>$455d545b1dff00eb$var$QA(e, a(t), "translate(-50%,-50%)"))((a)=>[
        1 / a,
        1 / a,
        1 / a,
        1,
        -1 / a,
        -1 / a,
        -1 / a,
        -1,
        1 / a,
        1 / a,
        1 / a,
        1,
        1,
        1,
        1,
        1
    ]);
function $455d545b1dff00eb$var$yI(a) {
    return a && typeof a == "object" && "current" in a;
}
const $455d545b1dff00eb$var$_I = $455d545b1dff00eb$var$X.forwardRef(({ children: a, eps: e = .001, style: t, className: n, prepend: i, center: r, fullscreen: l, portal: c, distanceFactor: f, sprite: p = !1, transform: m = !1, occlude: x, onOcclude: v, castShadow: _, receiveShadow: S, material: A, geometry: M, zIndexRange: b = [
    16777271,
    0
], calculatePosition: C = $455d545b1dff00eb$var$hI, as: R = "div", wrapperClass: N, pointerEvents: z = "auto", ...L }, P)=>{
    const { gl: H, camera: O, scene: D, size: j, raycaster: G, events: q, viewport: Y } = $455d545b1dff00eb$var$Ei(), [ae] = $455d545b1dff00eb$var$X.useState(()=>document.createElement(R)), F = $455d545b1dff00eb$var$X.useRef(null), Q = $455d545b1dff00eb$var$X.useRef(null), K = $455d545b1dff00eb$var$X.useRef(0), $ = $455d545b1dff00eb$var$X.useRef([
        0,
        0
    ]), ee = $455d545b1dff00eb$var$X.useRef(null), I = $455d545b1dff00eb$var$X.useRef(null), Z = c?.current || q.connected || H.domElement.parentNode, oe = $455d545b1dff00eb$var$X.useRef(null), ce = $455d545b1dff00eb$var$X.useRef(!1), de = $455d545b1dff00eb$var$X.useMemo(()=>x && x !== "blending" || Array.isArray(x) && x.length && $455d545b1dff00eb$var$yI(x[0]), [
        x
    ]);
    $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        const Ue = H.domElement;
        x && x === "blending" ? (Ue.style.zIndex = `${Math.floor(b[0] / 2)}`, Ue.style.position = "absolute", Ue.style.pointerEvents = "none") : (Ue.style.zIndex = null, Ue.style.position = null, Ue.style.pointerEvents = null);
    }, [
        x
    ]), $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        if (Q.current) {
            const Ue = F.current = $455d545b1dff00eb$var$dE.createRoot(ae);
            if (D.updateMatrixWorld(), m) ae.style.cssText = "position:absolute;top:0;left:0;pointer-events:none;overflow:hidden;";
            else {
                const Ne = C(Q.current, O, j);
                ae.style.cssText = `position:absolute;top:0;left:0;transform:translate3d(${Ne[0]}px,${Ne[1]}px,0);transform-origin:0 0;`;
            }
            return Z && (i ? Z.prepend(ae) : Z.appendChild(ae)), ()=>{
                Z && Z.removeChild(ae), Ue.unmount();
            };
        }
    }, [
        Z,
        m
    ]), $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        N && (ae.className = N);
    }, [
        N
    ]);
    const ue = $455d545b1dff00eb$var$X.useMemo(()=>m ? {
            position: "absolute",
            top: 0,
            left: 0,
            width: j.width,
            height: j.height,
            transformStyle: "preserve-3d",
            pointerEvents: "none"
        } : {
            position: "absolute",
            transform: r ? "translate3d(-50%,-50%,0)" : "none",
            ...l && {
                top: -j.height / 2,
                left: -j.width / 2,
                width: j.width,
                height: j.height
            },
            ...t
        }, [
        t,
        r,
        l,
        j,
        m
    ]), le = $455d545b1dff00eb$var$X.useMemo(()=>({
            position: "absolute",
            pointerEvents: z
        }), [
        z
    ]);
    $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        if (ce.current = !1, m) {
            var Ue;
            (Ue = F.current) == null || Ue.render($455d545b1dff00eb$var$X.createElement("div", {
                ref: ee,
                style: ue
            }, $455d545b1dff00eb$var$X.createElement("div", {
                ref: I,
                style: le
            }, $455d545b1dff00eb$var$X.createElement("div", {
                ref: P,
                className: n,
                style: t,
                children: a
            }))));
        } else {
            var Ne;
            (Ne = F.current) == null || Ne.render($455d545b1dff00eb$var$X.createElement("div", {
                ref: P,
                style: ue,
                className: n,
                children: a
            }));
        }
    });
    const xe = $455d545b1dff00eb$var$X.useRef(!0);
    $455d545b1dff00eb$var$Zs((Ue)=>{
        if (Q.current) {
            O.updateMatrixWorld(), Q.current.updateWorldMatrix(!0, !1);
            const Ne = m ? $.current : C(Q.current, O, j);
            if (m || Math.abs(K.current - O.zoom) > e || Math.abs($.current[0] - Ne[0]) > e || Math.abs($.current[1] - Ne[1]) > e) {
                const ke = $455d545b1dff00eb$var$dI(Q.current, O);
                let nt = !1;
                de && (Array.isArray(x) ? nt = x.map((Ie)=>Ie.current) : x !== "blending" && (nt = [
                    D
                ]));
                const Re = xe.current;
                if (nt) {
                    const Ie = $455d545b1dff00eb$var$pI(Q.current, O, G, nt);
                    xe.current = Ie && !ke;
                } else xe.current = !ke;
                Re !== xe.current && (v ? v(!xe.current) : ae.style.display = xe.current ? "block" : "none");
                const te = Math.floor(b[0] / 2), Oe = x ? de ? [
                    b[0],
                    te
                ] : [
                    te - 1,
                    0
                ] : b;
                if (ae.style.zIndex = `${$455d545b1dff00eb$var$gI(Q.current, O, Oe)}`, m) {
                    const [Ie, Ae] = [
                        j.width / 2,
                        j.height / 2
                    ], ze = O.projectionMatrix.elements[5] * Ae, { isOrthographicCamera: Ze, top: be, left: rt, bottom: ne, right: W } = O, pe = $455d545b1dff00eb$var$xI(O.matrixWorldInverse), Be = Ze ? `scale(${ze})translate(${$455d545b1dff00eb$var$mb(-(W + rt) / 2)}px,${$455d545b1dff00eb$var$mb((be + ne) / 2)}px)` : `translateZ(${ze}px)`;
                    let Te = Q.current.matrixWorld;
                    p && (Te = O.matrixWorldInverse.clone().transpose().copyPosition(Te).scale(Q.current.scale), Te.elements[3] = Te.elements[7] = Te.elements[11] = 0, Te.elements[15] = 1), ae.style.width = j.width + "px", ae.style.height = j.height + "px", ae.style.perspective = Ze ? "" : `${ze}px`, ee.current && I.current && (ee.current.style.transform = `${Be}${pe}translate(${Ie}px,${Ae}px)`, I.current.style.transform = $455d545b1dff00eb$var$vI(Te, 1 / ((f || 10) / 400)));
                } else {
                    const Ie = f === void 0 ? 1 : $455d545b1dff00eb$var$mI(Q.current, O) * f;
                    ae.style.transform = `translate3d(${Ne[0]}px,${Ne[1]}px,0) scale(${Ie})`;
                }
                $.current = Ne, K.current = O.zoom;
            }
        }
        if (!de && oe.current && !ce.current) {
            if (m) {
                if (ee.current) {
                    const Ne = ee.current.children[0];
                    if (Ne != null && Ne.clientWidth && Ne != null && Ne.clientHeight) {
                        const { isOrthographicCamera: ke } = O;
                        if (ke || M) L.scale && (Array.isArray(L.scale) ? L.scale instanceof $455d545b1dff00eb$var$J ? oe.current.scale.copy(L.scale.clone().divideScalar(1)) : oe.current.scale.set(1 / L.scale[0], 1 / L.scale[1], 1 / L.scale[2]) : oe.current.scale.setScalar(1 / L.scale));
                        else {
                            const nt = (f || 10) / 400, Re = Ne.clientWidth * nt, te = Ne.clientHeight * nt;
                            oe.current.scale.set(Re, te, 1);
                        }
                        ce.current = !0;
                    }
                }
            } else {
                const Ne = ae.children[0];
                if (Ne != null && Ne.clientWidth && Ne != null && Ne.clientHeight) {
                    const ke = 1 / Y.factor, nt = Ne.clientWidth * ke, Re = Ne.clientHeight * ke;
                    oe.current.scale.set(nt, Re, 1), ce.current = !0;
                }
                oe.current.lookAt(Ue.camera.position);
            }
        }
    });
    const Le = $455d545b1dff00eb$var$X.useMemo(()=>({
            vertexShader: m ? void 0 : `
          /*
            This shader is from the THREE's SpriteMaterial.
            We need to turn the backing plane into a Sprite
            (make it always face the camera) if "transfrom"
            is false.
          */
          #include <common>

          void main() {
            vec2 center = vec2(0., 1.);
            float rotation = 0.0;

            // This is somewhat arbitrary, but it seems to work well
            // Need to figure out how to derive this dynamically if it even matters
            float size = 0.03;

            vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
            vec2 scale;
            scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
            scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );

            bool isPerspective = isPerspectiveMatrix( projectionMatrix );
            if ( isPerspective ) scale *= - mvPosition.z;

            vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale * size;
            vec2 rotatedPosition;
            rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
            rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
            mvPosition.xy += rotatedPosition;

            gl_Position = projectionMatrix * mvPosition;
          }
      `,
            fragmentShader: `
        void main() {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
        }
      `
        }), [
        m
    ]);
    return $455d545b1dff00eb$var$X.createElement("group", $455d545b1dff00eb$var$Zf({}, L, {
        ref: Q
    }), x && !de && $455d545b1dff00eb$var$X.createElement("mesh", {
        castShadow: _,
        receiveShadow: S,
        ref: oe
    }, M || $455d545b1dff00eb$var$X.createElement("planeGeometry", null), A || $455d545b1dff00eb$var$X.createElement("shaderMaterial", {
        side: $455d545b1dff00eb$var$Ea,
        vertexShader: Le.vertexShader,
        fragmentShader: Le.fragmentShader
    })));
}), $455d545b1dff00eb$var$B_ = $455d545b1dff00eb$var$X.forwardRef(function({ children: e, follow: t = !0, lockX: n = !1, lockY: i = !1, lockZ: r = !1, ...l }, c) {
    const f = $455d545b1dff00eb$var$X.useRef(null), p = $455d545b1dff00eb$var$X.useRef(null), m = new $455d545b1dff00eb$var$Gn;
    return $455d545b1dff00eb$var$Zs(({ camera: x })=>{
        if (!t || !p.current) return;
        const v = f.current.rotation.clone();
        p.current.updateMatrix(), p.current.updateWorldMatrix(!1, !1), p.current.getWorldQuaternion(m), x.getWorldQuaternion(f.current.quaternion).premultiply(m.invert()), n && (f.current.rotation.x = v.x), i && (f.current.rotation.y = v.y), r && (f.current.rotation.z = v.z);
    }), $455d545b1dff00eb$var$X.useImperativeHandle(c, ()=>p.current, []), $455d545b1dff00eb$var$X.createElement("group", $455d545b1dff00eb$var$Zf({
        ref: p
    }, l), $455d545b1dff00eb$var$X.createElement("group", {
        ref: f
    }, e));
});
function $455d545b1dff00eb$var$bI() {
    var a = Object.create(null);
    function e(i, r) {
        var l = i.id, c = i.name, f = i.dependencies;
        f === void 0 && (f = []);
        var p = i.init;
        p === void 0 && (p = function() {});
        var m = i.getTransferables;
        if (m === void 0 && (m = null), !a[l]) try {
            f = f.map(function(v) {
                return v && v.isWorkerModule && (e(v, function(_) {
                    if (_ instanceof Error) throw _;
                }), v = a[v.id].value), v;
            }), p = n("<" + c + ">.init", p), m && (m = n("<" + c + ">.getTransferables", m));
            var x = null;
            typeof p == "function" ? x = p.apply(void 0, f) : console.error("worker module init function failed to rehydrate"), a[l] = {
                id: l,
                value: x,
                getTransferables: m
            }, r(x);
        } catch (v) {
            v && v.noLog || console.error(v), r(v);
        }
    }
    function t(i, r) {
        var l, c = i.id, f = i.args;
        (!a[c] || typeof a[c].value != "function") && r(new Error("Worker module " + c + ": not found or its 'init' did not return a function"));
        try {
            var p = (l = a[c]).value.apply(l, f);
            p && typeof p.then == "function" ? p.then(m, function(x) {
                return r(x instanceof Error ? x : new Error("" + x));
            }) : m(p);
        } catch (x) {
            r(x);
        }
        function m(x) {
            try {
                var v = a[c].getTransferables && a[c].getTransferables(x);
                (!v || !Array.isArray(v) || !v.length) && (v = void 0), r(x, v);
            } catch (_) {
                console.error(_), r(_);
            }
        }
    }
    function n(i, r) {
        var l = void 0;
        self.troikaDefine = function(f) {
            return l = f;
        };
        var c = URL.createObjectURL(new Blob([
            "/** " + i.replace(/\*/g, "") + ` **/

troikaDefine(
` + r + `
)`
        ], {
            type: "application/javascript"
        }));
        try {
            importScripts(c);
        } catch (f) {
            console.error(f);
        }
        return URL.revokeObjectURL(c), delete self.troikaDefine, l;
    }
    self.addEventListener("message", function(i) {
        var r = i.data, l = r.messageId, c = r.action, f = r.data;
        try {
            c === "registerModule" && e(f, function(p) {
                p instanceof Error ? postMessage({
                    messageId: l,
                    success: !1,
                    error: p.message
                }) : postMessage({
                    messageId: l,
                    success: !0,
                    result: {
                        isCallable: typeof p == "function"
                    }
                });
            }), c === "callModule" && t(f, function(p, m) {
                p instanceof Error ? postMessage({
                    messageId: l,
                    success: !1,
                    error: p.message
                }) : postMessage({
                    messageId: l,
                    success: !0,
                    result: p
                }, m || void 0);
            });
        } catch (p) {
            postMessage({
                messageId: l,
                success: !1,
                error: p.stack
            });
        }
    });
}
function $455d545b1dff00eb$var$SI(a) {
    var e = function() {
        for(var t = [], n = arguments.length; n--;)t[n] = arguments[n];
        return e._getInitResult().then(function(i) {
            if (typeof i == "function") return i.apply(void 0, t);
            throw new Error("Worker module function was called but `init` did not return a callable function");
        });
    };
    return e._getInitResult = function() {
        var t = a.dependencies, n = a.init;
        t = Array.isArray(t) ? t.map(function(r) {
            return r && (r = r.onMainThread || r, r._getInitResult && (r = r._getInitResult())), r;
        }) : [];
        var i = Promise.all(t).then(function(r) {
            return n.apply(null, r);
        });
        return e._getInitResult = function() {
            return i;
        }, i;
    }, e;
}
var $455d545b1dff00eb$var$KA = function() {
    var a = !1;
    if (typeof window < "u" && typeof window.document < "u") try {
        var e = new Worker(URL.createObjectURL(new Blob([
            ""
        ], {
            type: "application/javascript"
        })));
        e.terminate(), a = !0;
    } catch (t) {
        console.log("Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + t.message + "]");
    }
    return $455d545b1dff00eb$var$KA = function() {
        return a;
    }, a;
}, $455d545b1dff00eb$var$MI = 0, $455d545b1dff00eb$var$EI = 0, $455d545b1dff00eb$var$I_ = !1, $455d545b1dff00eb$var$Zm = Object.create(null), $455d545b1dff00eb$var$Qm = Object.create(null), $455d545b1dff00eb$var$gb = Object.create(null);
function $455d545b1dff00eb$var$Qd(a) {
    if ((!a || typeof a.init != "function") && !$455d545b1dff00eb$var$I_) throw new Error("requires `options.init` function");
    var e = a.dependencies, t = a.init, n = a.getTransferables, i = a.workerId, r = $455d545b1dff00eb$var$SI(a);
    i == null && (i = "#default");
    var l = "workerModule" + ++$455d545b1dff00eb$var$MI, c = a.name || l, f = null;
    e = e && e.map(function(m) {
        return typeof m == "function" && !m.workerModuleData && ($455d545b1dff00eb$var$I_ = !0, m = $455d545b1dff00eb$var$Qd({
            workerId: i,
            name: "<" + c + "> function dependency: " + m.name,
            init: `function(){return (
` + $455d545b1dff00eb$var$Kx(m) + `
)}`
        }), $455d545b1dff00eb$var$I_ = !1), m && m.workerModuleData && (m = m.workerModuleData), m;
    });
    function p() {
        for(var m = [], x = arguments.length; x--;)m[x] = arguments[x];
        if (!$455d545b1dff00eb$var$KA()) return r.apply(void 0, m);
        if (!f) {
            f = $455d545b1dff00eb$var$H3(i, "registerModule", p.workerModuleData);
            var v = function() {
                f = null, $455d545b1dff00eb$var$Qm[i].delete(v);
            };
            ($455d545b1dff00eb$var$Qm[i] || ($455d545b1dff00eb$var$Qm[i] = new Set)).add(v);
        }
        return f.then(function(_) {
            var S = _.isCallable;
            if (S) return $455d545b1dff00eb$var$H3(i, "callModule", {
                id: l,
                args: m
            });
            throw new Error("Worker module function was called but `init` did not return a callable function");
        });
    }
    return p.workerModuleData = {
        isWorkerModule: !0,
        id: l,
        name: c,
        dependencies: e,
        init: $455d545b1dff00eb$var$Kx(t),
        getTransferables: n && $455d545b1dff00eb$var$Kx(n)
    }, p.onMainThread = r, p;
}
function $455d545b1dff00eb$var$TI(a) {
    $455d545b1dff00eb$var$Qm[a] && $455d545b1dff00eb$var$Qm[a].forEach(function(e) {
        e();
    }), $455d545b1dff00eb$var$Zm[a] && ($455d545b1dff00eb$var$Zm[a].terminate(), delete $455d545b1dff00eb$var$Zm[a]);
}
function $455d545b1dff00eb$var$Kx(a) {
    var e = a.toString();
    return !/^function/.test(e) && /^\w+\s*\(/.test(e) && (e = "function " + e), e;
}
function $455d545b1dff00eb$var$AI(a) {
    var e = $455d545b1dff00eb$var$Zm[a];
    if (!e) {
        var t = $455d545b1dff00eb$var$Kx($455d545b1dff00eb$var$bI);
        e = $455d545b1dff00eb$var$Zm[a] = new Worker(URL.createObjectURL(new Blob([
            "/** Worker Module Bootstrap: " + a.replace(/\*/g, "") + ` **/

;(` + t + ")()"
        ], {
            type: "application/javascript"
        }))), e.onmessage = function(n) {
            var i = n.data, r = i.messageId, l = $455d545b1dff00eb$var$gb[r];
            if (!l) throw new Error("WorkerModule response with empty or unknown messageId");
            delete $455d545b1dff00eb$var$gb[r], l(i);
        };
    }
    return e;
}
function $455d545b1dff00eb$var$H3(a, e, t) {
    return new Promise(function(n, i) {
        var r = ++$455d545b1dff00eb$var$EI;
        $455d545b1dff00eb$var$gb[r] = function(l) {
            l.success ? n(l.result) : i(new Error("Error in worker " + e + " call: " + l.error));
        }, $455d545b1dff00eb$var$AI(a).postMessage({
            messageId: r,
            action: e,
            data: t
        });
    });
}
function $455d545b1dff00eb$var$JA() {
    var a = function(e) {
        function t($, ee, I, Z, oe, ce, de, ue) {
            var le = 1 - de;
            ue.x = le * le * $ + 2 * le * de * I + de * de * oe, ue.y = le * le * ee + 2 * le * de * Z + de * de * ce;
        }
        function n($, ee, I, Z, oe, ce, de, ue, le, xe) {
            var Le = 1 - le;
            xe.x = Le * Le * Le * $ + 3 * Le * Le * le * I + 3 * Le * le * le * oe + le * le * le * de, xe.y = Le * Le * Le * ee + 3 * Le * Le * le * Z + 3 * Le * le * le * ce + le * le * le * ue;
        }
        function i($, ee) {
            for(var I = /([MLQCZ])([^MLQCZ]*)/g, Z, oe, ce, de, ue; Z = I.exec($);){
                var le = Z[2].replace(/^\s*|\s*$/g, "").split(/[,\s]+/).map(function(xe) {
                    return parseFloat(xe);
                });
                switch(Z[1]){
                    case "M":
                        de = oe = le[0], ue = ce = le[1];
                        break;
                    case "L":
                        (le[0] !== de || le[1] !== ue) && ee("L", de, ue, de = le[0], ue = le[1]);
                        break;
                    case "Q":
                        ee("Q", de, ue, de = le[2], ue = le[3], le[0], le[1]);
                        break;
                    case "C":
                        ee("C", de, ue, de = le[4], ue = le[5], le[0], le[1], le[2], le[3]);
                        break;
                    case "Z":
                        (de !== oe || ue !== ce) && ee("L", de, ue, oe, ce);
                        break;
                }
            }
        }
        function r($, ee, I) {
            I === void 0 && (I = 16);
            var Z = {
                x: 0,
                y: 0
            };
            i($, function(oe, ce, de, ue, le, xe, Le, Ue, Ne) {
                switch(oe){
                    case "L":
                        ee(ce, de, ue, le);
                        break;
                    case "Q":
                        for(var ke = ce, nt = de, Re = 1; Re < I; Re++)t(ce, de, xe, Le, ue, le, Re / (I - 1), Z), ee(ke, nt, Z.x, Z.y), ke = Z.x, nt = Z.y;
                        break;
                    case "C":
                        for(var te = ce, Oe = de, Ie = 1; Ie < I; Ie++)n(ce, de, xe, Le, Ue, Ne, ue, le, Ie / (I - 1), Z), ee(te, Oe, Z.x, Z.y), te = Z.x, Oe = Z.y;
                        break;
                }
            });
        }
        var l = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", c = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}", f = new WeakMap, p = {
            premultipliedAlpha: !1,
            preserveDrawingBuffer: !0,
            antialias: !1,
            depth: !1
        };
        function m($, ee) {
            var I = $.getContext ? $.getContext("webgl", p) : $, Z = f.get(I);
            if (!Z) {
                let Le = function(te) {
                    var Oe = ce[te];
                    if (!Oe && (Oe = ce[te] = I.getExtension(te), !Oe)) throw new Error(te + " not supported");
                    return Oe;
                }, Ue = function(te, Oe) {
                    var Ie = I.createShader(Oe);
                    return I.shaderSource(Ie, te), I.compileShader(Ie), Ie;
                }, Ne = function(te, Oe, Ie, Ae) {
                    if (!de[te]) {
                        var ze = {}, Ze = {}, be = I.createProgram();
                        I.attachShader(be, Ue(Oe, I.VERTEX_SHADER)), I.attachShader(be, Ue(Ie, I.FRAGMENT_SHADER)), I.linkProgram(be), de[te] = {
                            program: be,
                            transaction: function(ne) {
                                I.useProgram(be), ne({
                                    setUniform: function(pe, Be) {
                                        for(var Te = [], _e = arguments.length - 2; _e-- > 0;)Te[_e] = arguments[_e + 2];
                                        var ot = Ze[Be] || (Ze[Be] = I.getUniformLocation(be, Be));
                                        I["uniform" + pe].apply(I, [
                                            ot
                                        ].concat(Te));
                                    },
                                    setAttribute: function(pe, Be, Te, _e, ot) {
                                        var tt = ze[pe];
                                        tt || (tt = ze[pe] = {
                                            buf: I.createBuffer(),
                                            loc: I.getAttribLocation(be, pe),
                                            data: null
                                        }), I.bindBuffer(I.ARRAY_BUFFER, tt.buf), I.vertexAttribPointer(tt.loc, Be, I.FLOAT, !1, 0, 0), I.enableVertexAttribArray(tt.loc), oe ? I.vertexAttribDivisor(tt.loc, _e) : Le("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(tt.loc, _e), ot !== tt.data && (I.bufferData(I.ARRAY_BUFFER, ot, Te), tt.data = ot);
                                    }
                                });
                            }
                        };
                    }
                    de[te].transaction(Ae);
                }, ke = function(te, Oe) {
                    le++;
                    try {
                        I.activeTexture(I.TEXTURE0 + le);
                        var Ie = ue[te];
                        Ie || (Ie = ue[te] = I.createTexture(), I.bindTexture(I.TEXTURE_2D, Ie), I.texParameteri(I.TEXTURE_2D, I.TEXTURE_MIN_FILTER, I.NEAREST), I.texParameteri(I.TEXTURE_2D, I.TEXTURE_MAG_FILTER, I.NEAREST)), I.bindTexture(I.TEXTURE_2D, Ie), Oe(Ie, le);
                    } finally{
                        le--;
                    }
                }, nt = function(te, Oe, Ie) {
                    var Ae = I.createFramebuffer();
                    xe.push(Ae), I.bindFramebuffer(I.FRAMEBUFFER, Ae), I.activeTexture(I.TEXTURE0 + Oe), I.bindTexture(I.TEXTURE_2D, te), I.framebufferTexture2D(I.FRAMEBUFFER, I.COLOR_ATTACHMENT0, I.TEXTURE_2D, te, 0);
                    try {
                        Ie(Ae);
                    } finally{
                        I.deleteFramebuffer(Ae), I.bindFramebuffer(I.FRAMEBUFFER, xe[--xe.length - 1] || null);
                    }
                }, Re = function() {
                    ce = {}, de = {}, ue = {}, le = -1, xe.length = 0;
                };
                var oe = typeof WebGL2RenderingContext < "u" && I instanceof WebGL2RenderingContext, ce = {}, de = {}, ue = {}, le = -1, xe = [];
                I.canvas.addEventListener("webglcontextlost", function(te) {
                    Re(), te.preventDefault();
                }, !1), f.set(I, Z = {
                    gl: I,
                    isWebGL2: oe,
                    getExtension: Le,
                    withProgram: Ne,
                    withTexture: ke,
                    withTextureFramebuffer: nt,
                    handleContextLoss: Re
                });
            }
            ee(Z);
        }
        function x($, ee, I, Z, oe, ce, de, ue) {
            de === void 0 && (de = 15), ue === void 0 && (ue = null), m($, function(le) {
                var xe = le.gl, Le = le.withProgram, Ue = le.withTexture;
                Ue("copy", function(Ne, ke) {
                    xe.texImage2D(xe.TEXTURE_2D, 0, xe.RGBA, oe, ce, 0, xe.RGBA, xe.UNSIGNED_BYTE, ee), Le("copy", l, c, function(nt) {
                        var Re = nt.setUniform, te = nt.setAttribute;
                        te("aUV", 2, xe.STATIC_DRAW, 0, new Float32Array([
                            0,
                            0,
                            2,
                            0,
                            0,
                            2
                        ])), Re("1i", "image", ke), xe.bindFramebuffer(xe.FRAMEBUFFER, ue || null), xe.disable(xe.BLEND), xe.colorMask(de & 8, de & 4, de & 2, de & 1), xe.viewport(I, Z, oe, ce), xe.scissor(I, Z, oe, ce), xe.drawArrays(xe.TRIANGLES, 0, 3);
                    });
                });
            });
        }
        function v($, ee, I) {
            var Z = $.width, oe = $.height;
            m($, function(ce) {
                var de = ce.gl, ue = new Uint8Array(Z * oe * 4);
                de.readPixels(0, 0, Z, oe, de.RGBA, de.UNSIGNED_BYTE, ue), $.width = ee, $.height = I, x(de, ue, 0, 0, Z, oe);
            });
        }
        var _ = Object.freeze({
            __proto__: null,
            withWebGLContext: m,
            renderImageData: x,
            resizeWebGLCanvasWithoutClearing: v
        });
        function S($, ee, I, Z, oe, ce) {
            ce === void 0 && (ce = 1);
            var de = new Uint8Array($ * ee), ue = Z[2] - Z[0], le = Z[3] - Z[1], xe = [];
            r(I, function(te, Oe, Ie, Ae) {
                xe.push({
                    x1: te,
                    y1: Oe,
                    x2: Ie,
                    y2: Ae,
                    minX: Math.min(te, Ie),
                    minY: Math.min(Oe, Ae),
                    maxX: Math.max(te, Ie),
                    maxY: Math.max(Oe, Ae)
                });
            }), xe.sort(function(te, Oe) {
                return te.maxX - Oe.maxX;
            });
            for(var Le = 0; Le < $; Le++)for(var Ue = 0; Ue < ee; Ue++){
                var Ne = nt(Z[0] + ue * (Le + .5) / $, Z[1] + le * (Ue + .5) / ee), ke = Math.pow(1 - Math.abs(Ne) / oe, ce) / 2;
                Ne < 0 && (ke = 1 - ke), ke = Math.max(0, Math.min(255, Math.round(ke * 255))), de[Ue * $ + Le] = ke;
            }
            return de;
            function nt(te, Oe) {
                for(var Ie = 1 / 0, Ae = 1 / 0, ze = xe.length; ze--;){
                    var Ze = xe[ze];
                    if (Ze.maxX + Ae <= te) break;
                    if (te + Ae > Ze.minX && Oe - Ae < Ze.maxY && Oe + Ae > Ze.minY) {
                        var be = b(te, Oe, Ze.x1, Ze.y1, Ze.x2, Ze.y2);
                        be < Ie && (Ie = be, Ae = Math.sqrt(Ie));
                    }
                }
                return Re(te, Oe) && (Ae = -Ae), Ae;
            }
            function Re(te, Oe) {
                for(var Ie = 0, Ae = xe.length; Ae--;){
                    var ze = xe[Ae];
                    if (ze.maxX <= te) break;
                    var Ze = ze.y1 > Oe != ze.y2 > Oe && te < (ze.x2 - ze.x1) * (Oe - ze.y1) / (ze.y2 - ze.y1) + ze.x1;
                    Ze && (Ie += ze.y1 < ze.y2 ? 1 : -1);
                }
                return Ie !== 0;
            }
        }
        function A($, ee, I, Z, oe, ce, de, ue, le, xe) {
            ce === void 0 && (ce = 1), ue === void 0 && (ue = 0), le === void 0 && (le = 0), xe === void 0 && (xe = 0), M($, ee, I, Z, oe, ce, de, null, ue, le, xe);
        }
        function M($, ee, I, Z, oe, ce, de, ue, le, xe, Le) {
            ce === void 0 && (ce = 1), le === void 0 && (le = 0), xe === void 0 && (xe = 0), Le === void 0 && (Le = 0);
            for(var Ue = S($, ee, I, Z, oe, ce), Ne = new Uint8Array(Ue.length * 4), ke = 0; ke < Ue.length; ke++)Ne[ke * 4 + Le] = Ue[ke];
            x(de, Ne, le, xe, $, ee, 1 << 3 - Le, ue);
        }
        function b($, ee, I, Z, oe, ce) {
            var de = oe - I, ue = ce - Z, le = de * de + ue * ue, xe = le ? Math.max(0, Math.min(1, (($ - I) * de + (ee - Z) * ue) / le)) : 0, Le = $ - (I + xe * de), Ue = ee - (Z + xe * ue);
            return Le * Le + Ue * Ue;
        }
        var C = Object.freeze({
            __proto__: null,
            generate: S,
            generateIntoCanvas: A,
            generateIntoFramebuffer: M
        }), R = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", N = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}", z = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}", L = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]), P = null, H = !1, O = {}, D = new WeakMap;
        function j($) {
            if (!H && !ae($)) throw new Error("WebGL generation not supported");
        }
        function G($, ee, I, Z, oe, ce, de) {
            if (ce === void 0 && (ce = 1), de === void 0 && (de = null), !de && (de = P, !de)) {
                var ue = typeof OffscreenCanvas == "function" ? new OffscreenCanvas(1, 1) : typeof document < "u" ? document.createElement("canvas") : null;
                if (!ue) throw new Error("OffscreenCanvas or DOM canvas not supported");
                de = P = ue.getContext("webgl", {
                    depth: !1
                });
            }
            j(de);
            var le = new Uint8Array($ * ee * 4);
            m(de, function(Ne) {
                var ke = Ne.gl, nt = Ne.withTexture, Re = Ne.withTextureFramebuffer;
                nt("readable", function(te, Oe) {
                    ke.texImage2D(ke.TEXTURE_2D, 0, ke.RGBA, $, ee, 0, ke.RGBA, ke.UNSIGNED_BYTE, null), Re(te, Oe, function(Ie) {
                        Y($, ee, I, Z, oe, ce, ke, Ie, 0, 0, 0), ke.readPixels(0, 0, $, ee, ke.RGBA, ke.UNSIGNED_BYTE, le);
                    });
                });
            });
            for(var xe = new Uint8Array($ * ee), Le = 0, Ue = 0; Le < le.length; Le += 4)xe[Ue++] = le[Le];
            return xe;
        }
        function q($, ee, I, Z, oe, ce, de, ue, le, xe) {
            ce === void 0 && (ce = 1), ue === void 0 && (ue = 0), le === void 0 && (le = 0), xe === void 0 && (xe = 0), Y($, ee, I, Z, oe, ce, de, null, ue, le, xe);
        }
        function Y($, ee, I, Z, oe, ce, de, ue, le, xe, Le) {
            ce === void 0 && (ce = 1), le === void 0 && (le = 0), xe === void 0 && (xe = 0), Le === void 0 && (Le = 0), j(de);
            var Ue = [];
            r(I, function(Ne, ke, nt, Re) {
                Ue.push(Ne, ke, nt, Re);
            }), Ue = new Float32Array(Ue), m(de, function(Ne) {
                var ke = Ne.gl, nt = Ne.isWebGL2, Re = Ne.getExtension, te = Ne.withProgram, Oe = Ne.withTexture, Ie = Ne.withTextureFramebuffer, Ae = Ne.handleContextLoss;
                if (Oe("rawDistances", function(ze, Ze) {
                    ($ !== ze._lastWidth || ee !== ze._lastHeight) && ke.texImage2D(ke.TEXTURE_2D, 0, ke.RGBA, ze._lastWidth = $, ze._lastHeight = ee, 0, ke.RGBA, ke.UNSIGNED_BYTE, null), te("main", R, N, function(be) {
                        var rt = be.setAttribute, ne = be.setUniform, W = !nt && Re("ANGLE_instanced_arrays"), pe = !nt && Re("EXT_blend_minmax");
                        rt("aUV", 2, ke.STATIC_DRAW, 0, L), rt("aLineSegment", 4, ke.DYNAMIC_DRAW, 1, Ue), ne.apply(void 0, [
                            "4f",
                            "uGlyphBounds"
                        ].concat(Z)), ne("1f", "uMaxDistance", oe), ne("1f", "uExponent", ce), Ie(ze, Ze, function(Be) {
                            ke.enable(ke.BLEND), ke.colorMask(!0, !0, !0, !0), ke.viewport(0, 0, $, ee), ke.scissor(0, 0, $, ee), ke.blendFunc(ke.ONE, ke.ONE), ke.blendEquationSeparate(ke.FUNC_ADD, nt ? ke.MAX : pe.MAX_EXT), ke.clear(ke.COLOR_BUFFER_BIT), nt ? ke.drawArraysInstanced(ke.TRIANGLES, 0, 3, Ue.length / 4) : W.drawArraysInstancedANGLE(ke.TRIANGLES, 0, 3, Ue.length / 4);
                        });
                    }), te("post", l, z, function(be) {
                        be.setAttribute("aUV", 2, ke.STATIC_DRAW, 0, L), be.setUniform("1i", "tex", Ze), ke.bindFramebuffer(ke.FRAMEBUFFER, ue), ke.disable(ke.BLEND), ke.colorMask(Le === 0, Le === 1, Le === 2, Le === 3), ke.viewport(le, xe, $, ee), ke.scissor(le, xe, $, ee), ke.drawArrays(ke.TRIANGLES, 0, 3);
                    });
                }), ke.isContextLost()) throw Ae(), new Error("webgl context lost");
            });
        }
        function ae($) {
            var ee = !$ || $ === P ? O : $.canvas || $, I = D.get(ee);
            if (I === void 0) {
                H = !0;
                var Z = null;
                try {
                    var oe = [
                        97,
                        106,
                        97,
                        61,
                        99,
                        137,
                        118,
                        80,
                        80,
                        118,
                        137,
                        99,
                        61,
                        97,
                        106,
                        97
                    ], ce = G(4, 4, "M8,8L16,8L24,24L16,24Z", [
                        0,
                        0,
                        32,
                        32
                    ], 24, 1, $);
                    I = ce && oe.length === ce.length && ce.every(function(de, ue) {
                        return de === oe[ue];
                    }), I || (Z = "bad trial run results", console.info(oe, ce));
                } catch (de) {
                    I = !1, Z = de.message;
                }
                Z && console.warn("WebGL SDF generation not supported:", Z), H = !1, D.set(ee, I);
            }
            return I;
        }
        var F = Object.freeze({
            __proto__: null,
            generate: G,
            generateIntoCanvas: q,
            generateIntoFramebuffer: Y,
            isSupported: ae
        });
        function Q($, ee, I, Z, oe, ce) {
            oe === void 0 && (oe = Math.max(Z[2] - Z[0], Z[3] - Z[1]) / 2), ce === void 0 && (ce = 1);
            try {
                return G.apply(F, arguments);
            } catch (de) {
                return console.info("WebGL SDF generation failed, falling back to JS", de), S.apply(C, arguments);
            }
        }
        function K($, ee, I, Z, oe, ce, de, ue, le, xe) {
            oe === void 0 && (oe = Math.max(Z[2] - Z[0], Z[3] - Z[1]) / 2), ce === void 0 && (ce = 1), ue === void 0 && (ue = 0), le === void 0 && (le = 0), xe === void 0 && (xe = 0);
            try {
                return q.apply(F, arguments);
            } catch (Le) {
                return console.info("WebGL SDF generation failed, falling back to JS", Le), A.apply(C, arguments);
            }
        }
        return e.forEachPathCommand = i, e.generate = Q, e.generateIntoCanvas = K, e.javascript = C, e.pathToLineSegments = r, e.webgl = F, e.webglUtils = _, Object.defineProperty(e, "__esModule", {
            value: !0
        }), e;
    }({});
    return a;
}
function $455d545b1dff00eb$var$wI() {
    var a = function(e) {
        var t = {
            R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
            EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
            ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
            ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
            AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
            CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
            B: "a,3,f+2,2v,690",
            S: "9,2,k",
            WS: "c,k,4f4,1vk+a,u,1j,335",
            ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
            BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
            NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
            AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
            LRO: "6ct",
            RLO: "6cu",
            LRE: "6cq",
            RLE: "6cr",
            PDF: "6cs",
            LRI: "6ee",
            RLI: "6ef",
            FSI: "6eg",
            PDI: "6eh"
        }, n = {}, i = {};
        n.L = 1, i[1] = "L", Object.keys(t).forEach(function(Ae, ze) {
            n[Ae] = 1 << ze + 1, i[n[Ae]] = Ae;
        }), Object.freeze(n);
        var r = n.LRI | n.RLI | n.FSI, l = n.L | n.R | n.AL, c = n.B | n.S | n.WS | n.ON | n.FSI | n.LRI | n.RLI | n.PDI, f = n.BN | n.RLE | n.LRE | n.RLO | n.LRO | n.PDF, p = n.S | n.WS | n.B | r | n.PDI | f, m = null;
        function x() {
            if (!m) {
                m = new Map;
                var Ae = function(Ze) {
                    if (t.hasOwnProperty(Ze)) {
                        var be = 0;
                        t[Ze].split(",").forEach(function(rt) {
                            var ne = rt.split("+"), W = ne[0], pe = ne[1];
                            W = parseInt(W, 36), pe = pe ? parseInt(pe, 36) : 0, m.set(be += W, n[Ze]);
                            for(var Be = 0; Be < pe; Be++)m.set(++be, n[Ze]);
                        });
                    }
                };
                for(var ze in t)Ae(ze);
            }
        }
        function v(Ae) {
            return x(), m.get(Ae.codePointAt(0)) || n.L;
        }
        function _(Ae) {
            return i[v(Ae)];
        }
        var S = {
            pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
            canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
        };
        function A(Ae, ze) {
            var Ze = 36, be = 0, rt = new Map, ne = ze && new Map, W;
            return Ae.split(",").forEach(function pe(Be) {
                if (Be.indexOf("+") !== -1) for(var Te = +Be; Te--;)pe(W);
                else {
                    W = Be;
                    var _e = Be.split(">"), ot = _e[0], tt = _e[1];
                    ot = String.fromCodePoint(be += parseInt(ot, Ze)), tt = String.fromCodePoint(be += parseInt(tt, Ze)), rt.set(ot, tt), ze && ne.set(tt, ot);
                }
            }), {
                map: rt,
                reverseMap: ne
            };
        }
        var M, b, C;
        function R() {
            if (!M) {
                var Ae = A(S.pairs, !0), ze = Ae.map, Ze = Ae.reverseMap;
                M = ze, b = Ze, C = A(S.canonical, !1).map;
            }
        }
        function N(Ae) {
            return R(), M.get(Ae) || null;
        }
        function z(Ae) {
            return R(), b.get(Ae) || null;
        }
        function L(Ae) {
            return R(), C.get(Ae) || null;
        }
        var P = n.L, H = n.R, O = n.EN, D = n.ES, j = n.ET, G = n.AN, q = n.CS, Y = n.B, ae = n.S, F = n.ON, Q = n.BN, K = n.NSM, $ = n.AL, ee = n.LRO, I = n.RLO, Z = n.LRE, oe = n.RLE, ce = n.PDF, de = n.LRI, ue = n.RLI, le = n.FSI, xe = n.PDI;
        function Le(Ae, ze) {
            for(var Ze = 125, be = new Uint32Array(Ae.length), rt = 0; rt < Ae.length; rt++)be[rt] = v(Ae[rt]);
            var ne = new Map;
            function W(na, Ha) {
                var Bi = be[na];
                be[na] = Ha, ne.set(Bi, ne.get(Bi) - 1), Bi & c && ne.set(c, ne.get(c) - 1), ne.set(Ha, (ne.get(Ha) || 0) + 1), Ha & c && ne.set(c, (ne.get(c) || 0) + 1);
            }
            for(var pe = new Uint8Array(Ae.length), Be = new Map, Te = [], _e = null, ot = 0; ot < Ae.length; ot++)_e || Te.push(_e = {
                start: ot,
                end: Ae.length - 1,
                level: ze === "rtl" ? 1 : ze === "ltr" ? 0 : Ou(ot, !1)
            }), be[ot] & Y && (_e.end = ot, _e = null);
            for(var tt = oe | Z | I | ee | r | xe | ce | Y, gt = function(na) {
                return na + (na & 1 ? 1 : 2);
            }, pt = function(na) {
                return na + (na & 1 ? 2 : 1);
            }, Ge = 0; Ge < Te.length; Ge++){
                _e = Te[Ge];
                var Ye = [
                    {
                        _level: _e.level,
                        _override: 0,
                        _isolate: 0
                    }
                ], at = void 0, he = 0, Ee = 0, lt = 0;
                ne.clear();
                for(var fe = _e.start; fe <= _e.end; fe++){
                    var We = be[fe];
                    if (at = Ye[Ye.length - 1], ne.set(We, (ne.get(We) || 0) + 1), We & c && ne.set(c, (ne.get(c) || 0) + 1), We & tt) {
                        if (We & (oe | Z)) {
                            pe[fe] = at._level;
                            var Je = (We === oe ? pt : gt)(at._level);
                            Je <= Ze && !he && !Ee ? Ye.push({
                                _level: Je,
                                _override: 0,
                                _isolate: 0
                            }) : he || Ee++;
                        } else if (We & (I | ee)) {
                            pe[fe] = at._level;
                            var ut = (We === I ? pt : gt)(at._level);
                            ut <= Ze && !he && !Ee ? Ye.push({
                                _level: ut,
                                _override: We & I ? H : P,
                                _isolate: 0
                            }) : he || Ee++;
                        } else if (We & r) {
                            We & le && (We = Ou(fe + 1, !0) === 1 ? ue : de), pe[fe] = at._level, at._override && W(fe, at._override);
                            var Ke = (We === ue ? pt : gt)(at._level);
                            Ke <= Ze && he === 0 && Ee === 0 ? (lt++, Ye.push({
                                _level: Ke,
                                _override: 0,
                                _isolate: 1,
                                _isolInitIndex: fe
                            })) : he++;
                        } else if (We & xe) {
                            if (he > 0) he--;
                            else if (lt > 0) {
                                for(Ee = 0; !Ye[Ye.length - 1]._isolate;)Ye.pop();
                                var Ve = Ye[Ye.length - 1]._isolInitIndex;
                                Ve != null && (Be.set(Ve, fe), Be.set(fe, Ve)), Ye.pop(), lt--;
                            }
                            at = Ye[Ye.length - 1], pe[fe] = at._level, at._override && W(fe, at._override);
                        } else We & ce ? (he === 0 && (Ee > 0 ? Ee-- : !at._isolate && Ye.length > 1 && (Ye.pop(), at = Ye[Ye.length - 1])), pe[fe] = at._level) : We & Y && (pe[fe] = _e.level);
                    } else pe[fe] = at._level, at._override && We !== Q && W(fe, at._override);
                }
                for(var ft = [], vt = null, yt = _e.start; yt <= _e.end; yt++){
                    var Ct = be[yt];
                    if (!(Ct & f)) {
                        var on = pe[yt], gn = Ct & r, ni = Ct === xe;
                        vt && on === vt._level ? (vt._end = yt, vt._endsWithIsolInit = gn) : ft.push(vt = {
                            _start: yt,
                            _end: yt,
                            _level: on,
                            _startsWithPDI: ni,
                            _endsWithIsolInit: gn
                        });
                    }
                }
                for(var Gi = [], da = 0; da < ft.length; da++){
                    var jn = ft[da];
                    if (!jn._startsWithPDI || jn._startsWithPDI && !Be.has(jn._start)) {
                        for(var ea = [
                            vt = jn
                        ], Pi = void 0; vt && vt._endsWithIsolInit && (Pi = Be.get(vt._end)) != null;)for(var hi = da + 1; hi < ft.length; hi++)if (ft[hi]._start === Pi) {
                            ea.push(vt = ft[hi]);
                            break;
                        }
                        for(var Nn = [], jt = 0; jt < ea.length; jt++)for(var ci = ea[jt], Aa = ci._start; Aa <= ci._end; Aa++)Nn.push(Aa);
                        for(var Qs = pe[Nn[0]], Tl = _e.level, zo = Nn[0] - 1; zo >= 0; zo--)if (!(be[zo] & f)) {
                            Tl = pe[zo];
                            break;
                        }
                        var Ss = Nn[Nn.length - 1], es = pe[Ss], Ms = _e.level;
                        if (!(be[Ss] & r)) {
                            for(var Qn = Ss + 1; Qn <= _e.end; Qn++)if (!(be[Qn] & f)) {
                                Ms = pe[Qn];
                                break;
                            }
                        }
                        Gi.push({
                            _seqIndices: Nn,
                            _sosType: Math.max(Tl, Qs) % 2 ? H : P,
                            _eosType: Math.max(Ms, es) % 2 ? H : P
                        });
                    }
                }
                for(var ie = 0; ie < Gi.length; ie++){
                    var Se = Gi[ie], ve = Se._seqIndices, Pe = Se._sosType, Me = Se._eosType, dt = pe[ve[0]] & 1 ? H : P;
                    if (ne.get(K)) for(var xt = 0; xt < ve.length; xt++){
                        var Et = ve[xt];
                        if (be[Et] & K) {
                            for(var Tt = Pe, Ot = xt - 1; Ot >= 0; Ot--)if (!(be[ve[Ot]] & f)) {
                                Tt = be[ve[Ot]];
                                break;
                            }
                            W(Et, Tt & (r | xe) ? F : Tt);
                        }
                    }
                    if (ne.get(O)) for(var Pt = 0; Pt < ve.length; Pt++){
                        var Ut = ve[Pt];
                        if (be[Ut] & O) for(var qt = Pt - 1; qt >= -1; qt--){
                            var mn = qt === -1 ? Pe : be[ve[qt]];
                            if (mn & l) {
                                mn === $ && W(Ut, G);
                                break;
                            }
                        }
                    }
                    if (ne.get($)) for(var fn = 0; fn < ve.length; fn++){
                        var ln = ve[fn];
                        be[ln] & $ && W(ln, H);
                    }
                    if (ne.get(D) || ne.get(q)) for(var xn = 1; xn < ve.length - 1; xn++){
                        var Lt = ve[xn];
                        if (be[Lt] & (D | q)) {
                            for(var _n = 0, an = 0, ui = xn - 1; ui >= 0 && (_n = be[ve[ui]], !!(_n & f)); ui--);
                            for(var sr = xn + 1; sr < ve.length && (an = be[ve[sr]], !!(an & f)); sr++);
                            _n === an && (be[Lt] === D ? _n === O : _n & (O | G)) && W(Lt, _n);
                        }
                    }
                    if (ne.get(O)) for(var hn = 0; hn < ve.length; hn++){
                        var Or = ve[hn];
                        if (be[Or] & O) {
                            for(var On = hn - 1; On >= 0 && be[ve[On]] & (j | f); On--)W(ve[On], O);
                            for(hn++; hn < ve.length && be[ve[hn]] & (j | f | O); hn++)be[ve[hn]] !== O && W(ve[hn], O);
                        }
                    }
                    if (ne.get(j) || ne.get(D) || ne.get(q)) for(var ii = 0; ii < ve.length; ii++){
                        var gi = ve[ii];
                        if (be[gi] & (j | D | q)) {
                            W(gi, F);
                            for(var fi = ii - 1; fi >= 0 && be[ve[fi]] & f; fi--)W(ve[fi], F);
                            for(var qn = ii + 1; qn < ve.length && be[ve[qn]] & f; qn++)W(ve[qn], F);
                        }
                    }
                    if (ne.get(O)) for(var wa = 0, Ca = Pe; wa < ve.length; wa++){
                        var Po = ve[wa], Al = be[Po];
                        Al & O ? Ca === P && W(Po, P) : Al & l && (Ca = Al);
                    }
                    if (ne.get(c)) {
                        var ts = H | O | G, Nu = ts | P, wl = [];
                        for(var Lr = [], ta = 0; ta < ve.length; ta++)if (be[ve[ta]] & c) {
                            var ns = Ae[ve[ta]], Cl = void 0;
                            if (N(ns) !== null) {
                                if (Lr.length < 63) Lr.push({
                                    char: ns,
                                    seqIndex: ta
                                });
                                else break;
                            } else if ((Cl = z(ns)) !== null) for(var or = Lr.length - 1; or >= 0; or--){
                                var zr = Lr[or].char;
                                if (zr === Cl || zr === z(L(ns)) || N(L(zr)) === ns) {
                                    wl.push([
                                        Lr[or].seqIndex,
                                        ta
                                    ]), Lr.length = or;
                                    break;
                                }
                            }
                        }
                        wl.sort(function(na, Ha) {
                            return na[0] - Ha[0];
                        });
                        for(var Rl = 0; Rl < wl.length; Rl++){
                            for(var Dl = wl[Rl], Bo = Dl[0], is = Dl[1], lr = !1, pa = 0, Ks = Bo + 1; Ks < is; Ks++){
                                var as = ve[Ks];
                                if (be[as] & Nu) {
                                    lr = !0;
                                    var Ul = be[as] & ts ? H : P;
                                    if (Ul === dt) {
                                        pa = Ul;
                                        break;
                                    }
                                }
                            }
                            if (lr && !pa) {
                                pa = Pe;
                                for(var Pr = Bo - 1; Pr >= 0; Pr--){
                                    var Nl = ve[Pr];
                                    if (be[Nl] & Nu) {
                                        var Es = be[Nl] & ts ? H : P;
                                        Es !== dt ? pa = Es : pa = dt;
                                        break;
                                    }
                                }
                            }
                            if (pa) {
                                if (be[ve[Bo]] = be[ve[is]] = pa, pa !== dt) {
                                    for(var rs = Bo + 1; rs < ve.length; rs++)if (!(be[ve[rs]] & f)) {
                                        v(Ae[ve[rs]]) & K && (be[ve[rs]] = pa);
                                        break;
                                    }
                                }
                                if (pa !== dt) {
                                    for(var Js = is + 1; Js < ve.length; Js++)if (!(be[ve[Js]] & f)) {
                                        v(Ae[ve[Js]]) & K && (be[ve[Js]] = pa);
                                        break;
                                    }
                                }
                            }
                        }
                        for(var ai = 0; ai < ve.length; ai++)if (be[ve[ai]] & c) {
                            for(var ss = ai, $s = ai, Ra = Pe, Ts = ai - 1; Ts >= 0; Ts--)if (be[ve[Ts]] & f) ss = Ts;
                            else {
                                Ra = be[ve[Ts]] & ts ? H : P;
                                break;
                            }
                            for(var Ol = Me, os = ai + 1; os < ve.length; os++)if (be[ve[os]] & (c | f)) $s = os;
                            else {
                                Ol = be[ve[os]] & ts ? H : P;
                                break;
                            }
                            for(var As = ss; As <= $s; As++)be[ve[As]] = Ra === Ol ? Ra : dt;
                            ai = $s;
                        }
                    }
                }
                for(var ki = _e.start; ki <= _e.end; ki++){
                    var eh = pe[ki], xi = be[ki];
                    if (eh & 1 ? xi & (P | O | G) && pe[ki]++ : xi & H ? pe[ki]++ : xi & (G | O) && (pe[ki] += 2), xi & f && (pe[ki] = ki === 0 ? _e.level : pe[ki - 1]), ki === _e.end || v(Ae[ki]) & (ae | Y)) for(var Ll = ki; Ll >= 0 && v(Ae[Ll]) & p; Ll--)pe[Ll] = _e.level;
                }
            }
            return {
                levels: pe,
                paragraphs: Te
            };
            function Ou(na, Ha) {
                for(var Bi = na; Bi < Ae.length; Bi++){
                    var Br = be[Bi];
                    if (Br & (H | $)) return 1;
                    if (Br & (Y | P) || Ha && Br === xe) return 0;
                    if (Br & r) {
                        var Lu = wc(Bi);
                        Bi = Lu === -1 ? Ae.length : Lu;
                    }
                }
                return 0;
            }
            function wc(na) {
                for(var Ha = 1, Bi = na + 1; Bi < Ae.length; Bi++){
                    var Br = be[Bi];
                    if (Br & Y) break;
                    if (Br & xe) {
                        if (--Ha === 0) return Bi;
                    } else Br & r && Ha++;
                }
                return -1;
            }
        }
        var Ue = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", Ne;
        function ke() {
            if (!Ne) {
                var Ae = A(Ue, !0), ze = Ae.map, Ze = Ae.reverseMap;
                Ze.forEach(function(be, rt) {
                    ze.set(rt, be);
                }), Ne = ze;
            }
        }
        function nt(Ae) {
            return ke(), Ne.get(Ae) || null;
        }
        function Re(Ae, ze, Ze, be) {
            var rt = Ae.length;
            Ze = Math.max(0, Ze == null ? 0 : +Ze), be = Math.min(rt - 1, be == null ? rt - 1 : +be);
            for(var ne = new Map, W = Ze; W <= be; W++)if (ze[W] & 1) {
                var pe = nt(Ae[W]);
                pe !== null && ne.set(W, pe);
            }
            return ne;
        }
        function te(Ae, ze, Ze, be) {
            var rt = Ae.length;
            Ze = Math.max(0, Ze == null ? 0 : +Ze), be = Math.min(rt - 1, be == null ? rt - 1 : +be);
            var ne = [];
            return ze.paragraphs.forEach(function(W) {
                var pe = Math.max(Ze, W.start), Be = Math.min(be, W.end);
                if (pe < Be) {
                    for(var Te = ze.levels.slice(pe, Be + 1), _e = Be; _e >= pe && v(Ae[_e]) & p; _e--)Te[_e] = W.level;
                    for(var ot = W.level, tt = 1 / 0, gt = 0; gt < Te.length; gt++){
                        var pt = Te[gt];
                        pt > ot && (ot = pt), pt < tt && (tt = pt | 1);
                    }
                    for(var Ge = ot; Ge >= tt; Ge--)for(var Ye = 0; Ye < Te.length; Ye++)if (Te[Ye] >= Ge) {
                        for(var at = Ye; Ye + 1 < Te.length && Te[Ye + 1] >= Ge;)Ye++;
                        Ye > at && ne.push([
                            at + pe,
                            Ye + pe
                        ]);
                    }
                }
            }), ne;
        }
        function Oe(Ae, ze, Ze, be) {
            var rt = Ie(Ae, ze, Ze, be), ne = [].concat(Ae);
            return rt.forEach(function(W, pe) {
                ne[pe] = (ze.levels[W] & 1 ? nt(Ae[W]) : null) || Ae[W];
            }), ne.join("");
        }
        function Ie(Ae, ze, Ze, be) {
            for(var rt = te(Ae, ze, Ze, be), ne = [], W = 0; W < Ae.length; W++)ne[W] = W;
            return rt.forEach(function(pe) {
                for(var Be = pe[0], Te = pe[1], _e = ne.slice(Be, Te + 1), ot = _e.length; ot--;)ne[Te - ot] = _e[ot];
            }), ne;
        }
        return e.closingToOpeningBracket = z, e.getBidiCharType = v, e.getBidiCharTypeName = _, e.getCanonicalBracket = L, e.getEmbeddingLevels = Le, e.getMirroredCharacter = nt, e.getMirroredCharactersMap = Re, e.getReorderSegments = te, e.getReorderedIndices = Ie, e.getReorderedString = Oe, e.openingToClosingBracket = N, Object.defineProperty(e, "__esModule", {
            value: !0
        }), e;
    }({});
    return a;
}
const $455d545b1dff00eb$var$$A = /\bvoid\s+main\s*\(\s*\)\s*{/g;
function $455d545b1dff00eb$var$xb(a) {
    const e = /^[ \t]*#include +<([\w\d./]+)>/gm;
    function t(n, i) {
        let r = $455d545b1dff00eb$var$rn[i];
        return r ? $455d545b1dff00eb$var$xb(r) : n;
    }
    return a.replace(e, t);
}
const $455d545b1dff00eb$var$Ia = [];
for(let a = 0; a < 256; a++)$455d545b1dff00eb$var$Ia[a] = (a < 16 ? "0" : "") + a.toString(16);
function $455d545b1dff00eb$var$CI() {
    const a = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
    return ($455d545b1dff00eb$var$Ia[a & 255] + $455d545b1dff00eb$var$Ia[a >> 8 & 255] + $455d545b1dff00eb$var$Ia[a >> 16 & 255] + $455d545b1dff00eb$var$Ia[a >> 24 & 255] + "-" + $455d545b1dff00eb$var$Ia[e & 255] + $455d545b1dff00eb$var$Ia[e >> 8 & 255] + "-" + $455d545b1dff00eb$var$Ia[e >> 16 & 15 | 64] + $455d545b1dff00eb$var$Ia[e >> 24 & 255] + "-" + $455d545b1dff00eb$var$Ia[t & 63 | 128] + $455d545b1dff00eb$var$Ia[t >> 8 & 255] + "-" + $455d545b1dff00eb$var$Ia[t >> 16 & 255] + $455d545b1dff00eb$var$Ia[t >> 24 & 255] + $455d545b1dff00eb$var$Ia[n & 255] + $455d545b1dff00eb$var$Ia[n >> 8 & 255] + $455d545b1dff00eb$var$Ia[n >> 16 & 255] + $455d545b1dff00eb$var$Ia[n >> 24 & 255]).toUpperCase();
}
const $455d545b1dff00eb$var$Uf = Object.assign || function() {
    let a = arguments[0];
    for(let e = 1, t = arguments.length; e < t; e++){
        let n = arguments[e];
        if (n) for(let i in n)Object.prototype.hasOwnProperty.call(n, i) && (a[i] = n[i]);
    }
    return a;
}, $455d545b1dff00eb$var$RI = Date.now(), $455d545b1dff00eb$var$V3 = new WeakMap, $455d545b1dff00eb$var$G3 = new Map;
let $455d545b1dff00eb$var$DI = 1e10;
function $455d545b1dff00eb$var$vb(a, e) {
    const t = $455d545b1dff00eb$var$LI(e);
    let n = $455d545b1dff00eb$var$V3.get(a);
    if (n || $455d545b1dff00eb$var$V3.set(a, n = Object.create(null)), n[t]) return new n[t];
    const i = `_onBeforeCompile${t}`, r = function(p, m) {
        a.onBeforeCompile.call(this, p, m);
        const x = this.customProgramCacheKey() + "|" + p.vertexShader + "|" + p.fragmentShader;
        let v = $455d545b1dff00eb$var$G3[x];
        if (!v) {
            const _ = $455d545b1dff00eb$var$UI(this, p, e, t);
            v = $455d545b1dff00eb$var$G3[x] = _;
        }
        p.vertexShader = v.vertexShader, p.fragmentShader = v.fragmentShader, $455d545b1dff00eb$var$Uf(p.uniforms, this.uniforms), e.timeUniform && (p.uniforms[e.timeUniform] = {
            get value () {
                return Date.now() - $455d545b1dff00eb$var$RI;
            }
        }), this[i] && this[i](p);
    }, l = function() {
        return c(e.chained ? a : a.clone());
    }, c = function(p) {
        const m = Object.create(p, f);
        return Object.defineProperty(m, "baseMaterial", {
            value: a
        }), Object.defineProperty(m, "id", {
            value: $455d545b1dff00eb$var$DI++
        }), m.uuid = $455d545b1dff00eb$var$CI(), m.uniforms = $455d545b1dff00eb$var$Uf({}, p.uniforms, e.uniforms), m.defines = $455d545b1dff00eb$var$Uf({}, p.defines, e.defines), m.defines[`TROIKA_DERIVED_MATERIAL_${t}`] = "", m.extensions = $455d545b1dff00eb$var$Uf({}, p.extensions, e.extensions), m._listeners = void 0, m;
    }, f = {
        constructor: {
            value: l
        },
        isDerivedMaterial: {
            value: !0
        },
        type: {
            get: ()=>a.type,
            set: (p)=>{
                a.type = p;
            }
        },
        isDerivedFrom: {
            writable: !0,
            configurable: !0,
            value: function(p) {
                const m = this.baseMaterial;
                return p === m || m.isDerivedMaterial && m.isDerivedFrom(p) || !1;
            }
        },
        customProgramCacheKey: {
            writable: !0,
            configurable: !0,
            value: function() {
                return a.customProgramCacheKey() + "|" + t;
            }
        },
        onBeforeCompile: {
            get () {
                return r;
            },
            set (p) {
                this[i] = p;
            }
        },
        copy: {
            writable: !0,
            configurable: !0,
            value: function(p) {
                return a.copy.call(this, p), !a.isShaderMaterial && !a.isDerivedMaterial && ($455d545b1dff00eb$var$Uf(this.extensions, p.extensions), $455d545b1dff00eb$var$Uf(this.defines, p.defines), $455d545b1dff00eb$var$Uf(this.uniforms, $455d545b1dff00eb$var$jb.clone(p.uniforms))), this;
            }
        },
        clone: {
            writable: !0,
            configurable: !0,
            value: function() {
                const p = new a.constructor;
                return c(p).copy(this);
            }
        },
        getDepthMaterial: {
            writable: !0,
            configurable: !0,
            value: function() {
                let p = this._depthMaterial;
                return p || (p = this._depthMaterial = $455d545b1dff00eb$var$vb(a.isDerivedMaterial ? a.getDepthMaterial() : new $455d545b1dff00eb$var$Ly({
                    depthPacking: $455d545b1dff00eb$var$Ib
                }), e), p.defines.IS_DEPTH_MATERIAL = "", p.uniforms = this.uniforms), p;
            }
        },
        getDistanceMaterial: {
            writable: !0,
            configurable: !0,
            value: function() {
                let p = this._distanceMaterial;
                return p || (p = this._distanceMaterial = $455d545b1dff00eb$var$vb(a.isDerivedMaterial ? a.getDistanceMaterial() : new $455d545b1dff00eb$var$zy, e), p.defines.IS_DISTANCE_MATERIAL = "", p.uniforms = this.uniforms), p;
            }
        },
        dispose: {
            writable: !0,
            configurable: !0,
            value () {
                const { _depthMaterial: p, _distanceMaterial: m } = this;
                p && p.dispose(), m && m.dispose(), a.dispose.call(this);
            }
        }
    };
    return n[t] = l, new l;
}
function $455d545b1dff00eb$var$UI(a, { vertexShader: e, fragmentShader: t }, n, i) {
    let { vertexDefs: r, vertexMainIntro: l, vertexMainOutro: c, vertexTransform: f, fragmentDefs: p, fragmentMainIntro: m, fragmentMainOutro: x, fragmentColorTransform: v, customRewriter: _, timeUniform: S } = n;
    if (r = r || "", l = l || "", c = c || "", p = p || "", m = m || "", x = x || "", (f || _) && (e = $455d545b1dff00eb$var$xb(e)), (v || _) && (t = t.replace(/^[ \t]*#include <((?:tonemapping|encodings|colorspace|fog|premultiplied_alpha|dithering)_fragment)>/gm, `
//!BEGIN_POST_CHUNK $1
$&
//!END_POST_CHUNK
`), t = $455d545b1dff00eb$var$xb(t)), _) {
        let A = _({
            vertexShader: e,
            fragmentShader: t
        });
        e = A.vertexShader, t = A.fragmentShader;
    }
    if (v) {
        let A = [];
        t = t.replace(/^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm, (M)=>(A.push(M), "")), x = `${v}
${A.join(`
`)}
${x}`;
    }
    if (S) {
        const A = `
uniform float ${S};
`;
        r = A + r, p = A + p;
    }
    return f && (e = `vec3 troika_position_${i};
vec3 troika_normal_${i};
vec2 troika_uv_${i};
${e}
`, r = `${r}
void troikaVertexTransform${i}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${f}
}
`, l = `
troika_position_${i} = vec3(position);
troika_normal_${i} = vec3(normal);
troika_uv_${i} = vec2(uv);
troikaVertexTransform${i}(troika_position_${i}, troika_normal_${i}, troika_uv_${i});
${l}
`, e = e.replace(/\b(position|normal|uv)\b/g, (A, M, b, C)=>/\battribute\s+vec[23]\s+$/.test(C.substr(0, b)) ? M : `troika_${M}_${i}`), a.map && a.map.channel > 0 || (e = e.replace(/\bMAP_UV\b/g, `troika_uv_${i}`))), e = $455d545b1dff00eb$var$k3(e, i, r, l, c), t = $455d545b1dff00eb$var$k3(t, i, p, m, x), {
        vertexShader: e,
        fragmentShader: t
    };
}
function $455d545b1dff00eb$var$k3(a, e, t, n, i) {
    return (n || i || t) && (a = a.replace($455d545b1dff00eb$var$$A, `
${t}
void troikaOrigMain${e}() {`), a += `
void main() {
  ${n}
  troikaOrigMain${e}();
  ${i}
}`), a;
}
function $455d545b1dff00eb$var$NI(a, e) {
    return a === "uniforms" ? void 0 : typeof e == "function" ? e.toString() : e;
}
let $455d545b1dff00eb$var$OI = 0;
const $455d545b1dff00eb$var$j3 = new Map;
function $455d545b1dff00eb$var$LI(a) {
    const e = JSON.stringify(a, $455d545b1dff00eb$var$NI);
    let t = $455d545b1dff00eb$var$j3.get(e);
    return t == null && $455d545b1dff00eb$var$j3.set(e, t = ++$455d545b1dff00eb$var$OI), t;
}
function $455d545b1dff00eb$var$zI() {
    return typeof window > "u" && (self.window = self), function(a) {
        var e = {
            parse: function(i) {
                var r = e._bin, l = new Uint8Array(i);
                if (r.readASCII(l, 0, 4) == "ttcf") {
                    var c = 4;
                    r.readUshort(l, c), c += 2, r.readUshort(l, c), c += 2;
                    var f = r.readUint(l, c);
                    c += 4;
                    for(var p = [], m = 0; m < f; m++){
                        var x = r.readUint(l, c);
                        c += 4, p.push(e._readFont(l, x));
                    }
                    return p;
                }
                return [
                    e._readFont(l, 0)
                ];
            },
            _readFont: function(i, r) {
                var l = e._bin, c = r;
                l.readFixed(i, r), r += 4;
                var f = l.readUshort(i, r);
                r += 2, l.readUshort(i, r), r += 2, l.readUshort(i, r), r += 2, l.readUshort(i, r), r += 2;
                for(var p = [
                    "cmap",
                    "head",
                    "hhea",
                    "maxp",
                    "hmtx",
                    "name",
                    "OS/2",
                    "post",
                    "loca",
                    "glyf",
                    "kern",
                    "CFF ",
                    "GDEF",
                    "GPOS",
                    "GSUB",
                    "SVG "
                ], m = {
                    _data: i,
                    _offset: c
                }, x = {}, v = 0; v < f; v++){
                    var _ = l.readASCII(i, r, 4);
                    r += 4, l.readUint(i, r), r += 4;
                    var S = l.readUint(i, r);
                    r += 4;
                    var A = l.readUint(i, r);
                    r += 4, x[_] = {
                        offset: S,
                        length: A
                    };
                }
                for(v = 0; v < p.length; v++){
                    var M = p[v];
                    x[M] && (m[M.trim()] = e[M.trim()].parse(i, x[M].offset, x[M].length, m));
                }
                return m;
            },
            _tabOffset: function(i, r, l) {
                for(var c = e._bin, f = c.readUshort(i, l + 4), p = l + 12, m = 0; m < f; m++){
                    var x = c.readASCII(i, p, 4);
                    p += 4, c.readUint(i, p), p += 4;
                    var v = c.readUint(i, p);
                    if (p += 4, c.readUint(i, p), p += 4, x == r) return v;
                }
                return 0;
            }
        };
        e._bin = {
            readFixed: function(i, r) {
                return (i[r] << 8 | i[r + 1]) + (i[r + 2] << 8 | i[r + 3]) / 65540;
            },
            readF2dot14: function(i, r) {
                return e._bin.readShort(i, r) / 16384;
            },
            readInt: function(i, r) {
                return e._bin._view(i).getInt32(r);
            },
            readInt8: function(i, r) {
                return e._bin._view(i).getInt8(r);
            },
            readShort: function(i, r) {
                return e._bin._view(i).getInt16(r);
            },
            readUshort: function(i, r) {
                return e._bin._view(i).getUint16(r);
            },
            readUshorts: function(i, r, l) {
                for(var c = [], f = 0; f < l; f++)c.push(e._bin.readUshort(i, r + 2 * f));
                return c;
            },
            readUint: function(i, r) {
                return e._bin._view(i).getUint32(r);
            },
            readUint64: function(i, r) {
                return 4294967296 * e._bin.readUint(i, r) + e._bin.readUint(i, r + 4);
            },
            readASCII: function(i, r, l) {
                for(var c = "", f = 0; f < l; f++)c += String.fromCharCode(i[r + f]);
                return c;
            },
            readUnicode: function(i, r, l) {
                for(var c = "", f = 0; f < l; f++){
                    var p = i[r++] << 8 | i[r++];
                    c += String.fromCharCode(p);
                }
                return c;
            },
            _tdec: typeof window < "u" && window.TextDecoder ? new window.TextDecoder : null,
            readUTF8: function(i, r, l) {
                var c = e._bin._tdec;
                return c && r == 0 && l == i.length ? c.decode(i) : e._bin.readASCII(i, r, l);
            },
            readBytes: function(i, r, l) {
                for(var c = [], f = 0; f < l; f++)c.push(i[r + f]);
                return c;
            },
            readASCIIArray: function(i, r, l) {
                for(var c = [], f = 0; f < l; f++)c.push(String.fromCharCode(i[r + f]));
                return c;
            },
            _view: function(i) {
                return i._dataView || (i._dataView = i.buffer ? new DataView(i.buffer, i.byteOffset, i.byteLength) : new DataView(new Uint8Array(i).buffer));
            }
        }, e._lctf = {}, e._lctf.parse = function(i, r, l, c, f) {
            var p = e._bin, m = {}, x = r;
            p.readFixed(i, r), r += 4;
            var v = p.readUshort(i, r);
            r += 2;
            var _ = p.readUshort(i, r);
            r += 2;
            var S = p.readUshort(i, r);
            return r += 2, m.scriptList = e._lctf.readScriptList(i, x + v), m.featureList = e._lctf.readFeatureList(i, x + _), m.lookupList = e._lctf.readLookupList(i, x + S, f), m;
        }, e._lctf.readLookupList = function(i, r, l) {
            var c = e._bin, f = r, p = [], m = c.readUshort(i, r);
            r += 2;
            for(var x = 0; x < m; x++){
                var v = c.readUshort(i, r);
                r += 2;
                var _ = e._lctf.readLookupTable(i, f + v, l);
                p.push(_);
            }
            return p;
        }, e._lctf.readLookupTable = function(i, r, l) {
            var c = e._bin, f = r, p = {
                tabs: []
            };
            p.ltype = c.readUshort(i, r), r += 2, p.flag = c.readUshort(i, r), r += 2;
            var m = c.readUshort(i, r);
            r += 2;
            for(var x = p.ltype, v = 0; v < m; v++){
                var _ = c.readUshort(i, r);
                r += 2;
                var S = l(i, x, f + _, p);
                p.tabs.push(S);
            }
            return p;
        }, e._lctf.numOfOnes = function(i) {
            for(var r = 0, l = 0; l < 32; l++)(i >>> l & 1) != 0 && r++;
            return r;
        }, e._lctf.readClassDef = function(i, r) {
            var l = e._bin, c = [], f = l.readUshort(i, r);
            if (r += 2, f == 1) {
                var p = l.readUshort(i, r);
                r += 2;
                var m = l.readUshort(i, r);
                r += 2;
                for(var x = 0; x < m; x++)c.push(p + x), c.push(p + x), c.push(l.readUshort(i, r)), r += 2;
            }
            if (f == 2) {
                var v = l.readUshort(i, r);
                for(r += 2, x = 0; x < v; x++)c.push(l.readUshort(i, r)), r += 2, c.push(l.readUshort(i, r)), r += 2, c.push(l.readUshort(i, r)), r += 2;
            }
            return c;
        }, e._lctf.getInterval = function(i, r) {
            for(var l = 0; l < i.length; l += 3){
                var c = i[l], f = i[l + 1];
                if (i[l + 2], c <= r && r <= f) return l;
            }
            return -1;
        }, e._lctf.readCoverage = function(i, r) {
            var l = e._bin, c = {};
            c.fmt = l.readUshort(i, r), r += 2;
            var f = l.readUshort(i, r);
            return r += 2, c.fmt == 1 && (c.tab = l.readUshorts(i, r, f)), c.fmt == 2 && (c.tab = l.readUshorts(i, r, 3 * f)), c;
        }, e._lctf.coverageIndex = function(i, r) {
            var l = i.tab;
            if (i.fmt == 1) return l.indexOf(r);
            if (i.fmt == 2) {
                var c = e._lctf.getInterval(l, r);
                if (c != -1) return l[c + 2] + (r - l[c]);
            }
            return -1;
        }, e._lctf.readFeatureList = function(i, r) {
            var l = e._bin, c = r, f = [], p = l.readUshort(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = l.readASCII(i, r, 4);
                r += 4;
                var v = l.readUshort(i, r);
                r += 2;
                var _ = e._lctf.readFeatureTable(i, c + v);
                _.tag = x.trim(), f.push(_);
            }
            return f;
        }, e._lctf.readFeatureTable = function(i, r) {
            var l = e._bin, c = r, f = {}, p = l.readUshort(i, r);
            r += 2, p > 0 && (f.featureParams = c + p);
            var m = l.readUshort(i, r);
            r += 2, f.tab = [];
            for(var x = 0; x < m; x++)f.tab.push(l.readUshort(i, r + 2 * x));
            return f;
        }, e._lctf.readScriptList = function(i, r) {
            var l = e._bin, c = r, f = {}, p = l.readUshort(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = l.readASCII(i, r, 4);
                r += 4;
                var v = l.readUshort(i, r);
                r += 2, f[x.trim()] = e._lctf.readScriptTable(i, c + v);
            }
            return f;
        }, e._lctf.readScriptTable = function(i, r) {
            var l = e._bin, c = r, f = {}, p = l.readUshort(i, r);
            r += 2, p > 0 && (f.default = e._lctf.readLangSysTable(i, c + p));
            var m = l.readUshort(i, r);
            r += 2;
            for(var x = 0; x < m; x++){
                var v = l.readASCII(i, r, 4);
                r += 4;
                var _ = l.readUshort(i, r);
                r += 2, f[v.trim()] = e._lctf.readLangSysTable(i, c + _);
            }
            return f;
        }, e._lctf.readLangSysTable = function(i, r) {
            var l = e._bin, c = {};
            l.readUshort(i, r), r += 2, c.reqFeature = l.readUshort(i, r), r += 2;
            var f = l.readUshort(i, r);
            return r += 2, c.features = l.readUshorts(i, r, f), c;
        }, e.CFF = {}, e.CFF.parse = function(i, r, l) {
            var c = e._bin;
            (i = new Uint8Array(i.buffer, r, l))[r = 0], i[++r], i[++r], i[++r], r++;
            var f = [];
            r = e.CFF.readIndex(i, r, f);
            for(var p = [], m = 0; m < f.length - 1; m++)p.push(c.readASCII(i, r + f[m], f[m + 1] - f[m]));
            r += f[f.length - 1];
            var x = [];
            r = e.CFF.readIndex(i, r, x);
            var v = [];
            for(m = 0; m < x.length - 1; m++)v.push(e.CFF.readDict(i, r + x[m], r + x[m + 1]));
            r += x[x.length - 1];
            var _ = v[0], S = [];
            r = e.CFF.readIndex(i, r, S);
            var A = [];
            for(m = 0; m < S.length - 1; m++)A.push(c.readASCII(i, r + S[m], S[m + 1] - S[m]));
            if (r += S[S.length - 1], e.CFF.readSubrs(i, r, _), _.CharStrings) {
                r = _.CharStrings, S = [], r = e.CFF.readIndex(i, r, S);
                var M = [];
                for(m = 0; m < S.length - 1; m++)M.push(c.readBytes(i, r + S[m], S[m + 1] - S[m]));
                _.CharStrings = M;
            }
            if (_.ROS) {
                r = _.FDArray;
                var b = [];
                for(r = e.CFF.readIndex(i, r, b), _.FDArray = [], m = 0; m < b.length - 1; m++){
                    var C = e.CFF.readDict(i, r + b[m], r + b[m + 1]);
                    e.CFF._readFDict(i, C, A), _.FDArray.push(C);
                }
                r += b[b.length - 1], r = _.FDSelect, _.FDSelect = [];
                var R = i[r];
                if (r++, R != 3) throw R;
                var N = c.readUshort(i, r);
                for(r += 2, m = 0; m < N + 1; m++)_.FDSelect.push(c.readUshort(i, r), i[r + 2]), r += 3;
            }
            return _.Encoding && (_.Encoding = e.CFF.readEncoding(i, _.Encoding, _.CharStrings.length)), _.charset && (_.charset = e.CFF.readCharset(i, _.charset, _.CharStrings.length)), e.CFF._readFDict(i, _, A), _;
        }, e.CFF._readFDict = function(i, r, l) {
            var c;
            for(var f in r.Private && (c = r.Private[1], r.Private = e.CFF.readDict(i, c, c + r.Private[0]), r.Private.Subrs && e.CFF.readSubrs(i, c + r.Private.Subrs, r.Private)), r)[
                "FamilyName",
                "FontName",
                "FullName",
                "Notice",
                "version",
                "Copyright"
            ].indexOf(f) != -1 && (r[f] = l[r[f] - 426 + 35]);
        }, e.CFF.readSubrs = function(i, r, l) {
            var c = e._bin, f = [];
            r = e.CFF.readIndex(i, r, f);
            var p, m = f.length;
            p = m < 1240 ? 107 : m < 33900 ? 1131 : 32768, l.Bias = p, l.Subrs = [];
            for(var x = 0; x < f.length - 1; x++)l.Subrs.push(c.readBytes(i, r + f[x], f[x + 1] - f[x]));
        }, e.CFF.tableSE = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            0,
            111,
            112,
            113,
            114,
            0,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            0,
            123,
            0,
            124,
            125,
            126,
            127,
            128,
            129,
            130,
            131,
            0,
            132,
            133,
            0,
            134,
            135,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            138,
            0,
            139,
            0,
            0,
            0,
            0,
            140,
            141,
            142,
            143,
            0,
            0,
            0,
            0,
            0,
            144,
            0,
            0,
            0,
            145,
            0,
            0,
            146,
            147,
            148,
            149,
            0,
            0,
            0,
            0
        ], e.CFF.glyphByUnicode = function(i, r) {
            for(var l = 0; l < i.charset.length; l++)if (i.charset[l] == r) return l;
            return -1;
        }, e.CFF.glyphBySE = function(i, r) {
            return r < 0 || r > 255 ? -1 : e.CFF.glyphByUnicode(i, e.CFF.tableSE[r]);
        }, e.CFF.readEncoding = function(i, r, l) {
            e._bin;
            var c = [
                ".notdef"
            ], f = i[r];
            if (r++, f != 0) throw "error: unknown encoding format: " + f;
            var p = i[r];
            r++;
            for(var m = 0; m < p; m++)c.push(i[r + m]);
            return c;
        }, e.CFF.readCharset = function(i, r, l) {
            var c = e._bin, f = [
                ".notdef"
            ], p = i[r];
            if (r++, p == 0) for(var m = 0; m < l; m++){
                var x = c.readUshort(i, r);
                r += 2, f.push(x);
            }
            else {
                if (p != 1 && p != 2) throw "error: format: " + p;
                for(; f.length < l;){
                    x = c.readUshort(i, r), r += 2;
                    var v = 0;
                    for(p == 1 ? (v = i[r], r++) : (v = c.readUshort(i, r), r += 2), m = 0; m <= v; m++)f.push(x), x++;
                }
            }
            return f;
        }, e.CFF.readIndex = function(i, r, l) {
            var c = e._bin, f = c.readUshort(i, r) + 1, p = i[r += 2];
            if (r++, p == 1) for(var m = 0; m < f; m++)l.push(i[r + m]);
            else if (p == 2) for(m = 0; m < f; m++)l.push(c.readUshort(i, r + 2 * m));
            else if (p == 3) for(m = 0; m < f; m++)l.push(16777215 & c.readUint(i, r + 3 * m - 1));
            else if (f != 1) throw "unsupported offset size: " + p + ", count: " + f;
            return (r += f * p) - 1;
        }, e.CFF.getCharString = function(i, r, l) {
            var c = e._bin, f = i[r], p = i[r + 1];
            i[r + 2], i[r + 3], i[r + 4];
            var m = 1, x = null, v = null;
            f <= 20 && (x = f, m = 1), f == 12 && (x = 100 * f + p, m = 2), 21 <= f && f <= 27 && (x = f, m = 1), f == 28 && (v = c.readShort(i, r + 1), m = 3), 29 <= f && f <= 31 && (x = f, m = 1), 32 <= f && f <= 246 && (v = f - 139, m = 1), 247 <= f && f <= 250 && (v = 256 * (f - 247) + p + 108, m = 2), 251 <= f && f <= 254 && (v = 256 * -(f - 251) - p - 108, m = 2), f == 255 && (v = c.readInt(i, r + 1) / 65535, m = 5), l.val = v ?? "o" + x, l.size = m;
        }, e.CFF.readCharString = function(i, r, l) {
            for(var c = r + l, f = e._bin, p = []; r < c;){
                var m = i[r], x = i[r + 1];
                i[r + 2], i[r + 3], i[r + 4];
                var v = 1, _ = null, S = null;
                m <= 20 && (_ = m, v = 1), m == 12 && (_ = 100 * m + x, v = 2), m != 19 && m != 20 || (_ = m, v = 2), 21 <= m && m <= 27 && (_ = m, v = 1), m == 28 && (S = f.readShort(i, r + 1), v = 3), 29 <= m && m <= 31 && (_ = m, v = 1), 32 <= m && m <= 246 && (S = m - 139, v = 1), 247 <= m && m <= 250 && (S = 256 * (m - 247) + x + 108, v = 2), 251 <= m && m <= 254 && (S = 256 * -(m - 251) - x - 108, v = 2), m == 255 && (S = f.readInt(i, r + 1) / 65535, v = 5), p.push(S ?? "o" + _), r += v;
            }
            return p;
        }, e.CFF.readDict = function(i, r, l) {
            for(var c = e._bin, f = {}, p = []; r < l;){
                var m = i[r], x = i[r + 1];
                i[r + 2], i[r + 3], i[r + 4];
                var v = 1, _ = null, S = null;
                if (m == 28 && (S = c.readShort(i, r + 1), v = 3), m == 29 && (S = c.readInt(i, r + 1), v = 5), 32 <= m && m <= 246 && (S = m - 139, v = 1), 247 <= m && m <= 250 && (S = 256 * (m - 247) + x + 108, v = 2), 251 <= m && m <= 254 && (S = 256 * -(m - 251) - x - 108, v = 2), m == 255) throw S = c.readInt(i, r + 1) / 65535, v = 5, "unknown number";
                if (m == 30) {
                    var A = [];
                    for(v = 1;;){
                        var M = i[r + v];
                        v++;
                        var b = M >> 4, C = 15 & M;
                        if (b != 15 && A.push(b), C != 15 && A.push(C), C == 15) break;
                    }
                    for(var R = "", N = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        ".",
                        "e",
                        "e-",
                        "reserved",
                        "-",
                        "endOfNumber"
                    ], z = 0; z < A.length; z++)R += N[A[z]];
                    S = parseFloat(R);
                }
                m <= 21 && (_ = [
                    "version",
                    "Notice",
                    "FullName",
                    "FamilyName",
                    "Weight",
                    "FontBBox",
                    "BlueValues",
                    "OtherBlues",
                    "FamilyBlues",
                    "FamilyOtherBlues",
                    "StdHW",
                    "StdVW",
                    "escape",
                    "UniqueID",
                    "XUID",
                    "charset",
                    "Encoding",
                    "CharStrings",
                    "Private",
                    "Subrs",
                    "defaultWidthX",
                    "nominalWidthX"
                ][m], v = 1, m == 12 && (_ = [
                    "Copyright",
                    "isFixedPitch",
                    "ItalicAngle",
                    "UnderlinePosition",
                    "UnderlineThickness",
                    "PaintType",
                    "CharstringType",
                    "FontMatrix",
                    "StrokeWidth",
                    "BlueScale",
                    "BlueShift",
                    "BlueFuzz",
                    "StemSnapH",
                    "StemSnapV",
                    "ForceBold",
                    0,
                    0,
                    "LanguageGroup",
                    "ExpansionFactor",
                    "initialRandomSeed",
                    "SyntheticBase",
                    "PostScript",
                    "BaseFontName",
                    "BaseFontBlend",
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    "ROS",
                    "CIDFontVersion",
                    "CIDFontRevision",
                    "CIDFontType",
                    "CIDCount",
                    "UIDBase",
                    "FDArray",
                    "FDSelect",
                    "FontName"
                ][x], v = 2)), _ != null ? (f[_] = p.length == 1 ? p[0] : p, p = []) : p.push(S), r += v;
            }
            return f;
        }, e.cmap = {}, e.cmap.parse = function(i, r, l) {
            i = new Uint8Array(i.buffer, r, l), r = 0;
            var c = e._bin, f = {};
            c.readUshort(i, r), r += 2;
            var p = c.readUshort(i, r);
            r += 2;
            var m = [];
            f.tables = [];
            for(var x = 0; x < p; x++){
                var v = c.readUshort(i, r);
                r += 2;
                var _ = c.readUshort(i, r);
                r += 2;
                var S = c.readUint(i, r);
                r += 4;
                var A = "p" + v + "e" + _, M = m.indexOf(S);
                if (M == -1) {
                    var b;
                    M = f.tables.length, m.push(S);
                    var C = c.readUshort(i, S);
                    C == 0 ? b = e.cmap.parse0(i, S) : C == 4 ? b = e.cmap.parse4(i, S) : C == 6 ? b = e.cmap.parse6(i, S) : C == 12 ? b = e.cmap.parse12(i, S) : console.debug("unknown format: " + C, v, _, S), f.tables.push(b);
                }
                if (f[A] != null) throw "multiple tables for one platform+encoding";
                f[A] = M;
            }
            return f;
        }, e.cmap.parse0 = function(i, r) {
            var l = e._bin, c = {};
            c.format = l.readUshort(i, r), r += 2;
            var f = l.readUshort(i, r);
            r += 2, l.readUshort(i, r), r += 2, c.map = [];
            for(var p = 0; p < f - 6; p++)c.map.push(i[r + p]);
            return c;
        }, e.cmap.parse4 = function(i, r) {
            var l = e._bin, c = r, f = {};
            f.format = l.readUshort(i, r), r += 2;
            var p = l.readUshort(i, r);
            r += 2, l.readUshort(i, r), r += 2;
            var m = l.readUshort(i, r);
            r += 2;
            var x = m / 2;
            f.searchRange = l.readUshort(i, r), r += 2, f.entrySelector = l.readUshort(i, r), r += 2, f.rangeShift = l.readUshort(i, r), r += 2, f.endCount = l.readUshorts(i, r, x), r += 2 * x, r += 2, f.startCount = l.readUshorts(i, r, x), r += 2 * x, f.idDelta = [];
            for(var v = 0; v < x; v++)f.idDelta.push(l.readShort(i, r)), r += 2;
            for(f.idRangeOffset = l.readUshorts(i, r, x), r += 2 * x, f.glyphIdArray = []; r < c + p;)f.glyphIdArray.push(l.readUshort(i, r)), r += 2;
            return f;
        }, e.cmap.parse6 = function(i, r) {
            var l = e._bin, c = {};
            c.format = l.readUshort(i, r), r += 2, l.readUshort(i, r), r += 2, l.readUshort(i, r), r += 2, c.firstCode = l.readUshort(i, r), r += 2;
            var f = l.readUshort(i, r);
            r += 2, c.glyphIdArray = [];
            for(var p = 0; p < f; p++)c.glyphIdArray.push(l.readUshort(i, r)), r += 2;
            return c;
        }, e.cmap.parse12 = function(i, r) {
            var l = e._bin, c = {};
            c.format = l.readUshort(i, r), r += 2, r += 2, l.readUint(i, r), r += 4, l.readUint(i, r), r += 4;
            var f = l.readUint(i, r);
            r += 4, c.groups = [];
            for(var p = 0; p < f; p++){
                var m = r + 12 * p, x = l.readUint(i, m + 0), v = l.readUint(i, m + 4), _ = l.readUint(i, m + 8);
                c.groups.push([
                    x,
                    v,
                    _
                ]);
            }
            return c;
        }, e.glyf = {}, e.glyf.parse = function(i, r, l, c) {
            for(var f = [], p = 0; p < c.maxp.numGlyphs; p++)f.push(null);
            return f;
        }, e.glyf._parseGlyf = function(i, r) {
            var l = e._bin, c = i._data, f = e._tabOffset(c, "glyf", i._offset) + i.loca[r];
            if (i.loca[r] == i.loca[r + 1]) return null;
            var p = {};
            if (p.noc = l.readShort(c, f), f += 2, p.xMin = l.readShort(c, f), f += 2, p.yMin = l.readShort(c, f), f += 2, p.xMax = l.readShort(c, f), f += 2, p.yMax = l.readShort(c, f), f += 2, p.xMin >= p.xMax || p.yMin >= p.yMax) return null;
            if (p.noc > 0) {
                p.endPts = [];
                for(var m = 0; m < p.noc; m++)p.endPts.push(l.readUshort(c, f)), f += 2;
                var x = l.readUshort(c, f);
                if (f += 2, c.length - f < x) return null;
                p.instructions = l.readBytes(c, f, x), f += x;
                var v = p.endPts[p.noc - 1] + 1;
                for(p.flags = [], m = 0; m < v; m++){
                    var _ = c[f];
                    if (f++, p.flags.push(_), (8 & _) != 0) {
                        var S = c[f];
                        f++;
                        for(var A = 0; A < S; A++)p.flags.push(_), m++;
                    }
                }
                for(p.xs = [], m = 0; m < v; m++){
                    var M = (2 & p.flags[m]) != 0, b = (16 & p.flags[m]) != 0;
                    M ? (p.xs.push(b ? c[f] : -c[f]), f++) : b ? p.xs.push(0) : (p.xs.push(l.readShort(c, f)), f += 2);
                }
                for(p.ys = [], m = 0; m < v; m++)M = (4 & p.flags[m]) != 0, b = (32 & p.flags[m]) != 0, M ? (p.ys.push(b ? c[f] : -c[f]), f++) : b ? p.ys.push(0) : (p.ys.push(l.readShort(c, f)), f += 2);
                var C = 0, R = 0;
                for(m = 0; m < v; m++)C += p.xs[m], R += p.ys[m], p.xs[m] = C, p.ys[m] = R;
            } else {
                var N;
                p.parts = [];
                do {
                    N = l.readUshort(c, f), f += 2;
                    var z = {
                        m: {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            tx: 0,
                            ty: 0
                        },
                        p1: -1,
                        p2: -1
                    };
                    if (p.parts.push(z), z.glyphIndex = l.readUshort(c, f), f += 2, 1 & N) {
                        var L = l.readShort(c, f);
                        f += 2;
                        var P = l.readShort(c, f);
                        f += 2;
                    } else L = l.readInt8(c, f), f++, P = l.readInt8(c, f), f++;
                    2 & N ? (z.m.tx = L, z.m.ty = P) : (z.p1 = L, z.p2 = P), 8 & N ? (z.m.a = z.m.d = l.readF2dot14(c, f), f += 2) : 64 & N ? (z.m.a = l.readF2dot14(c, f), f += 2, z.m.d = l.readF2dot14(c, f), f += 2) : 128 & N && (z.m.a = l.readF2dot14(c, f), f += 2, z.m.b = l.readF2dot14(c, f), f += 2, z.m.c = l.readF2dot14(c, f), f += 2, z.m.d = l.readF2dot14(c, f), f += 2);
                }while (32 & N);
                if (256 & N) {
                    var H = l.readUshort(c, f);
                    for(f += 2, p.instr = [], m = 0; m < H; m++)p.instr.push(c[f]), f++;
                }
            }
            return p;
        }, e.GDEF = {}, e.GDEF.parse = function(i, r, l, c) {
            var f = r;
            r += 4;
            var p = e._bin.readUshort(i, r);
            return {
                glyphClassDef: p === 0 ? null : e._lctf.readClassDef(i, f + p)
            };
        }, e.GPOS = {}, e.GPOS.parse = function(i, r, l, c) {
            return e._lctf.parse(i, r, l, c, e.GPOS.subt);
        }, e.GPOS.subt = function(i, r, l, c) {
            var f = e._bin, p = l, m = {};
            if (m.fmt = f.readUshort(i, l), l += 2, r == 1 || r == 2 || r == 3 || r == 7 || r == 8 && m.fmt <= 2) {
                var x = f.readUshort(i, l);
                l += 2, m.coverage = e._lctf.readCoverage(i, x + p);
            }
            if (r == 1 && m.fmt == 1) {
                var v = f.readUshort(i, l);
                l += 2, v != 0 && (m.pos = e.GPOS.readValueRecord(i, l, v));
            } else if (r == 2 && m.fmt >= 1 && m.fmt <= 2) {
                v = f.readUshort(i, l), l += 2;
                var _ = f.readUshort(i, l);
                l += 2;
                var S = e._lctf.numOfOnes(v), A = e._lctf.numOfOnes(_);
                if (m.fmt == 1) {
                    m.pairsets = [];
                    var M = f.readUshort(i, l);
                    l += 2;
                    for(var b = 0; b < M; b++){
                        var C = p + f.readUshort(i, l);
                        l += 2;
                        var R = f.readUshort(i, C);
                        C += 2;
                        for(var N = [], z = 0; z < R; z++){
                            var L = f.readUshort(i, C);
                            C += 2, v != 0 && (G = e.GPOS.readValueRecord(i, C, v), C += 2 * S), _ != 0 && (q = e.GPOS.readValueRecord(i, C, _), C += 2 * A), N.push({
                                gid2: L,
                                val1: G,
                                val2: q
                            });
                        }
                        m.pairsets.push(N);
                    }
                }
                if (m.fmt == 2) {
                    var P = f.readUshort(i, l);
                    l += 2;
                    var H = f.readUshort(i, l);
                    l += 2;
                    var O = f.readUshort(i, l);
                    l += 2;
                    var D = f.readUshort(i, l);
                    for(l += 2, m.classDef1 = e._lctf.readClassDef(i, p + P), m.classDef2 = e._lctf.readClassDef(i, p + H), m.matrix = [], b = 0; b < O; b++){
                        var j = [];
                        for(z = 0; z < D; z++){
                            var G = null, q = null;
                            v != 0 && (G = e.GPOS.readValueRecord(i, l, v), l += 2 * S), _ != 0 && (q = e.GPOS.readValueRecord(i, l, _), l += 2 * A), j.push({
                                val1: G,
                                val2: q
                            });
                        }
                        m.matrix.push(j);
                    }
                }
            } else if (r == 4 && m.fmt == 1) m.markCoverage = e._lctf.readCoverage(i, f.readUshort(i, l) + p), m.baseCoverage = e._lctf.readCoverage(i, f.readUshort(i, l + 2) + p), m.markClassCount = f.readUshort(i, l + 4), m.markArray = e.GPOS.readMarkArray(i, f.readUshort(i, l + 6) + p), m.baseArray = e.GPOS.readBaseArray(i, f.readUshort(i, l + 8) + p, m.markClassCount);
            else if (r == 6 && m.fmt == 1) m.mark1Coverage = e._lctf.readCoverage(i, f.readUshort(i, l) + p), m.mark2Coverage = e._lctf.readCoverage(i, f.readUshort(i, l + 2) + p), m.markClassCount = f.readUshort(i, l + 4), m.mark1Array = e.GPOS.readMarkArray(i, f.readUshort(i, l + 6) + p), m.mark2Array = e.GPOS.readBaseArray(i, f.readUshort(i, l + 8) + p, m.markClassCount);
            else {
                if (r == 9 && m.fmt == 1) {
                    var Y = f.readUshort(i, l);
                    l += 2;
                    var ae = f.readUint(i, l);
                    if (l += 4, c.ltype == 9) c.ltype = Y;
                    else if (c.ltype != Y) throw "invalid extension substitution";
                    return e.GPOS.subt(i, c.ltype, p + ae);
                }
                console.debug("unsupported GPOS table LookupType", r, "format", m.fmt);
            }
            return m;
        }, e.GPOS.readValueRecord = function(i, r, l) {
            var c = e._bin, f = [];
            return f.push(1 & l ? c.readShort(i, r) : 0), r += 1 & l ? 2 : 0, f.push(2 & l ? c.readShort(i, r) : 0), r += 2 & l ? 2 : 0, f.push(4 & l ? c.readShort(i, r) : 0), r += 4 & l ? 2 : 0, f.push(8 & l ? c.readShort(i, r) : 0), r += 8 & l ? 2 : 0, f;
        }, e.GPOS.readBaseArray = function(i, r, l) {
            var c = e._bin, f = [], p = r, m = c.readUshort(i, r);
            r += 2;
            for(var x = 0; x < m; x++){
                for(var v = [], _ = 0; _ < l; _++)v.push(e.GPOS.readAnchorRecord(i, p + c.readUshort(i, r))), r += 2;
                f.push(v);
            }
            return f;
        }, e.GPOS.readMarkArray = function(i, r) {
            var l = e._bin, c = [], f = r, p = l.readUshort(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = e.GPOS.readAnchorRecord(i, l.readUshort(i, r + 2) + f);
                x.markClass = l.readUshort(i, r), c.push(x), r += 4;
            }
            return c;
        }, e.GPOS.readAnchorRecord = function(i, r) {
            var l = e._bin, c = {};
            return c.fmt = l.readUshort(i, r), c.x = l.readShort(i, r + 2), c.y = l.readShort(i, r + 4), c;
        }, e.GSUB = {}, e.GSUB.parse = function(i, r, l, c) {
            return e._lctf.parse(i, r, l, c, e.GSUB.subt);
        }, e.GSUB.subt = function(i, r, l, c) {
            var f = e._bin, p = l, m = {};
            if (m.fmt = f.readUshort(i, l), l += 2, r != 1 && r != 2 && r != 4 && r != 5 && r != 6) return null;
            if (r == 1 || r == 2 || r == 4 || r == 5 && m.fmt <= 2 || r == 6 && m.fmt <= 2) {
                var x = f.readUshort(i, l);
                l += 2, m.coverage = e._lctf.readCoverage(i, p + x);
            }
            if (r == 1 && m.fmt >= 1 && m.fmt <= 2) {
                if (m.fmt == 1) m.delta = f.readShort(i, l), l += 2;
                else if (m.fmt == 2) {
                    var v = f.readUshort(i, l);
                    l += 2, m.newg = f.readUshorts(i, l, v), l += 2 * m.newg.length;
                }
            } else if (r == 2 && m.fmt == 1) {
                v = f.readUshort(i, l), l += 2, m.seqs = [];
                for(var _ = 0; _ < v; _++){
                    var S = f.readUshort(i, l) + p;
                    l += 2;
                    var A = f.readUshort(i, S);
                    m.seqs.push(f.readUshorts(i, S + 2, A));
                }
            } else if (r == 4) for(m.vals = [], v = f.readUshort(i, l), l += 2, _ = 0; _ < v; _++){
                var M = f.readUshort(i, l);
                l += 2, m.vals.push(e.GSUB.readLigatureSet(i, p + M));
            }
            else if (r == 5 && m.fmt == 2) {
                if (m.fmt == 2) {
                    var b = f.readUshort(i, l);
                    l += 2, m.cDef = e._lctf.readClassDef(i, p + b), m.scset = [];
                    var C = f.readUshort(i, l);
                    for(l += 2, _ = 0; _ < C; _++){
                        var R = f.readUshort(i, l);
                        l += 2, m.scset.push(R == 0 ? null : e.GSUB.readSubClassSet(i, p + R));
                    }
                }
            } else if (r == 6 && m.fmt == 3) {
                if (m.fmt == 3) {
                    for(_ = 0; _ < 3; _++){
                        v = f.readUshort(i, l), l += 2;
                        for(var N = [], z = 0; z < v; z++)N.push(e._lctf.readCoverage(i, p + f.readUshort(i, l + 2 * z)));
                        l += 2 * v, _ == 0 && (m.backCvg = N), _ == 1 && (m.inptCvg = N), _ == 2 && (m.ahedCvg = N);
                    }
                    v = f.readUshort(i, l), l += 2, m.lookupRec = e.GSUB.readSubstLookupRecords(i, l, v);
                }
            } else {
                if (r == 7 && m.fmt == 1) {
                    var L = f.readUshort(i, l);
                    l += 2;
                    var P = f.readUint(i, l);
                    if (l += 4, c.ltype == 9) c.ltype = L;
                    else if (c.ltype != L) throw "invalid extension substitution";
                    return e.GSUB.subt(i, c.ltype, p + P);
                }
                console.debug("unsupported GSUB table LookupType", r, "format", m.fmt);
            }
            return m;
        }, e.GSUB.readSubClassSet = function(i, r) {
            var l = e._bin.readUshort, c = r, f = [], p = l(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = l(i, r);
                r += 2, f.push(e.GSUB.readSubClassRule(i, c + x));
            }
            return f;
        }, e.GSUB.readSubClassRule = function(i, r) {
            var l = e._bin.readUshort, c = {}, f = l(i, r), p = l(i, r += 2);
            r += 2, c.input = [];
            for(var m = 0; m < f - 1; m++)c.input.push(l(i, r)), r += 2;
            return c.substLookupRecords = e.GSUB.readSubstLookupRecords(i, r, p), c;
        }, e.GSUB.readSubstLookupRecords = function(i, r, l) {
            for(var c = e._bin.readUshort, f = [], p = 0; p < l; p++)f.push(c(i, r), c(i, r + 2)), r += 4;
            return f;
        }, e.GSUB.readChainSubClassSet = function(i, r) {
            var l = e._bin, c = r, f = [], p = l.readUshort(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = l.readUshort(i, r);
                r += 2, f.push(e.GSUB.readChainSubClassRule(i, c + x));
            }
            return f;
        }, e.GSUB.readChainSubClassRule = function(i, r) {
            for(var l = e._bin, c = {}, f = [
                "backtrack",
                "input",
                "lookahead"
            ], p = 0; p < f.length; p++){
                var m = l.readUshort(i, r);
                r += 2, p == 1 && m--, c[f[p]] = l.readUshorts(i, r, m), r += 2 * c[f[p]].length;
            }
            return m = l.readUshort(i, r), r += 2, c.subst = l.readUshorts(i, r, 2 * m), r += 2 * c.subst.length, c;
        }, e.GSUB.readLigatureSet = function(i, r) {
            var l = e._bin, c = r, f = [], p = l.readUshort(i, r);
            r += 2;
            for(var m = 0; m < p; m++){
                var x = l.readUshort(i, r);
                r += 2, f.push(e.GSUB.readLigature(i, c + x));
            }
            return f;
        }, e.GSUB.readLigature = function(i, r) {
            var l = e._bin, c = {
                chain: []
            };
            c.nglyph = l.readUshort(i, r), r += 2;
            var f = l.readUshort(i, r);
            r += 2;
            for(var p = 0; p < f - 1; p++)c.chain.push(l.readUshort(i, r)), r += 2;
            return c;
        }, e.head = {}, e.head.parse = function(i, r, l) {
            var c = e._bin, f = {};
            return c.readFixed(i, r), r += 4, f.fontRevision = c.readFixed(i, r), r += 4, c.readUint(i, r), r += 4, c.readUint(i, r), r += 4, f.flags = c.readUshort(i, r), r += 2, f.unitsPerEm = c.readUshort(i, r), r += 2, f.created = c.readUint64(i, r), r += 8, f.modified = c.readUint64(i, r), r += 8, f.xMin = c.readShort(i, r), r += 2, f.yMin = c.readShort(i, r), r += 2, f.xMax = c.readShort(i, r), r += 2, f.yMax = c.readShort(i, r), r += 2, f.macStyle = c.readUshort(i, r), r += 2, f.lowestRecPPEM = c.readUshort(i, r), r += 2, f.fontDirectionHint = c.readShort(i, r), r += 2, f.indexToLocFormat = c.readShort(i, r), r += 2, f.glyphDataFormat = c.readShort(i, r), r += 2, f;
        }, e.hhea = {}, e.hhea.parse = function(i, r, l) {
            var c = e._bin, f = {};
            return c.readFixed(i, r), r += 4, f.ascender = c.readShort(i, r), r += 2, f.descender = c.readShort(i, r), r += 2, f.lineGap = c.readShort(i, r), r += 2, f.advanceWidthMax = c.readUshort(i, r), r += 2, f.minLeftSideBearing = c.readShort(i, r), r += 2, f.minRightSideBearing = c.readShort(i, r), r += 2, f.xMaxExtent = c.readShort(i, r), r += 2, f.caretSlopeRise = c.readShort(i, r), r += 2, f.caretSlopeRun = c.readShort(i, r), r += 2, f.caretOffset = c.readShort(i, r), r += 2, r += 8, f.metricDataFormat = c.readShort(i, r), r += 2, f.numberOfHMetrics = c.readUshort(i, r), r += 2, f;
        }, e.hmtx = {}, e.hmtx.parse = function(i, r, l, c) {
            for(var f = e._bin, p = {
                aWidth: [],
                lsBearing: []
            }, m = 0, x = 0, v = 0; v < c.maxp.numGlyphs; v++)v < c.hhea.numberOfHMetrics && (m = f.readUshort(i, r), r += 2, x = f.readShort(i, r), r += 2), p.aWidth.push(m), p.lsBearing.push(x);
            return p;
        }, e.kern = {}, e.kern.parse = function(i, r, l, c) {
            var f = e._bin, p = f.readUshort(i, r);
            if (r += 2, p == 1) return e.kern.parseV1(i, r - 2, l, c);
            var m = f.readUshort(i, r);
            r += 2;
            for(var x = {
                glyph1: [],
                rval: []
            }, v = 0; v < m; v++){
                r += 2, l = f.readUshort(i, r), r += 2;
                var _ = f.readUshort(i, r);
                r += 2;
                var S = _ >>> 8;
                if ((S &= 15) != 0) throw "unknown kern table format: " + S;
                r = e.kern.readFormat0(i, r, x);
            }
            return x;
        }, e.kern.parseV1 = function(i, r, l, c) {
            var f = e._bin;
            f.readFixed(i, r), r += 4;
            var p = f.readUint(i, r);
            r += 4;
            for(var m = {
                glyph1: [],
                rval: []
            }, x = 0; x < p; x++){
                f.readUint(i, r), r += 4;
                var v = f.readUshort(i, r);
                r += 2, f.readUshort(i, r), r += 2;
                var _ = v >>> 8;
                if ((_ &= 15) != 0) throw "unknown kern table format: " + _;
                r = e.kern.readFormat0(i, r, m);
            }
            return m;
        }, e.kern.readFormat0 = function(i, r, l) {
            var c = e._bin, f = -1, p = c.readUshort(i, r);
            r += 2, c.readUshort(i, r), r += 2, c.readUshort(i, r), r += 2, c.readUshort(i, r), r += 2;
            for(var m = 0; m < p; m++){
                var x = c.readUshort(i, r);
                r += 2;
                var v = c.readUshort(i, r);
                r += 2;
                var _ = c.readShort(i, r);
                r += 2, x != f && (l.glyph1.push(x), l.rval.push({
                    glyph2: [],
                    vals: []
                }));
                var S = l.rval[l.rval.length - 1];
                S.glyph2.push(v), S.vals.push(_), f = x;
            }
            return r;
        }, e.loca = {}, e.loca.parse = function(i, r, l, c) {
            var f = e._bin, p = [], m = c.head.indexToLocFormat, x = c.maxp.numGlyphs + 1;
            if (m == 0) for(var v = 0; v < x; v++)p.push(f.readUshort(i, r + (v << 1)) << 1);
            if (m == 1) for(v = 0; v < x; v++)p.push(f.readUint(i, r + (v << 2)));
            return p;
        }, e.maxp = {}, e.maxp.parse = function(i, r, l) {
            var c = e._bin, f = {}, p = c.readUint(i, r);
            return r += 4, f.numGlyphs = c.readUshort(i, r), r += 2, p == 65536 && (f.maxPoints = c.readUshort(i, r), r += 2, f.maxContours = c.readUshort(i, r), r += 2, f.maxCompositePoints = c.readUshort(i, r), r += 2, f.maxCompositeContours = c.readUshort(i, r), r += 2, f.maxZones = c.readUshort(i, r), r += 2, f.maxTwilightPoints = c.readUshort(i, r), r += 2, f.maxStorage = c.readUshort(i, r), r += 2, f.maxFunctionDefs = c.readUshort(i, r), r += 2, f.maxInstructionDefs = c.readUshort(i, r), r += 2, f.maxStackElements = c.readUshort(i, r), r += 2, f.maxSizeOfInstructions = c.readUshort(i, r), r += 2, f.maxComponentElements = c.readUshort(i, r), r += 2, f.maxComponentDepth = c.readUshort(i, r), r += 2), f;
        }, e.name = {}, e.name.parse = function(i, r, l) {
            var c = e._bin, f = {};
            c.readUshort(i, r), r += 2;
            var p = c.readUshort(i, r);
            r += 2, c.readUshort(i, r);
            for(var m, x = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "ID",
                "fullName",
                "version",
                "postScriptName",
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "urlVendor",
                "urlDesigner",
                "licence",
                "licenceURL",
                "---",
                "typoFamilyName",
                "typoSubfamilyName",
                "compatibleFull",
                "sampleText",
                "postScriptCID",
                "wwsFamilyName",
                "wwsSubfamilyName",
                "lightPalette",
                "darkPalette"
            ], v = r += 2, _ = 0; _ < p; _++){
                var S = c.readUshort(i, r);
                r += 2;
                var A = c.readUshort(i, r);
                r += 2;
                var M = c.readUshort(i, r);
                r += 2;
                var b = c.readUshort(i, r);
                r += 2;
                var C = c.readUshort(i, r);
                r += 2;
                var R = c.readUshort(i, r);
                r += 2;
                var N, z = x[b], L = v + 12 * p + R;
                if (S == 0) N = c.readUnicode(i, L, C / 2);
                else if (S == 3 && A == 0) N = c.readUnicode(i, L, C / 2);
                else if (A == 0) N = c.readASCII(i, L, C);
                else if (A == 1) N = c.readUnicode(i, L, C / 2);
                else if (A == 3) N = c.readUnicode(i, L, C / 2);
                else {
                    if (S != 1) throw "unknown encoding " + A + ", platformID: " + S;
                    N = c.readASCII(i, L, C), console.debug("reading unknown MAC encoding " + A + " as ASCII");
                }
                var P = "p" + S + "," + M.toString(16);
                f[P] == null && (f[P] = {}), f[P][z !== void 0 ? z : b] = N, f[P]._lang = M;
            }
            for(var H in f)if (f[H].postScriptName != null && f[H]._lang == 1033) return f[H];
            for(var H in f)if (f[H].postScriptName != null && f[H]._lang == 0) return f[H];
            for(var H in f)if (f[H].postScriptName != null && f[H]._lang == 3084) return f[H];
            for(var H in f)if (f[H].postScriptName != null) return f[H];
            for(var H in f){
                m = H;
                break;
            }
            return console.debug("returning name table with languageID " + f[m]._lang), f[m];
        }, e["OS/2"] = {}, e["OS/2"].parse = function(i, r, l) {
            var c = e._bin.readUshort(i, r);
            r += 2;
            var f = {};
            if (c == 0) e["OS/2"].version0(i, r, f);
            else if (c == 1) e["OS/2"].version1(i, r, f);
            else if (c == 2 || c == 3 || c == 4) e["OS/2"].version2(i, r, f);
            else {
                if (c != 5) throw "unknown OS/2 table version: " + c;
                e["OS/2"].version5(i, r, f);
            }
            return f;
        }, e["OS/2"].version0 = function(i, r, l) {
            var c = e._bin;
            return l.xAvgCharWidth = c.readShort(i, r), r += 2, l.usWeightClass = c.readUshort(i, r), r += 2, l.usWidthClass = c.readUshort(i, r), r += 2, l.fsType = c.readUshort(i, r), r += 2, l.ySubscriptXSize = c.readShort(i, r), r += 2, l.ySubscriptYSize = c.readShort(i, r), r += 2, l.ySubscriptXOffset = c.readShort(i, r), r += 2, l.ySubscriptYOffset = c.readShort(i, r), r += 2, l.ySuperscriptXSize = c.readShort(i, r), r += 2, l.ySuperscriptYSize = c.readShort(i, r), r += 2, l.ySuperscriptXOffset = c.readShort(i, r), r += 2, l.ySuperscriptYOffset = c.readShort(i, r), r += 2, l.yStrikeoutSize = c.readShort(i, r), r += 2, l.yStrikeoutPosition = c.readShort(i, r), r += 2, l.sFamilyClass = c.readShort(i, r), r += 2, l.panose = c.readBytes(i, r, 10), r += 10, l.ulUnicodeRange1 = c.readUint(i, r), r += 4, l.ulUnicodeRange2 = c.readUint(i, r), r += 4, l.ulUnicodeRange3 = c.readUint(i, r), r += 4, l.ulUnicodeRange4 = c.readUint(i, r), r += 4, l.achVendID = [
                c.readInt8(i, r),
                c.readInt8(i, r + 1),
                c.readInt8(i, r + 2),
                c.readInt8(i, r + 3)
            ], r += 4, l.fsSelection = c.readUshort(i, r), r += 2, l.usFirstCharIndex = c.readUshort(i, r), r += 2, l.usLastCharIndex = c.readUshort(i, r), r += 2, l.sTypoAscender = c.readShort(i, r), r += 2, l.sTypoDescender = c.readShort(i, r), r += 2, l.sTypoLineGap = c.readShort(i, r), r += 2, l.usWinAscent = c.readUshort(i, r), r += 2, l.usWinDescent = c.readUshort(i, r), r += 2;
        }, e["OS/2"].version1 = function(i, r, l) {
            var c = e._bin;
            return r = e["OS/2"].version0(i, r, l), l.ulCodePageRange1 = c.readUint(i, r), r += 4, l.ulCodePageRange2 = c.readUint(i, r), r += 4;
        }, e["OS/2"].version2 = function(i, r, l) {
            var c = e._bin;
            return r = e["OS/2"].version1(i, r, l), l.sxHeight = c.readShort(i, r), r += 2, l.sCapHeight = c.readShort(i, r), r += 2, l.usDefault = c.readUshort(i, r), r += 2, l.usBreak = c.readUshort(i, r), r += 2, l.usMaxContext = c.readUshort(i, r), r += 2;
        }, e["OS/2"].version5 = function(i, r, l) {
            var c = e._bin;
            return r = e["OS/2"].version2(i, r, l), l.usLowerOpticalPointSize = c.readUshort(i, r), r += 2, l.usUpperOpticalPointSize = c.readUshort(i, r), r += 2;
        }, e.post = {}, e.post.parse = function(i, r, l) {
            var c = e._bin, f = {};
            return f.version = c.readFixed(i, r), r += 4, f.italicAngle = c.readFixed(i, r), r += 4, f.underlinePosition = c.readShort(i, r), r += 2, f.underlineThickness = c.readShort(i, r), r += 2, f;
        }, e == null && (e = {}), e.U == null && (e.U = {}), e.U.codeToGlyph = function(i, r) {
            var l = i.cmap, c = -1;
            if (l.p0e4 != null ? c = l.p0e4 : l.p3e1 != null ? c = l.p3e1 : l.p1e0 != null ? c = l.p1e0 : l.p0e3 != null && (c = l.p0e3), c == -1) throw "no familiar platform and encoding!";
            var f = l.tables[c];
            if (f.format == 0) return r >= f.map.length ? 0 : f.map[r];
            if (f.format == 4) {
                for(var p = -1, m = 0; m < f.endCount.length; m++)if (r <= f.endCount[m]) {
                    p = m;
                    break;
                }
                return p == -1 || f.startCount[p] > r ? 0 : 65535 & (f.idRangeOffset[p] != 0 ? f.glyphIdArray[r - f.startCount[p] + (f.idRangeOffset[p] >> 1) - (f.idRangeOffset.length - p)] : r + f.idDelta[p]);
            }
            if (f.format == 12) {
                if (r > f.groups[f.groups.length - 1][1]) return 0;
                for(m = 0; m < f.groups.length; m++){
                    var x = f.groups[m];
                    if (x[0] <= r && r <= x[1]) return x[2] + (r - x[0]);
                }
                return 0;
            }
            throw "unknown cmap table format " + f.format;
        }, e.U.glyphToPath = function(i, r) {
            var l = {
                cmds: [],
                crds: []
            };
            if (i.SVG && i.SVG.entries[r]) {
                var c = i.SVG.entries[r];
                return c == null ? l : (typeof c == "string" && (c = e.SVG.toPath(c), i.SVG.entries[r] = c), c);
            }
            if (i.CFF) {
                var f = {
                    x: 0,
                    y: 0,
                    stack: [],
                    nStems: 0,
                    haveWidth: !1,
                    width: i.CFF.Private ? i.CFF.Private.defaultWidthX : 0,
                    open: !1
                }, p = i.CFF, m = i.CFF.Private;
                if (p.ROS) {
                    for(var x = 0; p.FDSelect[x + 2] <= r;)x += 2;
                    m = p.FDArray[p.FDSelect[x + 1]].Private;
                }
                e.U._drawCFF(i.CFF.CharStrings[r], f, p, m, l);
            } else i.glyf && e.U._drawGlyf(r, i, l);
            return l;
        }, e.U._drawGlyf = function(i, r, l) {
            var c = r.glyf[i];
            c == null && (c = r.glyf[i] = e.glyf._parseGlyf(r, i)), c != null && (c.noc > -1 ? e.U._simpleGlyph(c, l) : e.U._compoGlyph(c, r, l));
        }, e.U._simpleGlyph = function(i, r) {
            for(var l = 0; l < i.noc; l++){
                for(var c = l == 0 ? 0 : i.endPts[l - 1] + 1, f = i.endPts[l], p = c; p <= f; p++){
                    var m = p == c ? f : p - 1, x = p == f ? c : p + 1, v = 1 & i.flags[p], _ = 1 & i.flags[m], S = 1 & i.flags[x], A = i.xs[p], M = i.ys[p];
                    if (p == c) {
                        if (v) {
                            if (!_) {
                                e.U.P.moveTo(r, A, M);
                                continue;
                            }
                            e.U.P.moveTo(r, i.xs[m], i.ys[m]);
                        } else _ ? e.U.P.moveTo(r, i.xs[m], i.ys[m]) : e.U.P.moveTo(r, (i.xs[m] + A) / 2, (i.ys[m] + M) / 2);
                    }
                    v ? _ && e.U.P.lineTo(r, A, M) : S ? e.U.P.qcurveTo(r, A, M, i.xs[x], i.ys[x]) : e.U.P.qcurveTo(r, A, M, (A + i.xs[x]) / 2, (M + i.ys[x]) / 2);
                }
                e.U.P.closePath(r);
            }
        }, e.U._compoGlyph = function(i, r, l) {
            for(var c = 0; c < i.parts.length; c++){
                var f = {
                    cmds: [],
                    crds: []
                }, p = i.parts[c];
                e.U._drawGlyf(p.glyphIndex, r, f);
                for(var m = p.m, x = 0; x < f.crds.length; x += 2){
                    var v = f.crds[x], _ = f.crds[x + 1];
                    l.crds.push(v * m.a + _ * m.b + m.tx), l.crds.push(v * m.c + _ * m.d + m.ty);
                }
                for(x = 0; x < f.cmds.length; x++)l.cmds.push(f.cmds[x]);
            }
        }, e.U._getGlyphClass = function(i, r) {
            var l = e._lctf.getInterval(r, i);
            return l == -1 ? 0 : r[l + 2];
        }, e.U._applySubs = function(i, r, l, c) {
            for(var f = i.length - r - 1, p = 0; p < l.tabs.length; p++)if (l.tabs[p] != null) {
                var m, x = l.tabs[p];
                if (!x.coverage || (m = e._lctf.coverageIndex(x.coverage, i[r])) != -1) {
                    if (l.ltype == 1) i[r], x.fmt == 1 ? i[r] = i[r] + x.delta : i[r] = x.newg[m];
                    else if (l.ltype == 4) for(var v = x.vals[m], _ = 0; _ < v.length; _++){
                        var S = v[_], A = S.chain.length;
                        if (!(A > f)) {
                            for(var M = !0, b = 0, C = 0; C < A; C++){
                                for(; i[r + b + (1 + C)] == -1;)b++;
                                S.chain[C] != i[r + b + (1 + C)] && (M = !1);
                            }
                            if (M) {
                                for(i[r] = S.nglyph, C = 0; C < A + b; C++)i[r + C + 1] = -1;
                                break;
                            }
                        }
                    }
                    else if (l.ltype == 5 && x.fmt == 2) for(var R = e._lctf.getInterval(x.cDef, i[r]), N = x.cDef[R + 2], z = x.scset[N], L = 0; L < z.length; L++){
                        var P = z[L], H = P.input;
                        if (!(H.length > f)) {
                            for(M = !0, C = 0; C < H.length; C++){
                                var O = e._lctf.getInterval(x.cDef, i[r + 1 + C]);
                                if (R == -1 && x.cDef[O + 2] != H[C]) {
                                    M = !1;
                                    break;
                                }
                            }
                            if (M) {
                                var D = P.substLookupRecords;
                                for(_ = 0; _ < D.length; _ += 2)D[_], D[_ + 1];
                            }
                        }
                    }
                    else if (l.ltype == 6 && x.fmt == 3) {
                        if (!e.U._glsCovered(i, x.backCvg, r - x.backCvg.length) || !e.U._glsCovered(i, x.inptCvg, r) || !e.U._glsCovered(i, x.ahedCvg, r + x.inptCvg.length)) continue;
                        var j = x.lookupRec;
                        for(L = 0; L < j.length; L += 2){
                            R = j[L];
                            var G = c[j[L + 1]];
                            e.U._applySubs(i, r + R, G, c);
                        }
                    }
                }
            }
        }, e.U._glsCovered = function(i, r, l) {
            for(var c = 0; c < r.length; c++)if (e._lctf.coverageIndex(r[c], i[l + c]) == -1) return !1;
            return !0;
        }, e.U.glyphsToPath = function(i, r, l) {
            for(var c = {
                cmds: [],
                crds: []
            }, f = 0, p = 0; p < r.length; p++){
                var m = r[p];
                if (m != -1) {
                    for(var x = p < r.length - 1 && r[p + 1] != -1 ? r[p + 1] : 0, v = e.U.glyphToPath(i, m), _ = 0; _ < v.crds.length; _ += 2)c.crds.push(v.crds[_] + f), c.crds.push(v.crds[_ + 1]);
                    for(l && c.cmds.push(l), _ = 0; _ < v.cmds.length; _++)c.cmds.push(v.cmds[_]);
                    l && c.cmds.push("X"), f += i.hmtx.aWidth[m], p < r.length - 1 && (f += e.U.getPairAdjustment(i, m, x));
                }
            }
            return c;
        }, e.U.P = {}, e.U.P.moveTo = function(i, r, l) {
            i.cmds.push("M"), i.crds.push(r, l);
        }, e.U.P.lineTo = function(i, r, l) {
            i.cmds.push("L"), i.crds.push(r, l);
        }, e.U.P.curveTo = function(i, r, l, c, f, p, m) {
            i.cmds.push("C"), i.crds.push(r, l, c, f, p, m);
        }, e.U.P.qcurveTo = function(i, r, l, c, f) {
            i.cmds.push("Q"), i.crds.push(r, l, c, f);
        }, e.U.P.closePath = function(i) {
            i.cmds.push("Z");
        }, e.U._drawCFF = function(i, r, l, c, f) {
            for(var p = r.stack, m = r.nStems, x = r.haveWidth, v = r.width, _ = r.open, S = 0, A = r.x, M = r.y, b = 0, C = 0, R = 0, N = 0, z = 0, L = 0, P = 0, H = 0, O = 0, D = 0, j = {
                val: 0,
                size: 0
            }; S < i.length;){
                e.CFF.getCharString(i, S, j);
                var G = j.val;
                if (S += j.size, G == "o1" || G == "o18") p.length % 2 != 0 && !x && (v = p.shift() + c.nominalWidthX), m += p.length >> 1, p.length = 0, x = !0;
                else if (G == "o3" || G == "o23") p.length % 2 != 0 && !x && (v = p.shift() + c.nominalWidthX), m += p.length >> 1, p.length = 0, x = !0;
                else if (G == "o4") p.length > 1 && !x && (v = p.shift() + c.nominalWidthX, x = !0), _ && e.U.P.closePath(f), M += p.pop(), e.U.P.moveTo(f, A, M), _ = !0;
                else if (G == "o5") for(; p.length > 0;)A += p.shift(), M += p.shift(), e.U.P.lineTo(f, A, M);
                else if (G == "o6" || G == "o7") for(var q = p.length, Y = G == "o6", ae = 0; ae < q; ae++){
                    var F = p.shift();
                    Y ? A += F : M += F, Y = !Y, e.U.P.lineTo(f, A, M);
                }
                else if (G == "o8" || G == "o24") {
                    q = p.length;
                    for(var Q = 0; Q + 6 <= q;)b = A + p.shift(), C = M + p.shift(), R = b + p.shift(), N = C + p.shift(), A = R + p.shift(), M = N + p.shift(), e.U.P.curveTo(f, b, C, R, N, A, M), Q += 6;
                    G == "o24" && (A += p.shift(), M += p.shift(), e.U.P.lineTo(f, A, M));
                } else {
                    if (G == "o11") break;
                    if (G == "o1234" || G == "o1235" || G == "o1236" || G == "o1237") G == "o1234" && (C = M, R = (b = A + p.shift()) + p.shift(), D = N = C + p.shift(), L = N, H = M, A = (P = (z = (O = R + p.shift()) + p.shift()) + p.shift()) + p.shift(), e.U.P.curveTo(f, b, C, R, N, O, D), e.U.P.curveTo(f, z, L, P, H, A, M)), G == "o1235" && (b = A + p.shift(), C = M + p.shift(), R = b + p.shift(), N = C + p.shift(), O = R + p.shift(), D = N + p.shift(), z = O + p.shift(), L = D + p.shift(), P = z + p.shift(), H = L + p.shift(), A = P + p.shift(), M = H + p.shift(), p.shift(), e.U.P.curveTo(f, b, C, R, N, O, D), e.U.P.curveTo(f, z, L, P, H, A, M)), G == "o1236" && (b = A + p.shift(), C = M + p.shift(), R = b + p.shift(), D = N = C + p.shift(), L = N, P = (z = (O = R + p.shift()) + p.shift()) + p.shift(), H = L + p.shift(), A = P + p.shift(), e.U.P.curveTo(f, b, C, R, N, O, D), e.U.P.curveTo(f, z, L, P, H, A, M)), G == "o1237" && (b = A + p.shift(), C = M + p.shift(), R = b + p.shift(), N = C + p.shift(), O = R + p.shift(), D = N + p.shift(), z = O + p.shift(), L = D + p.shift(), P = z + p.shift(), H = L + p.shift(), Math.abs(P - A) > Math.abs(H - M) ? A = P + p.shift() : M = H + p.shift(), e.U.P.curveTo(f, b, C, R, N, O, D), e.U.P.curveTo(f, z, L, P, H, A, M));
                    else if (G == "o14") {
                        if (p.length > 0 && !x && (v = p.shift() + l.nominalWidthX, x = !0), p.length == 4) {
                            var K = p.shift(), $ = p.shift(), ee = p.shift(), I = p.shift(), Z = e.CFF.glyphBySE(l, ee), oe = e.CFF.glyphBySE(l, I);
                            e.U._drawCFF(l.CharStrings[Z], r, l, c, f), r.x = K, r.y = $, e.U._drawCFF(l.CharStrings[oe], r, l, c, f);
                        }
                        _ && (e.U.P.closePath(f), _ = !1);
                    } else if (G == "o19" || G == "o20") p.length % 2 != 0 && !x && (v = p.shift() + c.nominalWidthX), m += p.length >> 1, p.length = 0, x = !0, S += m + 7 >> 3;
                    else if (G == "o21") p.length > 2 && !x && (v = p.shift() + c.nominalWidthX, x = !0), M += p.pop(), A += p.pop(), _ && e.U.P.closePath(f), e.U.P.moveTo(f, A, M), _ = !0;
                    else if (G == "o22") p.length > 1 && !x && (v = p.shift() + c.nominalWidthX, x = !0), A += p.pop(), _ && e.U.P.closePath(f), e.U.P.moveTo(f, A, M), _ = !0;
                    else if (G == "o25") {
                        for(; p.length > 6;)A += p.shift(), M += p.shift(), e.U.P.lineTo(f, A, M);
                        b = A + p.shift(), C = M + p.shift(), R = b + p.shift(), N = C + p.shift(), A = R + p.shift(), M = N + p.shift(), e.U.P.curveTo(f, b, C, R, N, A, M);
                    } else if (G == "o26") for(p.length % 2 && (A += p.shift()); p.length > 0;)b = A, C = M + p.shift(), A = R = b + p.shift(), M = (N = C + p.shift()) + p.shift(), e.U.P.curveTo(f, b, C, R, N, A, M);
                    else if (G == "o27") for(p.length % 2 && (M += p.shift()); p.length > 0;)C = M, R = (b = A + p.shift()) + p.shift(), N = C + p.shift(), A = R + p.shift(), M = N, e.U.P.curveTo(f, b, C, R, N, A, M);
                    else if (G == "o10" || G == "o29") {
                        var ce = G == "o10" ? c : l;
                        if (p.length == 0) console.debug("error: empty stack");
                        else {
                            var de = p.pop(), ue = ce.Subrs[de + ce.Bias];
                            r.x = A, r.y = M, r.nStems = m, r.haveWidth = x, r.width = v, r.open = _, e.U._drawCFF(ue, r, l, c, f), A = r.x, M = r.y, m = r.nStems, x = r.haveWidth, v = r.width, _ = r.open;
                        }
                    } else if (G == "o30" || G == "o31") {
                        var le = p.length, xe = (Q = 0, G == "o31");
                        for(Q += le - (q = -3 & le); Q < q;)xe ? (C = M, R = (b = A + p.shift()) + p.shift(), M = (N = C + p.shift()) + p.shift(), q - Q == 5 ? (A = R + p.shift(), Q++) : A = R, xe = !1) : (b = A, C = M + p.shift(), R = b + p.shift(), N = C + p.shift(), A = R + p.shift(), q - Q == 5 ? (M = N + p.shift(), Q++) : M = N, xe = !0), e.U.P.curveTo(f, b, C, R, N, A, M), Q += 4;
                    } else {
                        if ((G + "").charAt(0) == "o") throw console.debug("Unknown operation: " + G, i), G;
                        p.push(G);
                    }
                }
            }
            r.x = A, r.y = M, r.nStems = m, r.haveWidth = x, r.width = v, r.open = _;
        };
        var t = e, n = {
            Typr: t
        };
        return a.Typr = t, a.default = n, Object.defineProperty(a, "__esModule", {
            value: !0
        }), a;
    }({}).Typr;
}
function $455d545b1dff00eb$var$PI() {
    return function(a) {
        var e = Uint8Array, t = Uint16Array, n = Uint32Array, i = new e([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), r = new e([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), l = new e([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), c = function(G, q) {
            for(var Y = new t(31), ae = 0; ae < 31; ++ae)Y[ae] = q += 1 << G[ae - 1];
            var F = new n(Y[30]);
            for(ae = 1; ae < 30; ++ae)for(var Q = Y[ae]; Q < Y[ae + 1]; ++Q)F[Q] = Q - Y[ae] << 5 | ae;
            return [
                Y,
                F
            ];
        }, f = c(i, 2), p = f[0], m = f[1];
        p[28] = 258, m[258] = 28;
        for(var x = c(r, 0)[0], v = new t(32768), _ = 0; _ < 32768; ++_){
            var S = (43690 & _) >>> 1 | (21845 & _) << 1;
            S = (61680 & (S = (52428 & S) >>> 2 | (13107 & S) << 2)) >>> 4 | (3855 & S) << 4, v[_] = ((65280 & S) >>> 8 | (255 & S) << 8) >>> 1;
        }
        var A = function(G, q, Y) {
            for(var ae = G.length, F = 0, Q = new t(q); F < ae; ++F)++Q[G[F] - 1];
            var K, $ = new t(q);
            for(F = 0; F < q; ++F)$[F] = $[F - 1] + Q[F - 1] << 1;
            K = new t(1 << q);
            var ee = 15 - q;
            for(F = 0; F < ae; ++F)if (G[F]) for(var I = F << 4 | G[F], Z = q - G[F], oe = $[G[F] - 1]++ << Z, ce = oe | (1 << Z) - 1; oe <= ce; ++oe)K[v[oe] >>> ee] = I;
            return K;
        }, M = new e(288);
        for(_ = 0; _ < 144; ++_)M[_] = 8;
        for(_ = 144; _ < 256; ++_)M[_] = 9;
        for(_ = 256; _ < 280; ++_)M[_] = 7;
        for(_ = 280; _ < 288; ++_)M[_] = 8;
        var b = new e(32);
        for(_ = 0; _ < 32; ++_)b[_] = 5;
        var C = A(M, 9), R = A(b, 5), N = function(G) {
            for(var q = G[0], Y = 1; Y < G.length; ++Y)G[Y] > q && (q = G[Y]);
            return q;
        }, z = function(G, q, Y) {
            var ae = q / 8 | 0;
            return (G[ae] | G[ae + 1] << 8) >> (7 & q) & Y;
        }, L = function(G, q) {
            var Y = q / 8 | 0;
            return (G[Y] | G[Y + 1] << 8 | G[Y + 2] << 16) >> (7 & q);
        }, P = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], H = function(G, q, Y) {
            var ae = new Error(q || P[G]);
            if (ae.code = G, Error.captureStackTrace && Error.captureStackTrace(ae, H), !Y) throw ae;
            return ae;
        }, O = function(G, q, Y) {
            var ae = G.length;
            if (!ae || Y && !Y.l && ae < 5) return q || new e(0);
            var F = !q || Y, Q = !Y || Y.i;
            Y || (Y = {}), q || (q = new e(3 * ae));
            var K, $ = function(at) {
                var he = q.length;
                if (at > he) {
                    var Ee = new e(Math.max(2 * he, at));
                    Ee.set(q), q = Ee;
                }
            }, ee = Y.f || 0, I = Y.p || 0, Z = Y.b || 0, oe = Y.l, ce = Y.d, de = Y.m, ue = Y.n, le = 8 * ae;
            do {
                if (!oe) {
                    Y.f = ee = z(G, I, 1);
                    var xe = z(G, I + 1, 3);
                    if (I += 3, !xe) {
                        var Le = G[(Ze = ((K = I) / 8 | 0) + (7 & K && 1) + 4) - 4] | G[Ze - 3] << 8, Ue = Ze + Le;
                        if (Ue > ae) {
                            Q && H(0);
                            break;
                        }
                        F && $(Z + Le), q.set(G.subarray(Ze, Ue), Z), Y.b = Z += Le, Y.p = I = 8 * Ue;
                        continue;
                    }
                    if (xe == 1) oe = C, ce = R, de = 9, ue = 5;
                    else if (xe == 2) {
                        var Ne = z(G, I, 31) + 257, ke = z(G, I + 10, 15) + 4, nt = Ne + z(G, I + 5, 31) + 1;
                        I += 14;
                        for(var Re = new e(nt), te = new e(19), Oe = 0; Oe < ke; ++Oe)te[l[Oe]] = z(G, I + 3 * Oe, 7);
                        I += 3 * ke;
                        var Ie = N(te), Ae = (1 << Ie) - 1, ze = A(te, Ie);
                        for(Oe = 0; Oe < nt;){
                            var Ze, be = ze[z(G, I, Ae)];
                            if (I += 15 & be, (Ze = be >>> 4) < 16) Re[Oe++] = Ze;
                            else {
                                var rt = 0, ne = 0;
                                for(Ze == 16 ? (ne = 3 + z(G, I, 3), I += 2, rt = Re[Oe - 1]) : Ze == 17 ? (ne = 3 + z(G, I, 7), I += 3) : Ze == 18 && (ne = 11 + z(G, I, 127), I += 7); ne--;)Re[Oe++] = rt;
                            }
                        }
                        var W = Re.subarray(0, Ne), pe = Re.subarray(Ne);
                        de = N(W), ue = N(pe), oe = A(W, de), ce = A(pe, ue);
                    } else H(1);
                    if (I > le) {
                        Q && H(0);
                        break;
                    }
                }
                F && $(Z + 131072);
                for(var Be = (1 << de) - 1, Te = (1 << ue) - 1, _e = I;; _e = I){
                    var ot = (rt = oe[L(G, I) & Be]) >>> 4;
                    if ((I += 15 & rt) > le) {
                        Q && H(0);
                        break;
                    }
                    if (rt || H(2), ot < 256) q[Z++] = ot;
                    else {
                        if (ot == 256) {
                            _e = I, oe = null;
                            break;
                        }
                        var tt = ot - 254;
                        if (ot > 264) {
                            var gt = i[Oe = ot - 257];
                            tt = z(G, I, (1 << gt) - 1) + p[Oe], I += gt;
                        }
                        var pt = ce[L(G, I) & Te], Ge = pt >>> 4;
                        if (pt || H(3), I += 15 & pt, pe = x[Ge], Ge > 3 && (gt = r[Ge], pe += L(G, I) & (1 << gt) - 1, I += gt), I > le) {
                            Q && H(0);
                            break;
                        }
                        F && $(Z + 131072);
                        for(var Ye = Z + tt; Z < Ye; Z += 4)q[Z] = q[Z - pe], q[Z + 1] = q[Z + 1 - pe], q[Z + 2] = q[Z + 2 - pe], q[Z + 3] = q[Z + 3 - pe];
                        Z = Ye;
                    }
                }
                Y.l = oe, Y.p = _e, Y.b = Z, oe && (ee = 1, Y.m = de, Y.d = ce, Y.n = ue);
            }while (!ee);
            return Z == q.length ? q : function(at, he, Ee) {
                (Ee == null || Ee > at.length) && (Ee = at.length);
                var lt = new (at instanceof t ? t : at instanceof n ? n : e)(Ee - he);
                return lt.set(at.subarray(he, Ee)), lt;
            }(q, 0, Z);
        }, D = new e(0), j = typeof TextDecoder < "u" && new TextDecoder;
        try {
            j.decode(D, {
                stream: !0
            });
        } catch  {}
        return a.convert_streams = function(G) {
            var q = new DataView(G), Y = 0;
            function ae() {
                var Ne = q.getUint16(Y);
                return Y += 2, Ne;
            }
            function F() {
                var Ne = q.getUint32(Y);
                return Y += 4, Ne;
            }
            function Q(Ne) {
                Le.setUint16(Ue, Ne), Ue += 2;
            }
            function K(Ne) {
                Le.setUint32(Ue, Ne), Ue += 4;
            }
            for(var $ = {
                signature: F(),
                flavor: F(),
                length: F(),
                numTables: ae(),
                reserved: ae(),
                totalSfntSize: F(),
                majorVersion: ae(),
                minorVersion: ae(),
                metaOffset: F(),
                metaLength: F(),
                metaOrigLength: F(),
                privOffset: F(),
                privLength: F()
            }, ee = 0; Math.pow(2, ee) <= $.numTables;)ee++;
            ee--;
            for(var I = 16 * Math.pow(2, ee), Z = 16 * $.numTables - I, oe = 12, ce = [], de = 0; de < $.numTables; de++)ce.push({
                tag: F(),
                offset: F(),
                compLength: F(),
                origLength: F(),
                origChecksum: F()
            }), oe += 16;
            var ue, le = new Uint8Array(12 + 16 * ce.length + ce.reduce(function(Ne, ke) {
                return Ne + ke.origLength + 4;
            }, 0)), xe = le.buffer, Le = new DataView(xe), Ue = 0;
            return K($.flavor), Q($.numTables), Q(I), Q(ee), Q(Z), ce.forEach(function(Ne) {
                K(Ne.tag), K(Ne.origChecksum), K(oe), K(Ne.origLength), Ne.outOffset = oe, (oe += Ne.origLength) % 4 != 0 && (oe += 4 - oe % 4);
            }), ce.forEach(function(Ne) {
                var ke, nt = G.slice(Ne.offset, Ne.offset + Ne.compLength);
                if (Ne.compLength != Ne.origLength) {
                    var Re = new Uint8Array(Ne.origLength);
                    ke = new Uint8Array(nt, 2), O(ke, Re);
                } else Re = new Uint8Array(nt);
                le.set(Re, Ne.outOffset);
                var te = 0;
                (oe = Ne.outOffset + Ne.origLength) % 4 != 0 && (te = 4 - oe % 4), le.set(new Uint8Array(te).buffer, Ne.outOffset + Ne.origLength), ue = oe + te;
            }), xe.slice(0, ue);
        }, Object.defineProperty(a, "__esModule", {
            value: !0
        }), a;
    }({}).convert_streams;
}
function $455d545b1dff00eb$var$BI(a, e) {
    const t = {
        M: 2,
        L: 2,
        Q: 4,
        C: 6,
        Z: 0
    }, n = {
        C: "18g,ca,368,1kz",
        D: "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v",
        R: "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6",
        L: "x9u,jff,a,fd,jv",
        T: "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n"
    }, i = 1, r = 2, l = 4, c = 8, f = 16, p = 32;
    let m;
    function x(P) {
        if (!m) {
            const H = {
                R: r,
                L: i,
                D: l,
                C: f,
                U: p,
                T: c
            };
            m = new Map;
            for(let O in n){
                let D = 0;
                n[O].split(",").forEach((j)=>{
                    let [G, q] = j.split("+");
                    G = parseInt(G, 36), q = q ? parseInt(q, 36) : 0, m.set(D += G, H[O]);
                    for(let Y = q; Y--;)m.set(++D, H[O]);
                });
            }
        }
        return m.get(P) || p;
    }
    const v = 1, _ = 2, S = 3, A = 4, M = [
        null,
        "isol",
        "init",
        "fina",
        "medi"
    ];
    function b(P) {
        const H = new Uint8Array(P.length);
        let O = p, D = v, j = -1;
        for(let G = 0; G < P.length; G++){
            const q = P.codePointAt(G);
            let Y = x(q) | 0, ae = v;
            Y & c || (O & (i | l | f) ? Y & (r | l | f) ? (ae = S, (D === v || D === S) && H[j]++) : Y & (i | p) && (D === _ || D === A) && H[j]-- : O & (r | p) && (D === _ || D === A) && H[j]--, D = H[G] = ae, O = Y, j = G, q > 65535 && G++);
        }
        return H;
    }
    function C(P, H) {
        const O = [];
        for(let j = 0; j < H.length; j++){
            const G = H.codePointAt(j);
            G > 65535 && j++, O.push(a.U.codeToGlyph(P, G));
        }
        const D = P.GSUB;
        if (D) {
            const { lookupList: j, featureList: G } = D;
            let q;
            const Y = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws|ccmp)$/, ae = [];
            G.forEach((F)=>{
                if (Y.test(F.tag)) for(let Q = 0; Q < F.tab.length; Q++){
                    if (ae[F.tab[Q]]) continue;
                    ae[F.tab[Q]] = !0;
                    const K = j[F.tab[Q]], $ = /^(isol|init|fina|medi)$/.test(F.tag);
                    $ && !q && (q = b(H));
                    for(let ee = 0; ee < O.length; ee++)(!q || !$ || M[q[ee]] === F.tag) && a.U._applySubs(O, ee, K, j);
                }
            });
        }
        return O;
    }
    function R(P, H) {
        const O = new Int16Array(H.length * 3);
        let D = 0;
        for(; D < H.length; D++){
            const Y = H[D];
            if (Y === -1) continue;
            O[D * 3 + 2] = P.hmtx.aWidth[Y];
            const ae = P.GPOS;
            if (ae) {
                const F = ae.lookupList;
                for(let Q = 0; Q < F.length; Q++){
                    const K = F[Q];
                    for(let $ = 0; $ < K.tabs.length; $++){
                        const ee = K.tabs[$];
                        if (K.ltype === 1) {
                            if (a._lctf.coverageIndex(ee.coverage, Y) !== -1 && ee.pos) {
                                q(ee.pos, D);
                                break;
                            }
                        } else if (K.ltype === 2) {
                            let I = null, Z = j();
                            if (Z !== -1) {
                                const oe = a._lctf.coverageIndex(ee.coverage, H[Z]);
                                if (oe !== -1) {
                                    if (ee.fmt === 1) {
                                        const ce = ee.pairsets[oe];
                                        for(let de = 0; de < ce.length; de++)ce[de].gid2 === Y && (I = ce[de]);
                                    } else if (ee.fmt === 2) {
                                        const ce = a.U._getGlyphClass(H[Z], ee.classDef1), de = a.U._getGlyphClass(Y, ee.classDef2);
                                        I = ee.matrix[ce][de];
                                    }
                                    if (I) {
                                        I.val1 && q(I.val1, Z), I.val2 && q(I.val2, D);
                                        break;
                                    }
                                }
                            }
                        } else if (K.ltype === 4) {
                            const I = a._lctf.coverageIndex(ee.markCoverage, Y);
                            if (I !== -1) {
                                const Z = j(G), oe = Z === -1 ? -1 : a._lctf.coverageIndex(ee.baseCoverage, H[Z]);
                                if (oe !== -1) {
                                    const ce = ee.markArray[I], de = ee.baseArray[oe][ce.markClass];
                                    O[D * 3] = de.x - ce.x + O[Z * 3] - O[Z * 3 + 2], O[D * 3 + 1] = de.y - ce.y + O[Z * 3 + 1];
                                    break;
                                }
                            }
                        } else if (K.ltype === 6) {
                            const I = a._lctf.coverageIndex(ee.mark1Coverage, Y);
                            if (I !== -1) {
                                const Z = j();
                                if (Z !== -1) {
                                    const oe = H[Z];
                                    if (N(P, oe) === 3) {
                                        const ce = a._lctf.coverageIndex(ee.mark2Coverage, oe);
                                        if (ce !== -1) {
                                            const de = ee.mark1Array[I], ue = ee.mark2Array[ce][de.markClass];
                                            O[D * 3] = ue.x - de.x + O[Z * 3] - O[Z * 3 + 2], O[D * 3 + 1] = ue.y - de.y + O[Z * 3 + 1];
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (P.kern && !P.cff) {
                const F = j();
                if (F !== -1) {
                    const Q = P.kern.glyph1.indexOf(H[F]);
                    if (Q !== -1) {
                        const K = P.kern.rval[Q].glyph2.indexOf(Y);
                        K !== -1 && (O[F * 3 + 2] += P.kern.rval[Q].vals[K]);
                    }
                }
            }
        }
        return O;
        function j(Y) {
            for(let ae = D - 1; ae >= 0; ae--)if (H[ae] !== -1 && (!Y || Y(H[ae]))) return ae;
            return -1;
        }
        function G(Y) {
            return N(P, Y) === 1;
        }
        function q(Y, ae) {
            for(let F = 0; F < 3; F++)O[ae * 3 + F] += Y[F] || 0;
        }
    }
    function N(P, H) {
        const O = P.GDEF && P.GDEF.glyphClassDef;
        return O ? a.U._getGlyphClass(H, O) : 0;
    }
    function z(...P) {
        for(let H = 0; H < P.length; H++)if (typeof P[H] == "number") return P[H];
    }
    function L(P) {
        const H = Object.create(null), O = P["OS/2"], D = P.hhea, j = P.head.unitsPerEm, G = z(O && O.sTypoAscender, D && D.ascender, j), q = {
            unitsPerEm: j,
            ascender: G,
            descender: z(O && O.sTypoDescender, D && D.descender, 0),
            capHeight: z(O && O.sCapHeight, G),
            xHeight: z(O && O.sxHeight, G),
            lineGap: z(O && O.sTypoLineGap, D && D.lineGap),
            supportsCodePoint (Y) {
                return a.U.codeToGlyph(P, Y) > 0;
            },
            forEachGlyph (Y, ae, F, Q) {
                let K = 0;
                const $ = 1 / q.unitsPerEm * ae, ee = C(P, Y);
                let I = 0;
                const Z = R(P, ee);
                return ee.forEach((oe, ce)=>{
                    if (oe !== -1) {
                        let de = H[oe];
                        if (!de) {
                            const { cmds: ue, crds: le } = a.U.glyphToPath(P, oe);
                            let xe = "", Le = 0;
                            for(let Re = 0, te = ue.length; Re < te; Re++){
                                const Oe = t[ue[Re]];
                                xe += ue[Re];
                                for(let Ie = 1; Ie <= Oe; Ie++)xe += (Ie > 1 ? "," : "") + le[Le++];
                            }
                            let Ue, Ne, ke, nt;
                            if (le.length) {
                                Ue = Ne = 1 / 0, ke = nt = -1 / 0;
                                for(let Re = 0, te = le.length; Re < te; Re += 2){
                                    let Oe = le[Re], Ie = le[Re + 1];
                                    Oe < Ue && (Ue = Oe), Ie < Ne && (Ne = Ie), Oe > ke && (ke = Oe), Ie > nt && (nt = Ie);
                                }
                            } else Ue = ke = Ne = nt = 0;
                            de = H[oe] = {
                                index: oe,
                                advanceWidth: P.hmtx.aWidth[oe],
                                xMin: Ue,
                                yMin: Ne,
                                xMax: ke,
                                yMax: nt,
                                path: xe
                            };
                        }
                        Q.call(null, de, K + Z[ce * 3] * $, Z[ce * 3 + 1] * $, I), K += Z[ce * 3 + 2] * $, F && (K += F * ae);
                    }
                    I += Y.codePointAt(I) > 65535 ? 2 : 1;
                }), K;
            }
        };
        return q;
    }
    return function(H) {
        const O = new Uint8Array(H, 0, 4), D = a._bin.readASCII(O, 0, 4);
        if (D === "wOFF") H = e(H);
        else if (D === "wOF2") throw new Error("woff2 fonts not supported");
        return L(a.parse(H)[0]);
    };
}
const $455d545b1dff00eb$var$II = $455d545b1dff00eb$var$Qd({
    name: "Typr Font Parser",
    dependencies: [
        $455d545b1dff00eb$var$zI,
        $455d545b1dff00eb$var$PI,
        $455d545b1dff00eb$var$BI
    ],
    init (a, e, t) {
        const n = a(), i = e();
        return t(n, i);
    }
});
function $455d545b1dff00eb$var$FI() {
    return function(a) {
        var e = function() {
            this.buckets = new Map;
        };
        e.prototype.add = function(R) {
            var N = R >> 5;
            this.buckets.set(N, (this.buckets.get(N) || 0) | 1 << (31 & R));
        }, e.prototype.has = function(R) {
            var N = this.buckets.get(R >> 5);
            return N !== void 0 && (N & 1 << (31 & R)) != 0;
        }, e.prototype.serialize = function() {
            var R = [];
            return this.buckets.forEach(function(N, z) {
                R.push((+z).toString(36) + ":" + N.toString(36));
            }), R.join(",");
        }, e.prototype.deserialize = function(R) {
            var N = this;
            this.buckets.clear(), R.split(",").forEach(function(z) {
                var L = z.split(":");
                N.buckets.set(parseInt(L[0], 36), parseInt(L[1], 36));
            });
        };
        var t = Math.pow(2, 8), n = t - 1, i = ~n;
        function r(R) {
            var N = (function(L) {
                return L & i;
            })(R).toString(16), z = (function(L) {
                return (L & i) + t - 1;
            })(R).toString(16);
            return "codepoint-index/plane" + (R >> 16) + "/" + N + "-" + z + ".json";
        }
        function l(R, N) {
            var z = R & n, L = N.codePointAt(z / 6 | 0);
            return ((L = (L || 48) - 48) & 1 << z % 6) != 0;
        }
        function c(R, N) {
            var z;
            (z = R, z.replace(/U\+/gi, "").replace(/^,+|,+$/g, "").split(/,+/).map(function(L) {
                return L.split("-").map(function(P) {
                    return parseInt(P.trim(), 16);
                });
            })).forEach(function(L) {
                var P = L[0], H = L[1];
                H === void 0 && (H = P), N(P, H);
            });
        }
        function f(R, N) {
            c(R, function(z, L) {
                for(var P = z; P <= L; P++)N(P);
            });
        }
        var p = {}, m = {}, x = new WeakMap, v = "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v1.0.1/packages/data";
        function _(R) {
            var N = x.get(R);
            return N || (N = new e, f(R.ranges, function(z) {
                return N.add(z);
            }), x.set(R, N)), N;
        }
        var S, A = new Map;
        function M(R, N, z) {
            return R[N] ? N : R[z] ? z : function(L) {
                for(var P in L)return P;
            }(R);
        }
        function b(R, N) {
            var z = N;
            if (!R.includes(z)) {
                z = 1 / 0;
                for(var L = 0; L < R.length; L++)Math.abs(R[L] - N) < Math.abs(z - N) && (z = R[L]);
            }
            return z;
        }
        function C(R) {
            return S || (S = new Set, f("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", function(N) {
                S.add(N);
            })), S.has(R);
        }
        return a.CodePointSet = e, a.clearCache = function() {
            p = {}, m = {};
        }, a.getFontsForString = function(R, N) {
            N === void 0 && (N = {});
            var z, L = N.lang;
            L === void 0 && (L = new RegExp("\\p{Script=Hangul}", "u").test(z = R) ? "ko" : new RegExp("\\p{Script=Hiragana}|\\p{Script=Katakana}", "u").test(z) ? "ja" : "en");
            var P = N.category;
            P === void 0 && (P = "sans-serif");
            var H = N.style;
            H === void 0 && (H = "normal");
            var O = N.weight;
            O === void 0 && (O = 400);
            var D = (N.dataUrl || v).replace(/\/$/g, ""), j = new Map, G = new Uint8Array(R.length), q = {}, Y = {}, ae = new Array(R.length), F = new Map, Q = !1;
            function K(I) {
                var Z = A.get(I);
                return Z || (Z = fetch(D + "/" + I).then(function(oe) {
                    if (!oe.ok) throw new Error(oe.statusText);
                    return oe.json().then(function(ce) {
                        if (!Array.isArray(ce) || ce[0] !== 1) throw new Error("Incorrect schema version; need 1, got " + ce[0]);
                        return ce[1];
                    });
                }).catch(function(oe) {
                    if (D !== v) return Q || (console.error('unicode-font-resolver: Failed loading from dataUrl "' + D + '", trying default CDN. ' + oe.message), Q = !0), D = v, A.delete(I), K(I);
                    throw oe;
                }), A.set(I, Z)), Z;
            }
            for(var $ = function(I) {
                var Z = R.codePointAt(I), oe = r(Z);
                ae[I] = oe, p[oe] || F.has(oe) || F.set(oe, K(oe).then(function(ce) {
                    p[oe] = ce;
                })), Z > 65535 && (I++, ee = I);
            }, ee = 0; ee < R.length; ee++)$(ee);
            return Promise.all(F.values()).then(function() {
                F.clear();
                for(var I = function(oe) {
                    var ce = R.codePointAt(oe), de = null, ue = p[ae[oe]], le = void 0;
                    for(var xe in ue){
                        var Le = Y[xe];
                        if (Le === void 0 && (Le = Y[xe] = new RegExp(xe).test(L || "en")), Le) {
                            for(var Ue in le = xe, ue[xe])if (l(ce, ue[xe][Ue])) {
                                de = Ue;
                                break;
                            }
                            break;
                        }
                    }
                    if (!de) {
                        e: for(var Ne in ue)if (Ne !== le) {
                            for(var ke in ue[Ne])if (l(ce, ue[Ne][ke])) {
                                de = ke;
                                break e;
                            }
                        }
                    }
                    de || (console.debug("No font coverage for U+" + ce.toString(16)), de = "latin"), ae[oe] = de, m[de] || F.has(de) || F.set(de, K("font-meta/" + de + ".json").then(function(nt) {
                        m[de] = nt;
                    })), ce > 65535 && (oe++, Z = oe);
                }, Z = 0; Z < R.length; Z++)I(Z);
                return Promise.all(F.values());
            }).then(function() {
                for(var I, Z = null, oe = 0; oe < R.length; oe++){
                    var ce = R.codePointAt(oe);
                    if (Z && (C(ce) || _(Z).has(ce))) G[oe] = G[oe - 1];
                    else {
                        Z = m[ae[oe]];
                        var de = q[Z.id];
                        if (!de) {
                            var ue = Z.typeforms, le = M(ue, P, "sans-serif"), xe = M(ue[le], H, "normal"), Le = b((I = ue[le]) === null || I === void 0 ? void 0 : I[xe], O);
                            de = q[Z.id] = D + "/font-files/" + Z.id + "/" + le + "." + xe + "." + Le + ".woff";
                        }
                        var Ue = j.get(de);
                        Ue == null && (Ue = j.size, j.set(de, Ue)), G[oe] = Ue;
                    }
                    ce > 65535 && (oe++, G[oe] = G[oe - 1]);
                }
                return {
                    fontUrls: Array.from(j.keys()),
                    chars: G
                };
            });
        }, Object.defineProperty(a, "__esModule", {
            value: !0
        }), a;
    }({});
}
function $455d545b1dff00eb$var$HI(a, e) {
    const t = Object.create(null), n = Object.create(null);
    function i(l, c) {
        const f = (p)=>{
            console.error(`Failure loading font ${l}`, p);
        };
        try {
            const p = new XMLHttpRequest;
            p.open("get", l, !0), p.responseType = "arraybuffer", p.onload = function() {
                if (p.status >= 400) f(new Error(p.statusText));
                else if (p.status > 0) try {
                    const m = a(p.response);
                    m.src = l, c(m);
                } catch (m) {
                    f(m);
                }
            }, p.onerror = f, p.send();
        } catch (p) {
            f(p);
        }
    }
    function r(l, c) {
        let f = t[l];
        f ? c(f) : n[l] ? n[l].push(c) : (n[l] = [
            c
        ], i(l, (p)=>{
            p.src = l, t[l] = p, n[l].forEach((m)=>m(p)), delete n[l];
        }));
    }
    return function(l, c, { lang: f, fonts: p = [], style: m = "normal", weight: x = "normal", unicodeFontsURL: v } = {}) {
        const _ = new Uint8Array(l.length), S = [];
        l.length || C();
        const A = new Map, M = [];
        if (m !== "italic" && (m = "normal"), typeof x != "number" && (x = x === "bold" ? 700 : 400), p && !Array.isArray(p) && (p = [
            p
        ]), p = p.slice().filter((N)=>!N.lang || N.lang.test(f)).reverse(), p.length) {
            let P = 0;
            (function H(O = 0) {
                for(let D = O, j = l.length; D < j; D++){
                    const G = l.codePointAt(D);
                    if (P === 1 && S[_[D - 1]].supportsCodePoint(G) || D > 0 && /\s/.test(l[D])) _[D] = _[D - 1], P === 2 && (M[M.length - 1][1] = D);
                    else for(let q = _[D], Y = p.length; q <= Y; q++)if (q === Y) {
                        const ae = P === 2 ? M[M.length - 1] : M[M.length] = [
                            D,
                            D
                        ];
                        ae[1] = D, P = 2;
                    } else {
                        _[D] = q;
                        const { src: ae, unicodeRange: F } = p[q];
                        if (!F || R(G, F)) {
                            const Q = t[ae];
                            if (!Q) {
                                r(ae, ()=>{
                                    H(D);
                                });
                                return;
                            }
                            if (Q.supportsCodePoint(G)) {
                                let K = A.get(Q);
                                typeof K != "number" && (K = S.length, S.push(Q), A.set(Q, K)), _[D] = K, P = 1;
                                break;
                            }
                        }
                    }
                    G > 65535 && D + 1 < j && (_[D + 1] = _[D], D++, P === 2 && (M[M.length - 1][1] = D));
                }
                b();
            })();
        } else M.push([
            0,
            l.length - 1
        ]), b();
        function b() {
            if (M.length) {
                const N = M.map((z)=>l.substring(z[0], z[1] + 1)).join(`
`);
                e.getFontsForString(N, {
                    lang: f || void 0,
                    style: m,
                    weight: x,
                    dataUrl: v
                }).then(({ fontUrls: z, chars: L })=>{
                    const P = S.length;
                    let H = 0;
                    M.forEach((D)=>{
                        for(let j = 0, G = D[1] - D[0]; j <= G; j++)_[D[0] + j] = L[H++] + P;
                        H++;
                    });
                    let O = 0;
                    z.forEach((D, j)=>{
                        r(D, (G)=>{
                            S[j + P] = G, ++O === z.length && C();
                        });
                    });
                });
            } else C();
        }
        function C() {
            c({
                chars: _,
                fonts: S
            });
        }
        function R(N, z) {
            for(let L = 0; L < z.length; L++){
                const [P, H = P] = z[L];
                if (P <= N && N <= H) return !0;
            }
            return !1;
        }
    };
}
const $455d545b1dff00eb$var$VI = $455d545b1dff00eb$var$Qd({
    name: "FontResolver",
    dependencies: [
        $455d545b1dff00eb$var$HI,
        $455d545b1dff00eb$var$II,
        $455d545b1dff00eb$var$FI
    ],
    init (a, e, t) {
        return a(e, t());
    }
});
function $455d545b1dff00eb$var$GI(a, e) {
    const n = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/, i = "[^\\S\\u00A0]", r = new RegExp(`${i}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`);
    function l({ text: S, lang: A, fonts: M, style: b, weight: C, preResolvedFonts: R, unicodeFontsURL: N }, z) {
        const L = ({ chars: P, fonts: H })=>{
            let O, D;
            const j = [];
            for(let G = 0; G < P.length; G++)P[G] !== D ? (D = P[G], j.push(O = {
                start: G,
                end: G,
                fontObj: H[P[G]]
            })) : O.end = G;
            z(j);
        };
        R ? L(R) : a(S, L, {
            lang: A,
            fonts: M,
            style: b,
            weight: C,
            unicodeFontsURL: N
        });
    }
    function c({ text: S = "", font: A, lang: M, sdfGlyphSize: b = 64, fontSize: C = 400, fontWeight: R = 1, fontStyle: N = "normal", letterSpacing: z = 0, lineHeight: L = "normal", maxWidth: P = 1 / 0, direction: H, textAlign: O = "left", textIndent: D = 0, whiteSpace: j = "normal", overflowWrap: G = "normal", anchorX: q = 0, anchorY: Y = 0, metricsOnly: ae = !1, unicodeFontsURL: F, preResolvedFonts: Q = null, includeCaretPositions: K = !1, chunkedBoundsSize: $ = 8192, colorRanges: ee = null }, I) {
        const Z = x(), oe = {
            fontLoad: 0,
            typesetting: 0
        };
        S.indexOf("\r") > -1 && (console.info("Typesetter: got text with \\r chars; normalizing to \\n"), S = S.replace(/\r\n/g, `
`).replace(/\r/g, `
`)), C = +C, z = +z, P = +P, L = L || "normal", D = +D, l({
            text: S,
            lang: M,
            style: N,
            weight: R,
            fonts: typeof A == "string" ? [
                {
                    src: A
                }
            ] : A,
            unicodeFontsURL: F,
            preResolvedFonts: Q
        }, (ce)=>{
            oe.fontLoad = x() - Z;
            const de = isFinite(P);
            let ue = null, le = null, xe = null, Le = null, Ue = null, Ne = null, ke = null, nt = null, Re = 0, te = 0, Oe = j !== "nowrap";
            const Ie = new Map, Ae = x();
            let ze = D, Ze = 0, be = new v;
            const rt = [
                be
            ];
            ce.forEach((Te)=>{
                const { fontObj: _e } = Te, { ascender: ot, descender: tt, unitsPerEm: gt, lineGap: pt, capHeight: Ge, xHeight: Ye } = _e;
                let at = Ie.get(_e);
                if (!at) {
                    const We = C / gt, Je = L === "normal" ? (ot - tt + pt) * We : L * C, ut = (Je - (ot - tt) * We) / 2, Ke = Math.min(Je, (ot - tt) * We), Ve = (ot + tt) / 2 * We + Ke / 2;
                    at = {
                        index: Ie.size,
                        src: _e.src,
                        fontObj: _e,
                        fontSizeMult: We,
                        unitsPerEm: gt,
                        ascender: ot * We,
                        descender: tt * We,
                        capHeight: Ge * We,
                        xHeight: Ye * We,
                        lineHeight: Je,
                        baseline: -ut - ot * We,
                        caretTop: Ve,
                        caretBottom: Ve - Ke
                    }, Ie.set(_e, at);
                }
                const { fontSizeMult: he } = at, Ee = S.slice(Te.start, Te.end + 1);
                let lt, fe;
                _e.forEachGlyph(Ee, C, z, (We, Je, ut, Ke)=>{
                    Je += Ze, Ke += Te.start, lt = Je, fe = We;
                    const Ve = S.charAt(Ke), ft = We.advanceWidth * he, vt = be.count;
                    let yt;
                    if ("isEmpty" in We || (We.isWhitespace = !!Ve && new RegExp(i).test(Ve), We.canBreakAfter = !!Ve && r.test(Ve), We.isEmpty = We.xMin === We.xMax || We.yMin === We.yMax || n.test(Ve)), !We.isWhitespace && !We.isEmpty && te++, Oe && de && !We.isWhitespace && Je + ft + ze > P && vt) {
                        if (be.glyphAt(vt - 1).glyphObj.canBreakAfter) yt = new v, ze = -Je;
                        else for(let on = vt; on--;)if (on === 0 && G === "break-word") {
                            yt = new v, ze = -Je;
                            break;
                        } else if (be.glyphAt(on).glyphObj.canBreakAfter) {
                            yt = be.splitAt(on + 1);
                            const gn = yt.glyphAt(0).x;
                            ze -= gn;
                            for(let ni = yt.count; ni--;)yt.glyphAt(ni).x -= gn;
                            break;
                        }
                        yt && (be.isSoftWrapped = !0, be = yt, rt.push(be), Re = P);
                    }
                    let Ct = be.glyphAt(be.count);
                    Ct.glyphObj = We, Ct.x = Je + ze, Ct.y = ut, Ct.width = ft, Ct.charIndex = Ke, Ct.fontData = at, Ve === `
` && (be = new v, rt.push(be), ze = -(Je + ft + z * C) + D);
                }), Ze = lt + fe.advanceWidth * he + z * C;
            });
            let ne = 0;
            rt.forEach((Te)=>{
                let _e = !0;
                for(let ot = Te.count; ot--;){
                    const tt = Te.glyphAt(ot);
                    _e && !tt.glyphObj.isWhitespace && (Te.width = tt.x + tt.width, Te.width > Re && (Re = Te.width), _e = !1);
                    let { lineHeight: gt, capHeight: pt, xHeight: Ge, baseline: Ye } = tt.fontData;
                    gt > Te.lineHeight && (Te.lineHeight = gt);
                    const at = Ye - Te.baseline;
                    at < 0 && (Te.baseline += at, Te.cap += at, Te.ex += at), Te.cap = Math.max(Te.cap, Te.baseline + pt), Te.ex = Math.max(Te.ex, Te.baseline + Ge);
                }
                Te.baseline -= ne, Te.cap -= ne, Te.ex -= ne, ne += Te.lineHeight;
            });
            let W = 0, pe = 0;
            if (q && (typeof q == "number" ? W = -q : typeof q == "string" && (W = -Re * (q === "left" ? 0 : q === "center" ? .5 : q === "right" ? 1 : p(q)))), Y && (typeof Y == "number" ? pe = -Y : typeof Y == "string" && (pe = Y === "top" ? 0 : Y === "top-baseline" ? -rt[0].baseline : Y === "top-cap" ? -rt[0].cap : Y === "top-ex" ? -rt[0].ex : Y === "middle" ? ne / 2 : Y === "bottom" ? ne : Y === "bottom-baseline" ? -rt[rt.length - 1].baseline : p(Y) * ne)), !ae) {
                const Te = e.getEmbeddingLevels(S, H);
                ue = new Uint16Array(te), le = new Uint8Array(te), xe = new Float32Array(te * 2), Le = {}, ke = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], nt = [], K && (Ne = new Float32Array(S.length * 4)), ee && (Ue = new Uint8Array(te * 3));
                let _e = 0, ot = -1, tt = -1, gt, pt;
                if (rt.forEach((Ge, Ye)=>{
                    let { count: at, width: he } = Ge;
                    if (at > 0) {
                        let Ee = 0;
                        for(let Ke = at; Ke-- && Ge.glyphAt(Ke).glyphObj.isWhitespace;)Ee++;
                        let lt = 0, fe = 0;
                        if (O === "center") lt = (Re - he) / 2;
                        else if (O === "right") lt = Re - he;
                        else if (O === "justify" && Ge.isSoftWrapped) {
                            let Ke = 0;
                            for(let Ve = at - Ee; Ve--;)Ge.glyphAt(Ve).glyphObj.isWhitespace && Ke++;
                            fe = (Re - he) / Ke;
                        }
                        if (fe || lt) {
                            let Ke = 0;
                            for(let Ve = 0; Ve < at; Ve++){
                                let ft = Ge.glyphAt(Ve);
                                const vt = ft.glyphObj;
                                ft.x += lt + Ke, fe !== 0 && vt.isWhitespace && Ve < at - Ee && (Ke += fe, ft.width += fe);
                            }
                        }
                        const We = e.getReorderSegments(S, Te, Ge.glyphAt(0).charIndex, Ge.glyphAt(Ge.count - 1).charIndex);
                        for(let Ke = 0; Ke < We.length; Ke++){
                            const [Ve, ft] = We[Ke];
                            let vt = 1 / 0, yt = -1 / 0;
                            for(let Ct = 0; Ct < at; Ct++)if (Ge.glyphAt(Ct).charIndex >= Ve) {
                                let on = Ct, gn = Ct;
                                for(; gn < at; gn++){
                                    let ni = Ge.glyphAt(gn);
                                    if (ni.charIndex > ft) break;
                                    gn < at - Ee && (vt = Math.min(vt, ni.x), yt = Math.max(yt, ni.x + ni.width));
                                }
                                for(let ni = on; ni < gn; ni++){
                                    const Gi = Ge.glyphAt(ni);
                                    Gi.x = yt - (Gi.x + Gi.width - vt);
                                }
                                break;
                            }
                        }
                        let Je;
                        const ut = (Ke)=>Je = Ke;
                        for(let Ke = 0; Ke < at; Ke++){
                            const Ve = Ge.glyphAt(Ke);
                            Je = Ve.glyphObj;
                            const ft = Je.index, vt = Te.levels[Ve.charIndex] & 1;
                            if (vt) {
                                const yt = e.getMirroredCharacter(S[Ve.charIndex]);
                                yt && Ve.fontData.fontObj.forEachGlyph(yt, 0, 0, ut);
                            }
                            if (K) {
                                const { charIndex: yt, fontData: Ct } = Ve, on = Ve.x + W, gn = Ve.x + Ve.width + W;
                                Ne[yt * 4] = vt ? gn : on, Ne[yt * 4 + 1] = vt ? on : gn, Ne[yt * 4 + 2] = Ge.baseline + Ct.caretBottom + pe, Ne[yt * 4 + 3] = Ge.baseline + Ct.caretTop + pe;
                                const ni = yt - ot;
                                ni > 1 && m(Ne, ot, ni), ot = yt;
                            }
                            if (ee) {
                                const { charIndex: yt } = Ve;
                                for(; yt > tt;)tt++, ee.hasOwnProperty(tt) && (pt = ee[tt]);
                            }
                            if (!Je.isWhitespace && !Je.isEmpty) {
                                const yt = _e++, { fontSizeMult: Ct, src: on, index: gn } = Ve.fontData, ni = Le[on] || (Le[on] = {});
                                ni[ft] || (ni[ft] = {
                                    path: Je.path,
                                    pathBounds: [
                                        Je.xMin,
                                        Je.yMin,
                                        Je.xMax,
                                        Je.yMax
                                    ]
                                });
                                const Gi = Ve.x + W, da = Ve.y + Ge.baseline + pe;
                                xe[yt * 2] = Gi, xe[yt * 2 + 1] = da;
                                const jn = Gi + Je.xMin * Ct, ea = da + Je.yMin * Ct, Pi = Gi + Je.xMax * Ct, hi = da + Je.yMax * Ct;
                                jn < ke[0] && (ke[0] = jn), ea < ke[1] && (ke[1] = ea), Pi > ke[2] && (ke[2] = Pi), hi > ke[3] && (ke[3] = hi), yt % $ === 0 && (gt = {
                                    start: yt,
                                    end: yt,
                                    rect: [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                }, nt.push(gt)), gt.end++;
                                const Nn = gt.rect;
                                if (jn < Nn[0] && (Nn[0] = jn), ea < Nn[1] && (Nn[1] = ea), Pi > Nn[2] && (Nn[2] = Pi), hi > Nn[3] && (Nn[3] = hi), ue[yt] = ft, le[yt] = gn, ee) {
                                    const jt = yt * 3;
                                    Ue[jt] = pt >> 16 & 255, Ue[jt + 1] = pt >> 8 & 255, Ue[jt + 2] = pt & 255;
                                }
                            }
                        }
                    }
                }), Ne) {
                    const Ge = S.length - ot;
                    Ge > 1 && m(Ne, ot, Ge);
                }
            }
            const Be = [];
            Ie.forEach(({ index: Te, src: _e, unitsPerEm: ot, ascender: tt, descender: gt, lineHeight: pt, capHeight: Ge, xHeight: Ye })=>{
                Be[Te] = {
                    src: _e,
                    unitsPerEm: ot,
                    ascender: tt,
                    descender: gt,
                    lineHeight: pt,
                    capHeight: Ge,
                    xHeight: Ye
                };
            }), oe.typesetting = x() - Ae, I({
                glyphIds: ue,
                glyphFontIndices: le,
                glyphPositions: xe,
                glyphData: Le,
                fontData: Be,
                caretPositions: Ne,
                glyphColors: Ue,
                chunkedBounds: nt,
                fontSize: C,
                topBaseline: pe + rt[0].baseline,
                blockBounds: [
                    W,
                    pe - ne,
                    W + Re,
                    pe
                ],
                visibleBounds: ke,
                timings: oe
            });
        });
    }
    function f(S, A) {
        c({
            ...S,
            metricsOnly: !0
        }, (M)=>{
            const [b, C, R, N] = M.blockBounds;
            A({
                width: R - b,
                height: N - C
            });
        });
    }
    function p(S) {
        let A = S.match(/^([\d.]+)%$/), M = A ? parseFloat(A[1]) : NaN;
        return isNaN(M) ? 0 : M / 100;
    }
    function m(S, A, M) {
        const b = S[A * 4], C = S[A * 4 + 1], R = S[A * 4 + 2], N = S[A * 4 + 3], z = (C - b) / M;
        for(let L = 0; L < M; L++){
            const P = (A + L) * 4;
            S[P] = b + z * L, S[P + 1] = b + z * (L + 1), S[P + 2] = R, S[P + 3] = N;
        }
    }
    function x() {
        return (self.performance || Date).now();
    }
    function v() {
        this.data = [];
    }
    const _ = [
        "glyphObj",
        "x",
        "y",
        "width",
        "charIndex",
        "fontData"
    ];
    return v.prototype = {
        width: 0,
        lineHeight: 0,
        baseline: 0,
        cap: 0,
        ex: 0,
        isSoftWrapped: !1,
        get count () {
            return Math.ceil(this.data.length / _.length);
        },
        glyphAt (S) {
            let A = v.flyweight;
            return A.data = this.data, A.index = S, A;
        },
        splitAt (S) {
            let A = new v;
            return A.data = this.data.splice(S * _.length), A;
        }
    }, v.flyweight = _.reduce((S, A, M, b)=>(Object.defineProperty(S, A, {
            get () {
                return this.data[this.index * _.length + M];
            },
            set (C) {
                this.data[this.index * _.length + M] = C;
            }
        }), S), {
        data: null,
        index: 0
    }), {
        typeset: c,
        measure: f
    };
}
const $455d545b1dff00eb$var$Gf = ()=>(self.performance || Date).now(), $455d545b1dff00eb$var$Hy = $455d545b1dff00eb$var$JA();
let $455d545b1dff00eb$var$X3;
function $455d545b1dff00eb$var$kI(a, e, t, n, i, r, l, c, f, p, m = !0) {
    return m ? $455d545b1dff00eb$var$XI(a, e, t, n, i, r, l, c, f, p).then(null, (x)=>($455d545b1dff00eb$var$X3 || (console.warn("WebGL SDF generation failed, falling back to JS", x), $455d545b1dff00eb$var$X3 = !0), $455d545b1dff00eb$var$q3(a, e, t, n, i, r, l, c, f, p))) : $455d545b1dff00eb$var$q3(a, e, t, n, i, r, l, c, f, p);
}
const $455d545b1dff00eb$var$Jx = [], $455d545b1dff00eb$var$jI = 5;
let $455d545b1dff00eb$var$yb = 0;
function $455d545b1dff00eb$var$ew() {
    const a = $455d545b1dff00eb$var$Gf();
    for(; $455d545b1dff00eb$var$Jx.length && $455d545b1dff00eb$var$Gf() - a < $455d545b1dff00eb$var$jI;)$455d545b1dff00eb$var$Jx.shift()();
    $455d545b1dff00eb$var$yb = $455d545b1dff00eb$var$Jx.length ? setTimeout($455d545b1dff00eb$var$ew, 0) : 0;
}
const $455d545b1dff00eb$var$XI = (...a)=>new Promise((e, t)=>{
        $455d545b1dff00eb$var$Jx.push(()=>{
            const n = $455d545b1dff00eb$var$Gf();
            try {
                $455d545b1dff00eb$var$Hy.webgl.generateIntoCanvas(...a), e({
                    timing: $455d545b1dff00eb$var$Gf() - n
                });
            } catch (i) {
                t(i);
            }
        }), $455d545b1dff00eb$var$yb || ($455d545b1dff00eb$var$yb = setTimeout($455d545b1dff00eb$var$ew, 0));
    }), $455d545b1dff00eb$var$WI = 4, $455d545b1dff00eb$var$qI = 2e3, $455d545b1dff00eb$var$W3 = {};
let $455d545b1dff00eb$var$YI = 0;
function $455d545b1dff00eb$var$q3(a, e, t, n, i, r, l, c, f, p) {
    const m = "TroikaTextSDFGenerator_JS_" + $455d545b1dff00eb$var$YI++ % $455d545b1dff00eb$var$WI;
    let x = $455d545b1dff00eb$var$W3[m];
    return x || (x = $455d545b1dff00eb$var$W3[m] = {
        workerModule: $455d545b1dff00eb$var$Qd({
            name: m,
            workerId: m,
            dependencies: [
                $455d545b1dff00eb$var$JA,
                $455d545b1dff00eb$var$Gf
            ],
            init (v, _) {
                const S = v().javascript.generate;
                return function(...A) {
                    const M = _();
                    return {
                        textureData: S(...A),
                        timing: _() - M
                    };
                };
            },
            getTransferables (v) {
                return [
                    v.textureData.buffer
                ];
            }
        }),
        requests: 0,
        idleTimer: null
    }), x.requests++, clearTimeout(x.idleTimer), x.workerModule(a, e, t, n, i, r).then(({ textureData: v, timing: _ })=>{
        const S = $455d545b1dff00eb$var$Gf(), A = new Uint8Array(v.length * 4);
        for(let M = 0; M < v.length; M++)A[M * 4 + p] = v[M];
        return $455d545b1dff00eb$var$Hy.webglUtils.renderImageData(l, A, c, f, a, e, 1 << 3 - p), _ += $455d545b1dff00eb$var$Gf() - S, --x.requests === 0 && (x.idleTimer = setTimeout(()=>{
            $455d545b1dff00eb$var$TI(m);
        }, $455d545b1dff00eb$var$qI)), {
            timing: _
        };
    });
}
function $455d545b1dff00eb$var$ZI(a) {
    a._warm || ($455d545b1dff00eb$var$Hy.webgl.isSupported(a), a._warm = !0);
}
const $455d545b1dff00eb$var$QI = $455d545b1dff00eb$var$Hy.webglUtils.resizeWebGLCanvasWithoutClearing, $455d545b1dff00eb$var$Bm = {
    unicodeFontsURL: null,
    sdfGlyphSize: 64,
    sdfMargin: 1 / 16,
    sdfExponent: 9,
    textureWidth: 2048
}, $455d545b1dff00eb$var$KI = new $455d545b1dff00eb$var$_t;
function $455d545b1dff00eb$var$Td() {
    return (self.performance || Date).now();
}
const $455d545b1dff00eb$var$Y3 = Object.create(null);
function $455d545b1dff00eb$var$tw(a1, e) {
    a1 = $455d545b1dff00eb$var$e6({}, a1);
    const t = $455d545b1dff00eb$var$Td(), n = [];
    if (a1.font && n.push({
        label: "user",
        src: $455d545b1dff00eb$var$t6(a1.font)
    }), a1.font = n, a1.text = "" + a1.text, a1.sdfGlyphSize = a1.sdfGlyphSize || $455d545b1dff00eb$var$Bm.sdfGlyphSize, a1.unicodeFontsURL = a1.unicodeFontsURL || $455d545b1dff00eb$var$Bm.unicodeFontsURL, a1.colorRanges != null) {
        let v = {};
        for(let _ in a1.colorRanges)if (a1.colorRanges.hasOwnProperty(_)) {
            let S = a1.colorRanges[_];
            typeof S != "number" && (S = $455d545b1dff00eb$var$KI.set(S).getHex()), v[_] = S;
        }
        a1.colorRanges = v;
    }
    Object.freeze(a1);
    const { textureWidth: i, sdfExponent: r } = $455d545b1dff00eb$var$Bm, { sdfGlyphSize: l } = a1, c = i / l * 4;
    let f = $455d545b1dff00eb$var$Y3[l];
    if (!f) {
        const v = document.createElement("canvas");
        v.width = i, v.height = l * 256 / c, f = $455d545b1dff00eb$var$Y3[l] = {
            glyphCount: 0,
            sdfGlyphSize: l,
            sdfCanvas: v,
            sdfTexture: new $455d545b1dff00eb$var$Li(v, void 0, void 0, void 0, $455d545b1dff00eb$var$mi, $455d545b1dff00eb$var$mi),
            contextLost: !1,
            glyphsByFont: new Map
        }, f.sdfTexture.generateMipmaps = !1, $455d545b1dff00eb$var$JI(f);
    }
    const { sdfTexture: p, sdfCanvas: m } = f;
    $455d545b1dff00eb$var$aw(a1).then((v)=>{
        const { glyphIds: _, glyphFontIndices: S, fontData: A, glyphPositions: M, fontSize: b, timings: C } = v, R = [], N = new Float32Array(_.length * 4);
        let z = 0, L = 0;
        const P = $455d545b1dff00eb$var$Td(), H = A.map((q)=>{
            let Y = f.glyphsByFont.get(q.src);
            return Y || f.glyphsByFont.set(q.src, Y = new Map), Y;
        });
        _.forEach((q, Y)=>{
            const ae = S[Y], { src: F, unitsPerEm: Q } = A[ae];
            let K = H[ae].get(q);
            if (!K) {
                const { path: oe, pathBounds: ce } = v.glyphData[F][q], de = Math.max(ce[2] - ce[0], ce[3] - ce[1]) / l * ($455d545b1dff00eb$var$Bm.sdfMargin * l + .5), ue = f.glyphCount++, le = [
                    ce[0] - de,
                    ce[1] - de,
                    ce[2] + de,
                    ce[3] + de
                ];
                H[ae].set(q, K = {
                    path: oe,
                    atlasIndex: ue,
                    sdfViewBox: le
                }), R.push(K);
            }
            const { sdfViewBox: $ } = K, ee = M[L++], I = M[L++], Z = b / Q;
            N[z++] = ee + $[0] * Z, N[z++] = I + $[1] * Z, N[z++] = ee + $[2] * Z, N[z++] = I + $[3] * Z, _[Y] = K.atlasIndex;
        }), C.quads = (C.quads || 0) + ($455d545b1dff00eb$var$Td() - P);
        const O = $455d545b1dff00eb$var$Td();
        C.sdf = {};
        const D = m.height, j = Math.ceil(f.glyphCount / c), G = Math.pow(2, Math.ceil(Math.log2(j * l)));
        G > D && (console.info(`Increasing SDF texture size ${D}->${G}`), $455d545b1dff00eb$var$QI(m, i, G), p.dispose()), Promise.all(R.map((q)=>$455d545b1dff00eb$var$nw(q, f, a1.gpuAccelerateSDF).then(({ timing: Y })=>{
                C.sdf[q.atlasIndex] = Y;
            }))).then(()=>{
            R.length && !f.contextLost && ($455d545b1dff00eb$var$iw(f), p.needsUpdate = !0), C.sdfTotal = $455d545b1dff00eb$var$Td() - O, C.total = $455d545b1dff00eb$var$Td() - t, e(Object.freeze({
                parameters: a1,
                sdfTexture: p,
                sdfGlyphSize: l,
                sdfExponent: r,
                glyphBounds: N,
                glyphAtlasIndices: _,
                glyphColors: v.glyphColors,
                caretPositions: v.caretPositions,
                chunkedBounds: v.chunkedBounds,
                ascender: v.ascender,
                descender: v.descender,
                lineHeight: v.lineHeight,
                capHeight: v.capHeight,
                xHeight: v.xHeight,
                topBaseline: v.topBaseline,
                blockBounds: v.blockBounds,
                visibleBounds: v.visibleBounds,
                timings: v.timings
            }));
        });
    }), Promise.resolve().then(function() {
        return import(a.module);
    }).then((res)=>{
        f.contextLost || $455d545b1dff00eb$var$ZI(m);
    });
}
function $455d545b1dff00eb$var$nw({ path: a, atlasIndex: e, sdfViewBox: t }, { sdfGlyphSize: n, sdfCanvas: i, contextLost: r }, l) {
    if (r) return Promise.resolve({
        timing: -1
    });
    const { textureWidth: c, sdfExponent: f } = $455d545b1dff00eb$var$Bm, p = Math.max(t[2] - t[0], t[3] - t[1]), m = Math.floor(e / 4), x = m % (c / n) * n, v = Math.floor(m / (c / n)) * n, _ = e % 4;
    return $455d545b1dff00eb$var$kI(n, n, a, t, p, f, i, x, v, _, l);
}
function $455d545b1dff00eb$var$JI(a) {
    const e = a.sdfCanvas;
    e.addEventListener("webglcontextlost", (t)=>{
        console.log("Context Lost", t), t.preventDefault(), a.contextLost = !0;
    }), e.addEventListener("webglcontextrestored", (t)=>{
        console.log("Context Restored", t), a.contextLost = !1;
        const n = [];
        a.glyphsByFont.forEach((i)=>{
            i.forEach((r)=>{
                n.push($455d545b1dff00eb$var$nw(r, a, !0));
            });
        }), Promise.all(n).then(()=>{
            $455d545b1dff00eb$var$iw(a), a.sdfTexture.needsUpdate = !0;
        });
    });
}
function $455d545b1dff00eb$var$$I({ font: a, characters: e, sdfGlyphSize: t }, n) {
    let i = Array.isArray(e) ? e.join(`
`) : "" + e;
    $455d545b1dff00eb$var$tw({
        font: a,
        sdfGlyphSize: t,
        text: i
    }, n);
}
function $455d545b1dff00eb$var$e6(a, e) {
    for(let t in e)e.hasOwnProperty(t) && (a[t] = e[t]);
    return a;
}
let $455d545b1dff00eb$var$Vx;
function $455d545b1dff00eb$var$t6(a) {
    return $455d545b1dff00eb$var$Vx || ($455d545b1dff00eb$var$Vx = typeof document > "u" ? {} : document.createElement("a")), $455d545b1dff00eb$var$Vx.href = a, $455d545b1dff00eb$var$Vx.href;
}
function $455d545b1dff00eb$var$iw(a) {
    if (typeof createImageBitmap != "function") {
        console.info("Safari<15: applying SDF canvas workaround");
        const { sdfCanvas: e, sdfTexture: t } = a, { width: n, height: i } = e, r = a.sdfCanvas.getContext("webgl");
        let l = t.image.data;
        (!l || l.length !== n * i * 4) && (l = new Uint8Array(n * i * 4), t.image = {
            width: n,
            height: i,
            data: l
        }, t.flipY = !1, t.isDataTexture = !0), r.readPixels(0, 0, n, i, r.RGBA, r.UNSIGNED_BYTE, l);
    }
}
const $455d545b1dff00eb$var$n6 = $455d545b1dff00eb$var$Qd({
    name: "Typesetter",
    dependencies: [
        $455d545b1dff00eb$var$GI,
        $455d545b1dff00eb$var$VI,
        $455d545b1dff00eb$var$wI
    ],
    init (a, e, t) {
        return a(e, t());
    }
}), $455d545b1dff00eb$var$aw = $455d545b1dff00eb$var$Qd({
    name: "Typesetter",
    dependencies: [
        $455d545b1dff00eb$var$n6
    ],
    init (a) {
        return function(e) {
            return new Promise((t)=>{
                a.typeset(e, t);
            });
        };
    },
    getTransferables (a) {
        const e = [];
        for(let t in a)a[t] && a[t].buffer && e.push(a[t].buffer);
        return e;
    }
});
$455d545b1dff00eb$var$aw.onMainThread;
const $455d545b1dff00eb$var$Z3 = {};
function $455d545b1dff00eb$var$i6(a) {
    let e = $455d545b1dff00eb$var$Z3[a];
    return e || (e = $455d545b1dff00eb$var$Z3[a] = new $455d545b1dff00eb$var$Jr(1, 1, a, a).translate(.5, .5, 0)), e;
}
const $455d545b1dff00eb$var$a6 = "aTroikaGlyphBounds", $455d545b1dff00eb$var$Q3 = "aTroikaGlyphIndex", $455d545b1dff00eb$var$r6 = "aTroikaGlyphColor";
class $455d545b1dff00eb$var$s6 extends $455d545b1dff00eb$var$oS {
    constructor(){
        super(), this.detail = 1, this.curveRadius = 0, this.groups = [
            {
                start: 0,
                count: 1 / 0,
                materialIndex: 0
            },
            {
                start: 0,
                count: 1 / 0,
                materialIndex: 1
            }
        ], this.boundingSphere = new $455d545b1dff00eb$var$Ta, this.boundingBox = new $455d545b1dff00eb$var$ca;
    }
    computeBoundingSphere() {}
    computeBoundingBox() {}
    set detail(e) {
        if (e !== this._detail) {
            this._detail = e, (typeof e != "number" || e < 1) && (e = 1);
            let t = $455d545b1dff00eb$var$i6(e);
            [
                "position",
                "normal",
                "uv"
            ].forEach((n)=>{
                this.attributes[n] = t.attributes[n].clone();
            }), this.setIndex(t.getIndex().clone());
        }
    }
    get detail() {
        return this._detail;
    }
    set curveRadius(e) {
        e !== this._curveRadius && (this._curveRadius = e, this._updateBounds());
    }
    get curveRadius() {
        return this._curveRadius;
    }
    updateGlyphs(e, t, n, i, r) {
        this.updateAttributeData($455d545b1dff00eb$var$a6, e, 4), this.updateAttributeData($455d545b1dff00eb$var$Q3, t, 1), this.updateAttributeData($455d545b1dff00eb$var$r6, r, 3), this._blockBounds = n, this._chunkedBounds = i, this.instanceCount = t.length, this._updateBounds();
    }
    _updateBounds() {
        const e = this._blockBounds;
        if (e) {
            const { curveRadius: t, boundingBox: n } = this;
            if (t) {
                const { PI: i, floor: r, min: l, max: c, sin: f, cos: p } = Math, m = i / 2, x = i * 2, v = Math.abs(t), _ = e[0] / v, S = e[2] / v, A = r((_ + m) / x) !== r((S + m) / x) ? -v : l(f(_) * v, f(S) * v), M = r((_ - m) / x) !== r((S - m) / x) ? v : c(f(_) * v, f(S) * v), b = r((_ + i) / x) !== r((S + i) / x) ? v * 2 : c(v - p(_) * v, v - p(S) * v);
                n.min.set(A, e[1], t < 0 ? -b : 0), n.max.set(M, e[3], t < 0 ? 0 : b);
            } else n.min.set(e[0], e[1], 0), n.max.set(e[2], e[3], 0);
            n.getBoundingSphere(this.boundingSphere);
        }
    }
    applyClipRect(e) {
        let t = this.getAttribute($455d545b1dff00eb$var$Q3).count, n = this._chunkedBounds;
        if (n) for(let i = n.length; i--;){
            t = n[i].end;
            let r = n[i].rect;
            if (r[1] < e.w && r[3] > e.y && r[0] < e.z && r[2] > e.x) break;
        }
        this.instanceCount = t;
    }
    updateAttributeData(e, t, n) {
        const i = this.getAttribute(e);
        t ? i && i.array.length === t.length ? (i.array.set(t), i.needsUpdate = !0) : (this.setAttribute(e, new $455d545b1dff00eb$var$Wf(t, n)), delete this._maxInstanceCount, this.dispose()) : i && this.deleteAttribute(e);
    }
}
const $455d545b1dff00eb$var$o6 = `
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform vec4 uTroikaTotalBounds;
uniform vec4 uTroikaClipRect;
uniform mat3 uTroikaOrient;
uniform bool uTroikaUseGlyphColors;
uniform float uTroikaEdgeOffset;
uniform float uTroikaBlurRadius;
uniform vec2 uTroikaPositionOffset;
uniform float uTroikaCurveRadius;
attribute vec4 aTroikaGlyphBounds;
attribute float aTroikaGlyphIndex;
attribute vec3 aTroikaGlyphColor;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec3 vTroikaGlyphColor;
varying vec2 vTroikaGlyphDimensions;
`, $455d545b1dff00eb$var$l6 = `
vec4 bounds = aTroikaGlyphBounds;
bounds.xz += uTroikaPositionOffset.x;
bounds.yw -= uTroikaPositionOffset.y;

vec4 outlineBounds = vec4(
  bounds.xy - uTroikaEdgeOffset - uTroikaBlurRadius,
  bounds.zw + uTroikaEdgeOffset + uTroikaBlurRadius
);
vec4 clippedBounds = vec4(
  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),
  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)
);

vec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);

position.xy = mix(bounds.xy, bounds.zw, clippedXY);

uv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);

float rad = uTroikaCurveRadius;
if (rad != 0.0) {
  float angle = position.x / rad;
  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);
  normal.xz = vec2(sin(angle), cos(angle));
}
  
position = uTroikaOrient * position;
normal = uTroikaOrient * normal;

vTroikaGlyphUV = clippedXY.xy;
vTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);


float txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;
vec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;
vec2 txStartUV = txUvPerSquare * vec2(
  mod(floor(aTroikaGlyphIndex / 4.0), txCols),
  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)
);
vTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);
vTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);
`, $455d545b1dff00eb$var$c6 = `
uniform sampler2D uTroikaSDFTexture;
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform float uTroikaSDFExponent;
uniform float uTroikaEdgeOffset;
uniform float uTroikaFillOpacity;
uniform float uTroikaBlurRadius;
uniform vec3 uTroikaStrokeColor;
uniform float uTroikaStrokeWidth;
uniform float uTroikaStrokeOpacity;
uniform bool uTroikaSDFDebug;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec2 vTroikaGlyphDimensions;

float troikaSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  
  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float troikaGlyphUvToSdfValue(vec2 glyphUV) {
  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);
  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);
  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1
  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;
}

float troikaGlyphUvToDistance(vec2 uv) {
  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));
}

float troikaGetAADist() {
  
  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300
  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;
  #else
  return vTroikaGlyphDimensions.x / 64.0;
  #endif
}

float troikaGetFragDistValue() {
  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);
  float distance = troikaGlyphUvToDistance(clampedGlyphUV);
 
  // Extrapolate distance when outside bounds:
  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : 
    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);

  

  return distance;
}

float troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)
  float alpha = step(-distanceOffset, -distance);
  #else

  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );
  #endif

  return alpha;
}
`, $455d545b1dff00eb$var$u6 = `
float aaDist = troikaGetAADist();
float fragDistance = troikaGetFragDistValue();
float edgeAlpha = uTroikaSDFDebug ?
  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :
  troikaGetEdgeAlpha(fragDistance, uTroikaEdgeOffset, max(aaDist, uTroikaBlurRadius));

#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)
vec4 fillRGBA = gl_FragColor;
fillRGBA.a *= uTroikaFillOpacity;
vec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);
if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;
gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
  -uTroikaStrokeWidth - aaDist,
  -uTroikaStrokeWidth + aaDist,
  fragDistance
));
gl_FragColor.a *= edgeAlpha;
#endif

if (edgeAlpha == 0.0) {
  discard;
}
`;
function $455d545b1dff00eb$var$f6(a) {
    const e = $455d545b1dff00eb$var$vb(a, {
        chained: !0,
        extensions: {
            derivatives: !0
        },
        uniforms: {
            uTroikaSDFTexture: {
                value: null
            },
            uTroikaSDFTextureSize: {
                value: new $455d545b1dff00eb$var$$e
            },
            uTroikaSDFGlyphSize: {
                value: 0
            },
            uTroikaSDFExponent: {
                value: 0
            },
            uTroikaTotalBounds: {
                value: new $455d545b1dff00eb$var$Un(0, 0, 0, 0)
            },
            uTroikaClipRect: {
                value: new $455d545b1dff00eb$var$Un(0, 0, 0, 0)
            },
            uTroikaEdgeOffset: {
                value: 0
            },
            uTroikaFillOpacity: {
                value: 1
            },
            uTroikaPositionOffset: {
                value: new $455d545b1dff00eb$var$$e
            },
            uTroikaCurveRadius: {
                value: 0
            },
            uTroikaBlurRadius: {
                value: 0
            },
            uTroikaStrokeWidth: {
                value: 0
            },
            uTroikaStrokeColor: {
                value: new $455d545b1dff00eb$var$_t
            },
            uTroikaStrokeOpacity: {
                value: 1
            },
            uTroikaOrient: {
                value: new $455d545b1dff00eb$var$Jt
            },
            uTroikaUseGlyphColors: {
                value: !0
            },
            uTroikaSDFDebug: {
                value: !1
            }
        },
        vertexDefs: $455d545b1dff00eb$var$o6,
        vertexTransform: $455d545b1dff00eb$var$l6,
        fragmentDefs: $455d545b1dff00eb$var$c6,
        fragmentColorTransform: $455d545b1dff00eb$var$u6,
        customRewriter ({ vertexShader: t, fragmentShader: n }) {
            let i = /\buniform\s+vec3\s+diffuse\b/;
            return i.test(n) && (n = n.replace(i, "varying vec3 vTroikaGlyphColor").replace(/\bdiffuse\b/g, "vTroikaGlyphColor"), i.test(t) || (t = t.replace($455d545b1dff00eb$var$$A, `uniform vec3 diffuse;
$&
vTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;
`))), {
                vertexShader: t,
                fragmentShader: n
            };
        }
    });
    return e.transparent = !0, e.forceSinglePass = !0, Object.defineProperties(e, {
        isTroikaTextMaterial: {
            value: !0
        },
        shadowSide: {
            get () {
                return this.side;
            },
            set () {}
        }
    }), e;
}
const $455d545b1dff00eb$var$MS = new $455d545b1dff00eb$var$Ac({
    color: 16777215,
    side: $455d545b1dff00eb$var$Ea,
    transparent: !0
}), $455d545b1dff00eb$var$K3 = 8421504, $455d545b1dff00eb$var$J3 = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$Gx = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$F_ = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Nm = [], $455d545b1dff00eb$var$h6 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$H_ = "+x+y";
function $455d545b1dff00eb$var$$3(a) {
    return Array.isArray(a) ? a[0] : a;
}
let $455d545b1dff00eb$var$rw = ()=>{
    const a = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Jr(1, 1), $455d545b1dff00eb$var$MS);
    return $455d545b1dff00eb$var$rw = ()=>a, a;
}, $455d545b1dff00eb$var$sw = ()=>{
    const a = new $455d545b1dff00eb$var$zi(new $455d545b1dff00eb$var$Jr(1, 1, 32, 1), $455d545b1dff00eb$var$MS);
    return $455d545b1dff00eb$var$sw = ()=>a, a;
};
const $455d545b1dff00eb$var$d6 = {
    type: "syncstart"
}, $455d545b1dff00eb$var$p6 = {
    type: "synccomplete"
}, $455d545b1dff00eb$var$ow = [
    "font",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "lang",
    "letterSpacing",
    "lineHeight",
    "maxWidth",
    "overflowWrap",
    "text",
    "direction",
    "textAlign",
    "textIndent",
    "whiteSpace",
    "anchorX",
    "anchorY",
    "colorRanges",
    "sdfGlyphSize"
], $455d545b1dff00eb$var$m6 = $455d545b1dff00eb$var$ow.concat("material", "color", "depthOffset", "clipRect", "curveRadius", "orientation", "glyphGeometryDetail");
let $455d545b1dff00eb$var$lw = class extends $455d545b1dff00eb$var$zi {
    constructor(){
        const e = new $455d545b1dff00eb$var$s6;
        super(e, null), this.text = "", this.anchorX = 0, this.anchorY = 0, this.curveRadius = 0, this.direction = "auto", this.font = null, this.unicodeFontsURL = null, this.fontSize = .1, this.fontWeight = "normal", this.fontStyle = "normal", this.lang = null, this.letterSpacing = 0, this.lineHeight = "normal", this.maxWidth = 1 / 0, this.overflowWrap = "normal", this.textAlign = "left", this.textIndent = 0, this.whiteSpace = "normal", this.material = null, this.color = null, this.colorRanges = null, this.outlineWidth = 0, this.outlineColor = 0, this.outlineOpacity = 1, this.outlineBlur = 0, this.outlineOffsetX = 0, this.outlineOffsetY = 0, this.strokeWidth = 0, this.strokeColor = $455d545b1dff00eb$var$K3, this.strokeOpacity = 1, this.fillOpacity = 1, this.depthOffset = 0, this.clipRect = null, this.orientation = $455d545b1dff00eb$var$H_, this.glyphGeometryDetail = 1, this.sdfGlyphSize = null, this.gpuAccelerateSDF = !0, this.debugSDF = !1;
    }
    sync(e) {
        this._needsSync && (this._needsSync = !1, this._isSyncing ? (this._queuedSyncs || (this._queuedSyncs = [])).push(e) : (this._isSyncing = !0, this.dispatchEvent($455d545b1dff00eb$var$d6), $455d545b1dff00eb$var$tw({
            text: this.text,
            font: this.font,
            lang: this.lang,
            fontSize: this.fontSize || .1,
            fontWeight: this.fontWeight || "normal",
            fontStyle: this.fontStyle || "normal",
            letterSpacing: this.letterSpacing || 0,
            lineHeight: this.lineHeight || "normal",
            maxWidth: this.maxWidth,
            direction: this.direction || "auto",
            textAlign: this.textAlign,
            textIndent: this.textIndent,
            whiteSpace: this.whiteSpace,
            overflowWrap: this.overflowWrap,
            anchorX: this.anchorX,
            anchorY: this.anchorY,
            colorRanges: this.colorRanges,
            includeCaretPositions: !0,
            sdfGlyphSize: this.sdfGlyphSize,
            gpuAccelerateSDF: this.gpuAccelerateSDF,
            unicodeFontsURL: this.unicodeFontsURL
        }, (t)=>{
            this._isSyncing = !1, this._textRenderInfo = t, this.geometry.updateGlyphs(t.glyphBounds, t.glyphAtlasIndices, t.blockBounds, t.chunkedBounds, t.glyphColors);
            const n = this._queuedSyncs;
            n && (this._queuedSyncs = null, this._needsSync = !0, this.sync(()=>{
                n.forEach((i)=>i && i());
            })), this.dispatchEvent($455d545b1dff00eb$var$p6), e && e();
        })));
    }
    onBeforeRender(e, t, n, i, r, l) {
        this.sync(), r.isTroikaTextMaterial && this._prepareForRender(r);
    }
    dispose() {
        this.geometry.dispose();
    }
    get textRenderInfo() {
        return this._textRenderInfo || null;
    }
    createDerivedMaterial(e) {
        return $455d545b1dff00eb$var$f6(e);
    }
    get material() {
        let e = this._derivedMaterial;
        const t = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $455d545b1dff00eb$var$MS.clone());
        if ((!e || !e.isDerivedFrom(t)) && (e = this._derivedMaterial = this.createDerivedMaterial(t), t.addEventListener("dispose", function n() {
            t.removeEventListener("dispose", n), e.dispose();
        })), this.hasOutline()) {
            let n = e._outlineMtl;
            return n || (n = e._outlineMtl = Object.create(e, {
                id: {
                    value: e.id + .1
                }
            }), n.isTextOutlineMaterial = !0, n.depthWrite = !1, n.map = null, e.addEventListener("dispose", function i() {
                e.removeEventListener("dispose", i), n.dispose();
            })), [
                n,
                e
            ];
        } else return e;
    }
    set material(e) {
        e && e.isTroikaTextMaterial ? (this._derivedMaterial = e, this._baseMaterial = e.baseMaterial) : this._baseMaterial = e;
    }
    hasOutline() {
        return !!(this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY);
    }
    get glyphGeometryDetail() {
        return this.geometry.detail;
    }
    set glyphGeometryDetail(e) {
        this.geometry.detail = e;
    }
    get curveRadius() {
        return this.geometry.curveRadius;
    }
    set curveRadius(e) {
        this.geometry.curveRadius = e;
    }
    get customDepthMaterial() {
        return $455d545b1dff00eb$var$$3(this.material).getDepthMaterial();
    }
    set customDepthMaterial(e) {}
    get customDistanceMaterial() {
        return $455d545b1dff00eb$var$$3(this.material).getDistanceMaterial();
    }
    set customDistanceMaterial(e) {}
    _prepareForRender(e) {
        const t = e.isTextOutlineMaterial, n = e.uniforms, i = this.textRenderInfo;
        if (i) {
            const { sdfTexture: c, blockBounds: f } = i;
            n.uTroikaSDFTexture.value = c, n.uTroikaSDFTextureSize.value.set(c.image.width, c.image.height), n.uTroikaSDFGlyphSize.value = i.sdfGlyphSize, n.uTroikaSDFExponent.value = i.sdfExponent, n.uTroikaTotalBounds.value.fromArray(f), n.uTroikaUseGlyphColors.value = !t && !!i.glyphColors;
            let p = 0, m = 0, x = 0, v, _, S, A = 0, M = 0;
            if (t) {
                let { outlineWidth: C, outlineOffsetX: R, outlineOffsetY: N, outlineBlur: z, outlineOpacity: L } = this;
                p = this._parsePercent(C) || 0, m = Math.max(0, this._parsePercent(z) || 0), v = L, A = this._parsePercent(R) || 0, M = this._parsePercent(N) || 0;
            } else x = Math.max(0, this._parsePercent(this.strokeWidth) || 0), x && (S = this.strokeColor, n.uTroikaStrokeColor.value.set(S ?? $455d545b1dff00eb$var$K3), _ = this.strokeOpacity, _ == null && (_ = 1)), v = this.fillOpacity;
            n.uTroikaEdgeOffset.value = p, n.uTroikaPositionOffset.value.set(A, M), n.uTroikaBlurRadius.value = m, n.uTroikaStrokeWidth.value = x, n.uTroikaStrokeOpacity.value = _, n.uTroikaFillOpacity.value = v ?? 1, n.uTroikaCurveRadius.value = this.curveRadius || 0;
            let b = this.clipRect;
            if (b && Array.isArray(b) && b.length === 4) n.uTroikaClipRect.value.fromArray(b);
            else {
                const C = (this.fontSize || .1) * 100;
                n.uTroikaClipRect.value.set(f[0] - C, f[1] - C, f[2] + C, f[3] + C);
            }
            this.geometry.applyClipRect(n.uTroikaClipRect.value);
        }
        n.uTroikaSDFDebug.value = !!this.debugSDF, e.polygonOffset = !!this.depthOffset, e.polygonOffsetFactor = e.polygonOffsetUnits = this.depthOffset || 0;
        const r = t ? this.outlineColor || 0 : this.color;
        if (r == null) delete e.color;
        else {
            const c = e.hasOwnProperty("color") ? e.color : e.color = new $455d545b1dff00eb$var$_t;
            (r !== c._input || typeof r == "object") && c.set(c._input = r);
        }
        let l = this.orientation || $455d545b1dff00eb$var$H_;
        if (l !== e._orientation) {
            let c = n.uTroikaOrient.value;
            l = l.replace(/[^-+xyz]/g, "");
            let f = l !== $455d545b1dff00eb$var$H_ && l.match(/^([-+])([xyz])([-+])([xyz])$/);
            if (f) {
                let [, p, m, x, v] = f;
                $455d545b1dff00eb$var$Gx.set(0, 0, 0)[m] = p === "-" ? 1 : -1, $455d545b1dff00eb$var$F_.set(0, 0, 0)[v] = x === "-" ? -1 : 1, $455d545b1dff00eb$var$J3.lookAt($455d545b1dff00eb$var$h6, $455d545b1dff00eb$var$Gx.cross($455d545b1dff00eb$var$F_), $455d545b1dff00eb$var$F_), c.setFromMatrix4($455d545b1dff00eb$var$J3);
            } else c.identity();
            e._orientation = l;
        }
    }
    _parsePercent(e) {
        if (typeof e == "string") {
            let t = e.match(/^(-?[\d.]+)%$/), n = t ? parseFloat(t[1]) : NaN;
            e = (isNaN(n) ? 0 : n / 100) * this.fontSize;
        }
        return e;
    }
    localPositionToTextCoords(e, t = new $455d545b1dff00eb$var$$e) {
        t.copy(e);
        const n = this.curveRadius;
        return n && (t.x = Math.atan2(e.x, Math.abs(n) - Math.abs(e.z)) * Math.abs(n)), t;
    }
    worldPositionToTextCoords(e, t = new $455d545b1dff00eb$var$$e) {
        return $455d545b1dff00eb$var$Gx.copy(e), this.localPositionToTextCoords(this.worldToLocal($455d545b1dff00eb$var$Gx), t);
    }
    raycast(e, t) {
        const { textRenderInfo: n, curveRadius: i } = this;
        if (n) {
            const r = n.blockBounds, l = i ? $455d545b1dff00eb$var$sw() : $455d545b1dff00eb$var$rw(), c = l.geometry, { position: f, uv: p } = c.attributes;
            for(let m = 0; m < p.count; m++){
                let x = r[0] + p.getX(m) * (r[2] - r[0]);
                const v = r[1] + p.getY(m) * (r[3] - r[1]);
                let _ = 0;
                i && (_ = i - Math.cos(x / i) * i, x = Math.sin(x / i) * i), f.setXYZ(m, x, v, _);
            }
            c.boundingSphere = this.geometry.boundingSphere, c.boundingBox = this.geometry.boundingBox, l.matrixWorld = this.matrixWorld, l.material.side = this.material.side, $455d545b1dff00eb$var$Nm.length = 0, l.raycast(e, $455d545b1dff00eb$var$Nm);
            for(let m = 0; m < $455d545b1dff00eb$var$Nm.length; m++)$455d545b1dff00eb$var$Nm[m].object = this, t.push($455d545b1dff00eb$var$Nm[m]);
        }
    }
    copy(e) {
        const t = this.geometry;
        return super.copy(e), this.geometry = t, $455d545b1dff00eb$var$m6.forEach((n)=>{
            this[n] = e[n];
        }), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
$455d545b1dff00eb$var$ow.forEach((a)=>{
    const e = "_private_" + a;
    Object.defineProperty($455d545b1dff00eb$var$lw.prototype, a, {
        get () {
            return this[e];
        },
        set (t) {
            t !== this[e] && (this[e] = t, this._needsSync = !0);
        }
    });
});
new $455d545b1dff00eb$var$ca;
new $455d545b1dff00eb$var$_t;
const $455d545b1dff00eb$var$vl = $455d545b1dff00eb$var$X.forwardRef(({ sdfGlyphSize: a = 64, anchorX: e = "center", anchorY: t = "middle", font: n, fontSize: i = 1, children: r, characters: l, onSync: c, ...f }, p)=>{
    const m = $455d545b1dff00eb$var$Ei(({ invalidate: S })=>S), [x] = $455d545b1dff00eb$var$X.useState(()=>new $455d545b1dff00eb$var$lw), [v, _] = $455d545b1dff00eb$var$X.useMemo(()=>{
        const S = [];
        let A = "";
        return $455d545b1dff00eb$var$X.Children.forEach(r, (M)=>{
            typeof M == "string" || typeof M == "number" ? A += M : S.push(M);
        }), [
            S,
            A
        ];
    }, [
        r
    ]);
    return $455d545b1dff00eb$var$KP(()=>new Promise((S)=>$455d545b1dff00eb$var$$I({
                font: n,
                characters: l
            }, S)), [
        "troika-text",
        n,
        l
    ]), $455d545b1dff00eb$var$X.useLayoutEffect(()=>void x.sync(()=>{
            m(), c && c(x);
        })), $455d545b1dff00eb$var$X.useEffect(()=>()=>x.dispose(), [
        x
    ]), $455d545b1dff00eb$var$X.createElement("primitive", $455d545b1dff00eb$var$Zf({
        object: x,
        ref: p,
        font: n,
        text: _,
        anchorX: e,
        anchorY: t,
        fontSize: i,
        sdfGlyphSize: a
    }, f), v);
});
function $455d545b1dff00eb$var$g6(a, e, t) {
    const n = $455d545b1dff00eb$var$Ei((_)=>_.size), i = $455d545b1dff00eb$var$Ei((_)=>_.viewport), r = typeof a == "number" ? a : n.width * i.dpr, l = n.height * i.dpr, c = (typeof a == "number" ? t : a) || {}, { samples: f = 0, depth: p, ...m } = c, x = p ?? c.depthBuffer, v = $455d545b1dff00eb$var$X.useMemo(()=>{
        const _ = new $455d545b1dff00eb$var$Oo(r, l, {
            minFilter: $455d545b1dff00eb$var$mi,
            magFilter: $455d545b1dff00eb$var$mi,
            type: $455d545b1dff00eb$var$wu,
            ...m
        });
        return x && (_.depthTexture = new $455d545b1dff00eb$var$yy(r, l, $455d545b1dff00eb$var$Rr)), _.samples = f, _;
    }, []);
    return $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        v.setSize(r, l), f && (v.samples = f);
    }, [
        f,
        v,
        r,
        l
    ]), $455d545b1dff00eb$var$X.useEffect(()=>()=>v.dispose(), []), v;
}
const $455d545b1dff00eb$var$x6 = (a)=>typeof a == "function", $455d545b1dff00eb$var$_b = $455d545b1dff00eb$var$X.forwardRef(({ envMap: a, resolution: e = 256, frames: t = 1 / 0, makeDefault: n, children: i, ...r }, l)=>{
    const c = $455d545b1dff00eb$var$Ei(({ set: M })=>M), f = $455d545b1dff00eb$var$Ei(({ camera: M })=>M), p = $455d545b1dff00eb$var$Ei(({ size: M })=>M), m = $455d545b1dff00eb$var$X.useRef(null);
    $455d545b1dff00eb$var$X.useImperativeHandle(l, ()=>m.current, []);
    const x = $455d545b1dff00eb$var$X.useRef(null), v = $455d545b1dff00eb$var$g6(e);
    $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        r.manual || (m.current.aspect = p.width / p.height);
    }, [
        p,
        r
    ]), $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        m.current.updateProjectionMatrix();
    });
    let _ = 0, S = null;
    const A = $455d545b1dff00eb$var$x6(i);
    return $455d545b1dff00eb$var$Zs((M)=>{
        A && (t === 1 / 0 || _ < t) && (x.current.visible = !1, M.gl.setRenderTarget(v), S = M.scene.background, a && (M.scene.background = a), M.gl.render(M.scene, m.current), M.scene.background = S, M.gl.setRenderTarget(null), x.current.visible = !0, _++);
    }), $455d545b1dff00eb$var$X.useLayoutEffect(()=>{
        if (n) {
            const M = f;
            return c(()=>({
                    camera: m.current
                })), ()=>c(()=>({
                        camera: M
                    }));
        }
    }, [
        m,
        n,
        c
    ]), $455d545b1dff00eb$var$X.createElement($455d545b1dff00eb$var$X.Fragment, null, $455d545b1dff00eb$var$X.createElement("perspectiveCamera", $455d545b1dff00eb$var$Zf({
        ref: m
    }, r), !A && i), $455d545b1dff00eb$var$X.createElement("group", {
        ref: x
    }, A && i(v.texture)));
}), $455d545b1dff00eb$var$v6 = $455d545b1dff00eb$var$X.forwardRef(({ makeDefault: a, camera: e, regress: t, domElement: n, enableDamping: i = !0, keyEvents: r = !1, onChange: l, onStart: c, onEnd: f, ...p }, m)=>{
    const x = $455d545b1dff00eb$var$Ei((L)=>L.invalidate), v = $455d545b1dff00eb$var$Ei((L)=>L.camera), _ = $455d545b1dff00eb$var$Ei((L)=>L.gl), S = $455d545b1dff00eb$var$Ei((L)=>L.events), A = $455d545b1dff00eb$var$Ei((L)=>L.setEvents), M = $455d545b1dff00eb$var$Ei((L)=>L.set), b = $455d545b1dff00eb$var$Ei((L)=>L.get), C = $455d545b1dff00eb$var$Ei((L)=>L.performance), R = e || v, N = n || S.connected || _.domElement, z = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$TP(R), [
        R
    ]);
    return $455d545b1dff00eb$var$Zs(()=>{
        z.enabled && z.update();
    }, -1), $455d545b1dff00eb$var$X.useEffect(()=>(r && z.connect(r === !0 ? N : r), z.connect(N), ()=>void z.dispose()), [
        r,
        N,
        t,
        z,
        x
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        const L = (O)=>{
            x(), t && C.regress(), l && l(O);
        }, P = (O)=>{
            c && c(O);
        }, H = (O)=>{
            f && f(O);
        };
        return z.addEventListener("change", L), z.addEventListener("start", P), z.addEventListener("end", H), ()=>{
            z.removeEventListener("start", P), z.removeEventListener("end", H), z.removeEventListener("change", L);
        };
    }, [
        l,
        c,
        f,
        z,
        x,
        A
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (a) {
            const L = b().controls;
            return M({
                controls: z
            }), ()=>M({
                    controls: L
                });
        }
    }, [
        a,
        z
    ]), $455d545b1dff00eb$var$X.createElement("primitive", $455d545b1dff00eb$var$Zf({
        ref: m,
        object: z,
        enableDamping: i
    }, p));
}), $455d545b1dff00eb$var$y6 = 1500;
function $455d545b1dff00eb$var$_6({ netIsComplete: a, worldMatrices: e, isMobile: t }) {
    const { camera: n, controls: i } = $455d545b1dff00eb$var$Ei(), r = $455d545b1dff00eb$var$X.useRef(null);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        r.current = i ?? null;
    }, [
        i
    ]);
    const l = $455d545b1dff00eb$var$X.useRef(!1), c = $455d545b1dff00eb$var$X.useRef(null), f = $455d545b1dff00eb$var$X.useRef(null), p = $455d545b1dff00eb$var$X.useRef(null), m = $455d545b1dff00eb$var$X.useRef(null), x = $455d545b1dff00eb$var$X.useRef(null), v = $455d545b1dff00eb$var$X.useRef(!1), { cameraPosition: _, lookAtTarget: S } = $455d545b1dff00eb$var$X.useMemo(()=>{
        if (!a || e.length === 0) {
            const Ue = t ? 2.8 : 3.5;
            return {
                cameraPosition: new $455d545b1dff00eb$var$J(Ue, Ue, Ue),
                lookAtTarget: new $455d545b1dff00eb$var$J(0, 0, 0)
            };
        }
        const A = [], M = [], b = new $455d545b1dff00eb$var$J, C = new $455d545b1dff00eb$var$Gn, R = new $455d545b1dff00eb$var$J, N = new $455d545b1dff00eb$var$J(0, 0, 1);
        for(let Ue = 0; Ue < e.length; Ue++)e[Ue].decompose(b, C, R), A.push(b.clone()), N.set(0, 0, 1).applyQuaternion(C).normalize(), M.push(N.clone());
        if (A.length === 0) return {
            cameraPosition: new $455d545b1dff00eb$var$J(0, 0, t ? 10 : 12),
            lookAtTarget: new $455d545b1dff00eb$var$J(0, 0, 0)
        };
        const z = A.map((Ue)=>Ue.x), L = A.map((Ue)=>Ue.y), P = A.map((Ue)=>Ue.z), H = Math.min(...z), O = Math.max(...z), D = Math.min(...L), j = Math.max(...L), G = Math.min(...P), q = Math.max(...P), Y = (H + O) / 2, ae = (D + j) / 2, F = (G + q) / 2, Q = new $455d545b1dff00eb$var$J(Y, ae, F), K = O - H + $455d545b1dff00eb$var$pn, $ = j - D + $455d545b1dff00eb$var$pn, ee = q - G + $455d545b1dff00eb$var$pn, I = Math.max(K, $, ee), Z = Math.max(I * 2, 12), ce = M[0] || new $455d545b1dff00eb$var$J(0, 0, 1), de = O - H, ue = j - D, le = q - G, xe = Math.min(de, ue, le);
        let Le;
        if (xe === le) {
            const Ue = ce.z >= 0 ? 1 : -1;
            Le = new $455d545b1dff00eb$var$J(Y, ae, F + Z * Ue);
        } else if (xe === ue) {
            const Ue = ce.y >= 0 ? 1 : -1;
            Le = new $455d545b1dff00eb$var$J(Y, ae + Z * Ue, F);
        } else {
            const Ue = ce.x >= 0 ? 1 : -1;
            Le = new $455d545b1dff00eb$var$J(Y + Z * Ue, ae, F);
        }
        return {
            cameraPosition: Le,
            lookAtTarget: Q
        };
    }, [
        a,
        e,
        t
    ]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        if (a && !l.current) {
            const A = setTimeout(()=>{
                if (!a || l.current) return;
                if (f.current = n.position.clone(), i && "target" in i) p.current = i.target.clone();
                else {
                    const z = new $455d545b1dff00eb$var$J(0, 0, -1);
                    z.applyQuaternion(n.quaternion), p.current = n.position.clone().add(z.multiplyScalar(5));
                }
                p.current.distanceTo(new $455d545b1dff00eb$var$J(0, 0, 0)) > 10 && (p.current = new $455d545b1dff00eb$var$J(0, 0, 0));
                const M = [], b = new $455d545b1dff00eb$var$J, C = new $455d545b1dff00eb$var$Gn, R = new $455d545b1dff00eb$var$J;
                for(let z = 0; z < e.length; z++)e[z].decompose(b, C, R), M.push(b.clone());
                if (M.length > 0) {
                    const z = M.map((Z)=>Z.x), L = M.map((Z)=>Z.y), P = M.map((Z)=>Z.z), H = (Math.min(...z) + Math.max(...z)) / 2, O = (Math.min(...L) + Math.max(...L)) / 2, D = (Math.min(...P) + Math.max(...P)) / 2, j = new $455d545b1dff00eb$var$J(H, O, D), G = Math.max(...z) - Math.min(...z) + $455d545b1dff00eb$var$pn, q = Math.max(...L) - Math.min(...L) + $455d545b1dff00eb$var$pn, Y = Math.max(...P) - Math.min(...P) + $455d545b1dff00eb$var$pn, ae = Math.max(G, q, Y), F = Math.max(ae * 2, 12), Q = Math.max(...z) - Math.min(...z), K = Math.max(...L) - Math.min(...L), $ = Math.max(...P) - Math.min(...P), ee = Math.min(Q, K, $);
                    let I;
                    ee === $ ? I = new $455d545b1dff00eb$var$J(H, O, D + F) : ee === K ? I = new $455d545b1dff00eb$var$J(H, O + F, D) : I = new $455d545b1dff00eb$var$J(H + F, O, D), m.current = I, x.current = j;
                } else m.current = _.clone(), x.current = S.clone();
                (f.current.distanceTo(m.current) > 50 || isNaN(m.current.x)) && (m.current = new $455d545b1dff00eb$var$J(0, 0, 12), x.current = new $455d545b1dff00eb$var$J(0, 0, 0)), c.current = Date.now(), l.current = !0, v.current = !0, r.current && (r.current.enabled = !1);
            }, 1400);
            return ()=>clearTimeout(A);
        } else a || (l.current = !1, c.current = null, v.current = !1, r.current && (r.current.enabled = !0));
    }, [
        a,
        n,
        _,
        i,
        r,
        S,
        e
    ]), $455d545b1dff00eb$var$Zs(()=>{
        if (!a || !l.current || !c.current || !f.current || !p.current || !m.current || !x.current) return;
        const A = Date.now() - c.current, M = Math.min(A / $455d545b1dff00eb$var$y6, 1), b = $455d545b1dff00eb$var$g0(M), C = new $455d545b1dff00eb$var$J().lerpVectors(f.current, m.current, b), R = x.current.clone();
        (isNaN(R.x) || R.distanceTo(C) > 100) && R.set(0, 0, 0), n.position.copy(C), n.lookAt(R), i && "target" in i && (i.target.copy(R), "update" in i && typeof i.update == "function" && i.update()), M >= 1 && (c.current = null, v.current = !1, l.current = !0, r.current && (r.current.enabled = !0));
    }), null;
}
function $455d545b1dff00eb$var$b6({ validDirections: a, onDirectionClick: e, onArrowHover: t, onArrowLeave: n, worldMatrix: i }) {
    const { camera: r, size: l } = $455d545b1dff00eb$var$Ei(), [c, f] = $455d545b1dff00eb$var$X.useState({
        UP: 0,
        DOWN: 0,
        LEFT: 0,
        RIGHT: 0
    }), p = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J, []), m = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J, []);
    $455d545b1dff00eb$var$Zs(()=>{
        const v = [
            "UP",
            "DOWN",
            "LEFT",
            "RIGHT"
        ], _ = {
            ...c
        };
        let S = !1;
        p.set(0, 0, 0).applyMatrix4(i).project(r);
        const A = p.x * l.width / 2, M = p.y * l.height / 2;
        v.forEach((b)=>{
            m.set(0, 0, 0), b === "UP" ? m.set(0, .5, 0) : b === "DOWN" ? m.set(0, -0.5, 0) : b === "LEFT" ? m.set(-0.5, 0, 0) : b === "RIGHT" && m.set(.5, 0, 0), m.applyMatrix4(i).project(r);
            const C = m.x * l.width / 2, R = m.y * l.height / 2, N = C - A, z = R - M, P = 90 - Math.atan2(z, N) * (180 / Math.PI);
            Math.abs(_[b] - P) > .1 && (_[b] = P, S = !0);
        }), S && f(_);
    });
    const x = [
        {
            dir: "UP",
            position: [
                0,
                .5,
                .01
            ]
        },
        {
            dir: "DOWN",
            position: [
                0,
                -0.5,
                .01
            ]
        },
        {
            dir: "LEFT",
            position: [
                -0.5,
                0,
                .01
            ]
        },
        {
            dir: "RIGHT",
            position: [
                .5,
                0,
                .01
            ]
        }
    ];
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$k.Fragment, {
        children: x.map(({ dir: v, position: _ })=>{
            const S = a.includes(v);
            return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_I, {
                position: _,
                center: !0,
                children: $455d545b1dff00eb$var$k.jsx("button", {
                    onClick: (A)=>{
                        A.stopPropagation(), S && e(v);
                    },
                    onPointerOver: (A)=>{
                        A.stopPropagation(), t();
                    },
                    onPointerOut: (A)=>{
                        A.stopPropagation(), n();
                    },
                    className: `text-2xl md:text-xl transition-colors rounded-full p-1.5 md:p-1 border-2 shadow-lg select-none touch-none ${S ? "text-green-600 hover:text-green-800 active:text-green-900 bg-white/90 border-green-300 hover:bg-green-50 active:bg-green-100" : "text-gray-400 bg-gray-100 border-gray-300 cursor-not-allowed"}`,
                    style: {
                        touchAction: "none",
                        width: "2rem",
                        height: "2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transform: `rotate(${c[v]}deg)`
                    },
                    disabled: !S,
                    children: $455d545b1dff00eb$var$k.jsx("span", {
                        style: {
                            transform: "translateY(-1px)"
                        },
                        children: "\u2191"
                    })
                })
            }, v);
        })
    });
}
function $455d545b1dff00eb$var$S6({ faceIndex: a, color: e, mode: t, faceState: n, worldMatrix: i, onUnfold: r, onFoldBack: l, possibleDirections: c, selectedFaceIndex: f, onFaceTap: p }) {
    const m = $455d545b1dff00eb$var$X.useRef(null), x = $455d545b1dff00eb$var$X.useRef(null), [v, _] = $455d545b1dff00eb$var$X.useState(!1), [S, A] = $455d545b1dff00eb$var$X.useState(!1), M = $455d545b1dff00eb$var$X.useRef(null), b = $455d545b1dff00eb$var$X.useRef(!1), C = $455d545b1dff00eb$var$X.useRef(!1), R = $455d545b1dff00eb$var$X.useMemo(()=>typeof window > "u" ? !1 : "ontouchstart" in window || window.matchMedia("(pointer: coarse)").matches, []), N = 200, z = R && f === a && !n.unfolded, L = $455d545b1dff00eb$var$X.useCallback((Y)=>{
        t === "net-building" && (Y.stopPropagation(), Y.nativeEvent.stopPropagation(), n.unfolded ? l(a) : p(a));
    }, [
        t,
        n.unfolded,
        a,
        l,
        p
    ]), P = $455d545b1dff00eb$var$X.useCallback((Y)=>{
        t === "net-building" && !n.unfolded && (A(!1), C.current = !1, M.current && (clearTimeout(M.current), M.current = null), r(a, Y));
    }, [
        t,
        n.unfolded,
        a,
        r
    ]), H = $455d545b1dff00eb$var$X.useCallback(()=>{
        C.current = !0, M.current && (clearTimeout(M.current), M.current = null), A(!0);
    }, []), O = $455d545b1dff00eb$var$X.useCallback(()=>{
        C.current = !1, b.current || (M.current = setTimeout(()=>{
            !b.current && !C.current && A(!1);
        }, N));
    }, []);
    $455d545b1dff00eb$var$X.useEffect(()=>()=>{
            M.current && clearTimeout(M.current);
        }, []), $455d545b1dff00eb$var$X.useEffect(()=>{
        x.current && (x.current.userData = {
            faceIndex: a
        });
    }, [
        a
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        R && n.unfolded && f === a && p(-1);
    }, [
        R,
        n.unfolded,
        f,
        a,
        p
    ]);
    const D = $455d545b1dff00eb$var$X.useRef(i.clone());
    $455d545b1dff00eb$var$X.useEffect(()=>{
        D.current.copy(i);
    }, [
        i
    ]);
    const j = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J, []), G = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$Gn, []), q = $455d545b1dff00eb$var$X.useMemo(()=>new $455d545b1dff00eb$var$J(1, 1, 1), []);
    return $455d545b1dff00eb$var$Zs(()=>{
        if (!m.current || !x.current) return;
        D.current.decompose(j, G, q), m.current.position.copy(j), m.current.quaternion.copy(G);
        let Y = 1;
        t === "net-building" && !n.unfolded && v && (Y = 1.05), n.unfolded && n.animProgress > 0 && n.animProgress < 1 && (Y = 1 + Math.sin(n.animProgress * Math.PI * 2) * .05);
        const ae = m.current.scale.x, F = Y - ae, Q = ae + F * .1;
        m.current.scale.set(Q, Q, Q), x.current.material instanceof $455d545b1dff00eb$var$Oy && (t === "net-building" ? !n.unfolded && v ? (x.current.material.opacity = 1, x.current.material.emissive = new $455d545b1dff00eb$var$_t(3355443)) : (x.current.material.opacity = .9, x.current.material.emissive = new $455d545b1dff00eb$var$_t(0)) : (x.current.material.opacity = .9, x.current.material.emissive = new $455d545b1dff00eb$var$_t(0)));
    }), $455d545b1dff00eb$var$k.jsxs("group", {
        ref: m,
        children: [
            $455d545b1dff00eb$var$k.jsxs("mesh", {
                ref: x,
                onClick: L,
                onPointerOver: (Y)=>{
                    Y.stopPropagation(), t === "net-building" && !R && (b.current = !0, _(!0), n.unfolded || (M.current && (clearTimeout(M.current), M.current = null), A(!0)), document.body.style.cursor = "pointer");
                },
                onPointerOut: (Y)=>{
                    Y.stopPropagation(), t === "net-building" && (b.current = !1, _(!1), !R && !n.unfolded && (C.current || (M.current = setTimeout(()=>{
                        !b.current && !C.current && A(!1);
                    }, N))), R || (document.body.style.cursor = "default"));
                },
                children: [
                    $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                        args: [
                            $455d545b1dff00eb$var$pn,
                            $455d545b1dff00eb$var$pn
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                        color: e,
                        transparent: !0,
                        opacity: .85,
                        side: $455d545b1dff00eb$var$Ea
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("lineSegments", {
                children: [
                    $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                        args: [
                            new $455d545b1dff00eb$var$Jr($455d545b1dff00eb$var$pn, $455d545b1dff00eb$var$pn)
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                        color: "#000000",
                        opacity: 1,
                        transparent: !1,
                        linewidth: 2
                    })
                ]
            }),
            t === "net-building" && !n.unfolded && (v || z) && $455d545b1dff00eb$var$k.jsxs("lineSegments", {
                children: [
                    $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                        args: [
                            new $455d545b1dff00eb$var$Jr($455d545b1dff00eb$var$pn * 1.05, $455d545b1dff00eb$var$pn * 1.05)
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                        color: "#FFD700",
                        opacity: 1,
                        transparent: !1,
                        linewidth: 3
                    })
                ]
            }),
            t === "net-building" && !n.unfolded && (S || z) && $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$b6, {
                validDirections: c,
                onDirectionClick: P,
                onArrowHover: H,
                onArrowLeave: O,
                worldMatrix: i
            })
        ]
    });
}
const $455d545b1dff00eb$var$M6 = $455d545b1dff00eb$var$X.forwardRef(({ mode: a, faceStates: e, worldMatrices: t, onUnfold: n, onFoldBack: i, showLabels: r, hingeConfig: l }, c)=>{
    const f = $455d545b1dff00eb$var$X.useRef(null), [p, m] = $455d545b1dff00eb$var$X.useState(null);
    $455d545b1dff00eb$var$X.useImperativeHandle(c, ()=>({
            clearSelectedFace: ()=>{
                m(null);
            }
        }), []);
    const x = $455d545b1dff00eb$var$X.useCallback((A, M)=>{
        let b = A;
        for(; b !== null;){
            if (b === M) return !0;
            b = b !== null ? e[b]?.parentFace ?? null : null;
        }
        return !1;
    }, [
        e
    ]), v = $455d545b1dff00eb$var$X.useCallback((A)=>{
        if (e[A].unfolded) return [];
        const M = l[A], b = [];
        if ($455d545b1dff00eb$var$gS.forEach((N)=>{
            const z = M?.[N];
            if (!z) return;
            const L = z.parentFaceIndex, P = e[L], H = P.unfolded && P.animProgress >= .95, O = !P.unfolded && P.animProgress < .05;
            if (!H && !O || !$455d545b1dff00eb$var$CP[A].includes(L) || x(L, A)) return;
            const j = new $455d545b1dff00eb$var$J().setFromMatrixPosition(t[A]), G = new $455d545b1dff00eb$var$J().setFromMatrixPosition(t[L]), q = j.distanceTo(G);
            b.push({
                direction: N,
                parentIndex: L,
                distance: q
            });
        }), b.length === 0) return [];
        const C = Math.min(...b.map((N)=>N.distance));
        return C > 1.6 ? [] : b.filter((N)=>Math.abs(N.distance - C) < .1).map((N)=>N.direction);
    }, [
        e,
        l,
        t,
        x
    ]), _ = $455d545b1dff00eb$var$X.useCallback((A)=>{
        m(A);
    }, []), S = $455d545b1dff00eb$var$X.useCallback((A, M)=>{
        m(null), n(A, M);
    }, [
        n
    ]);
    return $455d545b1dff00eb$var$k.jsx("group", {
        ref: f,
        children: $455d545b1dff00eb$var$Ur.map((A, M)=>{
            const b = e[M], C = b?.color || A;
            return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$S6, {
                faceIndex: M,
                color: C,
                mode: a,
                faceState: b,
                worldMatrix: t[M],
                onUnfold: S,
                onFoldBack: i,
                possibleDirections: v(M),
                showLabel: r,
                selectedFaceIndex: p,
                onFaceTap: _
            }, M);
        })
    });
});
function $455d545b1dff00eb$var$E6({ cubeRef: a }) {
    const { controls: e } = $455d545b1dff00eb$var$Ei(), t = $455d545b1dff00eb$var$X.useRef(!1), n = $455d545b1dff00eb$var$X.useRef(null);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!e) {
            console.log("OrbitControlsListener: No controls available");
            return;
        }
        const i = e;
        console.log("OrbitControlsListener: Controls found, configuring touches..."), i.touches = {
            ONE: $455d545b1dff00eb$var$Zr.ROTATE,
            TWO: $455d545b1dff00eb$var$Zr.DOLLY_PAN
        }, console.log("OrbitControls touches configured:", {
            ONE: i.touches.ONE,
            TWO: i.touches.TWO,
            ROTATE: $455d545b1dff00eb$var$Zr.ROTATE,
            DOLLY_PAN: $455d545b1dff00eb$var$Zr.DOLLY_PAN,
            isMobile: typeof window < "u" && ("ontouchstart" in window || window.matchMedia("(pointer: coarse)").matches)
        });
        const r = ()=>{
            t.current = !0, a.current && a.current.clearSelectedFace();
        }, l = ()=>{
            t.current && a.current && a.current.clearSelectedFace();
        }, c = ()=>{
            n.current && clearTimeout(n.current), n.current = window.setTimeout(()=>{
                t.current = !1;
            }, 150);
        };
        return i.addEventListener("start", r), i.addEventListener("change", l), i.addEventListener("end", c), ()=>{
            i.removeEventListener("start", r), i.removeEventListener("change", l), i.removeEventListener("end", c), n.current && clearTimeout(n.current);
        };
    }, [
        e,
        a
    ]), null;
}
function $455d545b1dff00eb$var$T6({ onControlsReady: a }) {
    const { controls: e } = $455d545b1dff00eb$var$Ei();
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        e && a(e);
    }, [
        e,
        a
    ]), null;
}
const $455d545b1dff00eb$var$A6 = `
  .unfolding-slider::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #fd99c5;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
  .unfolding-slider::-moz-range-thumb {
    height: 20px;
    width: 30px;
    border-radius: 50%;
    background: #fd99c5;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
`;
function $455d545b1dff00eb$var$w6({ rotationValue: a, verticalRotationValue: e, zoomValue: t, onRotationChange: n, onVerticalRotationChange: i, onZoomChange: r }) {
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("style", {
                children: $455d545b1dff00eb$var$A6
            }),
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "fixed bottom-36 right-4 z-40 hidden lg:block",
                style: {
                    zIndex: 10
                },
                children: $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "flex flex-col space-y-3 bg-white/90 backdrop-blur-sm rounded-lg p-3 shadow-lg",
                    children: [
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-row items-center space-x-3 min-w-[200px]",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-gray-700 whitespace-nowrap min-w-[60px]",
                                    children: "Rotate X:"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "100",
                                    value: a,
                                    onChange: (l)=>n(Number(l.target.value)),
                                    className: "flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer unfolding-slider"
                                }),
                                $455d545b1dff00eb$var$k.jsxs("span", {
                                    className: "text-sm min-w-[40px]",
                                    children: [
                                        Math.round((a - 50) / 50 * 180),
                                        "\xb0"
                                    ]
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-row items-center space-x-3 min-w-[200px]",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-gray-700 whitespace-nowrap min-w-[60px]",
                                    children: "Rotate Y:"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "100",
                                    value: e,
                                    onChange: (l)=>i(Number(l.target.value)),
                                    className: "flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer unfolding-slider"
                                }),
                                $455d545b1dff00eb$var$k.jsxs("span", {
                                    className: "text-sm text-gray-600 min-w-[40px]",
                                    children: [
                                        Math.round(e / 100 * 180),
                                        "\xb0"
                                    ]
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-row items-center space-x-3 min-w-[200px]",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("label", {
                                    className: "text-sm font-medium text-gray-700 whitespace-nowrap min-w-[60px]",
                                    children: "Zoom:"
                                }),
                                $455d545b1dff00eb$var$k.jsx("input", {
                                    type: "range",
                                    min: "0",
                                    max: "100",
                                    value: t,
                                    onChange: (l)=>r(Number(l.target.value)),
                                    className: "flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer unfolding-slider"
                                }),
                                $455d545b1dff00eb$var$k.jsxs("span", {
                                    className: "text-sm text-gray-600 min-w-[40px]",
                                    children: [
                                        Math.round(t),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
const $455d545b1dff00eb$var$kf = $455d545b1dff00eb$var$OP(), $455d545b1dff00eb$var$ES = $455d545b1dff00eb$var$$B($455d545b1dff00eb$var$kf), $455d545b1dff00eb$var$bb = $455d545b1dff00eb$var$ZB($455d545b1dff00eb$var$kf), $455d545b1dff00eb$var$x0 = $455d545b1dff00eb$var$JB($455d545b1dff00eb$var$kf, $455d545b1dff00eb$var$ES, $455d545b1dff00eb$var$bb);
function $455d545b1dff00eb$var$C6({ isMobileWidth: a, shouldShowStraightView: e, worldMatrices: t, interactiveCubeRef: n, orbitControlsRef: i, faceStates: r, onUnfold: l, onFoldBack: c, netIsComplete: f }) {
    const p = "net-building", m = Math.PI / 4, x = Math.PI / 2, v = $455d545b1dff00eb$var$X.useRef(m), _ = $455d545b1dff00eb$var$X.useRef(x), [S, A] = $455d545b1dff00eb$var$X.useState(50), [M, b] = $455d545b1dff00eb$var$X.useState(50), [C, R] = $455d545b1dff00eb$var$X.useState(50), N = a ? 2 : 2.5, z = a ? 9 : 12, L = $455d545b1dff00eb$var$X.useCallback((O)=>{
        if (A(O), i.current) {
            const D = i.current, j = -(O - 50) / 50 * 2 * Math.PI, q = ((v.current + j) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
            D.setAzimuthalAngle(q), D.update();
        }
    }, [
        i
    ]), P = $455d545b1dff00eb$var$X.useCallback((O)=>{
        if (b(O), i.current) {
            const D = i.current, j = O / 100 * Math.PI;
            D.setPolarAngle(j), D.update();
        }
    }, [
        i
    ]), H = $455d545b1dff00eb$var$X.useCallback((O)=>{
        if (R(O), i.current) {
            const D = i.current, j = D.object, G = D.target, q = N + (100 - O) / 100 * (z - N), Y = new $455d545b1dff00eb$var$J().subVectors(j.position, G).normalize(), ae = new $455d545b1dff00eb$var$J().copy(G).add(Y.multiplyScalar(q));
            j.position.copy(ae), D.update();
        }
    }, [
        i,
        N,
        z
    ]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        if (i.current) {
            const O = i.current, D = ()=>{
                let G = O.getAzimuthalAngle() - v.current;
                G = (G + Math.PI) % (2 * Math.PI) - Math.PI;
                const q = 50 + G / (2 * Math.PI) * 50;
                A(Math.max(0, Math.min(100, q)));
                const ae = O.getPolarAngle() / Math.PI * 100;
                b(Math.max(0, Math.min(100, ae)));
                const Q = 100 - (O.object.position.distanceTo(O.target) - N) / (z - N) * 100;
                R(Math.max(0, Math.min(100, Q)));
            };
            return O.addEventListener("change", D), ()=>O.removeEventListener("change", D);
        }
    }, [
        i,
        N,
        z
    ]), $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "flex-1 w-full relative overflow-hidden mt-32 md:mt-0 md:pl-[22rem] lg:pl-[26rem]",
                style: {
                    minHeight: "300px"
                },
                children: $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$_S, {
                    flat: !0,
                    gl: {
                        outputColorSpace: $455d545b1dff00eb$var$No
                    },
                    children: [
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_b, {
                            makeDefault: !0,
                            position: a ? [
                                2.8,
                                2.8,
                                2.8
                            ] : [
                                3.5,
                                3.5,
                                3.5
                            ],
                            fov: a ? 50 : 70
                        }),
                        $455d545b1dff00eb$var$k.jsx("ambientLight", {
                            intensity: .3
                        }),
                        $455d545b1dff00eb$var$k.jsx("directionalLight", {
                            position: [
                                5,
                                5,
                                5
                            ],
                            intensity: 1
                        }),
                        $455d545b1dff00eb$var$k.jsx("directionalLight", {
                            position: [
                                -5,
                                -5,
                                -5
                            ],
                            intensity: .5
                        }),
                        $455d545b1dff00eb$var$k.jsx("directionalLight", {
                            position: [
                                0,
                                5,
                                0
                            ],
                            intensity: .8
                        }),
                        $455d545b1dff00eb$var$k.jsx("pointLight", {
                            position: [
                                0,
                                0,
                                0
                            ],
                            intensity: .3
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_6, {
                            netIsComplete: e,
                            worldMatrices: t,
                            isMobile: a
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$M6, {
                            ref: n,
                            mode: p,
                            faceStates: r,
                            worldMatrices: t,
                            onUnfold: l,
                            onFoldBack: c,
                            showLabels: f,
                            hingeConfig: $455d545b1dff00eb$var$x0
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$E6, {
                            cubeRef: n
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v6, {
                            ref: i,
                            enableZoom: !1,
                            enablePan: !0,
                            enableRotate: !0,
                            enabled: !0,
                            minDistance: N,
                            maxDistance: z,
                            minPolarAngle: 0,
                            maxPolarAngle: Math.PI,
                            enableDamping: !1
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$T6, {
                            onControlsReady: (O)=>{
                                i.current = O, O.setAzimuthalAngle(m), O.setPolarAngle(x), v.current = m, _.current = x, O.update(), A(50), b(x / Math.PI * 100);
                            }
                        })
                    ]
                })
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$w6, {
                rotationValue: S,
                verticalRotationValue: M,
                zoomValue: C,
                onRotationChange: L,
                onVerticalRotationChange: P,
                onZoomChange: H
            })
        ]
    });
}
function $455d545b1dff00eb$var$R6({ progressCount: a, isAnimating: e, animateUnfold: t, handleUndo: n, unfoldHistoryLength: i, handleReset: r, handleFoldToCube: l, unfoldedCount: c, surfaceAreaVideoUrl: f, onOpenVideo: p, toggleDrawer: m, isDrawerOpen: x }) {
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "w-full bg-white border-t border-gray-100 px-3 md:px-8 py-2 md:py-3 flex-shrink-0",
        children: $455d545b1dff00eb$var$k.jsxs("div", {
            className: "max-w-6xl mx-auto",
            children: [
                $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4 mb-2 md:mb-3",
                    children: [
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-col md:flex-row items-center gap-2 md:gap-3 w-full md:w-auto",
                            children: [
                                $455d545b1dff00eb$var$k.jsxs("div", {
                                    className: "text-center flex-shrink-0",
                                    children: [
                                        $455d545b1dff00eb$var$k.jsx("p", {
                                            className: "text-[10px] md:text-xs text-gray-500 uppercase tracking-wide",
                                            children: "Progress"
                                        }),
                                        $455d545b1dff00eb$var$k.jsxs("p", {
                                            className: "text-lg md:text-2xl font-bold text-gray-900",
                                            children: [
                                                a,
                                                " / ",
                                                $455d545b1dff00eb$var$Do
                                            ]
                                        })
                                    ]
                                }),
                                $455d545b1dff00eb$var$k.jsx("div", {
                                    className: "h-px md:h-8 w-full md:w-px bg-gray-200"
                                }),
                                $455d545b1dff00eb$var$k.jsx("div", {
                                    className: "flex-1 w-full md:w-auto min-w-[150px] max-w-md",
                                    children: $455d545b1dff00eb$var$k.jsx("div", {
                                        className: "h-1.5 bg-gray-100 rounded-full overflow-hidden",
                                        children: $455d545b1dff00eb$var$k.jsx("div", {
                                            className: "h-full rounded-full transition-all duration-300",
                                            style: {
                                                width: `${Math.min(100, a / $455d545b1dff00eb$var$Do * 100)}%`,
                                                backgroundColor: "#4A90E2"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-wrap items-center gap-2 justify-center md:justify-end w-full md:w-auto",
                            children: [
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: t,
                                    disabled: e,
                                    className: `px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all ${e ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#FD99C5] text-white hover:bg-[#db2777]"}`,
                                    children: e ? "\u23F3 Animating..." : "\u25B6 Animate"
                                }),
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: n,
                                    disabled: i === 0 || e,
                                    className: `px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all ${i === 0 || e ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#FD99C5] text-white hover:bg-[#db2777]"}`,
                                    children: "\u21B6 Undo"
                                }),
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: r,
                                    disabled: e,
                                    className: `px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all ${e ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#FD99C5] text-white hover:bg-[#db2777]"}`,
                                    children: "Reset"
                                }),
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: l,
                                    disabled: c === 0 || e,
                                    className: `px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all ${c === 0 || e ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#FD99C5] text-white hover:bg-[#db2777]"}`,
                                    children: "Fold to Cube"
                                }),
                                !!f && $455d545b1dff00eb$var$k.jsxs("button", {
                                    onClick: p,
                                    className: "px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all bg-[#FD99C5] text-white hover:bg-[#db2777] flex items-center gap-2",
                                    children: [
                                        $455d545b1dff00eb$var$k.jsx("svg", {
                                            className: "w-4 h-4",
                                            fill: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: $455d545b1dff00eb$var$k.jsx("path", {
                                                d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                            })
                                        }),
                                        "Play Video"
                                    ]
                                }),
                                $455d545b1dff00eb$var$k.jsx("button", {
                                    onClick: m,
                                    className: "px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all bg-[#FD99C5] text-white hover:bg-[#db2777]",
                                    children: x ? "\u2715 Close Nets" : "\uD83D\uDCCB View All Nets"
                                })
                            ]
                        })
                    ]
                }),
                $455d545b1dff00eb$var$k.jsx("div", {
                    className: "bg-gray-50 mb-4 md:mb-0 rounded-lg md:rounded-xl p-2 md:p-3 border border-gray-100",
                    children: $455d545b1dff00eb$var$k.jsxs("div", {
                        className: "flex items-center justify-start gap-3",
                        children: [
                            $455d545b1dff00eb$var$k.jsx("p", {
                                className: "text-[10px] md:text-xs text-gray-500 uppercase tracking-wide flex-shrink-0",
                                children: "Colors"
                            }),
                            $455d545b1dff00eb$var$k.jsx("div", {
                                className: "flex flex-wrap items-center gap-1.5 md:gap-2 flex-1 ",
                                children: $455d545b1dff00eb$var$mS.map((v, _)=>$455d545b1dff00eb$var$k.jsxs("div", {
                                        className: "flex items-center gap-1 rounded-md bg-white px-1.5 md:px-2 py-1 border border-gray-100 hover:border-gray-200 transition-colors",
                                        title: $455d545b1dff00eb$var$lb[_],
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("div", {
                                                className: "h-4 w-4 md:h-5 md:w-5 rounded border border-gray-200 flex-shrink-0",
                                                style: {
                                                    backgroundColor: v
                                                }
                                            }),
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                className: "text-[10px] md:text-xs font-medium text-gray-700 whitespace-nowrap hidden sm:inline",
                                                children: $455d545b1dff00eb$var$lb[_]
                                            })
                                        ]
                                    }, `palette-${_}`))
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function $455d545b1dff00eb$var$eE(a, e) {
    return `linear-gradient(135deg, ${a}, ${e})`;
}
function $455d545b1dff00eb$var$D6() {
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "absolute bottom-36 left-8 w-full md:w-auto md:max-w-sm lg:max-w-md xl:max-w-lg -z-0 hidden md:block",
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: "rounded-lg md:rounded-xl p-[4px] min-w-0",
            style: {
                background: $455d545b1dff00eb$var$eE($455d545b1dff00eb$var$wt.sunshineYellow, $455d545b1dff00eb$var$wt.petalPink),
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
            },
            children: $455d545b1dff00eb$var$k.jsxs("div", {
                className: "w-full h-full rounded-lg md:rounded-xl px-3 md:px-5 py-2 md:py-4 relative",
                style: {
                    background: $455d545b1dff00eb$var$eE($455d545b1dff00eb$var$wt.sunshineYellow, $455d545b1dff00eb$var$wt.petalPink)
                },
                children: [
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: "absolute inset-0 rounded-lg md:rounded-xl pointer-events-none",
                        style: {
                            backgroundColor: "rgb(255 255 255 / 0.95)"
                        }
                    }),
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        className: "relative z-10",
                        children: [
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "flex items-center gap-3 mb-4",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("span", {
                                        className: "text-3xl",
                                        children: "\uD83D\uDCE6"
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("div", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("p", {
                                                className: "text-xs uppercase tracking-[0.35em] text-slate-500",
                                                children: "Flow"
                                            }),
                                            $455d545b1dff00eb$var$k.jsx("h3", {
                                                className: "text-lg font-bold text-slate-900",
                                                children: "Box Unfold Ritual"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "space-y-3 text-sm text-slate-700",
                                children: [
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.electricBlue,
                                                    fontWeight: 700
                                                },
                                                children: "Hover Highlights:"
                                            }),
                                            " ",
                                            "hover over any face to reveal direction arrows for the next rotation."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.sunshineYellow,
                                                    fontWeight: 700
                                                },
                                                children: "90\xb0 Clicks:"
                                            }),
                                            " ",
                                            "click an arrow to swing a square with satisfying precision."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.coralGlow,
                                                    fontWeight: 700
                                                },
                                                children: "Fold-Back Magic:"
                                            }),
                                            " ",
                                            "click an unfolded face to reattach it and reimagine the layout."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.aquaBlue,
                                                    fontWeight: 700
                                                },
                                                children: "Rotate & Zoom:"
                                            }),
                                            " ",
                                            "drag with one finger to rotate the cube, pinch with two fingers to zoom in/out."
                                        ]
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("p", {
                                className: "mt-4 text-xs font-semibold uppercase tracking-wide text-slate-600",
                                children: "\uD83C\uDFAF Think of it as remixing a luxury gift box."
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $455d545b1dff00eb$var$tE(a, e) {
    return `linear-gradient(135deg, ${a}, ${e})`;
}
function $455d545b1dff00eb$var$U6({ isVisible: a, onClose: e }) {
    return a ? $455d545b1dff00eb$var$k.jsx("div", {
        style: {
            zIndex: 1e10
        },
        className: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 md:hidden",
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: "w-full max-w-sm rounded-xl p-[4px] relative",
            style: {
                background: $455d545b1dff00eb$var$tE($455d545b1dff00eb$var$wt.sunshineYellow, $455d545b1dff00eb$var$wt.petalPink),
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
            },
            children: $455d545b1dff00eb$var$k.jsxs("div", {
                className: "w-full h-full rounded-xl px-4 py-4 relative",
                style: {
                    background: $455d545b1dff00eb$var$tE($455d545b1dff00eb$var$wt.sunshineYellow, $455d545b1dff00eb$var$wt.petalPink)
                },
                children: [
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: "absolute inset-0 rounded-xl pointer-events-none",
                        style: {
                            backgroundColor: "rgb(255 255 255 / 0.95)"
                        }
                    }),
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        className: "relative z-10",
                        children: [
                            $455d545b1dff00eb$var$k.jsx("button", {
                                onClick: e,
                                className: "absolute top-2 right-2 w-6 h-6 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors",
                                "aria-label": "Close guide",
                                children: $455d545b1dff00eb$var$k.jsx("svg", {
                                    className: "w-4 h-4 text-gray-600",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: $455d545b1dff00eb$var$k.jsx("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "flex items-center gap-3 mb-4 pr-8",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("span", {
                                        className: "text-3xl",
                                        children: "\uD83D\uDCE6"
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("div", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("p", {
                                                className: "text-xs uppercase tracking-[0.35em] text-slate-500",
                                                children: "Flow"
                                            }),
                                            $455d545b1dff00eb$var$k.jsx("h3", {
                                                className: "text-lg font-bold text-slate-900",
                                                children: "Box Unfold Ritual"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "space-y-3 text-sm text-slate-700",
                                children: [
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.electricBlue,
                                                    fontWeight: 700
                                                },
                                                children: "Tap to Reveal:"
                                            }),
                                            " ",
                                            "tap any face to reveal direction arrows for the next rotation."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.sunshineYellow,
                                                    fontWeight: 700
                                                },
                                                children: "90\xb0 Taps:"
                                            }),
                                            " ",
                                            "tap an arrow to swing a square with satisfying precision."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.coralGlow,
                                                    fontWeight: 700
                                                },
                                                children: "Fold-Back Magic:"
                                            }),
                                            " ",
                                            "tap an unfolded face to reattach it and reimagine the layout."
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("p", {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("span", {
                                                style: {
                                                    color: $455d545b1dff00eb$var$wt.aquaBlue,
                                                    fontWeight: 700
                                                },
                                                children: "Rotate & Zoom:"
                                            }),
                                            " ",
                                            "drag with one finger to rotate the cube, pinch with two fingers (up/down) to zoom in/out."
                                        ]
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("p", {
                                className: "mt-4 text-xs font-semibold uppercase tracking-wide text-slate-600 mb-4",
                                children: "\uD83C\uDFAF Think of it as remixing a luxury gift box."
                            }),
                            $455d545b1dff00eb$var$k.jsx("button", {
                                onClick: e,
                                className: "w-full py-2.5 px-4 rounded-lg font-semibold text-sm transition-all duration-200 bg-[#FD99C5] text-white hover:bg-[#db2777] shadow-md hover:shadow-lg",
                                children: "I have read"
                            })
                        ]
                    })
                ]
            })
        })
    }) : null;
}
function $455d545b1dff00eb$var$O0() {
    const [a, e] = $455d545b1dff00eb$var$X.useState(()=>typeof window > "u" ? !1 : window.innerWidth < 768);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        const t = ()=>{
            e(window.innerWidth < 768);
        };
        return window.addEventListener("resize", t), ()=>window.removeEventListener("resize", t);
    }, []), a;
}
function $455d545b1dff00eb$var$v0({ className: a = "", baseSize: e = "text-4xl", supSize: t = "text-lg", strokeWidth: n = "2px", color: i, fontSize: r }) {
    const l = $455d545b1dff00eb$var$O0(), c = {
        fontWeight: 900,
        WebkitTextStroke: `${n} black`,
        WebkitTextFillColor: i || "black",
        paintOrder: "stroke fill"
    };
    r && (c.fontSize = r);
    const f = {
        fontWeight: 600,
        WebkitTextStroke: `${n} black`,
        WebkitTextFillColor: i || "black",
        paintOrder: "stroke fill"
    };
    return $455d545b1dff00eb$var$k.jsxs("span", {
        className: `${e} relative tracking-wide font-nickainley ${a}`,
        style: {
            ...c,
            display: "inline-block",
            textAlign: "center",
            lineHeight: 1
        },
        children: [
            "x",
            $455d545b1dff00eb$var$k.jsx("sup", {
                className: `${t} relative ${l ? "top-[-0.7em]" : "top-[-1em]"} left-[0.3em] tracking-wide font-nickainley`,
                style: {
                    ...f,
                    lineHeight: 0
                },
                children: "2"
            })
        ]
    });
}
var $9f0a41d13e21f34e$exports = {};
$9f0a41d13e21f34e$exports = new URL("../../Nickainley-BuWKc7LA.3ba7586e.ttf", import.meta.url).toString();


const $455d545b1dff00eb$var$Dd = "" + new URL($9f0a41d13e21f34e$exports).href;
function $455d545b1dff00eb$var$N6(a, e, t) {
    const n = [];
    let i = 0;
    const r = [
        ...e
    ].sort((f, p)=>p.length - f.length), l = [];
    r.forEach((f)=>{
        const p = new RegExp(f.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
        let m;
        for(; (m = p.exec(a)) !== null;)l.push({
            start: m.index,
            end: m.index + m[0].length,
            text: m[0]
        });
    }), l.sort((f, p)=>f.start - p.start);
    const c = [];
    return l.forEach((f)=>{
        c.some((m)=>f.start < m.end && f.end > m.start) || c.push(f);
    }), c.forEach((f)=>{
        f.start > i && n.push({
            text: a.substring(i, f.start),
            isHighlight: !1
        }), n.push({
            text: f.text,
            isHighlight: !0
        }), i = f.end;
    }), i < a.length && n.push({
        text: a.substring(i),
        isHighlight: !1
    }), n.length === 0 ? [
        a
    ] : n.map((f, p)=>f.isHighlight ? $455d545b1dff00eb$var$k.jsx("span", {
            className: "font-bold",
            style: {
                color: t
            },
            children: f.text
        }, p) : f.text);
}
function $455d545b1dff00eb$var$O6({ tips: a, currentTip: e, isTipTransitioning: t, onNext: n, onPrev: i, onTipChange: r }) {
    const l = Array.isArray(a) && a.length > 0 && typeof a[0] == "string", c = (S)=>[
            [
                $455d545b1dff00eb$var$wt.sunshineYellow,
                $455d545b1dff00eb$var$wt.coralGlow
            ],
            [
                $455d545b1dff00eb$var$wt.aquaBlue,
                $455d545b1dff00eb$var$wt.electricBlue
            ],
            [
                $455d545b1dff00eb$var$wt.blushPink,
                $455d545b1dff00eb$var$wt.petalPink
            ],
            [
                $455d545b1dff00eb$var$wt.sunshineYellow,
                $455d545b1dff00eb$var$wt.blushPink
            ],
            [
                $455d545b1dff00eb$var$wt.aquaBlue,
                $455d545b1dff00eb$var$wt.coralGlow
            ],
            [
                $455d545b1dff00eb$var$wt.electricBlue,
                $455d545b1dff00eb$var$wt.petalPink
            ],
            [
                $455d545b1dff00eb$var$wt.coralGlow,
                $455d545b1dff00eb$var$wt.energyRed
            ],
            [
                $455d545b1dff00eb$var$wt.sunshineYellow,
                $455d545b1dff00eb$var$wt.aquaBlue
            ],
            [
                $455d545b1dff00eb$var$wt.blushPink,
                $455d545b1dff00eb$var$wt.electricBlue
            ],
            [
                $455d545b1dff00eb$var$wt.petalPink,
                $455d545b1dff00eb$var$wt.coralGlow
            ]
        ][S % 10], f = l ? null : a[e], p = l ? c(e) : f?.accent || null, m = p ? `linear-gradient(135deg, ${p[0]}, ${p[1]})` : null, x = p ? `linear-gradient(135deg, ${p[0]}, ${p[1]})` : null, v = $455d545b1dff00eb$var$X.useCallback((S)=>{
        !t && S !== e && r(S);
    }, [
        t,
        e,
        r
    ]), _ = $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "relative overflow-hidden",
                style: {
                    minHeight: "80px"
                },
                children: l ? a.map((S, A)=>$455d545b1dff00eb$var$k.jsxs("div", {
                        className: `absolute inset-0 ${A === e ? "opacity-100 relative" : "opacity-0 pointer-events-none"}`,
                        children: [
                            $455d545b1dff00eb$var$k.jsx("div", {
                                className: "html-content text-gray-800",
                                dangerouslySetInnerHTML: {
                                    __html: S
                                }
                            }),
                            $455d545b1dff00eb$var$k.jsx("style", {
                                children: `
                .html-content h3,
                .html-content h4 {
                  font-weight: 700;
                  color: #000000;
                  margin-top: 0;
                }
                .html-content h3 {
                  font-size: 1.125rem;
                  line-height: 1.75rem;
                }
              `
                            })
                        ]
                    }, A)) : a.map((S, A)=>$455d545b1dff00eb$var$k.jsxs("div", {
                        className: `absolute inset-0 ${A === e ? "opacity-100 relative" : "opacity-0 pointer-events-none"}`,
                        children: [
                            $455d545b1dff00eb$var$k.jsx("h1", {
                                className: "text-base md:text-xl font-bold text-black mb-2",
                                children: "Whilst Checking This Theorem..."
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "flex items-start gap-2",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("span", {
                                        className: "text-xl md:text-2xl flex-shrink-0",
                                        children: S.icon
                                    }),
                                    $455d545b1dff00eb$var$k.jsx("p", {
                                        className: "text-sm md:text-base text-gray-800 leading-relaxed",
                                        children: $455d545b1dff00eb$var$N6(S.content, S.highlights, S.accent[0])
                                    })
                                ]
                            })
                        ]
                    }, A))
            }),
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "flex items-center justify-center gap-3 mt-4",
                children: [
                    $455d545b1dff00eb$var$k.jsx("button", {
                        onClick: i,
                        disabled: e === 0 || t,
                        className: "flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-white/90 hover:bg-white border-2 border-gray-300 hover:border-[#FD99C5] flex items-center justify-center transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-sm hover:shadow-md",
                        "aria-label": "Previous tip",
                        children: $455d545b1dff00eb$var$k.jsx("svg", {
                            className: "w-3 h-3 md:w-4 md:h-4 text-gray-700",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            children: $455d545b1dff00eb$var$k.jsx("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2.5,
                                d: "M15 19l-7-7 7-7"
                            })
                        })
                    }),
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: "flex items-center gap-2",
                        children: a.map((S, A)=>$455d545b1dff00eb$var$k.jsx("button", {
                                onClick: ()=>v(A),
                                className: "group relative",
                                disabled: t,
                                "aria-label": `Go to tip ${A + 1}`,
                                children: $455d545b1dff00eb$var$k.jsx("span", {
                                    className: `block rounded-full transition-all duration-300 ${A === e ? "bg-[#FD99C5]" : "border-2 border-[#FD99C5] bg-transparent"}`,
                                    style: {
                                        width: "12px",
                                        height: "12px"
                                    }
                                })
                            }, A))
                    }),
                    $455d545b1dff00eb$var$k.jsx("button", {
                        onClick: n,
                        disabled: e === a.length - 1 || t,
                        className: "flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-white/90 hover:bg-white border-2 border-gray-300 hover:border-[#FD99C5] flex items-center justify-center transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-sm hover:shadow-md",
                        "aria-label": "Next tip",
                        children: $455d545b1dff00eb$var$k.jsx("svg", {
                            className: "w-3 h-3 md:w-4 md:h-4 text-gray-700",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            children: $455d545b1dff00eb$var$k.jsx("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2.5,
                                d: "M9 5l7 7-7 7"
                            })
                        })
                    })
                ]
            })
        ]
    });
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "w-full",
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: "flex items-center",
            children: x ? $455d545b1dff00eb$var$k.jsx("div", {
                className: "flex-1 rounded-lg md:rounded-xl p-[4px] min-w-0",
                style: {
                    background: x,
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
                },
                children: $455d545b1dff00eb$var$k.jsxs("div", {
                    className: "w-full h-full rounded-lg md:rounded-xl px-3 md:px-5 py-2 md:py-4 relative",
                    style: {
                        background: m || void 0
                    },
                    children: [
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: "absolute inset-0 rounded-lg md:rounded-xl pointer-events-none",
                            style: {
                                backgroundColor: "rgb(255 255 255 / 0.95)"
                            }
                        }),
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: "relative z-10",
                            children: _
                        })
                    ]
                })
            }) : $455d545b1dff00eb$var$k.jsx("div", {
                className: "flex-1 rounded-lg md:rounded-xl border-2 px-3 md:px-5 py-2 md:py-4 bg-white min-w-0",
                style: {
                    borderColor: "#000000",
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
                },
                children: _
            })
        })
    });
}
function $455d545b1dff00eb$var$L6({ isGameStarted: a, loadingProgress: e, isLoading: t, onStartGame: n }) {
    return a ? null : $455d545b1dff00eb$var$k.jsxs("div", {
        className: "fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white",
        style: {
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)"
        },
        children: [
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "mb-8 md:mb-12 flex items-center justify-center",
                children: $455d545b1dff00eb$var$k.jsx("img", {
                    src: "/static/images/logo-small.png",
                    alt: "My Maths Cloud",
                    className: "w-auto h-24 md:h-32 lg:h-40 object-contain",
                    style: {
                        maxWidth: "min(80vw, 400px)"
                    }
                })
            }),
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "w-full max-w-xs px-4 md:px-8 flex flex-col items-center",
                children: [
                    e < 100 && $455d545b1dff00eb$var$k.jsx("div", {
                        className: "w-full h-6 md:h-6 rounded-md overflow-hidden shadow-inner",
                        style: {
                            backgroundColor: "#EFEFEF",
                            maxWidth: "150px"
                        },
                        children: $455d545b1dff00eb$var$k.jsx("div", {
                            className: "h-full rounded-md transition-all duration-75 ease-out",
                            style: {
                                width: `${e}%`,
                                background: "linear-gradient(135deg, #21D4FE, #23d4ff)",
                                transition: "width 0.1s ease-out"
                            }
                        })
                    }),
                    e === 100 && !t && $455d545b1dff00eb$var$k.jsx("button", {
                        type: "button",
                        onClick: n,
                        className: "w-full h-8 rounded-md font-semibold text-sm shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl active:scale-95 cursor-pointer flex items-center justify-center gap-2",
                        style: {
                            background: "#23d4ff",
                            color: "#ffffff",
                            fontWeight: 600,
                            maxWidth: "200px"
                        },
                        children: "Start Game"
                    })
                ]
            })
        ]
    });
}
function $455d545b1dff00eb$var$cw() {
    const [a, e] = $455d545b1dff00eb$var$X.useState(()=>typeof window > "u" ? 1200 : window.innerWidth);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        const t = ()=>{
            e(window.innerWidth);
        };
        return window.addEventListener("resize", t), ()=>window.removeEventListener("resize", t);
    }, []), a;
}
const $455d545b1dff00eb$var$nE = "unfolding_of_a_cube_video", $455d545b1dff00eb$var$iE = "surface_area_of_a_cube_video";
function $455d545b1dff00eb$var$uw({ viewMode: a }) {
    const e = $455d545b1dff00eb$var$X.useMemo(()=>{
        if (typeof window > "u") return {
            unfolding: null,
            surfaceArea: null
        };
        const n = window.location.hash;
        if (!n) return {
            unfolding: null,
            surfaceArea: null
        };
        const i = n.indexOf("?");
        if (i === -1) return {
            unfolding: null,
            surfaceArea: null
        };
        const r = n.substring(i + 1);
        if (!r) return {
            unfolding: null,
            surfaceArea: null
        };
        try {
            const l = new URLSearchParams(r);
            return {
                unfolding: l.get($455d545b1dff00eb$var$nE) ? decodeURIComponent(l.get($455d545b1dff00eb$var$nE)) : null,
                surfaceArea: l.get($455d545b1dff00eb$var$iE) ? decodeURIComponent(l.get($455d545b1dff00eb$var$iE)) : null
            };
        } catch  {
            return {
                unfolding: null,
                surfaceArea: null
            };
        }
    }, []);
    return {
        currentVideoUrl: a === "unfolding" ? e.unfolding : e.surfaceArea,
        videoUrls: e
    };
}
const $455d545b1dff00eb$var$fw = $455d545b1dff00eb$var$X.createContext(void 0);
function $455d545b1dff00eb$var$hw() {
    const a = $455d545b1dff00eb$var$X.useContext($455d545b1dff00eb$var$fw);
    if (a === void 0) throw new Error("useViewMode must be used within a ViewModeProvider");
    return a;
}
function $455d545b1dff00eb$var$dw(a, e) {
    const t = a * Math.PI / 180, n = e * Math.PI / 180, i = t - .1, r = n + .35, l = [
        new $455d545b1dff00eb$var$J(0, 0, 1),
        new $455d545b1dff00eb$var$J(0, 0, -1),
        new $455d545b1dff00eb$var$J(0, 1, 0),
        new $455d545b1dff00eb$var$J(0, -1, 0),
        new $455d545b1dff00eb$var$J(1, 0, 0),
        new $455d545b1dff00eb$var$J(-1, 0, 0)
    ], c = [
        new $455d545b1dff00eb$var$J(0, 0, 1),
        new $455d545b1dff00eb$var$J(0, 0, -1),
        new $455d545b1dff00eb$var$J(0, 1, 0),
        new $455d545b1dff00eb$var$J(0, -1, 0),
        new $455d545b1dff00eb$var$J(1, 0, 0),
        new $455d545b1dff00eb$var$J(-1, 0, 0)
    ], f = new $455d545b1dff00eb$var$Ft().makeRotationFromEuler(new $455d545b1dff00eb$var$ua(i, r, 0, "XYZ")), p = c.map((x)=>x.clone().applyMatrix4(f).normalize()), m = [];
    for (const x of l){
        let v = -1 / 0, _ = 0;
        for(let S = 0; S < p.length; S++){
            const A = p[S].dot(x);
            A > v && (v = A, _ = S);
        }
        m.push(_);
    }
    return m;
}
function $455d545b1dff00eb$var$aE(a, e, t, n, i, r, l) {
    return new Promise((c)=>{
        const f = performance.now(), p = new $455d545b1dff00eb$var$ua($455d545b1dff00eb$var$Of.degToRad(a) - .1, $455d545b1dff00eb$var$Of.degToRad(e) + .35, 0, "XYZ"), m = new $455d545b1dff00eb$var$ua($455d545b1dff00eb$var$Of.degToRad(t) - .1, $455d545b1dff00eb$var$Of.degToRad(n) + .35, 0, "XYZ"), x = new $455d545b1dff00eb$var$Gn().setFromEuler(p), v = new $455d545b1dff00eb$var$Gn().setFromEuler(m), _ = new $455d545b1dff00eb$var$Gn, S = new $455d545b1dff00eb$var$ua, A = (M)=>{
            if (l?.()) {
                c();
                return;
            }
            const b = M - f, C = Math.min(b / i, 1), R = $455d545b1dff00eb$var$iI(C);
            _.slerpQuaternions(x, v, R), S.setFromQuaternion(_, "XYZ");
            const N = $455d545b1dff00eb$var$Of.radToDeg(S.x + .1), z = $455d545b1dff00eb$var$Of.radToDeg(S.y - .35);
            r(N, z), C < 1 ? requestAnimationFrame(A) : c();
        };
        requestAnimationFrame(A);
    });
}
const $455d545b1dff00eb$var$Ud = new $455d545b1dff00eb$var$ml, $455d545b1dff00eb$var$gc = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$pw = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$V_ = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$$x = new $455d545b1dff00eb$var$$e, $455d545b1dff00eb$var$Yv = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$Sb = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$mw = new $455d545b1dff00eb$var$Ft, $455d545b1dff00eb$var$gw = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$xw = new $455d545b1dff00eb$var$J;
let $455d545b1dff00eb$var$ir = null, $455d545b1dff00eb$var$pl = null;
const $455d545b1dff00eb$var$xc = [], $455d545b1dff00eb$var$Su = {
    NONE: -1,
    PAN: 0,
    ROTATE: 1
};
class $455d545b1dff00eb$var$z6 extends $455d545b1dff00eb$var$_A {
    constructor(e, t, n = null){
        super(t, n), this.objects = e, this.recursive = !0, this.transformGroup = !1, this.rotateSpeed = 1, this.raycaster = new $455d545b1dff00eb$var$dS, this.mouseButtons = {
            LEFT: $455d545b1dff00eb$var$Xs.PAN,
            MIDDLE: $455d545b1dff00eb$var$Xs.PAN,
            RIGHT: $455d545b1dff00eb$var$Xs.ROTATE
        }, this.touches = {
            ONE: $455d545b1dff00eb$var$Zr.PAN
        }, this._onPointerMove = $455d545b1dff00eb$var$P6.bind(this), this._onPointerDown = $455d545b1dff00eb$var$B6.bind(this), this._onPointerCancel = $455d545b1dff00eb$var$I6.bind(this), this._onContextMenu = $455d545b1dff00eb$var$F6.bind(this), n !== null && this.connect(n);
    }
    connect(e) {
        super.connect(e), this.domElement.addEventListener("pointermove", this._onPointerMove), this.domElement.addEventListener("pointerdown", this._onPointerDown), this.domElement.addEventListener("pointerup", this._onPointerCancel), this.domElement.addEventListener("pointerleave", this._onPointerCancel), this.domElement.addEventListener("contextmenu", this._onContextMenu), this.domElement.style.touchAction = "none";
    }
    disconnect() {
        this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerdown", this._onPointerDown), this.domElement.removeEventListener("pointerup", this._onPointerCancel), this.domElement.removeEventListener("pointerleave", this._onPointerCancel), this.domElement.removeEventListener("contextmenu", this._onContextMenu), this.domElement.style.touchAction = "auto", this.domElement.style.cursor = "";
    }
    dispose() {
        this.disconnect();
    }
    _updatePointer(e) {
        const t = this.domElement.getBoundingClientRect();
        $455d545b1dff00eb$var$gc.x = (e.clientX - t.left) / t.width * 2 - 1, $455d545b1dff00eb$var$gc.y = -(e.clientY - t.top) / t.height * 2 + 1;
    }
    _updateState(e) {
        let t;
        if (e.pointerType === "touch") t = this.touches.ONE;
        else switch(e.button){
            case 0:
                t = this.mouseButtons.LEFT;
                break;
            case 1:
                t = this.mouseButtons.MIDDLE;
                break;
            case 2:
                t = this.mouseButtons.RIGHT;
                break;
            default:
                t = null;
        }
        switch(t){
            case $455d545b1dff00eb$var$Xs.PAN:
            case $455d545b1dff00eb$var$Zr.PAN:
                this.state = $455d545b1dff00eb$var$Su.PAN;
                break;
            case $455d545b1dff00eb$var$Xs.ROTATE:
            case $455d545b1dff00eb$var$Zr.ROTATE:
                this.state = $455d545b1dff00eb$var$Su.ROTATE;
                break;
            default:
                this.state = $455d545b1dff00eb$var$Su.NONE;
        }
    }
}
function $455d545b1dff00eb$var$P6(a) {
    const e = this.object, t = this.domElement, n = this.raycaster;
    if (this.enabled !== !1) {
        if (this._updatePointer(a), n.setFromCamera($455d545b1dff00eb$var$gc, e), $455d545b1dff00eb$var$ir) this.state === $455d545b1dff00eb$var$Su.PAN ? n.ray.intersectPlane($455d545b1dff00eb$var$Ud, $455d545b1dff00eb$var$Yv) && ($455d545b1dff00eb$var$ir.position.copy($455d545b1dff00eb$var$Yv.sub($455d545b1dff00eb$var$pw).applyMatrix4($455d545b1dff00eb$var$mw)), this.dispatchEvent({
            type: "drag",
            object: $455d545b1dff00eb$var$ir
        })) : this.state === $455d545b1dff00eb$var$Su.ROTATE && ($455d545b1dff00eb$var$V_.subVectors($455d545b1dff00eb$var$gc, $455d545b1dff00eb$var$$x).multiplyScalar(this.rotateSpeed), $455d545b1dff00eb$var$ir.rotateOnWorldAxis($455d545b1dff00eb$var$gw, $455d545b1dff00eb$var$V_.x), $455d545b1dff00eb$var$ir.rotateOnWorldAxis($455d545b1dff00eb$var$xw.normalize(), -$455d545b1dff00eb$var$V_.y), this.dispatchEvent({
            type: "drag",
            object: $455d545b1dff00eb$var$ir
        })), $455d545b1dff00eb$var$$x.copy($455d545b1dff00eb$var$gc);
        else if (a.pointerType === "mouse" || a.pointerType === "pen") {
            if ($455d545b1dff00eb$var$xc.length = 0, n.setFromCamera($455d545b1dff00eb$var$gc, e), n.intersectObjects(this.objects, this.recursive, $455d545b1dff00eb$var$xc), $455d545b1dff00eb$var$xc.length > 0) {
                const i = $455d545b1dff00eb$var$xc[0].object;
                $455d545b1dff00eb$var$Ud.setFromNormalAndCoplanarPoint(e.getWorldDirection($455d545b1dff00eb$var$Ud.normal), $455d545b1dff00eb$var$Sb.setFromMatrixPosition(i.matrixWorld)), $455d545b1dff00eb$var$pl !== i && $455d545b1dff00eb$var$pl !== null && (this.dispatchEvent({
                    type: "hoveroff",
                    object: $455d545b1dff00eb$var$pl
                }), t.style.cursor = "auto", $455d545b1dff00eb$var$pl = null), $455d545b1dff00eb$var$pl !== i && (this.dispatchEvent({
                    type: "hoveron",
                    object: i
                }), t.style.cursor = "pointer", $455d545b1dff00eb$var$pl = i);
            } else $455d545b1dff00eb$var$pl !== null && (this.dispatchEvent({
                type: "hoveroff",
                object: $455d545b1dff00eb$var$pl
            }), t.style.cursor = "auto", $455d545b1dff00eb$var$pl = null);
        }
        $455d545b1dff00eb$var$$x.copy($455d545b1dff00eb$var$gc);
    }
}
function $455d545b1dff00eb$var$B6(a) {
    const e = this.object, t = this.domElement, n = this.raycaster;
    this.enabled !== !1 && (this._updatePointer(a), this._updateState(a), $455d545b1dff00eb$var$xc.length = 0, n.setFromCamera($455d545b1dff00eb$var$gc, e), n.intersectObjects(this.objects, this.recursive, $455d545b1dff00eb$var$xc), $455d545b1dff00eb$var$xc.length > 0 && (this.transformGroup === !0 ? $455d545b1dff00eb$var$ir = $455d545b1dff00eb$var$vw($455d545b1dff00eb$var$xc[0].object) : $455d545b1dff00eb$var$ir = $455d545b1dff00eb$var$xc[0].object, $455d545b1dff00eb$var$Ud.setFromNormalAndCoplanarPoint(e.getWorldDirection($455d545b1dff00eb$var$Ud.normal), $455d545b1dff00eb$var$Sb.setFromMatrixPosition($455d545b1dff00eb$var$ir.matrixWorld)), n.ray.intersectPlane($455d545b1dff00eb$var$Ud, $455d545b1dff00eb$var$Yv) && (this.state === $455d545b1dff00eb$var$Su.PAN ? ($455d545b1dff00eb$var$mw.copy($455d545b1dff00eb$var$ir.parent.matrixWorld).invert(), $455d545b1dff00eb$var$pw.copy($455d545b1dff00eb$var$Yv).sub($455d545b1dff00eb$var$Sb.setFromMatrixPosition($455d545b1dff00eb$var$ir.matrixWorld)), t.style.cursor = "move", this.dispatchEvent({
        type: "dragstart",
        object: $455d545b1dff00eb$var$ir
    })) : this.state === $455d545b1dff00eb$var$Su.ROTATE && ($455d545b1dff00eb$var$gw.set(0, 1, 0).applyQuaternion(e.quaternion).normalize(), $455d545b1dff00eb$var$xw.set(1, 0, 0).applyQuaternion(e.quaternion).normalize(), t.style.cursor = "move", this.dispatchEvent({
        type: "dragstart",
        object: $455d545b1dff00eb$var$ir
    })))), $455d545b1dff00eb$var$$x.copy($455d545b1dff00eb$var$gc));
}
function $455d545b1dff00eb$var$I6() {
    this.enabled !== !1 && ($455d545b1dff00eb$var$ir && (this.dispatchEvent({
        type: "dragend",
        object: $455d545b1dff00eb$var$ir
    }), $455d545b1dff00eb$var$ir = null), this.domElement.style.cursor = $455d545b1dff00eb$var$pl ? "pointer" : "auto", this.state = $455d545b1dff00eb$var$Su.NONE);
}
function $455d545b1dff00eb$var$F6(a) {
    this.enabled !== !1 && a.preventDefault();
}
function $455d545b1dff00eb$var$vw(a, e = null) {
    return a.isGroup && (e = a), a.parent === null ? e : $455d545b1dff00eb$var$vw(a.parent, e);
}
function $455d545b1dff00eb$var$H6({ objects: a, onDragStart: e, onDrag: t, onDragEnd: n, enabled: i = !0 }) {
    const { camera: r, gl: l } = $455d545b1dff00eb$var$Ei(), c = $455d545b1dff00eb$var$X.useRef(null), f = $455d545b1dff00eb$var$X.useRef(e), p = $455d545b1dff00eb$var$X.useRef(t), m = $455d545b1dff00eb$var$X.useRef(n);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        f.current = e, p.current = t, m.current = n;
    }, [
        e,
        t,
        n
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        c.current && (c.current.objects = a);
    }, [
        a
    ]), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!i || a.length === 0) {
            c.current && (c.current.dispose(), c.current = null);
            return;
        }
        if (!c.current) {
            const x = new $455d545b1dff00eb$var$z6(a, r, l.domElement);
            c.current = x;
            const v = (A)=>{
                f.current?.(A.object);
            }, _ = (A)=>{
                p.current?.(A.object);
            }, S = (A)=>{
                m.current?.(A.object);
            };
            x.addEventListener("dragstart", v), x.addEventListener("drag", _), x.addEventListener("dragend", S);
        }
        return ()=>{};
    }, [
        r,
        l,
        i
    ]), $455d545b1dff00eb$var$X.useEffect(()=>()=>{
            c.current && (c.current.dispose(), c.current = null);
        }, []);
}
function $455d545b1dff00eb$var$V6({ size: a }) {
    return $455d545b1dff00eb$var$k.jsxs("lineSegments", {
        children: [
            $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                args: [
                    new $455d545b1dff00eb$var$Ru(a, a, a)
                ]
            }),
            $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                color: "#000000",
                linewidth: 4
            })
        ]
    });
}
function $455d545b1dff00eb$var$G6({ size: a, widthLabelRef: e, heightLabelRef: t, depthLabelRef: n }) {
    const i = a * .3, r = a * .006;
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$B_, {
                ref: e,
                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                    fontSize: i,
                    color: "#000000",
                    anchorX: "center",
                    anchorY: "middle",
                    fontWeight: "bold",
                    font: $455d545b1dff00eb$var$Dd,
                    outlineWidth: r,
                    outlineColor: "#000000",
                    children: "x"
                })
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$B_, {
                ref: t,
                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                    fontSize: i,
                    color: "#000000",
                    anchorX: "center",
                    anchorY: "middle",
                    fontWeight: "bold",
                    font: $455d545b1dff00eb$var$Dd,
                    outlineWidth: r,
                    outlineColor: "#000000",
                    children: "x"
                })
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$B_, {
                ref: n,
                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                    fontSize: i,
                    color: "#000000",
                    anchorX: "center",
                    anchorY: "middle",
                    fontWeight: "bold",
                    font: $455d545b1dff00eb$var$Dd,
                    outlineWidth: r,
                    outlineColor: "#000000",
                    children: "x"
                })
            })
        ]
    });
}
function $455d545b1dff00eb$var$k6({ size: a, droppedFaces: e, droppedFacesGroupRef: t, faceMeshesRef: n, animatingFacesRef: i, originalFacePositionsRef: r, onFaceDropped: l }) {
    const c = $455d545b1dff00eb$var$X.useCallback((f)=>{
        const p = n.current[f], m = t?.current;
        if (!p || !m) return;
        const x = e.size, v = .75, _ = Math.floor(x / 3), A = (x % 3 - 1) * v, M = (_ - .5) * v, b = .01, C = new $455d545b1dff00eb$var$J(A, M, b), R = new $455d545b1dff00eb$var$Gn().setFromEuler(new $455d545b1dff00eb$var$ua(0, 0, 0)), N = .6, z = new $455d545b1dff00eb$var$J(N / a, N / a, 1), L = p.getWorldPosition(new $455d545b1dff00eb$var$J), P = p.getWorldQuaternion(new $455d545b1dff00eb$var$Gn), H = p.getWorldScale(new $455d545b1dff00eb$var$J), O = p.geometry.clone(), D = p.material.clone(), j = new $455d545b1dff00eb$var$zi(O, D);
        j.position.copy(L), j.quaternion.copy(P), j.scale.copy(H), m.add(j);
        const G = m.worldToLocal(L.clone()), Y = m.getWorldQuaternion(new $455d545b1dff00eb$var$Gn).invert().multiply(P);
        j.position.copy(G), j.quaternion.copy(Y), p.visible = !1, i.current.set(f, {
            startPos: G,
            targetPos: C,
            startQuat: Y,
            targetQuat: R,
            startScale: H.clone(),
            targetScale: z,
            progress: 0,
            proxyMesh: j
        }), l?.(f);
    }, [
        a,
        e,
        t,
        n,
        i,
        r,
        l
    ]);
    return $455d545b1dff00eb$var$Zs((f, p)=>{
        i.current.forEach((m, x)=>{
            const v = m.proxyMesh || n.current[x];
            if (v && (m.progress = Math.min(1, m.progress + p * 2.5), v.position.lerpVectors(m.startPos, m.targetPos, m.progress), v.quaternion.copy(m.startQuat.clone().slerp(m.targetQuat, m.progress)), v.scale.lerpVectors(m.startScale, m.targetScale, m.progress), m.progress >= 1)) {
                if (m.proxyMesh) {
                    const _ = m.proxyMesh;
                    _.parent?.remove(_), _.geometry.dispose(), _.material.dispose(), l?.(x), r.current.set(x, {
                        position: m.targetPos.clone(),
                        quaternion: m.targetQuat.clone(),
                        scale: m.targetScale.clone(),
                        parent: v.parent
                    });
                }
                i.current.delete(x);
            }
        });
    }), c;
}
const $455d545b1dff00eb$var$j6 = .001;
function $455d545b1dff00eb$var$X6(a) {
    const e = a / 2, t = $455d545b1dff00eb$var$j6;
    return $455d545b1dff00eb$var$X.useMemo(()=>[
            {
                position: [
                    0,
                    0,
                    e + t
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                index: 0,
                normal: new $455d545b1dff00eb$var$J(0, 0, 1)
            },
            {
                position: [
                    0,
                    0,
                    -e - t
                ],
                rotation: [
                    0,
                    Math.PI,
                    0
                ],
                index: 1,
                normal: new $455d545b1dff00eb$var$J(0, 0, -1)
            },
            {
                position: [
                    0,
                    e + t,
                    0
                ],
                rotation: [
                    -Math.PI / 2,
                    0,
                    0
                ],
                index: 2,
                normal: new $455d545b1dff00eb$var$J(0, 1, 0)
            },
            {
                position: [
                    0,
                    -e - t,
                    0
                ],
                rotation: [
                    Math.PI / 2,
                    0,
                    0
                ],
                index: 3,
                normal: new $455d545b1dff00eb$var$J(0, -1, 0)
            },
            {
                position: [
                    e + t,
                    0,
                    0
                ],
                rotation: [
                    0,
                    Math.PI / 2,
                    0
                ],
                index: 4,
                normal: new $455d545b1dff00eb$var$J(1, 0, 0)
            },
            {
                position: [
                    -e - t,
                    0,
                    0
                ],
                rotation: [
                    0,
                    -Math.PI / 2,
                    0
                ],
                index: 5,
                normal: new $455d545b1dff00eb$var$J(-1, 0, 0)
            }
        ], [
        e,
        t
    ]);
}
const $455d545b1dff00eb$var$W6 = new $455d545b1dff00eb$var$J, $455d545b1dff00eb$var$rE = new $455d545b1dff00eb$var$Ft;
function $455d545b1dff00eb$var$G_(a, e, t, n, i) {
    if (!e.current || !a.current) return;
    const r = n / 2, l = n * .25, c = .15;
    let f = 0, p = 0, m = -1 / 0;
    [
        [
            -1,
            1
        ],
        [
            1,
            1
        ],
        [
            -1,
            -1
        ],
        [
            1,
            -1
        ]
    ].forEach(([S, A])=>{
        const M = new $455d545b1dff00eb$var$J;
        t === "x" ? M.set(0, S * r, A * r) : t === "y" ? M.set(S * r, 0, A * r) : M.set(S * r, A * r, 0);
        const C = M.clone().applyMatrix4(a.current.matrixWorld).applyMatrix4(i.matrixWorldInverse);
        let R = 0;
        R += C.z * 1, t === "y" ? (R += Math.abs(C.x) * 10, C.x < 0 && (R += r * 5)) : t === "x" ? (R += Math.abs(C.y) * 10, C.y < 0 && (R += r * 2)) : (R += (Math.abs(C.x) + Math.abs(C.y)) * 5, C.x > 0 && (R += r * 1), C.y < 0 && (R += r * 1)), R > m && (m = R, f = S, p = A);
    });
    const v = new $455d545b1dff00eb$var$J;
    t === "x" ? v.set(0, f * r, p * r) : t === "y" ? v.set(f * r, 0, p * r) : v.set(f * r, p * r, 0);
    const _ = v.clone().normalize().multiplyScalar(l);
    v.add(_), e.current.position.lerp(v, c);
}
function $455d545b1dff00eb$var$q6({ cubeGroupRef: a, widthLabelRef: e, heightLabelRef: t, depthLabelRef: n, size: i, showLabels: r }) {
    $455d545b1dff00eb$var$Zs(({ camera: l })=>{
        !r || !a.current || ($455d545b1dff00eb$var$rE.copy(a.current.matrixWorld).invert(), $455d545b1dff00eb$var$W6.copy(l.position).applyMatrix4($455d545b1dff00eb$var$rE), $455d545b1dff00eb$var$G_(a, e, "x", i, l), $455d545b1dff00eb$var$G_(a, t, "y", i, l), $455d545b1dff00eb$var$G_(a, n, "z", i, l));
    });
}
const $455d545b1dff00eb$var$yw = $455d545b1dff00eb$var$X.forwardRef(({ size: a, showLabels: e, rotationX: t = 0, rotationY: n = 0, droppedFaces: i = new Set, draggable: r = !1, onFaceDragStart: l, onFaceDrag: c, onFaceDragEnd: f, showDropZone: p = !1, onFaceDropped: m, onFaceRemovedFromDropZone: x, dropZoneRef: v, droppedFacesGroupRef: _ }, S)=>{
    const A = t * Math.PI / 180, M = n * Math.PI / 180, b = $455d545b1dff00eb$var$X6(a), C = $455d545b1dff00eb$var$X.useRef(new Array(6).fill(null)), [R, N] = $455d545b1dff00eb$var$X.useState(!1), z = Array.from(i).sort().join(","), L = $455d545b1dff00eb$var$X.useRef(null), P = $455d545b1dff00eb$var$X.useRef(null), H = $455d545b1dff00eb$var$X.useRef(null), O = $455d545b1dff00eb$var$X.useRef(new Map), D = $455d545b1dff00eb$var$X.useRef(new Map), j = $455d545b1dff00eb$var$X.useRef(null), G = $455d545b1dff00eb$var$X.useRef(null), q = $455d545b1dff00eb$var$X.useRef(null), Y = $455d545b1dff00eb$var$X.useCallback(()=>{
        const $ = C.current.every((ee)=>ee !== null);
        N($);
    }, []);
    $455d545b1dff00eb$var$X.useEffect(()=>(Y(), ()=>{
            P.current && clearTimeout(P.current);
        }), [
        Y
    ]);
    const ae = $455d545b1dff00eb$var$k6({
        size: a,
        droppedFaces: i,
        droppedFacesGroupRef: _ ?? {
            current: null
        },
        faceMeshesRef: C,
        animatingFacesRef: D,
        originalFacePositionsRef: O,
        onFaceDropped: m
    });
    $455d545b1dff00eb$var$X.useImperativeHandle(S, ()=>({
            animateDropFace: ($)=>ae($),
            reset: ()=>{
                D.current.forEach(($)=>{
                    const ee = $.proxyMesh;
                    ee && (ee.parent?.remove(ee), ee.geometry.dispose(), ee.material.dispose());
                }), D.current.clear(), O.current.clear(), C.current.fill(null), H.current = null, N(!1);
            }
        }), [
        ae
    ]), $455d545b1dff00eb$var$q6({
        cubeGroupRef: L,
        widthLabelRef: j,
        heightLabelRef: G,
        depthLabelRef: q,
        size: a,
        showLabels: e
    });
    const F = $455d545b1dff00eb$var$X.useCallback(($, ee)=>{
        const I = O.current.get($);
        if (!I || !I.parent) return;
        ee.visible = !0;
        const Z = I.position.clone(), oe = I.quaternion.clone(), ce = I.scale.clone(), de = I.parent;
        if (ee.parent !== de) {
            const ue = ee.getWorldPosition(new $455d545b1dff00eb$var$J), le = ee.getWorldQuaternion(new $455d545b1dff00eb$var$Gn), xe = ee.getWorldScale(new $455d545b1dff00eb$var$J);
            ee.parent?.remove(ee), de.add(ee), ee.position.copy(de.worldToLocal(ue));
            const Le = de.getWorldQuaternion(new $455d545b1dff00eb$var$Gn).invert();
            ee.quaternion.copy(Le.multiply(le)), ee.scale.copy(xe);
        }
        D.current.set($, {
            startPos: ee.position.clone(),
            targetPos: Z,
            startQuat: ee.quaternion.clone(),
            targetQuat: oe,
            startScale: ee.scale.clone(),
            targetScale: ce,
            progress: 0
        });
    }, []), { camera: Q } = $455d545b1dff00eb$var$Ei(), K = $455d545b1dff00eb$var$X.useMemo(()=>!r || !R ? [] : C.current.filter(($, ee)=>!($ === null || D.current.has(ee))), [
        r,
        R,
        z,
        Q.position
    ]);
    return $455d545b1dff00eb$var$H6({
        objects: K,
        onDragStart: ($)=>{
            const ee = C.current.indexOf($);
            if (ee !== -1) {
                H.current = ee;
                const I = C.current[ee];
                if (I) {
                    O.current.has(ee) || O.current.set(ee, {
                        position: I.position.clone(),
                        quaternion: I.quaternion.clone(),
                        scale: I.scale.clone(),
                        parent: I.parent
                    }), I.scale.set(1.2, 1.2, 1.2);
                    const Z = I.material;
                    Z && (Z.color.set($455d545b1dff00eb$var$Ur[ee]), Z.opacity = .7, Z.transparent = !0, Z.visible = !0, Z.side = $455d545b1dff00eb$var$Ea, Z.needsUpdate = !0);
                }
                l?.(ee, $);
            }
        },
        onDrag: ($)=>{
            const ee = C.current.indexOf($);
            c?.(ee, $);
        },
        onDragEnd: ($)=>{
            const ee = C.current.indexOf($);
            if (ee !== -1) {
                H.current = null;
                const I = C.current[ee];
                if (I) {
                    I.scale.set(1, 1, 1);
                    const Z = I.material;
                    Z && (Z.opacity = .7, Z.transparent = !0, Z.needsUpdate = !0);
                }
                if (p && v?.current) {
                    const Z = new $455d545b1dff00eb$var$ca().setFromObject(v.current);
                    Z.expandByVector(new $455d545b1dff00eb$var$J(0, 0, 2));
                    const oe = $.getWorldPosition(new $455d545b1dff00eb$var$J), ce = i.has(ee);
                    Z.containsPoint(oe) ? ce || ae(ee) : (ce && x?.(ee), I && F(ee, I));
                } else I && F(ee, I);
                f?.(ee, $);
            }
        },
        enabled: r && K.length > 0
    }), $455d545b1dff00eb$var$k.jsx("group", {
        children: $455d545b1dff00eb$var$k.jsxs("group", {
            ref: L,
            rotation: [
                A - .1,
                M + .35,
                0
            ],
            children: [
                b.map(($)=>$455d545b1dff00eb$var$k.jsx("group", {
                        position: $.position,
                        rotation: $.rotation,
                        children: $455d545b1dff00eb$var$k.jsxs("mesh", {
                            position: [
                                0,
                                0,
                                -0.001
                            ],
                            children: [
                                $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                                    args: [
                                        a,
                                        a
                                    ]
                                }),
                                $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                                    color: $455d545b1dff00eb$var$Ur[$.index],
                                    side: $455d545b1dff00eb$var$Ea,
                                    transparent: !0,
                                    opacity: .45
                                })
                            ]
                        })
                    }, `inner-${$.index}`)),
                b.map(($)=>i.has($.index) ? null : $455d545b1dff00eb$var$k.jsx("group", {
                        position: $.position,
                        rotation: $.rotation,
                        children: $455d545b1dff00eb$var$k.jsxs("mesh", {
                            ref: (I)=>{
                                if (I) C.current[$.index] = I, I.scale.set(1, 1, 1), I.position.set(0, 0, 0), I.rotation.set(0, 0, 0), P.current && clearTimeout(P.current), P.current = setTimeout(()=>{
                                    Y();
                                }, 0);
                                else {
                                    const Z = C.current[$.index];
                                    Z && !Z.parent && (C.current[$.index] = null);
                                }
                            },
                            position: [
                                0,
                                0,
                                0
                            ],
                            rotation: [
                                0,
                                0,
                                0
                            ],
                            children: [
                                $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                                    args: [
                                        a * 1.002,
                                        a * 1.002
                                    ]
                                }),
                                $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                                    color: $455d545b1dff00eb$var$Ur[$.index],
                                    side: $455d545b1dff00eb$var$Ea,
                                    transparent: !0,
                                    opacity: .7
                                })
                            ]
                        })
                    }, `outer-${$.index}`)),
                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$V6, {
                    size: a
                }),
                e && $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$G6, {
                    size: a,
                    widthLabelRef: j,
                    heightLabelRef: G,
                    depthLabelRef: q
                })
            ]
        })
    });
});
$455d545b1dff00eb$var$yw.displayName = "DraggableCube";
function $455d545b1dff00eb$var$Y6() {
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
        position: [
            1e3,
            1e3,
            1e3
        ],
        fontSize: .1,
        font: $455d545b1dff00eb$var$Dd,
        visible: !1,
        children: "x"
    });
}
function $455d545b1dff00eb$var$Z6({ faceIndex: a, idx: e, zoneSize: t }) {
    const n = $455d545b1dff00eb$var$Ur[a], i = $455d545b1dff00eb$var$X.useRef(null), r = $455d545b1dff00eb$var$X.useRef(null), l = t / 4, c = l * 1.2, f = Math.floor(e / 3), m = (e % 3 - 1) * c, x = (f - .5) * c;
    $455d545b1dff00eb$var$Zs(({ clock: R })=>{
        if (i.current) {
            const N = Math.sin(R.getElapsedTime() * 2 + e * .5) * .15;
            i.current.position.set(m, x + N, .01);
        }
        r.current && (r.current.position.set(0, 0, .05), r.current.visible = !0);
    });
    const v = l * .6, _ = v * .5, S = v * .55, A = _ * .45, b = -(S + A) / 2, C = b + S;
    return $455d545b1dff00eb$var$k.jsxs("mesh", {
        ref: i,
        position: [
            m,
            x,
            .01
        ],
        rotation: [
            0,
            0,
            0
        ],
        children: [
            $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                args: [
                    l,
                    l
                ]
            }),
            $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                color: n,
                transparent: !0,
                opacity: .7
            }),
            $455d545b1dff00eb$var$k.jsxs("group", {
                ref: r,
                position: [
                    0,
                    0,
                    .05
                ],
                children: [
                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                        position: [
                            b,
                            0,
                            0
                        ],
                        fontSize: v,
                        font: $455d545b1dff00eb$var$Dd,
                        color: "#000000",
                        fillOpacity: 1,
                        visible: !0,
                        anchorX: "left",
                        anchorY: "middle",
                        fontWeight: "bold",
                        outlineWidth: .009,
                        outlineColor: "black",
                        outlineOpacity: 1,
                        children: "x"
                    }),
                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                        position: [
                            C,
                            v * .35,
                            0
                        ],
                        fontSize: _,
                        font: $455d545b1dff00eb$var$Dd,
                        color: "#000000",
                        fillOpacity: 1,
                        visible: !0,
                        anchorX: "left",
                        anchorY: "middle",
                        fontWeight: "bold",
                        outlineWidth: .009,
                        outlineColor: "black",
                        outlineOpacity: 1,
                        children: "2"
                    })
                ]
            })
        ]
    });
}
const $455d545b1dff00eb$var$_w = $455d545b1dff00eb$var$X.forwardRef(({ droppedFacesArray: a, droppedFacesGroupRef: e }, t)=>{
    const { size: n, viewport: i } = $455d545b1dff00eb$var$Ei(), r = $455d545b1dff00eb$var$O0(), c = 200 * (i.width / n.width);
    return $455d545b1dff00eb$var$k.jsxs("group", {
        position: [
            .1,
            0,
            0
        ],
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Y6, {}),
            $455d545b1dff00eb$var$k.jsxs("mesh", {
                ref: t,
                children: [
                    $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                        args: [
                            c,
                            c
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                        color: $455d545b1dff00eb$var$wt.blushPink,
                        transparent: !0,
                        opacity: .25,
                        side: $455d545b1dff00eb$var$Ea
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("lineSegments", {
                position: [
                    0,
                    .002,
                    0
                ],
                children: [
                    $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                        args: [
                            new $455d545b1dff00eb$var$Jr(c, c)
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                        color: $455d545b1dff00eb$var$wt.blushPink,
                        linewidth: 4
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("group", {
                position: [
                    0,
                    0,
                    .005
                ],
                children: [
                    $455d545b1dff00eb$var$k.jsxs("mesh", {
                        children: [
                            $455d545b1dff00eb$var$k.jsx("planeGeometry", {
                                args: [
                                    c * .4,
                                    c * .4
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("meshBasicMaterial", {
                                color: "#ffffff",
                                transparent: !0,
                                opacity: .3
                            })
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsxs("lineSegments", {
                        children: [
                            $455d545b1dff00eb$var$k.jsx("edgesGeometry", {
                                args: [
                                    new $455d545b1dff00eb$var$Jr(c * .4, c * .4)
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("lineBasicMaterial", {
                                color: "#000000",
                                transparent: !0,
                                opacity: .2,
                                linewidth: 1
                            })
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                        position: [
                            0,
                            c * .2 + .1,
                            .001
                        ],
                        fontSize: c * .05,
                        fontWeight: "bold",
                        color: "#000000",
                        fillOpacity: .3,
                        anchorX: "center",
                        anchorY: "bottom",
                        children: "Length"
                    }),
                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                        position: [
                            -c * .2 - .1,
                            0,
                            .001
                        ],
                        rotation: [
                            0,
                            0,
                            Math.PI / 2
                        ],
                        fontSize: c * .05,
                        fontWeight: "bold",
                        color: "#000000",
                        fillOpacity: .3,
                        anchorX: "center",
                        anchorY: "bottom",
                        children: "width"
                    })
                ]
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                position: [
                    0,
                    c / 2 + .3,
                    .02
                ],
                fontSize: c * .06,
                fontWeight: "bold",
                color: "#000000",
                fillOpacity: 1,
                anchorX: "center",
                anchorY: "middle",
                children: "Drop the folds here"
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$vl, {
                position: [
                    0,
                    -c / 2.6,
                    .02
                ],
                fontSize: c * .06,
                fontWeight: "bold",
                color: "#000000",
                fillOpacity: 1,
                anchorX: "center",
                anchorY: "top",
                children: "Area = Width \xd7 Length"
            }),
            $455d545b1dff00eb$var$k.jsx("group", {
                ref: e,
                children: a.map((f, p)=>$455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Z6, {
                        isMobileWidth: r,
                        faceIndex: f,
                        idx: p,
                        zoneSize: c
                    }, `${f}-${p}`))
            })
        ]
    });
});
$455d545b1dff00eb$var$_w.displayName = "ThreeJSDropZone";
function $455d545b1dff00eb$var$Q6() {
    const { camera: a } = $455d545b1dff00eb$var$Ei(), e = $455d545b1dff00eb$var$cw(), t = $455d545b1dff00eb$var$O0();
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        a.lookAt(t ? 0 : 2, 0, 0), a.updateProjectionMatrix();
    }, [
        a,
        e,
        t
    ]), null;
}
function $455d545b1dff00eb$var$K6({ cubeSize: a, showLabels: e, visualRotationX: t, visualRotationY: n, droppedFaces: i, draggable: r, showDropZone: l, isMobile: c, windowWidth: f, onFaceDragStart: p, onFaceDrag: m, onFaceDragEnd: x, onFaceDropped: v, onFaceRemovedFromDropZone: _, dropZoneRef: S, droppedFacesGroupRef: A, cubeRef: M }) {
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Q6, {}),
            $455d545b1dff00eb$var$k.jsx("ambientLight", {
                intensity: 1.5
            }),
            $455d545b1dff00eb$var$k.jsx("directionalLight", {
                position: [
                    5,
                    5,
                    5
                ],
                intensity: 2
            }),
            $455d545b1dff00eb$var$k.jsx("directionalLight", {
                position: [
                    -5,
                    -5,
                    -5
                ],
                intensity: 1
            }),
            $455d545b1dff00eb$var$k.jsx("pointLight", {
                position: [
                    0,
                    0,
                    0
                ],
                intensity: .5
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$yw, {
                size: a,
                showLabels: e,
                rotationX: t,
                rotationY: n,
                droppedFaces: i,
                draggable: r,
                onFaceDragStart: p,
                onFaceDrag: m,
                onFaceDragEnd: x,
                showDropZone: l,
                onFaceDropped: v,
                onFaceRemovedFromDropZone: _,
                dropZoneRef: S,
                droppedFacesGroupRef: A,
                ref: M
            }),
            l && $455d545b1dff00eb$var$k.jsx("group", {
                position: c ? [
                    4.1,
                    0,
                    0
                ] : [
                    5,
                    0,
                    0
                ],
                scale: c ? .8 : f <= 1600 ? 1.05 : 1.5,
                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_w, {
                    ref: S,
                    droppedFacesArray: Array.from(i),
                    isMobileWidth: c,
                    droppedFacesGroupRef: A
                })
            })
        ]
    });
}
function $455d545b1dff00eb$var$J6({ isAutoAnimating: a, droppedFacesCount: e, onAnimate: t, onReset: n, onVideoPlay: i, currentVideoUrl: r }) {
    const c = a || e === 6;
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "flex flex-row gap-2 pointer-events-auto",
        children: [
            $455d545b1dff00eb$var$k.jsxs("button", {
                onClick: t,
                disabled: c,
                className: `px-2 py-2.5 rounded-full font-bold text-[11px] uppercase tracking-widest transition-all shadow-lg flex items-center justify-center gap-2 ${c ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-[#FD4A67] text-white hover:bg-[#e13d5a] active:scale-95"} min-w-[130px]`,
                children: [
                    $455d545b1dff00eb$var$k.jsx("svg", {
                        className: "w-3.5 h-3.5",
                        fill: "currentColor",
                        viewBox: "0 0 24 24",
                        children: $455d545b1dff00eb$var$k.jsx("path", {
                            d: "M8 5v14l11-7z"
                        })
                    }),
                    "Animate"
                ]
            }),
            $455d545b1dff00eb$var$k.jsxs("button", {
                onClick: n,
                className: "px-2 py-2.5 rounded-full font-bold text-[11px] uppercase tracking-widest bg-white text-[#FD4A67] border border-rose-100 hover:bg-rose-50 active:scale-95 transition-all shadow-md flex items-center justify-center gap-2 min-w-[130px]",
                children: [
                    $455d545b1dff00eb$var$k.jsx("svg", {
                        className: "w-3.5 h-3.5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: $455d545b1dff00eb$var$k.jsx("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2.5,
                            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        })
                    }),
                    "Reset"
                ]
            }),
            r && $455d545b1dff00eb$var$k.jsxs("button", {
                onClick: i,
                className: "px-2 py-2.5 rounded-full font-bold text-[11px] uppercase tracking-widest bg-rose-50 text-rose-600 border border-rose-100 hover:bg-rose-100 active:scale-95 transition-all shadow-md flex items-center justify-center gap-2 min-w-[130px]",
                children: [
                    $455d545b1dff00eb$var$k.jsx("svg", {
                        className: "w-3.5 h-3.5",
                        fill: "currentColor",
                        viewBox: "0 0 24 24",
                        children: $455d545b1dff00eb$var$k.jsx("path", {
                            d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        })
                    }),
                    "Play Video"
                ]
            })
        ]
    });
}
const $455d545b1dff00eb$var$$6 = `
  .slider::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #fd99c5;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
  .slider::-moz-range-thumb {
    height: 20px;
    width: 30px;
    border-radius: 50%;
    background: #fd99c5;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
`;
function $455d545b1dff00eb$var$e8({ rotationX: a, rotationY: e, visualRotationX: t, visualRotationY: n, onRotationChange: i, controlsPosition: r, isDragging: l, onDragStart: c, isMobile: f, windowWidth: p, onClose: m }) {
    const x = (S)=>{
        S.target.tagName !== "INPUT" && c(S.clientX, S.clientY);
    }, v = (S)=>{
        if (S.target.tagName === "INPUT") return;
        const A = S.touches[0];
        c(A.clientX, A.clientY);
    }, _ = $455d545b1dff00eb$var$dw(t, n);
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: `absolute ${f ? "left-1/2 bottom-4 -translate-x-1/2 w-[90%]" : ` ${p >= 1200 ? "left-[-40%]" : "left-[-20%] top-[0%]"} `} flex flex-col bg-white/90 backdrop-blur-md rounded-2xl p-5 shadow-md border border-white/20 ${l ? "select-none transition-none" : ""} z-[100]`,
        style: {
            maxWidth: f ? "300px" : "fit-content",
            top: !f && p >= 1200 ? p >= 1600 ? "10%" : "-10%" : void 0,
            transform: f ? `translate(calc(-50% + ${r.x}px), ${r.y + 250}px)` : `translate(${r.x}px, ${r.y}px)`
        },
        children: [
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "flex flex-col space-y-4",
                children: [
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        className: `flex ${f ? "flex-col space-y-3" : "flex-row items-center space-x-2"}`,
                        children: [
                            $455d545b1dff00eb$var$k.jsx("button", {
                                onMouseDown: x,
                                onTouchStart: v,
                                className: `flex-shrink-0 flex items-center px-2 py-2 rounded-xl border transition-all ${l ? "bg-rose-500 text-white border-rose-600 cursor-grabbing shadow-inner" : "bg-rose-50 text-rose-600 border-rose-100 hover:bg-rose-100 cursor-grab shadow-sm"} ${f ? "self-end mb-2 mr-6" : ""}`,
                                style: {
                                    touchAction: "none"
                                },
                                children: $455d545b1dff00eb$var$k.jsx("span", {
                                    className: "text-[10px] font-bold uppercase tracking-widest whitespace-nowrap",
                                    children: "Drag"
                                })
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: `flex flex-col space-y-1.5 ${f ? "w-full" : "min-w-[160px]"}`,
                                children: [
                                    $455d545b1dff00eb$var$k.jsxs("div", {
                                        className: "flex justify-between items-center px-0.5",
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("label", {
                                                className: "text-[10px] font-bold text-gray-400 uppercase tracking-widest",
                                                children: "Rotate X"
                                            }),
                                            $455d545b1dff00eb$var$k.jsxs("span", {
                                                className: "text-xs font-bold text-rose-500 bg-rose-50 px-2 py-0.5 rounded-full",
                                                children: [
                                                    Math.round(e),
                                                    "\xb0"
                                                ]
                                            })
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsx("input", {
                                        type: "range",
                                        min: "-180",
                                        max: "180",
                                        value: e,
                                        onChange: (S)=>i(a, parseInt(S.target.value)),
                                        className: "w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsxs("div", {
                                className: `flex flex-col space-y-1.5 ${f ? "w-full" : "min-w-[160px]"}`,
                                children: [
                                    $455d545b1dff00eb$var$k.jsxs("div", {
                                        className: "flex justify-between items-center px-0.5",
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("label", {
                                                className: "text-[10px] font-bold text-gray-500 uppercase tracking-widest",
                                                children: "Rotate Y"
                                            }),
                                            $455d545b1dff00eb$var$k.jsxs("span", {
                                                className: "text-xs font-bold text-rose-500 bg-rose-50 px-2 py-0.5 rounded-full",
                                                children: [
                                                    Math.round(a),
                                                    "\xb0"
                                                ]
                                            })
                                        ]
                                    }),
                                    $455d545b1dff00eb$var$k.jsx("input", {
                                        type: "range",
                                        min: "-180",
                                        max: "180",
                                        value: a,
                                        onChange: (S)=>i(parseInt(S.target.value), e),
                                        className: "w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
                                    })
                                ]
                            })
                        ]
                    }),
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: "pt-3 border-t border-gray-100/50",
                        children: $455d545b1dff00eb$var$k.jsx("div", {
                            className: `grid ${f ? "grid-cols-3" : "grid-cols-6"} gap-x-1 gap-y-2`,
                            children: _.map((S, A)=>{
                                const M = $455d545b1dff00eb$var$lb[A];
                                return $455d545b1dff00eb$var$k.jsxs("div", {
                                    className: "flex items-center gap-1 group/item",
                                    children: [
                                        $455d545b1dff00eb$var$k.jsx("div", {
                                            className: "h-4 w-4 rounded-sm border border-black/10 flex-shrink-0 shadow-sm transition-transform group-hover/item:scale-110",
                                            style: {
                                                backgroundColor: $455d545b1dff00eb$var$mS[S]
                                            }
                                        }),
                                        $455d545b1dff00eb$var$k.jsx("span", {
                                            className: "text-[10px] font-bold text-gray-600 uppercase tracking-tight",
                                            children: M
                                        })
                                    ]
                                }, `palette-${A}`);
                            })
                        })
                    })
                ]
            }),
            f && m && $455d545b1dff00eb$var$k.jsx("button", {
                onClick: m,
                className: "absolute top-2 right-2 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors",
                "aria-label": "Close controls",
                children: $455d545b1dff00eb$var$k.jsx("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-5 w-5 text-gray-600",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    strokeWidth: 2.5,
                    children: $455d545b1dff00eb$var$k.jsx("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M6 18L18 6M6 6l12 12"
                    })
                })
            })
        ]
    });
}
const $455d545b1dff00eb$var$sE = [
    5,
    1,
    2,
    4,
    3,
    0
], $455d545b1dff00eb$var$t8 = [
    {
        x: 0,
        y: 0
    },
    {
        x: 0,
        y: 180
    },
    {
        x: 90,
        y: 0
    },
    {
        x: -90,
        y: 0
    },
    {
        x: 0,
        y: -90
    },
    {
        x: 0,
        y: 90
    }
], $455d545b1dff00eb$var$oE = 1400, $455d545b1dff00eb$var$n8 = 400, $455d545b1dff00eb$var$i8 = 1200;
function $455d545b1dff00eb$var$a8({ size: a, FormulaDisplayComponent: e, showControls: t = !0, showLabels: n = !0, droppedFaces: i = new Set, draggable: r = !1, rotationX: l = 49, rotationY: c = 55, onRotationChange: f, onFaceDragStart: p, onFaceDrag: m, onFaceDragEnd: x, showDropZone: v = !0, onFaceDropped: _, onFaceRemovedFromDropZone: S, onResetAll: A, onVideoPlay: M }) {
    const { viewMode: b } = $455d545b1dff00eb$var$hw(), { currentVideoUrl: C } = $455d545b1dff00eb$var$uw({
        viewMode: b
    }), R = $455d545b1dff00eb$var$O0(), N = $455d545b1dff00eb$var$cw(), z = $455d545b1dff00eb$var$X.useRef(null), L = $455d545b1dff00eb$var$X.useRef(null), P = $455d545b1dff00eb$var$X.useRef(null), [H, O] = $455d545b1dff00eb$var$X.useState(!1), [D, j] = $455d545b1dff00eb$var$X.useState({
        x: 0,
        y: 0
    }), [G, q] = $455d545b1dff00eb$var$X.useState(!1), [Y, ae] = $455d545b1dff00eb$var$X.useState(!1), [F, Q] = $455d545b1dff00eb$var$X.useState({
        x: l,
        y: c
    }), K = $455d545b1dff00eb$var$X.useRef({
        x: 0,
        y: 0
    }), $ = $455d545b1dff00eb$var$X.useRef({
        x: 0,
        y: 0
    }), ee = $455d545b1dff00eb$var$X.useRef(!1);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        Y || Q({
            x: l,
            y: c
        });
    }, [
        l,
        c,
        Y
    ]);
    const I = $455d545b1dff00eb$var$X.useCallback(()=>{
        ee.current = !0, P.current?.reset(), ae(!1), A?.();
    }, [
        A
    ]), Z = $455d545b1dff00eb$var$X.useCallback(async ()=>{
        if (Y) return;
        ae(!0), ee.current = !1;
        const le = l, xe = c;
        let Le = l, Ue = c;
        for(let Ne = 0; Ne < $455d545b1dff00eb$var$sE.length && !ee.current; Ne++){
            const ke = $455d545b1dff00eb$var$sE[Ne];
            if (i.has(ke)) continue;
            const nt = $455d545b1dff00eb$var$t8[ke];
            if (await $455d545b1dff00eb$var$aE(Le, Ue, nt.x, nt.y, $455d545b1dff00eb$var$oE, (Re, te)=>{
                ee.current || Q({
                    x: Re,
                    y: te
                });
            }, ()=>ee.current), ee.current || (f?.(nt.x, nt.y), Le = nt.x, Ue = nt.y, await new Promise((Re)=>setTimeout(Re, $455d545b1dff00eb$var$n8)), ee.current)) break;
            P.current?.animateDropFace(ke), await new Promise((Re)=>setTimeout(Re, $455d545b1dff00eb$var$i8));
        }
        ee.current || (await $455d545b1dff00eb$var$aE(Le, Ue, le, xe, $455d545b1dff00eb$var$oE, (Ne, ke)=>{
            ee.current || Q({
                x: Ne,
                y: ke
            });
        }, ()=>ee.current), f?.(le, xe)), ae(!1), ee.current = !1;
    }, [
        Y,
        i,
        l,
        c,
        f
    ]), oe = $455d545b1dff00eb$var$X.useCallback((le, xe)=>{
        q(!0), K.current = {
            x: le,
            y: xe
        }, $.current = {
            ...D
        };
    }, [
        D
    ]);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!G) return;
        const le = (Ue)=>{
            const Ne = Ue.clientX - K.current.x, ke = Ue.clientY - K.current.y;
            j({
                x: $.current.x + Ne,
                y: $.current.y + ke
            });
        }, xe = (Ue)=>{
            const Ne = Ue.touches[0], ke = Ne.clientX - K.current.x, nt = Ne.clientY - K.current.y;
            j({
                x: $.current.x + ke,
                y: $.current.y + nt
            });
        }, Le = ()=>q(!1);
        return window.addEventListener("mousemove", le), window.addEventListener("mouseup", Le), window.addEventListener("touchmove", xe), window.addEventListener("touchend", Le), ()=>{
            window.removeEventListener("mousemove", le), window.removeEventListener("mouseup", Le), window.removeEventListener("touchmove", xe), window.removeEventListener("touchend", Le);
        };
    }, [
        G
    ]);
    const ce = $455d545b1dff00eb$var$X.useMemo(()=>a !== void 0 ? a : R ? $455d545b1dff00eb$var$pn * .6 : N < 1024 ? $455d545b1dff00eb$var$pn * 1 : N > 1536 ? $455d545b1dff00eb$var$pn * 2.5 : $455d545b1dff00eb$var$pn * 1.8, [
        a,
        R,
        N
    ]), de = R ? "350px" : N > 1536 ? "600px" : "400px", ue = R ? "500px" : N > 1536 ? "800px" : "600px";
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("style", {
                children: $455d545b1dff00eb$var$$6
            }),
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: `flex flex-col ${R ? "items-start" : "items-center mt-10"}`,
                children: [
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        className: "flex-shrink-0 w-full",
                        style: {
                            width: ue,
                            height: de,
                            position: "relative",
                            left: R ? "-70px" : 0,
                            top: R ? 0 : N <= 1600 ? "100px" : 0,
                            overflow: "visible"
                        },
                        children: [
                            $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$_S, {
                                flat: !0,
                                gl: {
                                    outputColorSpace: $455d545b1dff00eb$var$No,
                                    antialias: !0,
                                    alpha: !0,
                                    powerPreference: "high-performance"
                                },
                                dpr: [
                                    1,
                                    2
                                ],
                                style: {
                                    background: "transparent"
                                },
                                children: [
                                    R ? $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_b, {
                                        makeDefault: !0,
                                        position: [
                                            -0.9,
                                            0,
                                            20
                                        ],
                                        fov: 25,
                                        near: 5,
                                        far: 1e3
                                    }) : $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$_b, {
                                        makeDefault: !0,
                                        position: [
                                            2,
                                            0,
                                            20
                                        ],
                                        fov: 25,
                                        near: 5,
                                        far: 1e3
                                    }),
                                    $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$K6, {
                                        cubeSize: ce,
                                        showLabels: n,
                                        visualRotationX: F.x,
                                        visualRotationY: F.y,
                                        droppedFaces: i,
                                        draggable: r,
                                        showDropZone: v,
                                        isMobile: R,
                                        windowWidth: N,
                                        onFaceDragStart: p,
                                        onFaceDrag: m,
                                        onFaceDragEnd: x,
                                        onFaceDropped: _,
                                        onFaceRemovedFromDropZone: S,
                                        dropZoneRef: z,
                                        droppedFacesGroupRef: L,
                                        cubeRef: P
                                    })
                                ]
                            }),
                            $455d545b1dff00eb$var$k.jsx("div", {
                                className: `absolute flex ${R ? "flex-col" : "flex-row"} gap-2 pointer-events-none`,
                                style: {
                                    right: "-50px",
                                    top: R ? "10px" : "-40px",
                                    zIndex: 1e3
                                },
                                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$J6, {
                                    isAutoAnimating: Y,
                                    droppedFacesCount: i.size,
                                    onAnimate: Z,
                                    onReset: I,
                                    onVideoPlay: M,
                                    currentVideoUrl: C
                                })
                            }),
                            t && R && !H && $455d545b1dff00eb$var$k.jsxs("button", {
                                onClick: ()=>O(!0),
                                className: "absolute bottom-0 right-3 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-md flex items-center gap-2 text-sm font-medium text-gray-700 z-50",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-4 w-4",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        strokeWidth: 2,
                                        children: $455d545b1dff00eb$var$k.jsx("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                        })
                                    }),
                                    "Rotate"
                                ]
                            }),
                            t && (!R || H) && $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$e8, {
                                rotationX: l,
                                rotationY: c,
                                visualRotationX: F.x,
                                visualRotationY: F.y,
                                onRotationChange: (le, xe)=>f?.(le, xe),
                                controlsPosition: D,
                                isDragging: G,
                                onDragStart: oe,
                                isMobile: R,
                                windowWidth: N,
                                onClose: R ? ()=>O(!1) : void 0
                            })
                        ]
                    }),
                    e && $455d545b1dff00eb$var$k.jsx("div", {
                        style: {
                            top: N > 1600 ? -100 : 40
                        },
                        className: "z-40 relative w-full flex justify-end",
                        children: e
                    })
                ]
            })
        ]
    });
}
const $455d545b1dff00eb$var$r8 = `
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes moveToCenterTop {
    0% {
      opacity: 1;
      transform: translateX(-50%) translateY(0) scale(1);
    }
    60% {
      opacity: 0.9;
      transform: translateX(-50%) translateY(24px) scale(0.85);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) translateY(24px) scale(0.3);
    }
  }
  @keyframes moveToCenterLeft {
    0% {
      opacity: 1;
      transform: translateY(-50%) translateX(0) scale(1);
    }
    60% {
      opacity: 0.9;
      transform: translateY(-50%) translateX(24px) scale(0.85);
    }
    100% {
      opacity: 0;
      transform: translateY(-50%) translateX(24px) scale(0.3);
    }
  }
  @keyframes combineToCenter {
    0% {
      opacity: 0;
      transform: scale(0.3) rotate(-5deg);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.1) rotate(2deg);
    }
    100% {
      opacity: 1;
      transform: scale(1) rotate(0deg);
    }
  }
  @keyframes dropAndHide {
    0% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateY(100px) scale(0.8);
    }
  }
`;
function $455d545b1dff00eb$var$s8({ faceIndex: a, isAnimating: e, onAnimationComplete: t, isMobileWidth: n = !1, zIndex: i = 1 }) {
    const [r, l] = $455d545b1dff00eb$var$X.useState("idle"), c = $455d545b1dff00eb$var$X.useRef(!1), f = $455d545b1dff00eb$var$X.useRef([]);
    $455d545b1dff00eb$var$X.useEffect(()=>()=>{
            f.current.forEach((R)=>clearTimeout(R)), f.current = [];
        }, []), $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!e) {
            if (!c.current || r === "complete" || r === "idle") {
                f.current.forEach((O)=>clearTimeout(O)), f.current = [];
                const H = setTimeout(()=>{
                    l("idle");
                }, 0);
                f.current.push(H);
            }
            return;
        }
        if (c.current && r !== "complete" && r !== "idle") return;
        f.current.forEach((H)=>clearTimeout(H)), f.current = [], c.current = !0;
        const R = setTimeout(()=>{
            l("side-labels");
        }, 0);
        f.current.push(R);
        const N = setTimeout(()=>{
            l("moving-to-center");
        }, 800);
        f.current.push(N);
        const z = setTimeout(()=>{
            l("center-label");
        }, 1800);
        f.current.push(z);
        const L = setTimeout(()=>{
            l("dropping");
        }, 3200);
        f.current.push(L);
        const P = setTimeout(()=>{
            l("complete"), c.current = !1, t?.();
        }, 4e3);
        f.current.push(P);
    }, [
        e
    ]);
    const p = r === "side-labels" || r === "moving-to-center", m = r === "moving-to-center", x = r === "center-label" || r === "dropping", v = r === "dropping";
    if (r === "idle" || r === "complete") return null;
    const _ = n ? "w-16 h-16" : "w-20 h-20", S = n ? "text-sm" : "text-base", A = "text-xl", M = (i - 1) * 30, b = n ? 100 : 40;
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
        children: [
            $455d545b1dff00eb$var$k.jsx("style", {
                children: $455d545b1dff00eb$var$r8
            }),
            $455d545b1dff00eb$var$k.jsx("div", {
                className: "fixed inset-0 flex items-center justify-center pointer-events-none",
                style: {
                    zIndex: 50 + i,
                    transform: `translate(${b}px, ${30 - M}px)`
                },
                children: $455d545b1dff00eb$var$k.jsxs("div", {
                    className: `${_} border-2 border-black rounded flex items-center justify-center relative`,
                    style: {
                        backgroundColor: $455d545b1dff00eb$var$Ur[a],
                        animation: v ? "dropAndHide 1s ease-in forwards" : "bounce 1s ease-in-out infinite",
                        transform: `scale(${1 + i * .05})`
                    },
                    children: [
                        p && $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
                            children: [
                                $455d545b1dff00eb$var$k.jsx("div", {
                                    className: `absolute font-nickainley font-bold text-gray-800 flex items-center justify-center ${A} opacity-0`,
                                    style: {
                                        top: "-24px",
                                        left: "50%",
                                        WebkitTextStroke: "1px black",
                                        WebkitTextFillColor: "black",
                                        paintOrder: "stroke fill",
                                        transform: "translateX(-50%)",
                                        animation: m ? "fadeIn 0.6s ease-out forwards, moveToCenterTop 1.3s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards" : "fadeIn 0.6s ease-out forwards"
                                    },
                                    children: "x"
                                }),
                                $455d545b1dff00eb$var$k.jsx("div", {
                                    className: `absolute font-nickainley font-bold text-gray-800 flex items-center justify-center ${A} opacity-0`,
                                    style: {
                                        left: "-24px",
                                        top: "35%",
                                        WebkitTextStroke: "1px black",
                                        WebkitTextFillColor: "black",
                                        paintOrder: "stroke fill",
                                        transform: "translateY(-50%)",
                                        animation: m ? "fadeIn 0.6s ease-out 0.2s forwards, moveToCenterLeft 1.3s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards" : "fadeIn 0.6s ease-out 0.2s forwards"
                                    },
                                    children: "x"
                                }),
                                $455d545b1dff00eb$var$k.jsxs("div", {
                                    className: "absolute text-bold text-gray-800 flex items-center justify-center text-sm opacity-0 whitespace-nowrap",
                                    style: {
                                        right: "-140px",
                                        top: "35%",
                                        transform: "translateY(-50%)",
                                        animation: "fadeIn 0.6s ease-out 0.4s forwards"
                                    },
                                    children: [
                                        $455d545b1dff00eb$var$k.jsxs("span", {
                                            className: "font-bold relative mx-2",
                                            children: [
                                                "Area =",
                                                " ",
                                                $455d545b1dff00eb$var$k.jsx("span", {
                                                    className: `font-nickainley font-bold text-gray-800 justify-center ${A}`,
                                                    style: {
                                                        WebkitTextStroke: "1px black",
                                                        WebkitTextFillColor: "black",
                                                        paintOrder: "stroke fill"
                                                    },
                                                    children: "x"
                                                }),
                                                " ",
                                                "\xd7 ",
                                                $455d545b1dff00eb$var$k.jsx("span", {
                                                    className: `font-nickainley font-bold text-gray-800 justify-center ${A}`,
                                                    style: {
                                                        WebkitTextStroke: "1px black",
                                                        WebkitTextFillColor: "black",
                                                        paintOrder: "stroke fill"
                                                    },
                                                    children: "x"
                                                })
                                            ]
                                        }),
                                        "=",
                                        $455d545b1dff00eb$var$k.jsx("span", {
                                            className: "font-bold relative px-2",
                                            children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v0, {
                                                fontSize: "24px",
                                                strokeWidth: "1px"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        x && $455d545b1dff00eb$var$k.jsx("div", {
                            className: `text-black font-bold z-10 font-nickainley ${S} opacity-0`,
                            style: {
                                animation: "combineToCenter 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards"
                            },
                            children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v0, {})
                        })
                    ]
                })
            })
        ]
    });
}
const $455d545b1dff00eb$var$lE = {
    mobile: {
        netSize: 180,
        faceSize: 60,
        padding: "12px",
        edgeLabelFontSize: "10px",
        edgeLabelOffset: "-20px"
    },
    desktop: {
        netSize: 240,
        faceSize: 80,
        padding: "16px",
        edgeLabelFontSize: "14px",
        edgeLabelOffset: "-25px"
    }
};
function $455d545b1dff00eb$var$o8(a) {
    return a ? $455d545b1dff00eb$var$lE.mobile : $455d545b1dff00eb$var$lE.desktop;
}
function $455d545b1dff00eb$var$l8(a) {
    return [
        {
            pos: "col-start-1 row-start-2",
            faceIndex: a[5]
        },
        {
            pos: "col-start-2 row-start-1",
            faceIndex: a[1]
        },
        {
            pos: "col-start-3 row-start-2",
            faceIndex: a[4]
        },
        {
            pos: "col-start-2 row-start-2",
            faceIndex: a[3]
        },
        {
            pos: "col-start-2 row-start-3",
            faceIndex: a[0]
        },
        {
            pos: "col-start-2 row-start-4",
            faceIndex: a[2]
        }
    ];
}
function $455d545b1dff00eb$var$cE({ isArea: a, draggedFaces: e = new Set, isMobileWidth: t = !1, rotationX: n = 0, rotationY: i = 0 }) {
    const r = $455d545b1dff00eb$var$o8(t), l = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$dw(n, i), [
        n,
        i
    ]), c = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$l8(l), [
        l
    ]), f = (p)=>{
        const x = "#000000";
        return p === "col-start-1 row-start-2" ? {
            borderTop: `2px solid ${x}`,
            borderLeft: `2px solid ${x}`,
            borderBottom: `2px solid ${x}`,
            borderRight: "none"
        } : p === "col-start-2 row-start-1" ? {
            borderTop: `2px solid ${x}`,
            borderLeft: `2px solid ${x}`,
            borderRight: `2px solid ${x}`
        } : p === "col-start-3 row-start-2" ? {
            borderTop: `2px solid ${x}`,
            borderRight: `2px solid ${x}`,
            borderBottom: `2px solid ${x}`,
            borderLeft: "none"
        } : p === "col-start-2 row-start-2" ? {
            borderLeft: `2px solid ${x}`,
            borderRight: `2px solid ${x}`,
            borderBottom: `2px solid ${x}`,
            borderTop: `2px solid ${x}`
        } : p === "col-start-2 row-start-3" ? {
            borderLeft: `2px solid ${x}`,
            borderRight: `2px solid ${x}`,
            borderBottom: `2px solid ${x}`,
            borderTop: "none"
        } : p === "col-start-2 row-start-4" ? {
            borderBottom: `2px solid ${x}`,
            borderLeft: `2px solid ${x}`,
            borderRight: `2px solid ${x}`,
            borderTop: "none"
        } : {
            border: `2px solid ${x}`
        };
    };
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "w-full flex justify-center overflow-visible",
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: "grid grid-cols-3 grid-rows-4 gap-0",
            style: {
                width: `${r.netSize}px`,
                height: `${r.netSize * 4 / 3}px`,
                flexShrink: 0,
                gridTemplateColumns: "repeat(3, 1fr)",
                gridTemplateRows: "repeat(4, 1fr)"
            },
            children: c.map((p, m)=>{
                const x = p.faceIndex, v = $455d545b1dff00eb$var$mS[x], _ = e.has(x);
                return $455d545b1dff00eb$var$k.jsx("div", {
                    className: `${p.pos} flex items-center justify-center relative transition-all duration-300 ${_ ? "opacity-100" : "opacity-30"}`,
                    style: {
                        backgroundColor: v,
                        ...f(p.pos),
                        width: `${r.faceSize}px`,
                        height: `${r.faceSize}px`,
                        boxShadow: _ ? "0 2px 4px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)" : "none"
                    },
                    children: $455d545b1dff00eb$var$k.jsx("span", {
                        className: `text-black font-extrabold drop-shadow-sm font-nickainley ${t ? "text-sm" : "text-lg"}`,
                        children: a ? $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v0, {
                            fontSize: t ? "32px" : "48px"
                        }) : "x"
                    })
                }, m);
            })
        })
    });
}
var $455d545b1dff00eb$var$kx = {
    exports: {}
};
var $455d545b1dff00eb$var$uE;
function $455d545b1dff00eb$var$c8() {
    return $455d545b1dff00eb$var$uE || ($455d545b1dff00eb$var$uE = 1, function(a, e) {
        (function() {
            var t = 9007199254740991;
            function n(H) {
                return !(typeof H != "number" || H != H || H === 1 / 0 || H === -1 / 0);
            }
            function i(H) {
                return typeof H == "number" && Math.abs(H) <= t;
            }
            var r = /(hundred|thousand|(m|b|tr|quadr)illion)$/, l = /teen$/, c = /y$/, f = /(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/, p = {
                zero: "zeroth",
                one: "first",
                two: "second",
                three: "third",
                four: "fourth",
                five: "fifth",
                six: "sixth",
                seven: "seventh",
                eight: "eighth",
                nine: "ninth",
                ten: "tenth",
                eleven: "eleventh",
                twelve: "twelfth"
            };
            function m(H) {
                return r.test(H) || l.test(H) ? H + "th" : c.test(H) ? H.replace(c, "ieth") : f.test(H) ? H.replace(f, x) : H;
            }
            function x(H, O) {
                return p[O];
            }
            var v = 10, _ = 100, S = 1e3, A = 1e6, M = 1e9, b = 1e12, C = 1e15, R = 9007199254740992, N = [
                "zero",
                "one",
                "two",
                "three",
                "four",
                "five",
                "six",
                "seven",
                "eight",
                "nine",
                "ten",
                "eleven",
                "twelve",
                "thirteen",
                "fourteen",
                "fifteen",
                "sixteen",
                "seventeen",
                "eighteen",
                "nineteen"
            ], z = [
                "zero",
                "ten",
                "twenty",
                "thirty",
                "forty",
                "fifty",
                "sixty",
                "seventy",
                "eighty",
                "ninety"
            ];
            function L(H, O) {
                var D, j = parseInt(H, 10);
                if (!n(j)) throw new TypeError("Not a finite number: " + H + " (" + typeof H + ")");
                if (!i(j)) throw new RangeError("Input is not a safe number, it\u2019s either too large or too small.");
                return D = function G(q) {
                    var Y, ae, F = arguments[1];
                    return q === 0 ? F ? F.join(" ").replace(/,$/, "") : "zero" : (F || (F = []), q < 0 && (F.push("minus"), q = Math.abs(q)), q < 20 ? (Y = 0, ae = N[q]) : q < _ ? (Y = q % v, ae = z[Math.floor(q / v)], Y && (ae += "-" + N[Y], Y = 0)) : q < S ? (Y = q % _, ae = G(Math.floor(q / _)) + " hundred") : q < A ? (Y = q % S, ae = G(Math.floor(q / S)) + " thousand,") : q < M ? (Y = q % A, ae = G(Math.floor(q / A)) + " million,") : q < b ? (Y = q % M, ae = G(Math.floor(q / M)) + " billion,") : q < C ? (Y = q % b, ae = G(Math.floor(q / b)) + " trillion,") : q <= R && (Y = q % C, ae = G(Math.floor(q / C)) + " quadrillion,"), F.push(ae), G(Y, F));
                }(j), O ? m(D) : D;
            }
            var P = {
                toOrdinal: function(H) {
                    var O = parseInt(H, 10);
                    if (!n(O)) throw new TypeError("Not a finite number: " + H + " (" + typeof H + ")");
                    if (!i(O)) throw new RangeError("Input is not a safe number, it\u2019s either too large or too small.");
                    var D = String(O), j = Math.abs(O % 100), G = 11 <= j && j <= 13, q = D.charAt(D.length - 1);
                    return D + (G ? "th" : q === "1" ? "st" : q === "2" ? "nd" : q === "3" ? "rd" : "th");
                },
                toWords: L,
                toWordsOrdinal: function(H) {
                    return m(L(H));
                }
            };
            a.exports && (e = a.exports = P), e.numberToWords = P;
        })();
    }($455d545b1dff00eb$var$kx, $455d545b1dff00eb$var$kx.exports)), $455d545b1dff00eb$var$kx.exports;
}
var $455d545b1dff00eb$var$u8 = $455d545b1dff00eb$var$c8();
function $455d545b1dff00eb$var$fE({ droppedCount: a, droppedFacesArray: e, isMobileWidth: t }) {
    const n = ()=>a === 0 ? "Drop faces to build the formula from cube" : a === 1 ? "Surface area of one face =" : a === 6 ? "Hence complete area of cube =" : `Surface area of ${$455d545b1dff00eb$var$u8.toWords(a)} faces =`;
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: `w-full max-w-md ${t ? "flex justify-center" : ""}`,
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: `
          bg-transparent border-0 shadow-none p-0'
        `,
            style: {
                fontFamily: "'Inter', 'Poppins', system-ui, sans-serif"
            },
            children: a === 0 ? $455d545b1dff00eb$var$k.jsx("div", {
                className: "text-center text-gray-400 text-sm py-4",
                children: n()
            }) : $455d545b1dff00eb$var$k.jsxs("div", {
                className: "flex flex-col items-center gap-1 md:gap-2",
                children: [
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: `font-semibold text-gray-800 whitespace-nowrap w-full text-center ${t ? "text-sm" : "text-base mb-1"}`,
                        children: n()
                    }),
                    $455d545b1dff00eb$var$k.jsx("div", {
                        className: `flex items-center gap-1 md:gap-2 ${t ? "flex-row w-full justify-center flex-wrap" : "flex-col"}`,
                        children: $455d545b1dff00eb$var$k.jsxs("div", {
                            className: "flex flex-row items-center gap-1 flex-shrink-0",
                            children: [
                                e.map((i, r)=>$455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$hE.Fragment, {
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v0, {
                                                className: "font-math font-bold",
                                                color: $455d545b1dff00eb$var$Ur[i],
                                                fontSize: "36px",
                                                strokeWidth: "2px"
                                            }),
                                            r < a - 1 && $455d545b1dff00eb$var$k.jsx("span", {
                                                className: "text-gray-600 font-bold",
                                                style: {
                                                    fontSize: t ? "14px" : "18px"
                                                },
                                                children: "+"
                                            })
                                        ]
                                    }, i)),
                                a > 0 && $455d545b1dff00eb$var$k.jsxs("div", {
                                    className: "flex items-center gap-1 md:gap-2 flex-shrink-0 ",
                                    style: {
                                        fontSize: "20px"
                                    },
                                    children: [
                                        $455d545b1dff00eb$var$k.jsx("span", {
                                            className: "font-semibold text-gray-800 whitespace-nowrap",
                                            children: "="
                                        }),
                                        $455d545b1dff00eb$var$k.jsxs("span", {
                                            className: "font-mono font-bold text-gray-800 whitespace-nowrap",
                                            children: [
                                                $455d545b1dff00eb$var$k.jsx("span", {
                                                    className: `font-semibold text-gray-800 ${t ? "text-2xl" : "text-3xl"}`,
                                                    children: a
                                                }),
                                                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$v0, {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
function $455d545b1dff00eb$var$f8({ onVideoPlay: a }) {
    const [e, t] = $455d545b1dff00eb$var$X.useState(new Set), [n, i] = $455d545b1dff00eb$var$X.useState(new Set), [r, l] = $455d545b1dff00eb$var$X.useState(15), c = $455d545b1dff00eb$var$O0(), [f, p] = $455d545b1dff00eb$var$X.useState(c ? 35 : 55), m = $455d545b1dff00eb$var$X.useRef(null), x = $455d545b1dff00eb$var$X.useRef(null), v = $455d545b1dff00eb$var$X.useRef(new Set), _ = $455d545b1dff00eb$var$X.useCallback(()=>{
        if (x.current) for(; x.current.children.length > 0;)x.current.remove(x.current.children[0]);
        t(new Set), i(new Set), v.current = new Set, l(15), p(c ? 35 : 55);
    }, [
        c
    ]), S = $455d545b1dff00eb$var$X.useCallback((P, H)=>{
        window.dispatchEvent(new CustomEvent("threejs-drag-start", {
            detail: {
                faceIndex: P,
                object: H
            }
        }));
    }, []), A = $455d545b1dff00eb$var$X.useCallback((P, H)=>{
        window.dispatchEvent(new CustomEvent("threejs-drag-move", {
            detail: {
                faceIndex: P,
                object: H,
                position: H.position
            }
        }));
    }, []), M = $455d545b1dff00eb$var$X.useCallback((P, H)=>{
        console.log("Face drag ended:", P), window.dispatchEvent(new CustomEvent("threejs-drag-end", {
            detail: {
                faceIndex: P,
                object: H,
                position: H.position
            }
        }));
    }, []), b = $455d545b1dff00eb$var$X.useCallback((P)=>{
        e.has(P) || (v.current.has(P) ? (t((H)=>{
            const O = new Set(H);
            return O.add(P), O;
        }), v.current.delete(P)) : (v.current.add(P), i((H)=>{
            const O = new Set(H);
            return O.add(P), O;
        })));
    }, [
        e
    ]), C = $455d545b1dff00eb$var$X.useCallback((P)=>{
        t((H)=>{
            const O = new Set(H);
            return O.delete(P), O;
        });
    }, []), R = $455d545b1dff00eb$var$X.useCallback((P)=>{
        v.current.delete(P), i((H)=>{
            const O = new Set(H);
            return O.delete(P), O;
        });
    }, []), N = $455d545b1dff00eb$var$X.useCallback((P, H)=>{
        l(P), p(H);
    }, []), z = e.size, L = $455d545b1dff00eb$var$X.useMemo(()=>Array.from(e), [
        e
    ]);
    return $455d545b1dff00eb$var$k.jsxs("div", {
        className: "flex flex-col md:flex-row  justify-start items-start md:items-center mt-40 md:mt-0 gap-3 md:gap-8 p-2 md:p-4 min-w-0",
        children: [
            $455d545b1dff00eb$var$k.jsxs("div", {
                className: "flex flex-col  md:flex-row w-full md:w-auto gap-3 md:gap-8 items-start",
                children: [
                    $455d545b1dff00eb$var$k.jsxs("div", {
                        className: `flex-shrink-0 flex relative flex-col overflow-visible ${c ? "items-center right-0 top-[200px]" : "items-center"} w-full md:w-auto ${c ? "h-[800px]" : "h-[600px]"}`,
                        children: [
                            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$a8, {
                                size: 2.5,
                                showLabels: !0,
                                droppedFaces: e,
                                draggable: !0,
                                rotationX: r,
                                rotationY: f,
                                onRotationChange: N,
                                onFaceDragStart: S,
                                onFaceDrag: A,
                                onFaceDragEnd: M,
                                showDropZone: !0,
                                onFaceDropped: b,
                                onFaceRemovedFromDropZone: C,
                                dropZoneRef: m,
                                droppedFacesGroupRef: x,
                                onResetAll: _,
                                onVideoPlay: a,
                                FormulaDisplayComponent: c ? void 0 : $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$fE, {
                                    droppedCount: z,
                                    droppedFacesArray: L,
                                    isMobileWidth: c
                                })
                            }),
                            c && $455d545b1dff00eb$var$k.jsxs("div", {
                                className: "flex flex-col gap-4 w-full",
                                children: [
                                    $455d545b1dff00eb$var$k.jsx("div", {
                                        className: "flex-1 w-full flex justify-center",
                                        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$fE, {
                                            droppedCount: z,
                                            droppedFacesArray: L,
                                            isMobileWidth: c
                                        })
                                    }),
                                    $455d545b1dff00eb$var$k.jsxs("div", {
                                        className: "flex flex-col items-center flex-1 w-full",
                                        children: [
                                            $455d545b1dff00eb$var$k.jsx("h3", {
                                                className: "text-sm font-semibold mb-4 text-black h-6 flex items-end",
                                                children: "Surface Area Net"
                                            }),
                                            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$cE, {
                                                isArea: !0,
                                                draggedFaces: e,
                                                isMobileWidth: c,
                                                rotationX: r,
                                                rotationY: f
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !c && $455d545b1dff00eb$var$k.jsxs("div", {
                        className: "flex relative top-24 flex-col items-center flex-shrink-0 flex-grow-1",
                        children: [
                            $455d545b1dff00eb$var$k.jsx("h3", {
                                className: "text-sm md:text-lg font-semibold mb-6 md:mb-4 text-black h-6 md:h-7 flex items-end",
                                children: "Surface Area Net"
                            }),
                            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$cE, {
                                isArea: !0,
                                draggedFaces: e,
                                isMobileWidth: c,
                                rotationX: r,
                                rotationY: f
                            })
                        ]
                    })
                ]
            }),
            Array.from(n).map((P, H)=>$455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$s8, {
                    faceIndex: P,
                    isAnimating: !0,
                    onAnimationComplete: ()=>R(P),
                    isMobileWidth: c,
                    zIndex: H + 1
                }, P))
        ]
    });
}
function $455d545b1dff00eb$var$h8({ onVideoPlay: a }) {
    return $455d545b1dff00eb$var$k.jsx("div", {
        className: "flex-1 top-0 md:top-24 w-full relative overflow-x-auto overflow-y-auto mt-4 md:mt-0 ",
        style: {
            zIndex: 10
        },
        children: $455d545b1dff00eb$var$k.jsx("div", {
            className: "w-full  min-w-0 h-full flex justify-center items-center",
            children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$f8, {
                onVideoPlay: a
            })
        })
    });
}
function $455d545b1dff00eb$var$d8({ children: a }) {
    const [e, t] = $455d545b1dff00eb$var$X.useState(()=>{
        if (typeof window > "u") return "surface-area";
        const r = localStorage.getItem("cubeViewMode");
        return r === "unfolding" || r === "surface-area" ? r : "surface-area";
    });
    $455d545b1dff00eb$var$X.useEffect(()=>{
        typeof window < "u" && localStorage.setItem("cubeViewMode", e);
    }, [
        e
    ]);
    const i = {
        viewMode: e,
        setViewMode: (r)=>{
            t(r);
        }
    };
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$fw.Provider, {
        value: i,
        children: a
    });
}
const $455d545b1dff00eb$var$p8 = $455d545b1dff00eb$var$X.createContext(void 0);
function $455d545b1dff00eb$var$m8({ children: a, value: e }) {
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$p8.Provider, {
        value: e,
        children: a
    });
}
function $455d545b1dff00eb$var$g8() {
    const [a, e] = $455d545b1dff00eb$var$X.useState(!1), t = $455d545b1dff00eb$var$X.useCallback(()=>{
        e((n)=>!n);
    }, []);
    return {
        isDrawerOpen: a,
        toggleDrawer: t
    };
}
function $455d545b1dff00eb$var$x8() {
    const [a, e] = $455d545b1dff00eb$var$X.useState(()=>typeof window > "u" ? !1 : localStorage.getItem("hasReadBoxUnfoldGuide") === "true"), t = $455d545b1dff00eb$var$X.useCallback(()=>{
        e(!0), typeof window < "u" && localStorage.setItem("hasReadBoxUnfoldGuide", "true");
    }, []);
    return {
        hasReadGuide: a,
        handleReadGuide: t
    };
}
function $455d545b1dff00eb$var$v8({ faceStates: a, setFaceStates: e, unfoldHistory: t, setUnfoldHistory: n }) {
    const [i, r] = $455d545b1dff00eb$var$X.useState(0), [l, c] = $455d545b1dff00eb$var$X.useState(!1), f = $455d545b1dff00eb$var$X.useCallback((m, x)=>new Promise((v)=>{
            const _ = Date.now(), S = 800, A = ()=>{
                const M = Date.now() - _, b = Math.min(M / S, 1), C = $455d545b1dff00eb$var$g0(b);
                e((R)=>{
                    const N = [
                        ...R
                    ], z = R[m].animProgress;
                    return N[m] = {
                        ...N[m],
                        animProgress: z + (x - z) * C
                    }, N;
                }), b < 1 ? requestAnimationFrame(A) : (e((R)=>{
                    const N = [
                        ...R
                    ];
                    return N[m] = {
                        ...N[m],
                        animProgress: x
                    }, N;
                }), v());
            };
            requestAnimationFrame(A);
        }), []), p = $455d545b1dff00eb$var$X.useCallback(async ()=>{
        if (l) return;
        c(!0), r(0);
        const m = (b)=>new Promise((C)=>setTimeout(C, b)), x = (b)=>{
            if (t.length > 0) return [
                ...t
            ].reverse();
            const C = b.map((z, L)=>({
                    idx: L,
                    s: z
                })).filter(({ s: z, idx: L })=>L !== 0 && (z.unfolded || z.animProgress > .001)), R = new Map, N = (z)=>{
                if (R.has(z)) return R.get(z);
                let L = 0, P = b[z]?.parentFace ?? null;
                const H = new Set;
                for(; P != null && !H.has(P);)H.add(P), L += 1, P = b[P]?.parentFace ?? null;
                return R.set(z, L), L;
            };
            return C.sort((z, L)=>N(L.idx) - N(z.idx)).map(({ idx: z })=>z);
        }, v = async ()=>{
            const b = x(a);
            if (b.length !== 0) for (const C of b)e((R)=>{
                const N = [
                    ...R
                ];
                return N[C] = {
                    ...N[C],
                    unfolded: !1,
                    direction: null,
                    gridX: 0,
                    gridY: 0,
                    parentFace: null
                }, N;
            }), f(C, 0), n((R)=>R.filter((N)=>N !== C)), await m(100);
        };
        (a.filter((b, C)=>C === 0 ? a[0].animProgress >= .999 || a[0].unfolded : b.unfolded || b.animProgress >= .999).length > 0 || a.some((b, C)=>C !== 0 && (b.unfolded || b.animProgress > .001))) && (await v(), await m(200)), e($455d545b1dff00eb$var$Ur.map((b)=>({
                unfolded: !1,
                animProgress: 0,
                direction: null,
                gridX: 0,
                gridY: 0,
                parentFace: null,
                color: b
            }))), n([]), await m(200);
        const A = $455d545b1dff00eb$var$Ur.map((b)=>({
                unfolded: !0,
                animProgress: 0,
                direction: null,
                gridX: 0,
                gridY: 0,
                parentFace: null,
                color: b
            }));
        A[0].parentFace = null, A[0].direction = null;
        for (const [b, C] of $455d545b1dff00eb$var$h3){
            const R = $455d545b1dff00eb$var$kf[b], N = $455d545b1dff00eb$var$Ym(R, C), z = $455d545b1dff00eb$var$bb[$455d545b1dff00eb$var$If(N)];
            if (z === void 0 || A[z].parentFace !== null) continue;
            const L = R.normal;
            let P;
            for (const H of $455d545b1dff00eb$var$gS){
                const O = $455d545b1dff00eb$var$Ym($455d545b1dff00eb$var$kf[z], H);
                if ($455d545b1dff00eb$var$If(O) === $455d545b1dff00eb$var$If(L)) {
                    P = H;
                    break;
                }
            }
            P && (A[z].parentFace = b, A[z].direction = P);
        }
        e(A), await m(100);
        const M = [
            ...$455d545b1dff00eb$var$h3
        ].reverse();
        for (const [b, C] of M){
            const R = $455d545b1dff00eb$var$kf[b], N = $455d545b1dff00eb$var$Ym(R, C), z = $455d545b1dff00eb$var$bb[$455d545b1dff00eb$var$If(N)];
            z !== void 0 && (await new Promise((L)=>{
                const P = Date.now(), H = 1e3, O = ()=>{
                    const D = Date.now() - P, j = Math.min(D / H, 1), G = $455d545b1dff00eb$var$g0(j);
                    e((q)=>{
                        const Y = [
                            ...q
                        ];
                        return Y[z] && (Y[z] = {
                            ...Y[z],
                            animProgress: G
                        }), Y;
                    }), j < 1 ? requestAnimationFrame(O) : (e((q)=>{
                        const Y = [
                            ...q
                        ];
                        return Y[z] && (Y[z] = {
                            ...Y[z],
                            animProgress: 1
                        }), Y;
                    }), L());
                };
                requestAnimationFrame(O);
            }), await m(200));
        }
        c(!1);
    }, [
        l,
        a,
        t,
        f
    ]);
    return {
        animateFace: f,
        animateUnfold: p,
        isAnimating: l,
        setIsAnimating: c,
        cubeRotation: i,
        setCubeRotation: r
    };
}
function $455d545b1dff00eb$var$Zv() {
    return $455d545b1dff00eb$var$Ur.map((a)=>({
            unfolded: !1,
            animProgress: 0,
            direction: null,
            gridX: 0,
            gridY: 0,
            parentFace: null,
            color: a
        }));
}
function $455d545b1dff00eb$var$y8() {
    const [a, e] = $455d545b1dff00eb$var$X.useState($455d545b1dff00eb$var$Zv()), [t, n] = $455d545b1dff00eb$var$X.useState($455d545b1dff00eb$var$Zv());
    return {
        faceStates: a,
        setFaceStates: e,
        surfaceAreaFaceStates: t,
        setSurfaceAreaFaceStates: n
    };
}
function $455d545b1dff00eb$var$_8({ faceStates: a, setFaceStates: e, unfoldHistory: t, setUnfoldHistory: n, animateFace: i }) {
    const [, r] = $455d545b1dff00eb$var$X.useState(!1), l = $455d545b1dff00eb$var$X.useCallback((x, v)=>{
        const _ = $455d545b1dff00eb$var$x0[x][v];
        _ && (e((S)=>{
            const A = [
                ...S
            ];
            return A[x] = {
                ...A[x],
                unfolded: !0,
                gridX: 0,
                gridY: 0,
                direction: v,
                parentFace: _.parentFaceIndex
            }, A;
        }), i(x, 1), n((S)=>[
                ...S,
                x
            ]));
    }, [
        i
    ]), c = $455d545b1dff00eb$var$X.useCallback(async (x)=>{
        const v = (M, b)=>{
            const C = b.map((N, z)=>({
                    s: N,
                    i: z
                })).filter((N)=>N.s.parentFace === M && N.s.unfolded).map((N)=>N.i);
            let R = [
                ...C
            ];
            for (const N of C)R = [
                ...R,
                ...v(N, b)
            ];
            return R;
        }, _ = v(x, a), S = [
            x,
            ..._
        ], A = S.map((M)=>i(M, 0));
        await Promise.all(A), e((M)=>{
            const b = [
                ...M
            ];
            return S.forEach((C)=>{
                b[C] = {
                    ...b[C],
                    unfolded: !1,
                    animProgress: 0,
                    direction: null,
                    gridX: 0,
                    gridY: 0,
                    parentFace: null
                };
            }), b;
        }), r(!1), n((M)=>M.filter((b)=>!S.includes(b)));
    }, [
        i,
        a
    ]), f = $455d545b1dff00eb$var$X.useCallback(async ()=>{
        if (t.length === 0) return;
        const v = [
            t[t.length - 1]
        ], _ = v.map((S)=>i(S, 0));
        await Promise.all(_), e((S)=>{
            const A = [
                ...S
            ];
            return v.forEach((M)=>{
                A[M] = {
                    ...A[M],
                    unfolded: !1,
                    animProgress: 0,
                    direction: null,
                    gridX: 0,
                    gridY: 0,
                    parentFace: null
                };
            }), A;
        }), n((S)=>S.filter((A)=>!v.includes(A))), r(!1);
    }, [
        t,
        a,
        i
    ]), p = $455d545b1dff00eb$var$X.useCallback(()=>{
        const x = a.map((v, _)=>({
                idx: _,
                state: v
            })).filter(({ state: v })=>v.unfolded);
        x.length !== 0 && (x.forEach(({ idx: v })=>{
            i(v, 0);
        }), r(!1), setTimeout(()=>{
            e($455d545b1dff00eb$var$Zv()), n([]);
        }, 850));
    }, [
        a,
        i
    ]), m = $455d545b1dff00eb$var$X.useCallback(()=>{
        e($455d545b1dff00eb$var$Zv()), n([]), r(!1);
    }, []);
    return {
        handleUnfold: l,
        handleFoldBack: c,
        handleUndo: f,
        handleFoldToCube: p,
        handleReset: m
    };
}
const $455d545b1dff00eb$var$Nd = new $455d545b1dff00eb$var$J;
function $455d545b1dff00eb$var$b8(a, e) {
    const t = new Set;
    if (a.length !== $455d545b1dff00eb$var$Do || e.length !== $455d545b1dff00eb$var$Do) return t;
    const { normal: n, right: i, up: r } = $455d545b1dff00eb$var$qA(e[0]);
    if (!e.map($455d545b1dff00eb$var$bS).every((x)=>Math.abs(x.dot(n)) >= .999)) return t;
    const f = $455d545b1dff00eb$var$pn * .2, p = new Map, m = new Set;
    for(let x = 0; x < e.length; x++){
        const v = e[x];
        $455d545b1dff00eb$var$Nd.setFromMatrixPosition(v);
        const _ = $455d545b1dff00eb$var$Nd.dot(i), S = $455d545b1dff00eb$var$Nd.dot(r), A = Math.round(_ / $455d545b1dff00eb$var$pn), M = Math.round(S / $455d545b1dff00eb$var$pn), b = Math.abs(_ - A * $455d545b1dff00eb$var$pn), C = Math.abs(S - M * $455d545b1dff00eb$var$pn);
        if (b <= f && C <= f) {
            const R = `${A},${M}`;
            p.has(R) || (p.set(R, x), m.add(x));
        }
    }
    return m;
}
function $455d545b1dff00eb$var$S8(a) {
    const e = Array.from(a.keys()).map((i)=>i.split(",").map(Number)), t = [];
    let n = e;
    for(let i = 0; i < 2; i++){
        i === 1 && (n = n.map(([l, c])=>[
                l,
                -c
            ]));
        let r = n;
        for(let l = 0; l < 4; l++){
            l === 1 ? r = r.map(([x, v])=>[
                    v,
                    -x
                ]) : l === 2 ? r = r.map(([x, v])=>[
                    -x,
                    -v
                ]) : l === 3 && (r = r.map(([x, v])=>[
                    -v,
                    x
                ]));
            const c = Math.min(...r.map(([x])=>x)), f = Math.min(...r.map(([, x])=>x)), m = r.map(([x, v])=>[
                    x - c,
                    v - f
                ]).sort((x, v)=>x[0] - v[0] || x[1] - v[1]).map(([x, v])=>`${x},${v}`).join(";");
            t.push(m);
        }
    }
    return t.sort(), t[0];
}
function $455d545b1dff00eb$var$M8(a, e) {
    if (a.length !== $455d545b1dff00eb$var$Do || e.length !== $455d545b1dff00eb$var$Do) return {
        isComplete: !1
    };
    const t = $455d545b1dff00eb$var$b8(a, e);
    if (!a.every((v, _)=>t.has(_) ? !0 : _ === 0 ? v.animProgress >= .999 : v.unfolded && v.animProgress >= .999 && v.direction !== null || v.animProgress >= .999)) return {
        isComplete: !1,
        visuallyUnfoldedFaces: t
    };
    const { normal: i, right: r, up: l } = $455d545b1dff00eb$var$qA(e[0]);
    if (!e.map($455d545b1dff00eb$var$bS).every((v)=>Math.abs(v.dot(i)) >= .999)) return {
        isComplete: !1
    };
    const p = $455d545b1dff00eb$var$pn * .1, m = new Map;
    for(let v = 0; v < e.length; v++){
        const _ = e[v];
        $455d545b1dff00eb$var$Nd.setFromMatrixPosition(_);
        const S = $455d545b1dff00eb$var$Nd.dot(r), A = $455d545b1dff00eb$var$Nd.dot(l), M = Math.round(S / $455d545b1dff00eb$var$pn), b = Math.round(A / $455d545b1dff00eb$var$pn);
        if (Math.abs(S - M * $455d545b1dff00eb$var$pn) > p || Math.abs(A - b * $455d545b1dff00eb$var$pn) > p) return {
            isComplete: !1
        };
        const C = `${M},${b}`;
        if (m.has(C)) return {
            isComplete: !1
        };
        m.set(C, v);
    }
    if (m.size !== $455d545b1dff00eb$var$Do) return {
        isComplete: !1
    };
    const x = $455d545b1dff00eb$var$S8(m);
    return $455d545b1dff00eb$var$RP.has(x) ? {
        isComplete: !0,
        canonicalKey: x,
        visuallyUnfoldedFaces: t
    } : {
        isComplete: !1
    };
}
function $455d545b1dff00eb$var$E8({ faceStates: a, cubeRotation: e }) {
    const t = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$ZA(a, $455d545b1dff00eb$var$ES, $455d545b1dff00eb$var$x0, e), [
        a,
        e
    ]), n = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$M8(a, t), [
        a,
        t
    ]), i = n.isComplete, r = n.visuallyUnfoldedFaces ?? new Set, l = r.size === $455d545b1dff00eb$var$Do, c = r.size >= 5, p = a.filter((_, S)=>{
        const A = _.animProgress >= .999, M = !(_.gridX === 0 && _.gridY === 0) || S === 0, b = r.has(S);
        return A || M && (_.unfolded || b);
    }).length >= 5, m = i || l || c || p, x = c ? $455d545b1dff00eb$var$Do : a.filter((_, S)=>S === 0 ? r.has(S) || _.animProgress >= .999 || _.unfolded : _.unfolded || r.has(S) || _.animProgress >= .999).length;
    return {
        worldMatrices: t,
        netStatus: n,
        netIsComplete: i,
        shouldShowStraightView: m,
        unfoldedCount: x,
        progressCount: m ? $455d545b1dff00eb$var$Do : x
    };
}
function $455d545b1dff00eb$var$T8() {
    const { faceStates: a, setFaceStates: e, surfaceAreaFaceStates: t, setSurfaceAreaFaceStates: n } = $455d545b1dff00eb$var$y8(), [i, r] = $455d545b1dff00eb$var$X.useState([]), { animateFace: l, animateUnfold: c, isAnimating: f, setIsAnimating: p, cubeRotation: m, setCubeRotation: x } = $455d545b1dff00eb$var$v8({
        faceStates: a,
        setFaceStates: e,
        unfoldHistory: i,
        setUnfoldHistory: r
    }), { handleUnfold: v, handleFoldBack: _, handleUndo: S, handleFoldToCube: A, handleReset: M } = $455d545b1dff00eb$var$_8({
        faceStates: a,
        setFaceStates: e,
        unfoldHistory: i,
        setUnfoldHistory: r,
        animateFace: l
    }), { worldMatrices: b, netStatus: C, netIsComplete: R, shouldShowStraightView: N, unfoldedCount: z, progressCount: L } = $455d545b1dff00eb$var$E8({
        faceStates: a,
        cubeRotation: m
    }), [P, H] = $455d545b1dff00eb$var$X.useState(!1);
    return {
        faceStates: a,
        setFaceStates: e,
        surfaceAreaFaceStates: t,
        setSurfaceAreaFaceStates: n,
        unfoldHistory: i,
        setUnfoldHistory: r,
        cubeRotation: m,
        setCubeRotation: x,
        isAnimating: f,
        setIsAnimating: p,
        isSurfaceAreaVideoModalOpen: P,
        setIsSurfaceAreaVideoModalOpen: H,
        animateFace: l,
        handleUnfold: v,
        handleFoldBack: _,
        handleUndo: S,
        handleFoldToCube: A,
        handleReset: M,
        worldMatrices: b,
        netStatus: C,
        netIsComplete: R,
        shouldShowStraightView: N,
        unfoldedCount: z,
        progressCount: L,
        animateUnfold: c
    };
}
function $455d545b1dff00eb$var$A8() {
    return {
        mode: "net-building"
    };
}
function $455d545b1dff00eb$var$w8({ tipsCount: a, isGameStarted: e = !1, autoRotateInterval: t = 8e3 }) {
    const [n, i] = $455d545b1dff00eb$var$X.useState(0), [r] = $455d545b1dff00eb$var$X.useState(!1), l = $455d545b1dff00eb$var$X.useCallback(()=>{
        a !== 0 && i((p)=>(p + 1) % a);
    }, [
        a
    ]), c = $455d545b1dff00eb$var$X.useCallback(()=>{
        a !== 0 && i((p)=>(p - 1 + a) % a);
    }, [
        a
    ]), f = $455d545b1dff00eb$var$X.useCallback((p)=>{
        p !== n && p >= 0 && p < a && i(p);
    }, [
        n,
        a
    ]);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!e || a === 0) return;
        const p = setInterval(()=>{
            i((m)=>(m + 1) % a);
        }, t);
        return ()=>clearInterval(p);
    }, [
        e,
        a,
        t
    ]), {
        currentTip: n,
        isTipTransitioning: r,
        nextTip: l,
        prevTip: c,
        onTipChange: f
    };
}
function $455d545b1dff00eb$var$C8(a) {
    if (typeof window > "u") return null;
    const e = window.location.hash;
    if (!e) return null;
    const t = e.indexOf("?");
    if (t === -1) return null;
    const n = e.substring(t + 1);
    if (!n) return null;
    try {
        const i = new URLSearchParams(n), r = a === "surface-area" ? "surface_area_of_a_cube[]" : "unfolding_of_a_cube[]", l = i.getAll(r);
        if (l.length === 0) return null;
        const c = l.map((f)=>{
            try {
                return decodeURIComponent(f);
            } catch (p) {
                return console.warn(`Failed to decode ${r} item:`, f, p), f;
            }
        });
        return console.log(`Parsed ${r} from URL:`, c.length, "items"), c;
    } catch (i) {
        return console.warn(`Failed to parse ${a === "surface-area" ? "surface_area_of_a_cube[]" : "unfolding_of_a_cube[]"} from URL:`, i), null;
    }
}
function $455d545b1dff00eb$var$R8(a, e, t) {
    const n = $455d545b1dff00eb$var$C8(a);
    return n || (a === "surface-area" ? t : e);
}
function $455d545b1dff00eb$var$D8({ viewMode: a, isGameStarted: e }) {
    const t = $455d545b1dff00eb$var$X.useMemo(()=>$455d545b1dff00eb$var$R8(a, $455d545b1dff00eb$var$UP, $455d545b1dff00eb$var$NP), [
        a
    ]), { currentTip: n, isTipTransitioning: i, nextTip: r, prevTip: l, onTipChange: c } = $455d545b1dff00eb$var$w8({
        tipsCount: t.length,
        isGameStarted: e
    });
    return {
        tips: t,
        currentTip: n,
        isTipTransitioning: i,
        nextTip: r,
        prevTip: l,
        onTipChange: c
    };
}
function $455d545b1dff00eb$var$U8({ isLocalhost: a }) {
    const [e, t] = $455d545b1dff00eb$var$X.useState(0), [n, i] = $455d545b1dff00eb$var$X.useState(!a), [r, l] = $455d545b1dff00eb$var$X.useState(a);
    $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!r && !a) {
            const f = setInterval(()=>{
                t((p)=>{
                    if (p >= 100) return clearInterval(f), i(!1), 100;
                    const m = p < 50 ? 5 : 8;
                    return Math.min(100, p + m);
                });
            }, 5);
            return ()=>clearInterval(f);
        }
    }, [
        r,
        a
    ]);
    const c = $455d545b1dff00eb$var$X.useCallback(()=>{
        l(!0), i(!1);
    }, []);
    return {
        isGameStarted: r,
        setIsGameStarted: l,
        isLoading: n,
        loadingProgress: e,
        handleStartGame: c
    };
}
function $455d545b1dff00eb$var$N8(a) {
    const [e, t] = $455d545b1dff00eb$var$X.useState(()=>typeof window > "u" ? 1024 : document.documentElement.clientWidth || window.innerWidth);
    return $455d545b1dff00eb$var$X.useEffect(()=>{
        if (!a.current) return;
        const n = ()=>{
            if (a.current) {
                const r = a.current.getBoundingClientRect();
                t(r.width);
            } else {
                const r = document.documentElement.clientWidth || window.innerWidth;
                t(r);
            }
        };
        n();
        const i = new ResizeObserver(()=>{
            n();
        });
        return a.current && i.observe(a.current), window.addEventListener("resize", n), ()=>{
            i.disconnect(), window.removeEventListener("resize", n);
        };
    }, [
        a
    ]), e;
}
function $455d545b1dff00eb$var$O8() {
    return $455d545b1dff00eb$var$X.useMemo(()=>typeof window > "u" ? !1 : window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", []);
}
function $455d545b1dff00eb$var$L8() {
    const { viewMode: a, setViewMode: e } = $455d545b1dff00eb$var$hw(), t = $455d545b1dff00eb$var$O8(), { isGameStarted: n, isLoading: i, loadingProgress: r, handleStartGame: l } = $455d545b1dff00eb$var$U8({
        isLocalhost: t
    }), { isDrawerOpen: c, toggleDrawer: f } = $455d545b1dff00eb$var$g8(), { hasReadGuide: p, handleReadGuide: m } = $455d545b1dff00eb$var$x8(), { mode: x } = $455d545b1dff00eb$var$A8(), { faceStates: v, setFaceStates: _, surfaceAreaFaceStates: S, setSurfaceAreaFaceStates: A, unfoldHistory: M, setUnfoldHistory: b, cubeRotation: C, setCubeRotation: R, isAnimating: N, setIsAnimating: z, isSurfaceAreaVideoModalOpen: L, setIsSurfaceAreaVideoModalOpen: P, animateFace: H, handleUnfold: O, handleFoldBack: D, handleUndo: j, handleFoldToCube: G, handleReset: q, worldMatrices: Y, netIsComplete: ae, shouldShowStraightView: F, unfoldedCount: Q, progressCount: K, animateUnfold: $ } = $455d545b1dff00eb$var$T8(), { tips: ee, currentTip: I, isTipTransitioning: Z, nextTip: oe, prevTip: ce, onTipChange: de } = $455d545b1dff00eb$var$D8({
        viewMode: a,
        isGameStarted: n
    }), { currentVideoUrl: ue } = $455d545b1dff00eb$var$uw({
        viewMode: a
    }), le = ae;
    $455d545b1dff00eb$var$X.useEffect(()=>{
        n && (typeof window > "u" || window.parent == null || (a === "surface-area" ? window.parent.postMessage({
            type: "SHOW_DOCUMENTS_BUTTON"
        }, "*") : window.parent.postMessage({
            type: "HIDE_DOCUMENTS_BUTTON"
        }, "*")));
    }, [
        n,
        a
    ]);
    const xe = $455d545b1dff00eb$var$X.useRef(null), Le = $455d545b1dff00eb$var$X.useRef(null), Ue = $455d545b1dff00eb$var$X.useMemo(()=>({
            viewMode: a,
            setViewMode: e,
            faceStates: v,
            setFaceStates: _,
            mode: x,
            isAnimating: N,
            setIsAnimating: z,
            cubeRotation: C,
            setCubeRotation: R,
            unfoldHistory: M,
            setUnfoldHistory: b,
            worldMatrices: Y,
            hingeConfig: $455d545b1dff00eb$var$x0,
            handleUnfold: O,
            handleFoldBack: D,
            handleUndo: j,
            handleReset: q,
            handleFoldToCube: G,
            animateUnfold: $,
            animateFace: H,
            netIsComplete: ae,
            progressCount: K,
            unfoldedCount: Q,
            showLabels: le
        }), [
        a,
        e,
        v,
        _,
        x,
        N,
        z,
        C,
        R,
        M,
        b,
        Y,
        O,
        D,
        j,
        q,
        G,
        $,
        H,
        ae,
        K,
        Q,
        le
    ]), Ne = $455d545b1dff00eb$var$X.useRef(null), nt = $455d545b1dff00eb$var$N8(Ne) < 768;
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$m8, {
        value: Ue,
        children: $455d545b1dff00eb$var$k.jsxs("div", {
            ref: Ne,
            className: "relative w-full h-screen bg-white overflow-hidden flex flex-col",
            children: [
                $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$L6, {
                    isGameStarted: n,
                    loadingProgress: r,
                    isLoading: i,
                    onStartGame: l
                }),
                n && $455d545b1dff00eb$var$k.jsxs("div", {
                    style: {
                        zIndex: 1e4
                    },
                    className: "flex flex-col relative md:absolute max-h-32 md:top-4 md:left-8 md:z-30 gap-3 w-full md:w-auto md:max-w-sm lg:max-w-md xl:max-w-lg px-4 pt-24 md:px-0 md:pt-0",
                    children: [
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$uI, {
                            value: a,
                            onChange: e,
                            options: [
                                {
                                    value: "unfolding",
                                    label: "Unfolding + Rotate"
                                },
                                {
                                    value: "surface-area",
                                    label: "Surface Area"
                                }
                            ]
                        }),
                        $455d545b1dff00eb$var$k.jsx("div", {
                            className: `flex flex-col md:flex-row gap-4 w-full items-start ${a === "surface-area" ? "md:justify-between" : ""}`,
                            children: $455d545b1dff00eb$var$k.jsx("div", {
                                style: {
                                    zIndex: 9e3
                                },
                                className: `shadow-lg rounded-xl max-h-32 border ${a === "surface-area" ? "w-full md:max-w-md flex-shrink-0" : "w-full flex flex-1"}`,
                                children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$O6, {
                                    tips: ee,
                                    currentTip: I,
                                    isTipTransitioning: Z,
                                    onNext: oe,
                                    onPrev: ce,
                                    onTipChange: de
                                })
                            })
                        })
                    ]
                }),
                a === "unfolding" ? $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
                    children: [
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$C6, {
                            isMobileWidth: nt,
                            shouldShowStraightView: F,
                            worldMatrices: Y,
                            interactiveCubeRef: xe,
                            orbitControlsRef: Le,
                            faceStates: v,
                            onUnfold: O,
                            onFoldBack: D,
                            netIsComplete: ae
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$D6, {}),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$U6, {
                            isVisible: !p && nt,
                            onClose: m
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$R6, {
                            progressCount: K,
                            isAnimating: N,
                            animateUnfold: $,
                            handleUndo: j,
                            unfoldHistoryLength: M.length,
                            handleReset: q,
                            handleFoldToCube: G,
                            unfoldedCount: Q,
                            surfaceAreaVideoUrl: ue,
                            onOpenVideo: ()=>P(!0),
                            toggleDrawer: f,
                            isDrawerOpen: c
                        })
                    ]
                }) : $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$k.Fragment, {
                    children: [
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$h8, {
                            surfaceAreaFaceStates: S,
                            setSurfaceAreaFaceStates: A,
                            isMobileWidth: nt,
                            orbitControlsRef: Le,
                            onVideoPlay: ()=>P(!0)
                        }),
                        $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$lI, {
                            isOpen: c,
                            onClose: f,
                            faceBaseInfo: $455d545b1dff00eb$var$kf,
                            getDirectionVector: $455d545b1dff00eb$var$Ym,
                            vectorKey: $455d545b1dff00eb$var$If,
                            hingeConfig: $455d545b1dff00eb$var$x0,
                            baseMatrices: $455d545b1dff00eb$var$ES
                        })
                    ]
                }),
                ue && $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$cI, {
                    isOpen: L,
                    onClose: ()=>P(!1),
                    videoUrl: ue,
                    title: a === "surface-area" ? "Surface Area Video" : "Unfolding Cube Video"
                })
            ]
        })
    });
}
function $455d545b1dff00eb$var$z8() {
    return $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$d8, {
        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$L8, {})
    });
}
function $455d545b1dff00eb$var$P8() {
    return $455d545b1dff00eb$var$k.jsxs($455d545b1dff00eb$var$uR, {
        children: [
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Om, {
                path: "/",
                element: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$WR, {})
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Om, {
                path: "/angle-in-semicircle",
                element: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$L2, {})
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Om, {
                path: "/cube-3d",
                element: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$z8, {})
            }),
            $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$Om, {
                path: "/exercise",
                element: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$L2, {})
            })
        ]
    });
}
$455d545b1dff00eb$var$dE.createRoot(document.getElementById("root")).render($455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$X.StrictMode, {
    children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$OR, {
        children: $455d545b1dff00eb$var$k.jsx($455d545b1dff00eb$var$P8, {})
    })
}));


//# sourceMappingURL=index.be4e51fe.js.map
